
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("aRuQ6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0823c09d1fa7bae5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $hP2VF = parcelRequire("hP2VF");
var $0823c09d1fa7bae5$export$2e2bcd8739ae039 = (0, $hP2VF.default);

});
parcelRegister("hP2VF", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fd8fd8e5da474a7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $3fd8fd8e5da474a7$export$2e2bcd8739ae039 = {
    'act.action.dismissalMessage.common.text': "You won\u2019t see this here as often.",
    'act.action.notInterested.button.text': 'Not interested',
    'act.action.notInterestedFlag.flag.text': 'Got it, thanks for letting us know',
    'act.action.reasonsModalOkButton.common.text': 'OK',
    'act.action.showReasons.common.text': 'Why am I seeing this?'
};

});


parcelRegister("fQZfS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d27d6188de935c1c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $1BTtm = parcelRequire("1BTtm");
var $d27d6188de935c1c$export$2e2bcd8739ae039 = (0, $1BTtm.default);

});
parcelRegister("1BTtm", function(module, exports) {
$parcel$export(module.exports, "default", () => $82e8b4f9e0bd8117$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $82e8b4f9e0bd8117$export$2e2bcd8739ae039 = {
    'navigation-global-side-navigation.object-list-flyout.empty-state.description': "Once you visit, edit, or create projects, issues, boards, filters, and dashboards, they\u2019ll show up here.",
    'navigation-global-side-navigation.object-list-flyout.empty-state.header': 'Nothing to see here!',
    'navigation-global-side-navigation.object-list-flyout.error-state.description': 'Refresh the page and try again.',
    'navigation-global-side-navigation.object-list-flyout.error-state.header': "We couldn't fetch your items",
    'navigation-global-side-navigation.object-list-flyout.loading-state.accessible-name': 'Content is loading',
    'navigation-global-side-navigation.object-list-flyout.no-results-state.description': "We couldn\u2019t find what you\u2019re looking for.",
    'navigation-global-side-navigation.object-list-flyout.no-results-state.header': 'No results',
    'navigation-global-side-navigation.object-list-flyout.starred-empty-state.description': "Mark items that are important to you with a star to quickly access them. You\u2019ll see those items here.",
    'navigation-global-side-navigation.object-list-flyout.starred-empty-state.header': "You haven't starred anything yet.",
    'navigation.global-side-navigation.customization-modal.actions-icon-button-label': 'Actions for {menuName} item',
    'navigation.global-side-navigation.customization-modal.app-items-list-description': 'The following Atlassian apps are available for your organization.',
    'navigation.global-side-navigation.customization-modal.app-items-list-label': 'App shortcuts',
    'navigation.global-side-navigation.customization-modal.app-items-list-title': 'App shortcuts',
    'navigation.global-side-navigation.customization-modal.close-button-label': 'Cancel changes to your sidebar',
    'navigation.global-side-navigation.customization-modal.close-button-text': 'Cancel',
    'navigation.global-side-navigation.customization-modal.heading-body.heading-body-text': 'Selected items will always be visible in the sidebar. You can still access unselected items from the <b>More</b> menu in the sidebar.',
    'navigation.global-side-navigation.customization-modal.heading-body.heading-body-text-info': 'The changes you make here only affect you and not anyone else on your site.',
    'navigation.global-side-navigation.customization-modal.heading-text': 'Customize your sidebar',
    'navigation.global-side-navigation.customization-modal.hide-item-action-label': 'Hide {menuName} from sidebar',
    'navigation.global-side-navigation.customization-modal.hide-item-action-text': 'Hide item from sidebar',
    'navigation.global-side-navigation.customization-modal.item-checkbox-label': '{menuName} item in sidebar',
    'navigation.global-side-navigation.customization-modal.move-item-actions-label': 'Move {menuName}',
    'navigation.global-side-navigation.customization-modal.move-item-actions-text': 'Move item within sidebar',
    'navigation.global-side-navigation.customization-modal.move-item-bottom-label': 'Move {menuName} to bottom',
    'navigation.global-side-navigation.customization-modal.move-item-bottom-text': 'Move {menuName} to bottom',
    'navigation.global-side-navigation.customization-modal.move-item-down-label': 'Move {menuName} down',
    'navigation.global-side-navigation.customization-modal.move-item-down-text': 'Move down',
    'navigation.global-side-navigation.customization-modal.move-item-top-label': 'Move {menuName} to top',
    'navigation.global-side-navigation.customization-modal.move-item-top-text': 'Move {menuName} to top',
    'navigation.global-side-navigation.customization-modal.move-item-up-label': 'Move {menuName} up',
    'navigation.global-side-navigation.customization-modal.move-item-up-text': 'Move up',
    'navigation.global-side-navigation.customization-modal.on-reorder-item-label': "You've moved {menuName} from position {fromIndex} to position {toIndex} of {numberOfItems} items.",
    'navigation.global-side-navigation.customization-modal.product-items-list-description': 'The following navigation items are available in {app}.',
    'navigation.global-side-navigation.customization-modal.product-items-list-label': 'Customize {app} navigation',
    'navigation.global-side-navigation.customization-modal.product-items-list-title': '{app} navigation',
    'navigation.global-side-navigation.customization-modal.save-button-label': 'Save customization to your sidebar',
    'navigation.global-side-navigation.customization-modal.save-button-text': 'Save changes',
    'navigation.global-side-navigation.customization-modal.show-item-action-label': 'Show {menuName} in sidebar',
    'navigation.global-side-navigation.customization-modal.show-item-action-text': 'Show item in sidebar',
    'navigation.global-side-navigation.customize-sidebar-menu-item.label': 'Customize sidebar',
    'navigation.global-side-navigation.error.description': 'Refresh the page and try again',
    'navigation.global-side-navigation.error.description.default': 'Refresh the page and try again',
    'navigation.global-side-navigation.error.header': "We couldn\u2019t load the sidebar",
    'navigation.global-side-navigation.error.header.default': "We couldn\u2019t load this content",
    'navigation.global-side-navigation.for-you.label': 'For you',
    'navigation.global-side-navigation.hide-from-sidebar-section-screen-reader': 'Dragging {item} over "Hide from navigation" drop area',
    'navigation.global-side-navigation.main-nav-item.error.description': 'Refresh the page and try again',
    'navigation.global-side-navigation.main-nav-item.error.header': "We couldn\u2019t load the item {menuId}",
    'navigation.global-side-navigation.more-menu-item.link-external-item-label': 'Open external link icon',
    'navigation.global-side-navigation.more-menu.hide-from-sidebar.label': 'Hide from sidebar',
    'navigation.global-side-navigation.more-menu.show-in-sidebar.label': 'Show in sidebar',
    'navigation.global-side-navigation.object-list-flyout.clearSearchIconLabel': 'Clear search',
    'navigation.global-side-navigation.object-list-flyout.close-button': 'Close menu',
    'navigation.global-side-navigation.object-list-flyout.filterIconLabel': 'Filters',
    'navigation.global-side-navigation.object-list-flyout.removeFilterIconLabel': 'Remove',
    'navigation.global-side-navigation.object-list-flyout.searchPlaceholder': 'Search...',
    'navigation.global-side-navigation.object-list-flyout.selectedFilters': 'Selected filters',
    'navigation.global-side-navigation.panel-splitter.label': 'Resize panel',
    'navigation.global-side-navigation.panel-splitter.tooltip-content': 'Double click to collapse',
    'navigation.global-side-navigation.primary-navigation-section-screen-reader': 'Dragging {item} over primary navigation group',
    'navigation.global-side-navigation.recents.label': 'Recent',
    'navigation.global-side-navigation.recents.viewAllRecentsLabel': 'View all recent items',
    'navigation.global-side-navigation.recentsSearchPlaceholder': 'Search recent items',
    'navigation.global-side-navigation.shortcuts-section-screen-reader': 'Dragging {item} over shortcuts group',
    'navigation.global-side-navigation.show-in-sidebar-section-screen-reader': 'Dragging {item} over "Show in navigation" drop area',
    'navigation.global-side-navigation.starred.label': 'Starred',
    'navigation.global-side-navigation.starred.viewAllStarredLabel': 'View all starred items',
    'navigation.global-side-navigation.starredSearchPlaceholder': 'Search starred items',
    'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-hidden': 'The top level menu item {label} has been hidden and moved to the More menu.',
    'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-reordered': 'The top level menu item {label} has been moved from position {startIndex} to {finishIndex}.',
    'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-unhidden': 'The top level menu item {label} has been unhidden and moved from the more menu to position {finishIndex}.',
    'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-visible': 'The top level menu item {label} has been moved from the More menu to the visible items.'
};

});


parcelRegister("hkZMV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $477e1f17e52879e3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $barOk = parcelRequire("barOk");
var $477e1f17e52879e3$export$2e2bcd8739ae039 = (0, $barOk.default);

});
parcelRegister("barOk", function(module, exports) {
$parcel$export(module.exports, "default", () => $8398619179815069$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $8398619179815069$export$2e2bcd8739ae039 = {
    'navigation.error.description.default': 'Refresh the page and try again',
    'navigation.error.header.default': "We couldn\u2019t load this content",
    'navigation.global-shortcuts.apps.align': 'Align',
    'navigation.global-shortcuts.apps.analytics': 'Analytics',
    'navigation.global-shortcuts.apps.assets': 'Assets',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': 'Company Hub',
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.customer-service-management': 'Customer Service Management',
    'navigation.global-shortcuts.apps.feedback': 'Feedback',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': 'Goals',
    'navigation.global-shortcuts.apps.home': 'Home',
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Projects',
    'navigation.global-shortcuts.apps.projects-galaxia': 'Spaces',
    'navigation.global-shortcuts.apps.studio': 'Studio',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': 'Teams',
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.error.description': 'Refresh the page and try again',
    'navigation.global-shortcuts.error.header': "We couldn\u2019t load the shortcut for {menuId}",
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Open external link icon',
    'navigation.global-shortcuts.shortcut-action.open-menu-label': 'open menu',
    'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
    'navigation.global-shortcuts.view-all-apps.label': 'View all apps'
};

});


parcelRegister("e09PY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $f43d0225d00493ff$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $9Qw6a = parcelRequire("9Qw6a");
var $f43d0225d00493ff$export$2e2bcd8739ae039 = (0, $9Qw6a.default);

});
parcelRegister("9Qw6a", function(module, exports) {
$parcel$export(module.exports, "default", () => $e61a014273fccbba$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $e61a014273fccbba$export$2e2bcd8739ae039 = {
    'navigation.global-more-menu.error.description': 'Refresh the page and try again',
    'navigation.global-more-menu.error.global-more-menu-item.error.description': 'Refresh the page and try again',
    'navigation.global-more-menu.error.header': "We couldn\u2019t load more sidebar options",
    'navigation.global-more-menu.global-more-menu-item.error.header': "We couldn\u2019t load {menuId} in more options",
    'navigation.global-more-menu.trigger-label': 'More'
};

});


parcelRegister("3nfFb", function(module, exports) {
$parcel$export(module.exports, "draggable", () => (parcelRequire("gOKKd")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("gOKKd")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("gOKKd")).monitorForElements);

var $gOKKd = parcelRequire("gOKKd");

});
parcelRegister("gOKKd", function(module, exports) {
$parcel$export(module.exports, "dropTargetForElements", () => $f4d9028dea86b058$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $f4d9028dea86b058$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $f4d9028dea86b058$export$c746a5152d4ba26c);

var $glbdM = parcelRequire("glbdM");

var $90V0f = parcelRequire("90V0f");

var $6LLtr = parcelRequire("6LLtr");

var $6lUjo = parcelRequire("6lUjo");

var $7aH0o = parcelRequire("7aH0o");

var $fVTcB = parcelRequire("fVTcB");

var $16kDa = parcelRequire("16kDa");

var $bGWmL = parcelRequire("bGWmL");

var $1lNJq = parcelRequire("1lNJq");



const $f4d9028dea86b058$var$draggableRegistry = new WeakMap();
function $f4d9028dea86b058$var$addToRegistry(args) {
    $f4d9028dea86b058$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $f4d9028dea86b058$var$draggableRegistry.delete(args.element);
    };
}
const $f4d9028dea86b058$var$honeyPotFix = (0, $6LLtr.makeHoneyPotFix)();
const $f4d9028dea86b058$var$adapter = (0, $6lUjo.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
		 * this adapter always gets preference over the text adapter.
		 * `document` is the first `EventTarget` under `window`
		 * https://twitter.com/alexandereardon/status/1604658588311465985
		 */ return (0, $7aH0o.combine)($f4d9028dea86b058$var$honeyPotFix.bindEvents(), (0, $glbdM.bind)(document, {
            type: 'dragstart',
            listener (event) {
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                const entry = $f4d9028dea86b058$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
					 * A text selection drag _can_ have the `draggable` element be
					 * the `event.target` if the user is dragging the text selection
					 * from the `draggable`.
					 *
					 * To know if the `draggable` is being dragged, we look at whether any
					 * `"text/plain"` data is being dragged. If it is, then a text selection
					 * drag is occurring.
					 *
					 * This behaviour has been validated on:
					 *
					 * - Chrome@128 on Android@14
					 * - Chrome@128 on iOS@17.6.1
					 * - Chrome@128 on Windows@11
					 * - Chrome@128 on MacOS@14.6.1
					 * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
					 * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
					 *
					 * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
					 * but unfortunately ProseMirror is always setting `""` as the dragged text
					 *
					 * Note: Unfortunately editor is (heavily) leaning on the current functionality today
					 * and unwinding it will be a decent amount of effort. So for now, a text selection
					 * where the `event.target` is a `draggable` element will still trigger the
					 * element adapter.
					 *
					 * // Future state:
					 * if(event.dataTransfer.getData(textMediaType)) {
					 * 	return;
					 * }
					 *
					 */ const input = (0, $1lNJq.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $90V0f.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
					 *  **Goal**
					 *  Pass information to other applications
					 *
					 * **Approach**
					 *  Put data into the native data store
					 *
					 *  **What about the native adapter?**
					 *  When the element adapter puts native data into the native data store
					 *  the native adapter is not triggered in the current window,
					 *  but a native adapter in an external window _can_ be triggered
					 *
					 *  **Why bake this into core?**
					 *  This functionality could be pulled out and exposed inside of
					 *  `onGenerateDragPreview`. But decided to make it a part of the
					 *  base API as it felt like a common enough use case and ended
					 *  up being a similar amount of code to include this function as
					 *  it was to expose the hook for it
					 */ const nativeData = entry.getInitialDataForExternal?.(feedback) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
					 *  📱 For Android devices, a drag operation will not start unless
					 * "text/plain" or "text/uri-list" data exists in the native data store
					 * https://twitter.com/alexandereardon/status/1732189803754713424
					 *
					 * Tested on:
					 * Device: Google Pixel 5
					 * Android version: 14 (November 5, 2023)
					 * Chrome version: 120.0
					 */ if ((0, $bGWmL.isAndroid)() && !event.dataTransfer.types.includes((0, $bba7dc78ee4d9c2c$export$fd3d00026297c0ad)) && !event.dataTransfer.types.includes((0, $3db3d7ba430e6e3e$export$4c44a460f123106))) event.dataTransfer.setData((0, $bba7dc78ee4d9c2c$export$fd3d00026297c0ad), (0, $bGWmL.androidFallbackText));
                /**
					 * 1. Must set any media type for `iOS15` to work
					 * 2. We are also doing adding data so that the native adapter
					 * can know that the element adapter has handled this drag
					 *
					 * We used to wrap this `setData()` in a `try/catch` for Firefox,
					 * but it looks like that was not needed.
					 *
					 * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
					 *
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
					 * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
					 *
					 * // just checking a few more combinations to be super safe
					 *
					 * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
					 * - ✅ Chrome@78 (Oct 2019) on Windows 10
					 * - ✅ Safari@14.1 on macOS Big Sur
					 */ event.dataTransfer.setData((0, $493a15c399719ace$export$c9c4cc54e73b125d), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: entry.getInitialData?.(feedback) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        $f4d9028dea86b058$var$draggableRegistry.get(payload.source.element)?.[eventName]?.(// I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $f4d9028dea86b058$var$honeyPotFix.getOnPostDispatch()
});
const $f4d9028dea86b058$export$e7140b68045b5036 = $f4d9028dea86b058$var$adapter.dropTarget;
const $f4d9028dea86b058$export$59a074bac4c54f54 = $f4d9028dea86b058$var$adapter.monitor;
function $f4d9028dea86b058$export$c746a5152d4ba26c(args) {
    const cleanup = (0, $7aH0o.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $f4d9028dea86b058$var$adapter.registerUsage(), $f4d9028dea86b058$var$addToRegistry(args), (0, $16kDa.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $fVTcB.once)(cleanup);
}

});
parcelRegister("90V0f", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $b9c2fc4d1a9ae8dc$export$81d0353f25f5dd);

var $gTWYd = parcelRequire("gTWYd");
function $b9c2fc4d1a9ae8dc$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $gTWYd.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("gTWYd", function(module, exports) {
$parcel$export(module.exports, "isHoneyPotElement", () => $033ec68c588cd263$export$821bdcd739a2706b);

function $033ec68c588cd263$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $28faff212a143649$export$6eafea55f7947469));
}

});
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $28faff212a143649$export$6eafea55f7947469 = 'data-pdnd-honey-pot';



parcelRegister("6LLtr", function(module, exports) {
$parcel$export(module.exports, "makeHoneyPotFix", () => $058c9b0061994555$export$8ecad27c959e89e0);

var $glbdM = parcelRequire("glbdM");


var $hgLmR = parcelRequire("hgLmR");

var $5t7KL = parcelRequire("5t7KL");

const $058c9b0061994555$var$honeyPotSize = 2;
const $058c9b0061994555$var$halfHoneyPotSize = $058c9b0061994555$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $058c9b0061994555$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $058c9b0061994555$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $058c9b0061994555$var$halfHoneyPotSize,
        y: point.y - $058c9b0061994555$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $058c9b0061994555$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $058c9b0061994555$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $058c9b0061994555$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $058c9b0061994555$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $058c9b0061994555$var$getHoneyPotRectFor({ client: client }) {
    const point = $058c9b0061994555$var$preventGoingForwardsOffScreen($058c9b0061994555$var$preventGoingBackwardsOffScreen($058c9b0061994555$var$pullBackByHalfHoneyPotSize($058c9b0061994555$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $058c9b0061994555$var$honeyPotSize,
        height: $058c9b0061994555$var$honeyPotSize
    });
}
function $058c9b0061994555$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $058c9b0061994555$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $058c9b0061994555$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $28faff212a143649$export$6eafea55f7947469), 'true');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the honey pot is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    if ((0, $5t7KL.supportsPopover)()) element.setAttribute('popover', 'manual');
    // can shift during the drag thanks to Firefox
    let clientRect = $058c9b0061994555$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        position: 'fixed',
        ...(0, $5t7KL.supportsPopover)() ? // needs to be overridden by our top / left values
        (0, $hgLmR.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $41191a919c68fe1a$export$7d0a15ee70427305)
        },
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        ...$058c9b0061994555$var$getRectStyles({
            clientRect: clientRect
        })
    });
    document.body.appendChild(element);
    if ((0, $5t7KL.supportsPopover)()) element.showPopover();
    /**
	 *  🦊 In firefox we can get `"pointermove"` events after the drag
	 * has started, which is a spec violation.
	 * The final `"pointermove"` will reveal where the "depressed" position
	 * is for our honey pot fix.
	 */ const unbindPointerMove = (0, $glbdM.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $058c9b0061994555$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $058c9b0061994555$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($058c9b0061994555$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $glbdM.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $058c9b0061994555$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $glbdM.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $058c9b0061994555$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                const { input: input } = payload.location.current;
                finish?.({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $41191a919c68fe1a$export$7d0a15ee70427305 = 2147483647;

parcelRegister("hgLmR", function(module, exports) {
$parcel$export(module.exports, "popoverResetUserAgentStyles", () => $79de43a18e2eaff4$export$74004cb910cdc478);
const $79de43a18e2eaff4$export$74004cb910cdc478 = {
    inset: 'unset',
    border: 'none',
    padding: 0,
    margin: 0,
    overflow: 'visible',
    color: 'inherit',
    background: 'transparent',
    width: 'auto',
    height: 'auto'
};

});

parcelRegister("5t7KL", function(module, exports) {
$parcel$export(module.exports, "supportsPopover", () => $19e054cb9a8bee73$export$1150b66d0ff92823);

var $fVTcB = parcelRequire("fVTcB");
const $19e054cb9a8bee73$export$1150b66d0ff92823 = (0, $fVTcB.once)(function supportsPopover() {
    return typeof HTMLElement !== 'undefined' && typeof HTMLElement.prototype.showPopover === 'function';
});

});
parcelRegister("fVTcB", function(module, exports) {
$parcel$export(module.exports, "once", () => $8a0a07b357320a20$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $8a0a07b357320a20$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});



parcelRegister("6lUjo", function(module, exports) {
$parcel$export(module.exports, "makeAdapter", () => $96eab76a84984236$export$2aa3a33160990d96);

var $eih5Q = parcelRequire("eih5Q");

var $3gfFG = parcelRequire("3gfFG");

var $8NAYm = parcelRequire("8NAYm");

var $jDYD3 = parcelRequire("jDYD3");
function $96eab76a84984236$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $jDYD3.makeMonitor)();
    const dropTargetAPI = (0, $8NAYm.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource?.(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch?.(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $eih5Q.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $eih5Q.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $3gfFG.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("eih5Q", function(module, exports) {
$parcel$export(module.exports, "lifecycle", () => $7119a26968905b2b$export$3efdceeb8ca25c51);

var $glbdM = parcelRequire("glbdM");

var $90V0f = parcelRequire("90V0f");

var $gTWYd = parcelRequire("gTWYd");

var $hZk9a = parcelRequire("hZk9a");

var $49GfZ = parcelRequire("49GfZ");

var $1lNJq = parcelRequire("1lNJq");

var $iR3l8 = parcelRequire("iR3l8");
const $7119a26968905b2b$var$globalState = {
    isActive: false
};
function $7119a26968905b2b$var$canStart() {
    return !$7119a26968905b2b$var$globalState.isActive;
}
function $7119a26968905b2b$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $7119a26968905b2b$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $7119a26968905b2b$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$7119a26968905b2b$var$canStart()) return;
    const initial = $7119a26968905b2b$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $7119a26968905b2b$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $7119a26968905b2b$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $iR3l8.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $7119a26968905b2b$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $1lNJq.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $gTWYd.isHoneyPotElement)(event.target) ? (0, $90V0f.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $7119a26968905b2b$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $7119a26968905b2b$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $glbdM.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $hZk9a.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
					 * At this point we don't know if a drag is being cancelled,
					 * or if a drag is leaving the `window`.
					 *
					 * Both have:
					 *   1. "dragleave" (with `relatedTarget: null`)
					 *   2. "dragend" (a "dragend" can occur when outside the `window`)
					 *
					 * **Clearing drop targets**
					 *
					 * For either case we are clearing the the drop targets
					 *
					 * - cancelling: we clear drop targets in `"dragend"` anyway
					 * - leaving the `window`: we clear the drop targets (to clear stickiness)
					 *
					 * **Leaving the window and finishing the drag**
					 *
					 * _internal drags_
					 *
					 * - The drag continues when the user is outside the `window`
					 *   and can resume if the user drags back over the `window`,
					 *   or end when the user drops in an external `window`.
					 * - We will get a `"dragend"`, or we can listen for other
					 *   events to determine the drag is finished when the user re-enters the `window`).
					 *
					 * _external drags_
					 *
					 * - We conclude the drag operation.
					 * - We have no idea if the user will drag back over the `window`,
					 *   or if the drag ends elsewhere.
					 * - We will create a new drag if the user re-enters the `window`.
					 *
					 * **Not updating `input`**
					 *
					 * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
					 * Workaround: intentionally not updating `input` in "dragleave"
					 * rather than the users current input values
					 * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
					 * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
					 **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $1lNJq.getInput)(event)
                };
                /** If there are no drop targets, then we will get
					 * a "drop" event if:
					 * - `preventUnhandled()` is being used
					 * - there is an unmanaged drop target (eg another library)
					 * In these cases, it's up to the consumer
					 * to handle the drop if it's not over one of our drop targets
					 * - `preventUnhandled()` will cancel the "drop"
					 * - unmanaged drop targets can handle the "drop" how they want to
					 * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $7119a26968905b2b$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $1lNJq.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $49GfZ.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $7119a26968905b2b$var$getNativeSetDragImage(event)
    });
}
function $7119a26968905b2b$var$setDropEffectOnEvent({ event: event, current: current }) {
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = current[0]?.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $7119a26968905b2b$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $1lNJq.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $7119a26968905b2b$export$3efdceeb8ca25c51 = {
    canStart: $7119a26968905b2b$var$canStart,
    start: $7119a26968905b2b$var$start
};

});
parcelRegister("hZk9a", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindow", () => $321ea0843269138d$export$57d220c74e84a273);

var $3kTMP = parcelRequire("3kTMP");

var $iAExz = parcelRequire("iAExz");

var $cbhIi = parcelRequire("cbhIi");

var $kwxP0 = parcelRequire("kwxP0");
function $321ea0843269138d$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $iAExz.isSafari)()) return (0, $cbhIi.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 * (foreign element)
	 */ if ((0, $3kTMP.isFirefox)()) return (0, $kwxP0.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is `null` *(standard check)*
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("3kTMP", function(module, exports) {
$parcel$export(module.exports, "isFirefox", () => $68b30a3f0d00b59f$export$b7d78993b74f766d);

var $fVTcB = parcelRequire("fVTcB");
const $68b30a3f0d00b59f$export$b7d78993b74f766d = (0, $fVTcB.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});

parcelRegister("iAExz", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $88f8a029e9152a84$export$95df08bae54cb4df);

var $fVTcB = parcelRequire("fVTcB");
const $88f8a029e9152a84$export$95df08bae54cb4df = (0, $fVTcB.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("cbhIi", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindowInSafari", () => $8dafd3ba60c64f79$export$de68634bd94ed596);
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $8dafd3ba60c64f79$export$f21837c338005454);

var $glbdM = parcelRequire("glbdM");

var $iAExz = parcelRequire("iAExz");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
const $8dafd3ba60c64f79$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $8dafd3ba60c64f79$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $iAExz.isSafari)()) return false;
    return dragEnter.hasOwnProperty($8dafd3ba60c64f79$var$symbols.isEnteringWindow);
}
function $8dafd3ba60c64f79$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $iAExz.isSafari)()) return false;
    return dragLeave.hasOwnProperty($8dafd3ba60c64f79$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $iAExz.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $glbdM.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$8dafd3ba60c64f79$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$8dafd3ba60c64f79$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("kwxP0", function(module, exports) {
$parcel$export(module.exports, "isFromAnotherWindow", () => $2b066b585ca4adea$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $2b066b585ca4adea$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $2b066b585ca4adea$export$e46810fef53b5b0e(eventTarget) {
    return $2b066b585ca4adea$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("49GfZ", function(module, exports) {
$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $edfc629111baa9c0$export$ac5e5b0daf997b2);
function $edfc629111baa9c0$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("1lNJq", function(module, exports) {
$parcel$export(module.exports, "getInput", () => $7e305f77cef39a6b$export$7c112ceec8941e67);
function $7e305f77cef39a6b$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("iR3l8", function(module, exports) {
$parcel$export(module.exports, "makeDispatch", () => $0301749d8cfb5b91$export$9f13ecc44e83d682);

var $1qU3G = parcelRequire("1qU3G");
const $0301749d8cfb5b91$var$scheduleOnDrag = (0, $1qU3G.default)((fn)=>fn());
const $0301749d8cfb5b91$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $0301749d8cfb5b91$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $0301749d8cfb5b91$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $0301749d8cfb5b91$var$dragStart.flush();
            $0301749d8cfb5b91$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $0301749d8cfb5b91$var$scheduleOnDrag(()=>{
                $0301749d8cfb5b91$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $0301749d8cfb5b91$var$dragStart.flush();
            $0301749d8cfb5b91$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});


parcelRegister("3gfFG", function(module, exports) {
$parcel$export(module.exports, "register", () => $71ed77b35da78584$export$6503ec6e8aabbaf);
const $71ed77b35da78584$var$ledger = new Map();
function $71ed77b35da78584$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $71ed77b35da78584$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $71ed77b35da78584$var$ledger.set(typeKey, initial);
    return initial;
}
function $71ed77b35da78584$export$6503ec6e8aabbaf(args) {
    const entry = $71ed77b35da78584$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $71ed77b35da78584$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("8NAYm", function(module, exports) {
$parcel$export(module.exports, "makeDropTarget", () => $05f86030a598e0e6$export$47d10e7bd9c81890);

var $7aH0o = parcelRequire("7aH0o");

var $fVTcB = parcelRequire("fVTcB");

var $16kDa = parcelRequire("16kDa");
function $05f86030a598e0e6$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $05f86030a598e0e6$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        const cleanup = (0, $7aH0o.combine)((0, $16kDa.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $fVTcB.once)(cleanup);
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = args.getData?.(feedback) ?? {};
        const dropEffect = args.getDropEffect?.(feedback) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry?.[eventName]?.(// I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry?.onDropTargetChange?.(args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) entry?.onDragLeave?.(args);
            }
            for (const record of payload.location.current.dropTargets){
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry?.onDropTargetChange?.(args);
                entry?.onDragEnter?.(args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $05f86030a598e0e6$var$copyReverse(current);
        const actualCaptureOrdered = $05f86030a598e0e6$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if (parent?.element !== lastParent?.element) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!argsForLast.getIsSticky?.(feedback)) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $05f86030a598e0e6$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("7aH0o", function(module, exports) {
$parcel$export(module.exports, "combine", () => $7f73792a0b2f6cd1$export$1be1fc439b849fdf);
function $7f73792a0b2f6cd1$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});

parcelRegister("16kDa", function(module, exports) {
$parcel$export(module.exports, "addAttribute", () => $b9939105f2347f7b$export$5dcb5c23b6ba980a);
function $b9939105f2347f7b$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("jDYD3", function(module, exports) {
$parcel$export(module.exports, "makeMonitor", () => $27c412d97be6c987$export$5dd4ed888d5b12ca);

var $fVTcB = parcelRequire("fVTcB");
function $27c412d97be6c987$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $fVTcB.once)(cleanup);
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) // @ts-expect-error: I cannot get this type working!
        monitor[eventName]?.(payload);
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("bGWmL", function(module, exports) {
$parcel$export(module.exports, "isAndroid", () => $601db19365817328$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $601db19365817328$export$aceb3ed8b7f7bd2c);

var $fVTcB = parcelRequire("fVTcB");
const $601db19365817328$export$a11b0059900ceec8 = (0, $fVTcB.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $601db19365817328$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $bba7dc78ee4d9c2c$export$fd3d00026297c0ad = 'text/plain';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $3db3d7ba430e6e3e$export$4c44a460f123106 = 'text/uri-list';

/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $493a15c399719ace$export$c9c4cc54e73b125d = 'application/vnd.pdnd';



parcelRegister("e4ZHy", function(module, exports) {
$parcel$export(module.exports, "attachClosestEdge", () => $db2de0ffc459b901$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $db2de0ffc459b901$export$945a571f3b658bf);
const $db2de0ffc459b901$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $db2de0ffc459b901$var$uniqueKey = Symbol('closestEdge');
function $db2de0ffc459b901$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $db2de0ffc459b901$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$db2de0ffc459b901$var$uniqueKey]: addClosestEdge
    };
}
function $db2de0ffc459b901$export$945a571f3b658bf(userData) {
    return userData[$db2de0ffc459b901$var$uniqueKey] ?? null;
}

});

parcelRegister("lKGrY", function(module, exports) {
$parcel$export(module.exports, "getReorderDestinationIndex", () => $31b666c4875063cb$export$846f792f51b92b6e);
function $31b666c4875063cb$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

});

parcelRegister("l7nPt", function(module, exports) {
$parcel$export(module.exports, "combine", () => (parcelRequire("7aH0o")).combine);

var $7aH0o = parcelRequire("7aH0o");

});

parcelRegister("eRSGV", function(module, exports) {
/**
 * This allows you to work with object hierarchies that have been frozen
 * with Object.freeze().  "get" operations can use the normal JS syntax,
 * but operations that modify the data will have to return partial copies of
 * the structure. The portions of the structure that did not change will
 * === their previous values.
 *
 * Inspired by clojure/mori and Immutable.js
 */ "use strict";
var $ad307080a3e5fe62$var$i = module.exports;
// we only care about objects or arrays for now
function $ad307080a3e5fe62$var$weCareAbout(val) {
    return null !== val && (Array.isArray(val) || // This will skip objects created with `new Foo()`
    // and objects created with `Object.create(proto)`
    // The benefit is ignoring DOM elements and event emitters,
    // which are often circular.
    $ad307080a3e5fe62$var$isObjectLike(val));
}
function $ad307080a3e5fe62$var$isObjectLike(val) {
    return typeof val === "object" && val.constructor === Object && Object.getPrototypeOf(val) === Object.prototype;
}
function $ad307080a3e5fe62$var$arrayClone(arr) {
    var index = 0, length = arr.length, result = Array(length);
    for(; index < length; index += 1)result[index] = arr[index];
    return result;
}
function $ad307080a3e5fe62$var$objClone(obj) {
    var index = 0, keys = Object.keys(obj), length = keys.length, key, result = {};
    for(; index < length; index += 1){
        key = keys[index];
        result[key] = obj[key];
    }
    return result;
}
function $ad307080a3e5fe62$var$clone(coll) {
    if (Array.isArray(coll)) return $ad307080a3e5fe62$var$arrayClone(coll);
    else return $ad307080a3e5fe62$var$objClone(coll);
}
function $ad307080a3e5fe62$var$freezeIfNeeded(coll) {
    $ad307080a3e5fe62$var$weCareAbout(coll) && Object.isFrozen(coll);
    return coll;
}
function $ad307080a3e5fe62$var$_freeze(coll) {
    return coll;
}
function $ad307080a3e5fe62$var$baseFreeze(coll, prevNodes) {
    if (prevNodes.some(function(node) {
        return node === coll;
    })) throw new Error("object has a reference cycle");
    Object.freeze(coll);
    prevNodes.push(coll);
    Object.keys(coll).forEach(function(key) {
        var prop = coll[key];
        if ($ad307080a3e5fe62$var$weCareAbout(prop)) $ad307080a3e5fe62$var$baseFreeze(prop, prevNodes);
    });
    prevNodes.pop();
    return coll;
}
/**
 * recrursively freeze an object and all its child objects
 * @param  {Object|Array} coll
 * @return {Object|Array}
 */ module.exports.freeze = function freeze(coll) {
    return coll;
};
/**
 * recursively un-freeze an object, by cloning frozen collections
 * @param  {[type]} coll [description]
 * @return {[type]}      [description]
 */ module.exports.thaw = function thaw(coll) {
    if ($ad307080a3e5fe62$var$weCareAbout(coll) && Object.isFrozen(coll)) {
        var newColl = $ad307080a3e5fe62$var$clone(coll);
        Object.keys(newColl).forEach(function(key) {
            newColl[key] = thaw(newColl[key]);
        });
        return newColl;
    }
    return coll;
};
/**
 * set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key   Key or index
 * @param  {Object}        value
 * @return {Object|Array}        new object hierarchy with modifications
 */ module.exports.assoc = function assoc(coll, key, value) {
    if (coll[key] === value) return $ad307080a3e5fe62$var$_freeze(coll);
    var newObj = $ad307080a3e5fe62$var$clone(coll);
    newObj[key] = $ad307080a3e5fe62$var$freezeIfNeeded(value);
    return $ad307080a3e5fe62$var$_freeze(newObj);
};
module.exports.set = module.exports.assoc;
/**
 * un-set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key  Key or Index
 * @return {Object|Array}       New object or array
 */ module.exports.dissoc = function dissoc(coll, key) {
    var newObj = $ad307080a3e5fe62$var$clone(coll);
    delete newObj[key];
    return $ad307080a3e5fe62$var$_freeze(newObj);
};
module.exports.unset = module.exports.dissoc;
/**
 * set a value deep in a hierarchical structure
 * @param  {Object|Array} coll
 * @param  {Array}        path    A list of keys to traverse
 * @param  {Object}       value
 * @return {Object|Array}       new object hierarchy with modifications
 */ module.exports.assocIn = function assocIn(coll, path, value) {
    var key0 = path[0];
    if (path.length === 1) // simplest case is a 1-element array.  Just a simple assoc.
    return $ad307080a3e5fe62$var$i.assoc(coll, key0, value);
    else // break the problem down.  Assoc this object with the first key
    // and the result of assocIn with the rest of the keys
    return $ad307080a3e5fe62$var$i.assoc(coll, key0, assocIn(coll[key0] || {}, path.slice(1), value));
};
module.exports.setIn = module.exports.assocIn;
/**
 * get an object from a hierachy based on an array of keys
 * @param  {Object|Array} coll
 * @param  {Array}        path    list of keys
 * @return {Object}       value, or undefined
 */ function $ad307080a3e5fe62$var$baseGet(coll, path) {
    return (path || []).reduce(function(curr, key) {
        if (!curr) return;
        return curr[key];
    }, coll);
}
module.exports.getIn = $ad307080a3e5fe62$var$baseGet;
/**
 * Update a value in a hierarchy
 * @param  {Object|Array}   coll
 * @param  {Array}          path     list of keys
 * @param  {Function} callback The existing value with be passed to this.
 *                             Return the new value to set
 * @return {Object|Array}      new object hierarchy with modifications
 */ module.exports.updateIn = function updateIn(coll, path, callback) {
    var existingVal = $ad307080a3e5fe62$var$baseGet(coll, path);
    return $ad307080a3e5fe62$var$i.assocIn(coll, path, callback(existingVal));
};
// generate wrappers for the mutative array methods
[
    "push",
    "unshift",
    "pop",
    "shift",
    "reverse",
    "sort"
].forEach(function(methodName) {
    module.exports[methodName] = function(arr, val) {
        var newArr = $ad307080a3e5fe62$var$arrayClone(arr);
        newArr[methodName]($ad307080a3e5fe62$var$freezeIfNeeded(val));
        return $ad307080a3e5fe62$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = "icepick." + methodName;
});
// splice is special because it is variadic
module.exports.splice = function splice(arr /*, args*/ ) {
    var newArr = $ad307080a3e5fe62$var$arrayClone(arr), args = $ad307080a3e5fe62$var$rest(arguments).map($ad307080a3e5fe62$var$freezeIfNeeded);
    newArr.splice.apply(newArr, args);
    return $ad307080a3e5fe62$var$_freeze(newArr);
};
// slice is non-mutative
module.exports.slice = function slice(arr, arg1, arg2) {
    var newArr = arr.slice(arg1, arg2);
    return $ad307080a3e5fe62$var$_freeze(newArr);
};
[
    "map",
    "filter"
].forEach(function(methodName) {
    module.exports[methodName] = function(fn, arr) {
        var newArr = arr[methodName](fn);
        return $ad307080a3e5fe62$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = "icepick." + methodName;
});
module.exports.extend = module.exports.assign = function assign() {
    var newObj = $ad307080a3e5fe62$var$rest(arguments).reduce($ad307080a3e5fe62$var$singleAssign, arguments[0]);
    return $ad307080a3e5fe62$var$_freeze(newObj);
};
function $ad307080a3e5fe62$var$singleAssign(obj1, obj2) {
    return Object.keys(obj2).reduce(function(obj, key) {
        return $ad307080a3e5fe62$var$i.assoc(obj, key, obj2[key]);
    }, obj1);
}
module.exports.merge = $ad307080a3e5fe62$var$merge;
function $ad307080a3e5fe62$var$merge(target, source, resolver) {
    if (target == null || source == null) return target;
    return Object.keys(source).reduce(function(obj, key) {
        var sourceVal = source[key];
        var targetVal = obj[key];
        var resolvedSourceVal = resolver ? resolver(targetVal, sourceVal, key) : sourceVal;
        if ($ad307080a3e5fe62$var$weCareAbout(sourceVal) && $ad307080a3e5fe62$var$weCareAbout(targetVal)) {
            // if they are both frozen and reference equal, assume they are deep equal
            if (Object.isFrozen(resolvedSourceVal) && Object.isFrozen(targetVal), resolvedSourceVal === targetVal) return obj;
            if (Array.isArray(sourceVal)) return $ad307080a3e5fe62$var$i.assoc(obj, key, resolvedSourceVal);
            // recursively merge pairs of objects
            return $ad307080a3e5fe62$var$assocIfDifferent(obj, key, $ad307080a3e5fe62$var$merge(targetVal, resolvedSourceVal, resolver));
        }
        // primitive values, stuff with prototypes
        return $ad307080a3e5fe62$var$assocIfDifferent(obj, key, resolvedSourceVal);
    }, target);
}
function $ad307080a3e5fe62$var$assocIfDifferent(target, key, value) {
    if (target[key] === value) return target;
    return $ad307080a3e5fe62$var$i.assoc(target, key, value);
}
function $ad307080a3e5fe62$var$_slice(array, start) {
    var begin = start || 0;
    var len = array.length;
    len -= begin;
    len = len < 0 ? 0 : len;
    var result = new Array(len);
    for(var i = 0; i < len; i += 1)result[i] = array[i + begin];
    return result;
}
function $ad307080a3e5fe62$var$rest(args) {
    return $ad307080a3e5fe62$var$_slice(args, 1);
}
var $ad307080a3e5fe62$var$chainProto = {
    value: function value() {
        return this.val;
    },
    thru: function thru(fn) {
        this.val = $ad307080a3e5fe62$var$freezeIfNeeded(fn(this.val));
        return this;
    }
};
Object.keys(module.exports).forEach(function(methodName) {
    $ad307080a3e5fe62$var$chainProto[methodName] = function() {
        var args = $ad307080a3e5fe62$var$_slice(arguments);
        args.unshift(this.val);
        this.val = module.exports[methodName].apply(null, args);
        return this;
    };
});
module.exports.chain = function chain(val) {
    var wrapped = Object.create($ad307080a3e5fe62$var$chainProto);
    wrapped.val = val;
    return wrapped;
};
// for testing
module.exports._weCareAbout = $ad307080a3e5fe62$var$weCareAbout;
module.exports._slice = $ad307080a3e5fe62$var$_slice;

});

parcelRegister("jvGCa", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $da6ff0e85cfe5c30$export$b0c5c2fac8144e54);

var $9CY9I = parcelRequire("9CY9I");

var $ir5fs = parcelRequire("ir5fs");
const $da6ff0e85cfe5c30$export$b0c5c2fac8144e54 = {
    pageLoad: $ir5fs.pageLoad,
    pageSegmentLoad: $ir5fs.pageSegmentLoad,
    interaction: $ir5fs.interaction,
    custom: $ir5fs.custom,
    concurrent: $9CY9I.concurrent
};

});
parcelRegister("9CY9I", function(module, exports) {
$parcel$export(module.exports, "concurrent", () => $bd4e37e9923a6f5d$export$370df09ecc3de059);

var $2VIRA = parcelRequire("2VIRA");

var $ir5fs = parcelRequire("ir5fs");
const $bd4e37e9923a6f5d$var$concurrentMetrics = {};
const $bd4e37e9923a6f5d$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bd4e37e9923a6f5d$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bd4e37e9923a6f5d$var$ensurePath = (config, type)=>{
    const key = $bd4e37e9923a6f5d$var$getKey(config, type);
    if (!(key in $bd4e37e9923a6f5d$var$concurrentMetrics)) $bd4e37e9923a6f5d$var$concurrentMetrics[key] = {};
};
const $bd4e37e9923a6f5d$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bd4e37e9923a6f5d$var$getKey(config, type);
    if (concurrentKey in $bd4e37e9923a6f5d$var$concurrentMetrics && $bd4e37e9923a6f5d$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bd4e37e9923a6f5d$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bd4e37e9923a6f5d$var$concurrentMetrics)) $bd4e37e9923a6f5d$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $bd4e37e9923a6f5d$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bd4e37e9923a6f5d$var$validateConfig(config);
    $bd4e37e9923a6f5d$var$ensurePath(config, type);
    const metricFromCache = $bd4e37e9923a6f5d$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $2VIRA.BMEventsType).INLINE_RESULT ? (0, $ir5fs.interaction) : (0, $ir5fs.custom);
    const metric = metricFactory(config);
    $bd4e37e9923a6f5d$var$concurrentMetrics[$bd4e37e9923a6f5d$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bd4e37e9923a6f5d$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bd4e37e9923a6f5d$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $2VIRA.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bd4e37e9923a6f5d$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $2VIRA.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bd4e37e9923a6f5d$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $2VIRA.BMEventsType).CUSTOM)
};

});
parcelRegister("ir5fs", function(module, exports) {
$parcel$export(module.exports, "pageLoad", () => $1535c2ec2db766da$export$791d520f7e8058a5);
$parcel$export(module.exports, "pageSegmentLoad", () => $1535c2ec2db766da$export$94114666844d5f66);
$parcel$export(module.exports, "interaction", () => $1535c2ec2db766da$export$92473e6020ad89b4);
$parcel$export(module.exports, "custom", () => $1535c2ec2db766da$export$4c00f665f0d4b443);

var $jqUZf = parcelRequire("jqUZf");

var $1LKvd = parcelRequire("1LKvd");

var $jAmvf = parcelRequire("jAmvf");

var $2VIRA = parcelRequire("2VIRA");
const $1535c2ec2db766da$export$791d520f7e8058a5 = (config)=>{
    return new (0, $1LKvd.PageLoadMetric)({
        ...config,
        type: (0, $2VIRA.BMEventsType).PAGE_LOAD
    });
};
const $1535c2ec2db766da$export$94114666844d5f66 = (config)=>{
    return new (0, $jAmvf.PageSegmentLoadMetric)({
        ...config,
        type: (0, $2VIRA.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $1535c2ec2db766da$export$92473e6020ad89b4 = (config)=>{
    return new (0, $jqUZf.Metric)({
        ...config,
        type: (0, $2VIRA.BMEventsType).INLINE_RESULT
    });
};
const $1535c2ec2db766da$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $jqUZf.Metric)({
        ...config,
        type: (0, $2VIRA.BMEventsType).CUSTOM
    });
};

});
parcelRegister("jqUZf", function(module, exports) {
$parcel$export(module.exports, "Metric", () => $6fe8f50d20fe424b$export$efdd3e096bc27746);

var $8P8vl = parcelRequire("8P8vl");

var $iPBlg = parcelRequire("iPBlg");

var $1GhoA = parcelRequire("1GhoA");
class $6fe8f50d20fe424b$export$efdd3e096bc27746 extends (0, $1GhoA.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $8P8vl.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $iPBlg.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}

});

parcelRegister("1LKvd", function(module, exports) {
$parcel$export(module.exports, "PageLoadMetric", () => $b49520517666d3a1$export$3c51073271a9eac3);

var $3zdd0 = parcelRequire("3zdd0");

var $7C981 = parcelRequire("7C981");

var $8P8vl = parcelRequire("8P8vl");

var $iPBlg = parcelRequire("iPBlg");

var $2VIRA = parcelRequire("2VIRA");

var $8ecYH = parcelRequire("8ecYH");

var $3QJKP = parcelRequire("3QJKP");

var $ebas8 = parcelRequire("ebas8");
class $b49520517666d3a1$export$3c51073271a9eac3 extends (0, $8ecYH.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $3QJKP.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $3QJKP.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $3QJKP.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $8ecYH.BasePageLoadMetric).FMP]) {
                const mark = (0, $3zdd0.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $3QJKP.pageLoadMetaMetric).markFMP(mark);
            } else (0, $3QJKP.pageLoadMetaMetric).markFMP(this.marks[(0, $8ecYH.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $8P8vl.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $iPBlg.submitter).queue(data);
        (0, $7C981.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $3QJKP.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $3QJKP.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $3QJKP.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $iPBlg.submitter).config.configChunk;
        if (!configChunk?.[(0, $2VIRA.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $ebas8.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $iPBlg.submitter).queue(webVitalMetric.getData());
        (0, $7C981.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}

});
parcelRegister("ebas8", function(module, exports) {
$parcel$export(module.exports, "WebVitalsMetric", () => $7cf85a8058e9a1e5$export$dc0d85d4d6503cd7);

var $2VIRA = parcelRequire("2VIRA");

var $1GhoA = parcelRequire("1GhoA");
class $7cf85a8058e9a1e5$export$dc0d85d4d6503cd7 extends (0, $1GhoA.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $2VIRA.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $1GhoA.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}

});


parcelRegister("jAmvf", function(module, exports) {
$parcel$export(module.exports, "PageSegmentLoadMetric", () => $a78e0d4a49f8bb31$export$24c8bfcd77494cc1);

var $3zdd0 = parcelRequire("3zdd0");

var $2VIRA = parcelRequire("2VIRA");

var $1GhoA = parcelRequire("1GhoA");

var $jqUZf = parcelRequire("jqUZf");

var $3QJKP = parcelRequire("3QJKP");
class $a78e0d4a49f8bb31$export$24c8bfcd77494cc1 extends (0, $jqUZf.Metric) {
    static{
        this.FMP = 'fmp';
    }
    constructor(config){
        super(config), this.isInitial = true;
        this.config = config;
    }
    startFromPageLoad() {
        const pageLoadMetaData = (0, $3QJKP.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $a78e0d4a49f8bb31$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($a78e0d4a49f8bb31$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $3QJKP.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$a78e0d4a49f8bb31$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $3zdd0.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $2VIRA.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $1GhoA.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $1GhoA.MetricState).STARTED) (0, $3QJKP.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
}

});




parcelRegister("jkqqC", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $cc5bcb280a62c658$export$c00d22927c60484a);

var $gqxTF = parcelRequire("gqxTF");
class $cc5bcb280a62c658$export$c00d22927c60484a extends (0, $gqxTF.UFOAbstractExperience) {
}

});
parcelRegister("gqxTF", function(module, exports) {
$parcel$export(module.exports, "perfNowOrTimestamp", () => $f601d182f85dfb0c$export$c753e8669d30c8ad);
$parcel$export(module.exports, "UFOAbstractExperience", () => $f601d182f85dfb0c$export$d31c89db257648c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $7TA2J = parcelRequire("7TA2J");

var $egspI = parcelRequire("egspI");

var $2e4T3 = parcelRequire("2e4T3");


var $ev3CP = parcelRequire("ev3CP");

var $7NjC3 = parcelRequire("7NjC3");

var $d4ULW = parcelRequire("d4ULW");

var $jQqmM = parcelRequire("jQqmM");

var $1jtaq = parcelRequire("1jtaq");

var $3sqZc = parcelRequire("3sqZc");

var $686xa = parcelRequire("686xa");

var $lrWdv = parcelRequire("lrWdv");

var $ipvkO = parcelRequire("ipvkO");
const $f601d182f85dfb0c$var$getPageVisibleState = ()=>{
    return !(0, $ev3CP.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $1jtaq.PageVisibleState).VISIBLE : (0, $1jtaq.PageVisibleState).HIDDEN;
};
const $f601d182f85dfb0c$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $3sqZc.roundPerfNow)();
};
class $f601d182f85dfb0c$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $686xa.UFOExperienceState).NOT_STARTED;
        this.instanceId = null; // for concurrent
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.traceContext = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $1jtaq.PageVisibleState).MIXED;
            (0, $jQqmM.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $f601d182f85dfb0c$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $ipvkO.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $d4ULW.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $lrWdv.canTransition)(this.state, newState)) {
            (0, $d4ULW.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $686xa.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $f601d182f85dfb0c$export$c753e8669d30c8ad(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $7TA2J.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $f601d182f85dfb0c$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $7NjC3.getGlobalEventStream)().push((0, $7NjC3.unsubscribeEvent)((0, $1jtaq.SUBSCRIBE_ALL), this.handleDoneBind));
                this.stopTrace();
                const data = await this.exportData();
                (0, $d4ULW.ufolog)('this.parent', this.parent);
                (0, $7NjC3.getGlobalEventStream)().push((0, $7NjC3.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $d4ULW.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $d4ULW.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $686xa.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $f601d182f85dfb0c$var$getPageVisibleState();
            (0, $jQqmM.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $d4ULW.ufolog)('subscribed', this.id);
                (0, $7NjC3.getGlobalEventStream)().push((0, $7NjC3.subscribeEvent)((0, $1jtaq.SUBSCRIBE_ALL), this.handleDoneBind));
            }
            this.startTrace(this.id);
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $1jtaq.FMP_MARK) && name !== (0, $1jtaq.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $d4ULW.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $f601d182f85dfb0c$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $686xa.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $1jtaq.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $1jtaq.INLINE_RESPONSE_MARK), timestamp);
    }
    startTrace(experienceId) {
        if ((0, $egspI.fg)('ufo_v1_tracing')) {
            let traceContext = (0, $2e4T3.getActiveTrace)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, $2e4T3.generateTraceId)(),
                    spanId: (0, $2e4T3.generateSpanId)()
                };
                (0, $2e4T3.setActiveTrace)(traceContext.traceId, traceContext.spanId, 'ufo_v1.' + experienceId);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, $egspI.fg)('ufo_v1_tracing')) (0, $2e4T3.clearActiveTrace)();
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $d4ULW.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $jQqmM.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $686xa.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $686xa.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $686xa.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $d4ULW.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $c6ef15cf6ce743a7$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig,
            ...(0, $egspI.fg)('ufo_v1_tracing') ? {
                traceContext: this.traceContext
            } : {}
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.traceContext = null;
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $c6ef15cf6ce743a7$export$2295b861f318254a = '0.1.5';

parcelRegister("3sqZc", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $79070cc2464add47$export$5f490af6b2b115cf);
const $79070cc2464add47$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("686xa", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $89c6ca8263002e03$export$81b70111112841a0);
const $89c6ca8263002e03$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("lrWdv", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $e6b6383657cd02c8$export$178881f329fdb81f);

var $686xa = parcelRequire("686xa");
const $e6b6383657cd02c8$var$UFOStateAvailableTransitions = {
    [(0, $686xa.UFOExperienceState).NOT_STARTED.id]: [
        (0, $686xa.UFOExperienceState).STARTED.id
    ],
    [(0, $686xa.UFOExperienceState).STARTED.id]: [
        (0, $686xa.UFOExperienceState).IN_PROGRESS.id,
        (0, $686xa.UFOExperienceState).BLOCKED.id,
        (0, $686xa.UFOExperienceState).SUCCEEDED.id,
        (0, $686xa.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $686xa.UFOExperienceState).FAILED.id,
        (0, $686xa.UFOExperienceState).ABORTED.id
    ],
    [(0, $686xa.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $686xa.UFOExperienceState).BLOCKED.id,
        (0, $686xa.UFOExperienceState).SUCCEEDED.id,
        (0, $686xa.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $686xa.UFOExperienceState).FAILED.id,
        (0, $686xa.UFOExperienceState).ABORTED.id
    ],
    [(0, $686xa.UFOExperienceState).BLOCKED.id]: [
        (0, $686xa.UFOExperienceState).RECOVERED.id,
        (0, $686xa.UFOExperienceState).ABORTED.id
    ],
    [(0, $686xa.UFOExperienceState).RECOVERED.id]: [
        (0, $686xa.UFOExperienceState).STARTED.id,
        (0, $686xa.UFOExperienceState).SUCCEEDED.id,
        (0, $686xa.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $686xa.UFOExperienceState).FAILED.id,
        (0, $686xa.UFOExperienceState).ABORTED.id
    ],
    [(0, $686xa.UFOExperienceState).SUCCEEDED.id]: [
        (0, $686xa.UFOExperienceState).STARTED.id
    ],
    [(0, $686xa.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $686xa.UFOExperienceState).SUCCEEDED.id,
        (0, $686xa.UFOExperienceState).FAILED.id,
        (0, $686xa.UFOExperienceState).ABORTED.id
    ],
    [(0, $686xa.UFOExperienceState).FAILED.id]: [
        (0, $686xa.UFOExperienceState).STARTED.id
    ],
    [(0, $686xa.UFOExperienceState).ABORTED.id]: [
        (0, $686xa.UFOExperienceState).STARTED.id
    ]
};
const $e6b6383657cd02c8$export$178881f329fdb81f = (state1, state2)=>{
    return $e6b6383657cd02c8$var$UFOStateAvailableTransitions[state1.id] && $e6b6383657cd02c8$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});



parcelRegister("atcQv", function(module, exports) {
$parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", () => $b77b0b70b25570d9$export$81189edc9b923717);
$parcel$export(module.exports, "retryOnError", () => $b77b0b70b25570d9$export$f859c88bfac2cf2c);
$parcel$export(module.exports, "shouldRetry", () => $b77b0b70b25570d9$export$7bfea3c3d460ecd8);
$parcel$export(module.exports, "getRetryAttemptsForQuery", () => $b77b0b70b25570d9$export$9dec0f42cc67f6ab);
const $b77b0b70b25570d9$export$81189edc9b923717 = 1;
const $b77b0b70b25570d9$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $b77b0b70b25570d9$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $b77b0b70b25570d9$export$81189edc9b923717 ? $b77b0b70b25570d9$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};
const $b77b0b70b25570d9$export$7bfea3c3d460ecd8 = (error)=>{
    if ('statusCode' in error && typeof error.statusCode === 'number') return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};
const $b77b0b70b25570d9$export$9dec0f42cc67f6ab = (request)=>{
    if (request.operationKind === 'query') return $b77b0b70b25570d9$export$81189edc9b923717;
    return 0;
};

});

parcelRegister("srxic", function(module, exports) {

var $lyiHY = parcelRequire("lyiHY");

var $4byGb = parcelRequire("4byGb");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $0557f9b60e2912c4$var$capitalize(string) {
    return $4byGb($lyiHY(string).toLowerCase());
}
module.exports = $0557f9b60e2912c4$var$capitalize;

});
parcelRegister("4byGb", function(module, exports) {

var $cCAFw = parcelRequire("cCAFw");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $30c3171b7fc3e29d$var$upperFirst = $cCAFw('toUpperCase');
module.exports = $30c3171b7fc3e29d$var$upperFirst;

});
parcelRegister("cCAFw", function(module, exports) {

var $bJwlz = parcelRequire("bJwlz");

var $9hBAk = parcelRequire("9hBAk");

var $g0Vt9 = parcelRequire("g0Vt9");

var $lyiHY = parcelRequire("lyiHY");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $93057a446ed00fba$var$createCaseFirst(methodName) {
    return function(string) {
        string = $lyiHY(string);
        var strSymbols = $9hBAk(string) ? $g0Vt9(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $bJwlz(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $93057a446ed00fba$var$createCaseFirst;

});
parcelRegister("bJwlz", function(module, exports) {

var $g2svi = parcelRequire("g2svi");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $88acfd1e792d44be$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $g2svi(array, start, end);
}
module.exports = $88acfd1e792d44be$var$castSlice;

});
parcelRegister("g2svi", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $bad2f1846c244ba4$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $bad2f1846c244ba4$var$baseSlice;

});


parcelRegister("9hBAk", function(module, exports) {
/** Used to compose unicode character classes. */ var $6c22db2a526224f6$var$rsAstralRange = '\\ud800-\\udfff', $6c22db2a526224f6$var$rsComboMarksRange = '\\u0300-\\u036f', $6c22db2a526224f6$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $6c22db2a526224f6$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $6c22db2a526224f6$var$rsComboRange = $6c22db2a526224f6$var$rsComboMarksRange + $6c22db2a526224f6$var$reComboHalfMarksRange + $6c22db2a526224f6$var$rsComboSymbolsRange, $6c22db2a526224f6$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $6c22db2a526224f6$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $6c22db2a526224f6$var$reHasUnicode = RegExp('[' + $6c22db2a526224f6$var$rsZWJ + $6c22db2a526224f6$var$rsAstralRange + $6c22db2a526224f6$var$rsComboRange + $6c22db2a526224f6$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $6c22db2a526224f6$var$hasUnicode(string) {
    return $6c22db2a526224f6$var$reHasUnicode.test(string);
}
module.exports = $6c22db2a526224f6$var$hasUnicode;

});

parcelRegister("g0Vt9", function(module, exports) {

var $5q05L = parcelRequire("5q05L");

var $9hBAk = parcelRequire("9hBAk");

var $eEROQ = parcelRequire("eEROQ");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $ba893995d84fb71c$var$stringToArray(string) {
    return $9hBAk(string) ? $eEROQ(string) : $5q05L(string);
}
module.exports = $ba893995d84fb71c$var$stringToArray;

});
parcelRegister("5q05L", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $3f1f73bcc05ac3ff$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $3f1f73bcc05ac3ff$var$asciiToArray;

});

parcelRegister("eEROQ", function(module, exports) {
/** Used to compose unicode character classes. */ var $aabe8c7043ef2a20$var$rsAstralRange = '\\ud800-\\udfff', $aabe8c7043ef2a20$var$rsComboMarksRange = '\\u0300-\\u036f', $aabe8c7043ef2a20$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $aabe8c7043ef2a20$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $aabe8c7043ef2a20$var$rsComboRange = $aabe8c7043ef2a20$var$rsComboMarksRange + $aabe8c7043ef2a20$var$reComboHalfMarksRange + $aabe8c7043ef2a20$var$rsComboSymbolsRange, $aabe8c7043ef2a20$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $aabe8c7043ef2a20$var$rsAstral = '[' + $aabe8c7043ef2a20$var$rsAstralRange + ']', $aabe8c7043ef2a20$var$rsCombo = '[' + $aabe8c7043ef2a20$var$rsComboRange + ']', $aabe8c7043ef2a20$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $aabe8c7043ef2a20$var$rsModifier = '(?:' + $aabe8c7043ef2a20$var$rsCombo + '|' + $aabe8c7043ef2a20$var$rsFitz + ')', $aabe8c7043ef2a20$var$rsNonAstral = '[^' + $aabe8c7043ef2a20$var$rsAstralRange + ']', $aabe8c7043ef2a20$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $aabe8c7043ef2a20$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $aabe8c7043ef2a20$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $aabe8c7043ef2a20$var$reOptMod = $aabe8c7043ef2a20$var$rsModifier + '?', $aabe8c7043ef2a20$var$rsOptVar = '[' + $aabe8c7043ef2a20$var$rsVarRange + ']?', $aabe8c7043ef2a20$var$rsOptJoin = '(?:' + $aabe8c7043ef2a20$var$rsZWJ + '(?:' + [
    $aabe8c7043ef2a20$var$rsNonAstral,
    $aabe8c7043ef2a20$var$rsRegional,
    $aabe8c7043ef2a20$var$rsSurrPair
].join('|') + ')' + $aabe8c7043ef2a20$var$rsOptVar + $aabe8c7043ef2a20$var$reOptMod + ')*', $aabe8c7043ef2a20$var$rsSeq = $aabe8c7043ef2a20$var$rsOptVar + $aabe8c7043ef2a20$var$reOptMod + $aabe8c7043ef2a20$var$rsOptJoin, $aabe8c7043ef2a20$var$rsSymbol = '(?:' + [
    $aabe8c7043ef2a20$var$rsNonAstral + $aabe8c7043ef2a20$var$rsCombo + '?',
    $aabe8c7043ef2a20$var$rsCombo,
    $aabe8c7043ef2a20$var$rsRegional,
    $aabe8c7043ef2a20$var$rsSurrPair,
    $aabe8c7043ef2a20$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $aabe8c7043ef2a20$var$reUnicode = RegExp($aabe8c7043ef2a20$var$rsFitz + '(?=' + $aabe8c7043ef2a20$var$rsFitz + ')|' + $aabe8c7043ef2a20$var$rsSymbol + $aabe8c7043ef2a20$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $aabe8c7043ef2a20$var$unicodeToArray(string) {
    return string.match($aabe8c7043ef2a20$var$reUnicode) || [];
}
module.exports = $aabe8c7043ef2a20$var$unicodeToArray;

});





parcelRegister("bnMP4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.batchActions = $8497b6dafa4ef516$var$batchActions;
module.exports.enableBatching = $8497b6dafa4ef516$var$enableBatching;
module.exports.batchDispatchMiddleware = $8497b6dafa4ef516$var$batchDispatchMiddleware;
var $8497b6dafa4ef516$var$BATCH = module.exports.BATCH = 'BATCHING_REDUCER.BATCH';
function $8497b6dafa4ef516$var$batchActions(actions) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $8497b6dafa4ef516$var$BATCH;
    return {
        type: type,
        meta: {
            batch: true
        },
        payload: actions
    };
}
function $8497b6dafa4ef516$var$enableBatching(reduce) {
    return function batchingReducer(state, action) {
        if (action && action.meta && action.meta.batch) return action.payload.reduce(batchingReducer, state);
        return reduce(state, action);
    };
}
function $8497b6dafa4ef516$var$batchDispatchMiddleware(store) {
    function dispatchChildActions(store, action) {
        if (action.meta && action.meta.batch) action.payload.forEach(function(childAction) {
            dispatchChildActions(store, childAction);
        });
        else store.dispatch(action);
    }
    return function(next) {
        return function(action) {
            if (action && action.meta && action.meta.batch) dispatchChildActions(store, action);
            return next(action);
        };
    };
}

});

parcelRegister("cuwfX", function(module, exports) {
!function(e, t) {
    t(module.exports);
}(module.exports, function(e) {
    "use strict";
    function t(e, t) {
        e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        });
    }
    function r(e, t) {
        Object.defineProperty(this, "kind", {
            value: e,
            enumerable: !0
        }), t && t.length && Object.defineProperty(this, "path", {
            value: t,
            enumerable: !0
        });
    }
    function n(e, t, r) {
        n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "rhs", {
            value: r,
            enumerable: !0
        });
    }
    function o(e, t) {
        o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
            value: t,
            enumerable: !0
        });
    }
    function i(e, t) {
        i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        });
    }
    function a(e, t, r) {
        a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "item", {
            value: r,
            enumerable: !0
        });
    }
    function f(e, t, r) {
        var n = e.slice((r || t) + 1 || e.length);
        return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
    }
    function u(e) {
        var t = "undefined" == typeof e ? "undefined" : N(e);
        return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
    }
    function l(e, t, r, c, s, d, p) {
        s = s || [], p = p || [];
        var g = s.slice(0);
        if ("undefined" != typeof d) {
            if (c) {
                if ("function" == typeof c && c(g, d)) return;
                if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
                    if (c.prefilter && c.prefilter(g, d)) return;
                    if (c.normalize) {
                        var h = c.normalize(g, d, e, t);
                        h && (e = h[0], t = h[1]);
                    }
                }
            }
            g.push(d);
        }
        "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
        var y = "undefined" == typeof e ? "undefined" : N(e), v = "undefined" == typeof t ? "undefined" : N(t), b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d), m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
        if (!b && m) r(new o(g, t));
        else if (!m && b) r(new i(g, e));
        else if (u(e) !== u(t)) r(new n(g, e, t));
        else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));
        else if ("object" === y && null !== e && null !== t) {
            if (p.filter(function(t) {
                return t.lhs === e;
            }).length) e !== t && r(new n(g, e, t));
            else {
                if (p.push({
                    lhs: e,
                    rhs: t
                }), Array.isArray(e)) {
                    var w;
                    e.length;
                    for(w = 0; w < e.length; w++)w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
                    for(; w < t.length;)r(new a(g, w, new o(void 0, t[w++])));
                } else {
                    var x = Object.keys(e), S = Object.keys(t);
                    x.forEach(function(n, o) {
                        var i = S.indexOf(n);
                        i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
                    }), S.forEach(function(e) {
                        l(void 0, t[e], r, c, g, e, p);
                    });
                }
                p.length = p.length - 1;
            }
        } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
    }
    function c(e, t, r, n) {
        return n = n || [], l(e, t, function(e) {
            e && n.push(e);
        }, r), n.length ? n : void 0;
    }
    function s(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    s(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    delete o[r.path[n]];
                    break;
                case "E":
                case "N":
                    o[r.path[n]] = r.rhs;
            }
        } else switch(r.kind){
            case "A":
                s(e[t], r.index, r.item);
                break;
            case "D":
                e = f(e, t);
                break;
            case "E":
            case "N":
                e[t] = r.rhs;
        }
        return e;
    }
    function d(e, t, r) {
        if (e && t && r && r.kind) {
            for(var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;)"undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
            switch(r.kind){
                case "A":
                    s(r.path ? n[r.path[o]] : n, r.index, r.item);
                    break;
                case "D":
                    delete n[r.path[o]];
                    break;
                case "E":
                case "N":
                    n[r.path[o]] = r.rhs;
            }
        }
    }
    function p(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    p(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    o[r.path[n]] = r.lhs;
                    break;
                case "E":
                    o[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete o[r.path[n]];
            }
        } else switch(r.kind){
            case "A":
                p(e[t], r.index, r.item);
                break;
            case "D":
                e[t] = r.lhs;
                break;
            case "E":
                e[t] = r.lhs;
                break;
            case "N":
                e = f(e, t);
        }
        return e;
    }
    function g(e, t, r) {
        if (e && t && r && r.kind) {
            var n, o, i = e;
            for(o = r.path.length - 1, n = 0; n < o; n++)"undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
            switch(r.kind){
                case "A":
                    p(i[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    i[r.path[n]] = r.lhs;
                    break;
                case "E":
                    i[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete i[r.path[n]];
            }
        }
    }
    function h(e, t, r) {
        if (e && t) {
            var n = function(n) {
                r && !r(e, t, n) || d(e, t, n);
            };
            l(e, t, n);
        }
    }
    function y(e) {
        return "color: " + F[e].color + "; font-weight: bold";
    }
    function v(e) {
        var t = e.kind, r = e.path, n = e.lhs, o = e.rhs, i = e.index, a = e.item;
        switch(t){
            case "E":
                return [
                    r.join("."),
                    n,
                    "\u2192",
                    o
                ];
            case "N":
                return [
                    r.join("."),
                    o
                ];
            case "D":
                return [
                    r.join(".")
                ];
            case "A":
                return [
                    r.join(".") + "[" + i + "]",
                    a
                ];
            default:
                return [];
        }
    }
    function b(e, t, r, n) {
        var o = c(e, t);
        try {
            n ? r.groupCollapsed("diff") : r.group("diff");
        } catch (e) {
            r.log("diff");
        }
        o ? o.forEach(function(e) {
            var t = e.kind, n = v(e);
            r.log.apply(r, [
                "%c " + F[t].text,
                y(t)
            ].concat(P(n)));
        }) : r.log("\u2014\u2014 no diff \u2014\u2014");
        try {
            r.groupEnd();
        } catch (e) {
            r.log("\u2014\u2014 diff end \u2014\u2014 ");
        }
    }
    function m(e, t, r, n) {
        switch("undefined" == typeof e ? "undefined" : N(e)){
            case "object":
                return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];
            case "function":
                return e(t);
            default:
                return e;
        }
    }
    function w(e) {
        var t = e.timestamp, r = e.duration;
        return function(e, n, o) {
            var i = [
                "action"
            ];
            return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
        };
    }
    function x(e, t) {
        var r = t.logger, n = t.actionTransformer, o = t.titleFormatter, i = void 0 === o ? w(t) : o, a = t.collapsed, f = t.colors, u = t.level, l = t.diff, c = "undefined" == typeof t.titleFormatter;
        e.forEach(function(o, s) {
            var d = o.started, p = o.startedTime, g = o.action, h = o.prevState, y = o.error, v = o.took, w = o.nextState, x = e[s + 1];
            x && (w = x.prevState, v = x.started - d);
            var S = n(g), k = "function" == typeof a ? a(function() {
                return w;
            }, g, o) : a, j = D(p), E = f.title ? "color: " + f.title(S) + ";" : "", A = [
                "color: gray; font-weight: lighter;"
            ];
            A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
            var O = i(S, j, v);
            try {
                k ? f.title && c ? r.groupCollapsed.apply(r, [
                    "%c " + O
                ].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, [
                    "%c " + O
                ].concat(A)) : r.group(O);
            } catch (e) {
                r.log(O);
            }
            var N = m(u, S, [
                h
            ], "prevState"), P = m(u, S, [
                S
            ], "action"), C = m(u, S, [
                y,
                h
            ], "error"), F = m(u, S, [
                w
            ], "nextState");
            if (N) {
                if (f.prevState) {
                    var L = "color: " + f.prevState(h) + "; font-weight: bold";
                    r[N]("%c prev state", L, h);
                } else r[N]("prev state", h);
            }
            if (P) {
                if (f.action) {
                    var T = "color: " + f.action(S) + "; font-weight: bold";
                    r[P]("%c action    ", T, S);
                } else r[P]("action    ", S);
            }
            if (y && C) {
                if (f.error) {
                    var M = "color: " + f.error(y, h) + "; font-weight: bold;";
                    r[C]("%c error     ", M, y);
                } else r[C]("error     ", y);
            }
            if (F) {
                if (f.nextState) {
                    var _ = "color: " + f.nextState(w) + "; font-weight: bold";
                    r[F]("%c next state", _, w);
                } else r[F]("next state", w);
            }
            l && b(h, w, r, k);
            try {
                r.groupEnd();
            } catch (e) {
                r.log("\u2014\u2014 log end \u2014\u2014");
            }
        });
    }
    function S() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Object.assign({}, L, e), r = t.logger, n = t.stateTransformer, o = t.errorTransformer, i = t.predicate, a = t.logErrors, f = t.diffPredicate;
        if ("undefined" == typeof r) return function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        var u = [];
        return function(e) {
            var r = e.getState;
            return function(e) {
                return function(l) {
                    if ("function" == typeof i && !i(r, l)) return e(l);
                    var c = {};
                    u.push(c), c.started = O.now(), c.startedTime = new Date, c.prevState = n(r()), c.action = l;
                    var s = void 0;
                    if (a) try {
                        s = e(l);
                    } catch (e) {
                        c.error = o(e);
                    }
                    else s = e(l);
                    c.took = O.now() - c.started, c.nextState = n(r());
                    var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
                    if (x(u, Object.assign({}, t, {
                        diff: d
                    })), u.length = 0, c.error) throw c.error;
                    return s;
                };
            };
        };
    }
    var k, j, E = function(e, t) {
        return new Array(t + 1).join(e);
    }, A = function(e, t) {
        return E("0", t - e.toString().length) + e;
    }, D = function(e) {
        return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
    }, O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date, N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, P = function(e) {
        if (Array.isArray(e)) {
            for(var t = 0, r = Array(e.length); t < e.length; t++)r[t] = e[t];
            return r;
        }
        return Array.from(e);
    }, C = [];
    k = "object" === ("undefined" == typeof $parcel$global ? "undefined" : N($parcel$global)) && $parcel$global ? $parcel$global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function() {
        "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
    }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
        diff: {
            value: c,
            enumerable: !0
        },
        observableDiff: {
            value: l,
            enumerable: !0
        },
        applyDiff: {
            value: h,
            enumerable: !0
        },
        applyChange: {
            value: d,
            enumerable: !0
        },
        revertChange: {
            value: g,
            enumerable: !0
        },
        isConflict: {
            value: function() {
                return "undefined" != typeof j;
            },
            enumerable: !0
        },
        noConflict: {
            value: function() {
                return C && (C.forEach(function(e) {
                    e();
                }), C = null), c;
            },
            enumerable: !0
        }
    });
    var F = {
        E: {
            color: "#2196F3",
            text: "CHANGED:"
        },
        N: {
            color: "#4CAF50",
            text: "ADDED:"
        },
        D: {
            color: "#F44336",
            text: "DELETED:"
        },
        A: {
            color: "#2196F3",
            text: "ARRAY:"
        }
    }, L = {
        level: "log",
        logger: console,
        logErrors: !0,
        collapsed: void 0,
        predicate: void 0,
        duration: !1,
        timestamp: !0,
        stateTransformer: function(e) {
            return e;
        },
        actionTransformer: function(e) {
            return e;
        },
        errorTransformer: function(e) {
            return e;
        },
        colors: {
            title: function() {
                return "inherit";
            },
            prevState: function() {
                return "#9E9E9E";
            },
            action: function() {
                return "#03A9F4";
            },
            nextState: function() {
                return "#4CAF50";
            },
            error: function() {
                return "#F20404";
            }
        },
        diff: !1,
        diffPredicate: void 0,
        transformer: void 0
    }, T = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.dispatch, r = e.getState;
        return "function" == typeof t || "function" == typeof r ? S()({
            dispatch: t,
            getState: r
        }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
    };
    e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});

parcelRegister("hTfsm", function(module, exports) {

var $4cz3P = parcelRequire("4cz3P");
/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var $d06390061a2fe15d$var$partition = $4cz3P(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
module.exports = $d06390061a2fe15d$var$partition;

});
parcelRegister("4cz3P", function(module, exports) {

var $4jGbt = parcelRequire("4jGbt");

var $l1tFt = parcelRequire("l1tFt");

var $9JUaE = parcelRequire("9JUaE");

var $jOlpf = parcelRequire("jOlpf");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $30f37ab970802634$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $jOlpf(collection) ? $4jGbt : $l1tFt, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $9JUaE(iteratee, 2), accumulator);
    };
}
module.exports = $30f37ab970802634$var$createAggregator;

});
parcelRegister("4jGbt", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $3249a8ac19cc3c9d$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $3249a8ac19cc3c9d$var$arrayAggregator;

});

parcelRegister("l1tFt", function(module, exports) {

var $73ZOi = parcelRequire("73ZOi");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $f4e0b461e083d709$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $73ZOi(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $f4e0b461e083d709$var$baseAggregator;

});
parcelRegister("73ZOi", function(module, exports) {

var $hmcvL = parcelRequire("hmcvL");

var $5Zryy = parcelRequire("5Zryy");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $5248c273cc69455c$var$baseEach = $5Zryy($hmcvL);
module.exports = $5248c273cc69455c$var$baseEach;

});
parcelRegister("hmcvL", function(module, exports) {

var $k2nAp = parcelRequire("k2nAp");

var $k4FO8 = parcelRequire("k4FO8");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $ca2e32412de355d7$var$baseForOwn(object, iteratee) {
    return object && $k2nAp(object, iteratee, $k4FO8);
}
module.exports = $ca2e32412de355d7$var$baseForOwn;

});

parcelRegister("5Zryy", function(module, exports) {

var $dWb9x = parcelRequire("dWb9x");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $45c8065929f42c0d$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$dWb9x(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $45c8065929f42c0d$var$createBaseEach;

});





parcelRegister("5H1E5", function(module, exports) {
$parcel$export(module.exports, "getATLContextDomain", () => $b45936a4b840dedb$export$b5ce351acdc48c2a);
$parcel$export(module.exports, "getATLContextUrl", () => $b45936a4b840dedb$export$45d6512913ef41b4);


var $cERmE = parcelRequire("cERmE");

var $1YAoR = parcelRequire("1YAoR");
function $b45936a4b840dedb$export$8d21e34596265fa2(data) {
    if (!data || Object.keys(data).length < 1) throw new Error('Data are not available');
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    globalThis.ATL_CONTEXT_DOMAIN = data;
}
function $b45936a4b840dedb$var$isValidDomainKey(domainKey) {
    if (!(0, $1YAoR.AllowedDomains).includes(domainKey)) return false;
    return true;
}
function $b45936a4b840dedb$export$b5ce351acdc48c2a(domain, environment) {
    // Validate this is a valid domain
    if (!$b45936a4b840dedb$var$isValidDomainKey(domain)) throw new Error(`Domain ${domain} is not supported.
      Supported domains: ${(0, $1YAoR.AllowedDomains).join(', ')}`);
    // First priority, always return the global context if the product has onboarded
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    const data = globalThis.ATL_CONTEXT_DOMAIN;
    if (data) return data[domain];
    const [env, perimeter] = environment ?? $b45936a4b840dedb$export$509d18a5fd824839();
    // Second priority, return if there is a full domain override
    const override = (0, $cERmE.fullDomainOverride)[domain];
    if (override) return(// Exact match preferred
    override[perimeter]?.[env] ?? override[0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f][0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9] // Fallback to mandatory commercial production
    );
    // Third priority, join the subdomain
    const tld = (0, $cERmE.domainMap)[perimeter]?.[env] ?? (0, $cERmE.domainMap)[0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f][0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9];
    const subdomain = (0, $cERmE.subdomainOverride)[domain] ?? domain;
    return `${subdomain}.${tld}`;
}
function $b45936a4b840dedb$export$45d6512913ef41b4(domain) {
    return `${globalThis.location?.protocol ?? 'https:'}//${$b45936a4b840dedb$export$b5ce351acdc48c2a(domain)}`;
}
function $b45936a4b840dedb$export$509d18a5fd824839() {
    const hostname = globalThis.location?.hostname;
    if (!hostname) // default if no location available
    return [
        (0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9),
        (0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)
    ];
    // *.atlassian-fex.com
    if (hostname.match(/atlassian-fex\.com/)) return [
        (0, $32f4f7c20d37fe6f$export$a739cd5aac835909),
        (0, $32f4f7c20d37fe6f$export$bd6b5a7802d76127)
    ];
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $32f4f7c20d37fe6f$export$a739cd5aac835909),
        (0, $32f4f7c20d37fe6f$export$ce553301d55c2fd8)
    ];
    // *.atlassian-stg-fedm.net
    if (hostname.match(/atlassian-stg-fedm\.net/)) return [
        (0, $32f4f7c20d37fe6f$export$a739cd5aac835909),
        (0, $32f4f7c20d37fe6f$export$ce553301d55c2fd8)
    ];
    // *.atlassian-us-gov-mod.com OR *.atlassian-us-gov-mod.net
    if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9),
        (0, $32f4f7c20d37fe6f$export$ce553301d55c2fd8)
    ];
    // *.stg.atlassian.com OR *.stg.internal.atlassian.com
    if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
        (0, $32f4f7c20d37fe6f$export$a739cd5aac835909),
        (0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)
    ];
    // *.jira-dev.com
    if (hostname.match(/jira-dev\.com/)) return [
        (0, $32f4f7c20d37fe6f$export$a739cd5aac835909),
        (0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)
    ];
    // default fallthrough
    return [
        (0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9),
        (0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)
    ];
}

});
const $32f4f7c20d37fe6f$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $32f4f7c20d37fe6f$export$f005e2e9f707cb5f = 'commercial';
const $32f4f7c20d37fe6f$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $32f4f7c20d37fe6f$export$a739cd5aac835909 = 'stg';
const $32f4f7c20d37fe6f$export$42dd0cdd351a4a9 = 'prod';
const $32f4f7c20d37fe6f$export$404582bc18fe4d9e = 'dev';

parcelRegister("cERmE", function(module, exports) {
$parcel$export(module.exports, "domainMap", () => $faa20c80f94e275b$export$6836b090dbaa813a);
$parcel$export(module.exports, "subdomainOverride", () => $faa20c80f94e275b$export$c6ab20d0ac4d06b2);
$parcel$export(module.exports, "fullDomainOverride", () => $faa20c80f94e275b$export$4723232b625f823e);

const $faa20c80f94e275b$export$6836b090dbaa813a = {
    [(0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)]: {
        [(0, $32f4f7c20d37fe6f$export$a739cd5aac835909)]: 'stg.atlassian.com',
        [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'atlassian.com'
    },
    [(0, $32f4f7c20d37fe6f$export$bd6b5a7802d76127)]: {
        [(0, $32f4f7c20d37fe6f$export$a739cd5aac835909)]: 'atlassian-fex.com'
    },
    [(0, $32f4f7c20d37fe6f$export$ce553301d55c2fd8)]: {
        [(0, $32f4f7c20d37fe6f$export$a739cd5aac835909)]: 'stg.atlassian-us-gov-mod.com',
        [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'atlassian-us-gov-mod.com'
    }
};
const $faa20c80f94e275b$export$c6ab20d0ac4d06b2 = {};
const $faa20c80f94e275b$export$4723232b625f823e = {
    analytics: {
        [(0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'analytics.atlassian.com'
        }
    },
    // Marketing site
    confluence: {
        [(0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'confluence.atlassian.com'
        }
    },
    // Atlassian design system documentation
    design: {
        [(0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'design.atlassian.com'
        }
    },
    // Old staff intranet (now hello.atlassian.net)
    extranet: {
        [(0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'extranet.atlassian.com'
        }
    },
    // Go links
    go: {
        [(0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'go.atlassian.com'
        }
    },
    my: {
        [(0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'my.atlassian.com'
        }
    },
    schema: {
        [(0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'schema.atlassian.com'
        }
    },
    start: {
        [(0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'start.atlassian.com',
            [(0, $32f4f7c20d37fe6f$export$a739cd5aac835909)]: 'start.stg.atlassian.com'
        },
        [(0, $32f4f7c20d37fe6f$export$ce553301d55c2fd8)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'start.atlassian-us-gov-mod.com',
            [(0, $32f4f7c20d37fe6f$export$a739cd5aac835909)]: 'start.stg.atlassian-us-gov-mod.com'
        }
    },
    surveys: {
        [(0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'surveys.atlassian.com'
        }
    },
    'wac-cdn': {
        [(0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'wac-cdn.atlassian.com'
        }
    },
    integrations: {
        [(0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'integrations.atlassian.com'
        }
    },
    permalink: {
        [(0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'permalink.atlassian.com'
        }
    },
    id: {
        [(0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'id.atlassian.com',
            [(0, $32f4f7c20d37fe6f$export$a739cd5aac835909)]: 'id.stg.internal.atlassian.com',
            [(0, $32f4f7c20d37fe6f$export$404582bc18fe4d9e)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $32f4f7c20d37fe6f$export$ce553301d55c2fd8)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'id.atlassian-us-gov-mod.com',
            [(0, $32f4f7c20d37fe6f$export$a739cd5aac835909)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    },
    support: {
        [(0, $32f4f7c20d37fe6f$export$f005e2e9f707cb5f)]: {
            [(0, $32f4f7c20d37fe6f$export$42dd0cdd351a4a9)]: 'support.atlassian.com'
        }
    }
};

});

parcelRegister("1YAoR", function(module, exports) {
$parcel$export(module.exports, "AllowedDomains", () => $ea86254ac1d658e3$export$b450288891b9771b);
/* *NOTE*: please ensure any changes made to Perimeter and DomainKey type is copied in typings/atl-context.globals.d.ts */ const $ea86254ac1d658e3$export$b450288891b9771b = [
    'admin',
    'analytics',
    'api',
    'api.media',
    'api-private',
    'as',
    'atl-global',
    'atlaskit',
    'auth',
    'automation',
    'cassi.internal',
    'cc-import-sources.services',
    'confluence',
    'confluence-chats-integr.services',
    'confluence-cloud-bamboo.internal',
    'confluence-questions.services',
    'data-portal.internal',
    'design',
    'developer',
    'extranet',
    'go',
    'id',
    'id-mail-assets',
    'integrations',
    'ja',
    'jira',
    'jsd-widget',
    'jsd-widget-staging',
    'marketplace',
    'my',
    'my-reminders.services',
    'partners',
    'permalink',
    'permalink.stg',
    'schema',
    'start',
    'support',
    'surveys',
    'team',
    'wac-cdn',
    'xxid',
    'home'
];

});


parcelRegister("i8gMT", function(module, exports) {
$parcel$export(module.exports, "getInstance", () => $7dcfa280885ecc5e$export$8bedcca5bbd73999);

var $5H1E5 = parcelRequire("5H1E5");

var $8IF8Z = parcelRequire("8IF8Z");

var $wnOPK = parcelRequire("wnOPK");

var $lLIu7 = parcelRequire("lLIu7");
const $7dcfa280885ecc5e$var$redirect = ()=>{
    const identity = (0, $5H1E5.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
    window.location.assign(redirectUrl);
};
const $7dcfa280885ecc5e$var$timeIsBeforeNow = (dateTime)=>{
    return !!(dateTime && dateTime.getTime() <= Date.now());
};
const $7dcfa280885ecc5e$var$HeartbeatService = ()=>{
    let timer;
    let heartBeatInterval;
    let nextCallTimestamp;
    let sessionExpiryTimestamp;
    let initialized = false;
    let authenticated = false;
    let userActive = true;
    let tabActive = true;
    const isAuthenticated = ()=>{
        return authenticated;
    };
    const isInitialized = ()=>{
        return initialized;
    };
    const init = ()=>{
        // Initial heartbeat
        beat();
        heartBeatInterval = setupHeartbeatInterval();
        timer = setupBrowserInteractionTime();
    };
    const cleanup = ()=>{
        clearHeartbeatInterval();
        clearBrowserInteractionTime();
    };
    const beat = async ()=>{
        try {
            const response = await (0, $lLIu7.postHeartbeat)((0, $8IF8Z.DEFAULT_HEARTBEAT_ENDPOINT), $7dcfa280885ecc5e$var$redirect);
            if (!initialized) initialized = true;
            if (response) {
                const { nextCallTimestamp: nextCallT, sessionExpiryTime: sessionExpiryT } = response;
                nextCallTimestamp = new Date(nextCallT);
                sessionExpiryTimestamp = sessionExpiryT ? new Date(sessionExpiryT) : undefined;
                authenticated = true;
            }
        } catch (error) {
            // Silent degradation - heartbeat service should not interfere with application
            authenticated = false;
            clearHeartbeatInterval();
        }
    };
    const setupHeartbeatInterval = ()=>setInterval(()=>{
            if ($7dcfa280885ecc5e$var$timeIsBeforeNow(sessionExpiryTimestamp) || userActive && tabActive && $7dcfa280885ecc5e$var$timeIsBeforeNow(nextCallTimestamp)) beat();
        }, (0, $8IF8Z.INTERVAL_TIME));
    const clearHeartbeatInterval = ()=>{
        clearInterval(heartBeatInterval);
        heartBeatInterval = undefined;
    };
    const setupBrowserInteractionTime = ()=>{
        const timer = new (0, $wnOPK.default)({
            idleTimeoutMs: (0, $8IF8Z.DEFAULT_IDLE_TIME),
            stopTimerOnTabchange: false,
            browserTabActiveCallbacks: [
                ()=>tabActive = true
            ],
            browserTabInactiveCallbacks: [
                ()=>tabActive = false
            ],
            idleCallbacks: [
                ()=>{
                    // Beat once when the user goes idle and the tab is active
                    if (tabActive) beat();
                    userActive = false;
                }
            ],
            activeCallbacks: [
                ()=>userActive = true
            ]
        });
        timer.startTimer();
        return timer;
    };
    const clearBrowserInteractionTime = ()=>{
        timer && timer.destroy();
        timer = undefined;
    };
    return {
        isAuthenticated: isAuthenticated,
        isInitialized: isInitialized,
        init: init,
        cleanup: cleanup
    };
};
let $7dcfa280885ecc5e$var$instance = null;
const $7dcfa280885ecc5e$export$8bedcca5bbd73999 = ()=>{
    if (!$7dcfa280885ecc5e$var$instance) {
        $7dcfa280885ecc5e$var$instance = $7dcfa280885ecc5e$var$HeartbeatService();
        $7dcfa280885ecc5e$var$instance.init();
    }
    return $7dcfa280885ecc5e$var$instance;
};

});
parcelRegister("8IF8Z", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_HEARTBEAT_ENDPOINT", () => $fdf874fd736045f7$export$4496080a0271e85d);
$parcel$export(module.exports, "DEFAULT_IDLE_TIME", () => $fdf874fd736045f7$export$af2ff676951003fe);
$parcel$export(module.exports, "INTERVAL_TIME", () => $fdf874fd736045f7$export$f2b2f5ef0b498d26);
const $fdf874fd736045f7$export$4496080a0271e85d = '/gateway/api/session/heartbeat';
const $fdf874fd736045f7$export$af2ff676951003fe = 60000; // 60 seconds
const $fdf874fd736045f7$export$f2b2f5ef0b498d26 = 10000; // 10 seconds

});

parcelRegister("wnOPK", function(module, exports) {
$parcel$export(module.exports, "default", () => $3348a0057906de5b$export$2e2bcd8739ae039);

var $5pMen = parcelRequire("5pMen");
const $3348a0057906de5b$var$windowIdleEvents = [
    'scroll',
    'resize'
];
const $3348a0057906de5b$var$documentIdleEvents = [
    'wheel',
    'keydown',
    'keyup',
    'mousedown',
    'mousemove',
    'touchstart',
    'touchmove',
    'click',
    'contextmenu'
];
class $3348a0057906de5b$export$2e2bcd8739ae039 {
    constructor({ timeIntervalEllapsedCallbacks: timeIntervalEllapsedCallbacks = [], absoluteTimeEllapsedCallbacks: absoluteTimeEllapsedCallbacks = [], checkCallbacksIntervalMs: checkCallbacksIntervalMs = 100, browserTabInactiveCallbacks: browserTabInactiveCallbacks = [], idleCallbacks: idleCallbacks = [], stopTimerOnTabchange: stopTimerOnTabchange = true, activeCallbacks: activeCallbacks = [], browserTabActiveCallbacks: browserTabActiveCallbacks = [], idleTimeoutMs: idleTimeoutMs = 3000 }){
        this.onBrowserTabInactive = ()=>{
            // if running pause timer
            if (this.isRunning() && this.stopTimerOnTabchange) this.stopTimer();
            this.browserTabInactiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
        };
        this.onBrowserTabActive = ()=>{
            // if not running start timer
            if (!this.isRunning()) this.startTimer();
            this.browserTabActiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
        };
        this.onBrowserActiveChange = ()=>{
            if (document.visibilityState === 'visible') this.onBrowserTabActive();
            else this.onBrowserTabInactive();
        };
        this.onTimePassed = ()=>{
            // check all callbacks time and if passed execute callback
            this.absoluteTimeEllapsedCallbacks.forEach(({ callback: callback, pending: pending, timeInMilliseconds: timeInMilliseconds }, index)=>{
                if (pending && timeInMilliseconds <= this.getTimeInMilliseconds()) {
                    callback(this.getTimeInMilliseconds());
                    this.absoluteTimeEllapsedCallbacks[index].pending = false;
                }
            });
            this.timeIntervalEllapsedCallbacks.forEach(({ callback: callback, timeInMilliseconds: timeInMilliseconds, multiplier: multiplier }, index)=>{
                if (timeInMilliseconds <= this.getTimeInMilliseconds()) {
                    callback(this.getTimeInMilliseconds());
                    this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                }
            });
            if (this.currentIdleTimeMs >= this.idleTimeoutMs && this.isRunning()) {
                this.idle = true;
                this.stopTimer();
                this.idleCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            } else this.currentIdleTimeMs += this.checkCallbacksIntervalMs;
        };
        this.resetIdleTime = ()=>{
            if (this.idle) this.startTimer();
            this.activeCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            this.idle = false;
            this.currentIdleTimeMs = 0;
        };
        this.registerEventListeners = ()=>{
            const documentListenerOptions = {
                passive: true
            };
            const windowListenerOptions = {
                ...documentListenerOptions,
                capture: true
            };
            document.addEventListener('visibilitychange', this.onBrowserActiveChange);
            const throttleResetIdleTime = (0, (/*@__PURE__*/$parcel$interopDefault($5pMen)))(this.resetIdleTime, 2000, {
                leading: true,
                trailing: false
            });
            $3348a0057906de5b$var$windowIdleEvents.forEach((event)=>{
                window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
            });
            $3348a0057906de5b$var$documentIdleEvents.forEach((event)=>document.addEventListener(event, throttleResetIdleTime, documentListenerOptions));
        };
        this.unregisterEventListeners = ()=>{
            document.removeEventListener('visibilitychange', this.onBrowserActiveChange);
            $3348a0057906de5b$var$windowIdleEvents.forEach((event)=>window.removeEventListener(event, this.resetIdleTime));
            $3348a0057906de5b$var$documentIdleEvents.forEach((event)=>document.removeEventListener(event, this.resetIdleTime));
        };
        this.checkCallbacksOnInterval = ()=>{
            this.checkCallbackIntervalId = window.setInterval(()=>{
                this.onTimePassed();
            }, this.checkCallbacksIntervalMs);
        };
        this.startTimer = ()=>{
            if (!this.checkCallbackIntervalId) this.checkCallbacksOnInterval();
            const last = this.times[this.times.length - 1];
            if (last && last.stop === null) return;
            this.times.push({
                start: performance.now(),
                stop: null
            });
            this.running = true;
        };
        this.stopTimer = ()=>{
            if (!this.times.length) return;
            this.times[this.times.length - 1].stop = performance.now();
            this.running = false;
        };
        this.addTimeIntervalEllapsedCallback = (timeIntervalEllapsedCallback)=>{
            this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
        };
        this.addAbsoluteTimeEllapsedCallback = (absoluteTimeEllapsedCallback)=>{
            this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
        };
        this.addBrowserTabInactiveCallback = (browserTabInactiveCallback)=>{
            this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
        };
        this.addBrowserTabActiveCallback = (browserTabActiveCallback)=>{
            this.browserTabActiveCallbacks.push(browserTabActiveCallback);
        };
        this.addIdleCallback = (inactiveCallback)=>{
            this.idleCallbacks.push(inactiveCallback);
        };
        this.addActiveCallback = (activeCallback)=>{
            this.activeCallbacks.push(activeCallback);
        };
        this.getTimeInMilliseconds = ()=>{
            return this.times.reduce((acc, current)=>{
                if (current.stop) acc = acc + (current.stop - current.start);
                else acc = acc + (performance.now() - current.start);
                return acc;
            }, 0);
        };
        this.isRunning = ()=>{
            return this.running;
        };
        this.isIdle = ()=>{
            return this.idle;
        };
        this.reset = ()=>{
            this.times = [];
        };
        this.destroy = ()=>{
            this.unregisterEventListeners();
            if (this.checkCallbackIntervalId) window.clearInterval(this.checkCallbackIntervalId);
        };
        this.running = false;
        this.times = [];
        this.idle = false;
        this.currentIdleTimeMs = 0;
        this.marks = {};
        this.measures = {};
        this.stopTimerOnTabchange = stopTimerOnTabchange;
        this.browserTabActiveCallbacks = browserTabActiveCallbacks;
        this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
        this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
        this.idleTimeoutMs = idleTimeoutMs;
        this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
        this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
        this.idleCallbacks = idleCallbacks;
        this.activeCallbacks = activeCallbacks;
        this.registerEventListeners();
    }
    mark(key) {
        if (!this.marks[key]) this.marks[key] = [];
        this.marks[key].push({
            time: this.getTimeInMilliseconds()
        });
    }
    getMarks(name) {
        if (this.marks[name].length < 1) return;
        return this.marks[name];
    }
    measure(name, startMarkName, endMarkName) {
        const startMarks = this.marks[startMarkName];
        const startMark = startMarks[startMarks.length - 1];
        const endMarks = this.marks[endMarkName];
        const endMark = endMarks[endMarks.length - 1];
        if (!this.measures[name]) this.measures[name] = [];
        this.measures[name].push({
            name: name,
            startTime: startMark.time,
            duration: endMark.time - startMark.time
        });
    }
    getMeasures(name) {
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        if (!this.measures[name] && this.measures[name].length < 1) return;
        return this.measures[name];
    }
}

});
parcelRegister("5pMen", function(module, exports) {

var $eVMQF = parcelRequire("eVMQF");

var $cslvQ = parcelRequire("cslvQ");
/** Error message constants. */ var $3f14b335ca0defe8$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $3f14b335ca0defe8$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($3f14b335ca0defe8$var$FUNC_ERROR_TEXT);
    if ($cslvQ(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $eVMQF(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $3f14b335ca0defe8$var$throttle;

});


parcelRegister("lLIu7", function(module, exports) {
$parcel$export(module.exports, "postHeartbeat", () => $fdb2f015f066cbf0$export$931f43089f67754c);
const $fdb2f015f066cbf0$var$RETRY_HTTP_CODES = [
    408,
    500,
    502,
    503,
    504,
    522,
    524
];
function $fdb2f015f066cbf0$var$timeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
async function $fdb2f015f066cbf0$var$fetchRetry(url, options = {}, retries = 5, backoff = 300) {
    const response = await fetch(url, options);
    if (response.ok || response.status === 401) return response;
    if (retries > 0 && $fdb2f015f066cbf0$var$RETRY_HTTP_CODES.includes(response.status)) {
        await $fdb2f015f066cbf0$var$timeout(backoff);
        return await $fdb2f015f066cbf0$var$fetchRetry(url, options, retries - 1, backoff * 2);
    } else return Promise.reject(response);
}
const $fdb2f015f066cbf0$export$931f43089f67754c = async (endpoint, onAuthenticationFailed, onBadRequest)=>{
    try {
        const response = await $fdb2f015f066cbf0$var$fetchRetry(endpoint, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response && response.ok) return response.json();
        if (response && response.status === 401 && onAuthenticationFailed) {
            onAuthenticationFailed();
            return;
        }
    } catch (e) {
        const errorResponse = e;
        if (errorResponse.status === 400) {
            onBadRequest?.();
            return Promise.reject(errorResponse);
        }
        $fdb2f015f066cbf0$var$RETRY_HTTP_CODES.includes(errorResponse.status);
    }
};

});


parcelRegister("8nMDY", function(module, exports) {
$parcel$export(module.exports, "getRelayExperimentalApis", () => $f72dbb4258d29405$export$2cb71284f72ca45b);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
const $f72dbb4258d29405$export$ebe3a775ce3053a5 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs',
    'help-object-store-agg-beta',
    'HelpCenterReorderTopics',
    'polaris-v0'
];
const $f72dbb4258d29405$export$2cb71284f72ca45b = ()=>$f72dbb4258d29405$export$ebe3a775ce3053a5;

});

parcelRegister("edGGR", function(module, exports) {
$parcel$export(module.exports, "createRelayEnvironment", () => $5985f66d4bb88c0a$export$7afaa9c867644497);

var $lIGkE = parcelRequire("lIGkE");

var $gdWPm = parcelRequire("gdWPm");

var $jiTLE = parcelRequire("jiTLE");

var $gTnnv = parcelRequire("gTnnv");

var $dp0Rz = parcelRequire("dp0Rz");

var $azQP4 = parcelRequire("azQP4");

var $NZFdy = parcelRequire("NZFdy");

var $3VbHo = parcelRequire("3VbHo");

var $fUeId = parcelRequire("fUeId");
// Enable Relay Resolvers globally for this module
(0, $lIGkE.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
function $5985f66d4bb88c0a$var$createNetwork(networkOptions) {
    return (0, $lIGkE.Network).create((request, variables, cacheConfig)=>(0, $azQP4.fetch)(request, variables, cacheConfig, networkOptions), networkOptions.isServer === false ? (0, $fUeId.createSubscribeFn)(networkOptions) : undefined);
}
const $5985f66d4bb88c0a$var$createStore = (source, options)=>{
    return new (0, (/*@__PURE__*/$parcel$interopDefault($gdWPm)))(source, options);
};
// Copied from ConnectionHandler.deleteNode implementation with a single change in behaviour:
// nodeID is compared to the `id` field of the node, rather than node.getDataID().
// This is a sane thing to do within the scope of a single connection even in the light of
// id collisions present in AGG for the entities of different types.
// Such change makes @deleteEdge directive usable again.
function $5985f66d4bb88c0a$var$deleteNode(record, nodeID) {
    const { EDGES: EDGES, NODE: NODE } = (0, $lIGkE.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    let nextEdges;
    for(let ii = 0; ii < edges.length; ii++){
        const edge = edges[ii];
        const node = edge && edge.getLinkedRecord(NODE);
        // N.B. node.getValue('id') instead of node.getDataID()
        if (node != null && node.getValue('id') === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
// Copied from DeleteEdgeHandler implementation in Relay with a single change in behaviour:
// it calls deleteNode above instead of ConnectionHandler.deleteNode.
const $5985f66d4bb88c0a$var$DeleteEdgeHandler = {
    update: (store, payload)=>{
        const record = store.get(payload.dataID);
        if (record == null) return;
        // @types/relay-runtime is broken, handleArgs is present in the original Flow types.
        const { connections: connections } = payload.handleArgs;
        (0, $jiTLE.default)(connections != null, 'MutationHandlers: Expected connection IDs to be specified.');
        const idOrIds = record.getValue(payload.fieldKey);
        const idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach((id)=>{
            if (typeof id === 'string') for (const connectionID of connections){
                const connection = store.get(connectionID);
                if (connection == null) {
                    (0, $gTnnv.default)(false, `[Relay] The connection with id ${connectionID} doesn't exist.`);
                    continue;
                }
                $5985f66d4bb88c0a$var$deleteNode(connection, id);
            }
        });
    }
};
function $5985f66d4bb88c0a$var$HandlerProvider(handle) {
    switch(handle){
        case 'deleteEdge':
            return $5985f66d4bb88c0a$var$DeleteEdgeHandler;
        default:
            return (0, $lIGkE.DefaultHandlerProvider)(handle);
    }
}
function $5985f66d4bb88c0a$export$7afaa9c867644497({ log: log, requiredFieldLogger: requiredFieldLogger, networkOptions: networkOptions, getDataID: getDataID }) {
    return new (0, $lIGkE.Environment)({
        configName: 'Atlassian Shared Graphql Gateway',
        network: $5985f66d4bb88c0a$var$createNetwork(networkOptions || {
            isServer: false
        }),
        store: $5985f66d4bb88c0a$var$createStore(new (0, $lIGkE.RecordSource)(), {
            log: log ?? undefined,
            getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $dp0Rz.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $dp0Rz.default),
        scheduler: (0, $3VbHo.default),
        missingFieldHandlers: (0, $NZFdy.default),
        handlerProvider: $5985f66d4bb88c0a$var$HandlerProvider
    });
}

});
parcelRegister("gdWPm", function(module, exports) {
'use strict';

var $kg5Mx = parcelRequire("kg5Mx");
module.exports = $kg5Mx;

});

parcelRegister("gTnnv", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4c3ead0da5ed4ba$export$2e2bcd8739ae039);
var $c4c3ead0da5ed4ba$var$isProduction = true;
function $c4c3ead0da5ed4ba$var$warning(condition, message) {
    if (!$c4c3ead0da5ed4ba$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $c4c3ead0da5ed4ba$export$2e2bcd8739ae039 = $c4c3ead0da5ed4ba$var$warning;

});

parcelRegister("dp0Rz", function(module, exports) {
$parcel$export(module.exports, "default", () => $3dea31f22366d4df$export$2e2bcd8739ae039);
function $3dea31f22366d4df$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    return `${String(id)}:::::${typeName}`;
}

});

parcelRegister("azQP4", function(module, exports) {
$parcel$export(module.exports, "fetch", () => $ecb42a18ab63c5a4$export$e7aa7bc5c1b3cfb3);

var $WqSvO = parcelRequire("WqSvO");

var $lIGkE = parcelRequire("lIGkE");

var $egspI = parcelRequire("egspI");

var $4JkUK = parcelRequire("4JkUK");

var $6b5L5 = parcelRequire("6b5L5");

var $5SJ3N = parcelRequire("5SJ3N");

var $511Fu = parcelRequire("511Fu");

var $hfZ0x = parcelRequire("hfZ0x");

var $b8Dvw = parcelRequire("b8Dvw");

var $izqDl = parcelRequire("izqDl");

var $atcQv = parcelRequire("atcQv");

var $aQEWc = parcelRequire("aQEWc");
const $ecb42a18ab63c5a4$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $ecb42a18ab63c5a4$var$moduleID = 'relay-fetch';
const $ecb42a18ab63c5a4$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig, dependencies)=>{
    if ((0, $egspI.fg)('nike_redirect-logic-jira')) {
        if (dependencies?.didPreflightAuthenticationCheckTriggerRedirect?.(request, variables, cacheConfig) === true) // Jira's preflight check starts login navigation as a side effect. Keep Relay pending
        // while the redirect takes over instead of starting a fetch with a stale auth state.
        return (0, $lIGkE.Observable).from(new Promise(()=>{}));
    }
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = dependencies?.getLoggingAndMetricsHelper?.(loggingMetadata);
    function augmentResponse(response) {
        (0, $511Fu.addTraceId)(queryName, (0, $aQEWc.getTraceIdFromExtensions)(response));
        (0, $4JkUK.putExtensions)(queryName, response.extensions);
    }
    // TODO: This needs to be changed by removing each Product, and only if all keys are empty final output is null
    function enforceNonNullability(response) {
        if (response.data && // DO NOT ADD TO THIS CONDITION.
        // Doing so can make service timeouts in non-critical dependencies result in a complete breakage of experiences.
        // If requesting a namespaced field, flatten it - e.g. "query { foo { bar {" should become "query { foo_bar {".
        // See https://atlassian.slack.com/archives/C01E2MPPLE4/p1780367270438419.
        (response.data.jira === null || response.data.customerService === null || response.data.graphStore === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    return (0, $lIGkE.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$ecb42a18ab63c5a4$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // handles getting multipart response
            const getData = ()=>{
                const endpoint = (0, $6b5L5.getAggEndpoint)(request, cacheConfig);
                const body = (0, $6b5L5.getRequestBody)(request, variables);
                let options = {
                    body: body
                };
                if (dependencies?.getHeaders) {
                    const headers = dependencies.getHeaders({
                        endpoint: endpoint,
                        options: options,
                        request: request,
                        variables: variables
                    });
                    options = {
                        ...options,
                        headers: {
                            ...options.headers,
                            ...headers
                        }
                    };
                }
                if (dependencies?.getAbortSignal) options.signal = dependencies?.getAbortSignal();
                const fetchOverNetwork = (0, $izqDl.buildGraphqlSmartFetch)({
                    url: dependencies?.setEndpoint ? dependencies?.setEndpoint(endpoint) : endpoint,
                    options: options,
                    variables: variables,
                    request: request,
                    isServer: dependencies?.isServer || false,
                    cacheConfig: cacheConfig
                });
                const earlyScriptPromise = dependencies?.earlyScriptPromise?.(request, variables);
                let fetchFn = fetchOverNetwork;
                let initialSource = fetchFn;
                if (dependencies?.withErrorHandling) {
                    const withErrorHandling = dependencies.withErrorHandling;
                    initialSource = ()=>!dependencies?.isServer && earlyScriptPromise ? withErrorHandling(earlyScriptPromise) : withErrorHandling(fetchFn());
                }
                const responses = (0, $izqDl.processMultipartPromise)(()=>(0, $atcQv.retryOnError)(initialSource, {
                        retryFunc: fetchFn,
                        retryPredicate: (0, $atcQv.shouldRetry),
                        retryAttempts: (0, $atcQv.getRetryAttemptsForQuery)(request),
                        onRetry: loggingAndMetrics?.logErrorRetry
                    }), dependencies?.onFetchError);
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (dependencies?.isServer) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = $ecb42a18ab63c5a4$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, $5SJ3N.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, $5SJ3N.QueryPromisesMap).set(requestID, firstResponse);
                            (0, $5SJ3N.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: (r)=>{
                        let payload = r;
                        let response = payload || {};
                        if (dependencies?.isServer && $ecb42a18ab63c5a4$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, $b8Dvw.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if (dependencies?.validateResponse && !dependencies.validateResponse(request, singularResponse)) {
                                dependencies?.onInvalidResponse?.(request, singularResponse);
                                responseShouldHang = true;
                                return;
                            }
                            if ((0, $egspI.fg)('platform_relay_use_new_non_nullability')) response = $ecb42a18ab63c5a4$export$b143926e518df3b(singularResponse);
                            else enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if (dependencies?.isServer && requestID != null && typeof dependencies?.queryResponseCache !== 'undefined') {
                                if ('appendWithMetadata' in dependencies.queryResponseCache) dependencies.queryResponseCache.appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                                else dependencies.queryResponseCache.setWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                            }
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if (dependencies?.isServer && $ecb42a18ab63c5a4$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        loggingAndMetrics?.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!dependencies?.isServer && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = dependencies?.queryResponseCache?.get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(ssrCache)) {
                    dependencies?.queryResponseCache?.delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($ecb42a18ab63c5a4$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $hfZ0x.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $hfZ0x.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                dependencies?.handleAbort?.(request, reason);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics?.logError(error);
            sink.error(error);
        }
    });
};
function $ecb42a18ab63c5a4$export$b143926e518df3b(response) {
    if (response.data) {
        // Enforce non-nullability of the product namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        let sanitisedData = Object.assign({}, response.data);
        const productKeys = [
            'jira',
            'customerService',
            'graphStore'
        ];
        for (const product of productKeys)if (sanitisedData[product] === null) delete sanitisedData[product];
        if (Object.keys(sanitisedData).length === 0) // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Dataa
        sanitisedData = null;
        response.data = sanitisedData;
    }
    return response;
}

});
parcelRegister("4JkUK", function(module, exports) {
$parcel$export(module.exports, "startCapturingExtensions", () => $267f4f54a9f768ce$export$8656ba3981c6f6c1);
$parcel$export(module.exports, "stopCapturingExtensions", () => $267f4f54a9f768ce$export$f16fa6040161f056);
$parcel$export(module.exports, "putExtensions", () => $267f4f54a9f768ce$export$17dc47fdf278de21);
$parcel$export(module.exports, "getExtensions", () => $267f4f54a9f768ce$export$7c6ea4184129ef74);
const $267f4f54a9f768ce$var$OperationExtensionsMap = {};
const $267f4f54a9f768ce$export$8656ba3981c6f6c1 = (operationName)=>{
    $267f4f54a9f768ce$var$OperationExtensionsMap[operationName] = $267f4f54a9f768ce$var$OperationExtensionsMap[operationName] || [];
};
const $267f4f54a9f768ce$export$f16fa6040161f056 = (operationName)=>{
    $267f4f54a9f768ce$var$OperationExtensionsMap[operationName] = undefined;
};
const $267f4f54a9f768ce$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $267f4f54a9f768ce$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $267f4f54a9f768ce$export$7c6ea4184129ef74 = (operationName)=>$267f4f54a9f768ce$var$OperationExtensionsMap[operationName] || [];

});

parcelRegister("6b5L5", function(module, exports) {
$parcel$export(module.exports, "getAggEndpoint", () => $1068c774ee90f262$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $1068c774ee90f262$export$55bce18df99af758);

var $gIMgJ = parcelRequire("gIMgJ");
const $1068c774ee90f262$var$branchSlug = typeof $gIMgJ !== 'undefined' && $gIMgJ.env ? undefined : undefined;
// Pre-encoded value passed through verbatim as the `serviceOverride` query param.
const $1068c774ee90f262$var$serviceOverrides = typeof $gIMgJ !== 'undefined' && $gIMgJ.env ? undefined : undefined;
const $1068c774ee90f262$export$8f8c52ac77845a86 = `/gateway/api/graphql${$1068c774ee90f262$var$branchSlug ? `/${$1068c774ee90f262$var$branchSlug}/graphql` : ''}`;
const $1068c774ee90f262$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    let endpoint = $1068c774ee90f262$export$8f8c52ac77845a86;
    if (cacheConfig.metadata?.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    let url = `${endpoint}?operation=${request.name}`;
    if ($1068c774ee90f262$var$serviceOverrides) url = `${url}&serviceOverride=${$1068c774ee90f262$var$serviceOverrides}`;
    return url;
};
const $1068c774ee90f262$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});

parcelRegister("5SJ3N", function(module, exports) {
$parcel$export(module.exports, "QueryPromisesMap", () => $95abf4ad0bccd03b$export$607b80f5bc6e396d);
$parcel$export(module.exports, "CompletedQueryPromisesMap", () => $95abf4ad0bccd03b$export$cdadce6ed6361a2c);
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $95abf4ad0bccd03b$export$607b80f5bc6e396d = new Map();
const $95abf4ad0bccd03b$export$cdadce6ed6361a2c = new Map();

});

parcelRegister("511Fu", function(module, exports) {
$parcel$export(module.exports, "startCapturingTraceIds", () => $61738d4a5a79eff1$export$a2bcb2fac360646c);
$parcel$export(module.exports, "stopCapturingTraceIds", () => $61738d4a5a79eff1$export$559128bdc4352001);
$parcel$export(module.exports, "addTraceId", () => $61738d4a5a79eff1$export$fcaa732775f12226);
$parcel$export(module.exports, "getTraceIds", () => $61738d4a5a79eff1$export$5113e470f5c95670);
const $61738d4a5a79eff1$var$OperationTraceIdMap = {};
const $61738d4a5a79eff1$export$a2bcb2fac360646c = (operationName)=>{
    $61738d4a5a79eff1$var$OperationTraceIdMap[operationName] = $61738d4a5a79eff1$var$OperationTraceIdMap[operationName] || [];
};
const $61738d4a5a79eff1$export$559128bdc4352001 = (operationName)=>{
    $61738d4a5a79eff1$var$OperationTraceIdMap[operationName] = undefined;
};
const $61738d4a5a79eff1$export$fcaa732775f12226 = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = $61738d4a5a79eff1$var$OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const $61738d4a5a79eff1$export$5113e470f5c95670 = (operationName)=>$61738d4a5a79eff1$var$OperationTraceIdMap[operationName] || [];

});

parcelRegister("hfZ0x", function(module, exports) {
$parcel$export(module.exports, "CLIENT_DISPATCHER_MODULE", () => $e129b3d3b6d66863$export$eb5d9c90d65c7fea);
$parcel$export(module.exports, "getClientDispatcher", () => $e129b3d3b6d66863$export$5bb012cf9b3a5452);

var $3FFFH = parcelRequire("3FFFH");
const $e129b3d3b6d66863$export$eb5d9c90d65c7fea = 'ClientDispatcher';
let $e129b3d3b6d66863$var$dispatcher;
const $e129b3d3b6d66863$export$5bb012cf9b3a5452 = ()=>{
    if (!$e129b3d3b6d66863$var$dispatcher) {
        $e129b3d3b6d66863$var$dispatcher = new (0, $3FFFH.ClientDispatcher)();
        // Handle the server hangup scenarios
        $e129b3d3b6d66863$var$dispatcher.register($e129b3d3b6d66863$export$eb5d9c90d65c7fea, $e129b3d3b6d66863$var$dispatcher._abort.bind($e129b3d3b6d66863$var$dispatcher));
    }
    return $e129b3d3b6d66863$var$dispatcher;
};

});
parcelRegister("3FFFH", function(module, exports) {
$parcel$export(module.exports, "ClientDispatcher", () => $7200a458901c0264$export$3f5ba18eb97af725);
class $7200a458901c0264$export$3f5ba18eb97af725 {
    constructor(){
        this.handlers = new Map();
        this.abortHandlers = new Map();
        this.queuedPayloads = new Map();
    }
    /**
	 * Ingest a payload from the server.
	 * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
	 * @param payload - The payload to ingest.
	 */ ingest(payload) {
        const handler = this.handlers.get(payload.id);
        if (handler) this.exec(handler, payload);
        else {
            const queue = this.queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.queuedPayloads.set(payload.id, queue);
        }
    }
    /**
	 * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when the event is ingested.
	 */ register(id, callback) {
        this.handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.exec(callback, payload));
            this.queuedPayloads.delete(id);
        }
    }
    /**
	 * Unregister a callback for a given event.
	 * @param id
	 */ unregister(id) {
        this.handlers.delete(id);
        this.queuedPayloads.delete(id);
    }
    /**
	 * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when abort detected.
	 */ onAbort(id, callback) {
        if (this.abortReason) this.exec(callback, {
            args: [
                this.abortReason
            ]
        });
        else this.abortHandlers.set(id, callback);
    }
    /**
	 * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
	 * @private
	 * @param props
	 */ _abort(props) {
        this.abortReason = props;
        this.abortHandlers.forEach((handler)=>{
            this.exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.abortHandlers = new Map();
    }
    /**
	 * Execute a callback with the given payload.
	 * @param callback - The callback to execute.
	 * @param payload - The payload to execute the callback with.
	 */ exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            // @ts-expect-error
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
}

});


parcelRegister("b8Dvw", function(module, exports) {
$parcel$export(module.exports, "registerEvent", () => $4ffb220ef717ac7b$export$bd50bc4cd3c601ee);
const $4ffb220ef717ac7b$var$events = [];
const $4ffb220ef717ac7b$export$bd50bc4cd3c601ee = (event)=>{
    $4ffb220ef717ac7b$var$events.push(event);
};
const $4ffb220ef717ac7b$export$3c7145db84d4587c = ()=>{
    return $4ffb220ef717ac7b$var$events.splice(0, $4ffb220ef717ac7b$var$events.length);
};

});

parcelRegister("izqDl", function(module, exports) {
$parcel$export(module.exports, "processMultipartPromise", () => $1bfe0ef3752d92e8$export$f76505a7f2969e4e);
$parcel$export(module.exports, "buildGraphqlSmartFetch", () => $1bfe0ef3752d92e8$export$33c9c992c7855d86);
/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */ 
var $6Fltw = parcelRequire("6Fltw");

var $lIGkE = parcelRequire("lIGkE");

var $egspI = parcelRequire("egspI");

var $8nMDY = parcelRequire("8nMDY");
const $1bfe0ef3752d92e8$var$NO_CONTENT = 204;
function $1bfe0ef3752d92e8$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
function $1bfe0ef3752d92e8$export$701544522b0c6c99(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [part1, part2] = part.split(/\r?\n\r?\n/);
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            const body = part2 ?? part1;
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch  {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}
async function $1bfe0ef3752d92e8$export$efb69f1fe7577739(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = $1bfe0ef3752d92e8$export$701544522b0c6c99(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) $1bfe0ef3752d92e8$export$701544522b0c6c99(incompleteChunk, boundaryString, observer);
    observer.complete();
}
/**
 * Forward `error` to `observer.error`, giving the product-provided
 * `onFetchError` (if any) a chance to transform it first.
 */ function $1bfe0ef3752d92e8$var$emitError(observer, error, response, onFetchError) {
    const transformed = onFetchError ? onFetchError(error, response) : error;
    // `Sink.error` accepts `Error` per its type, but in practice relay
    // forwards whatever it receives to consumers. Cast to keep the existing
    // signature while allowing products to return any error-like value.
    observer.error(transformed);
}
function $1bfe0ef3752d92e8$var$handleMultipartResponse(response, observer, onFetchError) {
    const contentType = response.headers.get('content-type');
    const boundary = $1bfe0ef3752d92e8$var$getBoundary(contentType || '');
    if (!boundary) {
        $1bfe0ef3752d92e8$var$emitError(observer, new Error('Invalid multipart boundary'), response, onFetchError);
        return;
    }
    const decoder = new TextDecoder('utf-8');
    async function* streamReader() {
        // @ts-expect-error a Response object in Node is streamable
        for await (const chunk of response.body){
            const newText = decoder.decode(chunk, {
                stream: true
            });
            yield newText;
        }
    }
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        $1bfe0ef3752d92e8$export$efb69f1fe7577739(streamReader(), boundary, observer).catch((error)=>$1bfe0ef3752d92e8$var$emitError(observer, error, response, onFetchError));
    } catch (e) {
        const error = new Error('Failed to read from response body');
        // @ts-ignore: cause property may not be available in all environments
        error.cause = e;
        $1bfe0ef3752d92e8$var$emitError(observer, error, response, onFetchError);
    }
}
function $1bfe0ef3752d92e8$var$handleJsonResponse(response, observer, onFetchError) {
    response.json().then((data)=>{
        return observer.next(data);
    }).catch((error)=>$1bfe0ef3752d92e8$var$emitError(observer, error, response, onFetchError)).finally(()=>observer.complete());
}
function $1bfe0ef3752d92e8$var$handleTextResponse(response, observer, onFetchError) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((responseError)=>{
        let traceId = '';
        if ((0, $egspI.fg)('platform_relay_use_shared_relay_env_help_center')) traceId = `(trace-id: ${response.headers.get('atl-traceid')}) `;
        const error = new Error(`Error while parsing text response ${traceId}(Content-Type: ${response?.headers?.get('content-type')}): ${responseError instanceof Error ? responseError.message : String(responseError)}`);
        $1bfe0ef3752d92e8$var$emitError(observer, error, response, onFetchError);
    });
}
function $1bfe0ef3752d92e8$export$f76505a7f2969e4e(source, onFetchError) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $lIGkE.Observable).create((observer)=>{
        result.then((response)=>{
            if (response.status === $1bfe0ef3752d92e8$var$NO_CONTENT) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $1bfe0ef3752d92e8$var$handleJsonResponse(response, observer, onFetchError);
            else if (contentType.includes('text/plain')) $1bfe0ef3752d92e8$var$handleTextResponse(response, observer, onFetchError);
            else if (contentType.includes('multipart/mixed')) $1bfe0ef3752d92e8$var$handleMultipartResponse(response, observer, onFetchError);
            else $1bfe0ef3752d92e8$var$handleTextResponse(response, observer, onFetchError);
        })// Pre-response failure (network error, AbortController, etc.) — no
        // Response object is in scope, so pass `undefined`.
        .catch((error)=>$1bfe0ef3752d92e8$var$emitError(observer, error, undefined, onFetchError));
    });
}
const $1bfe0ef3752d92e8$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
const $1bfe0ef3752d92e8$var$MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
const $1bfe0ef3752d92e8$var$MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
// Calculate the size of the headers
function $1bfe0ef3752d92e8$export$dd754c3ef60c6999(headers) {
    let totalBytes = 0;
    const textEncoder = new TextEncoder();
    // Iterate over each header entry (name and value)
    for (const [name, value] of Object.entries(headers)){
        const headerSize = textEncoder.encode(`${name}: ${value}\r\n`).length; // Include CRLF
        totalBytes += headerSize;
    }
    return totalBytes;
}
function $1bfe0ef3752d92e8$export$28ae0033b80c6303(baseUrl, variables) {
    const params = new URLSearchParams();
    params.append('variables', JSON.stringify(variables));
    return baseUrl + `${baseUrl.includes('?') ? '&' : '?'}${params.toString()}`;
}
function $1bfe0ef3752d92e8$export$5ad31d96a9271d42({ url: baseUrl, variables: variables, request: request, headers: headers, isServer: isServer }) {
    if (isServer) return {
        isGetRequest: false,
        reason: 'SSR'
    };
    if ((0, $egspI.fg)('hot-302159-relay-get-killswitch')) return {
        isGetRequest: false,
        reason: 'Killswitch is on'
    };
    if (request.operationKind !== 'query') return {
        isGetRequest: false,
        reason: request.operationKind
    };
    const queryLength = $1bfe0ef3752d92e8$export$28ae0033b80c6303(baseUrl, variables).length;
    const headersSize = $1bfe0ef3752d92e8$export$dd754c3ef60c6999(headers || {});
    return queryLength <= $1bfe0ef3752d92e8$var$MAX_QUERY_LENGTH && headersSize <= $1bfe0ef3752d92e8$var$MAX_HEADERS_SIZE ? {
        isGetRequest: true
    } : {
        isGetRequest: false,
        reason: 'URL length or headers size too large'
    };
}
function $1bfe0ef3752d92e8$export$33c9c992c7855d86({ url: url, options: options, variables: variables, request: request, isServer: isServer, cacheConfig: cacheConfig }) {
    const headers = {
        'atl-client-name': 'atlassian-frontend-monorepo',
        Accept: $1bfe0ef3752d92e8$var$relayDeferAcceptableFormats.join(', '),
        'X-ExperimentalApi': (0, $8nMDY.getRelayExperimentalApis)().join(','),
        ...cacheConfig?.metadata?.headers || {}
    };
    const requestOptions = (0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(options, {
        credentials: 'same-origin',
        headers: headers
    });
    requestOptions.headers['Content-Type'] = 'application/json';
    // Default `atl-attribution` header value for AGG requests
    // https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
    if (!requestOptions.headers['atl-attribution']) requestOptions.headers['atl-attribution'] = JSON.stringify({
        service: 'afm-frontend'
    });
    const { isGetRequest: isGetRequest, reason: reason } = $1bfe0ef3752d92e8$export$5ad31d96a9271d42({
        url: url,
        variables: variables,
        request: request,
        headers: requestOptions.headers,
        isServer: isServer
    });
    // Nav4ProjectsContentQuery is forced to go POST route to avoid the stale cache issues when transition between issues in Issue-view
    // that's not a permanent fix, but rather an attampt to unblock the team
    // Context: #jiv-navigation-issue channel
    if (isGetRequest && request.name !== 'Nav4ProjectsContentQuery') {
        requestOptions.method = 'GET';
        url = $1bfe0ef3752d92e8$export$28ae0033b80c6303(url, variables);
        delete requestOptions.body; // Not needed for GET
    } else {
        requestOptions.method = 'POST';
        if (reason) requestOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
    }
    return ()=>fetch(url, requestOptions);
}

});

parcelRegister("aQEWc", function(module, exports) {
$parcel$export(module.exports, "getTraceIdFromExtensions", () => $682759d06c9fd2c7$export$eefb7f54c3b07211);

var $egspI = parcelRequire("egspI");
const $682759d06c9fd2c7$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions === undefined || extensions.gateway === undefined || extensions.gateway === null) return undefined;
    if ((0, $egspI.fg)('platform_relay_fetch_use_tid_property')) {
        if (typeof extensions.gateway.tId === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.tId;
    } else {
        if (typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.trace_id;
    }
    return undefined;
};

});


parcelRegister("NZFdy", function(module, exports) {
$parcel$export(module.exports, "default", () => $a81575717623e943$export$2e2bcd8739ae039);

var $1zTEC = parcelRequire("1zTEC");

var $dp0Rz = parcelRequire("dp0Rz");
const $a81575717623e943$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $a81575717623e943$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $a81575717623e943$export$77232ec02db7a24a = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $1zTEC.JiraFilterAri).parse(id).filterId;
            if ($a81575717623e943$var$isCustomFilter(filterId)) return (0, $dp0Rz.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($a81575717623e943$var$isSystemFilter(filterId)) return (0, $dp0Rz.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $a81575717623e943$var$MissingFieldHandlers = [
    $a81575717623e943$export$77232ec02db7a24a
];
var $a81575717623e943$export$2e2bcd8739ae039 = $a81575717623e943$var$MissingFieldHandlers;

});
parcelRegister("1zTEC", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAri", () => $12643b10bad32634$export$3cfb6cc809e835bd);

var $7UQ30 = parcelRequire("7UQ30");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira/filter/manifest.ts
var $12643b10bad32634$var$jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $7UQ30.JiraFilterAriResourceOwner),
    resourceType: (0, $7UQ30.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/filter/index.ts
var $12643b10bad32634$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $12643b10bad32634$var$jiraFilterAriStaticOpts.qualifier,
            platformQualifier: $12643b10bad32634$var$jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $12643b10bad32634$var$jiraFilterAriStaticOpts.resourceOwner,
            resourceType: $12643b10bad32634$var$jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $12643b10bad32634$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $12643b10bad32634$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
};

});
parcelRegister("7UQ30", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAriResourceOwner", () => $5c3622e5a5e325c8$export$e6199848f52f1119);
$parcel$export(module.exports, "JiraFilterAriResourceType", () => $5c3622e5a5e325c8$export$3c64de4ae038e3ae);
// src/jira/filter/types.ts
var $5c3622e5a5e325c8$export$e6199848f52f1119 = "jira", $5c3622e5a5e325c8$export$3c64de4ae038e3ae = "filter";

});

parcelRegister("8FnTo", function(module, exports) {
$parcel$export(module.exports, "RegisteredAri", () => $64f4af95a2b1ba37$export$579ee78b1dcf0a11);

var $6fsuc = parcelRequire("6fsuc");
// src/core/registered-ari.ts
var $64f4af95a2b1ba37$export$579ee78b1dcf0a11 = class extends (0, $6fsuc.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $6fsuc.AnyAri).parse(this.toString());
    }
};

});
parcelRegister("6fsuc", function(module, exports) {
$parcel$export(module.exports, "Ari", () => $48ca3d8c20059d51$export$3a4885701291260b);
$parcel$export(module.exports, "AnyAri", () => $48ca3d8c20059d51$export$44a7af7122933d6b);

var $aDthf = parcelRequire("aDthf");
// src/core/ari.ts
var $48ca3d8c20059d51$export$3a4885701291260b = class {
    constructor(opts){
        this._ati = (0, $aDthf.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
};
// src/any-ari.ts
var $48ca3d8c20059d51$export$44a7af7122933d6b = class _AnyAri extends $48ca3d8c20059d51$export$3a4885701291260b {
    constructor(opts){
        super(opts);
    }
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $aDthf.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $aDthf.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
};

});
parcelRegister("aDthf", function(module, exports) {
$parcel$export(module.exports, "AriParser", () => $7be441be93c2dc0d$export$4c3a8cde7a55740b);
$parcel$export(module.exports, "Ati", () => $7be441be93c2dc0d$export$ab4b293d0121b8ee);

var $aWb6y = parcelRequire("aWb6y");

var $lYbUB = parcelRequire("lYbUB");
// src/core/rules/cloud-id.ts
function $7be441be93c2dc0d$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, $lYbUB.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $7be441be93c2dc0d$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:;{}=]+(/[!a-zA-Z0-9\\-_.~@:;{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $lYbUB.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $7be441be93c2dc0d$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $7be441be93c2dc0d$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $7be441be93c2dc0d$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $lYbUB.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $7be441be93c2dc0d$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $lYbUB.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $7be441be93c2dc0d$var$NUMBER_OF_ARI_SEGMENTS = 5, $7be441be93c2dc0d$export$4c3a8cde7a55740b = class extends (0, $aWb6y.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $7be441be93c2dc0d$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $aWb6y.validateAriQualifier)(qualifier), (0, $aWb6y.validatePlatformQualifier)(platformQualifier), $7be441be93c2dc0d$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $7be441be93c2dc0d$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $7be441be93c2dc0d$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $7be441be93c2dc0d$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
        let regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
        if (!regexpResult) throw new (0, $lYbUB.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a;
            if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, $lYbUB.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $7be441be93c2dc0d$var$NUMBER_OF_ATI_SEGMENTS = 4, $7be441be93c2dc0d$var$AtiParser = class extends (0, $aWb6y.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $7be441be93c2dc0d$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $aWb6y.validateAtiQualifier)(qualifier), (0, $aWb6y.validatePlatformQualifier)(platformQualifier), $7be441be93c2dc0d$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $7be441be93c2dc0d$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $aWb6y.validateAtiQualifier)(qualifier), (0, $aWb6y.validatePlatformQualifier)(platformQualifier), $7be441be93c2dc0d$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $7be441be93c2dc0d$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $7be441be93c2dc0d$export$ab4b293d0121b8ee = class _Ati {
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $7be441be93c2dc0d$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
};

});
parcelRegister("aWb6y", function(module, exports) {
$parcel$export(module.exports, "validatePlatformQualifier", () => $7f67ef5842cd0a3b$export$4f6e8fa90a16fdc4);
$parcel$export(module.exports, "validateAtiQualifier", () => $7f67ef5842cd0a3b$export$da331df28ad1f3d9);
$parcel$export(module.exports, "validateAriQualifier", () => $7f67ef5842cd0a3b$export$822bcd2b6f6774a1);
$parcel$export(module.exports, "BaseParser", () => $7f67ef5842cd0a3b$export$3d09a5c28ff3e040);

var $lYbUB = parcelRequire("lYbUB");
// src/core/rules/platform-qualifier.ts
function $7f67ef5842cd0a3b$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $lYbUB.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $7f67ef5842cd0a3b$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $lYbUB.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $7f67ef5842cd0a3b$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $lYbUB.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $7f67ef5842cd0a3b$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $lYbUB.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $7f67ef5842cd0a3b$var$NUMBER_OF_BASE_SEGMENTS = 5, $7f67ef5842cd0a3b$var$SEGMENT_SEPARATOR = ":", $7f67ef5842cd0a3b$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($7f67ef5842cd0a3b$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $lYbUB.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $7f67ef5842cd0a3b$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($7f67ef5842cd0a3b$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($7f67ef5842cd0a3b$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

});
parcelRegister("lYbUB", function(module, exports) {
$parcel$export(module.exports, "ValidationError", () => $ffe8710df024ebd2$export$2191b9da168c6cf0);
// src/errors.ts
var $ffe8710df024ebd2$export$2191b9da168c6cf0 = class extends Error {
};

});







parcelRegister("3VbHo", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea5dd71d675e324b$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$ea5dd71d675e324b$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, (/*@__PURE__*/$parcel$interopDefault($85XPu))).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, $85XPu.version) === 'undefined' || (0, $85XPu.version).startsWith('16'))) (0, (/*@__PURE__*/$parcel$interopDefault($85XPu))).unstable_batchedUpdates(()=>{
            fn();
        });
        else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).startTransition === 'function') // @ts-ignore -error React.startTransition does not exist in react-16
        (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).startTransition(()=>{
            fn();
        });
        else fn();
        return '';
    }
};

});

parcelRegister("fUeId", function(module, exports) {
$parcel$export(module.exports, "createSubscribeFn", () => $bc6c6d7cc154362a$export$10f5a0700f263f11);

var $lIGkE = parcelRequire("lIGkE");

var $egspI = parcelRequire("egspI");

var $lOp85 = parcelRequire("lOp85");
var $7SqTw = parcelRequire("7SqTw");
let $bc6c6d7cc154362a$var$cachedDefaultSubscribe;
function $bc6c6d7cc154362a$export$10f5a0700f263f11(subscribeOptions) {
    if (typeof subscribeOptions === 'undefined' && typeof $bc6c6d7cc154362a$var$cachedDefaultSubscribe !== 'undefined') return $bc6c6d7cc154362a$var$cachedDefaultSubscribe;
    const fn = ({ id: id, name: operationName }, variables, cacheConfig)=>(0, $lIGkE.Observable).create((sink)=>{
            const client = (0, $lOp85.getClient)();
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const replayConfig = cacheConfig?.metadata?.replay || undefined;
            // When the fix gate is ON and the caller supplies a `command` key inside
            // replayConfig, hoist it to extensions.command (flat) to match AGG's
            // expected wire shape. AGG reads extensions["command"] directly; the
            // previous extensions.replay.command nesting was silently dropped and no
            // Replay ChannelCommand was ever issued. See CRCS-3291.
            // When the gate is OFF the old extensions.replay: {...} shape is preserved,
            // which is the broken-but-stable status-quo for consumers not using replay.
            const replayCommand = replayConfig !== null && typeof replayConfig === 'object' && 'command' in replayConfig ? replayConfig.command : undefined;
            const replayExtensions = replayCommand && (0, $egspI.fg)('platform_relay_subscription_fix_replay_command') ? {
                command: replayCommand
            } : replayConfig ? {
                replay: replayConfig
            } : {};
            const payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: {
                    pq: id,
                    ...subscribeOptions?.subscribeExtensions || {},
                    ...replayExtensions
                }
            };
            let requestId = null;
            subscribeOptions?.onSubscribeTrigger?.(payload);
            return client.subscribe(payload, {
                ...sink,
                next: (value)=>{
                    // @ts-expect-error agg prop is missing on generic "extensions" type
                    const aggRequestId = value?.extensions?.gateway?.request_id;
                    requestId = aggRequestId ?? requestId;
                    // @ts-expect-error incompatible types between two libraries
                    sink.next(value);
                },
                error: (sinkError)=>{
                    const errorInfo = (0, $7SqTw.getSinkError)(sinkError);
                    sink.error(errorInfo);
                    subscribeOptions?.onSubscribeError?.({
                        ...payload,
                        requestId: requestId
                    });
                }
            });
        });
    if (typeof subscribeOptions === 'undefined') $bc6c6d7cc154362a$var$cachedDefaultSubscribe = fn;
    return fn;
}
const $bc6c6d7cc154362a$export$ec068583843480e7 = $bc6c6d7cc154362a$export$10f5a0700f263f11();

});
parcelRegister("lOp85", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $e21f0ac1e1d341d3$export$6bb76d6eba7e258c);

var $5cPT7 = parcelRequire("5cPT7");

var $8nMDY = parcelRequire("8nMDY");


var $9U3Pa = parcelRequire("9U3Pa");
let $e21f0ac1e1d341d3$var$client;
const $e21f0ac1e1d341d3$export$6bb76d6eba7e258c = ()=>{
    if ((0, $9U3Pa.isSSR)()) return null;
    if (!$e21f0ac1e1d341d3$var$client) $e21f0ac1e1d341d3$var$client = (0, $5cPT7.createClient)({
        url: (0, $9U3Pa.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $4987114a75f06bf7$export$8b012b965402e06a),
        retryAttempts: (0, $4987114a75f06bf7$export$bf6cd96e19b2987f),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $8nMDY.getRelayExperimentalApis)().join(',')
        }
    });
    return $e21f0ac1e1d341d3$var$client;
};
const $e21f0ac1e1d341d3$export$2f0afd443356d36f = ()=>{
    $e21f0ac1e1d341d3$var$client = null;
};

});
parcelRegister("5cPT7", function(module, exports) {
$parcel$export(module.exports, "createClient", () => $3ca652a400551359$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ 
var $bZAkS = parcelRequire("bZAkS");

var $5tGtL = parcelRequire("5tGtL");
var $3ca652a400551359$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $3ca652a400551359$var$__await ? (this.v = v, this) : new $3ca652a400551359$var$__await(v);
};
var $3ca652a400551359$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3ca652a400551359$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $3ca652a400551359$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $3ca652a400551359$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$3ca652a400551359$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting');
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $bZAkS.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $bZAkS.stringifyMessage)({
                                    type: (0, $bZAkS.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if ($3ca652a400551359$var$isLikeCloseEvent(errOrEvent) && errOrEvent.code === 4499) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $bZAkS.stringifyMessage)(payload ? {
                            type: (0, $bZAkS.MessageType).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $bZAkS.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $bZAkS.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $bZAkS.CloseCode).InternalClientError, (0, $5tGtL.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $bZAkS.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $bZAkS.stringifyMessage)(message.payload ? {
                                    type: (0, $bZAkS.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $bZAkS.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $bZAkS.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $bZAkS.CloseCode).BadResponse, (0, $5tGtL.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($3ca652a400551359$var$isLikeCloseEvent(errOrCloseEvent) && ($3ca652a400551359$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $bZAkS.CloseCode).InternalServerError,
            (0, $bZAkS.CloseCode).InternalClientError,
            (0, $bZAkS.CloseCode).BadRequest,
            (0, $bZAkS.CloseCode).BadResponse,
            (0, $bZAkS.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $bZAkS.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $bZAkS.CloseCode).SubscriberAlreadyExists,
            (0, $bZAkS.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($3ca652a400551359$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    return {
        on: emitter.on,
        subscribe (payload, sink) {
            const id = generateID(payload);
            let done = false, errored = false, releaser = ()=>{
                // for handling completions before connect
                locks--;
                done = true;
            };
            (async ()=>{
                locks++;
                for(;;)try {
                    const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                    // if done while waiting for connect, release the connection lock right away
                    if (done) return release();
                    const unlisten = emitter.onMessage(id, (message)=>{
                        switch(message.type){
                            case (0, $bZAkS.MessageType).Next:
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                                sink.next(message.payload);
                                return;
                            case (0, $bZAkS.MessageType).Error:
                                errored = true, done = true;
                                sink.error(message.payload);
                                releaser();
                                return;
                            case (0, $bZAkS.MessageType).Complete:
                                done = true;
                                releaser(); // release completes the sink
                                return;
                        }
                    });
                    socket.send((0, $bZAkS.stringifyMessage)({
                        id: id,
                        type: (0, $bZAkS.MessageType).Subscribe,
                        payload: payload
                    }, replacer));
                    releaser = ()=>{
                        if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                        socket.send((0, $bZAkS.stringifyMessage)({
                            id: id,
                            type: (0, $bZAkS.MessageType).Complete
                        }, replacer));
                        locks--;
                        done = true;
                        release();
                    };
                    // either the releaser will be called, connection completed and
                    // the promise resolved or the socket closed and the promise rejected.
                    // whatever happens though, we want to stop listening for messages
                    await waitForReleaseOrThrowOnClose.finally(unlisten);
                    return; // completed, shouldnt try again
                } catch (errOrCloseEvent) {
                    if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
                }
            })().then(()=>{
                // delivering either an error or a complete terminates the sequence
                if (!errored) sink.complete();
            }) // resolves on release or normal closure
            .catch((err)=>{
                sink.error(err);
            }); // rejects on close events and errors
            return ()=>{
                // dispose only of active subscriptions
                if (!done) releaser();
            };
        },
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = this.subscribe(request, {
                next (val) {
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $3ca652a400551359$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $3ca652a400551359$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $3ca652a400551359$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $3ca652a400551359$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', {
                code: 4499,
                reason: 'Terminated',
                wasClean: false
            });
        }
    };
}
function $3ca652a400551359$var$isLikeCloseEvent(val) {
    return (0, $5tGtL.isObject)(val) && 'code' in val && 'reason' in val;
}
function $3ca652a400551359$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $3ca652a400551359$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});
parcelRegister("bZAkS", function(module, exports) {
$parcel$export(module.exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", () => $8bb193b511a10487$export$5c0a4edfedc7c457);
$parcel$export(module.exports, "CloseCode", () => $8bb193b511a10487$export$777128f41f6616ec);
$parcel$export(module.exports, "MessageType", () => $8bb193b511a10487$export$80edbf15fa61a4db);
$parcel$export(module.exports, "parseMessage", () => $8bb193b511a10487$export$f2f615077a189f21);
$parcel$export(module.exports, "stringifyMessage", () => $8bb193b511a10487$export$77896e5b47bfd50b);
/**
 *
 * common
 *
 */ 
var $5tGtL = parcelRequire("5tGtL");
const $8bb193b511a10487$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $8bb193b511a10487$export$ec743af8bb66f3be = 'graphql-ws';
var $8bb193b511a10487$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($8bb193b511a10487$export$777128f41f6616ec || ($8bb193b511a10487$export$777128f41f6616ec = {}));
var $8bb193b511a10487$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($8bb193b511a10487$export$80edbf15fa61a4db || ($8bb193b511a10487$export$80edbf15fa61a4db = {}));
function $8bb193b511a10487$export$c17861b159b1b673(val) {
    if (!(0, $5tGtL.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $5tGtL.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $5tGtL.extendedTypeof)(val.type)}`);
    switch(val.type){
        case $8bb193b511a10487$export$80edbf15fa61a4db.ConnectionInit:
        case $8bb193b511a10487$export$80edbf15fa61a4db.ConnectionAck:
        case $8bb193b511a10487$export$80edbf15fa61a4db.Ping:
        case $8bb193b511a10487$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $5tGtL.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $8bb193b511a10487$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $5tGtL.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $5tGtL.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $5tGtL.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $5tGtL.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $5tGtL.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $5tGtL.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $5tGtL.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $5tGtL.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $5tGtL.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $5tGtL.extendedTypeof)(val.payload.extensions)}`);
            break;
        case $8bb193b511a10487$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $5tGtL.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $5tGtL.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $5tGtL.extendedTypeof)(val.payload)}`);
            break;
        case $8bb193b511a10487$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $5tGtL.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $5tGtL.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $8bb193b511a10487$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $5tGtL.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $8bb193b511a10487$export$9e0e49e75fa7d548(val) {
    try {
        $8bb193b511a10487$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $8bb193b511a10487$export$f2f615077a189f21(data, reviver) {
    return $8bb193b511a10487$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $8bb193b511a10487$export$77896e5b47bfd50b(msg, replacer) {
    $8bb193b511a10487$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}

});
parcelRegister("5tGtL", function(module, exports) {
$parcel$export(module.exports, "extendedTypeof", () => $3fd09ca6108dbf7a$export$573326049e1b1c6b);
$parcel$export(module.exports, "isObject", () => $3fd09ca6108dbf7a$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "areGraphQLErrors", () => $3fd09ca6108dbf7a$export$e6262fbc2e92290);
$parcel$export(module.exports, "limitCloseReason", () => $3fd09ca6108dbf7a$export$2937fa0c8dddae54);
/** @private */ function $3fd09ca6108dbf7a$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $3fd09ca6108dbf7a$export$a6cdc56e425d0d0a(val) {
    return $3fd09ca6108dbf7a$export$573326049e1b1c6b(val) === 'object';
}
function $3fd09ca6108dbf7a$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $3fd09ca6108dbf7a$export$92bd080471bc30f1(val) {
    return $3fd09ca6108dbf7a$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $3fd09ca6108dbf7a$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $3fd09ca6108dbf7a$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

});



const $4987114a75f06bf7$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $4987114a75f06bf7$export$bf6cd96e19b2987f = 100;
const $4987114a75f06bf7$export$1ad8434180c5936c = 300000; // 5m

parcelRegister("9U3Pa", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $b7fa0113bfb5d654$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $b7fa0113bfb5d654$export$29a72e89601dfc59);
const $b7fa0113bfb5d654$export$48d7c418edadb60c = ()=>globalThis.false ?? false;
const $b7fa0113bfb5d654$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});


parcelRegister("7SqTw", function(module, exports) {
$parcel$export(module.exports, "getSinkError", () => $c37e5045dc68770b$export$ece4736473c28965);
const $c37e5045dc68770b$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (typeof error === 'object' && 'type' in error && error.type === 'error') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const errorEvent = error;
        errorInfo = new Error(`ErrorEvent: "${errorEvent.error}"`);
    } else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};

});



parcelRegister("3QaCr", function(module, exports) {
$parcel$export(module.exports, "ExperienceTrackerContext", () => $e94c6412fe21031c$export$a7b0697657ed8bd0);

var $euxye = parcelRequire("euxye");
const $e94c6412fe21031c$export$a7b0697657ed8bd0 = (0, $euxye.createContext)({
    abort () {},
    fail () {},
    start () {},
    succeed () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    },
    updateAttributes () {}
});

});

parcelRegister("6Zzi4", function(module, exports) {
$parcel$export(module.exports, "ExperienceTracker", () => $875c8b04ac8c44dd$export$12b6b072930fd68f);

var $TMOEJ = parcelRequire("TMOEJ");
class $875c8b04ac8c44dd$export$12b6b072930fd68f {
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $TMOEJ.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
}

});
parcelRegister("TMOEJ", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $29c54f76ef85018c$export$c90b54e658fc4d7c);

var $67yn9 = parcelRequire("67yn9");
function $29c54f76ef85018c$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $29c54f76ef85018c$export$c90b54e658fc4d7c {
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this._hasStopped = false;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $29c54f76ef85018c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $29c54f76ef85018c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $67yn9.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $29c54f76ef85018c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
}

});
parcelRegister("67yn9", function(module, exports) {
$parcel$export(module.exports, "ExperienceTimeoutError", () => $98b59cd78880b083$export$d27a2b6293f7631c);
class $98b59cd78880b083$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}

});



parcelRegister("1pIYN", function(module, exports) {
$parcel$export(module.exports, "useUFOTransitionCompleter", () => $f58a7600d3419e77$export$369f0ded13ce6c50);
$parcel$export(module.exports, "default", () => $f58a7600d3419e77$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $7TA2J = parcelRequire("7TA2J");

var $erszr = parcelRequire("erszr");

var $gmMRH = parcelRequire("gmMRH");

var $anDmR = parcelRequire("anDmR");

var $qqoKJ = parcelRequire("qqoKJ");

var $siTdT = parcelRequire("siTdT");

var $7VWGN = parcelRequire("7VWGN");

var $iNG3T = parcelRequire("iNG3T");
function $f58a7600d3419e77$var$traceUFOTransition(ufoName, routeName = ufoName) {
    if (!(0, $gmMRH.isUFOEnabled)()) return;
    const pressInteractionsList = (0, $gmMRH.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $siTdT.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $siTdT.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $7VWGN.default).current = ufoName;
        const rate = (0, $gmMRH.getInteractionRate)(ufoName, 'transition');
        if ((0, $erszr.default)(rate)) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const newId = (0, $7TA2J.v4)();
            (0, $iNG3T.setInteractionActiveTrace)(newId);
            (0, $qqoKJ.DefaultInteractionID).current = newId;
            (0, $siTdT.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $anDmR.getActiveTrace)());
        }
    }
}
function $f58a7600d3419e77$export$369f0ded13ce6c50() {
    const interactionId = (0, $euxye.useContext)((0, $qqoKJ.default));
    const capturedInteractionId = interactionId.current;
    (0, $euxye.useEffect)(()=>{
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            let cancel = requestAnimationFrame(()=>{
                cancel = requestAnimationFrame(()=>{
                    if (capturedInteractionId === interactionId.current) (0, $siTdT.tryComplete)(capturedInteractionId);
                });
            });
            (0, $siTdT.addOnCancelCallback)(capturedInteractionId, ()=>{
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f58a7600d3419e77$export$2e2bcd8739ae039 = $f58a7600d3419e77$var$traceUFOTransition;

});
parcelRegister("iNG3T", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $1154af3efd171c44$export$f2e521e495a88544);

var $anDmR = parcelRequire("anDmR");

var $jdfCT = parcelRequire("jdfCT");
function $1154af3efd171c44$export$f2e521e495a88544(newId) {
    (0, $anDmR.setActiveTrace)(newId.replace(/-/g, ''), (0, $jdfCT.generateSpanId)(), 'transition');
}

});
parcelRegister("jdfCT", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $a4cd9ee76571d64d$export$295213bc4d0c54ad);
function $a4cd9ee76571d64d$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});



parcelRegister("ehOO1", function(module, exports) {
$parcel$export(module.exports, "GlobalPageLoadExperience", () => $ed5093fb69b69611$export$bf7c1e56255f1467);

var $iUbRz = parcelRequire("iUbRz");

var $gqxTF = parcelRequire("gqxTF");

var $ipvkO = parcelRequire("ipvkO");

var $537xs = parcelRequire("537xs");
class $ed5093fb69b69611$var$UFOGlobalPageLoadExperience extends (0, $gqxTF.UFOAbstractExperience) {
    startPageLoad(id, initial = false, startTime) {
        const result = super.start(initial ? 0 : (0, $gqxTF.perfNowOrTimestamp)(startTime));
        this.setPageLoadId(id);
        this.initial = initial;
        return result;
    }
    updateConfig(config) {
        Object.assign(this.config, config);
    }
    setPageLoadId(id) {
        this.loadingPageLoadId = id;
    }
    async getId() {
        return this.loadingPageLoadId;
    }
    async exportData() {
        const data = await super.exportData();
        return {
            ...data,
            initial: this.initial
        };
    }
    constructor(...args){
        super(...args), this.loadingPageLoadId = 'UNKNOWN', this.type = (0, $ipvkO.ExperienceTypes).Load, this.performanceType = (0, $ipvkO.ExperiencePerformanceTypes).PageLoad, this.initial = true;
    }
}
const $ed5093fb69b69611$export$bf7c1e56255f1467 = new $ed5093fb69b69611$var$UFOGlobalPageLoadExperience('UFO_GLOBAL_PAGE_LOAD', {
    type: (0, $ipvkO.ExperienceTypes).Load,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageLoad,
    // this should come from global config
    until: (0, $iUbRz.untilAll)([
        {
            category: (0, $537xs.PageSegmentExperienceTypes).PRODUCT
        }
    ])
});

});
parcelRegister("iUbRz", function(module, exports) {
$parcel$export(module.exports, "untilAll", () => $01216f50297edd9b$export$44695628831598be);

var $d4ULW = parcelRequire("d4ULW");

var $686xa = parcelRequire("686xa");
const $01216f50297edd9b$var$isUntilExperience = (until)=>{
    return until.experience !== undefined;
};
const $01216f50297edd9b$var$isUntilCategory = (until)=>{
    return until.category !== undefined;
};
const $01216f50297edd9b$export$44695628831598be = (deps)=>()=>{
        const notMet = [
            ...deps
        ];
        return (data)=>{
            if (notMet.length > 0) {
                const doneIndexes = notMet.reduce((acc, dep, i)=>{
                    // validation logic
                    if ($01216f50297edd9b$var$isUntilExperience(dep) && dep.experience.uuid === data.uuid) acc.push(i);
                    else if ($01216f50297edd9b$var$isUntilCategory(dep) && dep.category === data.category) acc.push(i);
                    return acc;
                }, []);
                const priorityStateFound = data.state === (0, $686xa.UFOExperienceState).ABORTED || data.state === (0, $686xa.UFOExperienceState).FAILED;
                if (priorityStateFound && doneIndexes.length > 0) {
                    notMet.length = 0;
                    return {
                        done: true,
                        state: data.state
                    };
                }
                doneIndexes.reverse().forEach((i)=>{
                    notMet.splice(i, 1);
                });
                (0, $d4ULW.ufolog)('untilAll deps left:', notMet.length, notMet);
                if (notMet.length === 0) return {
                    done: true,
                    state: (0, $686xa.UFOExperienceState).SUCCEEDED
                };
            }
            return {
                done: false
            };
        };
    };

});

parcelRegister("537xs", function(module, exports) {
$parcel$export(module.exports, "PageSegmentExperienceTypes", () => $fb6ce47839cc2e2c$export$17d97452062ccf73);
const $fb6ce47839cc2e2c$export$17d97452062ccf73 = {
    NAVIGATION: 'NAVIGATION',
    PRODUCT: 'PRODUCT',
    COMPONENT: 'COMPONENT'
};

});


parcelRegister("8ndFS", function(module, exports) {
$parcel$export(module.exports, "choreographerFactory", () => $e92e70e4e6be7f87$export$55d2aeb17c4cfbe);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $kNBjd = parcelRequire("kNBjd");

var $7OysO = parcelRequire("7OysO");

var $eBiBT = parcelRequire("eBiBT");
var $iZhno = parcelRequire("iZhno");
var $a4RVh = parcelRequire("a4RVh");
var $k9qsB = parcelRequire("k9qsB");
var $lpfen = parcelRequire("lpfen");
var $4qSEu = parcelRequire("4qSEu");
var $ciCvm = parcelRequire("ciCvm");
var $5FwJv = parcelRequire("5FwJv");
var $RV79X = parcelRequire("RV79X");
var $kDVb4 = parcelRequire("kDVb4");
var $gSdzH = parcelRequire("gSdzH");
var $jmlYc = parcelRequire("jmlYc");
var $jCpSG = parcelRequire("jCpSG");
function $e92e70e4e6be7f87$export$55d2aeb17c4cfbe(productId, env, metaMetricsData = {}, choreographerOptions = {
    enableChoreographer: true
}) {
    // Instantiate our plugin instance, passing the productId through for segmenting any messageId's from any other plugins
    const plugin = new (0, $7OysO.ProductChoreographerPlugin)(productId, env, metaMetricsData);
    // Capture plugin-wide TTL from options
    const pluginTtl = choreographerOptions.messageTtl;
    /**
	 * React hook that provides startMessage and stopMessage functions that call through the plugin API with the provided messageId, for easy assignment to React event handlers.
	 *
	 * @param messageId The messageId to be provided to the choreographer API whenever the startMessage and stopMessage callbacks are invoked.
	 * @param callbacks An object containing start and stop callbacks.
	 * @param messageTtl Optional TTL for messages started via the returned startMessage function. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use plugin-wide TTL or global default (5 minutes). Message-level TTL takes priority over plugin-wide TTL.
	 * @returns An object with startMessage and stopMessage callbacks, which contain references to the messageId to be passed to the choreographer API, so that the consumer no longer needs to specify that at call time.
	 */ const useChoreographer = (messageId, { [(0, $kNBjd.MessageEventType).START]: startCallback, [(0, $kNBjd.MessageEventType).STOP]: stopCallback } = {}, messageTtl)=>{
        const isMessageStarted = (0, $euxye.useRef)(false);
        const startRef = (0, $euxye.useRef)(startCallback);
        const stopRef = (0, $euxye.useRef)(stopCallback);
        // Callback that uses a ref to track any changes in the received startCallback parameter, so the caller doesn't have to worry about memoization
        const startMessageCallback = (0, $euxye.useCallback)(async (...args)=>{
            const didMessageStart = await startRef.current?.(...args) ?? true;
            isMessageStarted.current = didMessageStart;
            return didMessageStart;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's startMessage function, for use in components.
        // Use message-level TTL if provided, otherwise fall back to plugin-wide TTL
        const startMessage = (0, $euxye.useCallback)((...args)=>{
            plugin.onStart(messageId, ()=>startMessageCallback(...args));
            // Message-level TTL takes priority over plugin-wide TTL, if provided
            return plugin.startMessage(messageId, {}, messageTtl !== undefined ? messageTtl : pluginTtl);
        }, [
            messageId,
            startMessageCallback,
            messageTtl
        ]);
        // Callback that uses a ref to track any changes in the received stopCallback parameter, so the caller doesn't have to worry about memoization
        const stopMessageCallback = (0, $euxye.useCallback)(async (...args)=>{
            const didMessageStop = await stopRef.current?.(...args) ?? true;
            isMessageStarted.current = !didMessageStop;
            return didMessageStop;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's stopMessage function, for use in components.
        const stopMessage = (0, $euxye.useCallback)((...args)=>{
            if (isMessageStarted.current) {
                plugin.onStop(messageId, ()=>stopMessageCallback(...args));
                return plugin.stopMessage(messageId);
            }
            return Promise.resolve((0, $kNBjd.MessageDeliveryStatus).STOPPED);
        }, [
            isMessageStarted,
            messageId,
            stopMessageCallback
        ]);
        // Stable function reference that invokes whichever start or stop handler is appropriate for the message's current display state.
        // Tracking this state with a ref allows us to know the current display state in real-time, so that potentially subsequent calls
        // can be made to toggle its state, without requiring tracking a useState value and requiring rerenders to update the callback
        // with the latest display state, and without generating false blocked messages from cached/outdated toggleMessage references.
        const toggleMessage = (0, $euxye.useCallback)(()=>{
            return isMessageStarted.current ? stopMessage() : startMessage();
        }, [
            isMessageStarted,
            startMessage,
            stopMessage
        ]);
        // Syncs any incoming startCallback and stopCallback functions as the latest version to be invoked when a startMessage or stopMessage call is issued through the choreographer API
        (0, $euxye.useLayoutEffect)(()=>{
            startRef.current = startCallback;
            stopRef.current = stopCallback;
        }, [
            startCallback,
            stopCallback
        ]);
        /**
		 * At component mount, we want to default a start and stop function, which invokes these functions with no additional parameters,
		 * just to supply some sane defaults. If startMessage or stopMessage are called explicitly, they can optionally supply some extra
		 * parameters, at which point, a just-in-time registration of a new callback version will be supplied to the choreographer, which
		 * will proxy those parameter through to the target state-setter functions. But if they are not called explicitly, such as in the
		 * case where a message is started and never stopped, and is timed out from the Choreographer, we want to have a default version
		 * available to execute against.
		 *
		 * At component unmount, stop the current message, if it's displayed, and unsubscribe the stop callback for this messageId within
		 * the plugin.
		 */ (0, $euxye.useLayoutEffect)(()=>{
            plugin.on(messageId, {
                start: async ()=>{
                    return await startMessage() === (0, $kNBjd.MessageDeliveryStatus).STARTED;
                },
                stop: async ()=>{
                    return await stopMessage() === (0, $kNBjd.MessageDeliveryStatus).STOPPED;
                }
            });
            return ()=>{
                // If unsubscribing, fire the stopMessageCallback one last time to ensure the component can clear the local state responsible for displaying its message
                stopMessage(messageId);
                plugin.off(messageId);
            };
        }, [
            messageId,
            startMessage,
            stopMessage
        ]);
        // Return the wrapped startMessage and stopMessage functions to the consumer, which will route their requests through the choreographer API with the messageId proxied straight through on behalf of the caller
        return (0, $euxye.useMemo)(()=>({
                startMessage: startMessage,
                stopMessage: stopMessage,
                toggleMessage: toggleMessage
            }), [
            startMessage,
            stopMessage,
            toggleMessage
        ]);
    };
    const shouldBeChoreographed = (props, toggleableProp)=>{
        if ((0, $egspI.fg)('post-office_move_shouldbechoreographed')) return plugin.shouldBeChoreographed(props, choreographerOptions, toggleableProp);
        return (0, $kDVb4.shouldBeChoreographed)(props, choreographerOptions);
    };
    const useChoreographedRender = ({ messageId: messageId, onMessageDisposition: onMessageDisposition, messageTtl: messageTtl })=>{
        const [shouldRender, setShouldRender] = (0, $euxye.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
            start: ()=>setShouldRender(true),
            stop: ()=>setShouldRender(false)
        }, messageTtl);
        (0, $euxye.useLayoutEffect)(()=>{
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            const stopMessageAsync = async ()=>{
                const disposition = await stopMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>void stopMessageAsync();
        }, [
            messageId,
            onMessageDisposition,
            startMessage,
            stopMessage,
            messageTtl
        ]);
        return shouldRender;
    };
    const withChoreographedRender = (Component)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, messageTtl: messageTtl, ...props }) {
            const shouldRender = useChoreographedRender({
                messageId: messageId,
                onMessageDisposition: onMessageDisposition,
                messageTtl: messageTtl
            });
            if (shouldRender) // Need to cast "props" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition" | "messageTtl"> is the same as T
            return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                ...props
            });
            return null;
        }
        ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
        return ChoreographedComponent;
    };
    const withChoreographedToggle = (Component, toggleableProp)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, messageTtl: messageTtl, ...rest }) {
            // Need to cast "rest" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition" | "messageTtl"> is the same as T
            const props = rest;
            const toggleablePropValue = props[toggleableProp];
            const [shouldRender, setShouldRender] = (0, $euxye.useState)(false);
            const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
                start: ()=>setShouldRender(true),
                stop: ()=>setShouldRender(false)
            }, messageTtl);
            (0, $euxye.useLayoutEffect)(()=>{
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                const stopMessageAsync = async ()=>{
                    const disposition = await stopMessage();
                    onMessageDisposition?.(disposition);
                };
                if (toggleablePropValue && !shouldRender) startMessageAsync();
                else if (!toggleablePropValue && shouldRender) stopMessageAsync();
                return ()=>{
                    if (!toggleablePropValue && shouldRender) stopMessageAsync();
                };
            }, [
                messageId,
                onMessageDisposition,
                shouldRender,
                startMessage,
                stopMessage,
                toggleablePropValue,
                messageTtl
            ]);
            return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                ...props,
                [toggleableProp]: shouldRender
            });
        }
        return ChoreographedComponent;
    };
    function wrapWithFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $e79Pd.jsx)(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedRender: withChoreographedRender
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    function wrapWithToggleFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $e79Pd.jsx)(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    const AutoDismissFlag = wrapWithFactoryFunctions((0, $eBiBT.AutoDismissFlag));
    const Banner = wrapWithFactoryFunctions((0, $iZhno.Banner));
    const ChoreographedComponent = wrapWithFactoryFunctions((0, $a4RVh.ChoreographedComponent));
    const Flag = wrapWithFactoryFunctions((0, $k9qsB.Flag));
    const Modal = wrapWithFactoryFunctions((0, $4qSEu.Modal));
    const Popper = wrapWithFactoryFunctions((0, $5FwJv.Popper));
    const Spotlight = wrapWithFactoryFunctions((0, $gSdzH.Spotlight));
    const SpotlightCard = wrapWithFactoryFunctions((0, $jmlYc.SpotlightCard));
    const InlineDialog = wrapWithToggleFactoryFunctions((0, $lpfen.InlineDialog));
    // Similar to Popup, PopoverContent uses a union type and so must be wrapped manually.
    const PopoverContent = function() {
        function WrappedPopoverContent(props) {
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ciCvm.PopoverContent), {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        WrappedPopoverContent.displayName = `ChoreographerFactory(${(0, $ciCvm.PopoverContent).displayName})`;
        return WrappedPopoverContent;
    }();
    // Would ideally like to use wrapWithToggleFactoryFunctions here, but the Popup component's props is a union
    // type, and that for some reason causes ToggleableChoreographerUtilities to be passed through to the
    // consumer-exposed Popup component's prop type, which is not what we want, so we'll just wrap it manually here
    const Popup = function() {
        function WrappedPopup(props) {
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $RV79X.Popup), {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        WrappedPopup.displayName = `ChoreographerFactory(${(0, $RV79X.Popup).displayName})`;
        return WrappedPopup;
    }();
    // Return these items from the factory function for use within React products
    return {
        plugin: plugin,
        useChoreographer: useChoreographer,
        shouldBeChoreographed: shouldBeChoreographed,
        useChoreographedRender: useChoreographedRender,
        withChoreographedRender: withChoreographedRender,
        withChoreographedToggle: withChoreographedToggle,
        AutoDismissFlag: AutoDismissFlag,
        Banner: Banner,
        ChoreographedComponent: ChoreographedComponent,
        Flag: Flag,
        InlineDialog: InlineDialog,
        Modal: Modal,
        Popper: Popper,
        Popup: Popup,
        Spotlight: Spotlight,
        SpotlightCard: SpotlightCard,
        SpotlightTarget: $jCpSG.SpotlightTarget,
        PopoverContent: PopoverContent
    };
}

});
parcelRegister("7OysO", function(module, exports) {
$parcel$export(module.exports, "ProductChoreographerPlugin", () => $59cd0f9eccee7953$export$44bee9c9373d59fb);

var $blN8U = parcelRequire("blN8U");
class $59cd0f9eccee7953$export$44bee9c9373d59fb extends (0, $blN8U.ChoreographerPlugin) {
    constructor(product, env, metaMetricsData = {}){
        super(product, env, metaMetricsData);
    }
}

});

parcelRegister("eBiBT", function(module, exports) {
$parcel$export(module.exports, "AutoDismissFlag", () => $9956bdc2bf374545$export$9879a8e0db317538);

var $63XI1 = parcelRequire("63XI1");

var $kDVb4 = parcelRequire("kDVb4");
const $9956bdc2bf374545$export$9879a8e0db317538 = (0, $kDVb4.wrapComponentForChoreographer)((0, $63XI1.default));

});

parcelRegister("iZhno", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $ba6cf29c77a222fb$export$3b4e64e77073e307);

var $yn9go = parcelRequire("yn9go");

var $kDVb4 = parcelRequire("kDVb4");
const $ba6cf29c77a222fb$export$3b4e64e77073e307 = (0, $kDVb4.wrapComponentForChoreographer)((0, $yn9go.default));

});

parcelRegister("a4RVh", function(module, exports) {
$parcel$export(module.exports, "ChoreographedComponent", () => $454b8cb267a9cef1$export$2d56cb44b2c5f8dc);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $454b8cb267a9cef1$var$ChildrenWrapper = ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
$454b8cb267a9cef1$var$ChildrenWrapper.displayName = "ChildrenWrapper";
const $454b8cb267a9cef1$export$2d56cb44b2c5f8dc = ({ messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, shouldBeChoreographed: shouldBeChoreographed, withChoreographedRender: withChoreographedRender, children: children })=>{
    const ChoreographedChildrenWrapper = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>withChoreographedRender($454b8cb267a9cef1$var$ChildrenWrapper), [
        withChoreographedRender
    ]);
    if (!shouldBeChoreographed({
        messageId: messageId,
        messageType: messageType,
        onMessageDisposition: onMessageDisposition
    })) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)(ChoreographedChildrenWrapper, {
        messageId: messageId,
        onMessageDisposition: onMessageDisposition,
        children: children
    });
};
$454b8cb267a9cef1$export$2d56cb44b2c5f8dc.displayName = "ChoreographedComponent";

});

parcelRegister("k9qsB", function(module, exports) {
$parcel$export(module.exports, "Flag", () => $e26f3dad04f6f4fb$export$48ea269755562084);

var $f1Spj = parcelRequire("f1Spj");

var $kDVb4 = parcelRequire("kDVb4");
const $e26f3dad04f6f4fb$export$48ea269755562084 = (0, $kDVb4.wrapComponentForChoreographer)((0, $f1Spj.default));

});

parcelRegister("lpfen", function(module, exports) {
$parcel$export(module.exports, "InlineDialog", () => $ab43b63a10b480b8$export$c7313f750e9cbc9d);

var $j0ADo = parcelRequire("j0ADo");

var $kDVb4 = parcelRequire("kDVb4");
const $ab43b63a10b480b8$export$c7313f750e9cbc9d = (0, $kDVb4.wrapToggleableComponentForChoreographer)((0, $j0ADo.default), 'isOpen');

});

parcelRegister("4qSEu", function(module, exports) {
$parcel$export(module.exports, "Modal", () => $0880c4330abd49ee$export$2b77a92f1a5ad772);

var $7tY81 = parcelRequire("7tY81");

var $kDVb4 = parcelRequire("kDVb4");
const $0880c4330abd49ee$export$2b77a92f1a5ad772 = (0, $kDVb4.wrapComponentForChoreographer)((0, $7tY81.default));

});

parcelRegister("ciCvm", function(module, exports) {
$parcel$export(module.exports, "PopoverContent", () => $a09799ba2b710b02$export$d7e1f420b25549ff);

var $fxLck = parcelRequire("fxLck");

var $kDVb4 = parcelRequire("kDVb4");
const $a09799ba2b710b02$export$d7e1f420b25549ff = (0, $kDVb4.wrapToggleableComponentForChoreographer)((0, $fxLck.PopoverContent), 'isVisible');

});

parcelRegister("5FwJv", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $d899b140917b4efb$export$badac9ada3a0bdf9);

var $1DTca = parcelRequire("1DTca");

var $kDVb4 = parcelRequire("kDVb4");
const $d899b140917b4efb$export$badac9ada3a0bdf9 = (0, $kDVb4.wrapComponentForChoreographer)((0, $1DTca.Popper));

});

parcelRegister("RV79X", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $309657df648c451e$export$129a32eedafa97c5);

var $1CdDx = parcelRequire("1CdDx");

var $kDVb4 = parcelRequire("kDVb4");
const $309657df648c451e$export$129a32eedafa97c5 = (0, $kDVb4.wrapToggleableComponentForChoreographer)((0, $1CdDx.Popup), 'isOpen');

});

parcelRegister("gSdzH", function(module, exports) {
$parcel$export(module.exports, "Spotlight", () => $430f813726f59562$export$1033c28b5e1c2deb);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $12j6D = parcelRequire("12j6D");

var $egspI = parcelRequire("egspI");

var $kDVb4 = parcelRequire("kDVb4");

var $dn5dX = parcelRequire("dn5dX");

var $jCpSG = parcelRequire("jCpSG");
const $430f813726f59562$var$DeprecatedSpotlight = (0, $kDVb4.wrapComponentForChoreographer)((0, $12j6D.default));
const $430f813726f59562$export$1033c28b5e1c2deb = (props)=>{
    const { isMigrated: isMigrated } = props;
    if (isMigrated && (0, $egspI.fg)('post-office_enable_ads_spotlight_migration')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dn5dX.MigratedSpotlight), {
        ...props
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($430f813726f59562$var$DeprecatedSpotlight, {
        ...props
    });
};
$430f813726f59562$export$1033c28b5e1c2deb.displayName = "Spotlight";
$430f813726f59562$export$1033c28b5e1c2deb.displayName = 'ChoreographerSpotlight';

});
parcelRegister("dn5dX", function(module, exports) {
$parcel$export(module.exports, "MigratedSpotlight", () => $3ae013699597b3b2$export$13e08e0bdd266b1b);
/* MigratedSpotlight.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $i2sOf = parcelRequire("i2sOf");

var $8Sdzy = parcelRequire("8Sdzy");

var $fxLck = parcelRequire("fxLck");
var $g5k19 = parcelRequire("g5k19");
var $5Gxfr = parcelRequire("5Gxfr");
var $jFNyB = parcelRequire("jFNyB");
var $liP0D = parcelRequire("liP0D");
var $8CDnU = parcelRequire("8CDnU");
var $8qQ8A = parcelRequire("8qQ8A");
var $8guPH = parcelRequire("8guPH");
var $7okqc = parcelRequire("7okqc");
var $KcP1c = parcelRequire("KcP1c");
var $413te = parcelRequire("413te");
var $54cWg = parcelRequire("54cWg");
var $jukA2 = parcelRequire("jukA2");
var $bEy1I = parcelRequire("bEy1I");
var $7Bcvd = parcelRequire("7Bcvd");

var $a4RVh = parcelRequire("a4RVh");

var $ic1Gf = parcelRequire("ic1Gf");

var $7RJpR = parcelRequire("7RJpR");

var $1ph0w = parcelRequire("1ph0w");

var $k77dm = parcelRequire("k77dm");

var $f6YQ2 = parcelRequire("f6YQ2");

var $10lUL = parcelRequire("10lUL");
const $3ae013699597b3b2$var$styles = {
    imageWrapper: "_1bsb1osq"
};
const $3ae013699597b3b2$var$translations = {
    actions: (0, $ic1Gf.actions),
    heading: (0, $k77dm.heading),
    children: (0, $7RJpR.children),
    dialogPlacement: (0, $1ph0w.dialogPlacement),
    target: (0, $f6YQ2.target)
};
const $3ae013699597b3b2$export$13e08e0bdd266b1b = (props)=>{
    const { messageId: messageId, messageType: messageType, onMessageDisposition: onMessageDisposition, shouldBeChoreographed: shouldBeChoreographed, withChoreographedRender: withChoreographedRender, ...rest } = props;
    const placement = $3ae013699597b3b2$var$translations.dialogPlacement(rest.dialogPlacement);
    const actions = $3ae013699597b3b2$var$translations.actions(rest.actions);
    const heading = $3ae013699597b3b2$var$translations.heading(rest.heading);
    const body = $3ae013699597b3b2$var$translations.children(rest.children);
    const id = $3ae013699597b3b2$var$translations.target(rest.target);
    const [isVisible, setIsVisible] = (0, $euxye.useState)(true);
    const dismiss = (0, $euxye.useCallback)(()=>{
        setIsVisible(false);
    }, []);
    const renderInline = (0, $10lUL.useMountToHtmlElement)({
        selectors: id ? `#${id}` : undefined,
        as: 'inline',
        position: 'inside'
    });
    return renderInline(/*#__PURE__*/ (0, $e79Pd.jsx)((0, $a4RVh.ChoreographedComponent), {
        messageId: messageId,
        messageType: messageType,
        onMessageDisposition: onMessageDisposition,
        shouldBeChoreographed: shouldBeChoreographed,
        withChoreographedRender: withChoreographedRender,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $g5k19.PopoverProvider), {
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5Gxfr.PopoverTarget), {
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {})
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fxLck.PopoverContent), {
                    offset: rest.offset,
                    dismiss: dismiss,
                    placement: placement,
                    isVisible: isVisible,
                    children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8CDnU.SpotlightCard), {
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $KcP1c.SpotlightHeader), {
                                children: [
                                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $413te.SpotlightHeadline), {
                                        children: heading
                                    }),
                                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8qQ8A.SpotlightControls), {
                                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8guPH.SpotlightDismissControl), {
                                            onClick: dismiss
                                        })
                                    })
                                ]
                            }),
                            rest.image && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $54cWg.SpotlightMedia), {
                                children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                                    className: (0, $4jQY2.default)([
                                        $3ae013699597b3b2$var$styles.imageWrapper
                                    ]),
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $i2sOf.default), {
                                        src: rest.image,
                                        alt: ""
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $liP0D.SpotlightBody), {
                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                                    children: body
                                })
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $7okqc.SpotlightFooter), {
                                children: [
                                    rest.actionsBeforeElement && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7Bcvd.SpotlightStepCount), {
                                        children: rest.actionsBeforeElement
                                    }),
                                    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $jFNyB.SpotlightActions), {
                                        children: [
                                            actions.secondary && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bEy1I.SpotlightSecondaryAction), {
                                                onClick: actions.secondary.onClick,
                                                children: actions.secondary.text
                                            }),
                                            actions.primary && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jukA2.SpotlightPrimaryAction), {
                                                onClick: actions.primary.onClick,
                                                children: actions.primary.text
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
$3ae013699597b3b2$export$13e08e0bdd266b1b.displayName = "MigratedSpotlight";

});
parcelRegister("ic1Gf", function(module, exports) {
$parcel$export(module.exports, "actions", () => $688fd994f31259c5$export$e324594224ef24da);
const $688fd994f31259c5$export$e324594224ef24da = (value)=>{
    if (!value || value.length === 0) return {};
    if (value.length === 1) {
        const [primary] = value;
        return {
            primary: primary
        };
    }
    const primary = value.find((action)=>action.ctaType === 'primary');
    const secondary = value.find((action)=>action.ctaType === 'secondary');
    if (primary && secondary) return {
        primary: primary,
        secondary: secondary
    };
    if (primary) {
        // Only primary found, assign the other as secondary
        const other = value.find((action)=>action !== primary);
        return {
            primary: primary,
            secondary: other
        };
    }
    if (secondary) {
        // Only secondary found, assign the other as primary
        const other = value.find((action)=>action !== secondary);
        return {
            primary: other,
            secondary: secondary
        };
    }
    // Neither ctaType is set, assume second is primary, first is secondary
    const [secondaryFallback, primaryFallback] = value;
    return {
        primary: primaryFallback,
        secondary: secondaryFallback
    };
};

});

parcelRegister("7RJpR", function(module, exports) {
$parcel$export(module.exports, "children", () => $85d237949ff452ce$export$bacb5cc5a11aef16);
const $85d237949ff452ce$export$bacb5cc5a11aef16 = (value)=>{
    return value;
};

});

parcelRegister("1ph0w", function(module, exports) {
$parcel$export(module.exports, "dialogPlacement", () => $b89c172c899b1224$export$608d2c28a2f3926e);
const $b89c172c899b1224$var$placementMap = {
    'top right': 'top-start',
    'top center': 'top-center',
    'top left': 'top-end',
    'right bottom': 'right-start',
    'right middle': 'right-start',
    'right top': 'right-end',
    'bottom left': 'bottom-end',
    'bottom center': 'bottom-center',
    'bottom right': 'bottom-start',
    'left top': 'left-end',
    'left middle': 'left-start',
    'left bottom': 'left-start'
};
const $b89c172c899b1224$export$608d2c28a2f3926e = (value)=>{
    // `bottom left` is the default placement when `undefined` is passed.
    return $b89c172c899b1224$var$placementMap[value || 'bottom left'];
};

});

parcelRegister("k77dm", function(module, exports) {
$parcel$export(module.exports, "heading", () => $5026913ef8709973$export$46e4a324ac90507f);
const $5026913ef8709973$export$46e4a324ac90507f = (value)=>{
    return value;
};

});

parcelRegister("f6YQ2", function(module, exports) {
$parcel$export(module.exports, "target", () => $04ccca9492d86134$export$44271b4f0c6a3563);
const $04ccca9492d86134$export$44271b4f0c6a3563 = (value)=>{
    if (!value || value.length === 0) return '';
    /**
	 * All of the following are actually invalid in CSS selectors.
	 * It's unlikely that a lot of these are actually used as `Spotlight` `name` prop values.
	 * If it turns out other characters are used, add them as needed.
	 *
	 * (space) — descendant combinator
	 * > — child combinator
	 * + — adjacent sibling combinator
	 * ~ — general sibling combinator
	 * . — class selector
	 * # — ID selector
	 * : — pseudo-class/element
	 * [ ] — attribute selectors
	 * ( ) — functional notation
	 * , — selector list separator
	 * * — universal selector
	 * | — namespace separator
	 * " ' — string delimiters
	 * \ — escape character
	 * Characters not allowed in unescaped identifiers:
	 * Digits 0-9 cannot be the first character
	 * !, @, $, %, ^, &, =, {, }, ;, /, and most other punctuation
	 */ return value.replace(/ /g, '-').replace(/\//g, '-');
};

});

parcelRegister("10lUL", function(module, exports) {
$parcel$export(module.exports, "useMountToHtmlElement", () => $35751d1e51c49f55$export$81e9e5f51d0d0a61);

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $u9iDa = parcelRequire("u9iDa");
function $35751d1e51c49f55$export$81e9e5f51d0d0a61(params) {
    const { as: as = 'portal', selectors: selectors, position: position = 'after', observeRoot: observeRoot, rootDocument: rootDocument } = params ?? {};
    const targetElement = $35751d1e51c49f55$var$useElement({
        selectors: selectors,
        observeRoot: observeRoot,
        rootDocument: rootDocument
    });
    const renderPortal = $35751d1e51c49f55$var$usePortalNearElement({
        targetElement: targetElement,
        position: position
    });
    const renderInline = $35751d1e51c49f55$var$useInlineNearElement({
        targetElement: targetElement,
        position: position
    });
    if (as === 'inline') return renderInline;
    return renderPortal;
}
function $35751d1e51c49f55$var$useElement({ selectors: selectors, observeRoot: observeRoot, rootDocument: rootDocument }) {
    const knownEls = (0, $euxye.useRef)({});
    const [el, setEl] = (0, $euxye.useState)();
    (0, $euxye.useEffect)(()=>{
        const doc = rootDocument ?? (0, $u9iDa.getDocument)();
        if (!doc || !selectors) {
            setEl(undefined);
            return;
        }
        if (knownEls.current[selectors] !== undefined) {
            setEl(knownEls.current[selectors]);
            return;
        }
        const element = doc.querySelector(selectors) ?? undefined;
        knownEls.current[selectors] = element;
        setEl(element);
        if (observeRoot) {
            const observer = new MutationObserver(()=>{
                const foundElement = doc.querySelector(selectors);
                if (foundElement) {
                    setEl(foundElement);
                    observer.disconnect();
                }
            });
            observer.observe(observeRoot, {
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        selectors,
        observeRoot,
        rootDocument
    ]);
    return el;
}
function $35751d1e51c49f55$var$usePortalNearElement({ targetElement: targetElement, position: position }) {
    const [portalContainer, setPortalContainer] = (0, $euxye.useState)(null);
    (0, $euxye.useEffect)(()=>{
        if (!(0, $u9iDa.getDocument)() || !targetElement) {
            setPortalContainer(null);
            return;
        }
        const container = targetElement.ownerDocument.createElement('div');
        container.style.position = 'absolute';
        if (position === 'after') targetElement.parentNode?.insertBefore(container, targetElement.nextSibling);
        else if (position === 'before') targetElement.parentNode?.insertBefore(container, targetElement);
        else targetElement.appendChild(container);
        setPortalContainer(container);
        return ()=>container.remove();
    }, [
        targetElement,
        position
    ]);
    return (children)=>portalContainer ? (0, $85XPu.createPortal)(children, portalContainer) : null;
}
function $35751d1e51c49f55$var$useInlineNearElement({ targetElement: targetElement, position: position }) {
    const [inlineContainer, setInlineContainer] = (0, $euxye.useState)(null);
    (0, $euxye.useEffect)(()=>{
        if (!(0, $u9iDa.getDocument)() || !targetElement) {
            setInlineContainer(null);
            return;
        }
        const container = targetElement.ownerDocument.createElement('div');
        if (position === 'after') targetElement.parentNode?.insertBefore(container, targetElement.nextSibling);
        else if (position === 'before') targetElement.parentNode?.insertBefore(container, targetElement);
        else targetElement.appendChild(container);
        setInlineContainer(container);
        return ()=>container.remove();
    }, [
        targetElement,
        position
    ]);
    return (children)=>inlineContainer ? (0, $85XPu.createPortal)(children, inlineContainer) : null;
}

});


parcelRegister("jCpSG", function(module, exports) {
$parcel$export(module.exports, "SpotlightTarget", () => $902502760a64bb4c$export$e29577842f211e22);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8jEW8 = parcelRequire("8jEW8");

var $egspI = parcelRequire("egspI");

var $f6YQ2 = parcelRequire("f6YQ2");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $902502760a64bb4c$export$e29577842f211e22 = ({ children: children, name: name })=>{
    const id = (0, $f6YQ2.target)(name);
    if ((0, $egspI.fg)('post-office_enable_ads_spotlight_migration')) return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        id: id,
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8jEW8.default), {
        name: name,
        children: children
    });
};
$902502760a64bb4c$export$e29577842f211e22.displayName = "SpotlightTarget";
$902502760a64bb4c$export$e29577842f211e22.displayName = 'SpotlightTarget';

});


parcelRegister("jmlYc", function(module, exports) {
$parcel$export(module.exports, "SpotlightCard", () => $d6f613fa655aaa34$export$14710e13fc01d383);
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package

var $UEjKq = parcelRequire("UEjKq");

var $kDVb4 = parcelRequire("kDVb4");
const $d6f613fa655aaa34$export$14710e13fc01d383 = (0, $kDVb4.wrapComponentForChoreographer)((0, $UEjKq.default));

});


parcelRegister("g6TgS", function(module, exports) {
$parcel$export(module.exports, "default", () => $bba814979fc08f0b$export$2e2bcd8739ae039);

var $gdeXx = parcelRequire("gdeXx");

var $bba814979fc08f0b$export$2e2bcd8739ae039 = (0, $gdeXx.default);

});
parcelRegister("gdeXx", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcd976d8c6731dcc$export$2e2bcd8739ae039);

var $2rVEs = parcelRequire("2rVEs");

var $jimAf = parcelRequire("jimAf");

var $euxye = parcelRequire("euxye");

var $3Xa4v = parcelRequire("3Xa4v");

var $9Y4ZE = parcelRequire("9Y4ZE");
var $bcd976d8c6731dcc$var$FocusLockCombination = /*#__PURE__*/ $euxye.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $euxye.createElement((0, $3Xa4v.default), (0, $jimAf.default)({
        sideCar: (0, $9Y4ZE.default),
        ref: ref
    }, props));
});
var $bcd976d8c6731dcc$var$_ref = (0, $3Xa4v.default).propTypes || {}, $bcd976d8c6731dcc$var$sideCar = $bcd976d8c6731dcc$var$_ref.sideCar, $bcd976d8c6731dcc$var$propTypes = (0, $2rVEs.default)($bcd976d8c6731dcc$var$_ref, [
    "sideCar"
]);
$bcd976d8c6731dcc$var$FocusLockCombination.propTypes = {};
var $bcd976d8c6731dcc$export$2e2bcd8739ae039 = $bcd976d8c6731dcc$var$FocusLockCombination;

});
parcelRegister("3Xa4v", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e0eb1cf5ba2e7c9$export$2e2bcd8739ae039);

var $jimAf = parcelRequire("jimAf");

var $euxye = parcelRequire("euxye");


var $jBqdC = parcelRequire("jBqdC");

var $fsEVO = parcelRequire("fsEVO");

var $bCLEq = parcelRequire("bCLEq");

var $bDFkF = parcelRequire("bDFkF");

var $2kGxz = parcelRequire("2kGxz");
var $2e0eb1cf5ba2e7c9$var$emptyArray = [];
var $2e0eb1cf5ba2e7c9$var$FocusLock = /*#__PURE__*/ $euxye.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $euxye.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $euxye.useRef();
    var isActive = $euxye.useRef(false);
    var originalFocusedElement = $euxye.useRef(null);
    var _React$useState2 = $euxye.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $2e0eb1cf5ba2e7c9$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $euxye.useState({}), id = _React$useState3[0];
    var onActivation = $euxye.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $euxye.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $euxye.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $euxye.useCallback(function(event) {
        if (isActive.current) (0, $bDFkF.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $bDFkF.mediumBlur).useMedium;
    var setObserveNode = $euxye.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $jimAf.default)((_extends2 = {}, _extends2[$jBqdC.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$jBqdC.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $fsEVO.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $euxye.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $euxye.createElement($euxye.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $euxye.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $bCLEq.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $euxye.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $bCLEq.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $euxye.createElement(SideCar, {
        id: id,
        sideCar: (0, $bDFkF.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $euxye.createElement(Container, (0, $jimAf.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $euxye.createElement((0, $2kGxz.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $euxye.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $bCLEq.hiddenGuard)
    }));
});
$2e0eb1cf5ba2e7c9$var$FocusLock.propTypes = {};
var $2e0eb1cf5ba2e7c9$export$2e2bcd8739ae039 = $2e0eb1cf5ba2e7c9$var$FocusLock;

});
parcelRegister("jBqdC", function(module, exports) {
$parcel$export(module.exports, "FOCUS_GROUP", () => $e455cf86375a9cd6$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $e455cf86375a9cd6$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $e455cf86375a9cd6$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $e455cf86375a9cd6$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $e455cf86375a9cd6$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $e455cf86375a9cd6$export$4f9a06cb7441a087 = 'data-focus-lock';
var $e455cf86375a9cd6$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $e455cf86375a9cd6$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $e455cf86375a9cd6$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $e455cf86375a9cd6$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("fsEVO", function(module, exports) {
$parcel$export(module.exports, "useMergeRefs", () => $b41938a9c3309ce7$export$74665b213cb5c4cf);

var $euxye = parcelRequire("euxye");

var $jbpxB = parcelRequire("jbpxB");

var $hiEG2 = parcelRequire("hiEG2");
var $b41938a9c3309ce7$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $euxye.useLayoutEffect : $euxye.useEffect;
var $b41938a9c3309ce7$var$currentValues = new WeakMap();
function $b41938a9c3309ce7$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $hiEG2.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $jbpxB.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $b41938a9c3309ce7$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $b41938a9c3309ce7$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $jbpxB.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $jbpxB.assignRef)(ref, current_1);
            });
        }
        $b41938a9c3309ce7$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("jbpxB", function(module, exports) {
$parcel$export(module.exports, "assignRef", () => $df72db4ee184d008$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $df72db4ee184d008$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("hiEG2", function(module, exports) {
$parcel$export(module.exports, "useCallbackRef", () => $c983abbcab376ead$export$25bec8c6f54ee79a);

var $euxye = parcelRequire("euxye");
function $c983abbcab376ead$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $euxye.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("bCLEq", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", () => $876834d4fff04aa1$export$b8c7b07253306600);

var $euxye = parcelRequire("euxye");

var $876834d4fff04aa1$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $876834d4fff04aa1$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $euxye.createElement($euxye.Fragment, null, /*#__PURE__*/ $euxye.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $876834d4fff04aa1$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $euxye.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $876834d4fff04aa1$export$b8c7b07253306600
    }));
};
$876834d4fff04aa1$var$InFocusGuard.propTypes = {};
var $876834d4fff04aa1$export$2e2bcd8739ae039 = $876834d4fff04aa1$var$InFocusGuard;

});

parcelRegister("bDFkF", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", () => $879365f8e5888fcf$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $879365f8e5888fcf$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $879365f8e5888fcf$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $879365f8e5888fcf$export$892cbf28e5518020);

var $4n4GM = parcelRequire("4n4GM");
var $879365f8e5888fcf$export$5733e022b1d538cb = (0, $4n4GM.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $879365f8e5888fcf$export$b3e9a9312f73723c = (0, $4n4GM.createMedium)();
var $879365f8e5888fcf$export$3a1d52767cbc07b8 = (0, $4n4GM.createMedium)();
var $879365f8e5888fcf$export$892cbf28e5518020 = (0, $4n4GM.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("4n4GM", function(module, exports) {
$parcel$export(module.exports, "createMedium", () => $32ecf28e8b1b4ae0$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $32ecf28e8b1b4ae0$export$e13ec7dd7a14088d);

var $j9yrT = parcelRequire("j9yrT");
function $32ecf28e8b1b4ae0$var$ItoI(a) {
    return a;
}
function $32ecf28e8b1b4ae0$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $32ecf28e8b1b4ae0$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $32ecf28e8b1b4ae0$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $32ecf28e8b1b4ae0$var$ItoI;
    return $32ecf28e8b1b4ae0$var$innerCreateMedium(defaults, middleware);
}
function $32ecf28e8b1b4ae0$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $32ecf28e8b1b4ae0$var$innerCreateMedium(null);
    medium.options = (0, $j9yrT.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});


parcelRegister("2kGxz", function(module, exports) {
$parcel$export(module.exports, "focusScope", () => $1b2e72a82f0ef84d$export$f5272e9b1168239c);

var $euxye = parcelRequire("euxye");
var $1b2e72a82f0ef84d$export$f5272e9b1168239c = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});


parcelRegister("9Y4ZE", function(module, exports) {
$parcel$export(module.exports, "default", () => $741d973ba9506a9e$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");


var $34nHh = parcelRequire("34nHh");

var $bOdqC = parcelRequire("bOdqC");
var $kHkD3 = parcelRequire("kHkD3");
var $aTBId = parcelRequire("aTBId");
var $7fCFo = parcelRequire("7fCFo");
var $gNDHj = parcelRequire("gNDHj");parcelRequire("4y1ln");
var $cexyG = parcelRequire("cexyG");

var $7X07D = parcelRequire("7X07D");

var $bDFkF = parcelRequire("bDFkF");
var $741d973ba9506a9e$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $741d973ba9506a9e$var$isFreeFocus = function isFreeFocus() {
    return $741d973ba9506a9e$var$focusOnBody() || (0, $gNDHj.focusIsHidden)();
};
var $741d973ba9506a9e$var$lastActiveTrap = null;
var $741d973ba9506a9e$var$lastActiveFocus = null;
var $741d973ba9506a9e$var$lastPortaledElement = null;
var $741d973ba9506a9e$var$focusWasOutsideWindow = false;
var $741d973ba9506a9e$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $741d973ba9506a9e$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($741d973ba9506a9e$var$lastActiveTrap.whiteList || $741d973ba9506a9e$var$defaultWhitelist)(activeElement);
};
var $741d973ba9506a9e$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $741d973ba9506a9e$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $741d973ba9506a9e$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $741d973ba9506a9e$var$lastPortaledElement && $741d973ba9506a9e$var$lastPortaledElement.portaledElement === element;
};
function $741d973ba9506a9e$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $741d973ba9506a9e$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($741d973ba9506a9e$var$focusWasOutsideWindow);
    return $741d973ba9506a9e$var$focusWasOutsideWindow === 'meanwhile';
};
var $741d973ba9506a9e$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $741d973ba9506a9e$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $741d973ba9506a9e$var$checkInHost(activeElement, area, area);
    });
};
var $741d973ba9506a9e$var$activateTrap = function activateTrap() {
    var result = false;
    if ($741d973ba9506a9e$var$lastActiveTrap) {
        var _lastActiveTrap = $741d973ba9506a9e$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $741d973ba9506a9e$var$lastPortaledElement && $741d973ba9506a9e$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $7X07D.extractRef)).filter(Boolean));
            if (!activeElement || $741d973ba9506a9e$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $741d973ba9506a9e$var$focusWasOutside(crossFrame) || !$741d973ba9506a9e$var$isFreeFocus() || !$741d973ba9506a9e$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $7fCFo.focusInside)(workingArea) || activeElement && $741d973ba9506a9e$var$withinHost(activeElement, workingArea) || $741d973ba9506a9e$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$741d973ba9506a9e$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $cexyG.moveFocusInside)(workingArea, $741d973ba9506a9e$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $741d973ba9506a9e$var$lastPortaledElement = {};
                        }
                    }
                    $741d973ba9506a9e$var$focusWasOutsideWindow = false;
                    $741d973ba9506a9e$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $kHkD3.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $741d973ba9506a9e$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $741d973ba9506a9e$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $741d973ba9506a9e$var$onTrap = function onTrap(event) {
    if ($741d973ba9506a9e$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $741d973ba9506a9e$var$onBlur = function onBlur() {
    return (0, $7X07D.deferAction)($741d973ba9506a9e$var$activateTrap);
};
var $741d973ba9506a9e$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $741d973ba9506a9e$var$recordPortal(currentNode, source);
};
var $741d973ba9506a9e$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $741d973ba9506a9e$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $euxye.createElement("div", {
        onBlur: $741d973ba9506a9e$var$onBlur,
        onFocus: $741d973ba9506a9e$var$onFocus
    }, children);
};
$741d973ba9506a9e$var$FocusTrap.propTypes = {};
var $741d973ba9506a9e$var$onWindowBlur = function onWindowBlur() {
    $741d973ba9506a9e$var$focusWasOutsideWindow = 'just';
    (0, $7X07D.deferAction)(function() {
        $741d973ba9506a9e$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $741d973ba9506a9e$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $741d973ba9506a9e$var$onTrap);
    document.addEventListener('focusout', $741d973ba9506a9e$var$onBlur);
    window.addEventListener('blur', $741d973ba9506a9e$var$onWindowBlur);
};
var $741d973ba9506a9e$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $741d973ba9506a9e$var$onTrap);
    document.removeEventListener('focusout', $741d973ba9506a9e$var$onBlur);
    window.removeEventListener('blur', $741d973ba9506a9e$var$onWindowBlur);
};
function $741d973ba9506a9e$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $741d973ba9506a9e$var$focusLockAPI = {
    moveFocusInside: (0, $cexyG.moveFocusInside),
    focusInside: (0, $7fCFo.focusInside),
    focusNextElement: (0, $aTBId.focusNextElement),
    focusPrevElement: (0, $aTBId.focusPrevElement),
    focusFirstElement: (0, $aTBId.focusFirstElement),
    focusLastElement: (0, $aTBId.focusLastElement),
    captureFocusRestore: (0, $bOdqC.captureFocusRestore)
};
function $741d973ba9506a9e$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$741d973ba9506a9e$var$lastActiveTrap) $741d973ba9506a9e$var$attachHandler();
    var lastTrap = $741d973ba9506a9e$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $741d973ba9506a9e$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $741d973ba9506a9e$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($741d973ba9506a9e$var$focusLockAPI);
        $741d973ba9506a9e$var$activateTrap(true);
        (0, $7X07D.deferAction)($741d973ba9506a9e$var$activateTrap);
    } else {
        $741d973ba9506a9e$var$detachHandler();
        $741d973ba9506a9e$var$lastActiveFocus = null;
    }
}
(0, $bDFkF.mediumFocus).assignSyncMedium($741d973ba9506a9e$var$onFocus);
(0, $bDFkF.mediumBlur).assignMedium($741d973ba9506a9e$var$onBlur);
(0, $bDFkF.mediumEffect).assignMedium(function(cb) {
    return cb($741d973ba9506a9e$var$focusLockAPI);
});
var $741d973ba9506a9e$export$2e2bcd8739ae039 = (0, $34nHh.default)($741d973ba9506a9e$var$reducePropsToState, $741d973ba9506a9e$var$handleStateChangeOnClient)($741d973ba9506a9e$var$FocusWatcher);

});
parcelRegister("34nHh", function(module, exports) {
$parcel$export(module.exports, "default", () => $23c4208f6e0ee5ef$export$2e2bcd8739ae039);

var $cvqF7 = parcelRequire("cvqF7");

var $35jf9 = parcelRequire("35jf9");

var $euxye = parcelRequire("euxye");
function $23c4208f6e0ee5ef$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $cvqF7.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $euxye.PureComponent));
        (0, $35jf9.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $23c4208f6e0ee5ef$export$2e2bcd8739ae039 = $23c4208f6e0ee5ef$var$withSideEffect;

});
parcelRegister("35jf9", function(module, exports) {
$parcel$export(module.exports, "default", () => $23f0c4114e084f05$export$2e2bcd8739ae039);

var $8rDrr = parcelRequire("8rDrr");
function $23f0c4114e084f05$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $8rDrr.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("8rDrr", function(module, exports) {
$parcel$export(module.exports, "default", () => $625f70a37c994787$export$2e2bcd8739ae039);

var $fmNWd = parcelRequire("fmNWd");

var $4UyIv = parcelRequire("4UyIv");
function $625f70a37c994787$export$2e2bcd8739ae039(t) {
    var i = (0, $4UyIv.default)(t, "string");
    return "symbol" == (0, $fmNWd.default)(i) ? i : i + "";
}

});
parcelRegister("fmNWd", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2ffa5b62d255124$export$2e2bcd8739ae039);
function $b2ffa5b62d255124$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b2ffa5b62d255124$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b2ffa5b62d255124$export$2e2bcd8739ae039(o);
}

});

parcelRegister("4UyIv", function(module, exports) {
$parcel$export(module.exports, "default", () => $3937526fc344bf1e$export$2e2bcd8739ae039);

var $fmNWd = parcelRequire("fmNWd");
function $3937526fc344bf1e$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fmNWd.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fmNWd.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("bOdqC", function(module, exports) {
$parcel$export(module.exports, "captureFocusRestore", () => $898ec7c934a13aa6$export$d357db6e554ff59a);

var $k0t4i = parcelRequire("k0t4i");
function $898ec7c934a13aa6$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $898ec7c934a13aa6$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $898ec7c934a13aa6$var$weakRef(currentElement),
            parent: $898ec7c934a13aa6$var$weakRef(currentElement.parentElement),
            left: $898ec7c934a13aa6$var$weakRef(currentElement.previousElementSibling),
            right: $898ec7c934a13aa6$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $898ec7c934a13aa6$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $898ec7c934a13aa6$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $k0t4i.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $898ec7c934a13aa6$export$d357db6e554ff59a = function(targetElement) {
    var location = $898ec7c934a13aa6$export$5061a7725be48ff9(targetElement);
    return function() {
        return $898ec7c934a13aa6$var$restoreFocusTo(location);
    };
};

});
parcelRegister("k0t4i", function(module, exports) {
$parcel$export(module.exports, "filterAutoFocusable", () => $e90a5b1dfe3ac3f0$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $e90a5b1dfe3ac3f0$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $e90a5b1dfe3ac3f0$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $e90a5b1dfe3ac3f0$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $e90a5b1dfe3ac3f0$export$2344b14b097df817);

var $5GUEZ = parcelRequire("5GUEZ");

var $4jLlo = parcelRequire("4jLlo");

var $5Fkr3 = parcelRequire("5Fkr3");

var $3b04W = parcelRequire("3b04W");
var $e90a5b1dfe3ac3f0$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $5GUEZ.toArray)(nodes).filter(function(node) {
        return (0, $4jLlo.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $4jLlo.notHiddenInput)(node);
    });
};
var $e90a5b1dfe3ac3f0$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $5GUEZ.toArray)(nodes).filter(function(node) {
        return (0, $4jLlo.isAutoFocusAllowedCached)(cache, node);
    });
};
var $e90a5b1dfe3ac3f0$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $5Fkr3.orderByTabIndex)($e90a5b1dfe3ac3f0$export$6266a5cd5915dc33((0, $3b04W.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $e90a5b1dfe3ac3f0$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $5Fkr3.orderByTabIndex)($e90a5b1dfe3ac3f0$export$6266a5cd5915dc33((0, $3b04W.getFocusables)(topNodes), visibilityCache), false);
};
var $e90a5b1dfe3ac3f0$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $e90a5b1dfe3ac3f0$export$6266a5cd5915dc33((0, $3b04W.getParentAutofocusables)(topNode), visibilityCache);
};
var $e90a5b1dfe3ac3f0$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $e90a5b1dfe3ac3f0$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $5GUEZ.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $e90a5b1dfe3ac3f0$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $e90a5b1dfe3ac3f0$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("5GUEZ", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $424cd37fe3e59e7e$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $424cd37fe3e59e7e$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $424cd37fe3e59e7e$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $424cd37fe3e59e7e$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $424cd37fe3e59e7e$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $424cd37fe3e59e7e$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("4jLlo", function(module, exports) {
$parcel$export(module.exports, "isVisibleCached", () => $324da94c72f945bc$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $324da94c72f945bc$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $324da94c72f945bc$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $324da94c72f945bc$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $324da94c72f945bc$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $324da94c72f945bc$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $324da94c72f945bc$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $324da94c72f945bc$export$4e62c701997796c1);

var $jBqdC = parcelRequire("jBqdC");
var $324da94c72f945bc$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $324da94c72f945bc$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $324da94c72f945bc$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $324da94c72f945bc$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $324da94c72f945bc$var$isVisibleUncached = function(node, checkParent) {
    return !node || $324da94c72f945bc$var$isTopNode(node) || !$324da94c72f945bc$var$isElementHidden(node) && !$324da94c72f945bc$var$isInert(node) && checkParent($324da94c72f945bc$var$getParentNode(node));
};
var $324da94c72f945bc$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $324da94c72f945bc$var$isVisibleUncached(node, $324da94c72f945bc$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $324da94c72f945bc$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$324da94c72f945bc$var$isTopNode(node) ? $324da94c72f945bc$export$b8550e27de209d85(node) ? checkParent($324da94c72f945bc$var$getParentNode(node)) : false : true;
};
var $324da94c72f945bc$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $324da94c72f945bc$var$isAutoFocusAllowedUncached(node, $324da94c72f945bc$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $324da94c72f945bc$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $324da94c72f945bc$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $324da94c72f945bc$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $324da94c72f945bc$export$9d74f6fbc6f469d0 = function(node) {
    return $324da94c72f945bc$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $324da94c72f945bc$export$8197b0ea56b3b055 = function(node) {
    return !(($324da94c72f945bc$export$88a6ceeed5737ba3(node) || $324da94c72f945bc$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $324da94c72f945bc$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $jBqdC.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $324da94c72f945bc$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $324da94c72f945bc$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $324da94c72f945bc$export$602e5a0d338d7750 = function(node) {
    return !$324da94c72f945bc$export$d94b8b58ec2f30eb(node);
};
var $324da94c72f945bc$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("5Fkr3", function(module, exports) {
$parcel$export(module.exports, "orderByTabIndex", () => $4200a22344fa6e5d$export$cb40ee071f0d5226);

var $5GUEZ = parcelRequire("5GUEZ");
var $4200a22344fa6e5d$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $4200a22344fa6e5d$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $4200a22344fa6e5d$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $5GUEZ.toArray)(nodes).map(function(node, index) {
        var tabIndex = $4200a22344fa6e5d$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($4200a22344fa6e5d$export$350ee6c095d98996);
};

});

parcelRegister("3b04W", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $250275ce228428da$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $250275ce228428da$export$853fa94d922e78b9);

var $jBqdC = parcelRequire("jBqdC");

var $5GUEZ = parcelRequire("5GUEZ");

var $lpM37 = parcelRequire("lpM37");
var $250275ce228428da$var$queryTabbables = (0, $lpM37.tabbables).join(',');
var $250275ce228428da$var$queryGuardTabbables = "".concat($250275ce228428da$var$queryTabbables, ", [data-focus-guard]");
var $250275ce228428da$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $5GUEZ.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $250275ce228428da$var$queryGuardTabbables : $250275ce228428da$var$queryTabbables) ? [
            child
        ] : [], $250275ce228428da$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $250275ce228428da$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $250275ce228428da$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $250275ce228428da$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $250275ce228428da$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $250275ce228428da$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $5GUEZ.toArray)(parent.parentNode.querySelectorAll($250275ce228428da$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $250275ce228428da$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $jBqdC.FOCUS_AUTO), "]"));
    return (0, $5GUEZ.toArray)(parentFocus).map(function(node) {
        return $250275ce228428da$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("lpM37", function(module, exports) {
$parcel$export(module.exports, "tabbables", () => $f971345e1159805b$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $f971345e1159805b$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("kHkD3", function(module, exports) {
$parcel$export(module.exports, "expandFocusableNodes", () => $f117d34bb5698c02$export$f89ac71e91767111);

var $fURfc = parcelRequire("fURfc");

var $4jLlo = parcelRequire("4jLlo");

var $3YaRH = parcelRequire("3YaRH");

var $5Fkr3 = parcelRequire("5Fkr3");

var $3b04W = parcelRequire("3b04W");
var $f117d34bb5698c02$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $fURfc.getAllAffectedNodes)(topNode).filter((0, $4jLlo.isNotAGuard));
    var commonParent = (0, $3YaRH.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $5Fkr3.orderByTabIndex)((0, $3b04W.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $3b04W.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $4jLlo.isGuard)(node)
        };
    });
};

});
parcelRegister("fURfc", function(module, exports) {
$parcel$export(module.exports, "getAllAffectedNodes", () => $b965632bfcec2018$export$7e87c4720b9b279b);

var $jBqdC = parcelRequire("jBqdC");

var $5GUEZ = parcelRequire("5GUEZ");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $b965632bfcec2018$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $b965632bfcec2018$var$getTopParent = function(node) {
    return node.parentNode ? $b965632bfcec2018$var$getTopParent(node.parentNode) : node;
};
var $b965632bfcec2018$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $5GUEZ.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $jBqdC.FOCUS_GROUP));
        acc.push.apply(acc, group ? $b965632bfcec2018$var$filterNested((0, $5GUEZ.toArray)($b965632bfcec2018$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $jBqdC.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $jBqdC.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("3YaRH", function(module, exports) {
$parcel$export(module.exports, "getTopCommonParent", () => $2e3f674b6f321c5c$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $2e3f674b6f321c5c$export$8f99714c70a37db1);

var $k0t4i = parcelRequire("k0t4i");

var $5GUEZ = parcelRequire("5GUEZ");
var $2e3f674b6f321c5c$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $2e3f674b6f321c5c$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $2e3f674b6f321c5c$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $2e3f674b6f321c5c$var$getParents(nodeA);
    var parentsB = $2e3f674b6f321c5c$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $2e3f674b6f321c5c$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $5GUEZ.asArray)(baseActiveElement);
    var leftEntries = (0, $5GUEZ.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $2e3f674b6f321c5c$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $2e3f674b6f321c5c$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $k0t4i.contains)(common, topCommon)) topCommon = common;
                else topCommon = $2e3f674b6f321c5c$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $2e3f674b6f321c5c$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $k0t4i.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("aTBId", function(module, exports) {
$parcel$export(module.exports, "focusNextElement", () => $7eec4b468b30727c$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $7eec4b468b30727c$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $7eec4b468b30727c$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $7eec4b468b30727c$export$6a79073ddabfd6c3);

var $lFBCp = parcelRequire("lFBCp");

var $k0t4i = parcelRequire("k0t4i");

var $5GUEZ = parcelRequire("5GUEZ");
var $7eec4b468b30727c$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $5GUEZ.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $k0t4i.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $k0t4i.getTabbableNodes)(shards, new Map()) : (0, $k0t4i.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $7eec4b468b30727c$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $k0t4i.getTabbableNodes)((0, $5GUEZ.asArray)(shards), new Map()) : (0, $k0t4i.getFocusableNodes)((0, $5GUEZ.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $7eec4b468b30727c$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $7eec4b468b30727c$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $7eec4b468b30727c$var$defaultOptions(options);
    var solution = $7eec4b468b30727c$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $lFBCp.focusOn)(target.node, newOptions.focusOptions);
};
var $7eec4b468b30727c$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $7eec4b468b30727c$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $7eec4b468b30727c$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $7eec4b468b30727c$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $7eec4b468b30727c$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $7eec4b468b30727c$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $lFBCp.focusOn)(node.node, options.focusOptions);
};
var $7eec4b468b30727c$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $7eec4b468b30727c$var$pickBoundary(scope, options, 'first');
};
var $7eec4b468b30727c$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $7eec4b468b30727c$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("lFBCp", function(module, exports) {
$parcel$export(module.exports, "focusOn", () => $fc6a9b8e141322af$export$c12b3da842c43a8);
var $fc6a9b8e141322af$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("7fCFo", function(module, exports) {
$parcel$export(module.exports, "focusInside", () => $5477ed832a5d6ac8$export$20115f8da7baa6fa);

var $k0t4i = parcelRequire("k0t4i");

var $fURfc = parcelRequire("fURfc");

var $5GUEZ = parcelRequire("5GUEZ");

var $6zI4q = parcelRequire("6zI4q");
var $5477ed832a5d6ac8$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $5477ed832a5d6ac8$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $5GUEZ.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $5477ed832a5d6ac8$var$focusInFrame(node, activeElement);
    }));
};
var $5477ed832a5d6ac8$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $6zI4q.getActiveElement)((0, $5GUEZ.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $fURfc.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $k0t4i.contains)(node, activeElement) || $5477ed832a5d6ac8$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("6zI4q", function(module, exports) {
$parcel$export(module.exports, "getActiveElement", () => $4c98326638358aa9$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $izQro = parcelRequire("izQro");
var $4c98326638358aa9$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $4c98326638358aa9$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $izQro.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $4c98326638358aa9$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("izQro", function(module, exports) {
$parcel$export(module.exports, "safeProbe", () => $d8642c8c53b89de8$export$78d20aae35adef88);
var $d8642c8c53b89de8$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("gNDHj", function(module, exports) {
$parcel$export(module.exports, "focusIsHidden", () => $c3b0040991bda462$export$be6b21806d3fd485);

var $jBqdC = parcelRequire("jBqdC");

var $k0t4i = parcelRequire("k0t4i");

var $5GUEZ = parcelRequire("5GUEZ");

var $6zI4q = parcelRequire("6zI4q");
var $c3b0040991bda462$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $6zI4q.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $5GUEZ.toArray)(inDocument.querySelectorAll("[".concat((0, $jBqdC.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $k0t4i.contains)(node, activeElement);
    });
};

});

parcelRegister("4y1ln", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("cexyG")).moveFocusInside);

var $jBqdC = parcelRequire("jBqdC");

var $7fCFo = parcelRequire("7fCFo");

var $gNDHj = parcelRequire("gNDHj");


var $kHkD3 = parcelRequire("kHkD3");

var $cexyG = parcelRequire("cexyG");

var $bOdqC = parcelRequire("bOdqC");

var $aTBId = parcelRequire("aTBId");

var $k0t4i = parcelRequire("k0t4i");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $34fb613ce2f94ab9$export$1a988e7317c65621 = $jBqdC;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $34fb613ce2f94ab9$var$deprecated_default_moveFocusInside = (0, $cexyG.moveFocusInside);
var $34fb613ce2f94ab9$export$2e2bcd8739ae039 //
 = $34fb613ce2f94ab9$var$deprecated_default_moveFocusInside;

});
parcelRegister("cexyG", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => $8e80d2d1a3d4dcb4$export$cd599851e879a025);

var $lFBCp = parcelRequire("lFBCp");

var $5ctCX = parcelRequire("5ctCX");
var $8e80d2d1a3d4dcb4$var$guardCount = 0;
var $8e80d2d1a3d4dcb4$var$lockDisabled = false;
var $8e80d2d1a3d4dcb4$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $5ctCX.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($8e80d2d1a3d4dcb4$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($8e80d2d1a3d4dcb4$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $8e80d2d1a3d4dcb4$var$lockDisabled = true;
            setTimeout(function() {
                $8e80d2d1a3d4dcb4$var$lockDisabled = false;
            }, 1);
            return;
        }
        $8e80d2d1a3d4dcb4$var$guardCount++;
        (0, $lFBCp.focusOn)(focusable.node, options.focusOptions);
        $8e80d2d1a3d4dcb4$var$guardCount--;
    }
};

});
parcelRegister("5ctCX", function(module, exports) {
$parcel$export(module.exports, "focusSolver", () => $3c950e1c30280c88$export$305758c744b57f6f);

var $k8pzT = parcelRequire("k8pzT");

var $k0t4i = parcelRequire("k0t4i");

var $fURfc = parcelRequire("fURfc");

var $5GUEZ = parcelRequire("5GUEZ");

var $izR9L = parcelRequire("izR9L");

var $6zI4q = parcelRequire("6zI4q");

var $4jLlo = parcelRequire("4jLlo");

var $3YaRH = parcelRequire("3YaRH");
var $3c950e1c30280c88$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $4jLlo.isDefined));
};
var $3c950e1c30280c88$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $6zI4q.getActiveElement)((0, $5GUEZ.asArray)(topNode).length > 0 ? document : (0, $5GUEZ.getFirst)(topNode).ownerDocument);
    var entries = (0, $fURfc.getAllAffectedNodes)(topNode).filter((0, $4jLlo.isNotAGuard));
    var commonParent = (0, $3YaRH.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $k0t4i.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $4jLlo.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $k0t4i.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $3c950e1c30280c88$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $k8pzT.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $k8pzT.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $izR9L.pickAutofocus)(anyFocusable, innerTabbable, (0, $3YaRH.allParentAutofocusables)(entries, visibilityCache)) || (0, $izR9L.pickAutofocus)(anyFocusable, innerFocusables, (0, $3YaRH.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("k8pzT", function(module, exports) {
$parcel$export(module.exports, "NEW_FOCUS", () => $ea88653a54c465f0$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $ea88653a54c465f0$export$65842178e9bb4205);

var $3vFHo = parcelRequire("3vFHo");

var $fcSHA = parcelRequire("fcSHA");

var $4jLlo = parcelRequire("4jLlo");
var $ea88653a54c465f0$export$85710b12cf912438 = 'NEW_FOCUS';
var $ea88653a54c465f0$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $4jLlo.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $ea88653a54c465f0$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $ea88653a54c465f0$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $3vFHo.correctNodes)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $fcSHA.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $fcSHA.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("3vFHo", function(module, exports) {
$parcel$export(module.exports, "correctNode", () => $28e49ce6857f5648$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $28e49ce6857f5648$export$4a5a72a7124e45f9);

var $4jLlo = parcelRequire("4jLlo");
var $28e49ce6857f5648$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $4jLlo.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $28e49ce6857f5648$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $4jLlo.isRadioElement)(node) && node.name) return $28e49ce6857f5648$var$findSelectedRadio(node, nodes);
    return node;
};
var $28e49ce6857f5648$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($28e49ce6857f5648$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("fcSHA", function(module, exports) {
$parcel$export(module.exports, "pickFirstFocus", () => $b12268b4ac5ecf45$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $b12268b4ac5ecf45$export$e06728ee87c96122);

var $3vFHo = parcelRequire("3vFHo");
var $b12268b4ac5ecf45$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $3vFHo.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $b12268b4ac5ecf45$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $3vFHo.correctNode)(node, nodes));
};

});


parcelRegister("izR9L", function(module, exports) {
$parcel$export(module.exports, "pickAutofocus", () => $d864baa42bfb0fa5$export$cfb742983e257555);

var $k0t4i = parcelRequire("k0t4i");

var $fcSHA = parcelRequire("fcSHA");

var $4jLlo = parcelRequire("4jLlo");
var $d864baa42bfb0fa5$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $4jLlo.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $d864baa42bfb0fa5$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $k0t4i.filterAutoFocusable)(nodes.filter($d864baa42bfb0fa5$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $fcSHA.pickFirstFocus)(autoFocusable);
    return (0, $fcSHA.pickFirstFocus)((0, $k0t4i.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("7X07D", function(module, exports) {
$parcel$export(module.exports, "deferAction", () => $5c9e2358e2bcc093$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $5c9e2358e2bcc093$export$c613fed06e332533);
function $5c9e2358e2bcc093$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $5c9e2358e2bcc093$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $5c9e2358e2bcc093$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("7eXG5", function(module, exports) {
$parcel$export(module.exports, "default", () => $545821fe9c4045e1$export$2e2bcd8739ae039);

var $3Xa4v = parcelRequire("3Xa4v");






var $545821fe9c4045e1$export$2e2bcd8739ae039 = (0, $3Xa4v.default);

});

parcelRegister("jr1Vl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $i7Huj = parcelRequire("i7Huj");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $e2620801fcc86ddc$var$_interopRequireDefault($i7Huj).default;
    }
});

var $eosOC = parcelRequire("eosOC");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $eosOC.TouchScrollable;
    }
});
function $e2620801fcc86ddc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("i7Huj", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d31a9d3f3c30c755$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $euxye = parcelRequire("euxye");
var $d31a9d3f3c30c755$var$_react2 = $d31a9d3f3c30c755$var$_interopRequireDefault($euxye);

var $kt9Lz = parcelRequire("kt9Lz");

var $eosOC = parcelRequire("eosOC");

var $7h9Q1 = parcelRequire("7h9Q1");
var $d31a9d3f3c30c755$var$_withLockSheet2 = $d31a9d3f3c30c755$var$_interopRequireDefault($7h9Q1);

var $h770m = parcelRequire("h770m");
var $d31a9d3f3c30c755$var$_withTouchListeners2 = $d31a9d3f3c30c755$var$_interopRequireDefault($h770m);

var $eavJM = parcelRequire("eavJM");
function $d31a9d3f3c30c755$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d31a9d3f3c30c755$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d31a9d3f3c30c755$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d31a9d3f3c30c755$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d31a9d3f3c30c755$var$ScrollLock = function(_PureComponent) {
    $d31a9d3f3c30c755$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $d31a9d3f3c30c755$var$_classCallCheck(this, ScrollLock);
        return $d31a9d3f3c30c755$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $d31a9d3f3c30c755$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$kt9Lz.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $d31a9d3f3c30c755$var$_react2.default.createElement($eosOC.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($euxye.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $d31a9d3f3c30c755$var$compose = (0, $eavJM.pipe)($d31a9d3f3c30c755$var$_withTouchListeners2.default, $d31a9d3f3c30c755$var$_withLockSheet2.default);
var $d31a9d3f3c30c755$var$SheetLock = $d31a9d3f3c30c755$var$compose($d31a9d3f3c30c755$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $d31a9d3f3c30c755$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $d31a9d3f3c30c755$var$_react2.default.createElement($d31a9d3f3c30c755$var$SheetLock, props) : props.children;
};
$d31a9d3f3c30c755$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $d31a9d3f3c30c755$var$LockToggle;

});
parcelRegister("kt9Lz", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("eosOC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $a7a9a8b605a619a2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a7a9a8b605a619a2$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $euxye = parcelRequire("euxye");

var $kt9Lz = parcelRequire("kt9Lz");

var $eavJM = parcelRequire("eavJM");
function $a7a9a8b605a619a2$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $a7a9a8b605a619a2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a7a9a8b605a619a2$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a7a9a8b605a619a2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a7a9a8b605a619a2$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $a7a9a8b605a619a2$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $a7a9a8b605a619a2$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $a7a9a8b605a619a2$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $a7a9a8b605a619a2$var$_possibleConstructorReturn(_this, _ret);
    }
    $a7a9a8b605a619a2$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$kt9Lz.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $eavJM.preventInertiaScroll, $eavJM.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $eavJM.allowTouchMove, $eavJM.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$kt9Lz.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $eavJM.preventInertiaScroll, $eavJM.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $eavJM.allowTouchMove, $eavJM.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $a7a9a8b605a619a2$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $euxye.cloneElement)(children, $a7a9a8b605a619a2$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($euxye.PureComponent);

});
parcelRegister("eavJM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $a50a9e44f5e44876$var$preventTouchMove;
module.exports.allowTouchMove = $a50a9e44f5e44876$var$allowTouchMove;
module.exports.preventInertiaScroll = $a50a9e44f5e44876$var$preventInertiaScroll;
module.exports.isTouchDevice = $a50a9e44f5e44876$var$isTouchDevice;
module.exports.camelToKebab = $a50a9e44f5e44876$var$camelToKebab;
module.exports.parse = $a50a9e44f5e44876$var$parse;
module.exports.getPadding = $a50a9e44f5e44876$var$getPadding;
module.exports.getWindowHeight = $a50a9e44f5e44876$var$getWindowHeight;
module.exports.getDocumentHeight = $a50a9e44f5e44876$var$getDocumentHeight;
module.exports.makeStyleTag = $a50a9e44f5e44876$var$makeStyleTag;
module.exports.injectStyles = $a50a9e44f5e44876$var$injectStyles;
module.exports.insertStyleTag = $a50a9e44f5e44876$var$insertStyleTag;

var $kt9Lz = parcelRequire("kt9Lz");
var $a50a9e44f5e44876$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $a50a9e44f5e44876$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $a50a9e44f5e44876$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $a50a9e44f5e44876$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $a50a9e44f5e44876$var$isTouchDevice() {
    if (!$kt9Lz.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $a50a9e44f5e44876$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $a50a9e44f5e44876$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $a50a9e44f5e44876$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $a50a9e44f5e44876$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($a50a9e44f5e44876$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $a50a9e44f5e44876$var$getPadding() {
    if (!$kt9Lz.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $a50a9e44f5e44876$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($kt9Lz.canUseDOM) return window.innerHeight * multiplier;
}
function $a50a9e44f5e44876$var$getDocumentHeight() {
    if ($kt9Lz.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $a50a9e44f5e44876$var$makeStyleTag() {
    if (!$kt9Lz.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $a50a9e44f5e44876$var$injectStyles(tag, css) {
    if (!$kt9Lz.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $a50a9e44f5e44876$var$insertStyleTag(tag) {
    if (!$kt9Lz.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("7h9Q1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $54c1c092cb2a2b45$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $54c1c092cb2a2b45$var$withLockSheet;

var $euxye = parcelRequire("euxye");
var $54c1c092cb2a2b45$var$_react2 = $54c1c092cb2a2b45$var$_interopRequireDefault($euxye);

var $eavJM = parcelRequire("eavJM");
function $54c1c092cb2a2b45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $54c1c092cb2a2b45$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $54c1c092cb2a2b45$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $54c1c092cb2a2b45$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $54c1c092cb2a2b45$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $54c1c092cb2a2b45$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $54c1c092cb2a2b45$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $54c1c092cb2a2b45$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $eavJM.makeStyleTag)();
                if (!sheet) return;
                (0, $eavJM.injectStyles)(sheet, styles);
                (0, $eavJM.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $eavJM.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $eavJM.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $54c1c092cb2a2b45$var$_possibleConstructorReturn(_this, _ret);
        }
        $54c1c092cb2a2b45$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $54c1c092cb2a2b45$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($euxye.PureComponent);
}

});

parcelRegister("h770m", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c758862355e50618$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $c758862355e50618$var$withTouchListeners;

var $euxye = parcelRequire("euxye");
var $c758862355e50618$var$_react2 = $c758862355e50618$var$_interopRequireDefault($euxye);

var $kt9Lz = parcelRequire("kt9Lz");

var $eavJM = parcelRequire("eavJM");
function $c758862355e50618$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c758862355e50618$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c758862355e50618$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c758862355e50618$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $c758862355e50618$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $c758862355e50618$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $c758862355e50618$var$_classCallCheck(this, TouchProvider);
            return $c758862355e50618$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $c758862355e50618$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$kt9Lz.canUseDOM || !(0, $eavJM.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $eavJM.preventTouchMove, $eavJM.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$kt9Lz.canUseDOM || !(0, $eavJM.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $eavJM.preventTouchMove, $eavJM.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $c758862355e50618$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($euxye.PureComponent);
}

});



parcelRegister("c0ywx", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", () => (parcelRequire("5rIH0")).monitorForExternal);
$parcel$export(module.exports, "dropTargetForExternal", () => (parcelRequire("5rIH0")).dropTargetForExternal);

var $5rIH0 = parcelRequire("5rIH0");

});
parcelRegister("5rIH0", function(module, exports) {
$parcel$export(module.exports, "dropTargetForExternal", () => $e674d4ac45ac9287$export$9edc779df9a85289);
$parcel$export(module.exports, "monitorForExternal", () => $e674d4ac45ac9287$export$bb1740f3194979c1);

var $glbdM = parcelRequire("glbdM");

var $6lUjo = parcelRequire("6lUjo");

var $bGWmL = parcelRequire("bGWmL");

var $gXV7Z = parcelRequire("gXV7Z");

var $49GfZ = parcelRequire("49GfZ");


function $e674d4ac45ac9287$export$a8e56a860d7957c7({ type: type, value: value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $493a15c399719ace$export$c9c4cc54e73b125d)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $bba7dc78ee4d9c2c$export$fd3d00026297c0ad) && value === (0, $bGWmL.androidFallbackText)) return false;
    return true;
}
function $e674d4ac45ac9287$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter((type)=>$e674d4ac45ac9287$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        }));
}
function $e674d4ac45ac9287$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || $e674d4ac45ac9287$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}
let $e674d4ac45ac9287$var$didDragStartLocally = false;
const $e674d4ac45ac9287$var$adapter = (0, $6lUjo.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $glbdM.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($e674d4ac45ac9287$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $gXV7Z.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = $e674d4ac45ac9287$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types: types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = $e674d4ac45ac9287$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$e674d4ac45ac9287$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $e674d4ac45ac9287$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $e674d4ac45ac9287$var$adapter.dropTarget(args);
}
function $e674d4ac45ac9287$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $e674d4ac45ac9287$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $e674d4ac45ac9287$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $e674d4ac45ac9287$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $glbdM.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, $49GfZ.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $glbdM.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $e674d4ac45ac9287$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

});
parcelRegister("gXV7Z", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindow", () => $015ae4093da0431f$export$d1c6f249e893cdf4);

var $3kTMP = parcelRequire("3kTMP");

var $iAExz = parcelRequire("iAExz");

var $cbhIi = parcelRequire("cbhIi");

var $kwxP0 = parcelRequire("kwxP0");
function $015ae4093da0431f$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
    const { type: type, relatedTarget: relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, $iAExz.isSafari)()) return (0, $cbhIi.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is an element inside the child `iframe`
	 * (foreign element)
	 */ if ((0, $3kTMP.isFirefox)()) return (0, $kwxP0.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is `null` *(standard check)*
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});



parcelRegister("kYtXB", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => (parcelRequire("fNp4z")).monitorForTextSelection);

var $fNp4z = parcelRequire("fNp4z");

});
parcelRegister("fNp4z", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => $113ae95216fc18eb$export$2e178e3647f5e6e9);

var $glbdM = parcelRequire("glbdM");

var $6LLtr = parcelRequire("6LLtr");

var $6lUjo = parcelRequire("6lUjo");

var $7aH0o = parcelRequire("7aH0o");

var $iAExz = parcelRequire("iAExz");



function $113ae95216fc18eb$var$findTextNode(event) {
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $iAExz.isSafari)()) return null;
    /**
	 * According to the spec, `event.target` should be the `Text` node that
	 * the drag started from when dragging a text selection.
	 *
	 * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
	 *
	 * However, in Safari the closest `HTMLElement` is returned.
	 * So we need to figure out if text is dragging ourselves.
	 *
	 * → https://bugs.webkit.org/show_bug.cgi?id=268959
	 */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!event.dataTransfer?.getData((0, $bba7dc78ee4d9c2c$export$fd3d00026297c0ad))) return null;
    /**
	 * Grab the first Text node and use that.
	 * Only doing a single level search as that is all we need for this bug.
	 */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text ?? null;
}
const $113ae95216fc18eb$var$honeyPotFix = (0, $6LLtr.makeHoneyPotFix)();
const $113ae95216fc18eb$var$adapter = (0, $6lUjo.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $7aH0o.combine)($113ae95216fc18eb$var$honeyPotFix.bindEvents(), (0, $glbdM.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $493a15c399719ace$export$c9c4cc54e73b125d))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $bba7dc78ee4d9c2c$export$fd3d00026297c0ad))) return;
                const target = $113ae95216fc18eb$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    target: // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, $bba7dc78ee4d9c2c$export$fd3d00026297c0ad)),
                    HTML: event.dataTransfer.getData((0, $dad283f7a54162bf$export$338a9f6c7a1f02b0))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $113ae95216fc18eb$var$honeyPotFix.getOnPostDispatch()
});
function $113ae95216fc18eb$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $113ae95216fc18eb$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $113ae95216fc18eb$var$adapter.registerUsage();
})();
function $113ae95216fc18eb$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $113ae95216fc18eb$var$adapter.monitor(args);
}

});
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $dad283f7a54162bf$export$338a9f6c7a1f02b0 = 'text/html';



parcelRegister("hsOaS", function(module, exports) {

var $7RrTx = parcelRequire("7RrTx");
var $cb6bf8ca0d18f57d$var$listeningFocusTrap = null;
function $cb6bf8ca0d18f57d$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $cb6bf8ca0d18f57d$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($cb6bf8ca0d18f57d$var$listeningFocusTrap) $cb6bf8ca0d18f57d$var$listeningFocusTrap.pause();
        $cb6bf8ca0d18f57d$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $cb6bf8ca0d18f57d$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $cb6bf8ca0d18f57d$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $cb6bf8ca0d18f57d$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $cb6bf8ca0d18f57d$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $cb6bf8ca0d18f57d$var$tryFocus(lastTabbableNode);
            return $cb6bf8ca0d18f57d$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $cb6bf8ca0d18f57d$var$tryFocus(firstTabbableNode);
        $cb6bf8ca0d18f57d$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $7RrTx(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $cb6bf8ca0d18f57d$var$tryFocus(lastTabbableNode);
        $cb6bf8ca0d18f57d$var$tryFocus(firstTabbableNode);
    }
}
function $cb6bf8ca0d18f57d$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $cb6bf8ca0d18f57d$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $cb6bf8ca0d18f57d$var$focusTrap;

});
parcelRegister("7RrTx", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $5b931efcb469bd37$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $5b931efcb469bd37$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});


parcelRegister("6iNO1", function(module, exports) {
$parcel$export(module.exports, "default", () => $496b0ef011dc6fd5$export$2e2bcd8739ae039);

var $6sZcd = parcelRequire("6sZcd");
function $496b0ef011dc6fd5$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $496b0ef011dc6fd5$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $496b0ef011dc6fd5$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($496b0ef011dc6fd5$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $496b0ef011dc6fd5$var$scrollIntoView(target, options) {
    var targetIsDetached = !target.ownerDocument.documentElement.contains(target);
    if ($496b0ef011dc6fd5$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(targetIsDetached ? [] : (0, $6sZcd.default)(target, options));
    if (targetIsDetached) return;
    var computeOptions = $496b0ef011dc6fd5$var$getOptions(options);
    return $496b0ef011dc6fd5$var$defaultBehavior((0, $6sZcd.default)(target, computeOptions), computeOptions.behavior);
}
var $496b0ef011dc6fd5$export$2e2bcd8739ae039 = $496b0ef011dc6fd5$var$scrollIntoView;

});
parcelRegister("6sZcd", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b54d3def4657696$export$2e2bcd8739ae039);
function $4b54d3def4657696$var$isElement(el) {
    return el != null && typeof el === 'object' && el.nodeType === 1;
}
function $4b54d3def4657696$var$canOverflow(overflow, skipOverflowHiddenElements) {
    if (skipOverflowHiddenElements && overflow === 'hidden') return false;
    return overflow !== 'visible' && overflow !== 'clip';
}
function $4b54d3def4657696$var$getFrameElement(el) {
    if (!el.ownerDocument || !el.ownerDocument.defaultView) return null;
    return el.ownerDocument.defaultView.frameElement;
}
function $4b54d3def4657696$var$isHiddenByFrame(el) {
    var frame = $4b54d3def4657696$var$getFrameElement(el);
    if (!frame) return false;
    return frame.clientHeight < el.scrollHeight || frame.clientWidth < el.scrollWidth;
}
function $4b54d3def4657696$var$isScrollable(el, skipOverflowHiddenElements) {
    if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
        var style = getComputedStyle(el, null);
        return $4b54d3def4657696$var$canOverflow(style.overflowY, skipOverflowHiddenElements) || $4b54d3def4657696$var$canOverflow(style.overflowX, skipOverflowHiddenElements) || $4b54d3def4657696$var$isHiddenByFrame(el);
    }
    return false;
}
function $4b54d3def4657696$var$alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
    if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) return 0;
    if (elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize || elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize) return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
    if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
    return 0;
}
var $4b54d3def4657696$export$2e2bcd8739ae039 = function(target, options) {
    var scrollMode = options.scrollMode, block = options.block, inline = options.inline, boundary = options.boundary, skipOverflowHiddenElements = options.skipOverflowHiddenElements;
    var checkBoundary = typeof boundary === 'function' ? boundary : function(node) {
        return node !== boundary;
    };
    if (!$4b54d3def4657696$var$isElement(target)) throw new TypeError('Invalid target');
    var scrollingElement = document.scrollingElement || document.documentElement;
    var frames = [];
    var cursor = target;
    while($4b54d3def4657696$var$isElement(cursor) && checkBoundary(cursor)){
        cursor = cursor.parentNode;
        if (cursor === scrollingElement) {
            frames.push(cursor);
            break;
        }
        if (cursor === document.body && $4b54d3def4657696$var$isScrollable(cursor) && !$4b54d3def4657696$var$isScrollable(document.documentElement)) continue;
        if ($4b54d3def4657696$var$isScrollable(cursor, skipOverflowHiddenElements)) frames.push(cursor);
    }
    var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
    var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
    var viewportX = window.scrollX || pageXOffset;
    var viewportY = window.scrollY || pageYOffset;
    var _target$getBoundingCl = target.getBoundingClientRect(), targetHeight = _target$getBoundingCl.height, targetWidth = _target$getBoundingCl.width, targetTop = _target$getBoundingCl.top, targetRight = _target$getBoundingCl.right, targetBottom = _target$getBoundingCl.bottom, targetLeft = _target$getBoundingCl.left;
    var targetBlock = block === 'start' || block === 'nearest' ? targetTop : block === 'end' ? targetBottom : targetTop + targetHeight / 2;
    var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft;
    var computations = [];
    for(var index = 0; index < frames.length; index++){
        var frame = frames[index];
        var _frame$getBoundingCli = frame.getBoundingClientRect(), height = _frame$getBoundingCli.height, width = _frame$getBoundingCli.width, top = _frame$getBoundingCli.top, right = _frame$getBoundingCli.right, bottom = _frame$getBoundingCli.bottom, left = _frame$getBoundingCli.left;
        if (scrollMode === 'if-needed' && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= top && targetBottom <= bottom && targetLeft >= left && targetRight <= right) return computations;
        var frameStyle = getComputedStyle(frame);
        var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
        var borderTop = parseInt(frameStyle.borderTopWidth, 10);
        var borderRight = parseInt(frameStyle.borderRightWidth, 10);
        var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
        var blockScroll = 0;
        var inlineScroll = 0;
        var scrollbarWidth = 'offsetWidth' in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
        var scrollbarHeight = 'offsetHeight' in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;
        if (scrollingElement === frame) {
            if (block === 'start') blockScroll = targetBlock;
            else if (block === 'end') blockScroll = targetBlock - viewportHeight;
            else if (block === 'nearest') blockScroll = $4b54d3def4657696$var$alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - viewportHeight / 2;
            if (inline === 'start') inlineScroll = targetInline;
            else if (inline === 'center') inlineScroll = targetInline - viewportWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - viewportWidth;
            else inlineScroll = $4b54d3def4657696$var$alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
            blockScroll = Math.max(0, blockScroll + viewportY);
            inlineScroll = Math.max(0, inlineScroll + viewportX);
        } else {
            if (block === 'start') blockScroll = targetBlock - top - borderTop;
            else if (block === 'end') blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
            else if (block === 'nearest') blockScroll = $4b54d3def4657696$var$alignNearest(top, bottom, height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - (top + height / 2) + scrollbarHeight / 2;
            if (inline === 'start') inlineScroll = targetInline - left - borderLeft;
            else if (inline === 'center') inlineScroll = targetInline - (left + width / 2) + scrollbarWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - right + borderRight + scrollbarWidth;
            else inlineScroll = $4b54d3def4657696$var$alignNearest(left, right, width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
            var scrollLeft = frame.scrollLeft, scrollTop = frame.scrollTop;
            blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - height + scrollbarHeight));
            inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - width + scrollbarWidth));
            targetBlock += scrollTop - blockScroll;
            targetInline += scrollLeft - inlineScroll;
        }
        computations.push({
            el: frame,
            top: blockScroll,
            left: inlineScroll
        });
    }
    return computations;
};

});


parcelRegister("4C2iR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $BngbP = parcelRequire("BngbP");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $35bc7f617de21e51$var$_interopRequireDefault($BngbP).default;
    }
});
function $35bc7f617de21e51$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("BngbP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $07057fcadbdac059$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");
function $07057fcadbdac059$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $07057fcadbdac059$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $07057fcadbdac059$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $07057fcadbdac059$var$NodeResolver = function(_Component) {
    $07057fcadbdac059$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $07057fcadbdac059$var$_classCallCheck(this, NodeResolver);
        return $07057fcadbdac059$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $07057fcadbdac059$var$_createClass(NodeResolver, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.innerRef((0, $85XPu.findDOMNode)(this));
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($euxye.Component);
module.exports.default = $07057fcadbdac059$var$NodeResolver;

});


parcelRegister("4KFYC", function(module, exports) {
$parcel$export(module.exports, "PendoChoreographerPlugin", () => $ea1ff1c042dfc223$export$3390a677f4025523);

var $kNBjd = parcelRequire("kNBjd");

var $blN8U = parcelRequire("blN8U");
class $ea1ff1c042dfc223$export$3390a677f4025523 extends (0, $blN8U.ChoreographerPlugin) {
    constructor(envType, metaMetricsData = {}){
        super((0, $kNBjd.ProductIds).PENDO, envType, metaMetricsData), this.currentMessageId = '', this.getPendoConfig = (pendoConfig)=>{
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const pendoPlugin = this;
            return {
                ...pendoConfig,
                guides: {
                    ...pendoConfig.guides ?? {},
                    globalScripts: [
                        ...pendoConfig.guides?.globalScripts ?? [],
                        {
                            beforeMount (evnt) {
                                if (pendoPlugin.state.isDisabled) evnt.cancel = true;
                                else {
                                    pendoPlugin.currentMessageId = evnt.step.id;
                                    pendoPlugin.on(pendoPlugin.currentMessageId, {});
                                    pendoPlugin.startMessage(pendoPlugin.currentMessageId);
                                }
                            },
                            unmounted () {
                                pendoPlugin.stopMessage(pendoPlugin.currentMessageId);
                            }
                        }
                    ]
                }
            };
        };
    }
    isDisplayingMessage() {
        return Boolean(window.pendo?.getActiveGuide?.());
    }
}

});

parcelRegister("8w7Yz", function(module, exports) {
$parcel$export(module.exports, "default", () => $63377fb841d23943$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $63377fb841d23943$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("8DG7p", function(module, exports) {
$parcel$export(module.exports, "UFOThirdPartySegment", () => $b009551935e38d60$export$5f6fe75c46d0124e);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4FR7Y = parcelRequire("4FR7Y");

var $qqoKJ = parcelRequire("qqoKJ");

var $siTdT = parcelRequire("siTdT");

var $d7jXQ = parcelRequire("d7jXQ");

var $6Ah7H = parcelRequire("6Ah7H");

var $hC0jO = parcelRequire("hC0jO");

var $5wc6o = parcelRequire("5wc6o");
const $b009551935e38d60$var$FORGE_TTAI_EVENT_PREFIX = 'ufo-forge';
// Early-signal event emitted by the iframe bridge as soon as it wires up its
// UFO observers. Receiving this within ABORT_TIMEOUT_INITIAL_MS tells us the
// iframe is on the new rollout cohort and will send data events.
const $b009551935e38d60$var$FORGE_INIT_EVENT = 'ufo-forge-init';
// Grace period (ms) after the navigation hold releases before finalising.
const $b009551935e38d60$var$GRACE_PERIOD_MS = 2000;
// Initial abort timeout (ms from mount). If no recognised iframe event arrives within
// this window, the hold is force-released and an abort marker is logged. This protects
// metric quality during progressive rollouts where old-cohort iframes never emit events.
const $b009551935e38d60$var$ABORT_TIMEOUT_INITIAL_MS = 6000;
// Per-segment cap on the number of `resized` entries forwarded to addIframeSegmentData.
// useResizeAnalytics already limits emissions to a 10s tracking window, but a chatty
// app could still produce dozens of resizes; combined with many Forge apps on one
// page this could push segment3pData toward the 60 KB soft limit. The cap provides
// defence-in-depth without affecting realistic apps (typical <20 resizes per segment).
const $b009551935e38d60$var$MAX_RESIZED_ENTRIES_PER_SEGMENT = 50;
// Extended abort timeout (ms from mount). Once any recognised iframe event is received
// we know the iframe is on the new rollout cohort and actively sending data, so we extend
// the window to accommodate legitimately slow-loading Forge apps.
const $b009551935e38d60$var$ABORT_TIMEOUT_EXTENDED_MS = 30000;
// Events logged via addIframeSegmentData as they arrive.
const $b009551935e38d60$var$IFRAME_SEGMENT_DATA_SUFFIXES = [
    'resource-timing',
    'paint-timing',
    'largest-contentful-paint',
    'layout-shift',
    'dom-mutations',
    'navigation-timing'
];
// Events that extend the forge-ui-requests corrected end-time during grace.
const $b009551935e38d60$var$NAV_HOLD_GRACE_SUFFIXES = new Set([
    'navigation-timing',
    'resource-timing'
]);
/** Reads segmentId from UFOInteractionContext and stores it in a ref. */ function $b009551935e38d60$var$IframeSegmentIdReader({ segmentIdRef: segmentIdRef }) {
    const context = (0, $euxye.useContext)((0, $4FR7Y.default));
    const labelStack = context?.labelStack;
    const segmentId = labelStack && labelStack.length > 0 ? labelStack[labelStack.length - 1].segmentId : undefined;
    if (segmentId && segmentIdRef.current !== segmentId) segmentIdRef.current = segmentId;
    return null;
}
$b009551935e38d60$var$IframeSegmentIdReader.displayName = "IframeSegmentIdReader";
/** Subscribes to iframe performance events and records them as segment3pTimings. */ function $b009551935e38d60$var$IframeSegment({ onRegisterIframeEventListener: onRegisterIframeEventListener, appType: appType }) {
    const interactionId = (0, $euxye.useContext)((0, $qqoKJ.default));
    const interactionContext = (0, $euxye.useContext)((0, $4FR7Y.default));
    const segmentIdRef = (0, $euxye.useRef)(undefined);
    // Per-segment counter for `resized` entries (defence-in-depth payload cap).
    // Tracks both the count AND the segmentId it was last incremented under, so
    // SPA navigations that swap segmentId reset the budget for the new segment.
    const resizedCountRef = (0, $euxye.useRef)(0);
    const resizedCounterSegmentIdRef = (0, $euxye.useRef)(undefined);
    const isUiKit = appType === 'UIKit';
    // Released on the first navigation-timing event from the iframe.
    const [navigationHold, setNavigationHold] = (0, $euxye.useState)('holding');
    // UIKit: wrap onRender to account for React Profiler timings
    // Accumulates profiler timing bounds so we emit one aggregated entry at cleanup.
    const profilerAccRef = (0, $euxye.useRef)(null);
    (0, $euxye.useLayoutEffect)(()=>{
        if (!isUiKit || !interactionContext || !interactionContext.onRender) return;
        const originalOnRender = interactionContext.onRender.bind(interactionContext);
        interactionContext.onRender = function(phase, actualDuration, baseDuration, startTime, commitTime) {
            originalOnRender(phase, actualDuration, baseDuration, startTime, commitTime);
            // Accumulate timing bounds into a single entry.
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            if (profilerAccRef.current === null) profilerAccRef.current = {
                startTime: start,
                endTime: end
            };
            else {
                if (start < profilerAccRef.current.startTime) profilerAccRef.current.startTime = start;
                if (end > profilerAccRef.current.endTime) profilerAccRef.current.endTime = end;
            }
        };
        return ()=>{
            interactionContext.onRender = originalOnRender;
        };
    }, [
        isUiKit,
        interactionContext,
        interactionId
    ]);
    (0, $euxye.useEffect)(()=>{
        let navigationHoldReleased = false;
        let lastNavEventTime = null;
        let gracePeriodTimer = null;
        // Tracks whether any recognised iframe event has been received, which tells us
        // the iframe is on the new rollout cohort and actively sending data.
        let iframeEventsReceived = false;
        let abortTimer;
        const mountTime = performance.now();
        const fireAbort = (abortAfterMs)=>{
            // Cancel any pending grace period so it doesn't also fire.
            if (gracePeriodTimer !== null) {
                clearTimeout(gracePeriodTimer);
                gracePeriodTimer = null;
            }
            // Force-release the hold if still active at abort time.
            if (!navigationHoldReleased) {
                navigationHoldReleased = true;
                setNavigationHold('released');
            }
            // Record the abort marker so downstream analytics can detect it.
            if (interactionId.current && segmentIdRef.current) (0, $siTdT.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                label: 'segment-timing-abort',
                data: {
                    reason: 'timeout',
                    abortAfterMs: abortAfterMs
                }
            });
        };
        // Start with the short initial timeout. If no ufo-forge-init signal arrives
        // within this window, the iframe is likely an old-cohort app that will never
        // send events — abort early to avoid blocking the interaction indefinitely.
        abortTimer = setTimeout(()=>{
            if (!iframeEventsReceived) fireAbort($b009551935e38d60$var$ABORT_TIMEOUT_INITIAL_MS);
        }, $b009551935e38d60$var$ABORT_TIMEOUT_INITIAL_MS);
        const finaliseHolds = ()=>{
            const iid = interactionId.current;
            const lStack = interactionContext?.labelStack;
            if (iid && lStack) {
                if (lastNavEventTime !== null) (0, $siTdT.addCompletedHold)(iid, lStack, 'forge-ui-requests', mountTime, lastNavEventTime);
            }
        };
        const scheduleGracePeriodExpiry = ()=>{
            // Reset the 2s countdown each time a new event arrives during the grace period.
            if (gracePeriodTimer !== null) clearTimeout(gracePeriodTimer);
            gracePeriodTimer = setTimeout(()=>{
                clearTimeout(abortTimer);
                finaliseHolds();
            }, $b009551935e38d60$var$GRACE_PERIOD_MS);
        };
        const maybeStartGracePeriod = ()=>{
            if (navigationHoldReleased && gracePeriodTimer === null) scheduleGracePeriodExpiry();
        };
        const handleEvent = (event)=>{
            // Host-side `resized` events come from useResizeAnalytics (forge-ui).
            // They are emitted whenever the iframe container height changes during
            // the 10s tracking window after mount. We forward only the reliable
            // fields (height, elapsed). The `measuredHeight` and `viewportHeight`
            // fields are intentionally excluded because they require a vendor
            // config that is rarely populated in practice (almost always null).
            if (event.type === 'resized') {
                // Guard against malformed payloads (height is required and must be
                // a non-negative number; useResizeAnalytics emits Math.trunc'd ints).
                // `IframeSegmentEvent` already declares `[key: string]: unknown`, so
                // no `as` cast is needed — the typeof guards handle runtime safety.
                const { height: height, elapsed: elapsed } = event;
                // Reset the per-segment counter when the active segmentId changes
                // (SPA navigations swap segments; each gets a fresh budget).
                if (segmentIdRef.current && segmentIdRef.current !== resizedCounterSegmentIdRef.current) {
                    resizedCountRef.current = 0;
                    resizedCounterSegmentIdRef.current = segmentIdRef.current;
                }
                if (typeof height === 'number' && Number.isFinite(height) && height >= 0 && typeof elapsed === 'number' && Number.isFinite(elapsed) && elapsed >= 0 && resizedCountRef.current < $b009551935e38d60$var$MAX_RESIZED_ENTRIES_PER_SEGMENT && interactionId.current && segmentIdRef.current) {
                    resizedCountRef.current += 1;
                    (0, $siTdT.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                        label: 'resized',
                        data: {
                            height: height,
                            elapsed: elapsed
                        }
                    });
                }
                // NOTE: we deliberately do NOT set iframeEventsReceived = true here.
                // The 6s abort timer exists to detect old-cohort iframes that won't
                // emit bridge events. `resized` is a host-side signal (forge-ui's
                // ResizeObserver) and fires regardless of which bridge version the
                // iframe is serving, so it cannot confirm new-cohort membership.
                // Only bridge-emitted `ufo-forge-*` events (esp. `ufo-forge-init`)
                // are valid proof, and they extend the abort timeout below.
                return;
            }
            if (event.type !== 'ufo-event' || typeof event.name !== 'string' || !event.name.startsWith($b009551935e38d60$var$FORGE_TTAI_EVENT_PREFIX)) return;
            const eventName = event.name;
            const suffix = $b009551935e38d60$var$IFRAME_SEGMENT_DATA_SUFFIXES.find((s)=>eventName.endsWith(`-${s}`));
            if (suffix && interactionId.current && segmentIdRef.current) {
                const { type: type, ...rest } = event;
                const restData = rest;
                let data;
                if (suffix === 'resource-timing') data = (0, $6Ah7H.shapeResourceTimingData)(restData);
                else if (suffix === 'navigation-timing') data = (0, $6Ah7H.shapeNavigationTimingData)(restData);
                else if (suffix === 'paint-timing') data = (0, $5wc6o.shapePaintTimingData)(restData);
                else if (suffix === 'largest-contentful-paint') data = (0, $5wc6o.shapeLargestContentfulPaintData)(restData);
                else if (suffix === 'layout-shift') data = (0, $5wc6o.shapeLayoutShiftData)(restData);
                else if (suffix === 'dom-mutations') {
                    // Skip intermediate batches — only record the final summary batch.
                    if (!(0, $5wc6o.isDomMutationsFinalBatch)(restData)) return;
                    data = (0, $5wc6o.shapeDomMutationsData)(restData);
                } else data = restData;
                if (data !== undefined) (0, $siTdT.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                    label: suffix,
                    data: data
                });
            }
            // ufo-forge-init confirms the iframe is on the new rollout cohort — extend the abort window.
            if (eventName === $b009551935e38d60$var$FORGE_INIT_EVENT && !iframeEventsReceived) {
                iframeEventsReceived = true;
                clearTimeout(abortTimer);
                const remainingMs = Math.max($b009551935e38d60$var$ABORT_TIMEOUT_EXTENDED_MS - (performance.now() - mountTime), 0);
                abortTimer = setTimeout(()=>{
                    fireAbort($b009551935e38d60$var$ABORT_TIMEOUT_EXTENDED_MS);
                }, remainingMs);
            }
            if (eventName.endsWith('-navigation-timing') && !navigationHoldReleased) {
                navigationHoldReleased = true;
                setNavigationHold('released');
                maybeStartGracePeriod();
            }
            if (navigationHoldReleased) {
                const now = performance.now();
                if (suffix && $b009551935e38d60$var$NAV_HOLD_GRACE_SUFFIXES.has(suffix)) {
                    lastNavEventTime = now;
                    scheduleGracePeriodExpiry();
                }
            }
        };
        const unregister = onRegisterIframeEventListener(handleEvent);
        // Emit react-profiler-timing for UI kit
        const activeInteraction = (0, $siTdT.getActiveInteraction)();
        let isUnmounted = false;
        if (activeInteraction) activeInteraction.cleanupCallbacks.push(()=>{
            if (isUnmounted) return;
            const iid = interactionId.current;
            const sid = segmentIdRef.current;
            if (iid && sid && profilerAccRef.current !== null) {
                (0, $siTdT.addIframeSegmentData)(iid, sid, {
                    label: 'react-profiler-timing',
                    data: {
                        ...profilerAccRef.current
                    }
                });
                profilerAccRef.current = null;
            }
        });
        return ()=>{
            isUnmounted = true;
            unregister();
            clearTimeout(abortTimer);
            if (gracePeriodTimer !== null) clearTimeout(gracePeriodTimer);
        };
    }, [
        onRegisterIframeEventListener,
        interactionId,
        interactionContext
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $d7jXQ.default), {
                name: "forge-ui-requests",
                hold: navigationHold === 'holding'
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)($b009551935e38d60$var$IframeSegmentIdReader, {
                segmentIdRef: segmentIdRef
            })
        ]
    });
}
$b009551935e38d60$var$IframeSegment.displayName = "IframeSegment";
/** Writes per-segment extraData via addSegmentExtraData. */ function $b009551935e38d60$var$SegmentExtraDataWriter({ extraData: extraData }) {
    const interactionContext = (0, $euxye.useContext)((0, $4FR7Y.default));
    const interactionId = (0, $euxye.useContext)((0, $qqoKJ.default));
    const labelStack = interactionContext?.labelStack;
    const segmentId = labelStack && labelStack.length > 0 ? labelStack[labelStack.length - 1].segmentId : undefined;
    (0, $euxye.useEffect)(()=>{
        const currentInteractionId = interactionId.current;
        if (segmentId && currentInteractionId) (0, $siTdT.addSegmentExtraData)(currentInteractionId, segmentId, extraData);
    }, [
        extraData,
        segmentId,
        interactionId
    ]);
    return null;
}
$b009551935e38d60$var$SegmentExtraDataWriter.displayName = "SegmentExtraDataWriter";
const $b009551935e38d60$export$5f6fe75c46d0124e = (props)=>{
    const { children: children, onRegisterIframeEventListener: onRegisterIframeEventListener, extraData: extraData, ...otherProps } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $hC0jO.default), {
        type: "third-party",
        ...otherProps,
        children: [
            onRegisterIframeEventListener && extraData && /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)($b009551935e38d60$var$IframeSegment, {
                        onRegisterIframeEventListener: onRegisterIframeEventListener,
                        appType: extraData.appType
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)($b009551935e38d60$var$SegmentExtraDataWriter, {
                        extraData: extraData
                    })
                ]
            }),
            children
        ]
    });
};
$b009551935e38d60$export$5f6fe75c46d0124e.displayName = "UFOThirdPartySegment";
$b009551935e38d60$export$5f6fe75c46d0124e.displayName = 'UFOThirdPartySegment';

});
parcelRegister("d7jXQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0aada2cca328534d$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $gmMRH = parcelRequire("gmMRH");

var $4FR7Y = parcelRequire("4FR7Y");

var $qqoKJ = parcelRequire("qqoKJ");
const $0aada2cca328534d$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $euxye.useEffect) : (0, $euxye.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $0aada2cca328534d$var$useInteractionIdValue() {
    const interactionId = (0, $euxye.useContext)((0, $qqoKJ.default));
    const [currentId, setCurrentId] = (0, $euxye.useState)(interactionId?.current || null);
    $0aada2cca328534d$var$useLayoutEffectSAFE(()=>{
        setCurrentId(interactionId?.current || null);
        const unsubscribe = (0, $qqoKJ.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $0aada2cca328534d$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true }) {
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $gmMRH.isUFOEnabled)();
    const currentInteractionId = $0aada2cca328534d$var$useInteractionIdValue();
    // react-18: useId instead
    const context = (0, $euxye.useContext)((0, $4FR7Y.default));
    $0aada2cca328534d$var$useLayoutEffectSAFE(()=>{
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) return context.hold(name);
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    }) : null;
}
$0aada2cca328534d$export$2e2bcd8739ae039.displayName = "UFOLoadHold";

});

parcelRegister("6Ah7H", function(module, exports) {
$parcel$export(module.exports, "shapeNavigationTimingData", () => $d585d19ee8b63c17$export$545c2c69328f5019);
$parcel$export(module.exports, "shapeResourceTimingData", () => $d585d19ee8b63c17$export$58bcddf582fad063);

var $egspI = parcelRequire("egspI");

var $fJjLT = parcelRequire("fJjLT");

var $bhsUE = parcelRequire("bhsUE");
const $d585d19ee8b63c17$var$num = (v)=>typeof v === 'number' ? Math.round(v) : 0;
// Accepted source values from forge-cdn bridge:
//   - 'forge-framework' (PR #775+) — Forge runtime assets (bridge.js, iframeResizer*, etc.)
//   - 'forge-app'       (PR #775+) — app-author assets on installation-scoped subdomain
//   - 'external'        (both schemes) — anything outside Atlassian-controlled domains
//   - 'internal'        (PR #769 only, LEGACY) — bridges still emit this until PR #775
//                       rolls out everywhere; safe to remove from this allowlist after
//                       the rollout has been stable for a release cycle. Do NOT remove
//                       'external' during that cleanup — it's a first-class value in
//                       both the old and new schemes.
const $d585d19ee8b63c17$var$ACCEPTED_SOURCES = [
    'forge-framework',
    'forge-app',
    'external',
    'internal'
];
const $d585d19ee8b63c17$var$ASSET_RESOURCE_TYPES = new Set([
    'script',
    'link',
    'css'
]);
const $d585d19ee8b63c17$var$OTHER_JS_RESOURCE_TYPE = 'other';
const $d585d19ee8b63c17$var$SCRIPT_EXTENSIONS = [
    '.js',
    '.mjs',
    '.cjs'
];
const $d585d19ee8b63c17$var$STYLESHEET_EXTENSIONS = [
    '.css'
];
const $d585d19ee8b63c17$var$ASSET_EXTENSIONS = [
    ...$d585d19ee8b63c17$var$SCRIPT_EXTENSIONS,
    ...$d585d19ee8b63c17$var$STYLESHEET_EXTENSIONS
];
const $d585d19ee8b63c17$var$FILE_OR_MEDIA_EXTENSIONS = [
    '.pdf',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.ppt',
    '.pptx',
    '.csv',
    '.zip',
    '.heic',
    '.mov',
    '.mp4',
    '.mp3',
    '.wav',
    '.woff',
    '.woff2',
    '.ttf',
    '.otf'
];
const $d585d19ee8b63c17$var$IMAGE_EXTENSIONS = [
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.webp',
    '.svg',
    '.ico'
];
const $d585d19ee8b63c17$var$IMAGE_RESOURCE_LABEL = '<image-resource>';
const $d585d19ee8b63c17$var$FILE_RESOURCE_LABEL = '<file-resource>';
const $d585d19ee8b63c17$var$AVATAR_RESOURCE_LABEL = '<avatar-resource>';
const $d585d19ee8b63c17$var$ATTACHMENT_OR_DOWNLOAD_PATH_PATTERNS = [
    /(?:^|\/)secure\/attachment(?:\/|$)/,
    /(?:^|\/)download\/attachments(?:\/|$)/,
    /(?:^|\/)wiki\/download(?:\/|$)/,
    /(?:^|\/)child\/attachment(?:\/|$)/,
    /(?:^|\/)attachment(?:\/|$)/
];
function $d585d19ee8b63c17$var$stripQueryAndHash(value) {
    return value.split(/[?#]/, 1)[0] ?? '';
}
function $d585d19ee8b63c17$var$getLegacyLastPathSegment(value) {
    return value.includes('/') ? value.split('/').filter(Boolean).pop() ?? value : value;
}
function $d585d19ee8b63c17$var$getSanitizedLastPathSegment(value) {
    const trimmedValue = $d585d19ee8b63c17$var$stripQueryAndHash(value).replace(/\/+$/, '');
    if (!trimmedValue.includes('/')) return trimmedValue;
    return trimmedValue.split('/').filter(Boolean).pop() ?? trimmedValue;
}
function $d585d19ee8b63c17$var$hasExtension(value, extensions) {
    const path = $d585d19ee8b63c17$var$stripQueryAndHash(value).toLowerCase();
    return extensions.some((extension)=>path.endsWith(extension));
}
function $d585d19ee8b63c17$var$hasAttachmentOrDownloadPath(value) {
    return $d585d19ee8b63c17$var$ATTACHMENT_OR_DOWNLOAD_PATH_PATTERNS.some((pattern)=>pattern.test(value));
}
function $d585d19ee8b63c17$var$isAvatarResource(value) {
    return value.includes('avatar-management') || value.includes('/initials/') || value.includes('%2finitials%2f') || value.includes('viewavatar');
}
function $d585d19ee8b63c17$var$getSanitizedBackendResourceLabel(rawName) {
    const querylessName = $d585d19ee8b63c17$var$stripQueryAndHash(rawName);
    const normalizedRawName = rawName.toLowerCase();
    const normalizedQuerylessName = querylessName.toLowerCase();
    if ($d585d19ee8b63c17$var$isAvatarResource(normalizedRawName)) return $d585d19ee8b63c17$var$AVATAR_RESOURCE_LABEL;
    if ($d585d19ee8b63c17$var$hasExtension(normalizedQuerylessName, $d585d19ee8b63c17$var$IMAGE_EXTENSIONS)) return $d585d19ee8b63c17$var$IMAGE_RESOURCE_LABEL;
    if ($d585d19ee8b63c17$var$hasAttachmentOrDownloadPath(normalizedQuerylessName) || $d585d19ee8b63c17$var$hasExtension(normalizedQuerylessName, $d585d19ee8b63c17$var$FILE_OR_MEDIA_EXTENSIONS)) return $d585d19ee8b63c17$var$FILE_RESOURCE_LABEL;
    return querylessName;
}
function $d585d19ee8b63c17$var$isBackendResourceTiming(initiatorType) {
    return (0, $fJjLT.BACKEND_RESOURCE_TIMING_INITIATOR_TYPES).has(initiatorType);
}
function $d585d19ee8b63c17$var$isScriptOrStylesheetResource(rawName, initiatorType) {
    if (initiatorType === $d585d19ee8b63c17$var$OTHER_JS_RESOURCE_TYPE) return $d585d19ee8b63c17$var$hasExtension(rawName, $d585d19ee8b63c17$var$ASSET_EXTENSIONS);
    if (!$d585d19ee8b63c17$var$ASSET_RESOURCE_TYPES.has(initiatorType)) return false;
    return $d585d19ee8b63c17$var$hasExtension(rawName, $d585d19ee8b63c17$var$ASSET_EXTENSIONS);
}
function $d585d19ee8b63c17$export$545c2c69328f5019(data) {
    const payload = data?.payload || {};
    // payload.timing.* to payload.* directly. Support both shapes during rollout.
    const timing = payload?.timing || payload;
    // Trim long URLs to just the last path segment to keep payload size manageable.
    const rawName = typeof payload.name === 'string' ? payload.name : '';
    const label = rawName.includes('/') ? rawName.split('/').filter(Boolean).pop() ?? rawName : rawName;
    return {
        label: label,
        // From Resource Timing spec
        redirectStart: $d585d19ee8b63c17$var$num(timing.redirectStart),
        redirectEnd: $d585d19ee8b63c17$var$num(timing.redirectEnd),
        fetchStart: $d585d19ee8b63c17$var$num(timing.fetchStart),
        domainLookupStart: $d585d19ee8b63c17$var$num(timing.domainLookupStart),
        domainLookupEnd: $d585d19ee8b63c17$var$num(timing.domainLookupEnd),
        connectStart: $d585d19ee8b63c17$var$num(timing.connectStart),
        connectEnd: $d585d19ee8b63c17$var$num(timing.connectEnd),
        secureConnectionStart: $d585d19ee8b63c17$var$num(timing.secureConnectionStart),
        requestStart: $d585d19ee8b63c17$var$num(timing.requestStart),
        responseStart: $d585d19ee8b63c17$var$num(timing.responseStart),
        responseEnd: $d585d19ee8b63c17$var$num(timing.responseEnd),
        // Added in PR #769 — present in new flat shape, absent in old nested shape (defaults to 0)
        encodedBodySize: $d585d19ee8b63c17$var$num(timing.encodedBodySize),
        decodedBodySize: $d585d19ee8b63c17$var$num(timing.decodedBodySize),
        transferSize: $d585d19ee8b63c17$var$num(timing.transferSize),
        // From Navigation Timing 2 spec
        redirectCount: $d585d19ee8b63c17$var$num(payload.redirectCount),
        type: typeof payload.type === 'string' ? payload.type : undefined,
        unloadEventStart: $d585d19ee8b63c17$var$num(timing.unloadEventStart),
        unloadEventEnd: $d585d19ee8b63c17$var$num(timing.unloadEventEnd),
        workerStart: $d585d19ee8b63c17$var$num(timing.workerStart),
        nextHopProtocol: typeof timing.nextHopProtocol === 'string' ? timing.nextHopProtocol : undefined
    };
}
function $d585d19ee8b63c17$export$58bcddf582fad063(data) {
    const payload = data?.payload || {};
    // payload.timing.* to payload.* directly. Support both shapes during rollout.
    const timing = payload?.timing || payload;
    const rawName = typeof payload.name === 'string' ? payload.name : '';
    const initiatorType = typeof payload.initiatorType === 'string' ? payload.initiatorType : 'other';
    const isFilteredModeEnabled = (0, $egspI.fg)('platform_ufo_3p_segment_timings');
    const isBackendTiming = $d585d19ee8b63c17$var$isBackendResourceTiming(initiatorType);
    if (isFilteredModeEnabled && !isBackendTiming && !$d585d19ee8b63c17$var$isScriptOrStylesheetResource(rawName, initiatorType)) return undefined;
    const name = isFilteredModeEnabled ? isBackendTiming ? $d585d19ee8b63c17$var$getSanitizedBackendResourceLabel(rawName) : $d585d19ee8b63c17$var$getSanitizedLastPathSegment(rawName) : $d585d19ee8b63c17$var$getLegacyLastPathSegment(rawName);
    const startTime = $d585d19ee8b63c17$var$num(payload.startTime);
    const duration = $d585d19ee8b63c17$var$num(payload.duration);
    const fetchStart = $d585d19ee8b63c17$var$num(timing.fetchStart);
    const workerStart = $d585d19ee8b63c17$var$num(timing.workerStart);
    const responseStart = $d585d19ee8b63c17$var$num(timing.responseStart);
    const requestStart = $d585d19ee8b63c17$var$num(timing.requestStart);
    const transferSize = typeof payload.transferSize === 'number' ? payload.transferSize : undefined;
    const encodedSize = typeof payload.encodedBodySize === 'number' ? payload.encodedBodySize : undefined;
    const decodedSize = typeof payload.decodedBodySize === 'number' ? payload.decodedBodySize : undefined;
    // serverTime / networkTime are not in the current iframe payload but kept for forward-compat
    const serverTime = typeof payload.serverTime === 'number' ? payload.serverTime : undefined;
    const networkTime = typeof payload.networkTime === 'number' ? payload.networkTime : undefined;
    const source = $d585d19ee8b63c17$var$ACCEPTED_SOURCES.includes(payload.source) ? payload.source : undefined;
    // Base fields — always present (times are relative to interaction start from the iframe)
    const shaped = {
        label: name,
        startTime: startTime,
        duration: duration,
        workerStart: Math.max(workerStart, 0),
        fetchStart: Math.max(fetchStart, 0),
        type: initiatorType,
        ...source !== undefined ? {
            source: source
        } : {}
    };
    const cacheable = (0, $bhsUE.isCacheableType)(rawName, initiatorType);
    shaped.ttfb = responseStart;
    if (serverTime !== undefined) shaped.serverTime = serverTime;
    if (networkTime !== undefined) shaped.networkTime = networkTime;
    if (transferSize !== undefined) shaped.size = transferSize;
    // Flag entries where timing-allow-origin headers are missing:
    // duration > 0 but all size fields are 0 means the browser withheld size data.
    if (duration > 0 && transferSize === 0 && encodedSize === 0) shaped.noTA = true;
    if (cacheable) {
        // CacheableResourceTiming — calculateTransferType is only meaningful for cacheable resources
        const transferType = (0, $bhsUE.calculateTransferType)(rawName, initiatorType, duration, transferSize);
        if (transferType !== null) shaped.transferType = transferType;
        if (encodedSize !== undefined) shaped.encodedSize = encodedSize;
        if (decodedSize !== undefined) shaped.decodedSize = decodedSize;
    } else // NonCacheableResourceTiming (fetch, xmlhttprequest, etc.)
    shaped.requestStart = requestStart;
    return shaped;
}

});
parcelRegister("bhsUE", function(module, exports) {
$parcel$export(module.exports, "isCacheableType", () => $e2756ba340ada086$export$86a03f39f85a653c);
$parcel$export(module.exports, "calculateTransferType", () => $e2756ba340ada086$export$82deef6698791e4e);
const $e2756ba340ada086$var$alwaysCacheableTypes = [
    'script',
    'link'
];
const $e2756ba340ada086$var$CACHE_NETWORK = 'network';
const $e2756ba340ada086$var$CACHE_MEMORY = 'memory';
const $e2756ba340ada086$var$CACHE_DISK = 'disk';
function $e2756ba340ada086$export$86a03f39f85a653c(url, type) {
    if ($e2756ba340ada086$var$alwaysCacheableTypes.includes(type)) return true;
    if (type === 'other' && url.includes('.js')) return true;
    return false;
}
function $e2756ba340ada086$export$82deef6698791e4e(name, type, duration, size) {
    if (!$e2756ba340ada086$export$86a03f39f85a653c(name, type)) return $e2756ba340ada086$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $e2756ba340ada086$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $e2756ba340ada086$var$CACHE_DISK;
    if (size === undefined) return null;
    return $e2756ba340ada086$var$CACHE_NETWORK;
}

});


parcelRegister("hC0jO", function(module, exports) {
$parcel$export(module.exports, "default", () => $85d10fc1c2bca434$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $g8xyD = parcelRequire("g8xyD");

var $7TA2J = parcelRequire("7TA2J");

var $erszr = parcelRequire("erszr");

var $gmMRH = parcelRequire("gmMRH");

var $3lb12 = parcelRequire("3lb12");

var $anDmR = parcelRequire("anDmR");

var $4FR7Y = parcelRequire("4FR7Y");

var $qqoKJ = parcelRequire("qqoKJ");

var $siTdT = parcelRequire("siTdT");

var $7VWGN = parcelRequire("7VWGN");

var $6nHyA = parcelRequire("6nHyA");

var $bZiPG = parcelRequire("bZiPG");

var $jokam = parcelRequire("jokam");
let $85d10fc1c2bca434$var$tryCompleteHandle;
let $85d10fc1c2bca434$var$hasMarkedFirstSegmentLoad = false;
/** A portion of the page we apply measurement to */ const $85d10fc1c2bca434$var$UFOSegment = ({ name: segmentName, children: children, mode: mode = 'single', type: type = 'first-party' })=>{
    // If UFO is disabled, render children without any tracking overhead
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $gmMRH.isUFOEnabled)();
    const parentContext = (0, $euxye.useContext)((0, $4FR7Y.default));
    const segmentIdMap = (0, $euxye.useMemo)(()=>{
        if (!parentContext?.segmentIdMap) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    const segmentId = (0, $euxye.useMemo)(()=>{
        if (mode === 'single') return (0, $6nHyA.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        const newSegmentId = (0, $6nHyA.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    const labelStack = (0, $euxye.useMemo)(()=>parentContext?.labelStack ? [
            ...parentContext.labelStack,
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            }
        ] : [
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            }
        ], [
        parentContext,
        segmentName,
        segmentId,
        type
    ]);
    const interactionId = (0, $euxye.useContext)((0, $qqoKJ.default));
    if (interactionId.current != null && !$85d10fc1c2bca434$var$hasMarkedFirstSegmentLoad) {
        (0, $siTdT.markFirstSegmentLoad)(interactionId.current, labelStack, performance.now());
        $85d10fc1c2bca434$var$hasMarkedFirstSegmentLoad = true;
    }
    const interactionContext = (0, $euxye.useMemo)(()=>{
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($85d10fc1c2bca434$var$tryCompleteHandle) cancelAnimationFrame?.($85d10fc1c2bca434$var$tryCompleteHandle);
                    const onComplete = ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            const isPageVisible = globalThis?.document?.visibilityState === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $85d10fc1c2bca434$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $85d10fc1c2bca434$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $siTdT.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $siTdT.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, $g8xyD.unstable_scheduleCallback)((0, $g8xyD.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $siTdT.addHold)(interactionId.current, labelStack, name, false);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $siTdT.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $siTdT.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                const minorInteractions = [
                    ...(0, $gmMRH.getDoNotAbortActivePressInteraction)() ?? [],
                    ...(0, $gmMRH.getMinorInteractions)() ?? []
                ];
                if (minorInteractions.includes(name)) {
                    const activeInteraction = (0, $siTdT.getActiveInteraction)();
                    activeInteraction?.minorInteractions?.push({
                        name: name,
                        startTime: timestamp ?? performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, $siTdT.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $gmMRH.getInteractionRate)(name, 'press');
                if ((0, $erszr.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    const newId = (0, $7TA2J.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $anDmR.setInteractionActiveTrace)(newId, 'press');
                    (0, $siTdT.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $7VWGN.default).current, (0, $anDmR.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $siTdT.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $siTdT.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $siTdT.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $siTdT.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $siTdT.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $siTdT.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $siTdT.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $siTdT.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $bZiPG.default)(()=>{
                        const paintedTime = performance.now();
                        this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    const hasMounted = (0, $euxye.useRef)(false);
    const onRender = (0, $euxye.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((0, $gmMRH.getConfig)()?.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $euxye.useEffect)(()=>{
        (0, $siTdT.addSegment)(labelStack);
        return ()=>{
            (0, $siTdT.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $euxye.useMemo)(()=>labelStack.map((l)=>(0, $3lb12.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    // If UFO is disabled, just render children without tracking overhead
    if (!ufoEnabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
    const ufoSegment = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4FR7Y.default).Provider, {
        value: interactionContext,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Profiler), {
            id: reactProfilerId,
            onRender: onRender,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jokam.default), {
        labelStack: labelStack,
        onRender: (...args)=>interactionContext.onRender.apply(interactionContext, args),
        children: ufoSegment
    });
};
$85d10fc1c2bca434$var$UFOSegment.displayName = "UFOSegment";
$85d10fc1c2bca434$var$UFOSegment.displayName = 'UFOSegment';
var $85d10fc1c2bca434$export$2e2bcd8739ae039 = $85d10fc1c2bca434$var$UFOSegment;

});
parcelRegister("6nHyA", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a69e61cbcd545ba$export$2e2bcd8739ae039);
function $3a69e61cbcd545ba$var$generateId(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $3a69e61cbcd545ba$export$2e2bcd8739ae039 = $3a69e61cbcd545ba$var$generateId;

});

parcelRegister("bZiPG", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c5023ddb779dd14$export$2e2bcd8739ae039);

var $gIMgJ = parcelRequire("gIMgJ");
function $8c5023ddb779dd14$var$scheduleOnPaint(callback) {
    const isSSR = typeof window === 'undefined' || Boolean(globalThis?.false) || typeof $gIMgJ !== 'undefined' && Boolean($gIMgJ?.env?.REACT_SSR);
    if (isSSR) {
        // In SSR, execute callback immediately (no paint event exists)
        callback();
        return;
    }
    if (globalThis.document?.visibilityState !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
}
var $8c5023ddb779dd14$export$2e2bcd8739ae039 = $8c5023ddb779dd14$var$scheduleOnPaint;

});


parcelRegister("5wc6o", function(module, exports) {
$parcel$export(module.exports, "shapePaintTimingData", () => $4144790ed625e9b5$export$eb873803b57f13dd);
$parcel$export(module.exports, "shapeLargestContentfulPaintData", () => $4144790ed625e9b5$export$249cfe420379ce6a);
$parcel$export(module.exports, "shapeLayoutShiftData", () => $4144790ed625e9b5$export$13eca0f9ce301e95);
$parcel$export(module.exports, "isDomMutationsFinalBatch", () => $4144790ed625e9b5$export$e8c5a8531f7dfa04);
$parcel$export(module.exports, "shapeDomMutationsData", () => $4144790ed625e9b5$export$6954fd19623912a2);
/**
 * Iframe event shaping helpers
 *
 * These functions normalise raw Forge bridge event data into compact, consistent
 * shapes before storing in segment3pTimings, reducing payload size and aligning
 * with the equivalent host-page metrics where applicable.
 *
 * Each function receives the full raw event object (minus `type`) and returns
 * only the fields worth retaining in the analytics payload.
 */ const $4144790ed625e9b5$var$num = (v)=>typeof v === 'number' ? Math.round(v) : 0;
function $4144790ed625e9b5$var$extractPayload(data) {
    return data.payload !== null && typeof data.payload === 'object' ? data.payload : {};
}
function $4144790ed625e9b5$export$eb873803b57f13dd(data) {
    const payload = $4144790ed625e9b5$var$extractPayload(data);
    return {
        name: typeof payload.name === 'string' ? payload.name : '',
        startTime: $4144790ed625e9b5$var$num(payload.startTime)
    };
}
function $4144790ed625e9b5$export$249cfe420379ce6a(data) {
    const payload = $4144790ed625e9b5$var$extractPayload(data);
    return {
        startTime: $4144790ed625e9b5$var$num(payload.startTime),
        size: $4144790ed625e9b5$var$num(payload.size)
    };
}
function $4144790ed625e9b5$export$13eca0f9ce301e95(data) {
    const payload = $4144790ed625e9b5$var$extractPayload(data);
    const rawSources = Array.isArray(payload.sources) ? payload.sources : [];
    const sources = rawSources.map((source)=>{
        const s = source !== null && typeof source === 'object' ? source : {};
        return {
            node: typeof s.node === 'string' ? s.node : 'unknown'
        };
    });
    return {
        value: typeof payload.value === 'number' ? payload.value : 0,
        startTime: $4144790ed625e9b5$var$num(payload.startTime),
        cumulativeScore: typeof payload.cumulativeScore === 'number' ? payload.cumulativeScore : 0,
        sessionValue: typeof payload.sessionValue === 'number' ? payload.sessionValue : 0,
        sources: sources
    };
}
function $4144790ed625e9b5$export$e8c5a8531f7dfa04(data) {
    const payload = $4144790ed625e9b5$var$extractPayload(data);
    return payload.isFinalBatch === true;
}
function $4144790ed625e9b5$export$6954fd19623912a2(data) {
    const payload = $4144790ed625e9b5$var$extractPayload(data);
    return {
        totalMutations: typeof payload.totalMutations === 'number' ? payload.totalMutations : 0,
        observationDurationMs: $4144790ed625e9b5$var$num(payload.observationDurationMs),
        stopReason: typeof payload.stopReason === 'string' ? payload.stopReason : null
    };
}

});


parcelRegister("cxpqA", function(module, exports) {
$parcel$export(module.exports, "AtlassianRelayEnvironmentProvider", () => $882410446d29e831$export$6c22afad970ad5ac);
$parcel$export(module.exports, "RelayEnvironmentProvider", () => $882410446d29e831$export$43b1f3e917d65526);
$parcel$export(module.exports, "ConditionalRelayEnvironmentProvider", () => $882410446d29e831$export$2f6292af3d34630d);
$parcel$export(module.exports, "useRelayEnvironmentProvider", () => $882410446d29e831$export$e237a628f59c9f4e);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $l0IFd = parcelRequire("l0IFd");
function $882410446d29e831$export$6c22afad970ad5ac({ children: children }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $n67Vb.RelayEnvironmentProvider), {
        environment: (0, $l0IFd.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__),
        children: children
    });
}
$882410446d29e831$export$6c22afad970ad5ac.displayName = "AtlassianRelayEnvironmentProvider";
const $882410446d29e831$export$43b1f3e917d65526 = $882410446d29e831$export$6c22afad970ad5ac;
const $882410446d29e831$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $euxye.useContext)((0, $n67Vb.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, $e79Pd.jsx)($882410446d29e831$export$6c22afad970ad5ac, {
        children: children
    });
};
$882410446d29e831$export$2f6292af3d34630d.displayName = "ConditionalRelayEnvironmentProvider";
function $882410446d29e831$export$e237a628f59c9f4e() {
    const environment = (0, $n67Vb.useRelayEnvironment)();
    return (0, $euxye.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("l0IFd", function(module, exports) {
$parcel$export(module.exports, "__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__", () => $0440278d52fafbd5$export$df54517d175e6d6b);

var $egspI = parcelRequire("egspI");

var $edGGR = parcelRequire("edGGR");

var $eOens = parcelRequire("eOens");

var $6I3VN = parcelRequire("6I3VN");
const $0440278d52fafbd5$var$getLoggingAndMetricsHelper = ()=>{
    return {
        logNonBreakingErrors: ()=>{},
        logError: ()=>{},
        logErrorRetry: ()=>{},
        logQueryFallbackToPost: ()=>{}
    };
};
const $0440278d52fafbd5$export$4a639ebead870a0c = new (0, $6I3VN.SSRQueryResponseCache)({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $0440278d52fafbd5$export$df54517d175e6d6b = (0, $edGGR.createRelayEnvironment)({
    networkOptions: {
        getLoggingAndMetricsHelper: $0440278d52fafbd5$var$getLoggingAndMetricsHelper,
        withErrorHandling: (source)=>source,
        validateResponse: (request, response)=>{
            const errors = 'errors' in response ? response.errors : undefined;
            if (errors != null) {
                const requestId = response?.extensions?.gateway?.request_id;
                (0, $eOens.captureErrors)(errors, {
                    operationName: request.name,
                    requestId: requestId
                });
                if ((0, $egspI.fg)('platform_relay_redirect_on_step_up_auth_studio')) {
                    const { hasStepUpAuthError: hasStepUpAuthError, stepUpUrl: stepUpUrl } = (0, $eOens.isStepUpAuthError)(errors);
                    // Guard against SSR: window is not defined in server-side rendering environments.
                    // RelayEnvironmentProvider is used by platform components (e.g. GlobalSideNavigation)
                    // during SSR — validateResponse may be called during renderToString where window
                    // does not exist. Without this guard, a step-up auth error would throw
                    // ReferenceError and crash the entire SSR render.
                    if (hasStepUpAuthError && stepUpUrl && typeof window !== 'undefined') window.location.href = stepUpUrl;
                }
            }
            return true;
        },
        onInvalidResponse: ()=>{},
        queryResponseCache: $0440278d52fafbd5$export$4a639ebead870a0c,
        // Use typeof window === 'undefined' for SSR detection rather than globalThis.false.
        // false is set in tests but not in Bifrost's actual SSR environment (it's set in
        // init() which runs after module evaluation). typeof window === 'undefined' is the
        // standard pattern and correctly identifies both Bifrost SSR and test environments.
        isServer: typeof window === 'undefined'
    }
});

});
parcelRegister("eOens", function(module, exports) {
$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $762bbd3f8d5b035a$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $762bbd3f8d5b035a$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $762bbd3f8d5b035a$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isStepUpAuthError", () => $762bbd3f8d5b035a$export$60fba4117567a49b);

var $7TA2J = parcelRequire("7TA2J");
const $762bbd3f8d5b035a$var$errorCollector = new Map();
const $762bbd3f8d5b035a$export$da396ad2a542b095 = 120000; // 2min
const $762bbd3f8d5b035a$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $762bbd3f8d5b035a$var$errorCollector.delete(key);
    }, $762bbd3f8d5b035a$export$da396ad2a542b095);
};
const $762bbd3f8d5b035a$export$c211170518c6d0f6 = (key = (0, $7TA2J.v4)())=>{
    $762bbd3f8d5b035a$var$errorCollector.set(key, []);
    $762bbd3f8d5b035a$var$scheduleCleanup(key);
    return key;
};
const $762bbd3f8d5b035a$export$e0491a0d974dadfa = (key)=>{
    const errors = $762bbd3f8d5b035a$var$errorCollector.get(key);
    $762bbd3f8d5b035a$var$errorCollector.delete(key);
    return errors || [];
};
const $762bbd3f8d5b035a$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $762bbd3f8d5b035a$var$errorCollector.forEach((value, key)=>{
        $762bbd3f8d5b035a$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $762bbd3f8d5b035a$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};
const $762bbd3f8d5b035a$export$60fba4117567a49b = (errors)=>{
    const stepUpError = errors.find((error)=>error.message.startsWith('Step-up authentication is required.') && error.extensions?.statusCode === 303 && error.extensions?.stepUpUrl);
    return {
        hasStepUpAuthError: !!stepUpError,
        stepUpUrl: stepUpError?.extensions?.stepUpUrl ?? undefined
    };
};

});

parcelRegister("6I3VN", function(module, exports) {
$parcel$export(module.exports, "SSRQueryResponseCache", () => $1709ec8e21a8bbc2$export$be21c283b097d175);

var $lIGkE = parcelRequire("lIGkE");
function $1709ec8e21a8bbc2$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $lIGkE.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $1709ec8e21a8bbc2$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $1709ec8e21a8bbc2$export$be21c283b097d175 extends (0, $lIGkE.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl, timeoutCallback: timeoutCallback }){
        super({
            size: size,
            ttl: ttl
        });
        const isServer = typeof window === 'undefined';
        const cachedData = isServer ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || window?.__PLATFORM_SSR_AGG_CACHE__?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(()=>{
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback?.(this._responses, this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    /**
	 * @deprecated only sets a single response; does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Stores a GraphQLRepsonse along with metadata about the call.
	 * If called multiple times (such as when incremental payloads are received),
	 * will update the stored response to be an array of GraphQLSingularResponse objects,
	 * which Relay is happy to handle.
	 * @deprecated works, but does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $1709ec8e21a8bbc2$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}

});



parcelRegister("4fPPi", function(module, exports) {
$parcel$export(module.exports, "AtlBrowserStorageLocal", () => $60894d780fc80f44$export$c8cc3ffd3f2c1d2f);
$parcel$export(module.exports, "AtlBrowserStorageSession", () => $60894d780fc80f44$export$edbae459bdf957a5);
$parcel$export(module.exports, "findStorageTarget", () => $60894d780fc80f44$export$14921bfc334334c0);
$parcel$export(module.exports, "WebStorageType", () => (parcelRequire("gCCe7")).WebStorageType);

var $egspI = parcelRequire("egspI");

var $c1I7W = parcelRequire("c1I7W");
var $hRda6 = parcelRequire("hRda6");
var $2rFtA = parcelRequire("2rFtA");

var $j1sAG = parcelRequire("j1sAG");

var $5MrbU = parcelRequire("5MrbU");

var $32VVg = parcelRequire("32VVg");

var $gCCe7 = parcelRequire("gCCe7");

var $ku80m = parcelRequire("ku80m");
var $1jP1S = parcelRequire("1jP1S");
var $dlEKC = parcelRequire("dlEKC");
class $60894d780fc80f44$export$8e4a3cf07a10930b {
    constructor(storage, storageType){
        this.isAvailable = false;
        this.checkIfSetByPackage = async ({ itemKey: itemKey, isSetCallback: isSetCallback = ()=>{}, isNotSetCallback: isNotSetCallback = ()=>{} })=>{
            // As IDB is asynchronous in nature, when this in invoked, we need to rely on the callbacks
            // to actually do something with the result.
            try {
                const record = await (0, $32VVg.BSCIndexedDB).getRecord(itemKey);
                if (record) {
                    isSetCallback();
                    return true;
                } else {
                    isNotSetCallback();
                    return false;
                }
            } catch (e) {
                // If it fails to pull from IDB, we can't validate that it's been set by our package or not, so log the error
                // and assume it hasn't been set by our package. This will only impact our analytics correctness.
                (0, $j1sAG.Logger).errorWithOperationalEvent({
                    action: 'usedCheckIfSetByPackageError',
                    message: `IDB lookup failed to check if item was set by package. ${e.message || ''}`,
                    attributes: {
                        itemKey: itemKey
                    }
                });
                isNotSetCallback();
                return false;
            }
        };
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStorageEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $c1I7W.getBscGlobalState)().webStorageEnabled) return true;
        (0, $j1sAG.Logger).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $j1sAG.Logger).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $ku80m.getStorageItem)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return {
                status: (0, $5MrbU.Status).SUCCESS
            };
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $j1sAG.Logger).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return {
                status: (0, $5MrbU.Status).ERROR,
                error: new Error(`${this.storageType} is unavailable. Failed to set item ${key}`)
            };
        }
        const globalStateProduct = (0, $c1I7W.getBscGlobalState)().product;
        const wasInitialized = (0, $c1I7W.getBscGlobalState)().hasInitialized;
        // IMPORTANT: do not await above this line - if you do it will cause reading after writing to not return the new value until the microtask queue is drained, instead of just those that need to wait for remote fetch.
        const itemSetResult = await (0, $1jP1S.setStorageItem)(key, value, this.storageType, globalStateProduct, this.storage);
        if (!wasInitialized && (0, $egspI.fg)('platform_bsc_initialize_controls_analytics')) (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        if (itemSetResult.status === (0, $5MrbU.Status).SUCCESS) (0, $j1sAG.Logger).debug(`Successfully set item ${key} with value ${value}`);
        else if (itemSetResult.status === (0, $5MrbU.Status).BLOCKED) {
            // Only an actual block is described as "blocked" — errors are surfaced (and logged)
            // upstream in setStorageItem's catch blocks via Logger.errorWithOperationalEvent.
            (0, $j1sAG.Logger).debug(`Blocked setting item ${key}`);
            const productSuffix = globalStateProduct ? ` for product "${globalStateProduct}"` : '';
            if (itemSetResult.blockedItemCategory === null) // Async path with confirmed cause: key is not registered.
            (0, $j1sAG.Logger).warn(`${this.storageType}.setItem('${key}', ...) was blocked${productSuffix}` + `: '${key}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
            else if (itemSetResult.blockedItemCategory === undefined) // MaybeSync path: cause not available. State only what we know.
            (0, $j1sAG.Logger).warn(`${this.storageType}.setItem('${key}', ...) was blocked${productSuffix}.`);
        }
        return itemSetResult;
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $j1sAG.Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $dlEKC.setStrictlyNecessaryStorageItem)(key, value, this.storageType, this.storage);
        if (!(0, $c1I7W.getBscGlobalState)().hasInitialized && (0, $egspI.fg)('platform_bsc_initialize_controls_analytics')) (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        (0, $j1sAG.Logger).debug(`${itemSetStatus === (0, $5MrbU.Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $j1sAG.Logger).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $hRda6.isSSR)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
}
const $60894d780fc80f44$export$c8cc3ffd3f2c1d2f = new $60894d780fc80f44$export$8e4a3cf07a10930b(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
globalThis.localStorage, (0, $gCCe7.WebStorageType).LocalStorage);
const $60894d780fc80f44$export$edbae459bdf957a5 = new $60894d780fc80f44$export$8e4a3cf07a10930b(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
globalThis.sessionStorage, (0, $gCCe7.WebStorageType).SessionStorage);
const $60894d780fc80f44$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $gCCe7.WebStorageType).LocalStorage]: $60894d780fc80f44$export$c8cc3ffd3f2c1d2f,
        [(0, $gCCe7.WebStorageType).SessionStorage]: $60894d780fc80f44$export$edbae459bdf957a5
    })[type];
};

});
parcelRegister("c1I7W", function(module, exports) {
$parcel$export(module.exports, "getBscGlobalState", () => $90d5d6803845679f$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "__internalApplyInitialState", () => $90d5d6803845679f$export$725ef39b428c0dc2);
$parcel$export(module.exports, "__internalGetHasInitialized", () => $90d5d6803845679f$export$8835d45f445e6ba4);
$parcel$export(module.exports, "__internalGetProductGlobalState", () => $90d5d6803845679f$export$9dfdd17bbd03b460);
$parcel$export(module.exports, "__internalGetWebStorageControlsEnabledGlobalState", () => $90d5d6803845679f$export$d96c3b0fb6d35c5d);
$parcel$export(module.exports, "__internalGetIndexedDbControlsEnabledGlobalState", () => $90d5d6803845679f$export$c8554d68c78456d3);
$parcel$export(module.exports, "__internalGetDisableWebStorageConsentChecksGlobalState", () => $90d5d6803845679f$export$ea650e4f51ec84d8);
$parcel$export(module.exports, "__internalGetAllowUncategorizedCookiesInOverridesGlobalState", () => $90d5d6803845679f$export$fa1f6ebb49ec4b30);
$parcel$export(module.exports, "__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState", () => $90d5d6803845679f$export$b60c6437117dfaf9);
$parcel$export(module.exports, "__internalGetAllowUncategorizedItemsInIndexedDBOverridesGlobalState", () => $90d5d6803845679f$export$cff869f7e58c9036);
$parcel$export(module.exports, "__internalGetShouldEnforceKeyGlobalState", () => $90d5d6803845679f$export$45364c2f8f3ebde3);
$parcel$export(module.exports, "__internalSetCacheLoadedDate", () => $90d5d6803845679f$export$491d0e6c401a0697);
$parcel$export(module.exports, "__internalGetDisableIndexedDbConsentChecksGlobalState", () => $90d5d6803845679f$export$ea32fe1e8610fd3b);

var $5MrbU = parcelRequire("5MrbU");

var $ixvQs = parcelRequire("ixvQs");
let $90d5d6803845679f$var$analyticsEnabledGlobalState;
let $90d5d6803845679f$var$productGlobalState;
let $90d5d6803845679f$var$perimeterGlobalState;
let $90d5d6803845679f$var$webStorageControlsEnabledGlobalState;
let $90d5d6803845679f$var$indexedDbControlsEnabledGlobalState;
let $90d5d6803845679f$var$disableWebStorageConsentChecksGlobalState;
let $90d5d6803845679f$var$localConsentModeGlobalState;
let $90d5d6803845679f$var$packageLogLevelGlobalState;
let $90d5d6803845679f$var$allowUncategorizedCookiesInOverridesGlobalState;
let $90d5d6803845679f$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
let $90d5d6803845679f$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState;
let $90d5d6803845679f$var$disableIndexedDbConsentChecksGlobalState;
let $90d5d6803845679f$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState;
let $90d5d6803845679f$var$userIdGlobalState;
let $90d5d6803845679f$var$cloudIdGlobalState;
let $90d5d6803845679f$var$hasInitialized = false;
let $90d5d6803845679f$var$cacheLoadedDateGlobalState;
let $90d5d6803845679f$var$cookiesCacheLoader;
let $90d5d6803845679f$var$localStorageCacheLoader;
let $90d5d6803845679f$var$sessionStorageCacheLoader;
let $90d5d6803845679f$var$indexedDBCacheLoader;
let $90d5d6803845679f$var$loadCache = async (storageType)=>{
    switch(storageType){
        case (0, $5MrbU.CategoryStorageType).Cookies:
            return await $90d5d6803845679f$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $5MrbU.CategoryStorageType).LocalStorage:
            return await $90d5d6803845679f$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $5MrbU.CategoryStorageType).SessionStorage:
            return await $90d5d6803845679f$var$sessionStorageCacheLoader?.loadStorageControlsData();
        case (0, $5MrbU.CategoryStorageType).IndexedDB:
            return await $90d5d6803845679f$var$indexedDBCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
let $90d5d6803845679f$var$loadCacheMaybeSync = (storageType)=>{
    switch(storageType){
        case (0, $5MrbU.CategoryStorageType).Cookies:
            return $90d5d6803845679f$var$cookiesCacheLoader?.getStorageControlsDataFromCache() ?? $90d5d6803845679f$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $5MrbU.CategoryStorageType).LocalStorage:
            return $90d5d6803845679f$var$localStorageCacheLoader?.getStorageControlsDataFromCache() ?? $90d5d6803845679f$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $5MrbU.CategoryStorageType).SessionStorage:
            return $90d5d6803845679f$var$sessionStorageCacheLoader?.getStorageControlsDataFromCache() ?? $90d5d6803845679f$var$sessionStorageCacheLoader?.loadStorageControlsData();
        case (0, $5MrbU.CategoryStorageType).IndexedDB:
            return $90d5d6803845679f$var$indexedDBCacheLoader?.getStorageControlsDataFromCache() ?? $90d5d6803845679f$var$indexedDBCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
const $90d5d6803845679f$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $90d5d6803845679f$var$analyticsEnabledGlobalState ?? true,
        product: $90d5d6803845679f$var$productGlobalState,
        perimeter: $90d5d6803845679f$var$perimeterGlobalState,
        webStorageEnabled: $90d5d6803845679f$var$webStorageControlsEnabledGlobalState ?? false,
        indexedDbEnabled: $90d5d6803845679f$var$indexedDbControlsEnabledGlobalState ?? false,
        disableWebStorageConsentChecks: $90d5d6803845679f$var$disableWebStorageConsentChecksGlobalState ?? false,
        localConsentMode: $90d5d6803845679f$var$localConsentModeGlobalState ?? false,
        allowUncategorizedCookiesInOverrides: $90d5d6803845679f$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        allowUncategorizedItemsInWebStorageOverrides: $90d5d6803845679f$var$allowUncategorizedItemsInWebStorageOverridesGlobalState ?? false,
        allowUncategorizedItemsInIndexedDBOverrides: $90d5d6803845679f$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState ?? false,
        disableIndexedDbConsentChecks: $90d5d6803845679f$var$disableIndexedDbConsentChecksGlobalState ?? false,
        __UNSAFE_shouldEnforceKeyForRollout: $90d5d6803845679f$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState,
        packageLogLevel: $90d5d6803845679f$var$packageLogLevelGlobalState,
        cookiesCacheLoader: $90d5d6803845679f$var$cookiesCacheLoader,
        localStorageCacheLoader: $90d5d6803845679f$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $90d5d6803845679f$var$sessionStorageCacheLoader,
        indexedDBCacheLoader: $90d5d6803845679f$var$indexedDBCacheLoader,
        loadCache: $90d5d6803845679f$var$loadCache,
        loadCacheMaybeSync: $90d5d6803845679f$var$loadCacheMaybeSync,
        hasInitialized: $90d5d6803845679f$var$hasInitialized,
        userId: $90d5d6803845679f$var$userIdGlobalState,
        cloudId: $90d5d6803845679f$var$cloudIdGlobalState,
        cacheLoadedDate: $90d5d6803845679f$var$cacheLoadedDateGlobalState
    };
};
const $90d5d6803845679f$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, loadCacheMaybeSync: overrideLoadCacheMaybeSync, product: overrideProduct })=>{
    if (overrideLoadCache) $90d5d6803845679f$var$loadCache = overrideLoadCache;
    if (overrideLoadCacheMaybeSync) $90d5d6803845679f$var$loadCacheMaybeSync = overrideLoadCacheMaybeSync;
    if (overrideProduct) $90d5d6803845679f$var$productGlobalState = overrideProduct;
};
const $90d5d6803845679f$export$ac7c2edd09656c05 = ()=>{
    $90d5d6803845679f$var$analyticsEnabledGlobalState = undefined;
    $90d5d6803845679f$var$productGlobalState = undefined;
    $90d5d6803845679f$var$webStorageControlsEnabledGlobalState = undefined;
    $90d5d6803845679f$var$indexedDbControlsEnabledGlobalState = undefined;
    $90d5d6803845679f$var$disableWebStorageConsentChecksGlobalState = undefined;
    $90d5d6803845679f$var$localConsentModeGlobalState = undefined;
    $90d5d6803845679f$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $90d5d6803845679f$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = undefined;
    $90d5d6803845679f$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState = undefined;
    $90d5d6803845679f$var$disableIndexedDbConsentChecksGlobalState = undefined;
    $90d5d6803845679f$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState = undefined;
    $90d5d6803845679f$var$userIdGlobalState = undefined;
    $90d5d6803845679f$var$cloudIdGlobalState = undefined;
    $90d5d6803845679f$var$packageLogLevelGlobalState = undefined;
    // Reset the resolved-log-level cache too, so a teardown that clears global state without a
    // following initializeGlobalState() can't bleed the previous request's level into the next.
    (0, $ixvQs.resetLogLevelCache)();
    $90d5d6803845679f$var$cookiesCacheLoader = undefined;
    $90d5d6803845679f$var$localStorageCacheLoader = undefined;
    $90d5d6803845679f$var$sessionStorageCacheLoader = undefined;
    $90d5d6803845679f$var$indexedDBCacheLoader = undefined;
    $90d5d6803845679f$var$hasInitialized = false;
    $90d5d6803845679f$var$cacheLoadedDateGlobalState = undefined;
};
function $90d5d6803845679f$export$725ef39b428c0dc2(updates) {
    if (updates.productGlobalState !== undefined) $90d5d6803845679f$var$productGlobalState = updates.productGlobalState;
    if (updates.webStorageControlsEnabledGlobalState !== undefined) $90d5d6803845679f$var$webStorageControlsEnabledGlobalState = updates.webStorageControlsEnabledGlobalState;
    if (updates.indexedDbControlsEnabledGlobalState !== undefined) $90d5d6803845679f$var$indexedDbControlsEnabledGlobalState = updates.indexedDbControlsEnabledGlobalState;
    if (updates.disableWebStorageConsentChecksGlobalState !== undefined) $90d5d6803845679f$var$disableWebStorageConsentChecksGlobalState = updates.disableWebStorageConsentChecksGlobalState;
    if (updates.allowUncategorizedCookiesInOverridesGlobalState !== undefined) $90d5d6803845679f$var$allowUncategorizedCookiesInOverridesGlobalState = updates.allowUncategorizedCookiesInOverridesGlobalState;
    if (updates.allowUncategorizedItemsInWebStorageOverridesGlobalState !== undefined) $90d5d6803845679f$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = updates.allowUncategorizedItemsInWebStorageOverridesGlobalState;
    if (updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState !== undefined) $90d5d6803845679f$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState = updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState;
    if (updates.disableIndexedDbConsentChecksGlobalState !== undefined) $90d5d6803845679f$var$disableIndexedDbConsentChecksGlobalState = updates.disableIndexedDbConsentChecksGlobalState;
    if (updates.__UNSAFE_shouldEnforceKeyForRolloutGlobalState !== undefined) $90d5d6803845679f$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState = updates.__UNSAFE_shouldEnforceKeyForRolloutGlobalState;
    if (updates.localConsentModeGlobalState !== undefined) $90d5d6803845679f$var$localConsentModeGlobalState = updates.localConsentModeGlobalState;
    if (updates.analyticsEnabledGlobalState !== undefined) $90d5d6803845679f$var$analyticsEnabledGlobalState = updates.analyticsEnabledGlobalState;
    if (updates.perimeterGlobalState !== undefined) $90d5d6803845679f$var$perimeterGlobalState = updates.perimeterGlobalState;
    if (updates.cookiesCacheLoader !== undefined) $90d5d6803845679f$var$cookiesCacheLoader = updates.cookiesCacheLoader;
    if (updates.localStorageCacheLoader !== undefined) $90d5d6803845679f$var$localStorageCacheLoader = updates.localStorageCacheLoader;
    if (updates.sessionStorageCacheLoader !== undefined) $90d5d6803845679f$var$sessionStorageCacheLoader = updates.sessionStorageCacheLoader;
    if (updates.indexedDBCacheLoader !== undefined) $90d5d6803845679f$var$indexedDBCacheLoader = updates.indexedDBCacheLoader;
    if (updates.packageLogLevelGlobalState !== undefined) $90d5d6803845679f$var$packageLogLevelGlobalState = updates.packageLogLevelGlobalState;
    if (updates.hasInitialized !== undefined) $90d5d6803845679f$var$hasInitialized = updates.hasInitialized;
    if (updates.cloudIdGlobalState !== undefined) $90d5d6803845679f$var$cloudIdGlobalState = updates.cloudIdGlobalState;
    if (updates.userIdGlobalState !== undefined) $90d5d6803845679f$var$userIdGlobalState = updates.userIdGlobalState;
}
function $90d5d6803845679f$export$8835d45f445e6ba4() {
    return $90d5d6803845679f$var$hasInitialized;
}
function $90d5d6803845679f$export$9dfdd17bbd03b460() {
    return $90d5d6803845679f$var$productGlobalState;
}
function $90d5d6803845679f$export$d96c3b0fb6d35c5d() {
    return $90d5d6803845679f$var$webStorageControlsEnabledGlobalState;
}
function $90d5d6803845679f$export$c8554d68c78456d3() {
    return $90d5d6803845679f$var$indexedDbControlsEnabledGlobalState;
}
function $90d5d6803845679f$export$ea650e4f51ec84d8() {
    return $90d5d6803845679f$var$disableWebStorageConsentChecksGlobalState;
}
function $90d5d6803845679f$export$fa1f6ebb49ec4b30() {
    return $90d5d6803845679f$var$allowUncategorizedCookiesInOverridesGlobalState;
}
function $90d5d6803845679f$export$b60c6437117dfaf9() {
    return $90d5d6803845679f$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
}
function $90d5d6803845679f$export$cff869f7e58c9036() {
    return $90d5d6803845679f$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState;
}
function $90d5d6803845679f$export$45364c2f8f3ebde3() {
    return $90d5d6803845679f$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState;
}
function $90d5d6803845679f$export$491d0e6c401a0697(date) {
    if ($90d5d6803845679f$var$cacheLoadedDateGlobalState === undefined) $90d5d6803845679f$var$cacheLoadedDateGlobalState = date;
}
function $90d5d6803845679f$export$ea32fe1e8610fd3b() {
    return $90d5d6803845679f$var$disableIndexedDbConsentChecksGlobalState;
}

});
parcelRegister("5MrbU", function(module, exports) {
$parcel$export(module.exports, "PreferenceCategory", () => $5eb30711ddd4858e$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $5eb30711ddd4858e$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $5eb30711ddd4858e$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $5eb30711ddd4858e$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CategoryStorageType", () => $5eb30711ddd4858e$export$2506b012eb637f61);
$parcel$export(module.exports, "Status", () => $5eb30711ddd4858e$export$96e9906d6d93a972);
var $5eb30711ddd4858e$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $5eb30711ddd4858e$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $5eb30711ddd4858e$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $5eb30711ddd4858e$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $5eb30711ddd4858e$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $5eb30711ddd4858e$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    CategoryStorageType["IndexedDB"] = "IndexedDB";
    return CategoryStorageType;
}({});
var $5eb30711ddd4858e$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    Status["ERROR"] = "ERROR";
    return Status;
}({});
var $5eb30711ddd4858e$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});

});

parcelRegister("ixvQs", function(module, exports) {
$parcel$export(module.exports, "determineLogLevel", () => $0ef776f443c745a6$export$5461380538f47d52);
$parcel$export(module.exports, "resetLogLevelCache", () => $0ef776f443c745a6$export$977223726df102da);

var $lO5Ez = parcelRequire("lO5Ez");

var $egspI = parcelRequire("egspI");

var $c1I7W = parcelRequire("c1I7W");

var $8LL59 = parcelRequire("8LL59");
/**
 * Returns the active log level for the BSC Logger, resolved from (in order):
 * developer cookie override, consumer init param, or `DEFAULT_LOG_LEVEL`.
 *
 * The first call resolves and caches; subsequent calls return the cached
 * value. `initializeGlobalState` invalidates the cache via
 * `resetLogLevelCache()` so an init that runs after the first Logger call
 * still picks up the consumer's `packageLogLevel`.
 *
 * SSR caveat: `cachedLogLevel` is a module-level singleton, so in a shared
 * Node module cache it persists across requests. Both `initializeGlobalState`
 * and `clearGlobalState` call `resetLogLevelCache()`, so per-request init and
 * teardown keep it correct — one request's resolved level cannot leak into the
 * next.
 */ let $0ef776f443c745a6$var$cachedLogLevel;
const $0ef776f443c745a6$export$5461380538f47d52 = ()=>{
    if ($0ef776f443c745a6$var$cachedLogLevel !== undefined) return $0ef776f443c745a6$var$cachedLogLevel;
    $0ef776f443c745a6$var$cachedLogLevel = $0ef776f443c745a6$var$readDebugCookieOverride() ?? $0ef776f443c745a6$var$readInitParamLogLevel() ?? (0, $8LL59.DEFAULT_LOG_LEVEL);
    return $0ef776f443c745a6$var$cachedLogLevel;
};
const $0ef776f443c745a6$export$977223726df102da = ()=>{
    $0ef776f443c745a6$var$cachedLogLevel = undefined;
};
/**
 * Returns `LogLevel.DEBUG` when the dev override is active (cookie set AND
 * the safety-net FF is enabled), else `null`. The FF gate lets us remotely
 * disable the cookie path if it ever misbehaves.
 *
 * The cookie is checked BEFORE the feature gate on purpose: `fg` is only ever
 * evaluated when the (rare, dev-only) `atl-bsc-debug-mode` cookie is present.
 * This keeps `Logger.*` calls — including ones that run at module-load time
 * (e.g. the AtlIndexedDb singleton) — from calling `fg` during a plain import.
 * Otherwise importing BSC crashes any consumer whose test mocks `fg` with a
 * not-yet-initialized factory variable ("Cannot access 'mockFg' before
 * initialization").
 */ const $0ef776f443c745a6$var$readDebugCookieOverride = ()=>{
    let debugCookieSet = false;
    try {
        debugCookieSet = (0, $lO5Ez.default).get('atl-bsc-debug-mode') === 'true';
    } catch  {
        // Cookie access can throw in sandboxed iframes / strict cookie policies.
        return null;
    }
    if (!debugCookieSet) return null;
    return (0, $egspI.fg)('platform_moonjelly_bsc_debug_mode') ? (0, $8LL59.LogLevel).DEBUG : null;
};
/**
 * Returns the LogLevel corresponding to the consumer's `packageLogLevel` init
 * param, or `null` if unset or unrecognized.
 */ const $0ef776f443c745a6$var$readInitParamLogLevel = ()=>{
    return (0, $8LL59.packageLogLevelStringToEnum)((0, $c1I7W.getBscGlobalState)().packageLogLevel);
};

});
parcelRegister("8LL59", function(module, exports) {
$parcel$export(module.exports, "LogLevel", () => $e1be9d64aecdbe38$export$243e62d78d3b544d);
$parcel$export(module.exports, "DEFAULT_LOG_LEVEL", () => $e1be9d64aecdbe38$export$97d4c6871900dcac);
$parcel$export(module.exports, "packageLogLevelStringToEnum", () => $e1be9d64aecdbe38$export$6b31b02af0747fdf);
/**
 * Internal numeric log level. Higher = more verbose; a Logger method fires
 * when the resolved level is `>=` its own. Not exported from the package's
 * public entry — consumers use `PackageLogLevel` instead.
 */ var $e1be9d64aecdbe38$export$243e62d78d3b544d = /*#__PURE__*/ function(LogLevel) {
    LogLevel[LogLevel["SILENT"] = 0] = "SILENT";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 4] = "DEBUG";
    return LogLevel;
}({});
const $e1be9d64aecdbe38$export$97d4c6871900dcac = 1;
const $e1be9d64aecdbe38$var$PACKAGE_LOG_LEVEL_BY_STRING = {
    silent: 0,
    error: 1,
    warn: 2,
    info: 3,
    debug: 4
};
const $e1be9d64aecdbe38$export$6b31b02af0747fdf = (value)=>{
    if (value === undefined) return null;
    return $e1be9d64aecdbe38$var$PACKAGE_LOG_LEVEL_BY_STRING[value] ?? null;
};

});



parcelRegister("hRda6", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $d38e5ca05ab59ef5$export$48d7c418edadb60c);

var $gL9hl = parcelRequire("gL9hl");

var $egspI = parcelRequire("egspI");
const $d38e5ca05ab59ef5$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $egspI.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $gL9hl.default));
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});

parcelRegister("2rFtA", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsClient", () => $32d877cff2611b43$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $32d877cff2611b43$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUnsampledPackageOperationalEvent", () => $32d877cff2611b43$export$c986f0e7f985d67f);
$parcel$export(module.exports, "sendUIEvent", () => $32d877cff2611b43$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $32d877cff2611b43$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $32d877cff2611b43$export$1ba525b8a711eaac);

var $gL9hl = parcelRequire("gL9hl");
var $hIipg = parcelRequire("hIipg");

var $c1I7W = parcelRequire("c1I7W");


var $3b644 = parcelRequire("3b644");

var $h9xO4 = parcelRequire("h9xO4");
const $32d877cff2611b43$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.') || hostname.includes('.jira-dev.') || hostname.includes('.jira-stg.')) return (0, $hIipg.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $hIipg.envType).DEV;
    return (0, $hIipg.envType).PROD;
};
const $32d877cff2611b43$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $32d877cff2611b43$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $32d877cff2611b43$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $32d877cff2611b43$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $32d877cff2611b43$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $32d877cff2611b43$var$decorateEventAttributes = (attributes)=>{
    const { domain: domain, product: product } = $32d877cff2611b43$export$fce3dd735e04d566();
    return {
        packageName: $3b644.packageName,
        packageVersion: $3b644.packageVersion,
        domain: domain,
        product: (0, $c1I7W.getBscGlobalState)().product?.toLowerCase() ?? product,
        ...attributes && attributes
    };
};
const $32d877cff2611b43$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $c1I7W.getBscGlobalState)().analyticsEnabled) {
                instance = new (0, $gL9hl.default)({
                    env: $32d877cff2611b43$var$getEnvironment(),
                    product: 'atlassianCookies'
                }, {
                    // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                    // When set to false, the client will use a stargate proxy for the current URL to send events
                    // to GAS. Said another way:
                    // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                    // false => events are sent to <the current domain>/gasv3/api/v1/batch
                    //
                    // By default, this should be set to false.  If you need to validate that analytics events
                    // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                    // won't be able to proxy to GAS via stargate.
                    useLegacyUrl: false,
                    disableCookiePersistence: true
                });
                if ((0, $c1I7W.getBscGlobalState)().cloudId) instance.setTenantInfo((0, $hIipg.tenantType).CLOUD_ID, (0, $c1I7W.getBscGlobalState)().cloudId);
                if ((0, $c1I7W.getBscGlobalState)().userId) instance.setUserInfo((0, $hIipg.userType).ATLASSIAN_ACCOUNT, (0, $c1I7W.getBscGlobalState)().userId ?? '');
            }
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            // eslint-disable-next-line no-console
            console.error(`${(0, $42033962320073ac$export$5e28bf885ebebfa6)}: Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $c1I7W.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $32d877cff2611b43$export$5bfe55348e7aebc1(properties) {
    (0, $h9xO4.withAnalyticsEventSampling)(properties.action, ()=>$32d877cff2611b43$export$fde53e78fd93a54d()?.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $32d877cff2611b43$var$decorateEventAttributes(properties.attributes)
        }));
}
function $32d877cff2611b43$export$c986f0e7f985d67f(properties) {
    $32d877cff2611b43$export$fde53e78fd93a54d()?.sendOperationalEvent({
        source: 'package',
        actionSubject: 'package',
        action: properties.action,
        attributes: $32d877cff2611b43$var$decorateEventAttributes(properties.attributes)
    });
}
function $32d877cff2611b43$export$1aecf263098db667(properties) {
    (0, $h9xO4.withAnalyticsEventSampling)(properties.actionSubjectId, ()=>$32d877cff2611b43$export$fde53e78fd93a54d()?.sendUIEvent({
            ...properties,
            attributes: $32d877cff2611b43$var$decorateEventAttributes(properties.attributes)
        }));
}
function $32d877cff2611b43$export$22a3b1671f38a193(properties) {
    (0, $h9xO4.withAnalyticsEventSampling)(properties.name, ()=>$32d877cff2611b43$export$fde53e78fd93a54d()?.sendScreenEvent({
            ...properties,
            attributes: $32d877cff2611b43$var$decorateEventAttributes(properties.attributes)
        }));
}
function $32d877cff2611b43$export$1ba525b8a711eaac(properties) {
    (0, $h9xO4.withAnalyticsEventSampling)(properties.actionSubject, ()=>$32d877cff2611b43$export$fde53e78fd93a54d()?.sendTrackEvent({
            ...properties,
            attributes: $32d877cff2611b43$var$decorateEventAttributes(properties.attributes)
        }));
}

});
const $42033962320073ac$export$5e28bf885ebebfa6 = '[browser-storage-controls]';
const $42033962320073ac$export$aeb1f5aa1188ce28 = 5000; // min gap between sends of the same action
const $42033962320073ac$export$ee3d07c2528881e2 = 10; // hard cap per action per page load

parcelRegister("3b644", function(module, exports) {
$parcel$export(module.exports, "packageName", () => $6a84bc16a1a374fe$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $6a84bc16a1a374fe$export$91546b032799aa40);
const $6a84bc16a1a374fe$export$9345d7360ffe0722 = "platform-pkg" ?? '';
const $6a84bc16a1a374fe$export$91546b032799aa40 = "0.0.0-use.local" ?? '';

});

parcelRegister("h9xO4", function(module, exports) {
$parcel$export(module.exports, "withAnalyticsEventSampling", () => $1315829a319fb6fe$export$67b6e87f323cb6ad);

var $5MrbU = parcelRequire("5MrbU");

var $c1I7W = parcelRequire("c1I7W");

var $gfngo = parcelRequire("gfngo");

var $hRda6 = parcelRequire("hRda6");
const $1315829a319fb6fe$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    indexDbSetRecordError: 1,
    usedCheckIfSetByPackageError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1,
    usedAtlIndexedDBOpen: 100,
    usedAtlIndexedDBOpenError: 1,
    usedAtlIndexedDBOpenStrictlyNecessary: 100,
    usedAtlIndexedDBOpenStrictlyNecessaryError: 1,
    bscInitControlsParameters: 1000,
    setItemWithoutInit: 1000,
    uncategorizedWebStorageItemSet: 100,
    storageCleanupCategorized: 100,
    storageCleanupDeleted: 100,
    storageCleanupError: 1,
    cookieConsentPreferences: 1,
    cookieConsentModal: 1,
    cookieConsentBanner: 1,
    preferences: 1,
    onlyNecessary: 1,
    acceptAll: 1,
    cookiesTrackingNotice: 1,
    confirm: 1,
    performanceConsent: 1,
    functionalConsent: 1,
    targetingConsent: 1,
    cancel: 1,
    close: 1,
    background: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $1315829a319fb6fe$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $1315829a319fb6fe$var$loadSamplingConfig() {
    if ((0, $gfngo.cache).cachedSamplingConfig) return (0, $gfngo.cache).cachedSamplingConfig;
    if ((0, $hRda6.isSSR)()) return undefined;
    const { loadCache: loadCache } = (0, $c1I7W.getBscGlobalState)();
    const controlsData = await loadCache((0, $5MrbU.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
    (0, $gfngo.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $1315829a319fb6fe$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($1315829a319fb6fe$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $1315829a319fb6fe$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $1315829a319fb6fe$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $1315829a319fb6fe$export$1138592b3c099377;
    const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $1315829a319fb6fe$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $1315829a319fb6fe$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
       ________
      /\       \
     /()\   ()  \
    /    \_______\
    \    /()     /
     \()/   ()  /
      \/_____()/
  */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $1315829a319fb6fe$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $1315829a319fb6fe$export$b286f5e8716d11ad(analyticsEventKey);
    $1315829a319fb6fe$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("gfngo", function(module, exports) {
$parcel$export(module.exports, "cache", () => $dc63cd15d93e34fb$export$69a3209f1a06c04d);

var $6FkKl = parcelRequire("6FkKl");
const $dc63cd15d93e34fb$export$69a3209f1a06c04d = new (0, $6FkKl.CachedSamplingConfig)();

});
parcelRegister("6FkKl", function(module, exports) {
$parcel$export(module.exports, "CachedSamplingConfig", () => $87174ddad484599b$export$b886edaf6623554a);
class $87174ddad484599b$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});




parcelRegister("j1sAG", function(module, exports) {
$parcel$export(module.exports, "Logger", () => $0ddeb2dbb57c9e80$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $egspI = parcelRequire("egspI");

var $2rFtA = parcelRequire("2rFtA");


var $ixvQs = parcelRequire("ixvQs");

var $6xX4N = parcelRequire("6xX4N");

var $8LL59 = parcelRequire("8LL59");
const $0ddeb2dbb57c9e80$var$formatMetadata = (metadata)=>{
    if (!metadata) return '';
    // `LoggingMetadata` allows a bare string; emit it as-is rather than running it
    // through JSON.stringify, which would wrap it in extra quotes ("error-code" -> '"error-code"').
    return typeof metadata === 'string' ? metadata : JSON.stringify(metadata);
};
class $0ddeb2dbb57c9e80$export$efa9a398d6368992 {
    // All console output below ERROR (info/warn/debug) is gated behind
    // `platform_moonjelly_bsc_warn_on_set_blocked` so this package's new logging stays dark until
    // the flag is enabled. ERROR output is intentionally always on (subject only to the log level).
    //
    // The log-level comparison is evaluated FIRST in each guard so that `fg` is never called at
    // module-load time: at the default ERROR level these methods short-circuit before reaching
    // `fg`, which keeps a plain `import` of this package from evaluating feature gates (the same
    // import-time concern handled in determine-log-level.ts).
    static info(message, metadata) {
        if ((0, $ixvQs.determineLogLevel)() >= (0, $8LL59.LogLevel).INFO && (0, $egspI.fg)('platform_moonjelly_bsc_warn_on_set_blocked')) console.info(`${(0, $42033962320073ac$export$5e28bf885ebebfa6)}: ${message}`, $0ddeb2dbb57c9e80$var$formatMetadata(metadata));
    }
    static warn(message, metadata) {
        if ((0, $ixvQs.determineLogLevel)() >= (0, $8LL59.LogLevel).WARN && (0, $egspI.fg)('platform_moonjelly_bsc_warn_on_set_blocked')) console.warn(`${(0, $42033962320073ac$export$5e28bf885ebebfa6)}: ${message}`, $0ddeb2dbb57c9e80$var$formatMetadata(metadata));
    }
    static error(message, metadata) {
        if ((0, $ixvQs.determineLogLevel)() >= (0, $8LL59.LogLevel).ERROR) console.error(`${(0, $42033962320073ac$export$5e28bf885ebebfa6)}: ${message}`, $0ddeb2dbb57c9e80$var$formatMetadata(metadata));
    }
    static debug(message, metadata) {
        if ((0, $ixvQs.determineLogLevel)() >= (0, $8LL59.LogLevel).DEBUG && (0, $egspI.fg)('platform_moonjelly_bsc_warn_on_set_blocked')) console.debug(`${(0, $42033962320073ac$export$5e28bf885ebebfa6)}: DEBUG ${message}`, $0ddeb2dbb57c9e80$var$formatMetadata(metadata));
    }
    /**
	 * Sends an unsampled operational event to backend telemetry and also emits the message via
	 * `Logger.error`. When `platform_bsc_throttle_error_events` is enabled the telemetry send is
	 * throttled per-action (see error-event-throttle); otherwise it is unconditional. The console
	 * output is always at ERROR level (subject to the resolved log level).
	 */ static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            // When the throttle gate is OFF the second operand is never evaluated, so no throttle
            // state is recorded and behaviour is unchanged. When ON, shouldSendErrorEvent records
            // the send and limits per-action volume.
            if (!(0, $egspI.fg)('platform_bsc_throttle_error_events') || (0, $6xX4N.shouldSendErrorEvent)(action)) (0, $2rFtA.sendUnsampledPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata);
    }
}

});
parcelRegister("6xX4N", function(module, exports) {
$parcel$export(module.exports, "shouldSendErrorEvent", () => $a4108afb061c4242$export$e54335114720f029);

// Per-process (per page load) throttle state, keyed by operational event action.
// Resets naturally on page reload because module state is re-initialised, which gives
// us the "per session" semantic for free (same pattern as bsc-global-state).
const $a4108afb061c4242$var$throttleState = new Map();
function $a4108afb061c4242$export$e54335114720f029(action) {
    const now = Date.now();
    const entry = $a4108afb061c4242$var$throttleState.get(action);
    if (!entry) {
        // First occurrence of this action this session always sends.
        $a4108afb061c4242$var$throttleState.set(action, {
            lastSentAt: now,
            sentCount: 1
        });
        return true;
    }
    if (entry.sentCount >= (0, $42033962320073ac$export$ee3d07c2528881e2)) // Hard per-session cap reached — drop regardless of elapsed time.
    return false;
    if (now - entry.lastSentAt < (0, $42033962320073ac$export$aeb1f5aa1188ce28)) // Within the cooldown window since the last send for this action.
    return false;
    entry.lastSentAt = now;
    entry.sentCount += 1;
    return true;
}
function $a4108afb061c4242$export$a5ff37ede5ff9625() {
    $a4108afb061c4242$var$throttleState.clear();
}

});


parcelRegister("32VVg", function(module, exports) {
$parcel$export(module.exports, "BSCIndexedDB", () => $3df7eb4582943a8e$export$36328b3bcbe4623a);

var $egspI = parcelRequire("egspI");

var $hRda6 = parcelRequire("hRda6");
var $2rFtA = parcelRequire("2rFtA");

var $j1sAG = parcelRequire("j1sAG");
class $3df7eb4582943a8e$export$fde2a4e0e57f47e {
    static{
        this.OPEN_DB_TIMEOUT_MS = 3000;
    }
    constructor(dbName, storeName){
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, $j1sAG.Logger).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>()=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>()=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $j1sAG.Logger).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $j1sAG.Logger).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
    async boot() {
        if (!this.isAvailable) {
            (0, $j1sAG.Logger).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $j1sAG.Logger).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $hRda6.isSSR)() && !!window.indexedDB;
    }
    async openDB() {
        const openPromise = new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
        if ((0, $egspI.fg)('cookies-bsc-timeout-for-indexeddb')) {
            const timeoutPromise = new Promise((_, reject)=>{
                setTimeout(()=>{
                    reject(new Error(`IndexedDB open timed out after ${$3df7eb4582943a8e$export$fde2a4e0e57f47e.OPEN_DB_TIMEOUT_MS}ms`));
                }, $3df7eb4582943a8e$export$fde2a4e0e57f47e.OPEN_DB_TIMEOUT_MS);
            });
            return Promise.race([
                openPromise,
                timeoutPromise
            ]);
        }
        return openPromise;
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, $2rFtA.sendPackageOperationalEvent)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey: recordKey
                    }
                });
                return Promise.resolve({
                    atlSetItem: '',
                    id: recordKey
                }); // return empty AtlIndexedDBItem object to exit code
            }
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $j1sAG.Logger).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, $2rFtA.sendPackageOperationalEvent)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey: recordKey
                    }
                });
                Promise.resolve(); // return void promise to exit code and not pass a null record
            }
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $j1sAG.Logger).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
}
const $3df7eb4582943a8e$export$36328b3bcbe4623a = new $3df7eb4582943a8e$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');

});

parcelRegister("gCCe7", function(module, exports) {
$parcel$export(module.exports, "WebStorageType", () => $5f1e28a72d75dcc3$export$259e3a861f28589b);
var $5f1e28a72d75dcc3$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});

});

parcelRegister("ku80m", function(module, exports) {
$parcel$export(module.exports, "getStorageItem", () => $04708bbbc4b47259$export$e612bb1301d659de);

var $2rFtA = parcelRequire("2rFtA");

var $j1sAG = parcelRequire("j1sAG");
const $04708bbbc4b47259$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $j1sAG.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};

});

parcelRegister("1jP1S", function(module, exports) {
$parcel$export(module.exports, "setStorageItem", () => $231fbe73b0577a1c$export$5ee8760f703d9d62);

var $egspI = parcelRequire("egspI");

var $c1I7W = parcelRequire("c1I7W");
var $2rFtA = parcelRequire("2rFtA");

var $bDj2g = parcelRequire("bDj2g");

var $5MrbU = parcelRequire("5MrbU");

var $lbJxq = parcelRequire("lbJxq");

var $gCCe7 = parcelRequire("gCCe7");

var $jTLe5 = parcelRequire("jTLe5");
const $231fbe73b0577a1c$var$isPromise = (value)=>value != null && typeof value.then === 'function';
const $231fbe73b0577a1c$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    const categoryStorageType = storageType === (0, $gCCe7.WebStorageType).LocalStorage ? (0, $5MrbU.CategoryStorageType).LocalStorage : (0, $5MrbU.CategoryStorageType).SessionStorage;
    // `disableWebStorageConsentChecks` skips the consent pipeline (analytics-only),
    // but `__UNSAFE_shouldEnforceKeyForRollout(key, type) === true` re-enables enforcement for this key.
    let disableWebStorageConsentChecks = (0, $c1I7W.getBscGlobalState)().disableWebStorageConsentChecks ?? false;
    if ((0, $egspI.fg)('jfp-magma-selective-storage-enforcement')) {
        const __UNSAFE_shouldEnforceKeyForRollout = (0, $c1I7W.getBscGlobalState)().__UNSAFE_shouldEnforceKeyForRollout;
        const enforceThisKey = __UNSAFE_shouldEnforceKeyForRollout?.(itemKey, categoryStorageType) === true;
        disableWebStorageConsentChecks = ((0, $c1I7W.getBscGlobalState)().disableWebStorageConsentChecks ?? false) && !enforceThisKey;
    }
    if (disableWebStorageConsentChecks) {
        const eventAttributes = {
            itemKey: itemKey,
            storageType: storageType,
            consentChecksDisabled: true
        };
        try {
            // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
            // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
            (0, $lbJxq.ItemKeyCache).markSetByPackage(categoryStorageType, itemKey);
            browserStorage.setItem(itemKey, value);
        } catch (e) {
            (0, $jTLe5.reportSetItemError)({
                message: `${storageType} failed to setItem with consent checks disabled. ${e.message || ''}`,
                attributes: eventAttributes,
                error: e
            });
            return {
                status: (0, $5MrbU.Status).ERROR,
                error: e
            };
        }
        let wasAsync = true;
        try {
            let shouldSetItem;
            const shouldSetItemOrPromise = (0, $bDj2g.isProcessingAllowedByPreferencesMaybeSync)({
                itemKey: itemKey,
                storageType: categoryStorageType,
                productName: productName
            });
            if ($231fbe73b0577a1c$var$isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
            else {
                wasAsync = false;
                shouldSetItem = shouldSetItemOrPromise;
            }
            (0, $2rFtA.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    ...eventAttributes,
                    wasRejected: !shouldSetItem,
                    wasAsync: wasAsync
                }
            });
        } catch (e) {
            (0, $jTLe5.reportSetItemError)({
                attributes: {
                    ...eventAttributes,
                    wasAsync: wasAsync
                },
                message: `Failed to emit analytics for setStorageItem with consent checks disabled. ${e.message || ''}`,
                error: e
            });
        }
        return {
            status: (0, $5MrbU.Status).SUCCESS
        };
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    let shouldSetItem;
    let wasAsync = true;
    const shouldSetItemOrPromise = (0, $bDj2g.isProcessingAllowedByPreferencesMaybeSync)({
        itemKey: itemKey,
        storageType: categoryStorageType,
        productName: productName
    });
    if ($231fbe73b0577a1c$var$isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
    else {
        wasAsync = false;
        shouldSetItem = shouldSetItemOrPromise;
    }
    // The synchronous preference check surfaces no block reason:
    // `isProcessingAllowedByPreferencesMaybeSync` takes no blockedCallback, so we cannot tell
    // "key not registered in the allow-list" from "blocked by user consent" here. The BLOCKED
    // result therefore carries `blockedItemCategory: undefined` ("reason unknown"), which the
    // caller reads as such and answers with a terse "was blocked" warning.
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType,
        consentChecksDisabled: false,
        wasAsync: wasAsync
    };
    try {
        (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
            // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
            (0, $lbJxq.ItemKeyCache).markSetByPackage(categoryStorageType, itemKey);
            browserStorage.setItem(itemKey, value);
            return {
                status: (0, $5MrbU.Status).SUCCESS
            };
        } else return {
            status: (0, $5MrbU.Status).BLOCKED,
            blockedItemCategory: undefined
        };
    } catch (e) {
        (0, $jTLe5.reportSetItemError)({
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`,
            error: e
        });
        return {
            status: (0, $5MrbU.Status).ERROR,
            error: e
        };
    }
};

});
parcelRegister("bDj2g", function(module, exports) {
$parcel$export(module.exports, "getItemCategoryFromPassedCache", () => $2ce1122b191e8cfa$export$69d5b68d01f4a366);
$parcel$export(module.exports, "getItemCategory", () => $2ce1122b191e8cfa$export$ec8ce5237293e4a4);
$parcel$export(module.exports, "isProcessingAllowedByPreferencesMaybeSync", () => $2ce1122b191e8cfa$export$ffbb879d3fefb45c);
$parcel$export(module.exports, "isProcessingAllowedByPreferences", () => $2ce1122b191e8cfa$export$e7a3dca206fec6e2);
$parcel$export(module.exports, "isProcessingAllowedByPreferencesWithCategory", () => $2ce1122b191e8cfa$export$17e4a7e00d5b99d9);

var $egspI = parcelRequire("egspI");

var $eTDvj = parcelRequire("eTDvj");

var $5MrbU = parcelRequire("5MrbU");

var $c1I7W = parcelRequire("c1I7W");

var $j1sAG = parcelRequire("j1sAG");
/**
 * WeakMap cache for precompiled RegExp objects, keyed by the raw regExp product map.
 * This ensures RegExp strings are compiled at most once per unique cache object.
 */ const $2ce1122b191e8cfa$var$compiledRegExpCache = new WeakMap();
const $2ce1122b191e8cfa$var$compileRegExpPatterns = (rawPatterns)=>{
    if ($2ce1122b191e8cfa$var$compiledRegExpCache.has(rawPatterns)) return $2ce1122b191e8cfa$var$compiledRegExpCache.get(rawPatterns);
    const compiled = [];
    for (const [regexString, category] of Object.entries(rawPatterns))try {
        compiled.push({
            regexp: new RegExp(regexString),
            category: category
        });
    } catch (e) {
        (0, $j1sAG.Logger).warn(`BSC: Invalid RegExp pattern "${regexString}" in storage controls cache \u{2014} skipping.`);
    }
    $2ce1122b191e8cfa$var$compiledRegExpCache.set(rawPatterns, compiled);
    return compiled;
};
const $2ce1122b191e8cfa$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $2ce1122b191e8cfa$export$81a82818a800a999 = (itemKey, compiledPatterns)=>{
    for (const { regexp: regexp, category: category } of compiledPatterns){
        if (regexp.test(itemKey)) return category;
    }
    return null;
};
const $2ce1122b191e8cfa$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $2ce1122b191e8cfa$export$915dea35caff63c = (itemKey, startsWith)=>{
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) return startsWith[prefix];
    }
    return null;
};
const $2ce1122b191e8cfa$export$4381be1b9fd38456 = (itemKey, startsWith)=>{
    let best = null;
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) {
            if (best === null || prefix.length > best.length) best = {
                category: startsWith[prefix],
                length: prefix.length
            };
        }
    }
    return best;
};
const $2ce1122b191e8cfa$export$495f1917e0bfb98c = (itemKey, endsWith)=>{
    let best = null;
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) {
            if (best === null || suffix.length > best.length) best = {
                category: endsWith[suffix],
                length: suffix.length
            };
        }
    }
    return best;
};
const $2ce1122b191e8cfa$export$f6f7882079c4a2cb = (itemKey, endsWith)=>{
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) return endsWith[suffix];
    }
    return null;
};
const $2ce1122b191e8cfa$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName?.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    const productStartsWithPatterns = {
        ...patterns.startsWith['all'],
        ...downcasedProduct ? patterns.startsWith[downcasedProduct] : {}
    };
    const productEndsWithPatterns = {
        ...patterns.endsWith['all'],
        ...downcasedProduct ? patterns.endsWith[downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else if ((0, $egspI.fg)('platform_bsc_flat_pattern_file_structure')) {
        if ((0, $egspI.fg)('platform_bsc_longest_pattern_match_wins')) {
            // Longest-match-wins flat path
            const swMatch = $2ce1122b191e8cfa$export$4381be1b9fd38456(itemKey, productStartsWithPatterns);
            if (swMatch !== null) itemCategoryNumber = swMatch.category;
            else {
                const ewMatch = $2ce1122b191e8cfa$export$495f1917e0bfb98c(itemKey, productEndsWithPatterns);
                if (ewMatch !== null) itemCategoryNumber = ewMatch.category;
            }
        } else {
            // First-match flat path (COOK-435)
            itemCategoryNumber = $2ce1122b191e8cfa$export$915dea35caff63c(itemKey, productStartsWithPatterns);
            if (itemCategoryNumber === null) itemCategoryNumber = $2ce1122b191e8cfa$export$f6f7882079c4a2cb(itemKey, productEndsWithPatterns);
        }
        // 3. RegExp fallback for both flat paths
        if (itemCategoryNumber === null && (0, $egspI.fg)('platform_moonjelly_bsc_regexp_pattern_matching')) {
            const rawRegExpPatterns = {
                ...patterns.regexp?.['all'],
                ...downcasedProduct ? patterns.regexp?.[downcasedProduct] : {}
            };
            const compiledPatterns = $2ce1122b191e8cfa$var$compileRegExpPatterns(rawRegExpPatterns);
            itemCategoryNumber = $2ce1122b191e8cfa$export$81a82818a800a999(itemKey, compiledPatterns);
        }
    } else {
        // Legacy trie matching path. When platform_bsc_lookup_product_then_all_pattern_tries
        // is ON we search the product trie first and fall back to the 'all' trie;
        // a merged trie is unsafe because a shared first character silently
        // drops the entire 'all' subtree under it (HOT-303432).
        if ((0, $egspI.fg)('platform_bsc_lookup_product_then_all_pattern_tries')) {
            const productStartsWith = downcasedProduct ? patterns.startsWith[downcasedProduct] : undefined;
            const productEndsWith = downcasedProduct ? patterns.endsWith[downcasedProduct] : undefined;
            const allStartsWith = patterns.startsWith['all'];
            const allEndsWith = patterns.endsWith['all'];
            if (productStartsWith) itemCategoryNumber = $2ce1122b191e8cfa$export$2c141b1c00f3e482(itemKey, productStartsWith);
            if (itemCategoryNumber === null && allStartsWith) itemCategoryNumber = $2ce1122b191e8cfa$export$2c141b1c00f3e482(itemKey, allStartsWith);
            if (itemCategoryNumber === null && productEndsWith) itemCategoryNumber = $2ce1122b191e8cfa$export$c4a1dd71bbd8954c(itemKey, productEndsWith);
            if (itemCategoryNumber === null && allEndsWith) itemCategoryNumber = $2ce1122b191e8cfa$export$c4a1dd71bbd8954c(itemKey, allEndsWith);
        } else {
            itemCategoryNumber = $2ce1122b191e8cfa$export$2c141b1c00f3e482(itemKey, productStartsWithPatterns);
            if (itemCategoryNumber === null) itemCategoryNumber = $2ce1122b191e8cfa$export$c4a1dd71bbd8954c(itemKey, productEndsWithPatterns);
        }
        if (itemCategoryNumber === null && (0, $egspI.fg)('platform_moonjelly_bsc_regexp_pattern_matching')) {
            const rawRegExpPatterns = {
                ...patterns.regexp?.['all'],
                ...downcasedProduct ? patterns.regexp?.[downcasedProduct] : {}
            };
            const compiledPatterns = $2ce1122b191e8cfa$var$compileRegExpPatterns(rawRegExpPatterns);
            itemCategoryNumber = $2ce1122b191e8cfa$export$81a82818a800a999(itemKey, compiledPatterns);
        }
    }
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $5MrbU.PreferenceCategory).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $5MrbU.PreferenceCategory).Functional,
        [categories.ANALYTICS]: (0, $5MrbU.PreferenceCategory).Analytics,
        [categories.MARKETING]: (0, $5MrbU.PreferenceCategory).Marketing,
        [categories.UNKNOWN]: (0, $5MrbU.PreferenceCategory).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] : null;
};
const $2ce1122b191e8cfa$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $c1I7W.getBscGlobalState)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $2ce1122b191e8cfa$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $2ce1122b191e8cfa$var$isPromise = (value)=>value != null && typeof value.then === 'function';
const $2ce1122b191e8cfa$export$68b935e7ddb93762 = (itemKey, storageType, productName)=>{
    const storageControlsDataOrPromise = (0, $c1I7W.getBscGlobalState)().loadCacheMaybeSync(storageType);
    if ($2ce1122b191e8cfa$var$isPromise(storageControlsDataOrPromise)) return storageControlsDataOrPromise.then((storageControlsData)=>{
        if (!storageControlsData) return null;
        else return $2ce1122b191e8cfa$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
    });
    if (!storageControlsDataOrPromise) return null;
    else return $2ce1122b191e8cfa$export$69d5b68d01f4a366(itemKey, storageControlsDataOrPromise, productName);
};
function $2ce1122b191e8cfa$var$isProcessingAllowedForCategoryAndPreferenceSync(category, preferences) {
    if (!!preferences) {
        if (!!category) return preferences[category];
    }
    return false;
}
/**
 * Given an item category and a promise or object of user preferences, determines whether the item can be set.
 * It avoids only returns a promise if we need the preference data to determine the result, otherwise it returns synchronously.
 *
 * DO NOT CONVERT THIS FUNCTION TO ASYNC - as async functions always return a promise, breaking read-after-write consistency for clients that have already loaded the cache.
 */ function $2ce1122b191e8cfa$var$isProcessingAllowedForCategoryMaybeSync(itemCategory, preferencesOrPromise) {
    if (itemCategory === (0, $5MrbU.PreferenceCategory).StrictlyNecessary) return {
        itemCategory: itemCategory,
        shouldProcessItem: true
    };
    if ($2ce1122b191e8cfa$var$isPromise(preferencesOrPromise)) return preferencesOrPromise.then((prefs)=>{
        return {
            itemCategory: itemCategory,
            shouldProcessItem: $2ce1122b191e8cfa$var$isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, prefs)
        };
    });
    else return {
        itemCategory: itemCategory,
        shouldProcessItem: $2ce1122b191e8cfa$var$isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, preferencesOrPromise)
    };
}
const $2ce1122b191e8cfa$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync = ({ itemKey: itemKey, storageType: storageType, productName: productName })=>{
    // start fetching both promises upfront, so they can resolve in parallel if needed
    const itemCategoryOrPromise = $2ce1122b191e8cfa$export$68b935e7ddb93762(itemKey, storageType, productName);
    const preferencesOrPromise = (0, $eTDvj.getPreferencesMaybeSync)();
    if ($2ce1122b191e8cfa$var$isPromise(itemCategoryOrPromise)) return itemCategoryOrPromise.then((category)=>$2ce1122b191e8cfa$var$isProcessingAllowedForCategoryMaybeSync(category, preferencesOrPromise));
    else return $2ce1122b191e8cfa$var$isProcessingAllowedForCategoryMaybeSync(itemCategoryOrPromise, preferencesOrPromise);
};
const $2ce1122b191e8cfa$export$ffbb879d3fefb45c = ({ itemKey: itemKey, storageType: storageType, productName: productName })=>{
    const categoryAndPreferenceOrPromise = $2ce1122b191e8cfa$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    if ($2ce1122b191e8cfa$var$isPromise(categoryAndPreferenceOrPromise)) return categoryAndPreferenceOrPromise.then(({ shouldProcessItem: shouldProcessItem })=>shouldProcessItem);
    else return categoryAndPreferenceOrPromise.shouldProcessItem;
};
const $2ce1122b191e8cfa$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName })=>{
    let shouldProcessItem;
    let itemCategory = null;
    let wasAsync = true;
    let categoryAndPreferenceOrPromise = $2ce1122b191e8cfa$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    if ($2ce1122b191e8cfa$var$isPromise(categoryAndPreferenceOrPromise)) // this should be the only await in the function.
    ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = await categoryAndPreferenceOrPromise);
    else {
        wasAsync = false;
        ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = categoryAndPreferenceOrPromise);
    }
    if (shouldProcessItem) allowedCallback?.({
        wasAsync: wasAsync
    });
    else blockedCallback?.({
        itemHasCategory: itemCategory != null,
        itemCategory: itemCategory,
        wasAsync: wasAsync
    });
    return shouldProcessItem;
};
const $2ce1122b191e8cfa$export$17e4a7e00d5b99d9 = async ({ itemKey: itemKey, storageType: storageType, productName: productName })=>{
    const categoryAndPreferenceOrPromise = $2ce1122b191e8cfa$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    let shouldProcessItem;
    let itemCategory;
    if ($2ce1122b191e8cfa$var$isPromise(categoryAndPreferenceOrPromise)) ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = await categoryAndPreferenceOrPromise);
    else ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = categoryAndPreferenceOrPromise);
    return {
        isAllowed: shouldProcessItem,
        itemCategory: itemCategory
    };
};

});
parcelRegister("eTDvj", function(module, exports) {
$parcel$export(module.exports, "getPreferences", () => $7d988759cd1d5c9a$export$1de6a888ae076ff8);
$parcel$export(module.exports, "getPreferencesMaybeSync", () => $7d988759cd1d5c9a$export$39c2cb6e65c1c16b);

var $c1I7W = parcelRequire("c1I7W");
var $hRda6 = parcelRequire("hRda6");

var $jOWFe = parcelRequire("jOWFe");

var $gY2lx = parcelRequire("gY2lx");

var $37LBQ = parcelRequire("37LBQ");

var $dh9AH = parcelRequire("dh9AH");
async function $7d988759cd1d5c9a$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $c1I7W.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $37LBQ.getCookie)((0, $jOWFe.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $dh9AH.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $37LBQ.getCookie)((0, $jOWFe.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $gY2lx.getConsentToken)();
            if ((0, $hRda6.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $dh9AH.unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, $dh9AH.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}
function $7d988759cd1d5c9a$export$39c2cb6e65c1c16b() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $c1I7W.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $37LBQ.getCookie)((0, $jOWFe.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $dh9AH.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $37LBQ.getCookie)((0, $jOWFe.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) return (0, $gY2lx.getConsentToken)().then((consentToken)=>{
            if ((0, $hRda6.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $dh9AH.unpackUserPreferencesCookie)(consentToken) : undefined;
        });
        else return (0, $dh9AH.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}

});
parcelRegister("jOWFe", function(module, exports) {
$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $5d1e80d0962c8439$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $5d1e80d0962c8439$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $5d1e80d0962c8439$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $5d1e80d0962c8439$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $5d1e80d0962c8439$export$37073d560ecebada);
$parcel$export(module.exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", () => $5d1e80d0962c8439$export$5dc0026db06844f3);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $5d1e80d0962c8439$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $5d1e80d0962c8439$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $5d1e80d0962c8439$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $5d1e80d0962c8439$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $5d1e80d0962c8439$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $5d1e80d0962c8439$export$31deaeaebce525bb);

var $5MrbU = parcelRequire("5MrbU");
const $5d1e80d0962c8439$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $5d1e80d0962c8439$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $5d1e80d0962c8439$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $5d1e80d0962c8439$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $5d1e80d0962c8439$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $5d1e80d0962c8439$export$37073d560ecebada = 'atl-testing-consents';
const $5d1e80d0962c8439$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $5d1e80d0962c8439$export$b28b5d760fe14a21 = {
    [(0, $5MrbU.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $5MrbU.PreferenceCategory).Functional]: true,
    [(0, $5MrbU.PreferenceCategory).Marketing]: true,
    [(0, $5MrbU.PreferenceCategory).Analytics]: true,
    [(0, $5MrbU.PreferenceCategory).Unknown]: true
};
const $5d1e80d0962c8439$export$4a12f9e99971760a = {
    [(0, $5MrbU.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $5MrbU.PreferenceCategory).Functional]: false,
    [(0, $5MrbU.PreferenceCategory).Marketing]: false,
    [(0, $5MrbU.PreferenceCategory).Analytics]: false,
    [(0, $5MrbU.PreferenceCategory).Unknown]: false
};
const $5d1e80d0962c8439$export$f0fd1d13ec1d48f2 = {
    ...$5d1e80d0962c8439$export$4a12f9e99971760a,
    [(0, $5MrbU.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $5MrbU.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $5MrbU.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $5d1e80d0962c8439$export$f95182b7aa141c57 = '001';
const $5d1e80d0962c8439$export$1f25427b34f9c405 = '002';
const $5d1e80d0962c8439$export$31deaeaebce525bb = '003';

});

parcelRegister("gY2lx", function(module, exports) {
$parcel$export(module.exports, "getConsentToken", () => $ff8f3f9075c3dbb4$export$f1b8f2ca713fca08);

var $jOWFe = parcelRequire("jOWFe");

var $37LBQ = parcelRequire("37LBQ");

var $dBUPi = parcelRequire("dBUPi");

var $fEndq = parcelRequire("fEndq");

var $b6HUM = parcelRequire("b6HUM");
/**
 * Module-level cache of the in-flight ConsentHub fetch promise.
 * Cleared as soon as the promise settles (resolved or rejected).
 *
 * Without this, N concurrent callers that all find the consent cookie absent
 * would each independently fire a fetch to ConsentHub, causing a request
 * fan-out on every page load where multiple components call getPreferences()
 * simultaneously.
 */ let $ff8f3f9075c3dbb4$var$inFlightConsentToken = null;
const $ff8f3f9075c3dbb4$var$_getConsentToken = async ()=>{
    const fallbackConsentToken = (0, $37LBQ.getCookie)((0, $jOWFe.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $b6HUM.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $dBUPi.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $37LBQ.getCookie)((0, $jOWFe.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $fEndq.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $fEndq.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $fEndq.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};
const $ff8f3f9075c3dbb4$export$f1b8f2ca713fca08 = ()=>{
    // N concurrent callers share a single in-flight promise so only one ConsentHub fetch
    // fires per page load regardless of how many components call getPreferences() simultaneously.
    if ($ff8f3f9075c3dbb4$var$inFlightConsentToken) return $ff8f3f9075c3dbb4$var$inFlightConsentToken;
    $ff8f3f9075c3dbb4$var$inFlightConsentToken = $ff8f3f9075c3dbb4$var$_getConsentToken().finally(()=>{
        $ff8f3f9075c3dbb4$var$inFlightConsentToken = null;
    });
    return $ff8f3f9075c3dbb4$var$inFlightConsentToken;
};

});
parcelRegister("37LBQ", function(module, exports) {
$parcel$export(module.exports, "getCookie", () => $2fb95a1082b78405$export$4be65e66cfa2648a);

var $lO5Ez = parcelRequire("lO5Ez");

var $egspI = parcelRequire("egspI");

var $2rFtA = parcelRequire("2rFtA");

var $j1sAG = parcelRequire("j1sAG");
function $2fb95a1082b78405$export$4be65e66cfa2648a(key) {
    if ((0, $egspI.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, $lO5Ez.default).get(key) : (0, $lO5Ez.default).get();
    try {
        (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, $lO5Ez.default).get(key) : (0, $lO5Ez.default).get();
    } catch (e) {
        (0, $j1sAG.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});

parcelRegister("dBUPi", function(module, exports) {
$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $73e225a2e4d5036b$export$b5282052fc15e1ae);

var $jOWFe = parcelRequire("jOWFe");

var $37LBQ = parcelRequire("37LBQ");
const $73e225a2e4d5036b$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $37LBQ.getCookie)((0, $jOWFe.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("fEndq", function(module, exports) {
$parcel$export(module.exports, "setConsentTokenCookie", () => $0777c1c48eaa695e$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $0777c1c48eaa695e$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $0777c1c48eaa695e$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $0777c1c48eaa695e$export$b3365240280cb3c3);

var $egspI = parcelRequire("egspI");

var $3tqhO = parcelRequire("3tqhO");
var $j1sAG = parcelRequire("j1sAG");

var $jOWFe = parcelRequire("jOWFe");

var $6e2YE = parcelRequire("6e2YE");

var $cyWbF = parcelRequire("cyWbF");
const $0777c1c48eaa695e$var$LEGACY_CONSENT_COOKIE_LIFETIME_MINUTES = 10;
const $0777c1c48eaa695e$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 50;
const $0777c1c48eaa695e$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 70;
const $0777c1c48eaa695e$export$6e0b780517c88191 = ()=>{
    // Random offset is 0-20 minutes inclusive, so the final lifetime spreads across 50-70 minutes.
    const randomizedOffsetMinutes = Math.floor(Math.random() * ($0777c1c48eaa695e$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES - $0777c1c48eaa695e$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + 1));
    // Spread cookie expiration times to smooth traffic spikes to ConsentHub.
    return $0777c1c48eaa695e$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + randomizedOffsetMinutes;
};
// Pick once per module load so both required consent cookies share the same spread-out expiry.
const $0777c1c48eaa695e$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = $0777c1c48eaa695e$export$6e0b780517c88191();
const $0777c1c48eaa695e$var$getRequiredConsentCookieExpiryDate = ()=>{
    const expiryDate = new Date();
    const lifetimeInMinutes = (0, $egspI.fg)('platform_bsc_cookie_lifetime') ? $0777c1c48eaa695e$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES : $0777c1c48eaa695e$var$LEGACY_CONSENT_COOKIE_LIFETIME_MINUTES;
    expiryDate.setTime(expiryDate.getTime() + lifetimeInMinutes * 60000);
    return expiryDate;
};
const $0777c1c48eaa695e$export$8e560d0760f733a2 = (consentToken)=>{
    (0, $cyWbF.setStrictlyNecessaryCookie)((0, $jOWFe.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: $0777c1c48eaa695e$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $j1sAG.Logger).debug(`Set Consent Token ${(0, $jOWFe.ATLASSIAN_CONSENT_COOKIE_KEY)} ${consentToken}`);
};
const $0777c1c48eaa695e$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $cyWbF.setStrictlyNecessaryCookie)((0, $jOWFe.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $j1sAG.Logger).debug(`set fallback consent token: ${(0, $jOWFe.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)} ${consentToken}`);
};
const $0777c1c48eaa695e$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $6e2YE.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $3tqhO.getBitValueFromBool)(!!bannerVisibility);
    (0, $cyWbF.setStrictlyNecessaryCookie)((0, $jOWFe.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: $0777c1c48eaa695e$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $j1sAG.Logger).debug(`set shouldShowBannerCookie: ${(0, $jOWFe.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)} ${shouldShowBanner}`);
};
const $0777c1c48eaa695e$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $0777c1c48eaa695e$export$8e560d0760f733a2(consentToken);
    $0777c1c48eaa695e$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("3tqhO", function(module, exports) {
$parcel$export(module.exports, "getBitValueFromBool", () => $99671c0917ebf8df$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $99671c0917ebf8df$export$27647458f3cf29d2);
const $99671c0917ebf8df$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $99671c0917ebf8df$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("6e2YE", function(module, exports) {
$parcel$export(module.exports, "getBannerVisibility", () => $ad79fda258167f1d$export$bfdb9f82a9194c1e);

var $lO5Ez = parcelRequire("lO5Ez");

var $hRda6 = parcelRequire("hRda6");

var $3tqhO = parcelRequire("3tqhO");

var $jOWFe = parcelRequire("jOWFe");

var $5bfto = parcelRequire("5bfto");

var $37LBQ = parcelRequire("37LBQ");

var $dh9AH = parcelRequire("dh9AH");
const $ad79fda258167f1d$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $dh9AH.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $ad79fda258167f1d$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $ad79fda258167f1d$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $3tqhO.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $5bfto.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $ad79fda258167f1d$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $5bfto.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $ad79fda258167f1d$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $5bfto.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $ad79fda258167f1d$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $ad79fda258167f1d$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $3tqhO.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $5bfto.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
        They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
        then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)

        UX Problem:
        Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
        But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
        is infrequent (either via Account Privacy Page or once this fallback expires in a year).

        Example:
        While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
        fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
        because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...

        We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
        to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
        persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.

        Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
        consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year

        Result: Show the banner again and hope we officially recapture consents this time around
      */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $ad79fda258167f1d$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $5bfto.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $ad79fda258167f1d$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $5bfto.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $ad79fda258167f1d$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents }, ssrOptions)=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    // Detect if js-cookie has been replaced with SSR-safe version (Confluence only)
    const isJsCookieSSRSafe = typeof (0, $lO5Ez.default).__SSR_INITIALIZE_COOKIES__ === 'function';
    // Jira passes getCookie explicitly via ssrOptions - it works on both SSR and CSR.
    const ssrFriendlyGetCookie = ssrOptions?.getCookie;
    let fallbackConsentToken;
    if (ssrFriendlyGetCookie) fallbackConsentToken = fallbackConsents || ssrFriendlyGetCookie((0, $jOWFe.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    else fallbackConsentToken = (0, $hRda6.isSSR)() ? fallbackConsents || (isJsCookieSSRSafe ? (0, $37LBQ.getCookie)((0, $jOWFe.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)) : undefined) : fallbackConsents || (0, $37LBQ.getCookie)((0, $jOWFe.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $ad79fda258167f1d$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $3tqhO.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $ad79fda258167f1d$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $ad79fda258167f1d$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});
parcelRegister("5bfto", function(module, exports) {
$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", () => $69cc859d6fffc61b$export$42b0ca8aba2631e4);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $69cc859d6fffc61b$export$497a647f0eb30ef4);
$parcel$export(module.exports, "serializeConsents", () => $69cc859d6fffc61b$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $69cc859d6fffc61b$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $69cc859d6fffc61b$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $69cc859d6fffc61b$export$3387347b75450ae1);
$parcel$export(module.exports, "hasPrefetchedDataConsents", () => $69cc859d6fffc61b$export$7133f415a79804e8);
$parcel$export(module.exports, "StatusCodeError", () => $69cc859d6fffc61b$export$a79c0ea3d7c2444a);

var $3tqhO = parcelRequire("3tqhO");

var $jOWFe = parcelRequire("jOWFe");

var $37LBQ = parcelRequire("37LBQ");

var $5MrbU = parcelRequire("5MrbU");

var $hdiJE = parcelRequire("hdiJE");
const $69cc859d6fffc61b$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $jOWFe.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $69cc859d6fffc61b$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $jOWFe.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $69cc859d6fffc61b$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($69cc859d6fffc61b$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $69cc859d6fffc61b$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $69cc859d6fffc61b$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $69cc859d6fffc61b$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $69cc859d6fffc61b$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $3tqhO.getBoolFromBitValue)(consentToken[7]);
    return isDefaultTokenV3;
};
const $69cc859d6fffc61b$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $jOWFe.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $jOWFe.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $5MrbU.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $5MrbU.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $3tqhO.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $5MrbU.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $3tqhO.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $3tqhO.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $69cc859d6fffc61b$export$42a0b3fb1e53e7b9 = (consents)=>{
    const version = (0, $jOWFe.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $3tqhO.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $hdiJE.ConsentHubKey).Functional)?.granted);
    const analyticsConsent = (0, $3tqhO.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $hdiJE.ConsentHubKey).Analytics)?.granted);
    const marketingConsent = (0, $3tqhO.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $hdiJE.ConsentHubKey).Marketing)?.granted);
    const unknownConsent = (0, $3tqhO.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $hdiJE.ConsentHubKey).Unknown)?.granted);
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $69cc859d6fffc61b$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $37LBQ.getCookie)((0, $jOWFe.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $69cc859d6fffc61b$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $69cc859d6fffc61b$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $69cc859d6fffc61b$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $69cc859d6fffc61b$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $5MrbU.PreferenceCategory).StrictlyNecessary,
        (0, $5MrbU.PreferenceCategory).Functional,
        (0, $5MrbU.PreferenceCategory).Analytics,
        (0, $5MrbU.PreferenceCategory).Marketing,
        (0, $5MrbU.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $5MrbU.PreferenceCategory).StrictlyNecessary]: (0, $hdiJE.ConsentHubKey).StrictlyNecessary,
        [(0, $5MrbU.PreferenceCategory).Functional]: (0, $hdiJE.ConsentHubKey).Functional,
        [(0, $5MrbU.PreferenceCategory).Analytics]: (0, $hdiJE.ConsentHubKey).Analytics,
        [(0, $5MrbU.PreferenceCategory).Marketing]: (0, $hdiJE.ConsentHubKey).Marketing,
        [(0, $5MrbU.PreferenceCategory).Unknown]: (0, $hdiJE.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $69cc859d6fffc61b$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $69cc859d6fffc61b$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
const $69cc859d6fffc61b$export$7133f415a79804e8 = (preferences)=>{
    if (!preferences) return false;
    const prefetchedToken = 'consentToken' in preferences && preferences.consentToken;
    const prefetchedTokenIsDefault = $69cc859d6fffc61b$export$497a647f0eb30ef4(prefetchedToken || '');
    const hasLegitConsentToken = prefetchedToken && !prefetchedTokenIsDefault;
    const prefetchedConsents = 'consents' in preferences && preferences.consents;
    const hasLegitConsents = prefetchedConsents && Array.isArray(prefetchedConsents) && prefetchedConsents.length > 0;
    return Boolean(hasLegitConsentToken || hasLegitConsents);
};
class $69cc859d6fffc61b$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, $69cc859d6fffc61b$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $69cc859d6fffc61b$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("hdiJE", function(module, exports) {
$parcel$export(module.exports, "ConsentHubKey", () => $5f296b48f4a99b87$export$31140359b1e505cf);
var $5f296b48f4a99b87$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});


parcelRegister("dh9AH", function(module, exports) {
$parcel$export(module.exports, "checkTokenVersionValidity", () => $db5467ae86c96645$export$64b31470e8522819);
$parcel$export(module.exports, "packUserPreferences", () => $db5467ae86c96645$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $db5467ae86c96645$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initialPreferencesAreMissing", () => $db5467ae86c96645$export$67f70eb55341bd29);
$parcel$export(module.exports, "initializePreferencesData", () => $db5467ae86c96645$export$7962405c3ca274b1);

var $c1I7W = parcelRequire("c1I7W");

var $3tqhO = parcelRequire("3tqhO");

var $jOWFe = parcelRequire("jOWFe");

var $5bfto = parcelRequire("5bfto");

var $5MrbU = parcelRequire("5MrbU");
const $db5467ae86c96645$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $jOWFe.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $jOWFe.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $jOWFe.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $jOWFe.V001_SCHEMA_KEY),
        (0, $jOWFe.V002_SCHEMA_KEY),
        (0, $jOWFe.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $db5467ae86c96645$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $jOWFe.V001_SCHEMA_KEY);
    return [
        version,
        (0, $3tqhO.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $3tqhO.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $3tqhO.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $3tqhO.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $db5467ae86c96645$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $5MrbU.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $5MrbU.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $5MrbU.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $5MrbU.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $5MrbU.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $db5467ae86c96645$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $jOWFe.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $5MrbU.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $5MrbU.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $5MrbU.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $5MrbU.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $5MrbU.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $3tqhO.getBitValueFromBool)(userPreferences[(0, $5MrbU.PreferenceCategory).Functional]),
        (0, $3tqhO.getBitValueFromBool)(userPreferences[(0, $5MrbU.PreferenceCategory).Analytics]),
        (0, $3tqhO.getBitValueFromBool)(userPreferences[(0, $5MrbU.PreferenceCategory).Marketing]),
        (0, $3tqhO.getBitValueFromBool)(userPreferences[(0, $5MrbU.PreferenceCategory).Unknown]),
        (0, $3tqhO.getBitValueFromBool)(isDefaultConsentBit),
        (0, $3tqhO.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $3tqhO.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $db5467ae86c96645$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $5bfto.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$db5467ae86c96645$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $5MrbU.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $5MrbU.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $5MrbU.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $db5467ae86c96645$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $jOWFe.V003_SCHEMA_KEY);
    return [
        version,
        (0, $3tqhO.getBitValueFromBool)(userPreferences[(0, $5MrbU.PreferenceCategory).Functional]),
        (0, $3tqhO.getBitValueFromBool)(userPreferences[(0, $5MrbU.PreferenceCategory).Analytics]),
        (0, $3tqhO.getBitValueFromBool)(userPreferences[(0, $5MrbU.PreferenceCategory).Marketing]),
        (0, $3tqhO.getBitValueFromBool)(userPreferences[(0, $5MrbU.PreferenceCategory).Unknown]),
        (0, $3tqhO.getBitValueFromBool)(userPreferences[(0, $5MrbU.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $3tqhO.getBitValueFromBool)(userPreferences[(0, $5MrbU.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $3tqhO.getBitValueFromBool)(userPreferences[(0, $5MrbU.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $db5467ae86c96645$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $5MrbU.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $5MrbU.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $5MrbU.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $5MrbU.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $5MrbU.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $5MrbU.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $5MrbU.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $5MrbU.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $db5467ae86c96645$var$V002SpecificBitKeys = [
    (0, $5MrbU.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $5MrbU.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $5MrbU.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $5MrbU.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $5MrbU.ConsentPreferenceV2).ConsentedUnderFADP
];
const $db5467ae86c96645$var$V003SpecificBitKeys = [
    (0, $5MrbU.ContextualConsentProperty).ConsentsAreDefault,
    (0, $5MrbU.ContextualConsentProperty).UserIsAuthenticated,
    (0, $5MrbU.ContextualConsentProperty).ConsentDataUnavailable
];
function $db5467ae86c96645$export$3199823fec979bd1(userPreferences) {
    if ((0, $c1I7W.getBscGlobalState)().localConsentMode) return $db5467ae86c96645$var$packPrefsVersion001(userPreferences);
    const isV002 = $db5467ae86c96645$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $db5467ae86c96645$var$packPrefsVersion002(userPreferences);
    const isV003 = $db5467ae86c96645$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $db5467ae86c96645$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $db5467ae86c96645$var$packPrefsVersion001(userPreferences);
}
function $db5467ae86c96645$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $c1I7W.getBscGlobalState)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $jOWFe.V001_SCHEMA_KEY)) return $db5467ae86c96645$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $db5467ae86c96645$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $db5467ae86c96645$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $db5467ae86c96645$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $db5467ae86c96645$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $db5467ae86c96645$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $db5467ae86c96645$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $5MrbU.PrefetchedPreferenceState).INTERNAL) {
        if ($db5467ae86c96645$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $db5467ae86c96645$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $5bfto.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $db5467ae86c96645$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $5MrbU.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

});


parcelRegister("cyWbF", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $862bd53cdb142819$export$93509ff9a62ee022);

var $lO5Ez = parcelRequire("lO5Ez");

var $egspI = parcelRequire("egspI");

var $c1I7W = parcelRequire("c1I7W");
var $2rFtA = parcelRequire("2rFtA");

var $j1sAG = parcelRequire("j1sAG");
const $862bd53cdb142819$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $egspI.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, $lO5Ez.default).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        if (!(0, $c1I7W.getBscGlobalState)().hasInitialized && (0, $egspI.fg)('platform_bsc_initialize_controls_analytics')) (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: 'Cookie'
            }
        });
        (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, $lO5Ez.default).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $j1sAG.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};

});


parcelRegister("b6HUM", function(module, exports) {
$parcel$export(module.exports, "getValidConsentData", () => $102db037228fd397$export$c515de1cc9cebc71);

var $jOWFe = parcelRequire("jOWFe");

var $i8BPS = parcelRequire("i8BPS");

var $dh9AH = parcelRequire("dh9AH");
const $102db037228fd397$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $i8BPS.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $dh9AH.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else {
            const version = (0, $jOWFe.V003_SCHEMA_KEY);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        }
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});
parcelRegister("i8BPS", function(module, exports) {
$parcel$export(module.exports, "buildConsentPreferences", () => $5a565cd805bb0d2f$export$bd9f5bcbf9cd947c);
$parcel$export(module.exports, "fetchConsentPreferences", () => $5a565cd805bb0d2f$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $5a565cd805bb0d2f$export$f8422650c3dec8b2);

var $egspI = parcelRequire("egspI");

var $j1sAG = parcelRequire("j1sAG");

var $5bfto = parcelRequire("5bfto");
const $5a565cd805bb0d2f$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $5a565cd805bb0d2f$var$POST_CONSENTS_URL = `${$5a565cd805bb0d2f$var$BASE_CONSENTS_URL}/user`;
const $5a565cd805bb0d2f$var$GET_CONSENTS_URL = `${$5a565cd805bb0d2f$var$POST_CONSENTS_URL}/consents/cookies`;
const $5a565cd805bb0d2f$var$getConsentHubHeaders = ()=>({
        'Content-Type': 'application/json',
        ...(0, $egspI.fg)('platform_bsc_consent_hub_x_origin') ? {
            'X-Request-Origin': 'bsc'
        } : {}
    });
const $5a565cd805bb0d2f$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $5bfto.serializeConsents)(consentData);
        const consentTimestamp = (0, $5bfto.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $5bfto.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $5a565cd805bb0d2f$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$5a565cd805bb0d2f$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: $5a565cd805bb0d2f$var$getConsentHubHeaders()
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $5a565cd805bb0d2f$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $j1sAG.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $5a565cd805bb0d2f$export$bd9f5bcbf9cd947c();
    }
};
const $5a565cd805bb0d2f$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $5bfto.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $5a565cd805bb0d2f$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$5a565cd805bb0d2f$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: $5a565cd805bb0d2f$var$getConsentHubHeaders(),
            body: $5a565cd805bb0d2f$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $5bfto.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $j1sAG.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

});





parcelRegister("lbJxq", function(module, exports) {
$parcel$export(module.exports, "ItemKeyCache", () => $f99a14f8b0ed38f2$export$ff3c91e80f54f26c);

var $5MrbU = parcelRequire("5MrbU");
class $f99a14f8b0ed38f2$var$ItemKeyCacheService {
    constructor(){
        this.cache = Object.fromEntries(Object.keys((0, $5MrbU.CategoryStorageType)).map((storageType)=>{
            return [
                storageType,
                new Set()
            ];
        }));
    }
    markSetByPackage(storageType, itemKey) {
        this.cache[storageType].add(itemKey);
    }
    wasSetByPackage(storageType, itemKey) {
        return this.cache[storageType].has(itemKey);
    }
}
const $f99a14f8b0ed38f2$export$ff3c91e80f54f26c = new $f99a14f8b0ed38f2$var$ItemKeyCacheService();

});

parcelRegister("jTLe5", function(module, exports) {
$parcel$export(module.exports, "reportSetItemError", () => $4d39c0d75d17c5ac$export$ba6a684424c69e54);

var $egspI = parcelRequire("egspI");

var $j1sAG = parcelRequire("j1sAG");
/**
 * Identifies browser "quota exceeded" storage failures across the cross-browser variants (per MDN's
 * `Storage.setItem` exceptions): modern browsers throw a `DOMException` named `QuotaExceededError`;
 * legacy WebKit/Blink expose the numeric `code === 22` (`QUOTA_EXCEEDED_ERR`); Firefox historically
 * throws `NS_ERROR_DOM_QUOTA_REACHED` with `code === 1014`.
 */ const $4d39c0d75d17c5ac$var$isQuotaExceededError = (error)=>{
    if (!error || typeof error !== 'object') return false;
    const { name: name, code: code } = error;
    return name === 'QuotaExceededError' || name === 'NS_ERROR_DOM_QUOTA_REACHED' || code === 22 || code === 1014;
};
const $4d39c0d75d17c5ac$export$ba6a684424c69e54 = ({ message: message, attributes: attributes, error: error })=>{
    if ($4d39c0d75d17c5ac$var$isQuotaExceededError(error) && (0, $egspI.fg)('platform_bsc_filter_quota_exceeded_set_item_errors')) {
        (0, $j1sAG.Logger).error(message);
        return;
    }
    (0, $j1sAG.Logger).errorWithOperationalEvent({
        action: 'usedAtlBrowserStorageSetItemError',
        message: message,
        attributes: attributes
    });
};

});


parcelRegister("dlEKC", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryStorageItem", () => $cf17a960ac1519c9$export$f1b0c189562aa9fd);

var $2rFtA = parcelRequire("2rFtA");

var $j1sAG = parcelRequire("j1sAG");

var $5MrbU = parcelRequire("5MrbU");

var $lbJxq = parcelRequire("lbJxq");

var $gCCe7 = parcelRequire("gCCe7");
const $cf17a960ac1519c9$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
        // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
        (0, $lbJxq.ItemKeyCache).markSetByPackage(storageType === (0, $gCCe7.WebStorageType).LocalStorage ? (0, $5MrbU.CategoryStorageType).LocalStorage : (0, $5MrbU.CategoryStorageType).SessionStorage, itemKey);
        browserStorage.setItem(itemKey, value);
        return (0, $5MrbU.Status).SUCCESS;
    } catch (e) {
        (0, $j1sAG.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $5MrbU.Status).FAILED;
    }
};

});


parcelRegister("3zQkx", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $9c14dcdc4910cbf2$export$6e8ea24b15199873);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
function $9c14dcdc4910cbf2$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $e79Pd.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $e79Pd.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("82QkS", function(module, exports) {
$parcel$export(module.exports, "z", () => (parcelRequire("iO6In")));

var $7qPhU = parcelRequire("7qPhU");
var $5db71b66501b3311$export$2e2bcd8739ae039 = (0, $7qPhU.default);

});
parcelRegister("7qPhU", function(module, exports) {
$parcel$export(module.exports, "default", () => $5692beca66c9379b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "z", () => (parcelRequire("iO6In")));

var $iO6In = parcelRequire("iO6In");
var $5692beca66c9379b$export$2e2bcd8739ae039 = $iO6In;

});
parcelRegister("iO6In", function(module, exports) {

var $g6DDZ = parcelRequire("g6DDZ");

var $8I00d = parcelRequire("8I00d");

var $gxrlC = parcelRequire("gxrlC");

var $bQlTp = parcelRequire("bQlTp");

var $bxL52 = parcelRequire("bxL52");

var $8Fc3i = parcelRequire("8Fc3i");
$parcel$exportWildcard(module.exports, $g6DDZ);
$parcel$exportWildcard(module.exports, $8I00d);
$parcel$exportWildcard(module.exports, $gxrlC);
$parcel$exportWildcard(module.exports, $bQlTp);
$parcel$exportWildcard(module.exports, $bxL52);
$parcel$exportWildcard(module.exports, $8Fc3i);

});
parcelRegister("g6DDZ", function(module, exports) {
$parcel$export(module.exports, "setErrorMap", () => $bb9bf5583d2ed0cd$export$1097a8289cfd22d7);
$parcel$export(module.exports, "getErrorMap", () => $bb9bf5583d2ed0cd$export$32f27c719778d4c4);
$parcel$export(module.exports, "defaultErrorMap", () => (parcelRequire("atFSE")).default);

var $atFSE = parcelRequire("atFSE");
let $bb9bf5583d2ed0cd$var$overrideErrorMap = (0, $atFSE.default);
function $bb9bf5583d2ed0cd$export$1097a8289cfd22d7(map) {
    $bb9bf5583d2ed0cd$var$overrideErrorMap = map;
}
function $bb9bf5583d2ed0cd$export$32f27c719778d4c4() {
    return $bb9bf5583d2ed0cd$var$overrideErrorMap;
}

});
parcelRegister("atFSE", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a0d196d25f67b11$export$2e2bcd8739ae039);

var $8Fc3i = parcelRequire("8Fc3i");

var $bQlTp = parcelRequire("bQlTp");
const $7a0d196d25f67b11$var$errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case (0, $8Fc3i.ZodIssueCode).invalid_type:
            if (issue.received === (0, $bQlTp.ZodParsedType).undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case (0, $8Fc3i.ZodIssueCode).invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, (0, $bQlTp.util).jsonStringifyReplacer)}`;
            break;
        case (0, $8Fc3i.ZodIssueCode).unrecognized_keys:
            message = `Unrecognized key(s) in object: ${(0, $bQlTp.util).joinValues(issue.keys, ", ")}`;
            break;
        case (0, $8Fc3i.ZodIssueCode).invalid_union:
            message = `Invalid input`;
            break;
        case (0, $8Fc3i.ZodIssueCode).invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${(0, $bQlTp.util).joinValues(issue.options)}`;
            break;
        case (0, $8Fc3i.ZodIssueCode).invalid_enum_value:
            message = `Invalid enum value. Expected ${(0, $bQlTp.util).joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case (0, $8Fc3i.ZodIssueCode).invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case (0, $8Fc3i.ZodIssueCode).invalid_return_type:
            message = `Invalid function return type`;
            break;
        case (0, $8Fc3i.ZodIssueCode).invalid_date:
            message = `Invalid date`;
            break;
        case (0, $8Fc3i.ZodIssueCode).invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else (0, $bQlTp.util).assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case (0, $8Fc3i.ZodIssueCode).too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case (0, $8Fc3i.ZodIssueCode).too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case (0, $8Fc3i.ZodIssueCode).custom:
            message = `Invalid input`;
            break;
        case (0, $8Fc3i.ZodIssueCode).invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case (0, $8Fc3i.ZodIssueCode).not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case (0, $8Fc3i.ZodIssueCode).not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            (0, $bQlTp.util).assertNever(issue);
    }
    return {
        message: message
    };
};
var $7a0d196d25f67b11$export$2e2bcd8739ae039 = $7a0d196d25f67b11$var$errorMap;

});
parcelRegister("8Fc3i", function(module, exports) {
$parcel$export(module.exports, "ZodIssueCode", () => $64eb805f0034ff16$export$5ba560653e4a1035);
$parcel$export(module.exports, "quotelessJson", () => $64eb805f0034ff16$export$913eddeaf297cfea);
$parcel$export(module.exports, "ZodError", () => $64eb805f0034ff16$export$f98dac4b251ab333);

var $bQlTp = parcelRequire("bQlTp");
const $64eb805f0034ff16$export$5ba560653e4a1035 = (0, $bQlTp.util).arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $64eb805f0034ff16$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $64eb805f0034ff16$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $64eb805f0034ff16$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, (0, $bQlTp.util).jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$64eb805f0034ff16$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $64eb805f0034ff16$export$f98dac4b251ab333(issues);
    return error;
};

});
parcelRegister("bQlTp", function(module, exports) {
$parcel$export(module.exports, "util", () => $89f5887c8a03a61d$export$7debb50ef11d5e0b);
$parcel$export(module.exports, "objectUtil", () => $89f5887c8a03a61d$export$4aa2142c225fd5c7);
$parcel$export(module.exports, "ZodParsedType", () => $89f5887c8a03a61d$export$5716da67bfaa244d);
$parcel$export(module.exports, "getParsedType", () => $89f5887c8a03a61d$export$3e9057828ebd5c7a);
var $89f5887c8a03a61d$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($89f5887c8a03a61d$export$7debb50ef11d5e0b || ($89f5887c8a03a61d$export$7debb50ef11d5e0b = {}));
var $89f5887c8a03a61d$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($89f5887c8a03a61d$export$4aa2142c225fd5c7 || ($89f5887c8a03a61d$export$4aa2142c225fd5c7 = {}));
const $89f5887c8a03a61d$export$5716da67bfaa244d = $89f5887c8a03a61d$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $89f5887c8a03a61d$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $89f5887c8a03a61d$export$5716da67bfaa244d.undefined;
        case "string":
            return $89f5887c8a03a61d$export$5716da67bfaa244d.string;
        case "number":
            return Number.isNaN(data) ? $89f5887c8a03a61d$export$5716da67bfaa244d.nan : $89f5887c8a03a61d$export$5716da67bfaa244d.number;
        case "boolean":
            return $89f5887c8a03a61d$export$5716da67bfaa244d.boolean;
        case "function":
            return $89f5887c8a03a61d$export$5716da67bfaa244d.function;
        case "bigint":
            return $89f5887c8a03a61d$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $89f5887c8a03a61d$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $89f5887c8a03a61d$export$5716da67bfaa244d.array;
            if (data === null) return $89f5887c8a03a61d$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $89f5887c8a03a61d$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $89f5887c8a03a61d$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $89f5887c8a03a61d$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $89f5887c8a03a61d$export$5716da67bfaa244d.date;
            return $89f5887c8a03a61d$export$5716da67bfaa244d.object;
        default:
            return $89f5887c8a03a61d$export$5716da67bfaa244d.unknown;
    }
};

});




parcelRegister("8I00d", function(module, exports) {
$parcel$export(module.exports, "makeIssue", () => $65726f49a35c1dfe$export$244a85fde9c419ed);
$parcel$export(module.exports, "EMPTY_PATH", () => $65726f49a35c1dfe$export$1526d2e05f74572);
$parcel$export(module.exports, "addIssueToContext", () => $65726f49a35c1dfe$export$db7caee60e5d514d);
$parcel$export(module.exports, "ParseStatus", () => $65726f49a35c1dfe$export$5b20a5c3d05c1f6f);
$parcel$export(module.exports, "INVALID", () => $65726f49a35c1dfe$export$9a105a556e65c2c0);
$parcel$export(module.exports, "DIRTY", () => $65726f49a35c1dfe$export$325a211da9693fcf);
$parcel$export(module.exports, "OK", () => $65726f49a35c1dfe$export$c6813a8d51f77eaf);
$parcel$export(module.exports, "isAborted", () => $65726f49a35c1dfe$export$afa861e3c5730743);
$parcel$export(module.exports, "isDirty", () => $65726f49a35c1dfe$export$910b6cdd390341b3);
$parcel$export(module.exports, "isValid", () => $65726f49a35c1dfe$export$1ea939691cdc45b8);
$parcel$export(module.exports, "isAsync", () => $65726f49a35c1dfe$export$aefee5ebe1dcfd9e);

var $g6DDZ = parcelRequire("g6DDZ");

var $atFSE = parcelRequire("atFSE");
const $65726f49a35c1dfe$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $65726f49a35c1dfe$export$1526d2e05f74572 = [];
function $65726f49a35c1dfe$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = (0, $g6DDZ.getErrorMap)();
    const issue = $65726f49a35c1dfe$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === (0, $atFSE.default) ? undefined : (0, $atFSE.default)
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $65726f49a35c1dfe$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $65726f49a35c1dfe$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $65726f49a35c1dfe$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $65726f49a35c1dfe$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $65726f49a35c1dfe$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $65726f49a35c1dfe$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $65726f49a35c1dfe$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $65726f49a35c1dfe$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $65726f49a35c1dfe$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $65726f49a35c1dfe$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $65726f49a35c1dfe$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $65726f49a35c1dfe$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;

});

parcelRegister("gxrlC", function(module, exports) {

});

parcelRegister("bxL52", function(module, exports) {
$parcel$export(module.exports, "ZodType", () => $86774bf5ad4be3c6$export$2afb8ab49d4b92c0);
$parcel$export(module.exports, "ZodEffects", () => $86774bf5ad4be3c6$export$a60af00cc0ce2582);
$parcel$export(module.exports, "ZodFirstPartyTypeKind", () => $86774bf5ad4be3c6$export$558106ce543bd011);
$parcel$export(module.exports, "ZodOptional", () => $86774bf5ad4be3c6$export$aa56fec1e9d629b8);
$parcel$export(module.exports, "ZodNullable", () => $86774bf5ad4be3c6$export$aaac0b8b429cef5);
$parcel$export(module.exports, "ZodArray", () => $86774bf5ad4be3c6$export$7acfc3e64785411);
$parcel$export(module.exports, "ZodPromise", () => $86774bf5ad4be3c6$export$3f196b0127d6e50a);
$parcel$export(module.exports, "ZodUnion", () => $86774bf5ad4be3c6$export$a8b236cb5070a311);
$parcel$export(module.exports, "ZodIntersection", () => $86774bf5ad4be3c6$export$c02deaf0bb5203d4);
$parcel$export(module.exports, "ZodDefault", () => $86774bf5ad4be3c6$export$bb19b37874861e7e);
$parcel$export(module.exports, "ZodBranded", () => $86774bf5ad4be3c6$export$66b0c798a395271f);
$parcel$export(module.exports, "ZodCatch", () => $86774bf5ad4be3c6$export$75a44ec6249ac76b);
$parcel$export(module.exports, "ZodPipeline", () => $86774bf5ad4be3c6$export$a3c3ef8a0e95c6da);
$parcel$export(module.exports, "ZodReadonly", () => $86774bf5ad4be3c6$export$5d1f7ef05c4e493a);
$parcel$export(module.exports, "datetimeRegex", () => $86774bf5ad4be3c6$export$a4b563879add27a);
$parcel$export(module.exports, "ZodString", () => $86774bf5ad4be3c6$export$1230eb29b8d3b502);
$parcel$export(module.exports, "ZodNumber", () => $86774bf5ad4be3c6$export$5b070a55c0c43e09);
$parcel$export(module.exports, "ZodBigInt", () => $86774bf5ad4be3c6$export$67d741fd70ff98f4);
$parcel$export(module.exports, "ZodBoolean", () => $86774bf5ad4be3c6$export$723d146f80596191);
$parcel$export(module.exports, "ZodDate", () => $86774bf5ad4be3c6$export$e974be33bdc55521);
$parcel$export(module.exports, "ZodSymbol", () => $86774bf5ad4be3c6$export$bcc3b40f6b638044);
$parcel$export(module.exports, "ZodUndefined", () => $86774bf5ad4be3c6$export$4e780e961c30340d);
$parcel$export(module.exports, "ZodNull", () => $86774bf5ad4be3c6$export$a96281f914484f2d);
$parcel$export(module.exports, "ZodAny", () => $86774bf5ad4be3c6$export$b9d1edb536b4e4eb);
$parcel$export(module.exports, "ZodUnknown", () => $86774bf5ad4be3c6$export$ef3b1bb1630977ae);
$parcel$export(module.exports, "ZodNever", () => $86774bf5ad4be3c6$export$1e576a20c3ce9fb5);
$parcel$export(module.exports, "ZodVoid", () => $86774bf5ad4be3c6$export$7d39f5df85f21031);
$parcel$export(module.exports, "ZodObject", () => $86774bf5ad4be3c6$export$736315c5b55efbad);
$parcel$export(module.exports, "ZodTuple", () => $86774bf5ad4be3c6$export$e2a18bb771d8e6a3);
$parcel$export(module.exports, "ZodLazy", () => $86774bf5ad4be3c6$export$378d0cfce37406e6);
$parcel$export(module.exports, "ZodLiteral", () => $86774bf5ad4be3c6$export$7e44096782a165d3);
$parcel$export(module.exports, "ZodEnum", () => $86774bf5ad4be3c6$export$d325d1f0e1c20179);
$parcel$export(module.exports, "ZodNativeEnum", () => $86774bf5ad4be3c6$export$370b2e8d6d6f5c56);
$parcel$export(module.exports, "ZodDiscriminatedUnion", () => $86774bf5ad4be3c6$export$5ef2424805ac76a3);
$parcel$export(module.exports, "ZodRecord", () => $86774bf5ad4be3c6$export$a2acc09968cb4b7f);
$parcel$export(module.exports, "ZodMap", () => $86774bf5ad4be3c6$export$163b6a2b712d9542);
$parcel$export(module.exports, "ZodSet", () => $86774bf5ad4be3c6$export$977057706f816712);
$parcel$export(module.exports, "ZodFunction", () => $86774bf5ad4be3c6$export$d4602ba55673f53c);
$parcel$export(module.exports, "ZodTransformer", () => $86774bf5ad4be3c6$export$a60af00cc0ce2582);
$parcel$export(module.exports, "ZodNaN", () => $86774bf5ad4be3c6$export$26ccfa0145e8511f);
$parcel$export(module.exports, "BRAND", () => $86774bf5ad4be3c6$export$cf2deea74cde46b4);
$parcel$export(module.exports, "custom", () => $86774bf5ad4be3c6$export$4c00f665f0d4b443);
$parcel$export(module.exports, "Schema", () => $86774bf5ad4be3c6$export$2afb8ab49d4b92c0);
$parcel$export(module.exports, "ZodSchema", () => $86774bf5ad4be3c6$export$2afb8ab49d4b92c0);
$parcel$export(module.exports, "late", () => $86774bf5ad4be3c6$export$1ee8ee30835eab8b);
$parcel$export(module.exports, "instanceof", () => $86774bf5ad4be3c6$export$3d916e7c22dbd8b5);
$parcel$export(module.exports, "string", () => $86774bf5ad4be3c6$export$22b082955e083ec3);
$parcel$export(module.exports, "number", () => $86774bf5ad4be3c6$export$98e628dec113755e);
$parcel$export(module.exports, "nan", () => $86774bf5ad4be3c6$export$9e06de0973666692);
$parcel$export(module.exports, "bigint", () => $86774bf5ad4be3c6$export$a0f65b52274bcc00);
$parcel$export(module.exports, "boolean", () => $86774bf5ad4be3c6$export$4a21f16c33752377);
$parcel$export(module.exports, "date", () => $86774bf5ad4be3c6$export$324d90190a8b822a);
$parcel$export(module.exports, "symbol", () => $86774bf5ad4be3c6$export$8f701197936bc2a6);
$parcel$export(module.exports, "undefined", () => $86774bf5ad4be3c6$export$1db45310990710a5);
$parcel$export(module.exports, "null", () => $86774bf5ad4be3c6$export$7b1b591b262c240);
$parcel$export(module.exports, "any", () => $86774bf5ad4be3c6$export$4154a199d7d90455);
$parcel$export(module.exports, "unknown", () => $86774bf5ad4be3c6$export$19282c40b967aec6);
$parcel$export(module.exports, "never", () => $86774bf5ad4be3c6$export$b3e22bcfd64c1022);
$parcel$export(module.exports, "void", () => $86774bf5ad4be3c6$export$490e536ee7389aeb);
$parcel$export(module.exports, "array", () => $86774bf5ad4be3c6$export$2f23118c22fb2630);
$parcel$export(module.exports, "object", () => $86774bf5ad4be3c6$export$be5493f9613cbbe);
$parcel$export(module.exports, "strictObject", () => $86774bf5ad4be3c6$export$8fb0df5f40d0b477);
$parcel$export(module.exports, "union", () => $86774bf5ad4be3c6$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "discriminatedUnion", () => $86774bf5ad4be3c6$export$4b888e40c4ee26dd);
$parcel$export(module.exports, "intersection", () => $86774bf5ad4be3c6$export$bc86dfbf7795668c);
$parcel$export(module.exports, "tuple", () => $86774bf5ad4be3c6$export$65e3907585753458);
$parcel$export(module.exports, "record", () => $86774bf5ad4be3c6$export$e5185e241753e543);
$parcel$export(module.exports, "map", () => $86774bf5ad4be3c6$export$871de8747c9eaa88);
$parcel$export(module.exports, "set", () => $86774bf5ad4be3c6$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "function", () => $86774bf5ad4be3c6$export$44e51c8aac7c2deb);
$parcel$export(module.exports, "lazy", () => $86774bf5ad4be3c6$export$488013bae63b21da);
$parcel$export(module.exports, "literal", () => $86774bf5ad4be3c6$export$c8ec6e1ec9fefcb0);
$parcel$export(module.exports, "enum", () => $86774bf5ad4be3c6$export$78a99c8d44d72635);
$parcel$export(module.exports, "nativeEnum", () => $86774bf5ad4be3c6$export$6fe7eca19ebe5199);
$parcel$export(module.exports, "promise", () => $86774bf5ad4be3c6$export$c957ef27a0ebfd4);
$parcel$export(module.exports, "effect", () => $86774bf5ad4be3c6$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "optional", () => $86774bf5ad4be3c6$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "nullable", () => $86774bf5ad4be3c6$export$133fc36489ac9add);
$parcel$export(module.exports, "preprocess", () => $86774bf5ad4be3c6$export$fc37fe19dfda43ee);
$parcel$export(module.exports, "pipeline", () => $86774bf5ad4be3c6$export$43f28b24e1eb8181);
$parcel$export(module.exports, "ostring", () => $86774bf5ad4be3c6$export$3b3d07727c5b702c);
$parcel$export(module.exports, "onumber", () => $86774bf5ad4be3c6$export$eb150471a61fced6);
$parcel$export(module.exports, "oboolean", () => $86774bf5ad4be3c6$export$269251733cdcbbf1);
$parcel$export(module.exports, "coerce", () => $86774bf5ad4be3c6$export$8c14e57e778d3873);
$parcel$export(module.exports, "transformer", () => $86774bf5ad4be3c6$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "NEVER", () => $86774bf5ad4be3c6$export$96c94437c95d7862);

var $8Fc3i = parcelRequire("8Fc3i");
parcelRequire("g6DDZ");
var $atFSE = parcelRequire("atFSE");
var $g6DDZ = parcelRequire("g6DDZ");

var $2KEZx = parcelRequire("2KEZx");

var $8I00d = parcelRequire("8I00d");

var $bQlTp = parcelRequire("bQlTp");
class $86774bf5ad4be3c6$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $86774bf5ad4be3c6$var$handleResult = (ctx, result)=>{
    if ((0, $8I00d.isValid)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new (0, $8Fc3i.ZodError)(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $86774bf5ad4be3c6$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, $bQlTp.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, $bQlTp.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new (0, $8I00d.ParseStatus)(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, $bQlTp.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, $8I00d.isAsync)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $bQlTp.getParsedType)(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $86774bf5ad4be3c6$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $bQlTp.getParsedType)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return (0, $8I00d.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>(0, $8I00d.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $bQlTp.getParsedType)(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, $8I00d.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $86774bf5ad4be3c6$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: (0, $8Fc3i.ZodIssueCode).custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $86774bf5ad4be3c6$export$a60af00cc0ce2582({
            schema: this,
            typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return $86774bf5ad4be3c6$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $86774bf5ad4be3c6$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $86774bf5ad4be3c6$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $86774bf5ad4be3c6$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $86774bf5ad4be3c6$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $86774bf5ad4be3c6$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $86774bf5ad4be3c6$export$a60af00cc0ce2582({
            ...$86774bf5ad4be3c6$var$processCreateParams(this._def),
            schema: this,
            typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $86774bf5ad4be3c6$export$bb19b37874861e7e({
            ...$86774bf5ad4be3c6$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $86774bf5ad4be3c6$export$66b0c798a395271f({
            typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$86774bf5ad4be3c6$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $86774bf5ad4be3c6$export$75a44ec6249ac76b({
            ...$86774bf5ad4be3c6$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $86774bf5ad4be3c6$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $86774bf5ad4be3c6$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $86774bf5ad4be3c6$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $86774bf5ad4be3c6$var$cuid2Regex = /^[0-9a-z]+$/;
const $86774bf5ad4be3c6$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $86774bf5ad4be3c6$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $86774bf5ad4be3c6$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $86774bf5ad4be3c6$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $86774bf5ad4be3c6$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $86774bf5ad4be3c6$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $86774bf5ad4be3c6$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $86774bf5ad4be3c6$var$emojiRegex;
// faster, simpler, safer
const $86774bf5ad4be3c6$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $86774bf5ad4be3c6$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $86774bf5ad4be3c6$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $86774bf5ad4be3c6$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $86774bf5ad4be3c6$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $86774bf5ad4be3c6$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $86774bf5ad4be3c6$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $86774bf5ad4be3c6$var$dateRegex = new RegExp(`^${$86774bf5ad4be3c6$var$dateRegexSource}$`);
function $86774bf5ad4be3c6$var$timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function $86774bf5ad4be3c6$var$timeRegex(args) {
    return new RegExp(`^${$86774bf5ad4be3c6$var$timeRegexSource(args)}$`);
}
function $86774bf5ad4be3c6$export$a4b563879add27a(args) {
    let regex = `${$86774bf5ad4be3c6$var$dateRegexSource}T${$86774bf5ad4be3c6$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $86774bf5ad4be3c6$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $86774bf5ad4be3c6$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $86774bf5ad4be3c6$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $86774bf5ad4be3c6$var$isValidJWT(jwt, alg) {
    if (!$86774bf5ad4be3c6$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function $86774bf5ad4be3c6$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $86774bf5ad4be3c6$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $86774bf5ad4be3c6$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $86774bf5ad4be3c6$export$1230eb29b8d3b502 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $bQlTp.ZodParsedType).string) {
            const ctx = this._getOrReturnCtx(input);
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).string,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        const status = new (0, $8I00d.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$86774bf5ad4be3c6$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        validation: "email",
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$86774bf5ad4be3c6$var$emojiRegex) $86774bf5ad4be3c6$var$emojiRegex = new RegExp($86774bf5ad4be3c6$var$_emojiRegex, "u");
                if (!$86774bf5ad4be3c6$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$86774bf5ad4be3c6$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$86774bf5ad4be3c6$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        validation: "nanoid",
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$86774bf5ad4be3c6$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$86774bf5ad4be3c6$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$86774bf5ad4be3c6$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, $8I00d.addIssueToContext)(ctx, {
                    validation: "url",
                    code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $86774bf5ad4be3c6$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $86774bf5ad4be3c6$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $86774bf5ad4be3c6$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$86774bf5ad4be3c6$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        validation: "duration",
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$86774bf5ad4be3c6$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$86774bf5ad4be3c6$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        validation: "jwt",
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$86774bf5ad4be3c6$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        validation: "cidr",
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$86774bf5ad4be3c6$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        validation: "base64",
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$86774bf5ad4be3c6$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        validation: "base64url",
                        code: (0, $8Fc3i.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $bQlTp.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: (0, $8Fc3i.ZodIssueCode).invalid_string,
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    _addCheck(check) {
        return new $86774bf5ad4be3c6$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...(0, $2KEZx.errorUtil).errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...(0, $2KEZx.errorUtil).errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...(0, $2KEZx.errorUtil).errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...(0, $2KEZx.errorUtil).errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...(0, $2KEZx.errorUtil).errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...(0, $2KEZx.errorUtil).errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...(0, $2KEZx.errorUtil).errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, (0, $2KEZx.errorUtil).errToObj(message));
    }
    trim() {
        return new $86774bf5ad4be3c6$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $86774bf5ad4be3c6$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $86774bf5ad4be3c6$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$86774bf5ad4be3c6$export$1230eb29b8d3b502.create = (params)=>{
    return new $86774bf5ad4be3c6$export$1230eb29b8d3b502({
        checks: [],
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodString,
        coerce: params?.coerce ?? false,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $86774bf5ad4be3c6$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class $86774bf5ad4be3c6$export$5b070a55c0c43e09 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $bQlTp.ZodParsedType).number) {
            const ctx = this._getOrReturnCtx(input);
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).number,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        let ctx = undefined;
        const status = new (0, $8I00d.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!(0, $bQlTp.util).isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($86774bf5ad4be3c6$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $bQlTp.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $2KEZx.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $2KEZx.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $2KEZx.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $2KEZx.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $86774bf5ad4be3c6$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $2KEZx.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $86774bf5ad4be3c6$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: (0, $2KEZx.errorUtil).toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: (0, $2KEZx.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: (0, $2KEZx.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: (0, $2KEZx.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: (0, $2KEZx.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $2KEZx.errorUtil).toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: (0, $2KEZx.errorUtil).toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: (0, $2KEZx.errorUtil).toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: (0, $2KEZx.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && (0, $bQlTp.util).isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$86774bf5ad4be3c6$export$5b070a55c0c43e09.create = (params)=>{
    return new $86774bf5ad4be3c6$export$5b070a55c0c43e09({
        checks: [],
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodNumber,
        coerce: params?.coerce || false,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$67d741fd70ff98f4 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== (0, $bQlTp.ZodParsedType).bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new (0, $8I00d.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $bQlTp.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $8I00d.addIssueToContext)(ctx, {
            code: (0, $8Fc3i.ZodIssueCode).invalid_type,
            expected: (0, $bQlTp.ZodParsedType).bigint,
            received: ctx.parsedType
        });
        return 0, $8I00d.INVALID;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $2KEZx.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $2KEZx.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $2KEZx.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $2KEZx.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $86774bf5ad4be3c6$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $2KEZx.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $86774bf5ad4be3c6$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: (0, $2KEZx.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: (0, $2KEZx.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: (0, $2KEZx.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: (0, $2KEZx.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $2KEZx.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$86774bf5ad4be3c6$export$67d741fd70ff98f4.create = (params)=>{
    return new $86774bf5ad4be3c6$export$67d741fd70ff98f4({
        checks: [],
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$723d146f80596191 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $bQlTp.ZodParsedType).boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).boolean,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        return (0, $8I00d.OK)(input.data);
    }
}
$86774bf5ad4be3c6$export$723d146f80596191.create = (params)=>{
    return new $86774bf5ad4be3c6$export$723d146f80596191({
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodBoolean,
        coerce: params?.coerce || false,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$e974be33bdc55521 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $bQlTp.ZodParsedType).date) {
            const ctx = this._getOrReturnCtx(input);
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).date,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_date
            });
            return 0, $8I00d.INVALID;
        }
        const status = new (0, $8I00d.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else (0, $bQlTp.util).assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $86774bf5ad4be3c6$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: (0, $2KEZx.errorUtil).toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: (0, $2KEZx.errorUtil).toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$86774bf5ad4be3c6$export$e974be33bdc55521.create = (params)=>{
    return new $86774bf5ad4be3c6$export$e974be33bdc55521({
        checks: [],
        coerce: params?.coerce || false,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodDate,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$bcc3b40f6b638044 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $bQlTp.ZodParsedType).symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).symbol,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        return (0, $8I00d.OK)(input.data);
    }
}
$86774bf5ad4be3c6$export$bcc3b40f6b638044.create = (params)=>{
    return new $86774bf5ad4be3c6$export$bcc3b40f6b638044({
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodSymbol,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$4e780e961c30340d extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $bQlTp.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).undefined,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        return (0, $8I00d.OK)(input.data);
    }
}
$86774bf5ad4be3c6$export$4e780e961c30340d.create = (params)=>{
    return new $86774bf5ad4be3c6$export$4e780e961c30340d({
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodUndefined,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$a96281f914484f2d extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $bQlTp.ZodParsedType).null) {
            const ctx = this._getOrReturnCtx(input);
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).null,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        return (0, $8I00d.OK)(input.data);
    }
}
$86774bf5ad4be3c6$export$a96281f914484f2d.create = (params)=>{
    return new $86774bf5ad4be3c6$export$a96281f914484f2d({
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodNull,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$b9d1edb536b4e4eb extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, $8I00d.OK)(input.data);
    }
}
$86774bf5ad4be3c6$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $86774bf5ad4be3c6$export$b9d1edb536b4e4eb({
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodAny,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$ef3b1bb1630977ae extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, $8I00d.OK)(input.data);
    }
}
$86774bf5ad4be3c6$export$ef3b1bb1630977ae.create = (params)=>{
    return new $86774bf5ad4be3c6$export$ef3b1bb1630977ae({
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodUnknown,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$1e576a20c3ce9fb5 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $8I00d.addIssueToContext)(ctx, {
            code: (0, $8Fc3i.ZodIssueCode).invalid_type,
            expected: (0, $bQlTp.ZodParsedType).never,
            received: ctx.parsedType
        });
        return 0, $8I00d.INVALID;
    }
}
$86774bf5ad4be3c6$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $86774bf5ad4be3c6$export$1e576a20c3ce9fb5({
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodNever,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$7d39f5df85f21031 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $bQlTp.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).void,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        return (0, $8I00d.OK)(input.data);
    }
}
$86774bf5ad4be3c6$export$7d39f5df85f21031.create = (params)=>{
    return new $86774bf5ad4be3c6$export$7d39f5df85f21031({
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodVoid,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$7acfc3e64785411 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== (0, $bQlTp.ZodParsedType).array) {
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, $8I00d.addIssueToContext)(ctx, {
                    code: tooBig ? (0, $8Fc3i.ZodIssueCode).too_big : (0, $8Fc3i.ZodIssueCode).too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, $8I00d.addIssueToContext)(ctx, {
                    code: (0, $8Fc3i.ZodIssueCode).too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, $8I00d.addIssueToContext)(ctx, {
                    code: (0, $8Fc3i.ZodIssueCode).too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $86774bf5ad4be3c6$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return (0, $8I00d.ParseStatus).mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $86774bf5ad4be3c6$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return (0, $8I00d.ParseStatus).mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $86774bf5ad4be3c6$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: (0, $2KEZx.errorUtil).toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $86774bf5ad4be3c6$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: (0, $2KEZx.errorUtil).toString(message)
            }
        });
    }
    length(len, message) {
        return new $86774bf5ad4be3c6$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: (0, $2KEZx.errorUtil).toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$86774bf5ad4be3c6$export$7acfc3e64785411.create = (schema, params)=>{
    return new $86774bf5ad4be3c6$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodArray,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
function $86774bf5ad4be3c6$var$deepPartialify(schema) {
    if (schema instanceof $86774bf5ad4be3c6$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $86774bf5ad4be3c6$export$aa56fec1e9d629b8.create($86774bf5ad4be3c6$var$deepPartialify(fieldSchema));
        }
        return new $86774bf5ad4be3c6$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $86774bf5ad4be3c6$export$7acfc3e64785411) return new $86774bf5ad4be3c6$export$7acfc3e64785411({
        ...schema._def,
        type: $86774bf5ad4be3c6$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $86774bf5ad4be3c6$export$aa56fec1e9d629b8) return $86774bf5ad4be3c6$export$aa56fec1e9d629b8.create($86774bf5ad4be3c6$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $86774bf5ad4be3c6$export$aaac0b8b429cef5) return $86774bf5ad4be3c6$export$aaac0b8b429cef5.create($86774bf5ad4be3c6$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $86774bf5ad4be3c6$export$e2a18bb771d8e6a3) return $86774bf5ad4be3c6$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$86774bf5ad4be3c6$var$deepPartialify(item)));
    else return schema;
}
class $86774bf5ad4be3c6$export$736315c5b55efbad extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = (0, $bQlTp.util).objectKeys(shape);
        this._cached = {
            shape: shape,
            keys: keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $bQlTp.ZodParsedType).object) {
            const ctx = this._getOrReturnCtx(input);
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $86774bf5ad4be3c6$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $86774bf5ad4be3c6$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $86774bf5ad4be3c6$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, $8I00d.addIssueToContext)(ctx, {
                        code: (0, $8Fc3i.ZodIssueCode).unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $86774bf5ad4be3c6$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return (0, $8I00d.ParseStatus).mergeObjectSync(status, syncPairs);
        });
        else return (0, $8I00d.ParseStatus).mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        (0, $2KEZx.errorUtil).errToObj;
        return new $86774bf5ad4be3c6$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (0, $2KEZx.errorUtil).errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $86774bf5ad4be3c6$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $86774bf5ad4be3c6$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $86774bf5ad4be3c6$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $86774bf5ad4be3c6$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $86774bf5ad4be3c6$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of (0, $bQlTp.util).objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new $86774bf5ad4be3c6$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of (0, $bQlTp.util).objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new $86774bf5ad4be3c6$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $86774bf5ad4be3c6$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of (0, $bQlTp.util).objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new $86774bf5ad4be3c6$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of (0, $bQlTp.util).objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof $86774bf5ad4be3c6$export$aa56fec1e9d629b8)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new $86774bf5ad4be3c6$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $86774bf5ad4be3c6$var$createZodEnum((0, $bQlTp.util).objectKeys(this.shape));
    }
}
$86774bf5ad4be3c6$export$736315c5b55efbad.create = (shape, params)=>{
    return new $86774bf5ad4be3c6$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $86774bf5ad4be3c6$export$1e576a20c3ce9fb5.create(),
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodObject,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
$86774bf5ad4be3c6$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $86774bf5ad4be3c6$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $86774bf5ad4be3c6$export$1e576a20c3ce9fb5.create(),
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodObject,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
$86774bf5ad4be3c6$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $86774bf5ad4be3c6$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $86774bf5ad4be3c6$export$1e576a20c3ce9fb5.create(),
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodObject,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$a8b236cb5070a311 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new (0, $8Fc3i.ZodError)(result.ctx.common.issues));
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $8I00d.INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new (0, $8Fc3i.ZodError)(issues));
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $8I00d.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
$86774bf5ad4be3c6$export$a8b236cb5070a311.create = (types, params)=>{
    return new $86774bf5ad4be3c6$export$a8b236cb5070a311({
        options: types,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodUnion,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $86774bf5ad4be3c6$var$getDiscriminator = (type)=>{
    if (type instanceof $86774bf5ad4be3c6$export$378d0cfce37406e6) return $86774bf5ad4be3c6$var$getDiscriminator(type.schema);
    else if (type instanceof $86774bf5ad4be3c6$export$a60af00cc0ce2582) return $86774bf5ad4be3c6$var$getDiscriminator(type.innerType());
    else if (type instanceof $86774bf5ad4be3c6$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $86774bf5ad4be3c6$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $86774bf5ad4be3c6$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return (0, $bQlTp.util).objectValues(type.enum);
    else if (type instanceof $86774bf5ad4be3c6$export$bb19b37874861e7e) return $86774bf5ad4be3c6$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $86774bf5ad4be3c6$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $86774bf5ad4be3c6$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $86774bf5ad4be3c6$export$aa56fec1e9d629b8) return [
        undefined,
        ...$86774bf5ad4be3c6$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $86774bf5ad4be3c6$export$aaac0b8b429cef5) return [
        null,
        ...$86774bf5ad4be3c6$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $86774bf5ad4be3c6$export$66b0c798a395271f) return $86774bf5ad4be3c6$var$getDiscriminator(type.unwrap());
    else if (type instanceof $86774bf5ad4be3c6$export$5d1f7ef05c4e493a) return $86774bf5ad4be3c6$var$getDiscriminator(type.unwrap());
    else if (type instanceof $86774bf5ad4be3c6$export$75a44ec6249ac76b) return $86774bf5ad4be3c6$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $86774bf5ad4be3c6$export$5ef2424805ac76a3 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $bQlTp.ZodParsedType).object) {
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return 0, $8I00d.INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $86774bf5ad4be3c6$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $86774bf5ad4be3c6$export$5ef2424805ac76a3({
            typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$86774bf5ad4be3c6$var$processCreateParams(params)
        });
    }
}
function $86774bf5ad4be3c6$var$mergeValues(a, b) {
    const aType = (0, $bQlTp.getParsedType)(a);
    const bType = (0, $bQlTp.getParsedType)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === (0, $bQlTp.ZodParsedType).object && bType === (0, $bQlTp.ZodParsedType).object) {
        const bKeys = (0, $bQlTp.util).objectKeys(b);
        const sharedKeys = (0, $bQlTp.util).objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $86774bf5ad4be3c6$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === (0, $bQlTp.ZodParsedType).array && bType === (0, $bQlTp.ZodParsedType).array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $86774bf5ad4be3c6$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === (0, $bQlTp.ZodParsedType).date && bType === (0, $bQlTp.ZodParsedType).date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $86774bf5ad4be3c6$export$c02deaf0bb5203d4 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, $8I00d.isAborted)(parsedLeft) || (0, $8I00d.isAborted)(parsedRight)) return 0, $8I00d.INVALID;
            const merged = $86774bf5ad4be3c6$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, $8I00d.addIssueToContext)(ctx, {
                    code: (0, $8Fc3i.ZodIssueCode).invalid_intersection_types
                });
                return 0, $8I00d.INVALID;
            }
            if ((0, $8I00d.isDirty)(parsedLeft) || (0, $8I00d.isDirty)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$86774bf5ad4be3c6$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $86774bf5ad4be3c6$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodIntersection,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$e2a18bb771d8e6a3 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $bQlTp.ZodParsedType).array) {
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return 0, $8I00d.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $86774bf5ad4be3c6$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return (0, $8I00d.ParseStatus).mergeArray(status, results);
        });
        else return (0, $8I00d.ParseStatus).mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $86774bf5ad4be3c6$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$86774bf5ad4be3c6$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $86774bf5ad4be3c6$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$a2acc09968cb4b7f extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $bQlTp.ZodParsedType).object) {
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $86774bf5ad4be3c6$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $86774bf5ad4be3c6$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return (0, $8I00d.ParseStatus).mergeObjectAsync(status, pairs);
        else return (0, $8I00d.ParseStatus).mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $86774bf5ad4be3c6$export$2afb8ab49d4b92c0) return new $86774bf5ad4be3c6$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodRecord,
            ...$86774bf5ad4be3c6$var$processCreateParams(third)
        });
        return new $86774bf5ad4be3c6$export$a2acc09968cb4b7f({
            keyType: $86774bf5ad4be3c6$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodRecord,
            ...$86774bf5ad4be3c6$var$processCreateParams(second)
        });
    }
}
class $86774bf5ad4be3c6$export$163b6a2b712d9542 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $bQlTp.ZodParsedType).map) {
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).map,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $86774bf5ad4be3c6$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $86774bf5ad4be3c6$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return 0, $8I00d.INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return 0, $8I00d.INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$86774bf5ad4be3c6$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $86774bf5ad4be3c6$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodMap,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$977057706f816712 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $bQlTp.ZodParsedType).set) {
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).set,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, $8I00d.addIssueToContext)(ctx, {
                    code: (0, $8Fc3i.ZodIssueCode).too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, $8I00d.addIssueToContext)(ctx, {
                    code: (0, $8Fc3i.ZodIssueCode).too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return 0, $8I00d.INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $86774bf5ad4be3c6$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $86774bf5ad4be3c6$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: (0, $2KEZx.errorUtil).toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $86774bf5ad4be3c6$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: (0, $2KEZx.errorUtil).toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$86774bf5ad4be3c6$export$977057706f816712.create = (valueType, params)=>{
    return new $86774bf5ad4be3c6$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodSet,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$d4602ba55673f53c extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $bQlTp.ZodParsedType).function) {
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).function,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, $8I00d.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $g6DDZ.getErrorMap)(),
                    (0, $atFSE.default)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $8Fc3i.ZodIssueCode).invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, $8I00d.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $g6DDZ.getErrorMap)(),
                    (0, $atFSE.default)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $8Fc3i.ZodIssueCode).invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $86774bf5ad4be3c6$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $8I00d.OK)(async function(...args) {
                const error = new (0, $8Fc3i.ZodError)([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $8I00d.OK)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new (0, $8Fc3i.ZodError)([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new (0, $8Fc3i.ZodError)([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $86774bf5ad4be3c6$export$d4602ba55673f53c({
            ...this._def,
            args: $86774bf5ad4be3c6$export$e2a18bb771d8e6a3.create(items).rest($86774bf5ad4be3c6$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $86774bf5ad4be3c6$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $86774bf5ad4be3c6$export$d4602ba55673f53c({
            args: args ? args : $86774bf5ad4be3c6$export$e2a18bb771d8e6a3.create([]).rest($86774bf5ad4be3c6$export$ef3b1bb1630977ae.create()),
            returns: returns || $86774bf5ad4be3c6$export$ef3b1bb1630977ae.create(),
            typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodFunction,
            ...$86774bf5ad4be3c6$var$processCreateParams(params)
        });
    }
}
class $86774bf5ad4be3c6$export$378d0cfce37406e6 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$86774bf5ad4be3c6$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $86774bf5ad4be3c6$export$378d0cfce37406e6({
        getter: getter,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodLazy,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$7e44096782a165d3 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, $8I00d.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $8Fc3i.ZodIssueCode).invalid_literal,
                expected: this._def.value
            });
            return 0, $8I00d.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$86774bf5ad4be3c6$export$7e44096782a165d3.create = (value, params)=>{
    return new $86774bf5ad4be3c6$export$7e44096782a165d3({
        value: value,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodLiteral,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
function $86774bf5ad4be3c6$var$createZodEnum(values, params) {
    return new $86774bf5ad4be3c6$export$d325d1f0e1c20179({
        values: values,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodEnum,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
}
class $86774bf5ad4be3c6$export$d325d1f0e1c20179 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $8I00d.addIssueToContext)(ctx, {
                expected: (0, $bQlTp.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $8Fc3i.ZodIssueCode).invalid_type
            });
            return 0, $8I00d.INVALID;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $8I00d.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $8Fc3i.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, $8I00d.INVALID;
        }
        return (0, $8I00d.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $86774bf5ad4be3c6$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $86774bf5ad4be3c6$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$86774bf5ad4be3c6$export$d325d1f0e1c20179.create = $86774bf5ad4be3c6$var$createZodEnum;
class $86774bf5ad4be3c6$export$370b2e8d6d6f5c56 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const nativeEnumValues = (0, $bQlTp.util).getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== (0, $bQlTp.ZodParsedType).string && ctx.parsedType !== (0, $bQlTp.ZodParsedType).number) {
            const expectedValues = (0, $bQlTp.util).objectValues(nativeEnumValues);
            (0, $8I00d.addIssueToContext)(ctx, {
                expected: (0, $bQlTp.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $8Fc3i.ZodIssueCode).invalid_type
            });
            return 0, $8I00d.INVALID;
        }
        if (!this._cache) this._cache = new Set((0, $bQlTp.util).getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = (0, $bQlTp.util).objectValues(nativeEnumValues);
            (0, $8I00d.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $8Fc3i.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, $8I00d.INVALID;
        }
        return (0, $8I00d.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$86774bf5ad4be3c6$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $86774bf5ad4be3c6$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodNativeEnum,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$3f196b0127d6e50a extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $bQlTp.ZodParsedType).promise && ctx.common.async === false) {
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).promise,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        const promisified = ctx.parsedType === (0, $bQlTp.ZodParsedType).promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, $8I00d.OK)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$86774bf5ad4be3c6$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $86774bf5ad4be3c6$export$3f196b0127d6e50a({
        type: schema,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodPromise,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$a60af00cc0ce2582 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $86774bf5ad4be3c6$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, $8I00d.addIssueToContext)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return 0, $8I00d.INVALID;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $8I00d.INVALID;
                if (result.status === "dirty") return (0, $8I00d.DIRTY)(result.value);
                if (status.value === "dirty") return (0, $8I00d.DIRTY)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return 0, $8I00d.INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $8I00d.INVALID;
                if (result.status === "dirty") return (0, $8I00d.DIRTY)(result.value);
                if (status.value === "dirty") return (0, $8I00d.DIRTY)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return 0, $8I00d.INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return 0, $8I00d.INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, $8I00d.isValid)(base)) return 0, $8I00d.INVALID;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, $8I00d.isValid)(base)) return 0, $8I00d.INVALID;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        (0, $bQlTp.util).assertNever(effect);
    }
}
$86774bf5ad4be3c6$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $86774bf5ad4be3c6$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
$86774bf5ad4be3c6$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $86774bf5ad4be3c6$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodEffects,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$aa56fec1e9d629b8 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $bQlTp.ZodParsedType).undefined) return (0, $8I00d.OK)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$86774bf5ad4be3c6$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $86774bf5ad4be3c6$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodOptional,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$aaac0b8b429cef5 extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $bQlTp.ZodParsedType).null) return (0, $8I00d.OK)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$86774bf5ad4be3c6$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $86774bf5ad4be3c6$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodNullable,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$bb19b37874861e7e extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === (0, $bQlTp.ZodParsedType).undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$86774bf5ad4be3c6$export$bb19b37874861e7e.create = (type, params)=>{
    return new $86774bf5ad4be3c6$export$bb19b37874861e7e({
        innerType: type,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$75a44ec6249ac76b extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, $8I00d.isAsync)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new (0, $8Fc3i.ZodError)(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new (0, $8Fc3i.ZodError)(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$86774bf5ad4be3c6$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $86774bf5ad4be3c6$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
class $86774bf5ad4be3c6$export$26ccfa0145e8511f extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $bQlTp.ZodParsedType).nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, $8I00d.addIssueToContext)(ctx, {
                code: (0, $8Fc3i.ZodIssueCode).invalid_type,
                expected: (0, $bQlTp.ZodParsedType).nan,
                received: ctx.parsedType
            });
            return 0, $8I00d.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$86774bf5ad4be3c6$export$26ccfa0145e8511f.create = (params)=>{
    return new $86774bf5ad4be3c6$export$26ccfa0145e8511f({
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodNaN,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
const $86774bf5ad4be3c6$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $86774bf5ad4be3c6$export$66b0c798a395271f extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $86774bf5ad4be3c6$export$a3c3ef8a0e95c6da extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return 0, $8I00d.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, $8I00d.DIRTY)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return 0, $8I00d.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $86774bf5ad4be3c6$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $86774bf5ad4be3c6$export$5d1f7ef05c4e493a extends $86774bf5ad4be3c6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, $8I00d.isValid)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, $8I00d.isAsync)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$86774bf5ad4be3c6$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $86774bf5ad4be3c6$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $86774bf5ad4be3c6$export$558106ce543bd011.ZodReadonly,
        ...$86774bf5ad4be3c6$var$processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $86774bf5ad4be3c6$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $86774bf5ad4be3c6$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $86774bf5ad4be3c6$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = $86774bf5ad4be3c6$var$cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = $86774bf5ad4be3c6$var$cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return $86774bf5ad4be3c6$export$b9d1edb536b4e4eb.create();
}
const $86774bf5ad4be3c6$export$1ee8ee30835eab8b = {
    object: $86774bf5ad4be3c6$export$736315c5b55efbad.lazycreate
};
var $86774bf5ad4be3c6$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($86774bf5ad4be3c6$export$558106ce543bd011 || ($86774bf5ad4be3c6$export$558106ce543bd011 = {}));
// requires TS 4.4+
class $86774bf5ad4be3c6$var$Class {
    constructor(..._){}
}
const $86774bf5ad4be3c6$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$86774bf5ad4be3c6$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $86774bf5ad4be3c6$export$22b082955e083ec3 = $86774bf5ad4be3c6$export$1230eb29b8d3b502.create;
const $86774bf5ad4be3c6$export$98e628dec113755e = $86774bf5ad4be3c6$export$5b070a55c0c43e09.create;
const $86774bf5ad4be3c6$export$9e06de0973666692 = $86774bf5ad4be3c6$export$26ccfa0145e8511f.create;
const $86774bf5ad4be3c6$export$a0f65b52274bcc00 = $86774bf5ad4be3c6$export$67d741fd70ff98f4.create;
const $86774bf5ad4be3c6$export$4a21f16c33752377 = $86774bf5ad4be3c6$export$723d146f80596191.create;
const $86774bf5ad4be3c6$export$324d90190a8b822a = $86774bf5ad4be3c6$export$e974be33bdc55521.create;
const $86774bf5ad4be3c6$export$8f701197936bc2a6 = $86774bf5ad4be3c6$export$bcc3b40f6b638044.create;
const $86774bf5ad4be3c6$export$1db45310990710a5 = $86774bf5ad4be3c6$export$4e780e961c30340d.create;
const $86774bf5ad4be3c6$export$7b1b591b262c240 = $86774bf5ad4be3c6$export$a96281f914484f2d.create;
const $86774bf5ad4be3c6$export$4154a199d7d90455 = $86774bf5ad4be3c6$export$b9d1edb536b4e4eb.create;
const $86774bf5ad4be3c6$export$19282c40b967aec6 = $86774bf5ad4be3c6$export$ef3b1bb1630977ae.create;
const $86774bf5ad4be3c6$export$b3e22bcfd64c1022 = $86774bf5ad4be3c6$export$1e576a20c3ce9fb5.create;
const $86774bf5ad4be3c6$export$490e536ee7389aeb = $86774bf5ad4be3c6$export$7d39f5df85f21031.create;
const $86774bf5ad4be3c6$export$2f23118c22fb2630 = $86774bf5ad4be3c6$export$7acfc3e64785411.create;
const $86774bf5ad4be3c6$export$be5493f9613cbbe = $86774bf5ad4be3c6$export$736315c5b55efbad.create;
const $86774bf5ad4be3c6$export$8fb0df5f40d0b477 = $86774bf5ad4be3c6$export$736315c5b55efbad.strictCreate;
const $86774bf5ad4be3c6$export$971dd5b0dfd021b6 = $86774bf5ad4be3c6$export$a8b236cb5070a311.create;
const $86774bf5ad4be3c6$export$4b888e40c4ee26dd = $86774bf5ad4be3c6$export$5ef2424805ac76a3.create;
const $86774bf5ad4be3c6$export$bc86dfbf7795668c = $86774bf5ad4be3c6$export$c02deaf0bb5203d4.create;
const $86774bf5ad4be3c6$export$65e3907585753458 = $86774bf5ad4be3c6$export$e2a18bb771d8e6a3.create;
const $86774bf5ad4be3c6$export$e5185e241753e543 = $86774bf5ad4be3c6$export$a2acc09968cb4b7f.create;
const $86774bf5ad4be3c6$export$871de8747c9eaa88 = $86774bf5ad4be3c6$export$163b6a2b712d9542.create;
const $86774bf5ad4be3c6$export$adaa4cf7ef1b65be = $86774bf5ad4be3c6$export$977057706f816712.create;
const $86774bf5ad4be3c6$export$44e51c8aac7c2deb = $86774bf5ad4be3c6$export$d4602ba55673f53c.create;
const $86774bf5ad4be3c6$export$488013bae63b21da = $86774bf5ad4be3c6$export$378d0cfce37406e6.create;
const $86774bf5ad4be3c6$export$c8ec6e1ec9fefcb0 = $86774bf5ad4be3c6$export$7e44096782a165d3.create;
const $86774bf5ad4be3c6$export$78a99c8d44d72635 = $86774bf5ad4be3c6$export$d325d1f0e1c20179.create;
const $86774bf5ad4be3c6$export$6fe7eca19ebe5199 = $86774bf5ad4be3c6$export$370b2e8d6d6f5c56.create;
const $86774bf5ad4be3c6$export$c957ef27a0ebfd4 = $86774bf5ad4be3c6$export$3f196b0127d6e50a.create;
const $86774bf5ad4be3c6$export$dc573d8a6576cdb3 = $86774bf5ad4be3c6$export$a60af00cc0ce2582.create;
const $86774bf5ad4be3c6$export$516e28dec6a4b6d4 = $86774bf5ad4be3c6$export$aa56fec1e9d629b8.create;
const $86774bf5ad4be3c6$export$133fc36489ac9add = $86774bf5ad4be3c6$export$aaac0b8b429cef5.create;
const $86774bf5ad4be3c6$export$fc37fe19dfda43ee = $86774bf5ad4be3c6$export$a60af00cc0ce2582.createWithPreprocess;
const $86774bf5ad4be3c6$export$43f28b24e1eb8181 = $86774bf5ad4be3c6$export$a3c3ef8a0e95c6da.create;
const $86774bf5ad4be3c6$export$3b3d07727c5b702c = ()=>$86774bf5ad4be3c6$export$22b082955e083ec3().optional();
const $86774bf5ad4be3c6$export$eb150471a61fced6 = ()=>$86774bf5ad4be3c6$export$98e628dec113755e().optional();
const $86774bf5ad4be3c6$export$269251733cdcbbf1 = ()=>$86774bf5ad4be3c6$export$4a21f16c33752377().optional();
const $86774bf5ad4be3c6$export$8c14e57e778d3873 = {
    string: (arg)=>$86774bf5ad4be3c6$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$86774bf5ad4be3c6$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$86774bf5ad4be3c6$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$86774bf5ad4be3c6$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$86774bf5ad4be3c6$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $86774bf5ad4be3c6$export$96c94437c95d7862 = (0, $8I00d.INVALID);

});
parcelRegister("2KEZx", function(module, exports) {
$parcel$export(module.exports, "errorUtil", () => $200facb4943a9088$export$b9faa7f0c32cb80d);
var $200facb4943a9088$export$b9faa7f0c32cb80d;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    // biome-ignore lint:
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})($200facb4943a9088$export$b9faa7f0c32cb80d || ($200facb4943a9088$export$b9faa7f0c32cb80d = {}));

});





parcelRegister("8qNgy", function(module, exports) {
$parcel$export(module.exports, "functionWithFG", () => $f6d65c87169bfaae$export$53903226fff06fbb);

var $egspI = parcelRequire("egspI");

var $8NOxQ = parcelRequire("8NOxQ");
const $f6d65c87169bfaae$export$53903226fff06fbb = (featureFlagName, functionTrue, functionFalse)=>(0, $8NOxQ.functionWithCondition)(()=>(0, $egspI.fg)(featureFlagName), functionTrue, functionFalse);

});
parcelRegister("8NOxQ", function(module, exports) {
$parcel$export(module.exports, "functionWithCondition", () => $89242cc3d48d4cd2$export$af3c0e82a18fc057);
$parcel$export(module.exports, "functionUnionWithCondition", () => $89242cc3d48d4cd2$export$c41c28c1d883fcd5);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $89242cc3d48d4cd2$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $89242cc3d48d4cd2$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $89242cc3d48d4cd2$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});


parcelRegister("iVtau", function(module, exports) {
$parcel$export(module.exports, "componentWithFG", () => $6f925f76fcbe2654$export$cf56d0f54cfcce4);

var $egspI = parcelRequire("egspI");

var $3zQkx = parcelRequire("3zQkx");
const $6f925f76fcbe2654$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $3zQkx.componentWithCondition)(()=>(0, $egspI.fg)(featureFlagName), ComponentTrue, ComponentFalse);

});

parcelRegister("9ll9z", function(module, exports) {
$parcel$export(module.exports, "useSubscribe", () => $cd9e8a23dfd230c6$export$d3d523392640272);
$parcel$export(module.exports, "useSubscribeAll", () => $cd9e8a23dfd230c6$export$2570c8aa24b6d327);
$parcel$export(module.exports, "usePublish", () => $cd9e8a23dfd230c6$export$d55c81786220731c);
$parcel$export(module.exports, "Subscriber", () => $cd9e8a23dfd230c6$export$60959659b2c22881);

var $euxye = parcelRequire("euxye");

var $egspI = parcelRequire("egspI");
const $cd9e8a23dfd230c6$var$MAX_CONSUMED_EVENT_KEYS = 5000;
const $cd9e8a23dfd230c6$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed',
    // Internal signals that must never overwrite the publish queue — they would
    // cause `triggerLatest` subscribers (e.g. PubSubListener) to replay them
    // instead of the real action event (e.g. open-browse-agent-modal) that
    // originally opened the chat.
    'smartlinks-subscription-changed',
    'smartlinks-context-payload'
]);
const $cd9e8a23dfd230c6$var$isIgnoredForTriggerLatest = (type)=>{
    if ($cd9e8a23dfd230c6$var$ignoredTriggerLatestEvents.has(type)) return true;
    return type === 'set-message-context' && (0, $egspI.fg)('rovo_chat_fix_cold_start_prompt_insertion');
};
const $cd9e8a23dfd230c6$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let consumedEventKeys = new Set();
    let consumedEventKeyQueue = [];
    let subIdCounter = 0;
    let eventIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const createEvent = (payload)=>{
        eventIdCounter += 1;
        return {
            id: eventIdCounter.toString(),
            payload: payload
        };
    };
    const rememberConsumedEventKey = (claimKey)=>{
        consumedEventKeys.add(claimKey);
        consumedEventKeyQueue = [
            ...consumedEventKeyQueue,
            claimKey
        ];
        if (consumedEventKeyQueue.length > $cd9e8a23dfd230c6$var$MAX_CONSUMED_EVENT_KEYS) {
            const [oldestClaimKey, ...remainingClaimKeys] = consumedEventKeyQueue;
            consumedEventKeyQueue = remainingClaimKeys;
            if (oldestClaimKey) consumedEventKeys.delete(oldestClaimKey);
        }
    };
    const claimConsumeOnceEvent = ({ event: event, consumeOnceKey: consumeOnceKey })=>{
        if (!event.payload.consumeOnce || !consumeOnceKey) return true;
        const claimKey = `${consumeOnceKey}:${event.id}`;
        if (consumedEventKeys.has(claimKey)) return false;
        rememberConsumedEventKey(claimKey);
        return true;
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest, consumeOnceKey: consumeOnceKey }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        const callbackWithConsumption = (event)=>{
            if (!claimConsumeOnceEvent({
                event: event,
                consumeOnceKey: consumeOnceKey
            })) return;
            callback(event.payload);
        };
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callbackWithConsumption,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const event = publishQueue[topic];
                callbackWithConsumption(event);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        const event = createEvent(payload);
        /**
		 * Log that this Topic received a published event, regardless of whether it has subscribers or not.
		 * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
		 */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$cd9e8a23dfd230c6$var$isIgnoredForTriggerLatest(payload.type)) publishQueue[topic] = event;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(event.payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(event));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $cd9e8a23dfd230c6$var$pubSub = $cd9e8a23dfd230c6$var$createPubSub();
const $cd9e8a23dfd230c6$var$usePubSub = ()=>{
    return $cd9e8a23dfd230c6$var$pubSub;
};
const $cd9e8a23dfd230c6$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest, consumeOnceKey: consumeOnceKey }, callback)=>{
    const { subscribe: subscribe } = $cd9e8a23dfd230c6$var$usePubSub();
    const callbackRef = (0, $euxye.useRef)(callback);
    callbackRef.current = callback;
    (0, $euxye.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest,
            consumeOnceKey: consumeOnceKey
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic,
        consumeOnceKey
    ]);
};
const $cd9e8a23dfd230c6$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $cd9e8a23dfd230c6$var$usePubSub();
    const callbackRef = (0, $euxye.useRef)(callback);
    callbackRef.current = callback;
    (0, $euxye.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $cd9e8a23dfd230c6$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $cd9e8a23dfd230c6$var$usePubSub();
    (0, $euxye.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $cd9e8a23dfd230c6$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $cd9e8a23dfd230c6$var$usePubSub();
    const publishFn = (0, $euxye.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $cd9e8a23dfd230c6$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount, consumeOnceKey: consumeOnceKey })=>{
    $cd9e8a23dfd230c6$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest,
        consumeOnceKey: consumeOnceKey
    }, onEvent);
    $cd9e8a23dfd230c6$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};
$cd9e8a23dfd230c6$export$60959659b2c22881.displayName = "Subscriber";

});

parcelRegister("ff1v8", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $95d45cc4279d2375$export$81b70111112841a0);
const $95d45cc4279d2375$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("3A0XF", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $05d148f36c65feba$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $05d148f36c65feba$export$d53d07b6034c4560);
class $05d148f36c65feba$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($05d148f36c65feba$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($05d148f36c65feba$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $05d148f36c65feba$export$4ab84f6f04f6566d = new $05d148f36c65feba$var$UFOLogger();
const $05d148f36c65feba$export$b4958caff08a0960 = (...args)=>{
    $05d148f36c65feba$export$4ab84f6f04f6566d.log(...args);
};
const $05d148f36c65feba$export$d53d07b6034c4560 = (...args)=>{
    $05d148f36c65feba$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("1fOu9", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $fcc8edc05702c9dc$export$c00d22927c60484a);

var $kZIta = parcelRequire("kZIta");
class $fcc8edc05702c9dc$export$c00d22927c60484a extends (0, $kZIta.UFOAbstractExperience) {
}

});
parcelRegister("kZIta", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $9da851cecbb64bc3$export$d31c89db257648c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $7TA2J = parcelRequire("7TA2J");


var $bwqmT = parcelRequire("bwqmT");

var $3A0XF = parcelRequire("3A0XF");

var $iC7Fk = parcelRequire("iC7Fk");

var $eYLHC = parcelRequire("eYLHC");

var $dbuN9 = parcelRequire("dbuN9");

var $91Pnq = parcelRequire("91Pnq");

var $ff1v8 = parcelRequire("ff1v8");

var $aTwZc = parcelRequire("aTwZc");

var $3nsUD = parcelRequire("3nsUD");
const $9da851cecbb64bc3$var$getPageVisibleState = ()=>{
    return !(0, $91Pnq.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $eYLHC.PageVisibleState).VISIBLE : (0, $eYLHC.PageVisibleState).HIDDEN;
};
const $9da851cecbb64bc3$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $dbuN9.roundPerfNow)();
};
class $9da851cecbb64bc3$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $ff1v8.UFOExperienceState).NOT_STARTED;
        this.instanceId = null; // for concurrent
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $eYLHC.PageVisibleState).MIXED;
            (0, $iC7Fk.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $9da851cecbb64bc3$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $3nsUD.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $3nsUD.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $3A0XF.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $aTwZc.canTransition)(this.state, newState)) {
            (0, $3A0XF.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $ff1v8.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $9da851cecbb64bc3$export$c753e8669d30c8ad(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $7TA2J.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $9da851cecbb64bc3$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $bwqmT.getGlobalEventStream)().push((0, $bwqmT.unsubscribeEvent)((0, $eYLHC.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $3A0XF.ufolog)('this.parent', this.parent);
                (0, $bwqmT.getGlobalEventStream)().push((0, $bwqmT.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $3A0XF.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $3A0XF.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $ff1v8.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $9da851cecbb64bc3$var$getPageVisibleState();
            (0, $iC7Fk.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $3A0XF.ufolog)('subscribed', this.id);
                (0, $bwqmT.getGlobalEventStream)().push((0, $bwqmT.subscribeEvent)((0, $eYLHC.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $eYLHC.FMP_MARK) && name !== (0, $eYLHC.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $3A0XF.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $9da851cecbb64bc3$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $ff1v8.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $eYLHC.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $eYLHC.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $3A0XF.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $iC7Fk.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $ff1v8.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $ff1v8.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $ff1v8.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $3A0XF.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $a63b8901dea4a6fd$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $a63b8901dea4a6fd$export$2295b861f318254a = '0.1.5';

parcelRegister("bwqmT", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $f8b6a4fe60918e67$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $f8b6a4fe60918e67$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $f8b6a4fe60918e67$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $f8b6a4fe60918e67$export$7c957416596ca127);

var $3A0XF = parcelRequire("3A0XF");

var $eYLHC = parcelRequire("eYLHC");
const $f8b6a4fe60918e67$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $f8b6a4fe60918e67$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $f8b6a4fe60918e67$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $f8b6a4fe60918e67$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $3A0XF.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $f8b6a4fe60918e67$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $eYLHC.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $f8b6a4fe60918e67$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $eYLHC.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $f8b6a4fe60918e67$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $eYLHC.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("eYLHC", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $8191be0339e1a087$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $8191be0339e1a087$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $8191be0339e1a087$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $8191be0339e1a087$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $8191be0339e1a087$export$837e0f79a8056912);
var $8191be0339e1a087$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $8191be0339e1a087$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $8191be0339e1a087$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $8191be0339e1a087$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $8191be0339e1a087$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $8191be0339e1a087$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $8191be0339e1a087$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $8191be0339e1a087$export$9f2bf58999404c75 = 'fmp';
const $8191be0339e1a087$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("iC7Fk", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $62a459808a9f3ec2$export$13e680397ec8f3eb);

var $91Pnq = parcelRequire("91Pnq");
class $62a459808a9f3ec2$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $91Pnq.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $62a459808a9f3ec2$export$13e680397ec8f3eb = new $62a459808a9f3ec2$var$VisibilityChangeObserver();

});
parcelRegister("91Pnq", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $03c1e631347bcb35$export$15e172712955e18f);
const $03c1e631347bcb35$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("dbuN9", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $31a7249068b3954e$export$5f490af6b2b115cf);
const $31a7249068b3954e$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("aTwZc", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $8f721a70c66b7784$export$178881f329fdb81f);

var $ff1v8 = parcelRequire("ff1v8");
const $8f721a70c66b7784$var$UFOStateAvailableTransitions = {
    [(0, $ff1v8.UFOExperienceState).NOT_STARTED.id]: [
        (0, $ff1v8.UFOExperienceState).STARTED.id
    ],
    [(0, $ff1v8.UFOExperienceState).STARTED.id]: [
        (0, $ff1v8.UFOExperienceState).IN_PROGRESS.id,
        (0, $ff1v8.UFOExperienceState).BLOCKED.id,
        (0, $ff1v8.UFOExperienceState).SUCCEEDED.id,
        (0, $ff1v8.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $ff1v8.UFOExperienceState).FAILED.id,
        (0, $ff1v8.UFOExperienceState).ABORTED.id
    ],
    [(0, $ff1v8.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $ff1v8.UFOExperienceState).BLOCKED.id,
        (0, $ff1v8.UFOExperienceState).SUCCEEDED.id,
        (0, $ff1v8.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $ff1v8.UFOExperienceState).FAILED.id,
        (0, $ff1v8.UFOExperienceState).ABORTED.id
    ],
    [(0, $ff1v8.UFOExperienceState).BLOCKED.id]: [
        (0, $ff1v8.UFOExperienceState).RECOVERED.id,
        (0, $ff1v8.UFOExperienceState).ABORTED.id
    ],
    [(0, $ff1v8.UFOExperienceState).RECOVERED.id]: [
        (0, $ff1v8.UFOExperienceState).STARTED.id,
        (0, $ff1v8.UFOExperienceState).SUCCEEDED.id,
        (0, $ff1v8.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $ff1v8.UFOExperienceState).FAILED.id,
        (0, $ff1v8.UFOExperienceState).ABORTED.id
    ],
    [(0, $ff1v8.UFOExperienceState).SUCCEEDED.id]: [
        (0, $ff1v8.UFOExperienceState).STARTED.id
    ],
    [(0, $ff1v8.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $ff1v8.UFOExperienceState).SUCCEEDED.id,
        (0, $ff1v8.UFOExperienceState).FAILED.id,
        (0, $ff1v8.UFOExperienceState).ABORTED.id
    ],
    [(0, $ff1v8.UFOExperienceState).FAILED.id]: [
        (0, $ff1v8.UFOExperienceState).STARTED.id
    ],
    [(0, $ff1v8.UFOExperienceState).ABORTED.id]: [
        (0, $ff1v8.UFOExperienceState).STARTED.id
    ]
};
const $8f721a70c66b7784$export$178881f329fdb81f = (state1, state2)=>{
    return $8f721a70c66b7784$var$UFOStateAvailableTransitions[state1.id] && $8f721a70c66b7784$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("3nsUD", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $6fe466ffb0268d0a$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $6fe466ffb0268d0a$export$cc26007c03242fff);
var $6fe466ffb0268d0a$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $6fe466ffb0268d0a$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});



parcelRegister("74oEx", function(module, exports) {

var $srxic = parcelRequire("srxic");

var $f6GKc = parcelRequire("f6GKc");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $525c07a7130bd265$var$camelCase = $f6GKc(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $srxic(word) : word);
});
module.exports = $525c07a7130bd265$var$camelCase;

});
parcelRegister("f6GKc", function(module, exports) {

var $8YQWO = parcelRequire("8YQWO");

var $hF9BU = parcelRequire("hF9BU");

var $huGzJ = parcelRequire("huGzJ");
/** Used to compose unicode capture groups. */ var $aff892a1632b391d$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $aff892a1632b391d$var$reApos = RegExp($aff892a1632b391d$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $aff892a1632b391d$var$createCompounder(callback) {
    return function(string) {
        return $8YQWO($huGzJ($hF9BU(string).replace($aff892a1632b391d$var$reApos, '')), callback, '');
    };
}
module.exports = $aff892a1632b391d$var$createCompounder;

});
parcelRegister("8YQWO", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $689cffa299f894f4$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $689cffa299f894f4$var$arrayReduce;

});

parcelRegister("hF9BU", function(module, exports) {

var $kdlCI = parcelRequire("kdlCI");

var $lyiHY = parcelRequire("lyiHY");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $cdbdb8739366577e$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $cdbdb8739366577e$var$rsComboMarksRange = '\\u0300-\\u036f', $cdbdb8739366577e$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $cdbdb8739366577e$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $cdbdb8739366577e$var$rsComboRange = $cdbdb8739366577e$var$rsComboMarksRange + $cdbdb8739366577e$var$reComboHalfMarksRange + $cdbdb8739366577e$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $cdbdb8739366577e$var$rsCombo = '[' + $cdbdb8739366577e$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $cdbdb8739366577e$var$reComboMark = RegExp($cdbdb8739366577e$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $cdbdb8739366577e$var$deburr(string) {
    string = $lyiHY(string);
    return string && string.replace($cdbdb8739366577e$var$reLatin, $kdlCI).replace($cdbdb8739366577e$var$reComboMark, '');
}
module.exports = $cdbdb8739366577e$var$deburr;

});
parcelRegister("kdlCI", function(module, exports) {

var $9I2Pb = parcelRequire("9I2Pb");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $eb75cb822d96c217$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $eb75cb822d96c217$var$deburrLetter = $9I2Pb($eb75cb822d96c217$var$deburredLetters);
module.exports = $eb75cb822d96c217$var$deburrLetter;

});
parcelRegister("9I2Pb", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $711a6a0816791cf3$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $711a6a0816791cf3$var$basePropertyOf;

});



parcelRegister("huGzJ", function(module, exports) {

var $jD5yT = parcelRequire("jD5yT");

var $fddu2 = parcelRequire("fddu2");

var $lyiHY = parcelRequire("lyiHY");

var $57sBr = parcelRequire("57sBr");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $cbc6439b24c1fbe3$var$words(string, pattern, guard) {
    string = $lyiHY(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $fddu2(string) ? $57sBr(string) : $jD5yT(string);
    return string.match(pattern) || [];
}
module.exports = $cbc6439b24c1fbe3$var$words;

});
parcelRegister("jD5yT", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $e4a5f94c283d7afd$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $e4a5f94c283d7afd$var$asciiWords(string) {
    return string.match($e4a5f94c283d7afd$var$reAsciiWord) || [];
}
module.exports = $e4a5f94c283d7afd$var$asciiWords;

});

parcelRegister("fddu2", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $b1328773877a3cdd$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $b1328773877a3cdd$var$hasUnicodeWord(string) {
    return $b1328773877a3cdd$var$reHasUnicodeWord.test(string);
}
module.exports = $b1328773877a3cdd$var$hasUnicodeWord;

});

parcelRegister("57sBr", function(module, exports) {
/** Used to compose unicode character classes. */ var $3ba3cb212994d61c$var$rsAstralRange = '\\ud800-\\udfff', $3ba3cb212994d61c$var$rsComboMarksRange = '\\u0300-\\u036f', $3ba3cb212994d61c$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $3ba3cb212994d61c$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $3ba3cb212994d61c$var$rsComboRange = $3ba3cb212994d61c$var$rsComboMarksRange + $3ba3cb212994d61c$var$reComboHalfMarksRange + $3ba3cb212994d61c$var$rsComboSymbolsRange, $3ba3cb212994d61c$var$rsDingbatRange = '\\u2700-\\u27bf', $3ba3cb212994d61c$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $3ba3cb212994d61c$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $3ba3cb212994d61c$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $3ba3cb212994d61c$var$rsPunctuationRange = '\\u2000-\\u206f', $3ba3cb212994d61c$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $3ba3cb212994d61c$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $3ba3cb212994d61c$var$rsVarRange = '\\ufe0e\\ufe0f', $3ba3cb212994d61c$var$rsBreakRange = $3ba3cb212994d61c$var$rsMathOpRange + $3ba3cb212994d61c$var$rsNonCharRange + $3ba3cb212994d61c$var$rsPunctuationRange + $3ba3cb212994d61c$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $3ba3cb212994d61c$var$rsApos = "['\u2019]", $3ba3cb212994d61c$var$rsBreak = '[' + $3ba3cb212994d61c$var$rsBreakRange + ']', $3ba3cb212994d61c$var$rsCombo = '[' + $3ba3cb212994d61c$var$rsComboRange + ']', $3ba3cb212994d61c$var$rsDigits = '\\d+', $3ba3cb212994d61c$var$rsDingbat = '[' + $3ba3cb212994d61c$var$rsDingbatRange + ']', $3ba3cb212994d61c$var$rsLower = '[' + $3ba3cb212994d61c$var$rsLowerRange + ']', $3ba3cb212994d61c$var$rsMisc = '[^' + $3ba3cb212994d61c$var$rsAstralRange + $3ba3cb212994d61c$var$rsBreakRange + $3ba3cb212994d61c$var$rsDigits + $3ba3cb212994d61c$var$rsDingbatRange + $3ba3cb212994d61c$var$rsLowerRange + $3ba3cb212994d61c$var$rsUpperRange + ']', $3ba3cb212994d61c$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $3ba3cb212994d61c$var$rsModifier = '(?:' + $3ba3cb212994d61c$var$rsCombo + '|' + $3ba3cb212994d61c$var$rsFitz + ')', $3ba3cb212994d61c$var$rsNonAstral = '[^' + $3ba3cb212994d61c$var$rsAstralRange + ']', $3ba3cb212994d61c$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $3ba3cb212994d61c$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $3ba3cb212994d61c$var$rsUpper = '[' + $3ba3cb212994d61c$var$rsUpperRange + ']', $3ba3cb212994d61c$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $3ba3cb212994d61c$var$rsMiscLower = '(?:' + $3ba3cb212994d61c$var$rsLower + '|' + $3ba3cb212994d61c$var$rsMisc + ')', $3ba3cb212994d61c$var$rsMiscUpper = '(?:' + $3ba3cb212994d61c$var$rsUpper + '|' + $3ba3cb212994d61c$var$rsMisc + ')', $3ba3cb212994d61c$var$rsOptContrLower = '(?:' + $3ba3cb212994d61c$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $3ba3cb212994d61c$var$rsOptContrUpper = '(?:' + $3ba3cb212994d61c$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $3ba3cb212994d61c$var$reOptMod = $3ba3cb212994d61c$var$rsModifier + '?', $3ba3cb212994d61c$var$rsOptVar = '[' + $3ba3cb212994d61c$var$rsVarRange + ']?', $3ba3cb212994d61c$var$rsOptJoin = '(?:' + $3ba3cb212994d61c$var$rsZWJ + '(?:' + [
    $3ba3cb212994d61c$var$rsNonAstral,
    $3ba3cb212994d61c$var$rsRegional,
    $3ba3cb212994d61c$var$rsSurrPair
].join('|') + ')' + $3ba3cb212994d61c$var$rsOptVar + $3ba3cb212994d61c$var$reOptMod + ')*', $3ba3cb212994d61c$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $3ba3cb212994d61c$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $3ba3cb212994d61c$var$rsSeq = $3ba3cb212994d61c$var$rsOptVar + $3ba3cb212994d61c$var$reOptMod + $3ba3cb212994d61c$var$rsOptJoin, $3ba3cb212994d61c$var$rsEmoji = '(?:' + [
    $3ba3cb212994d61c$var$rsDingbat,
    $3ba3cb212994d61c$var$rsRegional,
    $3ba3cb212994d61c$var$rsSurrPair
].join('|') + ')' + $3ba3cb212994d61c$var$rsSeq;
/** Used to match complex or compound words. */ var $3ba3cb212994d61c$var$reUnicodeWord = RegExp([
    $3ba3cb212994d61c$var$rsUpper + '?' + $3ba3cb212994d61c$var$rsLower + '+' + $3ba3cb212994d61c$var$rsOptContrLower + '(?=' + [
        $3ba3cb212994d61c$var$rsBreak,
        $3ba3cb212994d61c$var$rsUpper,
        '$'
    ].join('|') + ')',
    $3ba3cb212994d61c$var$rsMiscUpper + '+' + $3ba3cb212994d61c$var$rsOptContrUpper + '(?=' + [
        $3ba3cb212994d61c$var$rsBreak,
        $3ba3cb212994d61c$var$rsUpper + $3ba3cb212994d61c$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $3ba3cb212994d61c$var$rsUpper + '?' + $3ba3cb212994d61c$var$rsMiscLower + '+' + $3ba3cb212994d61c$var$rsOptContrLower,
    $3ba3cb212994d61c$var$rsUpper + '+' + $3ba3cb212994d61c$var$rsOptContrUpper,
    $3ba3cb212994d61c$var$rsOrdUpper,
    $3ba3cb212994d61c$var$rsOrdLower,
    $3ba3cb212994d61c$var$rsDigits,
    $3ba3cb212994d61c$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $3ba3cb212994d61c$var$unicodeWords(string) {
    return string.match($3ba3cb212994d61c$var$reUnicodeWord) || [];
}
module.exports = $3ba3cb212994d61c$var$unicodeWords;

});




parcelRegister("1xwC9", function(module, exports) {
"use strict";
var $11f22c091d651641$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $11f22c091d651641$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $11f22c091d651641$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $11f22c091d651641$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $euxye = parcelRequire("euxye");

var $bUjzO = parcelRequire("bUjzO");
var $11f22c091d651641$var$ALL_INITIALIZERS = [];
var $11f22c091d651641$var$READY_INITIALIZERS = [];
function $11f22c091d651641$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $11f22c091d651641$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $11f22c091d651641$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $11f22c091d651641$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $11f22c091d651641$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $11f22c091d651641$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $11f22c091d651641$var$render(loaded, props) {
    return $euxye.createElement($11f22c091d651641$var$resolve(loaded), props);
}
function $11f22c091d651641$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $11f22c091d651641$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $11f22c091d651641$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $11f22c091d651641$var$READY_INITIALIZERS.push(function() {
        if ($11f22c091d651641$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $11f22c091d651641$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $11f22c091d651641$var$_classCallCheck(this, LoadableComponent);
            var _this = $11f22c091d651641$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $euxye.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($euxye.Component), _class.contextTypes = {
        loadable: $bUjzO.shape({
            report: $bUjzO.func.isRequired
        })
    }, _temp;
}
function $11f22c091d651641$var$Loadable(opts) {
    return $11f22c091d651641$var$createLoadableComponent($11f22c091d651641$var$load, opts);
}
function $11f22c091d651641$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $11f22c091d651641$var$createLoadableComponent($11f22c091d651641$var$loadMap, opts);
}
$11f22c091d651641$var$Loadable.Map = $11f22c091d651641$var$LoadableMap;
var $11f22c091d651641$var$Capture = function(_React$Component2) {
    $11f22c091d651641$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $11f22c091d651641$var$_classCallCheck(this, Capture);
        return $11f22c091d651641$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $euxye.Children.only(this.props.children);
    };
    return Capture;
}($euxye.Component);
$11f22c091d651641$var$Capture.propTypes = {
    report: $bUjzO.func.isRequired
};
$11f22c091d651641$var$Capture.childContextTypes = {
    loadable: $bUjzO.shape({
        report: $bUjzO.func.isRequired
    }).isRequired
};
$11f22c091d651641$var$Loadable.Capture = $11f22c091d651641$var$Capture;
function $11f22c091d651641$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $11f22c091d651641$var$flushInitializers(initializers);
    });
}
$11f22c091d651641$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $11f22c091d651641$var$flushInitializers($11f22c091d651641$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$11f22c091d651641$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $11f22c091d651641$var$flushInitializers($11f22c091d651641$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $11f22c091d651641$var$Loadable;

});

parcelRegister("6YRFa", function(module, exports) {
$parcel$export(module.exports, "ROVO_POST_MESSAGE_EVENT_TYPE", () => $75e1d898157fc807$export$cabfb6cc8c48b099);
$parcel$export(module.exports, "RovoPostMessagePubsubListener", () => $75e1d898157fc807$export$e5e1a9c59c299631);
$parcel$export(module.exports, "useRovoPostMessageToPubsub", () => $75e1d898157fc807$export$5340cc94dd0ecbea);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $9ll9z = parcelRequire("9ll9z");
const $75e1d898157fc807$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $75e1d898157fc807$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $75e1d898157fc807$var$allowedSubdomains = [
    '.jira-dev.com',
    '.jira.atlassian.cloud',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $75e1d898157fc807$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $75e1d898157fc807$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($75e1d898157fc807$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $75e1d898157fc807$var$allowedOrigins.includes(hostname));
};
const $75e1d898157fc807$export$e5e1a9c59c299631 = ()=>{
    const publish = (0, $9ll9z.usePublish)('ai-mate');
    (0, $euxye.useEffect)(()=>{
        const handlerUnbind = (0, $glbdM.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$75e1d898157fc807$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $75e1d898157fc807$export$cabfb6cc8c48b099) {
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $75e1d898157fc807$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    event.source?.postMessage(ackPayload, {
                        targetOrigin: '*'
                    });
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
$75e1d898157fc807$export$e5e1a9c59c299631.displayName = "RovoPostMessagePubsubListener";
const $75e1d898157fc807$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $75e1d898157fc807$export$5340cc94dd0ecbea = ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $euxye.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $euxye.useState)(false);
    (0, $euxye.useEffect)(()=>{
        const handlerUnbind = (0, $glbdM.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$75e1d898157fc807$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $75e1d898157fc807$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $euxye.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $75e1d898157fc807$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $75e1d898157fc807$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};

});

parcelRegister("8faAl", function(module, exports) {
$parcel$export(module.exports, "default", () => $db3a8fdf614753b9$export$2e2bcd8739ae039);

var $fhNWD = parcelRequire("fhNWD");
const $db3a8fdf614753b9$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $db3a8fdf614753b9$export$2e2bcd8739ae039 {
    constructor(clientKey, options){
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $db3a8fdf614753b9$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $fhNWD.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
}

});
parcelRegister("fhNWD", function(module, exports) {
$parcel$export(module.exports, "mockWindowStorage", () => $483fd310d4734aa5$export$efebfe7859cae3c7);
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $483fd310d4734aa5$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $483fd310d4734aa5$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$483fd310d4734aa5$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};

});


parcelRegister("2D2gW", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f3fceacebfc72fe$export$2e2bcd8739ae039);

var $d7jXQ = parcelRequire("d7jXQ");
var $0f3fceacebfc72fe$export$2e2bcd8739ae039 = (0, $d7jXQ.default);

});

parcelRegister("fWrp0", function(module, exports) {
$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("7XqvC")).pointerOutsideOfPreview);

var $7XqvC = parcelRequire("7XqvC");

});
parcelRegister("7XqvC", function(module, exports) {
$parcel$export(module.exports, "pointerOutsideOfPreview", () => $b2a2bee232c33b3e$export$427e20518819fabc);

var $bGWmL = parcelRequire("bGWmL");

var $o336J = parcelRequire("o336J");

var $bhUnp = parcelRequire("bhUnp");
function $b2a2bee232c33b3e$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $o336J.isSafariOnIOS)() || (0, $bGWmL.isAndroid)()) return (0, $bhUnp.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}

});
parcelRegister("o336J", function(module, exports) {
$parcel$export(module.exports, "isSafariOnIOS", () => $0de94935f09cc6d4$export$52fc40c68fea4952);

var $fVTcB = parcelRequire("fVTcB");

var $iAExz = parcelRequire("iAExz");
const $0de94935f09cc6d4$export$52fc40c68fea4952 = (0, $fVTcB.once)(function isSafariOnIOS() {
    return (0, $iAExz.isSafari)() && 'ontouchend' in document;
});

});

parcelRegister("bhUnp", function(module, exports) {
$parcel$export(module.exports, "centerUnderPointer", () => $e98fc564643dc313$export$81d8e72a15eef435);
const $e98fc564643dc313$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};

});



parcelRegister("ij70u", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("e77YP")).setCustomNativeDragPreview);

var $e77YP = parcelRequire("e77YP");

});
parcelRegister("e77YP", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => $08964b57de003426$export$52d889c66db0f96e);

var $gOKKd = parcelRequire("gOKKd");

var $iAExz = parcelRequire("iAExz");


var $hgLmR = parcelRequire("hgLmR");

var $5t7KL = parcelRequire("5t7KL");
/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $08964b57de003426$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $08964b57de003426$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $08964b57de003426$var$defaultOffset }) {
    const container = document.createElement('div');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the drag preview container is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // This element is only created for a single frame for the browser to take a
    // photo of it, and then it is destroyed.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    // Note: the popover attribute must be set before the element is in the DOM.
    // `.showPopover()` is called further below after the element is appended to the body.
    if ((0, $5t7KL.supportsPopover)()) container.setAttribute('popover', 'manual');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        ...(0, $5t7KL.supportsPopover)() ? // needs to be overridden by our top / left values
        (0, $hgLmR.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $41191a919c68fe1a$export$7d0a15ee70427305)
        },
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    // `.showPopover()` must be called after the element is in the DOM.
    if ((0, $5t7KL.supportsPopover)()) container.showPopover();
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ /**
		 * Update: this bug fix is no longer needed in `Safari@26.4` (and maybe earlier)
		 * We can remove it in a future release
		 */ if ((0, $iAExz.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        // No need to call `.hidePopover()`.
        // Removing the element from the DOM dismisses the popover
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $gOKKd.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});


parcelRegister("2UWAE", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f6dc24a0b5499d9$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $5KKyn = parcelRequire("5KKyn");

var $gbVOR = parcelRequire("gbVOR");

var $e4Ka9 = parcelRequire("e4Ka9");
function $1f6dc24a0b5499d9$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $e4Ka9.useSafeIntl)();
    const messages = (0, $gbVOR.useMessages)(intl.locale, loaderFn);
    /**
	 * IntlProvider does not inherit from upstream IntlProviders,
	 * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
	 * This prevents the missing messages error.
	 */ const mergedMessages = (0, $euxye.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5KKyn.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}
$1f6dc24a0b5499d9$export$2e2bcd8739ae039.displayName = "IntlMessagesProvider";

});
parcelRegister("gbVOR", function(module, exports) {
$parcel$export(module.exports, "useMessages", () => $7a2a5f8a2635e035$export$4d17e2d9c5348842);

var $euxye = parcelRequire("euxye");

var $gRdVm = parcelRequire("gRdVm");
function $7a2a5f8a2635e035$export$4d17e2d9c5348842(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $euxye.useState)((0, $gRdVm.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $euxye.useRef)(localeState.locale);
    (0, $euxye.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}

});
parcelRegister("gRdVm", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $52f89c126184a046$export$79618bef82c02d4c);
const $52f89c126184a046$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};

});


parcelRegister("e4Ka9", function(module, exports) {
$parcel$export(module.exports, "useSafeIntl", () => $8d7dfb39a5e60785$export$f752ac21ea3960a5);

var $euxye = parcelRequire("euxye");

var $llgA6 = parcelRequire("llgA6");
var $dqCTG = parcelRequire("dqCTG");
var $1jztF = parcelRequire("1jztF");

var $gRdVm = parcelRequire("gRdVm");
// Prevents memory leaks
const $8d7dfb39a5e60785$var$cache = (0, $dqCTG.createIntlCache)();
const $8d7dfb39a5e60785$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $euxye.useContext)((0, $1jztF.Context));
    if (!context) return (0, $llgA6.createIntl)((0, $gRdVm.DEFAULT_LOCALE_STATE), $8d7dfb39a5e60785$var$cache);
    return context;
};

});


parcelRegister("jFnbs", function(module, exports) {
$parcel$export(module.exports, "reorder", () => (parcelRequire("Anlri")).reorder);

var $Anlri = parcelRequire("Anlri");

});
parcelRegister("Anlri", function(module, exports) {
$parcel$export(module.exports, "reorder", () => $294fcfdee274b871$export$fc77a6137e3f91c);
/**
 * A function that will reorder an array (`list`).
 * `reorder` returns a new array with reordered items and does not
 *  modify the original array. The items in the array are also not modified.
 */ function $294fcfdee274b871$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) // Making this function consistently return a new array reference.
    // This is consistent with .toSorted() which always returns a new array
    // even when it does not do anything
    return Array.from(list);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}

});


parcelRegister("cWZxy", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("90V0f")).getElementFromPointWithoutHoneypot);

var $90V0f = parcelRequire("90V0f");

});

parcelRegister("76mBo", function(module, exports) {
$parcel$export(module.exports, "DropIndicator", () => $b1d95cd2e55e2dd0$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $b1d95cd2e55e2dd0$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $864lj = parcelRequire("864lj");

var $1oxDH = parcelRequire("1oxDH");
function $b1d95cd2e55e2dd0$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $864lj.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $1oxDH.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
$b1d95cd2e55e2dd0$export$62ed72bc21f6b8a6.displayName = "DropIndicator";
var // This default export is intended for usage with React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b1d95cd2e55e2dd0$export$2e2bcd8739ae039 = $b1d95cd2e55e2dd0$export$62ed72bc21f6b8a6;

});
parcelRegister("864lj", function(module, exports) {
$parcel$export(module.exports, "Line", () => $c520b7b7ce6c1116$export$17d680238e50603e);
/* line.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $1oxDH = parcelRequire("1oxDH");
const $c520b7b7ce6c1116$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $c520b7b7ce6c1116$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $c520b7b7ce6c1116$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $c520b7b7ce6c1116$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $c520b7b7ce6c1116$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $c520b7b7ce6c1116$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $1oxDH.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $1oxDH.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $c520b7b7ce6c1116$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $c520b7b7ce6c1116$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $4jQY2.default)([
            $c520b7b7ce6c1116$var$baseStyles.root,
            $c520b7b7ce6c1116$var$orientationStyles[orientation],
            $c520b7b7ce6c1116$var$edgeStyles[edge]
        ])
    });
}
$c520b7b7ce6c1116$export$17d680238e50603e.displayName = "Line";
var // For React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$c520b7b7ce6c1116$export$2e2bcd8739ae039 = $c520b7b7ce6c1116$export$17d680238e50603e;

});
parcelRegister("1oxDH", function(module, exports) {
$parcel$export(module.exports, "presetStrokeColors", () => $afec5fd90ee83496$export$477fafec326bfca0);
$parcel$export(module.exports, "presetStrokeWidth", () => $afec5fd90ee83496$export$45db03aa04b685e3);
const $afec5fd90ee83496$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $afec5fd90ee83496$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";

});



parcelRegister("ku91h", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("kPaOg")).disableNativeDragPreview);

var $kPaOg = parcelRequire("kPaOg");

});
parcelRegister("kPaOg", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => $6849977dcbc2a076$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $6849977dcbc2a076$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $6849977dcbc2a076$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $6849977dcbc2a076$var$tinyTransparentImage) nativeSetDragImage($6849977dcbc2a076$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("2k9es", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("bZgd3")).preventUnhandled);

var $bZgd3 = parcelRequire("bZgd3");

});
parcelRegister("bZgd3", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => $561afe3b943fb53b$export$453c0582481cc59d);

var $glbdM = parcelRequire("glbdM");

var $49GfZ = parcelRequire("49GfZ");
function $561afe3b943fb53b$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $561afe3b943fb53b$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $561afe3b943fb53b$var$start() {
    $561afe3b943fb53b$var$cleanup();
    $561afe3b943fb53b$var$unbindEvents = (0, $glbdM.bindAll)(window, [
        {
            type: 'dragover',
            listener: $561afe3b943fb53b$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $561afe3b943fb53b$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $561afe3b943fb53b$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $561afe3b943fb53b$var$cleanup
        },
        ...(0, $49GfZ.getBindingsForBrokenDrags)({
            onDragEnd: $561afe3b943fb53b$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $561afe3b943fb53b$var$cleanup() {
    $561afe3b943fb53b$var$unbindEvents?.();
    $561afe3b943fb53b$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $561afe3b943fb53b$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $561afe3b943fb53b$var$cleanup();
}
const $561afe3b943fb53b$export$453c0582481cc59d = {
    start: $561afe3b943fb53b$var$start,
    stop: $561afe3b943fb53b$var$stop
};

});


parcelRegister("4B6hN", function(module, exports) {
$parcel$export(module.exports, "default", () => $358f7e679fa4bd72$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
function $358f7e679fa4bd72$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $euxye.useRef)(null);
    var maxWaitArgs = (0, $euxye.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $euxye.useRef)(false);
    var functionTimeoutHandler = (0, $euxye.useRef)(null);
    var isComponentUnmounted = (0, $euxye.useRef)(false);
    var debouncedFunction = (0, $euxye.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $euxye.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $euxye.useEffect)(function() {
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $euxye.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $euxye.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("5skZT", function(module, exports) {

var $cIPCk = parcelRequire("cIPCk");

var $7LQgR = parcelRequire("7LQgR");

var $gEB0r = parcelRequire("gEB0r");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $3f8fdaeb431b5518$var$flatRest(func) {
    return $gEB0r($7LQgR(func, undefined, $cIPCk), func + '');
}
module.exports = $3f8fdaeb431b5518$var$flatRest;

});

parcelRegister("3kknN", function(module, exports) {
$parcel$export(module.exports, "default", () => $26c30cf6661977e3$export$2e2bcd8739ae039);

var $jimAf = parcelRequire("jimAf");

var $euxye = parcelRequire("euxye");

var $igleo = parcelRequire("igleo");

var $hStPE = parcelRequire("hStPE");

var $9xrpb = parcelRequire("9xrpb");

var $7dAX9 = parcelRequire("7dAX9");

var $1hsCE = parcelRequire("1hsCE");
var $26c30cf6661977e3$var$testOmitPropsOnStringTag = (0, $igleo.default);
var $26c30cf6661977e3$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $26c30cf6661977e3$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $26c30cf6661977e3$var$testOmitPropsOnStringTag : $26c30cf6661977e3$var$testOmitPropsOnComponent;
};
var $26c30cf6661977e3$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $26c30cf6661977e3$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $26c30cf6661977e3$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $9xrpb.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $1hsCE.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $9xrpb.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $26c30cf6661977e3$var$createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $26c30cf6661977e3$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $26c30cf6661977e3$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $hStPE.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = (0, $euxye.useContext)((0, $hStPE.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $9xrpb.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $7dAX9.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $26c30cf6661977e3$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ (0, $euxye.createElement)((0, $euxye.Fragment), null, /*#__PURE__*/ (0, $euxye.createElement)($26c30cf6661977e3$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ (0, $euxye.createElement)(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $jimAf.default)({}, options, nextOptions, {
                shouldForwardProp: $26c30cf6661977e3$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var $26c30cf6661977e3$export$2e2bcd8739ae039 = $26c30cf6661977e3$var$createStyled;

});
parcelRegister("igleo", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4ba30a8f054120f$export$2e2bcd8739ae039);

var $cPkmA = parcelRequire("cPkmA");
// eslint-disable-next-line no-undef
var $d4ba30a8f054120f$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $d4ba30a8f054120f$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $cPkmA.default)(function(prop) {
    return $d4ba30a8f054120f$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("cPkmA", function(module, exports) {
$parcel$export(module.exports, "default", () => $956a0b2f7f925b51$export$2e2bcd8739ae039);
function $956a0b2f7f925b51$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("9xrpb", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $6f1c743a846507af$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $6f1c743a846507af$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $6f1c743a846507af$export$6f077d94b33a01aa);
var $6f1c743a846507af$var$isBrowser = true;
function $6f1c743a846507af$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $6f1c743a846507af$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $6f1c743a846507af$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $6f1c743a846507af$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $6f1c743a846507af$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});


parcelRegister("8DKOs", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== 'undefined' ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var RushaCore = __webpack_require__(5);
            var _require = __webpack_require__(1), toHex = _require.toHex, ceilHeapSize = _require.ceilHeapSize;
            var conv = __webpack_require__(6);
            // Calculate the length of buffer that the sha1 routine uses
            // including the padding.
            var padlen = function(len) {
                for(len += 9; len % 64 > 0; len += 1);
                return len;
            };
            var padZeroes = function(bin, len) {
                var h8 = new Uint8Array(bin.buffer);
                var om = len % 4, align = len - om;
                switch(om){
                    case 0:
                        h8[align + 3] = 0;
                    case 1:
                        h8[align + 2] = 0;
                    case 2:
                        h8[align + 1] = 0;
                    case 3:
                        h8[align + 0] = 0;
                }
                for(var i = (len >> 2) + 1; i < bin.length; i++)bin[i] = 0;
            };
            var padData = function(bin, chunkLen, msgLen) {
                bin[chunkLen >> 2] |= 0x80 << 24 - (chunkLen % 4 << 3);
                // To support msgLen >= 2 GiB, use a float division when computing the
                // high 32-bits of the big-endian message length in bits.
                bin[((chunkLen >> 2) + 2 & -16) + 14] = msgLen / 536870912 | 0;
                bin[((chunkLen >> 2) + 2 & -16) + 15] = msgLen << 3;
            };
            var getRawDigest = function(heap, padMaxChunkLen) {
                var io = new Int32Array(heap, padMaxChunkLen + 320, 5);
                var out = new Int32Array(5);
                var arr = new DataView(out.buffer);
                arr.setInt32(0, io[0], false);
                arr.setInt32(4, io[1], false);
                arr.setInt32(8, io[2], false);
                arr.setInt32(12, io[3], false);
                arr.setInt32(16, io[4], false);
                return out;
            };
            var Rusha = function() {
                function Rusha(chunkSize) {
                    _classCallCheck(this, Rusha);
                    chunkSize = chunkSize || 65536;
                    if (chunkSize % 64 > 0) throw new Error('Chunk size must be a multiple of 128 bit');
                    this._offset = 0;
                    this._maxChunkLen = chunkSize;
                    this._padMaxChunkLen = padlen(chunkSize);
                    // The size of the heap is the sum of:
                    // 1. The padded input message size
                    // 2. The extended space the algorithm needs (320 byte)
                    // 3. The 160 bit state the algoritm uses
                    this._heap = new ArrayBuffer(ceilHeapSize(this._padMaxChunkLen + 320 + 20));
                    this._h32 = new Int32Array(this._heap);
                    this._h8 = new Int8Array(this._heap);
                    this._core = new RushaCore({
                        Int32Array: Int32Array
                    }, {}, this._heap);
                }
                Rusha.prototype._initState = function _initState(heap, padMsgLen) {
                    this._offset = 0;
                    var io = new Int32Array(heap, padMsgLen + 320, 5);
                    io[0] = 1732584193;
                    io[1] = -271733879;
                    io[2] = -1732584194;
                    io[3] = 271733878;
                    io[4] = -1009589776;
                };
                Rusha.prototype._padChunk = function _padChunk(chunkLen, msgLen) {
                    var padChunkLen = padlen(chunkLen);
                    var view = new Int32Array(this._heap, 0, padChunkLen >> 2);
                    padZeroes(view, chunkLen);
                    padData(view, chunkLen, msgLen);
                    return padChunkLen;
                };
                Rusha.prototype._write = function _write(data, chunkOffset, chunkLen, off) {
                    conv(data, this._h8, this._h32, chunkOffset, chunkLen, off || 0);
                };
                Rusha.prototype._coreCall = function _coreCall(data, chunkOffset, chunkLen, msgLen, finalize) {
                    var padChunkLen = chunkLen;
                    this._write(data, chunkOffset, chunkLen);
                    if (finalize) padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                };
                Rusha.prototype.rawDigest = function rawDigest(str) {
                    var msgLen = str.byteLength || str.length || str.size || 0;
                    this._initState(this._heap, this._padMaxChunkLen);
                    var chunkOffset = 0, chunkLen = this._maxChunkLen;
                    for(chunkOffset = 0; msgLen > chunkOffset + chunkLen; chunkOffset += chunkLen)this._coreCall(str, chunkOffset, chunkLen, msgLen, false);
                    this._coreCall(str, chunkOffset, msgLen - chunkOffset, msgLen, true);
                    return getRawDigest(this._heap, this._padMaxChunkLen);
                };
                Rusha.prototype.digest = function digest(str) {
                    return toHex(this.rawDigest(str).buffer);
                };
                Rusha.prototype.digestFromString = function digestFromString(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromBuffer = function digestFromBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromArrayBuffer = function digestFromArrayBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.resetState = function resetState() {
                    this._initState(this._heap, this._padMaxChunkLen);
                    return this;
                };
                Rusha.prototype.append = function append(chunk) {
                    var chunkOffset = 0;
                    var chunkLen = chunk.byteLength || chunk.length || chunk.size || 0;
                    var turnOffset = this._offset % this._maxChunkLen;
                    var inputLen = void 0;
                    this._offset += chunkLen;
                    while(chunkOffset < chunkLen){
                        inputLen = Math.min(chunkLen - chunkOffset, this._maxChunkLen - turnOffset);
                        this._write(chunk, chunkOffset, inputLen, turnOffset);
                        turnOffset += inputLen;
                        chunkOffset += inputLen;
                        if (turnOffset === this._maxChunkLen) {
                            this._core.hash(this._maxChunkLen, this._padMaxChunkLen);
                            turnOffset = 0;
                        }
                    }
                    return this;
                };
                Rusha.prototype.getState = function getState() {
                    var turnOffset = this._offset % this._maxChunkLen;
                    var heap = void 0;
                    if (!turnOffset) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        heap = io.buffer.slice(io.byteOffset, io.byteOffset + io.byteLength);
                    } else heap = this._heap.slice(0);
                    return {
                        offset: this._offset,
                        heap: heap
                    };
                };
                Rusha.prototype.setState = function setState(state) {
                    this._offset = state.offset;
                    if (state.heap.byteLength === 20) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        io.set(new Int32Array(state.heap));
                    } else this._h32.set(new Int32Array(state.heap));
                    return this;
                };
                Rusha.prototype.rawEnd = function rawEnd() {
                    var msgLen = this._offset;
                    var chunkLen = msgLen % this._maxChunkLen;
                    var padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                    var result = getRawDigest(this._heap, this._padMaxChunkLen);
                    this._initState(this._heap, this._padMaxChunkLen);
                    return result;
                };
                Rusha.prototype.end = function end() {
                    return toHex(this.rawEnd().buffer);
                };
                return Rusha;
            }();
            module1.exports = Rusha;
            module1.exports._core = RushaCore;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /* eslint-env commonjs, browser */ //
            // toHex
            //
            var precomputedHex = new Array(256);
            for(var i = 0; i < 256; i++)precomputedHex[i] = (i < 0x10 ? '0' : '') + i.toString(16);
            module1.exports.toHex = function(arrayBuffer) {
                var binarray = new Uint8Array(arrayBuffer);
                var res = new Array(arrayBuffer.byteLength);
                for(var _i = 0; _i < res.length; _i++)res[_i] = precomputedHex[binarray[_i]];
                return res.join('');
            };
            //
            // ceilHeapSize
            //
            module1.exports.ceilHeapSize = function(v) {
                // The asm.js spec says:
                // The heap object's byteLength must be either
                // 2^n for n in [12, 24) or 2^24 * n for n ≥ 1.
                // Also, byteLengths smaller than 2^16 are deprecated.
                var p = 0;
                // If v is smaller than 2^16, the smallest possible solution
                // is 2^16.
                if (v <= 65536) return 65536;
                // If v < 2^24, we round up to 2^n,
                // otherwise we round up to 2^24 * n.
                if (v < 16777216) {
                    for(p = 1; p < v; p = p << 1);
                } else {
                    for(p = 16777216; p < v; p += 16777216);
                }
                return p;
            };
            //
            // isDedicatedWorkerScope
            //
            module1.exports.isDedicatedWorkerScope = function(self1) {
                var isRunningInWorker = 'WorkerGlobalScope' in self1 && self1 instanceof self1.WorkerGlobalScope;
                var isRunningInSharedWorker = 'SharedWorkerGlobalScope' in self1 && self1 instanceof self1.SharedWorkerGlobalScope;
                var isRunningInServiceWorker = 'ServiceWorkerGlobalScope' in self1 && self1 instanceof self1.ServiceWorkerGlobalScope;
                // Detects whether we run inside a dedicated worker or not.
                //
                // We can't just check for `DedicatedWorkerGlobalScope`, since IE11
                // has a bug where it only supports `WorkerGlobalScope`.
                //
                // Therefore, we consider us as running inside a dedicated worker
                // when we are running inside a worker, but not in a shared or service worker.
                //
                // When new types of workers are introduced, we will need to adjust this code.
                return isRunningInWorker && !isRunningInSharedWorker && !isRunningInServiceWorker;
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, worker */ module1.exports = function() {
                var Rusha = __webpack_require__(0);
                var hashData = function(hasher, data, cb) {
                    try {
                        return cb(null, hasher.digest(data));
                    } catch (e) {
                        return cb(e);
                    }
                };
                var hashFile = function(hasher, readTotal, blockSize, file, cb) {
                    var reader = new self.FileReader();
                    reader.onloadend = function onloadend() {
                        if (reader.error) return cb(reader.error);
                        var buffer = reader.result;
                        readTotal += reader.result.byteLength;
                        try {
                            hasher.append(buffer);
                        } catch (e) {
                            cb(e);
                            return;
                        }
                        if (readTotal < file.size) hashFile(hasher, readTotal, blockSize, file, cb);
                        else cb(null, hasher.end());
                    };
                    reader.readAsArrayBuffer(file.slice(readTotal, readTotal + blockSize));
                };
                var workerBehaviourEnabled = true;
                self.onmessage = function(event) {
                    if (!workerBehaviourEnabled) return;
                    var data = event.data.data, file = event.data.file, id = event.data.id;
                    if (typeof id === 'undefined') return;
                    if (!file && !data) return;
                    var blockSize = event.data.blockSize || 4194304;
                    var hasher = new Rusha(blockSize);
                    hasher.resetState();
                    var done = function(err, hash) {
                        if (!err) self.postMessage({
                            id: id,
                            hash: hash
                        });
                        else self.postMessage({
                            id: id,
                            error: err.name
                        });
                    };
                    if (data) hashData(hasher, data, done);
                    if (file) hashFile(hasher, 0, blockSize, file, done);
                };
                return function() {
                    workerBehaviourEnabled = false;
                };
            };
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, browser */ var work = __webpack_require__(4);
            var Rusha = __webpack_require__(0);
            var createHash = __webpack_require__(7);
            var runWorker = __webpack_require__(2);
            var _require = __webpack_require__(1), isDedicatedWorkerScope = _require.isDedicatedWorkerScope;
            var isRunningInDedicatedWorker = typeof self !== 'undefined' && isDedicatedWorkerScope(self);
            Rusha.disableWorkerBehaviour = isRunningInDedicatedWorker ? runWorker() : function() {};
            Rusha.createWorker = function() {
                var worker = work(/*require.resolve*/ 2);
                var terminate = worker.terminate;
                worker.terminate = function() {
                    URL.revokeObjectURL(worker.objectURL);
                    terminate.call(worker);
                };
                return worker;
            };
            Rusha.createHash = createHash;
            module1.exports = Rusha;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            function webpackBootstrapFunc(modules) {
                /******/ // The module cache
                /******/ var installedModules = {};
                /******/ // The require function
                /******/ function __webpack_require__(moduleId) {
                    /******/ // Check if module is in cache
                    /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                    /******/ // Create a new module (and put it into the cache)
                    /******/ var module1 = installedModules[moduleId] = {
                        /******/ i: moduleId,
                        /******/ l: false,
                        /******/ exports: {}
                    };
                    /******/ // Execute the module function
                    /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                    /******/ // Flag the module as loaded
                    /******/ module1.l = true;
                    /******/ // Return the exports of the module
                    /******/ return module1.exports;
                /******/ }
                /******/ // expose the modules object (__webpack_modules__)
                /******/ __webpack_require__.m = modules;
                /******/ // expose the module cache
                /******/ __webpack_require__.c = installedModules;
                /******/ // identity function for calling harmony imports with the correct context
                /******/ __webpack_require__.i = function(value) {
                    return value;
                };
                /******/ // define getter function for harmony exports
                /******/ __webpack_require__.d = function(exports, name, getter) {
                    /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                        /******/ configurable: false,
                        /******/ enumerable: true,
                        /******/ get: getter
                    });
                /******/ };
                /******/ // define __esModule on exports
                /******/ __webpack_require__.r = function(exports) {
                    /******/ Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                /******/ };
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/ __webpack_require__.n = function(module1) {
                    /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                        return module1['default'];
                    } : /******/ function getModuleExports() {
                        return module1;
                    };
                    /******/ __webpack_require__.d(getter, 'a', getter);
                    /******/ return getter;
                /******/ };
                /******/ // Object.prototype.hasOwnProperty.call
                /******/ __webpack_require__.o = function(object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/ // __webpack_public_path__
                /******/ __webpack_require__.p = "/";
                /******/ // on error function for async loading
                /******/ __webpack_require__.oe = function(err) {
                    console.error(err);
                    throw err;
                };
                var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
                return f.default || f // try to call default if defined to also support babel esmodule exports
                ;
            }
            var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
            var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true
            ;
            // http://stackoverflow.com/a/2593661/130442
            function quoteRegExp(str) {
                return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
            }
            function getModuleDependencies(sources, module1, queueName) {
                var retval = {};
                retval[queueName] = [];
                var fnString = module1.toString();
                var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!wrapperSignature) return retval;
                var webpackRequireName = wrapperSignature[1];
                // main bundle deps
                var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
                var match;
                while(match = re.exec(fnString)){
                    if (match[3] === 'dll-reference') continue;
                    retval[queueName].push(match[3]);
                }
                // dll deps
                re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
                while(match = re.exec(fnString)){
                    if (!sources[match[2]]) {
                        retval[queueName].push(match[1]);
                        sources[match[2]] = __webpack_require__(match[1]).m;
                    }
                    retval[match[2]] = retval[match[2]] || [];
                    retval[match[2]].push(match[4]);
                }
                return retval;
            }
            function hasValuesInQueues(queues) {
                var keys = Object.keys(queues);
                return keys.reduce(function(hasValues, key) {
                    return hasValues || queues[key].length > 0;
                }, false);
            }
            function getRequiredModules(sources, moduleId) {
                var modulesQueue = {
                    main: [
                        moduleId
                    ]
                };
                var requiredModules = {
                    main: []
                };
                var seenModules = {
                    main: {}
                };
                while(hasValuesInQueues(modulesQueue)){
                    var queues = Object.keys(modulesQueue);
                    for(var i = 0; i < queues.length; i++){
                        var queueName = queues[i];
                        var queue = modulesQueue[queueName];
                        var moduleToCheck = queue.pop();
                        seenModules[queueName] = seenModules[queueName] || {};
                        if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue;
                        seenModules[queueName][moduleToCheck] = true;
                        requiredModules[queueName] = requiredModules[queueName] || [];
                        requiredModules[queueName].push(moduleToCheck);
                        var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
                        var newModulesKeys = Object.keys(newModules);
                        for(var j = 0; j < newModulesKeys.length; j++){
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
                        }
                    }
                }
                return requiredModules;
            }
            module1.exports = function(moduleId, options) {
                options = options || {};
                var sources = {
                    main: __webpack_require__.m
                };
                var requiredModules = options.all ? {
                    main: Object.keys(sources)
                } : getRequiredModules(sources, moduleId);
                var src = '';
                Object.keys(requiredModules).filter(function(m) {
                    return m !== 'main';
                }).forEach(function(module1) {
                    var entryModule = 0;
                    while(requiredModules[module1][entryModule])entryModule++;
                    requiredModules[module1].push(entryModule);
                    sources[module1][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
                    src = src + 'var ' + module1 + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module1].map(function(id) {
                        return '' + JSON.stringify(id) + ': ' + sources[module1][id].toString();
                    }).join(',') + '});\n';
                });
                src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function(id) {
                    return '' + JSON.stringify(id) + ': ' + sources.main[id].toString();
                }).join(',') + '})(self);';
                var blob = new window.Blob([
                    src
                ], {
                    type: 'text/javascript'
                });
                if (options.bare) return blob;
                var URL1 = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var workerUrl = URL1.createObjectURL(blob);
                var worker = new window.Worker(workerUrl);
                worker.objectURL = workerUrl;
                return worker;
            };
        /***/ },
        /* 5 */ /***/ function(module1, exports) {
            // The low-level RushCore module provides the heart of Rusha,
            // a high-speed sha1 implementation working on an Int32Array heap.
            // At first glance, the implementation seems complicated, however
            // with the SHA1 spec at hand, it is obvious this almost a textbook
            // implementation that has a few functions hand-inlined and a few loops
            // hand-unrolled.
            module1.exports = function RushaCore(stdlib$846, foreign$847, heap$848) {
                'use asm';
                var H$849 = new stdlib$846.Int32Array(heap$848);
                function hash$850(k$851, x$852) {
                    // k in bytes
                    k$851 = k$851 | 0;
                    x$852 = x$852 | 0;
                    var i$853 = 0, j$854 = 0, y0$855 = 0, z0$856 = 0, y1$857 = 0, z1$858 = 0, y2$859 = 0, z2$860 = 0, y3$861 = 0, z3$862 = 0, y4$863 = 0, z4$864 = 0, t0$865 = 0, t1$866 = 0;
                    y0$855 = H$849[x$852 + 320 >> 2] | 0;
                    y1$857 = H$849[x$852 + 324 >> 2] | 0;
                    y2$859 = H$849[x$852 + 328 >> 2] | 0;
                    y3$861 = H$849[x$852 + 332 >> 2] | 0;
                    y4$863 = H$849[x$852 + 336 >> 2] | 0;
                    for(i$853 = 0; (i$853 | 0) < (k$851 | 0); i$853 = i$853 + 64 | 0){
                        z0$856 = y0$855;
                        z1$858 = y1$857;
                        z2$860 = y2$859;
                        z3$862 = y3$861;
                        z4$864 = y4$863;
                        for(j$854 = 0; (j$854 | 0) < 64; j$854 = j$854 + 4 | 0){
                            t1$866 = H$849[i$853 + j$854 >> 2] | 0;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[k$851 + j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 64 | 0; (j$854 | 0) < (k$851 + 80 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 80 | 0; (j$854 | 0) < (k$851 + 160 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1859775393 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 160 | 0; (j$854 | 0) < (k$851 + 240 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | y1$857 & y3$861 | y2$859 & y3$861) | 0) + ((t1$866 + y4$863 | 0) - 1894007588 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 240 | 0; (j$854 | 0) < (k$851 + 320 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) - 899497514 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        y0$855 = y0$855 + z0$856 | 0;
                        y1$857 = y1$857 + z1$858 | 0;
                        y2$859 = y2$859 + z2$860 | 0;
                        y3$861 = y3$861 + z3$862 | 0;
                        y4$863 = y4$863 + z4$864 | 0;
                    }
                    H$849[x$852 + 320 >> 2] = y0$855;
                    H$849[x$852 + 324 >> 2] = y1$857;
                    H$849[x$852 + 328 >> 2] = y2$859;
                    H$849[x$852 + 332 >> 2] = y3$861;
                    H$849[x$852 + 336 >> 2] = y4$863;
                }
                return {
                    hash: hash$850
                };
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports) {
            var _this = this;
            /* eslint-env commonjs, browser */ var reader = void 0;
            if (typeof self !== 'undefined' && typeof self.FileReaderSync !== 'undefined') reader = new self.FileReaderSync();
            // Convert a binary string and write it to the heap.
            // A binary string is expected to only contain char codes < 256.
            var convStr = function(str, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = str.charCodeAt(start + 3);
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = str.charCodeAt(start + 2);
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = str.charCodeAt(start + 1);
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = str.charCodeAt(start);
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2] = str.charCodeAt(start + i) << 24 | str.charCodeAt(start + i + 1) << 16 | str.charCodeAt(start + i + 2) << 8 | str.charCodeAt(start + i + 3);
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = str.charCodeAt(start + j + 2);
                    case 2:
                        H8[off + j + 2 | 0] = str.charCodeAt(start + j + 1);
                    case 1:
                        H8[off + j + 3 | 0] = str.charCodeAt(start + j);
                }
            };
            // Convert a buffer or array and write it to the heap.
            // The buffer or array is expected to only contain elements < 256.
            var convBuf = function(buf, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = buf[start + 3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[start + 2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[start + 1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[start];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[start + i] << 24 | buf[start + i + 1] << 16 | buf[start + i + 2] << 8 | buf[start + i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[start + j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[start + j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[start + j];
                }
            };
            var convBlob = function(blob, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                var buf = new Uint8Array(reader.readAsArrayBuffer(blob.slice(start, start + len)));
                switch(om){
                    case 0:
                        H8[off] = buf[3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[0];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[i] << 24 | buf[i + 1] << 16 | buf[i + 2] << 8 | buf[i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[j];
                }
            };
            module1.exports = function(data, H8, H32, start, len, off) {
                if (typeof data === 'string') return convStr(data, H8, H32, start, len, off);
                if (data instanceof Array) return convBuf(data, H8, H32, start, len, off);
                // Safely doing a Buffer check using "this" to avoid Buffer polyfill to be included in the dist
                if (_this && _this.Buffer && _this.Buffer.isBuffer(data)) return convBuf(data, H8, H32, start, len, off);
                if (data instanceof ArrayBuffer) return convBuf(new Uint8Array(data), H8, H32, start, len, off);
                if (data.buffer instanceof ArrayBuffer) return convBuf(new Uint8Array(data.buffer, data.byteOffset, data.byteLength), H8, H32, start, len, off);
                if (data instanceof Blob) return convBlob(data, H8, H32, start, len, off);
                throw new Error('Unsupported data type.');
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var Rusha = __webpack_require__(0);
            var _require = __webpack_require__(1), toHex = _require.toHex;
            var Hash = function() {
                function Hash() {
                    _classCallCheck(this, Hash);
                    this._rusha = new Rusha();
                    this._rusha.resetState();
                }
                Hash.prototype.update = function update(data) {
                    this._rusha.append(data);
                    return this;
                };
                Hash.prototype.digest = function digest(encoding) {
                    var digest = this._rusha.rawEnd().buffer;
                    if (!encoding) return digest;
                    if (encoding === 'hex') return toHex(digest);
                    throw new Error('unsupported digest encoding');
                };
                return Hash;
            }();
            module1.exports = function() {
                return new Hash();
            };
        /***/ }
    ]);
});

});

parcelRegister("3BBB7", function(module, exports) {
$parcel$export(module.exports, "default", () => $46ccd9b8e4ce2fac$export$2e2bcd8739ae039);

var $hC0jO = parcelRequire("hC0jO");

var $8DG7p = parcelRequire("8DG7p");


var $46ccd9b8e4ce2fac$export$2e2bcd8739ae039 = (0, $hC0jO.default);

});

parcelRegister("60MZW", function(module, exports) {
$parcel$export(module.exports, "default", () => $16d0cacd88c2cd59$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $16d0cacd88c2cd59$export$d12f56a472cdbe6c);

var $euxye = parcelRequire("euxye");

var $4FR7Y = parcelRequire("4FR7Y");

var $qqoKJ = parcelRequire("qqoKJ");

var $siTdT = parcelRequire("siTdT");
function $16d0cacd88c2cd59$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $euxye.useContext)((0, $4FR7Y.default));
    (0, $euxye.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof globalThis?.structuredClone === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $16d0cacd88c2cd59$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $qqoKJ.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof globalThis?.structuredClone === 'function') (0, $siTdT.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $siTdT.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("jnOWT", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5714e5ca67c675d$export$2e2bcd8739ae039);

var $3Je2d = parcelRequire("3Je2d");
var $e5714e5ca67c675d$export$2e2bcd8739ae039 = (0, $3Je2d.default);

});
parcelRegister("3Je2d", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bd786fff76125a3$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4FR7Y = parcelRequire("4FR7Y");
/**
 * Annotate part of the react tree with a product name
 * ```
 * <UFOLabel name="card">
 *   <Card card={data} />
 * </UFOLabel>
 * ```
 */ const $9bd786fff76125a3$var$UFOLabel = ({ name: name, children: children })=>{
    const context = (0, $4FR7Y.useInteractionContext)();
    const newContext = (0, $euxye.useMemo)(()=>{
        if (context) return {
            ...context,
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [
                ...context.labelStack,
                {
                    name: name
                }
            ]
        };
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4FR7Y.default).Provider, {
        value: newContext,
        children: children
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
};
$9bd786fff76125a3$var$UFOLabel.displayName = "UFOLabel";
$9bd786fff76125a3$var$UFOLabel.displayName = 'UFOLabel';
var $9bd786fff76125a3$export$2e2bcd8739ae039 = $9bd786fff76125a3$var$UFOLabel;

});


parcelRegister("jgHJE", function(module, exports) {
$parcel$export(module.exports, "getUrlForDomainInContext", () => $be7b78888674008e$export$c162de1e7fecc908);

var $fFXK3 = parcelRequire("fFXK3");

var $2XlDJ = parcelRequire("2XlDJ");

var $b1MEY = parcelRequire("b1MEY");

var $22HRS = parcelRequire("22HRS");
function $be7b78888674008e$export$3f82b86ecb947bf0(subdomain, envType) {
    const currentCloudEnvironment = (0, $b1MEY.cloudEnvironment)();
    if (currentCloudEnvironment === undefined) return undefined;
    if (currentCloudEnvironment.type === 'isolated-cloud') {
        const domain = (0, $b1MEY.isolatedCloudDomain)();
        if (domain === undefined) return undefined;
        return $be7b78888674008e$var$getDomainForIsolatedCloud(subdomain, (0, $fFXK3.COMMERCIAL), domain);
    }
    return $be7b78888674008e$var$getDomainForNonIsolatedCloud(subdomain, currentCloudEnvironment.perimeter, envType);
}
/**
 * Gets the full Isolated Cloud domain
 * Returns undefined only if ic_domain cannot be determined from the atl-ctx cookies
 * Defaults to returning the vanity name pattern
 * @param subdomain - The Atlassian experience subdomain
 * @param perimeter - The Isolated Cloud perimeter to get the domain for
 * @param isolatedCloudDomain - The IC domain (ex. "company.atlassian-isolated.net")
 * @returns The full domain associated with the subdomain in a specific IC
 */ function $be7b78888674008e$var$getDomainForIsolatedCloud(subdomain, perimeter, isolatedCloudDomain) {
    const domainMappings = (0, $22HRS.isolatedCloudFunctions)[perimeter];
    if ((0, $22HRS.ReservedNameMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudReservedNameDomain(subdomain, isolatedCloudDomain);
    if ((0, $22HRS.AtlDomainMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudAtlDomain(subdomain, isolatedCloudDomain);
    return domainMappings.isolatedCloudVanityDomain(subdomain, isolatedCloudDomain);
}
/**
 * Gets the full domain in an non-Isolated Cloud perimeter
 *
 * @param subdomain - The Atlassian experience subdomain
 * @param perimeter - The non-isolated cloud perimeter to get the domain for
 * @param The environment to get the domain for ('dev', 'staging', or 'prod'). When in Isolated Cloud, the same value will be returned for all env types.
 * @returns The full domain associated with the subdomain for the given perimeter and environment
 */ function $be7b78888674008e$var$getDomainForNonIsolatedCloud(subdomain, perimeter, envType) {
    // First, check if the subdomain is associated with a global domain
    if ((0, $2XlDJ.globalDomains)[subdomain]) return (0, $2XlDJ.globalDomains)[subdomain];
    // Second, check if the subdomain is associated with a full domain override (ex. a domain that uses a different pattern in other perimeters/environments)
    const override = (0, $2XlDJ.fullDomainOverride)[subdomain]?.[perimeter]?.[envType];
    if (override) return override;
    // Use default domain ending for the given perimeter
    const domainMappings = (0, $22HRS.nonIsolatedCloudFunctions)[perimeter];
    return domainMappings.defaultDomainEnding(subdomain, envType);
}
function $be7b78888674008e$export$c162de1e7fecc908(subdomain, envType) {
    const domain = $be7b78888674008e$export$3f82b86ecb947bf0(subdomain, envType);
    if (!domain) {
        console.warn(`Domain could not be determined for requested subdomain: ${subdomain}`);
        return undefined;
    }
    return `${globalThis.location?.protocol ?? 'https:'}//${domain}`;
}

});
parcelRegister("2XlDJ", function(module, exports) {
$parcel$export(module.exports, "globalDomains", () => $772fa6c5a1c25c79$export$cfd430a73d68f4bc);
$parcel$export(module.exports, "fullDomainOverride", () => $772fa6c5a1c25c79$export$4723232b625f823e);

var $fFXK3 = parcelRequire("fFXK3");
const $772fa6c5a1c25c79$export$cfd430a73d68f4bc = {
    confluence: 'confluence.atlassian.com',
    design: 'design.atlassian.com',
    extranet: 'extranet.atlassian.com',
    go: 'go.atlassian.com',
    my: 'my.atlassian.com',
    surveys: 'surveys.atlassian.com',
    'wac-cdn': 'wac-cdn.atlassian.com',
    integrations: 'integrations.atlassian.com',
    permalink: 'permalink.atlassian.com',
    support: 'support.atlassian.com'
};
const $772fa6c5a1c25c79$export$4723232b625f823e = {
    id: {
        [(0, $fFXK3.COMMERCIAL)]: {
            [(0, $fFXK3.PRODUCTION)]: 'id.atlassian.com',
            [(0, $fFXK3.STAGING)]: 'id.stg.internal.atlassian.com',
            [(0, $fFXK3.DEV)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $fFXK3.FEDRAMP_MODERATE)]: {
            [(0, $fFXK3.PRODUCTION)]: 'id.atlassian-us-gov-mod.com',
            [(0, $fFXK3.STAGING)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    }
};

});

parcelRegister("22HRS", function(module, exports) {
$parcel$export(module.exports, "ReservedNameMapping", () => $cd9518ef61b25112$export$5860df3acd1ee020);
$parcel$export(module.exports, "AtlDomainMapping", () => $cd9518ef61b25112$export$c6366754aee43afa);
$parcel$export(module.exports, "isolatedCloudFunctions", () => $cd9518ef61b25112$export$ad1f7afdb45ad83);
$parcel$export(module.exports, "nonIsolatedCloudFunctions", () => $cd9518ef61b25112$export$c3b4bc58a05128d6);

var $fFXK3 = parcelRequire("fFXK3");
const $cd9518ef61b25112$export$5860df3acd1ee020 = {
    [(0, $fFXK3.COMMERCIAL)]: [
        'home',
        'team',
        'start',
        'id',
        'api',
        'admin',
        'auth',
        'bitbucket'
    ]
};
const $cd9518ef61b25112$export$c6366754aee43afa = {
    [(0, $fFXK3.COMMERCIAL)]: [
        'packages'
    ]
};
const $cd9518ef61b25112$export$ad1f7afdb45ad83 = {
    [(0, $fFXK3.COMMERCIAL)]: {
        isolatedCloudReservedNameDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.${isolatedCloudDomain}`,
        isolatedCloudAtlDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.atl.${isolatedCloudDomain}`,
        isolatedCloudVanityDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.services.${isolatedCloudDomain}`
    }
};
const $cd9518ef61b25112$export$c3b4bc58a05128d6 = {
    [(0, $fFXK3.COMMERCIAL)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $fFXK3.PRODUCTION:
                    return `${subdomain}.atlassian.com`;
                case 0, $fFXK3.STAGING:
                    return `${subdomain}.stg.atlassian.com`;
                case 0, $fFXK3.DEV:
                    return `${subdomain}.dev.atlassian.com`;
                default:
                    console.warn(`Cannot get non-isolated commercial domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    },
    [(0, $fFXK3.FEDRAMP_MODERATE)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $fFXK3.PRODUCTION:
                    return `${subdomain}.atlassian-us-gov-mod.com`;
                case 0, $fFXK3.STAGING:
                    return `${subdomain}.stg.atlassian-us-gov-mod.com`;
                default:
                    console.warn(`Cannot get fedramp-moderate domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    }
};

});


parcelRegister("8HVfB", function(module, exports) {

var $f6GKc = parcelRequire("f6GKc");

var $4byGb = parcelRequire("4byGb");
/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */ var $656ebfa61d3c2125$var$startCase = $f6GKc(function(result, word, index) {
    return result + (index ? ' ' : '') + $4byGb(word);
});
module.exports = $656ebfa61d3c2125$var$startCase;

});

parcelRegister("fSsxt", function(module, exports) {
$parcel$export(module.exports, "default", () => $319a0319ff01f31c$export$2e2bcd8739ae039);
const $319a0319ff01f31c$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $319a0319ff01f31c$export$2e2bcd8739ae039 = $319a0319ff01f31c$var$convertToError;

});

parcelRegister("38a02", function(module, exports) {
$parcel$export(module.exports, "default", () => $2479e027a2c8ccae$export$2e2bcd8739ae039);
function $2479e027a2c8ccae$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $2479e027a2c8ccae$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $2479e027a2c8ccae$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $2479e027a2c8ccae$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $2479e027a2c8ccae$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $2479e027a2c8ccae$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $2479e027a2c8ccae$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $2479e027a2c8ccae$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $2479e027a2c8ccae$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $2479e027a2c8ccae$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $2479e027a2c8ccae$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $2479e027a2c8ccae$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $2479e027a2c8ccae$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $2479e027a2c8ccae$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $2479e027a2c8ccae$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $2479e027a2c8ccae$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $2479e027a2c8ccae$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $2479e027a2c8ccae$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $2479e027a2c8ccae$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $2479e027a2c8ccae$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $2479e027a2c8ccae$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $2479e027a2c8ccae$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $2479e027a2c8ccae$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $2479e027a2c8ccae$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $2479e027a2c8ccae$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $2479e027a2c8ccae$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $2479e027a2c8ccae$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $2479e027a2c8ccae$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $2479e027a2c8ccae$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $2479e027a2c8ccae$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $2479e027a2c8ccae$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $2479e027a2c8ccae$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $2479e027a2c8ccae$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $2479e027a2c8ccae$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $2479e027a2c8ccae$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $2479e027a2c8ccae$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $2479e027a2c8ccae$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $2479e027a2c8ccae$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $2479e027a2c8ccae$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $2479e027a2c8ccae$var$fromHex_1 = $2479e027a2c8ccae$var$fromHex, $2479e027a2c8ccae$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $2479e027a2c8ccae$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $2479e027a2c8ccae$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $2479e027a2c8ccae$var$fromRgb_1 = $2479e027a2c8ccae$var$fromRgb, $2479e027a2c8ccae$var$fromCssRgb_1 = $2479e027a2c8ccae$var$fromCssRgb, $2479e027a2c8ccae$var$fromHsl_1 = $2479e027a2c8ccae$var$fromHsl, $2479e027a2c8ccae$var$fromCssHsl_1 = $2479e027a2c8ccae$var$fromCssHsl, $2479e027a2c8ccae$var$fromHsv_1 = $2479e027a2c8ccae$var$fromHsv, $2479e027a2c8ccae$var$fromCmyk_1 = $2479e027a2c8ccae$var$fromCmyk, $2479e027a2c8ccae$var$fromYiq_1 = $2479e027a2c8ccae$var$fromYiq, $2479e027a2c8ccae$var$fromXYZ_1 = $2479e027a2c8ccae$var$fromXYZ, $2479e027a2c8ccae$var$fromxyY_1 = $2479e027a2c8ccae$var$fromxyY, $2479e027a2c8ccae$var$fromLms_1 = $2479e027a2c8ccae$var$fromLms, $2479e027a2c8ccae$var$fromCieLab_1 = $2479e027a2c8ccae$var$fromCieLab, $2479e027a2c8ccae$var$fromCieLuv_1 = $2479e027a2c8ccae$var$fromCieLuv, $2479e027a2c8ccae$var$fromCieLch_1 = $2479e027a2c8ccae$var$fromCieLch, $2479e027a2c8ccae$var$fromHsluv = $2479e027a2c8ccae$var$fromCieLch$1, $2479e027a2c8ccae$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $2479e027a2c8ccae$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $2479e027a2c8ccae$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $2479e027a2c8ccae$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $2479e027a2c8ccae$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $2479e027a2c8ccae$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $2479e027a2c8ccae$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $2479e027a2c8ccae$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $2479e027a2c8ccae$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $2479e027a2c8ccae$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $2479e027a2c8ccae$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $2479e027a2c8ccae$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $2479e027a2c8ccae$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $2479e027a2c8ccae$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $2479e027a2c8ccae$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $2479e027a2c8ccae$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $2479e027a2c8ccae$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $2479e027a2c8ccae$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $2479e027a2c8ccae$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $2479e027a2c8ccae$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $2479e027a2c8ccae$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $2479e027a2c8ccae$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $2479e027a2c8ccae$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $2479e027a2c8ccae$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $2479e027a2c8ccae$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $2479e027a2c8ccae$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $2479e027a2c8ccae$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $2479e027a2c8ccae$var$fromHsluv
    }
}, $2479e027a2c8ccae$var$adapt_1 = $2479e027a2c8ccae$var$adapt, $2479e027a2c8ccae$var$adjacent_1 = $2479e027a2c8ccae$var$adjacent, $2479e027a2c8ccae$var$brightness_1 = $2479e027a2c8ccae$var$brightness, $2479e027a2c8ccae$var$complementary_1 = $2479e027a2c8ccae$var$complementary, $2479e027a2c8ccae$var$contrast_1 = $2479e027a2c8ccae$var$contrast, $2479e027a2c8ccae$var$contrastRatio_1 = $2479e027a2c8ccae$var$contrastRatio, $2479e027a2c8ccae$var$convert_1 = $2479e027a2c8ccae$var$convert, $2479e027a2c8ccae$var$difference_1 = $2479e027a2c8ccae$var$difference, $2479e027a2c8ccae$var$fade_1 = $2479e027a2c8ccae$var$fade, $2479e027a2c8ccae$var$greyscale_1 = $2479e027a2c8ccae$var$greyscale, $2479e027a2c8ccae$var$hue_1 = $2479e027a2c8ccae$var$hue, $2479e027a2c8ccae$var$invert_1 = $2479e027a2c8ccae$var$invert, $2479e027a2c8ccae$var$invertLightness_1 = $2479e027a2c8ccae$var$invertLightness, $2479e027a2c8ccae$var$mid_1 = $2479e027a2c8ccae$var$mid, $2479e027a2c8ccae$var$multiply_1 = $2479e027a2c8ccae$var$multiply, $2479e027a2c8ccae$var$saturation_1 = $2479e027a2c8ccae$var$saturation, $2479e027a2c8ccae$var$sepia_1 = $2479e027a2c8ccae$var$sepia, $2479e027a2c8ccae$var$shade_1 = $2479e027a2c8ccae$var$shade, $2479e027a2c8ccae$var$temperature_1 = $2479e027a2c8ccae$var$temperature, $2479e027a2c8ccae$var$tetrad_1 = $2479e027a2c8ccae$var$tetrad, $2479e027a2c8ccae$var$triad_1 = $2479e027a2c8ccae$var$triad, $2479e027a2c8ccae$var$index$2 = {
    adapt: $2479e027a2c8ccae$var$adapt_1,
    adjacent: $2479e027a2c8ccae$var$adjacent_1,
    brightness: $2479e027a2c8ccae$var$brightness_1,
    complementary: $2479e027a2c8ccae$var$complementary_1,
    contrast: $2479e027a2c8ccae$var$contrast_1,
    contrastRatio: $2479e027a2c8ccae$var$contrastRatio_1,
    convert: $2479e027a2c8ccae$var$convert_1,
    difference: $2479e027a2c8ccae$var$difference_1,
    fade: $2479e027a2c8ccae$var$fade_1,
    greyscale: $2479e027a2c8ccae$var$greyscale_1,
    hue: $2479e027a2c8ccae$var$hue_1,
    invert: $2479e027a2c8ccae$var$invert_1,
    invertLightness: $2479e027a2c8ccae$var$invertLightness_1,
    mid: $2479e027a2c8ccae$var$mid_1,
    multiply: $2479e027a2c8ccae$var$multiply_1,
    saturation: $2479e027a2c8ccae$var$saturation_1,
    sepia: $2479e027a2c8ccae$var$sepia_1,
    shade: $2479e027a2c8ccae$var$shade_1,
    temperature: $2479e027a2c8ccae$var$temperature_1,
    tetrad: $2479e027a2c8ccae$var$tetrad_1,
    triad: $2479e027a2c8ccae$var$triad_1
}, $2479e027a2c8ccae$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $2479e027a2c8ccae$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $2479e027a2c8ccae$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($2479e027a2c8ccae$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $2479e027a2c8ccae$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($2479e027a2c8ccae$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $2479e027a2c8ccae$var$api_1 = $2479e027a2c8ccae$var$api, $2479e027a2c8ccae$var$helpers = {
    getIlluminant: function(r) {
        return $2479e027a2c8ccae$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $2479e027a2c8ccae$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $2479e027a2c8ccae$var$index)if ($2479e027a2c8ccae$var$index.hasOwnProperty(e) && $2479e027a2c8ccae$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $2479e027a2c8ccae$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $2479e027a2c8ccae$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $2479e027a2c8ccae$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $2479e027a2c8ccae$var$constants, s));
            default:
                return null;
        }
    }
}, $2479e027a2c8ccae$var$helpers_1 = $2479e027a2c8ccae$var$helpers, $2479e027a2c8ccae$var$dependencies = {
    conversions: $2479e027a2c8ccae$var$index,
    operations: $2479e027a2c8ccae$var$index$2,
    helpers: $2479e027a2c8ccae$var$helpers_1
}, $2479e027a2c8ccae$var$entry = $2479e027a2c8ccae$var$api_1($2479e027a2c8ccae$var$dependencies, $2479e027a2c8ccae$var$constants);
var $2479e027a2c8ccae$export$2e2bcd8739ae039 = $2479e027a2c8ccae$var$entry;

});

parcelRegister("l28YB", function(module, exports) {

var $bTATB = parcelRequire("bTATB");

var $aisNj = parcelRequire("aisNj");

var $gidbT = parcelRequire("gidbT");

var $kTkDw = parcelRequire("kTkDw");

var $8b2ec = parcelRequire("8b2ec");

var $3KYgg = parcelRequire("3KYgg");

var $5skZT = parcelRequire("5skZT");

var $7L3er = parcelRequire("7L3er");
/** Used to compose bitmasks for cloning. */ var $f500bf6cfa5444cf$var$CLONE_DEEP_FLAG = 1, $f500bf6cfa5444cf$var$CLONE_FLAT_FLAG = 2, $f500bf6cfa5444cf$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $f500bf6cfa5444cf$var$omit = $5skZT(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $bTATB(paths, function(path) {
        path = $kTkDw(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $8b2ec(object, $7L3er(object), result);
    if (isDeep) result = $aisNj(result, $f500bf6cfa5444cf$var$CLONE_DEEP_FLAG | $f500bf6cfa5444cf$var$CLONE_FLAT_FLAG | $f500bf6cfa5444cf$var$CLONE_SYMBOLS_FLAG, $3KYgg);
    var length = paths.length;
    while(length--)$gidbT(result, paths[length]);
    return result;
});
module.exports = $f500bf6cfa5444cf$var$omit;

});
parcelRegister("gidbT", function(module, exports) {

var $kTkDw = parcelRequire("kTkDw");

var $hlxpN = parcelRequire("hlxpN");

var $04f0t = parcelRequire("04f0t");

var $7I3m1 = parcelRequire("7I3m1");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $bdc88f3332a0c07c$var$baseUnset(object, path) {
    path = $kTkDw(path, object);
    object = $04f0t(object, path);
    return object == null || delete object[$7I3m1($hlxpN(path))];
}
module.exports = $bdc88f3332a0c07c$var$baseUnset;

});
parcelRegister("04f0t", function(module, exports) {

var $70631 = parcelRequire("70631");

var $g2svi = parcelRequire("g2svi");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $00cc03d4db6bae76$var$parent(object, path) {
    return path.length < 2 ? object : $70631(object, $g2svi(path, 0, -1));
}
module.exports = $00cc03d4db6bae76$var$parent;

});


parcelRegister("3KYgg", function(module, exports) {

var $9Ym1f = parcelRequire("9Ym1f");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $2bc4699deaeacec1$var$customOmitClone(value) {
    return $9Ym1f(value) ? undefined : value;
}
module.exports = $2bc4699deaeacec1$var$customOmitClone;

});


parcelRegister("fb5DN", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ae8230dec162b42$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $kTviw = parcelRequire("kTviw");
var $2ae8230dec162b42$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $euxye.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, $e79Pd.jsx)(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args), this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $kTviw.default)()(EngagementEventsWrapper);
};

});

parcelRegister("ba3AP", function(module, exports) {
$parcel$export(module.exports, "default", () => $52da481b5ec9a3a9$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $bUjzO = parcelRequire("bUjzO");
var $52da481b5ec9a3a9$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $euxye.Component) {
        static{
            this.contextTypes = {
                subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($bUjzO))).func,
                setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($bUjzO))).func
            };
        }
        render() {
            return /*#__PURE__*/ (0, $e79Pd.jsx)(StoreWrapperInner, {
                ...this.props,
                context: this.context
            });
        }
    }
    const StoreWrapperInner = (allProps)=>{
        const { context: context, ...props } = allProps;
        const { children: children, engagementId: engagementId, messageType: messageType, onMessageDisposition: onMessageDisposition } = props;
        const [message, setMessage] = (0, $euxye.useState)(null);
        const unsubscribeRef = (0, $euxye.useRef)(null);
        const removeConfigRef = (0, $euxye.useRef)(null);
        const canSubscribe = (0, $euxye.useCallback)(()=>{
            return context && !!context?.subscribeEngagementState;
        }, [
            context
        ]);
        const canSetConfig = (0, $euxye.useCallback)(()=>{
            return context && !!context?.setComponentConfig;
        }, [
            context
        ]);
        const onStoreChange = (0, $euxye.useCallback)((state)=>{
            setMessage(computeNewState(state).message);
        }, []);
        const subscribeToStore = (0, $euxye.useCallback)(()=>{
            return context?.subscribeEngagementState?.(onStoreChange);
        }, [
            context,
            onStoreChange
        ]);
        const setChoreographerConfig = (0, $euxye.useCallback)((propsToUse = props)=>{
            return context?.setComponentConfig?.(getComponentType(), {
                messageType: propsToUse.messageType,
                onMessageDisposition: propsToUse.onMessageDisposition
            }, propsToUse.engagementId);
        }, [
            context,
            props
        ]);
        // Handle initial mount (equivalent to UNSAFE_componentWillMount)
        (0, $euxye.useEffect)(()=>{
            if (canSubscribe()) unsubscribeRef.current = subscribeToStore() || null;
            if (canSetConfig()) removeConfigRef.current = setChoreographerConfig() || null;
            return ()=>{
                if (unsubscribeRef.current) unsubscribeRef.current();
                if (removeConfigRef.current) removeConfigRef.current();
            };
        }, [
            canSubscribe,
            canSetConfig,
            subscribeToStore,
            setChoreographerConfig
        ]);
        // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
        const previousEngagementId = (0, $euxye.useRef)(engagementId);
        const previousMessageType = (0, $euxye.useRef)(messageType);
        const previousOnMessageDisposition = (0, $euxye.useRef)(onMessageDisposition);
        (0, $euxye.useEffect)(()=>{
            if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
                removeConfigRef.current();
                removeConfigRef.current = setChoreographerConfig(props) || null;
            } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) setChoreographerConfig(props);
            previousEngagementId.current = engagementId;
            previousMessageType.current = messageType;
            previousOnMessageDisposition.current = onMessageDisposition;
        }, [
            props,
            setChoreographerConfig,
            canSetConfig,
            engagementId,
            messageType,
            onMessageDisposition
        ]);
        if (!message) {
            if (componentType === 'inlineDialog') return children || null;
            return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
        const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/ (0, $e79Pd.jsx)(InnerComponent, {
            ...props,
            ...message
        }, messageKey);
    };
    return StoreWrapper;
};

});

parcelRegister("1MKhf", function(module, exports) {
$parcel$export(module.exports, "buttonActionTypes", () => $74a6b637d7e1174a$export$e7d79186651244da);
const $74a6b637d7e1174a$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};

});

parcelRegister("kFBBO", function(module, exports) {
$parcel$export(module.exports, "default", () => $38629afbe265020e$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
class $38629afbe265020e$export$2e2bcd8739ae039 extends (0, $euxye.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}
$38629afbe265020e$export$2e2bcd8739ae039.displayName = "HtmlContent";

});

parcelRegister("a5nxD", function(module, exports) {
$parcel$export(module.exports, "getIsInJiraHoldoutData", () => $c1d8402e717adb83$export$169025fa80347e5);
$parcel$export(module.exports, "JiraHoldoutCustomData", () => $c1d8402e717adb83$export$fdfd98dbe16cdb4a);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4LDqh = parcelRequire("4LDqh");

var $egspI = parcelRequire("egspI");

var $60MZW = parcelRequire("60MZW");
const $c1d8402e717adb83$export$169025fa80347e5 = ()=>{
    const featureGateWithinHoldout = (0, $egspI.fg)('migrate-jira-holdout-observability-flag-fy27h1') ? 'product-jira-holdout-org_id-observability-gate' : 'product-jira-holdout-observability-gate';
    // This explicitly does not fire exposure, in order to prevent a Holdout exposure, which can dilute the Holdout measurement.
    const isInJiraHoldout = (0, $4LDqh.default).initializeCompleted() && !(0, $4LDqh.default).checkGate(featureGateWithinHoldout, {
        fireGateExposure: false
    });
    return {
        holdout: isInJiraHoldout ? 'jira-holdout' : ''
    };
};
const $c1d8402e717adb83$export$fdfd98dbe16cdb4a = ()=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $60MZW.default), {
        data: $c1d8402e717adb83$export$169025fa80347e5()
    });
};
$c1d8402e717adb83$export$fdfd98dbe16cdb4a.displayName = "JiraHoldoutCustomData";

});

parcelRegister("e7boj", function(module, exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @lightSyntaxTransform
 * @noflow
 * @nolint
 * @preventMunge
 * @preserve-invariant-messages
 */ "use no memo";
"use strict";
var $a46a8e31f9fed9ca$var$__create = Object.create;
var $a46a8e31f9fed9ca$var$__defProp = Object.defineProperty;
var $a46a8e31f9fed9ca$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $a46a8e31f9fed9ca$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $a46a8e31f9fed9ca$var$__getProtoOf = Object.getPrototypeOf;
var $a46a8e31f9fed9ca$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a46a8e31f9fed9ca$var$__export = (target, all)=>{
    for(var name in all)$a46a8e31f9fed9ca$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $a46a8e31f9fed9ca$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $a46a8e31f9fed9ca$var$__getOwnPropNames(from))if (!$a46a8e31f9fed9ca$var$__hasOwnProp.call(to, key) && key !== except) $a46a8e31f9fed9ca$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $a46a8e31f9fed9ca$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $a46a8e31f9fed9ca$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $a46a8e31f9fed9ca$var$__create($a46a8e31f9fed9ca$var$__getProtoOf(mod)) : {}, $a46a8e31f9fed9ca$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $a46a8e31f9fed9ca$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $a46a8e31f9fed9ca$var$__toCommonJS = (mod)=>$a46a8e31f9fed9ca$var$__copyProps($a46a8e31f9fed9ca$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/index.ts
var $a46a8e31f9fed9ca$var$index_exports = {};
$a46a8e31f9fed9ca$var$__export($a46a8e31f9fed9ca$var$index_exports, {
    $dispatcherGuard: ()=>$a46a8e31f9fed9ca$var$$dispatcherGuard,
    $makeReadOnly: ()=>$a46a8e31f9fed9ca$var$$makeReadOnly,
    $reset: ()=>$a46a8e31f9fed9ca$var$$reset,
    $structuralCheck: ()=>$a46a8e31f9fed9ca$var$$structuralCheck,
    c: ()=>$a46a8e31f9fed9ca$var$c,
    clearRenderCounterRegistry: ()=>$a46a8e31f9fed9ca$var$clearRenderCounterRegistry,
    renderCounterRegistry: ()=>$a46a8e31f9fed9ca$var$renderCounterRegistry,
    useRenderCounter: ()=>$a46a8e31f9fed9ca$var$useRenderCounter
});
module.exports = $a46a8e31f9fed9ca$var$__toCommonJS($a46a8e31f9fed9ca$var$index_exports);

var $a46a8e31f9fed9ca$var$React = $a46a8e31f9fed9ca$var$__toESM((parcelRequire("euxye")));
var { useRef: $a46a8e31f9fed9ca$var$useRef, useEffect: $a46a8e31f9fed9ca$var$useEffect, isValidElement: $a46a8e31f9fed9ca$var$isValidElement } = $a46a8e31f9fed9ca$var$React;
var $a46a8e31f9fed9ca$var$_a;
var $a46a8e31f9fed9ca$var$ReactSecretInternals = //@ts-ignore
($a46a8e31f9fed9ca$var$_a = $a46a8e31f9fed9ca$var$React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE) != null ? $a46a8e31f9fed9ca$var$_a : $a46a8e31f9fed9ca$var$React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
var $a46a8e31f9fed9ca$var$$empty = Symbol.for("react.memo_cache_sentinel");
var $a46a8e31f9fed9ca$var$_a2;
var $a46a8e31f9fed9ca$var$c = // @ts-expect-error
typeof (($a46a8e31f9fed9ca$var$_a2 = $a46a8e31f9fed9ca$var$React.__COMPILER_RUNTIME) == null ? void 0 : $a46a8e31f9fed9ca$var$_a2.c) === "function" ? // @ts-expect-error
$a46a8e31f9fed9ca$var$React.__COMPILER_RUNTIME.c : function c2(size) {
    return $a46a8e31f9fed9ca$var$React.useMemo(()=>{
        const $ = new Array(size);
        for(let ii = 0; ii < size; ii++)$[ii] = $a46a8e31f9fed9ca$var$$empty;
        $[$a46a8e31f9fed9ca$var$$empty] = true;
        return $;
    }, []);
};
var $a46a8e31f9fed9ca$var$LazyGuardDispatcher = {};
[
    "readContext",
    "useCallback",
    "useContext",
    "useEffect",
    "useImperativeHandle",
    "useInsertionEffect",
    "useLayoutEffect",
    "useMemo",
    "useReducer",
    "useRef",
    "useState",
    "useDebugValue",
    "useDeferredValue",
    "useTransition",
    "useMutableSource",
    "useSyncExternalStore",
    "useId",
    "unstable_isNewReconciler",
    "getCacheSignal",
    "getCacheForType",
    "useCacheRefresh"
].forEach((name)=>{
    $a46a8e31f9fed9ca$var$LazyGuardDispatcher[name] = ()=>{
        throw new Error(`[React] Unexpected React hook call (${name}) from a React compiled function. Check that all hooks are called directly and named according to convention ('use[A-Z]') `);
    };
});
var $a46a8e31f9fed9ca$var$originalDispatcher = null;
$a46a8e31f9fed9ca$var$LazyGuardDispatcher["useMemoCache"] = (count)=>{
    if ($a46a8e31f9fed9ca$var$originalDispatcher == null) throw new Error("React Compiler internal invariant violation: unexpected null dispatcher");
    else return $a46a8e31f9fed9ca$var$originalDispatcher.useMemoCache(count);
};
function $a46a8e31f9fed9ca$var$setCurrent(newDispatcher) {
    $a46a8e31f9fed9ca$var$ReactSecretInternals.ReactCurrentDispatcher.current = newDispatcher;
    return $a46a8e31f9fed9ca$var$ReactSecretInternals.ReactCurrentDispatcher.current;
}
var $a46a8e31f9fed9ca$var$guardFrames = [];
function $a46a8e31f9fed9ca$var$$dispatcherGuard(kind) {
    const curr = $a46a8e31f9fed9ca$var$ReactSecretInternals.ReactCurrentDispatcher.current;
    if (kind === 0 /* PushGuardContext */ ) {
        $a46a8e31f9fed9ca$var$guardFrames.push(curr);
        if ($a46a8e31f9fed9ca$var$guardFrames.length === 1) $a46a8e31f9fed9ca$var$originalDispatcher = curr;
        if (curr === $a46a8e31f9fed9ca$var$LazyGuardDispatcher) throw new Error(`[React] Unexpected call to custom hook or component from a React compiled function. Check that (1) all hooks are called directly and named according to convention ('use[A-Z]') and (2) components are returned as JSX instead of being directly invoked.`);
        $a46a8e31f9fed9ca$var$setCurrent($a46a8e31f9fed9ca$var$LazyGuardDispatcher);
    } else if (kind === 1 /* PopGuardContext */ ) {
        const lastFrame = $a46a8e31f9fed9ca$var$guardFrames.pop();
        if (lastFrame == null) throw new Error("React Compiler internal error: unexpected null in guard stack");
        if ($a46a8e31f9fed9ca$var$guardFrames.length === 0) $a46a8e31f9fed9ca$var$originalDispatcher = null;
        $a46a8e31f9fed9ca$var$setCurrent(lastFrame);
    } else if (kind === 2 /* PushExpectHook */ ) {
        $a46a8e31f9fed9ca$var$guardFrames.push(curr);
        $a46a8e31f9fed9ca$var$setCurrent($a46a8e31f9fed9ca$var$originalDispatcher);
    } else if (kind === 3 /* PopExpectHook */ ) {
        const lastFrame = $a46a8e31f9fed9ca$var$guardFrames.pop();
        if (lastFrame == null) throw new Error("React Compiler internal error: unexpected null in guard stack");
        $a46a8e31f9fed9ca$var$setCurrent(lastFrame);
    } else throw new Error("React Compiler internal error: unreachable block" + kind);
}
function $a46a8e31f9fed9ca$var$$reset($) {
    for(let ii = 0; ii < $.length; ii++)$[ii] = $a46a8e31f9fed9ca$var$$empty;
}
function $a46a8e31f9fed9ca$var$$makeReadOnly() {
    throw new Error("TODO: implement $makeReadOnly in react-compiler-runtime");
}
var $a46a8e31f9fed9ca$var$renderCounterRegistry = /* @__PURE__ */ new Map();
function $a46a8e31f9fed9ca$var$clearRenderCounterRegistry() {
    for (const counters of $a46a8e31f9fed9ca$var$renderCounterRegistry.values())counters.forEach((counter)=>{
        counter.count = 0;
    });
}
function $a46a8e31f9fed9ca$var$registerRenderCounter(name, val) {
    let counters = $a46a8e31f9fed9ca$var$renderCounterRegistry.get(name);
    if (counters == null) {
        counters = /* @__PURE__ */ new Set();
        $a46a8e31f9fed9ca$var$renderCounterRegistry.set(name, counters);
    }
    counters.add(val);
}
function $a46a8e31f9fed9ca$var$removeRenderCounter(name, val) {
    const counters = $a46a8e31f9fed9ca$var$renderCounterRegistry.get(name);
    if (counters == null) return;
    counters.delete(val);
}
function $a46a8e31f9fed9ca$var$useRenderCounter(name) {
    const val = $a46a8e31f9fed9ca$var$useRef(null);
    if (val.current != null) val.current.count += 1;
    $a46a8e31f9fed9ca$var$useEffect(()=>{
        if (val.current == null) {
            const counter = {
                count: 0
            };
            $a46a8e31f9fed9ca$var$registerRenderCounter(name, counter);
            val.current = counter;
        }
        return ()=>{
            if (val.current !== null) $a46a8e31f9fed9ca$var$removeRenderCounter(name, val.current);
        };
    });
}
var $a46a8e31f9fed9ca$var$seenErrors = /* @__PURE__ */ new Set();
function $a46a8e31f9fed9ca$var$$structuralCheck(oldValue, newValue, variableName, fnName, kind, loc) {
    function error(l, r, path, depth) {
        const str = `${fnName}:${loc} [${kind}] ${variableName}${path} changed from ${l} to ${r} at depth ${depth}`;
        if ($a46a8e31f9fed9ca$var$seenErrors.has(str)) return;
        $a46a8e31f9fed9ca$var$seenErrors.add(str);
        console.error(str);
    }
    const depthLimit = 2;
    function recur(oldValue2, newValue2, path, depth) {
        if (depth > depthLimit) return;
        else if (oldValue2 === newValue2) return;
        else if (typeof oldValue2 !== typeof newValue2) error(`type ${typeof oldValue2}`, `type ${typeof newValue2}`, path, depth);
        else if (typeof oldValue2 === "object") {
            const oldArray = Array.isArray(oldValue2);
            const newArray = Array.isArray(newValue2);
            if (oldValue2 === null && newValue2 !== null) error("null", `type ${typeof newValue2}`, path, depth);
            else if (newValue2 === null) error(`type ${typeof oldValue2}`, "null", path, depth);
            else if (oldValue2 instanceof Map) {
                if (!(newValue2 instanceof Map)) error(`Map instance`, `other value`, path, depth);
                else if (oldValue2.size !== newValue2.size) error(`Map instance with size ${oldValue2.size}`, `Map instance with size ${newValue2.size}`, path, depth);
                else {
                    for (const [k, v] of oldValue2)if (!newValue2.has(k)) error(`Map instance with key ${k}`, `Map instance without key ${k}`, path, depth);
                    else recur(v, newValue2.get(k), `${path}.get(${k})`, depth + 1);
                }
            } else if (newValue2 instanceof Map) error("other value", `Map instance`, path, depth);
            else if (oldValue2 instanceof Set) {
                if (!(newValue2 instanceof Set)) error(`Set instance`, `other value`, path, depth);
                else if (oldValue2.size !== newValue2.size) error(`Set instance with size ${oldValue2.size}`, `Set instance with size ${newValue2.size}`, path, depth);
                else {
                    for (const v of newValue2)if (!oldValue2.has(v)) error(`Set instance without element ${v}`, `Set instance with element ${v}`, path, depth);
                }
            } else if (newValue2 instanceof Set) error("other value", `Set instance`, path, depth);
            else if (oldArray || newArray) {
                if (oldArray !== newArray) error(`type ${oldArray ? "array" : "object"}`, `type ${newArray ? "array" : "object"}`, path, depth);
                else if (oldValue2.length !== newValue2.length) error(`array with length ${oldValue2.length}`, `array with length ${newValue2.length}`, path, depth);
                else for(let ii = 0; ii < oldValue2.length; ii++)recur(oldValue2[ii], newValue2[ii], `${path}[${ii}]`, depth + 1);
            } else if ($a46a8e31f9fed9ca$var$isValidElement(oldValue2) || $a46a8e31f9fed9ca$var$isValidElement(newValue2)) {
                if ($a46a8e31f9fed9ca$var$isValidElement(oldValue2) !== $a46a8e31f9fed9ca$var$isValidElement(newValue2)) error(`type ${$a46a8e31f9fed9ca$var$isValidElement(oldValue2) ? "React element" : "object"}`, `type ${$a46a8e31f9fed9ca$var$isValidElement(newValue2) ? "React element" : "object"}`, path, depth);
                else if (oldValue2.type !== newValue2.type) error(`React element of type ${oldValue2.type}`, `React element of type ${newValue2.type}`, path, depth);
                else recur(oldValue2.props, newValue2.props, `[props of ${path}]`, depth + 1);
            } else {
                for(const key in newValue2)if (!(key in oldValue2)) error(`object without key ${key}`, `object with key ${key}`, path, depth);
                for(const key in oldValue2)if (!(key in newValue2)) error(`object with key ${key}`, `object without key ${key}`, path, depth);
                else recur(oldValue2[key], newValue2[key], `${path}.${key}`, depth + 1);
            }
        } else if (typeof oldValue2 === "function") return;
        else if (isNaN(oldValue2) || isNaN(newValue2)) {
            if (isNaN(oldValue2) !== isNaN(newValue2)) error(`${isNaN(oldValue2) ? "NaN" : "non-NaN value"}`, `${isNaN(newValue2) ? "NaN" : "non-NaN value"}`, path, depth);
        } else if (oldValue2 !== newValue2) error(oldValue2, newValue2, path, depth);
    }
    recur(oldValue, newValue, "", 0);
}

});

parcelRegister("jW8UK", function(module, exports) {
$parcel$export(module.exports, "createCache", () => $1adca3fff5470b2f$export$cf6fa0bbcc94b912);
function $1adca3fff5470b2f$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}

});

parcelRegister("hkiLZ", function(module, exports) {
$parcel$export(module.exports, "PreloadableJSResource", () => $f5d73453d5cf3720$export$4fe5fba5bb1d3c09);

var $cJCHi = parcelRequire("cJCHi");
function $f5d73453d5cf3720$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $cJCHi.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}

});
parcelRegister("cJCHi", function(module, exports) {
$parcel$export(module.exports, "JSResource", () => $d9c908d54479f6d1$export$148e45a6d4b4d65);

var $6GCis = parcelRequire("6GCis");

var $9z2RL = parcelRequire("9z2RL");

var $6g7fo = parcelRequire("6g7fo");
function $d9c908d54479f6d1$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $9z2RL.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $9z2RL.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $6GCis.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $9z2RL.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $6g7fo.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}

});
parcelRegister("6GCis", function(module, exports) {
$parcel$export(module.exports, "generateId", () => $5d21f68f52101bfc$export$567fc7097e064344);
let $5d21f68f52101bfc$var$id = 100000;
function $5d21f68f52101bfc$export$567fc7097e064344() {
    $5d21f68f52101bfc$var$id += 1;
    return $5d21f68f52101bfc$var$id.toString();
}

});

parcelRegister("9z2RL", function(module, exports) {
$parcel$export(module.exports, "eventEmitter", () => $92b3cf3107cf144c$export$10dc3edfc20c8ff);
function $92b3cf3107cf144c$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $92b3cf3107cf144c$export$10dc3edfc20c8ff = $92b3cf3107cf144c$var$createEventEmitter();

});

parcelRegister("6g7fo", function(module, exports) {
$parcel$export(module.exports, "isJSModuleWithDefaultExport", () => $ba7b8db49f174854$export$3b514faac3ba993c);
function $ba7b8db49f174854$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}

});



parcelRegister("fDVI0", function(module, exports) {
$parcel$export(module.exports, "JiraWorkspaceAri", () => $b637434be567646e$export$d4d0794234e3fd53);

var $kPkwB = parcelRequire("kPkwB");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira/workspace/manifest.ts
var $b637434be567646e$var$jiraWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $kPkwB.JiraWorkspaceAriResourceOwner),
    resourceType: (0, $kPkwB.JiraWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/jira/workspace/index.ts
var $b637434be567646e$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $b637434be567646e$var$jiraWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $b637434be567646e$var$jiraWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $b637434be567646e$var$jiraWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $b637434be567646e$var$jiraWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $b637434be567646e$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $b637434be567646e$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
};

});
parcelRegister("kPkwB", function(module, exports) {
$parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", () => $f2987de15eb3e45b$export$e52ccdf6abac8896);
$parcel$export(module.exports, "JiraWorkspaceAriResourceType", () => $f2987de15eb3e45b$export$669cd5f7b3746bb);
// src/jira/workspace/types.ts
var $f2987de15eb3e45b$export$e52ccdf6abac8896 = "jira", $f2987de15eb3e45b$export$669cd5f7b3746bb = "workspace";

});


parcelRegister("9xzYB", function(module, exports) {
$parcel$export(module.exports, "PlatformSiteAri", () => $6f231a4a908e6376$export$62388e9e87e2e1c9);

var $4MB1Q = parcelRequire("4MB1Q");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/platform/site/manifest.ts
var $6f231a4a908e6376$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $4MB1Q.PlatformSiteAriResourceOwner),
    resourceType: (0, $4MB1Q.PlatformSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $6f231a4a908e6376$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6f231a4a908e6376$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $6f231a4a908e6376$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $6f231a4a908e6376$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $6f231a4a908e6376$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $6f231a4a908e6376$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $6f231a4a908e6376$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};

});
parcelRegister("4MB1Q", function(module, exports) {
$parcel$export(module.exports, "PlatformSiteAriResourceOwner", () => $37b85e3bdfd4acde$export$2866935ccba4694c);
$parcel$export(module.exports, "PlatformSiteAriResourceType", () => $37b85e3bdfd4acde$export$c9ae8b227ea4b550);
// src/platform/site/types.ts
var $37b85e3bdfd4acde$export$2866935ccba4694c = "platform", $37b85e3bdfd4acde$export$c9ae8b227ea4b550 = "site";

});


parcelRegister("1hxzM", function(module, exports) {
$parcel$export(module.exports, "buildNavigationAriForMenuData", () => $bc4259a2d8e51361$export$edcad403b9bac010);
$parcel$export(module.exports, "buildNavigationAriForSidebarData", () => $bc4259a2d8e51361$export$370c1cceae722446);

var $18sMq = parcelRequire("18sMq");
const $bc4259a2d8e51361$var$MENU_DATA_KEY = 'nav-plat-l1-menu-data';
const $bc4259a2d8e51361$var$SIDE_BAR_DATA_KEY = 'nav-plat-sidebar-data';
function $bc4259a2d8e51361$export$edcad403b9bac010(params) {
    return $bc4259a2d8e51361$var$buildNavigationAri({
        ...params,
        settingId: $bc4259a2d8e51361$var$MENU_DATA_KEY
    });
}
function $bc4259a2d8e51361$export$370c1cceae722446(params) {
    return $bc4259a2d8e51361$var$buildNavigationAri({
        ...params,
        settingId: $bc4259a2d8e51361$var$SIDE_BAR_DATA_KEY
    });
}
function $bc4259a2d8e51361$var$buildNavigationAri(params) {
    return $bc4259a2d8e51361$var$homeOverride((0, $18sMq.NavigationSettingAri).create($bc4259a2d8e51361$var$adjustParams(params)).toString());
}
// For the time being (Sept 2025), Home will be the only townsquare app that stores network settings.
// The other apps (Goals, Teams &Projects) are in the process of being individually commissioned
// (meaning they will have their own siteId and/or activationId). In the meantime, they will NOT
// be using the settings service, so we don't need an override for them.
function $bc4259a2d8e51361$var$adjustParams(params) {
    if (params.firstPartyApp === 'home') return {
        ...params,
        settingId: `${params.settingId}-${params.firstPartyApp}`
    };
    return params;
}
function $bc4259a2d8e51361$var$homeOverride(ari) {
    return ari.replace('/home/', '/townsquare/');
}

});
parcelRegister("18sMq", function(module, exports) {
$parcel$export(module.exports, "NavigationSettingAri", () => $0d3cdcf002f2ac49$export$d9494d14fa8a72a2);

var $4A5BC = parcelRequire("4A5BC");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/navigation/setting/manifest.ts
var $0d3cdcf002f2ac49$var$navigationSettingAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $4A5BC.NavigationSettingAriResourceOwner),
    resourceType: (0, $4A5BC.NavigationSettingAriResourceType),
    resourceIdSlug: "{firstPartyApp}/{siteId}/{activationId}/{settingId}",
    resourceIdSegmentFormats: {
        firstPartyApp: /[a-z0-9-]{1,100}/,
        siteId: /[a-zA-Z0-9_\-.]{1,255}/,
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        settingId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/navigation/setting/index.ts
var $0d3cdcf002f2ac49$export$d9494d14fa8a72a2 = class _NavigationSettingAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._firstPartyApp = opts.resourceIdSegmentValues.firstPartyApp, this._siteId = opts.resourceIdSegmentValues.siteId, this._activationId = opts.resourceIdSegmentValues.activationId, this._settingId = opts.resourceIdSegmentValues.settingId;
    }
    get firstPartyApp() {
        return this._firstPartyApp;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get settingId() {
        return this._settingId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $0d3cdcf002f2ac49$var$navigationSettingAriStaticOpts.qualifier,
            platformQualifier: $0d3cdcf002f2ac49$var$navigationSettingAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $0d3cdcf002f2ac49$var$navigationSettingAriStaticOpts.resourceOwner,
            resourceType: $0d3cdcf002f2ac49$var$navigationSettingAriStaticOpts.resourceType,
            resourceId: `${opts.firstPartyApp}/${opts.siteId}/${opts.activationId}/${opts.settingId}`,
            resourceIdSegmentValues: {
                firstPartyApp: opts.firstPartyApp,
                siteId: opts.siteId,
                activationId: opts.activationId,
                settingId: opts.settingId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $0d3cdcf002f2ac49$var$navigationSettingAriStaticOpts);
        return new _NavigationSettingAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $0d3cdcf002f2ac49$var$navigationSettingAriStaticOpts);
        return new _NavigationSettingAri(opts);
    }
    getVariables() {
        return {
            firstPartyApp: this.firstPartyApp,
            siteId: this.siteId,
            activationId: this.activationId,
            settingId: this.settingId
        };
    }
};

});
parcelRegister("4A5BC", function(module, exports) {
$parcel$export(module.exports, "NavigationSettingAriResourceOwner", () => $355edf696d90f38f$export$efad67ea8db3f12e);
$parcel$export(module.exports, "NavigationSettingAriResourceType", () => $355edf696d90f38f$export$fd28c74ac3f5b728);
// src/navigation/setting/types.ts
var $355edf696d90f38f$export$efad67ea8db3f12e = "navigation", $355edf696d90f38f$export$fd28c74ac3f5b728 = "setting";

});



parcelRegister("7NTte", function(module, exports) {
$parcel$export(module.exports, "JSResourceForInteraction", () => $7a955540d214c633$export$e83743682263315a);

var $jW8UK = parcelRequire("jW8UK");

var $hkiLZ = parcelRequire("hkiLZ");

var $bCiN9 = parcelRequire("bCiN9");
const $7a955540d214c633$var$cache = (0, $jW8UK.createCache)(new Map());
/** Message when a string path reaches runtime (expected: build rewrites it to a loader). */ const $7a955540d214c633$var$RUNTIME_STRING_ERROR = "JSResourceForInteraction was called with a string path at runtime. Ensure @atlassian/react-async-transformer is applied to transform this to a dynamic import.";
function $7a955540d214c633$export$e83743682263315a(loaderOrPath, opts) {
    if (typeof loaderOrPath === 'string') throw new Error(`${$7a955540d214c633$var$RUNTIME_STRING_ERROR} String path: ${JSON.stringify(loaderOrPath)}`);
    return $7a955540d214c633$var$cache.get(opts.moduleId, ()=>(0, $hkiLZ.PreloadableJSResource)(()=>(0, $bCiN9.postTask)(loaderOrPath, {
                priority: 'user-visible'
            }), opts));
}

});

parcelRegister("fiVog", function(module, exports) {
$parcel$export(module.exports, "createEntryPoint", () => $3adf08aec3bc65d1$export$fa00dd5c1a75592f);
/* eslint-disable @typescript-eslint/ban-types */ function $3adf08aec3bc65d1$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}

});

parcelRegister("50OIz", function(module, exports) {
$parcel$export(module.exports, "mergeRefs", () => $3a644b5a6eec0fd8$export$c9058316764c140e);

var $jbpxB = parcelRequire("jbpxB");

var $52CPJ = parcelRequire("52CPJ");
function $3a644b5a6eec0fd8$export$c9058316764c140e(refs) {
    return (0, $52CPJ.createCallbackRef)(function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $jbpxB.assignRef)(ref, newValue);
        });
    });
}

});
parcelRegister("52CPJ", function(module, exports) {
$parcel$export(module.exports, "createCallbackRef", () => $3abb4322bb6559d6$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $3abb4322bb6559d6$export$35a19128eb4acba4(callback) {
    var current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            var last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});


parcelRegister("8EpkY", function(module, exports) {
$parcel$export(module.exports, "usePressablePreloadRef", () => $0efb87c0d4fc3d5f$export$1ff47f24e06a5d2d);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $dHa0b = parcelRequire("dHa0b");
function $0efb87c0d4fc3d5f$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad, loadOnFocus: loadOnFocus = false, preloadOnFocus: preloadOnFocus = false }) {
    const nodeRef = (0, $euxye.useRef)(null);
    const eventListeners = (0, $euxye.useRef)([]);
    const { preloadReference: preloadReference, cancelPreload: cancelPreload, eagerLoad: eagerLoad } = (0, $dHa0b.useEntryPointPreload)(load);
    const clickListener = (0, $euxye.useMemo)(()=>{
        return ()=>{
            if (onBeforeLoad) onBeforeLoad();
            onLoad(eagerLoad());
        };
    }, [
        onBeforeLoad,
        onLoad,
        eagerLoad
    ]);
    const mouseDownListener = (0, $euxye.useMemo)(()=>{
        return ()=>{
            eagerLoad();
        };
    }, [
        eagerLoad
    ]);
    const cleanUpEventListeners = (0, $euxye.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $euxye.useCallback)((element, type, callback)=>{
        const unbind = (0, $glbdM.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $euxye.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'click', clickListener);
                addEventListener(element, 'mousedown', mouseDownListener);
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
                if (loadOnFocus) addEventListener(element, 'focusin', clickListener);
                else if (preloadOnFocus) {
                    addEventListener(element, 'focusin', preloadReference);
                    addEventListener(element, 'focusout', cancelPreload);
                }
            }
            // Update the ref with the new element
            nodeRef.current = element;
        }
    }, [
        clickListener,
        mouseDownListener,
        preloadReference,
        cancelPreload,
        loadOnFocus,
        addEventListener,
        cleanUpEventListeners,
        preloadOnFocus
    ]);
    (0, $euxye.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}

});
parcelRegister("dHa0b", function(module, exports) {
$parcel$export(module.exports, "useEntryPointPreload", () => $424da9967ccf44e1$export$57effc2a5e3611f);

var $euxye = parcelRequire("euxye");

var $egspI = parcelRequire("egspI");
const $424da9967ccf44e1$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $424da9967ccf44e1$var$TIME_TO_INTENT = 200;
function $424da9967ccf44e1$export$57effc2a5e3611f(load) {
    const actions = (0, $euxye.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $egspI.fg)('platform_relay_preload_ensure_max_age_disposal') === false) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            if ((0, $egspI.fg)('platform_relay_persist_entrypoint_preloaded_data') === false) request.preload?.dispose();
        };
        const cleanupPreload = ()=>{
            request.preload?.dispose();
            // Only remove the max age timeout when the component is cleaned up.
            if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $egspI.fg)('platform_relay_preload_ensure_max_age_disposal')) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const eagerLoad = ()=>{
            clearPreloadTimeouts();
            return loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $424da9967ccf44e1$var$PRELOAD_MAX_AGE);
            }, $424da9967ccf44e1$var$TIME_TO_INTENT);
        };
        return {
            preloadReference: preloadReference,
            cancelPreload: cancelPreload,
            cleanupPreload: cleanupPreload,
            eagerLoad: eagerLoad
        };
    }, [
        load
    ]);
    // Dispose preload and clear timeouts when component unmounts
    // or when `load` identity changes (new actions object created).
    (0, $euxye.useEffect)(()=>{
        return ()=>{
            if ((0, $egspI.fg)('platform_relay_persist_entrypoint_preloaded_data')) actions.cleanupPreload();
        };
    }, [
        actions
    ]);
    return actions;
}

});


parcelRegister("gAEFP", function(module, exports) {
$parcel$export(module.exports, "InternalEntryPointContainer", () => $39a1ceabe882d71c$export$5d4dc37edd8a3adb);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2dBla = parcelRequire("2dBla");

var $n67Vb = parcelRequire("n67Vb");

var $203nR = parcelRequire("203nR");

var $bDxkI = parcelRequire("bDxkI");

var $dzfUQ = parcelRequire("dzfUQ");
function $39a1ceabe882d71c$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $dzfUQ.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $203nR.useUFOReportError)();
    const onError = (0, $euxye.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $bDxkI.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: error?.message ?? 'Unknown error',
            errorStack: error?.stack ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $euxye.useCallback)(({ error: error })=>{
        const onClose = runtimeProps?.onClose ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2dBla.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)(PlaceholderComponent, {
            name: placeholderName ?? 'internal-internal-entry-point-container',
            fallback: fallback,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $n67Vb.EntryPointContainer), {
                entryPointReference: entryPointReference,
                props: runtimeProps
            })
        })
    });
}
$39a1ceabe882d71c$var$InternalEntryPointContainerInner.displayName = "InternalEntryPointContainerInner";
function $39a1ceabe882d71c$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $dzfUQ.useEntryPointConfig)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($39a1ceabe882d71c$var$InternalEntryPointContainerInner, {
            ...props
        })
    });
}
$39a1ceabe882d71c$export$5d4dc37edd8a3adb.displayName = "InternalEntryPointContainer";

});
parcelRegister("2dBla", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("euxye")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("203nR", function(module, exports) {
$parcel$export(module.exports, "useUFOReportError", () => $318604e0c8e559cd$export$75d40f522062f923);

var $4FR7Y = parcelRequire("4FR7Y");

var $siTdT = parcelRequire("siTdT");
function $318604e0c8e559cd$export$75d40f522062f923() {
    const ufoContext = (0, $4FR7Y.useInteractionContext)();
    const reportError = (error)=>{
        const interaction = (0, $siTdT.getActiveInteraction)();
        if (interaction?.id) (0, $siTdT.addError)(interaction.id, error.name, ufoContext?.labelStack || null, error.name, error.errorMessage, error.errorStack, error.forcedError);
        else (0, $siTdT.addErrorToAll)(error.name, ufoContext?.labelStack || null, error.name, error.errorMessage, error.errorStack);
    };
    return reportError;
}

});

parcelRegister("dzfUQ", function(module, exports) {
$parcel$export(module.exports, "initEntryPointConfig", () => $4bc7c67597d9875a$export$93a6801f9db838c4);
$parcel$export(module.exports, "useEntryPointConfig", () => $4bc7c67597d9875a$export$dfa96f26176fa91f);

var $2yEb9 = parcelRequire("2yEb9");

var $3BBB7 = parcelRequire("3BBB7");
const $4bc7c67597d9875a$var$DefaultUFOSegmentComponent = (0, $3BBB7.default);
const $4bc7c67597d9875a$var$entryPointConfig = {
    PlaceholderComponent: (0, $2yEb9.default),
    UFOSegmentComponent: $4bc7c67597d9875a$var$DefaultUFOSegmentComponent,
    ModalOnError: ()=>null
};
function $4bc7c67597d9875a$export$93a6801f9db838c4(overrides) {
    Object.assign($4bc7c67597d9875a$var$entryPointConfig, overrides);
    return $4bc7c67597d9875a$var$entryPointConfig;
}
function $4bc7c67597d9875a$export$dfa96f26176fa91f() {
    return $4bc7c67597d9875a$var$entryPointConfig;
}

});
parcelRegister("2yEb9", function(module, exports) {
$parcel$export(module.exports, "default", () => $71f09279bae8e3fc$export$2e2bcd8739ae039);

var $kgb2x = parcelRequire("kgb2x");
var $71f09279bae8e3fc$export$2e2bcd8739ae039 = (0, $kgb2x.default);

});
parcelRegister("kgb2x", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f0b1d3b53706868$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2D2gW = parcelRequire("2D2gW");

var $9gzip = parcelRequire("9gzip");
var $3lCnx = parcelRequire("3lCnx");
function $9f0b1d3b53706868$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback = null }) {
    const waitContext = (0, $euxye.useContext)((0, $3lCnx.WaitContext));
    const shouldHold = !waitContext || !!waitContext.currentValue();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9gzip.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
            children: [
                fallback,
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2D2gW.default), {
                    name: name,
                    hold: shouldHold
                })
            ]
        }),
        name: name,
        children: children
    });
}
$9f0b1d3b53706868$export$2e2bcd8739ae039.displayName = "Placeholder";

});
parcelRegister("9gzip", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $3189fe0d13d0ee5f$export$256c542058532d6f);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $3189fe0d13d0ee5f$var$isNodeEnvironment = ()=>{
    return typeof window === 'undefined' || window.name === 'nodejs';
};
const $3189fe0d13d0ee5f$var$LazySuspenseContext = /*#__PURE__*/ (0, $euxye.createContext)({
    fallback: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {}),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    },
    name: ''
});
const $3189fe0d13d0ee5f$var$DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useContext($3189fe0d13d0ee5f$var$LazySuspenseContext);
    (0, $euxye.useLayoutEffect)(()=>{
        return ()=>{
            if (!outsideSuspense) setFallback(null);
        };
    }, [
        outsideSuspense,
        setFallback
    ]);
    return children(outsideSuspense ? null : fallback);
};
$3189fe0d13d0ee5f$var$DynamicFallback.displayName = "DynamicFallback";
$3189fe0d13d0ee5f$var$DynamicFallback.displayName = 'DynamicFallback';
const $3189fe0d13d0ee5f$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
    const [hydrationFallback, setHydrationFallback] = (0, $euxye.useState)(null);
    const mountedRef = (0, $euxye.useRef)(false);
    (0, $euxye.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const contextValue = (0, $euxye.useMemo)(()=>({
            fallback: fallback,
            setFallback: (newFallback)=>{
                if (hydrationFallback === newFallback) return;
                setHydrationFallback(newFallback);
            },
            name: name
        }), [
        fallback,
        hydrationFallback,
        name
    ]);
    const renderFallback = (outsideSuspense)=>/*#__PURE__*/ (0, $e79Pd.jsx)($3189fe0d13d0ee5f$var$DynamicFallback, {
            outsideSuspense: outsideSuspense,
            children: (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback
        });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($3189fe0d13d0ee5f$var$LazySuspenseContext.Provider, {
        value: contextValue,
        children: $3189fe0d13d0ee5f$var$isNodeEnvironment() ? children : /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
                    fallback: renderFallback(false),
                    children: children
                }),
                (!mountedRef.current || hydrationFallback) && renderFallback(true)
            ]
        })
    });
};
$3189fe0d13d0ee5f$export$256c542058532d6f.displayName = "LazySuspense";
$3189fe0d13d0ee5f$export$256c542058532d6f.displayName = 'LazySuspense';

});

parcelRegister("3lCnx", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $da4859ea6fd58c69$export$9ba3fe09d15de47b);

var $euxye = parcelRequire("euxye");
const $da4859ea6fd58c69$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $euxye.createContext)({
    subscribe: ()=>()=>{},
    currentValue: ()=>1
});

});





parcelRegister("63qMo", function(module, exports) {
$parcel$export(module.exports, "blockDraggingToIFrames", () => (parcelRequire("daypx")).blockDraggingToIFrames);

var $daypx = parcelRequire("daypx");

});
parcelRegister("daypx", function(module, exports) {
$parcel$export(module.exports, "blockDraggingToIFrames", () => $7539f6364ef5c671$export$6ae1d8fab001518c);

var $gOKKd = parcelRequire("gOKKd");

var $7aH0o = parcelRequire("7aH0o");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $7539f6364ef5c671$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $7539f6364ef5c671$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $7539f6364ef5c671$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($7539f6364ef5c671$var$isActive) return;
    $7539f6364ef5c671$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$7539f6364ef5c671$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $7aH0o.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $gOKKd.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $7539f6364ef5c671$var$isActive = false;
    });
}
function $7539f6364ef5c671$export$6ae1d8fab001518c({ element: element }) {
    return (0, $gOKKd.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $7539f6364ef5c671$var$tryStart();
        }
    });
}

});


parcelRegister("j1TMp", function(module, exports) {
$parcel$export(module.exports, "EditionAwareness", () => $5dfeb0a2ee0f0ea5$export$a55b02efe3d62583);

var $e79Pd = parcelRequire("e79Pd");

var $3VFSE = parcelRequire("3VFSE");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $2D2gW = parcelRequire("2D2gW");

var $3BBB7 = parcelRequire("3BBB7");

var $54zD2 = parcelRequire("54zD2");

var $1W10O = parcelRequire("1W10O");

var $kXxEy = parcelRequire("kXxEy");

var $cLUxG = parcelRequire("cLUxG");

var $72laA = parcelRequire("72laA");

var $i6bLD = parcelRequire("i6bLD");

var $0MN7v = parcelRequire("0MN7v");

var $7YAYH = parcelRequire("7YAYH");

var $frC7k = parcelRequire("frC7k");

var $8c1CF = parcelRequire("8c1CF");

var $fl5mA = parcelRequire("fl5mA");
const $5dfeb0a2ee0f0ea5$var$PREDUNNING_LENGTH = 14;
const $5dfeb0a2ee0f0ea5$var$MILLISECONDS_PER_DAY = 86400000;
/**
 * Edition awareness is used to communicate to customers about the current edition they have and if they should
 * - Add payment details
 * - Upgrade their edition
 *
 * This component deals with creating the context which is then used throughout the package to:
 * - Track analytics
 * - Know which product/edition/cloud id is being used
 * - Know when to show/hide the button
 */ function $5dfeb0a2ee0f0ea5$var$EditionAwarenessImpl(props) {
    const { cloudId: cloudId, product: product, edition: edition, orgId: orgId, userDisplayName: userDisplayName, userEmail: userEmail, userRoles: userRolesFromProduct, environment: environment, siteTraits: siteTraits = [], canRender: canRender, currentRoute: currentRoute, premiumFeatureHighlightToggle: premiumFeatureHighlightToggle, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen, PremiumWrapper: PremiumWrapper, getAction: getAction, showFlag: showFlag, hideFlag: hideFlag, originalProjectTypeWasCore: originalProjectTypeWasCore } = props;
    const queryConfig = (0, $0MN7v.getQueryConfig)(product, edition, cloudId, userRolesFromProduct);
    const data = (0, $n67Vb.useLazyLoadQuery)((0, $3VFSE.default), queryConfig);
    const entitlementInfo = data?.tenantContexts?.[0]?.entitlementInfo;
    const entitlement = entitlementInfo?.entitlement;
    const entitlementId = entitlementInfo?.entitlementId;
    const invoiceableStatus = typeof entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable === 'boolean' ? entitlement.subscription.accountDetails.invoiceGroup.invoiceable ? 'INVOICEABLE' : 'NOT_INVOICEABLE' : 'UNKNOWN';
    const invoiceGroupPaymentConfig = entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities?.configurePaymentV2;
    const canAddInvoiceGroupPayment = invoiceGroupPaymentConfig ? Boolean(invoiceGroupPaymentConfig.isAvailableToUser && invoiceGroupPaymentConfig.experienceUrl) : null;
    const transactionAccountPaymentConfig = entitlement?.transactionAccount?.experienceCapabilities?.addPaymentMethodV2;
    const canAddTxaPayment = transactionAccountPaymentConfig ? Boolean(transactionAccountPaymentConfig.isAvailableToUser && transactionAccountPaymentConfig.experienceUrl) : null;
    // Use invoice group configurePaymentV2 to determine can add payment and experience url by default
    // If invoice group does not exist (for example free edition skip trial scenario), fall back to txa addPaymentMethodV2 if possible
    const canAddPaymentDetails = canAddInvoiceGroupPayment ?? canAddTxaPayment;
    const addPaymentDetailsExperienceUrl = invoiceGroupPaymentConfig ? invoiceGroupPaymentConfig.experienceUrl : edition === 'free' ? transactionAccountPaymentConfig?.experienceUrl : null;
    const hasPaymentDetailsEntered = Boolean(entitlement?.transactionAccount?.isBillToPresent);
    const trialTimeLeft = entitlement?.subscription?.trial?.timeLeft ?? undefined;
    const trialDaysLeft = (0, $54zD2.getTrialDaysLeft)(trialTimeLeft);
    const trialStartTimestamp = entitlement?.subscription?.trial?.startTimestamp;
    const trialStartDate = (0, $euxye.useMemo)(()=>trialStartTimestamp ? new Date(trialStartTimestamp) : undefined, [
        trialStartTimestamp
    ]);
    const trialEndTimestamp = entitlement?.subscription?.trial?.endTimestamp;
    const trialEndDate = (0, $euxye.useMemo)(()=>trialEndTimestamp ? new Date(trialEndTimestamp) : undefined, [
        trialEndTimestamp
    ]);
    const trialLengthDays = entitlement?.offering?.trial?.lengthDays ?? undefined;
    const isInTrial = Boolean(trialDaysLeft && trialDaysLeft > 0);
    const isEntitlementPredunningStatus = entitlement?.preDunning?.status;
    const isCollectionEntitlementPredunningStatus = entitlement?.relatesFromEntitlementsWithCollectionType?.[0]?.entitlement?.preDunning?.status;
    const isInPredunning = (isEntitlementPredunningStatus === 'IN_PRE_DUNNING' || isCollectionEntitlementPredunningStatus === 'IN_PRE_DUNNING') && invoiceableStatus === 'NOT_INVOICEABLE';
    const { isInCollection: isInCollection, collectionEntitlementId: collectionEntitlementId } = (0, $euxye.useMemo)(()=>{
        const collectionEntitlement = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'COLLECTION');
        return {
            isInCollection: !!collectionEntitlement?.entitlementId,
            collectionEntitlementId: collectionEntitlement?.entitlementId
        };
    }, [
        entitlement?.relatesFromEntitlements
    ]);
    const isChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
    const changeOfferingToStandardExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
    const isDirectBuyChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2WithSkipTrial?.isAvailableToUser;
    const directBuyChangeOfferingToStandardExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2WithSkipTrial?.experienceUrl;
    const canUpgrade = Boolean(isChangeOfferingAvailable && changeOfferingToStandardExperienceUrl);
    const canDirectBuyUpgrade = Boolean(isDirectBuyChangeOfferingAvailable && directBuyChangeOfferingToStandardExperienceUrl);
    const transactionAccountId = entitlement?.transactionAccount?.key;
    const isEnterpriseCustomer = (0, $euxye.useMemo)(()=>{
        const enterpriseEntitlement = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'ENTERPRISE');
        return !!enterpriseEntitlement?.entitlementId;
    }, [
        entitlement?.relatesFromEntitlements
    ]);
    const productCollection = (0, $i6bLD.getProductCollection)(product);
    const collectionType = isInCollection && productCollection?.isEnabled && productCollection?.collectionType || null;
    const userRoles = (0, $euxye.useMemo)(()=>{
        const roles = [
            ...userRolesFromProduct || []
        ];
        if (data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.transactionAccount?.isCurrentUserBillingAdmin) roles.push('BILLING_ADMIN');
        return roles;
    }, [
        data?.tenantContexts,
        userRolesFromProduct
    ]);
    // We need to use the `latestUsageForChargeElement` to get the licensed user count for both free and trialing customers
    const licensedUsersRaw = entitlement?.latestUsageForChargeElement;
    // Assumes that there are always at least one assigned user to cover scenarios
    const licensedUsers = Math.max(licensedUsersRaw || 0, 1);
    const storageUsageInGB = (0, $euxye.useMemo)(()=>{
        if (data.jira?.attachmentStorageUsed && (0, $frC7k.isProductOneOf)(product, [
            'jira',
            'jira-service-management',
            'jira-product-discovery'
        ])) return (0, $1W10O.bytesToGigabytes)(data.jira.attachmentStorageUsed);
        return undefined;
    }, [
        data.jira?.attachmentStorageUsed,
        product
    ]);
    const storageLimitInGB = (0, $euxye.useMemo)(()=>{
        if (data.jira?.attachmentStorageAllowed) return (0, $1W10O.bytesToGigabytes)(data.jira.attachmentStorageAllowed);
        return undefined;
    }, [
        data.jira?.attachmentStorageAllowed
    ]);
    const storageIsUnlimited = (0, $euxye.useMemo)(()=>{
        if (data.jira?.attachmentStorageIsUnlimited) return data.jira.attachmentStorageIsUnlimited;
        return undefined;
    }, [
        data.jira?.attachmentStorageIsUnlimited
    ]);
    const siteTraitsForContext = (0, $euxye.useMemo)(()=>(0, $7YAYH.getSiteTraitValues)(siteTraits), [
        siteTraits
    ]);
    const offeringKey = entitlement?.offering?.key;
    const automationFreeLimitStatus = (0, $euxye.useMemo)(()=>(0, $72laA.getAutomationFreeLimitStatus)({
            product: product,
            edition: edition,
            ...siteTraitsForContext
        }), [
        product,
        edition,
        siteTraitsForContext
    ]);
    const lastKnownTrial = (0, $euxye.useMemo)(()=>{
        // We purposely don't discard the results of the trial if the customer is not on a trial, the reason for this
        // is to enable experiences where the customer has just started a trial, but that change is not yet reflected
        // on the page that has loaded for them.
        const trialEndTimeStamp = entitlement?.entitlementProfile?.lastKnownTrial?.trialEndTimeStamp;
        if (!trialEndTimeStamp) return undefined;
        if (isInTrial && trialEndTimeStamp <= Date.now() || isInPredunning && trialEndTimeStamp + $5dfeb0a2ee0f0ea5$var$PREDUNNING_LENGTH * $5dfeb0a2ee0f0ea5$var$MILLISECONDS_PER_DAY <= Date.now()) return undefined;
        return {
            trialEndTimeStamp: entitlement?.entitlementProfile?.lastKnownTrial?.trialEndTimeStamp,
            trialType: entitlement?.entitlementProfile?.lastKnownTrial?.trialType,
            trialTrigger: entitlement?.entitlementProfile?.lastKnownTrial?.trialTrigger,
            createdAt: entitlement?.entitlementProfile?.lastKnownTrial?.createdAt,
            offeringId: entitlement?.entitlementProfile?.lastKnownTrial?.offeringId
        };
    }, [
        entitlement?.entitlementProfile?.lastKnownTrial,
        isInPredunning,
        isInTrial
    ]);
    const isInReverseTrial = (isInTrial || isInPredunning) && lastKnownTrial?.trialType === 'REVERSE_TRIAL';
    const context = (0, $euxye.useMemo)(()=>{
        return {
            cloudId: cloudId,
            orgId: orgId,
            product: product,
            edition: edition,
            entitlementId: entitlementId,
            invoiceableStatus: invoiceableStatus,
            canAddPaymentDetails: canAddPaymentDetails,
            hasPaymentDetailsEntered: hasPaymentDetailsEntered,
            addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl,
            offeringKey: offeringKey,
            trialDaysLeft: trialDaysLeft,
            trialLengthDays: trialLengthDays,
            trialStartDate: trialStartDate,
            trialEndDate: trialEndDate,
            isInTrial: isInTrial,
            isInPredunning: isInPredunning,
            isInReverseTrial: isInReverseTrial,
            canUpgrade: canUpgrade,
            canDirectBuyUpgrade: canDirectBuyUpgrade,
            changeOfferingToStandardExperienceUrl: changeOfferingToStandardExperienceUrl,
            directBuyChangeOfferingToStandardExperienceUrl: directBuyChangeOfferingToStandardExperienceUrl,
            transactionAccountId: transactionAccountId,
            isInCollection: isInCollection,
            isEnterpriseCustomer: isEnterpriseCustomer,
            collectionEntitlementId: collectionEntitlementId,
            collectionType: collectionType,
            userDisplayName: userDisplayName,
            userEmail: userEmail,
            userRoles: userRoles,
            environment: environment,
            licensedUsers: licensedUsers,
            storageUsageInGB: storageUsageInGB,
            storageLimitInGB: storageLimitInGB,
            storageIsUnlimited: storageIsUnlimited,
            ...siteTraitsForContext,
            automationFreeLimitStatus: automationFreeLimitStatus,
            premiumFeatureHighlightToggle: premiumFeatureHighlightToggle,
            shouldAutoOpen: shouldAutoOpen,
            onAutoOpen: onAutoOpen,
            PremiumWrapper: PremiumWrapper,
            lastKnownTrial: lastKnownTrial,
            getAction: getAction,
            showFlag: showFlag,
            hideFlag: hideFlag,
            currentRoute: currentRoute,
            originalProjectTypeWasCore: originalProjectTypeWasCore
        };
    }, [
        cloudId,
        orgId,
        product,
        edition,
        entitlementId,
        invoiceableStatus,
        canAddPaymentDetails,
        hasPaymentDetailsEntered,
        addPaymentDetailsExperienceUrl,
        offeringKey,
        trialDaysLeft,
        trialLengthDays,
        trialStartDate,
        trialEndDate,
        isInTrial,
        isInPredunning,
        isInReverseTrial,
        canUpgrade,
        canDirectBuyUpgrade,
        changeOfferingToStandardExperienceUrl,
        directBuyChangeOfferingToStandardExperienceUrl,
        transactionAccountId,
        isInCollection,
        isEnterpriseCustomer,
        collectionEntitlementId,
        collectionType,
        userDisplayName,
        userEmail,
        userRoles,
        environment,
        licensedUsers,
        storageUsageInGB,
        storageLimitInGB,
        storageIsUnlimited,
        siteTraitsForContext,
        automationFreeLimitStatus,
        premiumFeatureHighlightToggle,
        shouldAutoOpen,
        onAutoOpen,
        PremiumWrapper,
        lastKnownTrial,
        getAction,
        showFlag,
        hideFlag,
        currentRoute,
        originalProjectTypeWasCore
    ]);
    const experimentContextValue = (0, $euxye.useMemo)(()=>new (0, $cLUxG.ExperimentContextClass)(), []);
    if (!canRender) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2D2gW.default), {
        name: "edition-awareness-waiting-on-product"
    });
    if (isEnterpriseCustomer) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cLUxG.ExperimentContext).Provider, {
        value: experimentContextValue,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kXxEy.EditionAwarenessContext).Provider, {
            value: context,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fl5mA.ErrorBoundary), {
                product: product,
                edition: edition,
                id: "audience-and-timing",
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8c1CF.ActionsAndContent), {})
            })
        })
    });
}
$5dfeb0a2ee0f0ea5$var$EditionAwarenessImpl.displayName = "EditionAwarenessImpl";
function $5dfeb0a2ee0f0ea5$export$a55b02efe3d62583(props) {
    const { product: product, edition: edition } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3BBB7.default), {
        name: "edition-awareness-platform",
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fl5mA.ErrorBoundary), {
            product: product,
            edition: edition,
            id: "edition-awareness",
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)($5dfeb0a2ee0f0ea5$var$EditionAwarenessImpl, {
                    ...props
                })
            })
        })
    });
}
$5dfeb0a2ee0f0ea5$export$a55b02efe3d62583.displayName = "EditionAwareness";

});
parcelRegister("3VFSE", function(module, exports) {
$parcel$export(module.exports, "default", () => $13a11782555366e6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0ca548cae8602a1b35a680b800d3f55f>>
 * @relayHash abdf888217d0202c9d3723ddcc833c8f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fd9f5ac6d6ac5fbe05b0b7c0b2e44cc3a233f8346f52be0a8958617e7975cff4
const $13a11782555366e6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "applicationKey"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entitlementFilter"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForAddPaymentDetails"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForChargeQuantities"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForDirectBuyChangeOffering"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForPaymentDetails"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForStorageLimit"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForStorageUsageJira"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForTrial"
    }, v12 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "applicationKey"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v13 = {
        "condition": "shouldCheckForStorageUsageJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "shouldCheckForStorageLimit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": v12 /*: any*/ ,
                                "kind": "ScalarField",
                                "name": "attachmentStorageAllowed"
                            },
                            {
                                "args": v12 /*: any*/ ,
                                "kind": "ScalarField",
                                "name": "attachmentStorageIsUnlimited"
                            }
                        ]
                    },
                    {
                        "args": v12 /*: any*/ ,
                        "kind": "ScalarField",
                        "name": "attachmentStorageUsed"
                    }
                ]
            }
        ]
    }, v14 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v15 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v17 = [
        {
            "kind": "Variable",
            "name": "where",
            "variableName": "entitlementFilter"
        }
    ], v18 = {
        "kind": "Literal",
        "name": "offeringName",
        "value": "Standard"
    }, v19 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v20 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v21 = [
        v19 /*: any*/ ,
        v20 /*: any*/ 
    ], v22 = {
        "concreteType": "CcpEntitlementExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "args": [
                    v18 /*: any*/ 
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": v21 /*: any*/ ,
                "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
            },
            {
                "condition": "shouldCheckForDirectBuyChangeOffering",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "changeOfferingV2WithSkipTrial",
                        "args": [
                            v18 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "skipTrial",
                                "value": true
                            }
                        ],
                        "concreteType": "CcpChangeOfferingExperienceCapability",
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": v21 /*: any*/ ,
                        "storageKey": "changeOfferingV2(offeringName:\"Standard\",skipTrial:true)"
                    }
                ]
            }
        ]
    }, v23 = {
        "condition": "shouldCheckForChargeQuantities",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "chargeElement",
                        "variableName": "chargeElement"
                    }
                ],
                "kind": "ScalarField",
                "name": "latestUsageForChargeElement"
            }
        ]
    }, v24 = {
        "concreteType": "CcpEntitlementPreDunning",
        "kind": "LinkedField",
        "name": "preDunning",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    }, v25 = {
        "concreteType": "CcpTrial",
        "kind": "LinkedField",
        "name": "trial",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "timeLeft"
            },
            {
                "kind": "ScalarField",
                "name": "startTimestamp"
            },
            {
                "kind": "ScalarField",
                "name": "endTimestamp"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v27 = {
        "concreteType": "CcpInvoiceGroupExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpConfigurePaymentMethodExperienceCapability",
                "kind": "LinkedField",
                "name": "configurePaymentV2",
                "plural": false,
                "selections": [
                    v20 /*: any*/ ,
                    v19 /*: any*/ 
                ]
            }
        ]
    }, v28 = {
        "concreteType": "CcpOfferingTrial",
        "kind": "LinkedField",
        "name": "trial",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lengthDays"
            }
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "key"
    }, v30 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v31 = {
        "condition": "shouldCheckForPaymentDetails",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "CcpTransactionAccount",
                "kind": "LinkedField",
                "name": "transactionAccount",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isBillToPresent"
                    }
                ]
            }
        ]
    }, v32 = {
        "condition": "shouldCheckForAddPaymentDetails",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "CcpTransactionAccount",
                "kind": "LinkedField",
                "name": "transactionAccount",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "CcpTransactionAccountExperienceCapabilities",
                        "kind": "LinkedField",
                        "name": "experienceCapabilities",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "CcpAddPaymentMethodExperienceCapability",
                                "kind": "LinkedField",
                                "name": "addPaymentMethodV2",
                                "plural": false,
                                "selections": v21 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ]
    }, v33 = {
        "concreteType": "CcpEntitlementRelationship",
        "kind": "LinkedField",
        "name": "relatesFromEntitlements",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "relationshipType"
            },
            v16 /*: any*/ 
        ]
    }, v34 = [
        {
            "kind": "Literal",
            "name": "relationshipTypes",
            "value": "COLLECTION"
        }
    ], v35 = {
        "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
        "kind": "LinkedField",
        "name": "entitlementProfile",
        "plural": false,
        "selections": [
            {
                "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
                "kind": "LinkedField",
                "name": "lastKnownTrial",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "trialType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "trialTrigger"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "trialEndTimeStamp"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "createdAt"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "offeringId"
                    }
                ]
            }
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editionAwarenessQuery",
            "selections": [
                v13 /*: any*/ ,
                {
                    "args": v14 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v15 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForTrial",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        {
                                                            "concreteType": "CcpSubscription",
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CcpAccountDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "accountDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CcpInvoiceGroup",
                                                                            "kind": "LinkedField",
                                                                            "name": "invoiceGroup",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "CcpOffering",
                                                            "kind": "LinkedField",
                                                            "name": "offering",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v29 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "CcpTransactionAccount",
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v29 /*: any*/ ,
                                                        v30 /*: any*/ 
                                                    ]
                                                },
                                                v31 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                {
                                                    "alias": "relatesFromEntitlementsWithCollectionType",
                                                    "args": v34 /*: any*/ ,
                                                    "concreteType": "CcpEntitlementRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CcpEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlement",
                                                            "plural": false,
                                                            "selections": [
                                                                v24 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                                                },
                                                v35 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v11 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v10 /*: any*/ ,
                v0 /*: any*/ ,
                v9 /*: any*/ ,
                v8 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editionAwarenessQuery",
            "selections": [
                {
                    "args": v14 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v15 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v16 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                {
                                                    "concreteType": "CcpTransactionAccount",
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v29 /*: any*/ ,
                                                        v30 /*: any*/ ,
                                                        v36 /*: any*/ 
                                                    ]
                                                },
                                                v33 /*: any*/ ,
                                                {
                                                    "alias": "relatesFromEntitlementsWithCollectionType",
                                                    "args": v34 /*: any*/ ,
                                                    "concreteType": "CcpEntitlementRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CcpEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlement",
                                                            "plural": false,
                                                            "selections": [
                                                                v24 /*: any*/ ,
                                                                v36 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                                                },
                                                v35 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForTrial",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        {
                                                            "concreteType": "CcpSubscription",
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CcpAccountDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "accountDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CcpInvoiceGroup",
                                                                            "kind": "LinkedField",
                                                                            "name": "invoiceGroup",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v36 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "CcpOffering",
                                                            "kind": "LinkedField",
                                                            "name": "offering",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v29 /*: any*/ ,
                                                                v36 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v31 /*: any*/ ,
                                                v32 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                },
                v13 /*: any*/ 
            ]
        },
        "params": {
            "id": "fd9f5ac6d6ac5fbe05b0b7c0b2e44cc3a233f8346f52be0a8958617e7975cff4",
            "metadata": {},
            "name": "editionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$13a11782555366e6$var$node.hash = "43a85dd2716d6af04414b1235b28d104";
var $13a11782555366e6$export$2e2bcd8739ae039 = $13a11782555366e6$var$node;

});

parcelRegister("54zD2", function(module, exports) {
$parcel$export(module.exports, "getTrialDaysLeft", () => $a632a6485ff0f925$export$954628993bf3188e);
$parcel$export(module.exports, "getTrialDaysLeftFromTrialEndTime", () => $a632a6485ff0f925$export$165abb069513be0e);
$parcel$export(module.exports, "useMemoizedTrialDaysLeftFromTrialEndTime", () => $a632a6485ff0f925$export$bc3e0c760835aa1e);

var $euxye = parcelRequire("euxye");

function $a632a6485ff0f925$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $7bbaa8ad37f7eb61$export$98a7370239de6730));
}
function $a632a6485ff0f925$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $a632a6485ff0f925$export$954628993bf3188e(trialEndTime - Date.now());
}
function $a632a6485ff0f925$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $euxye.useMemo)(()=>$a632a6485ff0f925$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $a632a6485ff0f925$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $a632a6485ff0f925$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $a632a6485ff0f925$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $euxye.useMemo)(()=>$a632a6485ff0f925$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}

});
const $7bbaa8ad37f7eb61$export$98a7370239de6730 = 86400000;


parcelRegister("1W10O", function(module, exports) {
$parcel$export(module.exports, "bytesToGigabytes", () => $ce2c5b4373dc32d5$export$6f25243957146989);
/**
 * Most storage measurements are in gigabytes
 */ function $ce2c5b4373dc32d5$export$6f25243957146989(bytes) {
    return bytes / 1000000000;
}

});

parcelRegister("kXxEy", function(module, exports) {
$parcel$export(module.exports, "EditionAwarenessContext", () => $e85785d69d412987$export$ac3ca8c46f19a73f);
$parcel$export(module.exports, "useEditionAwareness", () => $e85785d69d412987$export$5a5baedfe8151ce);

var $euxye = parcelRequire("euxye");
const $e85785d69d412987$export$ac3ca8c46f19a73f = /*#__PURE__*/ (0, $euxye.createContext)(null);
function $e85785d69d412987$export$5a5baedfe8151ce() {
    const context = (0, $euxye.useContext)($e85785d69d412987$export$ac3ca8c46f19a73f);
    if (!context) throw new Error('Missing context, please ensure this is used within EditionAwarenessContext');
    return context;
}

});

parcelRegister("cLUxG", function(module, exports) {
$parcel$export(module.exports, "ExperimentContextClass", () => $bda527b81f217509$export$cab0526cd5428d4e);
$parcel$export(module.exports, "ExperimentContext", () => $bda527b81f217509$export$fcdf652c4fd8e4c7);
$parcel$export(module.exports, "useExperimentContext", () => $bda527b81f217509$export$471c3c65727643de);
$parcel$export(module.exports, "treatmentCohortTransformFn", () => $bda527b81f217509$export$f2497ad79c72045c);
$parcel$export(module.exports, "useGetExperimentValue", () => $bda527b81f217509$export$59dd27b2c85d98d8);

var $euxye = parcelRequire("euxye");

var $4LDqh = parcelRequire("4LDqh");

var $atjjs = parcelRequire("atjjs");
class $bda527b81f217509$export$cab0526cd5428d4e {
    constructor(context){
        this.experimentDictionary = {};
        this.experimentDictionary = context ?? {};
    }
    experimentExposed(experimentName, experimentVariant, extraAttributes) {
        // If the experiment is already in the dictionary (i.e. been exposed before),
        // we don't want to overwrite the timestamp of first exposure.
        if (Object.keys(this.experimentDictionary).includes(experimentName)) return;
        this.experimentDictionary[experimentName] = {
            cohort: experimentVariant,
            timestamp: Date.now(),
            ...extraAttributes
        };
    }
    experiments() {
        return this.experimentDictionary;
    }
}
$bda527b81f217509$export$cab0526cd5428d4e.displayName = "ExperimentContextClass";
const $bda527b81f217509$export$fcdf652c4fd8e4c7 = /*#__PURE__*/ (0, $euxye.createContext)(null);
function $bda527b81f217509$export$471c3c65727643de() {
    const context = (0, $euxye.useContext)($bda527b81f217509$export$fcdf652c4fd8e4c7);
    if (!context) throw new Error('Missing context, please ensure this is used within ExperimentContext');
    return context;
}
const $bda527b81f217509$export$259da07bf82c42c7 = (parameterValue)=>parameterValue ? 'variation' : 'control';
const $bda527b81f217509$export$f2497ad79c72045c = (cohort)=>{
    if (cohort === 'treatment') return 'variation';
    else if (cohort === 'control') return 'control';
    else return 'not-enrolled';
};
const $bda527b81f217509$export$59dd27b2c85d98d8 = ()=>{
    const experimentContext = $bda527b81f217509$export$471c3c65727643de();
    const fireExperimentExposureEvent = (0, $atjjs.useFeatureExposedAnalytics)();
    const getExperimentValue = (0, $euxye.useCallback)(({ statsigParams: { experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options }, trackEventParameters: trackEventParameters, experimentContextAttributes: experimentContextAttributes = {} })=>{
        const cohort = options ? (0, $4LDqh.default).getExperimentValue(experimentName, parameterName, defaultValue, options) : (0, $4LDqh.default).getExperimentValue(experimentName, parameterName, defaultValue);
        // By default, fireExperimentExposure is true but we need to explicitly
        // check for that to ensure we fire our context update correctly.
        if (options?.fireExperimentExposure !== false) {
            experimentContext.experimentExposed(experimentName, cohort, experimentContextAttributes);
            if (trackEventParameters) fireExperimentExposureEvent(experimentName, cohort, trackEventParameters?.trackEventGrowthInitiative, trackEventParameters?.trackEventAttributes);
        }
        return cohort;
    }, [
        experimentContext,
        fireExperimentExposureEvent
    ]);
    /**
	 * @deprecated Use getExperimentValue instead with the correct experiment cohort values.
	 * We are moving towards consistent cohort values of 'control', 'variation' and 'not-enrolled'.
	 */ const getExperimentValueWithTransform = (0, $euxye.useCallback)(({ statsigParams: { experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options }, transformCohortFunc: transformCohortFunc, trackEventParameters: trackEventParameters, experimentContextAttributes: experimentContextAttributes = {} })=>{
        const cohort = options ? (0, $4LDqh.default).getExperimentValue(experimentName, parameterName, defaultValue, options) : (0, $4LDqh.default).getExperimentValue(experimentName, parameterName, defaultValue);
        // By default, fireExperimentExposure is true but we need to explicitly
        // check for that to ensure we fire our context update correctly.
        if (options?.fireExperimentExposure !== false) {
            experimentContext.experimentExposed(experimentName, transformCohortFunc(cohort), experimentContextAttributes);
            if (trackEventParameters && typeof cohort === 'string') fireExperimentExposureEvent(experimentName, cohort, trackEventParameters?.trackEventGrowthInitiative, trackEventParameters?.trackEventAttributes);
        }
        return cohort;
    }, [
        experimentContext,
        fireExperimentExposureEvent
    ]);
    return {
        getExperimentValue: getExperimentValue,
        getExperimentValueWithTransform: getExperimentValueWithTransform
    };
};

});
parcelRegister("atjjs", function(module, exports) {
$parcel$export(module.exports, "FeatureExposedAnalytics", () => $059f4b061e49137a$export$b12ce465f015026c);
$parcel$export(module.exports, "useFeatureExposedAnalytics", () => $059f4b061e49137a$export$5218ddb3d9c658c0);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $lmRlQ = parcelRequire("lmRlQ");
function $059f4b061e49137a$export$b12ce465f015026c({ flagKey: flagKey, cohort: cohort, growthInitiative: growthInitiative, attributes: attributes, children: children }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $lmRlQ.useAnalytics)();
    const hasSent = (0, $euxye.useRef)(false);
    (0, $euxye.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        flagKey,
        cohort,
        growthInitiative,
        attributes
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
}
$059f4b061e49137a$export$b12ce465f015026c.displayName = "FeatureExposedAnalytics";
const $059f4b061e49137a$export$5218ddb3d9c658c0 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $lmRlQ.useAnalytics)();
    const sentFlagKeys = (0, $euxye.useRef)([]);
    const fireExperimentExposureEvent = (0, $euxye.useCallback)((flagKey, cohort, growthInitiative, attributes)=>{
        if (sentFlagKeys.current.includes(flagKey)) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        sentFlagKeys.current.push(flagKey);
    }, [
        sendAnalyticsEvent
    ]);
    return fireExperimentExposureEvent;
};

});
parcelRegister("lmRlQ", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $5071214b12c93e2b$export$85183a312807388d);
$parcel$export(module.exports, "getAttributesFromContexts", () => $5071214b12c93e2b$export$d97c97ed77ff09e8);
$parcel$export(module.exports, "defaultAttributes", () => $5071214b12c93e2b$export$38cd8db2db178f58);
$parcel$export(module.exports, "useAnalytics", () => $5071214b12c93e2b$export$e955abb82869dc84);

var $euxye = parcelRequire("euxye");

var $bHcfq = parcelRequire("bHcfq");

var $9xulT = parcelRequire("9xulT");
var $inMxE = parcelRequire("inMxE");

var $kXxEy = parcelRequire("kXxEy");

var $cLUxG = parcelRequire("cLUxG");
const $5071214b12c93e2b$export$85183a312807388d = (0, $bHcfq.FabricChannel).growth;
const $5071214b12c93e2b$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        if (x.attributes) return {
            ...acc,
            ...x.attributes
        };
        return {
            ...acc,
            ...x ?? {}
        };
    }, {});
};
const $5071214b12c93e2b$export$38cd8db2db178f58 = {
    packageName: '@atlassian/edition-awareness',
    source: 'editionAwareness',
    featureId: 'edition-awareness',
    growthPillar: 'BUY'
};
function $5071214b12c93e2b$export$e955abb82869dc84() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const editionAwarenessContext = (0, $kXxEy.useEditionAwareness)();
    const experimentContext = (0, $cLUxG.useExperimentContext)();
    const sendAnalyticsEvent = (0, $euxye.useCallback)((payload)=>{
        const editionAwarenessContextAttributes = {
            // Required properties
            cloudId: editionAwarenessContext.cloudId,
            product: editionAwarenessContext.product,
            currentProductEdition: editionAwarenessContext.edition,
            // Payment properties
            isInvoiceable: editionAwarenessContext.invoiceableStatus === 'INVOICEABLE' ? true : editionAwarenessContext.invoiceableStatus === 'NOT_INVOICEABLE' ? false : null,
            hasPaymentDetailsEntered: editionAwarenessContext.hasPaymentDetailsEntered,
            canAddPaymentDetails: editionAwarenessContext.canAddPaymentDetails,
            addPaymentDetailsExperienceUrl: editionAwarenessContext.addPaymentDetailsExperienceUrl,
            // Trial properties
            trialDaysLeft: editionAwarenessContext.trialDaysLeft,
            trialLengthDays: editionAwarenessContext.trialLengthDays,
            trialEndDate: editionAwarenessContext.trialEndDate,
            isInTrial: editionAwarenessContext.isInTrial,
            isInPredunning: editionAwarenessContext.isInPredunning,
            isInReverseTrial: editionAwarenessContext.isInReverseTrial,
            trialOfferingName: editionAwarenessContext.trialOfferingName,
            lastKnownTrial: editionAwarenessContext?.lastKnownTrial,
            offeringKey: editionAwarenessContext?.offeringKey,
            // Upgrade properties
            canUpgrade: editionAwarenessContext.canUpgrade,
            canDirectBuyUpgrade: editionAwarenessContext.canDirectBuyUpgrade,
            changeOfferingToStandardExperienceUrl: editionAwarenessContext.changeOfferingToStandardExperienceUrl,
            directBuyChangeOfferingToStandardExperienceUrl: editionAwarenessContext.directBuyChangeOfferingToStandardExperienceUrl,
            // Entitlement properties
            entitlementId: editionAwarenessContext.entitlementId,
            isInCollection: editionAwarenessContext.isInCollection,
            collectionType: editionAwarenessContext.collectionType,
            // User permissions properties
            userRoles: editionAwarenessContext.userRoles,
            // Site properties
            billingSourceSystem: editionAwarenessContext.hasDismissedButton === false ? null : 'CCP',
            licensedUsers: editionAwarenessContext.licensedUsers,
            storageUsageInGB: editionAwarenessContext.storageUsageInGB,
            isEnterpriseCustomer: editionAwarenessContext.isEnterpriseCustomer,
            // Site traits
            automationUsage: editionAwarenessContext.automationUsage,
            lastAutomationFreeLimitBreachDate: editionAwarenessContext.lastAutomationFreeLimitBreachDate,
            automationFreeLimitStatus: editionAwarenessContext.automationFreeLimitStatus,
            // Capabilities
            shouldAutoOpen: editionAwarenessContext.shouldAutoOpen,
            // For twcg-1563 experiment, temporary attribute for the introduction of full JWM support
            originalProjectTypeWasCore: editionAwarenessContext.originalProjectTypeWasCore
        };
        if (payload instanceof (0, $9xulT.default)) {
            const contextAttributes = $5071214b12c93e2b$export$d97c97ed77ff09e8(payload.context);
            payload.update({
                ...payload.payload,
                attributes: {
                    ...contextAttributes,
                    ...$5071214b12c93e2b$export$38cd8db2db178f58,
                    ...payload.payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experiments: experimentContext.experiments()
                }
            }).fire($5071214b12c93e2b$export$85183a312807388d);
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                attributes: {
                    ...$5071214b12c93e2b$export$38cd8db2db178f58,
                    ...payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experiments: experimentContext.experiments()
                }
            });
            const contextAttributes = $5071214b12c93e2b$export$d97c97ed77ff09e8(event.context);
            event.update({
                attributes: {
                    ...contextAttributes,
                    ...event.payload.attributes
                }
            }).fire($5071214b12c93e2b$export$85183a312807388d);
        }
    }, [
        createAnalyticsEvent,
        editionAwarenessContext,
        experimentContext
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent
    };
}
function $5071214b12c93e2b$export$b901544a79a3bbad({ name: name, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = $5071214b12c93e2b$export$e955abb82869dc84();
    const hasSent = (0, $euxye.useRef)(false);
    (0, $euxye.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'screen',
            name: name,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        name,
        attributes
    ]);
    return null;
}
$5071214b12c93e2b$export$b901544a79a3bbad.displayName = "ScreenEvent";

});



parcelRegister("72laA", function(module, exports) {
$parcel$export(module.exports, "AUTOMATION_USAGE_FREE_LIMIT", () => $38c45028c480396b$export$7296becdbc8d7810);
$parcel$export(module.exports, "AUTOMATION_USAGE_STANDARD_LIMIT", () => $38c45028c480396b$export$5a0f9f37fb711f37);
$parcel$export(module.exports, "getAutomationFreeLimitStatus", () => $38c45028c480396b$export$5f347675b43b787f);

var $bqzoU = parcelRequire("bqzoU");

var $lg9Th = parcelRequire("lg9Th");
const $38c45028c480396b$export$7296becdbc8d7810 = 100;
const $38c45028c480396b$export$5a0f9f37fb711f37 = 1700;
const $38c45028c480396b$export$b3d11e30afa46646 = 0.8 * $38c45028c480396b$export$7296becdbc8d7810;
const $38c45028c480396b$export$5f347675b43b787f = ({ edition: edition, product: product, automationUsage: automationUsage, lastAutomationFreeLimitBreachDate: lastAutomationFreeLimitBreachDate = null })=>{
    if (edition === 'free' && product === 'jira') {
        if ($38c45028c480396b$export$5ff23a30e22aeec2(automationUsage, lastAutomationFreeLimitBreachDate)) return 'BREACHED';
        if ($38c45028c480396b$var$isAutomationProjectedToBreach(automationUsage, edition)) return 'PROJECTED_TO_BREACH';
        if ($38c45028c480396b$var$hasBreachedAutomationUsagePreviousMonth(lastAutomationFreeLimitBreachDate)) return 'BREACHED_PREVIOUS_MONTH';
    }
    return null;
};
const $38c45028c480396b$export$5c4f4d557a0ee678 = (automationUsage)=>{
    const today = new Date();
    const dayOfMonth = today.getDate();
    return automationUsage / dayOfMonth * (0, $bqzoU.default)(today);
};
const $38c45028c480396b$var$isAutomationProjectedToBreach = (automationUsage, edition)=>{
    // Already breached the limit, no need to project
    if (automationUsage >= $38c45028c480396b$export$7296becdbc8d7810) return false;
    const projectedUsage = $38c45028c480396b$export$5c4f4d557a0ee678(automationUsage);
    if (edition === 'free') return projectedUsage >= $38c45028c480396b$export$7296becdbc8d7810 && automationUsage >= $38c45028c480396b$export$b3d11e30afa46646;
    return projectedUsage >= $38c45028c480396b$export$7296becdbc8d7810;
};
const $38c45028c480396b$export$5ff23a30e22aeec2 = (automationUsage, lastAutomationFreeLimitBreachDate)=>{
    return lastAutomationFreeLimitBreachDate && automationUsage >= $38c45028c480396b$export$7296becdbc8d7810 && (0, $lg9Th.default)(new Date(), lastAutomationFreeLimitBreachDate);
};
const $38c45028c480396b$var$hasBreachedAutomationUsagePreviousMonth = (lastAutomationFreeLimitBreachDate)=>{
    if (!lastAutomationFreeLimitBreachDate) return false;
    const now = new Date();
    // Date constructor handles overflow on the last month correctly
    const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    return (0, $lg9Th.default)(lastAutomationFreeLimitBreachDate, lastMonth);
};

});

parcelRegister("i6bLD", function(module, exports) {
$parcel$export(module.exports, "getProductCollection", () => $6b53164f0fea0f48$export$6cf5f13af3dcd5bf);
const $6b53164f0fea0f48$export$6cf5f13af3dcd5bf = (product)=>{
    switch(product){
        case 'jira-service-management':
        case 'jira-customer-service':
            return {
                collectionType: 'Service Collection',
                isEnabled: true
            };
        case 'jira':
        case 'confluence':
            return {
                collectionType: 'Teamwork Collection',
                isEnabled: true
            };
        default:
            return undefined;
    }
};

});

parcelRegister("0MN7v", function(module, exports) {
$parcel$export(module.exports, "getQueryConfig", () => $071be9b70bc5481d$export$bac5bb66ae1b635d);

var $36u0q = parcelRequire("36u0q");

var $42S0C = parcelRequire("42S0C");

var $frC7k = parcelRequire("frC7k");

var $6KMGi = parcelRequire("6KMGi");
function $071be9b70bc5481d$export$bac5bb66ae1b635d(product, edition, cloudId, userRolesFromProduct) {
    const isProductJiraFree = product === 'jira' && edition === 'free';
    const shouldCheckForPaymentDetails = edition === 'free' && (0, $frC7k.isProductOneOf)(product, [
        'jira',
        'confluence',
        'jira-product-discovery',
        'jira-service-management'
    ]);
    const isSiteAdmin = userRolesFromProduct?.includes('SITE_ADMIN') ?? false;
    // Entitlement filter controls which entitlements are fetched from the API.
    // The filter is based on the trial end timestamp in TCS - if a customer downgrades to free while
    // on a trial, they still show up when inTrialOrPreDunning is true as the filter assumes they're still on trial.
    //
    //   - Site admin + non-free edition:
    //       Returns entitlements that are (in trial/predunning) OR (in a collection)
    //
    //   - Non-site admin + non-free edition:
    //       Returns entitlements that are (in trial/predunning)
    //
    //   - Free edition (any user):
    //       Returns all entitlements (no filter)
    //
    // GATE OFF (standard behavior):
    //   - Non-free edition: Returns trial/predunning entitlements
    const getEntitlementFilter = ()=>{
        if (isSiteAdmin && edition !== 'free') return {
            OR: [
                {
                    inTrialOrPreDunning: true
                },
                {
                    hasRelationshipFromWithType: 'COLLECTION'
                }
            ]
        };
        else return edition !== 'free' ? {
            inTrialOrPreDunning: true
        } : null;
    };
    const entitlementFilter = getEntitlementFilter();
    return {
        shouldCheckForDirectBuyChangeOffering: isProductJiraFree,
        shouldCheckForTrial: edition === 'premium' || edition === 'standard',
        cloudId: cloudId,
        productKey: (0, $6KMGi.getHamsKey)(product),
        shouldCheckForChargeQuantities: edition === 'free',
        entitlementFilter: entitlementFilter,
        chargeElement: (0, $36u0q.getChargeElementKey)(product),
        shouldCheckForStorageUsageJira: isProductJiraFree,
        applicationKey: (0, $42S0C.getJiraApplicationKey)(product) ?? 'JIRA_SOFTWARE',
        shouldCheckForStorageLimit: isProductJiraFree,
        shouldCheckForPaymentDetails: shouldCheckForPaymentDetails,
        shouldCheckForAddPaymentDetails: edition === 'free'
    };
}

});
parcelRegister("36u0q", function(module, exports) {
$parcel$export(module.exports, "getChargeElementKey", () => $bedad65d096a06bd$export$58e4e89574623b4);
const $bedad65d096a06bd$var$PRODUCT_TO_CHARGE_ELEMENT = {
    ['confluence']: 'user',
    ['jira']: 'user',
    ['jira-product-discovery']: 'user',
    ['jira-service-management']: 'agent',
    ['jira-customer-service']: 'agent'
};
const $bedad65d096a06bd$export$58e4e89574623b4 = (product)=>{
    return $bedad65d096a06bd$var$PRODUCT_TO_CHARGE_ELEMENT[product];
};

});

parcelRegister("42S0C", function(module, exports) {
$parcel$export(module.exports, "getJiraApplicationKey", () => $98fcfdd54e069f92$export$2fd6994252e4887f);
// We're explicitly excluding 'confluence' from this mapping as it's handled separately
const $98fcfdd54e069f92$var$PRODUCT_TO_JIRA_APPLICATION_KEY = {
    ['jira']: 'JIRA_SOFTWARE',
    ['jira-product-discovery']: 'JIRA_PRODUCT_DISCOVERY',
    ['jira-service-management']: 'JIRA_SERVICE_DESK'
};
const $98fcfdd54e069f92$export$2fd6994252e4887f = (product)=>{
    return $98fcfdd54e069f92$var$PRODUCT_TO_JIRA_APPLICATION_KEY[product];
};

});

parcelRegister("frC7k", function(module, exports) {
$parcel$export(module.exports, "isProductOneOf", () => $1bd88b7f8a35fe90$export$fda637a5d76f2dc6);
function $1bd88b7f8a35fe90$export$fda637a5d76f2dc6(product, possibleMatches) {
    return possibleMatches.includes(product);
}

});

parcelRegister("6KMGi", function(module, exports) {
$parcel$export(module.exports, "getHamsKey", () => $16488b95470b7d64$export$291d012eb0744b34);
const $16488b95470b7d64$var$ProductKeyToHAMSMap = {
    ['confluence']: 'confluence',
    ['jira']: 'jira-software',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['jira-service-management']: 'jira-servicedesk',
    ['jira-customer-service']: 'jira-customer-service'
};
const $16488b95470b7d64$export$291d012eb0744b34 = (product)=>{
    return $16488b95470b7d64$var$ProductKeyToHAMSMap[product];
};

});


parcelRegister("7YAYH", function(module, exports) {
$parcel$export(module.exports, "getSiteTraitValues", () => $4591b1457307b3fa$export$2a16c85f3c5d2302);
const $4591b1457307b3fa$export$2a16c85f3c5d2302 = (traits)=>{
    if (traits.length === 0) return {
        automationUsage: 0,
        lastAutomationFreeLimitBreachDate: null,
        isSiteEligibleToServcoUplift: false
    };
    const automationUsageTrait = traits.find((trait)=>trait.name === 'growth_automation_limits_current_usage');
    const lastAutomationFreeLimitBreachDateTrait = traits.find((trait)=>trait.name === 'growth_automation_limits_usage_latest_breach_date');
    const servcoUpliftTrait = traits.find((trait)=>trait.name === 'is_site_eligible_to_servco_uplift');
    const automationUsage = automationUsageTrait && automationUsageTrait.value !== undefined && !isNaN(Number(automationUsageTrait.value)) ? Number(automationUsageTrait.value) : 0;
    const lastAutomationFreeLimitBreachDate = lastAutomationFreeLimitBreachDateTrait && typeof lastAutomationFreeLimitBreachDateTrait.value === 'string' && !isNaN(Date.parse(lastAutomationFreeLimitBreachDateTrait.value)) ? new Date(lastAutomationFreeLimitBreachDateTrait.value) : null;
    const isSiteEligibleToServcoUplift = Boolean(servcoUpliftTrait && typeof servcoUpliftTrait.value === 'boolean' && servcoUpliftTrait.value);
    return {
        automationUsage: automationUsage,
        lastAutomationFreeLimitBreachDate: lastAutomationFreeLimitBreachDate,
        isSiteEligibleToServcoUplift: isSiteEligibleToServcoUplift
    };
};

});

parcelRegister("8c1CF", function(module, exports) {
$parcel$export(module.exports, "ActionsAndContent", () => $d533307c30fb6ce9$export$3bec899b1babe0fe);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $5k5Eu = parcelRequire("5k5Eu");

var $kXxEy = parcelRequire("kXxEy");

var $cLUxG = parcelRequire("cLUxG");

var $bWK43 = parcelRequire("bWK43");

var $kdy74 = parcelRequire("kdy74");

var $dWZDJ = parcelRequire("dWZDJ");

var $3247t = parcelRequire("3247t");

var $2HR8E = parcelRequire("2HR8E");

var $hz7zH = parcelRequire("hz7zH");

var $dlUhC = parcelRequire("dlUhC");

var $kEyDS = parcelRequire("kEyDS");

var $4P8nz = parcelRequire("4P8nz");

var $cLtI0 = parcelRequire("cLtI0");

var $a0VWO = parcelRequire("a0VWO");

var $adjEa = parcelRequire("adjEa");

var $ejHsy = parcelRequire("ejHsy");

var $9H5h5 = parcelRequire("9H5h5");

var $4pvcM = parcelRequire("4pvcM");

var $lWBWs = parcelRequire("lWBWs");

var $aFAvE = parcelRequire("aFAvE");

var $2rNq9 = parcelRequire("2rNq9");

var $dt55X = parcelRequire("dt55X");

var $4gfIO = parcelRequire("4gfIO");

var $53SXY = parcelRequire("53SXY");

var $7rjBV = parcelRequire("7rjBV");

var $a9Sta = parcelRequire("a9Sta");

var $5M9bA = parcelRequire("5M9bA");

var $7pFb4 = parcelRequire("7pFb4");

var $gL9et = parcelRequire("gL9et");

var $3eDdx = parcelRequire("3eDdx");

var $frC7k = parcelRequire("frC7k");

var $3y3NW = parcelRequire("3y3NW");

var $lbX0f = parcelRequire("lbX0f");

var $V15Jq = parcelRequire("V15Jq");

var $6vTjx = parcelRequire("6vTjx");

var $iWrzG = parcelRequire("iWrzG");

var $2ce7f = parcelRequire("2ce7f");

var $ecvmR = parcelRequire("ecvmR");

var $3WISE = parcelRequire("3WISE");

var $jzJLz = parcelRequire("jzJLz");

var $3UcPg = parcelRequire("3UcPg");

var $5pyVI = parcelRequire("5pyVI");

var $4AZqG = parcelRequire("4AZqG");

var $ihjrE = parcelRequire("ihjrE");

var $7lbX7 = parcelRequire("7lbX7");
function $d533307c30fb6ce9$var$FreeEdition() {
    const context = (0, $kXxEy.useEditionAwareness)();
    const { automationFreeLimitStatus: automationFreeLimitStatus } = context;
    const { getExperimentValue: getExperimentValue } = (0, $cLUxG.useGetExperimentValue)();
    if ((0, $gL9et.isEligibleForTWCPlanSelectionPage)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ecvmR.PlanSelectionPageModal), {
        type: "twc"
    });
    if ((0, $bWK43.isEligibleForAutomationFreeLimitModal)(context)) {
        // These two statuses change the button content, and we need to fire exposure
        const fireExperimentExposure = automationFreeLimitStatus === 'BREACHED' || automationFreeLimitStatus === 'PROJECTED_TO_BREACH';
        const cohort = getExperimentValue({
            statsigParams: {
                experimentName: 'twcg-1076_jira_automation_limits_experiment',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled',
                options: {
                    fireExperimentExposure: fireExperimentExposure
                }
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'luna'
            }
        });
        if (cohort === 'variation') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3y3NW.AutomationFreeLimitModal), {});
    }
    if ((0, $a9Sta.isEligibleForStorageHardLimit)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4AZqG.StorageHardLimitModal), {});
    if ((0, $2HR8E.isEligibleForEAtoOSBFreeWithPDE)(context)) {
        const cohort = getExperimentValue({
            statsigParams: {
                experimentName: 'ea-to-osb-free-with-pde-ab',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled',
                options: {
                    fireExperimentExposure: false
                }
            }
        });
        if (cohort === 'variation') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7lbX7.UpgradeStandardFlowLink), {});
    }
    if ((0, $9H5h5.isEligibleForJsmStorageOverLimit)(context) || (0, $ejHsy.isEligibleForJsmStorageNearLimit)(context) || (0, $cLtI0.isEligibleForFreeToStandardModal)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iWrzG.FreeToStandardModal), {});
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5k5Eu.IneligibleAnalytics), {});
}
$d533307c30fb6ce9$var$FreeEdition.displayName = "FreeEdition";
function $d533307c30fb6ce9$var$StandardEdition() {
    const context = (0, $kXxEy.useEditionAwareness)();
    const { product: product, isInTrial: isInTrial, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, hasPaymentDetailsEntered: hasPaymentDetailsEntered, currentRoute: currentRoute } = context;
    const { getExperimentValue: getExperimentValue } = (0, $cLUxG.useGetExperimentValue)();
    if ((0, $3eDdx.isEligibleForTWCTrialNoPDE)(context)) // Teamwork Collection with no PDE in trial
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ecvmR.PlanSelectionPageModal), {
        type: "twc"
    });
    if ((0, $7pFb4.isEligibleForTWCChangePlan)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $V15Jq.CollectionChangePlanPopup), {});
    if ((0, $5M9bA.isEligibleForTWCAddPaymentDetails)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lbX0f.CollectionAddPaymentDetailsPopup), {});
    if (isInTrial && (0, $frC7k.isProductOneOf)(product, [
        'jira-service-management',
        'jira-customer-service'
    ]) && (hasPaymentDetailsEntered || invoiceableStatus === 'INVOICEABLE' || invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails)) getExperimentValue({
        statsigParams: {
            experimentName: 'jsmgrowth-466_aa_test',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled',
            options: {
                fireExperimentExposure: true
            }
        },
        trackEventParameters: {
            trackEventGrowthInitiative: 'sequoia'
        }
    });
    // Storage-limit auto-upgrade path is independent of the STAR experiment / its
    // killswitch / cohort. Render the modal whenever the dedicated storage-limit
    // killswitch is on and the entitlement trial trigger is AUTO_UPGRADE_STORAGE_LIMIT.
    if ((0, $dlUhC.isEligibleForExploreEditionBenefitsModalStorageLimit)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6vTjx.ExploreEditionBenefitsModal), {});
    if ((0, $kEyDS.isEligibleForExploreEditionBenefitsModalWithPDE)(context)) {
        if (getExperimentValue({
            statsigParams: {
                experimentName: 'jsmgrowth466_star',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'sequoia'
            }
        }) === 'variation') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6vTjx.ExploreEditionBenefitsModal), {});
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5k5Eu.IneligibleAnalytics), {});
    }
    if ((0, $4P8nz.isEligibleForExploreEditionBenefitsModalWithoutPDE)(context)) {
        if (getExperimentValue({
            statsigParams: {
                experimentName: 'jsmgrowth466_star',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'sequoia'
            }
        }) === 'variation') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6vTjx.ExploreEditionBenefitsModal), {});
    // jira-service-management intentionally falls through to the downstream isEligibleForStandardAddPaymentModal handler
    }
    // Catch-all: block CSM and ops routes that fell through (e.g. killswitch OFF, not in trial, or non-variation cohort)
    if (product === 'jira-customer-service' || currentRoute === 'ops') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5k5Eu.IneligibleAnalytics), {});
    if ((0, $7rjBV.isEligibleForStandardPaymentFlowLink)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihjrE.PaymentFlowLink), {});
    if ((0, $4gfIO.isEligibleForStandardAddPaymentModal)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5pyVI.StandardAddPaymentModal), {});
    // Jira Standard - Site admins get routed to JSTO, others to payment popup
    if ((0, $53SXY.isEligibleForStandardPaymentDetailsPopup)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2ce7f.PaymentDetailsPopup), {});
    if ((0, $3247t.isEligibleForConfluenceStandardAddPaymentModal)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5pyVI.StandardAddPaymentModal), {});
    if ((0, $adjEa.isEligibleForJiraStandardPredunning)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihjrE.PaymentFlowLink), {});
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5k5Eu.IneligibleAnalytics), {});
}
$d533307c30fb6ce9$var$StandardEdition.displayName = "StandardEdition";
function $d533307c30fb6ce9$var$PremiumEdition() {
    const context = (0, $kXxEy.useEditionAwareness)();
    const { getExperimentValue: getExperimentValue } = (0, $cLUxG.useGetExperimentValue)();
    // make sure twc is always shown first before jira reverse trial
    // otherwise, jira reverse trial will be shown with collection
    // additional check on invoiceableStatus and canAddPaymentDetails
    // to block any EA to be shown if the customer is in a collection
    // * confluence premium is showing EA regardless which needs to be blocked from collection
    if ((0, $3eDdx.isEligibleForTWCTrialNoPDE)(context)) // Teamwork Collection with no PDE in trial
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ecvmR.PlanSelectionPageModal), {
        type: "twc"
    });
    if ((0, $7pFb4.isEligibleForTWCChangePlan)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $V15Jq.CollectionChangePlanPopup), {});
    if ((0, $5M9bA.isEligibleForTWCAddPaymentDetails)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lbX0f.CollectionAddPaymentDetailsPopup), {});
    if ((0, $hz7zH.isEligibleForEAtoOSBNonRTPremiumAndRTPredunning)(context)) {
        const cohort = getExperimentValue({
            statsigParams: {
                experimentName: 'ea-to-osb-nonrt-premium-rt-predunning-ab',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled',
                options: {
                    fireExperimentExposure: false
                }
            }
        });
        if (cohort === 'variation') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihjrE.PaymentFlowLink), {});
    }
    if ((0, $dt55X.isEligibleForReverseTrialPlanSelection)(context)) {
        const rtCohort = getExperimentValue({
            statsigParams: {
                experimentName: 'jira_reverse_trial_ea_updates_during_trial',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'transmuters'
            }
        });
        if (rtCohort === 'variation') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ecvmR.PlanSelectionPageModal), {
            type: "reverse-trial"
        });
    }
    if ((0, $2rNq9.isEligibleForReverseTrial)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3UcPg.ReverseTrialPopupDialog), {});
    if ((0, $aFAvE.isEligibleForPremiumPaymentDetailsPopup)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2ce7f.PaymentDetailsPopup), {});
    if ((0, $a0VWO.isEligibleForJiraPremiumPredunning)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihjrE.PaymentFlowLink), {});
    if ((0, $kdy74.isEligibleForConfluenceBuyReverseTrialExperiment)(context) && (0, $egspI.fg)('growth_confluence_buy_reverse_trials_fg')) {
        const abCohort = getExperimentValue({
            statsigParams: {
                experimentName: 'growth_confluence_buy_reverse_trials_ab',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'luna',
                trackEventAttributes: {
                    touchpointId: 'actions-and-content'
                }
            }
        });
        if (abCohort === 'variation') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ecvmR.PlanSelectionPageModal), {
            type: "reverse-trial"
        });
    }
    if ((0, $dWZDJ.isEligibleForConfluencePremiumPopup)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jzJLz.PremiumPopup), {});
    if ((0, $lWBWs.isEligibleForPremiumAddPaymentModal)(context)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3WISE.PremiumAddPaymentModal), {});
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5k5Eu.IneligibleAnalytics), {});
}
$d533307c30fb6ce9$var$PremiumEdition.displayName = "PremiumEdition";
function $d533307c30fb6ce9$export$3bec899b1babe0fe() {
    const context = (0, $kXxEy.useEditionAwareness)();
    const { edition: edition } = context;
    const { getExperimentValue: getExperimentValue } = (0, $cLUxG.useGetExperimentValue)();
    if ((0, $4pvcM.isEligibleForJWMExperiment)(context) && getExperimentValue({
        statsigParams: {
            experimentName: 'twcg-1563-remove-jira-only-restriction',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled'
        }
    }) !== 'variation') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5k5Eu.IneligibleAnalytics), {});
    if (edition === 'free') return /*#__PURE__*/ (0, $e79Pd.jsx)($d533307c30fb6ce9$var$FreeEdition, {});
    if (edition === 'standard') return /*#__PURE__*/ (0, $e79Pd.jsx)($d533307c30fb6ce9$var$StandardEdition, {});
    if (edition === 'premium') return /*#__PURE__*/ (0, $e79Pd.jsx)($d533307c30fb6ce9$var$PremiumEdition, {});
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5k5Eu.IneligibleAnalytics), {});
}
$d533307c30fb6ce9$export$3bec899b1babe0fe.displayName = "ActionsAndContent";

});
parcelRegister("5k5Eu", function(module, exports) {
$parcel$export(module.exports, "IneligibleAnalytics", () => $57924888ef0fe9cb$export$132e847a0a2f0eca);

var $euxye = parcelRequire("euxye");

var $kXxEy = parcelRequire("kXxEy");

var $lmRlQ = parcelRequire("lmRlQ");
/**
 * One off event which tracks when a customer is eligible/ineligible for edition awareness.
 */ function $57924888ef0fe9cb$var$useTrackAudienceAndTiming({ isEligible: isEligible, shouldTrack: shouldTrack }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $lmRlQ.useAnalytics)();
    const hasSent = (0, $euxye.useRef)(false);
    (0, $euxye.useEffect)(()=>{
        if (!shouldTrack || hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'operational',
            actionSubject: 'audienceAndTiming',
            actionSubjectId: 'editionAwareness',
            action: 'checked',
            attributes: {
                isEligible: isEligible
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        isEligible,
        shouldTrack
    ]);
}
function $57924888ef0fe9cb$export$132e847a0a2f0eca() {
    const { edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning } = (0, $kXxEy.useEditionAwareness)();
    const shouldTrack = Boolean(edition === 'free' || isInTrial || isInPredunning);
    $57924888ef0fe9cb$var$useTrackAudienceAndTiming({
        isEligible: false,
        shouldTrack: shouldTrack
    });
    return null;
}

});

parcelRegister("bWK43", function(module, exports) {
$parcel$export(module.exports, "isEligibleForAutomationFreeLimitModal", () => $b15f0e18f4d9315e$export$f8cd4dfe6dfcae9f);

var $cV67E = parcelRequire("cV67E");

var $frC7k = parcelRequire("frC7k");
function $b15f0e18f4d9315e$export$f8cd4dfe6dfcae9f(context) {
    const { isInCollection: isInCollection, edition: edition, automationFreeLimitStatus: automationFreeLimitStatus, product: product, canUpgrade: canUpgrade } = context;
    return Boolean(!isInCollection && (0, $cV67E.isEditionOneOf)(edition, [
        'free'
    ]) && (0, $frC7k.isProductOneOf)(product, [
        'jira'
    ]) && canUpgrade && automationFreeLimitStatus);
}

});
parcelRegister("cV67E", function(module, exports) {
$parcel$export(module.exports, "isEditionOneOf", () => $75848c5d465b577e$export$33790e51c030646b);
function $75848c5d465b577e$export$33790e51c030646b(edition, possibleMatches) {
    return possibleMatches.includes(edition);
}

});


parcelRegister("kdy74", function(module, exports) {
$parcel$export(module.exports, "isEligibleForConfluenceBuyReverseTrialExperiment", () => $ffb749667fae1a3d$export$d8e323470f628b52);
function $ffb749667fae1a3d$export$d8e323470f628b52(context) {
    const { product: product, edition: edition, invoiceableStatus: invoiceableStatus, isInReverseTrial: isInReverseTrial, isInTrial: isInTrial, isInPredunning: isInPredunning, isInCollection: isInCollection } = context;
    return Boolean(!isInCollection && product === 'confluence' && edition === 'premium' && (isInTrial || isInPredunning) && isInReverseTrial && invoiceableStatus === 'NOT_INVOICEABLE');
}

});

parcelRegister("dWZDJ", function(module, exports) {
$parcel$export(module.exports, "isEligibleForConfluencePremiumPopup", () => $139581a5942944ce$export$9416586c22ff4b30);

var $cV67E = parcelRequire("cV67E");
function $139581a5942944ce$export$9416586c22ff4b30(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, isInCollection: isInCollection } = context;
    return Boolean(!isInCollection && (0, $cV67E.isEditionOneOf)(edition, [
        'premium'
    ]) && product === 'confluence' && (isInTrial || isInPredunning));
}

});

parcelRegister("3247t", function(module, exports) {
$parcel$export(module.exports, "isEligibleForConfluenceStandardAddPaymentModal", () => $b044313f747df7a2$export$e836acfd81d43d40);

var $cV67E = parcelRequire("cV67E");
function $b044313f747df7a2$export$e836acfd81d43d40(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, isInCollection: isInCollection } = context;
    return Boolean(!isInCollection && (0, $cV67E.isEditionOneOf)(edition, [
        'standard'
    ]) && product === 'confluence' && (isInTrial || isInPredunning) && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails);
}

});

parcelRegister("2HR8E", function(module, exports) {
$parcel$export(module.exports, "isEligibleForEAtoOSBFreeWithPDE", () => $abc2c91695ce4500$export$2fc8b3290463c59f);

var $cV67E = parcelRequire("cV67E");

var $frC7k = parcelRequire("frC7k");
function $abc2c91695ce4500$export$2fc8b3290463c59f(context) {
    const { product: product, edition: edition, canUpgrade: canUpgrade, changeOfferingToStandardExperienceUrl: changeOfferingToStandardExperienceUrl, isInCollection: isInCollection, hasPaymentDetailsEntered: hasPaymentDetailsEntered } = context;
    const isEligibleNonCollectionProduct = !isInCollection && (0, $frC7k.isProductOneOf)(product, [
        'jira',
        'jira-product-discovery',
        'confluence'
    ]);
    const isEligibleCollectionAgnosticProduct = (0, $frC7k.isProductOneOf)(product, [
        'jira-service-management'
    ]);
    return Boolean((0, $cV67E.isEditionOneOf)(edition, [
        'free'
    ]) && canUpgrade && hasPaymentDetailsEntered && changeOfferingToStandardExperienceUrl && (isEligibleNonCollectionProduct || isEligibleCollectionAgnosticProduct));
}

});

parcelRegister("hz7zH", function(module, exports) {
$parcel$export(module.exports, "isEligibleForEAtoOSBNonRTPremiumAndRTPredunning", () => $efd02c307c4347fd$export$5fbb167b086fdea2);

var $egspI = parcelRequire("egspI");
function $efd02c307c4347fd$export$5fbb167b086fdea2(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, isInReverseTrial: isInReverseTrial, isInCollection: isInCollection, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl } = context;
    const isRTPredunningAudience = isInReverseTrial && isInPredunning && (product === 'jira' || product === 'confluence');
    const isNonRTTrialAudience = !isInReverseTrial && (product === 'jira' && isInTrial || product === 'confluence' && (isInTrial || isInPredunning));
    return Boolean(!isInCollection && edition === 'premium' && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails && !!addPaymentDetailsExperienceUrl && (isRTPredunningAudience || isNonRTTrialAudience) && (0, $egspI.fg)('ea-to-osb-nonrt-premium-rt-predunning-kill-switch'));
}

});

parcelRegister("dlUhC", function(module, exports) {
$parcel$export(module.exports, "isEligibleForExploreEditionBenefitsModalStorageLimit", () => $d1eb17b313a00d6a$export$e9fa57939363ea21);

var $egspI = parcelRequire("egspI");

var $frC7k = parcelRequire("frC7k");
function $d1eb17b313a00d6a$export$e9fa57939363ea21({ product: product, edition: edition, isInTrial: isInTrial, lastKnownTrial: lastKnownTrial }) {
    if (edition === 'standard' && isInTrial && (0, $frC7k.isProductOneOf)(product, [
        'jira-service-management',
        'jira-customer-service'
    ]) && lastKnownTrial?.trialTrigger === 'AUTO_UPGRADE_STORAGE_LIMIT' && (0, $egspI.fg)('post-trial-modal')) return true;
    return false;
}

});

parcelRegister("kEyDS", function(module, exports) {
$parcel$export(module.exports, "isEligibleForExploreEditionBenefitsModalWithPDE", () => $10e8fe00f3affe7c$export$9c6d1794c9e6b0da);

var $egspI = parcelRequire("egspI");

var $frC7k = parcelRequire("frC7k");
function $10e8fe00f3affe7c$export$9c6d1794c9e6b0da({ product: product, edition: edition, isInTrial: isInTrial, invoiceableStatus: invoiceableStatus, hasPaymentDetailsEntered: hasPaymentDetailsEntered }) {
    if (edition === 'standard' && isInTrial && (0, $frC7k.isProductOneOf)(product, [
        'jira-service-management',
        'jira-customer-service'
    ]) && (hasPaymentDetailsEntered || invoiceableStatus === 'INVOICEABLE') && (0, $egspI.fg)('jsmgrowth-466_star_killswitch')) return true;
    return false;
}

});

parcelRegister("4P8nz", function(module, exports) {
$parcel$export(module.exports, "isEligibleForExploreEditionBenefitsModalWithoutPDE", () => $cf2959b9d3ce0b0e$export$e4ac5dd74ecc884f);

var $egspI = parcelRequire("egspI");

var $frC7k = parcelRequire("frC7k");
function $cf2959b9d3ce0b0e$export$e4ac5dd74ecc884f({ product: product, edition: edition, isInTrial: isInTrial, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails }) {
    if (edition === 'standard' && isInTrial && (0, $frC7k.isProductOneOf)(product, [
        'jira-service-management',
        'jira-customer-service'
    ]) && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails && (0, $egspI.fg)('jsmgrowth-466_star_killswitch')) return true;
    return false;
}

});

parcelRegister("cLtI0", function(module, exports) {
$parcel$export(module.exports, "isEligibleForFreeToStandardModal", () => $f5a3d2f8dcd0222f$export$4a67e7452b9d2774);

var $cV67E = parcelRequire("cV67E");

var $frC7k = parcelRequire("frC7k");
function $f5a3d2f8dcd0222f$export$4a67e7452b9d2774(context) {
    const { edition: edition, canUpgrade: canUpgrade, canDirectBuyUpgrade: canDirectBuyUpgrade, isInCollection: isInCollection, product: product, currentRoute: currentRoute } = context;
    return Boolean((0, $cV67E.isEditionOneOf)(edition, [
        'free'
    ]) && (canUpgrade || canDirectBuyUpgrade) && ((0, $frC7k.isProductOneOf)(product, [
        'jira-service-management'
    ]) && currentRoute !== 'ops' || // All the other products are eligible for non-collection sites
    !isInCollection && (0, $frC7k.isProductOneOf)(product, [
        'jira',
        'confluence',
        'jira-product-discovery'
    ])));
}

});

parcelRegister("a0VWO", function(module, exports) {
$parcel$export(module.exports, "isEligibleForJiraPremiumPredunning", () => $32350fb7f4eb95de$export$f46acfd104f09e48);

var $cV67E = parcelRequire("cV67E");

var $frC7k = parcelRequire("frC7k");
function $32350fb7f4eb95de$export$f46acfd104f09e48(context) {
    const { product: product, edition: edition, isInPredunning: isInPredunning, canAddPaymentDetails: canAddPaymentDetails, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, isInCollection: isInCollection, invoiceableStatus: invoiceableStatus } = context;
    return Boolean(!isInCollection && (0, $cV67E.isEditionOneOf)(edition, [
        'premium'
    ]) && isInPredunning && (0, $frC7k.isProductOneOf)(product, [
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ]) && canAddPaymentDetails && addPaymentDetailsExperienceUrl && invoiceableStatus === 'NOT_INVOICEABLE');
}

});

parcelRegister("adjEa", function(module, exports) {
$parcel$export(module.exports, "isEligibleForJiraStandardPredunning", () => $096d35a45bb0cc18$export$99a24d1a09f0bdfd);

var $cV67E = parcelRequire("cV67E");

var $frC7k = parcelRequire("frC7k");
function $096d35a45bb0cc18$export$99a24d1a09f0bdfd(context) {
    const { product: product, edition: edition, isInPredunning: isInPredunning, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, isInCollection: isInCollection } = context;
    return Boolean(!isInCollection && (0, $cV67E.isEditionOneOf)(edition, [
        'standard'
    ]) && addPaymentDetailsExperienceUrl && isInPredunning && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails && (0, $frC7k.isProductOneOf)(product, [
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ]));
}

});

parcelRegister("ejHsy", function(module, exports) {
$parcel$export(module.exports, "isEligibleForJsmStorageNearLimit", () => $b731904f836e8dc7$export$9be156eca6370e22);

var $egspI = parcelRequire("egspI");
const $b731904f836e8dc7$export$e651dfbe221a2c4 = 0.9;
// Hard-limit and near-limit are mutually exclusive at the threshold of
// storageUsageInGB === storageLimitInGB. The hard-limit predicate uses
// `>=` so we must use a strict `<` here AND defensively guard against
// floating-point drift around the boundary (e.g. usage 0.999_999 of a
// 1.0 limit). Without this, a fractional gigabyte of drift would route
// the user to "Storage almost full" while AdminHub shows "full".
//
// We treat anything within 1e-9 of the limit as already at the hard
// limit. JSM storage usage is reported in GB with at most 6 decimal
// places of precision upstream, so 1e-9 is well below any real-world
// drift while still keeping the boundary deterministic.
const $b731904f836e8dc7$var$FLOAT_DRIFT_TOLERANCE = 1e-9;
function $b731904f836e8dc7$export$9be156eca6370e22(context) {
    const { storageUsageInGB: storageUsageInGB, storageLimitInGB: storageLimitInGB, storageIsUnlimited: storageIsUnlimited, product: product, edition: edition, canUpgrade: canUpgrade, canDirectBuyUpgrade: canDirectBuyUpgrade } = context;
    if (!storageUsageInGB || !storageLimitInGB) return false;
    const usageRatio = storageUsageInGB / storageLimitInGB;
    const isStrictlyBelowHardLimit = usageRatio < 1 - $b731904f836e8dc7$var$FLOAT_DRIFT_TOLERANCE;
    return product === 'jira-service-management' && edition === 'free' && !!(canUpgrade || canDirectBuyUpgrade) && !storageIsUnlimited && usageRatio >= $b731904f836e8dc7$export$e651dfbe221a2c4 && isStrictlyBelowHardLimit && (0, $egspI.fg)('jsmgrowth-267_-_enforce_storage_limits');
}

});

parcelRegister("9H5h5", function(module, exports) {
$parcel$export(module.exports, "isEligibleForJsmStorageOverLimit", () => $ac92cd77f3f7c10b$export$7748cf7f08a86647);

var $egspI = parcelRequire("egspI");
function $ac92cd77f3f7c10b$export$7748cf7f08a86647(context) {
    const { storageUsageInGB: storageUsageInGB, storageLimitInGB: storageLimitInGB, storageIsUnlimited: storageIsUnlimited, product: product, edition: edition, canUpgrade: canUpgrade, canDirectBuyUpgrade: canDirectBuyUpgrade } = context;
    if (!storageUsageInGB || !storageLimitInGB) return false;
    return product === 'jira-service-management' && edition === 'free' && !!(canUpgrade || canDirectBuyUpgrade) && !storageIsUnlimited && storageUsageInGB >= storageLimitInGB && (0, $egspI.fg)('jsmgrowth-267_-_enforce_storage_limits');
}

});

parcelRegister("4pvcM", function(module, exports) {
$parcel$export(module.exports, "isEligibleForJWMExperiment", () => $557d15a1e3ed86cd$export$14915434c5c6f101);
function $557d15a1e3ed86cd$export$14915434c5c6f101(context) {
    const { product: product, originalProjectTypeWasCore: originalProjectTypeWasCore, isInCollection: isInCollection, userRoles: userRoles, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, canUpgrade: canUpgrade, canDirectBuyUpgrade: canDirectBuyUpgrade, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails } = context;
    // Base checks for this experiment
    if (product === 'jira' && originalProjectTypeWasCore) {
        // Had to replicate from audience-and-timing to avoid having to expose this experiment on each modal that targets Jira
        const isInTrialOrPredunning = isInTrial || isInPredunning;
        const collectionWithPermissions = isInCollection && userRoles?.includes('BILLING_ADMIN') && (edition === 'free' || isInTrialOrPredunning);
        const freeEditionWithPermissions = !isInCollection && edition === 'free' && (canUpgrade || canDirectBuyUpgrade);
        const trialWithPermissions = !isInCollection && (edition === 'standard' || edition === 'premium') && isInTrialOrPredunning && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails;
        return Boolean(collectionWithPermissions || freeEditionWithPermissions || trialWithPermissions);
    }
    return false;
}

});

parcelRegister("lWBWs", function(module, exports) {
$parcel$export(module.exports, "isEligibleForPremiumAddPaymentModal", () => $8c396d9a00fe6013$export$8ca336c4787758f5);

var $cV67E = parcelRequire("cV67E");

var $frC7k = parcelRequire("frC7k");
function $8c396d9a00fe6013$export$8ca336c4787758f5(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails } = context;
    return Boolean((0, $cV67E.isEditionOneOf)(edition, [
        'premium'
    ]) && isInTrial && (0, $frC7k.isProductOneOf)(product, [
        'jira-service-management',
        'jira-product-discovery'
    ]) && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails);
}

});

parcelRegister("aFAvE", function(module, exports) {
$parcel$export(module.exports, "isEligibleForPremiumPaymentDetailsPopup", () => $828a380e8e7b6dca$export$20fafa3abc2da179);

var $cV67E = parcelRequire("cV67E");
function $828a380e8e7b6dca$export$20fafa3abc2da179(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInReverseTrial: isInReverseTrial, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, isInCollection: isInCollection, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails } = context;
    return Boolean(!isInCollection && (0, $cV67E.isEditionOneOf)(edition, [
        'premium'
    ]) && product === 'jira' && isInTrial && !isInReverseTrial && addPaymentDetailsExperienceUrl && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails);
}

});

parcelRegister("2rNq9", function(module, exports) {
$parcel$export(module.exports, "isEligibleForReverseTrial", () => $dcec9921ec810c75$export$a40237193d8c237b);

var $cV67E = parcelRequire("cV67E");
function $dcec9921ec810c75$export$a40237193d8c237b(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInReverseTrial: isInReverseTrial, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, isInCollection: isInCollection, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails } = context;
    return Boolean(!isInCollection && (0, $cV67E.isEditionOneOf)(edition, [
        'premium'
    ]) && product === 'jira' && isInTrial && isInReverseTrial && addPaymentDetailsExperienceUrl && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails);
}

});

parcelRegister("dt55X", function(module, exports) {
$parcel$export(module.exports, "isEligibleForReverseTrialPlanSelection", () => $afd9248a3903acd6$export$e939a07b6b49e3d2);

var $cV67E = parcelRequire("cV67E");
function $afd9248a3903acd6$export$e939a07b6b49e3d2(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, isInReverseTrial: isInReverseTrial, userRoles: userRoles, isInCollection: isInCollection, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails } = context;
    return Boolean(!isInCollection && (0, $cV67E.isEditionOneOf)(edition, [
        'premium'
    ]) && product === 'jira' && (isInTrial || isInPredunning) && isInReverseTrial && userRoles?.includes('BILLING_ADMIN') && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails);
}

});

parcelRegister("4gfIO", function(module, exports) {
$parcel$export(module.exports, "isEligibleForStandardAddPaymentModal", () => $683b4ed656a2bddf$export$3895b7d1f33e279e);

var $cV67E = parcelRequire("cV67E");

var $frC7k = parcelRequire("frC7k");
function $683b4ed656a2bddf$export$3895b7d1f33e279e(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails } = context;
    return Boolean((0, $cV67E.isEditionOneOf)(edition, [
        'standard'
    ]) && isInTrial && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails && (0, $frC7k.isProductOneOf)(product, [
        'jira-service-management',
        'jira-product-discovery'
    ]));
}

});

parcelRegister("53SXY", function(module, exports) {
$parcel$export(module.exports, "isEligibleForStandardPaymentDetailsPopup", () => $6759c8fabea7269c$export$b02d2c2f86fa7487);

var $cV67E = parcelRequire("cV67E");
function $6759c8fabea7269c$export$b02d2c2f86fa7487(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, isInCollection: isInCollection } = context;
    return Boolean(!isInCollection && (0, $cV67E.isEditionOneOf)(edition, [
        'standard'
    ]) && product === 'jira' && isInTrial && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails);
}

});

parcelRegister("7rjBV", function(module, exports) {
$parcel$export(module.exports, "isEligibleForStandardPaymentFlowLink", () => $0a018f47544e3c36$export$1906afb287ebb7aa);

var $cV67E = parcelRequire("cV67E");

var $frC7k = parcelRequire("frC7k");
function $0a018f47544e3c36$export$1906afb287ebb7aa(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, isInCollection: isInCollection } = context;
    return Boolean(!isInCollection && (0, $cV67E.isEditionOneOf)(edition, [
        'standard'
    ]) && (isInTrial || isInPredunning) && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails && (0, $frC7k.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && addPaymentDetailsExperienceUrl);
}

});

parcelRegister("a9Sta", function(module, exports) {
$parcel$export(module.exports, "isEligibleForStorageHardLimit", () => $8e9b84da45d31fee$export$8057dcbab6360925);
function $8e9b84da45d31fee$export$8057dcbab6360925(context) {
    const { storageUsageInGB: storageUsageInGB, storageLimitInGB: storageLimitInGB, storageIsUnlimited: storageIsUnlimited, product: product, edition: edition, isInCollection: isInCollection, canUpgrade: canUpgrade, canDirectBuyUpgrade: canDirectBuyUpgrade } = context;
    if (!storageUsageInGB || !storageLimitInGB) return false;
    return Boolean(!isInCollection && product === 'jira' && edition === 'free' && (canUpgrade || canDirectBuyUpgrade) && !storageIsUnlimited && storageUsageInGB >= storageLimitInGB);
}

});

parcelRegister("5M9bA", function(module, exports) {
$parcel$export(module.exports, "isEligibleForTWCAddPaymentDetails", () => $078120064c0cd742$export$92559b6c170c03d7);

var $cV67E = parcelRequire("cV67E");

var $frC7k = parcelRequire("frC7k");
function $078120064c0cd742$export$92559b6c170c03d7(context) {
    const { product: product, edition: edition, isInCollection: isInCollection, isInPredunning: isInPredunning, userRoles: userRoles } = context;
    return Boolean((0, $cV67E.isEditionOneOf)(edition, [
        'standard',
        'premium'
    ]) && isInCollection && (0, $frC7k.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && userRoles?.includes('BILLING_ADMIN') && isInPredunning);
}

});

parcelRegister("7pFb4", function(module, exports) {
$parcel$export(module.exports, "isEligibleForTWCChangePlan", () => $025fb701336ad3d6$export$81d798ee41a14e1f);

var $cV67E = parcelRequire("cV67E");

var $frC7k = parcelRequire("frC7k");
function $025fb701336ad3d6$export$81d798ee41a14e1f(context) {
    const { product: product, edition: edition, isInCollection: isInCollection, isInTrial: isInTrial, userRoles: userRoles } = context;
    return Boolean((0, $cV67E.isEditionOneOf)(edition, [
        'standard',
        'premium'
    ]) && isInCollection && (0, $frC7k.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && userRoles?.includes('BILLING_ADMIN') && isInTrial);
}

});

parcelRegister("gL9et", function(module, exports) {
$parcel$export(module.exports, "isEligibleForTWCPlanSelectionPage", () => $5966bc1f48ca592b$export$1110acfc7a546604);

var $cV67E = parcelRequire("cV67E");

var $frC7k = parcelRequire("frC7k");
function $5966bc1f48ca592b$export$1110acfc7a546604(context) {
    const { product: product, edition: edition, isInCollection: isInCollection, userRoles: userRoles } = context;
    return Boolean((0, $cV67E.isEditionOneOf)(edition, [
        'free'
    ]) && isInCollection && (0, $frC7k.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && userRoles?.includes('BILLING_ADMIN'));
}

});

parcelRegister("3eDdx", function(module, exports) {
$parcel$export(module.exports, "isEligibleForTWCTrialNoPDE", () => $f19335abe543b4b6$export$f7ff9356fa50dbb8);

var $cV67E = parcelRequire("cV67E");

var $frC7k = parcelRequire("frC7k");
function $f19335abe543b4b6$export$f7ff9356fa50dbb8(context) {
    const { product: product, edition: edition, isInCollection: isInCollection, isInTrial: isInTrial, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, userRoles: userRoles } = context;
    return Boolean((0, $cV67E.isEditionOneOf)(edition, [
        'standard',
        'premium'
    ]) && isInCollection && (0, $frC7k.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && userRoles?.includes('BILLING_ADMIN') && isInTrial && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails);
}

});

parcelRegister("3y3NW", function(module, exports) {
$parcel$export(module.exports, "AutomationFreeLimitModal", () => $89c55bc72116062b$export$b124b7369c64df7c);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $kXxEy = parcelRequire("kXxEy");

var $fSAGQ = parcelRequire("fSAGQ");

var $68pIr = parcelRequire("68pIr");

var $91dyV = parcelRequire("91dyV");
function $89c55bc72116062b$export$b124b7369c64df7c() {
    const { edition: edition } = (0, $kXxEy.useEditionAwareness)();
    const DIALOG_CONFIG = (0, $euxye.useMemo)(()=>{
        if (edition === 'free') return 0, $91dyV.FREE_DIALOG_CONFIG;
        throw new Error(`Unsupported edition: ${edition}`);
    }, [
        edition
    ]);
    const modalProps = (0, $euxye.useMemo)(()=>({
            width: 968,
            height: 516
        }), []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fSAGQ.ModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $68pIr.default),
        dialogConfig: DIALOG_CONFIG
    });
}
$89c55bc72116062b$export$b124b7369c64df7c.displayName = "AutomationFreeLimitModal";

});
parcelRegister("fSAGQ", function(module, exports) {
$parcel$export(module.exports, "ModalEntryPoint", () => $aee3d538a7f64c10$export$50a5ec7edfae079b);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hUqPj = parcelRequire("hUqPj");

var $fnihK = parcelRequire("fnihK");

var $ikm5U = parcelRequire("ikm5U");

var $4pi5Q = parcelRequire("4pi5Q");

var $kkhkz = parcelRequire("kkhkz");

var $gWQqC = parcelRequire("gWQqC");

var $eX7RF = parcelRequire("eX7RF");

var $2cMDS = parcelRequire("2cMDS");
function $aee3d538a7f64c10$export$50a5ec7edfae079b(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4pi5Q.DialogContext).Provider, {
        value: dialogConfig,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hUqPj.default), {
            data: dialogConfig,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)($aee3d538a7f64c10$var$ModalEntryPointInner, {
                ...rest
            })
        })
    });
}
$aee3d538a7f64c10$export$50a5ec7edfae079b.displayName = "ModalEntryPoint";
function $aee3d538a7f64c10$var$ModalEntryPointInner(props) {
    const { shouldAutoOpen: shouldAutoOpen, entryPointProps: entryPointProps, onError: onError, ...rest } = props;
    const onEntrypointError = (0, $kkhkz.useEntrypointErrorAnalytics)();
    const onErrorCallback = (0, $euxye.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        onEntrypointError({
            error: error,
            errorInfo: errorInfo
        });
        onError?.({
            error: error,
            errorInfo: errorInfo
        });
    }, [
        onEntrypointError,
        onError
    ]);
    const onCloseDialog = (0, $gWQqC.useOnCloseDialog)();
    const onClose = (0, $euxye.useCallback)((extraInformation)=>{
        let attributes;
        if (extraInformation && typeof extraInformation === 'object' && 'triggeredBy' in extraInformation) attributes = {
            triggeredBy: extraInformation.triggeredBy
        };
        onCloseDialog(attributes);
        entryPointProps?.onClose?.();
    }, [
        entryPointProps,
        onCloseDialog
    ]);
    const finalEntryPointProps = (0, $euxye.useMemo)(()=>({
            ...entryPointProps,
            onClose: onClose
        }), [
        entryPointProps,
        onClose
    ]);
    // If we're auto opening, we can handle this setting here
    const Trigger = shouldAutoOpen ? (0, $2cMDS.AutoOpenModalTrigger) : (0, $ikm5U.ModalTrigger);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fnihK.ModalContextProvider), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)(Trigger, {
            ...rest,
            entryPointProps: finalEntryPointProps,
            onError: onErrorCallback,
            shouldAutoOpen: shouldAutoOpen,
            preloadOnFocus: true,
            children: ({ ref: ref })=>{
                return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eX7RF.EditionAwarenessButton), {
                    ref: ref
                });
            }
        })
    });
}
$aee3d538a7f64c10$var$ModalEntryPointInner.displayName = "ModalEntryPointInner";

});
parcelRegister("4pi5Q", function(module, exports) {
$parcel$export(module.exports, "DialogContext", () => $cfdd3ee514e88ab4$export$8b93a07348a7730c);
$parcel$export(module.exports, "useDialogContext", () => $cfdd3ee514e88ab4$export$898e461c0669e62d);

var $euxye = parcelRequire("euxye");
const $cfdd3ee514e88ab4$export$8b93a07348a7730c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createContext(null);
function $cfdd3ee514e88ab4$export$898e461c0669e62d() {
    return (0, $euxye.useContext)($cfdd3ee514e88ab4$export$8b93a07348a7730c);
}

});

parcelRegister("kkhkz", function(module, exports) {
$parcel$export(module.exports, "useEntrypointErrorAnalytics", () => $9992987bdfeb7a6d$export$f2e26e89f653216c);

var $euxye = parcelRequire("euxye");

var $lmRlQ = parcelRequire("lmRlQ");
function $9992987bdfeb7a6d$export$f2e26e89f653216c() {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $lmRlQ.useAnalytics)();
    const handleOnError = (0, $euxye.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: {
                error: error.message,
                errorStack: error.stack,
                errorName: error.name,
                errorComponentStack: errorInfo.componentStack,
                id: 'entrypointError'
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    return handleOnError;
}

});

parcelRegister("gWQqC", function(module, exports) {
$parcel$export(module.exports, "useOnCloseDialog", () => $53ce264d4f9a3752$export$bdf52d4393ceb609);

var $euxye = parcelRequire("euxye");

var $4B6hN = parcelRequire("4B6hN");

var $lmRlQ = parcelRequire("lmRlQ");
const $53ce264d4f9a3752$export$bdf52d4393ceb609 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $lmRlQ.useAnalytics)();
    const onClose = (0, $euxye.useCallback)((attributes)=>{
        sendAnalyticsEvent({
            action: 'closed',
            actionSubject: 'dialog',
            actionSubjectId: 'editionAwarenessDialog',
            attributes: attributes
        });
    }, [
        sendAnalyticsEvent
    ]);
    const [onCloseDebounced] = (0, $4B6hN.default)(onClose, 300, {
        leading: true,
        trailing: false
    });
    return onCloseDebounced;
};

});

parcelRegister("eX7RF", function(module, exports) {
$parcel$export(module.exports, "EditionAwarenessButton", () => $4a78ee6e3fa4b6d2$export$57ddd9301662f8e4);
$parcel$export(module.exports, "EditionAwarenessLink", () => $4a78ee6e3fa4b6d2$export$1bf8122badfd728c);
/* edition-awareness-button.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");
var $1YIbA = parcelRequire("1YIbA");

var $1MNmN = parcelRequire("1MNmN");

var $1Pip6 = parcelRequire("1Pip6");

var $dIQFJ = parcelRequire("dIQFJ");

var $7Fzpe = parcelRequire("7Fzpe");

var $8QmUu = parcelRequire("8QmUu");

var $hzWaA = parcelRequire("hzWaA");

var $8a8ab = parcelRequire("8a8ab");
var $fX8LH = parcelRequire("fX8LH");
var $eoGQo = parcelRequire("eoGQo");

var $d7tnL = parcelRequire("d7tnL");

var $egspI = parcelRequire("egspI");

var $9MWap = parcelRequire("9MWap");
var $ihEDU = parcelRequire("ihEDU");
var $2XXtG = parcelRequire("2XXtG");
var $6mEZn = parcelRequire("6mEZn");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $eMhe9 = parcelRequire("eMhe9");
var $7luds = parcelRequire("7luds");
var $cU4dJ = parcelRequire("cU4dJ");
var $3qx2a = parcelRequire("3qx2a");

var $1jN5w = parcelRequire("1jN5w");

var $lmRlQ = parcelRequire("lmRlQ");

var $cbW2j = parcelRequire("cbW2j");

var $kXxEy = parcelRequire("kXxEy");

var $cLUxG = parcelRequire("cLUxG");

var $crSbr = parcelRequire("crSbr");

var $1PteH = parcelRequire("1PteH");

var $2HR8E = parcelRequire("2HR8E");

var $hz7zH = parcelRequire("hz7zH");

var $67dVX = parcelRequire("67dVX");

var $aEAis = parcelRequire("aEAis");

var $59epF = parcelRequire("59epF");

var $im846 = parcelRequire("im846");
const $4a78ee6e3fa4b6d2$var$styles = {
    button: "_11c8fhey _2rko12b0 _zulpu2gc _4bfu18uv _1hmsglyw _ajmmnqa1 _189ee4h9 _1dqonqa1 _18zrutpp _1rjc1b66 _k48p1wq8 _bfhkvuon _1tkezwfg _syazi7uo _k8m0t8hk _1oecfnf5 _1e0c1txw _4cvr1h6o _1a3b18uv _4fprglyw _5goinqa1 _f8pji7uo _9oik18uv _1bnxglyw _jf4cnqa1 _irr31dpa _30l3i7uo _1nrm18uv _c2waglyw _1iohnqa1 _1di6fcek",
    buttonT26Shape: "_2rko1qi0",
    default: "_1h6dv30g _syazdv2p _f8pjdv2p _irr3kca2 _30l3dv2p _1di61jbm",
    warning: "_1h6d1xiv",
    danger: "_1h6d1bqt",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _uiztglyw",
    dismissible: "_qrwqidpf _1o0zidpf",
    dismissMenu: "_11c8fhey _2rko12b0 _zulpu2gc _4bfu18uv _1hmsglyw _ajmmnqa1 _189ee4h9 _1dqonqa1 _18zru2gc _1rjcze3t _1h6dv30g _k48p1wq8 _bfhkvuon _1tkezwfg _syazi7uo _k8m0t8hk _1oecfnf5 _1e0c1txw _4cvr1h6o _t6vdidpf _13liidpf _mrkbidpf _irr3kca2 _1di61jbm",
    dismissMenuT26Shape: "_2rko1qi0 _13liidpf _mrkbidpf",
    reasonsUl: "_19pkidpf _18u0pxbi _19bvu2gc"
};
function $4a78ee6e3fa4b6d2$var$Icon({ appearance: appearance, icon: icon, color: color }) {
    if (icon === 'warning') {
        const defaultColor = appearance === 'danger' ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon-warning, #E06C00)";
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8QmUu))), {
            label: "",
            color: color ?? defaultColor,
            size: "small"
        });
    }
    if (icon === 'credit-card') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dIQFJ))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #AF59E1)"
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Pip6))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #AF59E1)"
    });
}
$4a78ee6e3fa4b6d2$var$Icon.displayName = "Icon";
const $4a78ee6e3fa4b6d2$export$57ddd9301662f8e4 = /*#__PURE__*/ (0, $euxye.forwardRef)(function({ onClick: onClick, ...rest }, ref) {
    const buttonContent = (0, $67dVX.useButtonContent)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, badge: badge, appearance: appearance = 'default', isDismissible: isDismissible } = buttonContent;
    const hasCustomTheme = (0, $d7tnL.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $lmRlQ.useAnalytics)();
    const context = (0, $kXxEy.useEditionAwareness)();
    const { getExperimentValue: getExperimentValue } = (0, $cLUxG.useGetExperimentValue)();
    const analyticsAttributes = (0, $euxye.useMemo)(()=>({
            type: 'button',
            icon: icon,
            badge: badge,
            appearance: appearance
        }), [
        icon,
        badge,
        appearance
    ]);
    const handleOnClick = (0, $euxye.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        // Fire exposure here so control users, whose routing does not render PaymentFlowLink,
        // are still enrolled. Variation additionally fires in PaymentFlowLink.
        if ((0, $hz7zH.isEligibleForEAtoOSBNonRTPremiumAndRTPredunning)(context)) getExperimentValue({
            statsigParams: {
                experimentName: 'ea-to-osb-nonrt-premium-rt-predunning-ab',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'tako'
            }
        });
        if ((0, $2HR8E.isEligibleForEAtoOSBFreeWithPDE)(context)) {
            getExperimentValue({
                statsigParams: {
                    experimentName: 'ea-to-osb-free-with-pde-aa',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled'
                },
                trackEventParameters: {
                    trackEventGrowthInitiative: 'tako'
                }
            });
            getExperimentValue({
                statsigParams: {
                    experimentName: 'ea-to-osb-free-with-pde-ab',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled'
                },
                trackEventParameters: {
                    trackEventGrowthInitiative: 'tako'
                }
            });
        }
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes,
        getExperimentValue,
        context
    ]);
    const handleOnMouseEnter = (0, $euxye.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'hovered',
            actionSubject: 'button',
            actionSubjectId: 'editionAwareness',
            attributes: analyticsAttributes
        });
    }, [
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    const isAdsVariation = (0, $1PteH.isEligibleForAlignEditionButtonAds)(context) && getExperimentValue({
        statsigParams: {
            experimentName: 'align_edition_button_ads',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled',
            options: {
                fireExperimentExposure: true
            }
        },
        trackEventParameters: {
            trackEventGrowthInitiative: 'tako'
        }
    }) === 'variation';
    const Button = isAdsVariation ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $59epF.EditionAwarenessButtonAds), {
        ref: ref,
        buttonContent: buttonContent,
        onClick: handleOnClick,
        analyticsAttributes: analyticsAttributes,
        onMouseEnter: handleOnMouseEnter
    }) : hasCustomTheme ? // When there's a custom theme applied we just return a button which gets styled by the theme
    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8a8ab.Button), {
        ...rest,
        ref: ref,
        onClick: handleOnClick,
        onMouseEnter: handleOnMouseEnter,
        iconBefore: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)($4a78ee6e3fa4b6d2$var$Icon, {
                appearance: appearance,
                icon: icon,
                color: "currentColor"
            }),
        children: [
            text,
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1jN5w.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    }) : /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $6mEZn.default), {
        ...rest,
        ref: ref,
        xcss: (0, $1MNmN.cx)($4a78ee6e3fa4b6d2$var$styles.button, (0, $egspI.fg)('platform-dst-shape-theme-default') && $4a78ee6e3fa4b6d2$var$styles.buttonT26Shape, appearance === 'default' && $4a78ee6e3fa4b6d2$var$styles.default, appearance === 'warning' && $4a78ee6e3fa4b6d2$var$styles.warning, appearance === 'danger' && $4a78ee6e3fa4b6d2$var$styles.danger, isDismissible && $4a78ee6e3fa4b6d2$var$styles.dismissible),
        onClick: handleOnClick,
        onMouseEnter: handleOnMouseEnter,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $4a78ee6e3fa4b6d2$var$styles.icon,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)($4a78ee6e3fa4b6d2$var$Icon, {
                    appearance: appearance,
                    icon: icon
                })
            }),
            text,
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1jN5w.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
    if (isDismissible) return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2XXtG.default), {
        alignItems: "center",
        children: [
            Button,
            /*#__PURE__*/ (0, $e79Pd.jsx)($4a78ee6e3fa4b6d2$var$DismissMenu, {})
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        id: "edition-awareness-button",
        children: Button
    });
});
const $4a78ee6e3fa4b6d2$export$1bf8122badfd728c = /*#__PURE__*/ (0, $euxye.forwardRef)(function({ onClick: onClick, href: href, touchpointIntent: touchpointIntent, linkId: linkId, ...rest }, ref) {
    const buttonContent = (0, $67dVX.useButtonContent)();
    const context = (0, $kXxEy.useEditionAwareness)();
    const { getExperimentValue: getExperimentValue } = (0, $cLUxG.useGetExperimentValue)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, badge: badge, appearance: appearance = 'default' } = buttonContent;
    const hasCustomTheme = (0, $d7tnL.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $lmRlQ.useAnalytics)();
    const { origin: origin, url: tracedUrl } = (0, $aEAis.useTracedUrl)(href);
    if (!tracedUrl) throw new Error('The link url is undefined, please check the context');
    const analyticsAttributes = (0, $euxye.useMemo)(()=>({
            type: 'link',
            icon: icon,
            badge: badge,
            appearance: appearance,
            touchpointIntent: touchpointIntent,
            linkId: linkId,
            ...origin.toAnalyticsAttributes()
        }), [
        icon,
        badge,
        appearance,
        touchpointIntent,
        linkId,
        origin
    ]);
    const handleOnClick = (0, $euxye.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    const handleOnMouseEnter = (0, $euxye.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'hovered',
            actionSubject: 'button',
            actionSubjectId: 'editionAwareness',
            attributes: analyticsAttributes
        });
    }, [
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    const isAdsVariation = (0, $1PteH.isEligibleForAlignEditionButtonAds)(context) && getExperimentValue({
        statsigParams: {
            experimentName: 'align_edition_button_ads',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled',
            options: {
                fireExperimentExposure: true
            }
        },
        trackEventParameters: {
            trackEventGrowthInitiative: 'tako'
        }
    }) === 'variation';
    if (isAdsVariation) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $im846.EditionAwarenessButtonLinkAds), {
        buttonContent: buttonContent,
        href: tracedUrl,
        onClick: handleOnClick,
        analyticsAttributes: analyticsAttributes,
        onMouseEnter: handleOnMouseEnter
    });
    if (hasCustomTheme) {
        // When there's a custom theme applied we just return a button which gets styled by the theme
        const topNavLinkButton = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $eoGQo.LinkButton), {
            ...rest,
            href: tracedUrl,
            ref: ref,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            iconBefore: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)($4a78ee6e3fa4b6d2$var$Icon, {
                    appearance: appearance,
                    icon: icon,
                    color: "currentColor"
                }),
            children: [
                text,
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1jN5w.UiViewedEvent), {
                    actionSubjectId: "editionAwareness",
                    actionSubject: "button",
                    attributes: analyticsAttributes
                })
            ]
        });
        return topNavLinkButton;
    }
    const anchor = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $9MWap.default), {
        ...rest,
        href: tracedUrl,
        ref: ref,
        xcss: (0, $1MNmN.cx)($4a78ee6e3fa4b6d2$var$styles.button, (0, $egspI.fg)('platform-dst-shape-theme-default') && $4a78ee6e3fa4b6d2$var$styles.buttonT26Shape, appearance === 'default' && $4a78ee6e3fa4b6d2$var$styles.default, appearance === 'warning' && $4a78ee6e3fa4b6d2$var$styles.warning, appearance === 'danger' && $4a78ee6e3fa4b6d2$var$styles.danger),
        onClick: handleOnClick,
        onMouseEnter: handleOnMouseEnter,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $4a78ee6e3fa4b6d2$var$styles.icon,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)($4a78ee6e3fa4b6d2$var$Icon, {
                    appearance: appearance,
                    icon: icon
                })
            }),
            text,
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1jN5w.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
    return anchor;
});
const $4a78ee6e3fa4b6d2$var$capitalizeName = (name)=>name.split(' ').map((word)=>{
        return word[0].toUpperCase() + word.substring(1);
    }).join(' ');
function $4a78ee6e3fa4b6d2$var$DismissMenu() {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const fireDismissMenuEvent = (0, $cbW2j.useOnClickDismissMenu)();
    const { product: product, edition: edition, onDismissButton: onDismissButton } = (0, $kXxEy.useEditionAwareness)();
    const hasCustomTheme = (0, $d7tnL.useHasCustomTheme)();
    const trialOfferingName = (0, $crSbr.getTrialOfferingName)(product, edition);
    const handleOnEvents = (0, $euxye.useCallback)((e)=>{
        if (e.type === 'DISMISS_SUCCEEDED' && onDismissButton) {
            onDismissButton();
            fireDismissMenuEvent('dismiss');
        }
        if (e.type === 'AD_CONTROL_DROP_DOWN_MENU_OPENED') fireDismissMenuEvent('openMenu');
        if (e.type === 'REASONS_BUTTON_CLICKED') fireDismissMenuEvent('learnMore');
    }, [
        onDismissButton,
        fireDismissMenuEvent
    ]);
    const dismissMenuAriaLabel = formatMessage({
        id: '@atlassian/edition-awareness.edition-awareness-dismiss-button.menu-aria',
        defaultMessage: 'More',
        description: 'The aria label for the dismiss menu, indicating to the user that there are further actions available.'
    });
    const getAdControlsTrigger = (0, $euxye.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ triggerRef: triggerRef, ...props })=>{
        return hasCustomTheme ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fX8LH.IconButton), {
            ...props,
            ref: triggerRef,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Fzpe))),
            "aria-label": dismissMenuAriaLabel
        }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
            ...props,
            ref: triggerRef,
            xcss: (0, $1MNmN.cx)($4a78ee6e3fa4b6d2$var$styles.dismissMenu, (0, $egspI.fg)('platform-dst-shape-theme-default') && $4a78ee6e3fa4b6d2$var$styles.dismissMenuT26Shape),
            "aria-label": dismissMenuAriaLabel,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7Fzpe))), {
                label: "",
                spacing: "none",
                color: "var(--ds-icon-subtlest, #6B6E76)"
            })
        });
    }, [
        hasCustomTheme,
        dismissMenuAriaLabel
    ]);
    const offering = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8Sdzy.default), {
        weight: "bold",
        children: [
            $4a78ee6e3fa4b6d2$var$capitalizeName(product.replace(/-/g, ' ')),
            " ",
            $4a78ee6e3fa4b6d2$var$capitalizeName(trialOfferingName)
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7luds.default), {
        onEvents: (e)=>handleOnEvents(e),
        shouldShowDismissFlag: false,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eMhe9.default), {
            itemId: "default-item",
            trigger: getAdControlsTrigger,
            children: (props)=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cU4dJ.default), {
                            ...props,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.dismiss",
                                defaultMessage: "Dismiss",
                                description: "An action for the user to permanently dismiss this button to prevent it from appearing again"
                            })
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3qx2a.default), {
                            ...props,
                            modalProps: {
                                body: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
                                    space: "space.150",
                                    children: [
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.why-am-i-seeing-this",
                                                defaultMessage: "We think {offering} will improve your team's productivity. This recommendation is only shown to billing admins and is based on:",
                                                description: "A message that informs the user why they are seeing the current plan recommendation for their current product",
                                                values: {
                                                    offering: offering
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
                                            as: "ul",
                                            xcss: $4a78ee6e3fa4b6d2$var$styles.reasonsUl,
                                            children: [
                                                /*#__PURE__*/ (0, $e79Pd.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                        id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-1",
                                                        defaultMessage: "the size of your team",
                                                        description: "A reason why the user is seeing the current plan recommendation"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $e79Pd.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                        id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-2",
                                                        defaultMessage: "your existing Atlassian products",
                                                        description: "A reason why the user is seeing the current plan recommendation"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hzWaA.default), {
                                                appearance: "default",
                                                href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                                target: "_blank",
                                                onClick: ()=>fireDismissMenuEvent('clickLink'),
                                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                                    id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.data-privacy.link",
                                                    defaultMessage: "Learn more about your data privacy with Atlassian",
                                                    description: "Link to Atlassian data privacy page"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }
                        })
                    ]
                })
        })
    });
}
$4a78ee6e3fa4b6d2$var$DismissMenu.displayName = "DismissMenu";

});
parcelRegister("eMhe9", function(module, exports) {
$parcel$export(module.exports, "default", () => $57824684befe892c$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jaPl6 = parcelRequire("jaPl6");
var $2Xkyn = parcelRequire("2Xkyn");


var $7YEva = parcelRequire("7YEva");

var $3VbRg = parcelRequire("3VbRg");
const $57824684befe892c$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsDropdown'
};
const $57824684befe892c$var$AdControlDropdownMenu = ({ children: children, itemId: itemId, onOpenChange: onOpenChange = ()=>{}, ...rest })=>{
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $7YEva.default)();
    const { createEventDispatcher: createEventDispatcher } = (0, $3VbRg.useAdControlProvider)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jaPl6.default), {
        ...rest,
        onOpenChange: (onOpenChangeArgs)=>{
            eventDispatcher.dispatch(onOpenChangeArgs.isOpen ? (0, $89f94d9a31406c96$export$17ff257e1f6e39f5) : (0, $89f94d9a31406c96$export$7fc09cf740f33ed4), createInteractedUIEvent($57824684befe892c$var$interactedUIEventAction));
            onOpenChange(onOpenChangeArgs);
        },
        shouldFitContainer: false,
        shouldRenderToParent: true,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2Xkyn.default), {
            children: typeof children === 'function' ? children({
                itemId: itemId
            }) : children
        })
    });
};
$57824684befe892c$var$AdControlDropdownMenu.displayName = "AdControlDropdownMenu";
var $57824684befe892c$export$2e2bcd8739ae039 = $57824684befe892c$var$AdControlDropdownMenu;

});
// ACT Event types
// AdControlDropdownMenu
const $89f94d9a31406c96$export$17ff257e1f6e39f5 = 'AD_CONTROL_DROP_DOWN_MENU_OPENED';
const $89f94d9a31406c96$export$7fc09cf740f33ed4 = 'AD_CONTROL_DROP_DOWN_MENU_CLOSED';
const $89f94d9a31406c96$export$e33200507ac1d20a = 'DISMISS_STARTED';
const $89f94d9a31406c96$export$103f41d1f3bf374e = 'DISMISS_SUCCEEDED';
const $89f94d9a31406c96$export$6d3088110036f124 = 'DISMISS_FAILED';
const $89f94d9a31406c96$export$5595c6967e83d351 = 'REASONS_BUTTON_CLICKED';
const $89f94d9a31406c96$export$ff50ad60f08a4bc0 = 'REASONS_MODAL_SHOWN';
const $89f94d9a31406c96$export$6bd2d8eacca15ce1 = 'REASONS_MODAL_DISMISSED';
const $89f94d9a31406c96$export$5c5fc6956b7600ea = 'FLAG_DISMISSED';

parcelRegister("7YEva", function(module, exports) {
$parcel$export(module.exports, "default", () => $e39a04dabf85c75e$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");


var $inMxE = parcelRequire("inMxE");
function $e39a04dabf85c75e$export$2e2bcd8739ae039() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const createInteractedUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback((action)=>createAnalyticsEvent({
            eventType: (0, $6d4033511f75ada1$export$a1562d08625f5d7e),
            ...action
        }), [
        createAnalyticsEvent
    ]);
    const createScreenUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback((name)=>createAnalyticsEvent({
            eventType: (0, $6d4033511f75ada1$export$f1d537d508d2945a),
            name: name
        }), [
        createAnalyticsEvent
    ]);
    return {
        createInteractedUIEvent: createInteractedUIEvent,
        createScreenUIEvent: createScreenUIEvent
    };
}

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $6d4033511f75ada1$export$a1562d08625f5d7e = 'ui';
const $6d4033511f75ada1$export$947dac6c72b26f81 = 'track';
const $6d4033511f75ada1$export$f1d537d508d2945a = 'screen';
const $6d4033511f75ada1$export$12346a674644c156 = 'operational';
const $6d4033511f75ada1$export$b055de0e665cb20c = 'unknown';


parcelRegister("3VbRg", function(module, exports) {
$parcel$export(module.exports, "useAdControlProvider", () => $c220ac074ce882d7$export$450072b04d50916);

var $euxye = parcelRequire("euxye");


var $95VQq = parcelRequire("95VQq");

var $jYAKG = parcelRequire("jYAKG");
function $c220ac074ce882d7$export$450072b04d50916() {
    const { state: state, modalPropsRef: modalPropsRef, dispatch: dispatch, onEvents: onEvents, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $jYAKG.useAdControlContext)();
    /**
	 * Add a flag with flagProps to state for the item was dismissed
	 * {@link https://atlassian.design/components/flag/examples}
	 */ const addFlag = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback((itemId, flagProps)=>{
        dispatch({
            type: 'ADD_FLAG',
            payload: {
                itemId: itemId,
                flagProps: flagProps
            }
        });
    }, [
        dispatch
    ]);
    /**
	 * Open a modal and set the modal props reference
	 */ const openModal = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback((modalProps, modalItemId)=>{
        modalPropsRef.current = modalProps;
        dispatch({
            type: 'OPEN_MODAL',
            payload: modalItemId
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * Close a modal and clear the modal props reference
	 */ const closeModal = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback(()=>{
        modalPropsRef.current = undefined;
        dispatch({
            type: 'CLOSE_MODAL'
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * The internal event handler that is used by the ACTEventDispatcher
	 */ const handleOnEvents = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback((event)=>{
        // Handle the events that have side effects on the state.
        switch(event.type){
            case 0, $89f94d9a31406c96$export$5c5fc6956b7600ea:
                dispatch({
                    type: 'REMOVE_FLAG',
                    payload: event.itemId
                });
                break;
        }
        // Call the onEvents handler that is passed from the consumer.
        onEvents(event);
    }, [
        dispatch,
        onEvents
    ]);
    /**
	 * Create an event dispatcher for the given item id
	 */ const createEventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback((itemId)=>{
        return new (0, $95VQq.default)(itemId, handleOnEvents);
    }, [
        handleOnEvents
    ]);
    return {
        state: state,
        openModal: openModal,
        closeModal: closeModal,
        createEventDispatcher: createEventDispatcher,
        addFlag: addFlag,
        shouldShowDismissFlag: shouldShowDismissFlag
    };
}

});
parcelRegister("95VQq", function(module, exports) {
$parcel$export(module.exports, "default", () => $c91ee08cfb23ccea$export$2e2bcd8739ae039);
class $c91ee08cfb23ccea$export$2e2bcd8739ae039 {
    constructor(itemId, handler){
        this.itemId = itemId;
        this.handler = handler;
    }
    dispatch(type, analyticsEvent) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            analyticsEvent: analyticsEvent
        });
    }
    dispatchError(type, error) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            error: error
        });
    }
    _dispatch(event) {
        if (this.handler) this.handler(event);
    }
}

});

parcelRegister("jYAKG", function(module, exports) {
$parcel$export(module.exports, "useAdControlContext", () => $8d6128ba806137ff$export$4e82dc865a56141b);

var $euxye = parcelRequire("euxye");

var $2gle3 = parcelRequire("2gle3");
function $8d6128ba806137ff$export$4e82dc865a56141b() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useContext((0, $2gle3.AdControlContext));
}

});
parcelRegister("2gle3", function(module, exports) {
$parcel$export(module.exports, "AdControlContext", () => $cd2b14e5f8e93be9$export$554b2f9bd0a293df);

var $euxye = parcelRequire("euxye");

var $apEOH = parcelRequire("apEOH");
const $cd2b14e5f8e93be9$export$554b2f9bd0a293df = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createContext({
    state: {
        ...(0, $apEOH.initialAdControlProviderState)
    },
    modalPropsRef: undefined,
    dispatch: ()=>{},
    onEvents: ()=>{},
    shouldShowDismissFlag: true
});

});
parcelRegister("apEOH", function(module, exports) {
$parcel$export(module.exports, "initialAdControlProviderState", () => $cbebd2a6aba9ad2a$export$22776e7a42f7089d);
$parcel$export(module.exports, "adControlProviderReducer", () => $cbebd2a6aba9ad2a$export$5f3557676ca801eb);
const $cbebd2a6aba9ad2a$export$22776e7a42f7089d = {
    flags: new Map()
};
const $cbebd2a6aba9ad2a$export$5f3557676ca801eb = (state, action)=>{
    switch(action.type){
        case 'ADD_FLAG':
            return {
                ...state,
                flags: new Map(state.flags).set(action.payload.itemId, action.payload.flagProps)
            };
        case 'REMOVE_FLAG':
            {
                // Clone the flags map and delete the flag
                const flags = new Map(state.flags);
                flags.delete(action.payload);
                return {
                    ...state,
                    flags: flags
                };
            }
        case 'OPEN_MODAL':
            return {
                ...state,
                modalItemId: action.payload
            };
        case 'CLOSE_MODAL':
            return {
                ...state,
                modalItemId: undefined
            };
        default:
            return state;
    }
};

});





parcelRegister("7luds", function(module, exports) {
$parcel$export(module.exports, "default", () => $019682709d0945df$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2gle3 = parcelRequire("2gle3");

var $apEOH = parcelRequire("apEOH");

var $jz8Yt = parcelRequire("jz8Yt");

var $4Jnau = parcelRequire("4Jnau");

var $1RkLa = parcelRequire("1RkLa");
const $019682709d0945df$var$AdControlProvider = ({ children: children, onEvents: onEvents = ()=>{}, shouldShowDismissFlag: shouldShowDismissFlag = true })=>{
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useReducer((0, $apEOH.adControlProviderReducer), (0, $apEOH.initialAdControlProviderState));
    const modalPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useRef();
    const modalProps = modalPropsRef.current ?? {
        body: '',
        title: '',
        hasCloseButton: true
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jz8Yt.default), {
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2gle3.AdControlContext).Provider, {
            value: {
                state: state,
                modalPropsRef: modalPropsRef,
                dispatch: dispatch,
                onEvents: onEvents,
                shouldShowDismissFlag: shouldShowDismissFlag
            },
            children: [
                children,
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1RkLa.default), {
                    itemId: state.modalItemId,
                    ...modalProps
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4Jnau.default), {})
            ]
        })
    });
};
$019682709d0945df$var$AdControlProvider.displayName = "AdControlProvider";
var $019682709d0945df$export$2e2bcd8739ae039 = $019682709d0945df$var$AdControlProvider;

});
parcelRegister("jz8Yt", function(module, exports) {
$parcel$export(module.exports, "default", () => $db650dac20826bf3$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $2UWAE = parcelRequire("2UWAE");

var $2oKqK = parcelRequire("2oKqK");

var $aRuQ6 = parcelRequire("aRuQ6");
const $db650dac20826bf3$var$ActIntlProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2UWAE.default), {
        defaultMessages: (0, $aRuQ6.default),
        loaderFn: (0, $2oKqK.fetchMessagesForLocale),
        children: children
    });
};
$db650dac20826bf3$var$ActIntlProvider.displayName = "ActIntlProvider";
var $db650dac20826bf3$export$2e2bcd8739ae039 = $db650dac20826bf3$var$ActIntlProvider;

});
parcelRegister("2oKqK", function(module, exports) {
$parcel$export(module.exports, "fetchMessagesForLocale", () => $8be095e175c3d52d$export$2b153a2030b0feb2);

var $27I2i = parcelRequire("27I2i");

var $aRuQ6 = parcelRequire("aRuQ6");
const $8be095e175c3d52d$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $8be095e175c3d52d$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const targetLocale = ($8be095e175c3d52d$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $27I2i.locales)) {
            const messages = await (0, $27I2i.locales)[targetLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $27I2i.locales)) {
            const messages = await (0, $27I2i.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
	 * English bundled by default as this is the majority of users
	 */ return 0, $aRuQ6.default;
};

});
parcelRegister("27I2i", function(module, exports) {
$parcel$export(module.exports, "locales", () => $d196c41820a1af4d$export$df1c34db1371eeed);


























const $d196c41820a1af4d$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("c4CVF")),
    da: ()=>(parcelRequire("gVz1v")),
    de: ()=>(parcelRequire("jqGwQ")),
    en_GB: ()=>(parcelRequire("dyBuh")),
    en_ZZ: ()=>(parcelRequire("an9nS")),
    en: ()=>Promise.resolve((parcelRequire("aRuQ6"))),
    es: ()=>(parcelRequire("bxPVM")),
    fi: ()=>(parcelRequire("8zX3V")),
    fr: ()=>(parcelRequire("lcOeU")),
    hu: ()=>(parcelRequire("dQRut")),
    it: ()=>(parcelRequire("bfhXN")),
    ja: ()=>(parcelRequire("lopla")),
    ko: ()=>(parcelRequire("cgGRF")),
    nb: ()=>(parcelRequire("c1TuQ")),
    nl: ()=>(parcelRequire("4e88n")),
    pl: ()=>(parcelRequire("fLDbo")),
    pt_BR: ()=>(parcelRequire("gEn2x")),
    ru: ()=>(parcelRequire("fPuvB")),
    sv: ()=>(parcelRequire("8RM6h")),
    th: ()=>(parcelRequire("iMAUo")),
    tr: ()=>(parcelRequire("gXfhR")),
    uk: ()=>(parcelRequire("9br4G")),
    vi: ()=>(parcelRequire("cSKqT")),
    zh_TW: ()=>(parcelRequire("avHn6")),
    zh: ()=>(parcelRequire("3oukG"))
};

});
parcelRegister("c4CVF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7DcTU").then(()=>parcelRequire('fIgOK'));

});
parcelRegister("4cvLQ", function(module, exports) {
"use strict";

function $30f0ed6275c09e08$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("96thM")).resolve(id));
}
module.exports = $30f0ed6275c09e08$var$load;

});
parcelRegister("96thM", function(module, exports) {
$parcel$export(module.exports, "register", () => $6a0b641ff72a0641$export$6503ec6e8aabbaf, (v) => $6a0b641ff72a0641$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $6a0b641ff72a0641$export$f7ad0328861e2f03, (v) => $6a0b641ff72a0641$export$f7ad0328861e2f03 = v);
var $6a0b641ff72a0641$export$6503ec6e8aabbaf;
var $6a0b641ff72a0641$export$f7ad0328861e2f03;
"use strict";
var $6a0b641ff72a0641$var$mapping = new Map();
function $6a0b641ff72a0641$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$6a0b641ff72a0641$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $6a0b641ff72a0641$var$resolve(id) {
    var resolved = $6a0b641ff72a0641$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$6a0b641ff72a0641$export$6503ec6e8aabbaf = $6a0b641ff72a0641$var$register;
$6a0b641ff72a0641$export$f7ad0328861e2f03 = $6a0b641ff72a0641$var$resolve;

});



parcelRegister("gVz1v", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ega8v").then(()=>parcelRequire('bmY0V'));

});

parcelRegister("jqGwQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("igbCy").then(()=>parcelRequire('eyLPr'));

});

parcelRegister("dyBuh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("62bLU").then(()=>parcelRequire('izXLJ'));

});

parcelRegister("an9nS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iSheO").then(()=>parcelRequire('1wmNq'));

});

parcelRegister("bxPVM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2Y0QC").then(()=>parcelRequire('7EQNk'));

});

parcelRegister("8zX3V", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aRAeO").then(()=>parcelRequire('3NChz'));

});

parcelRegister("lcOeU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kUwFD").then(()=>parcelRequire('lnldJ'));

});

parcelRegister("dQRut", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("e6YOv").then(()=>parcelRequire('7ich4'));

});

parcelRegister("bfhXN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hCnPD").then(()=>parcelRequire('8RufT'));

});

parcelRegister("lopla", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d18My").then(()=>parcelRequire('3l1RN'));

});

parcelRegister("cgGRF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7zQ9M").then(()=>parcelRequire('iP38n'));

});

parcelRegister("c1TuQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k1x5T").then(()=>parcelRequire('5NV7M'));

});

parcelRegister("4e88n", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9uA68").then(()=>parcelRequire('4zyjz'));

});

parcelRegister("fLDbo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ki5TA").then(()=>parcelRequire('l1GIy'));

});

parcelRegister("gEn2x", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9qBnd").then(()=>parcelRequire('52Rkm'));

});

parcelRegister("fPuvB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("enKpg").then(()=>parcelRequire('bFGpT'));

});

parcelRegister("8RM6h", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eV7yL").then(()=>parcelRequire('cdwHY'));

});

parcelRegister("iMAUo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("akN4j").then(()=>parcelRequire('5mZy8'));

});

parcelRegister("gXfhR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dO665").then(()=>parcelRequire('3Jhto'));

});

parcelRegister("9br4G", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5rsAN").then(()=>parcelRequire('4e2Kx'));

});

parcelRegister("cSKqT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iyDGC").then(()=>parcelRequire('ldEXb'));

});

parcelRegister("avHn6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6s0Z3").then(()=>parcelRequire('bxeP7'));

});

parcelRegister("3oukG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4zXlJ").then(()=>parcelRequire('hlDRH'));

});




parcelRegister("4Jnau", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b35dd98ba1c3c9c$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $63XI1 = parcelRequire("63XI1");
var $8RTvC = parcelRequire("8RTvC");

var $kJKna = parcelRequire("kJKna");

var $ihEDU = parcelRequire("ihEDU");


var $7YEva = parcelRequire("7YEva");

var $3VbRg = parcelRequire("3VbRg");

var $gBqFn = parcelRequire("gBqFn");

var $jDK8h = parcelRequire("jDK8h");
const $7b35dd98ba1c3c9c$var$ACT_FLAG_WRAPPER = 'act-flag-wrapper';
const $7b35dd98ba1c3c9c$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsFlagClose'
};
const $7b35dd98ba1c3c9c$var$DismissalFlagGroup = ()=>{
    (0, $jDK8h.overridePortalIndex)($7b35dd98ba1c3c9c$var$ACT_FLAG_WRAPPER);
    const { state: { flags: flags }, createEventDispatcher: createEventDispatcher } = (0, $3VbRg.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $7YEva.default)();
    const handleOnDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback((id)=>{
        createEventDispatcher(id).dispatch((0, $89f94d9a31406c96$export$5c5fc6956b7600ea), createInteractedUIEvent($7b35dd98ba1c3c9c$var$interactedUIEventAction));
    }, [
        createEventDispatcher,
        createInteractedUIEvent
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8RTvC.default), {
        onDismissed: handleOnDismissed,
        children: Array.from(flags.entries()).map(([itemId, { actions: actions = [], ...flagProps } = {
            actions: []
        }], i)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                id: $7b35dd98ba1c3c9c$var$ACT_FLAG_WRAPPER,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $63XI1.default), {
                    id: itemId,
                    testId: `act-flag-${itemId}`,
                    icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kJKna))), {
                        label: "Success",
                        spacing: "spacious",
                        color: "var(--ds-icon-success, #6A9A23)"
                    }),
                    title: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                        ...(0, $gBqFn.messages).notInterestedFlag
                    }),
                    description: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                        ...(0, $gBqFn.messages).dismissalMessage
                    }),
                    ...flagProps,
                    actions: actions.map((action)=>({
                            ...action,
                            onClick: (e)=>{
                                action.onClick?.(e, ()=>handleOnDismissed(itemId));
                            }
                        }))
                })
            }, i))
    });
};
$7b35dd98ba1c3c9c$var$DismissalFlagGroup.displayName = "DismissalFlagGroup";
var $7b35dd98ba1c3c9c$export$2e2bcd8739ae039 = $7b35dd98ba1c3c9c$var$DismissalFlagGroup;

});
parcelRegister("gBqFn", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b6251903464fc308$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $b6251903464fc308$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    notInterested: {
        id: 'act.action.notInterested.button.text',
        defaultMessage: 'Not interested',
        description: 'The text of a button to indicate the users can dismiss the current component'
    },
    notInterestedFlag: {
        id: 'act.action.notInterestedFlag.flag.text',
        defaultMessage: 'Got it, thanks for letting us know',
        description: 'A message that informs the users the dismissal action is taken'
    },
    showReasons: {
        id: 'act.action.showReasons.common.text',
        defaultMessage: 'Why am I seeing this?',
        description: "The text of a button to indicate the users can click and see the reasons for a component's appearance"
    },
    dismissalMessage: {
        id: 'act.action.dismissalMessage.common.text',
        defaultMessage: "You won\u2019t see this here as often.",
        description: 'A message that informs the users the dismissal action is taken'
    },
    reasonsModalOkButton: {
        id: 'act.action.reasonsModalOkButton.common.text',
        defaultMessage: 'OK',
        description: 'The text of a button to indicate the users can dismiss the current modal'
    }
});

});

parcelRegister("jDK8h", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PORTAL_OVERRIDE_INDEX", () => $097ca657d2f377e9$export$335243096683aa37);
$parcel$export(module.exports, "overridePortalIndex", () => $097ca657d2f377e9$export$61df98316049b30);
const $097ca657d2f377e9$export$335243096683aa37 = 900;
function $097ca657d2f377e9$export$61df98316049b30(elementId, index = $097ca657d2f377e9$export$335243096683aa37) {
    setTimeout(()=>{
        if (typeof document !== 'undefined') {
            const parentPortal = $097ca657d2f377e9$export$148feac3be949786(document.getElementById(elementId), '.atlaskit-portal');
            if (parentPortal) parentPortal.setAttribute('style', `z-index:${index};`);
        }
    }, 0);
}
function $097ca657d2f377e9$var$collectionHas(all, curr) {
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
}
function $097ca657d2f377e9$export$148feac3be949786(elm, selector) {
    let all = document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$097ca657d2f377e9$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
}

});


parcelRegister("1RkLa", function(module, exports) {
$parcel$export(module.exports, "default", () => $67f6d73c6f646ade$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $iOfms = parcelRequire("iOfms");

var $7tY81 = parcelRequire("7tY81");
var $2v3yi = parcelRequire("2v3yi");
var $4vluQ = parcelRequire("4vluQ");
var $gpyJM = parcelRequire("gpyJM");
var $dNPnD = parcelRequire("dNPnD");
var $9imxF = parcelRequire("9imxF");

var $ihEDU = parcelRequire("ihEDU");


var $7YEva = parcelRequire("7YEva");

var $3VbRg = parcelRequire("3VbRg");

var $gBqFn = parcelRequire("gBqFn");

var $jDK8h = parcelRequire("jDK8h");
const $67f6d73c6f646ade$var$adControlScreenName = 'adControlsReasonsModal';
const $67f6d73c6f646ade$var$ACT_MODAL_CONTENT = 'ACT_MODAL_CONTENT';
const $67f6d73c6f646ade$var$ReasonsModal = ({ body: body, itemId: itemId, title: title, zIndexOverride: zIndexOverride = (0, $jDK8h.DEFAULT_PORTAL_OVERRIDE_INDEX), hasCloseButton: hasCloseButton = true, ...props })=>{
    const { closeModal: closeModal, createEventDispatcher: createEventDispatcher } = (0, $3VbRg.useAdControlProvider)();
    const { createScreenUIEvent: createScreenUIEvent } = (0, $7YEva.default)();
    const isMounted = (0, $euxye.useRef)(false);
    const eventDispatcherRef = (0, $euxye.useRef)();
    eventDispatcherRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>itemId !== undefined ? createEventDispatcher(itemId) : eventDispatcherRef.current, [
        createEventDispatcher,
        itemId
    ]);
    const isOpen = itemId !== undefined;
    (0, $euxye.useEffect)(()=>{
        const eventDispatcher = eventDispatcherRef.current;
        if (!eventDispatcher) return;
        if (isOpen) eventDispatcher.dispatch((0, $89f94d9a31406c96$export$ff50ad60f08a4bc0), createScreenUIEvent($67f6d73c6f646ade$var$adControlScreenName));
        else if (isMounted.current && !isOpen) eventDispatcher.dispatch((0, $89f94d9a31406c96$export$6bd2d8eacca15ce1), createScreenUIEvent($67f6d73c6f646ade$var$adControlScreenName));
    }, [
        createScreenUIEvent,
        isOpen
    ]);
    (0, $euxye.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    if (isOpen && zIndexOverride) (0, $jDK8h.overridePortalIndex)($67f6d73c6f646ade$var$ACT_MODAL_CONTENT, zIndexOverride);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9imxF.default), {
        children: isOpen && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7tY81.default), {
            shouldCloseOnEscapePress: true,
            onClose: closeModal,
            ...props,
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
                id: $67f6d73c6f646ade$var$ACT_MODAL_CONTENT,
                children: [
                    title !== null && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gpyJM.default), {
                        hasCloseButton: hasCloseButton,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dNPnD.default), {
                            children: title ?? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                ...(0, $gBqFn.messages).showReasons
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2v3yi.default), {
                        children: body
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4vluQ.default), {
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iOfms.default), {
                            appearance: "primary",
                            onClick: closeModal,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
                                ...(0, $gBqFn.messages).reasonsModalOkButton
                            })
                        })
                    })
                ]
            })
        })
    });
};
$67f6d73c6f646ade$var$ReasonsModal.displayName = "ReasonsModal";
var $67f6d73c6f646ade$export$2e2bcd8739ae039 = $67f6d73c6f646ade$var$ReasonsModal;

});


parcelRegister("cU4dJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b5b6ada9398c1ef$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $2YPKP = parcelRequire("2YPKP");


var $7YEva = parcelRequire("7YEva");

var $3VbRg = parcelRequire("3VbRg");

var $gBqFn = parcelRequire("gBqFn");
const $3b5b6ada9398c1ef$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'notInterested'
};
const $3b5b6ada9398c1ef$var$DismissalButton = ({ itemId: itemId, onClick: onClick, children: children, flagProps: flagProps, ...props })=>{
    const { addFlag: addFlag, createEventDispatcher: createEventDispatcher, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $3VbRg.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $7YEva.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback(async (e)=>{
        eventDispatcher.dispatch((0, $89f94d9a31406c96$export$e33200507ac1d20a), createInteractedUIEvent($3b5b6ada9398c1ef$var$interactedUIEventAction));
        shouldShowDismissFlag && addFlag(itemId, flagProps);
        try {
            await onClick?.(e, itemId);
            eventDispatcher.dispatch((0, $89f94d9a31406c96$export$103f41d1f3bf374e));
        } catch (e) {
            eventDispatcher.dispatchError((0, $89f94d9a31406c96$export$6d3088110036f124), e);
        }
    }, [
        addFlag,
        createInteractedUIEvent,
        eventDispatcher,
        flagProps,
        itemId,
        onClick,
        shouldShowDismissFlag
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2YPKP.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            ...(0, $gBqFn.messages).notInterested
        })
    });
};
$3b5b6ada9398c1ef$var$DismissalButton.displayName = "DismissalButton";
var $3b5b6ada9398c1ef$export$2e2bcd8739ae039 = $3b5b6ada9398c1ef$var$DismissalButton;

});

parcelRegister("3qx2a", function(module, exports) {
$parcel$export(module.exports, "default", () => $23ceb84067b94f3d$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $2YPKP = parcelRequire("2YPKP");


var $7YEva = parcelRequire("7YEva");

var $3VbRg = parcelRequire("3VbRg");

var $gBqFn = parcelRequire("gBqFn");
const $23ceb84067b94f3d$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsReasons'
};
const $23ceb84067b94f3d$var$ReasonsButton = ({ children: children, itemId: itemId, modalProps: modalProps, onClick: onClick, ...props })=>{
    const { createEventDispatcher: createEventDispatcher, openModal: openModal } = (0, $3VbRg.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $7YEva.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback((e)=>{
        eventDispatcher.dispatch((0, $89f94d9a31406c96$export$5595c6967e83d351), createInteractedUIEvent($23ceb84067b94f3d$var$interactedUIEventAction));
        openModal(modalProps, itemId);
        onClick?.(e, itemId);
    }, [
        createInteractedUIEvent,
        eventDispatcher,
        itemId,
        modalProps,
        onClick,
        openModal
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2YPKP.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
            ...(0, $gBqFn.messages).showReasons
        })
    });
};
$23ceb84067b94f3d$var$ReasonsButton.displayName = "ReasonsButton";
var $23ceb84067b94f3d$export$2e2bcd8739ae039 = $23ceb84067b94f3d$var$ReasonsButton;

});

parcelRegister("1jN5w", function(module, exports) {
$parcel$export(module.exports, "UiViewedEvent", () => $d054550893d2c722$export$d0a9edec5c713764);

var $euxye = parcelRequire("euxye");

var $lmRlQ = parcelRequire("lmRlQ");
function $d054550893d2c722$export$d0a9edec5c713764({ actionSubjectId: actionSubjectId, actionSubject: actionSubject, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $lmRlQ.useAnalytics)();
    const hasSent = (0, $euxye.useRef)(false);
    (0, $euxye.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        actionSubject,
        actionSubjectId,
        attributes
    ]);
    return null;
}
$d054550893d2c722$export$d0a9edec5c713764.displayName = "UiViewedEvent";

});

parcelRegister("cbW2j", function(module, exports) {
$parcel$export(module.exports, "useOnClickDismissMenu", () => $eb05159875229b29$export$d840cf3018e72a62);

var $euxye = parcelRequire("euxye");

var $lmRlQ = parcelRequire("lmRlQ");
const $eb05159875229b29$export$d840cf3018e72a62 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $lmRlQ.useAnalytics)();
    return (0, $euxye.useCallback)((dismissMenuIntent)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'editionAwarenessDismissMenu',
            attributes: {
                dismissMenuIntent: dismissMenuIntent
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
};

});

parcelRegister("crSbr", function(module, exports) {
$parcel$export(module.exports, "getTrialOfferingName", () => $9c55481aee787543$export$38ffae8c634274ba);

var $egspI = parcelRequire("egspI");
const $9c55481aee787543$export$38ffae8c634274ba = (product, edition)=>{
    if (edition === 'standard') {
        if (product === 'jira' && (0, $egspI.fg)('edition_awareness_upsell_jira_fg')) return 'premium';
        if (product === 'jira-service-management' && (0, $egspI.fg)('edition_awareness_upsell_jsm_fg')) return 'premium';
        if (product === 'confluence' && (0, $egspI.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) return 'premium';
        if (product === 'jira-product-discovery' && (0, $egspI.fg)('upsell_edition_awareness_jpd_fg')) return 'premium';
    }
    return 'standard';
};

});

parcelRegister("1PteH", function(module, exports) {
$parcel$export(module.exports, "isEligibleForAlignEditionButtonAds", () => $7813a1e0c76fb559$export$bd6e32a14dc76096);

var $frC7k = parcelRequire("frC7k");
function $7813a1e0c76fb559$export$bd6e32a14dc76096(context) {
    const { product: product, edition: edition, isInPredunning: isInPredunning, isInTrial: isInTrial } = context;
    return Boolean(edition === 'free' || isInTrial || isInPredunning) && (0, $frC7k.isProductOneOf)(product, [
        'jira',
        'confluence',
        'jira-product-discovery'
    ]);
}

});

parcelRegister("67dVX", function(module, exports) {
$parcel$export(module.exports, "useButtonContent", () => $5a4586a6947b0a75$export$c810aba6284fa97d);

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $egspI = parcelRequire("egspI");

var $jpzat = parcelRequire("jpzat");

var $a9Sta = parcelRequire("a9Sta");

var $kXxEy = parcelRequire("kXxEy");

var $cLUxG = parcelRequire("cLUxG");

var $1PteH = parcelRequire("1PteH");

var $kdy74 = parcelRequire("kdy74");

var $ejHsy = parcelRequire("ejHsy");

var $9H5h5 = parcelRequire("9H5h5");

var $fWaSn = parcelRequire("fWaSn");

var $frC7k = parcelRequire("frC7k");
const $5a4586a6947b0a75$var$buttonMessages = (0, $7eNDO.defineMessages)({
    upgradeText: {
        id: '@atlassian/edition-awareness.button.upgrade',
        defaultMessage: 'Upgrade',
        description: 'Informs the user that they can upgrade their product'
    },
    addPayment: {
        id: '@atlassian/edition-awareness.button.add-payment',
        defaultMessage: 'Add payment',
        description: 'Informs the user that they need to add a payment method'
    },
    tooltipUpgradeYourPlan: {
        id: '@atlassian/edition-awareness.button.tooltip-upgrade-your-plan',
        defaultMessage: 'Upgrade your plan',
        description: 'Informs the user that they can upgrade their app'
    },
    tooltipConfirmYourPlan: {
        id: '@atlassian/edition-awareness.button.tooltip-confirm-your-plan',
        defaultMessage: 'Confirm your plan',
        description: 'Informs the user that they need to confirm whether to keep the plan they are trialling'
    },
    tooltipConfirmAndPay: {
        id: '@atlassian/edition-awareness.button.tooltip-confirm-and-pay',
        defaultMessage: 'Confirm and pay',
        description: 'Informs the user that they need to add payment details for the plan they are trialling'
    },
    tooltipKeepYourPlan: {
        id: '@atlassian/edition-awareness.button.tooltip-keep-your-plan',
        defaultMessage: 'Keep your plan',
        description: 'Informs the user that they need to add payment details to keep the plan they are on'
    },
    premiumTrial: {
        id: '@atlassian/edition-awareness.button.premium-trial',
        defaultMessage: 'Premium trial',
        description: 'Informs the user that they are on a Premium trial'
    },
    standardTrial: {
        id: '@atlassian/edition-awareness.button.standard-trial',
        defaultMessage: 'Standard trial',
        description: 'Informs the user that they are on a Standard trial'
    },
    trialDaysLeft: {
        id: '@atlassian/edition-awareness.button.trial-days-left',
        defaultMessage: '{days}d',
        description: 'Informs the user how many days they have left in trial'
    },
    storageNearLimit: {
        id: '@atlassian/edition-awareness.button.storage-near-limit',
        defaultMessage: 'Near limit',
        description: 'Shown on the edition awareness pill when JSM Free storage usage is approaching the limit (near-limit threshold).'
    }
});
// TODO: `licensedUserLimit` should be fetched from the server
const $5a4586a6947b0a75$var$PRODUCT_LIMITS_MAP = {
    'jira-product-discovery': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    },
    jira: {
        licensedUserLimit: 10,
        warningUserLimit: 7
    },
    confluence: {
        licensedUserLimit: 10,
        warningUserLimit: 3
    },
    'jira-service-management': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    },
    'jira-customer-service': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    }
};
function $5a4586a6947b0a75$var$getFreeContent({ context: context, formatMessage: formatMessage, getExperimentValue: getExperimentValue, isEligibleForAds: isEligibleForAds }) {
    const { licensedUsers: licensedUsers, product: product, automationFreeLimitStatus: automationFreeLimitStatus } = context;
    const limits = $5a4586a6947b0a75$var$PRODUCT_LIMITS_MAP[product];
    const upgradeText = formatMessage($5a4586a6947b0a75$var$buttonMessages.upgradeText);
    if (isEligibleForAds) {
        if (automationFreeLimitStatus) {
            if (automationFreeLimitStatus === 'BREACHED' && getExperimentValue({
                statsigParams: {
                    experimentName: 'twcg-1076_jira_automation_limits_experiment',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled'
                }
            }) === 'variation') return {
                text: upgradeText,
                appearance: 'warning',
                icon: 'warning',
                tooltip: formatMessage({
                    id: '@atlassian/edition-awareness.button.tooltip-automation-limit-reached',
                    defaultMessage: 'Automation limit reached',
                    description: 'Informs the user that they have breached their automation limit'
                })
            };
            if (automationFreeLimitStatus === 'PROJECTED_TO_BREACH' && getExperimentValue({
                statsigParams: {
                    experimentName: 'twcg-1076_jira_automation_limits_experiment',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled'
                }
            }) === 'variation') return {
                text: upgradeText,
                appearance: 'warning',
                icon: 'arrow-up-circle',
                tooltip: formatMessage({
                    id: '@atlassian/edition-awareness.button.tooltip-automation-limit-almost-reached',
                    defaultMessage: 'Automation limit almost reached',
                    description: 'Informs the user that they are about to breach their automation limit'
                })
            };
        }
        if ((0, $a9Sta.isEligibleForStorageHardLimit)(context)) return {
            text: upgradeText,
            appearance: 'warning',
            icon: 'warning',
            tooltip: formatMessage({
                id: '@atlassian/edition-awareness.button.tooltip-storage-limit-reached',
                defaultMessage: 'Storage limit reached',
                description: 'Informs the user that they have breached their storage limit'
            })
        };
        if (licensedUsers >= limits.licensedUserLimit) return {
            text: upgradeText,
            appearance: 'warning',
            icon: 'warning',
            tooltip: formatMessage({
                id: '@atlassian/edition-awareness.button.tooltip-user-limit-reached',
                defaultMessage: '{product, select, jpd {Creator} jsm {Agent} jcs {Agent} other {User}} limit reached',
                description: 'Informs the user that there are no licensed users left and to upgrade their app'
            }, {
                product: (0, $jpzat.getProductForTranslation)(product)
            })
        };
        if (licensedUsers >= limits.warningUserLimit) return {
            text: upgradeText,
            appearance: 'warning',
            icon: 'arrow-up-circle',
            tooltip: formatMessage({
                id: '@atlassian/edition-awareness.button.tooltip-user-limit-almost-reached',
                defaultMessage: '{product, select, jpd {Creator} jsm {Agent} jcs {Agent} other {User}} limit almost reached',
                description: 'Informs the user that there are limited licensed users left before they need to upgrade their app'
            }, {
                product: (0, $jpzat.getProductForTranslation)(product)
            })
        };
        return {
            text: upgradeText,
            appearance: 'discovery',
            icon: 'arrow-up-circle',
            tooltip: formatMessage($5a4586a6947b0a75$var$buttonMessages.tooltipUpgradeYourPlan)
        };
    }
    if (automationFreeLimitStatus) {
        if (automationFreeLimitStatus === 'BREACHED' && getExperimentValue({
            statsigParams: {
                experimentName: 'twcg-1076_jira_automation_limits_experiment',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            }
        }) === 'variation') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.automation-limits-breached',
                defaultMessage: 'Limit reached',
                description: 'Informs the user that they have breached their automation limits'
            }),
            appearance: 'danger',
            icon: 'warning'
        };
        if (automationFreeLimitStatus === 'PROJECTED_TO_BREACH' && getExperimentValue({
            statsigParams: {
                experimentName: 'twcg-1076_jira_automation_limits_experiment',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            }
        }) === 'variation') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.automation-near-limit',
                defaultMessage: 'Near limit',
                description: 'Informs the user that they are about to breach their automation limits'
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    if ((0, $a9Sta.isEligibleForStorageHardLimit)(context) || (0, $9H5h5.isEligibleForJsmStorageOverLimit)(context)) return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.storage-hard-limit',
            defaultMessage: 'Storage full',
            description: 'Shown on the edition awareness pill when storage usage is at or over the limit.'
        }),
        appearance: 'warning',
        icon: 'warning'
    };
    if ((0, $frC7k.isProductOneOf)(product, [
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ])) {
        if (licensedUsers >= limits.licensedUserLimit) return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.no-users-left',
                defaultMessage: 'No {product, select, jpd {creators} jsm {agents} jcs {agents} jira {users} confluence {users} other {users}} left',
                description: 'Informs the user that there are no licensed users left and they may need to upgrade their product'
            }, {
                product: (0, $jpzat.getProductForTranslation)(product)
            }),
            appearance: product !== 'confluence' ? 'danger' : 'warning',
            icon: 'warning'
        };
        if (licensedUsers >= limits.warningUserLimit) return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.limited-users-left',
                defaultMessage: 'Limited {product, select, jpd {creators} jsm {agents} jcs {agents} jira {users} confluence {users} other {users}} left',
                description: 'Informs the user that there are limited licensed users left before they need to upgrade their product'
            }, {
                product: (0, $jpzat.getProductForTranslation)(product)
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    if ((0, $ejHsy.isEligibleForJsmStorageNearLimit)(context)) return {
        text: formatMessage($5a4586a6947b0a75$var$buttonMessages.storageNearLimit),
        appearance: 'warning',
        icon: 'warning'
    };
    if (product === 'confluence' && licensedUsers >= limits.warningUserLimit) return {
        text: upgradeText,
        appearance: 'warning',
        icon: 'warning'
    };
    return {
        text: upgradeText,
        appearance: 'default',
        icon: 'gem'
    };
}
function $5a4586a6947b0a75$var$getTrialContent({ context: context, formatMessage: formatMessage, getExperimentValue: getExperimentValue, isEligibleForAds: isEligibleForAds }) {
    const { product: product, edition: edition, trialDaysLeft: trialDaysLeft, trialLengthDays: trialLengthDays, isInReverseTrial: isInReverseTrial, userRoles: userRoles } = context;
    const isInFirstHalfOfTrial = Boolean(trialDaysLeft && trialLengthDays && trialDaysLeft > Math.ceil(trialLengthDays / 2));
    const addPaymentText = formatMessage($5a4586a6947b0a75$var$buttonMessages.addPayment);
    const confirmYourPlanTooltip = formatMessage($5a4586a6947b0a75$var$buttonMessages.tooltipConfirmYourPlan);
    const confirmAndPayTooltip = formatMessage($5a4586a6947b0a75$var$buttonMessages.tooltipConfirmAndPay);
    const premiumTrialText = formatMessage($5a4586a6947b0a75$var$buttonMessages.premiumTrial);
    const standardTrialText = formatMessage($5a4586a6947b0a75$var$buttonMessages.standardTrial);
    const badge = trialDaysLeft !== undefined ? formatMessage($5a4586a6947b0a75$var$buttonMessages.trialDaysLeft, {
        days: trialDaysLeft
    }) : undefined;
    if (isEligibleForAds) {
        if (isInFirstHalfOfTrial) return {
            text: edition === 'premium' ? premiumTrialText : standardTrialText,
            appearance: 'default',
            icon: undefined,
            tooltip: confirmYourPlanTooltip,
            badge: badge
        };
        if (trialDaysLeft !== undefined && trialDaysLeft <= 3) return {
            text: addPaymentText,
            appearance: 'warning',
            icon: 'credit-card',
            tooltip: confirmAndPayTooltip
        };
        return {
            text: edition === 'premium' ? premiumTrialText : standardTrialText,
            appearance: 'default',
            icon: undefined,
            tooltip: confirmYourPlanTooltip,
            badge: badge
        };
    }
    // Control cohort / not eligible for ads
    let appearance = 'default';
    let icon = 'gem';
    const daysLeftText = formatMessage({
        id: '@atlassian/edition-awareness.button.daysLeft',
        defaultMessage: '{trialDaysLeft, plural, one {# day} other {# days}} left',
        description: 'Informs the user how many days they have left in trial'
    }, {
        trialDaysLeft: trialDaysLeft
    });
    if (edition === 'premium' && product === 'jira' && isInReverseTrial && userRoles?.includes('BILLING_ADMIN')) {
        if (getExperimentValue({
            statsigParams: {
                experimentName: 'jira_reverse_trial_ea_updates_during_trial',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            }
        }) === 'variation') {
            appearance = 'default';
            icon = 'gem';
            if (isInFirstHalfOfTrial) return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.see-plans',
                    defaultMessage: 'See plans',
                    description: 'Informs the user that they are able to see plans'
                }),
                appearance: appearance,
                icon: icon
            };
            if (trialDaysLeft && trialDaysLeft <= 3) {
                appearance = 'warning';
                icon = 'warning';
            }
            return {
                text: daysLeftText,
                appearance: appearance,
                icon: icon
            };
        }
    }
    if ((0, $frC7k.isProductOneOf)(product, [
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ])) {
        // If trial is still in its first half, show trial message instead of trial days left
        if (isInFirstHalfOfTrial) {
            if (edition === 'premium') return {
                text: premiumTrialText,
                appearance: appearance,
                icon: icon
            };
            if (edition === 'standard') return {
                text: standardTrialText,
                appearance: appearance,
                icon: icon
            };
        }
        // If trial has 3 days or less remaining, swap the button to the warning state
        if (trialDaysLeft && trialDaysLeft <= 3) {
            appearance = 'warning';
            icon = 'warning';
        }
        return {
            text: daysLeftText,
            appearance: appearance,
            icon: icon
        };
    }
    if ((0, $kdy74.isEligibleForConfluenceBuyReverseTrialExperiment)(context) && (0, $egspI.fg)('growth_confluence_buy_reverse_trials_fg')) {
        const abCohort = getExperimentValue({
            statsigParams: {
                experimentName: 'growth_confluence_buy_reverse_trials_ab',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'luna',
                trackEventAttributes: {
                    touchpointId: 'use-button-content getTrialContent'
                }
            }
        });
        if (abCohort === 'variation') {
            appearance = 'default';
            icon = 'gem';
            if (trialDaysLeft && trialDaysLeft > 15) return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.see-plans.cbrt',
                    defaultMessage: 'See plans',
                    description: 'Informs the user that they are able to see plans'
                }),
                appearance: appearance,
                icon: icon
            };
            if (trialDaysLeft && trialDaysLeft <= 3) {
                appearance = 'warning';
                icon = 'warning';
            }
            return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.see-plans.cbrt.final',
                    // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
                    defaultMessage: '{trialDaysLeft, plural, =1 {# day} other {# days}} left',
                    description: 'Indicates to the user how many days they have left in trial'
                }, {
                    trialDaysLeft: trialDaysLeft
                }),
                appearance: appearance,
                icon: icon
            };
        }
    }
    return {
        text: daysLeftText,
        appearance: appearance,
        icon: icon
    };
}
function $5a4586a6947b0a75$var$getPredunningContent({ context: context, formatMessage: formatMessage, getExperimentValue: getExperimentValue, isEligibleForAds: isEligibleForAds }) {
    const { edition: edition, product: product, isInReverseTrial: isInReverseTrial, userRoles: userRoles } = context;
    const addPaymentText = formatMessage($5a4586a6947b0a75$var$buttonMessages.addPayment);
    const keepYourPlanTooltip = formatMessage($5a4586a6947b0a75$var$buttonMessages.tooltipKeepYourPlan);
    if (isEligibleForAds) return {
        text: addPaymentText,
        appearance: 'warning',
        icon: 'credit-card',
        tooltip: keepYourPlanTooltip
    };
    // Control cohort / not eligible for ads
    let appearance = 'default';
    let icon = 'credit-card';
    if (product === 'jira' && edition === 'premium' && isInReverseTrial && userRoles?.includes('BILLING_ADMIN')) {
        if (getExperimentValue({
            statsigParams: {
                experimentName: 'jira_reverse_trial_ea_updates_during_trial',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            }
        }) === 'variation') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.choose-plans',
                defaultMessage: 'Choose a plan',
                description: 'Informs the user that they are able to choose a plan'
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    if ((0, $kdy74.isEligibleForConfluenceBuyReverseTrialExperiment)(context) && (0, $egspI.fg)('growth_confluence_buy_reverse_trials_fg')) {
        const abCohort = getExperimentValue({
            statsigParams: {
                experimentName: 'growth_confluence_buy_reverse_trials_ab',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'luna',
                trackEventAttributes: {
                    touchpointId: 'use-button-content getPredunningContent'
                }
            }
        });
        if (abCohort === 'variation') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.see-plans.final',
                defaultMessage: 'Choose a plan',
                description: 'Informs the user that they are able to choose a plan'
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.addPaymentDetails',
            defaultMessage: 'Add payment details',
            description: 'Informs the user how many days they have left in trial'
        }),
        appearance: appearance,
        icon: icon
    };
}
function $5a4586a6947b0a75$var$getCollectionContent({ context: context, formatMessage: formatMessage, isEligibleForAds: isEligibleForAds }) {
    /* ==============================
	// Collection
	// Collection handles its own logic for the button content
	// This is to avoid the button content from being overridden by other products' logic
	// ============================== */ const { isInTrial: isInTrial, trialDaysLeft: trialDaysLeft, isInPredunning: isInPredunning, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, edition: edition } = context;
    const upgradeText = formatMessage($5a4586a6947b0a75$var$buttonMessages.upgradeText);
    const addPaymentText = formatMessage($5a4586a6947b0a75$var$buttonMessages.addPayment);
    const confirmYourPlanTooltip = formatMessage($5a4586a6947b0a75$var$buttonMessages.tooltipConfirmYourPlan);
    const confirmAndPayTooltip = formatMessage($5a4586a6947b0a75$var$buttonMessages.tooltipConfirmAndPay);
    const keepYourPlanTooltip = formatMessage($5a4586a6947b0a75$var$buttonMessages.tooltipKeepYourPlan);
    const premiumTrialText = formatMessage($5a4586a6947b0a75$var$buttonMessages.premiumTrial);
    const standardTrialText = formatMessage($5a4586a6947b0a75$var$buttonMessages.standardTrial);
    if (isEligibleForAds) {
        if (isInTrial) {
            const badge = trialDaysLeft !== undefined ? formatMessage($5a4586a6947b0a75$var$buttonMessages.trialDaysLeft, {
                days: trialDaysLeft
            }) : undefined;
            if (trialDaysLeft !== undefined && trialDaysLeft <= 3 && canAddPaymentDetails) return {
                text: addPaymentText,
                appearance: 'warning',
                icon: 'credit-card',
                tooltip: confirmAndPayTooltip
            };
            return {
                text: edition === 'premium' ? premiumTrialText : standardTrialText,
                appearance: 'default',
                icon: undefined,
                tooltip: confirmYourPlanTooltip,
                badge: badge
            };
        }
        if (isInPredunning && canAddPaymentDetails) return {
            text: addPaymentText,
            appearance: 'warning',
            icon: 'credit-card',
            tooltip: keepYourPlanTooltip
        };
        return {
            text: upgradeText,
            appearance: 'discovery',
            icon: 'arrow-up-circle',
            tooltip: formatMessage($5a4586a6947b0a75$var$buttonMessages.tooltipUpgradeYourPlan)
        };
    }
    // Control cohort / not eligible for ads
    if (isInTrial) {
        let appearance = 'default';
        let icon = 'gem';
        const daysLeftText = formatMessage({
            id: '@atlassian/edition-awareness.button.collection.daysLeft',
            defaultMessage: '{trialDaysLeft, plural, one {# day} other {# days}} left',
            description: 'Informs the user how many days they have left in trial'
        }, {
            trialDaysLeft: trialDaysLeft
        });
        if (trialDaysLeft && trialDaysLeft <= 3) {
            if (invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails) {
                appearance = 'warning';
                icon = 'warning';
            }
        }
        return {
            text: daysLeftText,
            appearance: appearance,
            icon: icon
        };
    }
    if (isInPredunning) {
        if (canAddPaymentDetails && invoiceableStatus === 'NOT_INVOICEABLE') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.collection.addPaymentDetails',
                defaultMessage: 'Add payment details'
            }),
            appearance: 'default',
            icon: 'gem'
        };
    }
    return {
        text: upgradeText,
        appearance: 'default',
        icon: 'gem'
    };
}
function $5a4586a6947b0a75$export$c810aba6284fa97d() {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const context = (0, $kXxEy.useEditionAwareness)();
    const { getExperimentValue: getExperimentValue } = (0, $cLUxG.useGetExperimentValue)();
    const { edition: edition, isInPredunning: isInPredunning, isInTrial: isInTrial, isInCollection: isInCollection, product: product } = context;
    const isEligibleForAds = Boolean((0, $1PteH.isEligibleForAlignEditionButtonAds)(context) && getExperimentValue({
        statsigParams: {
            experimentName: 'align_edition_button_ads',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled',
            options: {
                fireExperimentExposure: false
            }
        }
    }) === 'variation');
    /*
	 * Keep this before the other checks to avoid showing the collection content in the other cases
	 */ if (isInCollection && (0, $frC7k.isProductOneOf)(product, [
        'jira',
        'confluence'
    ])) return $5a4586a6947b0a75$var$getCollectionContent({
        context: context,
        formatMessage: formatMessage,
        isEligibleForAds: isEligibleForAds
    });
    if (edition === 'free') return $5a4586a6947b0a75$var$getFreeContent({
        context: context,
        formatMessage: formatMessage,
        getExperimentValue: getExperimentValue,
        isEligibleForAds: isEligibleForAds
    });
    if (isInTrial) return $5a4586a6947b0a75$var$getTrialContent({
        context: context,
        formatMessage: formatMessage,
        getExperimentValue: getExperimentValue,
        isEligibleForAds: isEligibleForAds
    });
    if (isInPredunning) return $5a4586a6947b0a75$var$getPredunningContent({
        context: context,
        formatMessage: formatMessage,
        getExperimentValue: getExperimentValue,
        isEligibleForAds: isEligibleForAds
    });
    if ((0, $fWaSn.isEligibleForStandardToPremium)(context)) return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.upgrade.standard-to-premium',
            defaultMessage: 'Upgrade',
            description: 'Informs the user that they can upgrade their product'
        }),
        appearance: 'default',
        icon: 'gem',
        isDismissible: true
    };
    return null;
}

});
parcelRegister("jpzat", function(module, exports) {
$parcel$export(module.exports, "getProductForTranslation", () => $b53407b458791127$export$fd45d905638d9909);
const $b53407b458791127$var$PRODUCT_TO_TRANSLATION_KEY = {
    jira: 'jira',
    'jira-service-management': 'jsm',
    'jira-product-discovery': 'jpd',
    'jira-customer-service': 'jcs',
    confluence: 'confluence'
};
function $b53407b458791127$export$fd45d905638d9909(product) {
    return $b53407b458791127$var$PRODUCT_TO_TRANSLATION_KEY[product];
}

});

parcelRegister("fWaSn", function(module, exports) {
$parcel$export(module.exports, "isEligibleForStandardToPremium", () => $54e9c136adeba4d4$export$d58c0da339bf36d9);

var $egspI = parcelRequire("egspI");
function $54e9c136adeba4d4$export$d58c0da339bf36d9({ product: product, edition: edition, userRoles: userRoles, trialOfferingName: trialOfferingName }) {
    if (edition === 'standard' && userRoles?.includes('SITE_ADMIN') && trialOfferingName === 'premium') {
        if (product === 'jira' && (0, $egspI.fg)('edition_awareness_upsell_jira_fg')) return true;
        if (product === 'jira-service-management' && (0, $egspI.fg)('edition_awareness_upsell_jsm_fg')) return true;
        if (product === 'confluence' && (0, $egspI.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) return true;
        if (product === 'jira-product-discovery' && (0, $egspI.fg)('upsell_edition_awareness_jpd_fg')) return true;
    }
    return false;
}

});


parcelRegister("aEAis", function(module, exports) {
$parcel$export(module.exports, "useTracedUrl", () => $97ef179b275cdb22$export$5eea7bde9861e87b);

var $euxye = parcelRequire("euxye");

var $3zT69 = parcelRequire("3zT69");

var $kXxEy = parcelRequire("kXxEy");
const $97ef179b275cdb22$var$PRODUCT_TO_ORIGIN = {
    ['confluence']: 'confluence',
    ['jira']: 'jira',
    ['jira-product-discovery']: 'jira',
    ['jira-service-management']: 'jira',
    ['jira-customer-service']: 'jira'
};
function $97ef179b275cdb22$export$5eea7bde9861e87b(untracedUrl) {
    const { product: product } = (0, $kXxEy.useEditionAwareness)();
    const origin = (0, $euxye.useMemo)(()=>new (0, $3zT69.default)({
            product: $97ef179b275cdb22$var$PRODUCT_TO_ORIGIN[product]
        }), [
        product
    ]);
    const url = (0, $euxye.useMemo)(()=>untracedUrl ? origin.addToUrl(untracedUrl) : undefined, [
        untracedUrl,
        origin
    ]);
    return {
        url: url,
        origin: origin
    };
}

});

parcelRegister("59epF", function(module, exports) {
$parcel$export(module.exports, "EditionAwarenessButtonAds", () => $732472c6b6bde177$export$661d2f06cdb28bff);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $50OIz = parcelRequire("50OIz");

var $htkxY = parcelRequire("htkxY");

var $iOfms = parcelRequire("iOfms");

var $hZDXn = parcelRequire("hZDXn");

var $1jN5w = parcelRequire("1jN5w");

var $1vAAh = parcelRequire("1vAAh");
const $732472c6b6bde177$export$661d2f06cdb28bff = /*#__PURE__*/ (0, $euxye.forwardRef)(function EditionAwarenessButtonAds({ buttonContent: buttonContent, onClick: onClick, analyticsAttributes: analyticsAttributes, onMouseEnter: onMouseEnter }, ref) {
    const { text: text, appearance: appearance = 'default', tooltip: tooltip, icon: icon, badge: badge } = buttonContent;
    const iconElement = (0, $1vAAh.getIconElement)(icon);
    const iconBefore = iconElement ? ()=>iconElement : undefined;
    const iconAfter = badge ? ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $htkxY.default), {
            appearance: "discovery",
            children: badge
        }) : undefined;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        content: tooltip,
        children: (tooltipProps)=>{
            const { ref: tooltipRef, ...restTooltipProps } = tooltipProps;
            return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $iOfms.default), {
                ...restTooltipProps,
                ref: (0, $50OIz.mergeRefs)([
                    tooltipRef,
                    ref
                ]),
                appearance: appearance,
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                iconBefore: iconBefore,
                iconAfter: iconAfter,
                children: [
                    text,
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1jN5w.UiViewedEvent), {
                        actionSubjectId: "editionAwareness",
                        actionSubject: "button",
                        attributes: analyticsAttributes
                    })
                ]
            });
        }
    });
});

});
parcelRegister("1vAAh", function(module, exports) {
$parcel$export(module.exports, "getIconElement", () => $b13b6d9486b3c9c6$export$f6292fcace2a1886);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ibF8a = parcelRequire("ibF8a");

var $gdvYt = parcelRequire("gdvYt");

var $dIQFJ = parcelRequire("dIQFJ");
function $b13b6d9486b3c9c6$export$f6292fcace2a1886(icon) {
    if (icon === 'warning') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gdvYt))), {
        label: ""
    });
    if (icon === 'credit-card') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dIQFJ))), {
        label: ""
    });
    if (icon === 'arrow-up-circle') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ibF8a))), {
        label: ""
    });
    return undefined;
}

});


parcelRegister("im846", function(module, exports) {
$parcel$export(module.exports, "EditionAwarenessButtonLinkAds", () => $e67dfb64b624fa19$export$75e3b3e01cab9feb);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $htkxY = parcelRequire("htkxY");

var $9ufM9 = parcelRequire("9ufM9");

var $hZDXn = parcelRequire("hZDXn");

var $1jN5w = parcelRequire("1jN5w");

var $1vAAh = parcelRequire("1vAAh");
const $e67dfb64b624fa19$export$75e3b3e01cab9feb = /*#__PURE__*/ (0, $euxye.forwardRef)(function EditionAwarenessButtonLinkAds({ buttonContent: buttonContent, href: href, onClick: onClick, analyticsAttributes: analyticsAttributes, onMouseEnter: onMouseEnter }, _ref) {
    const { text: text, appearance: appearance = 'default', tooltip: tooltip, icon: icon, badge: badge } = buttonContent;
    const iconElement = (0, $1vAAh.getIconElement)(icon);
    const iconBefore = iconElement ? ()=>iconElement : undefined;
    const iconAfter = badge ? ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $htkxY.default), {
            appearance: "discovery",
            children: badge
        }) : undefined;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        content: tooltip,
        children: (tooltipProps)=>{
            const { ref: tooltipRef, ...restTooltipProps } = tooltipProps;
            return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $9ufM9.default), {
                ...restTooltipProps,
                ref: tooltipRef,
                href: href,
                target: "_blank",
                appearance: appearance,
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                iconBefore: iconBefore,
                iconAfter: iconAfter,
                children: [
                    text,
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1jN5w.UiViewedEvent), {
                        actionSubjectId: "editionAwareness",
                        actionSubject: "button",
                        attributes: analyticsAttributes
                    })
                ]
            });
        }
    });
});

});


parcelRegister("2cMDS", function(module, exports) {
$parcel$export(module.exports, "AutoOpenModalTrigger", () => $24153357ae098c6a$export$beb58c00994cbd66);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $fsEVO = parcelRequire("fsEVO");

var $kENFC = parcelRequire("kENFC");

var $7tY81 = parcelRequire("7tY81");
var $2v3yi = parcelRequire("2v3yi");
var $4vluQ = parcelRequire("4vluQ");
var $gpyJM = parcelRequire("gpyJM");
var $dNPnD = parcelRequire("dNPnD");

var $3PC9r = parcelRequire("3PC9r");

var $dzfUQ = parcelRequire("dzfUQ");

var $8EpkY = parcelRequire("8EpkY");

var $jp9KZ = parcelRequire("jp9KZ");

var $gAEFP = parcelRequire("gAEFP");

var $cxpqA = parcelRequire("cxpqA");
const $24153357ae098c6a$var$emptyEntryPointParams = {};
const $24153357ae098c6a$var$emptyEntryPointProps = {};
function $24153357ae098c6a$export$beb58c00994cbd66({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, shouldAutoOpen: shouldAutoOpen, preloadOnFocus: preloadOnFocus = false }) {
    const { openModal: openModal } = (0, $euxye.useContext)((0, $jp9KZ.ModalContext));
    const environmentProvider = (0, $cxpqA.useRelayEnvironmentProvider)();
    const { ModalOnError: ModalOnError } = (0, $dzfUQ.useEntryPointConfig)();
    const metricName = (0, $euxye.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $euxye.useCallback)(()=>(0, $n67Vb.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $24153357ae098c6a$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $euxye.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const defaultFallback = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gpyJM.default), {
                        hasCloseButton: true,
                        children: title ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dNPnD.default), {
                            children: title
                        }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3PC9r.default), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kENFC.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2v3yi.default), {
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kENFC.default), {}),
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kENFC.default), {}),
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kENFC.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4vluQ.default), {})
                ]
            });
            const container = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gAEFP.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, $e79Pd.jsx)(ModalOnError, {
                        error: error
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                    closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, $e79Pd.jsx)(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $24153357ae098c6a$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7tY81.default), {
                ...modalProps,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress,
                children: container
            });
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        ModalOnError,
        onError
    ]);
    const triggerRef = (0, $8EpkY.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $fsEVO.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    // -- UNIQUE CODE FOR AUTO LOADING
    const hasRun = (0, $euxye.useRef)(false);
    (0, $euxye.useEffect)(()=>{
        if (!hasRun.current && shouldAutoOpen) {
            hasRun.current = true;
            const reference = load();
            onLoad({
                reference: reference,
                dispose: reference.dispose
            });
        }
    }, [
        shouldAutoOpen,
        load,
        onLoad
    ]);
    // -- UNIQUE CODE FOR AUTO LOADING
    return children({
        ref: mergedRef
    });
}
$24153357ae098c6a$export$beb58c00994cbd66.displayName = "AutoOpenModalTrigger";

});


parcelRegister("68pIr", function(module, exports) {
$parcel$export(module.exports, "default", () => $734112cc409004e3$export$2e2bcd8739ae039);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $734112cc409004e3$var$AutomationLimitsEntryPoint = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("9zA4C")), {
        moduleId: "fda1ad3d",
        priority: "interaction",
        moduleId: 'edition-awareness-automation-free-limit-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});
var $734112cc409004e3$export$2e2bcd8739ae039 = $734112cc409004e3$var$AutomationLimitsEntryPoint;

});
parcelRegister("9zA4C", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("raTYO").then(()=>parcelRequire('dZ0BJ'));

});


parcelRegister("91dyV", function(module, exports) {
$parcel$export(module.exports, "FREE_DIALOG_CONFIG", () => $0fd34569abd21236$export$212eac90358facd0);

var $1hcaR = parcelRequire("1hcaR");
const $0fd34569abd21236$export$212eac90358facd0 = {
    touchpointIntent: 'directBuy',
    dialogId: 'automation-free-limit-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1hcaR.Edition).STANDARD_EDITION
};

});
parcelRegister("1hcaR", function(module, exports) {
$parcel$export(module.exports, "GrowthPillar", () => $3b428f50022dfb32$export$9874ba4d5a9c06c8);
$parcel$export(module.exports, "Edition", () => $3b428f50022dfb32$export$6f4a0f769e61929);
var $3b428f50022dfb32$export$9874ba4d5a9c06c8 = /*#__PURE__*/ function(GrowthPillar) {
    GrowthPillar["FIND"] = "FIND";
    GrowthPillar["BUY"] = "BUY";
    GrowthPillar["USE"] = "USE";
    GrowthPillar["PLATFORM"] = "PLATFORM";
    return GrowthPillar;
}({});
var $3b428f50022dfb32$export$6f4a0f769e61929 = /*#__PURE__*/ function(Edition) {
    Edition["FREE_EDITION"] = "free";
    Edition["STANDARD_EDITION"] = "standard";
    Edition["PREMIUM_EDITION"] = "premium";
    Edition["SELECTION"] = "selection";
    return Edition;
}({});

});



parcelRegister("lbX0f", function(module, exports) {
$parcel$export(module.exports, "CollectionAddPaymentDetailsPopup", () => $36ed63015be59334$export$7c1c66d41188536);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $38yTu = parcelRequire("38yTu");

var $95P85 = parcelRequire("95P85");

var $7eALW = parcelRequire("7eALW");
const $36ed63015be59334$export$7c1c66d41188536 = ()=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $38yTu.PopupEntryPoint), {
        entryPoint: (0, $95P85.entryPoint),
        entryPointProps: {},
        placement: 'bottom-end',
        dialogConfig: (0, $7eALW.DIALOG_CONFIG)
    });
};
$36ed63015be59334$export$7c1c66d41188536.displayName = "CollectionAddPaymentDetailsPopup";

});
parcelRegister("38yTu", function(module, exports) {
$parcel$export(module.exports, "PopupEntryPoint", () => $ae6c2882054d005d$export$e14c42e99b209c4d);
/* popup-entry-point.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hUqPj = parcelRequire("hUqPj");

var $ihEDU = parcelRequire("ihEDU");

var $abhF2 = parcelRequire("abhF2");

var $eUenY = parcelRequire("eUenY");

var $4pi5Q = parcelRequire("4pi5Q");

var $kkhkz = parcelRequire("kkhkz");

var $gWQqC = parcelRequire("gWQqC");

var $eX7RF = parcelRequire("eX7RF");
const $ae6c2882054d005d$var$styles = {
    fallbackBox: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
function $ae6c2882054d005d$export$e14c42e99b209c4d(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4pi5Q.DialogContext).Provider, {
        value: dialogConfig,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hUqPj.default), {
            data: dialogConfig,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)($ae6c2882054d005d$export$dece147acb9eddff, {
                ...rest
            })
        })
    });
}
$ae6c2882054d005d$export$e14c42e99b209c4d.displayName = "PopupEntryPoint";
function $ae6c2882054d005d$export$dece147acb9eddff(props) {
    const { onClose: onClose, ...rest } = props;
    const onError = (0, $kkhkz.useEntrypointErrorAnalytics)();
    const onCloseDialog = (0, $gWQqC.useOnCloseDialog)();
    const onClosePopup = (0, $euxye.useCallback)((event, currentLevel)=>{
        onClose?.(event, currentLevel);
        onCloseDialog();
    }, [
        onClose,
        onCloseDialog
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eUenY.PopupTrigger), {
        ...rest,
        shouldFitContainer: false,
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $eX7RF.EditionAwarenessButton), {
                ref: ref
            }),
        fallback: /*#__PURE__*/ (0, $e79Pd.jsx)($ae6c2882054d005d$var$PopupFallback, {}),
        onError: onError,
        onClose: onClosePopup,
        preloadOnFocus: true
    });
}
$ae6c2882054d005d$export$dece147acb9eddff.displayName = "PopupEntryPointInner";
const $ae6c2882054d005d$var$PopupFallback = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: $ae6c2882054d005d$var$styles.fallbackBox,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {})
    });
$ae6c2882054d005d$var$PopupFallback.displayName = "PopupFallback";

});

parcelRegister("95P85", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $e808e30b02ce6919$export$6333901e831d7af0);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $e808e30b02ce6919$export$6333901e831d7af0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("l2Ehy")), {
        moduleId: "732c33d7",
        priority: "interaction",
        moduleId: 'edition-awareness-collection-add-payment-details-popup'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});

});
parcelRegister("l2Ehy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jWRbF").then(()=>parcelRequire('kJY2n'));

});


parcelRegister("7eALW", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $cbb5866aa7b01be3$export$3b6761b6086f6dfd);
const $cbb5866aa7b01be3$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'collection-add-payment-details-popup',
    dialogType: 'pop-up'
};

});


parcelRegister("V15Jq", function(module, exports) {
$parcel$export(module.exports, "CollectionChangePlanPopup", () => $02e3642c1444d845$export$a32dee959fd7bd6e);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $kXxEy = parcelRequire("kXxEy");

var $38yTu = parcelRequire("38yTu");

var $1uceQ = parcelRequire("1uceQ");

var $S62Av = parcelRequire("S62Av");
const $02e3642c1444d845$export$a32dee959fd7bd6e = ()=>{
    const { collectionEntitlementId: collectionEntitlementId } = (0, $kXxEy.useEditionAwareness)();
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            collectionEntitlementId: `ari:cloud:commerce::entitlement/${collectionEntitlementId}`
        }), [
        collectionEntitlementId
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $38yTu.PopupEntryPoint), {
        entryPoint: (0, $1uceQ.entryPoint),
        entryPointParams: entryPointParams,
        placement: 'bottom-end',
        dialogConfig: (0, $S62Av.DIALOG_CONFIG)
    });
};
$02e3642c1444d845$export$a32dee959fd7bd6e.displayName = "CollectionChangePlanPopup";

});
parcelRegister("1uceQ", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $3634ef6af9b8d764$export$6333901e831d7af0);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $fPp2B = parcelRequire("fPp2B");

const $3634ef6af9b8d764$export$6333901e831d7af0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("1vnUE")), {
        moduleId: "47830478",
        priority: "interaction",
        moduleId: 'edition-awareness-collection-change-plan-popup'
    }),
    getPreloadProps: ({ collectionEntitlementId: collectionEntitlementId })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                collectionChangePlanPopupQuery: {
                    parameters: $fPp2B.default,
                    variables: {
                        collectionEntitlementId: collectionEntitlementId
                    }
                }
            }
        })
});

});
parcelRegister("fPp2B", function(module, exports) {
$parcel$export(module.exports, "default", () => $84d50d626529efc4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9bde5f91778d86c0c2aa7edb3623b43a>>
 * @relayHash 78d13f0d1fdc6880857606f82d2074ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 242a677a397113cedf06a1f4ffb86a7bef4bcd0e5d406fa845d786f9871940f0

var $lIGkE = parcelRequire("lIGkE");
const $84d50d626529efc4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "collectionEntitlementId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "collectionEntitlementId"
        }
    ], v2 = {
        "concreteType": "CcpEntitlementExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpManageEntitlementExperienceCapability",
                "kind": "LinkedField",
                "name": "manageEntitlement",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "experienceUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isAvailableToUser"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "collectionChangePlanPopupQuery",
            "selections": [
                {
                    "concreteType": "CcpQueryApi",
                    "kind": "LinkedField",
                    "name": "ccp",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlementV2",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "collectionChangePlanPopupQuery",
            "selections": [
                {
                    "concreteType": "CcpQueryApi",
                    "kind": "LinkedField",
                    "name": "ccp",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlementV2",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "242a677a397113cedf06a1f4ffb86a7bef4bcd0e5d406fa845d786f9871940f0",
            "metadata": {},
            "name": "collectionChangePlanPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$84d50d626529efc4$var$node.hash = "9b656bb88394dc31aa1596f9938d5c9a";
(0, $lIGkE.PreloadableQueryRegistry).set($84d50d626529efc4$var$node.params.id, $84d50d626529efc4$var$node);
var $84d50d626529efc4$export$2e2bcd8739ae039 = $84d50d626529efc4$var$node;

});

parcelRegister("1vnUE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kXha1").then(()=>parcelRequire('5GzCB'));

});


parcelRegister("S62Av", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $b92a471d09b7b111$export$3b6761b6086f6dfd);

var $1hcaR = parcelRequire("1hcaR");
const $b92a471d09b7b111$export$3b6761b6086f6dfd = {
    touchpointIntent: 'changePlan',
    dialogId: 'collection-change-plan-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $1hcaR.Edition).SELECTION
};

});


parcelRegister("6vTjx", function(module, exports) {
$parcel$export(module.exports, "ExploreEditionBenefitsModal", () => $35ce6a97c5a13bbf$export$6d6f5b93e7fec4b2);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $l1YPR = parcelRequire("l1YPR");

var $hRTTI = parcelRequire("hRTTI");

var $2pabT = parcelRequire("2pabT");

var $kXxEy = parcelRequire("kXxEy");

var $fSAGQ = parcelRequire("fSAGQ");

var $dFrMK = parcelRequire("dFrMK");

var $izv1r = parcelRequire("izv1r");
function $35ce6a97c5a13bbf$export$6d6f5b93e7fec4b2() {
    const { product: product, cloudId: cloudId, edition: edition, currentRoute: currentRoute, userEmail: userEmail, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen, lastKnownTrial: lastKnownTrial } = (0, $kXxEy.useEditionAwareness)();
    const isStorageLimitBreached = lastKnownTrial?.trialTrigger === 'AUTO_UPGRADE_STORAGE_LIMIT' && (0, $egspI.fg)('post-trial-modal');
    const variantId = (0, $izv1r.useVariantId)({
        product: product,
        currentRoute: currentRoute,
        isStorageLimitBreached: isStorageLimitBreached
    });
    const initialOpenModal = (0, $euxye.useRef)(shouldAutoOpen);
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            product: product
        }), [
        cloudId,
        product
    ]);
    const entryPointProps = (0, $euxye.useMemo)(()=>({
            variantId: variantId,
            touchpointId: 'edition-awareness-explore-modal',
            edition: edition,
            email: userEmail ?? undefined
        }), [
        edition,
        variantId,
        userEmail
    ]);
    const { fireTrigger: firePopupTrigger } = (0, $2pabT.useFirePostOfficeTrigger)({
        triggerId: 'jsm-edition-awareness-button-popup'
    });
    const { fireTrigger: fireModalTrigger } = (0, $2pabT.useFirePostOfficeTrigger)({
        triggerId: 'edition-benefits-modal'
    });
    // Clear the query param once we've consumed it, so re-mounts don't re-open
    (0, $euxye.useEffect)(()=>{
        if (shouldAutoOpen) onAutoOpen?.();
    }, [
        shouldAutoOpen,
        onAutoOpen
    ]);
    (0, $euxye.useEffect)(()=>{
        if (initialOpenModal.current) fireModalTrigger({
            isActive: true
        });
        else firePopupTrigger({
            isActive: true
        });
        return ()=>{
            firePopupTrigger({
                isActive: false
            });
            fireModalTrigger({
                isActive: false
            });
        };
    }, [
        firePopupTrigger,
        fireModalTrigger
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fSAGQ.ModalEntryPoint), {
        entryPoint: (0, $hRTTI.editionBenefitsModalEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        dialogConfig: (0, $dFrMK.DIALOG_CONFIG),
        modalProps: (0, $l1YPR.MODAL_CONFIG)
    });
}
$35ce6a97c5a13bbf$export$6d6f5b93e7fec4b2.displayName = "ExploreEditionBenefitsModal";

});
parcelRegister("l1YPR", function(module, exports) {
$parcel$export(module.exports, "MODAL_CONFIG", () => $3176313e7dc4054a$export$310af821ace1b0a4);
$parcel$export(module.exports, "SERVICE_COLLECTION_PRICING_PAGE_URL", () => $3176313e7dc4054a$export$73d1ac3f0d282717);
$parcel$export(module.exports, "ADMIN_BILLING_PATH", () => $3176313e7dc4054a$export$fe159292463016ac);
$parcel$export(module.exports, "JSM_STORAGE_MANAGEMENT_PATH", () => $3176313e7dc4054a$export$2ef4407f4b54d009);
$parcel$export(module.exports, "CSM_STORAGE_MANAGEMENT_PATH", () => $3176313e7dc4054a$export$1f6e874869664558);
$parcel$export(module.exports, "CANCEL_SUBSCRIPTION_SAC_URL", () => $3176313e7dc4054a$export$5911f793141d3670);
$parcel$export(module.exports, "JSM_PRICING_PAGE_URL", () => $3176313e7dc4054a$export$f3616073c30968f9);
$parcel$export(module.exports, "INCIDENTS_SLACK_INTEGRATION_VIDEO_URL", () => $3176313e7dc4054a$export$6a49267b3da8f732);
$parcel$export(module.exports, "SUPPORT_COMPANION_AGENT_ID", () => $3176313e7dc4054a$export$920cf1ad9b0dbb52);
const $3176313e7dc4054a$export$310af821ace1b0a4 = {
    width: 'x-large',
    shouldScrollInViewport: true
};
const $3176313e7dc4054a$export$73d1ac3f0d282717 = 'https://www.atlassian.com/collections/service/pricing';
const $3176313e7dc4054a$export$fe159292463016ac = '/admin/billing';
const $3176313e7dc4054a$export$2ef4407f4b54d009 = '/jira/settings/products/jira-service-management-storage-management';
const $3176313e7dc4054a$export$1f6e874869664558 = '/jira/settings/products/customerservice/storage-management';
const $3176313e7dc4054a$export$5911f793141d3670 = 'https://support.atlassian.com/subscriptions-and-billing/docs/cancel-a-subscription/';
const $3176313e7dc4054a$export$f3616073c30968f9 = 'http://www.atlassian.com/software/jira/service-management/product-pricing';
const $3176313e7dc4054a$export$6a49267b3da8f732 = `https://www.youtube.com/embed/cljyGRFV2fo?rel=0&modestbranding=1`;
const $3176313e7dc4054a$export$920cf1ad9b0dbb52 = '0ce0f1da-1c46-4bff-9a32-d1128cfbca68';

});

parcelRegister("hRTTI", function(module, exports) {
$parcel$export(module.exports, "editionBenefitsModalEntryPoint", () => $7683202af892370f$export$4708c4eaa8d901cd);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $fm4YO = parcelRequire("fm4YO");

var $lSem5 = parcelRequire("lSem5");

var $jV9r0 = parcelRequire("jV9r0");

const $7683202af892370f$export$4708c4eaa8d901cd = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("cdb5f")), {
        moduleId: "f335c645",
        priority: "interaction",
        moduleId: 'edition-benefits-modal-relay'
    }),
    getPreloadProps: ({ cloudId: cloudId, product: product })=>({
            queries: {
                editionBenefitsModalRelayQuery: {
                    parameters: (0, $jV9r0.default),
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: (0, $fm4YO.getHamsKey)(product),
                        projectType: (0, $lSem5.getProjectType)(product)
                    }
                }
            },
            extraProps: {
                cloudId: cloudId,
                product: product
            }
        })
});

});
parcelRegister("fm4YO", function(module, exports) {
$parcel$export(module.exports, "getHamsKey", () => $58d4a94eda9aa745$export$291d012eb0744b34);
const $58d4a94eda9aa745$var$ProductKeyToHAMSMap = {
    ['jira']: 'jira-software',
    ['jira-service-management']: 'jira-servicedesk',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['confluence']: 'confluence',
    ['jira-customer-service']: 'jira-customer-service'
};
const $58d4a94eda9aa745$export$291d012eb0744b34 = (product)=>{
    return $58d4a94eda9aa745$var$ProductKeyToHAMSMap[product];
};

});

parcelRegister("lSem5", function(module, exports) {
$parcel$export(module.exports, "getProjectType", () => $dfec73fdc6ffd001$export$3dd0da95519c1a33);
const $dfec73fdc6ffd001$export$3dd0da95519c1a33 = (product)=>{
    switch(product){
        case 'jira-service-management':
            return 'SERVICE_DESK';
        case 'jira-customer-service':
            return 'CUSTOMER_SERVICE';
        case 'jira':
            return 'SOFTWARE';
        case 'jira-product-discovery':
            return 'PRODUCT_DISCOVERY';
        case 'confluence':
            throw new Error('Confluence is not supported');
        default:
            throw new Error('Product not supported');
    }
};

});

parcelRegister("jV9r0", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba3f94c3e2f17f59$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74a53ad6421f1c8d7280d9877d928236>>
 * @relayHash ef1111bd15d10eaaab0f3bd5698ebf18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12af83d9dec697d2b286a6fc415281377a8f74d26d8aff5a0c9d7d5938b7d228

var $lIGkE = parcelRequire("lIGkE");
const $ba3f94c3e2f17f59$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectType"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "cloudUrl"
    }, v3 = {
        "args": [
            {
                "kind": "Literal",
                "name": "product",
                "value": "jira"
            }
        ],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "active"
            }
        ],
        "storageKey": "activationIdByProduct(product:\"jira\")"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "concreteType": "CcpEntitlementExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "offeringName",
                        "value": "Premium"
                    }
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": [
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isAvailableToUser"
                    }
                ],
                "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
            },
            {
                "alias": "changeToStandard",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "offeringName",
                        "value": "Standard"
                    }
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": v7 /*: any*/ ,
                "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
            }
        ]
    }, v9 = [
        {
            "kind": "Literal",
            "name": "relationshipTypes",
            "value": "COLLECTION"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v11 = {
        "concreteType": "CcpBillingPeriodDetails",
        "kind": "LinkedField",
        "name": "billingPeriodDetails",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "nextBillingTimestamp"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v13 = {
        "concreteType": "CcpInvoiceGroupExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpConfigurePaymentMethodExperienceCapability",
                "kind": "LinkedField",
                "name": "configurePaymentV2",
                "plural": false,
                "selections": v7 /*: any*/ 
            }
        ]
    }, v14 = {
        "concreteType": "CcpSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "concreteType": "CcpAccountDetails",
                "kind": "LinkedField",
                "name": "accountDetails",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "CcpInvoiceGroup",
                        "kind": "LinkedField",
                        "name": "invoiceGroup",
                        "plural": false,
                        "selections": [
                            v12 /*: any*/ ,
                            v13 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v16 = {
        "concreteType": "CcpTransactionAccountExperienceCapabilities",
        "kind": "LinkedField",
        "name": "experienceCapabilities",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpAddPaymentMethodExperienceCapability",
                "kind": "LinkedField",
                "name": "addPaymentMethodV2",
                "plural": false,
                "selections": v7 /*: any*/ 
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "key"
    }, v18 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v19 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "name"
    }, v23 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v25 = {
        "concreteType": "CcpSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "concreteType": "CcpAccountDetails",
                "kind": "LinkedField",
                "name": "accountDetails",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "CcpInvoiceGroup",
                        "kind": "LinkedField",
                        "name": "invoiceGroup",
                        "plural": false,
                        "selections": [
                            v12 /*: any*/ ,
                            v13 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ]
            },
            v20 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "editionBenefitsModalRelayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "CcpEntitlementRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "CcpEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlement",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CcpTransactionAccount",
                                                                    "kind": "LinkedField",
                                                                    "name": "transactionAccount",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                                                },
                                                v14 /*: any*/ ,
                                                {
                                                    "concreteType": "CcpTransactionAccount",
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v19 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "editionBenefitsModalRelayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v24 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "CcpEntitlementRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "relatesFromEntitlements",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "CcpEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlement",
                                                            "plural": false,
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CcpTransactionAccount",
                                                                    "kind": "LinkedField",
                                                                    "name": "transactionAccount",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                                                },
                                                v25 /*: any*/ ,
                                                {
                                                    "concreteType": "CcpTransactionAccount",
                                                    "kind": "LinkedField",
                                                    "name": "transactionAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                },
                                                v20 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v19 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "12af83d9dec697d2b286a6fc415281377a8f74d26d8aff5a0c9d7d5938b7d228",
            "metadata": {},
            "name": "editionBenefitsModalRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ba3f94c3e2f17f59$var$node.hash = "4adcf3c0d1fd080dc809373daae7326c";
(0, $lIGkE.PreloadableQueryRegistry).set($ba3f94c3e2f17f59$var$node.params.id, $ba3f94c3e2f17f59$var$node);
var $ba3f94c3e2f17f59$export$2e2bcd8739ae039 = $ba3f94c3e2f17f59$var$node;

});

parcelRegister("cdb5f", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8KqOk").then(()=>parcelRequire('hK4Jn'));

});


parcelRegister("2pabT", function(module, exports) {
$parcel$export(module.exports, "TriggerContextProvider", () => $de43a22731c97f4d$export$e80a5720bb4c8fe3);
$parcel$export(module.exports, "useTrigger", () => $de43a22731c97f4d$export$3b196fe93a948c18);
$parcel$export(module.exports, "useFirePostOfficeTrigger", () => $de43a22731c97f4d$export$83b33e5fe4cce64);
$parcel$export(module.exports, "usePostOfficeExernalMessageProxy", () => $de43a22731c97f4d$export$e45375ff75169f);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $de43a22731c97f4d$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $de43a22731c97f4d$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $de43a22731c97f4d$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createContext($de43a22731c97f4d$var$initialActiveTriggerState);
const $de43a22731c97f4d$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createContext($de43a22731c97f4d$var$initialTriggerDispatchState);
const $de43a22731c97f4d$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $euxye.useState)({});
    const setTriggerState = (0, $euxye.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $euxye.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $euxye.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($de43a22731c97f4d$var$TriggerContext.Provider, {
        value: triggerContextValue,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($de43a22731c97f4d$var$TriggerDispatchContext.Provider, {
            value: triggerContexDispatchValue,
            children: children
        })
    });
};
$de43a22731c97f4d$export$e80a5720bb4c8fe3.displayName = "TriggerContextProvider";
const $de43a22731c97f4d$export$454c1d7c35958f5e = ()=>(0, $euxye.useContext)($de43a22731c97f4d$var$TriggerContext);
const $de43a22731c97f4d$export$23cbf084e08bdb93 = ()=>(0, $euxye.useContext)($de43a22731c97f4d$var$TriggerDispatchContext);
const $de43a22731c97f4d$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $de43a22731c97f4d$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $de43a22731c97f4d$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $de43a22731c97f4d$export$23cbf084e08bdb93();
    const fireTrigger = (0, $euxye.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $de43a22731c97f4d$export$e45375ff75169f = (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $de43a22731c97f4d$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $de43a22731c97f4d$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $de43a22731c97f4d$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $de43a22731c97f4d$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $euxye.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $euxye.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $euxye.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};

});

parcelRegister("dFrMK", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $ffeec2e1196d08ea$export$3b6761b6086f6dfd);

var $1hcaR = parcelRequire("1hcaR");
const $ffeec2e1196d08ea$export$3b6761b6086f6dfd = {
    touchpointIntent: 'onboarding',
    dialogId: 'explore-edition-benefits-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1hcaR.Edition).STANDARD_EDITION
};

});

parcelRegister("izv1r", function(module, exports) {
$parcel$export(module.exports, "useVariantId", () => $317dbf49dba7ee98$export$1916128b8004cf87);
const $317dbf49dba7ee98$export$1916128b8004cf87 = ({ product: product, currentRoute: currentRoute, isStorageLimitBreached: isStorageLimitBreached })=>{
    if (currentRoute === 'ops') return 'standard-rovo-service-agents-ops-team';
    // When storage limit is breached, show storage-specific variants
    if (isStorageLimitBreached) switch(product){
        case 'jira-customer-service':
            return 'standard-storage-limits-csm-teams';
        case 'jira-service-management':
            return 'standard-storage-limits-jsm-teams';
        default:
            return 'standard-storage-limits-jsm-teams';
    }
    switch(product){
        case 'jira-customer-service':
            return 'standard-rovo-service-agents-csm-teams';
        case 'jira-service-management':
            return 'standard-rovo-service-agents-service-teams';
        default:
            return 'standard-rovo-service-agents-service-teams';
    }
};

});


parcelRegister("iWrzG", function(module, exports) {
$parcel$export(module.exports, "FreeToStandardModal", () => $fe0189ec643c1290$export$61689b501c3b79e6);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $kXxEy = parcelRequire("kXxEy");

var $42S0C = parcelRequire("42S0C");

var $ibXvy = parcelRequire("ibXvy");

var $fSAGQ = parcelRequire("fSAGQ");

var $b19I5 = parcelRequire("b19I5");

var $l052u = parcelRequire("l052u");
function $fe0189ec643c1290$export$61689b501c3b79e6() {
    const { product: product, cloudId: cloudId } = (0, $kXxEy.useEditionAwareness)();
    const jiraApplicationKey = (0, $42S0C.getJiraApplicationKey)(product);
    const projectType = (0, $ibXvy.getJiraProjectTypeKey)(product);
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            // Fallback to any valid value since this means that we're not using jira
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            // Fallback to any valid value since this means that we're not using jira
            projectType: projectType ?? 'SOFTWARE',
            isJira: product === 'jira' || product === 'jira-product-discovery' || product === 'jira-service-management',
            isConfluence: product === 'confluence'
        }), [
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const modalProps = (0, $euxye.useMemo)(()=>({
            width: 'x-large'
        }), []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fSAGQ.ModalEntryPoint), {
        entryPoint: (0, $l052u.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $b19I5.DIALOG_CONFIG)
    });
}
$fe0189ec643c1290$export$61689b501c3b79e6.displayName = "FreeToStandardModal";

});
parcelRegister("ibXvy", function(module, exports) {
$parcel$export(module.exports, "getJiraProjectTypeKey", () => $de085a11d4ff01c6$export$600268f282087736);
// We're explicitly excluding 'confluence' from this mapping as it's handled separately
const $de085a11d4ff01c6$var$PRODUCT_TO_JIRA_PROJECT_TYPE_KEY = {
    ['jira']: 'SOFTWARE',
    ['jira-product-discovery']: 'PRODUCT_DISCOVERY',
    ['jira-service-management']: 'SERVICE_DESK'
};
const $de085a11d4ff01c6$export$600268f282087736 = (product)=>{
    return $de085a11d4ff01c6$var$PRODUCT_TO_JIRA_PROJECT_TYPE_KEY[product];
};

});

parcelRegister("b19I5", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $610fa50a55f49f34$export$3b6761b6086f6dfd);

var $1hcaR = parcelRequire("1hcaR");
const $610fa50a55f49f34$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'free-to-standard-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1hcaR.Edition).STANDARD_EDITION
};

});

parcelRegister("l052u", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $a42887aea51c5335$export$6333901e831d7af0);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $c8hw7 = parcelRequire("c8hw7");

const $a42887aea51c5335$export$6333901e831d7af0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("5DQXJ")), {
        moduleId: "afc4323d",
        priority: "interaction",
        moduleId: 'edition-awareness-free-to-standard-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, projectType: projectType, jiraApplicationKey: jiraApplicationKey, isJira: isJira, isConfluence: isConfluence })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                freeToStandardModalQuery: {
                    parameters: $c8hw7.default,
                    variables: {
                        cloudId: cloudId,
                        jiraApplicationKey: jiraApplicationKey,
                        projectType: projectType,
                        isJira: isJira,
                        isConfluence: isConfluence
                    }
                }
            }
        })
});

});
parcelRegister("c8hw7", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f23f0dfe0b5a371$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0b99291f3c462c78adcc986455d12823>>
 * @relayHash 2dc5fffea1e06720964a2adc7bac87eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77fcab85a142bf2728ff9042ba4156fa8e5810a1ffdedc068e9d3b2ea62d87ff

var $lIGkE = parcelRequire("lIGkE");
const $8f23f0dfe0b5a371$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfluence"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJira"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraApplicationKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "condition": "isConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v5 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "cql",
                        "value": "type=user"
                    },
                    {
                        "kind": "Literal",
                        "name": "excludeServiceAppUsers",
                        "value": true
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "confluence_searchUser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponse",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluencePerson",
                                "kind": "LinkedField",
                                "name": "confluencePerson",
                                "plural": false,
                                "selections": [
                                    v6 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    {
                                        "concreteType": "Icon",
                                        "kind": "LinkedField",
                                        "name": "profilePicture",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "path"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isUnlimited"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesLimit"
                    }
                ]
            }
        ]
    }, v8 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v5 /*: any*/ 
    ], v9 = {
        "args": v8 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageAllowed"
    }, v10 = {
        "args": v8 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageUsed"
    }, v11 = {
        "args": v8 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageIsUnlimited"
    }, v12 = [
        v5 /*: any*/ ,
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v13 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "freeToStandardModalQuery",
            "selections": [
                v7 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v13 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v6 /*: any*/ ,
                                                                                v14 /*: any*/ ,
                                                                                v15 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "freeToStandardModalQuery",
            "selections": [
                v7 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v13 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "__typename"
                                                                                },
                                                                                v6 /*: any*/ ,
                                                                                v14 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v16 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        },
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "77fcab85a142bf2728ff9042ba4156fa8e5810a1ffdedc068e9d3b2ea62d87ff",
            "metadata": {},
            "name": "freeToStandardModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8f23f0dfe0b5a371$var$node.hash = "095e0f852e7df475f790e417235d477a";
(0, $lIGkE.PreloadableQueryRegistry).set($8f23f0dfe0b5a371$var$node.params.id, $8f23f0dfe0b5a371$var$node);
var $8f23f0dfe0b5a371$export$2e2bcd8739ae039 = $8f23f0dfe0b5a371$var$node;

});

parcelRegister("5DQXJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4F5Ly").then(()=>parcelRequire('cCbtd'));

});



parcelRegister("2ce7f", function(module, exports) {
$parcel$export(module.exports, "PaymentDetailsPopup", () => $f6c6f08c6e869bf9$export$7d88b723086482e8);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $kXxEy = parcelRequire("kXxEy");

var $38yTu = parcelRequire("38yTu");

var $gAvhp = parcelRequire("gAvhp");

var $aNg8s = parcelRequire("aNg8s");
function $f6c6f08c6e869bf9$export$7d88b723086482e8() {
    const { edition: edition } = (0, $kXxEy.useEditionAwareness)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $38yTu.PopupEntryPoint), {
        entryPoint: (0, $aNg8s.entryPoint),
        placement: 'bottom-end',
        dialogConfig: edition === 'standard' ? (0, $gAvhp.STANDARD_DIALOG_CONFIG) : (0, $gAvhp.PREMIUM_DIALOG_CONFIG)
    });
}
$f6c6f08c6e869bf9$export$7d88b723086482e8.displayName = "PaymentDetailsPopup";

});
parcelRegister("gAvhp", function(module, exports) {
$parcel$export(module.exports, "PREMIUM_DIALOG_CONFIG", () => $d5e4ae41725bb9be$export$1a0ae553b5d69abc);
$parcel$export(module.exports, "STANDARD_DIALOG_CONFIG", () => $d5e4ae41725bb9be$export$e42f11d536a45036);

var $1hcaR = parcelRequire("1hcaR");
const $d5e4ae41725bb9be$export$1a0ae553b5d69abc = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'payment-details-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $1hcaR.Edition).PREMIUM_EDITION
};
const $d5e4ae41725bb9be$export$e42f11d536a45036 = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'payment-details-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $1hcaR.Edition).STANDARD_EDITION
};

});

parcelRegister("aNg8s", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $16f7be64097a39e5$export$6333901e831d7af0);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $16f7be64097a39e5$export$6333901e831d7af0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("erIeu")), {
        moduleId: "43cb1037",
        priority: "interaction",
        moduleId: 'edition-awareness-payment-details-popup'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});

});
parcelRegister("erIeu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("172Aw").then(()=>parcelRequire('i085u'));

});



parcelRegister("ecvmR", function(module, exports) {
$parcel$export(module.exports, "PlanSelectionPageModal", () => $650159564ea21215$export$d906ffa5ff65562d);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $kXxEy = parcelRequire("kXxEy");

var $6KMGi = parcelRequire("6KMGi");

var $fSAGQ = parcelRequire("fSAGQ");

var $44mXY = parcelRequire("44mXY");

var $83XQ4 = parcelRequire("83XQ4");
const $650159564ea21215$var$TWC_MODAL_CONFIG_DEFAULT = {
    width: '1116px',
    height: '733px'
};
const $650159564ea21215$var$REVERSE_TRIAL_MODAL_CONFIG = {
    width: '968px',
    height: '740px'
};
const $650159564ea21215$var$getModalConfig = (type)=>{
    if (type === 'reverse-trial') return $650159564ea21215$var$REVERSE_TRIAL_MODAL_CONFIG;
    return $650159564ea21215$var$TWC_MODAL_CONFIG_DEFAULT;
};
function $650159564ea21215$export$d906ffa5ff65562d({ type: type }) {
    const { cloudId: cloudId, product: product } = (0, $kXxEy.useEditionAwareness)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { width: width, height: height } = (0, $euxye.useMemo)(()=>$650159564ea21215$var$getModalConfig(type), [
        type
    ]);
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $6KMGi.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const entryPointProps = (0, $euxye.useMemo)(()=>({
            type: type
        }), [
        type
    ]);
    const modalProps = (0, $euxye.useMemo)(()=>({
            width: width,
            height: height,
            shouldScrollInViewport: false,
            shouldCloseOnEscape: true,
            label: formatMessage({
                id: '@atlassian/edition-awareness.dialog.plan-selection-page.title',
                defaultMessage: 'Plan selection',
                description: 'Accessible name for the plan selection dialog, announced to assistive technology users.'
            })
        }), [
        width,
        height,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fSAGQ.ModalEntryPoint), {
        entryPointProps: entryPointProps,
        entryPoint: (0, $83XQ4.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $44mXY.DIALOG_CONFIG)
    });
}
$650159564ea21215$export$d906ffa5ff65562d.displayName = "PlanSelectionPageModal";

});
parcelRegister("44mXY", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $566204688846e32d$export$3b6761b6086f6dfd);

var $1hcaR = parcelRequire("1hcaR");
const $566204688846e32d$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'plan-selection-page-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1hcaR.Edition).SELECTION
};

});

parcelRegister("83XQ4", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $ceda312e2499079e$export$6333901e831d7af0);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $9dVBA = parcelRequire("9dVBA");

const $ceda312e2499079e$export$6333901e831d7af0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("bHyYT")), {
        moduleId: "d069ac51",
        priority: "interaction",
        moduleId: 'edition-awareness-plan-selection-page-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                planSelectionPageModalQuery: {
                    parameters: $9dVBA.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("9dVBA", function(module, exports) {
$parcel$export(module.exports, "default", () => $498c3e9d45fd684f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dc4078df9b1f0390bfc835f2aa813816>>
 * @relayHash f8efbc82dcbdf8e7ea9e842b687fdc1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 139c0d7db1e5c65a657e8eba68202a4fd9b24e66331526d96b03609175ad4f45

var $lIGkE = parcelRequire("lIGkE");
const $498c3e9d45fd684f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "planSelectionPageModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "planSelectionPageModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "139c0d7db1e5c65a657e8eba68202a4fd9b24e66331526d96b03609175ad4f45",
            "metadata": {},
            "name": "planSelectionPageModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$498c3e9d45fd684f$var$node.hash = "5856634e7757286e019aec8f127ddc46";
(0, $lIGkE.PreloadableQueryRegistry).set($498c3e9d45fd684f$var$node.params.id, $498c3e9d45fd684f$var$node);
var $498c3e9d45fd684f$export$2e2bcd8739ae039 = $498c3e9d45fd684f$var$node;

});

parcelRegister("bHyYT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cZlM5").then(()=>parcelRequire('3zMtw'));

});



parcelRegister("3WISE", function(module, exports) {
$parcel$export(module.exports, "PremiumAddPaymentModal", () => $d1bee20cff025d4b$export$45cd24e1ba5c2588);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $fSAGQ = parcelRequire("fSAGQ");

var $2udpB = parcelRequire("2udpB");

var $9cWAr = parcelRequire("9cWAr");
function $d1bee20cff025d4b$export$45cd24e1ba5c2588() {
    const modalProps = (0, $euxye.useMemo)(()=>({
            width: 968,
            height: 576
        }), []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fSAGQ.ModalEntryPoint), {
        entryPoint: (0, $9cWAr.entryPoint),
        modalProps: modalProps,
        dialogConfig: (0, $2udpB.DIALOG_CONFIG)
    });
}
$d1bee20cff025d4b$export$45cd24e1ba5c2588.displayName = "PremiumAddPaymentModal";

});
parcelRegister("2udpB", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $a6ef78628a58e20a$export$3b6761b6086f6dfd);

var $1hcaR = parcelRequire("1hcaR");
const $a6ef78628a58e20a$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'premium-add-payment-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1hcaR.Edition).PREMIUM_EDITION
};

});

parcelRegister("9cWAr", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $95174ab2e9b5960f$export$6333901e831d7af0);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $95174ab2e9b5960f$export$6333901e831d7af0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("3JA1b")), {
        moduleId: "f32031a2",
        priority: "interaction",
        moduleId: 'edition-awareness-premium-add-payment-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});

});
parcelRegister("3JA1b", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dYlHC").then(()=>parcelRequire('d77ET'));

});



parcelRegister("jzJLz", function(module, exports) {
$parcel$export(module.exports, "PremiumPopup", () => $d74fe70bb4ddc7de$export$831a974b36144ba6);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $kXxEy = parcelRequire("kXxEy");

var $6KMGi = parcelRequire("6KMGi");

var $38yTu = parcelRequire("38yTu");

var $whSK8 = parcelRequire("whSK8");

var $3gVxP = parcelRequire("3gVxP");

var $5pMcX = parcelRequire("5pMcX");
const $d74fe70bb4ddc7de$export$831a974b36144ba6 = ()=>{
    const { cloudId: cloudId, product: product, PremiumWrapper: PremiumWrapper, trialDaysLeft: trialDaysLeft, userRoles: userRoles, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen, isInTrial: isInTrial, isInReverseTrial: isInReverseTrial } = (0, $kXxEy.useEditionAwareness)();
    const [isPremiumModalOpen, setIsPremiumModalOpen] = (0, $euxye.useState)(false);
    const handleClosePremiumModal = (0, $euxye.useCallback)(()=>setIsPremiumModalOpen(false), []);
    const handleOpenPremiumModal = (0, $euxye.useCallback)(()=>setIsPremiumModalOpen(true), []);
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $6KMGi.getHamsKey)(product)
        }), [
        product,
        cloudId
    ]);
    const entryPointProps = (0, $euxye.useMemo)(()=>({
            handleOpenPremiumModal: handleOpenPremiumModal,
            onClose: handleClosePremiumModal
        }), [
        handleOpenPremiumModal,
        handleClosePremiumModal
    ]);
    const onClose = (0, $euxye.useCallback)(()=>{
        // This will reset the auto open state from product
        onAutoOpen?.();
    }, [
        onAutoOpen
    ]);
    if (!PremiumWrapper) // Shouldn't happen, but if it does then we can at least still show the customer a dialog
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: shouldAutoOpen ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $whSK8.AutoOpenPopupTrigger), {
            entryPoint: (0, $5pMcX.entryPoint),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            placement: 'bottom-end',
            onClose: onClose,
            dialogConfig: (0, $3gVxP.DIALOG_CONFIG)
        }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $38yTu.PopupEntryPoint), {
            entryPoint: (0, $5pMcX.entryPoint),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            placement: 'bottom-end',
            onClose: onClose,
            dialogConfig: (0, $3gVxP.DIALOG_CONFIG)
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)(PremiumWrapper, {
            isInTrial: Boolean(isInTrial),
            isInReverseTrial: Boolean(isInReverseTrial),
            trialDaysLeft: trialDaysLeft,
            isSiteAdmin: !!userRoles?.includes('SITE_ADMIN'),
            isPremiumModalOpen: isPremiumModalOpen,
            onClosePremiumModal: handleClosePremiumModal,
            children: shouldAutoOpen ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $whSK8.AutoOpenPopupTrigger), {
                entryPoint: (0, $5pMcX.entryPoint),
                entryPointParams: entryPointParams,
                entryPointProps: entryPointProps,
                placement: 'bottom-end',
                onClose: onClose,
                dialogConfig: (0, $3gVxP.DIALOG_CONFIG)
            }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $38yTu.PopupEntryPoint), {
                entryPoint: (0, $5pMcX.entryPoint),
                entryPointParams: entryPointParams,
                entryPointProps: entryPointProps,
                placement: 'bottom-end',
                onClose: onClose,
                dialogConfig: (0, $3gVxP.DIALOG_CONFIG)
            })
        })
    });
};
$d74fe70bb4ddc7de$export$831a974b36144ba6.displayName = "PremiumPopup";

});
parcelRegister("whSK8", function(module, exports) {
$parcel$export(module.exports, "AutoOpenPopupTrigger", () => $40bc2afa7eb45713$export$6189e5bf9171fa04);
/* AutoOpenPopupTrigger.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $hUqPj = parcelRequire("hUqPj");

var $1CdDx = parcelRequire("1CdDx");

var $ihEDU = parcelRequire("ihEDU");

var $abhF2 = parcelRequire("abhF2");

var $gAEFP = parcelRequire("gAEFP");

var $cxpqA = parcelRequire("cxpqA");

var $kkhkz = parcelRequire("kkhkz");

var $gWQqC = parcelRequire("gWQqC");

var $eX7RF = parcelRequire("eX7RF");
const $40bc2afa7eb45713$var$styles = {
    fallbackBox: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $40bc2afa7eb45713$var$emptyEntryPointParams = {};
const $40bc2afa7eb45713$var$emptyEntryPointProps = {};
function $40bc2afa7eb45713$export$6189e5bf9171fa04(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hUqPj.default), {
        data: dialogConfig,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($40bc2afa7eb45713$var$AutoOpenPopupTriggerInner, {
            ...rest
        })
    });
}
$40bc2afa7eb45713$export$6189e5bf9171fa04.displayName = "AutoOpenPopupTrigger";
/**
 * THIS IS A TEMPORARY IMPLEMENTATION, WILL BE REMOVED IN THE FUTURE
 * NOT RECOMMENDED FOR USE ANYWHERE ELSE
 * Supports the auto-open functionality for the Confluence Premium Popup
 */ function $40bc2afa7eb45713$var$AutoOpenPopupTriggerInner({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorFallback: errorFallback, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $cxpqA.useRelayEnvironmentProvider)();
    const onError = (0, $kkhkz.useEntrypointErrorAnalytics)();
    const onDismiss = (0, $gWQqC.useOnCloseDialog)();
    const id = (0, $euxye.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const [content, setContent] = (0, $euxye.useState)(null);
    const handleOpen = (0, $euxye.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0, $euxye.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event, currentLevel);
        onDismiss();
    }, [
        onClose,
        onDismiss
    ]);
    const load = (0, $euxye.useCallback)(()=>(0, $n67Vb.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $40bc2afa7eb45713$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $euxye.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        handleOpen();
        setContent(/*#__PURE__*/ (0, $e79Pd.jsx)((0, $gAEFP.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: /*#__PURE__*/ (0, $e79Pd.jsx)($40bc2afa7eb45713$var$PopupFallback, {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $40bc2afa7eb45713$var$emptyEntryPointProps,
            onError: onError
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        errorFallback,
        handleOpen,
        onError
    ]);
    const handleToggleAndLoad = (0, $euxye.useCallback)(()=>{
        if (isOpen) {
            handleClose(null);
            return;
        }
        handleOpen();
        onLoad({
            reference: load()
        });
    }, [
        isOpen,
        handleOpen,
        onLoad,
        load,
        handleClose
    ]);
    const popupTrigger = (0, $euxye.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eX7RF.EditionAwarenessButton), {
            ...triggerProps,
            ref: triggerProps.ref,
            onClick: handleToggleAndLoad
        });
    }, [
        handleToggleAndLoad
    ]);
    const popupContent = (0, $euxye.useCallback)(()=>{
        return content;
    }, [
        content
    ]);
    const hasRun = (0, $euxye.useRef)(false);
    // Auto-open on load
    (0, $euxye.useEffect)(()=>{
        if (!hasRun.current) {
            handleToggleAndLoad?.();
            hasRun.current = true;
        }
    }, [
        handleToggleAndLoad
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1CdDx.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent,
        shouldFitContainer: false
    });
}
$40bc2afa7eb45713$var$AutoOpenPopupTriggerInner.displayName = "AutoOpenPopupTriggerInner";
const $40bc2afa7eb45713$var$PopupFallback = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: $40bc2afa7eb45713$var$styles.fallbackBox,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {})
    });
$40bc2afa7eb45713$var$PopupFallback.displayName = "PopupFallback";

});

parcelRegister("3gVxP", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $c41d1d596be57a7e$export$3b6761b6086f6dfd);

var $1hcaR = parcelRequire("1hcaR");
const $c41d1d596be57a7e$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'premium-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $1hcaR.Edition).PREMIUM_EDITION
};

});

parcelRegister("5pMcX", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $a872d15e4c363749$export$6333901e831d7af0);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $9KiSp = parcelRequire("9KiSp");

const $a872d15e4c363749$export$6333901e831d7af0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("435gJ")), {
        moduleId: "d68a8af6",
        priority: "interaction",
        moduleId: 'edition-awareness-premium-popup'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                confluencePremiumPopupQuery: {
                    parameters: $9KiSp.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("9KiSp", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce94384dc1cd36ec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e8351006f5eb2eddc21a94e6eaea4bad>>
 * @relayHash f5958739e09e5411147f112f6550ea59
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 477817a92613a7818d8c6b7b9c49bbc1517b2ca7a3bc41a318aaf8920c59e4c7

var $lIGkE = parcelRequire("lIGkE");
const $ce94384dc1cd36ec$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "confluencePremiumPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "confluencePremiumPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "477817a92613a7818d8c6b7b9c49bbc1517b2ca7a3bc41a318aaf8920c59e4c7",
            "metadata": {},
            "name": "confluencePremiumPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ce94384dc1cd36ec$var$node.hash = "42c226cd7fc904c05729c90bcaaed23e";
(0, $lIGkE.PreloadableQueryRegistry).set($ce94384dc1cd36ec$var$node.params.id, $ce94384dc1cd36ec$var$node);
var $ce94384dc1cd36ec$export$2e2bcd8739ae039 = $ce94384dc1cd36ec$var$node;

});

parcelRegister("435gJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iDfhj").then(()=>parcelRequire('eIG4F'));

});



parcelRegister("3UcPg", function(module, exports) {
$parcel$export(module.exports, "ReverseTrialPopupDialog", () => $30ace863834db811$export$436172fa0e71e289);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $kXxEy = parcelRequire("kXxEy");

var $6KMGi = parcelRequire("6KMGi");

var $38yTu = parcelRequire("38yTu");

var $awo7M = parcelRequire("awo7M");

var $kirj1 = parcelRequire("kirj1");
function $30ace863834db811$export$436172fa0e71e289() {
    const { product: product, cloudId: cloudId } = (0, $kXxEy.useEditionAwareness)();
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $6KMGi.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $38yTu.PopupEntryPoint), {
        entryPoint: (0, $kirj1.entryPoint),
        entryPointParams: entryPointParams,
        placement: 'bottom-end',
        dialogConfig: (0, $awo7M.DIALOG_CONFIG)
    });
}
$30ace863834db811$export$436172fa0e71e289.displayName = "ReverseTrialPopupDialog";

});
parcelRegister("awo7M", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $af4bf2db248c51f6$export$3b6761b6086f6dfd);

var $1hcaR = parcelRequire("1hcaR");
const $af4bf2db248c51f6$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'reverse-trial-popup',
    dialogType: 'pop-up',
    targetProductEdition: (0, $1hcaR.Edition).PREMIUM_EDITION
};

});

parcelRegister("kirj1", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $c5828f16715b0f31$export$6333901e831d7af0);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $hAsPh = parcelRequire("hAsPh");

const $c5828f16715b0f31$export$6333901e831d7af0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("jP9eS")), {
        moduleId: "38aee5f9",
        priority: "interaction",
        moduleId: 'edition-awareness-reverse-trial-popup'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                reverseTrialPopupQuery: {
                    parameters: $hAsPh.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("hAsPh", function(module, exports) {
$parcel$export(module.exports, "default", () => $855d1f82e3e13036$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<282e84a59ad31677adfafd111cd33ab9>>
 * @relayHash fb387ee4c17d62b6ce4867baf6061884
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe23b73929c26e3fa0b23fad14fc6c713c94abcd8a87983ce3d62e052dbade3b

var $lIGkE = parcelRequire("lIGkE");
const $855d1f82e3e13036$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Free"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "reverseTrialPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Free\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "reverseTrialPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Free\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fe23b73929c26e3fa0b23fad14fc6c713c94abcd8a87983ce3d62e052dbade3b",
            "metadata": {},
            "name": "reverseTrialPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$855d1f82e3e13036$var$node.hash = "7149df0cbb7841476e95591ab561c360";
(0, $lIGkE.PreloadableQueryRegistry).set($855d1f82e3e13036$var$node.params.id, $855d1f82e3e13036$var$node);
var $855d1f82e3e13036$export$2e2bcd8739ae039 = $855d1f82e3e13036$var$node;

});

parcelRegister("jP9eS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8IHVK").then(()=>parcelRequire('eX94r'));

});



parcelRegister("5pyVI", function(module, exports) {
$parcel$export(module.exports, "StandardAddPaymentModal", () => $9e20062d76f8f24b$export$e7d982549be9547c);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $kXxEy = parcelRequire("kXxEy");

var $36u0q = parcelRequire("36u0q");

var $42S0C = parcelRequire("42S0C");

var $ibXvy = parcelRequire("ibXvy");

var $6KMGi = parcelRequire("6KMGi");

var $fSAGQ = parcelRequire("fSAGQ");

var $sZNiz = parcelRequire("sZNiz");

var $43iYw = parcelRequire("43iYw");
function $9e20062d76f8f24b$export$e7d982549be9547c() {
    const { product: product, cloudId: cloudId } = (0, $kXxEy.useEditionAwareness)();
    const projectType = (0, $ibXvy.getJiraProjectTypeKey)(product);
    const jiraApplicationKey = (0, $42S0C.getJiraApplicationKey)(product);
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $6KMGi.getHamsKey)(product),
            chargeElement: (0, $36u0q.getChargeElementKey)(product),
            // Fallback to any valid value since this means that we're not using jira
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            // Fallback to any valid value since this means that we're not using jira
            projectType: projectType ?? 'SOFTWARE',
            isJira: product === 'jira' || product === 'jira-product-discovery' || product === 'jira-service-management',
            isConfluence: product === 'confluence'
        }), [
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const modalProps = (0, $euxye.useMemo)(()=>{
        if (product === 'confluence') return {
            width: 1000,
            height: 600
        };
        return {
            width: 968,
            height: 576
        };
    }, [
        product
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fSAGQ.ModalEntryPoint), {
        entryPoint: (0, $43iYw.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $sZNiz.DIALOG_CONFIG)
    });
}
$9e20062d76f8f24b$export$e7d982549be9547c.displayName = "StandardAddPaymentModal";

});
parcelRegister("sZNiz", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $35d11218d9c8cd4f$export$3b6761b6086f6dfd);

var $1hcaR = parcelRequire("1hcaR");
const $35d11218d9c8cd4f$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'standard-add-payment-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1hcaR.Edition).STANDARD_EDITION
};

});

parcelRegister("43iYw", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $44b724db1008d720$export$6333901e831d7af0);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $8BkZV = parcelRequire("8BkZV");

const $44b724db1008d720$export$6333901e831d7af0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("kMpDI")), {
        moduleId: "8a2449b3",
        priority: "interaction",
        moduleId: 'edition-awareness-standard-add-payment-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey, projectType: projectType, chargeElement: chargeElement, jiraApplicationKey: jiraApplicationKey, isJira: isJira, isConfluence: isConfluence })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                standardAddPaymentModalQuery: {
                    parameters: $8BkZV.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey,
                        chargeElement: chargeElement,
                        projectType: projectType,
                        jiraApplicationKey: jiraApplicationKey,
                        isJira: isJira,
                        isConfluence: isConfluence
                    }
                }
            }
        })
});

});
parcelRegister("8BkZV", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd9d8816dae752c9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d282a5123f245865e33224a46f1392ca>>
 * @relayHash 081ae02dbc9e7d3009e7fbdca4492722
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7e0de08a75b889e79cd9fefc7277283b171871d0347b99f590cc073558ab0ab9

var $lIGkE = parcelRequire("lIGkE");
const $fd9d8816dae752c9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfluence"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJira"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraApplicationKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v7 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v9 = {
        "args": [
            {
                "kind": "Variable",
                "name": "chargeElement",
                "variableName": "chargeElement"
            }
        ],
        "kind": "ScalarField",
        "name": "latestUsageForChargeElement"
    }, v10 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "condition": "isConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v10 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "cql",
                        "value": "type=user"
                    },
                    {
                        "kind": "Literal",
                        "name": "excludeServiceAppUsers",
                        "value": true
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "confluence_searchUser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponse",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluencePerson",
                                "kind": "LinkedField",
                                "name": "confluencePerson",
                                "plural": false,
                                "selections": [
                                    v11 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    {
                                        "concreteType": "Icon",
                                        "kind": "LinkedField",
                                        "name": "profilePicture",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "path"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isUnlimited"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesLimit"
                    }
                ]
            }
        ]
    }, v13 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v10 /*: any*/ 
    ], v14 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageAllowed"
    }, v15 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageUsed"
    }, v16 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageIsUnlimited"
    }, v17 = [
        v10 /*: any*/ ,
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v18 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v22 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "standardAddPaymentModalQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v18 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "standardAddPaymentModalQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v18 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v22 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7e0de08a75b889e79cd9fefc7277283b171871d0347b99f590cc073558ab0ab9",
            "metadata": {},
            "name": "standardAddPaymentModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fd9d8816dae752c9$var$node.hash = "1a2deb9f2ae9b251077ad9a1cce4e589";
(0, $lIGkE.PreloadableQueryRegistry).set($fd9d8816dae752c9$var$node.params.id, $fd9d8816dae752c9$var$node);
var $fd9d8816dae752c9$export$2e2bcd8739ae039 = $fd9d8816dae752c9$var$node;

});

parcelRegister("kMpDI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aig4o").then(()=>parcelRequire('7Sabm'));

});



parcelRegister("4AZqG", function(module, exports) {
$parcel$export(module.exports, "StorageHardLimitModal", () => $2eea7f2875ecedcf$export$d58ea28307440812);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $fSAGQ = parcelRequire("fSAGQ");

var $9ekI4 = parcelRequire("9ekI4");

var $4plxa = parcelRequire("4plxa");
function $2eea7f2875ecedcf$export$d58ea28307440812() {
    const modalProps = (0, $euxye.useMemo)(()=>({
            width: 968,
            height: 520
        }), []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fSAGQ.ModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $4plxa.default),
        dialogConfig: (0, $9ekI4.DIALOG_CONFIG)
    });
}
$2eea7f2875ecedcf$export$d58ea28307440812.displayName = "StorageHardLimitModal";

});
parcelRegister("9ekI4", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $e8f1fa25aba18f26$export$3b6761b6086f6dfd);

var $1hcaR = parcelRequire("1hcaR");
const $e8f1fa25aba18f26$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'storage-hard-limit-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1hcaR.Edition).STANDARD_EDITION
};

});

parcelRegister("4plxa", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba90bfd602153142$export$2e2bcd8739ae039);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $ba90bfd602153142$var$storageHardLimitEntryPoint = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("azVDL")), {
        moduleId: "c613c169",
        priority: "interaction",
        moduleId: 'edition-awareness-storage-hard-limit-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});
var $ba90bfd602153142$export$2e2bcd8739ae039 = $ba90bfd602153142$var$storageHardLimitEntryPoint;

});
parcelRegister("azVDL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("FFrEl").then(()=>parcelRequire('3JcuZ'));

});



parcelRegister("ihjrE", function(module, exports) {
$parcel$export(module.exports, "PaymentFlowLink", () => $7a14cae924f2e414$export$aa8ff608e1ef425);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hUqPj = parcelRequire("hUqPj");

var $kXxEy = parcelRequire("kXxEy");

var $cLUxG = parcelRequire("cLUxG");

var $hz7zH = parcelRequire("hz7zH");

var $eX7RF = parcelRequire("eX7RF");
const $7a14cae924f2e414$export$d546020ad1fe9957 = {
    linkId: 'payment-flow',
    touchpointIntent: 'addPaymentDetails'
};
const $7a14cae924f2e414$var$PaymentFlowLinkContent = ({ href: href })=>{
    const context = (0, $kXxEy.useEditionAwareness)();
    const { getExperimentValue: getExperimentValue } = (0, $cLUxG.useGetExperimentValue)();
    const handlePaymentFlowClick = (0, $euxye.useCallback)(()=>{
        if ((0, $hz7zH.isEligibleForEAtoOSBNonRTPremiumAndRTPredunning)(context)) getExperimentValue({
            statsigParams: {
                experimentName: 'ea-to-osb-nonrt-premium-rt-predunning-ab',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'tako'
            }
        });
    }, [
        context,
        getExperimentValue
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eX7RF.EditionAwarenessLink), {
        href: href,
        target: "_blank",
        onClick: handlePaymentFlowClick,
        ...$7a14cae924f2e414$export$d546020ad1fe9957
    });
};
$7a14cae924f2e414$var$PaymentFlowLinkContent.displayName = "PaymentFlowLinkContent";
const $7a14cae924f2e414$export$aa8ff608e1ef425 = ()=>{
    const { addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl } = (0, $kXxEy.useEditionAwareness)();
    if (addPaymentDetailsExperienceUrl) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hUqPj.default), {
        data: $7a14cae924f2e414$export$d546020ad1fe9957,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($7a14cae924f2e414$var$PaymentFlowLinkContent, {
            href: addPaymentDetailsExperienceUrl
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {});
};
$7a14cae924f2e414$export$aa8ff608e1ef425.displayName = "PaymentFlowLink";

});

parcelRegister("7lbX7", function(module, exports) {
$parcel$export(module.exports, "UpgradeStandardFlowLink", () => $9a56ddc014684358$export$a8729b26aa8f56b8);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hUqPj = parcelRequire("hUqPj");

var $egspI = parcelRequire("egspI");

var $1hcaR = parcelRequire("1hcaR");

var $kXxEy = parcelRequire("kXxEy");

var $cLUxG = parcelRequire("cLUxG");

var $2HR8E = parcelRequire("2HR8E");

var $eX7RF = parcelRequire("eX7RF");
const $9a56ddc014684358$export$d546020ad1fe9957 = {
    linkId: 'upgrade-flow',
    touchpointIntent: 'changePlan',
    targetProductEdition: (0, $1hcaR.Edition).STANDARD_EDITION
};
const $9a56ddc014684358$var$UpgradeStandardFlowLinkContent = ()=>{
    const context = (0, $kXxEy.useEditionAwareness)();
    const { changeOfferingToStandardExperienceUrl: changeOfferingToStandardExperienceUrl, product: product } = context;
    const { getExperimentValue: getExperimentValue } = (0, $cLUxG.useGetExperimentValue)();
    const handleUpgradeFlowClick = (0, $euxye.useCallback)((e)=>{
        if ((0, $2HR8E.isEligibleForEAtoOSBFreeWithPDE)(context)) {
            getExperimentValue({
                statsigParams: {
                    experimentName: 'ea-to-osb-free-with-pde-aa',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled'
                },
                trackEventParameters: {
                    trackEventGrowthInitiative: 'tako'
                }
            });
            getExperimentValue({
                statsigParams: {
                    experimentName: 'ea-to-osb-free-with-pde-ab',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled'
                },
                trackEventParameters: {
                    trackEventGrowthInitiative: 'tako'
                }
            });
        }
        if (product === 'jira' && changeOfferingToStandardExperienceUrl && (0, $egspI.fg)('luna-twcg-1858-jira-start-trial-add-returnurl')) try {
            e.preventDefault();
            const url = new URL(changeOfferingToStandardExperienceUrl);
            // Read window.location.href at click time so it reflects any client-side
            // navigation that occurred since the component was rendered, regardless of
            // which router (Jira or Confluence) is in use.
            url.searchParams.set('returnUrl', window.location.href);
            window.open(url.toString(), '_blank');
        } catch  {
        // URL construction failed — let the <a> tag navigate naturally
        }
    }, [
        changeOfferingToStandardExperienceUrl,
        product,
        context,
        getExperimentValue
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eX7RF.EditionAwarenessLink), {
        href: changeOfferingToStandardExperienceUrl,
        target: "_blank",
        onClick: handleUpgradeFlowClick,
        ...$9a56ddc014684358$export$d546020ad1fe9957
    });
};
$9a56ddc014684358$var$UpgradeStandardFlowLinkContent.displayName = "UpgradeStandardFlowLinkContent";
const $9a56ddc014684358$export$a8729b26aa8f56b8 = ()=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hUqPj.default), {
        data: $9a56ddc014684358$export$d546020ad1fe9957,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($9a56ddc014684358$var$UpgradeStandardFlowLinkContent, {})
    });
};
$9a56ddc014684358$export$a8729b26aa8f56b8.displayName = "UpgradeStandardFlowLink";

});


parcelRegister("fl5mA", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $e8a82185026e6dbd$export$e926676385687eaf);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $b1LI7 = parcelRequire("b1LI7");

var $4FR7Y = parcelRequire("4FR7Y");

var $siTdT = parcelRequire("siTdT");

var $NCuQK = parcelRequire("NCuQK");
const $e8a82185026e6dbd$export$e926676385687eaf = ({ children: children, product: product, edition: edition, id: id })=>{
    const handleOnError = (0, $NCuQK.useErrorAnalytics)({
        product: product,
        edition: edition,
        id: id
    });
    const ufoContext = (0, $4FR7Y.useInteractionContext)();
    const onError = (0, $euxye.useCallback)((error)=>{
        const interaction = (0, $siTdT.getActiveInteraction)();
        handleOnError(error);
        if (interaction && ufoContext) (0, $siTdT.addError)(interaction?.id, error.name, ufoContext?.labelStack, error.name, error.message, error.stack);
        else (0, $siTdT.addErrorToAll)(`ErrorBoundary:${id}`, ufoContext?.labelStack || null, error.name, error.message);
    }, [
        handleOnError,
        id,
        ufoContext
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $b1LI7.ErrorBoundary), {
        onError: onError,
        fallback: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {}),
        children: children
    });
};
$e8a82185026e6dbd$export$e926676385687eaf.displayName = "ErrorBoundary";

});
parcelRegister("b1LI7", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("euxye")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("NCuQK", function(module, exports) {
$parcel$export(module.exports, "useErrorAnalytics", () => $ecc65eb3c54e8531$export$e2d4523bbccd2343);

var $euxye = parcelRequire("euxye");

var $gkrR2 = parcelRequire("gkrR2");
/**
 * This hook is designed to be used before contexts are initialized to avoid circular dependencies.
 */ function $ecc65eb3c54e8531$var$useOperationalFailureAnalytics({ product: product, edition: edition }) {
    const sendOperationalEvent = (0, $gkrR2.useOperationalAnalytics)({
        product: product,
        edition: edition
    });
    return (0, $euxye.useCallback)((attributes)=>{
        sendOperationalEvent({
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: attributes
        });
    }, [
        sendOperationalEvent
    ]);
}
/**
 * These are errors which we ignore from SLO reporting to ensure we reporting on errors we can action
 */ const $ecc65eb3c54e8531$var$nonSLOErrors = [
    /**
	 * These occur when the fetch request fails (usually this is because the users network is offline)
	 *
	 * This is usually thrown from inside of the products fetch handler
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws this error to every fetch request
	 */ /failed to fetch/i,
    /**
	 * These occur when the fetch request fails due to a server response (e.g. 401 due to the user needing to reauthenticate their session)
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws server errors after parsing the response headers
	 */ /Error server response:/i
];
function $ecc65eb3c54e8531$var$isSLOError(error) {
    // Just checks that none of our non slo errors match the error
    return !$ecc65eb3c54e8531$var$nonSLOErrors.some((msg)=>msg.test(error.message));
}
function $ecc65eb3c54e8531$export$e2d4523bbccd2343({ product: product, edition: edition, id: id }) {
    const sendOperationalFailure = $ecc65eb3c54e8531$var$useOperationalFailureAnalytics({
        product: product,
        edition: edition
    });
    return (0, $euxye.useCallback)((error)=>{
        sendOperationalFailure({
            error: error.message,
            errorStack: error.stack,
            errorName: error.name,
            id: id ?? 'unknownErrorId',
            isSLOError: $ecc65eb3c54e8531$var$isSLOError(error)
        });
    }, [
        sendOperationalFailure,
        id
    ]);
}
function $ecc65eb3c54e8531$export$45aafd752da9ba22({ product: product, edition: edition }) {
    const sendOperationalFailure = $ecc65eb3c54e8531$var$useOperationalFailureAnalytics({
        product: product,
        edition: edition
    });
    return (0, $euxye.useCallback)((dataValidationError)=>{
        sendOperationalFailure({
            dataValidationError: dataValidationError,
            id: 'dataValidationError'
        });
    }, [
        sendOperationalFailure
    ]);
}

});
parcelRegister("gkrR2", function(module, exports) {
$parcel$export(module.exports, "useOperationalAnalytics", () => $d34306a22e62e2b1$export$18e9461e904f638a);

var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $lmRlQ = parcelRequire("lmRlQ");
function $d34306a22e62e2b1$export$18e9461e904f638a({ product: product, edition: edition }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    return (0, $euxye.useCallback)(({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
        const event = createAnalyticsEvent({
            eventType: 'operational',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...(0, $lmRlQ.defaultAttributes),
                product: product,
                currentProductEdition: edition,
                ...attributes
            }
        });
        const contextAttributes = (0, $lmRlQ.getAttributesFromContexts)(event.context);
        event.update({
            attributes: {
                ...contextAttributes,
                ...event.payload.attributes
            }
        }).fire((0, $lmRlQ.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        product,
        edition
    ]);
}

});




parcelRegister("fbMby", function(module, exports) {
$parcel$export(module.exports, "EditionAwarenessUpsell", () => $4549eca23c6422d5$export$148b30c5d238daaa);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hUqPj = parcelRequire("hUqPj");

var $3BBB7 = parcelRequire("3BBB7");

var $cxpqA = parcelRequire("cxpqA");

var $atjjs = parcelRequire("atjjs");

var $kXxEy = parcelRequire("kXxEy");

var $cLUxG = parcelRequire("cLUxG");

var $crSbr = parcelRequire("crSbr");

var $fWaSn = parcelRequire("fWaSn");

var $7HTei = parcelRequire("7HTei");

var $fl5mA = parcelRequire("fl5mA");
/**
 * Edition awareness upsell is an experimental EA implementtiona that has to be exported as its own component to avoid making ccp calls which are alerting VC90 mertics
 *
 * This component deals with creating the context which is then used throughout the package to:
 * - Track analytics
 * - Know which product/edition/cloud id is being used
 * - Know when to show/hide the button
 */ function $4549eca23c6422d5$var$EditionAwarenessUpsellImpl({ edition: edition, product: product, cloudId: cloudId, userRoles: userRoles, hasDismissedButton: hasDismissedButton, onDismissButton: onDismissButton, navVersion: navVersion, originalProjectTypeWasCore: originalProjectTypeWasCore }) {
    const trialOfferingName = (0, $crSbr.getTrialOfferingName)(product, edition);
    const context = (0, $euxye.useMemo)(()=>{
        return {
            cloudId: cloudId,
            product: product,
            edition: edition,
            userRoles: userRoles,
            hasDismissedButton: hasDismissedButton,
            onDismissButton: onDismissButton,
            trialOfferingName: trialOfferingName,
            // This is not used in this flow, but a required type in context
            licensedUsers: 1,
            // This is displayed to sites that are on not trial not predunning
            invoiceableStatus: 'INVOICEABLE',
            originalProjectTypeWasCore: originalProjectTypeWasCore
        };
    }, [
        cloudId,
        product,
        edition,
        userRoles,
        hasDismissedButton,
        onDismissButton,
        trialOfferingName,
        originalProjectTypeWasCore
    ]);
    const experimentContextValue = (0, $euxye.useMemo)(()=>new (0, $cLUxG.ExperimentContextClass)(), []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cLUxG.ExperimentContext).Provider, {
        value: experimentContextValue,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kXxEy.EditionAwarenessContext).Provider, {
            value: context,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hUqPj.default), {
                data: {
                    navVersion: navVersion,
                    hasDismissedButton: hasDismissedButton
                },
                children: /*#__PURE__*/ (0, $e79Pd.jsx)($4549eca23c6422d5$var$StandardEdition, {})
            })
        })
    });
}
$4549eca23c6422d5$var$EditionAwarenessUpsellImpl.displayName = "EditionAwarenessUpsellImpl";
function $4549eca23c6422d5$export$148b30c5d238daaa(props) {
    const { product: product, edition: edition } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cxpqA.RelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3BBB7.default), {
            name: "edition-awareness-upsell",
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fl5mA.ErrorBoundary), {
                product: product,
                edition: edition,
                id: "edition-awareness-upsell",
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)($4549eca23c6422d5$var$EditionAwarenessUpsellImpl, {
                        ...props
                    })
                })
            })
        })
    });
}
$4549eca23c6422d5$export$148b30c5d238daaa.displayName = "EditionAwarenessUpsell";
function $4549eca23c6422d5$var$StandardEdition() {
    const context = (0, $kXxEy.useEditionAwareness)();
    const { product: product, hasDismissedButton: hasDismissedButton, originalProjectTypeWasCore: originalProjectTypeWasCore } = context;
    const { getExperimentValue: getExperimentValue, getExperimentValueWithTransform: getExperimentValueWithTransform } = (0, $cLUxG.useGetExperimentValue)();
    if ((0, $fWaSn.isEligibleForStandardToPremium)(context) && !hasDismissedButton) {
        // Firing exposure for the introduction of full JWM support
        if (product === 'jira' && originalProjectTypeWasCore && getExperimentValue({
            statsigParams: {
                experimentName: 'twcg-1563-remove-jira-only-restriction',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            }
        }) !== 'variation') // If the tenant is not in variation, we don't show anything, as that is the original JWM experience
        return null;
        let experimentKey;
        if (product === 'confluence') experimentKey = 'edition_awareness_standard_upsell_confluence_ab';
        else if (product === 'jira-product-discovery') experimentKey = 'edition_awareness_upsell_jpd';
        else experimentKey = 'edition_awareness_upsell_jira_ab';
        const cohort = getExperimentValueWithTransform({
            statsigParams: {
                experimentName: experimentKey,
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            transformCohortFunc: (0, $cLUxG.treatmentCohortTransformFn)
        });
        return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
            children: [
                cohort === 'control' && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $atjjs.FeatureExposedAnalytics), {
                    flagKey: experimentKey,
                    cohort: cohort
                }),
                cohort === 'treatment' && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $atjjs.FeatureExposedAnalytics), {
                    flagKey: experimentKey,
                    cohort: cohort,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7HTei.StandardToPremiumModal), {})
                })
            ]
        });
    }
    return null;
}
$4549eca23c6422d5$var$StandardEdition.displayName = "StandardEdition";

});
parcelRegister("7HTei", function(module, exports) {
$parcel$export(module.exports, "StandardToPremiumModal", () => $b9c43e785ac0decc$export$a74acc125b20e3e5);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $kXxEy = parcelRequire("kXxEy");

var $6KMGi = parcelRequire("6KMGi");

var $fSAGQ = parcelRequire("fSAGQ");

var $fFYK2 = parcelRequire("fFYK2");

var $9VChq = parcelRequire("9VChq");
function $b9c43e785ac0decc$export$a74acc125b20e3e5() {
    const { product: product, cloudId: cloudId } = (0, $kXxEy.useEditionAwareness)();
    const entryPointParams = (0, $euxye.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $6KMGi.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const modalProps = (0, $euxye.useMemo)(()=>({
            width: 968
        }), []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fSAGQ.ModalEntryPoint), {
        modalProps: modalProps,
        entryPoint: (0, $9VChq.entryPoint),
        entryPointParams: entryPointParams,
        dialogConfig: (0, $fFYK2.DIALOG_CONFIG)
    });
}
$b9c43e785ac0decc$export$a74acc125b20e3e5.displayName = "StandardToPremiumModal";

});
parcelRegister("fFYK2", function(module, exports) {
$parcel$export(module.exports, "DIALOG_CONFIG", () => $f3a77f54fb849629$export$3b6761b6086f6dfd);

var $1hcaR = parcelRequire("1hcaR");
const $f3a77f54fb849629$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'standard-to-premium-modal',
    dialogType: 'modal',
    targetProductEdition: (0, $1hcaR.Edition).PREMIUM_EDITION
};

});

parcelRegister("9VChq", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $1f51ade1c3bae963$export$6333901e831d7af0);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $6V8Pp = parcelRequire("6V8Pp");

const $1f51ade1c3bae963$export$6333901e831d7af0 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("alz5x")), {
        moduleId: "9dc17d8c",
        priority: "interaction",
        moduleId: 'edition-awareness-standard-to-premium-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                standardToPremiumModalQuery: {
                    parameters: $6V8Pp.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("6V8Pp", function(module, exports) {
$parcel$export(module.exports, "default", () => $bee4178a68fad033$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9ec3ebaafe97a4877fd4728337d1240a>>
 * @relayHash de6e2bac8a58a1f311e29bca101d04f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41a183f07082b19942dc28b868628bc31ce5d5b683a639aab2d17f96750539e

var $lIGkE = parcelRequire("lIGkE");
const $bee4178a68fad033$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "standardToPremiumModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "standardToPremiumModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e41a183f07082b19942dc28b868628bc31ce5d5b683a639aab2d17f96750539e",
            "metadata": {},
            "name": "standardToPremiumModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bee4178a68fad033$var$node.hash = "2c7841c5e5f86c438cbec88e2db2ae41";
(0, $lIGkE.PreloadableQueryRegistry).set($bee4178a68fad033$var$node.params.id, $bee4178a68fad033$var$node);
var $bee4178a68fad033$export$2e2bcd8739ae039 = $bee4178a68fad033$var$node;

});

parcelRegister("alz5x", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8VKfl").then(()=>parcelRequire('k9wdG'));

});




parcelRegister("d7U1K", function(module, exports) {
$parcel$export(module.exports, "setInteractionError", () => $ed6a25dada9558fc$export$5b689ca7b019e89f);

var $siTdT = parcelRequire("siTdT");
function $ed6a25dada9558fc$export$5b689ca7b019e89f(interactionName, error) {
    const interaction = (0, $siTdT.getActiveInteraction)();
    if (!interaction) return;
    if (interaction.ufoName !== interactionName) return;
    (0, $siTdT.addError)(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
}

});

parcelRegister("VoOhq", function(module, exports) {
$parcel$export(module.exports, "default", () => $c925999ecfb802f2$export$2e2bcd8739ae039);

var $e6ag7 = parcelRequire("e6ag7");
function $c925999ecfb802f2$var$traceUFOPress(name, timestamp) {
    return (0, $e6ag7.default)(name, 'press', timestamp);
}
var $c925999ecfb802f2$export$2e2bcd8739ae039 = $c925999ecfb802f2$var$traceUFOPress;

});
parcelRegister("e6ag7", function(module, exports) {
$parcel$export(module.exports, "default", () => $08dfa7b1eda23551$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $7TA2J = parcelRequire("7TA2J");

var $erszr = parcelRequire("erszr");

var $gmMRH = parcelRequire("gmMRH");

var $anDmR = parcelRequire("anDmR");

var $qqoKJ = parcelRequire("qqoKJ");

var $siTdT = parcelRequire("siTdT");

var $7VWGN = parcelRequire("7VWGN");
function $08dfa7b1eda23551$var$traceUFOInteraction(name, interactionType, startTime) {
    if (!(0, $gmMRH.isUFOEnabled)()) return;
    const rate = (0, $gmMRH.getInteractionRate)(name, interactionType);
    const pressInteractionsList = (0, $gmMRH.getDoNotAbortActivePressInteraction)();
    const minorInteractions = (pressInteractionsList ?? []).concat((0, $gmMRH.getMinorInteractions)() ?? []);
    if (minorInteractions.includes(name)) {
        const activeInteraction = (0, $siTdT.getActiveInteraction)();
        activeInteraction?.minorInteractions?.push({
            name: name,
            startTime: startTime ?? performance.now()
        });
        return;
    } else (0, $siTdT.abortAll)('new_interaction', name);
    if ((0, $erszr.default)(rate)) {
        const startTimestamp = startTime ?? performance.now();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $7TA2J.v4)();
        (0, $qqoKJ.DefaultInteractionID).current = newId;
        // covered experiences with tracing instrumentation:
        // inline-result.inline-card-create-submit
        (0, $anDmR.setInteractionActiveTrace)(newId, interactionType);
        (0, $siTdT.addNewInteraction)(newId, name, interactionType === 'hover' ? 'press' : interactionType, startTimestamp, rate, [], (0, $7VWGN.default).current, (0, $anDmR.getActiveTrace)());
    }
}
var $08dfa7b1eda23551$export$2e2bcd8739ae039 = $08dfa7b1eda23551$var$traceUFOInteraction;

});


parcelRegister("cVI8i", function(module, exports) {
$parcel$export(module.exports, "default", () => $38a94f2128743d5a$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $5pMen = parcelRequire("5pMen");

var $l0vTI = parcelRequire("l0vTI");

var $c3Aaw = parcelRequire("c3Aaw");

var $9Db7E = parcelRequire("9Db7E");
var $5ySJg = parcelRequire("5ySJg");
var $kTviw = parcelRequire("kTviw");

var $hZWgJ = parcelRequire("hZWgJ");
const $38a94f2128743d5a$var$THROTTLE_EXPIRES = 60000; // 60 seconds
const $38a94f2128743d5a$var$THROTTLE_OPTIONS = {
    leading: true,
    trailing: false
};
const $38a94f2128743d5a$var$TRIGGER_CONTEXT = {
    componentName: (0, $9Db7E.TRIGGER_COMPONENT),
    ...(0, $hZWgJ.default)
};
class $38a94f2128743d5a$var$PrefetchTrigger extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    render() {
        const { children: children, Container: Container = 'div' } = this.props;
        return /*#__PURE__*/ (0, $e79Pd.jsx)(Container, {
            onFocus: this.handleMouseEnter,
            onMouseEnter: this.handleMouseEnter,
            onClick: this.handleMouseClick,
            children: children
        });
    }
    constructor(...args){
        super(...args), this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $6d4033511f75ada1$export$12346a674644c156),
                actionSubject: (0, $9Db7E.TRIGGER_SUBJECT),
                ...payload
            }).fire((0, $9Db7E.NAVIGATION_CHANNEL));
        }, this.triggerPrefetch = (0, (/*@__PURE__*/$parcel$interopDefault($5pMen)))(()=>{
            (0, $l0vTI.prefetchAll)(this.props);
            this.fireOperationalEvent({
                action: 'triggered'
            });
        }, $38a94f2128743d5a$var$THROTTLE_EXPIRES, $38a94f2128743d5a$var$THROTTLE_OPTIONS), this.handleMouseEnter = ()=>{
            this.triggerPrefetch();
            this.lastEnteredAt = (0, $c3Aaw.performanceNow)();
        }, this.handleMouseClick = ()=>{
            if (this.lastEnteredAt) {
                const hoverToClick = Math.round((0, $c3Aaw.performanceNow)() - this.lastEnteredAt);
                this.fireOperationalEvent({
                    action: 'clicked',
                    attributes: {
                        hoverToClick: hoverToClick
                    }
                });
            }
        };
    }
}
$38a94f2128743d5a$var$PrefetchTrigger.displayName = "PrefetchTrigger";
const $38a94f2128743d5a$var$PrefetchTriggerWithEvents = (0, $kTviw.default)()($38a94f2128743d5a$var$PrefetchTrigger);
var $38a94f2128743d5a$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $5ySJg.NavigationAnalyticsContext), {
        data: $38a94f2128743d5a$var$TRIGGER_CONTEXT,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($38a94f2128743d5a$var$PrefetchTriggerWithEvents, {
            ...props
        })
    });

});
parcelRegister("l0vTI", function(module, exports) {
$parcel$export(module.exports, "prefetchAll", () => $b0adcf3ca0d88f81$export$aba5d6cf034db22e);

var $868ZD = parcelRequire("868ZD");

var $ichIT = parcelRequire("ichIT");

var $e9dtM = parcelRequire("e9dtM");

var $1tP1L = parcelRequire("1tP1L");

var $29Fdj = parcelRequire("29Fdj");
const $b0adcf3ca0d88f81$export$aba5d6cf034db22e = (props)=>{
    const { cloudId: cloudId, product: product } = props;
    (0, $e9dtM.default)();
    (0, $1tP1L.prefetchFlightDeck)({});
    (0, $868ZD.prefetchAvailableProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $29Fdj.prefetchThirdPartyProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $ichIT.prefetchJoinableSites)(props.joinableSitesDataProvider);
};

});
parcelRegister("868ZD", function(module, exports) {
$parcel$export(module.exports, "AvailableProductsProvider", () => $6ce145ce807e6222$export$4c169257ef988618);
$parcel$export(module.exports, "prefetchAvailableProducts", () => $6ce145ce807e6222$export$1c5684a3ba697d80);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $gWO0x = parcelRequire("gWO0x");
const { fetchMethod: $6ce145ce807e6222$var$fetchAppSwitcherBffAvailableProducts, ProviderComponent: $6ce145ce807e6222$var$DefaultBffDataProviderComponent } = (0, $gWO0x.createAppSwitcherBffAvailableProductsProvider)();
const $6ce145ce807e6222$export$4c169257ef988618 = ({ cloudId: cloudId, product: product, children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)($6ce145ce807e6222$var$DefaultBffDataProviderComponent, {
        cloudId: cloudId,
        product: product,
        children: children
    });
$6ce145ce807e6222$export$4c169257ef988618.displayName = "AvailableProductsProvider";
const $6ce145ce807e6222$export$1c5684a3ba697d80 = $6ce145ce807e6222$var$fetchAppSwitcherBffAvailableProducts;
const $6ce145ce807e6222$export$cd9fc41c59711bdd = ()=>$6ce145ce807e6222$var$fetchAppSwitcherBffAvailableProducts.reset();

});
parcelRegister("gWO0x", function(module, exports) {
$parcel$export(module.exports, "createAppSwitcherBffAvailableProductsProvider", () => $0bca4a6104f7d9af$export$7fd9c7ae7afb494c);

var $hssAp = parcelRequire("hssAp");

var $cEIt4 = parcelRequire("cEIt4");

var $bEjWd = parcelRequire("bEjWd");
const $0bca4a6104f7d9af$export$f36bb44a614923a8 = '/gateway/api/app-switcher/api/available-products';
const $0bca4a6104f7d9af$export$1096efb00c5f8afc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $cEIt4.fetchJsonWithNetworkRetries)(`${$0bca4a6104f7d9af$export$f36bb44a614923a8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $0bca4a6104f7d9af$export$7fd9c7ae7afb494c = ()=>{
    return (0, $hssAp.createProviderWithCustomFetchData)('appSwitcherBffAvailableProducts', (0, $bEjWd.ExperienceMark).API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, $0bca4a6104f7d9af$export$1096efb00c5f8afc);
};

});
parcelRegister("hssAp", function(module, exports) {
$parcel$export(module.exports, "createProviderWithCustomFetchData", () => $5117ef8bcd0c765d$export$310e48be95687c2f);

var $fO7CL = parcelRequire("fO7CL");

var $cEIt4 = parcelRequire("cEIt4");

var $hgltp = parcelRequire("hgltp");
const $5117ef8bcd0c765d$export$500fbc0cd14cdbaa = (name, experienceMark, url)=>{
    const fetchMethod = (0, $hgltp.withCached)((param)=>(0, $cEIt4.fetchJson)(url));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $fO7CL.default)(name, experienceMark, fetchMethod, fetchMethod.cached, // fetch will only throw on a network exception,
        // so we can safely retry on all exceptions
        {
            shouldRetryOnException: ()=>true,
            intervalsMS: [
                50,
                200,
                1000
            ]
        })
    };
};
const $5117ef8bcd0c765d$export$310e48be95687c2f = (name, experienceMark, fetchData, retryConfig)=>{
    const fetchMethod = (0, $hgltp.withCached)((param)=>fetchData(param));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $fO7CL.default)(name, experienceMark, fetchMethod, fetchMethod.cached, retryConfig)
    };
};

});
parcelRegister("fO7CL", function(module, exports) {
$parcel$export(module.exports, "Status", () => $1da08fd1faf900df$export$96e9906d6d93a972);
$parcel$export(module.exports, "isComplete", () => $1da08fd1faf900df$export$9569565a7ac14e8e);
$parcel$export(module.exports, "isError", () => $1da08fd1faf900df$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isLoading", () => $1da08fd1faf900df$export$20bb0d907fbbe433);
$parcel$export(module.exports, "hasLoaded", () => $1da08fd1faf900df$export$5fce62f50756dbf);
$parcel$export(module.exports, "default", () => $1da08fd1faf900df$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $9Db7E = parcelRequire("9Db7E");

var $kTviw = parcelRequire("kTviw");

var $gt7fJ = parcelRequire("gt7fJ");

var $6sbl3 = parcelRequire("6sbl3");

var $1lapN = parcelRequire("1lapN");
const $1da08fd1faf900df$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
var $1da08fd1faf900df$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
const $1da08fd1faf900df$export$947ceca65da0e7a6 = (data)=>({
        status: "complete",
        data: data
    });
const $1da08fd1faf900df$export$9569565a7ac14e8e = (result)=>result.status === "complete";
const $1da08fd1faf900df$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
const $1da08fd1faf900df$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
const $1da08fd1faf900df$export$5fce62f50756dbf = (result)=>result.status !== "loading";
function $1da08fd1faf900df$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    const getInitialState = (props)=>{
        if (mapPropsToInitialValue) {
            const initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: "complete",
                data: initialValue
            };
        }
        return {
            status: "loading",
            data: null
        };
    };
    class DataProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
        static{
            this.displayName = `DataProvider(${name})`;
        }
        componentWillUnmount() {
            /**
			 * Promise resolved after component is unmounted to be ignored
			 */ this.acceptResults = false;
        }
        componentDidMount() {
            this.props.experienceTracker.markStart(experienceMark);
            this.fetchData();
        }
        componentDidUpdate(prevProps) {
            if (shouldUpdate?.(prevProps.params, this.props.params)) this.fetchData();
        }
        fetchData() {
            (0, $6sbl3.retryOnException)(()=>mapPropsToPromise(this.props.params), {
                intervalsMS: retryConfig?.intervalsMS || [],
                shouldRetryOnException: retryConfig?.shouldRetryOnException,
                onRetry: (previousException, retryCount)=>{
                    this.onRetry(previousException, retryCount);
                }
            }).then((result)=>{
                this.onResult(result);
            }).catch((error)=>{
                this.onError(error);
            });
        }
        onResult(value) {
            if (this.acceptResults) this.setState({
                data: value,
                status: "complete"
            });
            this.props.experienceTracker.markEnd(experienceMark);
            this.fireOperationalEvent({
                action: 'receivedResult',
                actionSubjectId: name,
                attributes: {
                    provider: name
                }
            });
        }
        onRetry(error, retryCount) {
            this.fireOperationalEvent({
                action: 'retried',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: retryConfig?.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $gt7fJ.errorToReason)(error),
                    retryCount: retryCount
                }
            });
        }
        onError(error) {
            /**
			 * Do not transition from "complete" state to "error"
			 */ if (this.acceptResults && !$1da08fd1faf900df$export$9569565a7ac14e8e(this.state)) this.setState({
                error: error,
                status: "error",
                data: null
            });
            this.fireOperationalEvent({
                action: 'failed',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: (0, $gt7fJ.errorToReason)(error)
                }
            });
        }
        render() {
            return this.props.children(this.state);
        }
        constructor(...args){
            super(...args), this.acceptResults = true, this.state = getInitialState(this.props.params), this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $6d4033511f75ada1$export$12346a674644c156),
                    actionSubject: $1da08fd1faf900df$var$DATA_PROVIDER_SUBJECT,
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        outdated: !this.acceptResults
                    }
                }).fire((0, $9Db7E.NAVIGATION_CHANNEL));
            };
        }
    }
    // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    const InnerComponent = (0, $kTviw.default)()((0, $1lapN.withExperienceTracker)(DataProvider));
    const OuterComponent = ({ children: children, ...params })=>{
        return /*#__PURE__*/ (0, $e79Pd.jsx)(InnerComponent, {
            params: params,
            children: children
        });
    };
    return OuterComponent;
}

});
parcelRegister("9Db7E", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $cadfb0b3695d9bbf$export$515664faa1398f37);
$parcel$export(module.exports, "SWITCHER_SUBJECT", () => $cadfb0b3695d9bbf$export$17ff9c46e41eb585);
$parcel$export(module.exports, "SWITCHER_ITEM_SUBJECT", () => $cadfb0b3695d9bbf$export$7598b001981cfda5);
$parcel$export(module.exports, "SWITCHER_ITEM_LOZENGES_SUBJECT", () => $cadfb0b3695d9bbf$export$c3c93e13b09d3ad9);
$parcel$export(module.exports, "SWITCHER_CHILD_ITEM_SUBJECT", () => $cadfb0b3695d9bbf$export$7d4d527df0e3789c);
$parcel$export(module.exports, "SWITCHER_ITEM_EXPAND_SUBJECT", () => $cadfb0b3695d9bbf$export$16cf10618135eb24);
$parcel$export(module.exports, "SWITCHER_COMPONENT", () => $cadfb0b3695d9bbf$export$2b570fc112cbca);
$parcel$export(module.exports, "SWITCHER_SOURCE", () => $cadfb0b3695d9bbf$export$5ed36c4d23de5568);
$parcel$export(module.exports, "TRIGGER_COMPONENT", () => $cadfb0b3695d9bbf$export$8d2f933bbd9e4f09);
$parcel$export(module.exports, "TRIGGER_SUBJECT", () => $cadfb0b3695d9bbf$export$d7029a5dc66b0736);
$parcel$export(module.exports, "SWITCHER_PARTIAL_RESULTS", () => $cadfb0b3695d9bbf$export$4649adbfda1b6a66);
$parcel$export(module.exports, "SWITCHER_ORG_ITEM", () => $cadfb0b3695d9bbf$export$6dd696c9ad636a67);
$parcel$export(module.exports, "SWITCHER_ORG_LIST", () => $cadfb0b3695d9bbf$export$d9d2f872f3b91169);
$parcel$export(module.exports, "SWITCHER_JOINABLE_SITES", () => $cadfb0b3695d9bbf$export$5724539c9b1a3a5d);
$parcel$export(module.exports, "SWITCHER_AVAILABLE_PRODUCTS", () => $cadfb0b3695d9bbf$export$22f5f827d9934254);
$parcel$export(module.exports, "createAndFireNavigationEvent", () => $cadfb0b3695d9bbf$export$884b1a4c7ac9dd14);
$parcel$export(module.exports, "analyticsAttributes", () => $cadfb0b3695d9bbf$export$a305f130b289b818);
$parcel$export(module.exports, "withAnalyticsContextData", () => $cadfb0b3695d9bbf$export$97ebdd8e7274f18a);
$parcel$export(module.exports, "RenderTracker", () => $cadfb0b3695d9bbf$export$e09ad93c2b74b853);
$parcel$export(module.exports, "NotRenderedTracker", () => $cadfb0b3695d9bbf$export$95b1f1a72cad0dcb);
$parcel$export(module.exports, "ViewedTracker", () => $cadfb0b3695d9bbf$export$b3fd6624b6a6d057);
$parcel$export(module.exports, "getCustomLinksRenderTracker", () => $cadfb0b3695d9bbf$export$d75a4f56d85f67ea);
$parcel$export(module.exports, "getItemAnalyticsContext", () => $cadfb0b3695d9bbf$export$6489efba2ca85102);
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("kTviw")).default);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("5ySJg")).NavigationAnalyticsContext);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $6d4033511f75ada1$export$12346a674644c156);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $6d4033511f75ada1$export$a1562d08625f5d7e);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $5ySJg = parcelRequire("5ySJg");

var $flpE4 = parcelRequire("flpE4");
var $kTviw = parcelRequire("kTviw");


var $fO7CL = parcelRequire("fO7CL");

var $eUDJ0 = parcelRequire("eUDJ0");

var $4P5mQ = parcelRequire("4P5mQ");
const $cadfb0b3695d9bbf$export$515664faa1398f37 = 'navigation';
const $cadfb0b3695d9bbf$export$17ff9c46e41eb585 = 'atlassianSwitcher';
const $cadfb0b3695d9bbf$export$7598b001981cfda5 = 'atlassianSwitcherItem';
const $cadfb0b3695d9bbf$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
const $cadfb0b3695d9bbf$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
const $cadfb0b3695d9bbf$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
const $cadfb0b3695d9bbf$export$2b570fc112cbca = 'atlassianSwitcher';
const $cadfb0b3695d9bbf$export$5ed36c4d23de5568 = 'atlassianSwitcher';
const $cadfb0b3695d9bbf$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
const $cadfb0b3695d9bbf$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
const $cadfb0b3695d9bbf$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
const $cadfb0b3695d9bbf$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
const $cadfb0b3695d9bbf$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
const $cadfb0b3695d9bbf$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
const $cadfb0b3695d9bbf$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
const $cadfb0b3695d9bbf$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
const $cadfb0b3695d9bbf$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
const $cadfb0b3695d9bbf$var$RENDERED_ACTION = 'rendered';
const $cadfb0b3695d9bbf$var$NOT_RENDERED_ACTION = 'not_rendered';
const $cadfb0b3695d9bbf$var$VIEWED_ACTION = 'viewed';
const $cadfb0b3695d9bbf$export$884b1a4c7ac9dd14 = (0, $flpE4.default)($cadfb0b3695d9bbf$export$515664faa1398f37);
const $cadfb0b3695d9bbf$export$a305f130b289b818 = (attributes)=>({
        attributes: attributes
    });
const $cadfb0b3695d9bbf$export$97ebdd8e7274f18a = function(mapPropsToContext) {
    return function(WrappedComponent) {
        return (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $5ySJg.NavigationAnalyticsContext), {
                data: mapPropsToContext(props),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)(WrappedComponent, {
                    ...props
                })
            });
    };
};
const $cadfb0b3695d9bbf$var$isValidDuration = (duration)=>{
    return duration !== null && duration !== undefined && duration >= 0;
};
const $cadfb0b3695d9bbf$export$e09ad93c2b74b853 = (0, $kTviw.default)({
    onRender: (createAnalyticsEvent, props)=>{
        const duration = props.data?.duration;
        return createAnalyticsEvent({
            eventType: (0, $6d4033511f75ada1$export$12346a674644c156),
            action: $cadfb0b3695d9bbf$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: {
                ...props.data,
                ...$cadfb0b3695d9bbf$var$isValidDuration(duration) && {
                    bucket: (0, $4P5mQ.getMetricBucket)(duration, (0, $4P5mQ.RenderTrackerBuckets))
                }
            }
        }).fire($cadfb0b3695d9bbf$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $cadfb0b3695d9bbf$export$95b1f1a72cad0dcb = (0, $kTviw.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $6d4033511f75ada1$export$12346a674644c156),
            action: $cadfb0b3695d9bbf$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($cadfb0b3695d9bbf$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $cadfb0b3695d9bbf$export$b3fd6624b6a6d057 = (0, $kTviw.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $6d4033511f75ada1$export$a1562d08625f5d7e),
            action: $cadfb0b3695d9bbf$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($cadfb0b3695d9bbf$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $cadfb0b3695d9bbf$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
    if (notRenderedReason) return /*#__PURE__*/ (0, $e79Pd.jsx)($cadfb0b3695d9bbf$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            notRenderedReason: notRenderedReason
        }
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($cadfb0b3695d9bbf$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $cadfb0b3695d9bbf$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, $e79Pd.jsx)($cadfb0b3695d9bbf$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            providerFailed: providerFailed
        }
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($cadfb0b3695d9bbf$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $cadfb0b3695d9bbf$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
    if (!(0, $fO7CL.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $cadfb0b3695d9bbf$var$renderTracker({
        subject: $cadfb0b3695d9bbf$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
const $cadfb0b3695d9bbf$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    const emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if (customLinksProviderResult?.status === (0, $fO7CL.Status).ERROR) return 'custom_links_api_error';
        const error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $eUDJ0.UserSiteDataError)) return error.reason;
        else return 'usd_unknown';
    }
    const notRenderedReason = getNotRenderedReason();
    return $cadfb0b3695d9bbf$var$renderTrackerWithReason({
        subject: $cadfb0b3695d9bbf$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
const $cadfb0b3695d9bbf$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
        ...$cadfb0b3695d9bbf$export$a305f130b289b818({
            groupIndex: groupIndex,
            itemId: id,
            itemType: type,
            productType: productType,
            ...extraAttributes
        })
    });

});
parcelRegister("eUDJ0", function(module, exports) {
$parcel$export(module.exports, "UserSiteDataErrorReason", () => $0ea7d489874283f0$export$b08600051ba52198);
$parcel$export(module.exports, "UserSiteDataError", () => $0ea7d489874283f0$export$c460344055e97b1);
var $0ea7d489874283f0$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
class $0ea7d489874283f0$export$c460344055e97b1 extends Error {
    constructor(reason, message){
        super(message);
        this.name = 'UserSiteDataError';
        this.reason = reason;
    }
}

});

parcelRegister("4P5mQ", function(module, exports) {
$parcel$export(module.exports, "RenderTrackerBuckets", () => $7667afbd78b7a565$export$e59c24bc0768d568);
$parcel$export(module.exports, "getMetricBucket", () => $7667afbd78b7a565$export$b59492d26971ae92);
const $7667afbd78b7a565$var$INFINITY = '+Inf';
const $7667afbd78b7a565$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
const $7667afbd78b7a565$export$b59492d26971ae92 = (metricValue, buckets)=>{
    return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $7667afbd78b7a565$var$INFINITY) : null;
};

});


parcelRegister("gt7fJ", function(module, exports) {
$parcel$export(module.exports, "errorToReason", () => $c87590a09cbda1a1$export$a3e288208721751b);
function $c87590a09cbda1a1$export$a3e288208721751b(error) {
    const { name: name = 'Unknown', status: status } = error || {};
    return {
        name: name,
        status: status
    };
}

});

parcelRegister("6sbl3", function(module, exports) {
$parcel$export(module.exports, "retryOnException", () => $f1c8ea83b28ba8de$export$1d94629c94e7a17f);
const $f1c8ea83b28ba8de$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $f1c8ea83b28ba8de$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
    let nextMSInterval = 0;
    let error = new Error('No calls made');
    const retries = config.intervalsMS.length;
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) {
            await $f1c8ea83b28ba8de$export$5c069c93d2b7493f(nextMSInterval);
            if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
        }
        return await invokeOperation();
    } catch (e) {
        error = e;
        if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
        nextMSInterval = config.intervalsMS.shift();
    }
    throw error;
};

});

parcelRegister("1lapN", function(module, exports) {
$parcel$export(module.exports, "SwitcherExperienceTrackerContext", () => $db1f714f7c372664$export$3f3eebb4b8116461);
$parcel$export(module.exports, "useExperienceTracker", () => $db1f714f7c372664$export$cdefb2a8b53f879f);
$parcel$export(module.exports, "withExperienceTracker", () => $db1f714f7c372664$export$f88dde183f4d31cb);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $db1f714f7c372664$var$noop = ()=>{};
const $db1f714f7c372664$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $euxye.createContext)({
    start: $db1f714f7c372664$var$noop,
    success: $db1f714f7c372664$var$noop,
    failure: $db1f714f7c372664$var$noop,
    failureAll: $db1f714f7c372664$var$noop,
    abort: $db1f714f7c372664$var$noop,
    abortAll: $db1f714f7c372664$var$noop,
    markStart: $db1f714f7c372664$var$noop,
    markEnd: $db1f714f7c372664$var$noop
});
const $db1f714f7c372664$export$cdefb2a8b53f879f = ()=>(0, $euxye.useContext)($db1f714f7c372664$export$3f3eebb4b8116461);
const $db1f714f7c372664$export$f88dde183f4d31cb = (Component)=>{
    const WithExperienceTracker = (props)=>{
        const experienceTracker = $db1f714f7c372664$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
    WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
    return WithExperienceTracker;
};

});


parcelRegister("cEIt4", function(module, exports) {
$parcel$export(module.exports, "fetchJson", () => $d6dba2a98ff6389a$export$6d71b655afe1638d);
$parcel$export(module.exports, "fetchJsonWithNetworkRetries", () => $d6dba2a98ff6389a$export$16566b750080153d);
$parcel$export(module.exports, "postJson", () => $d6dba2a98ff6389a$export$c776284ef4b1209a);

var $g5IbG = parcelRequire("g5IbG");

var $6sbl3 = parcelRequire("6sbl3");

var $hZWgJ = parcelRequire("hZWgJ");
const $d6dba2a98ff6389a$var$extraJsonFromResponse = (response)=>{
    if (response.ok) return response.json();
    throw new (0, $g5IbG.FetchError)(`Unable to fetch ${response.url} ${response.status} ${response.statusText}`, response.status);
};
const $d6dba2a98ff6389a$export$6d71b655afe1638d = (url, init, emptyResponse)=>fetch(url, {
        credentials: 'include',
        ...init,
        headers: {
            'Atl-App-Switcher-Version': (0, $hZWgJ.default).packageVersion,
            ...init?.headers
        }
    }).then(!emptyResponse ? $d6dba2a98ff6389a$var$extraJsonFromResponse : ()=>{});
const $d6dba2a98ff6389a$export$16566b750080153d = (url, retryConfig, init)=>{
    return (0, $6sbl3.retryOnException)(()=>fetch(url, {
            credentials: 'include',
            ...init,
            headers: {
                'Atl-App-Switcher-Version': (0, $hZWgJ.default).packageVersion,
                ...init?.headers
            }
        }), retryConfig).then($d6dba2a98ff6389a$var$extraJsonFromResponse);
};
const $d6dba2a98ff6389a$export$c776284ef4b1209a = (url, data, emptyResponse)=>$d6dba2a98ff6389a$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }, emptyResponse);

});
parcelRegister("g5IbG", function(module, exports) {
$parcel$export(module.exports, "FETCH_ERROR_NAME", () => $a98d64d83256c139$export$83179404a61b001a);
$parcel$export(module.exports, "FetchError", () => $a98d64d83256c139$export$26e841bcf1aeb894);
const $a98d64d83256c139$export$83179404a61b001a = 'FetchError';
class $a98d64d83256c139$export$26e841bcf1aeb894 extends Error {
    constructor(message, status){
        super(message), this.name = $a98d64d83256c139$export$83179404a61b001a;
        this.status = status;
    }
    static isFetchError(value) {
        return value instanceof $a98d64d83256c139$export$26e841bcf1aeb894;
    }
}

});

parcelRegister("hZWgJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $469fe25029c3c7ae$export$2e2bcd8739ae039);
const $469fe25029c3c7ae$var$packageName = "platform-pkg";
const $469fe25029c3c7ae$var$packageVersion = "0.0.0-use.local";
const $469fe25029c3c7ae$var$_default_1 = {
    packageName: $469fe25029c3c7ae$var$packageName,
    packageVersion: $469fe25029c3c7ae$var$packageVersion
};
var $469fe25029c3c7ae$export$2e2bcd8739ae039 = $469fe25029c3c7ae$var$_default_1;

});


parcelRegister("hgltp", function(module, exports) {
$parcel$export(module.exports, "withCached", () => $3eb34c5932d0e79b$export$7f51828d6b6af163);
const $3eb34c5932d0e79b$export$d4d4b402ab64e2f4 = 5000;
const $3eb34c5932d0e79b$var$isPromise = (p)=>{
    return typeof p.then === 'function' && typeof p.catch === 'function';
};
const $3eb34c5932d0e79b$export$7f51828d6b6af163 = (fn)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        promiseCache.set(cacheKey, maybePromise);
        if ($3eb34c5932d0e79b$var$isPromise(maybePromise)) maybePromise.then((result)=>{
            resultCache.set(cacheKey, result);
            setTimeout(()=>promiseCache.delete(cacheKey), $3eb34c5932d0e79b$export$d4d4b402ab64e2f4);
        }).catch(()=>{
            promiseCache.delete(cacheKey);
        });
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});


parcelRegister("bEjWd", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $7e38ea562e7c4d3c$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "EXPERIENCE_CONFIGS", () => $7e38ea562e7c4d3c$export$d54d7a2744fdf647);
$parcel$export(module.exports, "ExperienceMark", () => $7e38ea562e7c4d3c$export$cbf1e672c3e37474);
$parcel$export(module.exports, "EXPERIENCES_TO_MARKS", () => $7e38ea562e7c4d3c$export$755e75afbd377bc4);
$parcel$export(module.exports, "MARKS_TO_EXPERIENCES", () => $7e38ea562e7c4d3c$export$805ed806e0769ee4);
$parcel$export(module.exports, "ExperienceMarkPhase", () => $7e38ea562e7c4d3c$export$ec8391a70bbdbe59);
$parcel$export(module.exports, "AbortReason", () => $7e38ea562e7c4d3c$export$279d6315a97b520d);
$parcel$export(module.exports, "SWITCHER_RENDER_START_PERFORMANCE_MARK", () => $7e38ea562e7c4d3c$export$86919b84f9a64054);

var $ipvkO = parcelRequire("ipvkO");

var $cHqEg = parcelRequire("cHqEg");
var $7e38ea562e7c4d3c$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    Experience["RENDER_THIRD_PARTY_SECTION"] = "render-third-party-section";
    return Experience;
}({});
const $7e38ea562e7c4d3c$export$d54d7a2744fdf647 = {
    ["render-custom-links-section"]: {
        type: (0, $ipvkO.ExperienceTypes).Load,
        performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switch-to-section"]: {
        type: (0, $ipvkO.ExperienceTypes).Load,
        performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switcher-empty-state"]: {
        type: (0, $ipvkO.ExperienceTypes).Load,
        performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-third-party-section"]: {
        type: (0, $ipvkO.ExperienceTypes).Load,
        performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
    }
};
var $7e38ea562e7c4d3c$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_APP_SWITCHER_BFF_GLOBAL_APPS"] = "api-app-switcher-bff-global-apps";
    ExperienceMark["API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS"] = "api-app-switcher-bff-third-party-products";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
const $7e38ea562e7c4d3c$var$allNonTestExperienceMarks = Object.values($7e38ea562e7c4d3c$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
const $7e38ea562e7c4d3c$export$755e75afbd377bc4 = {
    ["render-custom-links-section"]: $7e38ea562e7c4d3c$var$allNonTestExperienceMarks,
    ["render-switch-to-section"]: $7e38ea562e7c4d3c$var$allNonTestExperienceMarks,
    ["render-switcher-empty-state"]: $7e38ea562e7c4d3c$var$allNonTestExperienceMarks,
    ["render-third-party-section"]: $7e38ea562e7c4d3c$var$allNonTestExperienceMarks
};
const $7e38ea562e7c4d3c$export$805ed806e0769ee4 = (0, $cHqEg.invertRecordOfArrays)($7e38ea562e7c4d3c$export$755e75afbd377bc4);
var $7e38ea562e7c4d3c$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $7e38ea562e7c4d3c$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
const $7e38ea562e7c4d3c$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';

});
parcelRegister("cHqEg", function(module, exports) {
$parcel$export(module.exports, "invertRecordOfArrays", () => $ff992d33daa3c049$export$c371a74fe5222b3);
function $ff992d33daa3c049$export$c371a74fe5222b3(record) {
    const invertedRecord = {};
    Object.entries(record).forEach(([key, values])=>{
        values.forEach((value)=>{
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}

});




parcelRegister("ichIT", function(module, exports) {
$parcel$export(module.exports, "JoinableSitesProvider", () => $098c1c4ed4586389$export$70da68d3b04f82d0);
$parcel$export(module.exports, "prefetchJoinableSites", () => $098c1c4ed4586389$export$2aed3ef1595b4d9);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1FaDv = parcelRequire("1FaDv");
const { fetchMethod: $098c1c4ed4586389$var$fetchJoinableSites, ProviderComponent: $098c1c4ed4586389$var$DefaultDataProviderComponent } = (0, $1FaDv.createJoinableSitesProvider)();
const $098c1c4ed4586389$export$70da68d3b04f82d0 = ({ children: children, joinableSitesDataProvider: joinableSitesDataProvider, cloudId: cloudId })=>{
    const CustomDataProviderComponent = joinableSitesDataProvider && joinableSitesDataProvider.ProviderComponent;
    const DataProviderComponent = CustomDataProviderComponent || $098c1c4ed4586389$var$DefaultDataProviderComponent;
    return /*#__PURE__*/ (0, $e79Pd.jsx)(DataProviderComponent, {
        cloudId: cloudId,
        children: children
    });
};
$098c1c4ed4586389$export$70da68d3b04f82d0.displayName = "JoinableSitesProvider";
const $098c1c4ed4586389$export$2aed3ef1595b4d9 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod({});
        return;
    }
    $098c1c4ed4586389$var$fetchJoinableSites({});
};
const $098c1c4ed4586389$export$4ba2a997caa6db74 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod.reset();
        return;
    }
    $098c1c4ed4586389$var$fetchJoinableSites.reset();
};

});
parcelRegister("1FaDv", function(module, exports) {
$parcel$export(module.exports, "createJoinableSitesProvider", () => $242fe2eb1847a5fe$export$c3b6af53f1ca17d8);

var $hssAp = parcelRequire("hssAp");

var $bEjWd = parcelRequire("bEjWd");
const $242fe2eb1847a5fe$export$62986affcccd56a5 = ()=>Promise.resolve({
        sites: undefined
    });
const $242fe2eb1847a5fe$export$c3b6af53f1ca17d8 = (fetchData = $242fe2eb1847a5fe$export$62986affcccd56a5, retryConfig)=>{
    return (0, $hssAp.createProviderWithCustomFetchData)('joinableSites', (0, $bEjWd.ExperienceMark).API_JOINABLE_SITES, fetchData, retryConfig);
};

});


parcelRegister("e9dtM", function(module, exports) {
$parcel$export(module.exports, "default", () => $e551164a9ca73db8$export$2e2bcd8739ae039);

var $aFHNA = parcelRequire("aFHNA");
var $e551164a9ca73db8$export$2e2bcd8739ae039 = ()=>{
    (0, $aFHNA.loadAtlassianSwitcher)();
    return (0, $aFHNA.loadGenericSwitcher)();
};

});
parcelRegister("aFHNA", function(module, exports) {
$parcel$export(module.exports, "loadAtlassianSwitcher", () => $191653fce16b3617$export$6c6894dd831bfacb);
$parcel$export(module.exports, "loadGenericSwitcher", () => $191653fce16b3617$export$64191a36345a6b2b);
$parcel$export(module.exports, "AtlassianSwitcherLoader", () => $191653fce16b3617$export$25f16f9fee84a840);
$parcel$export(module.exports, "GenericSwitcherLoader", () => $191653fce16b3617$export$8c21d1a0c59fc17e);

var $e79Pd = parcelRequire("e79Pd");

var $1xwC9 = parcelRequire("1xwC9");
parcelRequire("euxye");

var $bSKOG = parcelRequire("bSKOG");

const $191653fce16b3617$export$6c6894dd831bfacb = ()=>(parcelRequire("92TY8")).then((module)=>module.default);

const $191653fce16b3617$export$64191a36345a6b2b = ()=>(parcelRequire("bQMtt")).then((module)=>module.default);
const $191653fce16b3617$export$25f16f9fee84a840 = (0, (/*@__PURE__*/$parcel$interopDefault($1xwC9)))({
    loader: $191653fce16b3617$export$6c6894dd831bfacb,
    loading: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $bSKOG.default), {})
});
const $191653fce16b3617$export$8c21d1a0c59fc17e = (0, (/*@__PURE__*/$parcel$interopDefault($1xwC9)))({
    loader: $191653fce16b3617$export$64191a36345a6b2b,
    loading: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $bSKOG.default), {})
});

});
parcelRegister("bSKOG", function(module, exports) {
$parcel$export(module.exports, "default", () => $442be2a1ab5feb09$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.38.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");

var $bEjWd = parcelRequire("bEjWd");
var $6qxjn = parcelRequire("6qxjn");

var $1YIbA = parcelRequire("1YIbA");

var $2c4kh = parcelRequire("2c4kh");
/*
  In the Remote App Switcher, the Skeleton component shows up first as a fallback while the full Remote App Switcher is still loading.
  Since the styles (compiled CSS) are lazy-loaded with the full App Switcher, they are not be ready when the Skeleton appears.
  This causes visual issues where the Skeleton looks broken

  To avoid this, we use inline styles instead. This guarantees that all required styles are applied immediately with the component.
  https://hello.jira.atlassian.cloud/browse/NAVX-676
*/ const $442be2a1ab5feb09$var$iconSkeleton = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
    style: {
        display: 'inline-block',
        width: 32,
        height: 32,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-large, 8px)",
        marginRight: "var(--ds-space-100, 8px)"
    }
});
const $442be2a1ab5feb09$var$lineSkeleton = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
    style: {
        display: 'inline-block',
        width: 260,
        height: 10,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-small, 4px)"
    }
});
var $442be2a1ab5feb09$export$2e2bcd8739ae039 = ()=>{
    (0, $6qxjn.useExperienceRenderAndMountMark)((0, $bEjWd.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const items = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            paddingInline: "var(--ds-space-200, 16px)",
            paddingBlock: "var(--ds-space-100, 8px)",
            alignItems: 'center'
        },
        children: [
            $442be2a1ab5feb09$var$iconSkeleton,
            $442be2a1ab5feb09$var$lineSkeleton
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
        as: "section",
        style: {
            width: '343px',
            height: '80vh'
        },
        role: "alert",
        "aria-label": formatMessage((0, $2c4kh.default).skeletonLoaderAriaLabel),
        testId: "skeleton",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                "aria-hidden": "true",
                style: {
                    paddingInline: "var(--ds-space-200, 16px)",
                    paddingTop: "var(--ds-space-300, 24px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                },
                children: $442be2a1ab5feb09$var$lineSkeleton
            }),
            items,
            items,
            items
        ]
    });
};

});
parcelRegister("6qxjn", function(module, exports) {
$parcel$export(module.exports, "useExperienceSuccess", () => $e43d14ba8d148d72$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceRenderAndMountMark", () => $e43d14ba8d148d72$export$fb30551804b67d63);
/* eslint-disable no-console */ 
var $1lapN = parcelRequire("1lapN");

var $euxye = parcelRequire("euxye");

var $8UL72 = parcelRequire("8UL72");
function $e43d14ba8d148d72$export$675e0d25df38d426(experienceName, customStartTime) {
    const experienceTracker = (0, $1lapN.useExperienceTracker)();
    (0, $8UL72.useOnceImmediately)(()=>experienceTracker.start(experienceName, customStartTime));
}
function $e43d14ba8d148d72$export$e94f0da4fc0603c6(experience, attributes) {
    const experienceTracker = (0, $1lapN.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $euxye.useLayoutEffect)(()=>experienceTracker.success(experience, attributes), []);
}
function $e43d14ba8d148d72$export$fb30551804b67d63(mark) {
    const experienceTracker = (0, $1lapN.useExperienceTracker)();
    (0, $8UL72.useOnceImmediately)(()=>experienceTracker.markStart(mark));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $euxye.useLayoutEffect)(()=>experienceTracker.markEnd(mark), []);
}

});
parcelRegister("8UL72", function(module, exports) {
$parcel$export(module.exports, "useSingleton", () => $2cab55d0131dcfe6$export$abf4268d2dd55708);
$parcel$export(module.exports, "useOnceImmediately", () => $2cab55d0131dcfe6$export$ad4f8d0eee7a0e24);

var $euxye = parcelRequire("euxye");
function $2cab55d0131dcfe6$export$abf4268d2dd55708(builder) {
    const ref = (0, $euxye.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $2cab55d0131dcfe6$export$ad4f8d0eee7a0e24(callback) {
    const wasCalledRef = (0, $euxye.useRef)(false);
    const result = (0, $euxye.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}

});


parcelRegister("2c4kh", function(module, exports) {
$parcel$export(module.exports, "default", () => $220383aa51cae344$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $220383aa51cae344$var$messages = (0, $7eNDO.defineMessages)({
    newLozenge: {
        id: 'fabric.atlassianSwitcher.newLozenge',
        defaultMessage: 'New',
        description: 'The lozenge text for a lozenge indicating a new switcher item'
    },
    tryLozenge: {
        id: 'fabric.atlassianSwitcher.tryLozenge',
        defaultMessage: 'Try',
        description: 'Alternative lozenge text for a lozenge indicating a new switcher item'
    },
    sites: {
        id: 'fabric.atlassianSwitcher.sites',
        defaultMessage: '{productName} {numSites, plural, one {site} other {sites}}',
        description: 'The text of a toggle showing or hiding more site options'
    },
    skeletonLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeletonLoaderAriaLabel',
        defaultMessage: 'The App Switcher is loading',
        description: 'The aria-label for the app switcher skeleton loader primitive'
    },
    skeleton3pLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeleton3pLoaderAriaLabel',
        defaultMessage: 'The App Switcher third party section is loading',
        description: 'The aria-label for the app switcher third party skeleton loader primitive'
    },
    reorderItemDropdown: {
        id: 'fabric.atlassianSwitcher.reorderItemDropdown',
        defaultMessage: 'Reorder menu item',
        description: 'The text of a button to reorder an item in the switcher'
    },
    moveItemUp: {
        id: 'fabric.atlassianSwitcher.moveItemUp',
        defaultMessage: 'Move up',
        description: 'The text of a button to move an item up in the switcher'
    },
    moveItemDown: {
        id: 'fabric.atlassianSwitcher.moveItemDown',
        defaultMessage: 'Move down',
        description: 'The text of a button to move an item down in the switcher'
    },
    moveItemToTop: {
        id: 'fabric.atlassianSwitcher.moveItemToTop',
        defaultMessage: 'Move to top',
        description: 'The text of a button to move an item to the top in the switcher'
    },
    moveItemToBottom: {
        id: 'fabric.atlassianSwitcher.moveItemToBottom',
        defaultMessage: 'Move to bottom',
        description: 'The text of a button to move an item to the bottom in the switcher'
    }
});
var $220383aa51cae344$export$2e2bcd8739ae039 = $220383aa51cae344$var$messages;

});


parcelRegister("92TY8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("37VHt").then(()=>parcelRequire('jqGts'));

});

parcelRegister("bQMtt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bnbJv").then(()=>parcelRequire('aIQFb'));

});



parcelRegister("1tP1L", function(module, exports) {
$parcel$export(module.exports, "FlightDeckProvider", () => $73cdba4c9ab5b562$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "prefetchFlightDeck", () => $73cdba4c9ab5b562$export$7d2a567d3e50224);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $2ejVE = parcelRequire("2ejVE");

var $hssAp = parcelRequire("hssAp");

var $bEjWd = parcelRequire("bEjWd");

var $fSoqG = parcelRequire("fSoqG");

var $l1vE2 = parcelRequire("l1vE2");


var $6bWJ9 = parcelRequire("6bWJ9");
const $73cdba4c9ab5b562$var$client = new (0, $2ejVE.default)('atlassian-switcher', {
    handlers: {},
    // Switch the FD default storage from localStorage to sessionStorage to avoid issues related to GDPR policy.
    // The storageEngine option isn't exposed directly by the FD SDK, but you can still pass it in
    // https://hello.jira.atlassian.cloud/browse/NAVX-658
    //@ts-ignore
    storageEngine: 'sessionStorage'
});
const { fetchMethod: $73cdba4c9ab5b562$var$fetchFlightDeck, ProviderComponent: $73cdba4c9ab5b562$var$DefaultFlightDeckProviderComponent } = (0, $hssAp.createProviderWithCustomFetchData)('flightDeck', (0, $bEjWd.ExperienceMark).API_FLIGHT_DECK, async ()=>{
    const artifact = await $73cdba4c9ab5b562$var$client.fetchConfigFromFlightDeck({
        name: 'app-switcher-fe',
        dimensions: {
            environmentType: 'prod',
            perimeter: (0, $l1vE2.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
        }
    });
    return $73cdba4c9ab5b562$var$transformFlightDeckArtifactToProductConfiguration(artifact);
});
const $73cdba4c9ab5b562$var$transformFlightDeckArtifactToProductConfiguration = (artifact)=>{
    const artifactMap = new Map();
    for (const product of artifact.products){
        const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey } = product;
        artifactMap.set(apsKey, {
            key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
            href: siteUrlSuffix,
            ordinal: ordinal,
            label: (0, $fSoqG.formatLabel)(displayName),
            description: (0, $fSoqG.formatDescription)(subtitle),
            iconKey: iconKey
        });
        // TODO: remove this once Asset app becomes standalone app
        if (apsKey === 'JIRA_SERVICE_DESK' && !artifactMap.has((0, $f50a465f4b3fb0e5$export$45e63649edff1e2a))) artifactMap.set((0, $f50a465f4b3fb0e5$export$45e63649edff1e2a), {
            key: (0, $f50a465f4b3fb0e5$export$45e63649edff1e2a),
            href: '/jira/assets',
            ordinal: ordinal + 0.1,
            label: (0, $fSoqG.formatLabel)((0, $6bWJ9.default).assets),
            iconKey: 'assets'
        });
    }
    return {
        products: Object.fromEntries(artifactMap),
        links: Object.fromEntries(artifact.links.map(({ apsKey: apsKey, ...link })=>[
                apsKey,
                {
                    ...link,
                    key: apsKey.toLowerCase(),
                    href: link.url,
                    label: (0, $fSoqG.formatLabel)(link.displayName),
                    description: (0, $fSoqG.formatDescription)(link.subtitle),
                    iconKey: 'admin'
                }
            ]))
    };
};
const $73cdba4c9ab5b562$export$56da85ac9d40dbcd = ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)($73cdba4c9ab5b562$var$DefaultFlightDeckProviderComponent, {
        children: children
    });
$73cdba4c9ab5b562$export$56da85ac9d40dbcd.displayName = "FlightDeckProvider";
const $73cdba4c9ab5b562$export$7d2a567d3e50224 = $73cdba4c9ab5b562$var$fetchFlightDeck;

});
parcelRegister("2ejVE", function(module, exports) {
$parcel$export(module.exports, "default", () => $19fc590e7c768c14$export$2e2bcd8739ae039);

var $35jf9 = parcelRequire("35jf9");

var $aLc3c = parcelRequire("aLc3c");

var $8faAl = parcelRequire("8faAl");

var $92nVR = parcelRequire("92nVR");
var $4dNkI = parcelRequire("4dNkI");

var $g0tPx = parcelRequire("g0tPx");

var $1LlmX = parcelRequire("1LlmX");

var $4yHXp = parcelRequire("4yHXp");
function $19fc590e7c768c14$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $19fc590e7c768c14$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $19fc590e7c768c14$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $35jf9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $19fc590e7c768c14$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $19fc590e7c768c14$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $19fc590e7c768c14$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $19fc590e7c768c14$export$2e2bcd8739ae039 {
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $35jf9.default)(this, "fallbackArtifactMap", new Map());
        (0, $35jf9.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $8faAl.default)($19fc590e7c768c14$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $1LlmX.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $aLc3c.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $92nVR.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $g0tPx.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$19fc590e7c768c14$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = Math.random() < 0.001 ? (0, $4yHXp.flightDeckClientExperience)() : new (0, $4dNkI.MockExperience)();
        experience.start();
        try {
            const artifactWithKey = $19fc590e7c768c14$var$_objectSpread($19fc590e7c768c14$var$_objectSpread({}, artifact), {}, {
                key: (0, $1LlmX.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $4yHXp.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
}

});
parcelRegister("aLc3c", function(module, exports) {
$parcel$export(module.exports, "retryOnException", () => $7c74dc7c6ef9a366$export$1d94629c94e7a17f);
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("4DMDt")).default);

var $fSsxt = parcelRequire("fSsxt");

var $95via = parcelRequire("95via");

var $4DMDt = parcelRequire("4DMDt");
const $7c74dc7c6ef9a366$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $7c74dc7c6ef9a366$var$NO_CALLS_ERROR = 'No calls made';
const $7c74dc7c6ef9a366$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $95via.NO_RETRIES), retryOn: retryOn = [
    (0, $4DMDt.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($7c74dc7c6ef9a366$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $7c74dc7c6ef9a366$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $7c74dc7c6ef9a366$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $fSsxt.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};

});
parcelRegister("95via", function(module, exports) {
$parcel$export(module.exports, "NO_RETRIES", () => $737bda19f9da9a03$export$a0a1c8f90becc136);
const $737bda19f9da9a03$export$a0a1c8f90becc136 = [];
const $737bda19f9da9a03$export$972171517b12aa4 = [
    0,
    0
];
const $737bda19f9da9a03$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $737bda19f9da9a03$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("4DMDt", function(module, exports) {
$parcel$export(module.exports, "default", () => $291975800427ce48$export$2e2bcd8739ae039);
class $291975800427ce48$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}

});


parcelRegister("92nVR", function(module, exports) {
$parcel$export(module.exports, "fetchFlightDeckConfiguration", () => $6946dd6b7e1fa2d2$export$6026918e023c9101);

var $eVacJ = parcelRequire("eVacJ");

var $7snsH = parcelRequire("7snsH");

var $djdCq = parcelRequire("djdCq");

var $4LGip = parcelRequire("4LGip");

var $iQae5 = parcelRequire("iQae5");

var $4dNkI = parcelRequire("4dNkI");

var $kA6Wc = parcelRequire("kA6Wc");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $6946dd6b7e1fa2d2$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $6946dd6b7e1fa2d2$var$defaultPerimeter = "commercial";
async function $6946dd6b7e1fa2d2$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter, _dim$impactLevel;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $6946dd6b7e1fa2d2$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $6946dd6b7e1fa2d2$var$defaultPerimeter;
    // Needed for backwards compatibility with Flight Deck core, reference perimeter
    const impactLevel = (_dim$impactLevel = dim.impactLevel) !== null && _dim$impactLevel !== void 0 ? _dim$impactLevel : perimeter;
    const environment = $6946dd6b7e1fa2d2$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $eVacJ.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        impactLevel: impactLevel,
        environment: environment,
        locale: locale
    };
    const client = await $6946dd6b7e1fa2d2$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $6946dd6b7e1fa2d2$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $6946dd6b7e1fa2d2$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $6946dd6b7e1fa2d2$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $6946dd6b7e1fa2d2$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $6946dd6b7e1fa2d2$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $4dNkI.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $4dNkI.getVersionMetadataFetchExperience)();
    return new (0, $iQae5.ConfigClient)(new (0, $djdCq.BifrostDataSource)(new (0, $4LGip.BifrostHttpClientImpl)(env, perimeter), (0, $7snsH.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $6946dd6b7e1fa2d2$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("eVacJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8132351a9fdb818d$export$2e2bcd8739ae039);
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $8132351a9fdb818d$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $8132351a9fdb818d$export$2e2bcd8739ae039 = $8132351a9fdb818d$export$852ff24d0930c62f;

});

parcelRegister("7snsH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $7c0PD = parcelRequire("7c0PD");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $7c0PD.Either;
    }
});

var $gNzIO = parcelRequire("gNzIO");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $gNzIO.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $gNzIO.tryGetArtifactData;
    }
});

var $1y2Cc = parcelRequire("1y2Cc");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $1y2Cc.parseArtifactManifest;
    }
});

var $9Dk2G = parcelRequire("9Dk2G");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $9Dk2G.parseVersionMetadata;
    }
});

var $da6JY = parcelRequire("da6JY");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $da6JY.checkManifest;
    }
});

var $1s6kS = parcelRequire("1s6kS");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $1s6kS.ConfigRegistryDataSource;
    }
});

var $jSYg0 = parcelRequire("jSYg0");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $jSYg0.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $jSYg0.Versions;
    }
});

});
parcelRegister("7c0PD", function(module, exports) {
"use strict";
var $53ca4c9919968f57$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $53ca4c9919968f57$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $53ca4c9919968f57$var$Right(value);
    };
    Either.left = function(error) {
        return new $53ca4c9919968f57$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $53ca4c9919968f57$var$Either;
var $53ca4c9919968f57$var$Right = /** @class */ function(_super) {
    $53ca4c9919968f57$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $53ca4c9919968f57$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $53ca4c9919968f57$var$Either.right(this.right);
    };
    return Right;
}($53ca4c9919968f57$var$Either);
var $53ca4c9919968f57$var$Left = /** @class */ function(_super) {
    $53ca4c9919968f57$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $53ca4c9919968f57$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $53ca4c9919968f57$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $53ca4c9919968f57$var$Either.left(f(this.left));
    };
    return Left;
}($53ca4c9919968f57$var$Either);

});

parcelRegister("gNzIO", function(module, exports) {
"use strict";
var $c3acee882dd3a01d$var$__assign = module.exports && module.exports.__assign || function() {
    $c3acee882dd3a01d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c3acee882dd3a01d$var$__assign.apply(this, arguments);
};
var $c3acee882dd3a01d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c3acee882dd3a01d$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $c3acee882dd3a01d$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $c3acee882dd3a01d$var$tryGetArtifactData;

var $g8Fef = parcelRequire("g8Fef");

var $7snsH = parcelRequire("7snsH");

var $5Rm4p = parcelRequire("5Rm4p");

var $3L3Q4 = parcelRequire("3L3Q4");

var $bdw3j = parcelRequire("bdw3j");
function $c3acee882dd3a01d$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $c3acee882dd3a01d$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $c3acee882dd3a01d$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $c3acee882dd3a01d$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $c3acee882dd3a01d$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $7snsH.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $5Rm4p.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $c3acee882dd3a01d$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $3L3Q4.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $c3acee882dd3a01d$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $c3acee882dd3a01d$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $c3acee882dd3a01d$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $g8Fef.interpolateTagScheme)(manifest.tagScheme, $c3acee882dd3a01d$var$__assign($c3acee882dd3a01d$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $c3acee882dd3a01d$var$__awaiter(_this, void 0, void 0, function() {
                                return $c3acee882dd3a01d$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $c3acee882dd3a01d$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $bdw3j.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $bdw3j.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $3L3Q4.assertUnreachable)(artifact);
    }
}

});
parcelRegister("g8Fef", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $bbfd5fe1d69f2821$var$interpolateTagScheme;
module.exports.generateTagScheme = $bbfd5fe1d69f2821$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $bbfd5fe1d69f2821$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $bbfd5fe1d69f2821$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $bbfd5fe1d69f2821$var$getVersionMetadataTag;
const $bbfd5fe1d69f2821$var$TAG_SCHEME_VERSION = 2;
function $bbfd5fe1d69f2821$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($bbfd5fe1d69f2821$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $bbfd5fe1d69f2821$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $bbfd5fe1d69f2821$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $bbfd5fe1d69f2821$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $bbfd5fe1d69f2821$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $bbfd5fe1d69f2821$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $bbfd5fe1d69f2821$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $bbfd5fe1d69f2821$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("5Rm4p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $444305a34c325554$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $444305a34c325554$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("3L3Q4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $2bc8bd2c482acdd8$var$assertUnreachable;
function $2bc8bd2c482acdd8$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("bdw3j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $82a9c589b79ff2ee$var$toJson;
module.exports.toPrettyJson = $82a9c589b79ff2ee$var$toPrettyJson;
function $82a9c589b79ff2ee$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $82a9c589b79ff2ee$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});


parcelRegister("1y2Cc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $120afeb751be302c$var$parseArtifactManifest;

var $fxVmw = parcelRequire("fxVmw");
function $120afeb751be302c$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $fxVmw.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $fxVmw.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $120afeb751be302c$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $fxVmw.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $120afeb751be302c$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $120afeb751be302c$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $fxVmw.parseUnknownObject)(dimensions);
    var supported = (0, $fxVmw.parseArray)(unparsedDimensions.supported).map($fxVmw.parseString);
    var fallback = (0, $fxVmw.parseUndefinedOr)($fxVmw.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $120afeb751be302c$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $fxVmw.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $120afeb751be302c$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $120afeb751be302c$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $fxVmw.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $fxVmw.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $fxVmw.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $fxVmw.parseUndefinedOr)($fxVmw.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $120afeb751be302c$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $120afeb751be302c$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});
parcelRegister("fxVmw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $b5166f04a9252c68$var$parseString;
module.exports.parseArray = $b5166f04a9252c68$var$parseArray;
module.exports.parseBoolean = $b5166f04a9252c68$var$parseBoolean;
module.exports.parseUnknownObject = $b5166f04a9252c68$var$parseUnknownObject;
module.exports.parseUndefinedOr = $b5166f04a9252c68$var$parseUndefinedOr;
function $b5166f04a9252c68$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $b5166f04a9252c68$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $b5166f04a9252c68$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $b5166f04a9252c68$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $b5166f04a9252c68$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});


parcelRegister("9Dk2G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $70374d9063331675$var$parseVersionMetadata;

var $fxVmw = parcelRequire("fxVmw");
function $70374d9063331675$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $fxVmw.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $fxVmw.parseString)(unknownObject.version);
    var publishTime = new Date((0, $fxVmw.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $fxVmw.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("da6JY", function(module, exports) {
"use strict";
var $9951700f509a4fb0$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $9951700f509a4fb0$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $9951700f509a4fb0$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $9951700f509a4fb0$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("1s6kS", function(module, exports) {
"use strict";
var $10ed52197fd89157$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $10ed52197fd89157$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $g8Fef = parcelRequire("g8Fef");

var $7c0PD = parcelRequire("7c0PD");

var $1y2Cc = parcelRequire("1y2Cc");

var $9Dk2G = parcelRequire("9Dk2G");
var $10ed52197fd89157$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $10ed52197fd89157$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $10ed52197fd89157$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $g8Fef.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($1y2Cc.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $7c0PD.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $10ed52197fd89157$var$__awaiter(this, void 0, void 0, function() {
            return $10ed52197fd89157$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $10ed52197fd89157$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $10ed52197fd89157$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $g8Fef.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $9Dk2G.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $10ed52197fd89157$var$ConfigRegistryDataSource;

});

parcelRegister("jSYg0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $e7a1cd4307efb5b0$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $e7a1cd4307efb5b0$var$BaseUrls;
var $e7a1cd4307efb5b0$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $e7a1cd4307efb5b0$var$Versions;

});


parcelRegister("djdCq", function(module, exports) {
$parcel$export(module.exports, "BifrostDataSource", () => $9b079d188572d76a$export$2cb8d79200775058);

var $7snsH = parcelRequire("7snsH");

var $g8Fef = parcelRequire("g8Fef");
class $9b079d188572d76a$export$2cb8d79200775058 {
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
    async getLatestVersionMetadata() {
        const tag = (0, $g8Fef.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $7snsH.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $7snsH.parseVersionMetadata)(response);
                return (0, $7snsH.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $7snsH.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $g8Fef.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $7snsH.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $7snsH.parseArtifactManifest)(response);
                return (0, $7snsH.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $7snsH.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
}

});

parcelRegister("4LGip", function(module, exports) {
$parcel$export(module.exports, "BifrostHttpClientImpl", () => $378c5c527b8b5052$export$45c6d12ca9c14f83);

var $7snsH = parcelRequire("7snsH");
function $378c5c527b8b5052$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $378c5c527b8b5052$export$45c6d12ca9c14f83 {
    constructor(env, perimeter){
        this.baseUrl = $378c5c527b8b5052$export$f654b28f82155665(env, perimeter);
    }
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $7snsH.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $7snsH.Either).right(json)));
            }).catch((error)=>resolve((0, $7snsH.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
}

});

parcelRegister("iQae5", function(module, exports) {
$parcel$export(module.exports, "ConfigClient", () => $db750405e0dfeb48$export$8489e2f039bfcc4c);

var $35jf9 = parcelRequire("35jf9");

var $7snsH = parcelRequire("7snsH");

var $9kLQj = parcelRequire("9kLQj");
function $db750405e0dfeb48$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $db750405e0dfeb48$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $db750405e0dfeb48$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $35jf9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $db750405e0dfeb48$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $db750405e0dfeb48$export$8489e2f039bfcc4c {
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $9kLQj.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $db750405e0dfeb48$var$_objectSpread($db750405e0dfeb48$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $7snsH.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $7snsH.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
}

});
parcelRegister("9kLQj", function(module, exports) {
$parcel$export(module.exports, "ExperienceDataSourceWrapper", () => $6cbb17e0f4f81e4d$export$1cc944571619e6e8);
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $6cbb17e0f4f81e4d$export$1cc944571619e6e8 {
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
}

});


parcelRegister("4dNkI", function(module, exports) {
$parcel$export(module.exports, "MockExperience", () => $312ea4db790f3dd3$export$5e7536cf7bc56fee);
$parcel$export(module.exports, "getFlightDeckFetchExperience", () => $312ea4db790f3dd3$export$a3006f8f221c0a3b);
$parcel$export(module.exports, "getVersionMetadataFetchExperience", () => $312ea4db790f3dd3$export$c3ac7702bfd47c1b);
const $312ea4db790f3dd3$var$SAMPLING_RATE = 10;
class $312ea4db790f3dd3$var$UFOExperienceWrapper {
    constructor(experience){
        this.experience = experience;
    }
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
}
class $312ea4db790f3dd3$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $312ea4db790f3dd3$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $312ea4db790f3dd3$var$SAMPLING_RATE) return new $312ea4db790f3dd3$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("9DqmU"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $312ea4db790f3dd3$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $312ea4db790f3dd3$export$5e7536cf7bc56fee();
    }
}
const $312ea4db790f3dd3$export$a3006f8f221c0a3b = ()=>$312ea4db790f3dd3$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $312ea4db790f3dd3$export$c3ac7702bfd47c1b = ()=>$312ea4db790f3dd3$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("9DqmU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5CIq7").then(()=>parcelRequire('4Fnfz'));

});


parcelRegister("kA6Wc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $ex5is = parcelRequire("ex5is");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $ex5is.parseConfigWithTargeting;
    }
});

var $6I9tO = parcelRequire("6I9tO");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $6I9tO.TargetedConfig;
    }
});

});
parcelRegister("ex5is", function(module, exports) {
"use strict";
var $a948418ba681fc57$var$__assign = module.exports && module.exports.__assign || function() {
    $a948418ba681fc57$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a948418ba681fc57$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $a948418ba681fc57$var$parseConfigWithTargeting;

var $6I9tO = parcelRequire("6I9tO");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $a948418ba681fc57$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $a948418ba681fc57$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $6I9tO.TargetedConfig({
                defaultConfig: $a948418ba681fc57$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $a948418ba681fc57$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $6I9tO.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $a948418ba681fc57$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $a948418ba681fc57$var$__assign($a948418ba681fc57$var$__assign({}, accObject), (_a = {}, _a[key] = $a948418ba681fc57$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $a948418ba681fc57$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $a948418ba681fc57$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $a948418ba681fc57$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $a948418ba681fc57$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $a948418ba681fc57$var$parseIdentifierList(target.orgIds),
            siteIds: $a948418ba681fc57$var$parseIdentifierList(target.siteIds),
            userIds: $a948418ba681fc57$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $a948418ba681fc57$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("6I9tO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $4e2e34a543db756f$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $4e2e34a543db756f$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $4e2e34a543db756f$var$TargetedConfig;
function $4e2e34a543db756f$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("g0tPx", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba73c91c690d2cbc$export$2e2bcd8739ae039);
class $ba73c91c690d2cbc$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
        this.perimeter = dimensions === null || dimensions === void 0 ? void 0 : dimensions.perimeter;
    }
}
const $ba73c91c690d2cbc$export$1d76d155060824c9 = (e)=>e instanceof $ba73c91c690d2cbc$export$2e2bcd8739ae039;

});

parcelRegister("1LlmX", function(module, exports) {
$parcel$export(module.exports, "artifactKey", () => $148ac1bc082a75f3$export$e3553dc63541d477);
const $148ac1bc082a75f3$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("4yHXp", function(module, exports) {
$parcel$export(module.exports, "flightDeckClientExperience", () => $351c6f5e090c533b$export$1e3a41a51f6457c5);
$parcel$export(module.exports, "exceptionToMetadata", () => $351c6f5e090c533b$export$f33622abb5224195);

var $35jf9 = parcelRequire("35jf9");

var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");
function $351c6f5e090c533b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $351c6f5e090c533b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $351c6f5e090c533b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $35jf9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $351c6f5e090c533b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $351c6f5e090c533b$export$1e3a41a51f6457c5 = ()=>new (0, $jkqqC.UFOExperience)("retrieve-artifact", {
        type: (0, $ipvkO.ExperienceTypes).Operation,
        performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $351c6f5e090c533b$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $351c6f5e090c533b$var$_objectSpread($351c6f5e090c533b$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});


parcelRegister("fSoqG", function(module, exports) {
$parcel$export(module.exports, "formatLabel", () => $b3562a595c8eeb0c$export$957d7daebd899f12);
$parcel$export(module.exports, "formatDescription", () => $b3562a595c8eeb0c$export$f731e929548061dc);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");
const $b3562a595c8eeb0c$export$957d7daebd899f12 = (label)=>{
    return typeof label === 'string' ? label : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        ...label
    });
};
const $b3562a595c8eeb0c$export$f731e929548061dc = (description)=>{
    return typeof description === 'string' ? description : description ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        ...description
    }) : null;
};

});

const $f50a465f4b3fb0e5$export$45e63649edff1e2a = 'ASSETS';
const $f50a465f4b3fb0e5$export$eb7589a4ee50c678 = 'tenantless';

parcelRegister("6bWJ9", function(module, exports) {
$parcel$export(module.exports, "default", () => $ace7ed4312bc47be$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $ace7ed4312bc47be$var$messages = (0, $7eNDO.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.title',
        defaultMessage: 'Get started with cloud',
        description: 'The title text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsBody: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body',
        defaultMessage: 'Try a product to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLink: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link',
        defaultMessage: 'Explore products',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    home: {
        id: 'fabric.atlassianSwitcher.atlassianHome',
        defaultMessage: 'Home',
        description: 'The text of a link redirecting the user to the Home site'
    },
    rovo: {
        id: 'fabric.atlassianSwitcher.rovo-home',
        defaultMessage: 'Rovo Home',
        description: 'The text of a link redirecting the user to the rovo home site'
    },
    administration: {
        id: 'fabric.atlassianSwitcher.administration',
        defaultMessage: 'Administration',
        description: 'The text of a link redirecting the user to Administration'
    },
    atlassianStart: {
        id: 'fabric.atlassianSwitcher.start',
        defaultMessage: 'Atlassian Start',
        description: 'The text of a link redirecting the user to the Start site'
    },
    assets: {
        id: 'fabric.atlassianSwitcher.assets',
        defaultMessage: 'Assets',
        description: 'The text of a link redirecting the user to the Assets'
    },
    analytics: {
        id: 'fabric.atlassianSwitcher.analytics',
        defaultMessage: 'Analytics',
        description: 'The text of a link redirecting the user to the Analytics'
    },
    companyHub: {
        id: 'fabric.atlassianSwitcher.companyHub',
        defaultMessage: 'Company Hub',
        description: 'The text of a link redirecting the user to the Company Hub'
    },
    goals: {
        id: 'fabric.atlassianSwitcher.goals',
        defaultMessage: 'Goals',
        description: 'The text of a link redirecting the user to the Goals'
    },
    projects: {
        id: 'fabric.atlassianSwitcher.projects',
        defaultMessage: 'Projects',
        description: 'The text of a link redirecting the user to the Projects'
    },
    teams: {
        id: 'fabric.atlassianSwitcher.teams',
        defaultMessage: 'Teams',
        description: 'The text of a link redirecting the user to the Teams'
    },
    search: {
        id: 'fabric.atlassianSwitcher.search',
        defaultMessage: 'Search',
        description: 'The text of a link redirecting the user to the Search'
    },
    chat: {
        id: 'fabric.atlassianSwitcher.chat',
        defaultMessage: 'Chat',
        description: 'The text of a link redirecting the user to the Chat'
    },
    studio: {
        id: 'fabric.atlassianSwitcher.studio',
        defaultMessage: 'Studio',
        description: 'The text of a link redirecting the user to the Studio'
    },
    rovoSearch: {
        id: 'fabric.atlassianSwitcher.rovo-search',
        defaultMessage: 'Rovo Search',
        description: 'The text of a link redirecting the user to Rovo Search app'
    },
    rovoChat: {
        id: 'fabric.atlassianSwitcher.rovo-chat',
        defaultMessage: 'Rovo Chat',
        description: 'The text of a link redirecting the user to the Rovo Chat app'
    },
    rovoStudio: {
        id: 'fabric.atlassianSwitcher.rovo-studio',
        defaultMessage: 'Rovo Studio',
        description: 'The text of a link redirecting the user to Rovo Studio app'
    },
    manageList: {
        id: 'fabric.atlassianSwitcher.manageList',
        defaultMessage: 'Manage list',
        description: 'This text is for the action for a user to manage the values present in an editable list of links.'
    },
    errorEmptyPartialResults: {
        id: 'fabric.atlassianSwitcher.errorEmptyPartialResults',
        defaultMessage: "We can't display your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and no sites'
    },
    errorHeading: {
        id: 'fabric.atlassianSwitcher.errorHeading',
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorText: {
        id: 'fabric.atlassianSwitcher.errorText',
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the Atlassian Switcher.'
    },
    errorImageAltText: {
        id: 'fabric.atlassianSwitcher.errorImageAltText',
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the Atlassian Switcher'
    },
    errorTextNetwork: {
        id: 'fabric.atlassianSwitcher.errorTextNetwork',
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again.",
        description: 'Text that is displayed when we detect a network issue.'
    },
    errorHeadingLoggedOut: {
        id: 'fabric.atlassianSwitcher.errorHeadingLoggedOut',
        defaultMessage: 'Your Atlassian account is logged out',
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorHeadingUnverified: {
        id: 'fabric.atlassianSwitcher.errorHeadingUnverified',
        defaultMessage: 'Your account is unverified',
        description: 'Heading that is displayed when we detect user account is unverified.'
    },
    errorPartialResults: {
        id: 'fabric.atlassianSwitcher.errorPartialResults',
        defaultMessage: "We can't display some of your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and 1 or more sites'
    },
    errorPartialResultsRefresh: {
        id: 'fabric.atlassianSwitcher.errorPartialResultsRefresh',
        defaultMessage: 'Refresh the page, or try again later.',
        description: 'Subtitle of the error message when available products returns a partial result'
    },
    errorTextUnverified: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified',
        defaultMessage: 'Please confirm your email address to view a list of available products.',
        description: 'Text that is displayed when we detect user account is unverified.'
    },
    productDescriptionConfluence: {
        id: 'fabric.atlassianSwitcher.product.description.confluence',
        defaultMessage: 'Document collaboration',
        description: 'Text displayed under the Confluence product recommendation.'
    },
    productDescriptionJiraServiceManagement: {
        id: 'fabric.atlassianSwitcher.product.description.jsm',
        defaultMessage: 'Collaborative IT service management',
        description: 'Text displayed under the Jira Service Management product recommendation.'
    },
    productDescriptionJiraSoftware: {
        id: 'fabric.atlassianSwitcher.product.description.jsw',
        defaultMessage: 'Project and issue tracking',
        description: 'Text displayed under the Jira Software product recommendation.'
    },
    productDescriptionOpsgenie: {
        id: 'fabric.atlassianSwitcher.product.description.opsgenie',
        defaultMessage: 'Modern incident management',
        description: 'Text displayed under the Opsgenie product recommendation.'
    },
    productDescriptionCompass: {
        id: 'fabric.atlassianSwitcher.product.description.compass',
        defaultMessage: 'Component manager',
        description: 'Text displayed under the Compass product recommendation.'
    },
    join: {
        id: 'fabric.atlassianSwitcher.join',
        defaultMessage: 'Join',
        description: 'Section Header in Atlassian Switcher. To set the expectation of what items would be shown in following section. Shown when an user has at least one joinable site via Domain Enabled Sign up with common collaborators.'
    },
    expandProductList: {
        id: 'fabric.atlassianSwitcher.expandProductList',
        defaultMessage: '{numItems} more',
        description: 'Text for the button that expands the product list in the Atlassian Switcher.'
    },
    collapseProductList: {
        id: 'fabric.atlassianSwitcher.contractProductList',
        defaultMessage: 'Less',
        description: 'Text for the button that collapses the product list in the Atlassian Switcher.'
    },
    emptyStateExploreProductsBodyAppify: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body-appify',
        defaultMessage: 'Try an app to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLinkAppify: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link-appify',
        defaultMessage: 'Explore apps',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    errorTextUnverifiedAppify: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified-appify',
        defaultMessage: 'Please confirm your email address to view a list of available apps.',
        description: 'Text that is displayed when we detect user account is unverified.'
    }
});
var $ace7ed4312bc47be$export$2e2bcd8739ae039 = $ace7ed4312bc47be$var$messages;

});


parcelRegister("29Fdj", function(module, exports) {
$parcel$export(module.exports, "ThirdPartyProductsProvider", () => $5a41f46a69ad0cec$export$a7ffda257898c103);
$parcel$export(module.exports, "prefetchThirdPartyProducts", () => $5a41f46a69ad0cec$export$ba83558707df5bbe);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4Ycud = parcelRequire("4Ycud");
const { fetchMethod: $5a41f46a69ad0cec$var$fetchAppSwitcherBffThirdPartyProducts, ProviderComponent: $5a41f46a69ad0cec$var$DefaultBffThirdPartyProductsDataProvider } = (0, $4Ycud.createAppSwitcherBffThirdPartyProductsProvider)();
const $5a41f46a69ad0cec$export$a7ffda257898c103 = ({ cloudId: cloudId, children: children, product: product })=>/*#__PURE__*/ (0, $e79Pd.jsx)($5a41f46a69ad0cec$var$DefaultBffThirdPartyProductsDataProvider, {
        cloudId: cloudId,
        product: product,
        children: children
    });
$5a41f46a69ad0cec$export$a7ffda257898c103.displayName = "ThirdPartyProductsProvider";
const $5a41f46a69ad0cec$export$ba83558707df5bbe = $5a41f46a69ad0cec$var$fetchAppSwitcherBffThirdPartyProducts;
const $5a41f46a69ad0cec$export$fdb5fe543e39bc7a = ()=>$5a41f46a69ad0cec$var$fetchAppSwitcherBffThirdPartyProducts.reset();

});
parcelRegister("4Ycud", function(module, exports) {
$parcel$export(module.exports, "createAppSwitcherBffThirdPartyProductsProvider", () => $79c9e41bfe2d75b6$export$1a41882ddb3a9c38);

var $hssAp = parcelRequire("hssAp");

var $cEIt4 = parcelRequire("cEIt4");

var $bEjWd = parcelRequire("bEjWd");
const $79c9e41bfe2d75b6$export$7cf62b3dbe96f5e8 = '/gateway/api/app-switcher/api/app-switcher/v1/third-party-products';
const $79c9e41bfe2d75b6$export$c39ca0fbc2221bcc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $cEIt4.fetchJsonWithNetworkRetries)(`${$79c9e41bfe2d75b6$export$7cf62b3dbe96f5e8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $79c9e41bfe2d75b6$export$1a41882ddb3a9c38 = ()=>{
    return (0, $hssAp.createProviderWithCustomFetchData)('appSwitcherBffThirdPartyProducts', (0, $bEjWd.ExperienceMark).API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS, $79c9e41bfe2d75b6$export$c39ca0fbc2221bcc);
};

});



parcelRegister("c3Aaw", function(module, exports) {
$parcel$export(module.exports, "performanceNow", () => $1b40f6d3b883c90a$export$fb4230f160368c88);
const $1b40f6d3b883c90a$export$fb4230f160368c88 = typeof window !== 'undefined' && window.performance && window.performance.now.bind(performance) || Date.now;

});


parcelRegister("45Cgc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9f5fffb07bd5d5f$export$2e2bcd8739ae039);
/* intl-provider.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $5KKyn = parcelRequire("5KKyn");
var $1YIbA = parcelRequire("1YIbA");


var $9Db7E = parcelRequire("9Db7E");

var $inMxE = parcelRequire("inMxE");

var $ihEDU = parcelRequire("ihEDU");

var $2c4kh = parcelRequire("2c4kh");
const $b9f5fffb07bd5d5f$var$styles = {
    skeleton: "_2rko12b0 _1e0c1o8l _1bsb1j4a _4t3i19bv _bfhkizff"
};






























function $b9f5fffb07bd5d5f$var$fetchLanguageFile(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("7TQal"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("6hh9o"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("dZKs9"));
        case 'en-GB':
            return (parcelRequire("h0b1Z"));
        case 'en-ZZ':
            return (parcelRequire("Yyu4a"));
        case 'en-US':
        case 'en':
            return (parcelRequire("9yZPp"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("cqzxu"));
        case 'et':
            return (parcelRequire("dtF8q"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("iCp1o"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("8nvwO"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("k6355"));
        case 'is':
            return (parcelRequire("2KBar"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("5CAG0"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("4P4Eu"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("66n7u"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("5aNcT"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("jWbvo"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("e1vEw"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("hjwC9"));
        case 'pt-PT':
            return (parcelRequire("jIwFG"));
        case 'ro':
            return (parcelRequire("dE87h"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("abbMP"));
        case 'sk':
            return (parcelRequire("4L0EV"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("7F2yJ"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("k7WBy"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("dIuXP"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("bCTJt"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("glEho"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("jt1mo"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("ifB95"));
    }
    throw Error(`Unable to find translation for locale ${locale}`);
}
const $b9f5fffb07bd5d5f$var$SwitcherIntlProvider = ({ children: children })=>{
    const { locale: locale, formatMessage: formatMessage } = (0, $1YIbA.default)();
    // Intl.Locale doesn't like underscores
    const [isLocaleLoaded, setIsLocaleLoaded] = (0, $euxye.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [localeMessages, setLocaleMessages] = (0, $euxye.useState)({});
    (0, $euxye.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const intlLocale = new Intl.Locale(locale.replace('_', '-'));
            try {
                const module = await $b9f5fffb07bd5d5f$var$fetchLanguageFile(intlLocale.toString());
                const newMessages = module.default || module;
                setLocaleMessages(newMessages);
                setIsLocaleLoaded(true);
            } catch  {
                // fail to download message and do nothing because UI will use default language (English) to render
                setIsLocaleLoaded(true);
                createAnalyticsEvent({
                    eventType: (0, $6d4033511f75ada1$export$12346a674644c156),
                    action: 'not_loaded',
                    actionSubject: 'i18n',
                    attributes: {
                        country: intlLocale.region,
                        language: intlLocale.language
                    }
                }).fire((0, $9Db7E.NAVIGATION_CHANNEL));
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale,
        createAnalyticsEvent
    ]);
    // delay loading until we have attempted to load the locale data otherwise we can flick from English to the user's language
    if (!isLocaleLoaded) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        role: "status",
        xcss: $b9f5fffb07bd5d5f$var$styles.skeleton,
        "aria-label": formatMessage((0, $2c4kh.default).skeletonLoaderAriaLabel)
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5KKyn.default), {
        locale: locale,
        messages: localeMessages,
        children: children
    }, locale);
};
$b9f5fffb07bd5d5f$var$SwitcherIntlProvider.displayName = "SwitcherIntlProvider";
var $b9f5fffb07bd5d5f$export$2e2bcd8739ae039 = $b9f5fffb07bd5d5f$var$SwitcherIntlProvider;

});
parcelRegister("7TQal", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("88jQp").then(()=>parcelRequire('fYoHm'));

});

parcelRegister("6hh9o", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fYQAk").then(()=>parcelRequire('4Q8x2'));

});

parcelRegister("dZKs9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5CVI5").then(()=>parcelRequire('lB2eE'));

});

parcelRegister("h0b1Z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2Nct9").then(()=>parcelRequire('dcWBD'));

});

parcelRegister("Yyu4a", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4TiuG").then(()=>parcelRequire('5cjXr'));

});

parcelRegister("9yZPp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ogWzB").then(()=>parcelRequire('2bvyr'));

});

parcelRegister("cqzxu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ht6uL").then(()=>parcelRequire('gDT8r'));

});

parcelRegister("dtF8q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ejYyD").then(()=>parcelRequire('7ARe0'));

});

parcelRegister("iCp1o", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("agTf0").then(()=>parcelRequire('4p4Mp'));

});

parcelRegister("8nvwO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bNMXr").then(()=>parcelRequire('7qXXL'));

});

parcelRegister("k6355", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aXseL").then(()=>parcelRequire('ey1TA'));

});

parcelRegister("2KBar", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("RuoMf").then(()=>parcelRequire('9Zg1u'));

});

parcelRegister("5CAG0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5a9tP").then(()=>parcelRequire('8L5PC'));

});

parcelRegister("4P4Eu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eJOcn").then(()=>parcelRequire('cuphx'));

});

parcelRegister("66n7u", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ck6dn").then(()=>parcelRequire('3tAZp'));

});

parcelRegister("5aNcT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fnxbq").then(()=>parcelRequire('9RFXK'));

});

parcelRegister("jWbvo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("au5kX").then(()=>parcelRequire('78XCj'));

});

parcelRegister("e1vEw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gPGeD").then(()=>parcelRequire('27f7T'));

});

parcelRegister("hjwC9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dE8fC").then(()=>parcelRequire('4ELVy'));

});

parcelRegister("jIwFG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dfsNs").then(()=>parcelRequire('2UnKk'));

});

parcelRegister("dE87h", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hAa22").then(()=>parcelRequire('8fIVz'));

});

parcelRegister("abbMP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eryGD").then(()=>parcelRequire('jCPDD'));

});

parcelRegister("4L0EV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bw2PT").then(()=>parcelRequire('7IQXF'));

});

parcelRegister("7F2yJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9WDcV").then(()=>parcelRequire('4vuSC'));

});

parcelRegister("k7WBy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i3VIg").then(()=>parcelRequire('gzF2l'));

});

parcelRegister("dIuXP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c1Ir6").then(()=>parcelRequire('dpZ6b'));

});

parcelRegister("bCTJt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6VONF").then(()=>parcelRequire('9aroV'));

});

parcelRegister("glEho", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gIy5T").then(()=>parcelRequire('bImMp'));

});

parcelRegister("jt1mo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dXiux").then(()=>parcelRequire('lAiBT'));

});

parcelRegister("ifB95", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("mSrHG").then(()=>parcelRequire('8C6mi'));

});


parcelRegister("8xPPl", function(module, exports) {
$parcel$export(module.exports, "experienceTimingsOf", () => $1a08cc5ee6144002$export$3ac4e94b194cd647);
$parcel$export(module.exports, "generateUFOMarkName", () => $1a08cc5ee6144002$export$504463c8409cf4d7);
$parcel$export(module.exports, "setSwitcherRenderStartMark", () => $1a08cc5ee6144002$export$16539b434cec5cfb);
$parcel$export(module.exports, "getSwitcherRenderStartMark", () => $1a08cc5ee6144002$export$436b7aeb93937572);

var $bEjWd = parcelRequire("bEjWd");
function $1a08cc5ee6144002$export$3ac4e94b194cd647(experience) {
    return (0, $bEjWd.EXPERIENCES_TO_MARKS)[experience].map($1a08cc5ee6144002$var$generateUFOTiming);
}
function $1a08cc5ee6144002$var$generateUFOTiming(mark) {
    return {
        key: mark,
        startMark: $1a08cc5ee6144002$export$504463c8409cf4d7(mark, (0, $bEjWd.ExperienceMarkPhase).START),
        endMark: $1a08cc5ee6144002$export$504463c8409cf4d7(mark, (0, $bEjWd.ExperienceMarkPhase).END)
    };
}
const $1a08cc5ee6144002$export$504463c8409cf4d7 = (mark, phase)=>`${mark}_${phase}`;
const $1a08cc5ee6144002$export$16539b434cec5cfb = ()=>{
    performance.mark((0, $bEjWd.SWITCHER_RENDER_START_PERFORMANCE_MARK));
};
const $1a08cc5ee6144002$export$436b7aeb93937572 = ()=>{
    const renderStartPerformanceMarks = performance.getEntriesByName ? performance.getEntriesByName((0, $bEjWd.SWITCHER_RENDER_START_PERFORMANCE_MARK)) : [];
    return renderStartPerformanceMarks[renderStartPerformanceMarks.length - 1]?.startTime;
};

});

parcelRegister("5ZMSQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a706a03de68b69a0$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $41FAq = parcelRequire("41FAq");

var $glbdM = parcelRequire("glbdM");

var $b1MEY = parcelRequire("b1MEY");

var $egspI = parcelRequire("egspI");

var $8qNgy = parcelRequire("8qNgy");

var $2VLFm = parcelRequire("2VLFm");

var $c0bP9 = parcelRequire("c0bP9");

var $jBnvq = parcelRequire("jBnvq");
// Shared helper: decides whether the hook should be active for the current
// runtime. Identical logic to the pre-fix code — kept in one place so both
// the OLD and NEW implementations below stay byte-equivalent on this branch.
function $a706a03de68b69a0$var$computeIsEnabled() {
    const shouldDisable = (0, $egspI.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $41FAq.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $b1MEY.isFedrampModerate)();
    return !shouldDisable;
}
/**
 * Legacy implementation (gate `platform_fix_cross_product_url_rerender` OFF).
 *
 * Initialises the session id to an empty string and reads it from the client
 * inside a `useEffect` after mount. This causes one guaranteed re-render of
 * any consumer that depends on the returned wrapper.
 *
 * Kept verbatim so the rollback path is byte-equivalent to the pre-fix code.
 */ function $a706a03de68b69a0$var$useCrossProductUrlOLD(options) {
    const [interactionSessionId, setInteractionSessionId] = (0, $euxye.useState)('');
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    const isEnabled = $a706a03de68b69a0$var$computeIsEnabled();
    // Client does not change on re-render - cache with useMemo
    const interactionSessionClient = (0, $euxye.useMemo)(()=>{
        if (isEnabled) return new (0, $2VLFm.default)();
        else return null;
    }, [
        isEnabled
    ]);
    (0, $euxye.useEffect)(()=>{
        if (interactionSessionClient && isEnabled) {
            // Fetch any initial interaction session ID
            const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
            currentSessionId && setInteractionSessionId(currentSessionId);
            // Add event listener that subscribes to any future interaction session ID updates
            const unbind = (0, $glbdM.bind)(document, {
                type: (0, $jBnvq.INTERACTION_SESSION_ID_UPDATED_EVENT),
                listener: ()=>{
                    const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
                    currentSessionId && setInteractionSessionId(currentSessionId);
                }
            });
            return unbind;
        }
        return ()=>{};
    }, [
        interactionSessionClient,
        isEnabled
    ]);
    if (!isEnabled) return (url)=>url;
    return (url)=>(0, $c0bP9.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct);
}
// Module-level identity wrapper used when the NEW hook is disabled. Stable
// identity avoids causing unnecessary re-renders / effect re-runs in
// downstream consumers.
const $a706a03de68b69a0$var$identityUrlWrapper = (url)=>url;
/**
 * Fixed implementation (gate `platform_fix_cross_product_url_rerender` ON).
 *
 * - Lazy-initialises the session id from the client on the very first render,
 *   eliminating the post-mount re-render that re-generated the `xpis` query
 *   param.
 * - Returns a stable, memoised wrapper so consumer effects keyed on it do not
 *   re-run on unrelated re-renders.
 *
 * See PIRA-3829.
 */ function $a706a03de68b69a0$var$useCrossProductUrlNEW(options) {
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    const isEnabled = $a706a03de68b69a0$var$computeIsEnabled();
    const interactionSessionClient = (0, $euxye.useMemo)(()=>{
        if (isEnabled) return new (0, $2VLFm.default)();
        else return null;
    }, [
        isEnabled
    ]);
    const [interactionSessionId, setInteractionSessionId] = (0, $euxye.useState)(()=>{
        if (isEnabled && interactionSessionClient) return interactionSessionClient.getCurrentInteractionSessionId() ?? '';
        return '';
    });
    (0, $euxye.useEffect)(()=>{
        if (interactionSessionClient && isEnabled) {
            // The lazy useState initializer above already read the session id on the
            // very first render, so we do NOT re-read here — that would cause the
            // avoidable post-mount re-render this fix is removing.
            const unbind = (0, $glbdM.bind)(document, {
                type: (0, $jBnvq.INTERACTION_SESSION_ID_UPDATED_EVENT),
                listener: ()=>{
                    const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
                    if (currentSessionId) setInteractionSessionId((prev)=>prev === currentSessionId ? prev : currentSessionId);
                }
            });
            return unbind;
        }
        return ()=>{};
    }, [
        interactionSessionClient,
        isEnabled
    ]);
    const wrapUrl = (0, $euxye.useCallback)((url)=>(0, $c0bP9.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct), [
        bridge,
        interactionSessionId,
        product,
        subProduct
    ]);
    if (!isEnabled) return $a706a03de68b69a0$var$identityUrlWrapper;
    return wrapUrl;
}
/**
 * This React hook is called with the correct bridge, product and sub-product parameters.
 * It returns a function that can be used to generate URLs with cross-product interaction parameters.
 *
 * The implementation is selected at call time by the
 * `platform_fix_cross_product_url_rerender` feature gate via `functionWithFG`.
 * This keeps the legacy and fixed code paths fully separated rather than
 * intermixed inside a single hook body. See PIRA-3829.
 *
 * @param options - Properties object that contains the following parameters:
 *
 * @returns A function that appends interaction session ID and other cross-product interaction parameters to a given URL.
 */ const $a706a03de68b69a0$var$useCrossProductUrl = (0, $8qNgy.functionWithFG)('platform_fix_cross_product_url_rerender', $a706a03de68b69a0$var$useCrossProductUrlNEW, $a706a03de68b69a0$var$useCrossProductUrlOLD);
var $a706a03de68b69a0$export$2e2bcd8739ae039 = $a706a03de68b69a0$var$useCrossProductUrl;

});

parcelRegister("gUQqP", function(module, exports) {
$parcel$export(module.exports, "default", () => $887b8709c41a813e$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $887b8709c41a813e$var$messages = (0, $7eNDO.defineMessages)({
    switchSitesOrAppsTooltip: {
        id: 'fabric.atlassianSwitcher.switchSitesOrAppsTooltip',
        defaultMessage: 'Switch sites or apps',
        description: 'This text appears as a tooltip when a user hovers over the atlassian switcher icon before clicking on it.'
    },
    tenantlessTopOrgSwitcherText: {
        id: 'fabric.atlassianSwitcher.tenantlessTopOrgSwitcherText',
        defaultMessage: 'Select organisation',
        description: 'The text of the organisation switcher item when no organisation is selected'
    },
    switcherModalLabel: {
        id: 'fabric.atlassianSwitcher.modalLabel',
        defaultMessage: 'Atlassian App Switcher',
        description: 'The label of the switcher modal'
    },
    joinStatusText: {
        id: 'fabric.atlassianSwitcher.joinStatusText',
        defaultMessage: 'Join',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    instantAccessStatusText: {
        id: 'fabric.atlassianSwitcher.instantAccessStatusText',
        defaultMessage: 'Instant access',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    joinTeamStatusText: {
        id: 'fabric.atlassianSwitcher.joinTeamStatusText',
        defaultMessage: 'Join team',
        description: 'The text displayed alongside a product to indicate the product is joinable.'
    },
    jpdDescriptionText: {
        id: 'fabric.atlassianSwitcher.jpdDescriptionText',
        defaultMessage: 'Prioritize and plan new ideas',
        description: 'The description displayed for Jira Product Discovery.'
    },
    confluenceDescriptionText: {
        id: 'fabric.atlassianSwitcher.confluenceDescriptionText',
        defaultMessage: 'Document and collaborate',
        description: 'The description displayed for Confluence.'
    },
    jiraDescriptionText: {
        id: 'fabric.atlassianSwitcher.jiraDescriptionText',
        defaultMessage: 'Plan and track project delivery',
        description: 'The description displayed for Jira.'
    },
    jsmDescriptionText: {
        id: 'fabric.atlassianSwitcher.jsmDescriptionText',
        defaultMessage: 'Automate and deliver IT support',
        description: 'The description displayed for Jira Service Management.'
    },
    requestSentStatusText: {
        id: 'fabric.atlassianSwitcher.requestSentStatusText',
        defaultMessage: 'Request sent',
        description: 'The text displayed alongside a product to indicate the user has requested access to the product.'
    },
    requestAccessPendingRequestFlagTitle: {
        id: 'fabric.atlassianSwitcher.successFlag.title',
        defaultMessage: 'Access request sent to Admin',
        description: 'Title shown when user has requested access to a product but the request is pending.'
    },
    requestAccessPendingRequestFlagDescription: {
        id: 'fabric.atlassianSwitcher.successFlag.description',
        defaultMessage: "You'll get an email once it's approved",
        description: 'Description shown when user has requested access to a product but the request is pending'
    },
    requestAccessPendingRequestFlagErrorTitle: {
        id: 'fabric.atlassianSwitcher.errorFlag.title',
        defaultMessage: `We couldn't add you to {product}`,
        description: 'Title shown when user has requested access to a product but the request has failed.'
    },
    requestAccessPendingRequestFlagErrorDescription: {
        id: 'fabric.atlassianSwitcher.errorFlag.description',
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, <a>contact support</a>.",
        description: 'Description shown when user has requested access to a product but the request is pending'
    },
    reorderItemErrorFlagTitle: {
        id: 'fabric.atlassianSwitcher.reorderItemErrorFlagTitle',
        defaultMessage: 'Something went wrong',
        description: 'The title of the error flag for reordering items in the switcher'
    },
    reorderItemErrorFlagDescription: {
        id: 'fabric.atlassianSwitcher.reorderItemErrorFlagDescription',
        defaultMessage: 'Please refresh the page or try again later.',
        description: 'The description of the error flag for reordering items in the switcher'
    },
    reorderItemErrorFlagAction: {
        id: 'fabric.atlassianSwitcher.reorderItemErrorFlagAction',
        defaultMessage: 'Got it',
        description: 'The action of the error flag for reordering items in the switcher'
    },
    jiraDescriptionTextGalaxia: {
        id: 'fabric.atlassianSwitcher.jiraDescriptionText-galaxia',
        defaultMessage: 'Plan and track project delivery',
        description: 'The description displayed for Jira.'
    },
    otherSectionOfOrgSwitcher: {
        id: 'fabric.atlassianSwitcher.otherSectionOfOrgSwitcher',
        defaultMessage: 'Other',
        description: 'Text displayed as the title of the other section of the org switcher.'
    }
});
var $887b8709c41a813e$export$2e2bcd8739ae039 = $887b8709c41a813e$var$messages;

});

parcelRegister("dA5C0", function(module, exports) {
$parcel$export(module.exports, "preserveOffsetOnSource", () => (parcelRequire("cEH4V")).preserveOffsetOnSource);

var $cEH4V = parcelRequire("cEH4V");

});
parcelRegister("cEH4V", function(module, exports) {
$parcel$export(module.exports, "preserveOffsetOnSource", () => $ac334bf2f1bd57e9$export$8830e7ac6eee750e);
function $ac334bf2f1bd57e9$export$8830e7ac6eee750e({ element: element, input: input }) {
    return function getOffset({ container: container }) {
        /**
		 * **Android**
		 *
		 * This function won't do anything 😅.
		 * The drag preview will _always_ be under the center of the users pointer.
		 * There is no harm in calling this function though 🧘.
		 *
		 * **iOS and iPadOS**
		 *
		 * The drag preview is lifted in the expected position and then slides under
		 * the users pointer.
		 * This is more pleasing than immediately putting the center of the drag preview
		 * under the users pointer.
		 * With this function the drag preview looks like it is popping out
		 * of the UI and then it shifts under the users pointer as the drag is occurring ✨
		 */ const sourceRect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const offsetX = Math.min(// difference
        input.clientX - sourceRect.x, // don't let the difference be more than the width of the container,
        // otherwise the pointer will be off the preview
        containerRect.width);
        const offsetY = Math.min(// difference
        input.clientY - sourceRect.y, // don't let the difference be more than the height of the container,
        // otherwise the pointer will be off the preview
        containerRect.height);
        return {
            x: offsetX,
            y: offsetY
        };
    };
}

});


parcelRegister("7ohZu", function(module, exports) {
$parcel$export(module.exports, "autoScrollForElements", () => $bd173e600f122385$export$4b66ee8317094cdb);
$parcel$export(module.exports, "autoScrollWindowForElements", () => $bd173e600f122385$export$c9168f41de61f525);
parcelRequire("3nfFb");
var $gOKKd = parcelRequire("gOKKd");

var $c6Yuv = parcelRequire("c6Yuv");
const $bd173e600f122385$var$api = (0, $c6Yuv.makeApi)({
    monitor: (0, $gOKKd.monitorForElements)
});
const $bd173e600f122385$export$4b66ee8317094cdb = $bd173e600f122385$var$api.autoScroll;
const $bd173e600f122385$export$c9168f41de61f525 = $bd173e600f122385$var$api.autoScrollWindow;

});
parcelRegister("c6Yuv", function(module, exports) {
$parcel$export(module.exports, "makeApi", () => $733c04fcf8c46a42$export$b8fa21320a811083);
parcelRequire("l7nPt");
var $7aH0o = parcelRequire("7aH0o");
parcelRequire("j6Tk9");
var $fVTcB = parcelRequire("fVTcB");

var $6piiJ = parcelRequire("6piiJ");

var $3i5FR = parcelRequire("3i5FR");

var $7djL9 = parcelRequire("7djL9");
function $733c04fcf8c46a42$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        const cleanup = (0, $7aH0o.combine)((0, $3i5FR.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        return (0, $fVTcB.once)(cleanup);
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        function cleanup() {
            windowRegistry.delete(unique);
        }
        return (0, $fVTcB.once)(cleanup);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $7djL9.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $6piiJ.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}

});
parcelRegister("j6Tk9", function(module, exports) {
$parcel$export(module.exports, "once", () => (parcelRequire("fVTcB")).once);

var $fVTcB = parcelRequire("fVTcB");

});

parcelRegister("6piiJ", function(module, exports) {
$parcel$export(module.exports, "getScheduler", () => $0ff58ecd2b4a15ae$export$5cff7ac265db316a);
parcelRequire("cWZxy");
var $90V0f = parcelRequire("90V0f");

var $gbTBz = parcelRequire("gbTBz");
// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $0ff58ecd2b4a15ae$var$schedulers = new Map();
function $0ff58ecd2b4a15ae$export$5cff7ac265db316a(monitor) {
    const scheduler = $0ff58ecd2b4a15ae$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $0ff58ecd2b4a15ae$var$makeScheduler(monitor);
    $0ff58ecd2b4a15ae$var$schedulers.set(monitor, created);
    return created;
}
function $0ff58ecd2b4a15ae$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $90V0f.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $gbTBz.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $gbTBz.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}

});
parcelRegister("gbTBz", function(module, exports) {
$parcel$export(module.exports, "markAndGetEngagement", () => $25474c448adc4758$export$8c764c3f2fc3d2d2);
$parcel$export(module.exports, "clearUnusedEngagements", () => $25474c448adc4758$export$991e77dd347f3df1);
$parcel$export(module.exports, "clearEngagementHistory", () => $25474c448adc4758$export$13ae770ed39b71ea);
const $25474c448adc4758$var$ledger = new Map();
const $25474c448adc4758$var$requested = new Set();
function $25474c448adc4758$export$8c764c3f2fc3d2d2(element) {
    $25474c448adc4758$export$1cb7cbb266b6f6fa(element);
    const entry = $25474c448adc4758$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $25474c448adc4758$var$ledger.set(element, fresh);
    return fresh;
}
function $25474c448adc4758$export$1cb7cbb266b6f6fa(element) {
    $25474c448adc4758$var$requested.add(element);
}
function $25474c448adc4758$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $25474c448adc4758$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $25474c448adc4758$var$ledger.forEach((_, element)=>{
        if (!$25474c448adc4758$var$requested.has(element)) $25474c448adc4758$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $25474c448adc4758$var$requested.clear();
}
function $25474c448adc4758$export$13ae770ed39b71ea() {
    $25474c448adc4758$var$ledger.clear();
}

});


parcelRegister("3i5FR", function(module, exports) {
$parcel$export(module.exports, "selector", () => $88ded6a532c138e7$export$aea217a45095ce11);
$parcel$export(module.exports, "addScrollableAttribute", () => $88ded6a532c138e7$export$4ec12fb57dfebd53);
const $88ded6a532c138e7$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $88ded6a532c138e7$export$aea217a45095ce11 = `[${$88ded6a532c138e7$export$4b152ab55cad4fd6}="true"]`;
function $88ded6a532c138e7$export$4ec12fb57dfebd53(element) {
    element.setAttribute($88ded6a532c138e7$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($88ded6a532c138e7$export$4b152ab55cad4fd6);
}

});

parcelRegister("7djL9", function(module, exports) {
$parcel$export(module.exports, "tryScroll", () => $a10c7737b0ac08fc$export$233199807749476d);

var $9gNZu = parcelRequire("9gNZu");

var $gbTBz = parcelRequire("gbTBz");

var $3i5FR = parcelRequire("3i5FR");

var $4VCcY = parcelRequire("4VCcY");
function $a10c7737b0ac08fc$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $a10c7737b0ac08fc$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$a10c7737b0ac08fc$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $3i5FR.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $a10c7737b0ac08fc$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $gbTBz.markAndGetEngagement)(element);
    const config = (0, $9gNZu.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $4VCcY.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $a10c7737b0ac08fc$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $gbTBz.markAndGetEngagement)(element);
        const config = (0, $9gNZu.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $4VCcY.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $a10c7737b0ac08fc$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $a10c7737b0ac08fc$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$a10c7737b0ac08fc$var$isScrollingAvailable(remainder)) return;
    $a10c7737b0ac08fc$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}

});
parcelRegister("9gNZu", function(module, exports) {
$parcel$export(module.exports, "getInternalConfig", () => $e8e3df651c5a339b$export$e96028ec7ff9d079);
const $e8e3df651c5a339b$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $e8e3df651c5a339b$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $e8e3df651c5a339b$export$e96028ec7ff9d079(provided) {
    return {
        ...$e8e3df651c5a339b$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $e8e3df651c5a339b$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}

});

parcelRegister("4VCcY", function(module, exports) {
$parcel$export(module.exports, "getScrollBy", () => $fd553c69440ac625$export$6cfa6dfe6898b98f);

var $9QkEe = parcelRequire("9QkEe");

var $azPRT = parcelRequire("azPRT");

var $4itey = parcelRequire("4itey");

var $g5vFL = parcelRequire("g5vFL");

var $gfM2w = parcelRequire("gfM2w");

var $807P1 = parcelRequire("807P1");
function $fd553c69440ac625$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $fd553c69440ac625$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $fd553c69440ac625$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $azPRT.edges).reduce((map, edge)=>{
        const hitbox = (0, $4itey.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $azPRT.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $gfM2w.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $807P1.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $9QkEe.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $g5vFL.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $g5vFL.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $g5vFL.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $g5vFL.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("9QkEe", function(module, exports) {
$parcel$export(module.exports, "canScrollOnEdge", () => $4c0016ef01166a00$export$ccd6d9407403fcad);
const $4c0016ef01166a00$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};

});

parcelRegister("azPRT", function(module, exports) {
$parcel$export(module.exports, "edges", () => $82526e984a35d761$export$4544a00f8eb65eb2);
$parcel$export(module.exports, "edgeAxisLookup", () => $82526e984a35d761$export$7fc144124ccf8292);
const $82526e984a35d761$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $82526e984a35d761$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};

});

parcelRegister("4itey", function(module, exports) {
$parcel$export(module.exports, "getOverElementHitbox", () => $8480ae46634c865f$export$b9a449c20abb0e9);

var $1zJNd = parcelRequire("1zJNd");

var $g0dJL = parcelRequire("g0dJL");
function $8480ae46634c865f$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $1zJNd.axisLookup)[axis];
        const side = (0, $g0dJL.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $8480ae46634c865f$export$b9a449c20abb0e9 = {
    top: $8480ae46634c865f$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $8480ae46634c865f$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $8480ae46634c865f$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $8480ae46634c865f$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};

});
parcelRegister("1zJNd", function(module, exports) {
$parcel$export(module.exports, "axisLookup", () => $e892e5de46267c48$export$42e42cdab35a2b96);
const $e892e5de46267c48$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $e892e5de46267c48$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $e892e5de46267c48$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $e892e5de46267c48$var$vertical,
        crossAxis: $e892e5de46267c48$var$horizontal
    },
    horizontal: {
        mainAxis: $e892e5de46267c48$var$horizontal,
        crossAxis: $e892e5de46267c48$var$vertical
    }
};

});

parcelRegister("g0dJL", function(module, exports) {
$parcel$export(module.exports, "mainAxisSideLookup", () => $62d56b5be5223e1e$export$a45c0cd714a4dbaa);
const $62d56b5be5223e1e$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};

});


parcelRegister("g5vFL", function(module, exports) {
$parcel$export(module.exports, "getScrollChange", () => $2e89361574ca850a$export$470a2ff46db8cee8);

var $1zJNd = parcelRequire("1zJNd");

var $llyMr = parcelRequire("llyMr");

var $g0dJL = parcelRequire("g0dJL");
// We want a consistent scroll speed across devices, regardless of framerate
function $2e89361574ca850a$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $2e89361574ca850a$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $1zJNd.axisLookup)[axis];
    const side = (0, $g0dJL.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $llyMr.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $llyMr.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $2e89361574ca850a$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $2e89361574ca850a$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $2e89361574ca850a$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $llyMr.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $g0dJL.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}

});
parcelRegister("llyMr", function(module, exports) {
$parcel$export(module.exports, "getPercentageInRange", () => $76391c4843dc3dcb$export$1a29de000a332d74);
function $76391c4843dc3dcb$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}

});


parcelRegister("gfM2w", function(module, exports) {
$parcel$export(module.exports, "isAxisAllowed", () => $7cc8be805b2801e0$export$7120fdbd90bd1292);
function $7cc8be805b2801e0$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}

});

parcelRegister("807P1", function(module, exports) {
$parcel$export(module.exports, "isWithin", () => $364156a22ff58cfa$export$cda7a9d4399bf2e3);
function $364156a22ff58cfa$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}

});





parcelRegister("jDRSV", function(module, exports) {
$parcel$export(module.exports, "SwitchToTooltipText", () => $d7347f53a7094963$export$c5ef4d14b7e18cbd);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");

var $45Cgc = parcelRequire("45Cgc");

var $gUQqP = parcelRequire("gUQqP");
const $d7347f53a7094963$export$c5ef4d14b7e18cbd = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $45Cgc.default), {
    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        ...(0, $gUQqP.default).switchSitesOrAppsTooltip
    })
});

});

parcelRegister("ik1Zc", function(module, exports) {
$parcel$export(module.exports, "EngagementSpotlight", () => $796e0d12735974f4$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $kxDv9 = parcelRequire("kxDv9");

var $iolOH = parcelRequire("iolOH");

var $fb5DN = parcelRequire("fb5DN");

var $ba3AP = parcelRequire("ba3AP");

var $65Ypi = parcelRequire("65Ypi");
const $796e0d12735974f4$var$SpotlightWithVariables = (0, $iolOH.default)((0, $65Ypi.default));
const $796e0d12735974f4$export$f57123e11f24bec9 = (0, $fb5DN.default)($796e0d12735974f4$var$SpotlightWithVariables);
const $796e0d12735974f4$var$SpotlightWithMessage = (0, $ba3AP.default)($796e0d12735974f4$export$f57123e11f24bec9, 'spotlight');
function $796e0d12735974f4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kxDv9.default), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($796e0d12735974f4$var$SpotlightWithMessage, {
            ...props
        })
    });
}
$796e0d12735974f4$export$2e2bcd8739ae039.displayName = "EngagementSpotlight";

});
parcelRegister("iolOH", function(module, exports) {
$parcel$export(module.exports, "default", () => $956432b747904d0d$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $3tNtH = parcelRequire("3tNtH");
function $956432b747904d0d$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $euxye.Component) {
        static{
            this.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
        }
        render() {
            const props = $956432b747904d0d$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, $e79Pd.jsx)(TargetComponent, {
                ...props
            });
        }
    }
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $956432b747904d0d$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $3tNtH.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $3tNtH.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $3tNtH.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});
parcelRegister("3tNtH", function(module, exports) {
$parcel$export(module.exports, "rebuildButtonAction", () => $85219edb5976cd63$export$5d0ec4f796aceeb1);
$parcel$export(module.exports, "runTemplateOnInputs", () => $85219edb5976cd63$export$d808999430a3f186);

var $dePXm = parcelRequire("dePXm");
function $85219edb5976cd63$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $85219edb5976cd63$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $dePXm.runTemplateForUrl)(input, variables) : (0, $dePXm.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $cc897b291750f655$export$edb46161045fece7)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}

});
const $cc897b291750f655$export$e26f00bd90899835 = 'success';
const $cc897b291750f655$export$edb46161045fece7 = 'error';

parcelRegister("dePXm", function(module, exports) {
$parcel$export(module.exports, "runTemplateForUrl", () => $418a6fbde4d8d96d$export$416b2ef51d91ea20);
$parcel$export(module.exports, "runTemplateForHtml", () => $418a6fbde4d8d96d$export$5681b97796b74884);

var $5c6DH = parcelRequire("5c6DH");

var $dJrAC = parcelRequire("dJrAC");


var $jEgtw = parcelRequire("jEgtw");
function $418a6fbde4d8d96d$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $5c6DH.default)(template);
    return (0, $jEgtw.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $418a6fbde4d8d96d$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $5c6DH.default)(template);
    return (0, $dJrAC.replaceForUrl)(epTemplate, variables);
}
function $418a6fbde4d8d96d$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $5c6DH.default)(template);
    return (0, $dJrAC.replaceForHtml)(epTemplate, variables);
}

});
parcelRegister("5c6DH", function(module, exports) {
$parcel$export(module.exports, "default", () => $e50cd595a80a22fb$export$2e2bcd8739ae039);

var $f33FE = parcelRequire("f33FE");
/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $e50cd595a80a22fb$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $e50cd595a80a22fb$var$UNESCAPED_MATCH = 1;
const $e50cd595a80a22fb$var$UNESCAPED_GROUP_CONTENTS = 2;
const $e50cd595a80a22fb$var$ESCAPED_GROUP_CONTENTS = 5;
function $e50cd595a80a22fb$export$2e2bcd8739ae039(template) {
    const parts = (0, $f33FE.regexpParts)(template, $e50cd595a80a22fb$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$e50cd595a80a22fb$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$e50cd595a80a22fb$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$e50cd595a80a22fb$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});
parcelRegister("f33FE", function(module, exports) {
$parcel$export(module.exports, "regexpParts", () => $e2f17e0f1b308804$export$b16d411b3b6d6dff);
function $e2f17e0f1b308804$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $e2f17e0f1b308804$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $e2f17e0f1b308804$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $e2f17e0f1b308804$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $e2f17e0f1b308804$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}

});


parcelRegister("dJrAC", function(module, exports) {
$parcel$export(module.exports, "replaceForUrl", () => $8c05e1229c8857e7$export$d10ae881b12b8ef2);
$parcel$export(module.exports, "replaceForHtml", () => $8c05e1229c8857e7$export$ca536300dbd6350);

var $jEgtw = parcelRequire("jEgtw");

var $6FjnN = parcelRequire("6FjnN");
/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $8c05e1229c8857e7$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $jEgtw.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $8c05e1229c8857e7$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $8c05e1229c8857e7$var$rawReplaceVariablesForUrl(template, variables) {
    return $8c05e1229c8857e7$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $8c05e1229c8857e7$var$rawReplaceVariablesForHtml(template, variables) {
    return $8c05e1229c8857e7$var$rawReplaceVariables(template, variables, (0, $6FjnN.default));
}
function $8c05e1229c8857e7$export$d10ae881b12b8ef2(template, variables) {
    return $8c05e1229c8857e7$var$withVariableValidation(template, variables, $8c05e1229c8857e7$var$rawReplaceVariablesForUrl);
}
function $8c05e1229c8857e7$export$ca536300dbd6350(template, variables) {
    return $8c05e1229c8857e7$var$withVariableValidation(template, variables, $8c05e1229c8857e7$var$rawReplaceVariablesForHtml);
}

});
parcelRegister("jEgtw", function(module, exports) {
$parcel$export(module.exports, "getRequiredVariablesFromTemplate", () => $0754b3d2daf26d24$export$4a33186abb06007b);

var $3b5Bn = parcelRequire("3b5Bn");
function $0754b3d2daf26d24$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $0754b3d2daf26d24$export$4a33186abb06007b(template) {
    const variableParts = $0754b3d2daf26d24$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $3b5Bn.uniqStrings)(variableNames);
}

});
parcelRegister("3b5Bn", function(module, exports) {
$parcel$export(module.exports, "uniqStrings", () => $76d458f98fa5eebe$export$c150c7c1a29f33d8);
/**
 * Removes duplicate strings from an array.
 */ function $76d458f98fa5eebe$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}

});


parcelRegister("6FjnN", function(module, exports) {
$parcel$export(module.exports, "default", () => $68fadaaf249b5153$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $68fadaaf249b5153$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});





parcelRegister("65Ypi", function(module, exports) {
$parcel$export(module.exports, "default", () => $9af68a0ecea63f95$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $i2sOf = parcelRequire("i2sOf");

var $12j6D = parcelRequire("12j6D");

var $egspI = parcelRequire("egspI");

var $8Sdzy = parcelRequire("8Sdzy");

var $fxLck = parcelRequire("fxLck");
var $jFNyB = parcelRequire("jFNyB");
var $liP0D = parcelRequire("liP0D");
var $8CDnU = parcelRequire("8CDnU");
var $8qQ8A = parcelRequire("8qQ8A");
var $8guPH = parcelRequire("8guPH");
var $7okqc = parcelRequire("7okqc");
var $KcP1c = parcelRequire("KcP1c");
var $413te = parcelRequire("413te");
var $54cWg = parcelRequire("54cWg");
var $jukA2 = parcelRequire("jukA2");
var $jleyn = parcelRequire("jleyn");
var $bEy1I = parcelRequire("bEy1I");
var $54AB6 = parcelRequire("54AB6");

var $1MKhf = parcelRequire("1MKhf");

var $eIOSt = parcelRequire("eIOSt");

var $kFBBO = parcelRequire("kFBBO");
const $9af68a0ecea63f95$var$styles = {
    image: "_1bsb1osq"
};
const $9af68a0ecea63f95$export$f14689466e4eca7a = ({ isMigrated: isMigrated = false, ...rest })=>{
    if (isMigrated && (0, $egspI.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, $e79Pd.jsx)($9af68a0ecea63f95$var$MigratedAkSpotlight, {
        ...rest
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($9af68a0ecea63f95$var$DeprecatedAkSpotlight, {
        ...rest
    });
};
$9af68a0ecea63f95$export$f14689466e4eca7a.displayName = "EngagementSpotlight";
// eslint-disable-next-line @repo/internal/react/no-class-components
class $9af68a0ecea63f95$var$DeprecatedAkSpotlight extends (0, $euxye.Component) {
    static{
        this.defaultProps = {
            fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
        };
    }
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $1MKhf.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $12j6D.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kFBBO.default), {
                html: body
            })
        });
    }
}
$9af68a0ecea63f95$var$DeprecatedAkSpotlight.displayName = "DeprecatedAkSpotlight";
const $9af68a0ecea63f95$var$MigratedAkSpotlight = (props)=>{
    const placement = (0, $eIOSt.translations).dialogPlacement(props.dialogPlacement);
    const [isVisible, setIsVisible] = (0, $euxye.useState)(true);
    const dismiss = (0, $euxye.useCallback)(()=>{
        setIsVisible(false);
    }, [
        setIsVisible
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fxLck.PopoverContent), {
        offset: props.offset,
        dismiss: dismiss,
        placement: placement,
        isVisible: isVisible,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8CDnU.SpotlightCard), {
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $KcP1c.SpotlightHeader), {
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $413te.SpotlightHeadline), {
                            children: props.title
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8qQ8A.SpotlightControls), {
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8guPH.SpotlightDismissControl), {})
                        })
                    ]
                }),
                props.image && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $54cWg.SpotlightMedia), {
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $i2sOf.default), {
                        src: props.image,
                        alt: "",
                        className: (0, $4jQY2.default)([
                            $9af68a0ecea63f95$var$styles.image
                        ])
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $liP0D.SpotlightBody), {
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                        children: props.body
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7okqc.SpotlightFooter), {
                    children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $jFNyB.SpotlightActions), {
                        children: [
                            props.secondaryAction && (props.secondaryAction?.type === 'link' ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $54AB6.SpotlightSecondaryLink), {
                                onClick: dismiss,
                                ...props.secondaryAction.data,
                                href: props.secondaryAction.data?.url || '',
                                target: props.secondaryAction.data?.target,
                                children: props.secondaryText
                            }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bEy1I.SpotlightSecondaryAction), {
                                onClick: dismiss,
                                ...props.secondaryAction.data,
                                children: props.secondaryText
                            })),
                            props.primaryAction && (props.primaryAction?.type === 'link' ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jleyn.SpotlightPrimaryLink), {
                                onClick: dismiss,
                                ...props.primaryAction.data,
                                href: props.primaryAction.data?.url || '',
                                target: props.primaryAction.data?.target,
                                children: props.primaryText
                            }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jukA2.SpotlightPrimaryAction), {
                                onClick: dismiss,
                                ...props.primaryAction.data,
                                children: props.primaryText
                            }))
                        ]
                    })
                })
            ]
        })
    });
};
$9af68a0ecea63f95$var$MigratedAkSpotlight.displayName = "MigratedAkSpotlight";
var $9af68a0ecea63f95$export$2e2bcd8739ae039 = $9af68a0ecea63f95$export$f14689466e4eca7a;

});
parcelRegister("eIOSt", function(module, exports) {
$parcel$export(module.exports, "translations", () => $28ba362aa6fd260e$export$150b732325d14d04);
const $28ba362aa6fd260e$export$44271b4f0c6a3563 = (value)=>{
    if (!value || value.length === 0) return '';
    /**
	 * All of the following are actually invalid in CSS selectors.
	 * It's unlikely that a lot of these are actually used as `Spotlight` `name` prop values.
	 * If it turns out other characters are used, add them as needed.
	 *
	 * (space) — descendant combinator
	 * > — child combinator
	 * + — adjacent sibling combinator
	 * ~ — general sibling combinator
	 * . — class selector
	 * # — ID selector
	 * : — pseudo-class/element
	 * [ ] — attribute selectors
	 * ( ) — functional notation
	 * , — selector list separator
	 * * — universal selector
	 * | — namespace separator
	 * " ' — string delimiters
	 * \ — escape character
	 * Characters not allowed in unescaped identifiers:
	 * Digits 0-9 cannot be the first character
	 * !, @, $, %, ^, &, =, {, }, ;, /, and most other punctuation
	 */ return value.replaceAll(' ', '-').replaceAll('/', '-');
};
const $28ba362aa6fd260e$var$placementMap = {
    'top right': 'top-start',
    'top center': 'top-center',
    'top left': 'top-end',
    'right bottom': 'right-start',
    'right middle': 'right-start',
    'right top': 'right-end',
    'bottom left': 'bottom-end',
    'bottom center': 'bottom-center',
    'bottom right': 'bottom-start',
    'left top': 'left-end',
    'left middle': 'left-start',
    'left bottom': 'left-start'
};
const $28ba362aa6fd260e$export$608d2c28a2f3926e = (value)=>{
    // `bottom left` is the default placement when `undefined` is passed.
    return $28ba362aa6fd260e$var$placementMap[value || 'bottom left'];
};
const $28ba362aa6fd260e$export$150b732325d14d04 = {
    target: $28ba362aa6fd260e$export$44271b4f0c6a3563,
    dialogPlacement: $28ba362aa6fd260e$export$608d2c28a2f3926e
};

});



parcelRegister("4eeMq", function(module, exports) {
$parcel$export(module.exports, "SpotlightManager", () => $285cea0742331603$export$e040768d915476be);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $g5k19 = parcelRequire("g5k19");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $285cea0742331603$export$e040768d915476be = ({ children: children })=>{
    if ((0, $egspI.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g5k19.PopoverProvider), {
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, {
        children: children
    });
};
$285cea0742331603$export$e040768d915476be.displayName = "SpotlightManager";
$285cea0742331603$export$e040768d915476be.displayName = 'SpotlightManager';

});

parcelRegister("hT5UW", function(module, exports) {
$parcel$export(module.exports, "SpotlightTarget", () => $4c88d9899cd05e60$export$e29577842f211e22);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8jEW8 = parcelRequire("8jEW8");

var $egspI = parcelRequire("egspI");

var $5Gxfr = parcelRequire("5Gxfr");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $4c88d9899cd05e60$export$e29577842f211e22 = ({ children: children, name: name })=>{
    if ((0, $egspI.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5Gxfr.PopoverTarget), {
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8jEW8.default), {
        name: name,
        children: children
    });
};
$4c88d9899cd05e60$export$e29577842f211e22.displayName = "SpotlightTarget";
$4c88d9899cd05e60$export$e29577842f211e22.displayName = 'SpotlightTarget';

});

parcelRegister("jvDG2", function(module, exports) {
module.exports = $e33fb09d3bae2987$var$defaultsPlugin;
function $e33fb09d3bae2987$var$defaultsPlugin() {
    var defaultValues = {};
    return {
        defaults: defaults,
        get: get
    };
    function defaults(_, values) {
        defaultValues = values;
    }
    function get(super_fn, key) {
        var val = super_fn();
        return val !== undefined ? val : defaultValues[key];
    }
}

});

parcelRegister("jd9DX", function(module, exports) {
var $dfc6b63bf9d4a62c$var$namespace = 'expire_mixin';
module.exports = $dfc6b63bf9d4a62c$var$expirePlugin;
function $dfc6b63bf9d4a62c$var$expirePlugin() {
    var expirations = this.createStore(this.storage, null, this._namespacePrefix + $dfc6b63bf9d4a62c$var$namespace);
    return {
        set: expire_set,
        get: expire_get,
        remove: expire_remove,
        getExpiration: getExpiration,
        removeExpiredKeys: removeExpiredKeys
    };
    function expire_set(super_fn, key, val, expiration) {
        if (!this.hasNamespace($dfc6b63bf9d4a62c$var$namespace)) expirations.set(key, expiration);
        return super_fn();
    }
    function expire_get(super_fn, key) {
        if (!this.hasNamespace($dfc6b63bf9d4a62c$var$namespace)) _checkExpiration.call(this, key);
        return super_fn();
    }
    function expire_remove(super_fn, key) {
        if (!this.hasNamespace($dfc6b63bf9d4a62c$var$namespace)) expirations.remove(key);
        return super_fn();
    }
    function getExpiration(_, key) {
        return expirations.get(key);
    }
    function removeExpiredKeys(_) {
        var keys = [];
        this.each(function(val, key) {
            keys.push(key);
        });
        for(var i = 0; i < keys.length; i++)_checkExpiration.call(this, keys[i]);
    }
    function _checkExpiration(key) {
        var expiration = expirations.get(key, Number.MAX_VALUE);
        if (expiration <= new Date().getTime()) {
            this.raw.remove(key);
            expirations.remove(key);
        }
    }
}

});

parcelRegister("ef3Gs", function(module, exports) {

var $8rZnz = parcelRequire("8rZnz");
var $a5e552eeddb8b6bd$var$slice = $8rZnz.slice;
var $a5e552eeddb8b6bd$var$pluck = $8rZnz.pluck;
var $a5e552eeddb8b6bd$var$each = $8rZnz.each;
var $a5e552eeddb8b6bd$var$bind = $8rZnz.bind;
var $a5e552eeddb8b6bd$var$create = $8rZnz.create;
var $a5e552eeddb8b6bd$var$isList = $8rZnz.isList;
var $a5e552eeddb8b6bd$var$isFunction = $8rZnz.isFunction;
var $a5e552eeddb8b6bd$var$isObject = $8rZnz.isObject;
module.exports = {
    createStore: $a5e552eeddb8b6bd$var$createStore
};
var $a5e552eeddb8b6bd$var$storeAPI = {
    version: '2.0.12',
    enabled: false,
    // get returns the value of the given key. If that value
    // is undefined, it returns optionalDefaultValue instead.
    get: function(key, optionalDefaultValue) {
        var data = this.storage.read(this._namespacePrefix + key);
        return this._deserialize(data, optionalDefaultValue);
    },
    // set will store the given value at key and returns value.
    // Calling set with value === undefined is equivalent to calling remove.
    set: function(key, value) {
        if (value === undefined) return this.remove(key);
        this.storage.write(this._namespacePrefix + key, this._serialize(value));
        return value;
    },
    // remove deletes the key and value stored at the given key.
    remove: function(key) {
        this.storage.remove(this._namespacePrefix + key);
    },
    // each will call the given callback once for each key-value pair
    // in this store.
    each: function(callback) {
        var self = this;
        this.storage.each(function(val, namespacedKey) {
            callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''));
        });
    },
    // clearAll will remove all the stored key-value pairs in this store.
    clearAll: function() {
        this.storage.clearAll();
    },
    // additional functionality that can't live in plugins
    // ---------------------------------------------------
    // hasNamespace returns true if this store instance has the given namespace.
    hasNamespace: function(namespace) {
        return this._namespacePrefix == '__storejs_' + namespace + '_';
    },
    // createStore creates a store.js instance with the first
    // functioning storage in the list of storage candidates,
    // and applies the the given mixins to the instance.
    createStore: function() {
        return $a5e552eeddb8b6bd$var$createStore.apply(this, arguments);
    },
    addPlugin: function(plugin) {
        this._addPlugin(plugin);
    },
    namespace: function(namespace) {
        return $a5e552eeddb8b6bd$var$createStore(this.storage, this.plugins, namespace);
    }
};
function $a5e552eeddb8b6bd$var$_warn() {
    var _console = typeof console == 'undefined' ? null : console;
    if (!_console) return;
    var fn = _console.warn ? _console.warn : _console.log;
    fn.apply(_console, arguments);
}
function $a5e552eeddb8b6bd$var$createStore(storages, plugins, namespace) {
    if (!namespace) namespace = '';
    if (storages && !$a5e552eeddb8b6bd$var$isList(storages)) storages = [
        storages
    ];
    if (plugins && !$a5e552eeddb8b6bd$var$isList(plugins)) plugins = [
        plugins
    ];
    var namespacePrefix = namespace ? '__storejs_' + namespace + '_' : '';
    var namespaceRegexp = namespace ? new RegExp('^' + namespacePrefix) : null;
    var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
    ;
    if (!legalNamespaces.test(namespace)) throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes');
    var _privateStoreProps = {
        _namespacePrefix: namespacePrefix,
        _namespaceRegexp: namespaceRegexp,
        _testStorage: function(storage) {
            try {
                var testStr = '__storejs__test__';
                storage.write(testStr, testStr);
                var ok = storage.read(testStr) === testStr;
                storage.remove(testStr);
                return ok;
            } catch (e) {
                return false;
            }
        },
        _assignPluginFnProp: function(pluginFnProp, propName) {
            var oldFn = this[propName];
            this[propName] = function pluginFn() {
                var args = $a5e552eeddb8b6bd$var$slice(arguments, 0);
                var self = this;
                // super_fn calls the old function which was overwritten by
                // this mixin.
                function super_fn() {
                    if (!oldFn) return;
                    $a5e552eeddb8b6bd$var$each(arguments, function(arg, i) {
                        args[i] = arg;
                    });
                    return oldFn.apply(self, args);
                }
                // Give mixing function access to super_fn by prefixing all mixin function
                // arguments with super_fn.
                var newFnArgs = [
                    super_fn
                ].concat(args);
                return pluginFnProp.apply(self, newFnArgs);
            };
        },
        _serialize: function(obj) {
            return JSON.stringify(obj);
        },
        _deserialize: function(strVal, defaultVal) {
            if (!strVal) return defaultVal;
            // It is possible that a raw string value has been previously stored
            // in a storage without using store.js, meaning it will be a raw
            // string value instead of a JSON serialized string. By defaulting
            // to the raw string value in case of a JSON parse error, we allow
            // for past stored values to be forwards-compatible with store.js
            var val = '';
            try {
                val = JSON.parse(strVal);
            } catch (e) {
                val = strVal;
            }
            return val !== undefined ? val : defaultVal;
        },
        _addStorage: function(storage) {
            if (this.enabled) return;
            if (this._testStorage(storage)) {
                this.storage = storage;
                this.enabled = true;
            }
        },
        _addPlugin: function(plugin) {
            var self = this;
            // If the plugin is an array, then add all plugins in the array.
            // This allows for a plugin to depend on other plugins.
            if ($a5e552eeddb8b6bd$var$isList(plugin)) {
                $a5e552eeddb8b6bd$var$each(plugin, function(plugin) {
                    self._addPlugin(plugin);
                });
                return;
            }
            // Keep track of all plugins we've seen so far, so that we
            // don't add any of them twice.
            var seenPlugin = $a5e552eeddb8b6bd$var$pluck(this.plugins, function(seenPlugin) {
                return plugin === seenPlugin;
            });
            if (seenPlugin) return;
            this.plugins.push(plugin);
            // Check that the plugin is properly formed
            if (!$a5e552eeddb8b6bd$var$isFunction(plugin)) throw new Error('Plugins must be function values that return objects');
            var pluginProperties = plugin.call(this);
            if (!$a5e552eeddb8b6bd$var$isObject(pluginProperties)) throw new Error('Plugins must return an object of function properties');
            // Add the plugin function properties to this store instance.
            $a5e552eeddb8b6bd$var$each(pluginProperties, function(pluginFnProp, propName) {
                if (!$a5e552eeddb8b6bd$var$isFunction(pluginFnProp)) throw new Error('Bad plugin property: ' + propName + ' from plugin ' + plugin.name + '. Plugins should only return functions.');
                self._assignPluginFnProp(pluginFnProp, propName);
            });
        },
        // Put deprecated properties in the private API, so as to not expose it to accidential
        // discovery through inspection of the store object.
        // Deprecated: addStorage
        addStorage: function(storage) {
            $a5e552eeddb8b6bd$var$_warn('store.addStorage(storage) is deprecated. Use createStore([storages])');
            this._addStorage(storage);
        }
    };
    var store = $a5e552eeddb8b6bd$var$create(_privateStoreProps, $a5e552eeddb8b6bd$var$storeAPI, {
        plugins: []
    });
    store.raw = {};
    $a5e552eeddb8b6bd$var$each(store, function(prop, propName) {
        if ($a5e552eeddb8b6bd$var$isFunction(prop)) store.raw[propName] = $a5e552eeddb8b6bd$var$bind(store, prop);
    });
    $a5e552eeddb8b6bd$var$each(storages, function(storage) {
        store._addStorage(storage);
    });
    $a5e552eeddb8b6bd$var$each(plugins, function(plugin) {
        store._addPlugin(plugin);
    });
    return store;
}

});
parcelRegister("8rZnz", function(module, exports) {
var $627074fe69e92c9a$var$assign = $627074fe69e92c9a$var$make_assign();
var $627074fe69e92c9a$var$create = $627074fe69e92c9a$var$make_create();
var $627074fe69e92c9a$var$trim = $627074fe69e92c9a$var$make_trim();
var $627074fe69e92c9a$var$Global = typeof window !== 'undefined' ? window : $parcel$global;
module.exports = {
    assign: $627074fe69e92c9a$var$assign,
    create: $627074fe69e92c9a$var$create,
    trim: $627074fe69e92c9a$var$trim,
    bind: $627074fe69e92c9a$var$bind,
    slice: $627074fe69e92c9a$var$slice,
    each: $627074fe69e92c9a$var$each,
    map: $627074fe69e92c9a$var$map,
    pluck: $627074fe69e92c9a$var$pluck,
    isList: $627074fe69e92c9a$var$isList,
    isFunction: $627074fe69e92c9a$var$isFunction,
    isObject: $627074fe69e92c9a$var$isObject,
    Global: $627074fe69e92c9a$var$Global
};
function $627074fe69e92c9a$var$make_assign() {
    if (Object.assign) return Object.assign;
    else return function shimAssign(obj, props1, props2, etc) {
        for(var i = 1; i < arguments.length; i++)$627074fe69e92c9a$var$each(Object(arguments[i]), function(val, key) {
            obj[key] = val;
        });
        return obj;
    };
}
function $627074fe69e92c9a$var$make_create() {
    if (Object.create) return function create(obj, assignProps1, assignProps2, etc) {
        var assignArgsList = $627074fe69e92c9a$var$slice(arguments, 1);
        return $627074fe69e92c9a$var$assign.apply(this, [
            Object.create(obj)
        ].concat(assignArgsList));
    };
    else {
        function F() {} // eslint-disable-line no-inner-declarations
        return function create(obj, assignProps1, assignProps2, etc) {
            var assignArgsList = $627074fe69e92c9a$var$slice(arguments, 1);
            F.prototype = obj;
            return $627074fe69e92c9a$var$assign.apply(this, [
                new F()
            ].concat(assignArgsList));
        };
    }
}
function $627074fe69e92c9a$var$make_trim() {
    if (String.prototype.trim) return function trim(str) {
        return String.prototype.trim.call(str);
    };
    else return function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}
function $627074fe69e92c9a$var$bind(obj, fn) {
    return function() {
        return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
    };
}
function $627074fe69e92c9a$var$slice(arr, index) {
    return Array.prototype.slice.call(arr, index || 0);
}
function $627074fe69e92c9a$var$each(obj, fn) {
    $627074fe69e92c9a$var$pluck(obj, function(val, key) {
        fn(val, key);
        return false;
    });
}
function $627074fe69e92c9a$var$map(obj, fn) {
    var res = $627074fe69e92c9a$var$isList(obj) ? [] : {};
    $627074fe69e92c9a$var$pluck(obj, function(v, k) {
        res[k] = fn(v, k);
        return false;
    });
    return res;
}
function $627074fe69e92c9a$var$pluck(obj, fn) {
    if ($627074fe69e92c9a$var$isList(obj)) for(var i = 0; i < obj.length; i++){
        if (fn(obj[i], i)) return obj[i];
    }
    else {
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            if (fn(obj[key], key)) return obj[key];
        }
    }
}
function $627074fe69e92c9a$var$isList(val) {
    return val != null && typeof val != 'function' && typeof val.length == 'number';
}
function $627074fe69e92c9a$var$isFunction(val) {
    return val && ({}).toString.call(val) === '[object Function]';
}
function $627074fe69e92c9a$var$isObject(val) {
    return val && ({}).toString.call(val) === '[object Object]';
}

});


parcelRegister("5oLFf", function(module, exports) {
// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.
module.exports = {
    name: 'memoryStorage',
    read: $3ee42ac09d3b03d0$var$read,
    write: $3ee42ac09d3b03d0$var$write,
    each: $3ee42ac09d3b03d0$var$each,
    remove: $3ee42ac09d3b03d0$var$remove,
    clearAll: $3ee42ac09d3b03d0$var$clearAll
};
var $3ee42ac09d3b03d0$var$memoryStorage = {};
function $3ee42ac09d3b03d0$var$read(key) {
    return $3ee42ac09d3b03d0$var$memoryStorage[key];
}
function $3ee42ac09d3b03d0$var$write(key, data) {
    $3ee42ac09d3b03d0$var$memoryStorage[key] = data;
}
function $3ee42ac09d3b03d0$var$each(callback) {
    for(var key in $3ee42ac09d3b03d0$var$memoryStorage)if ($3ee42ac09d3b03d0$var$memoryStorage.hasOwnProperty(key)) callback($3ee42ac09d3b03d0$var$memoryStorage[key], key);
}
function $3ee42ac09d3b03d0$var$remove(key) {
    delete $3ee42ac09d3b03d0$var$memoryStorage[key];
}
function $3ee42ac09d3b03d0$var$clearAll(key) {
    $3ee42ac09d3b03d0$var$memoryStorage = {};
}

});

parcelRegister("c7VES", function(module, exports) {

var $8rZnz = parcelRequire("8rZnz");
var $8d42dd3d2e61c3b6$var$Global = $8rZnz.Global;
module.exports = {
    name: 'sessionStorage',
    read: $8d42dd3d2e61c3b6$var$read,
    write: $8d42dd3d2e61c3b6$var$write,
    each: $8d42dd3d2e61c3b6$var$each,
    remove: $8d42dd3d2e61c3b6$var$remove,
    clearAll: $8d42dd3d2e61c3b6$var$clearAll
};
function $8d42dd3d2e61c3b6$var$sessionStorage() {
    return $8d42dd3d2e61c3b6$var$Global.sessionStorage;
}
function $8d42dd3d2e61c3b6$var$read(key) {
    return $8d42dd3d2e61c3b6$var$sessionStorage().getItem(key);
}
function $8d42dd3d2e61c3b6$var$write(key, data) {
    return $8d42dd3d2e61c3b6$var$sessionStorage().setItem(key, data);
}
function $8d42dd3d2e61c3b6$var$each(fn) {
    for(var i = $8d42dd3d2e61c3b6$var$sessionStorage().length - 1; i >= 0; i--){
        var key = $8d42dd3d2e61c3b6$var$sessionStorage().key(i);
        fn($8d42dd3d2e61c3b6$var$read(key), key);
    }
}
function $8d42dd3d2e61c3b6$var$remove(key) {
    return $8d42dd3d2e61c3b6$var$sessionStorage().removeItem(key);
}
function $8d42dd3d2e61c3b6$var$clearAll() {
    return $8d42dd3d2e61c3b6$var$sessionStorage().clear();
}

});

parcelRegister("l0gQX", function(module, exports) {
$parcel$export(module.exports, "usePreviewPanelsActions", () => $0394b3e9ca285b52$export$5f5debba1692bf40);

var $jn0ly = parcelRequire("jn0ly");
const $0394b3e9ca285b52$var$noop = (props)=>{};
const $0394b3e9ca285b52$export$5f5debba1692bf40 = ()=>{
    const context = (0, $jn0ly.usePreviewPanelsContext)();
    if (!context) return {
        open: $0394b3e9ca285b52$var$noop,
        close: $0394b3e9ca285b52$var$noop,
        setPanelWidth: $0394b3e9ca285b52$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};

});
parcelRegister("jn0ly", function(module, exports) {
$parcel$export(module.exports, "PreviewPanelsProvider", () => $933e81775dcae40f$export$65ae37e9c61321f9);
$parcel$export(module.exports, "usePreviewPanelsContext", () => $933e81775dcae40f$export$609db4be92d0fad8);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $jc42K = parcelRequire("jc42K");

var $huais = parcelRequire("huais");
const $933e81775dcae40f$var$noop = ()=>{};
const $933e81775dcae40f$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $933e81775dcae40f$var$noop,
    onClose: $933e81775dcae40f$var$noop
};
const $933e81775dcae40f$export$f473d225913e225d = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
const $933e81775dcae40f$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $933e81775dcae40f$var$noop,
                onClose: $933e81775dcae40f$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
				When opening a new preview panel, if the current panel is of the same type we don't
				want to close the panel, but rather swap out the content. If the panel types don't match
				we close the current panel and open the new one.
				ex: A Goals panel is already open, and user tries to open a different Goals panel.
				Parent Products must pass their preview panel close functions to the Preview Panel provider
				via the `onPreviewPanelClose` prop.
			*/ if (state.panel && !(0, $huais.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $933e81775dcae40f$var$initialState.onOpen,
                onClose: params.onClose || $933e81775dcae40f$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $933e81775dcae40f$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $jc42K.usePanelWidth)((0, $egspI.fg)('nin_glance_panel_initial_width_ssr') ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $euxye.useReducer)($933e81775dcae40f$var$previewPanelsReducer, {
        ...$933e81775dcae40f$var$initialState,
        ...initialPanel && (0, $egspI.fg)('preview_panel_initial_state') ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $euxye.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $euxye.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $euxye.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $euxye.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($933e81775dcae40f$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
$933e81775dcae40f$export$65ae37e9c61321f9.displayName = "PreviewPanelsProvider";
const $933e81775dcae40f$export$609db4be92d0fad8 = ()=>{
    return (0, $euxye.useContext)($933e81775dcae40f$export$f473d225913e225d);
};

});
parcelRegister("jc42K", function(module, exports) {
$parcel$export(module.exports, "usePanelWidth", () => $fac349c571c610ec$export$82b270f291af5a5);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $eVMQF = parcelRequire("eVMQF");

var $inMxE = parcelRequire("inMxE");

var $2mQmw = parcelRequire("2mQmw");
const $fac349c571c610ec$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $euxye.useState)((0, $2mQmw.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $euxye.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $euxye.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $euxye.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $euxye.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $euxye.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $euxye.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $euxye.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($eVMQF)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $2mQmw.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $euxye.useEffect)(()=>{
        const unbind = (0, $glbdM.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};

});
parcelRegister("2mQmw", function(module, exports) {
$parcel$export(module.exports, "getDefaultPanelWidth", () => $1256d13e47ce4575$export$29ceecbfeef33bfc);
const $1256d13e47ce4575$var$PANEL_DEFAULT_WIDTH = 400;
const $1256d13e47ce4575$var$PANEL_MAX_WIDTH = 1000;
const $1256d13e47ce4575$var$MINIMUM_WIDTH = 1800;
const $1256d13e47ce4575$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $1256d13e47ce4575$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $1256d13e47ce4575$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $1256d13e47ce4575$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $1256d13e47ce4575$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $1256d13e47ce4575$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $1256d13e47ce4575$var$PANEL_MAX_WIDTH;
    }
    return width;
};

});


parcelRegister("huais", function(module, exports) {
$parcel$export(module.exports, "doPreviewPanelTypesMatch", () => $d815c866c1f5c58c$export$eb89e687f2b278d7);

var $6fsuc = parcelRequire("6fsuc");
const $d815c866c1f5c58c$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $6fsuc.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $6fsuc.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};

});



parcelRegister("5IRCU", function(module, exports) {
$parcel$export(module.exports, "useCurrentPreviewPanel", () => $809a3051ef2e2472$export$5351114e92b31bc6);

var $jn0ly = parcelRequire("jn0ly");
const $809a3051ef2e2472$export$5351114e92b31bc6 = ()=>{
    const context = (0, $jn0ly.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    return {
        ...context.state.panel,
        width: context.width,
        setWidth: context.setPanelWidth
    };
};

});

parcelRegister("jndX2", function(module, exports) {
$parcel$export(module.exports, "GlobalRoot", () => $b650d73d1b340800$export$619ad3a424d54038);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $1uH7N = parcelRequire("1uH7N");

var $17vVh = parcelRequire("17vVh");
var $9R2G9 = parcelRequire("9R2G9");
var $7GI4h = parcelRequire("7GI4h");
var $7I1eK = parcelRequire("7I1eK");
var $eLpG2 = parcelRequire("eLpG2");
var $2pWfK = parcelRequire("2pWfK");

var $5Km63 = parcelRequire("5Km63");

var $hXMfa = parcelRequire("hXMfa");

var $egspI = parcelRequire("egspI");

var $9qH0V = parcelRequire("9qH0V");

var $iikeY = parcelRequire("iikeY");

var $diTVj = parcelRequire("diTVj");

var $6LQvl = parcelRequire("6LQvl");
/**
 * Renders the default fallback top nav items when no children are supplied.
 *
 * Isolated into its own component so that useIntl() is only called on the path
 * that actually formats messages. Consumers that pass children (e.g. Jira via
 * TopNavSlot) never instantiate this component and therefore have no IntlProvider
 * requirement.
 */ function $b650d73d1b340800$var$FallbackTopNavItems({ appLabel: appLabel, isAnonymous: isAnonymous }) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2pWfK.TopNavStart), {
                sideNavToggleButton: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9R2G9.SideNavToggleButton), {
                    collapseLabel: formatMessage((0, $6LQvl.messages).collapseSidebar),
                    expandLabel: formatMessage((0, $6LQvl.messages).expandSidebar)
                }),
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        children: formatMessage((0, $6LQvl.messages).logo)
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        children: appLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $eLpG2.TopNavMiddle), {
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        children: formatMessage((0, $6LQvl.messages).search)
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        children: formatMessage((0, $6LQvl.messages).universalCreate)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $7I1eK.TopNavEnd), {
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        children: formatMessage((0, $6LQvl.messages).editionAwareness)
                    }),
                    !isAnonymous && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        children: formatMessage((0, $6LQvl.messages).conversationAssistant)
                    }),
                    !isAnonymous && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        children: formatMessage((0, $6LQvl.messages).notifications)
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hXMfa.Help), {
                        label: formatMessage((0, $6LQvl.messages).help)
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        children: formatMessage((0, $6LQvl.messages).settings)
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        children: formatMessage((0, $6LQvl.messages).profile)
                    })
                ]
            })
        ]
    });
}
$b650d73d1b340800$var$FallbackTopNavItems.displayName = "FallbackTopNavItems";
/**
 * Fallback top nav rendered when the consumer does not supply a TopNavSlot.
 *
 * Defined as a separate named component so that GlobalRoot itself has no
 * IntlProvider requirement. Consumers that supply their own TopNavSlot (the
 * vast majority) are completely unaffected. Only the fallback items path (used
 * in dev/testing when no children are passed) needs an IntlProvider in the tree.
 */ function $b650d73d1b340800$var$FallbackTopNav({ appLabel: appLabel, isAnonymous: isAnonymous, ...wrapperProps }) {
    return(// TODO: Change the ADS component to accept the sidebar width navx-3998
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7GI4h.TopNav), {
        testId: "global-root-topnav",
        ...wrapperProps,
        children: wrapperProps.children ? wrapperProps.children : /*#__PURE__*/ (0, $e79Pd.jsx)($b650d73d1b340800$var$FallbackTopNavItems, {
            appLabel: appLabel,
            isAnonymous: isAnonymous
        })
    }));
}
$b650d73d1b340800$var$FallbackTopNav.displayName = "FallbackTopNav";
function $b650d73d1b340800$export$619ad3a424d54038(props) {
    (0, $1uH7N.di)((0, $9qH0V.GlobalSideNavigation), (0, $7GI4h.TopNav), (0, $iikeY.default));
    const { app: app, appLabel: appLabel, children: children, isAnonymous: isAnonymous = false, isRibbonEnabled: isRibbonEnabled = (0, $egspI.fg)('navx-ribbon-rollout'), BannerSlot: BannerSlot, RibbonSlot: RibbonSlot, SideNavSlot: SideNavSlot, TopNavSlot: TopNavSlot, ...rootProps } = props;
    const BaseBanner = (0, $euxye.useCallback)((wrapperProps)=>{
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5Km63.Banner), {
            ...wrapperProps
        });
    }, []);
    const BaseRibbon = (0, $euxye.useCallback)((wrapperProps)=>{
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iikeY.default), {
            testId: "global-root-ribbon",
            ...wrapperProps
        });
    }, []);
    const BaseTopNav = (0, $euxye.useCallback)((wrapperProps)=>{
        return /*#__PURE__*/ (0, $e79Pd.jsx)($b650d73d1b340800$var$FallbackTopNav, {
            appLabel: appLabel,
            isAnonymous: isAnonymous,
            ...wrapperProps
        });
    }, [
        appLabel,
        isAnonymous
    ]);
    const BaseSideNav = (0, $euxye.useCallback)((wrapperProps)=>{
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9qH0V.GlobalSideNavigation), {
            app: app,
            appLabel: appLabel,
            testId: "global-root-sidenav",
            forYou: {},
            items: {},
            ...wrapperProps
        });
    }, [
        app,
        appLabel
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $diTVj.IsRibbonEnabledProvider), {
        value: isRibbonEnabled,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $17vVh.Root), {
            ...rootProps,
            children: [
                BannerSlot && /*#__PURE__*/ (0, $e79Pd.jsx)(BannerSlot, {
                    Banner: BaseBanner
                }),
                !isAnonymous && isRibbonEnabled && RibbonSlot !== null && (RibbonSlot ? /*#__PURE__*/ (0, $e79Pd.jsx)(RibbonSlot, {
                    Ribbon: BaseRibbon
                }) : /*#__PURE__*/ (0, $e79Pd.jsx)(BaseRibbon, {})),
                TopNavSlot !== null && (TopNavSlot ? /*#__PURE__*/ (0, $e79Pd.jsx)(TopNavSlot, {
                    TopNav: BaseTopNav
                }) : /*#__PURE__*/ (0, $e79Pd.jsx)(BaseTopNav, {})),
                SideNavSlot !== null && (SideNavSlot ? /*#__PURE__*/ (0, $e79Pd.jsx)(SideNavSlot, {
                    SideNav: BaseSideNav
                }) : /*#__PURE__*/ (0, $e79Pd.jsx)(BaseSideNav, {})),
                children
            ]
        })
    });
}
$b650d73d1b340800$export$619ad3a424d54038.displayName = "GlobalRoot";

});
parcelRegister("9qH0V", function(module, exports) {
$parcel$export(module.exports, "GlobalSideNavigation", () => $b7ee4ddfd9393ccd$export$e3822b656235cd34);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $iVtau = parcelRequire("iVtau");

var $3BBB7 = parcelRequire("3BBB7");

var $fnihK = parcelRequire("fnihK");

var $7NmHC = parcelRequire("7NmHC");
var $hWvME = parcelRequire("hWvME");

var $hctZP = parcelRequire("hctZP");

var $f3A47 = parcelRequire("f3A47");

var $dWWgU = parcelRequire("dWWgU");

var $ixu3u = parcelRequire("ixu3u");

var $69tcH = parcelRequire("69tcH");

var $4RLhz = parcelRequire("4RLhz");

var $kBtiJ = parcelRequire("kBtiJ");


var $B3kUb = parcelRequire("B3kUb");

var $cZZxG = parcelRequire("cZZxG");

var $fs8fG = parcelRequire("fs8fG");

var $xBNZo = parcelRequire("xBNZo");

var $1AXS3 = parcelRequire("1AXS3");

var $50EJx = parcelRequire("50EJx");
// `RawGlobalSideNavigation` is not memoised by default, so when its parent
// (e.g. Jira's `GSNForContentSidebarInner`) legitimately re-renders — for
// example as preloaded Relay data settles on load — the entire side-nav
// subtree re-renders even though none of its props changed identity. The
// props crossing this boundary are already referentially stable (the callers
// memoise `items`, `shortcuts`, `forYou`, `networkStorageParams`, etc.), so a
// memo boundary here lets the justified parent re-render happen without
// cascading a wasted re-render down the whole navigation tree.
//
// Gated behind `navx-4728-jira-stability-fixes`: gate ON wraps the component in
// `React.memo`, which performs a shallow (referential) comparison of all props
// and bails out when they are all equal; gate OFF renders the plain
// (unmemoised) component, preserving current behaviour. The default `React.memo`
// shallow comparator is exactly what we want here (the callers already memoise
// `items`, `shortcuts`, `forYou`, `networkStorageParams`, etc.), so no custom
// comparator is needed.
const $b7ee4ddfd9393ccd$var$MemoizedRawGlobalSideNavigation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo($b7ee4ddfd9393ccd$var$RawGlobalSideNavigation);
const $b7ee4ddfd9393ccd$var$GatedGlobalSideNavigation = (0, $iVtau.componentWithFG)('navx-4728-jira-stability-fixes', $b7ee4ddfd9393ccd$var$MemoizedRawGlobalSideNavigation, $b7ee4ddfd9393ccd$var$RawGlobalSideNavigation);
const $b7ee4ddfd9393ccd$export$e3822b656235cd34 = (0, $dWWgU.withSideNavigationAnalyticsContext)($b7ee4ddfd9393ccd$var$GatedGlobalSideNavigation);
var $b7ee4ddfd9393ccd$export$2e2bcd8739ae039 // This is only needed to support the Atlaskit docs. See https://hello.atlassian.net/wiki/spaces/navx/pages/5305993008/Platform+Guide#Atlaskit-%3CProps%3E-component-not-rendering
 = $b7ee4ddfd9393ccd$var$RawGlobalSideNavigation;
function $b7ee4ddfd9393ccd$var$RawGlobalSideNavigation(props) {
    const { app: app, appLabel: appLabel, cloudId: cloudId, customizationStore: customizationStore = 'local', defaultMenuVisibility: defaultMenuVisibility, disableMenuCustomization: disableMenuCustomization = false, forYou: forYou, growthItemShortcuts: growthItemShortcuts, intlMode: intlMode = 'async', isAnonymous: isAnonymous = false, isShortcutsStatic: isShortcutsStatic, items: items, networkStorageParams: networkStorageParams, peekMenuId: peekMenuId, shortcuts: shortcuts, userId: userId, ...innerProps } = props;
    const IntlWrapper = intlMode === 'inherit' ? (0, $euxye.Fragment) : (0, $ixu3u.AsyncIntlProvider);
    // If user is anon, disable menu customization and use local store
    const effectiveDisableMenuCustomization = disableMenuCustomization || isAnonymous;
    const effectiveCustomizationStore = isAnonymous ? 'local' : customizationStore;
    const Store = (0, $euxye.useMemo)(()=>{
        switch(effectiveCustomizationStore){
            case 'local':
                return 0, $fs8fG.LocalStore;
            case 'network-migration':
                return 0, $xBNZo.NetworkMigrationStore;
            default:
                return 0, $1AXS3.NetworkStore;
        }
    }, [
        effectiveCustomizationStore
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3BBB7.default), {
        name: (0, $e695cbb6f90a2d72$export$74a97a85614272ea),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)(IntlWrapper, {
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fnihK.ModalContextProvider), {
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f3A47.NavErrorBoundary), {
                    errorFallbackUI: ({ header: header, description: description })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $B3kUb.SideNavigationLayout), {
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hctZP.NavEmptyState), {
                                header: header,
                                description: description
                            })
                        }),
                    errorMessages: (0, $cZZxG.messages),
                    // `location` is no longer used for error-message lookup; it is retained
                    // purely to tag the nav-boundary context for Sentry/analytics so errors
                    // caught at the top of the side nav remain attributable to this surface.
                    location: "global-side-navigation",
                    sentryConfig: {
                        product: app
                    },
                    ufoInteractionName: (0, $e695cbb6f90a2d72$export$74a97a85614272ea),
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hWvME.BFFProvider), {
                        consumer: (0, $7NmHC.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4RLhz.OptionsProvider), {
                            app: app,
                            appLabel: appLabel,
                            cloudId: cloudId,
                            customizationStore: effectiveCustomizationStore,
                            defaultMenuVisibility: defaultMenuVisibility,
                            disableMenuCustomization: effectiveDisableMenuCustomization,
                            hasBottomElement: !!innerProps?.bottomElem,
                            intlMode: intlMode,
                            isShortcutsStatic: isShortcutsStatic || isAnonymous,
                            l1DragAndDropEnabled: !effectiveDisableMenuCustomization,
                            networkStorageParams: networkStorageParams,
                            userId: userId,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $69tcH.ItemsAndShortcutsProvider), {
                                forYou: isAnonymous ? {} : forYou,
                                growthItemShortcuts: growthItemShortcuts,
                                items: isAnonymous && props.anonymousItems ? props.anonymousItems : items,
                                rawShortcuts: shortcuts,
                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kBtiJ.PeekMenuIdProviders), {
                                    value: peekMenuId,
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)(Store, {
                                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $50EJx.SideNav), {
                                            ...innerProps
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}
$b7ee4ddfd9393ccd$var$RawGlobalSideNavigation.displayName = "RawGlobalSideNavigation";

});
parcelRegister("7NmHC", function(module, exports) {
$parcel$export(module.exports, "BFFConsumerEnum", () => $4dcf54dc4451358c$export$9a146e025690327e);
$parcel$export(module.exports, "ASSETS_APP_KEY", () => $4dcf54dc4451358c$export$45e63649edff1e2a);
$parcel$export(module.exports, "RETRY_INTERVAL_DEFAULT", () => $4dcf54dc4451358c$export$7b4183e5f0de390a);
$parcel$export(module.exports, "MAX_ATTEMPTS_NEW_DEFAULT", () => $4dcf54dc4451358c$export$2edbfcb69dc77e78);
$parcel$export(module.exports, "RequestStatus", () => $4dcf54dc4451358c$export$600e7c1f9e0414e1);
$parcel$export(module.exports, "BFF_REQUEST_STATUS_KEY", () => $4dcf54dc4451358c$export$c889532d47d74e9c);
$parcel$export(module.exports, "FLIGHTDECK_REQUEST_STATUS_KEY", () => $4dcf54dc4451358c$export$123b1b8742c0ac6a);
$parcel$export(module.exports, "UC_MENU_ITEMS_REQUEST_STATUS_KEY", () => $4dcf54dc4451358c$export$1631e8a201b50246);
var $4dcf54dc4451358c$export$9a146e025690327e = /*#__PURE__*/ function(BFFConsumerEnum) {
    BFFConsumerEnum["ATLASSIAN_SWITCHER"] = "ATLASSIAN_SWITCHER";
    BFFConsumerEnum["GLOBAL_SHORTCUTS"] = "GLOBAL_SHORTCUTS";
    BFFConsumerEnum["GLOBAL_SIDE_NAVIGATION"] = "GLOBAL_SIDE_NAVIGATION";
    BFFConsumerEnum["UNIVERSAL_CREATE"] = "UNIVERSAL_CREATE";
    return BFFConsumerEnum;
}({});
const $4dcf54dc4451358c$export$45e63649edff1e2a = 'ASSETS';
const $4dcf54dc4451358c$export$45c80c6b98d65f36 = 3;
const $4dcf54dc4451358c$export$7b4183e5f0de390a = 1000;
const $4dcf54dc4451358c$export$2edbfcb69dc77e78 = 1;
const $4dcf54dc4451358c$export$891dc7068a3d5e65 = 14;
const $4dcf54dc4451358c$export$6e594fe130dbe3b = 14;
var $4dcf54dc4451358c$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["INIT"] = "initializing";
    RequestStatus["LOADING"] = "loading";
    RequestStatus["COMPLETE"] = "complete";
    RequestStatus["ERROR"] = "error";
    return RequestStatus;
}({});
const $4dcf54dc4451358c$export$c889532d47d74e9c = 'bff';
const $4dcf54dc4451358c$export$123b1b8742c0ac6a = 'flightdeck';
const $4dcf54dc4451358c$export$1631e8a201b50246 = 'uc-menu-items';

});

parcelRegister("hWvME", function(module, exports) {
$parcel$export(module.exports, "BFFContext", () => $91a0f05750223d25$export$873dcaf380a86d6b);
$parcel$export(module.exports, "useBFFContext", () => $91a0f05750223d25$export$63342c357ecccda2);
$parcel$export(module.exports, "BFFProvider", () => $91a0f05750223d25$export$71a938590b6955cc);
$parcel$export(module.exports, "useUserContext", () => $91a0f05750223d25$export$87c54b525b914dab);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $7NmHC = parcelRequire("7NmHC");
const $91a0f05750223d25$export$b2445cd6f2d7fd5 = {
    cache: {},
    cacheKey: '',
    status: null,
    consumer: null
};
const $91a0f05750223d25$export$873dcaf380a86d6b = /*#__PURE__*/ (0, $euxye.createContext)({
    value: $91a0f05750223d25$export$b2445cd6f2d7fd5,
    currentLoadingRequests: [],
    setValue: ()=>{},
    updateCurrentLoadingRequests: ()=>{}
});
function $91a0f05750223d25$export$63342c357ecccda2() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useContext($91a0f05750223d25$export$873dcaf380a86d6b);
}
function $91a0f05750223d25$export$71a938590b6955cc({ consumer: consumer, children: children }) {
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useState({
        cache: {},
        cacheKey: consumer,
        consumer: consumer,
        status: (0, $7NmHC.RequestStatus).INIT
    });
    const [currentLoadingRequests, setCurrentLoadingRequests] = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useState([]);
    const updateCurrentLoadingRequests = (0, $euxye.useCallback)((name, status)=>{
        switch(status){
            case (0, $7NmHC.RequestStatus).LOADING:
                setCurrentLoadingRequests((prev)=>[
                        ...prev,
                        name
                    ]);
                break;
            case (0, $7NmHC.RequestStatus).COMPLETE:
                setCurrentLoadingRequests((prev)=>prev.filter((request)=>request !== name));
                break;
            case (0, $7NmHC.RequestStatus).ERROR:
                setCurrentLoadingRequests([]);
                break;
        }
    }, [
        setCurrentLoadingRequests
    ]);
    const stableContextValue = (0, $euxye.useMemo)(()=>({
            value: value,
            setValue: setValue,
            currentLoadingRequests: currentLoadingRequests,
            updateCurrentLoadingRequests: updateCurrentLoadingRequests
        }), [
        currentLoadingRequests,
        updateCurrentLoadingRequests,
        value
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($91a0f05750223d25$export$873dcaf380a86d6b.Provider, {
        value: stableContextValue,
        children: children
    });
}
$91a0f05750223d25$export$71a938590b6955cc.displayName = "BFFProvider";
const $91a0f05750223d25$var$defaultUserControls = {
    user: undefined
};
const $91a0f05750223d25$export$38ee920e59704589 = /*#__PURE__*/ (0, $euxye.createContext)($91a0f05750223d25$var$defaultUserControls);
function $91a0f05750223d25$export$87c54b525b914dab() {
    return (0, $euxye.useContext)($91a0f05750223d25$export$38ee920e59704589);
}

});

parcelRegister("hctZP", function(module, exports) {
$parcel$export(module.exports, "NavEmptyState", () => $abf62e616a2c40c2$export$618cc98292cae482);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $j26jU = parcelRequire("j26jU");

var $ihEDU = parcelRequire("ihEDU");

var $gNHJ8 = parcelRequire("gNHJ8");

var $iLXbL = parcelRequire("iLXbL");
const $abf62e616a2c40c2$var$styles = {
    textWrapper: "_195g1wug _p12fo8uj _1e0c1o8l",
    imageWrapper: "_n3td1jfw"
};
function $abf62e616a2c40c2$export$618cc98292cae482({ testId: testId = 'navigation-empty-state', renderImage: renderImage = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: $abf62e616a2c40c2$var$styles.imageWrapper,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iLXbL.GenericErrorIcon), {})
    }), description: description, ...restProps }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $j26jU.default), {
        ...restProps,
        testId: testId,
        renderImage: renderImage,
        headingLevel: 3,
        headingSize: "xsmall",
        description: /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
            className: (0, $4jQY2.default)([
                $abf62e616a2c40c2$var$styles.textWrapper
            ]),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gNHJ8.default), {
                size: "small",
                color: "color.text.subtle",
                children: description
            })
        })
    });
}
$abf62e616a2c40c2$export$618cc98292cae482.displayName = "NavEmptyState";

});
parcelRegister("iLXbL", function(module, exports) {
$parcel$export(module.exports, "GenericErrorIcon", () => $83169ceca50e42e0$export$f370712d0ce7173b);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $bV5W6 = parcelRequire("bV5W6");
const $83169ceca50e42e0$export$f370712d0ce7173b = ()=>{
    const theme = (0, $bV5W6.useColorMode)();
    const isDarkTheme = theme === 'dark';
    const fillColour = isDarkTheme ? '#4B4D51' : '#DDDEE1';
    const innerColour = isDarkTheme ? '#101214' : 'white';
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("svg", {
        "data-testid": "navigation-empty-state--generic-error-icon",
        width: "57",
        height: "53",
        viewBox: "0 0 57 53",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                d: "M0 52.5871L0.0314182 52.6499H56.8739L56.9088 52.5871L28.4544 0L0 52.5871Z",
                fill: fillColour
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.2725 38.0368V18.8333H29.8313V38.0368H27.2725Z",
                fill: innerColour
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28.0814 41.2098C28.2675 41.1764 28.4451 41.1665 28.5973 41.1665C28.7583 41.1665 28.9179 41.1777 29.0781 41.2023L29.084 41.2032L29.0899 41.2042C30.1047 41.37 30.9494 42.0762 31.154 43.2046C31.19 43.3958 31.1998 43.5794 31.1998 43.7306C31.1998 43.8478 31.1939 43.9799 31.1754 44.1197V44.1412L31.1552 44.2533C30.9533 45.3786 30.1106 46.0937 29.0899 46.2604L29.084 46.2614L29.0781 46.2623C28.9179 46.287 28.7583 46.2981 28.5973 46.2981C28.444 46.2981 28.2649 46.2881 28.0772 46.2541C27.0757 46.0805 26.2351 45.3807 26.0303 44.2574C25.9948 44.0692 25.9844 43.8932 25.9844 43.7341C25.9844 43.5767 25.9945 43.3951 26.0311 43.2033C26.2382 42.0971 27.0613 41.3814 28.0814 41.2098ZM28.5432 43.7274C28.5432 43.7295 28.5432 43.7318 28.5432 43.7341C28.5432 43.7352 28.5432 43.7362 28.5432 43.7373C28.5444 43.7374 28.5456 43.7375 28.547 43.7376C28.559 43.7385 28.5757 43.7393 28.5973 43.7393C28.6137 43.7393 28.6281 43.7389 28.6409 43.7381C28.6409 43.7357 28.641 43.7332 28.641 43.7306C28.641 43.7292 28.641 43.7278 28.6409 43.7265C28.6282 43.7258 28.6137 43.7253 28.5973 43.7253C28.5757 43.7253 28.559 43.7261 28.547 43.727C28.5457 43.7272 28.5444 43.7273 28.5432 43.7274Z",
                fill: innerColour
            })
        ]
    });
};
$83169ceca50e42e0$export$f370712d0ce7173b.displayName = "GenericErrorIcon";

});


parcelRegister("f3A47", function(module, exports) {
$parcel$export(module.exports, "NavErrorBoundary", () => $40bcead3318a1702$export$afc779e659fd533f);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $9aD9w = parcelRequire("9aD9w");

var $6xxcW = parcelRequire("6xxcW");

var $37KTn = parcelRequire("37KTn");

var $hhv7M = parcelRequire("hhv7M");

var $1gjsF = parcelRequire("1gjsF");

var $5GLMc = parcelRequire("5GLMc");

var $9L6yp = parcelRequire("9L6yp");

var $bEbww = parcelRequire("bEbww");
function $40bcead3318a1702$export$afc779e659fd533f(props) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6xxcW.FlagsProvider), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($40bcead3318a1702$var$InnerErrorBoundary, {
            ...props
        })
    });
}
$40bcead3318a1702$export$afc779e659fd533f.displayName = "NavErrorBoundary";
function $40bcead3318a1702$var$InnerErrorBoundary({ disableAnalytics: disableAnalytics = false, disableSentry: disableSentry = false, errorActionUI: errorActionUI, errorFallbackUI: errorFallbackUI, errorMessages: errorMessages, errorMessageValues: errorMessageValues, interactionId: interactionId, location: location = 'unknown', onError: onError, showFlags: showFlags, silent: silent, children: children, sentryConfig: sentryConfig, tags: tags, ufoInteractionName: ufoInteractionName }) {
    const { header: header, description: description, values: values } = (0, $hhv7M.useBoundaryMessages)({
        errorMessages: errorMessages,
        errorMessageValues: errorMessageValues
    });
    const flags = (0, $5GLMc.useMessageFlags)({
        showFlags: showFlags
    });
    const emitFailureFlag = (0, $1gjsF.useFailureFlagEmitter)(flags);
    const reportInteractionError = (0, $9L6yp.useReportInteractionError)({
        interactionId: interactionId,
        ufoInteractionName: ufoInteractionName
    });
    const onErrorUIHandler = (0, $euxye.useCallback)((error)=>{
        emitFailureFlag({
            header: header,
            description: description,
            values: values
        });
        reportInteractionError(error);
        onError?.(error);
    }, [
        emitFailureFlag,
        reportInteractionError,
        header,
        description,
        values,
        onError
    ]);
    const { handleError: handleError } = (0, $37KTn.useNavBoundaryContext)({
        disableAnalytics: disableAnalytics,
        disableSentry: disableSentry,
        interactionId: interactionId,
        location: location,
        onError: onErrorUIHandler,
        sentryConfig: sentryConfig,
        tags: tags
    });
    // When `silent` is true or `flags` are enabled, we don't want to show any UI on error
    const errorComponent = silent || flags ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {}) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bEbww.ErrorBoundaryUI), {
        disableAnalytics: disableAnalytics,
        errorActionUI: errorActionUI,
        errorFallbackUI: errorFallbackUI,
        errorMessages: errorMessages,
        errorMessageValues: errorMessageValues,
        location: location
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9aD9w.ErrorBoundary), {
        onError: handleError,
        fallback: errorComponent,
        children: children
    });
}
$40bcead3318a1702$var$InnerErrorBoundary.displayName = "InnerErrorBoundary";

});
parcelRegister("9aD9w", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("euxye")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("37KTn", function(module, exports) {
$parcel$export(module.exports, "useNavBoundaryContext", () => $e582b357099f0163$export$335b0c12ccf77339);

var $euxye = parcelRequire("euxye");

var $9mypc = parcelRequire("9mypc");

var $lDZVX = parcelRequire("lDZVX");

var $aSsYL = parcelRequire("aSsYL");
function $e582b357099f0163$export$335b0c12ccf77339({ location: location = 'unknown', disableSentry: disableSentry = false, disableAnalytics: disableAnalytics = false, onError: onError, sentryConfig: sentryConfig, tags: tags } = {}) {
    const { fireEvent: fireEvent } = (0, $9mypc.useAnalyticsEvents)();
    if (!disableSentry) try {
        (0, $lDZVX.setupSentryClient)({
            sentryConfig: sentryConfig
        });
    } catch (error) {
        // Log failure to initialize Sentry
        fireEvent('operational.initSentry.failed', {
            location: location,
            reason: error instanceof Error ? error.message : 'unknown'
        });
    }
    const tagsToLog = (0, $euxye.useMemo)(()=>{
        return {
            ...tags,
            location: location,
            teamName: (0, $aSsYL.SENTRY_TEAM_NAME),
            product: sentryConfig?.product ?? (0, $aSsYL.SENTRY_PRODUCT),
            productBuild: $e582b357099f0163$var$getProductBuild()
        };
    }, [
        tags,
        location,
        sentryConfig?.product
    ]);
    const handleError = (0, $euxye.useCallback)((error)=>{
        // Send events to sentry
        if (!disableSentry) try {
            (0, $lDZVX.logException)(error, tagsToLog);
        } catch (err) {
            // Log failure to send to Sentry
            fireEvent('operational.logToSentry.failed', {
                location: location,
                reason: err instanceof Error ? err.message : 'unknown'
            });
        }
        // Fire Analytics event
        if (!disableAnalytics) fireEvent('operational.errorBoundary.unhandledErrorCaught', {
            location: location,
            errorMessage: error.message,
            errorStack: error.stack || 'no stack trace'
        });
        // Invoke external onError
        onError?.(error);
    }, [
        disableSentry,
        disableAnalytics,
        onError,
        location,
        tagsToLog,
        fireEvent
    ]);
    return {
        handleError: handleError
    };
}
function $e582b357099f0163$var$getProductBuild() {
    // Ensure we don't invoke window object in SSR
    if (typeof window === 'undefined') return 'unknown';
    switch(true){
        // Jira - window.BUILD_KEY
        case 'BUILD_KEY' in window:
            return window.BUILD_KEY || 'unknown';
        // Confluence - window.__buildInfo
        case '__buildInfo' in window:
            return window.__buildInfo?.FRONTEND_VERSION || 'unknown';
        default:
            return 'unknown';
    }
}

});
parcelRegister("9mypc", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $9c1c906020150311$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::852a07e098801d09532a079dc210ca17>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen navigation-common
 */ 
var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");


var $dAAoU = parcelRequire("dAAoU");
const $9c1c906020150311$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireEvent = (0, $euxye.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $dAAoU.default)(...params));
        event.fire((0, $a33a0b7c1b6db775$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $a33a0b7c1b6db775$export$3f072f06b90c3985 = 'navigation';

parcelRegister("dAAoU", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4e450dcca9216d9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::85436479424fa726e1c817d9c4b6af72>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen navigation-common
 */ const $a4e450dcca9216d9$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $a4e450dcca9216d9$export$2e2bcd8739ae039 = $a4e450dcca9216d9$var$createEventPayload;

});


parcelRegister("lDZVX", function(module, exports) {
$parcel$export(module.exports, "logException", () => $76050c74a0c01308$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "setupSentryClient", () => $76050c74a0c01308$export$d8bd0edf6c978788);

var $iQyrW = parcelRequire("iQyrW");
var $21oNa = parcelRequire("21oNa");
var $eGgLE = parcelRequire("eGgLE");
var $5UoQk = parcelRequire("5UoQk");
var $dmR7m = parcelRequire("dmR7m");

var $egspI = parcelRequire("egspI");

var $9WJBh = parcelRequire("9WJBh");

var $8gRAU = parcelRequire("8gRAU");

var $aSsYL = parcelRequire("aSsYL");
let $76050c74a0c01308$var$sentryClient;
let $76050c74a0c01308$var$scope = new (0, $dmR7m.Scope)();
function $76050c74a0c01308$export$ef31311040ebdb46(event) {
    const exceptionValue = event.exception?.values?.[0]?.value ?? '';
    const candidates = [
        exceptionValue,
        event.message ?? ''
    ].filter(Boolean);
    if (candidates.length > 0 && (0, $aSsYL.SUPPRESSED_BACKEND_ERROR_PATTERNS).some((re)=>candidates.some((c)=>re.test(c)))) return true;
    // BFFNetworkError 5xx via flattened scope.extras (set by logException)
    const extras = event.extra;
    if (extras?.name === 'BFF_NETWORK_ERROR') {
        const status = Number(extras.status);
        if (!Number.isNaN(status) && status >= 500) return true;
    }
    return false;
}
function $76050c74a0c01308$export$f86b2a1a2ce291b3(exception, tags) {
    $76050c74a0c01308$var$scope.setTags(tags);
    if (exception instanceof (0, $9WJBh.BFFError)) {
        const error = exception;
        $76050c74a0c01308$var$scope.setExtras({
            name: error.name,
            context: error.context,
            status: error.status,
            timestamp: error.timestamp,
            originalError: error.originalError,
            ...error instanceof (0, $9WJBh.BFFNetworkError) && {
                url: error.url
            }
        });
    }
    $76050c74a0c01308$var$sentryClient?.captureException(exception, undefined, $76050c74a0c01308$var$scope);
    // Unset tags to prevent an instance of the error boundary from logging with a specific tag,
    // and then another instance from wrongly passing it despite not having the tag.
    for (const [key, _] of Object.entries(tags))$76050c74a0c01308$var$scope.setTag(key, undefined);
    // Unset any extras to prevent them from persisting
    $76050c74a0c01308$var$scope.setExtras({});
}
function $76050c74a0c01308$export$d8bd0edf6c978788({ sentryConfig: sentryConfig }) {
    const { dsn: dsn = (0, $aSsYL.SENTRY_DSN), env: env } = sentryConfig || {};
    if (!$76050c74a0c01308$var$sentryClient) {
        // SSR-safe check. If we are in SSR, we don't need a sentryClient
        if (typeof window === 'undefined') return false;
        const environment = (0, $8gRAU.getEnvironment)(env);
        // filter integrations that use the global variable
        const integrations = (0, $eGgLE.getDefaultIntegrations)({}).filter((defaultIntegration)=>{
            return ![
                'BrowserApiErrors',
                'Breadcrumbs',
                'GlobalHandlers'
            ].includes(defaultIntegration.name);
        });
        // NAVX-4946: gate BE-noise suppression behind a feature flag.
        const isSentryFilteringEnabled = (0, $egspI.fg)('navx-4946-sentry-filtering');
        $76050c74a0c01308$var$sentryClient = new (0, $iQyrW.BrowserClient)({
            ...(0, $aSsYL.DEFAULT_SENTRY_CONFIG),
            ignoreErrors: isSentryFilteringEnabled ? [
                ...(0, $aSsYL.DEFAULT_SENTRY_CONFIG).ignoreErrors,
                ...(0, $aSsYL.SUPPRESSED_BACKEND_ERROR_PATTERNS)
            ] : (0, $aSsYL.DEFAULT_SENTRY_CONFIG).ignoreErrors,
            dsn: dsn,
            environment: environment,
            beforeSend: (event)=>{
                // Only events captured via logException (which sets teamName)
                if (event.tags?.teamName === undefined) return null;
                if (isSentryFilteringEnabled && $76050c74a0c01308$export$ef31311040ebdb46(event)) return null;
                return event;
            },
            attachStacktrace: true,
            transport: (0, $5UoQk.makeFetchTransport),
            stackParser: (0, $21oNa.defaultStackParser),
            integrations: integrations
        });
        $76050c74a0c01308$var$scope.setClient($76050c74a0c01308$var$sentryClient);
        $76050c74a0c01308$var$sentryClient.init();
    }
    return true;
}
function $76050c74a0c01308$export$64db7b418e82aaf6() {
    $76050c74a0c01308$var$sentryClient = undefined;
    $76050c74a0c01308$var$scope = new (0, $dmR7m.Scope)();
}

});
parcelRegister("9WJBh", function(module, exports) {
$parcel$export(module.exports, "BFFError", () => $692af393e59d5ac6$export$c6a4f8515f74c5c8);
$parcel$export(module.exports, "BFFNetworkError", () => $692af393e59d5ac6$export$f4de77e3e154579c);
/**
 * ------------------------------------------------------------------
 * BFF Error Classes
 * Shared error handling for BFF operations / observability
 * ------------------------------------------------------------------
 */ var $692af393e59d5ac6$export$7d83cc20f4070394 = /*#__PURE__*/ function(BFFErrorEnum) {
    BFFErrorEnum["BFF_ERROR"] = "BFF_ERROR";
    BFFErrorEnum["BFF_NETWORK_ERROR"] = "BFF_NETWORK_ERROR";
    return BFFErrorEnum;
}({});
class $692af393e59d5ac6$export$c6a4f8515f74c5c8 extends Error {
    constructor(message, context){
        super(message);
        this.name = "BFF_ERROR";
        this.context = context.additionalContext;
        this.originalError = context.originalError;
        this.status = context.status;
        this.timestamp = new Date().toISOString();
    }
}
class $692af393e59d5ac6$export$f4de77e3e154579c extends $692af393e59d5ac6$export$c6a4f8515f74c5c8 {
    constructor(message, context){
        super(message, context);
        this.name = "BFF_NETWORK_ERROR";
        this.url = context.url;
    }
}

});

parcelRegister("8gRAU", function(module, exports) {
$parcel$export(module.exports, "getEnvironment", () => $2d8877c96cd45efd$export$57570b1603cf6adb);

var $2IHf5 = parcelRequire("2IHf5");

var $9ZCNK = parcelRequire("9ZCNK");
function $2d8877c96cd45efd$export$57570b1603cf6adb(env) {
    if (env) return env;
    if (typeof window === 'undefined' || !window.location) return (0, $9ZCNK.Environment).Unknown;
    const host = window.location.hostname.toLowerCase();
    // Fast path: exact hostname matches
    const exactMatch = (0, $2IHf5.EXACT_HOST_MAP)[host];
    if (exactMatch) return exactMatch;
    // Extract TLD for efficient branching (find last dot position)
    const lastDot = host.lastIndexOf('.');
    if (lastDot === -1) return (0, $9ZCNK.Environment).Unknown;
    const tld = host.slice(lastDot + 1); // 'com', 'net', etc.
    // Branch by TLD to reduce checks
    switch(tld){
        case 'com':
            return $2d8877c96cd45efd$var$classifyComDomain(host);
        case 'net':
            return $2d8877c96cd45efd$var$classifyNetDomain(host);
        default:
            return (0, $9ZCNK.Environment).Unknown;
    }
}
/**
 * Classify .com domains
 */ function $2d8877c96cd45efd$var$classifyComDomain(host) {
    // jira-dev.com (staging)
    if (host.endsWith('.jira-dev.com')) return (0, $9ZCNK.Environment).Staging;
    // atlassian-us-gov-mod.com (FedRAMP)
    if (host.endsWith('.atlassian-us-gov-mod.com')) {
        // FedRAMP Bifrost CDN: check most specific first
        if (host.endsWith('.frontend.cdn.atlassian-us-gov-mod.com')) return host.includes('.stg.') ? (0, $9ZCNK.Environment).Staging : (0, $9ZCNK.Environment).Prod;
        if (host.endsWith('.stg.atlassian-us-gov-mod.com')) return (0, $9ZCNK.Environment).Staging;
        return (0, $9ZCNK.Environment).Prod;
    }
    // atlassian.com domains
    if (host.endsWith('.atlassian.com')) {
        // services.atlassian.com vanity domains (check most specific first)
        if (host.endsWith('.dev.services.atlassian.com')) return (0, $9ZCNK.Environment).Development;
        if (host.endsWith('.staging.services.atlassian.com')) return (0, $9ZCNK.Environment).Staging;
        if (host.endsWith('.services.atlassian.com')) return (0, $9ZCNK.Environment).Prod;
        // Environment-specific subdomains
        if (host.endsWith('.dev.atlassian.com')) return (0, $9ZCNK.Environment).Development;
        if (host.endsWith('.stg.atlassian.com')) return (0, $9ZCNK.Environment).Staging;
        return (0, $9ZCNK.Environment).Prod;
    }
    return (0, $9ZCNK.Environment).Unknown;
}
/**
 * Classify .net domains
 */ function $2d8877c96cd45efd$var$classifyNetDomain(host) {
    // atlassian.net (prod tenants)
    if (host.endsWith('.atlassian.net')) return (0, $9ZCNK.Environment).Prod;
    // atl-paas-us-gov-mod.net (FedRAMP Micros)
    if (host.endsWith('.atl-paas-us-gov-mod.net')) {
        if (host.includes('.staging.')) return (0, $9ZCNK.Environment).Staging;
        if (host.includes('.prod.')) return (0, $9ZCNK.Environment).Prod;
        return (0, $9ZCNK.Environment).Unknown;
    }
    // atl-paas.net (commercial Micros and Bifrost)
    if (host.endsWith('.atl-paas.net')) {
        // Bifrost commercial: check most specific first
        if (host.endsWith('.frontend.public.atl-paas.net')) {
            if (host.includes('.ddev.') || host.includes('.dev-west2.')) return (0, $9ZCNK.Environment).Development;
            if (host.includes('.stg-east.')) return (0, $9ZCNK.Environment).Staging;
            if (host.includes('.prod-east.')) return (0, $9ZCNK.Environment).Prod;
            return (0, $9ZCNK.Environment).Development;
        }
        // Micros commercial
        if (host.includes('.dev.') || host.includes('.platdev.')) return (0, $9ZCNK.Environment).Development;
        if (host.includes('.staging.')) return (0, $9ZCNK.Environment).Staging;
        if (host.includes('.prod.')) return (0, $9ZCNK.Environment).Prod;
    }
    return (0, $9ZCNK.Environment).Unknown;
}

});
parcelRegister("2IHf5", function(module, exports) {
$parcel$export(module.exports, "EXACT_HOST_MAP", () => $31de349f7e01a3f7$export$636c0c57a2ce36e9);

var $9ZCNK = parcelRequire("9ZCNK");
const $31de349f7e01a3f7$export$636c0c57a2ce36e9 = {
    localhost: (0, $9ZCNK.Environment).Development,
    '127.0.0.1': (0, $9ZCNK.Environment).Development,
    'id.atlassian.com': (0, $9ZCNK.Environment).Prod,
    'admin.atlassian.com': (0, $9ZCNK.Environment).Prod,
    'id.stg.internal.atlassian.com': (0, $9ZCNK.Environment).Staging,
    'admin.stg.atlassian.com': (0, $9ZCNK.Environment).Staging
};

});
parcelRegister("9ZCNK", function(module, exports) {
$parcel$export(module.exports, "Environment", () => $c025c3969372d145$export$7dc6752a22ab011a);
var $c025c3969372d145$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
    Environment["Unknown"] = "unknown";
    return Environment;
}({});

});



parcelRegister("aSsYL", function(module, exports) {
$parcel$export(module.exports, "SENTRY_DSN", () => $79e15b4fd054124f$export$6faa4a850bc4d0ce);
$parcel$export(module.exports, "SENTRY_TEAM_NAME", () => $79e15b4fd054124f$export$eafddbd5a5d6fa6a);
$parcel$export(module.exports, "SUPPRESSED_BACKEND_ERROR_PATTERNS", () => $79e15b4fd054124f$export$3a6a639b0dcb30fa);
$parcel$export(module.exports, "DEFAULT_SENTRY_CONFIG", () => $79e15b4fd054124f$export$52d764e0fd2a1dc5);
$parcel$export(module.exports, "SENTRY_PRODUCT", () => $79e15b4fd054124f$export$9f448e5ee63d7699);
// Navigation-experience Sentry DSN
const $79e15b4fd054124f$export$6faa4a850bc4d0ce = 'https://b8c4ebbdd822beb92561fea2a46d2146@o55978.ingest.us.sentry.io/4510463033081856';
const $79e15b4fd054124f$export$eafddbd5a5d6fa6a = 'afe-navigation-experience';
const $79e15b4fd054124f$export$3a6a639b0dcb30fa = [
    // Browser-level network failures
    /Failed to fetch$/i,
    /NetworkError when attempting to fetch/i,
    /Load failed$/i,
    /AbortError/i,
    /The user aborted a request/i,
    /^Failed to fetch data:/i,
    /^BFF_NETWORK_ERROR:/i,
    /^RelayNetwork: No data returned for operation/i,
    /^FetchError:/i,
    /^Error getting available products by site/i
];
const $79e15b4fd054124f$export$52d764e0fd2a1dc5 = {
    whitelistUrls: [
        /atl-paas.net/,
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/
    ],
    ignoreUrls: [
        /extensions\//i,
        /^chrome:\/\//i
    ],
    attachStacktrace: true
};
const $79e15b4fd054124f$export$9f448e5ee63d7699 = 'navigation';

});



parcelRegister("hhv7M", function(module, exports) {
$parcel$export(module.exports, "useBoundaryMessages", () => $916fd3f043becb1e$export$dd28f26aa5199f5);

var $euxye = parcelRequire("euxye");

var $kEJz1 = parcelRequire("kEJz1");
function $916fd3f043becb1e$export$dd28f26aa5199f5({ errorMessages: errorMessages, errorMessageValues: errorMessageValues }) {
    return (0, $euxye.useMemo)(()=>{
        return (0, $kEJz1.getMessages)({
            errorMessages: errorMessages,
            errorMessageValues: errorMessageValues
        });
    }, [
        errorMessages,
        errorMessageValues
    ]);
}

});
parcelRegister("kEJz1", function(module, exports) {
$parcel$export(module.exports, "getMessages", () => $9b74f6fcfa0dc0ea$export$8c20ab16ac9cf14f);
function $9b74f6fcfa0dc0ea$export$8c20ab16ac9cf14f({ errorMessages: errorMessages, errorMessageValues: errorMessageValues }) {
    return errorMessages ? {
        header: errorMessages.header,
        description: errorMessages.description,
        values: errorMessageValues
    } : {};
}

});


parcelRegister("1gjsF", function(module, exports) {
$parcel$export(module.exports, "useFailureFlagEmitter", () => $d937f52c7afa293e$export$bc7f29bc4d00b60a);

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");
function $d937f52c7afa293e$export$bc7f29bc4d00b60a(flags) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const pendingFlagRef = (0, $euxye.useRef)(null);
    const dismissPendingFlagRef = (0, $euxye.useRef)(null);
    const reEmitPendingFlag = (0, $euxye.useCallback)(()=>{
        const pending = pendingFlagRef.current;
        if (!flags || !pending) return;
        dismissPendingFlagRef.current?.();
        const dismiss = flags.showFailure({
            title: formatMessage(pending.header, pending.values),
            description: formatMessage(pending.description, pending.values)
        });
        dismissPendingFlagRef.current = typeof dismiss === 'function' ? dismiss : null;
    }, [
        flags,
        formatMessage
    ]);
    // Re-emit whenever `formatMessage` identity changes (i.e. the inner
    // IntlProvider has re-rendered with a new messages map after the async
    // load). No-op when the gate is OFF or no error has fired yet.
    (0, $euxye.useEffect)(()=>{
        if (pendingFlagRef.current) reEmitPendingFlag();
    }, [
        reEmitPendingFlag
    ]);
    // On unmount, dismiss any flag we own so we don't leak it into the host
    // app's FlagGroup after this boundary goes away.
    (0, $euxye.useEffect)(()=>{
        return ()=>{
            dismissPendingFlagRef.current?.();
            dismissPendingFlagRef.current = null;
            pendingFlagRef.current = null;
        };
    }, []);
    return (0, $euxye.useCallback)((pending)=>{
        // Capture the descriptor inputs so the locale-change effect can
        // re-emit a re-localised flag once messages finish loading.
        // Emit immediately (possibly in the default language) so the
        // user gets visible feedback right away.
        pendingFlagRef.current = pending;
        reEmitPendingFlag();
    }, [
        reEmitPendingFlag
    ]);
}

});

parcelRegister("5GLMc", function(module, exports) {
$parcel$export(module.exports, "useMessageFlags", () => $0a3daf73a20fb3e3$export$ad59d437e6db3634);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $6xxcW = parcelRequire("6xxcW");

var $9qT28 = parcelRequire("9qT28");
function $0a3daf73a20fb3e3$export$ad59d437e6db3634({ showFlags: showFlags = false }) {
    const { showFlag: showFlag } = (0, $6xxcW.useFlags)();
    const flags = (0, $euxye.useMemo)(()=>({
            showFailure: ({ title: title, description: description, actions: actions })=>{
                return showFlag({
                    actions: actions,
                    description: description,
                    id: $0a3daf73a20fb3e3$var$flagsIds.failure,
                    isAutoDismiss: true,
                    icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9qT28))), {
                        label: "Failure",
                        spacing: "spacious"
                    }),
                    testId: $0a3daf73a20fb3e3$var$flagsIds.failure,
                    title: title
                });
            }
        }), [
        showFlag
    ]);
    return !showFlags ? undefined : flags;
}
const $0a3daf73a20fb3e3$var$flagsIds = {
    failure: 'nav-error-boundary-failure-flag'
};

});

parcelRegister("9L6yp", function(module, exports) {
$parcel$export(module.exports, "useReportInteractionError", () => $4980380264e21157$export$2139d636391467cf);

var $euxye = parcelRequire("euxye");

var $203nR = parcelRequire("203nR");

var $aalaB = parcelRequire("aalaB");
function $4980380264e21157$export$2139d636391467cf({ interactionId: interactionId, ufoInteractionName: ufoInteractionName }) {
    const reportError = (0, $203nR.useUFOReportError)();
    const reportErrorRef = (0, $euxye.useRef)(reportError);
    reportErrorRef.current = reportError;
    return (0, $euxye.useCallback)((error)=>{
        const name = ufoInteractionName ? ufoInteractionName : interactionId ? (0, $aalaB.NavigationExperienceId)[interactionId].experienceId : undefined;
        if (!name) return;
        reportErrorRef.current({
            name: name,
            errorMessage: error.message,
            errorStack: error.stack,
            errorStatusCode: error instanceof Response ? error?.status : undefined
        });
    }, [
        interactionId,
        ufoInteractionName
    ]);
}

});
parcelRegister("aalaB", function(module, exports) {
$parcel$export(module.exports, "NavigationExperienceId", () => $18f35b1b0d271b61$export$fe188b07687f765a);

var $ipvkO = parcelRequire("ipvkO");
const $18f35b1b0d271b61$export$fe188b07687f765a = {
    goalCreate: {
        experienceId: 'uc-goal-create',
        config: {
            type: (0, $ipvkO.ExperienceTypes).Experience,
            performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    teamCreate: {
        experienceId: 'uc-team-create',
        config: {
            type: (0, $ipvkO.ExperienceTypes).Experience,
            performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    projectCreate: {
        experienceId: 'uc-project-create',
        config: {
            type: (0, $ipvkO.ExperienceTypes).Experience,
            performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    universalCreateComponentLoad: {
        experienceId: 'uc-component-load',
        config: {
            type: (0, $ipvkO.ExperienceTypes).Load,
            performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
        },
        instanceId: undefined
    },
    universalCreatePrefetch: {
        experienceId: 'uc-backend-prefetch',
        config: {
            type: (0, $ipvkO.ExperienceTypes).Operation,
            performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
        },
        instanceId: undefined
    },
    globalSideNavigationLoad: {
        experienceId: 'global-side-navigation-load',
        config: {
            type: (0, $ipvkO.ExperienceTypes).Load,
            performanceType: (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad
        },
        instanceId: undefined
    },
    customizationModalLoad: {
        experienceId: 'customization-modal-load',
        config: {
            type: (0, $ipvkO.ExperienceTypes).Load,
            performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    customizationModalUpdate: {
        experienceId: 'customization-modal-update',
        config: {
            type: (0, $ipvkO.ExperienceTypes).Experience,
            performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    globalMoreMenuLoad: {
        experienceId: 'global-more-menu-load',
        config: {
            type: (0, $ipvkO.ExperienceTypes).Load,
            performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    }
};

});


parcelRegister("bEbww", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundaryUI", () => $fc886c464aeb61c4$export$ed65a7143a39e5b6);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $hctZP = parcelRequire("hctZP");

var $9mypc = parcelRequire("9mypc");

var $kEJz1 = parcelRequire("kEJz1");
function $fc886c464aeb61c4$export$ed65a7143a39e5b6({ disableAnalytics: disableAnalytics, errorFallbackUI: errorFallbackUI, errorActionUI: errorActionUI, location: location, errorMessages: errorMessages, errorMessageValues: errorMessageValues }) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { fireEvent: fireEvent } = (0, $9mypc.useAnalyticsEvents)();
    // Message precedence: errorMessages (consumer-provided) > location-based lookup
    const { header: header, description: description, values: values } = (0, $kEJz1.getMessages)({
        errorMessages: errorMessages,
        errorMessageValues: errorMessageValues
    });
    (0, $euxye.useLayoutEffect)(()=>{
        if (!disableAnalytics) fireEvent('ui.errorBoundary.viewed.errorBoundaryUI', {
            location: location,
            isFallbackUI: !!errorFallbackUI
        });
    }, [
        disableAnalytics,
        errorFallbackUI,
        fireEvent,
        location
    ]);
    // If a custom fallback UI is provided, render it directly at risk of consumer
    if (errorFallbackUI) return errorFallbackUI({
        header: formatMessage(header, values),
        description: formatMessage(description, values)
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hctZP.NavEmptyState), {
        testId: "navigation-error-boundary-ui",
        header: formatMessage(header, values),
        description: formatMessage(description, values),
        primaryAction: errorActionUI
    });
}
$fc886c464aeb61c4$export$ed65a7143a39e5b6.displayName = "ErrorBoundaryUI";

});


parcelRegister("dWWgU", function(module, exports) {
$parcel$export(module.exports, "withSideNavigationAnalyticsContext", () => $f2450ee32eeb876b$export$6d30b5ca07993d23);
$parcel$export(module.exports, "withSideNavigationAnalyticsListener", () => $f2450ee32eeb876b$export$b46bb3dcfcaed790);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $5ySJg = parcelRequire("5ySJg");

var $f6SzU = parcelRequire("f6SzU");

var $8mxlT = parcelRequire("8mxlT");

function $f2450ee32eeb876b$export$6d30b5ca07993d23(WrappedComponent) {
    return (props)=>{
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5ySJg.NavigationAnalyticsContext), {
            data: {
                ...$f2450ee32eeb876b$var$contextData,
                attributes: {
                    screen: props.app || 'unknown'
                }
            },
            children: /*#__PURE__*/ (0, $e79Pd.jsx)(WrappedComponent, {
                ...props
            })
        });
    };
}
const $f2450ee32eeb876b$export$b46bb3dcfcaed790 = (children, cb)=>{
    const handleOnEvent = (event)=>{
        // Make sure we only listen to click events and fires our event inside the callback function
        event._isUIAnalyticsEvent && event.payload?.action === 'clicked' && cb?.();
    };
    return(// Only listen to events from the ATLASKIT_CHANNEL to narrow down the payloads we receive
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f6SzU.default), {
        channel: (0, $87603373a5753b7f$export$3b03fceec8e67395),
        onEvent: handleOnEvent,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8mxlT.ElementEventListener), {
            handler: cb,
            children: children
        })
    }));
};
const $f2450ee32eeb876b$var$packageMetadata = {
    source: 'topNav',
    componentName: (0, $87603373a5753b7f$export$fc44104665f4d1e5),
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $f2450ee32eeb876b$var$sourceMetadata = {
    navLayer: 'global',
    navContainer: 'top',
    navVersion: '4'
};
const $f2450ee32eeb876b$var$sideNavMetadata = {
    screen: 'unknown'
};
const $f2450ee32eeb876b$var$contextData = {
    ...$f2450ee32eeb876b$var$packageMetadata,
    attributes: {
        ...$f2450ee32eeb876b$var$sideNavMetadata,
        ...$f2450ee32eeb876b$var$sourceMetadata
    }
};

});
parcelRegister("8mxlT", function(module, exports) {
$parcel$export(module.exports, "ElementEventListener", () => $81211a93544668dd$export$8209b3c2d1620841);
$parcel$export(module.exports, "ElementEventListenerProvider", () => $81211a93544668dd$export$306d19af1753a03e);
$parcel$export(module.exports, "useElementEventListenerHandler", () => $81211a93544668dd$export$33f666f474b46fc2);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");
const $81211a93544668dd$export$8209b3c2d1620841 = ({ handler: handler, children: children })=>{
    const wrapperRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (!wrapperRef.current || !handler) return;
        const handleMouseDown = (e)=>{
            const isLink = e.target.closest('a');
            if (isLink && e.button !== 0) handler(true);
        };
        const unbind = (0, $glbdM.bind)(wrapperRef.current, {
            type: 'mousedown',
            listener: handleMouseDown
        });
        return unbind;
    }, [
        handler
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        ref: wrapperRef,
        children: children
    });
};
$81211a93544668dd$export$8209b3c2d1620841.displayName = "ElementEventListener";
const $81211a93544668dd$var$ElementEventListenerContext = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
function $81211a93544668dd$export$306d19af1753a03e({ children: children, handler: handler }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)($81211a93544668dd$var$ElementEventListenerContext.Provider, {
        value: handler,
        children: children
    });
}
$81211a93544668dd$export$306d19af1753a03e.displayName = "ElementEventListenerProvider";
function $81211a93544668dd$export$33f666f474b46fc2() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useContext($81211a93544668dd$var$ElementEventListenerContext);
    return context;
}

});

const $87603373a5753b7f$export$3f072f06b90c3985 = 'navigation';
const $87603373a5753b7f$export$fc44104665f4d1e5 = 'GlobalSideNavigation';
const $87603373a5753b7f$export$3b03fceec8e67395 = 'atlaskit';


parcelRegister("ixu3u", function(module, exports) {
$parcel$export(module.exports, "AsyncIntlProvider", () => $e65d0de6d3c7c9b9$export$2f688dfcc031530a);

var $hE9Uq = parcelRequire("hE9Uq");

var $fQZfS = parcelRequire("fQZfS");

var $lzTqt = parcelRequire("lzTqt");
const $e65d0de6d3c7c9b9$export$2f688dfcc031530a = (0, $hE9Uq.createAsyncIntlProvider)({
    defaultMessages: (0, $fQZfS.default),
    asyncLanguages: $lzTqt.asyncLanguages
});

});
parcelRegister("hE9Uq", function(module, exports) {
$parcel$export(module.exports, "createAsyncIntlProvider", () => $f967a515c6bf3408$export$6fa362ed4e835606);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $2UWAE = parcelRequire("2UWAE");
function $f967a515c6bf3408$export$6fa362ed4e835606({ defaultMessages: defaultMessages, asyncLanguages: asyncLanguages, onLoadError: onLoadError }) {
    const fetchMessagesForLocale = async (locale)=>{
        try {
            // Fallback to the generic locale (e.g. `de`) if the specified
            // region-qualified locale (e.g. `de-DE`) is not present in the map.
            const languageLocale = locale in asyncLanguages ? locale : locale.split(/[-_]/)[0] || '';
            const localeMessages = await asyncLanguages[languageLocale]?.();
            return localeMessages?.default ?? defaultMessages;
        } catch (e) {
            onLoadError?.(locale, e);
        }
        return defaultMessages;
    };
    return function AsyncIntlProvider({ children: children, disabled: disabled = false }) {
        if (disabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
            children: children
        });
        // `fetchMessagesForLocale` is defined once at factory-call time and
        // closed over here, so its identity is already stable across renders
        // of this returned component — no `useCallback` needed.
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2UWAE.default), {
            defaultMessages: defaultMessages,
            loaderFn: fetchMessagesForLocale,
            children: children
        });
    };
}

});

parcelRegister("lzTqt", function(module, exports) {
$parcel$export(module.exports, "asyncLanguages", () => $25d3ac658c2be59f$export$3770c7a7737d463c);
// Map of locale code -> dynamic import for that locale's i18n message bundle.
// Each entry is code-split into its own webpack chunk.
//
// AUTO-GENERATED — do not edit by hand.
// Regenerate with: yarn generate-async-languages <package-path>
// (script lives in platform/build/i18n/generate-async-languages.js)





























const $25d3ac658c2be59f$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("8gRyJ")),
    da: ()=>(parcelRequire("lx10M")),
    de: ()=>(parcelRequire("lYaL7")),
    en: ()=>Promise.resolve((parcelRequire("fQZfS"))),
    'en-GB': ()=>(parcelRequire("5bniF")),
    'en-ZZ': ()=>(parcelRequire("6pVjy")),
    es: ()=>(parcelRequire("cgFw1")),
    fi: ()=>(parcelRequire("f3c0L")),
    fr: ()=>(parcelRequire("iFepC")),
    hr: ()=>(parcelRequire("ixwDS")),
    hu: ()=>(parcelRequire("Zl34X")),
    it: ()=>(parcelRequire("diaJ1")),
    ja: ()=>(parcelRequire("iQy0o")),
    ko: ()=>(parcelRequire("kSzf0")),
    nb: ()=>(parcelRequire("4LvJ9")),
    nl: ()=>(parcelRequire("wDpqB")),
    pl: ()=>(parcelRequire("a1wAr")),
    'pt-BR': ()=>(parcelRequire("eDnQ0")),
    ru: ()=>(parcelRequire("3d27A")),
    sl: ()=>(parcelRequire("jE0AB")),
    'sr-RS': ()=>(parcelRequire("cGV44")),
    'sr-YR': ()=>(parcelRequire("f88EF")),
    sv: ()=>(parcelRequire("lI0Yp")),
    th: ()=>(parcelRequire("iDhKY")),
    tr: ()=>(parcelRequire("AVXtP")),
    uk: ()=>(parcelRequire("4P1vc")),
    vi: ()=>(parcelRequire("5xKJb")),
    zh: ()=>(parcelRequire("c9nd1")),
    'zh-TW': ()=>(parcelRequire("4arQP"))
};

});
parcelRegister("8gRyJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6hdQb").then(()=>parcelRequire('ehexJ'));

});

parcelRegister("lx10M", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d7JC3").then(()=>parcelRequire('1tzLn'));

});

parcelRegister("lYaL7", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("b0lOX").then(()=>parcelRequire('foL6c'));

});

parcelRegister("5bniF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i9E1s").then(()=>parcelRequire('kwdmb'));

});

parcelRegister("6pVjy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hbWxx").then(()=>parcelRequire('bRYSn'));

});

parcelRegister("cgFw1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fbLSi").then(()=>parcelRequire('a4bO3'));

});

parcelRegister("f3c0L", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1PiD1").then(()=>parcelRequire('27nIj'));

});

parcelRegister("iFepC", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4vvBM").then(()=>parcelRequire('2L3Yu'));

});

parcelRegister("ixwDS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hcQmA").then(()=>parcelRequire('aRCMc'));

});

parcelRegister("Zl34X", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eLRF1").then(()=>parcelRequire('54X9D'));

});

parcelRegister("diaJ1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("26SHH").then(()=>parcelRequire('e1oBY'));

});

parcelRegister("iQy0o", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("f0rUC").then(()=>parcelRequire('5ru0g'));

});

parcelRegister("kSzf0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("db1Bq").then(()=>parcelRequire('41BcH'));

});

parcelRegister("4LvJ9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5UXdC").then(()=>parcelRequire('6FuOs'));

});

parcelRegister("wDpqB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3u1b6").then(()=>parcelRequire('iAGtr'));

});

parcelRegister("a1wAr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bXd2T").then(()=>parcelRequire('jXjYW'));

});

parcelRegister("eDnQ0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("28BuT").then(()=>parcelRequire('dWewf'));

});

parcelRegister("3d27A", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gDEbn").then(()=>parcelRequire('luow1'));

});

parcelRegister("jE0AB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("id3u3").then(()=>parcelRequire('7b2f2'));

});

parcelRegister("cGV44", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("d2Qgp").then(()=>parcelRequire('4I04e'));

});

parcelRegister("f88EF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bkSxg").then(()=>parcelRequire('8GBPM'));

});

parcelRegister("lI0Yp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8Ez34").then(()=>parcelRequire('dOphr'));

});

parcelRegister("iDhKY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l2qE6").then(()=>parcelRequire('dEMq5'));

});

parcelRegister("AVXtP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("clB3Q").then(()=>parcelRequire('lyFWN'));

});

parcelRegister("4P1vc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7yCz7").then(()=>parcelRequire('4LyXu'));

});

parcelRegister("5xKJb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aAcM8").then(()=>parcelRequire('55gxD'));

});

parcelRegister("c9nd1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7zAxa").then(()=>parcelRequire('hOF5J'));

});

parcelRegister("4arQP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aWfHQ").then(()=>parcelRequire('dZTRN'));

});



parcelRegister("69tcH", function(module, exports) {
$parcel$export(module.exports, "ItemsAndShortcutsProvider", () => $640d4cdd06c8a89b$export$47df1b932a29bc63);
$parcel$export(module.exports, "useItemsAndShortcuts", () => $640d4cdd06c8a89b$export$68ff8f5dbbf3b8af);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");

var $iVtau = parcelRequire("iVtau");

var $9eAkH = parcelRequire("9eAkH");

var $lJjYk = parcelRequire("lJjYk");

var $37KTn = parcelRequire("37KTn");

var $4RLhz = parcelRequire("4RLhz");

var $kh1m3 = parcelRequire("kh1m3");

var $hwktH = parcelRequire("hwktH");

var $h0B8m = parcelRequire("h0B8m");

var $1dTX3 = parcelRequire("1dTX3");
const $640d4cdd06c8a89b$export$190be01ed07ba845 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
// Provides all items and shortcuts.
// If these items are truly static, they could be folded into `OptionsProvider` instead.
// If any items are not static, they may need their own context to avoid impacting the consumers of the other items.
const $640d4cdd06c8a89b$var$ItemsAndShortcutsProviderHydrated = (0, $iVtau.componentWithFG)('navx-4606-gas-in-gsn-agg-hydration', $640d4cdd06c8a89b$var$ItemsAndShortcutsProviderAGGHydrated, $640d4cdd06c8a89b$var$ItemsAndShortcutsProviderBFFHydrated);
const $640d4cdd06c8a89b$export$47df1b932a29bc63 = (0, $iVtau.componentWithFG)('navx-4515-jira-gsn-gas-ssr', $640d4cdd06c8a89b$var$ItemsAndShortcutsProviderSSR, $640d4cdd06c8a89b$var$ItemsAndShortcutsProviderHydrated);
function $640d4cdd06c8a89b$var$ItemsAndShortcutsProviderAGGHydrated({ children: children, forYou: forYou, growthItemShortcuts: growthItemShortcuts, items: items, rawShortcuts: rawShortcuts }) {
    const { app: app, cloudId: cloudId, isShortcutsStatic: isShortcutsStatic } = (0, $4RLhz.useOptions)();
    const { handleError: handleError } = (0, $37KTn.useNavBoundaryContext)({
        location: 'items-and-shortcuts-provider-agg-hydrated',
        // Log backend errors only to Sentry
        // see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
        sentryConfig: {
            product: app
        },
        disableAnalytics: true
    });
    const forYouNavItem = (0, $kh1m3.useForYouNavItem)(forYou);
    const forYouMenuId = forYouNavItem.length ? forYouNavItem[0][0] : '';
    const recentNavItem = (0, $h0B8m.useRecentNavItem)(forYou);
    const starredNavItem = (0, $1dTX3.useStarredNavItem)(forYou);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lJjYk.default), {
        shortcutsConfig: rawShortcuts,
        cloudId: cloudId,
        isShortcutsStatic: isShortcutsStatic,
        onError: handleError,
        product: app,
        children: (shortcuts)=>/*#__PURE__*/ (0, $e79Pd.jsx)($640d4cdd06c8a89b$var$ItemsAndShortcutsProviderInner, {
                forYouMenuId: forYouMenuId,
                forYouNavItem: forYouNavItem,
                growthItemShortcuts: growthItemShortcuts,
                items: items,
                recentNavItem: recentNavItem,
                shortcuts: shortcuts,
                starredNavItem: starredNavItem,
                children: children
            })
    });
}
$640d4cdd06c8a89b$var$ItemsAndShortcutsProviderAGGHydrated.displayName = "ItemsAndShortcutsProviderAGGHydrated";
function $640d4cdd06c8a89b$var$ItemsAndShortcutsProviderBFFHydrated({ children: children, forYou: forYou, growthItemShortcuts: growthItemShortcuts, items: items, rawShortcuts: rawShortcuts }) {
    const forYouNavItem = (0, $kh1m3.useForYouNavItem)(forYou);
    const forYouMenuId = forYouNavItem.length ? forYouNavItem[0][0] : '';
    const recentNavItem = (0, $h0B8m.useRecentNavItem)(forYou);
    const starredNavItem = (0, $1dTX3.useStarredNavItem)(forYou);
    const shortcuts = (0, $hwktH.useHydratedShortcuts)(rawShortcuts);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($640d4cdd06c8a89b$var$ItemsAndShortcutsProviderInner, {
        forYouMenuId: forYouMenuId,
        forYouNavItem: forYouNavItem,
        growthItemShortcuts: growthItemShortcuts,
        items: items,
        recentNavItem: recentNavItem,
        shortcuts: shortcuts,
        starredNavItem: starredNavItem,
        children: children
    });
}
$640d4cdd06c8a89b$var$ItemsAndShortcutsProviderBFFHydrated.displayName = "ItemsAndShortcutsProviderBFFHydrated";
function $640d4cdd06c8a89b$export$68ff8f5dbbf3b8af() {
    const itemsAndShortcuts = (0, $euxye.useContext)($640d4cdd06c8a89b$export$190be01ed07ba845);
    (0, $jiTLE.default)(itemsAndShortcuts, 'useItemsAndShortcuts must be used inside an initialized ItemsAndShortcutsProvider');
    return itemsAndShortcuts;
}
function $640d4cdd06c8a89b$var$ItemsAndShortcutsProviderSSR(props) {
    const { networkStorageParams: networkStorageParams } = (0, $4RLhz.useOptions)();
    const queryRef = networkStorageParams?.queryRef;
    if (queryRef) return /*#__PURE__*/ (0, $e79Pd.jsx)($640d4cdd06c8a89b$var$ItemsAndShortcutsProviderWithQueryRef, {
        ...props,
        queryRef: queryRef
    });
    // if no queryRef provided, fallback to the hydrated version for GAS data
    return /*#__PURE__*/ (0, $e79Pd.jsx)($640d4cdd06c8a89b$var$ItemsAndShortcutsProviderHydrated, {
        ...props
    });
}
$640d4cdd06c8a89b$var$ItemsAndShortcutsProviderSSR.displayName = "ItemsAndShortcutsProviderSSR";
function $640d4cdd06c8a89b$var$ItemsAndShortcutsProviderWithQueryRef({ children: children, forYou: forYou, growthItemShortcuts: growthItemShortcuts, items: items, rawShortcuts: rawShortcuts, queryRef: queryRef }) {
    const { app: app, cloudId: cloudId, isShortcutsStatic: isShortcutsStatic } = (0, $4RLhz.useOptions)();
    const forYouNavItem = (0, $kh1m3.useForYouNavItem)(forYou);
    const forYouMenuId = forYouNavItem.length ? forYouNavItem[0][0] : '';
    const recentNavItem = (0, $h0B8m.useRecentNavItem)(forYou);
    const starredNavItem = (0, $1dTX3.useStarredNavItem)(forYou);
    const { handleError: handleError } = (0, $37KTn.useNavBoundaryContext)({
        location: 'use-ssr-shortcuts',
        // Log backend errors only to Sentry
        // see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
        sentryConfig: {
            product: app
        },
        disableAnalytics: true
    });
    const shortcuts = (0, $9eAkH.useGlobalShortcutsDataRelay)({
        cloudId: cloudId,
        onError: handleError,
        queryRef: queryRef,
        isShortcutsStatic: isShortcutsStatic,
        shortcutsConfig: rawShortcuts
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($640d4cdd06c8a89b$var$ItemsAndShortcutsProviderInner, {
        forYouMenuId: forYouMenuId,
        forYouNavItem: forYouNavItem,
        growthItemShortcuts: growthItemShortcuts,
        items: items,
        recentNavItem: recentNavItem,
        shortcuts: shortcuts,
        starredNavItem: starredNavItem,
        children: children
    });
}
$640d4cdd06c8a89b$var$ItemsAndShortcutsProviderWithQueryRef.displayName = "ItemsAndShortcutsProviderWithQueryRef";
function $640d4cdd06c8a89b$var$ItemsAndShortcutsProviderInner({ children: children, forYouMenuId: forYouMenuId, forYouNavItem: forYouNavItem, growthItemShortcuts: growthItemShortcuts, items: items, recentNavItem: recentNavItem, shortcuts: shortcuts, starredNavItem: starredNavItem }) {
    const itemsAndShortcuts = (0, $euxye.useMemo)(()=>{
        const globalItems = new Map([
            ...forYouNavItem,
            ...recentNavItem,
            ...starredNavItem
        ]);
        const allItems = {
            ...Object.fromEntries(globalItems),
            ...items
        };
        return {
            allItems: allItems,
            forYouMenuId: forYouMenuId,
            globalItems: globalItems,
            growthItemShortcuts: growthItemShortcuts,
            items: items,
            shortcuts: shortcuts
        };
    }, [
        forYouNavItem,
        forYouMenuId,
        recentNavItem,
        starredNavItem,
        items,
        growthItemShortcuts,
        shortcuts
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($640d4cdd06c8a89b$export$190be01ed07ba845.Provider, {
        value: itemsAndShortcuts,
        children: children
    });
}
$640d4cdd06c8a89b$var$ItemsAndShortcutsProviderInner.displayName = "ItemsAndShortcutsProviderInner";

});
parcelRegister("9eAkH", function(module, exports) {
$parcel$export(module.exports, "useGlobalShortcutsDataRelay", () => $fe6c099949c2315b$export$2dc34b66082250f3);

var $cpdD3 = parcelRequire("cpdD3");

var $euxye = parcelRequire("euxye");

var $6jLTU = parcelRequire("6jLTU");

var $n67Vb = parcelRequire("n67Vb");

var $egspI = parcelRequire("egspI");

var $dpcSS = parcelRequire("dpcSS");
const $fe6c099949c2315b$export$2dc34b66082250f3 = ({ queryRef: queryRef, cloudId: cloudId, onError: onError, shortcutsConfig: shortcutsConfig, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks })=>{
    const onUpdateGetFilteredProductLinksRef = (0, $euxye.useRef)(onUpdateGetFilteredProductLinks);
    onUpdateGetFilteredProductLinksRef.current = onUpdateGetFilteredProductLinks;
    /* eslint-disable @atlassian/relay/graphql-naming */ /* eslint-disable @atlassian/relay/no-wrapping-hooks */ const fragmentData = (0, $n67Vb.useFragment)((0, $cpdD3.default), queryRef);
    /* eslint-enable @atlassian/relay/graphql-naming */ /* eslint-enable @atlassian/relay/no-wrapping-hooks */ const appSwitcherResult = fragmentData?.appSwitcher_availableProductsBySite;
    (0, $euxye.useEffect)(()=>{
        if (appSwitcherResult?.__typename === 'QueryError') onError?.(new Error(appSwitcherResult.message ?? 'appSwitcher_availableProductsBySite failed'));
    }, [
        appSwitcherResult,
        onError
    ]);
    const { productLinksByProductType: productLinksByProductType, productLinksRequestStatus: productLinksRequestStatus } = (0, $euxye.useMemo)(()=>{
        const productLinksRequestStatus = !appSwitcherResult ? (0, $dpcSS.RequestStatus).INIT : appSwitcherResult.__typename === 'QueryError' ? (0, $dpcSS.RequestStatus).ERROR : appSwitcherResult.__typename === 'AppSwitcherAvailableProductsBySite' ? (0, $dpcSS.RequestStatus).COMPLETE : (0, $dpcSS.RequestStatus).INIT;
        const productLinksByProductType = new Map();
        if (appSwitcherResult?.__typename === 'AppSwitcherAvailableProductsBySite') {
            const products = appSwitcherResult.products;
            if (products?.length) for (const product of products){
                if (product.__typename === 'AppSwitcherSingleUrlProduct') {
                    if (product.url) productLinksByProductType.set(product.productType, [
                        {
                            url: product.url
                        }
                    ]);
                } else if (product.__typename === 'AppSwitcherSiteScopedProduct') {
                    const links = (product.sites ?? []).filter((site)=>Boolean(site.url)).map((site)=>({
                            cloudId: site.siteId,
                            url: site.url
                        }));
                    if (links.length) productLinksByProductType.set(product.productType, links);
                }
            }
        }
        return {
            productLinksByProductType: productLinksByProductType,
            productLinksRequestStatus: productLinksRequestStatus
        };
    }, [
        appSwitcherResult
    ]);
    const productLinksByProductTypeRef = (0, $euxye.useRef)(productLinksByProductType);
    productLinksByProductTypeRef.current = productLinksByProductType;
    const productLinksRequestStatusRef = (0, $euxye.useRef)(productLinksRequestStatus);
    productLinksRequestStatusRef.current = productLinksRequestStatus;
    const lastCompleteProductLinksByTypeRef = (0, $euxye.useRef)(new Map());
    if (productLinksRequestStatus === (0, $dpcSS.RequestStatus).COMPLETE) lastCompleteProductLinksByTypeRef.current = new Map(productLinksByProductType);
    const getRelayProductLinksForKey = (0, $euxye.useCallback)((apsKey)=>({
            links: ((0, $egspI.fg)('navx-gas-getlink-unstable-fix') ? lastCompleteProductLinksByTypeRef.current : productLinksByProductTypeRef.current).get(apsKey) ?? [],
            status: (0, $egspI.fg)('navx-gas-getlink-unstable-fix') ? (0, $dpcSS.RequestStatus).COMPLETE : productLinksRequestStatusRef.current
        }), []);
    (0, $euxye.useEffect)(()=>{
        if (!onUpdateGetFilteredProductLinksRef.current) return;
        if (productLinksRequestStatus !== (0, $dpcSS.RequestStatus).COMPLETE && (0, $egspI.fg)('navx-gas-getlink-unstable-fix')) return;
        onUpdateGetFilteredProductLinksRef.current(getRelayProductLinksForKey);
    }, [
        getRelayProductLinksForKey,
        productLinksRequestStatus,
        productLinksByProductType
    ]);
    const productUrlMap = (0, $euxye.useMemo)(()=>{
        const urlByProductType = new Map();
        for (const [productType, links] of productLinksByProductType.entries()){
            if (!links.length) continue;
            const match = cloudId ? links.find((l)=>l.cloudId === cloudId) : undefined;
            const chosen = match ?? links[0];
            if (chosen?.url) urlByProductType.set(productType, chosen.url);
        }
        return urlByProductType;
    }, [
        productLinksByProductType,
        cloudId
    ]);
    const appShortcuts = (0, $euxye.useMemo)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(shortcutsConfig)) return shortcutsConfig;
        const config = shortcutsConfig;
        if (!productUrlMap.size) return shortcutsConfig;
        const isArray = Array.isArray(config);
        if (isArray) return config.reduce((acc, item)=>{
            if (item.type !== 'link' || !item.apsKey) {
                acc.push(item);
                return acc;
            }
            const url = productUrlMap.get(item.apsKey);
            if (url) acc.push({
                ...item,
                url: url
            });
            return acc;
        }, []);
        const entries = Object.entries(config);
        return entries.reduce((acc, [key, value])=>{
            if (value.type !== 'link' || !value.apsKey) {
                acc[key] = value;
                return acc;
            }
            const url = productUrlMap.get(value.apsKey);
            if (url) acc[key] = {
                ...value,
                url: url
            };
            return acc;
        }, {});
    }, [
        productUrlMap,
        shortcutsConfig
    ]);
    return appShortcuts;
};

});
parcelRegister("cpdD3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a74002e4301138eb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c5ca11060b3f01d0eef237e6ba896387>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a74002e4301138eb$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "productType"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "useGlobalShortcutsDataRelay",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "LinkedField",
                "name": "appSwitcher_availableProductsBySite",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "products",
                                "plural": true,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v1 /*: any*/ ,
                                            v2 /*: any*/ 
                                        ],
                                        "type": "AppSwitcherSingleUrlProduct"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "concreteType": "AppSwitcherProductSite",
                                                "kind": "LinkedField",
                                                "name": "sites",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "siteId"
                                                    },
                                                    v2 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "AppSwitcherSiteScopedProduct"
                                    }
                                ]
                            }
                        ],
                        "type": "AppSwitcherAvailableProductsBySite"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ],
                        "type": "QueryError"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$a74002e4301138eb$var$node.hash = "c8b29534eaae104f3d284f0f36fda276";
var $a74002e4301138eb$export$2e2bcd8739ae039 = $a74002e4301138eb$var$node;

});

parcelRegister("dpcSS", function(module, exports) {
$parcel$export(module.exports, "RequestStatus", () => $30be38749731151c$export$600e7c1f9e0414e1);
$parcel$export(module.exports, "Products", () => $30be38749731151c$export$92e44ea1079b9ec6);
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $30be38749731151c$export$85183a312807388d);
var $30be38749731151c$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["INIT"] = "initializing";
    RequestStatus["LOADING"] = "loading";
    RequestStatus["COMPLETE"] = "complete";
    RequestStatus["ERROR"] = "error";
    return RequestStatus;
}({});
var $30be38749731151c$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    // ATLAS_* - Need to be standalone apps to sit in this space
    Products["ATLAS_ALIGN"] = "ALIGN";
    Products["ATLAS_HOME"] = "ATLAS_HOME";
    Products["ATLAS_GOALS"] = "GOALS";
    Products["ATLAS_TEAMS"] = "TEAMS";
    Products["ATLAS_HUB"] = "ATLAS_HUB";
    Products["ANALYTICS"] = "ANALYTICS";
    Products["ASSETS"] = "ASSETS";
    Products["BITBUCKET"] = "BITBUCKET";
    Products["COMPASS"] = "COMPASS";
    Products["CUSTOMER_SERVICE_MANAGEMENT"] = "JIRA_CUSTOMER_SERVICE";
    Products["FOCUS"] = "mercury";
    Products["STUDIO"] = "STUDIO";
    Products["OPSGENIE"] = "OPSGENIE";
    Products["JIRA_SERVICE_MANAGEMENT"] = "JIRA_SERVICE_DESK";
    Products["JIRA_PRODUCT_DISCOVERY"] = "JIRA_PRODUCT_DISCOVERY";
    Products["JIRA_SOFTWARE"] = "JIRA_SOFTWARE";
    Products["CONFLUENCE"] = "CONFLUENCE";
    Products["LOOM"] = "LOOM";
    Products["PROJECTS"] = "PROJECTS";
    Products["TALENT"] = "TALENT";
    Products["TRELLO"] = "TRELLO";
    Products["FEEDBACK"] = "FEEDBACK";
    return Products;
}({});
const $30be38749731151c$export$85183a312807388d = 'navigation';

});


parcelRegister("lJjYk", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a9ed53eb4109133$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $gixhl = parcelRequire("gixhl");

var $euxye = parcelRequire("euxye");

var $6jLTU = parcelRequire("6jLTU");

var $n67Vb = parcelRequire("n67Vb");

var $egspI = parcelRequire("egspI");

var $cxpqA = parcelRequire("cxpqA");

var $9eAkH = parcelRequire("9eAkH");
const $0a9ed53eb4109133$var$HydrationSafeSuspenseContent = /*#__PURE__*/ (0, $euxye.memo)(function HydrationSafeSuspenseContent({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
        fallback: fallback,
        children: children
    });
}, (_prevProps, nextProps)=>{
    // Block prop propagation into the Suspense boundary while locked (during hydration)
    return nextProps.isLocked;
});
function $0a9ed53eb4109133$var$HydrationSafeSuspense({ fallback: fallback = null, children: children }) {
    // Always start locked (true) regardless of SSR or CSR — this covers both SSR hydration
    // AND client-side transitions (e.g. edit mode) where process.env.REACT_SSR is false
    // but React still needs the boundary to stay stable until after the first mount.
    const [isLocked, setIsLocked] = (0, $euxye.useState)(true);
    (0, $euxye.useEffect)(()=>{
        setIsLocked(false);
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($0a9ed53eb4109133$var$HydrationSafeSuspenseContent, {
        isLocked: isLocked,
        fallback: fallback,
        children: children
    });
}
$0a9ed53eb4109133$var$HydrationSafeSuspense.displayName = "HydrationSafeSuspense";
const $0a9ed53eb4109133$var$emptySubscribe = ()=>()=>{};
/**
 * Returns `false` during SSR and the client's hydrating render, then `true` once React has finished
 * hydrating this subtree
 */ function $0a9ed53eb4109133$var$useIsHydrated() {
    return (0, $euxye.useSyncExternalStore)($0a9ed53eb4109133$var$emptySubscribe, ()=>true, ()=>false);
}
function $0a9ed53eb4109133$export$2e2bcd8739ae039(props) {
    const isHydrated = $0a9ed53eb4109133$var$useIsHydrated();
    // Render Skip until after mount so the Suspense boundary only mounts post-hydration (avoids #421).
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cxpqA.RelayEnvironmentProvider), {
        children: !isHydrated && (0, $egspI.fg)('confluence_global_shortcuts_hydration') ? /*#__PURE__*/ (0, $e79Pd.jsx)($0a9ed53eb4109133$var$GlobalShortcutsRelayClientSkip, {
            ...props
        }) : /*#__PURE__*/ (0, $e79Pd.jsx)($0a9ed53eb4109133$var$HydrationSafeSuspense, {
            fallback: /*#__PURE__*/ (0, $e79Pd.jsx)($0a9ed53eb4109133$var$GlobalShortcutsRelayClientSkip, {
                ...props
            }),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)($0a9ed53eb4109133$var$GlobalShortcutsRelayClientImpl, {
                ...props
            })
        })
    });
}
$0a9ed53eb4109133$export$2e2bcd8739ae039.displayName = "GlobalShortcutsRelayClient";
function $0a9ed53eb4109133$var$GlobalShortcutsRelayClientImpl(props) {
    const shouldFetch = Boolean(props.cloudId) && !props.isShortcutsStatic && !(0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(props.shortcutsConfig);
    const [queryRef, loadQuery] = (0, $n67Vb.useQueryLoader)((0, $gixhl.default));
    (0, $euxye.useEffect)(()=>{
        if (!shouldFetch) return;
        (0, $euxye.startTransition)(()=>{
            loadQuery({
                cloudId: props.cloudId ?? ''
            });
        });
    }, [
        shouldFetch,
        props.cloudId,
        loadQuery
    ]);
    if (!shouldFetch || queryRef == null) return /*#__PURE__*/ (0, $e79Pd.jsx)($0a9ed53eb4109133$var$GlobalShortcutsRelayClientSkip, {
        ...props
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($0a9ed53eb4109133$var$GlobalShortcutsRelayClientPreloaded, {
        queryRef: queryRef,
        ...props
    });
}
$0a9ed53eb4109133$var$GlobalShortcutsRelayClientImpl.displayName = "GlobalShortcutsRelayClientImpl";
function $0a9ed53eb4109133$var$GlobalShortcutsRelayClientSkip({ children: children, shortcutsConfig: shortcutsConfig, cloudId: cloudId, onError: onError, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks }) {
    const shortcutItems = (0, $9eAkH.useGlobalShortcutsDataRelay)({
        queryRef: undefined,
        shortcutsConfig: shortcutsConfig,
        cloudId: cloudId,
        onError: onError,
        product: product,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children(shortcutItems)
    });
}
$0a9ed53eb4109133$var$GlobalShortcutsRelayClientSkip.displayName = "GlobalShortcutsRelayClientSkip";
function $0a9ed53eb4109133$var$GlobalShortcutsRelayClientPreloaded({ queryRef: queryRef, children: children, shortcutsConfig: shortcutsConfig, cloudId: cloudId, onError: onError, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks }) {
    const queryData = (0, $n67Vb.usePreloadedQuery)((0, $gixhl.default), queryRef);
    const shortcutItems = (0, $9eAkH.useGlobalShortcutsDataRelay)({
        queryRef: queryData,
        shortcutsConfig: shortcutsConfig,
        cloudId: cloudId,
        onError: onError,
        product: product,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children(shortcutItems)
    });
}
$0a9ed53eb4109133$var$GlobalShortcutsRelayClientPreloaded.displayName = "GlobalShortcutsRelayClientPreloaded";

});
parcelRegister("gixhl", function(module, exports) {
$parcel$export(module.exports, "default", () => $c765cd689f141610$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8307d24646dec2179f7b4020c61d570b>>
 * @relayHash 86994beb11f4ef7c8af21523816aa062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d25c1a9e348f5cef268af0c5a574df9a275e97bc5093fe2bce8d15900b232a1c
const $c765cd689f141610$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "productType"
    }, v3 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GlobalShortcutsRelayClientQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useGlobalShortcutsDataRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GlobalShortcutsRelayClientQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "appSwitcher_availableProductsBySite",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "products",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ],
                                            "type": "AppSwitcherSingleUrlProduct"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "AppSwitcherProductSite",
                                                    "kind": "LinkedField",
                                                    "name": "sites",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "siteId"
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "AppSwitcherSiteScopedProduct"
                                        }
                                    ]
                                }
                            ],
                            "type": "AppSwitcherAvailableProductsBySite"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d25c1a9e348f5cef268af0c5a574df9a275e97bc5093fe2bce8d15900b232a1c",
            "metadata": {},
            "name": "GlobalShortcutsRelayClientQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c765cd689f141610$var$node.hash = "293957e10078d4cb40237c0fdc35aadd";
var $c765cd689f141610$export$2e2bcd8739ae039 = $c765cd689f141610$var$node;

});


parcelRegister("4RLhz", function(module, exports) {
$parcel$export(module.exports, "OptionsProvider", () => $405bac6981af8019$export$1238f6fc6d9e005a);
$parcel$export(module.exports, "useOptions", () => $405bac6981af8019$export$b8ae39f344200a7d);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");
const $405bac6981af8019$export$b709306b005c3ef = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
function $405bac6981af8019$export$1238f6fc6d9e005a({ app: app, appLabel: appLabel, children: children, cloudId: cloudId, customizationStore: customizationStore, defaultMenuVisibility: defaultMenuVisibility, disableMenuCustomization: disableMenuCustomization, hasBottomElement: hasBottomElement = false, intlMode: intlMode = 'async', isShortcutsStatic: isShortcutsStatic, l1DragAndDropEnabled: l1DragAndDropEnabled, networkStorageParams: networkStorageParams, userId: userId }) {
    const options = (0, $euxye.useMemo)(()=>({
            app: app,
            appLabel: appLabel,
            cloudId: cloudId,
            customizationStore: customizationStore,
            defaultMenuVisibility: defaultMenuVisibility,
            disableMenuCustomization: disableMenuCustomization,
            hasBottomElement: hasBottomElement,
            intlMode: intlMode,
            isShortcutsStatic: isShortcutsStatic,
            l1DragAndDropEnabled: l1DragAndDropEnabled,
            networkStorageParams: networkStorageParams,
            userId: userId
        }), [
        app,
        appLabel,
        cloudId,
        customizationStore,
        defaultMenuVisibility,
        disableMenuCustomization,
        hasBottomElement,
        intlMode,
        isShortcutsStatic,
        l1DragAndDropEnabled,
        networkStorageParams,
        userId
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($405bac6981af8019$export$b709306b005c3ef.Provider, {
        value: options,
        children: children
    });
}
$405bac6981af8019$export$1238f6fc6d9e005a.displayName = "OptionsProvider";
const $405bac6981af8019$export$b8ae39f344200a7d = ()=>{
    const options = (0, $euxye.useContext)($405bac6981af8019$export$b709306b005c3ef);
    (0, $jiTLE.default)(options, 'useOptions must be used inside an initialized OptionsProvider');
    return options;
};

});

parcelRegister("kh1m3", function(module, exports) {
$parcel$export(module.exports, "useForYouNavItem", () => $02cad85131ae1ca5$export$a2a6512e1bd9d273);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $lxN43 = parcelRequire("lxN43");


var $kRu73 = parcelRequire("kRu73");
const $02cad85131ae1ca5$var$elemBefore = /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lxN43))), {
    label: "",
    spacing: "spacious"
});
const $02cad85131ae1ca5$var$NO_FOR_YOU_ITEM = [];
function $02cad85131ae1ca5$export$a2a6512e1bd9d273(forYou) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)(); // formatMessage() is not a stable function
    // Some type magic so we can get the dependencies right for the memo and keep TypeScript happy.
    const forYouItem = forYou?.forYouItem;
    const label = formatMessage((0, $kRu73.messages).label);
    return (0, $euxye.useMemo)(()=>{
        if (!forYouItem) return $02cad85131ae1ca5$var$NO_FOR_YOU_ITEM;
        else {
            // Business rule: The forYouItem is not reorderable or hideable.
            const common = {
                elemBefore: $02cad85131ae1ca5$var$elemBefore,
                isHideable: false,
                isReorderable: false,
                isSelected: forYouItem.isSelected,
                label: label,
                testId: (0, $416bb0f028f20bcd$export$f47cf802fb7ac2e6),
                ItemWrapper: forYouItem?.ItemWrapper
            };
            const value = forYouItem.url ? {
                type: 'link',
                href: forYouItem.url,
                onClick: forYouItem.onClick,
                ...common
            } : {
                type: 'button',
                onClick: forYouItem.onClick,
                ...common
            };
            return [
                [
                    forYouItem.menuItemId ?? 'global.sidebar.forYou',
                    value
                ]
            ];
        }
    }, [
        forYouItem,
        label
    ]);
}

});
const $416bb0f028f20bcd$export$f47cf802fb7ac2e6 = 'gsn-for-you';

parcelRegister("kRu73", function(module, exports) {
$parcel$export(module.exports, "messages", () => $53c628e9c62c1df5$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $53c628e9c62c1df5$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    label: {
        id: 'navigation.global-side-navigation.for-you.label',
        description: 'Label on For You button in the side navigation. Typically takes users to an app-specific page showing user content',
        defaultMessage: 'For you'
    }
});

});


parcelRegister("hwktH", function(module, exports) {
$parcel$export(module.exports, "useHydratedShortcuts", () => $a4ad13e53b360198$export$f6a46bddb8e1f8d0);
parcelRequire("9LEhY");
var $6iPh2 = parcelRequire("6iPh2");

var $37KTn = parcelRequire("37KTn");

var $4RLhz = parcelRequire("4RLhz");
function $a4ad13e53b360198$export$f6a46bddb8e1f8d0(rawShortcuts) {
    const { cloudId: cloudId, isShortcutsStatic: isShortcutsStatic, app: app } = (0, $4RLhz.useOptions)();
    const { handleError: handleError } = (0, $37KTn.useNavBoundaryContext)({
        location: 'use-hydrated-shortcuts',
        // Log backend errors only to Sentry
        // see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
        sentryConfig: {
            product: app
        },
        disableAnalytics: true
    });
    return (0, $6iPh2.useGlobalShortcutsDataBFF)({
        shortcutsConfig: rawShortcuts,
        cloudId: cloudId,
        isShortcutsStatic: isShortcutsStatic,
        onError: handleError,
        product: app
    });
}

});
parcelRegister("9LEhY", function(module, exports) {
$parcel$export(module.exports, "useGlobalShortcutsDataBFF", () => (parcelRequire("6iPh2")).useGlobalShortcutsDataBFF);
/* eslint-disable import/order */ 
var $6iPh2 = parcelRequire("6iPh2");

var $9eAkH = parcelRequire("9eAkH");
const $774becf99a5b8126$export$bc8645ef40313f94 = (0, $6iPh2.useGlobalShortcutsDataBFF);

});
parcelRegister("6iPh2", function(module, exports) {
$parcel$export(module.exports, "useGlobalShortcutsDataBFF", () => $c12e14309823f8c3$export$716312c3742c01a3);

var $euxye = parcelRequire("euxye");

var $6jLTU = parcelRequire("6jLTU");

var $egspI = parcelRequire("egspI");

var $69Egd = parcelRequire("69Egd");

var $dpcSS = parcelRequire("dpcSS");

var $kd9bH = parcelRequire("kd9bH");
const $c12e14309823f8c3$export$716312c3742c01a3 = ({ shortcutsConfig: shortcutsConfig, cloudId: cloudId, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, isShortcutsStatic: isShortcutsStatic, onError: onError })=>{
    const onUpdateGetFilteredProductLinksRef = (0, $euxye.useRef)(onUpdateGetFilteredProductLinks);
    onUpdateGetFilteredProductLinksRef.current = onUpdateGetFilteredProductLinks;
    const { buildURLAndFetchData: buildURLAndFetchData, status: status, productLinks: productLinks, error: error } = (0, $69Egd.useBFFDataProvider)({
        request: {},
        cloudId: cloudId,
        forceStatic: isShortcutsStatic,
        product: product
    });
    const productLinksRef = (0, $euxye.useRef)(productLinks);
    productLinksRef.current = productLinks;
    const statusRef = (0, $euxye.useRef)(status);
    statusRef.current = status;
    const lastCompleteProductLinksRef = (0, $euxye.useRef)({});
    if (status === (0, $dpcSS.RequestStatus).COMPLETE) lastCompleteProductLinksRef.current = {
        ...productLinks
    };
    const getBffProductLinksForKey = (0, $euxye.useCallback)((apsKey)=>({
            links: ((0, $egspI.fg)('navx-gas-getlink-unstable-fix') ? lastCompleteProductLinksRef.current : productLinksRef.current)[apsKey] ?? [],
            status: (0, $egspI.fg)('navx-gas-getlink-unstable-fix') ? (0, $dpcSS.RequestStatus).COMPLETE : statusRef.current
        }), []);
    (0, $euxye.useEffect)(()=>{
        if (!onUpdateGetFilteredProductLinksRef.current) return;
        if (status !== (0, $dpcSS.RequestStatus).COMPLETE && (0, $egspI.fg)('navx-gas-getlink-unstable-fix')) return;
        onUpdateGetFilteredProductLinksRef.current(getBffProductLinksForKey);
    }, [
        getBffProductLinksForKey,
        status,
        productLinks
    ]);
    // fetch the data from the bff if required
    (0, $euxye.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(shortcutsConfig) || isShortcutsStatic || !cloudId) return;
        buildURLAndFetchData();
    }, [
        buildURLAndFetchData,
        cloudId,
        shortcutsConfig,
        isShortcutsStatic
    ]);
    (0, $euxye.useEffect)(()=>{
        if (status === (0, $dpcSS.RequestStatus).ERROR && error) onError?.(error);
    }, [
        status,
        error,
        onError
    ]);
    // associate shortcuts with the returned bff data
    const hydratedAppShortcuts = (0, $euxye.useMemo)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(shortcutsConfig)) return shortcutsConfig;
        const config = shortcutsConfig;
        if (status === (0, $dpcSS.RequestStatus).COMPLETE && Object.keys(productLinks).length) {
            const isArray = Array.isArray(config);
            if (isArray) return config.reduce((acc, item)=>{
                // if config does not need a data reference, just return the value
                if (item.type !== 'link' || !item.apsKey) {
                    acc.push(item);
                    return acc;
                }
                // if config requires the bff to determine the data reference
                const productLink = productLinks[item.apsKey];
                if (productLink) {
                    const filteredProductLink = cloudId ? productLink.filter((0, $kd9bH.productLinksWorkspaceCloudIdFilter)(cloudId))[0] : productLink[0];
                    acc.push({
                        ...item,
                        url: filteredProductLink.url
                    });
                }
                return acc;
            }, []);
            const entries = Object.entries(config);
            return entries.reduce((acc, [key, value])=>{
                // if config does not need a data reference, just return the value
                if (value.type !== 'link' || !value.apsKey) {
                    acc[key] = value;
                    return acc;
                }
                // if config requires the bff to determine the data reference
                const productLink = productLinks[value.apsKey];
                if (productLink) {
                    const filteredProductLink = cloudId ? productLink.filter((0, $kd9bH.productLinksWorkspaceCloudIdFilter)(cloudId))[0] : productLink[0];
                    acc[key] = {
                        ...value,
                        url: filteredProductLink.url
                    };
                    return acc;
                }
                return acc;
            }, {});
        }
        return shortcutsConfig;
    }, [
        productLinks,
        status,
        shortcutsConfig,
        cloudId
    ]);
    return hydratedAppShortcuts;
};

});
parcelRegister("69Egd", function(module, exports) {
$parcel$export(module.exports, "useBFFDataProvider", () => $7cb0b1978b7ea0a5$export$a00b492c9c3c66db);

var $euxye = parcelRequire("euxye");

var $7NmHC = parcelRequire("7NmHC");

var $g2gcC = parcelRequire("g2gcC");

var $9J3o2 = parcelRequire("9J3o2");

var $cOYnm = parcelRequire("cOYnm");

var $duTiv = parcelRequire("duTiv");

var $ayPsT = parcelRequire("ayPsT");
async function $7cb0b1978b7ea0a5$var$wait(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $7cb0b1978b7ea0a5$export$a00b492c9c3c66db({ request: request, cloudId: cloudId, orgId: orgId, product: product, userId: userId, forceStatic: forceStatic }) {
    const { items: cachedItems, addItemsToCache: addItemsToCache, clearCache: clearCache, cacheKey: cacheKey, updateCacheKey: updateCacheKey } = (0, $9J3o2.useCache)();
    const { status: status, error: error, setStatus: setStatus } = (0, $duTiv.useStatus)();
    const { productLinks: productLinks } = (0, $cOYnm.useProductLinks)({
        cloudId: cloudId,
        orgId: orgId,
        forceStatic: forceStatic
    });
    const { buildURL: buildURL } = (0, $ayPsT.useURLBuilder)({
        cloudId: cloudId,
        userId: userId,
        product: product
    });
    const currentRequest = (0, $euxye.useRef)(null);
    const fetchData = (0, $euxye.useCallback)(async (url, data, attemptCount = 1, successCheck)=>{
        if (url === '') throw new Error('URL is empty');
        // Always clear error status at the start of a new request
        setStatus((0, $7NmHC.RequestStatus).LOADING, (0, $7NmHC.BFF_REQUEST_STATUS_KEY), undefined);
        try {
            const response = await (0, $g2gcC.fetchJSON)(url, {});
            switch(response.status){
                case (0, $7NmHC.RequestStatus).ERROR:
                    throw response.error;
                case (0, $7NmHC.RequestStatus).COMPLETE:
                    setStatus((0, $7NmHC.RequestStatus).COMPLETE, (0, $7NmHC.BFF_REQUEST_STATUS_KEY), undefined);
                    currentRequest.current = null;
                    return response.data;
            }
        } catch (error) {
            const maxAttempts = request?.maxAttempts ?? (0, $7NmHC.MAX_ATTEMPTS_NEW_DEFAULT);
            if (request?.shouldRetryOnException && attemptCount < maxAttempts) {
                const baseInterval = request?.attemptInterval ?? (0, $7NmHC.RETRY_INTERVAL_DEFAULT);
                // Exponential backoff: delay doubles with each attempt (1x, 2x, 4x)
                const delay = request?.enableExponentialDelay ? baseInterval * Math.pow(2, attemptCount - 1) : baseInterval;
                await $7cb0b1978b7ea0a5$var$wait(delay);
                return await fetchData(url, data, attemptCount + 1, successCheck);
            } else {
                currentRequest.current = null;
                setStatus((0, $7NmHC.RequestStatus).ERROR, undefined, error instanceof Error ? error : new Error(String(error)));
                throw error;
            }
        }
    }, [
        request?.attemptInterval,
        request?.maxAttempts,
        request?.shouldRetryOnException,
        request?.enableExponentialDelay,
        setStatus
    ]);
    /**
	 * Helper function to build a URL and fetch data.
	 */ const buildURLAndFetchData = (0, $euxye.useCallback)(async ()=>{
        // Wait for the current request to end before firing another
        if (currentRequest.current) return currentRequest.current;
        const builtUrl = buildURL({});
        if (builtUrl !== '') {
            currentRequest.current = fetchData(builtUrl, undefined, undefined, undefined);
            const fetchedData = await currentRequest.current;
            if (!!fetchedData?.sites?.length) addItemsToCache(fetchedData.sites);
        }
    }, [
        addItemsToCache,
        buildURL,
        fetchData
    ]);
    return {
        error: error,
        status: status,
        cachedItems: cachedItems,
        cacheKey: cacheKey,
        updateCacheKey: updateCacheKey,
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        buildURL: buildURL,
        fetchData: fetchData,
        buildURLAndFetchData: buildURLAndFetchData,
        productLinks: productLinks
    };
}

});
parcelRegister("g2gcC", function(module, exports) {
$parcel$export(module.exports, "fetchJSON", () => $547bb6f3e3416dfd$export$81bec6e38e8b706b);

var $7NmHC = parcelRequire("7NmHC");

var $ayPsT = parcelRequire("ayPsT");

var $03jhm = parcelRequire("03jhm");
function $547bb6f3e3416dfd$export$f931afb2c5ecf7c7() {
    const host = window.location.host;
    return host.includes('localhost') && host.includes(':');
}
async function $547bb6f3e3416dfd$export$81bec6e38e8b706b(url, init) {
    try {
        const response = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: {
                'Atl-BFF-Payload-Version': (0, $03jhm.default).packageVersion,
                ...init?.headers
            }
        });
        // Defensive: misbehaving SWs / fetch wrappers can violate the Promise<Response>
        // contract and resolve to undefined
        if (!response) throw new Error('Failed to fetch data: fetch() returned no response');
        // Validate response status and throw an error for non-OK responses, except for specific cases handled by feature flags.
        if (!response.ok) {
            const isAvailableProductsEndpoint = URL.parse(url)?.pathname.includes((0, $ayPsT.BFFEndpointsEnum).AVAILABLE_PRODUCTS);
            // The Available Products endpoint returns a 403 status code exclusively from blockBotsMiddleware.
            if (response.status === 403 && isAvailableProductsEndpoint) // Return an empty list of sites to prevent pollinator from treating this as a failed request.
            return {
                status: (0, $7NmHC.RequestStatus).COMPLETE,
                data: {
                    sites: []
                }
            };
            throw new Error(`Failed to fetch data: ${response.status} ${response.statusText}`);
        }
        const jsonResponse = await response.json();
        return {
            status: (0, $7NmHC.RequestStatus).COMPLETE,
            data: jsonResponse
        };
    } catch (e) {
        return {
            status: (0, $7NmHC.RequestStatus).ERROR,
            error: e,
            data: null
        };
    }
}

});
parcelRegister("ayPsT", function(module, exports) {
$parcel$export(module.exports, "BFFEndpointsEnum", () => $1581c459909981f7$export$92af951f33a9009c);
$parcel$export(module.exports, "useURLBuilder", () => $1581c459909981f7$export$3748aab334e7d372);

var $euxye = parcelRequire("euxye");

var $7NmHC = parcelRequire("7NmHC");

var $9J3o2 = parcelRequire("9J3o2");

var $5qk4U = parcelRequire("5qk4U");

var $kcWc2 = parcelRequire("kcWc2");
var $1581c459909981f7$export$92af951f33a9009c = /*#__PURE__*/ function(BFFEndpointsEnum) {
    BFFEndpointsEnum["AVAILABLE_PRODUCTS"] = "/gateway/api/app-switcher/api/available-products";
    BFFEndpointsEnum["MENU_ITEMS_V2"] = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
    return BFFEndpointsEnum;
}({});
const $1581c459909981f7$var$getOriginUrl = ({ originUrl: originUrl } = {})=>originUrl || new URL(window.location.href).origin;
function $1581c459909981f7$export$3748aab334e7d372({ cloudId: cloudId, userId: userId, product: product }) {
    const { consumer: consumer } = (0, $5qk4U.useConsumer)();
    const { items: cachedItems } = (0, $9J3o2.useCache)();
    const originUrl = (0, $kcWc2.default)();
    const buildUCMenuItemsURL = (0, $euxye.useCallback)((props)=>{
        const { product: productParam, orgId: orgId, userId: userIdParam, locale: locale, subProduct: subProduct, d: d, ro: ro, rt: rt, ap: ap } = props;
        const baseUrl = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
        let url;
        try {
            url = new URL(`${$1581c459909981f7$var$getOriginUrl({
                originUrl: originUrl
            })}${baseUrl}`);
        } catch (e) {
            return '';
        }
        const searchParams = new URLSearchParams();
        // Maintain specific order: tenantid, product, orgid, userid, source, then other params
        const queryParams = [
            [
                'tenantid',
                cloudId
            ],
            [
                'product',
                productParam || product
            ],
            [
                'orgid',
                orgId
            ],
            [
                'userid',
                userIdParam || userId
            ],
            [
                'source',
                consumer
            ],
            [
                'locale',
                locale
            ],
            [
                'subproduct',
                subProduct
            ],
            [
                'd',
                d
            ],
            [
                'ro',
                ro
            ],
            [
                'rt',
                rt
            ],
            [
                'ap',
                ap
            ]
        ];
        queryParams.forEach(([key, value])=>{
            if (value) searchParams.append(key, value);
        });
        // Append search params to URL
        url.search = searchParams.toString();
        return url.toString();
    }, [
        cloudId,
        product,
        userId,
        consumer,
        originUrl
    ]);
    const buildProductShortcutURL = (0, $euxye.useCallback)(({ baseUrl: baseUrl })=>{
        const finalBaseUrl = baseUrl ?? "/gateway/api/app-switcher/api/available-products";
        // No point in building a URL if there are no items to fetch and the cache is already populated
        if (cachedItems.length > 0) return '';
        const queryValues = '';
        return `${$1581c459909981f7$var$getOriginUrl({
            originUrl: originUrl
        })}${finalBaseUrl}?${queryValues}`;
    }, [
        cachedItems,
        originUrl
    ]);
    const buildURL = (0, $euxye.useCallback)(({ baseUrl: baseUrl })=>{
        let url = '';
        if (baseUrl) url = `${$1581c459909981f7$var$getOriginUrl({
            originUrl: originUrl
        })}${baseUrl}`;
        // Consumer specific URL building implementations happen here
        switch(consumer){
            case (0, $7NmHC.BFFConsumerEnum).GLOBAL_SHORTCUTS:
                url = buildProductShortcutURL({});
                break;
            case (0, $7NmHC.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION:
                url = buildProductShortcutURL({});
                break;
        }
        if (!url) return url;
        // Append the consumer to the URL
        let formattedUrl;
        try {
            formattedUrl = new URL(url);
        } catch (e) {
            return url;
        }
        const updatedParams = new URLSearchParams(formattedUrl.search);
        if (consumer) updatedParams.append('source', consumer);
        if (cloudId) updatedParams.append('tenantid', cloudId);
        if (userId) updatedParams.append('userid', userId);
        if (product) updatedParams.append('product', product);
        return `${formattedUrl.origin}${formattedUrl.pathname}?${updatedParams}`;
    }, [
        buildProductShortcutURL,
        consumer,
        cloudId,
        userId,
        product,
        originUrl
    ]);
    return {
        buildURL: buildURL,
        buildProductShortcutURL: buildProductShortcutURL,
        buildUCMenuItemsURL: buildUCMenuItemsURL
    };
}

});
parcelRegister("9J3o2", function(module, exports) {
$parcel$export(module.exports, "useCache", () => $044e039373ed012f$export$c6e89b6bb9436bc0);

var $euxye = parcelRequire("euxye");

var $hWvME = parcelRequire("hWvME");
function $044e039373ed012f$export$c6e89b6bb9436bc0() {
    const { value: { consumer: consumer, cache: cache, cacheKey: cacheKey }, setValue: setValue } = (0, $euxye.useContext)((0, $hWvME.BFFContext));
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    const items = (0, $euxye.useMemo)(()=>{
        return cache[cacheKey] ?? [];
    }, [
        cache,
        cacheKey
    ]);
    const updateCacheKey = (0, $euxye.useCallback)((updatedCacheKey)=>{
        setValue((prev)=>({
                ...prev,
                cacheKey: `${consumer}-${updatedCacheKey}`
            }));
    }, [
        setValue,
        consumer
    ]);
    const addItemsToCache = (0, $euxye.useCallback)((items, compareKey = 'cloudId')=>{
        setValue((prev)=>{
            const itemData = prev.cache[cacheKey] ?? [];
            // Overwrite values with matched key if a new value is present
            // This shouldn't be necessary, but it helps act as a safeguard
            // for duplication.
            for (let item of items){
                const replacedItemIndex = itemData.findIndex((i)=>i[compareKey] === item[compareKey]);
                if (replacedItemIndex !== -1) itemData[replacedItemIndex] = item;
                else itemData.push(item);
            }
            return {
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: itemData
                }
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const clearCache = (0, $euxye.useCallback)(()=>{
        setValue((prev)=>({
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: []
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    return {
        addItemsToCache: addItemsToCache,
        cacheKey: cacheKey,
        clearCache: clearCache,
        items: items,
        updateCacheKey: updateCacheKey
    };
}

});

parcelRegister("5qk4U", function(module, exports) {
$parcel$export(module.exports, "useConsumer", () => $ff793f39bcc48781$export$33062d550933de6f);

var $euxye = parcelRequire("euxye");

var $hWvME = parcelRequire("hWvME");
function $ff793f39bcc48781$export$33062d550933de6f() {
    const { value: { consumer: consumer } } = (0, $euxye.useContext)((0, $hWvME.BFFContext));
    return {
        consumer: consumer
    };
}

});

parcelRegister("kcWc2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0b3bb1653896782$export$2e2bcd8739ae039);

var $e4xdy = parcelRequire("e4xdy");
/**
 * Hook that returns the context of a forced origin url (used for supporting global shortcuts locally)
 */ const $a0b3bb1653896782$var$useOriginUrl = ()=>{
    const context = (0, $e4xdy.useBFFOriginUrlContext)();
    return context;
};
var $a0b3bb1653896782$export$2e2bcd8739ae039 = $a0b3bb1653896782$var$useOriginUrl;

});
parcelRegister("e4xdy", function(module, exports) {
$parcel$export(module.exports, "useBFFOriginUrlContext", () => $07c2a3651230dfc3$export$13a55721f6e3a9e);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $07c2a3651230dfc3$var$BFFOriginUrlContext = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
const $07c2a3651230dfc3$export$405f92d0950d3d4f = ({ children: children, url: url })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)($07c2a3651230dfc3$var$BFFOriginUrlContext.Provider, {
        value: url,
        children: children
    });
};
$07c2a3651230dfc3$export$405f92d0950d3d4f.displayName = "BFFOriginUrlProvider";
const $07c2a3651230dfc3$export$13a55721f6e3a9e = ()=>{
    return (0, $euxye.useContext)($07c2a3651230dfc3$var$BFFOriginUrlContext);
};

});



parcelRegister("03jhm", function(module, exports) {
$parcel$export(module.exports, "default", () => $847885a9eb4105dd$export$2e2bcd8739ae039);
const $847885a9eb4105dd$var$packageName = "platform-pkg";
const $847885a9eb4105dd$var$packageVersion = "0.0.0-use.local";
const $847885a9eb4105dd$var$_default_1 = {
    packageName: $847885a9eb4105dd$var$packageName,
    packageVersion: $847885a9eb4105dd$var$packageVersion
};
var $847885a9eb4105dd$export$2e2bcd8739ae039 = $847885a9eb4105dd$var$_default_1;

});


parcelRegister("cOYnm", function(module, exports) {
$parcel$export(module.exports, "useProductLinks", () => $be6a20b389faa3a9$export$79322ba781a26ce1);

var $euxye = parcelRequire("euxye");

var $2ejVE = parcelRequire("2ejVE");

var $l1vE2 = parcelRequire("l1vE2");

var $7NmHC = parcelRequire("7NmHC");

var $7DPpB = parcelRequire("7DPpB");

var $8v2an = parcelRequire("8v2an");

var $9J3o2 = parcelRequire("9J3o2");

var $duTiv = parcelRequire("duTiv");
function $be6a20b389faa3a9$var$checkShouldRemoveJWM(productType) {
    return [
        'JIRA_SOFTWARE',
        'JIRA_PRODUCT_DISCOVERY',
        'JIRA_SERVICE_DESK'
    ].includes(productType);
}
const $be6a20b389faa3a9$var$flightdeckClient = new (0, $2ejVE.default)('atlassian-navigagtion-bff-data-provider');
function $be6a20b389faa3a9$export$79322ba781a26ce1({ cloudId: cloudId, orgId: orgId, forceStatic: forceStatic }) {
    const { items: items } = (0, $9J3o2.useCache)();
    const { setStatus: setStatus } = (0, $duTiv.useStatus)();
    const [fdResponse, setFdResponse] = (0, $euxye.useState)(null);
    const [productConfig, setProductConfig] = (0, $euxye.useState)(null);
    (0, $euxye.useEffect)(()=>{
        const getFlightdeckData = async ()=>{
            try {
                setStatus((0, $7NmHC.RequestStatus).LOADING, (0, $7NmHC.FLIGHTDECK_REQUEST_STATUS_KEY));
                const fdResponse = await $be6a20b389faa3a9$var$flightdeckClient.fetchConfigFromFlightDeck({
                    // app-switcher-fe is currently the only valid name that is configured
                    // in Flightdeck
                    name: 'app-switcher-fe',
                    // This should get updated to be based on the supplied consumer
                    // name: `app-global-shortcuts-${consumer}-fe`,
                    dimensions: {
                        environmentType: 'prod',
                        perimeter: (0, $l1vE2.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
                    }
                });
                setFdResponse(fdResponse);
                setStatus((0, $7NmHC.RequestStatus).COMPLETE, (0, $7NmHC.FLIGHTDECK_REQUEST_STATUS_KEY));
            } catch  {
                setStatus((0, $7NmHC.RequestStatus).ERROR, (0, $7NmHC.FLIGHTDECK_REQUEST_STATUS_KEY));
            }
        };
        if (!fdResponse && !forceStatic) getFlightdeckData();
    }, [
        fdResponse,
        setStatus,
        forceStatic
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!fdResponse) return;
        const config = {};
        for (const product of fdResponse.products){
            const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, rebrandedDisplayName: rebrandedDisplayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey, rebrandedIconKey: rebrandedIconKey } = product;
            config[apsKey] = {
                key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
                siteUrlSuffix: siteUrlSuffix,
                ordinal: ordinal,
                label: (0, $8v2an.formatText)(displayName),
                rebrandedLabel: rebrandedDisplayName && (0, $8v2an.formatText)(rebrandedDisplayName),
                description: (0, $8v2an.formatText)(subtitle),
                iconKey: iconKey,
                rebrandedIconKey: rebrandedIconKey
            };
            // TODO: remove this once Asset app becomes standalone app
            if (apsKey === 'JIRA_SERVICE_DESK' && !config[0, $7NmHC.ASSETS_APP_KEY]) config[0, $7NmHC.ASSETS_APP_KEY] = {
                key: (0, $7NmHC.ASSETS_APP_KEY),
                siteUrlSuffix: '/jira/assets',
                ordinal: ordinal + 0.1,
                label: (0, $8v2an.formatText)('Assets'),
                iconKey: 'assets'
            };
        }
        setProductConfig(config);
    }, [
        fdResponse
    ]);
    const getProductLinkForItem = (0, $euxye.useCallback)((productType, siteUrl, productUrl)=>{
        if (productUrl) return productUrl;
        const siteSuffix = productConfig?.[productType]?.siteUrlSuffix;
        return `${siteUrl}${siteSuffix}`;
    }, [
        productConfig
    ]);
    const productLinks = (0, $euxye.useMemo)(()=>{
        const products = {};
        const shouldRemoveJWM = items.some((item)=>{
            return (item.availableProducts || []).some(({ productType: productType })=>$be6a20b389faa3a9$var$checkShouldRemoveJWM(productType));
        });
        items.forEach((item)=>{
            const { availableProducts: availableProducts = [], cloudId: cachedItemCloudId, avatar: avatar, url: siteUrl, displayName: displayName, org: org } = item;
            // only apply org level filtering if org data is available
            if (org && orgId && org.id !== orgId) return;
            availableProducts.forEach((product)=>{
                const { url: productUrl } = product;
                let { productType: productType } = product;
                const isExcludeJiraBusiness = productType === 'JIRA_BUSINESS' && !shouldRemoveJWM;
                // if a site has JWM only and no other Jiras, JWM needs to appear under "Jira"
                // to ensure that this happens, we set JSM's productType to 'JIRA_SOFTWARE'
                // this will ensure that JWM is not removed, even if another site has JSW/JPD/JSM
                if (isExcludeJiraBusiness) productType = 'JIRA_SOFTWARE';
                if (!products[productType]) products[productType] = [];
                if (!isExcludeJiraBusiness) products[productType].push({
                    isCurrentSite: Boolean(cachedItemCloudId) && cloudId?.toLowerCase() === cachedItemCloudId?.toLowerCase(),
                    displayName: displayName,
                    url: getProductLinkForItem(productType, siteUrl, productUrl),
                    avatar: avatar,
                    cloudId: cachedItemCloudId
                });
            });
        });
        return (0, $7DPpB.sortArraysInObject)(products, (a, b)=>{
            return (0, $8v2an.sortAlphabetically)('asc')(a.displayName, b.displayName);
        });
    }, [
        items,
        orgId,
        cloudId,
        getProductLinkForItem
    ]);
    return {
        productLinks: productLinks
    };
}

});
parcelRegister("7DPpB", function(module, exports) {
$parcel$export(module.exports, "sortArraysInObject", () => $4d902a3bf835c7e4$export$3e8bbf689f8e6cad);
function $4d902a3bf835c7e4$export$3e8bbf689f8e6cad(record, sortFunction) {
    for(const key in record)if (Array.isArray(record[key])) record[key].sort(sortFunction); // Sorts alphabetically or numerically by default
    return record;
}

});

parcelRegister("8v2an", function(module, exports) {
$parcel$export(module.exports, "formatText", () => $4b0d6fcefdb7b182$export$905fe28a7c283e1d);
$parcel$export(module.exports, "sortAlphabetically", () => $4b0d6fcefdb7b182$export$60f5d4abb43a14b3);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");
const $4b0d6fcefdb7b182$export$905fe28a7c283e1d = (text)=>{
    return typeof text === 'string' ? text : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
        ...text
    });
};
const $4b0d6fcefdb7b182$export$60f5d4abb43a14b3 = (direction)=>(a, b)=>{
        const aLower = a.toLowerCase();
        const bLower = b.toLowerCase();
        if (direction === 'asc') return aLower.localeCompare(bLower);
        return bLower.localeCompare(aLower);
    };
const $4b0d6fcefdb7b182$export$e57a6793604f15ac = (atiArray)=>{
    return atiArray && atiArray.length > 0 ? atiArray.join(',') : undefined;
};

});

parcelRegister("duTiv", function(module, exports) {
$parcel$export(module.exports, "useStatus", () => $bce480174d8d04f5$export$53cc6abb6942ce72);

var $euxye = parcelRequire("euxye");

var $7NmHC = parcelRequire("7NmHC");

var $hWvME = parcelRequire("hWvME");
function $bce480174d8d04f5$export$53cc6abb6942ce72() {
    const { setValue: setValue, value: { status: status, error: error }, currentLoadingRequests: currentLoadingRequests, updateCurrentLoadingRequests: updateCurrentLoadingRequests } = (0, $hWvME.useBFFContext)();
    const isInitializing = (0, $euxye.useMemo)(()=>status === (0, $7NmHC.RequestStatus).INIT, [
        status
    ]);
    const isComplete = (0, $euxye.useMemo)(()=>status === (0, $7NmHC.RequestStatus).COMPLETE, [
        status
    ]);
    const isError = (0, $euxye.useMemo)(()=>status === (0, $7NmHC.RequestStatus).ERROR, [
        status
    ]);
    const isLoading = (0, $euxye.useMemo)(()=>status === (0, $7NmHC.RequestStatus).LOADING, [
        status
    ]);
    const isLoaded = (0, $euxye.useMemo)(()=>status !== (0, $7NmHC.RequestStatus).LOADING, [
        status
    ]);
    // Globally update the status based on the request queue for the BFF
    (0, $euxye.useEffect)(()=>{
        if (!currentLoadingRequests.length && status === (0, $7NmHC.RequestStatus).LOADING) // Ensure that the error state remains if it was previously set
        setValue((prev)=>{
            if (prev.status === (0, $7NmHC.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: (0, $7NmHC.RequestStatus).COMPLETE
            };
        });
    }, [
        currentLoadingRequests,
        setValue,
        status
    ]);
    // Globally manage the request queue of any calls to the BFF
    const setStatus = (0, $euxye.useCallback)((newStatus, integratingComponent, error)=>{
        if (newStatus === (0, $7NmHC.RequestStatus).LOADING && integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $7NmHC.RequestStatus).LOADING);
        if (newStatus === (0, $7NmHC.RequestStatus).COMPLETE) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $7NmHC.RequestStatus).COMPLETE);
        }
        if (newStatus === (0, $7NmHC.RequestStatus).ERROR) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $7NmHC.RequestStatus).ERROR);
        }
        setValue((prev)=>{
            const isErrorStatus = newStatus === (0, $7NmHC.RequestStatus).ERROR;
            return {
                ...prev,
                status: isErrorStatus ? (0, $7NmHC.RequestStatus).ERROR : (0, $7NmHC.RequestStatus).LOADING,
                error: isErrorStatus ? error : undefined
            };
        });
    }, [
        updateCurrentLoadingRequests,
        setValue
    ]);
    return {
        error: error,
        isComplete: isComplete,
        isError: isError,
        isInitializing: isInitializing,
        isLoaded: isLoaded,
        isLoading: isLoading,
        setStatus: setStatus,
        status: status
    };
}

});



parcelRegister("kd9bH", function(module, exports) {
$parcel$export(module.exports, "productLinksWorkspaceCloudIdFilter", () => $3218c16dde7134f0$export$54a1da5292674ec8);
const $3218c16dde7134f0$export$54a1da5292674ec8 = (workspaceCloudId)=>(item, index, arr)=>{
        const matchedItem = arr.find((productLink)=>{
            return productLink.cloudId === workspaceCloudId;
        });
        // If an item exists in the parent array with the same cloudId,
        // we don't want to show a flyout and instead only want the list
        // of available product links to include the matching cloudId.
        if (matchedItem) return workspaceCloudId === item.cloudId;
        // If the filter gets here we want to only pass the first item
        return index === 0;
    };

});




parcelRegister("h0B8m", function(module, exports) {
$parcel$export(module.exports, "useRecentNavItem", () => $89e8bb3a0a5aeb59$export$df1ef6bc89e1ae21);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $aNG0w = parcelRequire("aNG0w");

var $3xiQi = parcelRequire("3xiQi");

var $lKiuS = parcelRequire("lKiuS");


var $jXYhs = parcelRequire("jXYhs");
const $89e8bb3a0a5aeb59$var$elemBefore = /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3xiQi))), {
    label: "",
    spacing: "spacious"
});
function $89e8bb3a0a5aeb59$export$df1ef6bc89e1ae21(forYou) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)(); // formatMessage() is not a stable function
    const recentConfig = forYou?.recent;
    const viewAllRecentItemsLabel = formatMessage((0, $jXYhs.messages).viewAllRecentItemsLabel);
    const label = formatMessage((0, $jXYhs.messages).label);
    const searchPlaceholder = formatMessage((0, $jXYhs.messages).searchPlaceholder);
    return (0, $euxye.useMemo)(()=>{
        if (!recentConfig) return [];
        else {
            // This is where we map the forYou config to the ObjectListFlyout config.
            const actions = recentConfig.viewAllUrl ? [
                {
                    elemBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))), {
                        label: ''
                    }),
                    label: viewAllRecentItemsLabel,
                    href: recentConfig.viewAllUrl,
                    onClick: recentConfig.viewAllOnClick
                }
            ] : recentConfig.viewAllOnClick && [
                {
                    elemBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))), {
                        label: ''
                    }),
                    label: viewAllRecentItemsLabel,
                    onClick: recentConfig.viewAllOnClick
                }
            ];
            // Omit the type-props from FlyoutProps that are not used by ObjectListFlyout
            const safeConfig = (0, $lKiuS.omitSafely)(recentConfig, 'menuItemId', 'viewAllOnClick', 'viewAllUrl');
            const value = {
                ...safeConfig,
                actions: actions,
                elemBefore: $89e8bb3a0a5aeb59$var$elemBefore,
                label: label,
                searchPlaceholder: searchPlaceholder,
                testId: (0, $daea22c0297d1f78$export$cfead128731b1701),
                type: 'object-list-flyout'
            };
            return [
                [
                    recentConfig.menuItemId ?? 'global.sidebar.recent',
                    value
                ]
            ];
        }
    }, [
        label,
        searchPlaceholder,
        viewAllRecentItemsLabel,
        recentConfig
    ]);
}

});
parcelRegister("lKiuS", function(module, exports) {
$parcel$export(module.exports, "omitSafely", () => $dc19ed05ec89fb8e$export$d6eadbd047ebd460);

var $l28YB = parcelRequire("l28YB");
const $dc19ed05ec89fb8e$export$d6eadbd047ebd460 = (item, ...properties)=>(0, (/*@__PURE__*/$parcel$interopDefault($l28YB)))(item, ...properties);

});

const $daea22c0297d1f78$export$cfead128731b1701 = 'gsn-recent';

parcelRegister("jXYhs", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2aae9bf584a81dbc$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $2aae9bf584a81dbc$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    label: {
        id: 'navigation.global-side-navigation.recents.label',
        description: 'Label on Recent button in the side navigation. Shows a flyout with recent items.',
        defaultMessage: 'Recent'
    },
    searchPlaceholder: {
        id: 'navigation.global-side-navigation.recentsSearchPlaceholder',
        description: 'Placeholder for the search input in the recents flyout list.',
        defaultMessage: 'Search recent items'
    },
    viewAllRecentItemsLabel: {
        id: 'navigation.global-side-navigation.recents.viewAllRecentsLabel',
        description: 'Label on View all recent items button in the recents flyout list.',
        defaultMessage: 'View all recent items'
    }
});

});


parcelRegister("1dTX3", function(module, exports) {
$parcel$export(module.exports, "useStarredNavItem", () => $82d3d92e65d510e3$export$80b87278b6bf3ebc);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $aNG0w = parcelRequire("aNG0w");

var $cXTqc = parcelRequire("cXTqc");

var $lKiuS = parcelRequire("lKiuS");


var $3H1u7 = parcelRequire("3H1u7");
const $82d3d92e65d510e3$var$elemBefore = /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cXTqc))), {
    label: "",
    spacing: "spacious"
});
function $82d3d92e65d510e3$export$80b87278b6bf3ebc(forYou) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)(); // formatMessage() is not a stable function
    const starredConfig = forYou?.starred;
    const viewAllStarredItemsLabel = formatMessage((0, $3H1u7.messages).viewAllStarredItemsLabel);
    const label = formatMessage((0, $3H1u7.messages).label);
    const searchPlaceholder = formatMessage((0, $3H1u7.messages).searchPlaceholder);
    return (0, $euxye.useMemo)(()=>{
        if (!starredConfig) return [];
        else {
            const actions = starredConfig.viewAllUrl ? [
                {
                    elemBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))), {
                        label: ''
                    }),
                    label: viewAllStarredItemsLabel,
                    href: starredConfig.viewAllUrl,
                    onClick: starredConfig.viewAllOnClick
                }
            ] : starredConfig.viewAllOnClick && [
                {
                    elemBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))), {
                        label: ''
                    }),
                    label: viewAllStarredItemsLabel,
                    onClick: starredConfig.viewAllOnClick
                }
            ];
            // Omit the type-props from FlyoutProps that are not used by ObjectListFlyout
            const safeConfig = (0, $lKiuS.omitSafely)(starredConfig, 'menuItemId', 'viewAllOnClick', 'viewAllUrl');
            const value = {
                ...safeConfig,
                actions: actions,
                elemBefore: $82d3d92e65d510e3$var$elemBefore,
                label: label,
                searchPlaceholder: searchPlaceholder,
                testId: (0, $3967ce2413480d71$export$d8547b5f8547ae9a),
                type: 'object-list-flyout'
            };
            return [
                [
                    starredConfig.menuItemId ?? 'global.sidebar.starred',
                    value
                ]
            ];
        }
    }, [
        label,
        searchPlaceholder,
        viewAllStarredItemsLabel,
        starredConfig
    ]);
}

});
const $3967ce2413480d71$export$d8547b5f8547ae9a = 'gsn-starred';

parcelRegister("3H1u7", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a4f4246a3e0001b5$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $a4f4246a3e0001b5$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    label: {
        id: 'navigation.global-side-navigation.starred.label',
        description: 'Label on Starred button in the side navigation. Shows a flyout with starred items.',
        defaultMessage: 'Starred'
    },
    searchPlaceholder: {
        id: 'navigation.global-side-navigation.starredSearchPlaceholder',
        description: 'Placeholder for the search input in the starred flyout list.',
        defaultMessage: 'Search starred items'
    },
    viewAllStarredItemsLabel: {
        id: 'navigation.global-side-navigation.starred.viewAllStarredLabel',
        description: 'Label on View all starred items button in the starred flyout list.',
        defaultMessage: 'View all starred items'
    }
});

});



parcelRegister("kBtiJ", function(module, exports) {
$parcel$export(module.exports, "usePeekMenuId", () => $139591a220e50ee5$export$5d097184c0f78e68);
$parcel$export(module.exports, "useSetPeekMenuId", () => $139591a220e50ee5$export$a90578dce3c14324);
$parcel$export(module.exports, "PeekMenuIdProviders", () => $139591a220e50ee5$export$781f6b5709acd16f);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");
const $139591a220e50ee5$export$390c771b9e3f4124 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
const $139591a220e50ee5$export$4146a0b5f40d20d7 = /*#__PURE__*/ (0, $euxye.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))));
const $139591a220e50ee5$export$5d097184c0f78e68 = ()=>(0, $euxye.useContext)($139591a220e50ee5$export$390c771b9e3f4124);
const $139591a220e50ee5$export$a90578dce3c14324 = ()=>(0, $euxye.useContext)($139591a220e50ee5$export$4146a0b5f40d20d7);
const $139591a220e50ee5$export$781f6b5709acd16f = ({ children: children, value: value })=>{
    // There are two ways for `peekMenuId` to change.
    // One is if the `peekMenuId` prop (i.e. `value`) changes, likely due to a route change.
    // The other is internally via `setPeekMenuId`, e.g. the more menu.
    // Each will override the other, the last one to change/call will be the current state.
    const [peekMenuId, setPeekMenuId] = (0, $euxye.useState)(value);
    // Once FG is cleaned up, inline this hook
    $139591a220e50ee5$var$useCustomSyncState({
        setPeekMenuId: setPeekMenuId,
        value: value
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($139591a220e50ee5$export$390c771b9e3f4124.Provider, {
        value: peekMenuId,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($139591a220e50ee5$export$4146a0b5f40d20d7.Provider, {
            value: setPeekMenuId,
            children: children
        })
    });
};
$139591a220e50ee5$export$781f6b5709acd16f.displayName = "PeekMenuIdProviders";
// Sync peekMenuId with the prop during render instead of in a layout effect.
// This avoids hydration mismatches and the useLayoutEffect SSR warning.
// See: https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
function $139591a220e50ee5$var$useCustomSyncState({ setPeekMenuId: setPeekMenuId, value: value }) {
    const prevValue = (0, $euxye.useRef)(value);
    if (value !== prevValue.current) {
        prevValue.current = value;
        (0, $euxye.startTransition)(()=>{
            setPeekMenuId(value);
        });
    }
}

});

const $e695cbb6f90a2d72$export$5678faf50a8e9276 = 'global-side-nav-test-id';
const $e695cbb6f90a2d72$export$88dd4a9e4ffa4ec2 = 'gsn-peek';
const $e695cbb6f90a2d72$export$ee2a9579670b9420 = 'gsn-global-shortcuts';
const $e695cbb6f90a2d72$export$7a48056dfdcb252d = 'globalSideNavigationLoad';
const $e695cbb6f90a2d72$export$74a97a85614272ea = 'global-side-navigation-load';

parcelRegister("B3kUb", function(module, exports) {
$parcel$export(module.exports, "SideNavigationLayout", () => $3711be67e9b2f1ce$export$610d5f09b69fac71);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $4MYRQ = parcelRequire("4MYRQ");
var $cOqoy = parcelRequire("cOqoy");
var $eal2a = parcelRequire("eal2a");
var $2ysb2 = parcelRequire("2ysb2");
var $fVNT1 = parcelRequire("fVNT1");

var $av7P9 = parcelRequire("av7P9");

var $kYJqR = parcelRequire("kYJqR");

var $egspI = parcelRequire("egspI");

var $kIomd = parcelRequire("kIomd");

var $3Z74a = parcelRequire("3Z74a");
const $3711be67e9b2f1ce$var$footerStyles = {
    hideWhenEmpty: "_196xglyw"
};
function $3711be67e9b2f1ce$export$610d5f09b69fac71({ preMainElem: preMainElem, postMainElem: postMainElem, bottomElem: bottomElem, children: children, testId: testId, onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, defaultWidth: defaultWidth, defaultCollapsed: defaultCollapsed, sideNavContentRef: sideNavContentRef }) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    // only render the top level spacer if the there is content in the children and postMainElem
    const shouldRenderTopLevelSpacer = Boolean(children && postMainElem);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $cOqoy.SideNav), {
        testId: testId,
        onExpand: onExpand,
        onCollapse: onCollapse,
        onPeekStart: onPeekStart,
        onPeekEnd: onPeekEnd,
        defaultWidth: defaultWidth,
        defaultCollapsed: defaultCollapsed,
        children: [
            preMainElem && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fVNT1.SideNavHeader), {
                children: preMainElem
            }),
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $eal2a.SideNavBody), {
                ref: sideNavContentRef,
                children: [
                    children,
                    shouldRenderTopLevelSpacer ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kIomd.TopLevelSpacer), {}) : null,
                    postMainElem
                ]
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)($3711be67e9b2f1ce$var$PanelSplitterWithFG, {
                onResizeEnd: onResizeEnd,
                onResizeStart: onResizeStart,
                label: formatMessage((0, $3Z74a.messages).panelSplitterLabel)
            }),
            bottomElem && ((0, $egspI.fg)('ui-sidenav-footer-underline-fix') ? /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    $3711be67e9b2f1ce$var$footerStyles.hideWhenEmpty
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2ysb2.SideNavFooter), {
                    children: bottomElem
                })
            }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2ysb2.SideNavFooter), {
                children: bottomElem
            }))
        ]
    });
}
$3711be67e9b2f1ce$export$610d5f09b69fac71.displayName = "SideNavigationLayout";
function $3711be67e9b2f1ce$var$PanelSplitterWithFG(props) {
    const isFhsEnabled = (0, $av7P9.useIsFhsEnabled)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    if (isFhsEnabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kYJqR.SideNavPanelSplitter), {
        ...props,
        tooltipContent: formatMessage((0, $3Z74a.messages).panelSplitterTooltipContent)
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4MYRQ.PanelSplitter), {
        ...props
    });
}
$3711be67e9b2f1ce$var$PanelSplitterWithFG.displayName = "PanelSplitterWithFG";

});
parcelRegister("kIomd", function(module, exports) {
$parcel$export(module.exports, "TopLevelSpacer", () => $bfb78122954e6a88$export$5776f68925982056);
/* top-level-spacer.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $3D7ce = parcelRequire("3D7ce");
const $bfb78122954e6a88$var$styles = {
    root: "_4t3iutpp"
};
function $bfb78122954e6a88$export$5776f68925982056() {
    const level = (0, $3D7ce.useLevel)();
    (0, $euxye.useEffect)(()=>{}, [
        level
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $bfb78122954e6a88$var$styles.root
        ])
    });
}
$bfb78122954e6a88$export$5776f68925982056.displayName = "TopLevelSpacer";

});
parcelRegister("3D7ce", function(module, exports) {
$parcel$export(module.exports, "AreAllAncestorsExpandedContext", () => $858bf95b3ba6546f$export$9c01e0e6a504d553);
$parcel$export(module.exports, "IsExpandedContext", () => $858bf95b3ba6546f$export$c856e5885cc34d81);
$parcel$export(module.exports, "SetIsExpandedContext", () => $858bf95b3ba6546f$export$48cb11cb8691f597);
$parcel$export(module.exports, "OnExpansionToggleContext", () => $858bf95b3ba6546f$export$572ce188c913ceba);
$parcel$export(module.exports, "LevelContext", () => $858bf95b3ba6546f$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "useIsExpanded", () => $858bf95b3ba6546f$export$37e565a09598825e);
$parcel$export(module.exports, "useSetIsExpanded", () => $858bf95b3ba6546f$export$c9a171ea8de5861b);
$parcel$export(module.exports, "useOnExpansionToggle", () => $858bf95b3ba6546f$export$56c8438498b72c7a);
$parcel$export(module.exports, "useLevel", () => $858bf95b3ba6546f$export$fdfe9e5e8183d4f2);
$parcel$export(module.exports, "useAreAllAncestorsExpanded", () => $858bf95b3ba6546f$export$57108b5f08ae5194);

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");

var $2Kf7z = parcelRequire("2Kf7z");
const $858bf95b3ba6546f$export$9c01e0e6a504d553 = /*#__PURE__*/ (0, $euxye.createContext)(null);
const $858bf95b3ba6546f$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $euxye.createContext)(null);
const $858bf95b3ba6546f$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $euxye.createContext)(null);
const $858bf95b3ba6546f$export$572ce188c913ceba = /*#__PURE__*/ (0, $euxye.createContext)(null);
const $858bf95b3ba6546f$export$650d12d3c2ddb8fc = (0, $2Kf7z.ExpandableMenuItemLevelContext);
const $858bf95b3ba6546f$export$37e565a09598825e = ()=>{
    const context = (0, $euxye.useContext)($858bf95b3ba6546f$export$c856e5885cc34d81);
    (0, $jiTLE.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $858bf95b3ba6546f$export$c9a171ea8de5861b = ()=>{
    const context = (0, $euxye.useContext)($858bf95b3ba6546f$export$48cb11cb8691f597);
    (0, $jiTLE.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $858bf95b3ba6546f$export$56c8438498b72c7a = ()=>(0, $euxye.useContext)($858bf95b3ba6546f$export$572ce188c913ceba);
const $858bf95b3ba6546f$export$fdfe9e5e8183d4f2 = ()=>(0, $euxye.useContext)($858bf95b3ba6546f$export$650d12d3c2ddb8fc);
const $858bf95b3ba6546f$export$57108b5f08ae5194 = ()=>(0, $euxye.useContext)($858bf95b3ba6546f$export$9c01e0e6a504d553) ?? true;

});
parcelRegister("2Kf7z", function(module, exports) {
$parcel$export(module.exports, "ExpandableMenuItemLevelContext", () => $88cabd5676aff644$export$f8d6463f9b5ca897);

var $euxye = parcelRequire("euxye");
const $88cabd5676aff644$export$f8d6463f9b5ca897 = /*#__PURE__*/ (0, $euxye.createContext)(0);

});



parcelRegister("3Z74a", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3c0509223d81d460$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $3c0509223d81d460$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    panelSplitterLabel: {
        id: 'navigation.global-side-navigation.panel-splitter.label',
        description: 'The accessible label for the panel splitter. Visually hidden but read by screen readers.',
        defaultMessage: 'Resize panel'
    },
    panelSplitterTooltipContent: {
        id: 'navigation.global-side-navigation.panel-splitter.tooltip-content',
        description: 'Text content of the tooltip that appears when hovering over the side navigation resizing element, telling users that double clicking on the element will collapse the side nav',
        defaultMessage: 'Double click to collapse'
    }
});

});


parcelRegister("cZZxG", function(module, exports) {
$parcel$export(module.exports, "messages", () => $0848cf8535af927b$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $0848cf8535af927b$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    header: {
        id: 'navigation.global-side-navigation.error.header',
        defaultMessage: "We couldn\u2019t load the sidebar",
        description: 'Header when an unknown error occurs'
    },
    description: {
        id: 'navigation.global-side-navigation.error.description',
        defaultMessage: 'Refresh the page and try again',
        description: 'Description when an unknown error occurs'
    }
});

});

parcelRegister("fs8fG", function(module, exports) {
$parcel$export(module.exports, "LocalStore", () => $301ce67242e250ea$export$9adaf932dcd02b00);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4RLhz = parcelRequire("4RLhz");

var $l7H9Y = parcelRequire("l7H9Y");

var $2R4jK = parcelRequire("2R4jK");
function $301ce67242e250ea$export$9adaf932dcd02b00({ children: children }) {
    const { app: app } = (0, $4RLhz.useOptions)();
    // This is user data for the menu and the sidebar
    const userStoreProps = (0, $l7H9Y.useLocalSideNavUserData)({
        app: app
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2R4jK.StoreProviders), {
        ...userStoreProps,
        children: children
    });
}
$301ce67242e250ea$export$9adaf932dcd02b00.displayName = "LocalStore";

});
parcelRegister("l7H9Y", function(module, exports) {
$parcel$export(module.exports, "useLocalSideNavUserData", () => $cfc37b2c77143ed9$export$4714a0d7e8941053);

var $euxye = parcelRequire("euxye");

var $aPed4 = parcelRequire("aPed4");

const $cfc37b2c77143ed9$var$nullState = {
    userSideNavData: {
        defaultWidth: undefined,
        defaultCollapsed: undefined
    },
    userMenuData: []
};
// Allow the key to be extended (by adding a prefix or suffix)
let $cfc37b2c77143ed9$var$LS_KEY = (0, $519f5e54907c79d4$export$42cf6fc952b8bebd);
function $cfc37b2c77143ed9$export$4714a0d7e8941053({ app: app }) {
    $cfc37b2c77143ed9$var$setLocalStorageKey(app);
    const { fireEvent: fireEvent } = (0, $aPed4.useAnalyticsEvents)();
    const reducer = $cfc37b2c77143ed9$var$reducerWithAnalytics(fireEvent);
    const [sideNavState, setSideNavState] = (0, $euxye.useReducer)(reducer, $cfc37b2c77143ed9$var$getInitialState());
    const setUserMenuData = (0, $euxye.useCallback)((userMenuData)=>{
        setSideNavState({
            userMenuData: userMenuData
        });
    }, []);
    const setUserSideNavData = (0, $euxye.useCallback)((userSideNavData)=>{
        setSideNavState({
            userSideNavData: {
                ...sideNavState.userSideNavData,
                ...userSideNavData
            }
        });
    }, [
        sideNavState
    ]);
    return {
        ...sideNavState,
        setUserMenuData: setUserMenuData,
        setUserSideNavData: setUserSideNavData
    };
}
function $cfc37b2c77143ed9$var$setLocalStorageKey(suffix) {
    $cfc37b2c77143ed9$var$LS_KEY = [
        (0, $519f5e54907c79d4$export$42cf6fc952b8bebd),
        suffix
    ].join('-');
}
function $cfc37b2c77143ed9$var$getInitialState() {
    // Guard against SSR — localStorage is not available on the server.
    if (typeof window === 'undefined') return $cfc37b2c77143ed9$var$nullState;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const storedState = $cfc37b2c77143ed9$var$parseLocalStorageState(localStorage.getItem($cfc37b2c77143ed9$var$LS_KEY));
    if (storedState) return storedState;
    try {
        $cfc37b2c77143ed9$var$setLocalStorageState($cfc37b2c77143ed9$var$nullState);
    } catch (error) {
        // If localStorage fails during initialization, just continue with nullState
        // eslint-disable-next-line no-console
        console.warn('Failed to initialize localStorage state:', error);
    }
    return $cfc37b2c77143ed9$var$nullState;
}
function $cfc37b2c77143ed9$var$reducerWithAnalytics(fireEvent) {
    return (state, payload)=>{
        try {
            const newState = {
                ...state,
                ...payload
            };
            // Update localStorage with the new state
            $cfc37b2c77143ed9$var$setLocalStorageState(newState);
            fireEvent('operational.executeMutation.succeeded', {
                storage: 'local'
            });
            return newState;
        } catch (error) {
            fireEvent('operational.executeMutation.failed', {
                storage: 'local',
                error: error instanceof Error ? error.message : String(error) ?? 'Unknown error'
            });
            // Return the previous state if the update failed
            return state;
        }
    };
}
function $cfc37b2c77143ed9$var$setLocalStorageState(state) {
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem($cfc37b2c77143ed9$var$LS_KEY, JSON.stringify(state));
}
function $cfc37b2c77143ed9$var$parseLocalStorageState(state) {
    if (!state) return;
    try {
        const parsedState = JSON.parse(state);
        // This check should return true for the nullState
        if (parsedState?.userSideNavData && Array.isArray(parsedState.userMenuData) && typeof parsedState.userSideNavData === 'object') return parsedState;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    // something went wrong with parsing, return undefined
    }
}

});
parcelRegister("aPed4", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $ab513bcc5734845f$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::b3c61250a84f619b4027771ee5c5ce69>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen global-side-navigation
 */ 
var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");


var $9jjqJ = parcelRequire("9jjqJ");
const $ab513bcc5734845f$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireEvent = (0, $euxye.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $9jjqJ.default)(...params));
        event.fire((0, $87603373a5753b7f$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("9jjqJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f170fb9a948a8b2e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::104fd57c141a6ef812e2ef73c24c1bba>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen global-side-navigation
 */ const $f170fb9a948a8b2e$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $f170fb9a948a8b2e$export$2e2bcd8739ae039 = $f170fb9a948a8b2e$var$createEventPayload;

});


const $519f5e54907c79d4$export$42cf6fc952b8bebd = 'nav-platform-sidebar-state';
const $519f5e54907c79d4$export$f1259eef323ff984 = 'defaultCollapsed';
const $519f5e54907c79d4$export$5ec229a880d48b06 = 'defaultWidth';
const $519f5e54907c79d4$export$5716e8bcb003888d = 100;


parcelRegister("2R4jK", function(module, exports) {
$parcel$export(module.exports, "StoreProviders", () => $22a4664971c774c6$export$54ef25ae025e12ab);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $lyg9d = parcelRequire("lyg9d");

var $bf6Uo = parcelRequire("bf6Uo");
function $22a4664971c774c6$export$54ef25ae025e12ab(props) {
    const { children: children, userMenuData: userMenuData, userSideNavData: userSideNavData, setUserMenuData: setUserMenuData, setUserSideNavData: setUserSideNavData } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lyg9d.UserMenuDataShapesProvider), {
        rawUserMenuData: userMenuData,
        setUserMenuData: setUserMenuData,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bf6Uo.UserSideNavDataStoreProvider), {
            setUserSideNavData: setUserSideNavData,
            userSideNavData: userSideNavData,
            children: children
        })
    });
}
$22a4664971c774c6$export$54ef25ae025e12ab.displayName = "StoreProviders";

});
parcelRegister("lyg9d", function(module, exports) {
$parcel$export(module.exports, "UserMenuDataShapesProvider", () => $1b5daea6aac66f85$export$5063e15f61416e3b);
$parcel$export(module.exports, "useUserMenuDataShapes", () => $1b5daea6aac66f85$export$f340ebbec0629d31);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");

var $eyfdf = parcelRequire("eyfdf");

var $69tcH = parcelRequire("69tcH");

var $4RLhz = parcelRequire("4RLhz");
const $1b5daea6aac66f85$export$91fb8643e8c59f90 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
function $1b5daea6aac66f85$export$5063e15f61416e3b({ children: children, rawUserMenuData: rawUserMenuData, setUserMenuData: setUserMenuData }) {
    const { disableMenuCustomization: disableMenuCustomization, defaultMenuVisibility: defaultMenuVisibility } = (0, $4RLhz.useOptions)();
    const { allItems: allItems, forYouMenuId: forYouMenuId, globalItems: globalItems, shortcuts: shortcuts } = (0, $69tcH.useItemsAndShortcuts)();
    const userMenuDataShapes = (0, $euxye.useMemo)(()=>(0, $eyfdf.buildUserMenuDataShapes)({
            allItemMenuIds: Object.keys(allItems),
            allShortcutMenuIds: Object.keys(shortcuts ?? {}),
            forYouMenuId: forYouMenuId,
            globalItems: globalItems,
            // All menu items are visible when there is no user menu data
            rawUserMenuData: disableMenuCustomization ? [] : rawUserMenuData,
            setUserMenuData: setUserMenuData,
            defaultMenuVisibility: defaultMenuVisibility
        }), [
        allItems,
        disableMenuCustomization,
        forYouMenuId,
        globalItems,
        rawUserMenuData,
        setUserMenuData,
        shortcuts,
        defaultMenuVisibility
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($1b5daea6aac66f85$export$91fb8643e8c59f90.Provider, {
        value: userMenuDataShapes,
        children: children
    });
}
$1b5daea6aac66f85$export$5063e15f61416e3b.displayName = "UserMenuDataShapesProvider";
function $1b5daea6aac66f85$export$f340ebbec0629d31() {
    const context = (0, $euxye.useContext)($1b5daea6aac66f85$export$91fb8643e8c59f90);
    (0, $jiTLE.default)(context, 'useUserMenuDataShapes must be used inside an initialized UserMenuDataShapesProvider');
    return context;
}

});
parcelRegister("eyfdf", function(module, exports) {
$parcel$export(module.exports, "buildUserMenuDataShapes", () => $e4cc79c59a8f32cc$export$e98db1320ac4ff55);

var $3dnik = parcelRequire("3dnik");

var $e36rA = parcelRequire("e36rA");

var $7aQ75 = parcelRequire("7aQ75");
function $e4cc79c59a8f32cc$export$e98db1320ac4ff55(params) {
    const { allItemMenuIds: allItemMenuIds, allShortcutMenuIds: allShortcutMenuIds, forYouMenuId: forYouMenuId, globalItems: globalItems, rawUserMenuData: rawUserMenuData, setUserMenuData: setUserMenuData, defaultMenuVisibility: defaultMenuVisibility } = params;
    // Check whether customisation data is empty
    const userDataIsEmpty = !$e4cc79c59a8f32cc$var$hasUserData(rawUserMenuData);
    // Remove any menu ids that overlap with shortcuts using Set for O(1) lookups
    const shortcutMenuIdsSet = new Set(allShortcutMenuIds);
    const distinctDefaultItemMenuIds = allItemMenuIds.filter((id)=>!shortcutMenuIdsSet.has(id));
    const repairedUserMenuData = (0, $e36rA.repairGlobalMenuItems)({
        forYouMenuId: forYouMenuId,
        globalItems: globalItems,
        rawUserMenuData: rawUserMenuData
    });
    // Add missing items and remove obsolete or duplicate items
    const itemUserMenuData = userDataIsEmpty ? $e4cc79c59a8f32cc$var$repairWithDefaults(rawUserMenuData, defaultMenuVisibility, distinctDefaultItemMenuIds) : $e4cc79c59a8f32cc$var$repair(repairedUserMenuData, distinctDefaultItemMenuIds);
    // Add missing shortcuts and remove obsolete or duplicate shortcuts
    const shortcutUserMenuData = userDataIsEmpty ? $e4cc79c59a8f32cc$var$repairWithDefaults(rawUserMenuData, defaultMenuVisibility, allShortcutMenuIds) : $e4cc79c59a8f32cc$var$repair(repairedUserMenuData, allShortcutMenuIds);
    // This repaired user menu data should always be used instead of the raw user menu data
    const userMenuData = itemUserMenuData.concat(shortcutUserMenuData);
    // Split the user menu data into visible and hidden menu ids, taking into account any visibility overrides from props
    const itemUserMenuDataWithMaybeDefaultsApplied = userDataIsEmpty ? $e4cc79c59a8f32cc$var$setDefaultItemVisibility(itemUserMenuData, defaultMenuVisibility) : itemUserMenuData;
    const shortcutUserMenuDataWithMaybeDefaultsApplied = userDataIsEmpty ? $e4cc79c59a8f32cc$var$setDefaultItemVisibility(shortcutUserMenuData, defaultMenuVisibility) : shortcutUserMenuData;
    const [visibleItemMenuIds, hiddenItemMenuIds] = (0, $3dnik.getMenuIdsByVisible)(itemUserMenuDataWithMaybeDefaultsApplied);
    const [visibleShortcutMenuIds, hiddenShortcutMenuIds] = (0, $3dnik.getMenuIdsByVisible)(shortcutUserMenuDataWithMaybeDefaultsApplied);
    const visibleMenuIds = visibleItemMenuIds.concat(visibleShortcutMenuIds);
    const hiddenMenuIds = hiddenItemMenuIds.concat(hiddenShortcutMenuIds);
    return {
        hiddenItemMenuIds: hiddenItemMenuIds,
        hiddenMenuIds: hiddenMenuIds,
        hiddenShortcutMenuIds: hiddenShortcutMenuIds,
        itemUserMenuData: itemUserMenuDataWithMaybeDefaultsApplied,
        shortcutUserMenuData: shortcutUserMenuDataWithMaybeDefaultsApplied,
        setUserMenuData: setUserMenuData,
        userMenuData: userMenuData,
        visibleItemMenuIds: visibleItemMenuIds,
        visibleMenuIds: visibleMenuIds,
        visibleShortcutMenuIds: visibleShortcutMenuIds
    };
}
const $e4cc79c59a8f32cc$var$repair = (rawUserMenuData, defaultMenuIds)=>(0, $7aQ75.repairItems)(rawUserMenuData ?? [], $e4cc79c59a8f32cc$var$createDefaultItems(defaultMenuIds));
const $e4cc79c59a8f32cc$var$repairWithDefaults = (rawUserMenuData, defaultVisibilityOverride, defaultMenuIds)=>$e4cc79c59a8f32cc$var$setDefaultItemVisibility($e4cc79c59a8f32cc$var$repair(rawUserMenuData, defaultMenuIds), defaultVisibilityOverride);
const $e4cc79c59a8f32cc$var$createDefaultItems = (menuIds)=>menuIds.map((menuId)=>({
            menuId: menuId,
            visible: true
        }));
const $e4cc79c59a8f32cc$var$setDefaultItemVisibility = (userMenuData, defaultMenuVisibility)=>{
    if (!defaultMenuVisibility) return userMenuData;
    const overrideMap = new Map(defaultMenuVisibility.map((item)=>[
            item.menuId,
            item.visible
        ]));
    return userMenuData.map((item)=>{
        const overrideVisible = overrideMap.get(item.menuId);
        return overrideVisible !== undefined ? {
            ...item,
            visible: overrideVisible
        } : item;
    });
};
const $e4cc79c59a8f32cc$var$hasUserData = (rawUserMenuData)=>Array.isArray(rawUserMenuData) && rawUserMenuData.length > 0;

});
parcelRegister("3dnik", function(module, exports) {
$parcel$export(module.exports, "getMenuIdsByVisible", () => $0264a9438aaa2077$export$ac81be4e21f7c439);

var $cAmGf = parcelRequire("cAmGf");

var $5WDtw = parcelRequire("5WDtw");
const $0264a9438aaa2077$export$ac81be4e21f7c439 = (items)=>(0, $5WDtw.partitionByVisible)(items).map((0, $cAmGf.getMenuIds));

});
parcelRegister("cAmGf", function(module, exports) {
$parcel$export(module.exports, "getMenuIds", () => $0493aa113596bcec$export$df4a614c56950314);
const $0493aa113596bcec$export$df4a614c56950314 = (items)=>items.map((item)=>item.menuId);

});

parcelRegister("5WDtw", function(module, exports) {
$parcel$export(module.exports, "partitionByVisible", () => $c43fb512c10aa1c9$export$98e5c4110cac6c24);

var $hTfsm = parcelRequire("hTfsm");
const $c43fb512c10aa1c9$export$98e5c4110cac6c24 = (items)=>(0, (/*@__PURE__*/$parcel$interopDefault($hTfsm)))(items, (item)=>item.visible);

});


parcelRegister("e36rA", function(module, exports) {
$parcel$export(module.exports, "repairGlobalMenuItems", () => $adf9bac87354bed8$export$a5bdc0a85c6880c5);

var $jvz1H = parcelRequire("jvz1H");
function $adf9bac87354bed8$export$a5bdc0a85c6880c5(params) {
    const { forYouMenuId: forYouMenuId, globalItems: globalItems, rawUserMenuData: rawUserMenuData } = params;
    // Sort the globalMenuIds so that the forYouItem is at the start, if it exists.
    const globalMenuIds = Array.from(globalItems.keys()).sort((a, b)=>Number(b === forYouMenuId) - Number(a === forYouMenuId));
    const rawUserMenuDataArrMaybeWithForYou = rawUserMenuData ?? [];
    // If the userdata contains the forYou item, remove it so that it can be re-added into first position.
    const rawUserMenuDataArr = forYouMenuId ? rawUserMenuDataArrMaybeWithForYou.filter((i)=>i.menuId !== forYouMenuId) : rawUserMenuDataArrMaybeWithForYou;
    // Add the globalMenuIds to the user data, if they're not already there.
    const globalItemsNotInUserData = (0, (/*@__PURE__*/$parcel$interopDefault($jvz1H)))(globalMenuIds, rawUserMenuDataArr.map((i)=>i.menuId));
    return $adf9bac87354bed8$var$createDefaultItems(globalItemsNotInUserData).concat(rawUserMenuDataArr);
}
const $adf9bac87354bed8$var$createDefaultItems = (menuIds)=>menuIds.map((menuId)=>({
            menuId: menuId,
            visible: true
        }));

});
parcelRegister("jvz1H", function(module, exports) {

var $6bRnp = parcelRequire("6bRnp");

var $bCc8n = parcelRequire("bCc8n");

var $citK5 = parcelRequire("citK5");

var $d72cD = parcelRequire("d72cD");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $e33c15125d2fb3b9$var$difference = $citK5(function(array, values) {
    return $d72cD(array) ? $6bRnp(array, $bCc8n(values, 1, $d72cD, true)) : [];
});
module.exports = $e33c15125d2fb3b9$var$difference;

});
parcelRegister("6bRnp", function(module, exports) {

var $gJl3e = parcelRequire("gJl3e");

var $bJC7w = parcelRequire("bJC7w");

var $4mRIe = parcelRequire("4mRIe");

var $bTATB = parcelRequire("bTATB");

var $8UK9T = parcelRequire("8UK9T");

var $jZNA9 = parcelRequire("jZNA9");
/** Used as the size to enable large array optimizations. */ var $481d2ca7451ba053$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $481d2ca7451ba053$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $bJC7w, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $bTATB(values, $8UK9T(iteratee));
    if (comparator) {
        includes = $4mRIe;
        isCommon = false;
    } else if (values.length >= $481d2ca7451ba053$var$LARGE_ARRAY_SIZE) {
        includes = $jZNA9;
        isCommon = false;
        values = new $gJl3e(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $481d2ca7451ba053$var$baseDifference;

});



parcelRegister("7aQ75", function(module, exports) {
$parcel$export(module.exports, "repairItems", () => $87c558fd12409281$export$ce0466efa278e488);

var $8q2YZ = parcelRequire("8q2YZ");
const $87c558fd12409281$export$ce0466efa278e488 = (items, defaultItems)=>(0, (/*@__PURE__*/$parcel$interopDefault($8q2YZ)))(items.concat(defaultItems), defaultItems, (item)=>item.menuId);

});
parcelRegister("8q2YZ", function(module, exports) {

var $bTATB = parcelRequire("bTATB");

var $lYBc2 = parcelRequire("lYBc2");

var $9JUaE = parcelRequire("9JUaE");

var $citK5 = parcelRequire("citK5");

var $doIMR = parcelRequire("doIMR");

var $hlxpN = parcelRequire("hlxpN");
/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */ var $621310c03987a47c$var$intersectionBy = $citK5(function(arrays) {
    var iteratee = $hlxpN(arrays), mapped = $bTATB(arrays, $doIMR);
    if (iteratee === $hlxpN(mapped)) iteratee = undefined;
    else mapped.pop();
    return mapped.length && mapped[0] === arrays[0] ? $lYBc2(mapped, $9JUaE(iteratee, 2)) : [];
});
module.exports = $621310c03987a47c$var$intersectionBy;

});
parcelRegister("lYBc2", function(module, exports) {

var $gJl3e = parcelRequire("gJl3e");

var $bJC7w = parcelRequire("bJC7w");

var $4mRIe = parcelRequire("4mRIe");

var $bTATB = parcelRequire("bTATB");

var $8UK9T = parcelRequire("8UK9T");

var $jZNA9 = parcelRequire("jZNA9");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $fffc0d5ce6ec6dbd$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $fffc0d5ce6ec6dbd$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $4mRIe : $bJC7w, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $bTATB(array, $8UK9T(iteratee));
        maxLength = $fffc0d5ce6ec6dbd$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $gJl3e(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $jZNA9(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $jZNA9(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $fffc0d5ce6ec6dbd$var$baseIntersection;

});

parcelRegister("doIMR", function(module, exports) {

var $d72cD = parcelRequire("d72cD");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $9c1042097f7eb6bc$var$castArrayLikeObject(value) {
    return $d72cD(value) ? value : [];
}
module.exports = $9c1042097f7eb6bc$var$castArrayLikeObject;

});





parcelRegister("bf6Uo", function(module, exports) {
$parcel$export(module.exports, "UserSideNavDataStoreProvider", () => $146066d88c775d79$export$81208cef03561ef9);
$parcel$export(module.exports, "useUserSideNavDataStore", () => $146066d88c775d79$export$af1627270f7f3b2c);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");
const $146066d88c775d79$export$b892481aefb34336 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
function $146066d88c775d79$export$81208cef03561ef9({ children: children, setUserSideNavData: setUserSideNavData, userSideNavData: userSideNavData }) {
    const userSideNavDataStore = (0, $euxye.useMemo)(()=>({
            setUserSideNavData: setUserSideNavData,
            userSideNavData: userSideNavData
        }), [
        setUserSideNavData,
        userSideNavData
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($146066d88c775d79$export$b892481aefb34336.Provider, {
        value: userSideNavDataStore,
        children: children
    });
}
$146066d88c775d79$export$81208cef03561ef9.displayName = "UserSideNavDataStoreProvider";
function $146066d88c775d79$export$af1627270f7f3b2c() {
    const context = (0, $euxye.useContext)($146066d88c775d79$export$b892481aefb34336);
    (0, $jiTLE.default)(context, 'useUserSideNavDataStore must be used inside a UserSideNavDataStoreProvider');
    return context;
}

});



parcelRegister("xBNZo", function(module, exports) {
$parcel$export(module.exports, "NetworkMigrationStore", () => $2b27c7ce074e077d$export$c723d37fdda6e941);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");

var $4RLhz = parcelRequire("4RLhz");

var $as6o9 = parcelRequire("as6o9");

var $2R4jK = parcelRequire("2R4jK");
function $2b27c7ce074e077d$export$c723d37fdda6e941({ children: children }) {
    const { networkStorageParams: networkStorageParams, app: app } = (0, $4RLhz.useOptions)();
    (0, $jiTLE.default)(networkStorageParams?.activationId && networkStorageParams?.entityAri && networkStorageParams?.siteId && networkStorageParams?.ownerAri && networkStorageParams?.queryRef, 'Please provide networkStorageParams when using customization');
    // This is user data for the menu and the sidebar
    const userStoreProps = (0, $as6o9.useNetworkMigrationSideNavUserData)({
        ...networkStorageParams,
        firstPartyApp: app
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2R4jK.StoreProviders), {
        ...userStoreProps,
        children: children
    });
}
$2b27c7ce074e077d$export$c723d37fdda6e941.displayName = "NetworkMigrationStore";

});
parcelRegister("as6o9", function(module, exports) {
$parcel$export(module.exports, "useNetworkSideNavUserData", () => $114e0f185d6b81fd$export$caed0b91aaed2955);
$parcel$export(module.exports, "useNetworkMigrationSideNavUserData", () => $114e0f185d6b81fd$export$156415ede1cb8a79);

var $goEvH = parcelRequire("goEvH");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");


var $1hxzM = parcelRequire("1hxzM");

var $57bgm = parcelRequire("57bgm");
// Pure function to handle user side nav data updates - moved outside component for stability
const $114e0f185d6b81fd$var$setUserSideNavDataFixed = (userSideNavData, currentDefaultWidth, currentDefaultCollapsed, setSideNavPropertiesCallback, setSidebarNavDataCallback)=>{
    const newState = {
        defaultWidth: String(userSideNavData.defaultWidth ?? currentDefaultWidth) || '',
        defaultCollapsed: String(userSideNavData.defaultCollapsed ?? currentDefaultCollapsed) || 'false'
    };
    setSideNavPropertiesCallback(newState);
    const properties = [
        {
            key: (0, $519f5e54907c79d4$export$5ec229a880d48b06),
            value: newState.defaultWidth
        },
        {
            key: (0, $519f5e54907c79d4$export$f1259eef323ff984),
            value: newState.defaultCollapsed
        }
    ];
    setSidebarNavDataCallback({
        properties: properties
    });
};
function $114e0f185d6b81fd$export$caed0b91aaed2955(params) {
    const { firstPartyApp: firstPartyApp, activationId: activationId = '', ownerAri: ownerAri, queryRef: queryRef, siteId: siteId = '' } = params;
    const { queryData: menuQueryData, setNavData: setMenuNavData } = (0, $57bgm.useNavSettingsService)({
        mutationEntityAri: (0, $1hxzM.buildNavigationAriForMenuData)({
            activationId: activationId,
            firstPartyApp: firstPartyApp,
            siteId: siteId
        }),
        ownerAri: ownerAri,
        queryRef: queryRef.navPlatL1MenuData
    });
    const { queryData: sidebarQueryData, setNavData: setSidebarNavData } = (0, $57bgm.useNavSettingsService)({
        mutationEntityAri: (0, $1hxzM.buildNavigationAriForSidebarData)({
            activationId: activationId,
            firstPartyApp: firstPartyApp,
            siteId: siteId
        }),
        ownerAri: ownerAri,
        queryRef: queryRef.navPlatSidebarData
    });
    // We store the state of the properties & customizationItems, as the sidebar state can change without any
    // new calls to the local queryRef (to read the value back). So we persist it in this component.
    const [sideNavProperties, setSideNavProperties] = (0, $euxye.useState)({
        defaultWidth: (sidebarQueryData?.properties?.nodes ?? [
            {
                key: (0, $519f5e54907c79d4$export$5ec229a880d48b06),
                value: undefined
            }
        ]).find((item)=>item?.key === (0, $519f5e54907c79d4$export$5ec229a880d48b06))?.value ?? '',
        defaultCollapsed: (sidebarQueryData?.properties?.nodes ?? [
            {
                key: (0, $519f5e54907c79d4$export$f1259eef323ff984),
                value: undefined
            }
        ]).find((item)=>item?.key === (0, $519f5e54907c79d4$export$f1259eef323ff984))?.value ?? ''
    });
    const [customizationItems, setCustomizationItems] = (0, $euxye.useState)(// Business rule:  The user-customization-data (menu data):
    // 	- uses the new-record nodes (if they exist), or...
    //  - is an empty array (no user customization).
    // This means that if the settings service fails, we return empty user-customization data,
    // which causes GSN to render everything the *app* wants in the app-default order.
    $114e0f185d6b81fd$var$repairCustomizationItems(menuQueryData?.sidebar?.nodes || []));
    // Create two callback functions - one for each user data-prop.
    // Not sure how performant this is, but it simplifies updates (because the caller doesn't need to know about the other half of the data)
    const setUserMenuData = (0, $euxye.useCallback)((rawSidebarData)=>{
        setCustomizationItems(rawSidebarData);
        setMenuNavData({
            sidebar: $114e0f185d6b81fd$var$sanitizeUserMenuData(rawSidebarData)
        });
    }, [
        setMenuNavData
    ]);
    // A non-memoized version was created as part of https://hello.jira.atlassian.cloud/browse/NAVX-2972
    // Memoize to keep a stable setter reference when state is unchanged.
    const setUserSideNavData = (0, $euxye.useCallback)((userSideNavData)=>$114e0f185d6b81fd$var$setUserSideNavDataFixed(userSideNavData, sideNavProperties.defaultWidth, sideNavProperties.defaultCollapsed, setSideNavProperties, setSidebarNavData), [
        sideNavProperties.defaultWidth,
        sideNavProperties.defaultCollapsed,
        setSideNavProperties,
        setSidebarNavData
    ]);
    // Create a nicer shape for the data.
    // For the userSideNavData, it is ok for the values to be undefined,
    // as the ADS component will know what to do.
    const stableUserData = (0, $euxye.useMemo)(()=>({
            userMenuData: customizationItems,
            userSideNavData: $114e0f185d6b81fd$var$toUserSideNavData(sideNavProperties),
            setUserMenuData: setUserMenuData,
            setUserSideNavData: setUserSideNavData
        }), [
        customizationItems,
        sideNavProperties,
        setUserMenuData,
        setUserSideNavData
    ]);
    return stableUserData;
}
function $114e0f185d6b81fd$export$156415ede1cb8a79(params) {
    const { firstPartyApp: firstPartyApp, activationId: activationId = '', ownerAri: ownerAri, queryRef: queryRef, siteId: siteId = '' } = params;
    const queryDataOLD = $114e0f185d6b81fd$var$useLocalFragmentToGetOldEntityAri(queryRef); // Read from the existing entityAri record
    const { queryData: l1menuQueryData, setNavData: setL1MenuData } = (0, $57bgm.useNavSettingsService)({
        mutationEntityAri: (0, $1hxzM.buildNavigationAriForMenuData)({
            activationId: activationId,
            firstPartyApp: firstPartyApp,
            siteId: siteId
        }),
        ownerAri: ownerAri,
        queryRef: queryRef.navPlatL1MenuData
    });
    const { queryData: sidebarSizeQueryData, setNavData: setSidebarSizeData } = (0, $57bgm.useNavSettingsService)({
        mutationEntityAri: (0, $1hxzM.buildNavigationAriForSidebarData)({
            activationId: activationId,
            firstPartyApp: firstPartyApp,
            siteId: siteId
        }),
        ownerAri: ownerAri,
        queryRef: queryRef.navPlatSidebarData
    });
    // We store the state of the properties & customizationItems, as the sidebar state can change without any
    // new calls to the local queryRef (to read the value back). So we persist it in this component.
    const [sideNavProperties, setSideNavProperties] = (0, $euxye.useState)({
        defaultWidth: ((sidebarSizeQueryData?.properties?.nodes || queryDataOLD?.userSideNavSettings?.properties?.nodes) ?? [
            {
                key: (0, $519f5e54907c79d4$export$5ec229a880d48b06),
                value: undefined
            }
        ]).find((item)=>item?.key === (0, $519f5e54907c79d4$export$5ec229a880d48b06))?.value ?? '',
        defaultCollapsed: ((sidebarSizeQueryData?.properties?.nodes || queryDataOLD?.userSideNavSettings?.properties?.nodes) ?? [
            {
                key: (0, $519f5e54907c79d4$export$f1259eef323ff984),
                value: undefined
            }
        ]).find((item)=>item?.key === (0, $519f5e54907c79d4$export$f1259eef323ff984))?.value ?? ''
    });
    const [sideNavMenuData, setSideNavMenuData] = (0, $euxye.useState)($114e0f185d6b81fd$var$repairCustomizationItems(// Business rule:  The user-customization-data (menu data):
    // 	- uses the new-record nodes (if they exist), or...
    //	- uses the old-record nodes (if they exist), or...
    //  - is an empty array (no user customization).
    // This means that if the settings service fails, we return empty user-customization data,
    // which causes GSN to render everything the *app* wants in the app-default order.
    l1menuQueryData?.sidebar?.nodes || queryDataOLD?.userSideNavSettings?.sidebar?.nodes || []));
    // Create two callback functions - one for each user data-prop.
    const setUserMenuData = (0, $euxye.useCallback)((rawSidebarData)=>{
        setSideNavMenuData(rawSidebarData);
        setL1MenuData({
            properties: [],
            sidebar: $114e0f185d6b81fd$var$sanitizeUserMenuData(rawSidebarData)
        });
    }, [
        setL1MenuData
    ]);
    // A non-memoized version was created as part of https://hello.jira.atlassian.cloud/browse/NAVX-2972
    // Memoize to keep a stable setter reference when state is unchanged.
    const setUserSideNavData = (0, $euxye.useCallback)((userSideNavData)=>{
        const newState = {
            defaultWidth: String(userSideNavData.defaultWidth ?? sideNavProperties.defaultWidth) || '',
            defaultCollapsed: String(userSideNavData.defaultCollapsed ?? sideNavProperties.defaultCollapsed) || 'false'
        };
        setSideNavProperties(newState);
        const properties = [
            {
                key: (0, $519f5e54907c79d4$export$5ec229a880d48b06),
                value: newState.defaultWidth
            },
            {
                key: (0, $519f5e54907c79d4$export$f1259eef323ff984),
                value: newState.defaultCollapsed
            }
        ];
        setSidebarSizeData({
            properties: properties,
            sidebar: []
        });
    }, [
        sideNavProperties.defaultWidth,
        sideNavProperties.defaultCollapsed,
        setSideNavProperties,
        setSidebarSizeData
    ]);
    // Migration behaviour runs ONCE after the browser (we don't want to do this on the server) becomes idle for 2 seconds.
    // If there is data in the old record but no data in the new record, fix this up after idle
    (0, $euxye.useEffect)(()=>{
        const handleMigration = ()=>{
            // MENU data migration
            const oldMenuData = sideNavMenuData;
            const newMenuData = l1menuQueryData?.sidebar?.nodes || [];
            if (oldMenuData.length > 0 && newMenuData.length === 0) setUserMenuData(oldMenuData);
            // SIDEBAR data migration
            const oldSidebarData = queryDataOLD?.userSideNavSettings?.properties?.nodes || [];
            const newSidebarData = sidebarSizeQueryData?.properties?.nodes || [];
            if (oldSidebarData.length > 0 && newSidebarData.length === 0) setUserSideNavData($114e0f185d6b81fd$var$toUserSideNavData(sideNavProperties));
        };
        const searchParams = new URLSearchParams(location.search);
        // Add a way to reset the data in the NEW records, to allow us to re-test the migration process on an ad-hoc basis
        if (searchParams.has('reset-migration')) // Bypass the data formatters and reset the data. These values will be treated as 'empty' by the code.
        return $114e0f185d6b81fd$var$callWhenIdle(()=>{
            setL1MenuData({
                properties: [],
                sidebar: []
            });
            setSidebarSizeData({
                properties: [],
                sidebar: []
            });
        });
        else return $114e0f185d6b81fd$var$callWhenIdle(handleMigration);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Create a nicer shape for the data.
    // For the userSideNavData, it is ok for the values to be undefined,
    // as the ADS component will know what to do.
    const stableUserData = (0, $euxye.useMemo)(()=>({
            userMenuData: sideNavMenuData,
            userSideNavData: $114e0f185d6b81fd$var$toUserSideNavData(sideNavProperties),
            setUserMenuData: setUserMenuData,
            setUserSideNavData: setUserSideNavData
        }), [
        sideNavMenuData,
        sideNavProperties,
        setUserMenuData,
        setUserSideNavData
    ]);
    return stableUserData;
}
/**
 * Make the Relay data look "normal" to the outside world.
 */ function $114e0f185d6b81fd$var$repairCustomizationItems(value) {
    return value;
}
function $114e0f185d6b81fd$var$toUserSideNavData(sideNavProperties) {
    return {
        defaultWidth: sideNavProperties.defaultWidth === '' ? undefined : Number(sideNavProperties.defaultWidth),
        defaultCollapsed: sideNavProperties.defaultCollapsed === '' ? undefined : sideNavProperties.defaultCollapsed === 'true'
    };
}
function $114e0f185d6b81fd$var$useLocalFragmentToGetOldEntityAri(queryRef) {
    /* eslint-disable @atlassian/relay/no-wrapping-hooks */ /* eslint-disable @atlassian/relay/unused-fields */ /* eslint-disable @atlassian/relay/graphql-naming */ return (0, $n67Vb.useFragment)((0, $goEvH.default), queryRef);
/* eslint-enable @atlassian/relay/unused-fields */ }
/**
 * Creates a new UserMenuData (array) that is supported by the Settings Service.
 */ function $114e0f185d6b81fd$var$sanitizeUserMenuData(data) {
    return data.map((item)=>({
            menuId: item.menuId,
            visible: item.visible
        }));
}
function $114e0f185d6b81fd$var$callWhenIdle(callback) {
    if (typeof requestIdleCallback !== 'undefined') {
        const id = requestIdleCallback(callback);
        return ()=>cancelIdleCallback(id);
    }
    const id = requestAnimationFrame(callback);
    return ()=>cancelAnimationFrame(id);
}

});
parcelRegister("goEvH", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd15e6680337906c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0ffa5c8a5f68bc4537f010427d5ce4ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bd15e6680337906c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "entityAriUserSideNavSettings"
        },
        {
            "kind": "RootArgument",
            "name": "ownerAri"
        }
    ],
    "kind": "Fragment",
    "name": "useNetworkSideNavUserData",
    "selections": [
        {
            "alias": "userSideNavSettings",
            "args": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriUserSideNavSettings"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                }
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsMenuItemConnection",
                    "kind": "LinkedField",
                    "name": "sidebar",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsMenuItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "menuId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "visible"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "SettingsDisplayPropertyConnection",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsDisplayProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$bd15e6680337906c$var$node.hash = "48a417a1d2876624970df89dfa84bb10";
var $bd15e6680337906c$export$2e2bcd8739ae039 = $bd15e6680337906c$var$node;

});

parcelRegister("57bgm", function(module, exports) {
$parcel$export(module.exports, "useNavSettingsService", () => $6787d6a59bf716e8$export$29d13058c876d5c5);

var $bTVyz = parcelRequire("bTVyz");

var $fVtTa = parcelRequire("fVtTa");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $aPed4 = parcelRequire("aPed4");


var $4RLhz = parcelRequire("4RLhz");
function $6787d6a59bf716e8$export$29d13058c876d5c5(params) {
    const { mutationEntityAri: entityAri, ownerAri: ownerAri, queryRef: queryRef } = params;
    const queryData = $6787d6a59bf716e8$var$useLocalFragment(queryRef);
    const mutation = $6787d6a59bf716e8$var$useLocalMutation();
    const { fireEvent: fireEvent } = (0, $aPed4.useAnalyticsEvents)();
    const { customizationStore: customizationStore } = (0, $4RLhz.useOptions)();
    const fireMutationEvent = (0, $euxye.useCallback)((success, error)=>{
        switch(success){
            case true:
                fireEvent('operational.executeMutation.succeeded', {
                    storage: customizationStore ?? 'network'
                });
                break;
            case false:
                fireEvent('operational.executeMutation.failed', {
                    storage: customizationStore ?? 'network',
                    error: error ?? 'Unknown error'
                });
                break;
        }
    }, [
        customizationStore,
        fireEvent
    ]);
    const setNavData = (0, $euxye.useCallback)(({ sidebar: sidebar, properties: properties })=>{
        $6787d6a59bf716e8$var$executeMutation({
            mutation: mutation,
            variables: {
                entityAri: entityAri,
                ownerAri: ownerAri,
                properties: properties,
                sidebar: sidebar,
                pageSizeValue: (0, $519f5e54907c79d4$export$5716e8bcb003888d)
            },
            fireEvent: fireMutationEvent
        });
    }, [
        entityAri,
        fireMutationEvent,
        mutation,
        ownerAri
    ]);
    return {
        queryData: queryData,
        setNavData: setNavData
    };
}
function $6787d6a59bf716e8$var$useLocalFragment(queryRef) {
    /* eslint-disable @atlassian/relay/no-wrapping-hooks */ /* eslint-disable @atlassian/relay/unused-fields */ /* eslint-disable @atlassian/relay/graphql-naming */ return (0, $n67Vb.useFragment)((0, $fVtTa.default), queryRef);
/* eslint-enable @atlassian/relay/unused-fields */ }
function $6787d6a59bf716e8$var$useLocalMutation() {
    return (0, $n67Vb.useMutation)((0, $bTVyz.default))[0];
}
function $6787d6a59bf716e8$var$executeMutation({ mutation: mutation, variables: variables, fireEvent: fireEvent }) {
    try {
        return mutation({
            variables: variables,
            onCompleted: ()=>{
                fireEvent(true);
            },
            onError: (error)=>{
                fireEvent(false, error.message || 'Unknown error');
            }
        });
    } catch (error) {
        fireEvent(false, `Unhandled error: ${error.message || 'Unknown error'}`);
    }
}

});
parcelRegister("bTVyz", function(module, exports) {
$parcel$export(module.exports, "default", () => $c20b91a79b720ad9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<562465ef8265d5d23e2424c599193d33>>
 * @relayHash b2d7e70e45866cb05b2662c2d7cfed78
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 22faaff69843483ef60d4de279304a4f15d34d081305f2df728cf86333831fa7
const $c20b91a79b720ad9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageSizeValue"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "properties"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sidebar"
    }, v5 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAri"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                },
                {
                    "kind": "Variable",
                    "name": "properties",
                    "variableName": "properties"
                },
                {
                    "kind": "Variable",
                    "name": "sidebar",
                    "variableName": "sidebar"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v6 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "pageSizeValue"
        }
    ], v7 = {
        "args": v6 /*: any*/ ,
        "concreteType": "SettingsMenuItemConnection",
        "kind": "LinkedField",
        "name": "sidebar",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsMenuItem",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "menuId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "visible"
                    }
                ]
            }
        ]
    }, v8 = {
        "args": v6 /*: any*/ ,
        "concreteType": "SettingsDisplayPropertyConnection",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsDisplayProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useNavSettingsServiceMutation",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_updateNavigationCustomisation",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useNavSettingsServiceMutation",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_updateNavigationCustomisation",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "22faaff69843483ef60d4de279304a4f15d34d081305f2df728cf86333831fa7",
            "metadata": {},
            "name": "useNavSettingsServiceMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c20b91a79b720ad9$var$node.hash = "33eadcae8875ac6ec53a5b1340297431";
var $c20b91a79b720ad9$export$2e2bcd8739ae039 = $c20b91a79b720ad9$var$node;

});

parcelRegister("fVtTa", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3bb3fe6bcc9b726$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04adf71d881d96495a7a3f6a6a067951>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e3bb3fe6bcc9b726$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "__relay_internal__pv__getpagesizevaluerelayproviderts"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__getpagesizevaluerelayproviderts"
            }
        ],
        "kind": "Fragment",
        "name": "useNavSettingsService",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "concreteType": "SettingsMenuItemConnection",
                "kind": "LinkedField",
                "name": "sidebar",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "SettingsMenuItem",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "menuId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "visible"
                            }
                        ]
                    }
                ]
            },
            {
                "args": v0 /*: any*/ ,
                "concreteType": "SettingsDisplayPropertyConnection",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "SettingsDisplayProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "SettingsNavigationCustomisation"
    };
}();
$e3bb3fe6bcc9b726$var$node.hash = "3eeb846e40561ac05736d40d381db293";
var $e3bb3fe6bcc9b726$export$2e2bcd8739ae039 = $e3bb3fe6bcc9b726$var$node;

});




parcelRegister("1AXS3", function(module, exports) {
$parcel$export(module.exports, "NetworkStore", () => $025417e5691fe660$export$711a2621397f25fc);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");

var $4RLhz = parcelRequire("4RLhz");

var $as6o9 = parcelRequire("as6o9");

var $2R4jK = parcelRequire("2R4jK");
function $025417e5691fe660$export$711a2621397f25fc({ children: children }) {
    const { networkStorageParams: networkStorageParams, app: app } = (0, $4RLhz.useOptions)();
    (0, $jiTLE.default)(networkStorageParams?.activationId && networkStorageParams?.ownerAri && networkStorageParams?.queryRef && networkStorageParams?.siteId, 'Please provide networkStorageParams when using customization');
    // This is user data for the menu and the sidebar
    const userStoreProps = (0, $as6o9.useNetworkSideNavUserData)({
        ...networkStorageParams,
        firstPartyApp: app
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2R4jK.StoreProviders), {
        ...userStoreProps,
        children: children
    });
}
$025417e5691fe660$export$711a2621397f25fc.displayName = "NetworkStore";

});

parcelRegister("50EJx", function(module, exports) {
$parcel$export(module.exports, "SideNav", () => $0b894dbe0f6aa141$export$1a35787d6353cf6a);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $egspI = parcelRequire("egspI");

var $djYhH = parcelRequire("djYhH");

var $aWAN2 = parcelRequire("aWAN2");

var $jufsF = parcelRequire("jufsF");
var $13WSK = parcelRequire("13WSK");
var $9sYLJ = parcelRequire("9sYLJ");
var $TmJ6X = parcelRequire("TmJ6X");

var $f3A47 = parcelRequire("f3A47");

var $2CeGr = parcelRequire("2CeGr");

var $69tcH = parcelRequire("69tcH");

var $4RLhz = parcelRequire("4RLhz");

var $b3CAV = parcelRequire("b3CAV");

var $jje4p = parcelRequire("jje4p");

var $lyg9d = parcelRequire("lyg9d");


var $eechR = parcelRequire("eechR");

var $d338J = parcelRequire("d338J");

var $79qLH = parcelRequire("79qLH");
function $0b894dbe0f6aa141$export$1a35787d6353cf6a(props) {
    const { postItemsElem: postItemsElem, postMainElem: postMainElem, openShortcutsInSameTab: openShortcutsInSameTab, viewAllAppsConfig: viewAllAppsConfig, ShortcutsSlot: ShortcutsSlot, experimental_onShortcutsMenuSettled: experimental_onShortcutsMenuSettled, onPeekEnd: onPeekEnd, onPeekStart: onPeekStart, onLeftNavCollapse: onLeftNavCollapse, onLeftNavExpand: onLeftNavExpand, onResizeEnd: onResizeEnd, onResizeStart: onResizeStart, sideNavContentRef: sideNavContentRef } = props;
    const { app: app, l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $4RLhz.useOptions)();
    const { allItems: allItems, shortcuts: shortcuts } = (0, $69tcH.useItemsAndShortcuts)();
    const userMenuDataShapes = (0, $lyg9d.useUserMenuDataShapes)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    // #region Drag and drop
    // Element registry for L1 items
    const [elementRegistry] = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useState((0, $jufsF.createElementRegistry));
    const { dragAndDropSave: dragAndDropSave } = (0, $b3CAV.useDragAndDropSave)(userMenuDataShapes, elementRegistry);
    const [draggingL1Group, setDraggingL1Group] = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useEffect(()=>{
        if (!experimental_onShortcutsMenuSettled) return;
        experimental_onShortcutsMenuSettled({
            shortcuts: shortcuts ?? {},
            visibleMenuIds: userMenuDataShapes.visibleMenuIds
        });
    }, [
        shortcuts,
        userMenuDataShapes.visibleMenuIds,
        experimental_onShortcutsMenuSettled
    ]);
    (0, $jje4p.useMonitorForDnDElements)({
        l1DragAndDropEnabled: l1DragAndDropEnabled,
        dragAndDropSave: dragAndDropSave,
        setDraggingL1Group: setDraggingL1Group,
        hiddenMenuIds: userMenuDataShapes.hiddenMenuIds
    });
    const { groupDropIndicatorRef: groupDropIndicatorRef, dragSource: dragSource } = (0, $TmJ6X.useDragState)({
        dragAndDropEnabled: l1DragAndDropEnabled,
        isItemData: (0, $9sYLJ.isL1ItemData)
    });
    // #endregion
    // #region Core rendering
    const mainNavItems = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>userMenuDataShapes.visibleItemMenuIds.map((id)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $f3A47.NavErrorBoundary), {
                errorMessages: (0, $79qLH.mainNavItemMessages),
                errorMessageValues: {
                    menuId: id
                },
                sentryConfig: {
                    product: app
                },
                showFlags: true,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2CeGr.default), {
                    id: id,
                    item: allItems[id]
                }, id)
            }, id)), [
        userMenuDataShapes.visibleItemMenuIds,
        app,
        allItems
    ]);
    const topElem = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>props.topElem ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f3A47.NavErrorBoundary), {
            errorMessages: (0, $79qLH.defaultErrorMessages),
            sentryConfig: {
                product: app
            },
            showFlags: true,
            children: props.topElem
        }) : null, [
        app,
        props.topElem
    ]);
    const bottomElem = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>props.bottomElem ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f3A47.NavErrorBoundary), {
            errorMessages: (0, $79qLH.defaultErrorMessages),
            sentryConfig: {
                product: app
            },
            showFlags: true,
            children: props.bottomElem
        }) : null, [
        app,
        props.bottomElem
    ]);
    const preMainElem = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>props.preMainElem ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f3A47.NavErrorBoundary), {
            errorMessages: (0, $79qLH.defaultErrorMessages),
            sentryConfig: {
                product: app
            },
            showFlags: true,
            children: props.preMainElem
        }) : null, [
        app,
        props.preMainElem
    ]);
    // The post-main element passed to GSNSideNavigationLayout. Like topElem /
    // preMainElem / bottomElem above, this is memoised so a justified SideNav
    // re-render does not hand the layout a fresh element identity every time
    // (which cascades a wasted re-render down the navigation tree — observed in
    // Chippy as `postMainElem: ref-changed` with identical content).
    //
    // Gated behind `navx-4728-jira-stability-fixes`: gate ON returns the
    // memoised element; gate OFF falls back to the inline JSX, preserving
    // current behaviour byte-for-byte.
    const memoizedPostMainElem = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $f3A47.NavErrorBoundary), {
            errorMessages: (0, $79qLH.defaultErrorMessages),
            sentryConfig: {
                product: app
            },
            showFlags: true,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $d338J.PostMainItems), {
                postItemsElem: postItemsElem,
                postMainElem: postMainElem,
                draggingL1Group: draggingL1Group,
                openShortcutsInSameTab: openShortcutsInSameTab,
                viewAllAppsConfig: viewAllAppsConfig,
                ShortcutsSlot: ShortcutsSlot
            })
        }), [
        app,
        postItemsElem,
        postMainElem,
        draggingL1Group,
        openShortcutsInSameTab,
        viewAllAppsConfig,
        ShortcutsSlot
    ]);
    const postMainElemForLayout = (0, $egspI.fg)('navx-4728-jira-stability-fixes') ? memoizedPostMainElem : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f3A47.NavErrorBoundary), {
        errorMessages: (0, $79qLH.defaultErrorMessages),
        sentryConfig: {
            product: app
        },
        showFlags: true,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $d338J.PostMainItems), {
            postItemsElem: postItemsElem,
            postMainElem: postMainElem,
            draggingL1Group: draggingL1Group,
            openShortcutsInSameTab: openShortcutsInSameTab,
            viewAllAppsConfig: viewAllAppsConfig,
            ShortcutsSlot: ShortcutsSlot
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jufsF.ElementRegistryProvider), {
        registry: elementRegistry,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eechR.GSNSideNavigationLayout), {
            testId: props.testId ?? (0, $e695cbb6f90a2d72$export$5678faf50a8e9276),
            preMainElem: topElem,
            onCollapse: onLeftNavCollapse,
            onExpand: onLeftNavExpand,
            onPeekEnd: onPeekEnd,
            onPeekStart: onPeekStart,
            onResizeEnd: onResizeEnd,
            onResizeStart: onResizeStart,
            sideNavContentRef: sideNavContentRef,
            postMainElem: postMainElemForLayout,
            bottomElem: bottomElem,
            children: mainNavItems?.length ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $djYhH.MenuList), {
                children: [
                    preMainElem,
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $13WSK.GroupDropIndicatorWithDragOver), {
                        ref: groupDropIndicatorRef,
                        isActive: draggingL1Group === (0, $aWAN2.L1_MENU_GROUPS).MENU,
                        ariaLabel: formatMessage((0, $79qLH.messages).primaryNavigationSectionScreenReader, {
                            item: dragSource
                        }),
                        children: mainNavItems
                    })
                ]
            }) : null
        })
    });
// #endregion
}
$0b894dbe0f6aa141$export$1a35787d6353cf6a.displayName = "SideNav";

});
parcelRegister("djYhH", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $63a0fd8410aa19d6$export$d4c4e98c5044dc8);

var $7qBrM = parcelRequire("7qBrM");
const $63a0fd8410aa19d6$export$d4c4e98c5044dc8 = (0, $7qBrM.List);

});
parcelRegister("7qBrM", function(module, exports) {
$parcel$export(module.exports, "List", () => $19612aeb60a5253d$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
function $19612aeb60a5253d$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId,
        children: children
    }));
}
const $19612aeb60a5253d$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $euxye.forwardRef)($19612aeb60a5253d$var$_List);

});


parcelRegister("aWAN2", function(module, exports) {
$parcel$export(module.exports, "L1_MENU_GROUPS", () => $400d455c4b30601e$export$72b069d0875dccc);
const $400d455c4b30601e$export$72b069d0875dccc = {
    MENU: 'L1MenuGroup',
    SHORTCUTS: 'L1ShortcutsGroup'
};

});

parcelRegister("jufsF", function(module, exports) {
$parcel$export(module.exports, "createElementRegistry", () => $d8cbf71c801f37dc$export$b8d30beb0c187a7);
$parcel$export(module.exports, "ElementRegistryProvider", () => $d8cbf71c801f37dc$export$ce0cc6a5e9b6a71a);
$parcel$export(module.exports, "useElementRegistry", () => $d8cbf71c801f37dc$export$9a176103b34f9da9);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");
// When a user drags & drops a navigation item, ADS recommends that we flash the item visually, and if the move was
// triggered by keyboard, also set focus to the moved item. This element registry allows GSN to keep track of the
// actual HTML elements of the L1 items, so that we can flash and focus them after the drag & drop action is performed.
// This pattern is recommended by AtlasKit in the side nav drag & drop documentation:
// https://atlassian.design/components/navigation-system/side-nav-items/drag-and-drop#on-drop
const $d8cbf71c801f37dc$var$MORE_MENU_ID = Symbol('moreMenuId');
function $d8cbf71c801f37dc$export$b8d30beb0c187a7() {
    const registry = new Map();
    function registerL1Item({ id: id, element: element }) {
        registry.set(id, element);
        return function cleanup() {
            registry.delete(id);
        };
    }
    function getL1ItemElement(id) {
        return registry.get(id);
    }
    function registerMoreMenuItem(element) {
        return registerL1Item({
            id: $d8cbf71c801f37dc$var$MORE_MENU_ID,
            element: element
        });
    }
    function getMoreMenuElement() {
        return getL1ItemElement($d8cbf71c801f37dc$var$MORE_MENU_ID);
    }
    return {
        getL1ItemElement: getL1ItemElement,
        getMoreMenuElement: getMoreMenuElement,
        registerL1Item: registerL1Item,
        registerMoreMenuItem: registerMoreMenuItem
    };
}
const $d8cbf71c801f37dc$var$ElementRegistryContext = /*#__PURE__*/ (0, $euxye.createContext)(null);
function $d8cbf71c801f37dc$export$ce0cc6a5e9b6a71a({ children: children, registry: registry }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)($d8cbf71c801f37dc$var$ElementRegistryContext.Provider, {
        value: registry,
        children: children
    });
}
$d8cbf71c801f37dc$export$ce0cc6a5e9b6a71a.displayName = "ElementRegistryProvider";
function $d8cbf71c801f37dc$export$9a176103b34f9da9() {
    const elementRegistry = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useContext($d8cbf71c801f37dc$var$ElementRegistryContext);
    (0, $jiTLE.default)(elementRegistry, 'useElementRegistry must be used within an ElementRegistryProvider');
    return elementRegistry;
}

});

parcelRegister("13WSK", function(module, exports) {
$parcel$export(module.exports, "GroupDropIndicatorWithDragOver", () => $7839e7a95355e125$export$bd7361bd33ae3eff);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $1pY3J = parcelRequire("1pY3J");
const $7839e7a95355e125$var$activeStyle = null;
const $7839e7a95355e125$var$enteredStyle = null;
const $7839e7a95355e125$export$bd7361bd33ae3eff = /*#__PURE__*/ (0, $euxye.forwardRef)($7839e7a95355e125$var$GroupDropIndicatorWithDragOverInner);
function $7839e7a95355e125$var$GroupDropIndicatorWithDragOverInner({ children: children, isActive: isActive, testId: testId, disableEntered: disableEntered, ariaLabel: ariaLabel }, forwardedRef) {
    const [isEntered, setIsEntered] = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useState(false);
    const ref = (0, $euxye.useRef)(null);
    const handleDragEnter = (0, $euxye.useCallback)(()=>{
        if (!isActive || Boolean(disableEntered) || isEntered) return;
        setIsEntered(true);
        // Announce directly in the event handler rather than in a chained effect,
        // so the live-region fires in the same event dispatch as the state change.
        if (ariaLabel) (0, $1pY3J.announce)(ariaLabel);
    }, [
        disableEntered,
        isActive,
        isEntered,
        ariaLabel
    ]);
    const handleDragLeave = (0, $euxye.useCallback)((event)=>{
        if (!isActive || Boolean(disableEntered) || !isEntered) return;
        const relatedTarget = event.relatedTarget;
        if (ref.current && relatedTarget && ref.current.contains(relatedTarget)) return; // Still within bounds, don't trigger leave
        setIsEntered(false);
    }, [
        disableEntered,
        isActive,
        isEntered
    ]);
    // `isEntered` is only meaningful when `isActive` is true. Compute the effective
    // value during render instead of resetting state in a chained effect, eliminating
    // one extra render cycle whenever `isActive` becomes false.
    const effectiveIsEntered = isActive && isEntered;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            onDragEnter: handleDragEnter,
            onDragLeave: handleDragLeave,
            ref: forwardedRef,
            "data-testid": testId,
            "data-is-active": isActive,
            "data-is-entered": effectiveIsEntered,
            role: isActive ? 'region' : undefined,
            "aria-label": isActive && ariaLabel ? ariaLabel : undefined,
            className: (0, $4jQY2.default)([
                isActive && "_2rkolb4i _bfhk19ip",
                effectiveIsEntered && "_1cwg12x7 _12y31dm9 _1qu2nqa1 _12jiq98m"
            ]),
            children: children
        })
    });
}
$7839e7a95355e125$var$GroupDropIndicatorWithDragOverInner.displayName = "GroupDropIndicatorWithDragOverInner";

});
parcelRegister("1pY3J", function(module, exports) {
$parcel$export(module.exports, "announce", () => $9031a5fe0296d5ff$export$a9b970dcc4ae71a9);
$parcel$export(module.exports, "cleanup", () => $9031a5fe0296d5ff$export$de863c629cb9919d);

let $9031a5fe0296d5ff$var$node = null;
const $9031a5fe0296d5ff$var$size = '1px';
const $9031a5fe0296d5ff$var$visuallyHiddenStyles = {
    // Standard visually hidden styles.
    // Copied from our VisuallyHidden (react) package.
    width: $9031a5fe0296d5ff$var$size,
    height: $9031a5fe0296d5ff$var$size,
    padding: '0',
    position: 'absolute',
    border: '0',
    clip: `rect(${$9031a5fe0296d5ff$var$size}, ${$9031a5fe0296d5ff$var$size}, ${$9031a5fe0296d5ff$var$size}, ${$9031a5fe0296d5ff$var$size})`,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    // Pulling upwards slightly to prevent the page
    // from growing when appended to a body that contains
    // an element with height:100%
    marginTop: `-${$9031a5fe0296d5ff$var$size}`,
    // Just being safe and letting this element not interfere with hitboxes
    pointerEvents: 'none'
};
/**
 * Creates a live region node, appends it to the body, and returns it.
 */ function $9031a5fe0296d5ff$var$createNode() {
    const node = document.createElement('div');
    /**
	 * Using `role="status"` instead of `role="alert"` so that the message
	 * can be queued and read when able.
	 *
	 * We found with `role="alert"` the message was not reliably read when
	 * focus changed.
	 */ node.setAttribute('role', 'status');
    Object.assign(node.style, $9031a5fe0296d5ff$var$visuallyHiddenStyles);
    document.body.append(node);
    return node;
}
/**
 * Returns the live region node, creating one if necessary.
 */ function $9031a5fe0296d5ff$var$getNode() {
    if ($9031a5fe0296d5ff$var$node === null) $9031a5fe0296d5ff$var$node = $9031a5fe0296d5ff$var$createNode();
    return $9031a5fe0296d5ff$var$node;
}
let $9031a5fe0296d5ff$var$timerId = null;
function $9031a5fe0296d5ff$var$tryClearTimer() {
    if ($9031a5fe0296d5ff$var$timerId !== null) clearTimeout($9031a5fe0296d5ff$var$timerId);
    $9031a5fe0296d5ff$var$timerId = null;
}
function $9031a5fe0296d5ff$export$a9b970dcc4ae71a9(message) {
    /**
	 * Calling this immediately to ensure a node exists and has time to be parsed
	 * and exposed in the accessibility tree.
	 */ $9031a5fe0296d5ff$var$getNode();
    /**
	 * Updating the message in a timeout so that it's less likely to be interrupted.
	 *
	 * This function is often called right before focus changes,
	 * because the user has just taken an action.
	 * This focus change would often cause the message to be skipped / interrupted.
	 */ $9031a5fe0296d5ff$var$tryClearTimer();
    $9031a5fe0296d5ff$var$timerId = setTimeout(()=>{
        $9031a5fe0296d5ff$var$timerId = null;
        const node = $9031a5fe0296d5ff$var$getNode();
        node.textContent = message;
    }, (0, $fb051c5ffc912a47$export$a88f30567ea7367a));
    return;
}
function $9031a5fe0296d5ff$export$de863c629cb9919d() {
    $9031a5fe0296d5ff$var$tryClearTimer();
    $9031a5fe0296d5ff$var$node?.remove();
    $9031a5fe0296d5ff$var$node = null;
}

});
/**
 * Delay until the text content of the live region is updated.
 *
 * This value was reached through some experimentation, and may need tweaking in the future.
 */ const $fb051c5ffc912a47$export$a88f30567ea7367a = 1000;



parcelRegister("9sYLJ", function(module, exports) {
$parcel$export(module.exports, "createL1ItemData", () => $4e334a8bdc7bfccf$export$a1dfda61267432e5);
$parcel$export(module.exports, "getL1ItemData", () => $4e334a8bdc7bfccf$export$e9f7c92759d0f281);
$parcel$export(module.exports, "isL1ItemData", () => $4e334a8bdc7bfccf$export$e52c346726a16591);
$parcel$export(module.exports, "isL1ItemDataInGroup", () => $4e334a8bdc7bfccf$export$9d9fcc463b545806);
$parcel$export(module.exports, "getMoreMenuData", () => $4e334a8bdc7bfccf$export$e74f096ffe08821d);
$parcel$export(module.exports, "isMoreMenuData", () => $4e334a8bdc7bfccf$export$e37de48254c6595e);
$parcel$export(module.exports, "createNestedItemData", () => $4e334a8bdc7bfccf$export$fe7d1a1bab9e2488);
$parcel$export(module.exports, "getNestedItemData", () => $4e334a8bdc7bfccf$export$db162439b96bd9a8);
$parcel$export(module.exports, "isNestedItemData", () => $4e334a8bdc7bfccf$export$23cae75a8064fbc1);
$parcel$export(module.exports, "isNestedItemDataInGroup", () => $4e334a8bdc7bfccf$export$a3f9aca82641b845);
$parcel$export(module.exports, "OPERATIONS", () => $4e334a8bdc7bfccf$export$98ff4de2f070152d);
const $4e334a8bdc7bfccf$var$l1ItemKey = Symbol('l1ItemKey');
const $4e334a8bdc7bfccf$var$nestedItemKey = Symbol('nestedItemKey');
const $4e334a8bdc7bfccf$var$moreMenuKey = Symbol('moreMenuKey');
const $4e334a8bdc7bfccf$export$a1dfda61267432e5 = (data)=>({
        ...data,
        type: 'menu-item',
        [$4e334a8bdc7bfccf$var$l1ItemKey]: true
    });
const $4e334a8bdc7bfccf$export$e9f7c92759d0f281 = (data)=>({
        ...data
    });
const $4e334a8bdc7bfccf$export$e52c346726a16591 = (data)=>{
    return data[$4e334a8bdc7bfccf$var$l1ItemKey] === true;
};
const $4e334a8bdc7bfccf$export$9d9fcc463b545806 = (data, groups)=>{
    return Array.isArray(groups) ? groups.includes(data.group) : groups === data.group;
};
const $4e334a8bdc7bfccf$export$7960450fbf5a0a72 = Symbol('moreMenuId');
function $4e334a8bdc7bfccf$export$e74f096ffe08821d() {
    return {
        menuItemId: $4e334a8bdc7bfccf$export$7960450fbf5a0a72,
        [$4e334a8bdc7bfccf$var$moreMenuKey]: true
    };
}
function $4e334a8bdc7bfccf$export$e37de48254c6595e(data) {
    return data[$4e334a8bdc7bfccf$var$moreMenuKey] === true;
}
const $4e334a8bdc7bfccf$export$fe7d1a1bab9e2488 = (data)=>({
        ...data,
        type: 'menu-item',
        [$4e334a8bdc7bfccf$var$nestedItemKey]: true
    });
const $4e334a8bdc7bfccf$export$db162439b96bd9a8 = (data)=>{
    return {
        ...data,
        [$4e334a8bdc7bfccf$var$nestedItemKey]: true
    };
};
const $4e334a8bdc7bfccf$export$23cae75a8064fbc1 = (data)=>{
    return data[$4e334a8bdc7bfccf$var$nestedItemKey] === true;
};
const $4e334a8bdc7bfccf$export$a3f9aca82641b845 = (data, groups)=>{
    return Array.isArray(groups) ? groups.includes(data.group) : groups === data.group;
};
const $4e334a8bdc7bfccf$export$98ff4de2f070152d = {
    MOVE_TO_TOP: 'MOVE_TO_TOP',
    MOVE_UP: 'MOVE_UP',
    MOVE_DOWN: 'MOVE_DOWN',
    MOVE_TO_BOTTOM: 'MOVE_TO_BOTTOM',
    BEFORE: 'reorder-before',
    AFTER: 'reorder-after'
};

});

parcelRegister("TmJ6X", function(module, exports) {
$parcel$export(module.exports, "useDragState", () => $990d995dce0b51bd$export$e782a36b4f98f6f5);

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");
parcelRequire("3nfFb");
var $gOKKd = parcelRequire("gOKKd");
function $990d995dce0b51bd$export$e782a36b4f98f6f5({ dragAndDropEnabled: dragAndDropEnabled = false, isItemData: isItemData }) {
    const groupDropIndicatorRef = (0, $euxye.useRef)(null);
    const [dragState, setDragState] = (0, $euxye.useState)('idle');
    const [dragSource, setDragSource] = (0, $euxye.useState)(null);
    // Track drag source menuItemId
    (0, $euxye.useEffect)(()=>{
        if (!dragAndDropEnabled) return;
        return (0, $gOKKd.monitorForElements)({
            canMonitor: ({ source: source })=>isItemData(source.data),
            onDragStart ({ source: source }) {
                setDragSource(source.data.menuItemId);
            },
            onDrop () {
                setDragSource(null);
            }
        });
    }, [
        isItemData,
        dragAndDropEnabled
    ]);
    // Track drop target source
    (0, $euxye.useEffect)(()=>{
        if (!dragAndDropEnabled) return;
        const groupDropIndicator = groupDropIndicatorRef.current;
        (0, $jiTLE.default)(groupDropIndicator, 'groupDropIndicatorRef should not be null');
        return (0, $gOKKd.dropTargetForElements)({
            element: groupDropIndicator,
            canDrop: ({ source: source })=>isItemData(source.data),
            onDragStart () {
                setDragState('is-over');
            },
            onDragEnter () {
                setDragState('is-over');
            },
            onDragLeave () {
                setDragState('idle');
            },
            onDrop () {
                setDragState('idle');
            }
        });
    }, [
        dragAndDropEnabled,
        isItemData
    ]);
    return {
        groupDropIndicatorRef: groupDropIndicatorRef,
        dragState: dragState,
        dragSource: dragSource
    };
}

});

parcelRegister("2CeGr", function(module, exports) {
$parcel$export(module.exports, "default", () => $41649a4412fa9f84$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $iVtau = parcelRequire("iVtau");

var $1Io8b = parcelRequire("1Io8b");

var $hQxjT = parcelRequire("hQxjT");
var $klGx5 = parcelRequire("klGx5");
var $ldfa4 = parcelRequire("ldfa4");

var $4U30j = parcelRequire("4U30j");
var $iozCP = parcelRequire("iozCP");
var $02ogW = parcelRequire("02ogW");

var $e6rNk = parcelRequire("e6rNk");

var $ar9gx = parcelRequire("ar9gx");

var $aWAN2 = parcelRequire("aWAN2");

var $dsHLR = parcelRequire("dsHLR");

var $4RLhz = parcelRequire("4RLhz");

var $edY9W = parcelRequire("edY9W");

var $dWWgU = parcelRequire("dWWgU");

var $8mxlT = parcelRequire("8mxlT");

var $lKiuS = parcelRequire("lKiuS");

var $5TAdw = parcelRequire("5TAdw");

var $1QF9m = parcelRequire("1QF9m");

var $yhM5u = parcelRequire("yhM5u");
// Gated behind `navx-4728-jira-stability-fixes`: gate ON renders the refactored
// `NavItemRawStable`, which splits each item type into its own memoised leaf
// component and hands each leaf a referentially-stable `onClick` so the
// memoised `LinkMenuItem` / `ButtonMenuItem` / trigger leaves are not handed a
// brand-new handler on every `NavItem` render (which would defeat their memo).
// Gate OFF renders the original `NavItemRaw`, preserving current behaviour.
const $41649a4412fa9f84$var$GatedNavItem = (0, $iVtau.componentWithFG)('navx-4728-jira-stability-fixes', $41649a4412fa9f84$var$NavItemRawStable, $41649a4412fa9f84$var$NavItemRaw);
const $41649a4412fa9f84$export$e3925dbaeffcc83f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo($41649a4412fa9f84$var$GatedNavItem);
var $41649a4412fa9f84$export$2e2bcd8739ae039 = $41649a4412fa9f84$export$e3925dbaeffcc83f;
function $41649a4412fa9f84$var$NavItemRaw({ id: id, item: item, peek: peek = false, isInMoreMenu: isInMoreMenu = false, onClick: onClick, onPeek: onPeek, group: group = (0, $aWAN2.L1_MENU_GROUPS).MENU }) {
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $4RLhz.useOptions)();
    const { type: type } = item;
    const ItemWrapper = item.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment;
    const { isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, isExpandable: isExpandable } = (0, $yhM5u.useExpandOpenState)(item, peek);
    const { draggableRef: draggableRef, isItemDraggable: isItemDraggable, isDragging: isDragging, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview } = (0, $dsHLR.useL1ItemDragAndDrop)({
        item: item,
        id: id,
        isExpandable: isExpandable,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle,
        peek: peek,
        group: group,
        l1DragAndDropEnabled: l1DragAndDropEnabled
    });
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent, fireClickedSideNavSubMenuItemEvent: fireClickedSideNavSubMenuItemEvent, fireViewedSideNavSubMenuEvent: fireViewedSideNavSubMenuEvent } = (0, $1QF9m.useNavAnalytics)();
    // Common internal onClick handler for all top-level item types
    const onNavItemClick = (0, $euxye.useCallback)((isRightClick, status)=>{
        (0, $egspI.fg)('navx-global-side-nav-confluence') ? fireClickedSideNavItemEvent(id, undefined, isRightClick, status) : fireClickedSideNavItemEvent(id, undefined, isRightClick);
    }, [
        fireClickedSideNavItemEvent,
        id
    ]);
    // Common onSubMenuItemClick handler for all sub-menu item types
    const onSubMenuItemClick = (0, $euxye.useCallback)((isRightClick, extendedAttributes)=>{
        fireClickedSideNavSubMenuItemEvent(id, undefined, isInMoreMenu, isRightClick, undefined, extendedAttributes ?? null);
    }, [
        fireClickedSideNavSubMenuItemEvent,
        id,
        isInMoreMenu
    ]);
    (0, $euxye.useEffect)(()=>{
        if (isExpandable && isExpandOrFlyoutOpen) fireViewedSideNavSubMenuEvent(id, undefined, isInMoreMenu);
    }, [
        fireViewedSideNavSubMenuEvent,
        id,
        isExpandOrFlyoutOpen,
        isExpandable,
        isInMoreMenu,
        type
    ]);
    if ((0, $5TAdw.isCustomItemConfig)(item)) {
        const Wrapper = item.isMenuListItem ? (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment : (0, $ar9gx.MenuListItem);
        // If the item is a custom item, render it directly
        // TODO: Add customizationHandlers prop when ready.
        return /*#__PURE__*/ (0, $e79Pd.jsx)(ItemWrapper, {
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)(item.Component, {
                        draggableRef: draggableRef,
                        dropIndicator: dropIndicator,
                        hasDragIndicator: isItemDraggable,
                        isDragging: isDragging,
                        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
                        isInMoreMenu: isInMoreMenu && !peek,
                        isPeeked: peek,
                        onClick: (...args)=>{
                            item.Component.defaultProps?.onClick?.(...args);
                            fireClickedSideNavItemEvent(id);
                            onClick?.();
                        },
                        onExpandFlyoutToggle: onExpandFlyoutToggle,
                        onPeek: onPeek,
                        visualContentRef: dropTargetRef
                    }),
                    maybeDragPreview
                ]
            })
        });
    } else if ((0, $5TAdw.isLinkItemConfig)(item)) {
        const { label: label, labelElem: labelElem, ...linkMenuItemProps } = (0, $lKiuS.omitSafely)(item, 'type');
        return /*#__PURE__*/ (0, $e79Pd.jsx)(ItemWrapper, {
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8mxlT.ElementEventListener), {
                handler: onNavItemClick,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e6rNk.LinkMenuItem), {
                        ...linkMenuItemProps,
                        onClick: (...args)=>{
                            linkMenuItemProps.onClick?.(...args);
                            onNavItemClick();
                            onClick?.();
                        },
                        hasDragIndicator: isItemDraggable,
                        ref: draggableRef,
                        isDragging: isDragging,
                        dropIndicator: dropIndicator,
                        visualContentRef: dropTargetRef,
                        actionsOnHover: $41649a4412fa9f84$var$getActionsOnHover({
                            id: id,
                            isItemDraggable: isItemDraggable,
                            item: item,
                            isInMoreMenu: isInMoreMenu,
                            group: group
                        }),
                        children: labelElem ?? label
                    }),
                    maybeDragPreview
                ]
            })
        });
    } else if ((0, $5TAdw.isButtonItemConfig)(item)) {
        const { label: label, labelElem: labelElem, ...buttonMenuItemProps } = (0, $lKiuS.omitSafely)(item, 'type');
        return /*#__PURE__*/ (0, $e79Pd.jsxs)(ItemWrapper, {
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1Io8b.ButtonMenuItem), {
                    ...buttonMenuItemProps,
                    onClick: (...args)=>{
                        buttonMenuItemProps.onClick?.(...args);
                        onNavItemClick();
                        onClick?.();
                    },
                    hasDragIndicator: isItemDraggable,
                    ref: draggableRef,
                    isDragging: isDragging,
                    dropIndicator: dropIndicator,
                    visualContentRef: dropTargetRef,
                    actionsOnHover: $41649a4412fa9f84$var$getActionsOnHover({
                        id: id,
                        isItemDraggable: isItemDraggable,
                        item: item,
                        isInMoreMenu: isInMoreMenu,
                        group: group
                    }),
                    children: labelElem ?? label
                }),
                maybeDragPreview
            ]
        });
    } else if ((0, $5TAdw.isExpandableItemConfig)(item)) {
        // eslint-disable-next-line no-unused-vars
        const { children: children, elemBefore: elemBefore, label: label, labelElem: labelElem, ...triggerProps } = (0, $lKiuS.omitSafely)(item, 'type', 'isDefaultExpanded', 'isExpanded', 'onExpansionToggle');
        // Wrap children with our analytics listener to capture their click events
        const wrappedChildren = (0, $dWWgU.withSideNavigationAnalyticsListener)(item.children, onSubMenuItemClick);
        return /*#__PURE__*/ (0, $e79Pd.jsxs)(ItemWrapper, {
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $hQxjT.ExpandableMenuItem), {
                    dropIndicator: dropIndicator,
                    isExpanded: isExpandOrFlyoutOpen,
                    onExpansionToggle: onExpandFlyoutToggle,
                    ref: dropTargetRef,
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ldfa4.ExpandableMenuItemTrigger), {
                            ...triggerProps,
                            onClick: (...args)=>{
                                triggerProps.onClick?.(...args);
                                (0, $egspI.fg)('navx-global-side-nav-confluence') ? onNavItemClick(false, isExpandOrFlyoutOpen ? 'collapsed' : 'expanded') : onNavItemClick();
                                onClick?.();
                            },
                            // During drags, custom elemBefore is not shown
                            // https://atlassian.design/components/navigation-system/side-nav-items/drag-and-drop#drag-start
                            elemBefore: isDragging ? null : elemBefore,
                            hasDragIndicator: isItemDraggable,
                            ref: draggableRef,
                            isDragging: isDragging,
                            actionsOnHover: $41649a4412fa9f84$var$getActionsOnHover({
                                id: id,
                                isItemDraggable: isItemDraggable,
                                item: item,
                                isInMoreMenu: isInMoreMenu,
                                group: group
                            }),
                            children: labelElem ?? label
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $klGx5.ExpandableMenuItemContent), {
                            children: wrappedChildren
                        })
                    ]
                }),
                maybeDragPreview
            ]
        });
    } else if ((0, $5TAdw.isFlyoutItemConfig)(item)) {
        // eslint-disable-next-line no-unused-vars
        const { children: children, label: label, labelElem: labelElem, ...triggerProps } = (0, $lKiuS.omitSafely)(item, 'type', 'isDefaultOpen', 'isOpen', 'onOpenChange');
        // Wrap children with our analytics listener to capture their click events
        const wrappedChildren = (0, $dWWgU.withSideNavigationAnalyticsListener)(item.children, onSubMenuItemClick);
        return /*#__PURE__*/ (0, $e79Pd.jsxs)(ItemWrapper, {
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $4U30j.FlyoutMenuItem), {
                    isOpen: isExpandOrFlyoutOpen,
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $02ogW.FlyoutMenuItemTrigger), {
                            ...triggerProps,
                            onClick: (...args)=>{
                                triggerProps.onClick?.(...args);
                                // Toggle the flyout open state
                                onExpandFlyoutToggle(!isExpandOrFlyoutOpen);
                                (0, $egspI.fg)('navx-global-side-nav-confluence') ? onNavItemClick(false, isExpandOrFlyoutOpen ? 'collapsed' : 'expanded') : onNavItemClick();
                                onClick?.();
                            },
                            hasDragIndicator: isItemDraggable,
                            ref: draggableRef,
                            isDragging: isDragging,
                            dropIndicator: dropIndicator,
                            visualContentRef: dropTargetRef,
                            children: labelElem ?? label
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iozCP.FlyoutMenuItemContent), {
                            onClose: ()=>onExpandFlyoutToggle(false),
                            children: wrappedChildren
                        })
                    ]
                }),
                maybeDragPreview
            ]
        });
    } else if ((0, $5TAdw.isObjectListFlyoutItemConfig)(item)) {
        const objectListFlyoutProps = (0, $lKiuS.omitSafely)(item, 'type', 'isOpen', 'onOpenChange');
        const isOpenExternallyControlled = typeof item.isOpen === 'boolean';
        // We only want to control the flyout if it is already open, or when we are doing a drag operation.
        // In other cases, we should return undefined to signal that the OLF is not controlled.
        const isControlledFlyout = isOpenExternallyControlled ? item.isOpen : isExpandOrFlyoutOpen || isDragging ? isExpandOrFlyoutOpen : undefined;
        return /*#__PURE__*/ (0, $e79Pd.jsx)(ItemWrapper, {
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8mxlT.ElementEventListenerProvider), {
                handler: onSubMenuItemClick,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $edY9W.ObjectListFlyout), {
                        ...objectListFlyoutProps,
                        itemMenuId: id,
                        onClick: (...args)=>{
                            // Toggle the flyout open state
                            onExpandFlyoutToggle(!isExpandOrFlyoutOpen);
                            objectListFlyoutProps.onClick?.(...args);
                            (0, $egspI.fg)('navx-global-side-nav-confluence') ? onNavItemClick(false, isExpandOrFlyoutOpen ? 'collapsed' : 'expanded') : onNavItemClick();
                            onClick?.();
                        },
                        onSubMenuItemClick: (event, extendedSubItemAnalyticsAttributes)=>{
                            objectListFlyoutProps.onSubMenuItemClick?.(event, extendedSubItemAnalyticsAttributes);
                            onSubMenuItemClick(false, extendedSubItemAnalyticsAttributes);
                        },
                        isFlyoutOpen: isControlledFlyout,
                        onOpenChange: onExpandFlyoutToggle,
                        hasDragIndicator: isItemDraggable,
                        triggerRef: draggableRef,
                        isDragging: isDragging,
                        dropIndicator: dropIndicator,
                        visualContentRef: dropTargetRef
                    }),
                    maybeDragPreview
                ]
            })
        });
    } else return null;
}
$41649a4412fa9f84$var$NavItemRaw.displayName = "NavItemRaw";
/**
 * Refactored dispatcher used when `navx-4728-jira-stability-fixes` is ON.
 *
 * All shared hooks run here once, then a thin type-guard switch selects which
 * memoised leaf component to render. The leaves receive the computed values via
 * `SharedLeafProps` and own their referentially-stable `onClick` handlers, so a
 * re-render of `NavItemRawStable` that does not change a leaf's props lets that
 * leaf bail out of re-rendering.
 */ function $41649a4412fa9f84$var$NavItemRawStable({ id: id, item: item, peek: peek = false, isInMoreMenu: isInMoreMenu = false, onClick: onClick, onPeek: onPeek, group: group = (0, $aWAN2.L1_MENU_GROUPS).MENU }) {
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $4RLhz.useOptions)();
    const { type: type } = item;
    const ItemWrapper = item.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment;
    const { isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, isExpandable: isExpandable } = (0, $yhM5u.useExpandOpenState)(item, peek);
    const { draggableRef: draggableRef, isItemDraggable: isItemDraggable, isDragging: isDragging, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview } = (0, $dsHLR.useL1ItemDragAndDrop)({
        item: item,
        id: id,
        isExpandable: isExpandable,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle,
        peek: peek,
        group: group,
        l1DragAndDropEnabled: l1DragAndDropEnabled
    });
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent, fireClickedSideNavSubMenuItemEvent: fireClickedSideNavSubMenuItemEvent, fireViewedSideNavSubMenuEvent: fireViewedSideNavSubMenuEvent } = (0, $1QF9m.useNavAnalytics)();
    // Common internal onClick handler for all top-level item types
    const onNavItemClick = (0, $euxye.useCallback)((isRightClick, status)=>{
        (0, $egspI.fg)('navx-global-side-nav-confluence') ? fireClickedSideNavItemEvent(id, undefined, isRightClick, status) : fireClickedSideNavItemEvent(id, undefined, isRightClick);
    }, [
        fireClickedSideNavItemEvent,
        id
    ]);
    // Common onSubMenuItemClick handler for all sub-menu item types
    const onSubMenuItemClick = (0, $euxye.useCallback)((isRightClick, extendedAttributes)=>{
        fireClickedSideNavSubMenuItemEvent(id, undefined, isInMoreMenu, isRightClick, undefined, extendedAttributes ?? null);
    }, [
        fireClickedSideNavSubMenuItemEvent,
        id,
        isInMoreMenu
    ]);
    (0, $euxye.useEffect)(()=>{
        if (isExpandable && isExpandOrFlyoutOpen) fireViewedSideNavSubMenuEvent(id, undefined, isInMoreMenu);
    }, [
        fireViewedSideNavSubMenuEvent,
        id,
        isExpandOrFlyoutOpen,
        isExpandable,
        isInMoreMenu,
        type
    ]);
    const shared = {
        id: id,
        onClick: onClick,
        onPeek: onPeek,
        peek: peek,
        isInMoreMenu: isInMoreMenu,
        group: group,
        ItemWrapper: ItemWrapper,
        draggableRef: draggableRef,
        dropTargetRef: dropTargetRef,
        dropIndicator: dropIndicator,
        maybeDragPreview: maybeDragPreview,
        isItemDraggable: isItemDraggable,
        isDragging: isDragging,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle,
        onNavItemClick: onNavItemClick,
        onSubMenuItemClick: onSubMenuItemClick,
        fireClickedSideNavItemEvent: fireClickedSideNavItemEvent
    };
    if ((0, $5TAdw.isCustomItemConfig)(item)) return /*#__PURE__*/ (0, $e79Pd.jsx)($41649a4412fa9f84$var$CustomNavItem, {
        item: item,
        ...shared
    });
    else if ((0, $5TAdw.isLinkItemConfig)(item)) return /*#__PURE__*/ (0, $e79Pd.jsx)($41649a4412fa9f84$var$LinkNavItem, {
        item: item,
        ...shared
    });
    else if ((0, $5TAdw.isButtonItemConfig)(item)) return /*#__PURE__*/ (0, $e79Pd.jsx)($41649a4412fa9f84$var$ButtonNavItem, {
        item: item,
        ...shared
    });
    else if ((0, $5TAdw.isExpandableItemConfig)(item)) return /*#__PURE__*/ (0, $e79Pd.jsx)($41649a4412fa9f84$var$ExpandableNavItem, {
        item: item,
        ...shared
    });
    else if ((0, $5TAdw.isFlyoutItemConfig)(item)) return /*#__PURE__*/ (0, $e79Pd.jsx)($41649a4412fa9f84$var$FlyoutNavItem, {
        item: item,
        ...shared
    });
    else if ((0, $5TAdw.isObjectListFlyoutItemConfig)(item)) return /*#__PURE__*/ (0, $e79Pd.jsx)($41649a4412fa9f84$var$ObjectListFlyoutNavItem, {
        item: item,
        ...shared
    });
    else return null;
}
$41649a4412fa9f84$var$NavItemRawStable.displayName = "NavItemRawStable";
const $41649a4412fa9f84$var$CustomNavItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo(function CustomNavItem({ item: item, onClick: onClick, onPeek: onPeek, peek: peek, isInMoreMenu: isInMoreMenu, ItemWrapper: ItemWrapper, draggableRef: draggableRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview, isItemDraggable: isItemDraggable, isDragging: isDragging, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, fireClickedSideNavItemEvent: fireClickedSideNavItemEvent, id: id }) {
    const Wrapper = item.isMenuListItem ? (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment : (0, $ar9gx.MenuListItem);
    // Stable click handler. `customItemOnClickRef` carries the latest per-item
    // default onClick so the callback identity stays stable across renders.
    const customItemOnClickRef = (0, $euxye.useRef)(item.Component.defaultProps?.onClick);
    customItemOnClickRef.current = item.Component.defaultProps?.onClick;
    const onCustomItemClick = (0, $euxye.useCallback)((...args)=>{
        customItemOnClickRef.current?.(...args);
        fireClickedSideNavItemEvent(id);
        onClick?.();
    }, [
        fireClickedSideNavItemEvent,
        id,
        onClick
    ]);
    // TODO: Add customizationHandlers prop when ready.
    return /*#__PURE__*/ (0, $e79Pd.jsx)(ItemWrapper, {
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)(item.Component, {
                    draggableRef: draggableRef,
                    dropIndicator: dropIndicator,
                    hasDragIndicator: isItemDraggable,
                    isDragging: isDragging,
                    isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
                    isInMoreMenu: isInMoreMenu && !peek,
                    isPeeked: peek,
                    onClick: onCustomItemClick,
                    onExpandFlyoutToggle: onExpandFlyoutToggle,
                    onPeek: onPeek,
                    visualContentRef: dropTargetRef
                }),
                maybeDragPreview
            ]
        })
    });
});
const $41649a4412fa9f84$var$LinkNavItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo(function LinkNavItem({ item: item, onClick: onClick, isInMoreMenu: isInMoreMenu, group: group, ItemWrapper: ItemWrapper, draggableRef: draggableRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview, isItemDraggable: isItemDraggable, isDragging: isDragging, onNavItemClick: onNavItemClick, id: id }) {
    const { label: label, labelElem: labelElem, ...linkMenuItemProps } = (0, $lKiuS.omitSafely)(item, 'type');
    // Stable click handler. `itemOnClickRef` carries the latest per-item onClick.
    const itemOnClickRef = (0, $euxye.useRef)(linkMenuItemProps.onClick);
    itemOnClickRef.current = linkMenuItemProps.onClick;
    const onLinkItemClick = (0, $euxye.useCallback)((...args)=>{
        itemOnClickRef.current?.(...args);
        onNavItemClick();
        onClick?.();
    }, [
        onNavItemClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)(ItemWrapper, {
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8mxlT.ElementEventListener), {
            handler: onNavItemClick,
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e6rNk.LinkMenuItem), {
                    ...linkMenuItemProps,
                    onClick: onLinkItemClick,
                    hasDragIndicator: isItemDraggable,
                    ref: draggableRef,
                    isDragging: isDragging,
                    dropIndicator: dropIndicator,
                    visualContentRef: dropTargetRef,
                    actionsOnHover: $41649a4412fa9f84$var$getActionsOnHover({
                        id: id,
                        isItemDraggable: isItemDraggable,
                        item: item,
                        isInMoreMenu: isInMoreMenu,
                        group: group
                    }),
                    children: labelElem ?? label
                }),
                maybeDragPreview
            ]
        })
    });
});
const $41649a4412fa9f84$var$ButtonNavItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo(function ButtonNavItem({ item: item, onClick: onClick, isInMoreMenu: isInMoreMenu, group: group, ItemWrapper: ItemWrapper, draggableRef: draggableRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview, isItemDraggable: isItemDraggable, isDragging: isDragging, onNavItemClick: onNavItemClick, id: id }) {
    const { label: label, labelElem: labelElem, ...buttonMenuItemProps } = (0, $lKiuS.omitSafely)(item, 'type');
    // Stable click handler. `itemOnClickRef` carries the latest per-item onClick.
    const itemOnClickRef = (0, $euxye.useRef)(buttonMenuItemProps.onClick);
    itemOnClickRef.current = buttonMenuItemProps.onClick;
    const onButtonItemClick = (0, $euxye.useCallback)((...args)=>{
        itemOnClickRef.current?.(...args);
        onNavItemClick();
        onClick?.();
    }, [
        onNavItemClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)(ItemWrapper, {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1Io8b.ButtonMenuItem), {
                ...buttonMenuItemProps,
                onClick: onButtonItemClick,
                hasDragIndicator: isItemDraggable,
                ref: draggableRef,
                isDragging: isDragging,
                dropIndicator: dropIndicator,
                visualContentRef: dropTargetRef,
                actionsOnHover: $41649a4412fa9f84$var$getActionsOnHover({
                    id: id,
                    isItemDraggable: isItemDraggable,
                    item: item,
                    isInMoreMenu: isInMoreMenu,
                    group: group
                }),
                children: labelElem ?? label
            }),
            maybeDragPreview
        ]
    });
});
const $41649a4412fa9f84$var$ExpandableNavItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo(function ExpandableNavItem({ item: item, onClick: onClick, isInMoreMenu: isInMoreMenu, group: group, ItemWrapper: ItemWrapper, draggableRef: draggableRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview, isItemDraggable: isItemDraggable, isDragging: isDragging, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, onNavItemClick: onNavItemClick, onSubMenuItemClick: onSubMenuItemClick, id: id }) {
    // eslint-disable-next-line no-unused-vars
    const { children: children, elemBefore: elemBefore, label: label, labelElem: labelElem, ...triggerProps } = (0, $lKiuS.omitSafely)(item, 'type', 'isDefaultExpanded', 'isExpanded', 'onExpansionToggle');
    // Wrap children with our analytics listener to capture their click events
    const wrappedChildren = (0, $dWWgU.withSideNavigationAnalyticsListener)(item.children, onSubMenuItemClick);
    // Latest-ref for the open state so the stable handler reads the current value
    // without being recreated whenever it toggles.
    const isExpandOrFlyoutOpenRef = (0, $euxye.useRef)(isExpandOrFlyoutOpen);
    isExpandOrFlyoutOpenRef.current = isExpandOrFlyoutOpen;
    // Stable click handler for the expandable trigger.
    const triggerOnClickRef = (0, $euxye.useRef)(triggerProps.onClick);
    triggerOnClickRef.current = triggerProps.onClick;
    const onTriggerClick = (0, $euxye.useCallback)((...args)=>{
        triggerOnClickRef.current?.(...args);
        (0, $egspI.fg)('navx-global-side-nav-confluence') ? onNavItemClick(false, isExpandOrFlyoutOpenRef.current ? 'collapsed' : 'expanded') : onNavItemClick();
        onClick?.();
    }, [
        onNavItemClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)(ItemWrapper, {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $hQxjT.ExpandableMenuItem), {
                dropIndicator: dropIndicator,
                isExpanded: isExpandOrFlyoutOpen,
                onExpansionToggle: onExpandFlyoutToggle,
                ref: dropTargetRef,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ldfa4.ExpandableMenuItemTrigger), {
                        ...triggerProps,
                        onClick: onTriggerClick,
                        // During drags, custom elemBefore is not shown
                        // https://atlassian.design/components/navigation-system/side-nav-items/drag-and-drop#drag-start
                        elemBefore: isDragging ? null : elemBefore,
                        hasDragIndicator: isItemDraggable,
                        ref: draggableRef,
                        isDragging: isDragging,
                        actionsOnHover: $41649a4412fa9f84$var$getActionsOnHover({
                            id: id,
                            isItemDraggable: isItemDraggable,
                            item: item,
                            isInMoreMenu: isInMoreMenu,
                            group: group
                        }),
                        children: labelElem ?? label
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $klGx5.ExpandableMenuItemContent), {
                        children: wrappedChildren
                    })
                ]
            }),
            maybeDragPreview
        ]
    });
});
const $41649a4412fa9f84$var$FlyoutNavItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo(function FlyoutNavItem({ item: item, onClick: onClick, ItemWrapper: ItemWrapper, draggableRef: draggableRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview, isItemDraggable: isItemDraggable, isDragging: isDragging, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, onNavItemClick: onNavItemClick, onSubMenuItemClick: onSubMenuItemClick }) {
    // eslint-disable-next-line no-unused-vars
    const { children: children, label: label, labelElem: labelElem, ...triggerProps } = (0, $lKiuS.omitSafely)(item, 'type', 'isDefaultOpen', 'isOpen', 'onOpenChange');
    // Wrap children with our analytics listener to capture their click events
    const wrappedChildren = (0, $dWWgU.withSideNavigationAnalyticsListener)(item.children, onSubMenuItemClick);
    const isExpandOrFlyoutOpenRef = (0, $euxye.useRef)(isExpandOrFlyoutOpen);
    isExpandOrFlyoutOpenRef.current = isExpandOrFlyoutOpen;
    // Stable click handler for the flyout trigger.
    const triggerOnClickRef = (0, $euxye.useRef)(triggerProps.onClick);
    triggerOnClickRef.current = triggerProps.onClick;
    const onTriggerClick = (0, $euxye.useCallback)((...args)=>{
        triggerOnClickRef.current?.(...args);
        // Toggle the flyout open state
        onExpandFlyoutToggle(!isExpandOrFlyoutOpenRef.current);
        (0, $egspI.fg)('navx-global-side-nav-confluence') ? onNavItemClick(false, isExpandOrFlyoutOpenRef.current ? 'collapsed' : 'expanded') : onNavItemClick();
        onClick?.();
    }, [
        onExpandFlyoutToggle,
        onNavItemClick,
        onClick
    ]);
    const onContentClose = (0, $euxye.useCallback)(()=>onExpandFlyoutToggle(false), [
        onExpandFlyoutToggle
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)(ItemWrapper, {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $4U30j.FlyoutMenuItem), {
                isOpen: isExpandOrFlyoutOpen,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $02ogW.FlyoutMenuItemTrigger), {
                        ...triggerProps,
                        onClick: onTriggerClick,
                        hasDragIndicator: isItemDraggable,
                        ref: draggableRef,
                        isDragging: isDragging,
                        dropIndicator: dropIndicator,
                        visualContentRef: dropTargetRef,
                        children: labelElem ?? label
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iozCP.FlyoutMenuItemContent), {
                        onClose: onContentClose,
                        children: wrappedChildren
                    })
                ]
            }),
            maybeDragPreview
        ]
    });
});
const $41649a4412fa9f84$var$ObjectListFlyoutNavItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo(function ObjectListFlyoutNavItem({ item: item, onClick: onClick, ItemWrapper: ItemWrapper, draggableRef: draggableRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview, isItemDraggable: isItemDraggable, isDragging: isDragging, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, onNavItemClick: onNavItemClick, onSubMenuItemClick: onSubMenuItemClick, id: id }) {
    const objectListFlyoutProps = (0, $lKiuS.omitSafely)(item, 'type', 'isOpen', 'onOpenChange');
    const isOpenExternallyControlled = typeof item.isOpen === 'boolean';
    // We only want to control the flyout if it is already open, or when we are doing a drag operation.
    // In other cases, we should return undefined to signal that the OLF is not controlled.
    const isControlledFlyout = isOpenExternallyControlled ? item.isOpen : isExpandOrFlyoutOpen || isDragging ? isExpandOrFlyoutOpen : undefined;
    const isExpandOrFlyoutOpenRef = (0, $euxye.useRef)(isExpandOrFlyoutOpen);
    isExpandOrFlyoutOpenRef.current = isExpandOrFlyoutOpen;
    // Stable click handler for the object-list flyout trigger. Toggles the flyout
    // first (matching the original order), then per-item onClick + analytics.
    const flyoutOnClickRef = (0, $euxye.useRef)(objectListFlyoutProps.onClick);
    flyoutOnClickRef.current = objectListFlyoutProps.onClick;
    const onObjectListFlyoutClick = (0, $euxye.useCallback)((...args)=>{
        onExpandFlyoutToggle(!isExpandOrFlyoutOpenRef.current);
        flyoutOnClickRef.current?.(...args);
        (0, $egspI.fg)('navx-global-side-nav-confluence') ? onNavItemClick(false, isExpandOrFlyoutOpenRef.current ? 'collapsed' : 'expanded') : onNavItemClick();
        onClick?.();
    }, [
        onExpandFlyoutToggle,
        onNavItemClick,
        onClick
    ]);
    const subMenuItemOnClickRef = (0, $euxye.useRef)(objectListFlyoutProps.onSubMenuItemClick);
    subMenuItemOnClickRef.current = objectListFlyoutProps.onSubMenuItemClick;
    const onObjectListSubMenuItemClick = (0, $euxye.useCallback)((event, extendedSubItemAnalyticsAttributes)=>{
        subMenuItemOnClickRef.current?.(event, extendedSubItemAnalyticsAttributes);
        onSubMenuItemClick(false, extendedSubItemAnalyticsAttributes);
    }, [
        onSubMenuItemClick
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)(ItemWrapper, {
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8mxlT.ElementEventListenerProvider), {
            handler: onSubMenuItemClick,
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $edY9W.ObjectListFlyout), {
                    ...objectListFlyoutProps,
                    itemMenuId: id,
                    onClick: onObjectListFlyoutClick,
                    onSubMenuItemClick: onObjectListSubMenuItemClick,
                    isFlyoutOpen: isControlledFlyout,
                    onOpenChange: onExpandFlyoutToggle,
                    hasDragIndicator: isItemDraggable,
                    triggerRef: draggableRef,
                    isDragging: isDragging,
                    dropIndicator: dropIndicator,
                    visualContentRef: dropTargetRef
                }),
                maybeDragPreview
            ]
        })
    });
});
// This cannot be a React function-component, otherwise the Link/Button/Expand.actionsOnHover prop will can never be undefined.
// When there are no actionsOnHover and the item is not draggable, actionsOnHover MUST return undefined, to avoid the
// elemAfter from being hidden unintentionally.
function $41649a4412fa9f84$var$getActionsOnHover({ item: item }) {
    return item.actionsOnHover ?? null;
}

});
parcelRegister("1Io8b", function(module, exports) {
$parcel$export(module.exports, "ButtonMenuItem", () => $49c119fb6dbeb4fd$export$6dc09b7c0ec1dfcd);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $9xUz7 = parcelRequire("9xUz7");

var $ar9gx = parcelRequire("ar9gx");
const $49c119fb6dbeb4fd$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $euxye.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ar9gx.MenuListItem), {
        ref: listItemRef,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9xUz7.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            /**
					 * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
					 * so they aren't rendered in the disabled state.
					 */ actions: isDisabled ? undefined : actions,
            actionsOnHover: isDisabled ? undefined : actionsOnHover,
            onClick: onClick,
            ariaControls: ariaControls,
            ariaExpanded: ariaExpanded,
            ariaHasPopup: ariaHasPopup,
            isSelected: isSelected,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});

});
parcelRegister("9xUz7", function(module, exports) {
$parcel$export(module.exports, "MenuItemBase", () => $231c8d9c8e4e9ac3$export$859b390bf71e044e);
/* menu-item.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $9S1b6 = parcelRequire("9S1b6");

var $hAt2p = parcelRequire("hAt2p");

var $lpQqY = parcelRequire("lpQqY");

var $ljVHR = parcelRequire("ljVHR");

var $egspI = parcelRequire("egspI");

var $9MWap = parcelRequire("9MWap");
var $6mEZn = parcelRequire("6mEZn");
var $8Sdzy = parcelRequire("8Sdzy");

var $hZDXn = parcelRequire("hZDXn");


var $lU97D = parcelRequire("lU97D");

var $3D7ce = parcelRequire("3D7ce");

var $hvEIh = parcelRequire("hvEIh");

var $hgiKI = parcelRequire("hgiKI");
function $231c8d9c8e4e9ac3$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $231c8d9c8e4e9ac3$var$defaultAvatarValues = {
    size: 'small'
};
// Stable reference for the anchor's text-decoration reset. Hoisted to module
// scope so it is not re-created on every render of every menu item — the
// inline literal `{ textDecoration: 'none' }` had identical content but a new
// identity each render, forcing the host element's `style` to reconcile
// unnecessarily. Gated behind `navx-4728-jira-stability-fixes`.
const $231c8d9c8e4e9ac3$var$anchorTextDecorationResetStyle = {
    textDecoration: 'none'
};
const $231c8d9c8e4e9ac3$var$elemAfterDisplayVar = '--elem-after-display';
const $231c8d9c8e4e9ac3$var$actionsOnHoverOpacityVar = '--actions-on-hover-opacity';
const $231c8d9c8e4e9ac3$var$actionsOnHoverWidthVar = '--actions-on-hover-width';
const $231c8d9c8e4e9ac3$var$actionsOnHoverPaddingInlineEndVar = '--actions-on-hover-padding';
const $231c8d9c8e4e9ac3$var$notchColorVar = '--notch-color';
// Note: this is also used in `drag-handle.tsx`
const $231c8d9c8e4e9ac3$var$dragHandleDisplayVar = '--drag-handle-display';
const $231c8d9c8e4e9ac3$var$dragCursorAnimation = null;
/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. drop indicators for drag and drop
 * 3. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */ const $231c8d9c8e4e9ac3$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
};
/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */ const $231c8d9c8e4e9ac3$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
};
const $231c8d9c8e4e9ac3$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup])';
const $231c8d9c8e4e9ac3$var$containerStyles = {
    root: "_2rko12b0 _vchhusvi _1e0c11p5 _yv0e7dup _2z05hkll _1lmcu4vt _1ul9t9kd _4t3iviql _4cvr1h6o _uiztglyw _syazazsu _1yyu3acm _91ju1txw _uomdidpf _pmxpidpf _db80idpf _irr319i6 _t7p8kb7n _g4kikb7n _91nl1wug _ynyi1wug _iy5o1b66 _v4o21b66",
    rootT26Shape: "_2rko1qi0",
    removeElemAfter: "_91juglyw",
    showHoverActions: "_uomdkb7n _pmxp1wug _db801b66",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1mfcglyw _1sjuglyw",
    selected: "_bfhk15s3 _syaz6x5g _1yyujmqp _30l36x5g _irr3ufnl",
    disabled: "_syaz1gmx _bfhkn7od _irr3n7od _30l31gmx",
    hasDescription: "_4t3i1wto",
    dragging: "_tzy41ou4"
};
const $231c8d9c8e4e9ac3$var$nestedOpenPopupStyles = {
    root: "_1783kb7n _1d171wug _ligh1b66 _1fpr19i6",
    removeElemAfterOnHoverOrOpenNestedPopup: "_n3ixglyw",
    selected: "_1fprufnl"
};
const $231c8d9c8e4e9ac3$var$buttonOrAnchorStyles = {
    root: "_2rko12b0 _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _2z05nbh3 _y4ti1b66 _bozg1b66 _1q511b66 _85i51b66 _bfhk18uv _syazazsu _4cvr1h6o _y3gnv2br _14iu13ro",
    rootT26Shape: "_2rko1qi0",
    selected: "_syaz6x5g _14iunozp",
    hasDragIndicator: "_1ifmglyw _1cykglyw _x0kw1txw _11om6b4r _7psyru3m _1uy01amc _bir2q7pw"
};
const $231c8d9c8e4e9ac3$var$extendButtonOrAnchorStyles = {
    root: "_1r04ze3t _kqswstnw"
};
const $231c8d9c8e4e9ac3$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
const $231c8d9c8e4e9ac3$var$actionStyles = {
    root: "_zulp1b66 _nd5lbc26 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $231c8d9c8e4e9ac3$var$actionsOnHoverStyles = {
    root: "_nd5l16dh _zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _tzy4pnc3 _1bsbty16 _y4tidria _1guo18uv _12s918uv"
};
const $231c8d9c8e4e9ac3$var$textStyles = {
    root: "_zulpv77o _1reo15vq _18m915vq _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
    noElemBeforeIndent: "_bozg12x7"
};
const $231c8d9c8e4e9ac3$var$elemBeforeStyles = {
    root: "_nd5l17zh _1reo15vq _18m915vq _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh18uv _1guo18uv _12s918uv"
};
const $231c8d9c8e4e9ac3$var$elemAfterStyles = {
    root: "_nd5l16dh _1reo15vq _18m915vq _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
/**
 * We are using a wrapping element for our interactive content
 * even though only the `Text` element is the only thing not using `position:absolute`
 *
 * Rationale:
 * - Super clear that everything inside the interactive content should be in a specific slot in the grid
 * - To work around a browser bug in Safari where it does not work well with `position:absolute`
 *   on a subgrid child.
 *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
 */ const $231c8d9c8e4e9ac3$var$interactiveContentStyles = {
    root: "_nd5l19l3 _1e0c1txw _2lx21bp4 _ae4v1h6o"
};
function $231c8d9c8e4e9ac3$var$getTextColor({ isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'color.text.disabled';
    if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
}
/**
 * This is the internal version of the component, to be passed into `forwardRef`.
 *
 * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
 * This can be inferred from the type of the `onClick` prop.
 */ const $231c8d9c8e4e9ac3$var$MenuItemBaseNoRef = ({ id: id, testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const level = (0, $3D7ce.useLevel)();
    const setFlyoutMenuOpen = (0, $hvEIh.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $hvEIh.useFlyoutMenuOpen)();
    const isLink = typeof href !== 'undefined';
    const labelRef = (0, $euxye.useRef)(null);
    const descriptionRef = (0, $euxye.useRef)(null);
    const tooltipOnClick = (0, $euxye.useRef)(null);
    const handleClick = (0, $euxye.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
        tooltipOnClick.current?.(event);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]);
    /**
   * Show the tooltip if _either_ label or description is truncated
   */ const canTooltipAppear = (0, $euxye.useCallback)(()=>{
        if (isContentTooltipDisabled) return false;
        // Show tooltip if _either_ label or description are clamped
        const label = labelRef.current;
        const description = descriptionRef.current;
        if (label && $231c8d9c8e4e9ac3$var$isTextClamped(label)) return true;
        return Boolean(description && $231c8d9c8e4e9ac3$var$isTextClamped(description));
    }, [
        isContentTooltipDisabled
    ]);
    // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $hgiKI.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        className: (0, $4jQY2.default)([
            $231c8d9c8e4e9ac3$var$interactiveContentStyles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                // This extends the clickable area of nested menu items to the width
                // of the root level menu items, while being visually indented.
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                style: {
                    insetInlineStart: `calc(-1 * ${level} * ${(0, $cdea47e3a9c40e55$export$d492445a79a49b48)})`
                },
                "aria-hidden": "true",
                className: (0, $4jQY2.default)([
                    $231c8d9c8e4e9ac3$var$extendButtonOrAnchorStyles.root
                ])
            }),
            /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
                className: (0, $4jQY2.default)([
                    $231c8d9c8e4e9ac3$var$textStyles.root,
                    !showElemBefore && $231c8d9c8e4e9ac3$var$textStyles.noElemBeforeIndent
                ]),
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                        weight: "medium",
                        maxLines: 1,
                        color: $231c8d9c8e4e9ac3$var$getTextColor({
                            isDisabled: isDisabled,
                            isSelected: isSelected
                        }),
                        ref: labelRef,
                        children: children
                    }),
                    description && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                        color: $231c8d9c8e4e9ac3$var$getTextColor({
                            isDisabled: isDisabled,
                            isSelected: isSelected
                        }),
                        size: "small",
                        maxLines: 1,
                        ref: descriptionRef,
                        children: description
                    })
                ]
            }),
            hasDragIndicator ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lU97D.DragHandle), {}) : null,
            dropIndicator
        ]
    });
    /**
   *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
   *
   * Note: we also remove the `elemAfter` when showing `actionsOnHover`
   */ const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hAt2p.AvatarContext).Provider, {
        value: $231c8d9c8e4e9ac3$var$defaultAvatarValues,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
            ref: visualContentRef,
            "data-testid": testId ? `${testId}-container` : undefined,
            "data-selected": isSelected,
            className: (0, $4jQY2.default)([
                $231c8d9c8e4e9ac3$var$containerStyles.root,
                $231c8d9c8e4e9ac3$var$nestedOpenPopupStyles.root,
                (0, $egspI.fg)('platform-dst-shape-theme-default') && $231c8d9c8e4e9ac3$var$containerStyles.rootT26Shape,
                isSelected && $231c8d9c8e4e9ac3$var$containerStyles.selected,
                isSelected && $231c8d9c8e4e9ac3$var$nestedOpenPopupStyles.selected,
                isDragging && $231c8d9c8e4e9ac3$var$containerStyles.dragging,
                description && $231c8d9c8e4e9ac3$var$containerStyles.hasDescription,
                showHoverActionsWhenNotHovered && $231c8d9c8e4e9ac3$var$containerStyles.showHoverActions,
                showHoverActionsWhenNotHovered && elemAfter && $231c8d9c8e4e9ac3$var$containerStyles.removeElemAfter,
                actionsOnHover && elemAfter && $231c8d9c8e4e9ac3$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
                actionsOnHover && elemAfter && $231c8d9c8e4e9ac3$var$nestedOpenPopupStyles.removeElemAfterOnHoverOrOpenNestedPopup,
                isDisabled && $231c8d9c8e4e9ac3$var$containerStyles.disabled
            ]),
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
                    content: ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                                    children: children
                                }),
                                description ? /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                                    children: description
                                }) : null
                            ]
                        }),
                    position: "right-start",
                    ignoreTooltipPointerEvents: true,
                    hideTooltipOnMouseDown: true,
                    // We don't need a duplicate hidden element containing tooltip content
                    // as the content of the tooltip matches what is rendered for the menu item.
                    isScreenReaderAnnouncementDisabled: true,
                    canAppear: canTooltipAppear,
                    children: (tooltipProps)=>{
                        // Putting the tooltip onClick into a ref.
                        // This way we don't need to create a new `onClick` function on each
                        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
                        tooltipOnClick.current = tooltipProps.onClick;
                        const sharedProps = {
                            ...tooltipProps,
                            'aria-controls': ariaControls,
                            'aria-haspopup': ariaHasPopup,
                            ref: (0, $ljVHR.default)([
                                forwardedRef,
                                tooltipProps.ref
                            ]),
                            id: id,
                            testId: testId,
                            interactionName: interactionName
                        };
                        return isLink ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $9MWap.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $9S1b6.cx)($231c8d9c8e4e9ac3$var$buttonOrAnchorStyles.root, (0, $egspI.fg)('platform-dst-shape-theme-default') && $231c8d9c8e4e9ac3$var$buttonOrAnchorStyles.rootT26Shape, $231c8d9c8e4e9ac3$var$topLevelSiblingStyles.root, isSelected && $231c8d9c8e4e9ac3$var$buttonOrAnchorStyles.selected, hasDragIndicator && $231c8d9c8e4e9ac3$var$buttonOrAnchorStyles.hasDragIndicator),
                            // Needed to override Anchor style due to a compiled/emotion conflict
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            style: (0, $egspI.fg)('navx-4728-jira-stability-fixes') ? $231c8d9c8e4e9ac3$var$anchorTextDecorationResetStyle : {
                                textDecoration: 'none'
                            },
                            "aria-current": isSelected ? 'page' : undefined,
                            href: href,
                            target: target,
                            /**
           * For anchors we don't want to have the standard drag and drop behaviour.
           *
           * Thinking on the topic:
           *
           * - Anchors look visually similar to buttons in the sidenav
           * - Why should some menu items be natively draggable, while others are not?
           * - A user cannot know which menu items are "natively" draggable (ie anchors)
           * - If you wire up an anchor to be draggable using our standard affordances
           *   it will have a different preview experience to native anchor dragging.
           *
           * To promote consistency, all elements need to use the same visual affordances.
           *
           * Anchor elements will automatically attach URL information
           * to the native data store.
           *
           * When `hasDragIndicator` is `true` we are expecting consumers to register
           * the element as draggable through the `draggable()` Pragmatic drag and drop function.
           * The `draggable()` function will add `draggable="true"` to the element.
           */ draggable: hasDragIndicator ? undefined : false,
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: (0, $4jQY2.default)([
                                        $231c8d9c8e4e9ac3$var$notchStyles.root
                                    ])
                                }),
                                interactiveElemContent
                            ]
                        }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $9S1b6.cx)($231c8d9c8e4e9ac3$var$buttonOrAnchorStyles.root, (0, $egspI.fg)('platform-dst-shape-theme-default') && $231c8d9c8e4e9ac3$var$buttonOrAnchorStyles.rootT26Shape, $231c8d9c8e4e9ac3$var$topLevelSiblingStyles.root, isSelected && $231c8d9c8e4e9ac3$var$buttonOrAnchorStyles.selected, hasDragIndicator && $231c8d9c8e4e9ac3$var$buttonOrAnchorStyles.hasDragIndicator),
                            "aria-expanded": ariaExpanded,
                            isDisabled: isDisabled,
                            children: interactiveElemContent
                        });
                    }
                }),
                showElemBefore && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $231c8d9c8e4e9ac3$var$elemBeforeStyles.root,
                        $231c8d9c8e4e9ac3$var$topLevelSiblingStyles.root,
                        $231c8d9c8e4e9ac3$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemBefore
                }),
                actionsOnHover && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $231c8d9c8e4e9ac3$var$actionsOnHoverStyles.root
                    ]),
                    children: actionsOnHover
                }),
                elemAfter && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $231c8d9c8e4e9ac3$var$elemAfterStyles.root,
                        $231c8d9c8e4e9ac3$var$topLevelSiblingStyles.root,
                        $231c8d9c8e4e9ac3$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemAfter
                }),
                actions && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $231c8d9c8e4e9ac3$var$actionStyles.root,
                        $231c8d9c8e4e9ac3$var$topLevelSiblingStyles.root,
                        $231c8d9c8e4e9ac3$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: actions
                })
            ]
        })
    });
};
$231c8d9c8e4e9ac3$var$MenuItemBaseNoRef.displayName = "MenuItemBaseNoRef";
const $231c8d9c8e4e9ac3$export$859b390bf71e044e = (0, $lpQqY.default)($231c8d9c8e4e9ac3$var$MenuItemBaseNoRef);

});
/**
 * _Internally_ shared value for the menu item indentation. Used in:
 * - Expandable menu item content, to add padding for each expandable level
 * - The base menu item, to set the negative inset to extend the clickable area of nested menu items
 * to the root level menu items.
 *
 * Internal to the package only. Should not be exported from the package.
 *
 * Note: We're unable to use a token() call here, as Compiled complains about function calls in imported
 * values - it requires statically defined values only.
 *
 * @private
 * @internal
 */ const $cdea47e3a9c40e55$export$d492445a79a49b48 = '12px';

parcelRegister("lU97D", function(module, exports) {
$parcel$export(module.exports, "DragHandle", () => $162eae16044add6e$export$a0c24614540b0efb);
/* drag-handle.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $arEoN = parcelRequire("arEoN");
const $162eae16044add6e$var$styles = {
    root: "_syazazsu _1e0c1i3c _2lx21bp4 _1bah1h6o _kqswstnw _152tidpf _u7coidpf _1e02idpf _ahbqxmi2"
};
function $162eae16044add6e$export$a0c24614540b0efb() {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "aria-hidden": "true",
        className: (0, $4jQY2.default)([
            $162eae16044add6e$var$styles.root
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($arEoN))), {
            label: "",
            size: "small"
        })
    });
}
$162eae16044add6e$export$a0c24614540b0efb.displayName = "DragHandle";

});

parcelRegister("hvEIh", function(module, exports) {
$parcel$export(module.exports, "IsOpenContext", () => $538d364b384460f0$export$efa4d9670e96ac31);
$parcel$export(module.exports, "SetIsOpenContext", () => $538d364b384460f0$export$4c55b1c61a116b42);
$parcel$export(module.exports, "useFlyoutMenuOpen", () => $538d364b384460f0$export$6927118f874a49aa);
$parcel$export(module.exports, "useSetFlyoutMenuOpen", () => $538d364b384460f0$export$538ac1aa421adb94);
$parcel$export(module.exports, "OnCloseContext", () => $538d364b384460f0$export$7376ab1fc7707bdd);
$parcel$export(module.exports, "useTitleId", () => $538d364b384460f0$export$761b237ca835a288);
$parcel$export(module.exports, "TitleIdContextProvider", () => $538d364b384460f0$export$9abe8108f4bc916);

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");
const $538d364b384460f0$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $euxye.createContext)(false);
const $538d364b384460f0$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $euxye.createContext)((0, $2oRWW.default));
const $538d364b384460f0$export$6927118f874a49aa = ()=>(0, $euxye.useContext)($538d364b384460f0$export$efa4d9670e96ac31);
const $538d364b384460f0$export$538ac1aa421adb94 = ()=>(0, $euxye.useContext)($538d364b384460f0$export$4c55b1c61a116b42);
const $538d364b384460f0$export$7376ab1fc7707bdd = /*#__PURE__*/ (0, $euxye.createContext)({
    current: null
});
const $538d364b384460f0$export$fb4c7299c436068c = /*#__PURE__*/ (0, $euxye.createContext)(undefined);
const $538d364b384460f0$export$761b237ca835a288 = ()=>(0, $euxye.useContext)($538d364b384460f0$export$fb4c7299c436068c);
const $538d364b384460f0$export$9abe8108f4bc916 = $538d364b384460f0$export$fb4c7299c436068c.Provider;

});

parcelRegister("hgiKI", function(module, exports) {
$parcel$export(module.exports, "COLLAPSE_ELEM_BEFORE", () => $a16e8e22309aa2cc$export$f4b8e24fae579c6f);
/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */ const $a16e8e22309aa2cc$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');

});


parcelRegister("ar9gx", function(module, exports) {
$parcel$export(module.exports, "MenuListItem", () => $682693d14a2acaef$export$6c2f3257abc4825b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $ke6yx = parcelRequire("ke6yx");
const $682693d14a2acaef$export$6c2f3257abc4825b = (0, $ke6yx.ListItem);

});
parcelRegister("ke6yx", function(module, exports) {
$parcel$export(module.exports, "ListItem", () => $a63bcb89680d5e76$export$a7b06bfba60a8a78);
/* list-item.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
function $a63bcb89680d5e76$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId,
        children: children
    });
}
const $a63bcb89680d5e76$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $euxye.forwardRef)($a63bcb89680d5e76$var$_ListItem);

});



parcelRegister("hQxjT", function(module, exports) {
$parcel$export(module.exports, "ExpandableMenuItem", () => $c8e57c917d952bc8$export$341dea48c30b36ff);
/* expandable-menu-item.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $540vN = parcelRequire("540vN");

var $ar9gx = parcelRequire("ar9gx");

var $3D7ce = parcelRequire("3D7ce");
const $c8e57c917d952bc8$var$relativeStyles = {
    root: "_kqswh2mm"
};
const $c8e57c917d952bc8$export$341dea48c30b36ff = /*#__PURE__*/ (0, $euxye.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $540vN.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3D7ce.IsExpandedContext).Provider, {
        value: isExpanded,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3D7ce.SetIsExpandedContext).Provider, {
            value: setIsExpanded,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3D7ce.OnExpansionToggleContext).Provider, {
                value: onExpansionToggle ?? null,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ar9gx.MenuListItem), {
                    ref: forwardedRef,
                    testId: testId,
                    children: /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
                        className: (0, $4jQY2.default)([
                            dropIndicator && $c8e57c917d952bc8$var$relativeStyles.root
                        ]),
                        children: [
                            children,
                            dropIndicator
                        ]
                    })
                })
            })
        })
    });
});

});

parcelRegister("klGx5", function(module, exports) {
$parcel$export(module.exports, "ExpandableMenuItemContent", () => $7999353a4e108caf$export$bd680a81504a92e9);
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $9S1b6 = parcelRequire("9S1b6");

var $7qBrM = parcelRequire("7qBrM");

var $3D7ce = parcelRequire("3D7ce");
const $7999353a4e108caf$var$styles = {
    content: "_bozg1crf",
    collapsedContent: "_1e0cglyw"
};
const $7999353a4e108caf$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $3D7ce.useIsExpanded)();
    const level = (0, $3D7ce.useLevel)();
    const hasExpanded = (0, $euxye.useRef)(false);
    const areAllAncestorsExpanded = (0, $3D7ce.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3D7ce.LevelContext).Provider, {
        value: level + 1,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3D7ce.AreAllAncestorsExpandedContext).Provider, {
            value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7qBrM.List), {
                ref: forwardedRef,
                xcss: (0, $9S1b6.cx)($7999353a4e108caf$var$styles.content, !isExpanded && $7999353a4e108caf$var$styles.collapsedContent),
                children: children
            })
        })
    });
});

});

parcelRegister("ldfa4", function(module, exports) {
$parcel$export(module.exports, "ExpandableMenuItemTrigger", () => $06a6808f14049752$export$fe6fe51056867f4d);
/* expandable-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $lpQqY = parcelRequire("lpQqY");

var $ld25x = parcelRequire("ld25x");

var $dUPUc = parcelRequire("dUPUc");

var $9xUz7 = parcelRequire("9xUz7");

var $gU68A = parcelRequire("gU68A");

var $3D7ce = parcelRequire("3D7ce");
// Widening type to `string` to side-step Compiled cssMap typescript warnings with unknown properties
const $06a6808f14049752$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $06a6808f14049752$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $06a6808f14049752$var$wrapperStyles = {
    root: "_1mmi1txw _165nglyw",
    showProvidedElemBefore: "_1mmiglyw _165n1bgi _1ddp1txw _pnu5glyw _b31z1txw _1vnl1txw _12xsglyw _p8btglyw"
};
// Merge back into the `wrapperStyles` after cleanup
const $06a6808f14049752$var$nestedOpenPopupStyles = {
    showProvidedElemBefore: "_1ddp1txw _pnu5glyw"
};
const $06a6808f14049752$var$iconStyles = {
    chevron: "_1e0ciw0t _1tz3r0mg",
    providedElemBefore: "_1e0c1xb2",
    providedElemBeforeSelected: "_syazxl6c"
};
const $06a6808f14049752$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($ld25x))) : (0, (/*@__PURE__*/$parcel$interopDefault($dUPUc)));
    const chevronElem = /*#__PURE__*/ (0, $e79Pd.jsx)(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    $06a6808f14049752$var$iconStyles.chevron
                ]),
                children: chevronElem
            }),
            providedElemBefore && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    $06a6808f14049752$var$iconStyles.providedElemBefore,
                    isSelected && $06a6808f14049752$var$iconStyles.providedElemBeforeSelected
                ]),
                children: providedElemBefore
            })
        ]
    });
};
$06a6808f14049752$var$ExpandableMenuItemIcon.displayName = "ExpandableMenuItemIcon";
const $06a6808f14049752$export$fe6fe51056867f4d = (0, $lpQqY.default)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const id = (0, $euxye.useId)();
    const onExpansionToggle = (0, $3D7ce.useOnExpansionToggle)();
    const isExpanded = (0, $3D7ce.useIsExpanded)();
    const setIsExpanded = (0, $3D7ce.useSetIsExpanded)();
    const itemRef = (0, $euxye.useRef)(null);
    const handleIconClick = (0, $euxye.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $euxye.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $gU68A.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    });
    // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)($06a6808f14049752$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // We are labelling the icon button using the containing menu item's content, to provide context to
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": id,
        // IconButton requires a label prop, however it will not be used by screen readers as we are setting
        // `aria-labelledby`, which will be used instead.
        label: "",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)($06a6808f14049752$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    });
    // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: itemRef,
        className: (0, $4jQY2.default)([
            $06a6808f14049752$var$wrapperStyles.root,
            providedElemBefore && $06a6808f14049752$var$wrapperStyles.showProvidedElemBefore,
            $06a6808f14049752$var$nestedOpenPopupStyles.showProvidedElemBefore
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9xUz7.MenuItemBase), {
            id: id,
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: elemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            testId: testId,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});

});
parcelRegister("gU68A", function(module, exports) {
$parcel$export(module.exports, "useScrollMenuItemIntoView", () => $5d8f7d30e5d70b78$export$2c52ec851fcc6058);

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");

var $3D7ce = parcelRequire("3D7ce");
function $5d8f7d30e5d70b78$var$scrollMenuItemIntoView(element) {
    /**
	 * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
	 * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
	 * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
	 *
	 * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
	 */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $5d8f7d30e5d70b78$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $3D7ce.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $euxye.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $euxye.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $jiTLE.default)(element, 'Element ref must be set');
            $5d8f7d30e5d70b78$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}

});


parcelRegister("4U30j", function(module, exports) {
$parcel$export(module.exports, "FlyoutMenuItem", () => $ad5d6a5c9c8fbe85$export$34e3b4eaa687835);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $540vN = parcelRequire("540vN");

var $gQ56h = parcelRequire("gQ56h");

var $2WNTY = parcelRequire("2WNTY");

var $ar9gx = parcelRequire("ar9gx");

var $hvEIh = parcelRequire("hvEIh");
const $ad5d6a5c9c8fbe85$export$34e3b4eaa687835 = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, id: id, isOpen: isOpenControlled, isDefaultOpen: isDefaultOpen = false, onOpenChange: onOpenChange }, forwardedRef)=>{
    const [isOpen, setIsOpen] = (0, $540vN.default)(isOpenControlled, ()=>isDefaultOpen);
    const titleId = (0, $euxye.useId)();
    const previousIsOpen = (0, $gQ56h.default)(isOpen);
    const onCloseRef = (0, $euxye.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    (0, $euxye.useEffect)(()=>{
        if (previousIsOpen === undefined || previousIsOpen === isOpen) /**
				 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
				 *
				 * The previous value can be equal to the current one if the component re-renders due to something else changing.
				 *
				 * In both cases the value hasn't changed and we don't want to notify consumers.
				 */ return;
        // When flyout menu is opened, fire analytics event
        if (isOpen && previousIsOpen === false) {
            const navigationAnalyticsEvent = createAnalyticsEvent({
                source: 'sideNav',
                actionSubject: 'flyoutMenu',
                action: 'opened'
            });
            navigationAnalyticsEvent.fire('navigation');
        }
        onOpenChange?.(isOpen);
    }, [
        isOpen,
        onOpenChange,
        previousIsOpen,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hvEIh.IsOpenContext).Provider, {
        value: isOpen,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hvEIh.SetIsOpenContext).Provider, {
            value: setIsOpen,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hvEIh.OnCloseContext).Provider, {
                value: onCloseRef,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hvEIh.TitleIdContextProvider), {
                    value: titleId,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ar9gx.MenuListItem), {
                        ref: forwardedRef,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2WNTY.Popup), {
                            id: id,
                            isOpen: isOpen,
                            role: "dialog",
                            children: children
                        })
                    })
                })
            })
        })
    });
});

});

parcelRegister("iozCP", function(module, exports) {
$parcel$export(module.exports, "FlyoutMenuItemContent", () => $5fce1a1d21291de2$export$2ca9a13c57a8839a);
/* flyout-menu-item-content.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $inMxE = parcelRequire("inMxE");

var $ljVHR = parcelRequire("ljVHR");

var $egspI = parcelRequire("egspI");

var $gRy4I = parcelRequire("gRy4I");

var $hvEIh = parcelRequire("hvEIh");
/**
 * The vertical offset in px to ensure the flyout container does not exceed the bounds of
 * the window. This matches the padding of the content container, and it's position within
 * the viewport.
 *
 * - FlyoutMenuItemContent: paddingBlock: token('space.100'); – 8px top, 8px bottom
 * - Position: 5px top, 5px bottom
 *
 * Total vertical padding:
 * 		(8px [content top] + 8px [content bottom]) +
 * 		(5px [position top] + 5px [position bottom]) = 26px
 */ const $5fce1a1d21291de2$var$FLYOUT_MENU_VERTICAL_OFFSET_PX = 26;
/**
 * The maximum height of the flyout menu in pixels, following the Confluence standard maximum
 * height of 760px.
 */ const $5fce1a1d21291de2$var$FLYOUT_MENU_MAX_HEIGHT_PX = 760;
const $5fce1a1d21291de2$var$FLYOUT_MENU_PADDING = "var(--ds-space-100, 8px)";
/**
 * The margin around the flyout menu popup when it has its modal appearance on mobile screen sizes.
 */ const $5fce1a1d21291de2$var$FLYOUT_MENU_MODAL_MARGIN = 4;
const $5fce1a1d21291de2$var$maxHeightCssVar = '--max-height';
const $5fce1a1d21291de2$var$flyoutMenuItemContentStyles = {
    root: "_1q51u2gc _85i5u2gc _bozgu2gc _y4tiu2gc _14b51kdj"
};
const $5fce1a1d21291de2$var$flyoutMenuItemContentContainerStyles = {
    container: "_1e0c1txw _4t3i1osq _2lx21bp4 _c71lq9dn _1jop304o"
};
const $5fce1a1d21291de2$export$2ca9a13c57a8839a = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, containerTestId: containerTestId, onClose: onClose, autoFocus: autoFocus, maxHeight: maxHeight = $5fce1a1d21291de2$var$FLYOUT_MENU_MAX_HEIGHT_PX }, forwardedRef)=>{
    const setIsOpen = (0, $euxye.useContext)((0, $hvEIh.SetIsOpenContext));
    const onCloseRef = (0, $euxye.useContext)((0, $hvEIh.OnCloseContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    // The source of the close is not accessible to the consumer, it is determined within the
    // handleClose function, or passed in as a parameter in FlyoutMenuItemTrigger (outside-click),
    // or FlyoutHeader (close-button).
    const handleClose = (0, $euxye.useCallback)((event, source)=>{
        // Use the passed source if provided, otherwise determine from event
        let determinedSource = source || 'other';
        if (!source) {
            if (event instanceof KeyboardEvent) {
                const keyboardEvent = event;
                if (keyboardEvent.key === 'Escape' || keyboardEvent.key === 'Esc') determinedSource = 'escape-key';
            } else if (event instanceof MouseEvent) {
                if (event && 'type' in event && event.type === 'click') determinedSource = 'outside-click';
            }
        }
        // When flyout menu is closed, fire analytics event
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'sideNav',
            actionSubject: 'flyoutMenu',
            action: 'closed',
            attributes: {
                closeSource: determinedSource
            }
        });
        navigationAnalyticsEvent.fire('navigation');
        onClose?.();
        setIsOpen(false);
    }, [
        setIsOpen,
        onClose,
        createAnalyticsEvent
    ]);
    // Register handleClose in the ref to allow the FlyoutMenuItemTrigger to access it
    (0, $euxye.useEffect)(()=>{
        onCloseRef.current = handleClose;
    }, [
        handleClose,
        onCloseRef
    ]);
    const titleId = (0, $hvEIh.useTitleId)();
    const computedMaxHeight = (0, $euxye.useMemo)(()=>/**
   * The max height of the flyout menu needs to factor in the top nav and banner, as it will be layered
   * beneath them and would otherwise be clipped.
   *
   * We can remove these navigation variables once layering has been addressed holistically (e.g. using Top Layer).
   *
   * Not using the UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY variable from `@atlaskit/navigation-system`
   * to avoid a circular dependency, as that package imports this one for re-exporting components.
   */ `min(calc(100vh - ${$5fce1a1d21291de2$var$FLYOUT_MENU_VERTICAL_OFFSET_PX}px - var(--n_tNvM, 0px) - var(--n_bnrM, 0px)), ${maxHeight}px)`, [
        maxHeight
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gRy4I.PopupContent), {
        appearance: "UNSAFE_modal-below-sm",
        onClose: handleClose,
        placement: "right-start",
        // Using a capture event listener so that we are more resilient against
        // code that stops events. We _really_ want to close the flyout whenever
        // user user clicks outside the flyout content
        shouldUseCaptureOnOutsideClick: true,
        shouldFitViewport: true,
        testId: containerTestId,
        xcss: $5fce1a1d21291de2$var$flyoutMenuItemContentStyles.root,
        autoFocus: autoFocus,
        role: "dialog",
        titleId: (0, $egspI.fg)('navx-5180-flyout-dialog-aria-label') ? titleId : undefined,
        /**
   * Disabling GPU acceleration removes the use of `transform` by popper.js for this popup.
   *
   * This allows makers to use popups with `shouldRenderToParent` inside the flyout.
   *
   * Without this, the `transform` makes the flyout the containing element for fixed positioning.
   * Because the flyout is also a scroll container then any nested, layered element is unable to
   * escape the flyout.
   *
   * Disabling the `transform` is the simplest way to resolve this layering issue,
   * and should have negligible performance impacts, because the flyout menus should rarely
   * need to be repositioned.
   */ shouldDisableGpuAcceleration: true,
        shouldRenderToParent: true,
        children: ({ update: update })=>/*#__PURE__*/ (0, $e79Pd.jsx)($5fce1a1d21291de2$var$UpdatePopperOnContentResize, {
                ref: forwardedRef,
                update: update,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hvEIh.TitleIdContextProvider), {
                    value: titleId,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        style: {
                            [$5fce1a1d21291de2$var$maxHeightCssVar]: computedMaxHeight
                        },
                        "data-testid": containerTestId ? `${containerTestId}--container` : undefined,
                        className: (0, $4jQY2.default)([
                            $5fce1a1d21291de2$var$flyoutMenuItemContentContainerStyles.container
                        ]),
                        children: children
                    })
                })
            })
    });
});
function $5fce1a1d21291de2$var$createResizeObserver(update) {
    return new ResizeObserver(update);
}
/**
 * Will call the Popper.js `update()` method to recalculate positioning, when the flyout menu changes size.
 * This is the size of the scroll container, NOT the scroll content.
 *
 * We could potentially bake this into `@atlaskit/popup` or `@atlaskit/popper` but there are a few
 * reasons to keep it scoped to flyout menus for now:
 *
 * 1. It's easier to unwind
 * 2. We've only had bug reports for flyout menus
 * 3. Popup exposes the `update` function so consumers can already do this themselves if necessary
 * 4. Flyout menus are a lot more restricted to other popups, it might not make sense more generally
 */ const $5fce1a1d21291de2$var$UpdatePopperOnContentResize = /*#__PURE__*/ (0, $euxye.forwardRef)(({ update: update, children: children }, forwardedRef)=>{
    /**
   * Storing our `update` function in a ref so that we have a stable reference to it.
   * We need this because our `ResizeObserver` callback cannot be changed after creating it.
   */ const updateRef = (0, $euxye.useRef)(update);
    (0, $euxye.useEffect)(()=>{
        updateRef.current = update;
    }, [
        update
    ]);
    /**
   * Stable function that calls the latest `update` function by calling it through the stable ref.
   */ const triggerUpdate = (0, $euxye.useCallback)(()=>{
        updateRef.current?.();
    }, []);
    const [resizeObserver] = (0, $euxye.useState)(()=>$5fce1a1d21291de2$var$createResizeObserver(triggerUpdate));
    /**
   * This is a callback ref that will update which `HTMLElement` we are observing,
   * if or when the underlying `HTMLElement` changes or unmounts.
   */ const observeCallbackRef = (0, $euxye.useCallback)((element)=>{
        /**
     * Unobserves all observed elements.
     * Allows us to cleanup without needing to store a reference to the previous element.
     */ resizeObserver.disconnect();
        if (!element) return;
        resizeObserver.observe(element);
    }, [
        resizeObserver
    ]);
    /**
   * We need to memoize the ref otherwise `triggerUpdate` is repeatedly called.
   *
   * This stems from ResizeObserver firing once after calling `.observe()` even if there
   * was no resize.
   *
   * Without memoizing the ref, the update causes a rerender, which causes the ref to
   * get recreated, which triggers an update and so on in a loop.
   */ const ref = (0, $euxye.useMemo)(()=>{
        return (0, $ljVHR.default)([
            forwardedRef,
            observeCallbackRef
        ]);
    }, [
        forwardedRef,
        observeCallbackRef
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: ref,
        children: children
    });
});

});

parcelRegister("02ogW", function(module, exports) {
$parcel$export(module.exports, "FlyoutMenuItemTrigger", () => $cff39c927494b13d$export$9f59f399fe37b6ca);
/* flyout-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $ljVHR = parcelRequire("ljVHR");

var $dUPUc = parcelRequire("dUPUc");

var $dDFaF = parcelRequire("dDFaF");

var $9xUz7 = parcelRequire("9xUz7");

var $hvEIh = parcelRequire("hvEIh");
const $cff39c927494b13d$var$elemAfterStyles = {
    root: "_18zr12x7 _1tz3r0mg"
};
const $cff39c927494b13d$export$9f59f399fe37b6ca = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, elemBefore: elemBefore, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const isOpen = (0, $euxye.useContext)((0, $hvEIh.IsOpenContext));
    const onCloseRef = (0, $euxye.useContext)((0, $hvEIh.OnCloseContext));
    const handleClick = (0, $euxye.useCallback)((event, analyticsEvent)=>{
        if (isOpen && onCloseRef.current) onCloseRef.current(event, 'outside-click');
        onClick?.(event, analyticsEvent);
    }, [
        isOpen,
        onCloseRef,
        onClick
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dDFaF.PopupTrigger), {
        children: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $9xUz7.MenuItemBase), {
                testId: testId,
                ref: (0, $ljVHR.default)([
                    ref,
                    forwardedRef
                ]),
                visualContentRef: visualContentRef,
                elemBefore: elemBefore,
                elemAfter: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $cff39c927494b13d$var$elemAfterStyles.root
                    ]),
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dUPUc))), {
                        label: "",
                        color: "currentColor",
                        size: "small"
                    })
                }),
                onClick: handleClick,
                ariaControls: ariaControls,
                ariaExpanded: ariaExpanded,
                ariaHasPopup: ariaHasPopup,
                interactionName: interactionName,
                isContentTooltipDisabled: isContentTooltipDisabled,
                isSelected: isSelected,
                isDragging: isDragging,
                hasDragIndicator: hasDragIndicator,
                dropIndicator: dropIndicator,
                children: children
            })
    });
});

});

parcelRegister("e6rNk", function(module, exports) {
$parcel$export(module.exports, "LinkMenuItem", () => $eeeb1a8c87bcdef2$export$d2cad7a1cce7b35f);
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $lpQqY = parcelRequire("lpQqY");

var $ljVHR = parcelRequire("ljVHR");

var $ke6yx = parcelRequire("ke6yx");

var $9xUz7 = parcelRequire("9xUz7");

var $gU68A = parcelRequire("gU68A");
const $eeeb1a8c87bcdef2$var$listItemStyles = {
    root: "_10m98stt"
};
const $eeeb1a8c87bcdef2$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $euxye.useRef)(null);
    (0, $gU68A.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $euxye.useMemo)(()=>{
        return (0, $ljVHR.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ke6yx.ListItem), {
        ref: ref,
        xcss: $eeeb1a8c87bcdef2$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9xUz7.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
$eeeb1a8c87bcdef2$var$LinkMenuItemNoRef.displayName = "LinkMenuItemNoRef";
const $eeeb1a8c87bcdef2$export$d2cad7a1cce7b35f = (0, $lpQqY.default)($eeeb1a8c87bcdef2$var$LinkMenuItemNoRef);

});

parcelRegister("dsHLR", function(module, exports) {
$parcel$export(module.exports, "useL1ItemDragAndDrop", () => $32e08fa6379a45d9$export$f8cda0f87a8e0691);

var $euxye = parcelRequire("euxye");

var $9sYLJ = parcelRequire("9sYLJ");

var $7UEMQ = parcelRequire("7UEMQ");
function $32e08fa6379a45d9$export$f8cda0f87a8e0691({ item: item, id: id, isExpandable: isExpandable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, peek: peek, l1DragAndDropEnabled: l1DragAndDropEnabled, group: group }) {
    const data = (0, $euxye.useMemo)(()=>(0, $9sYLJ.createL1ItemData)({
            menuItemId: id,
            group: group,
            isHidden: false,
            isHideable: item.isHideable !== false,
            label: item.label,
            isReorderable: item.isReorderable !== false
        }), [
        group,
        id,
        item.isHideable,
        item.isReorderable,
        item.label
    ]);
    const isItemDraggable = (0, $euxye.useCallback)(()=>{
        return !!l1DragAndDropEnabled && !peek && (item.isHideable !== false || item.isReorderable !== false) && (item.type !== 'custom' || !!item.isDraggable);
    }, [
        item.isDraggable,
        item.isHideable,
        item.isReorderable,
        item.type,
        l1DragAndDropEnabled,
        peek
    ]);
    const isItemDroppable = (0, $euxye.useCallback)(()=>!!l1DragAndDropEnabled && !peek && (item.type !== 'custom' || !!item.isDraggable), [
        item.isDraggable,
        item.type,
        l1DragAndDropEnabled,
        peek
    ]);
    return (0, $7UEMQ.useItemDragAndDrop)({
        data: data,
        getItemData: (0, $9sYLJ.getL1ItemData),
        group: group,
        id: id,
        item: item,
        isDragAndDropEnabled: l1DragAndDropEnabled,
        isExpandable: isExpandable,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        isItemData: (0, $9sYLJ.isL1ItemData),
        isItemDataInGroup: (0, $9sYLJ.isL1ItemDataInGroup),
        isItemDraggable: isItemDraggable,
        isItemDroppable: isItemDroppable,
        onExpandFlyoutToggle: onExpandFlyoutToggle
    });
}

});
parcelRegister("7UEMQ", function(module, exports) {
$parcel$export(module.exports, "useItemDragAndDrop", () => $5d722df1f75cd3f0$export$4696d1da23170d9a);

var $euxye = parcelRequire("euxye");

var $aYssY = parcelRequire("aYssY");

var $jufsF = parcelRequire("jufsF");

var $3m6RK = parcelRequire("3m6RK");
function $5d722df1f75cd3f0$export$4696d1da23170d9a(props) {
    const { data: data, item: item, id: id, isExpandable: isExpandable, isItemDraggable: isItemDraggable, isItemDroppable: isItemDroppable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, isDragAndDropEnabled: isDragAndDropEnabled, group: group, isItemDataInGroup: isItemDataInGroup, isItemData: isItemData, getItemData: getItemData } = props;
    const itemIsDraggable = isItemDraggable?.(data) ?? !!isDragAndDropEnabled;
    const itemIsDroppable = isItemDroppable?.(data) ?? !!isDragAndDropEnabled;
    const getInitialData = (0, $euxye.useCallback)(()=>getItemData({
            ...data,
            menuItemId: id,
            group: group
        }), [
        data,
        getItemData,
        group,
        id
    ]);
    const getDragPreviewPieces = (0, $euxye.useCallback)(()=>({
            elemBefore: (0, $3m6RK.getElemBeforeForItem)(item),
            content: (0, $3m6RK.getDragPreviewContentForItem)(item, data?.label)
        }), [
        data?.label,
        item
    ]);
    const canDrag = (0, $euxye.useCallback)(()=>isItemDraggable ? isItemDraggable(data) : !!isDragAndDropEnabled, [
        data,
        isDragAndDropEnabled,
        isItemDraggable
    ]);
    const getData = (0, $euxye.useCallback)((args)=>{
        const { source: source } = args;
        return getItemData({
            ...data,
            menuItemId: id,
            group: source?.data?.group
        });
    }, [
        data,
        getItemData,
        id
    ]);
    const getOperations = (0, $euxye.useCallback)(()=>({
            'reorder-before': itemIsDraggable ? 'available' : undefined,
            'reorder-after': 'available'
        }), [
        itemIsDraggable
    ]);
    const canDrop = (0, $euxye.useCallback)((args)=>{
        const { source: source } = args;
        return isItemData(source.data) && source.data.menuItemId !== id && isItemDataInGroup(source.data, group);
    }, [
        group,
        id,
        isItemData,
        isItemDataInGroup
    ]);
    const draggable = (0, $euxye.useMemo)(()=>{
        if (isDragAndDropEnabled && itemIsDraggable) return {
            canDrag: canDrag,
            getInitialData: getInitialData,
            getDragPreviewPieces: getDragPreviewPieces
        };
    }, [
        canDrag,
        getInitialData,
        getDragPreviewPieces,
        isDragAndDropEnabled,
        itemIsDraggable
    ]);
    const dropTarget = (0, $euxye.useMemo)(()=>{
        if (isDragAndDropEnabled && itemIsDroppable) return {
            canDrop: canDrop,
            getData: getData,
            getOperations: getOperations
        };
    }, [
        canDrop,
        getData,
        getOperations,
        isDragAndDropEnabled,
        itemIsDroppable
    ]);
    const memoizedHookProps = (0, $euxye.useMemo)(()=>({
            draggable: draggable,
            dropTarget: dropTarget
        }), [
        draggable,
        dropTarget
    ]);
    const { draggableAnchorRef: draggableAnchorRef, draggableButtonRef: draggableButtonRef, state: dragState, dragPreview: dragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $aYssY.useMenuItemDragAndDrop)(memoizedHookProps);
    const registry = (0, $jufsF.useElementRegistry)();
    const registrationRef = (0, $euxye.useRef)(null);
    const draggableRef = (0, $euxye.useCallback)((element)=>{
        if (!element) {
            registrationRef.current?.();
            registrationRef.current = null;
            draggableAnchorRef.current = null;
            draggableButtonRef.current = null;
            return;
        }
        if (element instanceof HTMLAnchorElement) draggableAnchorRef.current = element;
        else draggableButtonRef.current = element;
        if (registrationRef.current) registrationRef.current();
        registrationRef.current = registry.registerL1Item({
            id: id,
            element: element
        });
    }, [
        id,
        registry,
        draggableAnchorRef,
        draggableButtonRef,
        registrationRef
    ]);
    const isDragging = !!itemIsDraggable && dragState.type === 'dragging';
    const expandableClosedForDrag = (0, $euxye.useRef)(false);
    (0, $euxye.useLayoutEffect)(()=>{
        if (!isExpandable || !itemIsDraggable) return;
        if (isDragging && isExpandOrFlyoutOpen) {
            onExpandFlyoutToggle(false);
            expandableClosedForDrag.current = true;
        } else if (!isDragging && expandableClosedForDrag.current) {
            onExpandFlyoutToggle(true);
            expandableClosedForDrag.current = false;
        }
    }, [
        isDragging,
        isExpandable,
        isExpandOrFlyoutOpen,
        itemIsDraggable,
        expandableClosedForDrag,
        onExpandFlyoutToggle
    ]);
    return (0, $euxye.useMemo)(()=>({
            draggableRef: itemIsDraggable ? draggableRef : undefined,
            isItemDraggable: itemIsDraggable,
            isItemDroppable: itemIsDroppable,
            isDragging: isDragging,
            dropTargetRef: itemIsDroppable ? dropTargetRef : undefined,
            dropIndicator: itemIsDroppable ? dropIndicator : undefined,
            maybeDragPreview: itemIsDraggable ? dragPreview : null
        }), [
        draggableRef,
        dragPreview,
        dropIndicator,
        dropTargetRef,
        isDragging,
        itemIsDraggable,
        itemIsDroppable
    ]);
}

});
parcelRegister("aYssY", function(module, exports) {
$parcel$export(module.exports, "useMenuItemDragAndDrop", () => $619abff1b2cff003$export$fe281fdb09fbf0c8);
/* use-menu-item-drag-and-drop.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");
parcelRequire("3nfFb");
var $gOKKd = parcelRequire("gOKKd");
parcelRequire("fWrp0");
var $7XqvC = parcelRequire("7XqvC");
parcelRequire("ij70u");
var $e77YP = parcelRequire("e77YP");

var $5CWW7 = parcelRequire("5CWW7");

var $iG1P2 = parcelRequire("iG1P2");

var $6rsYi = parcelRequire("6rsYi");
const $619abff1b2cff003$var$idle = {
    type: 'idle'
};
function $619abff1b2cff003$export$fe281fdb09fbf0c8({ draggable: draggableArgs, dropTarget: dropTargetArgs }) {
    const draggableAnchorRef = (0, $euxye.useRef)(null);
    const draggableButtonRef = (0, $euxye.useRef)(null);
    const dropTargetRef = (0, $euxye.useRef)(null);
    const [internalState, setInternalState] = (0, $euxye.useState)($619abff1b2cff003$var$idle);
    const getDraggableElement = (0, $euxye.useCallback)(()=>{
        return draggableAnchorRef.current ?? draggableButtonRef.current ?? null;
    }, []);
    // Set up draggable
    (0, $euxye.useEffect)(()=>{
        // Don't set up a draggable if there are no draggable args
        if (!draggableArgs) return;
        const element = getDraggableElement();
        // Some elements may initially want to use DnD, then decide not to render.
        // In that case, we don't want to throw an error.
        if (!element) return;
        return (0, $gOKKd.draggable)({
            element: element,
            getInitialData: draggableArgs.getInitialData,
            canDrag: draggableArgs.canDrag,
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage, source: source, location: location }) {
                (0, $e77YP.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $7XqvC.pointerOutsideOfPreview)({
                        x: "var(--ds-space-200, 16px)",
                        y: "var(--ds-space-100, 8px)"
                    }),
                    render ({ container: container }) {
                        const args = {
                            dragHandle: source.dragHandle,
                            element: source.element,
                            input: location.current.input
                        };
                        setInternalState({
                            type: 'preview',
                            container: container,
                            ui: draggableArgs.getDragPreviewPieces(args)
                        });
                    }
                });
            },
            onDragStart () {
                setInternalState({
                    type: 'dragging'
                });
            },
            onDrop () {
                setInternalState($619abff1b2cff003$var$idle);
            }
        });
    }, [
        draggableArgs,
        getDraggableElement
    ]);
    // Set up drop target
    (0, $euxye.useEffect)(()=>{
        if (!dropTargetArgs) return;
        // Don't need to provide a draggable element to have a drop target.
        // Using this element in our `canDrop` check
        const draggableElement = getDraggableElement();
        const dropTarget = dropTargetRef.current;
        // Some elements may initially want to use DnD, then decide not to render.
        // In that case, we don't want to throw an error
        if (!dropTarget) return;
        return (0, $gOKKd.dropTargetForElements)({
            element: dropTarget,
            // cannot drop on self
            canDrop: (args)=>{
                // cannot drop on self
                if (args.source.element === draggableElement) return false;
                if (dropTargetArgs.canDrop) return dropTargetArgs.canDrop(args);
                return true;
            },
            // menu items are always sticky, and the GroupDropIndicator should clear stickiness
            getIsSticky: ()=>true,
            getData (args) {
                const data = dropTargetArgs.getData?.(args) ?? {};
                const operations = dropTargetArgs.getOperations(args);
                return (0, $6rsYi.attachInstruction)(data, {
                    input: args.input,
                    element: args.element,
                    operations: operations
                });
            },
            onDragStart ({ self: self }) {
                const instruction = (0, $6rsYi.extractInstruction)(self.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction
                });
            },
            onDrag ({ self: self }) {
                const instruction = (0, $6rsYi.extractInstruction)(self.data);
                setInternalState((current)=>{
                    if (current.type === 'is-over' && instruction?.operation === current.instruction?.operation && instruction?.blocked === current.instruction?.blocked) return current;
                    return {
                        type: 'is-over',
                        instruction: instruction
                    };
                });
            },
            onDragLeave () {
                setInternalState($619abff1b2cff003$var$idle);
            },
            onDrop () {
                setInternalState($619abff1b2cff003$var$idle);
            },
            onDragEnter ({ self: self }) {
                const instruction = (0, $6rsYi.extractInstruction)(self.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction
                });
            }
        });
    }, [
        dropTargetArgs,
        getDraggableElement
    ]);
    const dragPreview = (()=>{
        if (internalState.type !== 'preview') return null;
        return /*#__PURE__*/ (0, $85XPu.createPortal)(/*#__PURE__*/ (0, $e79Pd.jsx)((0, $5CWW7.DragPreview), {
            elemBefore: internalState.ui.elemBefore,
            children: internalState.ui.content
        }), internalState.container);
    })();
    const dropIndicator = internalState.type === 'is-over' && internalState.instruction && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iG1P2.DropIndicator), {
        instruction: internalState.instruction
    });
    const state = (0, $euxye.useMemo)(()=>{
        if (internalState.type === 'preview') return {
            type: 'preview'
        };
        // returning a new object to avoid modification of our `internalState` object
        return {
            ...internalState
        };
    }, [
        internalState
    ]);
    return {
        state: state,
        draggableButtonRef: draggableButtonRef,
        dropTargetRef: dropTargetRef,
        draggableAnchorRef: draggableAnchorRef,
        dragPreview: dragPreview,
        dropIndicator: dropIndicator
    };
}

});
parcelRegister("5CWW7", function(module, exports) {
$parcel$export(module.exports, "DragPreview", () => $e23e587921ecb7c4$export$905ab40ac2179daa);
/* drag-preview.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $egspI = parcelRequire("egspI");

var $2Kf7z = parcelRequire("2Kf7z");

var $9xUz7 = parcelRequire("9xUz7");

var $hgiKI = parcelRequire("hgiKI");
// Using JavaScript for detecting Safari, as I could not find a reliable way to do it with CSS.
function $e23e587921ecb7c4$var$isSafari() {
    if (typeof window === 'undefined') return false;
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
}
const $e23e587921ecb7c4$var$dragPreviewStyles = {
    root: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1 _bfhkvuon _y4ti1b66 _p12fgx0z",
    rootT26Shape: "_2rko1qi0",
    safariFix: "_1ul9uuw1"
};
function $e23e587921ecb7c4$export$905ab40ac2179daa({ elemBefore: elemBefore, children: children }) {
    return(// Resetting the expandable menu items to 0.
    // This is to prevent our hidden element from pushing
    // the drag preview further away from the users pointer
    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2Kf7z.ExpandableMenuItemLevelContext).Provider, {
        value: 0,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            className: (0, $4jQY2.default)([
                $e23e587921ecb7c4$var$dragPreviewStyles.root,
                (0, $egspI.fg)('platform-dst-shape-theme-default') && $e23e587921ecb7c4$var$dragPreviewStyles.rootT26Shape,
                $e23e587921ecb7c4$var$isSafari() && $e23e587921ecb7c4$var$dragPreviewStyles.safariFix
            ]),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9xUz7.MenuItemBase), {
                elemBefore: elemBefore ?? (0, $hgiKI.COLLAPSE_ELEM_BEFORE),
                children: children
            })
        })
    }));
}
$e23e587921ecb7c4$export$905ab40ac2179daa.displayName = "DragPreview";

});

parcelRegister("iG1P2", function(module, exports) {
$parcel$export(module.exports, "DropIndicator", () => $59027a6cc92e4e9a$export$62ed72bc21f6b8a6);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $5VQcl = parcelRequire("5VQcl");

var $76mBo = parcelRequire("76mBo");
const $59027a6cc92e4e9a$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom'
    },
    horizontal: {
        start: 'left',
        end: 'right'
    }
};
function $59027a6cc92e4e9a$export$62ed72bc21f6b8a6({ instruction: instruction, lineGap: lineGap, lineType: lineType }) {
    const appearance = instruction.blocked ? 'warning' : 'default';
    const axis = $59027a6cc92e4e9a$var$axisLookup[instruction.axis];
    if (instruction.operation === 'combine') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5VQcl.DropIndicator), {
        appearance: appearance
    });
    if (instruction.operation === 'reorder-before') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $76mBo.DropIndicator), {
        edge: axis.start,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    if (instruction.operation === 'reorder-after') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $76mBo.DropIndicator), {
        edge: axis.end,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    return null;
}
$59027a6cc92e4e9a$export$62ed72bc21f6b8a6.displayName = "DropIndicator";

});
parcelRegister("5VQcl", function(module, exports) {
$parcel$export(module.exports, "DropIndicator", () => $84c1c3f11a7281fc$export$62ed72bc21f6b8a6);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $g3Yyo = parcelRequire("g3Yyo");

var $1oxDH = parcelRequire("1oxDH");
function $84c1c3f11a7281fc$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', indent: indent }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g3Yyo.Border), {
        strokeColor: (0, $1oxDH.presetStrokeColors)[appearance],
        indent: indent
    });
}
$84c1c3f11a7281fc$export$62ed72bc21f6b8a6.displayName = "DropIndicator";
var // For React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$84c1c3f11a7281fc$export$2e2bcd8739ae039 = $84c1c3f11a7281fc$export$62ed72bc21f6b8a6;

});
parcelRegister("g3Yyo", function(module, exports) {
$parcel$export(module.exports, "Border", () => $d84873629b548129$export$d8e9c9d63e86d41e);
/* border.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $1oxDH = parcelRequire("1oxDH");
const $d84873629b548129$var$styles = null;
function $d84873629b548129$export$d8e9c9d63e86d41e({ strokeColor: strokeColor = (0, $1oxDH.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $1oxDH.presetStrokeWidth), borderRadius: borderRadius = '3px', indent: // TODO: update to radius.small (4px) token
indent = '0px' }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        style: {
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            '--border-radius': borderRadius,
            '--indent': indent
        },
        className: (0, $4jQY2.default)([
            "_19it1ebc _2rko1koq _kqswstnw _152tidpf _u7coidpf _rjxpidpf _1e02armj _lcxvglyw"
        ])
    });
}
$d84873629b548129$export$d8e9c9d63e86d41e.displayName = "Border";
var // For React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d84873629b548129$export$2e2bcd8739ae039 = $d84873629b548129$export$d8e9c9d63e86d41e;

});



parcelRegister("6rsYi", function(module, exports) {
$parcel$export(module.exports, "attachInstruction", () => $4f2d2608783ddbd4$export$267ad49d812c2c7f);
$parcel$export(module.exports, "extractInstruction", () => $4f2d2608783ddbd4$export$c8ffecbe249dc8f8);

var $2wKfH = parcelRequire("2wKfH");
// using a symbol so we can guarantee a key with a unique value
const $4f2d2608783ddbd4$var$uniqueKey = Symbol('list-item-instruction');
const $4f2d2608783ddbd4$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom',
        size: 'height',
        point: 'y'
    },
    horizontal: {
        start: 'left',
        end: 'right',
        size: 'width',
        point: 'x'
    }
};
function $4f2d2608783ddbd4$var$reorderAndCombine({ client: client, borderBox: borderBox, axis: axis }) {
    const quarterOfSize = borderBox[axis.size] / 4;
    // In the top 1/4: reorder-before
    // On the line: reorder-before to give a slight preference to reordering
    if (client[axis.point] <= borderBox[axis.start] + quarterOfSize) return 'reorder-before';
    // In the bottom 1/4: reorder-after
    // On the line: reorder-after to give a slight preference to reordering
    if (client[axis.point] >= borderBox[axis.end] - quarterOfSize) return 'reorder-after';
    return 'combine';
}
function $4f2d2608783ddbd4$var$reorder({ client: client, borderBox: borderBox, axis: axis }) {
    const halfSize = borderBox[axis.size] / 2;
    // In the top 1/2: reorder-before
    // On the line: reorder-after to give a slight preference to moving forward
    if (client[axis.point] < borderBox[axis.start] + halfSize) return 'reorder-before';
    return 'reorder-after';
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $4f2d2608783ddbd4$var$memoizeInstruction = (0, $2wKfH.stable)();
function $4f2d2608783ddbd4$var$isPossible(...values) {
    return values.every((value)=>value === 'available' || value === 'blocked');
}
function $4f2d2608783ddbd4$var$isNotAvailable(...values) {
    return values.every((value)=>value === 'not-available');
}
function $4f2d2608783ddbd4$export$267ad49d812c2c7f(userData, { operations: operations, element: element, input: input, axis: axisValue = 'vertical' }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    const axis = $4f2d2608783ddbd4$var$axisLookup[axisValue];
    const combine = operations.combine ?? 'not-available';
    const reorderAbove = operations['reorder-before'] ?? 'not-available';
    const reorderBelow = operations['reorder-after'] ?? 'not-available';
    const operation = (()=>{
        // Combining not possible
        if (!$4f2d2608783ddbd4$var$isPossible(combine)) {
            // can reorder above and below
            if ($4f2d2608783ddbd4$var$isPossible(reorderAbove, reorderBelow)) return $4f2d2608783ddbd4$var$reorder({
                client: client,
                borderBox: borderBox,
                axis: axis
            });
            // can only reorder above
            if ($4f2d2608783ddbd4$var$isPossible(reorderAbove)) return 'reorder-before';
            // can only reorder below
            if ($4f2d2608783ddbd4$var$isPossible(reorderBelow)) return 'reorder-after';
            // no `true` values - no Outcome available.
            return null;
        }
        // combining is available
        const result = $4f2d2608783ddbd4$var$reorderAndCombine({
            client: client,
            borderBox: borderBox,
            axis: axis
        });
        if (result === 'reorder-after') return $4f2d2608783ddbd4$var$isNotAvailable(reorderBelow) ? 'combine' : result;
        if (result === 'reorder-before') return $4f2d2608783ddbd4$var$isNotAvailable(reorderAbove) ? 'combine' : result;
        return result;
    })();
    // We cannot attach an instruction - all values passed where `false` or no values passed
    if (!operation) return userData;
    const instruction = {
        operation: operation,
        blocked: operations[operation] === 'blocked',
        axis: axisValue
    };
    const memoized = $4f2d2608783ddbd4$var$memoizeInstruction(instruction);
    return {
        ...userData,
        [$4f2d2608783ddbd4$var$uniqueKey]: memoized
    };
}
function $4f2d2608783ddbd4$export$c8ffecbe249dc8f8(userData) {
    return userData[$4f2d2608783ddbd4$var$uniqueKey] ?? null;
}

});
parcelRegister("2wKfH", function(module, exports) {
$parcel$export(module.exports, "isShallowEqual", () => $0ea180e830ed18cb$export$2225b4c39d37f8b3);
$parcel$export(module.exports, "stable", () => $0ea180e830ed18cb$export$3f55479a3469259f);
function $0ea180e830ed18cb$export$2225b4c39d37f8b3(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>Object.is(a[key], b[key]));
}
function $0ea180e830ed18cb$export$3f55479a3469259f(isEqual = $0ea180e830ed18cb$export$2225b4c39d37f8b3) {
    let cache = null;
    return (value)=>{
        if (cache && isEqual(cache.value, value)) return cache.value;
        cache = {
            value: value
        };
        return cache.value;
    };
}

});



parcelRegister("3m6RK", function(module, exports) {
$parcel$export(module.exports, "getElemBeforeForItem", () => $c588583a373874c3$export$9d7e63760538f47f);
$parcel$export(module.exports, "getDragPreviewContentForItem", () => $c588583a373874c3$export$d5d05b25e1604a8f);
function $c588583a373874c3$export$9d7e63760538f47f(item) {
    if (!item || item.type === 'custom' && item.dragPreviewContent) // If the custom item has a drag preview content, we should assume it contains the icon already
    return undefined;
    return item.elemBefore;
}
function $c588583a373874c3$export$d5d05b25e1604a8f(item, name) {
    if (!item) {
        if (name) return name;
        return undefined;
    }
    if (item.type === 'custom' && item.dragPreviewContent) // Custom items may return their drag preview content as a React node
    return item.dragPreviewContent;
    // If not custom or drag preview content not present, use the label
    return item.labelElem ?? item.label;
}

});



parcelRegister("edY9W", function(module, exports) {
$parcel$export(module.exports, "ObjectListFlyout", () => $cea0198a9a5efe01$export$8c8993cce765101e);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $33r3w = parcelRequire("33r3w");

var $4bQxN = parcelRequire("4bQxN");
function $cea0198a9a5efe01$export$8c8993cce765101e(props) {
    // We are NOT destructuring all of the properties in `props`.
    // There are extra properties (e.g. props.actions) which are being passed to the entrypoint
    const { dropIndicator: dropIndicator, elemBefore: elemBefore, entryPoint: entryPoint = (0, $4bQxN.objectListFlyoutEntrypoint), entryPointParams: entryPointParams, errorFallback: errorFallback, fallback: fallback, hasDragIndicator: hasDragIndicator, isDefaultOpen: isDefaultOpen, isDragging: isDragging, isFlyoutOpen: isFlyoutOpen, isSelected: isSelected, label: label, labelElem: labelElem, onClick: onClick, onOpenChange: onOpenChange, testId: testId, triggerRef: triggerRef, visualContentRef: visualContentRef } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $33r3w.FlyoutTrigger), {
        entryPoint: entryPoint,
        entryPointProps: props,
        entryPointParams: entryPointParams,
        errorFallback: errorFallback,
        fallback: fallback,
        isDefaultOpen: isDefaultOpen,
        isFlyoutOpen: isFlyoutOpen,
        onOpenChange: onOpenChange,
        triggerProps: {
            elemBefore: elemBefore,
            children: labelElem ?? label,
            isSelected: isSelected,
            onClick: onClick,
            testId: testId,
            hasDragIndicator: hasDragIndicator,
            isDragging: isDragging,
            dropIndicator: dropIndicator,
            triggerRef: triggerRef,
            visualContentRef: visualContentRef
        }
    });
}
$cea0198a9a5efe01$export$8c8993cce765101e.displayName = "ObjectListFlyout";

});
parcelRegister("33r3w", function(module, exports) {
$parcel$export(module.exports, "FlyoutTrigger", () => $12c1d2cf5bf1ad26$export$4ebbeeb2921cde03);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $50OIz = parcelRequire("50OIz");

var $4U30j = parcelRequire("4U30j");
var $iozCP = parcelRequire("iozCP");
var $02ogW = parcelRequire("02ogW");

var $abhF2 = parcelRequire("abhF2");

var $8EpkY = parcelRequire("8EpkY");

var $gAEFP = parcelRequire("gAEFP");

var $cxpqA = parcelRequire("cxpqA");
const $12c1d2cf5bf1ad26$var$emptyEntryPointParams = {};
const $12c1d2cf5bf1ad26$var$emptyEntryPointProps = {};
function $12c1d2cf5bf1ad26$export$4ebbeeb2921cde03({ triggerProps: triggerProps, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorFallback: errorFallback, fallback: fallback, onError: onError, onOpenChange: onOpenChange, isDefaultOpen: isDefaultOpen = false, ...flyoutProps }) {
    const environmentProvider = (0, $cxpqA.useRelayEnvironmentProvider)();
    const hasRun = (0, $euxye.useRef)(false);
    const hasLoaded = (0, $euxye.useRef)(false);
    const id = (0, $euxye.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const isOpenControlled = flyoutProps.isFlyoutOpen !== undefined && hasLoaded.current;
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const [content, setContent] = (0, $euxye.useState)(null);
    const handleOpenChange = (0, $euxye.useCallback)((open)=>{
        if (isOpenControlled) // Route through external controller so item.isOpen stays the single source of truth
        onOpenChange?.(open);
        else setIsOpen(open);
    }, [
        isOpenControlled,
        onOpenChange
    ]);
    const handleOpen = (0, $euxye.useCallback)(()=>handleOpenChange(true), [
        handleOpenChange
    ]);
    const handleClose = (0, $euxye.useCallback)(()=>{
        setIsOpen(false);
        onOpenChange?.(false);
    }, [
        onOpenChange
    ]);
    const onFlyoutOpenChange = (0, $euxye.useCallback)((open)=>{
        onOpenChange?.(open);
    }, [
        onOpenChange
    ]);
    const load = (0, $euxye.useCallback)(()=>(0, $n67Vb.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $12c1d2cf5bf1ad26$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $euxye.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing flyout
        if (isOpen) return;
        setContent(/*#__PURE__*/ (0, $e79Pd.jsx)((0, $gAEFP.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {}),
            errorFallback: errorFallback,
            runtimeProps: {
                ...entryPointProps ?? $12c1d2cf5bf1ad26$var$emptyEntryPointProps,
                closeFlyout: handleClose
            },
            onError: onError
        }));
        hasLoaded.current = true;
    }, [
        entryPointProps,
        errorFallback,
        fallback,
        handleClose,
        id,
        isOpen,
        onError,
        setContent
    ]);
    // Auto-open on first render if isDefaultOpen is true
    (0, $euxye.useEffect)(()=>{
        if (!hasRun.current && isDefaultOpen) {
            onLoad({
                reference: load()
            });
            handleOpen();
            hasRun.current = true;
        }
    }, [
        handleOpen,
        isDefaultOpen,
        load,
        onLoad
    ]);
    // Load entry point immediately if the flyout is open and it hasn't loaded
    (0, $euxye.useEffect)(()=>{
        if (flyoutProps.isFlyoutOpen && !hasLoaded.current) onLoad({
            reference: load()
        });
    }, [
        flyoutProps.isFlyoutOpen,
        load,
        onLoad
    ]);
    // Update internal open state when isOpenControlled changes
    // Allows the open state to be dynamically controlled
    (0, $euxye.useEffect)(()=>{
        isOpenControlled && setIsOpen(!!flyoutProps.isFlyoutOpen);
    }, [
        flyoutProps.isFlyoutOpen,
        isOpenControlled
    ]);
    const handleTriggerClick = (0, $euxye.useCallback)(()=>{
        isOpen ? handleClose() : handleOpen();
    }, [
        handleClose,
        handleOpen,
        isOpen
    ]);
    const triggerRef = (0, $8EpkY.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const flyoutTriggerRef = (0, $euxye.useMemo)(()=>{
        const refs = [
            triggerRef
        ];
        if (triggerProps?.triggerRef) refs.push(triggerProps.triggerRef);
        return (0, $50OIz.mergeRefs)(refs);
    }, [
        triggerRef,
        triggerProps.triggerRef
    ]);
    const flyoutContent = (0, $euxye.useCallback)(()=>content, [
        content
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $4U30j.FlyoutMenuItem), {
        ...flyoutProps,
        // isDefaultOpen={isDefaultOpen}
        isOpen: isOpen,
        onOpenChange: onFlyoutOpenChange,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $02ogW.FlyoutMenuItemTrigger), {
                ...triggerProps,
                ref: flyoutTriggerRef,
                onClick: handleTriggerClick
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iozCP.FlyoutMenuItemContent), {
                onClose: handleClose,
                children: flyoutContent()
            })
        ]
    });
}
$12c1d2cf5bf1ad26$export$4ebbeeb2921cde03.displayName = "FlyoutTrigger";

});

parcelRegister("4bQxN", function(module, exports) {
$parcel$export(module.exports, "objectListFlyoutEntrypoint", () => $4a01023f5660ad46$export$34c0c9850f758c93);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $4a01023f5660ad46$export$34c0c9850f758c93 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("eFm0R")), {
        moduleId: "55f97069",
        priority: "interaction",
        moduleId: 'objectListFlyoutEntrypoint'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eFm0R", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("gdZZt")
]).then(()=>parcelRequire('irNCE'));

});



parcelRegister("5TAdw", function(module, exports) {
$parcel$export(module.exports, "isButtonItemConfig", () => $424521a899b2f4cf$export$cd440346ca02126b);
$parcel$export(module.exports, "isCustomItemConfig", () => $424521a899b2f4cf$export$8e525d5a1e55be8f);
$parcel$export(module.exports, "isExpandableItemConfig", () => $424521a899b2f4cf$export$e5ec7109da4bc094);
$parcel$export(module.exports, "isFlyoutItemConfig", () => $424521a899b2f4cf$export$ee29322ec7068717);
$parcel$export(module.exports, "isLinkItemConfig", () => $424521a899b2f4cf$export$4fdefbbdae1adf42);
$parcel$export(module.exports, "isObjectListFlyoutItemConfig", () => $424521a899b2f4cf$export$10dd63e15344d4ca);
$parcel$export(module.exports, "isCustomShortcutConfig", () => $424521a899b2f4cf$export$f4fba01b0340f4b5);
$parcel$export(module.exports, "isCustomShortcutDraggableConfig", () => $424521a899b2f4cf$export$b3885daf9ee22eab);
const $424521a899b2f4cf$export$cd440346ca02126b = (item)=>item.type === 'button';
const $424521a899b2f4cf$export$8e525d5a1e55be8f = (item)=>item.type === 'custom';
const $424521a899b2f4cf$export$e5ec7109da4bc094 = (item)=>item.type === 'expand';
const $424521a899b2f4cf$export$ee29322ec7068717 = (item)=>item.type === 'flyout';
const $424521a899b2f4cf$export$4fdefbbdae1adf42 = (item)=>item.type === 'link';
const $424521a899b2f4cf$export$10dd63e15344d4ca = (item)=>item.type === 'object-list-flyout';
const $424521a899b2f4cf$export$f4fba01b0340f4b5 = (item)=>{
    return item.type === 'component';
};
const $424521a899b2f4cf$export$b3885daf9ee22eab = (item)=>{
    return item.type === 'component' && !!(item?.isReorderable && item?.menuItemId);
};

});

parcelRegister("1QF9m", function(module, exports) {
$parcel$export(module.exports, "useNavAnalytics", () => $b6d8038780ea3d37$export$8d6902e2f27b22d5);

var $euxye = parcelRequire("euxye");

var $69tcH = parcelRequire("69tcH");

var $4RLhz = parcelRequire("4RLhz");

var $lyg9d = parcelRequire("lyg9d");

var $8YxSe = parcelRequire("8YxSe");

var $aPed4 = parcelRequire("aPed4");
function $b6d8038780ea3d37$export$8d6902e2f27b22d5() {
    const { fireEvent: fireEvent } = (0, $aPed4.useAnalyticsEvents)();
    const { disableMenuCustomization: disableMenuCustomization, hasBottomElement: hasBottomElement } = (0, $4RLhz.useOptions)();
    const { allItems: allItems, globalItems: globalItems, growthItemShortcuts: growthItemShortcuts, items: items, shortcuts: shortcuts } = (0, $69tcH.useItemsAndShortcuts)();
    const { hiddenMenuIds: hiddenMenuIds, hiddenItemMenuIds: hiddenItemMenuIds, hiddenShortcutMenuIds: hiddenShortcutMenuIds, visibleMenuIds: visibleMenuIds, visibleItemMenuIds: visibleItemMenuIds, visibleShortcutMenuIds: visibleShortcutMenuIds } = (0, $lyg9d.useUserMenuDataShapes)();
    // Global items + customize/more + bottom element
    const globalItemsList = (0, $euxye.useMemo)(()=>[
            ...visibleItemMenuIds.filter((id)=>globalItems.has(id)),
            ...!disableMenuCustomization ? [
                !!hiddenItemMenuIds.length || !!hiddenShortcutMenuIds.length ? (0, $8YxSe.INTERNAL_GLOBAL_ITEMS).more : (0, $8YxSe.INTERNAL_GLOBAL_ITEMS).customize
            ] : [],
            ...hasBottomElement ? [
                (0, $8YxSe.INTERNAL_GLOBAL_ITEMS).bottomElem
            ] : []
        ], [
        disableMenuCustomization,
        hasBottomElement,
        hiddenItemMenuIds,
        hiddenShortcutMenuIds,
        globalItems,
        visibleItemMenuIds
    ]);
    // App specific items
    const appSpecificItemsList = (0, $euxye.useMemo)(()=>visibleItemMenuIds.filter((id)=>allItems[id] && !globalItems.has(id)), [
        allItems,
        globalItems,
        visibleItemMenuIds
    ]);
    // Shortcuts + growth shortcuts
    const shortcutIds = (0, $euxye.useMemo)(()=>Object.keys(growthItemShortcuts ?? {}), [
        growthItemShortcuts
    ]);
    const shortcutItemList = (0, $euxye.useMemo)(()=>[
            ...visibleShortcutMenuIds,
            ...shortcutIds
        ], [
        visibleShortcutMenuIds,
        shortcutIds
    ]);
    // All visible items
    const navItemList = (0, $euxye.useMemo)(()=>[
            ...globalItemsList,
            ...appSpecificItemsList,
            ...shortcutItemList
        ], [
        globalItemsList,
        appSpecificItemsList,
        shortcutItemList
    ]);
    // Index map for O(1) lookup performance
    const visibleMenuIdIndexMap = (0, $euxye.useMemo)(()=>{
        const map = new Map();
        visibleMenuIds.forEach((id, index)=>map.set(id, index));
        return map;
    }, [
        visibleMenuIds
    ]);
    // Item group
    const itemsIdsSet = (0, $euxye.useMemo)(()=>new Set(Object.keys(items)), [
        items
    ]);
    const getItemGroup = (0, $euxye.useCallback)((id)=>{
        return !!growthItemShortcuts?.[id] || !!shortcuts?.[id] ? 'appShortcut' : itemsIdsSet.has(id) ? 'appSpecific' : 'global';
    }, [
        growthItemShortcuts,
        itemsIdsSet,
        shortcuts
    ]);
    const getGroupItems = (0, $euxye.useCallback)((group)=>{
        switch(group){
            case 'global':
                return globalItemsList;
            case 'appSpecific':
                return appSpecificItemsList;
            case 'appShortcut':
                return shortcutItemList;
            default:
                return [];
        }
    }, [
        appSpecificItemsList,
        globalItemsList,
        shortcutItemList
    ]);
    const fireViewedSideNavEvent = (0, $euxye.useCallback)(()=>{
        const moreMenuItems = hiddenItemMenuIds.concat(hiddenShortcutMenuIds);
        fireEvent('ui.sideNav.viewed.sideNavMenu', {
            appSpecificItemsCount: appSpecificItemsList.length,
            appSpecificItemsList: appSpecificItemsList,
            appShortcutItemsCount: shortcutItemList.length,
            appShortcutItemsList: shortcutItemList,
            globalItemsCount: globalItemsList.length,
            globalItemsList: globalItemsList,
            inMoreItemsCount: moreMenuItems.length,
            inMoreItemsList: moreMenuItems
        });
    }, [
        hiddenItemMenuIds,
        hiddenShortcutMenuIds,
        globalItemsList,
        appSpecificItemsList,
        shortcutItemList,
        fireEvent
    ]);
    const fireClickedSideNavItemEvent = (0, $euxye.useCallback)((id, navLayoutComponent, isRightClick = false, status = null)=>{
        // Assign the current group based on the item type
        const currentGroup = getItemGroup(id);
        const isInternalGlobalItem = Object.values((0, $8YxSe.INTERNAL_GLOBAL_ITEMS)).includes(id);
        // Get visible items based on their group
        const visibleGroupItems = getGroupItems(currentGroup);
        const isInMore = // customize is in more if there are any hidden items
        (0, $8YxSe.INTERNAL_GLOBAL_ITEMS).customize === id && !!hiddenMenuIds.length || hiddenMenuIds.includes(id);
        // Current index irrespective of the item group
        const currentIndex = isInMore ? -1 : isInternalGlobalItem || !!growthItemShortcuts?.[id] ? visibleMenuIdIndexMap.size : visibleMenuIdIndexMap.get(id) ?? -1;
        // Current index within the item group
        const currentGroupIndex = isInMore ? -1 : visibleGroupItems.indexOf(id);
        const currentComponent = navLayoutComponent ? navLayoutComponent : isInMore ? 'postMain' : 'main';
        fireEvent('ui.sideNav.clicked.sideNavItem', {
            navLayoutComponent: currentComponent,
            navItemsCount: navItemList.length,
            navItemsIndex: currentIndex,
            group: currentGroup,
            groupItemsCount: visibleGroupItems.length,
            groupItemsIndex: currentGroupIndex,
            groupItem: id,
            isInMore: isInMore,
            isRightClick: isRightClick,
            status: status
        });
    }, [
        fireEvent,
        getGroupItems,
        getItemGroup,
        growthItemShortcuts,
        hiddenMenuIds,
        navItemList.length,
        visibleMenuIdIndexMap
    ]);
    const fireDraggedSideNavItemEvent = (0, $euxye.useCallback)((id, isInMore = false)=>{
        // Assign the current group based on the item type
        const currentGroup = getItemGroup(id);
        // Get visible items based on their group
        const visibleGroupItems = getGroupItems(currentGroup);
        // Current index irrespective of the item group
        const currentIndex = isInMore ? -1 : !!growthItemShortcuts?.[id] ? visibleMenuIdIndexMap.size : visibleMenuIdIndexMap.get(id) ?? -1;
        // Current index within the item group
        const currentGroupIndex = isInMore ? -1 : visibleGroupItems.indexOf(id);
        const currentComponent = isInMore ? 'postMain' : 'main';
        fireEvent('ui.sideNav.dragged.sideNavItem', {
            navLayoutComponent: currentComponent,
            navItemsCount: navItemList.length,
            navItemsIndex: currentIndex,
            group: currentGroup,
            groupItemsCount: visibleGroupItems.length,
            groupItemsIndex: currentGroupIndex,
            groupItem: id,
            isInMore: isInMore
        });
    }, [
        fireEvent,
        getGroupItems,
        getItemGroup,
        growthItemShortcuts,
        navItemList.length,
        visibleMenuIdIndexMap
    ]);
    const fireViewedSideNavSubMenuEvent = (0, $euxye.useCallback)((id, subItemsCount, isInMore = false, navLayoutComponent)=>{
        // Assign the current group based on the item type
        const currentGroup = getItemGroup(id);
        // Get visible items based on their group
        const visibleGroupItems = getGroupItems(currentGroup);
        const currentComponent = navLayoutComponent ? navLayoutComponent : isInMore ? 'postMain' : 'main';
        fireEvent('ui.sideNav.viewed.sideNavSubMenu', {
            group: currentGroup,
            groupItem: id,
            groupItemsCount: visibleGroupItems.length,
            groupItemsIndex: visibleGroupItems.indexOf(id),
            groupSubItemCount: subItemsCount ?? null,
            isInMore: isInMore,
            navLayoutComponent: currentComponent
        });
    }, [
        fireEvent,
        getGroupItems,
        getItemGroup
    ]);
    const fireViewedShortcutsEvent = (0, $euxye.useCallback)((shortcuts)=>{
        const attributes = {
            appShortcutItemsCount: shortcuts.length,
            appShortcutItemsList: shortcuts.map((item)=>item.label)
        };
        fireEvent('ui.sideNav.viewed.sideNavAppShortcutsSection', attributes);
    }, [
        fireEvent
    ]);
    const fireClickedSideNavSubMenuItemEvent = (0, $euxye.useCallback)((id, subItemsCount, isInMore = false, isRightClick = false, navLayoutComponent, extendedSubItemAnalyticsAttributes)=>{
        // Assign the current group based on the item type
        const currentGroup = getItemGroup(id);
        // Get visible items based on their group
        const visibleGroupItems = getGroupItems(currentGroup);
        const currentComponent = navLayoutComponent ? navLayoutComponent : isInMore ? 'postMain' : 'main';
        fireEvent('ui.sideNav.clicked.sideNavSubItem', {
            group: currentGroup,
            groupItem: id,
            groupItemsCount: visibleGroupItems.length,
            groupItemsIndex: visibleGroupItems.indexOf(id),
            groupSubItem: null,
            groupSubItemCount: subItemsCount ?? null,
            groupSubItemIndex: null,
            isInMore: isInMore,
            isRightClick: isRightClick,
            navLayoutComponent: currentComponent,
            extendedAnalyticsAttributes: extendedSubItemAnalyticsAttributes ?? null
        });
    }, [
        fireEvent,
        getGroupItems,
        getItemGroup
    ]);
    return {
        fireClickedSideNavItemEvent: fireClickedSideNavItemEvent,
        fireClickedSideNavSubMenuItemEvent: fireClickedSideNavSubMenuItemEvent,
        fireDraggedSideNavItemEvent: fireDraggedSideNavItemEvent,
        fireViewedShortcutsEvent: fireViewedShortcutsEvent,
        fireViewedSideNavEvent: fireViewedSideNavEvent,
        fireViewedSideNavSubMenuEvent: fireViewedSideNavSubMenuEvent
    };
}

});
parcelRegister("8YxSe", function(module, exports) {
$parcel$export(module.exports, "CUSTOMIZE_SIDEBAR_MENU_ITEM_TEST_ID", () => $294617c1da356c71$export$60e3e06657245ab);
$parcel$export(module.exports, "MORE_MENU_TEST_ID", () => $294617c1da356c71$export$9536180777e6913e);
$parcel$export(module.exports, "INTERNAL_GLOBAL_ITEMS", () => $294617c1da356c71$export$d1f148bb46faf037);
const $294617c1da356c71$export$60e3e06657245ab = 'gsn-customize-sidebar';
const $294617c1da356c71$export$9536180777e6913e = 'gsn-more-menu';
const $294617c1da356c71$export$d1f148bb46faf037 = {
    more: 'global.sidebar.more',
    customize: 'global.sidebar.customize',
    bottomElem: 'global.sidebar.bottomElem'
};

});


parcelRegister("yhM5u", function(module, exports) {
$parcel$export(module.exports, "useExpandOpenState", () => $156792ff44c12efc$export$e66526057f4a5c1e);

var $euxye = parcelRequire("euxye");
function $156792ff44c12efc$export$e66526057f4a5c1e(item, peek) {
    const { type: type } = item;
    const isExpandable = [
        'expand',
        'flyout',
        'object-list-flyout'
    ].includes(type);
    const isExpandableOnPeek = [
        'expand',
        'flyout'
    ].includes(type);
    const isExpandedFromProps = (type === 'expand' ? item.isExpanded : undefined) ?? (type === 'flyout' || type === 'object-list-flyout' ? item.isOpen : undefined);
    const isDefaultExpanded = (type === 'expand' ? item.isDefaultExpanded : undefined) ?? (type === 'flyout' || type === 'object-list-flyout' ? item.isDefaultOpen : undefined);
    // Peeked expand/flyout items should open initially, even if they are controlled closed.
    const initState = isExpandableOnPeek && peek ? true : typeof isExpandedFromProps === 'boolean' ? isExpandedFromProps : typeof isDefaultExpanded === 'boolean' ? isDefaultExpanded : false;
    const [isExpandOrFlyoutOpen, setIsExpandOrFlyoutOpen] = (0, $euxye.useState)(initState);
    const hookParams = (0, $euxye.useMemo)(()=>({
            isExpandedFromProps: isExpandedFromProps,
            isExpandable: isExpandable,
            peek: peek,
            isExpandableOnPeek: isExpandableOnPeek,
            setIsExpandOrFlyoutOpen: setIsExpandOrFlyoutOpen
        }), [
        isExpandedFromProps,
        isExpandable,
        peek,
        isExpandableOnPeek,
        setIsExpandOrFlyoutOpen
    ]);
    $156792ff44c12efc$var$useCustomSyncState(hookParams);
    const onExpanded = (type === 'expand' ? item.onExpansionToggle : undefined) ?? (type === 'flyout' || type === 'object-list-flyout' ? item.onOpenChange : undefined);
    const onExpandFlyoutToggle = (0, $euxye.useCallback)((isExpandedOrOpen)=>{
        if (!isExpandable) return;
        setIsExpandOrFlyoutOpen(isExpandedOrOpen);
        onExpanded?.(isExpandedOrOpen);
    }, [
        isExpandable,
        onExpanded
    ]);
    return {
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle,
        isExpandable: isExpandable
    };
}
// Sync internal state when controlled props change during render (not in an effect).
// This avoids hydration mismatches caused by useEffect setting state post-hydration.
// See: https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
function $156792ff44c12efc$var$useCustomSyncState(params) {
    const { isExpandedFromProps: isExpandedFromProps, isExpandable: isExpandable, peek: peek, isExpandableOnPeek: isExpandableOnPeek, setIsExpandOrFlyoutOpen: setIsExpandOrFlyoutOpen } = params;
    const prevIsExpandedFromProps = (0, $euxye.useRef)(isExpandedFromProps);
    const prevPeek = (0, $euxye.useRef)(peek);
    if (isExpandable) {
        if (isExpandedFromProps !== prevIsExpandedFromProps.current) {
            prevIsExpandedFromProps.current = isExpandedFromProps;
            if (typeof isExpandedFromProps === 'boolean' && !peek) setIsExpandOrFlyoutOpen(isExpandedFromProps);
        }
        if (peek !== prevPeek.current) {
            prevPeek.current = peek;
            if (isExpandableOnPeek && peek) setIsExpandOrFlyoutOpen(true);
        }
    }
}

});


parcelRegister("b3CAV", function(module, exports) {
$parcel$export(module.exports, "useDragAndDropSave", () => $ad471d24482b9db6$export$440b6dd66925f04d);

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $jiTLE = parcelRequire("jiTLE");

var $ijI7P = parcelRequire("ijI7P");

var $1pY3J = parcelRequire("1pY3J");
parcelRequire("jFnbs");
var $Anlri = parcelRequire("Anlri");

var $aPed4 = parcelRequire("aPed4");

var $1QF9m = parcelRequire("1QF9m");

var $j4Lo4 = parcelRequire("j4Lo4");
function $ad471d24482b9db6$export$440b6dd66925f04d(userMenuDataShapes, elementRegistry) {
    /*
	Get current order of items and shortcuts
	Apply reorder or hide operation
	Save the updated data using onSave
	*/ const intl = (0, $1YIbA.default)();
    const { fireEvent: fireEvent } = (0, $aPed4.useAnalyticsEvents)();
    const { fireDraggedSideNavItemEvent: fireDraggedSideNavItemEvent } = (0, $1QF9m.useNavAnalytics)();
    // Clean up live region when unmounted
    (0, $euxye.useEffect)(()=>{
        return ()=>$1pY3J.cleanup();
    }, []);
    /**
	 * Run flash/focus/announce/analytics directly after
	 * state updates settle, without the intermediate state → effect chain.
	 * We use Promise.resolve().then() to schedule after React has flushed the state update.
	 */ const runPostActionEffects = (0, $euxye.useCallback)((action)=>{
        Promise.resolve().then(()=>{
            if ($ad471d24482b9db6$var$isItemReorderAction(action)) {
                const label = action.draggedMenuItemLabel || action.draggedMenuItemId;
                const element = elementRegistry.getL1ItemElement(action.draggedMenuItemId);
                if (element) {
                    (0, $ijI7P.triggerPostMoveFlash)(element);
                    if (action.trigger === 'keyboard') setTimeout(()=>element.focus());
                    $1pY3J.announce(intl.formatMessage((0, $j4Lo4.messages).a11yAnnouncementItemReordered, {
                        label: label,
                        startIndex: action.startIndex + 1,
                        finishIndex: action.finishIndex + 1
                    }));
                    fireDraggedSideNavItemEvent(action.draggedMenuItemId, false);
                }
                return;
            }
            if ($ad471d24482b9db6$var$isItemHideAction(action)) {
                const label = action.draggedMenuItemLabel || action.draggedMenuItemId;
                const moreMenuElement = elementRegistry.getMoreMenuElement();
                if (moreMenuElement) {
                    (0, $ijI7P.triggerPostMoveFlash)(moreMenuElement);
                    if (action.trigger === 'keyboard') setTimeout(()=>moreMenuElement.focus());
                    $1pY3J.announce(intl.formatMessage((0, $j4Lo4.messages).a11yAnnouncementItemHidden, {
                        label: label
                    }));
                    fireDraggedSideNavItemEvent(action.draggedMenuItemId, true);
                }
                return;
            }
            if ($ad471d24482b9db6$var$isItemUnhideAction(action)) {
                const label = action.draggedMenuItemLabel || action.draggedMenuItemId;
                const element = elementRegistry.getL1ItemElement(action.draggedMenuItemId);
                if (element) {
                    (0, $ijI7P.triggerPostMoveFlash)(element);
                    if (action.trigger === 'keyboard') setTimeout(()=>element.focus());
                    $1pY3J.announce(intl.formatMessage((0, $j4Lo4.messages).a11yAnnouncementItemUnhidden, {
                        label: label,
                        finishIndex: action.finishIndex + 1
                    }));
                    fireDraggedSideNavItemEvent(action.draggedMenuItemId, false);
                }
                return;
            }
            if ($ad471d24482b9db6$var$isItemVisibleAction(action)) {
                const label = action.draggedMenuItemLabel || action.draggedMenuItemId;
                const moreMenuElement = elementRegistry.getMoreMenuElement();
                if (moreMenuElement) {
                    $1pY3J.announce(intl.formatMessage((0, $j4Lo4.messages).a11yAnnouncementItemVisible, {
                        label: label
                    }));
                    fireDraggedSideNavItemEvent(action.draggedMenuItemId, false);
                }
            }
        });
    }, // Intentional omission of `fireDraggedSideNavItemEvent` from dependencies to avoid firing twice
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        elementRegistry,
        intl
    ]);
    const dragAndDropSave = (0, $euxye.useCallback)(async (action)=>{
        // item reordered into visible menu
        if ($ad471d24482b9db6$var$isItemReorderAction(action)) {
            (0, $jiTLE.default)(action.droppedOnMenuItemId, 'item-reorder action must have droppedOnMenuItemId');
            const startIndex = userMenuDataShapes.userMenuData.findIndex((datum)=>datum.menuId === action.draggedMenuItemId);
            const itemsAndShortcutsIdsWithoutDraggedItem = userMenuDataShapes.userMenuData.map((datum)=>datum.menuId).filter((id)=>id !== action.draggedMenuItemId);
            const dropTargetIndex = itemsAndShortcutsIdsWithoutDraggedItem.indexOf(action.droppedOnMenuItemId);
            if (startIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `startIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            if (dropTargetIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `dropTargetIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            const finishIndex = action.instruction.operation === 'reorder-after' ? dropTargetIndex + 1 : dropTargetIndex;
            const visibleStartIndex = userMenuDataShapes.visibleMenuIds.indexOf(action.draggedMenuItemId);
            const visibleDropTargetIndex = userMenuDataShapes.visibleMenuIds.filter((id)=>id !== action.draggedMenuItemId).indexOf(action.droppedOnMenuItemId);
            if (visibleStartIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `visibleStartIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            if (visibleDropTargetIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `visibleDropTargetIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            const visibleFinishIndex = action.instruction.operation === 'reorder-after' ? visibleDropTargetIndex + 1 : visibleDropTargetIndex;
            const reordered = (0, $Anlri.reorder)({
                list: userMenuDataShapes.userMenuData,
                startIndex: startIndex,
                finishIndex: finishIndex
            });
            userMenuDataShapes.setUserMenuData(reordered);
            const extendedAction = {
                ...action,
                startIndex: visibleStartIndex,
                finishIndex: visibleFinishIndex
            };
            runPostActionEffects(extendedAction);
            return;
        }
        // item is dragged into hide button
        if ($ad471d24482b9db6$var$isItemHideAction(action)) {
            const dataWithHiddenItem = userMenuDataShapes.userMenuData.map((datum)=>{
                if (datum.menuId === action.draggedMenuItemId) return {
                    ...datum,
                    visible: false
                };
                return datum;
            });
            userMenuDataShapes.setUserMenuData(dataWithHiddenItem);
            runPostActionEffects(action);
            return;
        }
        // hidden item dragged into visible button
        if ($ad471d24482b9db6$var$isItemVisibleAction(action)) {
            const dataWithVisibleItem = userMenuDataShapes.userMenuData.map((datum)=>{
                if (datum.menuId === action.draggedMenuItemId) return {
                    ...datum,
                    visible: true
                };
                return datum;
            });
            userMenuDataShapes.setUserMenuData(dataWithVisibleItem);
            runPostActionEffects(action);
            return;
        }
        // hidden item dragged into visible menu
        if ($ad471d24482b9db6$var$isItemUnhideAction(action)) {
            (0, $jiTLE.default)(action.droppedOnMenuItemId, 'item-unhide action must have droppedOnMenuItemId');
            const userMenuDataWithUnhiddenItem = userMenuDataShapes.userMenuData.map((data)=>{
                if (data.menuId === action.draggedMenuItemId) return {
                    ...data,
                    visible: true
                };
                return data;
            });
            const startIndex = userMenuDataWithUnhiddenItem.findIndex((datum)=>datum.menuId === action.draggedMenuItemId);
            const itemsAndShortcutsIdsWithoutDraggedItem = userMenuDataWithUnhiddenItem.map((datum)=>datum.menuId).filter((id)=>id !== action.draggedMenuItemId);
            const dropTargetIndex = itemsAndShortcutsIdsWithoutDraggedItem.indexOf(action.droppedOnMenuItemId);
            if (startIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `startIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            if (dropTargetIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `dropTargetIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            const finishIndex = action.instruction.operation === 'reorder-after' ? dropTargetIndex + 1 : dropTargetIndex;
            const visibleDropTargetIndex = userMenuDataShapes.visibleMenuIds.filter((id)=>id !== action.draggedMenuItemId).indexOf(action.droppedOnMenuItemId);
            if (visibleDropTargetIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `visibleDropTargetIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            const visibleFinishIndex = action.instruction.operation === 'reorder-after' ? visibleDropTargetIndex + 1 : visibleDropTargetIndex;
            const reordered = (0, $Anlri.reorder)({
                list: userMenuDataWithUnhiddenItem,
                startIndex: startIndex,
                finishIndex: finishIndex
            });
            userMenuDataShapes.setUserMenuData(reordered);
            const extendedAction = {
                ...action,
                finishIndex: visibleFinishIndex
            };
            runPostActionEffects(extendedAction);
            return;
        }
    }, [
        fireEvent,
        runPostActionEffects,
        userMenuDataShapes
    ]);
    return {
        dragAndDropSave: dragAndDropSave
    };
}
function $ad471d24482b9db6$var$isItemReorderAction(action) {
    return action.type === 'item-reorder';
}
function $ad471d24482b9db6$var$isItemHideAction(action) {
    return action.type === 'item-hide';
}
function $ad471d24482b9db6$var$isItemUnhideAction(action) {
    return action.type === 'item-unhide';
}
function $ad471d24482b9db6$var$isItemVisibleAction(action) {
    return action.type === 'item-visible';
}

});
parcelRegister("ijI7P", function(module, exports) {
$parcel$export(module.exports, "triggerPostMoveFlash", () => $048470d6b8f80619$export$f5b5f29328df2633);

var $9VFAH = parcelRequire("9VFAH");
function $048470d6b8f80619$export$f5b5f29328df2633(element) {
    element.animate([
        {
            backgroundColor: "var(--ds-background-selected, #E9F2FE)"
        },
        {}
    ], {
        duration: (0, $9VFAH.durations).large,
        /**
     * This is equivalent to the browser default, but we are making it
     * explicit to avoid relying on implicit behavior.
     *
     * This curve is not part of `@atlaskit/motion` but it was an intentional
     * design decision to use this curve.
     */ easing: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)',
        iterations: 1
    });
}

});

parcelRegister("j4Lo4", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8ea8f54e141709bc$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $8ea8f54e141709bc$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    a11yAnnouncementItemHidden: {
        id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-hidden',
        defaultMessage: 'The top level menu item {label} has been hidden and moved to the More menu.',
        description: 'Announcement for assistive technology users when a top level menu item is hidden in the global side navigation.'
    },
    a11yAnnouncementItemUnhidden: {
        id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-unhidden',
        defaultMessage: 'The top level menu item {label} has been unhidden and moved from the more menu to position {finishIndex}.',
        description: 'Announcement for assistive technology users when a top level menu item is unhidden in the global side navigation.'
    },
    a11yAnnouncementItemReordered: {
        id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-reordered',
        defaultMessage: 'The top level menu item {label} has been moved from position {startIndex} to {finishIndex}.',
        description: 'Announcement for assistive technology users when a top level menu item is reordered in the global side navigation.'
    },
    a11yAnnouncementItemVisible: {
        id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-visible',
        defaultMessage: 'The top level menu item {label} has been moved from the More menu to the visible items.',
        description: 'Announcement for assistive technology users when a top level menu item is made visible in the global side navigation.'
    }
});

});


parcelRegister("jje4p", function(module, exports) {
$parcel$export(module.exports, "useMonitorForDnDElements", () => $b9bc7f07350816a9$export$9e5b5542ce283d4c);

var $euxye = parcelRequire("euxye");
parcelRequire("3nfFb");
var $gOKKd = parcelRequire("gOKKd");

var $6rsYi = parcelRequire("6rsYi");

var $aWAN2 = parcelRequire("aWAN2");

var $9sYLJ = parcelRequire("9sYLJ");
function $b9bc7f07350816a9$export$9e5b5542ce283d4c({ l1DragAndDropEnabled: l1DragAndDropEnabled, dragAndDropSave: dragAndDropSave, setDraggingL1Group: setDraggingL1Group, hiddenMenuIds: hiddenMenuIds }) {
    // Keep a ref up to date with the latest hiddenMenuIds on every render.
    // This allows the onDrop closure to always read the current value without
    // needing hiddenMenuIds in the monitor's dependency array.
    const hiddenMenuIdsRef = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useRef(hiddenMenuIds);
    (0, $euxye.useEffect)(()=>{
        hiddenMenuIdsRef.current = hiddenMenuIds;
    });
    (0, $euxye.useEffect)(()=>{
        if (!l1DragAndDropEnabled) return;
        return (0, $gOKKd.monitorForElements)({
            canMonitor: ({ source: source })=>(0, $9sYLJ.isL1ItemData)(source.data) && (0, $9sYLJ.isL1ItemDataInGroup)(source.data, [
                    (0, $aWAN2.L1_MENU_GROUPS).MENU,
                    (0, $aWAN2.L1_MENU_GROUPS).SHORTCUTS
                ]),
            onDragStart ({ source: source }) {
                if (!(0, $9sYLJ.isL1ItemData)(source.data)) return;
                setDraggingL1Group(source.data.group);
            },
            onDrop ({ source: source, location: location }) {
                const dragging = source.data;
                setDraggingL1Group(null);
                const [innerMost] = location.current.dropTargets;
                if (!innerMost) return;
                const dropTargetData = innerMost.data;
                const instruction = (0, $6rsYi.extractInstruction)(dropTargetData);
                if (!instruction) return;
                // Read from ref — always holds the latest hiddenMenuIds without causing
                // the monitor to re-register when the list changes.
                const hiddenMenuIds = hiddenMenuIdsRef.current;
                // Dragging out from More Menu
                if ((0, $9sYLJ.isL1ItemData)(dragging) && (0, $9sYLJ.isL1ItemData)(dropTargetData) && hiddenMenuIds.includes(dragging.menuItemId)) {
                    dragAndDropSave({
                        type: 'item-unhide',
                        draggedMenuItemId: dragging.menuItemId,
                        draggedMenuItemLabel: dragging.label,
                        droppedOnMenuItemId: dropTargetData.menuItemId,
                        instruction: instruction,
                        trigger: 'pointer'
                    });
                    return;
                }
                // Drag and Drop Order within Shortcuts group
                if ((0, $9sYLJ.isL1ItemData)(dragging) && (0, $9sYLJ.isL1ItemData)(dropTargetData) && (0, $9sYLJ.isL1ItemDataInGroup)(dragging, (0, $aWAN2.L1_MENU_GROUPS).SHORTCUTS) && (0, $9sYLJ.isL1ItemDataInGroup)(dropTargetData, (0, $aWAN2.L1_MENU_GROUPS).SHORTCUTS)) {
                    dragAndDropSave({
                        type: 'item-reorder',
                        draggedMenuItemId: dragging.menuItemId,
                        draggedMenuItemLabel: dragging.label,
                        droppedOnMenuItemId: dropTargetData.menuItemId,
                        instruction: instruction,
                        trigger: 'pointer'
                    });
                    return;
                }
                // Drag and Drop Order within Menu group
                if ((0, $9sYLJ.isL1ItemData)(dragging) && (0, $9sYLJ.isL1ItemData)(dropTargetData) && (0, $9sYLJ.isL1ItemDataInGroup)(dragging, (0, $aWAN2.L1_MENU_GROUPS).MENU) && (0, $9sYLJ.isL1ItemDataInGroup)(dropTargetData, (0, $aWAN2.L1_MENU_GROUPS).MENU)) {
                    dragAndDropSave({
                        type: 'item-reorder',
                        draggedMenuItemId: dragging.menuItemId,
                        draggedMenuItemLabel: dragging.label,
                        droppedOnMenuItemId: dropTargetData.menuItemId,
                        instruction: instruction,
                        trigger: 'pointer'
                    });
                    return;
                }
                // Drag into More Menu (hide or show)
                if ((0, $9sYLJ.isL1ItemData)(dragging) && (0, $9sYLJ.isL1ItemDataInGroup)(dragging, [
                    (0, $aWAN2.L1_MENU_GROUPS).MENU,
                    (0, $aWAN2.L1_MENU_GROUPS).SHORTCUTS
                ]) && (0, $9sYLJ.isMoreMenuData)(dropTargetData)) {
                    dragAndDropSave({
                        type: hiddenMenuIds.includes(dragging.menuItemId) ? 'item-visible' : 'item-hide',
                        draggedMenuItemId: dragging.menuItemId,
                        draggedMenuItemLabel: dragging.label,
                        instruction: instruction,
                        trigger: 'pointer'
                    });
                    return;
                }
            }
        });
    // Stable dep array: hiddenMenuIds is intentionally excluded — it is kept current via the
    // ref above. Only re-register the monitor when the save function or enabled flag changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dragAndDropSave,
        l1DragAndDropEnabled,
        setDraggingL1Group
    ]);
}

});

parcelRegister("eechR", function(module, exports) {
$parcel$export(module.exports, "GSNSideNavigationLayout", () => $9f8e7788d77788cd$export$5c53281b43e13144);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");

var $7ohZu = parcelRequire("7ohZu");

var $aPed4 = parcelRequire("aPed4");

var $4Hvwe = parcelRequire("4Hvwe");

var $1QF9m = parcelRequire("1QF9m");

var $j7yiP = parcelRequire("j7yiP");

var $4RLhz = parcelRequire("4RLhz");

var $bf6Uo = parcelRequire("bf6Uo");

var $5FnoX = parcelRequire("5FnoX");

var $B3kUb = parcelRequire("B3kUb");
function $9f8e7788d77788cd$export$5c53281b43e13144(props) {
    const { setUserSideNavData: setUserSideNavData } = (0, $bf6Uo.useUserSideNavDataStore)();
    const { onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5FnoX.SideNavVisibilityProvider), {
        setUserSideNavData: setUserSideNavData,
        onExpand: onExpand,
        onCollapse: onCollapse,
        onPeekStart: onPeekStart,
        onPeekEnd: onPeekEnd,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($9f8e7788d77788cd$var$GSNLayoutComponent, {
            ...props
        })
    });
}
$9f8e7788d77788cd$export$5c53281b43e13144.displayName = "GSNSideNavigationLayout";
function $9f8e7788d77788cd$var$GSNLayoutComponent({ preMainElem: preMainElem, postMainElem: postMainElem, bottomElem: bottomElem, children: children, testId: testId, sideNavContentRef: sideNavContentRef }) {
    const { fireEvent: fireEvent } = (0, $aPed4.useAnalyticsEvents)();
    const { userSideNavData: userSideNavData } = (0, $bf6Uo.useUserSideNavDataStore)();
    const { onCollapse: onCollapse, onExpand: onExpand, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd } = (0, $5FnoX.useSideNavVisibility)();
    const internalSideNavRef = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useRef(null);
    const combinedRef = (0, $euxye.useCallback)((instance)=>{
        internalSideNavRef.current = instance;
        if (typeof sideNavContentRef === 'function') sideNavContentRef(instance);
        else if (sideNavContentRef) sideNavContentRef.current = instance;
    }, [
        sideNavContentRef
    ]);
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $4RLhz.useOptions)();
    const { fireViewedSideNavEvent: fireViewedSideNavEvent } = (0, $1QF9m.useNavAnalytics)();
    const fireScrollAnalytics = (0, $euxye.useCallback)((direction)=>{
        fireEvent('ui.sideNav.scrolled.sideNavMenu', {
            scrollDirection: direction
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fireEvent
    ]);
    (0, $j7yiP.useScrollDirection)({
        onScroll: fireScrollAnalytics,
        ref: internalSideNavRef
    });
    (0, $4Hvwe.useInViewport)({
        ref: internalSideNavRef,
        rootMargin: '0px',
        onInViewport: fireViewedSideNavEvent
    });
    (0, $euxye.useEffect)(()=>{
        if (!l1DragAndDropEnabled) return;
        const scrollable = internalSideNavRef.current;
        (0, $jiTLE.default)(scrollable, 'sideNavContentRef must be set');
        return (0, $7ohZu.autoScrollForElements)({
            element: scrollable,
            canScroll: ({ source: source })=>source.data.type === 'menu-item'
        });
    }, [
        l1DragAndDropEnabled
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $B3kUb.SideNavigationLayout), {
        testId: testId,
        onExpand: onExpand,
        onCollapse: onCollapse,
        onPeekStart: onPeekStart,
        onPeekEnd: onPeekEnd,
        defaultWidth: userSideNavData.defaultWidth,
        defaultCollapsed: userSideNavData.defaultCollapsed,
        sideNavContentRef: combinedRef,
        preMainElem: preMainElem,
        postMainElem: postMainElem,
        onResizeEnd: onResizeEnd,
        onResizeStart: onResizeStart,
        bottomElem: bottomElem,
        children: children
    });
}
$9f8e7788d77788cd$var$GSNLayoutComponent.displayName = "GSNLayoutComponent";

});
parcelRegister("4Hvwe", function(module, exports) {
$parcel$export(module.exports, "useInViewport", () => $f01058d3462fef6d$export$6215040b989f9b0f);

var $euxye = parcelRequire("euxye");
function $f01058d3462fef6d$export$6215040b989f9b0f({ ref: ref, rootMargin: rootMargin = '0px 0px 200px 0px', onInViewport: onInViewport }) {
    // Use a ref instead of state to track viewport visibility.
    // This avoids hydration mismatches caused by IntersectionObserver firing immediately
    // after mount and calling a useState setter, which triggers a re-render.
    // The ref is exposed via a getter for consumers that only need the current value.
    const isInViewportRef = (0, $euxye.useRef)(false);
    (0, $euxye.useEffect)(()=>{
        if (!ref.current) {
            isInViewportRef.current = false;
            return;
        }
        const observer = new IntersectionObserver(([entry])=>{
            isInViewportRef.current = entry.isIntersecting;
            // Call the callback directly in the observer to avoid a chain-of-computation
            // anti-pattern (effect → state/ref → effect).
            if (entry.isIntersecting && onInViewport) onInViewport();
        }, {
            rootMargin: rootMargin
        });
        observer.observe(ref.current);
        return ()=>observer.disconnect();
    }, [
        rootMargin,
        ref,
        onInViewport
    ]);
}

});

parcelRegister("j7yiP", function(module, exports) {
$parcel$export(module.exports, "useScrollDirection", () => $71d34595dfe8c03a$export$a884902d10f751f2);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $eVMQF = parcelRequire("eVMQF");
const $71d34595dfe8c03a$var$DEBOUNCE_DURATION = 50;
const $71d34595dfe8c03a$var$MIN_SCROLL_OFFSET = 0;
function $71d34595dfe8c03a$export$a884902d10f751f2(params) {
    const { ref: ref, onScroll: onScroll } = params;
    const lastScrollY = (0, $euxye.useRef)(0);
    (0, $euxye.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const onScrollDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($eVMQF)))(()=>{
            const scrollY = ref.current.scrollTop;
            const direction = scrollY > lastScrollY.current ? 'down' : 'up';
            if (scrollY - lastScrollY.current > $71d34595dfe8c03a$var$MIN_SCROLL_OFFSET || scrollY - lastScrollY.current < -1 * $71d34595dfe8c03a$var$MIN_SCROLL_OFFSET) // Call the callback directly in the event handler to avoid a chain-of-computation
            // anti-pattern (effect → state → effect).
            onScroll(direction);
            lastScrollY.current = scrollY > 0 ? scrollY : 0;
        }, $71d34595dfe8c03a$var$DEBOUNCE_DURATION);
        return (0, $glbdM.bind)(ref.current, {
            type: 'scroll',
            listener: onScrollDebounced,
            options: {
                capture: true
            }
        });
    // Only depend on ref and onScrollCallback — no need to re-subscribe when scrollDirection changes.
    }, [
        ref,
        onScroll
    ]);
}

});

parcelRegister("5FnoX", function(module, exports) {
$parcel$export(module.exports, "useSideNavVisibility", () => $71c4f8c1f41ee227$export$4a602ad7e09bdb2c);
$parcel$export(module.exports, "SideNavVisibilityProvider", () => $71c4f8c1f41ee227$export$aac8e996360f6ad9);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");

var $aPed4 = parcelRequire("aPed4");
const $71c4f8c1f41ee227$export$afc6d5ca319092bd = /*#__PURE__*/ (0, $euxye.createContext)(null);
const $71c4f8c1f41ee227$export$4a602ad7e09bdb2c = ()=>{
    const context = (0, $euxye.useContext)($71c4f8c1f41ee227$export$afc6d5ca319092bd);
    (0, $jiTLE.default)(context, 'useSideNavVisibility must be used within an SideNavVisibilityProvider');
    return context;
};
function $71c4f8c1f41ee227$export$aac8e996360f6ad9({ children: children, onCollapse: onCollapse, onExpand: onExpand, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, onResizeEnd: onResizeEnd, onResizeStart: onResizeStart, setUserSideNavData: setUserSideNavData }) {
    const { fireEvent: fireEvent } = (0, $aPed4.useAnalyticsEvents)();
    const onCollapseHandler = (0, $euxye.useCallback)((args)=>{
        fireEvent('ui.sideNav.collapsed', {
            ...args
        });
        setUserSideNavData({
            defaultCollapsed: true
        });
        onCollapse?.(args);
    }, [
        fireEvent,
        onCollapse,
        setUserSideNavData
    ]);
    const onExpandHandler = (0, $euxye.useCallback)((args)=>{
        fireEvent('ui.sideNav.expanded', {
            ...args
        });
        setUserSideNavData({
            defaultCollapsed: false
        });
        onExpand?.(args);
    }, [
        fireEvent,
        onExpand,
        setUserSideNavData
    ]);
    const onPeekStartHandler = (0, $euxye.useCallback)(()=>{
        onPeekStart?.();
    }, [
        onPeekStart
    ]);
    const onPeekEndHandler = (0, $euxye.useCallback)((args)=>{
        onPeekEnd?.(args);
    }, [
        onPeekEnd
    ]);
    const onResizeStartHandler = (0, $euxye.useCallback)((args)=>{
        fireEvent('ui.sideNav.resizeStart', {
            ...args
        });
        onResizeStart?.(args);
    }, [
        fireEvent,
        onResizeStart
    ]);
    const onResizeEndHandler = (0, $euxye.useCallback)((args)=>{
        fireEvent('ui.sideNav.resizeEnd', {
            ...args
        });
        setUserSideNavData({
            defaultWidth: args.finalWidth
        });
        onResizeEnd?.(args);
    }, [
        fireEvent,
        onResizeEnd,
        setUserSideNavData
    ]);
    const stableContextValue = (0, $euxye.useMemo)(()=>({
            onExpand: onExpandHandler,
            onCollapse: onCollapseHandler,
            onPeekStart: onPeekStartHandler,
            onPeekEnd: onPeekEndHandler,
            onResizeEnd: onResizeEndHandler,
            onResizeStart: onResizeStartHandler
        }), [
        onExpandHandler,
        onCollapseHandler,
        onResizeEndHandler,
        onResizeStartHandler,
        onPeekStartHandler,
        onPeekEndHandler
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($71c4f8c1f41ee227$export$afc6d5ca319092bd.Provider, {
        value: stableContextValue,
        children: children
    });
}
$71c4f8c1f41ee227$export$aac8e996360f6ad9.displayName = "SideNavVisibilityProvider";

});


parcelRegister("d338J", function(module, exports) {
$parcel$export(module.exports, "PostMainItems", () => $91d2a6f49b95cb20$export$b540acb5f181a91e);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $1MNmN = parcelRequire("1MNmN");

var $c69sa = parcelRequire("c69sa");

var $5BP41 = parcelRequire("5BP41");

var $djYhH = parcelRequire("djYhH");

var $lNZ69 = parcelRequire("lNZ69");

var $aWAN2 = parcelRequire("aWAN2");

var $13WSK = parcelRequire("13WSK");
var $9sYLJ = parcelRequire("9sYLJ");
var $TmJ6X = parcelRequire("TmJ6X");

var $2CeGr = parcelRequire("2CeGr");

var $4Hvwe = parcelRequire("4Hvwe");

var $1QF9m = parcelRequire("1QF9m");

var $69tcH = parcelRequire("69tcH");

var $4RLhz = parcelRequire("4RLhz");

var $kBtiJ = parcelRequire("kBtiJ");

var $bcBnu = parcelRequire("bcBnu");

var $lyg9d = parcelRequire("lyg9d");


var $jbu8T = parcelRequire("jbu8T");

var $8YxSe = parcelRequire("8YxSe");

var $y7eOy = parcelRequire("y7eOy");

var $aqnwY = parcelRequire("aqnwY");

var $79qLH = parcelRequire("79qLH");
function $91d2a6f49b95cb20$export$b540acb5f181a91e({ postItemsElem: postItemsElem, postMainElem: postMainElem, draggingL1Group: draggingL1Group = null, openShortcutsInSameTab: openShortcutsInSameTab, viewAllAppsConfig: viewAllAppsConfig, ShortcutsSlot: ShortcutsSlot }) {
    const { appLabel: appLabel, disableMenuCustomization: disableMenuCustomization, intlMode: intlMode, l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $4RLhz.useOptions)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { allItems: allItems, growthItemShortcuts: growthItemShortcuts, shortcuts: shortcuts } = (0, $69tcH.useItemsAndShortcuts)();
    const peekMenuId = (0, $kBtiJ.usePeekMenuId)();
    const { hiddenItemMenuIds: hiddenItemMenuIds, hiddenShortcutMenuIds: hiddenShortcutMenuIds, visibleShortcutMenuIds: visibleShortcutMenuIds, hiddenMenuIds: hiddenMenuIds } = (0, $lyg9d.useUserMenuDataShapes)();
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent } = (0, $1QF9m.useNavAnalytics)();
    const { shortcutsWithMenuId: shortcutsWithMenuId } = (0, $bcBnu.useGlobalShortcutsTransformation)({
        shortcutsConfig: shortcuts,
        visibleShortcuts: visibleShortcutMenuIds,
        growthShortcutsConfig: growthItemShortcuts
    });
    const { groupDropIndicatorRef: groupDropIndicatorRef, dragSource: dragSource } = (0, $TmJ6X.useDragState)({
        dragAndDropEnabled: l1DragAndDropEnabled,
        isItemData: (0, $9sYLJ.isL1ItemData)
    });
    const handleClickMoreMenuItem = (0, $euxye.useCallback)(()=>{
        fireClickedSideNavItemEvent((0, $8YxSe.INTERNAL_GLOBAL_ITEMS).more, 'postMain');
    }, [
        fireClickedSideNavItemEvent
    ]);
    const handleClickCustomizeItem = (0, $euxye.useCallback)(()=>{
        fireClickedSideNavItemEvent((0, $8YxSe.INTERNAL_GLOBAL_ITEMS).customize, 'postMain');
    }, [
        fireClickedSideNavItemEvent
    ]);
    const peekItem = !!peekMenuId && hiddenItemMenuIds.includes(peekMenuId) && allItems[peekMenuId];
    const isDragSourceHidden = dragSource && hiddenMenuIds.includes(dragSource);
    const canMenuItemBeHidden = (0, $euxye.useMemo)(()=>{
        return !!(draggingL1Group && dragSource && allItems[dragSource]?.isHideable !== false);
    }, [
        allItems,
        dragSource,
        draggingL1Group
    ]);
    const moreMenu = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jbu8T.default), {
        appLabel: appLabel,
        intlMode: intlMode,
        items: allItems,
        itemIds: hiddenItemMenuIds,
        onClickCustomizeSidebarMenuItem: handleClickCustomizeItem,
        onClickMoreMenuTrigger: handleClickMoreMenuItem,
        openShortcutsInSameTab: openShortcutsInSameTab,
        shortcutItemIds: hiddenShortcutMenuIds,
        shortcutItems: shortcuts
    });
    const globalAppShortcuts = /*#__PURE__*/ (0, $e79Pd.jsx)($91d2a6f49b95cb20$var$GlobalAppShortcuts, {
        shortcutItems: shortcutsWithMenuId,
        openShortcutsInSameTab: openShortcutsInSameTab,
        viewAllAppsConfig: viewAllAppsConfig,
        ShortcutsSlot: ShortcutsSlot
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $5BP41.default), {
        space: "space.100",
        children: [
            postItemsElem,
            !!shortcutsWithMenuId.length && (l1DragAndDropEnabled ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $13WSK.GroupDropIndicatorWithDragOver), {
                ref: groupDropIndicatorRef,
                isActive: draggingL1Group === (0, $aWAN2.L1_MENU_GROUPS).SHORTCUTS,
                ariaLabel: formatMessage((0, $79qLH.messages).shortcutsSectionScreenReader, {
                    item: dragSource
                }),
                children: globalAppShortcuts
            }) : globalAppShortcuts),
            peekItem && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $djYhH.MenuList), {
                testId: (0, $e695cbb6f90a2d72$export$88dd4a9e4ffa4ec2),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2CeGr.default), {
                    id: peekMenuId,
                    item: peekItem,
                    isInMoreMenu: true,
                    peek: true
                }, peekMenuId)
            }),
            !disableMenuCustomization && (l1DragAndDropEnabled ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $13WSK.GroupDropIndicatorWithDragOver), {
                ref: groupDropIndicatorRef,
                isActive: canMenuItemBeHidden,
                ariaLabel: isDragSourceHidden ? formatMessage((0, $79qLH.messages).showInSidebarSectionScreenReader, {
                    item: dragSource
                }) : formatMessage((0, $79qLH.messages).hideFromSidebarSectionScreenReader, {
                    item: dragSource
                }),
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $c69sa.Box), {
                        xcss: (0, $1MNmN.cx)(canMenuItemBeHidden ? $91d2a6f49b95cb20$var$styles.hidden : $91d2a6f49b95cb20$var$styles.visible),
                        children: moreMenu
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $c69sa.Box), {
                        xcss: (0, $1MNmN.cx)(canMenuItemBeHidden ? $91d2a6f49b95cb20$var$styles.visible : $91d2a6f49b95cb20$var$styles.hidden),
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $djYhH.MenuList), {
                            children: isDragSourceHidden ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $aqnwY.ShowInSidebarButton), {}) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $y7eOy.HideFromSidebarButton), {})
                        })
                    })
                ]
            }) : moreMenu),
            postMainElem
        ]
    });
}
$91d2a6f49b95cb20$export$b540acb5f181a91e.displayName = "PostMainItems";
const $91d2a6f49b95cb20$var$styles = {
    visible: "_1e0c1ule",
    hidden: "_1e0cglyw"
};
function $91d2a6f49b95cb20$var$GlobalAppShortcuts({ openShortcutsInSameTab: openShortcutsInSameTab, shortcutItems: shortcutItems, viewAllAppsConfig: viewAllAppsConfig, ShortcutsSlot: ShortcutsSlot }) {
    const { app: app, intlMode: intlMode, l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $4RLhz.useOptions)();
    const { fireViewedShortcutsEvent: fireViewedShortcutsEvent } = (0, $1QF9m.useNavAnalytics)();
    const containerRef = (0, $euxye.useRef)(null);
    const fireAnalytics = (0, $euxye.useCallback)(()=>fireViewedShortcutsEvent(shortcutItems), [
        fireViewedShortcutsEvent,
        shortcutItems
    ]);
    (0, $4Hvwe.useInViewport)({
        ref: containerRef,
        onInViewport: fireAnalytics
    });
    // A pre-bound shortcuts menu handed to the `ShortcutsSlot` render prop. The
    // host renders this wherever it wants; any props it passes override the
    // GSN-internal defaults. Memoised to keep a stable component identity so the
    // slot subtree is not remounted on every render (see the drag-and-drop
    // rationale in the sibling comment in `PostMainItems`).
    const ShortcutsMenuComponent = (0, $euxye.useCallback)(function BoundGlobalShortcutsMenu(overrides) {
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lNZ69.GlobalShortcutsMenu), {
            shortcutItems: shortcutItems,
            testId: (0, $e695cbb6f90a2d72$export$ee2a9579670b9420),
            ...overrides,
            enableDragAndDrop: l1DragAndDropEnabled,
            intlMode: intlMode,
            openInSameTab: openShortcutsInSameTab,
            product: app,
            viewAllAppsConfig: viewAllAppsConfig
        });
    }, [
        app,
        intlMode,
        l1DragAndDropEnabled,
        openShortcutsInSameTab,
        shortcutItems,
        viewAllAppsConfig
    ]);
    // Inline the gate (rather than calling `componentWithFG` inside the render
    // body) so the rendered tree's component identity is stable across
    // renders. See sibling comment in `PostMainItems` for the rationale.
    const shortcutsMenu = ShortcutsSlot ? /*#__PURE__*/ (0, $e79Pd.jsx)(ShortcutsSlot, {
        Component: ShortcutsMenuComponent,
        shortcutItems: shortcutItems
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)(ShortcutsMenuComponent, {});
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $c69sa.Box), {
        ref: containerRef,
        children: shortcutsMenu
    });
}
$91d2a6f49b95cb20$var$GlobalAppShortcuts.displayName = "GlobalAppShortcuts";

});
parcelRegister("lNZ69", function(module, exports) {
$parcel$export(module.exports, "GlobalShortcuts", () => $35b9cfeabb619356$export$bae2da217bf9db6);
$parcel$export(module.exports, "GlobalShortcutsMenu", () => $35b9cfeabb619356$export$d64b9883b9bde88c);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $5ySJg = parcelRequire("5ySJg");

var $iVtau = parcelRequire("iVtau");

var $3PC9r = parcelRequire("3PC9r");

var $3BBB7 = parcelRequire("3BBB7");

var $djYhH = parcelRequire("djYhH");

var $7NmHC = parcelRequire("7NmHC");
var $hWvME = parcelRequire("hWvME");

var $f3A47 = parcelRequire("f3A47");
var $37KTn = parcelRequire("37KTn");

var $lJjYk = parcelRequire("lJjYk");

var $dFZc1 = parcelRequire("dFZc1");

parcelRequire("9LEhY");
var $6iPh2 = parcelRequire("6iPh2");

var $f4ngv = parcelRequire("f4ngv");

var $4EQsR = parcelRequire("4EQsR");

var $4u4Z8 = parcelRequire("4u4Z8");

var $6vSDf = parcelRequire("6vSDf");
const $35b9cfeabb619356$export$9da1f15784a2a312 = $35b9cfeabb619356$var$GlobalShortcutsRelay;
const $35b9cfeabb619356$export$bae2da217bf9db6 = (0, $iVtau.componentWithFG)('navx-4463-gas-agg-migration', $35b9cfeabb619356$var$GlobalShortcutsRelay, $35b9cfeabb619356$var$GlobalShortcutsBFF);
function $35b9cfeabb619356$var$GlobalShortcutsRelay(props) {
    const { product: product } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3BBB7.default), {
        name: (0, $c1964b3eba4c11e5$export$fe240e33002221f),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f3A47.NavErrorBoundary), {
            errorMessages: (0, $4EQsR.defaultMessages),
            sentryConfig: {
                product: product
            },
            silent: true,
            ufoInteractionName: (0, $c1964b3eba4c11e5$export$fe240e33002221f),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)($35b9cfeabb619356$var$GlobalShortcutsInnerRelay, {
                ...props
            })
        })
    });
}
$35b9cfeabb619356$var$GlobalShortcutsRelay.displayName = "GlobalShortcutsRelay";
function $35b9cfeabb619356$var$GlobalShortcutsBFF(props) {
    const { product: product } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hWvME.BFFProvider), {
        consumer: (0, $7NmHC.BFFConsumerEnum).GLOBAL_SHORTCUTS,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3BBB7.default), {
            name: (0, $c1964b3eba4c11e5$export$fe240e33002221f),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f3A47.NavErrorBoundary), {
                errorMessages: (0, $4EQsR.defaultMessages),
                sentryConfig: {
                    product: product
                },
                silent: true,
                ufoInteractionName: (0, $c1964b3eba4c11e5$export$fe240e33002221f),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)($35b9cfeabb619356$var$GlobalShortcutsInnerBFF, {
                    ...props
                })
            })
        })
    });
}
$35b9cfeabb619356$var$GlobalShortcutsBFF.displayName = "GlobalShortcutsBFF";
function $35b9cfeabb619356$var$GlobalShortcutsInnerRelay({ cloudId: cloudId, product: product, shortcutItems: rawShortcutItems, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, testId: testId, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig, openInSameTab: openInSameTab }) {
    const { handleError: handleError } = (0, $37KTn.useNavBoundaryContext)({
        location: (0, $0d02ca2fc86ffe27$export$1cb3fe63ec81f460),
        // Log backend errors only to Sentry
        // see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
        sentryConfig: {
            product: product
        },
        disableAnalytics: true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lJjYk.default), {
        cloudId: cloudId,
        onError: handleError,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks,
        product: product,
        shortcutsConfig: rawShortcutItems,
        children: (shortcutItems)=>/*#__PURE__*/ (0, $e79Pd.jsx)($35b9cfeabb619356$export$d64b9883b9bde88c, {
                enableDragAndDrop: enableDragAndDrop,
                openInSameTab: openInSameTab,
                product: product,
                shortcutItems: shortcutItems,
                testId: testId,
                viewAllAppsConfig: viewAllAppsConfig
            })
    });
}
$35b9cfeabb619356$var$GlobalShortcutsInnerRelay.displayName = "GlobalShortcutsInnerRelay";
function $35b9cfeabb619356$var$GlobalShortcutsInnerBFF({ cloudId: cloudId, product: product, shortcutItems: rawShortcutItems, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, testId: testId, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig, openInSameTab: openInSameTab }) {
    const { handleError: handleError } = (0, $37KTn.useNavBoundaryContext)({
        location: (0, $0d02ca2fc86ffe27$export$1cb3fe63ec81f460),
        // Log backend errors only to Sentry
        // see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
        sentryConfig: {
            product: product
        },
        disableAnalytics: true
    });
    const shortcutItems = (0, $6iPh2.useGlobalShortcutsDataBFF)({
        shortcutsConfig: rawShortcutItems,
        cloudId: cloudId,
        onError: handleError,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks,
        product: product
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($35b9cfeabb619356$export$d64b9883b9bde88c, {
        enableDragAndDrop: enableDragAndDrop,
        openInSameTab: openInSameTab,
        product: product,
        shortcutItems: shortcutItems,
        testId: testId,
        viewAllAppsConfig: viewAllAppsConfig
    });
}
$35b9cfeabb619356$var$GlobalShortcutsInnerBFF.displayName = "GlobalShortcutsInnerBFF";
function $35b9cfeabb619356$export$d64b9883b9bde88c({ testId: testId, shortcutItems: shortcutItems = [], product: product, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig = {}, openInSameTab: openInSameTab, intlMode: intlMode = 'async' }) {
    const IntlWrapper = intlMode === 'inherit' ? (0, $euxye.Fragment) : (0, $dFZc1.GlobalShortcutsWithIntlProvider);
    const mappedShortcutItems = (0, $euxye.useMemo)(()=>{
        return shortcutItems.map((item, index)=>{
            let key = item.type === 'link' && item.apsKey || `shortcut-${index}`;
            if (item.type === 'component') key = item?.apsKey ?? item.menuItemId ?? `shortcut-${index}`;
            return {
                ...item,
                key: key
            };
        });
    }, [
        shortcutItems
    ]);
    const createLinkItem = (0, $euxye.useCallback)((shortcut)=>{
        if (shortcut.type === 'component') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4u4Z8.ShortcutMenuItem), {
            shortcut: shortcut,
            dragAndDropEnabled: enableDragAndDrop
        }, shortcut.key);
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4u4Z8.ShortcutMenuItem), {
            shortcut: shortcut,
            openInSameTab: openInSameTab,
            product: product
        }, shortcut.key);
    }, [
        product,
        openInSameTab,
        enableDragAndDrop
    ]);
    const shortcutList = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $djYhH.MenuList), {
        children: [
            mappedShortcutItems?.map(createLinkItem),
            viewAllAppsConfig?.path && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6vSDf.ViewAllAppsItem), {
                ...viewAllAppsConfig,
                product: product
            })
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)(IntlWrapper, {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5ySJg.NavigationAnalyticsContext), {
            data: {
                product: product
            },
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3PC9r.default), {
                testId: testId,
                children: enableDragAndDrop ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f4ngv.DragAndDropOptionsProvider), {
                    enabled: enableDragAndDrop,
                    children: shortcutList
                }) : shortcutList
            })
        })
    });
}
$35b9cfeabb619356$export$d64b9883b9bde88c.displayName = "GlobalShortcutsMenu";

});
/**
 * Constants representing locations within the navigation system where errors might occur.
 * These help in identifying the source of errors for logging and debugging purposes.
 */ const $0d02ca2fc86ffe27$export$1cb3fe63ec81f460 = 'global-shortcuts';
const $0d02ca2fc86ffe27$export$7b1d5fb8b81e96a9 = 'ribbon';

parcelRegister("dFZc1", function(module, exports) {
$parcel$export(module.exports, "GlobalShortcutsWithIntlProvider", () => $a95792d46ca1f314$export$6b89dea1a4334953);

var $hE9Uq = parcelRequire("hE9Uq");

var $hkZMV = parcelRequire("hkZMV");

var $8ocwv = parcelRequire("8ocwv");
const $a95792d46ca1f314$export$6b89dea1a4334953 = (0, $hE9Uq.createAsyncIntlProvider)({
    defaultMessages: (0, $hkZMV.default),
    asyncLanguages: $8ocwv.asyncLanguages
});

});
parcelRegister("8ocwv", function(module, exports) {
$parcel$export(module.exports, "asyncLanguages", () => $70ad32d1563c4b32$export$3770c7a7737d463c);
// Map of locale code -> dynamic import for that locale's i18n message bundle.
// Each entry is code-split into its own webpack chunk.
//
// AUTO-GENERATED — do not edit by hand.
// Regenerate with: yarn generate-async-languages <package-path>
// (script lives in platform/build/i18n/generate-async-languages.js)































const $70ad32d1563c4b32$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("7H3A4")),
    da: ()=>(parcelRequire("lBOFG")),
    de: ()=>(parcelRequire("3EzwE")),
    en: ()=>Promise.resolve((parcelRequire("hkZMV"))),
    'en-GB': ()=>(parcelRequire("hbCDo")),
    'en-ZZ': ()=>(parcelRequire("inTAP")),
    es: ()=>(parcelRequire("hWgVj")),
    fi: ()=>(parcelRequire("aEakk")),
    fr: ()=>(parcelRequire("hBfqI")),
    hr: ()=>(parcelRequire("2XnC3")),
    hu: ()=>(parcelRequire("a8mtE")),
    it: ()=>(parcelRequire("7MFXQ")),
    ja: ()=>(parcelRequire("iGW7T")),
    ko: ()=>(parcelRequire("hDhpy")),
    nb: ()=>(parcelRequire("l2sQJ")),
    nl: ()=>(parcelRequire("9C7MT")),
    pl: ()=>(parcelRequire("1eToU")),
    'pt-BR': ()=>(parcelRequire("le0vt")),
    ru: ()=>(parcelRequire("jGslb")),
    sk: ()=>(parcelRequire("fxCdM")),
    sl: ()=>(parcelRequire("i1jwR")),
    sr: ()=>(parcelRequire("45onF")),
    'sr-RS': ()=>(parcelRequire("bYVPU")),
    'sr-YR': ()=>(parcelRequire("kxfu0")),
    sv: ()=>(parcelRequire("lKxLq")),
    th: ()=>(parcelRequire("8ZLm8")),
    tr: ()=>(parcelRequire("C077J")),
    uk: ()=>(parcelRequire("fOgyT")),
    vi: ()=>(parcelRequire("gqK07")),
    zh: ()=>(parcelRequire("dGUxq")),
    'zh-TW': ()=>(parcelRequire("2332G"))
};

});
parcelRegister("7H3A4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8JdFY").then(()=>parcelRequire('3EmLp'));

});

parcelRegister("lBOFG", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2EQ5d").then(()=>parcelRequire('hvmIQ'));

});

parcelRegister("3EzwE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("qVEde").then(()=>parcelRequire('3InQV'));

});

parcelRegister("hbCDo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bCril").then(()=>parcelRequire('ezEmT'));

});

parcelRegister("inTAP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7XbbU").then(()=>parcelRequire('xZbjF'));

});

parcelRegister("hWgVj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gTszC").then(()=>parcelRequire('bhjlo'));

});

parcelRegister("aEakk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bx7uM").then(()=>parcelRequire('aQPE2'));

});

parcelRegister("hBfqI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kKY6s").then(()=>parcelRequire('dI4QL'));

});

parcelRegister("2XnC3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("al6ob").then(()=>parcelRequire('4PAJl'));

});

parcelRegister("a8mtE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8mmrF").then(()=>parcelRequire('hh8bG'));

});

parcelRegister("7MFXQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("k4nko").then(()=>parcelRequire('9ItqJ'));

});

parcelRegister("iGW7T", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9GjHi").then(()=>parcelRequire('kdkxb'));

});

parcelRegister("hDhpy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lFImt").then(()=>parcelRequire('8rvoL'));

});

parcelRegister("l2sQJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bv6TS").then(()=>parcelRequire('lvJDO'));

});

parcelRegister("9C7MT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("49Jm1").then(()=>parcelRequire('8AyCI'));

});

parcelRegister("1eToU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3OECM").then(()=>parcelRequire('4s8DN'));

});

parcelRegister("le0vt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("h8jWX").then(()=>parcelRequire('dZTlT'));

});

parcelRegister("jGslb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("737ic").then(()=>parcelRequire('hT0pT'));

});

parcelRegister("fxCdM", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("QWbpd").then(()=>parcelRequire('2DkqO'));

});

parcelRegister("i1jwR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i8MIg").then(()=>parcelRequire('6lqrA'));

});

parcelRegister("45onF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cAK6O").then(()=>parcelRequire('dYbHr'));

});

parcelRegister("bYVPU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bR3I8").then(()=>parcelRequire('1LxXK'));

});

parcelRegister("kxfu0", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c0FcI").then(()=>parcelRequire('5TV1m'));

});

parcelRegister("lKxLq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6mMkI").then(()=>parcelRequire('c1bS8'));

});

parcelRegister("8ZLm8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fleLJ").then(()=>parcelRequire('24Dbe'));

});

parcelRegister("C077J", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5dfRh").then(()=>parcelRequire('cUYnz'));

});

parcelRegister("fOgyT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jkAzS").then(()=>parcelRequire('ElCHv'));

});

parcelRegister("gqK07", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cadyC").then(()=>parcelRequire('byIdr'));

});

parcelRegister("dGUxq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3zPEf").then(()=>parcelRequire('gSU6U'));

});

parcelRegister("2332G", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hooBS").then(()=>parcelRequire('3gr64'));

});



const $c1964b3eba4c11e5$export$fe240e33002221f = 'global-shortcuts-platform-component';
const $c1964b3eba4c11e5$export$2158b6d23c9689f5 = 'global-shortcuts-data-loading';

parcelRegister("f4ngv", function(module, exports) {
$parcel$export(module.exports, "DragAndDropOptionsContext", () => $2c8d5b0c05a63bbe$export$c69308b19dea1022);
$parcel$export(module.exports, "DragAndDropOptionsProvider", () => $2c8d5b0c05a63bbe$export$b40e2d2385213009);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $2c8d5b0c05a63bbe$export$c69308b19dea1022 = /*#__PURE__*/ (0, $euxye.createContext)({
    enabled: false
});
const $2c8d5b0c05a63bbe$export$b40e2d2385213009 = ({ children: children, enabled: enabled = false })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)($2c8d5b0c05a63bbe$export$c69308b19dea1022.Provider, {
        value: {
            enabled: enabled
        },
        children: children
    });
};
$2c8d5b0c05a63bbe$export$b40e2d2385213009.displayName = "DragAndDropOptionsProvider";

});

parcelRegister("4EQsR", function(module, exports) {
$parcel$export(module.exports, "defaultMessages", () => $8db81ee8c95604bc$export$628f6f7219a6b8b6);

var $7eNDO = parcelRequire("7eNDO");
const $8db81ee8c95604bc$export$628f6f7219a6b8b6 = (0, $7eNDO.defineMessages)({
    header: {
        id: 'navigation.error.header.default',
        defaultMessage: "We couldn\u2019t load this content",
        description: 'Header when an unknown error occurs'
    },
    description: {
        id: 'navigation.error.description.default',
        defaultMessage: 'Refresh the page and try again',
        description: 'Description when an unknown error occurs'
    }
});

});

parcelRegister("4u4Z8", function(module, exports) {
$parcel$export(module.exports, "ShortcutMenuItem", () => $60bcc5be8ddcc6a9$export$af94fce1535255cc);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $inMxE = parcelRequire("inMxE");

var $f3A47 = parcelRequire("f3A47");

var $iNzjb = parcelRequire("iNzjb");

var $hmHtr = parcelRequire("hmHtr");

var $fiz9P = parcelRequire("fiz9P");

var $25Ubc = parcelRequire("25Ubc");
const $60bcc5be8ddcc6a9$export$af94fce1535255cc = /*#__PURE__*/ (0, $euxye.memo)($60bcc5be8ddcc6a9$export$ca0f90d95927cf81);
function $60bcc5be8ddcc6a9$export$ca0f90d95927cf81(props) {
    const menuId = props.shortcut.key;
    const errorMessageValues = (0, $euxye.useMemo)(()=>({
            menuId: menuId
        }), [
        menuId
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f3A47.NavErrorBoundary), {
        errorMessages: (0, $25Ubc.menuErrorMessages),
        errorMessageValues: errorMessageValues,
        showFlags: true,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($60bcc5be8ddcc6a9$var$ShortcutMenuItemWithoutErrorBoundary, {
            ...props
        })
    }, menuId);
}
$60bcc5be8ddcc6a9$export$ca0f90d95927cf81.displayName = "ShortcutMenuItemInner";
function $60bcc5be8ddcc6a9$var$ShortcutMenuItemWithoutErrorBoundary({ shortcut: shortcut, dragAndDropEnabled: dragAndDropEnabled, product: product, openInSameTab: openInSameTab, isInMoreMenu: isInMoreMenu }) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const labelText = shortcut.label;
    const analyticsName = shortcut.analyticsName || `unknown_${labelText}`;
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment;
    const customComponentDraggableOnClick = (0, $euxye.useCallback)(()=>{
        (0, $fiz9P.fireMenuLinkItemClickAnalyticsEvent)(createAnalyticsEvent, analyticsName);
    }, [
        analyticsName,
        createAnalyticsEvent
    ]);
    if (shortcut.type === 'component') return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hmHtr.MenuComponentItem), {
        shortcut: shortcut,
        dragAndDropEnabled: dragAndDropEnabled,
        isInMoreMenu: isInMoreMenu,
        onClick: customComponentDraggableOnClick
    });
    if (shortcut.type === 'internal') return /*#__PURE__*/ (0, $e79Pd.jsx)(ItemWrapper, {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fiz9P.MenuLinkItem), {
            analyticsName: analyticsName,
            icon: shortcut.icon,
            isSelected: shortcut.isSelected,
            isReorderable: shortcut.isReorderable,
            label: labelText,
            labelElem: shortcut.labelElem,
            openInSameTab: true,
            onClick: shortcut.onClick,
            onRightClick: shortcut.onRightClick,
            product: product,
            url: (0, $iNzjb.getUrlMaybe)(shortcut)
        }, shortcut.key)
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)(ItemWrapper, {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fiz9P.MenuLinkItem), {
            actions: shortcut.actions,
            analyticsName: analyticsName,
            ariaLabel: formatMessage((0, $25Ubc.messages).menuLinkItemAriaLabel, {
                appName: labelText,
                siteName: ''
            }),
            icon: shortcut.icon,
            isReorderable: shortcut.isReorderable,
            label: labelText,
            labelElem: shortcut.labelElem,
            menuItemId: shortcut.menuItemId,
            onClick: shortcut.onClick,
            onFocus: shortcut.onFocus,
            onMouseEnter: shortcut.onMouseEnter,
            onRightClick: shortcut.onRightClick,
            openInSameTab: openInSameTab,
            optionalRef: shortcut.ref,
            optionsMenuElem: shortcut.optionsMenuElem,
            product: product,
            url: (0, $iNzjb.getUrlMaybe)(shortcut)
        }, shortcut.key)
    });
}
$60bcc5be8ddcc6a9$var$ShortcutMenuItemWithoutErrorBoundary.displayName = "ShortcutMenuItemWithoutErrorBoundary";

});
parcelRegister("iNzjb", function(module, exports) {
$parcel$export(module.exports, "getUrlMaybe", () => $8295638b8de83b25$export$ac51fdc0c7ed862d);

var $4R4YE = parcelRequire("4R4YE");
const $8295638b8de83b25$export$ac51fdc0c7ed862d = (options)=>options.url || (0, $4R4YE.getFallbackUrlMaybe)(options.fallbackUrl);

});
parcelRegister("4R4YE", function(module, exports) {
$parcel$export(module.exports, "getFallbackUrlMaybe", () => $a6b56400fb75ed8f$export$1f32ba41e2b31f39);

var $8P1GU = parcelRequire("8P1GU");
const $a6b56400fb75ed8f$export$1f32ba41e2b31f39 = (fallbackUrl)=>{
    if (fallbackUrl === undefined) return undefined;
    return (0, $8P1GU.getFallbackUrl)(fallbackUrl);
};

});
parcelRegister("8P1GU", function(module, exports) {
$parcel$export(module.exports, "getFallbackUrl", () => $b144d3251f11d20b$export$739b3f561aa47bc9);
const $b144d3251f11d20b$export$739b3f561aa47bc9 = (fallbackUrl)=>{
    if (typeof fallbackUrl === 'function') return fallbackUrl();
    // `fallbackUrl` is a string, return it directly
    return fallbackUrl;
};

});



parcelRegister("hmHtr", function(module, exports) {
$parcel$export(module.exports, "MenuComponentItem", () => $f6ff7579b737b685$export$9de4dadf420d5c24);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $ljVHR = parcelRequire("ljVHR");

var $aWAN2 = parcelRequire("aWAN2");

var $e5ti2 = parcelRequire("e5ti2");
var $dsHLR = parcelRequire("dsHLR");
const $f6ff7579b737b685$var$isMenuComponentDraggableItemConfig = (shortcut)=>{
    return !!(shortcut?.isReorderable && shortcut?.menuItemId);
};
function $f6ff7579b737b685$export$9de4dadf420d5c24({ shortcut: shortcut, onClick: onClick, dragAndDropEnabled: dragAndDropEnabled, isInMoreMenu: isInMoreMenu }) {
    const handleClick = (0, $euxye.useCallback)(()=>{
        onClick?.();
        shortcut.onClick?.();
    }, [
        onClick,
        shortcut
    ]);
    if (dragAndDropEnabled && $f6ff7579b737b685$var$isMenuComponentDraggableItemConfig(shortcut)) return /*#__PURE__*/ (0, $e79Pd.jsx)($f6ff7579b737b685$var$MenuComponentDraggableItem, {
        shortcut: shortcut,
        onClick: handleClick,
        isInMoreMenu: isInMoreMenu
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($f6ff7579b737b685$var$MenuComponentNonDraggableItem, {
        onClick: handleClick,
        shortcut: shortcut,
        isInMoreMenu: isInMoreMenu
    });
}
$f6ff7579b737b685$export$9de4dadf420d5c24.displayName = "MenuComponentItem";
function $f6ff7579b737b685$var$MenuComponentNonDraggableItem({ shortcut: shortcut, onClick: onClick, isInMoreMenu: isInMoreMenu }) {
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment;
    const Component = shortcut.component;
    return /*#__PURE__*/ (0, $e79Pd.jsx)(ItemWrapper, {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
            onClick: onClick,
            isInMoreMenu: isInMoreMenu
        })
    });
}
$f6ff7579b737b685$var$MenuComponentNonDraggableItem.displayName = "MenuComponentNonDraggableItem";
function $f6ff7579b737b685$var$MenuComponentDraggableItem({ shortcut: shortcut, onClick: onClick, isInMoreMenu: isInMoreMenu }) {
    const Component = shortcut.component;
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment;
    const [isExpandOrFlyoutOpen, setIsExpandOrFlyoutOpen] = (0, $euxye.useState)(false);
    const onExpandFlyoutToggle = (0, $euxye.useCallback)((open)=>{
        setIsExpandOrFlyoutOpen(open);
    }, []);
    const hookProps = (0, $euxye.useMemo)(()=>({
            id: shortcut.menuItemId,
            isExpandable: true,
            isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
            l1DragAndDropEnabled: true,
            onExpandFlyoutToggle: onExpandFlyoutToggle,
            peek: false,
            item: {
                type: 'custom',
                elemBefore: null,
                label: shortcut.label,
                labelElem: shortcut.labelElem,
                isReorderable: shortcut.isReorderable,
                Component: Component,
                isDraggable: true
            },
            group: (0, $aWAN2.L1_MENU_GROUPS).SHORTCUTS
        }), [
        shortcut.label,
        shortcut.menuItemId,
        shortcut.labelElem,
        Component,
        shortcut.isReorderable,
        isExpandOrFlyoutOpen,
        onExpandFlyoutToggle
    ]);
    const { draggableRef: draggableRef, isDragging: isDragging, maybeDragPreview: maybeDragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $dsHLR.useL1ItemDragAndDrop)(hookProps);
    if (draggableRef === undefined || dropIndicator === undefined || dropTargetRef === undefined) return /*#__PURE__*/ (0, $e79Pd.jsx)($f6ff7579b737b685$var$MenuComponentNonDraggableItem, {
        shortcut: shortcut,
        onClick: onClick,
        isInMoreMenu: isInMoreMenu
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e5ti2.DragIndicatorWrapper), {
        hasDragIndicator: true,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)(ItemWrapper, {
                children: /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                    draggableRef: (0, $ljVHR.default)([
                        draggableRef,
                        shortcut?.ref
                    ]),
                    dropIndicator: dropIndicator,
                    hasDragIndicator: true,
                    isDragging: isDragging,
                    visualContentRef: dropTargetRef,
                    onClick: onClick,
                    isInMoreMenu: isInMoreMenu,
                    isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
                    onExpandFlyoutToggle: onExpandFlyoutToggle
                })
            }),
            maybeDragPreview
        ]
    });
}
$f6ff7579b737b685$var$MenuComponentDraggableItem.displayName = "MenuComponentDraggableItem";

});
parcelRegister("e5ti2", function(module, exports) {
$parcel$export(module.exports, "DragIndicatorWrapper", () => $a686345c9053dbef$export$f9bcea5c2cbf8443);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ /**
 * This code is copied from packages/design-system/navigation-system/src/ui/menu-item/menu-item.tsx
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $9S1b6 = parcelRequire("9S1b6");

var $ihEDU = parcelRequire("ihEDU");

var $lU97D = parcelRequire("lU97D");
// Note: this is also used in `drag-handle.tsx`
const $a686345c9053dbef$var$dragHandleDisplayVar = '--drag-handle-display';
const $a686345c9053dbef$var$dragCursorAnimation = null;
const $a686345c9053dbef$var$topLevelSiblingStyles = {
    root: "_kqswh2mm _1e0c1txw _2lx21bp4"
};
const $a686345c9053dbef$var$styles = {
    hasDragIndicator: "_1ifmglyw _1cykglyw _e0jc1txw _fxw76b4r _avx0ru3m _1rnc1amc _132yq7pw"
};
function $a686345c9053dbef$export$f9bcea5c2cbf8443({ children: children, hasDragIndicator: hasDragIndicator }) {
    if (hasDragIndicator) return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
        xcss: (0, $9S1b6.cx)($a686345c9053dbef$var$topLevelSiblingStyles.root, $a686345c9053dbef$var$styles.hasDragIndicator),
        children: [
            children,
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lU97D.DragHandle), {})
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: children
    });
}
$a686345c9053dbef$export$f9bcea5c2cbf8443.displayName = "DragIndicatorWrapper";

});


parcelRegister("fiz9P", function(module, exports) {
$parcel$export(module.exports, "fireMenuLinkItemClickAnalyticsEvent", () => $6c76722254ef979f$export$18a13ecc162cd5c2);
$parcel$export(module.exports, "MenuLinkItem", () => $6c76722254ef979f$export$68ef190193a37bc2);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $5ZMSQ = parcelRequire("5ZMSQ");

var $1YIbA = parcelRequire("1YIbA");


var $inMxE = parcelRequire("inMxE");

var $ljVHR = parcelRequire("ljVHR");

var $a1Bqx = parcelRequire("a1Bqx");

var $egspI = parcelRequire("egspI");

var $ihEDU = parcelRequire("ihEDU");

var $e6rNk = parcelRequire("e6rNk");

var $aWAN2 = parcelRequire("aWAN2");

var $dsHLR = parcelRequire("dsHLR");

var $dpcSS = parcelRequire("dpcSS");

var $6yzu3 = parcelRequire("6yzu3");

var $3ke5K = parcelRequire("3ke5K");

var $36SNA = parcelRequire("36SNA");

var $hnOVZ = parcelRequire("hnOVZ");
const $6c76722254ef979f$export$18a13ecc162cd5c2 = (createAnalyticsEvent, analyticsName)=>{
    createAnalyticsEvent({
        eventType: (0, $6d4033511f75ada1$export$a1562d08625f5d7e),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'globalNavigation',
        attributes: {
            name: analyticsName
        }
    }).fire((0, $dpcSS.ANALYTICS_CHANNEL));
};
/**
 * Utility to return whether actions and options should be shown
 */ const $6c76722254ef979f$var$getShouldShowActionsAndOptions = (actions, optionsMenuElem)=>actions && actions.length >= 0 || !!optionsMenuElem;
/**
 * Actions and Options component to render both the action menu and options menu
 * beside each other on hover/focus
 */ const $6c76722254ef979f$var$ActionsAndOptions = ({ actions: actions, analyticsName: analyticsName, optionsMenuElem: optionsMenuElem })=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            actions && actions.length && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $36SNA.ShortcutActionMenu), {
                actions: actions,
                analyticsName: analyticsName
            }),
            optionsMenuElem
        ]
    });
$6c76722254ef979f$var$ActionsAndOptions.displayName = "ActionsAndOptions";
const $6c76722254ef979f$var$MenuLinkItemComponent = ({ url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, optionalRef: optionalRef, isSelected: isSelected, openInSameTab: openInSameTab, optionsMenuElem: optionsMenuElem, analyticsName: analyticsName })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const mergedRefs = (0, $ljVHR.default)(optionalRef ? [
        optionalRef
    ] : []);
    const shouldShowActionsAndOptions = $6c76722254ef979f$var$getShouldShowActionsAndOptions(actions, optionsMenuElem);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e6rNk.LinkMenuItem), {
        actionsOnHover: shouldShowActionsAndOptions && /*#__PURE__*/ (0, $e79Pd.jsx)($6c76722254ef979f$var$ActionsAndOptions, {
            actions: actions,
            analyticsName: analyticsName,
            optionsMenuElem: optionsMenuElem
        }),
        elemBefore: icon,
        elemAfter: !openInSameTab && ((0, $egspI.fg)('navx-4022-gas-icons-a11y-fix') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
            "aria-hidden": "true",
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))), {
                label: formatMessage((0, $hnOVZ.messages).linkExternalIconLabel),
                size: "small",
                spacing: "spacious"
            })
        }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))), {
            label: formatMessage((0, $hnOVZ.messages).linkExternalIconLabel),
            size: "small",
            spacing: "spacious"
        })),
        href: url || '',
        target: openInSameTab ? '_self' : '_blank',
        onClick: onClick,
        ref: mergedRefs,
        isSelected: isSelected,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
            "aria-label": ariaLabel,
            children: labelElem ?? label
        })
    });
};
$6c76722254ef979f$var$MenuLinkItemComponent.displayName = "MenuLinkItemComponent";
const $6c76722254ef979f$var$MenuLinkItemDraggableComponent = ({ url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, isReorderable: isReorderable, optionalRef: optionalRef, menuItemId: menuItemId, openInSameTab: openInSameTab, optionsMenuElem: optionsMenuElem, analyticsName: analyticsName, isSelected: isSelected })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { enabled: enabled } = (0, $3ke5K.useDragAndDropOptions)();
    const { draggableRef: draggableRef, isDragging: isDragging, maybeDragPreview: maybeDragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $dsHLR.useL1ItemDragAndDrop)({
        id: menuItemId,
        isExpandable: false,
        isExpandOrFlyoutOpen: false,
        l1DragAndDropEnabled: enabled,
        onExpandFlyoutToggle: ()=>{},
        peek: false,
        item: {
            type: 'link',
            elemBefore: icon,
            label: label,
            labelElem: labelElem,
            href: url || '',
            isReorderable: isReorderable
        },
        group: (0, $aWAN2.L1_MENU_GROUPS).SHORTCUTS
    });
    // Can possibly be undefined
    const draggableRefCollection = draggableRef ? [
        draggableRef
    ] : [];
    const mergedRefs = (0, $ljVHR.default)(optionalRef ? [
        optionalRef,
        ...draggableRefCollection
    ] : [
        ...draggableRefCollection
    ]);
    const shouldShowActionsAndOptions = $6c76722254ef979f$var$getShouldShowActionsAndOptions(actions, optionsMenuElem);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e6rNk.LinkMenuItem), {
                isDragging: isDragging,
                hasDragIndicator: true,
                ref: mergedRefs,
                dropIndicator: dropIndicator,
                visualContentRef: dropTargetRef,
                actionsOnHover: shouldShowActionsAndOptions && /*#__PURE__*/ (0, $e79Pd.jsx)($6c76722254ef979f$var$ActionsAndOptions, {
                    actions: actions,
                    analyticsName: analyticsName,
                    optionsMenuElem: optionsMenuElem
                }),
                elemBefore: icon,
                elemAfter: !openInSameTab && ((0, $egspI.fg)('navx-4022-gas-icons-a11y-fix') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))), {
                        label: formatMessage((0, $hnOVZ.messages).linkExternalIconLabel),
                        size: "small",
                        spacing: "spacious"
                    })
                }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))), {
                    label: formatMessage((0, $hnOVZ.messages).linkExternalIconLabel),
                    size: "small",
                    spacing: "spacious"
                })),
                href: url || '',
                target: openInSameTab ? '_self' : '_blank',
                isSelected: isSelected,
                onClick: onClick,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                    "aria-label": ariaLabel,
                    children: labelElem ?? label
                })
            }),
            maybeDragPreview
        ]
    });
};
$6c76722254ef979f$var$MenuLinkItemDraggableComponent.displayName = "MenuLinkItemDraggableComponent";
const $6c76722254ef979f$export$68ef190193a37bc2 = ({ analyticsName: analyticsName, url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, onRightClick: onRightClick, onFocus: onFocus, onMouseEnter: onMouseEnter, optionalRef: optionalRef, isReorderable: isReorderable, menuItemId: menuItemId, isSelected: isSelected, product: product = 'globalNavigation', openInSameTab: openInSameTab })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { enabled: dndEnabled } = (0, $3ke5K.useDragAndDropOptions)();
    const analyticsUrlWrapper = (0, $5ZMSQ.default)({
        bridge: 'globalShortcuts',
        product: product
    });
    const getTargetUrl = (0, $euxye.useCallback)((url)=>{
        // For SPA links, we don't want to wrap the URL
        if (!$6c76722254ef979f$var$isValidUrl(url)) return url;
        try {
            const parsedUrl = new URL(url);
            const continueParam = parsedUrl.searchParams.get('continue');
            if (!continueParam) // If there is no continue param, we just wrap the whole URL
            return analyticsUrlWrapper(url);
            // Safely deserialize identity links e.g: https://id.atlassian.com/login?login_hint=...
            const wrappedContinueUrl = analyticsUrlWrapper(continueParam);
            // Reconstruct the original URL with the wrapped continue param
            parsedUrl.searchParams.set('continue', wrappedContinueUrl);
            return parsedUrl.toString();
        } catch  {
            // Gracefully handle any URL parsing errors by returning the original URL
            // TODO: Log error to Sentry
            return url;
        }
    }, [
        analyticsUrlWrapper
    ]);
    const onClickMenuLinkItem = (0, $euxye.useCallback)((event)=>{
        $6c76722254ef979f$export$18a13ecc162cd5c2(createAnalyticsEvent, analyticsName);
        onClick?.(event);
    }, [
        createAnalyticsEvent,
        analyticsName,
        onClick
    ]);
    // If a shortcut doesn't have a URL, don't show it. This is a change from earlier behaviour in which
    // the shortcut would be shown, but greyed-out (disabled).
    if (!url) return null;
    const targetUrl = getTargetUrl(url);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6yzu3.ElementEventListener), {
        onRightClick: onRightClick,
        onMouseEnter: onMouseEnter,
        onFocus: onFocus,
        children: dndEnabled && menuItemId ? /*#__PURE__*/ (0, $e79Pd.jsx)($6c76722254ef979f$var$MenuLinkItemDraggableComponent, {
            optionalRef: optionalRef,
            url: targetUrl,
            icon: icon,
            ariaLabel: ariaLabel,
            label: label,
            labelElem: labelElem,
            actions: actions,
            onClick: onClickMenuLinkItem,
            isReorderable: isReorderable,
            isSelected: isSelected,
            menuItemId: menuItemId,
            openInSameTab: openInSameTab
        }) : /*#__PURE__*/ (0, $e79Pd.jsx)($6c76722254ef979f$var$MenuLinkItemComponent, {
            optionalRef: optionalRef,
            url: targetUrl,
            icon: icon,
            ariaLabel: ariaLabel,
            label: label,
            labelElem: labelElem,
            actions: actions,
            onClick: onClickMenuLinkItem,
            isReorderable: isReorderable,
            isSelected: isSelected,
            openInSameTab: openInSameTab
        })
    });
};
$6c76722254ef979f$export$68ef190193a37bc2.displayName = "MenuLinkItem";
const $6c76722254ef979f$var$isValidUrl = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch  {
        return false;
    }
};

});
parcelRegister("6yzu3", function(module, exports) {
$parcel$export(module.exports, "ElementEventListener", () => $148357adb9004b61$export$8209b3c2d1620841);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");
const $148357adb9004b61$export$8209b3c2d1620841 = ({ onFocus: onFocus, onMouseEnter: onMouseEnter, onRightClick: onRightClick, children: children })=>{
    const wrapperRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (!wrapperRef.current || !onRightClick) return;
        const handleMouseDown = (e)=>{
            const isLink = e.target.closest('a');
            if (isLink && e.button !== 0) onRightClick();
        };
        const unbind = (0, $glbdM.bind)(wrapperRef.current, {
            type: 'mousedown',
            listener: handleMouseDown
        });
        return unbind;
    }, [
        onRightClick
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        ref: wrapperRef,
        onMouseEnter: onMouseEnter,
        onFocus: onFocus,
        children: children
    });
};
$148357adb9004b61$export$8209b3c2d1620841.displayName = "ElementEventListener";

});

parcelRegister("3ke5K", function(module, exports) {
$parcel$export(module.exports, "useDragAndDropOptions", () => $16f8069a88e666be$export$eae7963fc47ca0d0);

var $euxye = parcelRequire("euxye");

var $f4ngv = parcelRequire("f4ngv");
function $16f8069a88e666be$export$eae7963fc47ca0d0() {
    const context = (0, $euxye.useContext)((0, $f4ngv.DragAndDropOptionsContext));
    if (!context) return {
        enabled: false
    };
    return {
        enabled: context.enabled
    };
}

});

parcelRegister("36SNA", function(module, exports) {
$parcel$export(module.exports, "ShortcutActionMenu", () => $940c3f58f80c81b4$export$7e648395389e18b0);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");


var $inMxE = parcelRequire("inMxE");

var $m9iwH = parcelRequire("m9iwH");

var $ikOED = parcelRequire("ikOED");

var $ceqcm = parcelRequire("ceqcm");
var $72ldR = parcelRequire("72ldR");

var $egspI = parcelRequire("egspI");

var $1CdDx = parcelRequire("1CdDx");

var $dpcSS = parcelRequire("dpcSS");

var $7tba5 = parcelRequire("7tba5");
const $940c3f58f80c81b4$export$7e648395389e18b0 = ({ actions: actions, analyticsName: analyticsName })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const handleClick = (0, $euxye.useCallback)(()=>{
        setIsOpen(true);
        $940c3f58f80c81b4$var$fireShortcutActionMenuClickedAnalyticsEvent(createAnalyticsEvent, analyticsName);
    }, [
        createAnalyticsEvent,
        analyticsName,
        setIsOpen
    ]);
    const handleDropdownItemClick = (0, $euxye.useCallback)((itemId)=>{
        $940c3f58f80c81b4$var$fireShortcutActionDropdownItemClickedAnalyticsEvent(createAnalyticsEvent, itemId);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1CdDx.Popup), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $72ldR.default), {
                children: actions.map((action, index)=>/*#__PURE__*/ (0, $e79Pd.jsx)($940c3f58f80c81b4$var$ButtonItemWithAnalytics, {
                        index: index,
                        action: action,
                        fireShortcutActionDropdownItemClickedAnalyticsEvent: handleDropdownItemClick,
                        setIsOpen: setIsOpen
                    }))
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                icon: (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ikOED))), {
                        ...props,
                        size: "small"
                    }),
                label: formatMessage((0, $7tba5.messages).shortcutActionOpenMenuLabel),
                onClick: handleClick
            })
    });
};
$940c3f58f80c81b4$export$7e648395389e18b0.displayName = "ShortcutActionMenu";
const $940c3f58f80c81b4$var$ButtonItemWithAnalytics = ({ index: index, action: action, fireShortcutActionDropdownItemClickedAnalyticsEvent: fireShortcutActionDropdownItemClickedAnalyticsEvent, setIsOpen: setIsOpen })=>{
    const handleClick = (0, $euxye.useCallback)((e)=>{
        e.preventDefault();
        action.onClick?.();
        if ((0, $egspI.fg)('navx-global-side-nav-confluence')) fireShortcutActionDropdownItemClickedAnalyticsEvent(action.itemId);
        setIsOpen(false);
    }, [
        action,
        fireShortcutActionDropdownItemClickedAnalyticsEvent,
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ceqcm.default), {
        onClick: handleClick,
        children: action.component
    }, index);
};
$940c3f58f80c81b4$var$ButtonItemWithAnalytics.displayName = "ButtonItemWithAnalytics";
const $940c3f58f80c81b4$var$fireShortcutActionMenuClickedAnalyticsEvent = (createAnalyticsEvent, analyticsName)=>{
    createAnalyticsEvent({
        eventType: (0, $6d4033511f75ada1$export$a1562d08625f5d7e),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'ShortcutActionMenu',
        attributes: {
            name: analyticsName
        }
    }).fire((0, $dpcSS.ANALYTICS_CHANNEL));
};
const $940c3f58f80c81b4$var$fireShortcutActionDropdownItemClickedAnalyticsEvent = (createAnalyticsEvent, itemId)=>{
    createAnalyticsEvent({
        eventType: (0, $6d4033511f75ada1$export$a1562d08625f5d7e),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'ShortcutActionDropdownItem',
        attributes: {
            itemId: itemId
        }
    }).fire((0, $dpcSS.ANALYTICS_CHANNEL));
};

});
parcelRegister("7tba5", function(module, exports) {
$parcel$export(module.exports, "messages", () => $296d199a186ae149$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $296d199a186ae149$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    shortcutActionOpenMenuLabel: {
        id: 'navigation.global-shortcuts.shortcut-action.open-menu-label',
        description: 'Label for shortcut action items button',
        defaultMessage: 'open menu'
    }
});

});


parcelRegister("hnOVZ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $245b7a45cf545209$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $245b7a45cf545209$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    linkExternalIconLabel: {
        id: 'navigation.global-shortcuts.menu-link-item.link-external-item-label',
        description: 'Label for the link external icon',
        defaultMessage: 'Open external link icon'
    }
});

});


parcelRegister("25Ubc", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f6e291baf6e73a48$export$defe85febe8b728c);
$parcel$export(module.exports, "menuErrorMessages", () => $f6e291baf6e73a48$export$b010a30b3233e0c5);

var $7eNDO = parcelRequire("7eNDO");
const $f6e291baf6e73a48$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    menuLinkItemAriaLabel: {
        id: 'navigation.global-shortcuts.shortcut-link-item.aria-label',
        description: 'Accessibility label for individual app shortcut items in the global shortcuts menu. The placeholder {appName} is substituted with the application name (e.g., "Jira", "Confluence"), and {siteName} is substituted with the site name if applicable (e.g., " - Engineering"). Example: "Jira - Engineering". Assistive technologies use this label to announce the app and site context to users.',
        defaultMessage: '{appName}{siteName}'
    }
});
const $f6e291baf6e73a48$export$b010a30b3233e0c5 = (0, $7eNDO.defineMessages)({
    header: {
        id: 'navigation.global-shortcuts.error.header',
        defaultMessage: "We couldn\u2019t load the shortcut for {menuId}",
        description: 'Header when an unknown error occurs'
    },
    description: {
        id: 'navigation.global-shortcuts.error.description',
        defaultMessage: 'Refresh the page and try again',
        description: 'Description when an unknown error occurs'
    }
});

});


parcelRegister("6vSDf", function(module, exports) {
$parcel$export(module.exports, "ViewAllAppsItem", () => $bf37050354c0ef5a$export$84e063904618ed06);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $aNG0w = parcelRequire("aNG0w");

var $egspI = parcelRequire("egspI");

var $4u4Z8 = parcelRequire("4u4Z8");

var $8Z6T2 = parcelRequire("8Z6T2");
const $bf37050354c0ef5a$var$analyticsName = 'VIEW_ALL_APPS';
function $bf37050354c0ef5a$export$84e063904618ed06({ path: path, isSelected: isSelected, product: product, onNavigate: onNavigate }) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    // Behind `navx-4728-jira-stability-fixes`, memoise the `shortcut` object so the
    // memoised `ShortcutMenuItem` isn't handed a brand-new object (with a fresh
    // icon element) on every render, which would defeat its memo. Hooks must run
    // unconditionally, so this is computed before the early `path` guard below.
    const memoisedShortcut = (0, $euxye.useMemo)(()=>({
            key: $bf37050354c0ef5a$var$analyticsName,
            analyticsName: $bf37050354c0ef5a$var$analyticsName,
            label: formatMessage((0, $8Z6T2.messages).viewAllAppsLabel),
            icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))), {
                label: ""
            }),
            url: path,
            isReorderable: false,
            type: 'internal',
            isSelected: isSelected,
            onClick: onNavigate
        }), [
        formatMessage,
        path,
        isSelected,
        onNavigate
    ]);
    if (!path || path.trim().length < 1) return null;
    const shortcut = (0, $egspI.fg)('navx-4728-jira-stability-fixes') ? memoisedShortcut : {
        key: $bf37050354c0ef5a$var$analyticsName,
        analyticsName: $bf37050354c0ef5a$var$analyticsName,
        label: formatMessage((0, $8Z6T2.messages).viewAllAppsLabel),
        icon: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aNG0w))), {
            label: ""
        }),
        url: path,
        isReorderable: false,
        type: 'internal',
        isSelected: isSelected,
        onClick: onNavigate
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4u4Z8.ShortcutMenuItem), {
        shortcut: shortcut,
        product: product
    });
}
$bf37050354c0ef5a$export$84e063904618ed06.displayName = "ViewAllAppsItem";

});
parcelRegister("8Z6T2", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f8b26f2e2c4fefef$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $f8b26f2e2c4fefef$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    viewAllAppsLabel: {
        id: 'navigation.global-shortcuts.view-all-apps.label',
        description: 'Button in Global App Shortcuts linking to a page to view all available apps',
        defaultMessage: 'View all apps'
    }
});

});



parcelRegister("bcBnu", function(module, exports) {
$parcel$export(module.exports, "useGlobalShortcutsTransformation", () => $c93160093ed2a37e$export$9ef62ebfdd487c3d);

var $euxye = parcelRequire("euxye");

var $iNzjb = parcelRequire("iNzjb");

var $1QF9m = parcelRequire("1QF9m");
const $c93160093ed2a37e$export$9ef62ebfdd487c3d = ({ shortcutsConfig: shortcutsConfig, growthShortcutsConfig: growthShortcutsConfig, visibleShortcuts: visibleShortcuts })=>{
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent } = (0, $1QF9m.useNavAnalytics)();
    // 1. Filter the shortcut config based on visible menu items
    const shortcutsWithMenuId = (0, $euxye.useMemo)(()=>{
        const availableShortcuts = visibleShortcuts.reduce((acc, id)=>{
            const shortcut = shortcutsConfig?.[id];
            if (shortcut) acc.push({
                menuItemId: id,
                ...shortcut
            });
            return acc;
        }, []);
        if (growthShortcutsConfig) availableShortcuts.push(...Object.entries(growthShortcutsConfig).map(([id, shortcut])=>({
                menuItemId: id,
                ...shortcut
            })));
        const availableShortcutsWithNonEmptyUrls = availableShortcuts.filter((shortcut)=>{
            // If a shortcut has no resolvable URL, it may ultimately render nothing.
            // Filter those out so we can avoid rendering the whole GAS block when empty.
            if (shortcut.type === 'link' || shortcut.type === 'internal') {
                const url = (0, $iNzjb.getUrlMaybe)(shortcut);
                return url !== undefined && url.trim() !== '';
            }
            // Component shortcuts can still render meaningful UI without a URL.
            return true;
        });
        return availableShortcutsWithNonEmptyUrls.map((shortcut)=>({
                ...shortcut,
                onClick: ()=>{
                    shortcut.onClick?.();
                    fireClickedSideNavItemEvent(shortcut.menuItemId, 'postMain');
                },
                ...shortcut.type === 'link' && {
                    onRightClick: ()=>{
                        shortcut.onRightClick?.();
                        fireClickedSideNavItemEvent(shortcut.menuItemId, 'postMain', true);
                    }
                }
            }));
    }, [
        visibleShortcuts,
        growthShortcutsConfig,
        shortcutsConfig,
        fireClickedSideNavItemEvent
    ]);
    return {
        // eslint-disable-next-line no-unused-vars
        shortcuts: shortcutsWithMenuId.map(({ menuItemId: menuItemId, ...shortcut })=>shortcut),
        shortcutsWithMenuId: shortcutsWithMenuId
    };
};

});

parcelRegister("jbu8T", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c9a19e64459aa4a$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jH4ta = parcelRequire("jH4ta");

var $kBtiJ = parcelRequire("kBtiJ");

var $8YxSe = parcelRequire("8YxSe");

var $gd7XH = parcelRequire("gd7XH");

var $gEPWh = parcelRequire("gEPWh");
function $7c9a19e64459aa4a$export$2e2bcd8739ae039({ appLabel: appLabel, intlMode: intlMode, itemIds: itemIds, items: items, onClickCustomizeSidebarMenuItem: onClickCustomizeSidebarMenuItem, onClickMoreMenuTrigger: onClickMoreMenuTrigger, openShortcutsInSameTab: openShortcutsInSameTab, shortcutItemIds: shortcutItemIds, shortcutItems: shortcutItems = {} }) {
    const peekMenuId = (0, $kBtiJ.usePeekMenuId)();
    const menuItemComponent = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useCallback(({ closeMenu: closeMenu, menuId: menuId })=>{
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gEPWh.default), {
            id: menuId,
            items: items,
            onClick: closeMenu,
            openShortcutsInSameTab: openShortcutsInSameTab,
            shortcutItems: shortcutItems
        }, menuId);
    }, [
        items,
        shortcutItems,
        openShortcutsInSameTab
    ]);
    const productItemsData = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>{
        return itemIds.map((menuId)=>({
                menuId: menuId,
                visible: false
            }));
    }, [
        itemIds
    ]);
    const appItemsData = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>{
        return shortcutItemIds.map((menuId)=>({
                menuId: menuId,
                visible: false
            }));
    }, [
        shortcutItemIds
    ]);
    const customizeSidebarMenuItem = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useMemo(()=>{
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gd7XH.CustomizeSidebarMenuItem), {
            items: items,
            shortcuts: shortcutItems,
            testId: (0, $8YxSe.CUSTOMIZE_SIDEBAR_MENU_ITEM_TEST_ID),
            appLabel: appLabel,
            onClick: onClickCustomizeSidebarMenuItem
        });
    }, [
        items,
        shortcutItems,
        appLabel,
        onClickCustomizeSidebarMenuItem
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jH4ta.GlobalMoreMenu), {
        appItemsData: appItemsData,
        customizeSidebarMenuItem: customizeSidebarMenuItem,
        intlMode: intlMode,
        menuItemComponent: menuItemComponent,
        onClickMoreMenuTrigger: onClickMoreMenuTrigger,
        peekingMenuIds: peekMenuId ? [
            peekMenuId
        ] : undefined,
        productItemsData: productItemsData,
        testId: (0, $8YxSe.MORE_MENU_TEST_ID)
    });
}
$7c9a19e64459aa4a$export$2e2bcd8739ae039.displayName = "MoreMenu";

});
parcelRegister("jH4ta", function(module, exports) {
$parcel$export(module.exports, "GlobalMoreMenu", () => $16d40ccdc02e91ad$export$6741e824c68e9927);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $jnOWT = parcelRequire("jnOWT");

var $f3A47 = parcelRequire("f3A47");


var $673os = parcelRequire("673os");

var $gax7O = parcelRequire("gax7O");

var $fWOaS = parcelRequire("fWOaS");

var $bbXmG = parcelRequire("bbXmG");
function $16d40ccdc02e91ad$export$6741e824c68e9927(props) {
    const { intlMode: intlMode } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $673os.AsyncIntlProvider), {
        disabled: intlMode === 'inherit',
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jnOWT.default), {
            name: (0, $f6349dd70c1dd18e$export$442bdbffe3dfb793),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f3A47.NavErrorBoundary), {
                errorMessages: (0, $gax7O.messages),
                interactionId: (0, $f6349dd70c1dd18e$export$3a4f595511a311c),
                showFlags: true,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)($16d40ccdc02e91ad$var$GlobalMoreMenuInner, {
                    ...props
                })
            })
        })
    });
}
$16d40ccdc02e91ad$export$6741e824c68e9927.displayName = "GlobalMoreMenu";
function $16d40ccdc02e91ad$var$GlobalMoreMenuInner({ productItemsData: productItemsData, appItemsData: appItemsData = [], menuItemComponent: menuItemComponent, customizeSidebarMenuItem: customizeSidebarMenuItem, moreMenuItemLabel: moreMenuItemLabel, peekingMenuIds: peekingMenuIds = [], onClickMoreMenuTrigger: onClickMoreMenuTrigger, testId: testId, triggerRef: triggerRef, triggerVisualContentRef: triggerVisualContentRef, dropIndicator: dropIndicator }) {
    const { hiddenProductItemsData: hiddenProductItemsData, hiddenAppItemsData: hiddenAppItemsData, shouldShowMoreMenu: shouldShowMoreMenu } = (0, $bbXmG.getHiddenItems)(productItemsData, appItemsData, peekingMenuIds);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fWOaS.MoreMenuPopup), {
        appItemsData: hiddenAppItemsData,
        customizeSidebarMenuItem: customizeSidebarMenuItem,
        dropIndicator: dropIndicator,
        menuItemComponent: menuItemComponent,
        moreMenuItemLabel: moreMenuItemLabel,
        onClickMoreMenuTrigger: onClickMoreMenuTrigger,
        productItemsData: hiddenProductItemsData,
        showMoreMenu: shouldShowMoreMenu,
        testId: testId,
        triggerRef: triggerRef,
        triggerVisualContentRef: triggerVisualContentRef
    });
}
$16d40ccdc02e91ad$var$GlobalMoreMenuInner.displayName = "GlobalMoreMenuInner";

});
const $f6349dd70c1dd18e$export$3a4f595511a311c = 'globalMoreMenuLoad';
const $f6349dd70c1dd18e$export$442bdbffe3dfb793 = 'global-more-menu-load';

parcelRegister("673os", function(module, exports) {
$parcel$export(module.exports, "AsyncIntlProvider", () => $13ea2cb929b4e37c$export$2f688dfcc031530a);

var $hE9Uq = parcelRequire("hE9Uq");

var $e09PY = parcelRequire("e09PY");

var $ablJt = parcelRequire("ablJt");
const $13ea2cb929b4e37c$export$2f688dfcc031530a = (0, $hE9Uq.createAsyncIntlProvider)({
    defaultMessages: (0, $e09PY.default),
    asyncLanguages: $ablJt.asyncLanguages
});

});
parcelRegister("ablJt", function(module, exports) {
$parcel$export(module.exports, "asyncLanguages", () => $3e4af3888ea82f93$export$3770c7a7737d463c);
// Map of locale code -> dynamic import for that locale's i18n message bundle.
// Each entry is code-split into its own webpack chunk.
//
// AUTO-GENERATED — do not edit by hand.
// Regenerate with: yarn generate-async-languages <package-path>
// (script lives in platform/build/i18n/generate-async-languages.js)





























const $3e4af3888ea82f93$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("dpAy4")),
    da: ()=>(parcelRequire("5y3NN")),
    de: ()=>(parcelRequire("irjZX")),
    en: ()=>Promise.resolve((parcelRequire("e09PY"))),
    'en-GB': ()=>(parcelRequire("Lxin3")),
    'en-ZZ': ()=>(parcelRequire("2J8TF")),
    es: ()=>(parcelRequire("5QDGz")),
    fi: ()=>(parcelRequire("iu13y")),
    fr: ()=>(parcelRequire("PZw57")),
    hr: ()=>(parcelRequire("2QKfQ")),
    hu: ()=>(parcelRequire("fFUtz")),
    it: ()=>(parcelRequire("lfxGV")),
    ja: ()=>(parcelRequire("e2B7q")),
    ko: ()=>(parcelRequire("6aPYT")),
    nb: ()=>(parcelRequire("432p1")),
    nl: ()=>(parcelRequire("5twk6")),
    pl: ()=>(parcelRequire("jROKW")),
    'pt-BR': ()=>(parcelRequire("gJrwu")),
    ru: ()=>(parcelRequire("gxzlL")),
    sl: ()=>(parcelRequire("cCEi6")),
    'sr-RS': ()=>(parcelRequire("aF3nd")),
    'sr-YR': ()=>(parcelRequire("eZwK9")),
    sv: ()=>(parcelRequire("7hkWS")),
    th: ()=>(parcelRequire("iGf5z")),
    tr: ()=>(parcelRequire("jMEbv")),
    uk: ()=>(parcelRequire("eBquB")),
    vi: ()=>(parcelRequire("jJVJW")),
    zh: ()=>(parcelRequire("bmnxJ")),
    'zh-TW': ()=>(parcelRequire("9NCTQ"))
};

});
parcelRegister("dpAy4", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8fidL").then(()=>parcelRequire('cF2RZ'));

});

parcelRegister("5y3NN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9UEGR").then(()=>parcelRequire('2nB2I'));

});

parcelRegister("irjZX", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dHNki").then(()=>parcelRequire('fv66D'));

});

parcelRegister("Lxin3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("60lYf").then(()=>parcelRequire('4nhMD'));

});

parcelRegister("2J8TF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("em1TI").then(()=>parcelRequire('6m39J'));

});

parcelRegister("5QDGz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3A7x2").then(()=>parcelRequire('63MjC'));

});

parcelRegister("iu13y", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gy8uq").then(()=>parcelRequire('19QH5'));

});

parcelRegister("PZw57", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dkp8P").then(()=>parcelRequire('sIMgy'));

});

parcelRegister("2QKfQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8ZEmc").then(()=>parcelRequire('iOscv'));

});

parcelRegister("fFUtz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jqs4A").then(()=>parcelRequire('iqcWL'));

});

parcelRegister("lfxGV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aWHdw").then(()=>parcelRequire('l0Qd9'));

});

parcelRegister("e2B7q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aHtS1").then(()=>parcelRequire('9sgwj'));

});

parcelRegister("6aPYT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("aQBmv").then(()=>parcelRequire('fOwQa'));

});

parcelRegister("432p1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("77aDr").then(()=>parcelRequire('7vqzq'));

});

parcelRegister("5twk6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("J29uD").then(()=>parcelRequire('1e2Ct'));

});

parcelRegister("jROKW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iIS7z").then(()=>parcelRequire('eQTN9'));

});

parcelRegister("gJrwu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2NT5b").then(()=>parcelRequire('ioa1R'));

});

parcelRegister("gxzlL", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6rSg2").then(()=>parcelRequire('ewQVD'));

});

parcelRegister("cCEi6", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lORjG").then(()=>parcelRequire('2NeVV'));

});

parcelRegister("aF3nd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("34pzx").then(()=>parcelRequire('5T0Xe'));

});

parcelRegister("eZwK9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gAQVw").then(()=>parcelRequire('6XxXw'));

});

parcelRegister("7hkWS", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2iBCh").then(()=>parcelRequire('f45Wq'));

});

parcelRegister("iGf5z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kGjdQ").then(()=>parcelRequire('96sNo'));

});

parcelRegister("jMEbv", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3ojhp").then(()=>parcelRequire('kxr8L'));

});

parcelRegister("eBquB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7zqhb").then(()=>parcelRequire('iuUqn'));

});

parcelRegister("jJVJW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4BGMj").then(()=>parcelRequire('3qBWK'));

});

parcelRegister("bmnxJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jktMU").then(()=>parcelRequire('aEB1G'));

});

parcelRegister("9NCTQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dFIV1").then(()=>parcelRequire('jdT1z'));

});



parcelRegister("gax7O", function(module, exports) {
$parcel$export(module.exports, "messages", () => $0e56e16d05b1b535$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $0e56e16d05b1b535$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    description: {
        id: 'navigation.global-more-menu.error.description',
        defaultMessage: 'Refresh the page and try again',
        description: 'Description when an unknown error occurs'
    },
    header: {
        id: 'navigation.global-more-menu.error.header',
        defaultMessage: "We couldn\u2019t load more sidebar options",
        description: 'Header when an unknown error occurs'
    }
});

});

parcelRegister("fWOaS", function(module, exports) {
$parcel$export(module.exports, "MoreMenuPopup", () => $9c7140d2734d0690$export$b426d2e536b00785);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $ljVHR = parcelRequire("ljVHR");

var $7Fzpe = parcelRequire("7Fzpe");

var $1Io8b = parcelRequire("1Io8b");

var $eUenY = parcelRequire("eUenY");


var $hX1oM = parcelRequire("hX1oM");

var $lHABw = parcelRequire("lHABw");

var $njOX4 = parcelRequire("njOX4");

var $gcgRZ = parcelRequire("gcgRZ");
const $9c7140d2734d0690$var$styles = {
    popup: "_1bsb1rgy"
};
function $9c7140d2734d0690$export$b426d2e536b00785(props) {
    const { customizeSidebarMenuItem: customizeSidebarMenuItem, showMoreMenu: showMoreMenu = true } = props;
    // This ref is ultimately passed to the Customization Modal, which should cause the modal dialog to
    // return focus to either the Customize Button or the More Menu trigger element.
    // This component is unusual because it must change the
    // visible-menuitem based on whether the more menu needs to show or not.
    const returnFocusRef = (0, $euxye.useRef)(null);
    // customizeSidebarMenuItemWithRef adds a ref to the customizeSidebarMenuItem (to allow focussing)
    // and a returnFocusRef, which is passed to the Modal. It doesn't make sense for the caller to
    // define the ref, so *we* add the ref to the component dynamically.
    // The component is then rendered either within the More Menu (when showMoreMenu is true),
    // or as a standalone-button.
    // The isValidElement() test is a formality - it should always pass because GSN should always pass a
    // proper customizeSidebarMenuItem.
    const customizeSidebarMenuItemWithRef = (0, $euxye.useMemo)(()=>{
        return /*#__PURE__*/ (0, $euxye.isValidElement)(customizeSidebarMenuItem) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).cloneElement(customizeSidebarMenuItem, {
            returnFocusRef: returnFocusRef,
            ref: returnFocusRef
        }) : customizeSidebarMenuItem;
    }, [
        customizeSidebarMenuItem
    ]);
    if (showMoreMenu) return /*#__PURE__*/ (0, $e79Pd.jsx)($9c7140d2734d0690$var$MoreMenuTriggerInner, {
        ...props,
        customizeSidebarMenuItem: customizeSidebarMenuItemWithRef,
        returnFocusRef: returnFocusRef
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($9c7140d2734d0690$var$CustomizeSidebarTriggerStandalone, {
        returnFocusRef: returnFocusRef,
        customizeSidebarMenuItem: customizeSidebarMenuItem
    });
}
$9c7140d2734d0690$export$b426d2e536b00785.displayName = "MoreMenuPopup";
function $9c7140d2734d0690$var$CustomizeSidebarTriggerStandalone({ customizeSidebarMenuItem: customizeSidebarMenuItem, returnFocusRef: returnFocusRef }) {
    return (0, $lHABw.useStandaloneButtonMenuItem)({
        item: customizeSidebarMenuItem,
        otherProps: {
            returnFocusRef: returnFocusRef,
            ref: returnFocusRef
        }
    });
}
$9c7140d2734d0690$var$CustomizeSidebarTriggerStandalone.displayName = "CustomizeSidebarTriggerStandalone";
function $9c7140d2734d0690$var$MoreMenuTriggerButton({ children: children, mergedRefs: mergedRefs, ...props }) {
    return (0, $lHABw.useStandaloneButtonMenuItem)({
        item: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1Io8b.ButtonMenuItem), {
            ref: mergedRefs,
            ...props,
            children: children
        })
    });
}
$9c7140d2734d0690$var$MoreMenuTriggerButton.displayName = "MoreMenuTriggerButton";
function $9c7140d2734d0690$var$MoreMenuTriggerInner(props) {
    const { appItemsData: appItemsData, customizeSidebarMenuItem: customizeSidebarMenuItem, dropIndicator: dropIndicator, menuItemComponent: menuItemComponent, moreMenuItemLabel: moreMenuItemLabel, onClickMoreMenuTrigger: onClickMoreMenuTrigger, productItemsData: productItemsData, returnFocusRef: returnFocusRef, testId: testId, triggerRef: triggerRef, triggerVisualContentRef: triggerVisualContentRef } = props;
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const handleTriggerClick = (0, $euxye.useCallback)(()=>{
        onClickMoreMenuTrigger?.();
    }, [
        onClickMoreMenuTrigger
    ]);
    const triggerFn = (0, $euxye.useCallback)((triggerProps)=>{
        const { ref: ref, ...restTriggerProps } = triggerProps;
        return /*#__PURE__*/ (0, $e79Pd.jsx)($9c7140d2734d0690$var$MoreMenuTriggerButton, {
            ...restTriggerProps,
            mergedRefs: (0, $ljVHR.default)(triggerRef ? [
                triggerRef,
                ref,
                returnFocusRef
            ] : [
                ref,
                returnFocusRef
            ]),
            dropIndicator: dropIndicator,
            elemBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7Fzpe))), {
                label: "",
                color: "currentColor",
                spacing: "spacious"
            }),
            isSelected: triggerProps['aria-expanded'],
            interactionName: (0, $f6349dd70c1dd18e$export$442bdbffe3dfb793),
            onClick: handleTriggerClick,
            testId: testId,
            visualContentRef: triggerVisualContentRef,
            children: moreMenuItemLabel ?? formatMessage((0, $gcgRZ.messages).moreMenuTriggerLabel)
        });
    }, [
        dropIndicator,
        formatMessage,
        handleTriggerClick,
        moreMenuItemLabel,
        returnFocusRef,
        testId,
        triggerRef,
        triggerVisualContentRef
    ]);
    const entryPointProps = (0, $euxye.useMemo)(()=>({
            customizeSidebarMenuItem: customizeSidebarMenuItem,
            menuItemComponent: menuItemComponent
        }), [
        customizeSidebarMenuItem,
        menuItemComponent
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hX1oM.PopupDataProvider), {
        appItemsData: appItemsData,
        productItemsData: productItemsData,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eUenY.PopupTrigger), {
            entryPoint: (0, $njOX4.popupEntryPoint),
            entryPointProps: entryPointProps,
            // Offset the top margin of the menu section.
            // This will keep an even spacing of menu items between those inside the dropdown and those above,
            // and keep the icons aligned
            offset: [
                -4,
                4
            ],
            placement: "bottom-start",
            preloadOnFocus: true,
            role: undefined,
            shouldFitContainer: true,
            shouldRenderToParent: true,
            strategy: "absolute",
            testId: `${testId || 'more-menu'}-content`,
            trigger: triggerFn,
            // It is very difficult to please TS here.  Tried using StrictXCSSProp<...>
            xcss: $9c7140d2734d0690$var$styles.popup
        })
    });
}
$9c7140d2734d0690$var$MoreMenuTriggerInner.displayName = "MoreMenuTriggerInner";

});
parcelRegister("hX1oM", function(module, exports) {
$parcel$export(module.exports, "PopupDataProvider", () => $7b1d5f2eb90d1500$export$d8b714c1cef53925);
$parcel$export(module.exports, "usePopupData", () => $7b1d5f2eb90d1500$export$6c1aeecd45a1d0f2);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");
const $7b1d5f2eb90d1500$var$initialValue = {
    appItemsData: [],
    productItemsData: []
};
const $7b1d5f2eb90d1500$export$84a8bfdb704f8dd7 = /*#__PURE__*/ (0, $euxye.createContext)($7b1d5f2eb90d1500$var$initialValue);
function $7b1d5f2eb90d1500$export$d8b714c1cef53925(props) {
    const { appItemsData: appItemsData, children: children, productItemsData: productItemsData } = props;
    const previousValue = (0, $euxye.useRef)($7b1d5f2eb90d1500$var$initialValue);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(previousValue.current.appItemsData, appItemsData) || !(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(previousValue.current.productItemsData, productItemsData)) previousValue.current = {
        appItemsData: appItemsData,
        productItemsData: productItemsData
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)($7b1d5f2eb90d1500$export$84a8bfdb704f8dd7.Provider, {
        value: previousValue.current,
        children: children
    });
}
$7b1d5f2eb90d1500$export$d8b714c1cef53925.displayName = "PopupDataProvider";
function $7b1d5f2eb90d1500$export$6c1aeecd45a1d0f2() {
    return (0, $euxye.useContext)($7b1d5f2eb90d1500$export$84a8bfdb704f8dd7);
}

});

parcelRegister("lHABw", function(module, exports) {
$parcel$export(module.exports, "useStandaloneButtonMenuItem", () => $870c1e13419526c0$export$9143519b12af0141);

var $euxye = parcelRequire("euxye");
function $870c1e13419526c0$export$9143519b12af0141({ item: item, otherProps: otherProps = {} }) {
    const listItemRef = (0, $euxye.useRef)(null);
    const itemWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).isValidElement(item) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).cloneElement(item, {
        ...otherProps,
        listItemRef: listItemRef
    }) : item;
    (0, $euxye.useEffect)(()=>{
        listItemRef?.current?.removeAttribute('role');
    }, []);
    return itemWithRef;
}

});

parcelRegister("njOX4", function(module, exports) {
$parcel$export(module.exports, "popupEntryPoint", () => $75239277b3940062$export$84811aec0a83d9e5);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $75239277b3940062$export$84811aec0a83d9e5 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("eEzt1")), {
        moduleId: "225b9015",
        priority: "interaction",
        moduleId: 'global-more-menu-content-entrypoint'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eEzt1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("1aRRK"),
    $4cvLQ("bSGBq")
]).then(()=>parcelRequire('c5XNW'));

});


parcelRegister("gcgRZ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d33f3067de82906a$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $d33f3067de82906a$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    moreMenuTriggerLabel: {
        id: 'navigation.global-more-menu.trigger-label',
        defaultMessage: 'More',
        description: 'Default label text for the global more menu trigger button'
    }
});

});


parcelRegister("bbXmG", function(module, exports) {
$parcel$export(module.exports, "getHiddenItems", () => $2acf99549610c303$export$89456cd3628213b2);
function $2acf99549610c303$export$89456cd3628213b2(productItemsData, appItemsData, peekingMenuIds) {
    const checkIsHiddenMenuItem = ({ menuId: menuId, visible: visible })=>!visible && !peekingMenuIds.includes(menuId);
    const hiddenProductItemsData = productItemsData.filter(checkIsHiddenMenuItem);
    const hiddenAppItemsData = appItemsData.filter(checkIsHiddenMenuItem);
    return {
        hiddenProductItemsData: hiddenProductItemsData,
        hiddenAppItemsData: hiddenAppItemsData,
        shouldShowMoreMenu: hiddenProductItemsData.length !== 0 || hiddenAppItemsData.length !== 0
    };
}

});


parcelRegister("gd7XH", function(module, exports) {
$parcel$export(module.exports, "CustomizeSidebarMenuItem", () => $43d05c3686e97976$export$b7fa0daee00ba08b);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $50OIz = parcelRequire("50OIz");

var $cKxq6 = parcelRequire("cKxq6");

var $1Io8b = parcelRequire("1Io8b");

var $ikm5U = parcelRequire("ikm5U");

var $aalaB = parcelRequire("aalaB");

var $lcdkz = parcelRequire("lcdkz");

var $crxrI = parcelRequire("crxrI");

var $dMlyK = parcelRequire("dMlyK");

var $lyg9d = parcelRequire("lyg9d");

var $jd16R = parcelRequire("jd16R");

var $8o7TO = parcelRequire("8o7TO");

var $4m7Oz = parcelRequire("4m7Oz");
const $43d05c3686e97976$export$b7fa0daee00ba08b = /*#__PURE__*/ (0, $euxye.forwardRef)($43d05c3686e97976$var$CustomizeSidebarMenuItemWithRef);
function $43d05c3686e97976$var$CustomizeSidebarMenuItemWithRef({ appLabel: appLabel, closeMenu: closeMenu, items: items, onClick: onClick, returnFocusRef: returnFocusRef, listItemRef: listItemRef, shortcuts: shortcuts, testId: testId }, ref) {
    const getMenuIconAndLabel = (0, $4m7Oz.useGetMenuIconAndLabel)(items, shortcuts);
    const { itemUserMenuData: itemUserMenuData, shortcutUserMenuData: shortcutUserMenuData } = (0, $lyg9d.useUserMenuDataShapes)();
    const itemExtendedUserMenuData = (0, $lcdkz.extendWithCustomizationOptions)(itemUserMenuData, items);
    const onSave = (0, $dMlyK.useOnSave)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const interactionName = (0, $aalaB.NavigationExperienceId).customizationModalLoad.experienceId;
    const handleClick = (0, $euxye.useCallback)(()=>{
        closeMenu?.();
        onClick?.();
    }, [
        closeMenu,
        onClick
    ]);
    if (!(0, $crxrI.hasCustomizableItems)(items, shortcuts)) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ikm5U.ModalTrigger), {
        entryPoint: (0, $jd16R.customizationModalEntryPoint),
        entryPointProps: {
            appLabel: appLabel,
            getMenuIconAndLabel: getMenuIconAndLabel,
            itemExtendedUserMenuData: itemExtendedUserMenuData,
            onSave: onSave,
            returnFocusRef: returnFocusRef,
            shortcutExtendedUserMenuData: shortcutUserMenuData
        },
        children: ({ ref: triggerRef })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $1Io8b.ButtonMenuItem), {
                elemBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cKxq6))), {
                    label: ""
                }),
                ref: (0, $50OIz.mergeRefs)([
                    triggerRef,
                    ref
                ]),
                testId: testId,
                onClick: handleClick,
                interactionName: interactionName,
                listItemRef: listItemRef,
                children: formatMessage((0, $8o7TO.messages).customizeSidebarMenuItemLabel)
            })
    });
}
$43d05c3686e97976$var$CustomizeSidebarMenuItemWithRef.displayName = "CustomizeSidebarMenuItemWithRef";

});
parcelRegister("lcdkz", function(module, exports) {
$parcel$export(module.exports, "extendWithCustomizationOptions", () => $1c021e6d42f0989b$export$fc8975fe9e50b6c4);
function $1c021e6d42f0989b$export$fc8975fe9e50b6c4(userMenuData, items) {
    return userMenuData.map((item)=>{
        const itemConfig = items[item.menuId];
        if (!itemConfig) return item;
        return {
            ...item,
            isNotCustomizable: itemConfig.isReorderable === false,
            isNotToggleable: itemConfig.isHideable === false
        };
    });
}

});

parcelRegister("crxrI", function(module, exports) {
$parcel$export(module.exports, "hasCustomizableItems", () => $fb0f366397049d5e$export$a035ba4c7e651a8e);
const $fb0f366397049d5e$export$a035ba4c7e651a8e = (items, _shortcuts)=>{
    // Check if any item is reorderable or hideable
    return Object.values(items).some((item)=>item.isReorderable !== false || item.isHideable !== false);
};

});

parcelRegister("dMlyK", function(module, exports) {
$parcel$export(module.exports, "useOnSave", () => $b129367a9ef8ed2d$export$ecbfe7cad2f40363);

var $euxye = parcelRequire("euxye");

var $lyg9d = parcelRequire("lyg9d");
const $b129367a9ef8ed2d$export$ecbfe7cad2f40363 = ()=>{
    const { setUserMenuData: setUserMenuData } = (0, $lyg9d.useUserMenuDataShapes)();
    return (0, $euxye.useCallback)(async (updatedItemExtendedUserMenuData, updatedShortcutExtendedUserMenuData)=>{
        // Put the data back together and remove extra properties
        const userMenuData = updatedItemExtendedUserMenuData.concat(updatedShortcutExtendedUserMenuData).map(({ menuId: menuId, visible: visible })=>({
                menuId: menuId,
                visible: visible
            }));
        setUserMenuData(userMenuData);
    }, [
        setUserMenuData
    ]);
};

});

parcelRegister("jd16R", function(module, exports) {
$parcel$export(module.exports, "customizationModalEntryPoint", () => $11f5d37753248836$export$ce0411fdea635705);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $11f5d37753248836$export$ce0411fdea635705 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("JbRU2")), {
        moduleId: "b2e7e7c1",
        priority: "interaction",
        moduleId: 'navigation.global-side-navigation.customization-modal'
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("JbRU2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("1aRRK"),
    $4cvLQ("7bhoj")
]).then(()=>parcelRequire('G9wMP'));

});


parcelRegister("8o7TO", function(module, exports) {
$parcel$export(module.exports, "messages", () => $fc776a1d764ec5a7$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $fc776a1d764ec5a7$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    customizeSidebarMenuItemLabel: {
        id: 'navigation.global-side-navigation.customize-sidebar-menu-item.label',
        description: 'Label on Customize button in the side navigation. Shows a modal with options to customize the sidebar.',
        defaultMessage: 'Customize sidebar'
    }
});

});

parcelRegister("4m7Oz", function(module, exports) {
$parcel$export(module.exports, "useGetMenuIconAndLabel", () => $f62e7bfe1723a52e$export$946f6bdd4c4f6c7);

var $euxye = parcelRequire("euxye");

var $iUl43 = parcelRequire("iUl43");
const $f62e7bfe1723a52e$export$946f6bdd4c4f6c7 = (items, shortcuts)=>(0, $euxye.useCallback)((menuId)=>(0, $iUl43.getMenuIconAndLabel)(items, shortcuts)(menuId), [
        items,
        shortcuts
    ]);

});
parcelRegister("iUl43", function(module, exports) {
$parcel$export(module.exports, "getMenuIconAndLabel", () => $914d4be8be01fd5e$export$5412ec86882b110d);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
function $914d4be8be01fd5e$export$5412ec86882b110d(items, shortcuts) {
    return (menuId)=>{
        const item = items[menuId];
        if (item) {
            const { elemBefore: icon, label: label } = item;
            return {
                icon: icon,
                label: label
            };
        }
        const shortcut = shortcuts[menuId];
        if (shortcut) {
            const { icon: icon, label: label } = shortcut;
            return {
                icon: $914d4be8be01fd5e$var$ShortcutWrapper(icon),
                label: label
            };
        }
        throw Error(`Menu id ${menuId} not found in either items or shortcuts`);
    };
}
// Add 2px padding around all shortcut icons, as their xsmall-size is 20px. For the app-items,
// their size is 16px, with space="spacious" (taking them to 24px). This added padding means
// the app item icons and shortcut icons should have the same size-including-padding.
const $914d4be8be01fd5e$var$styles = {
    box: "_1e0c1txw _ae4v1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
function $914d4be8be01fd5e$var$ShortcutWrapper(icon) {
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
        xcss: $914d4be8be01fd5e$var$styles.box,
        children: [
            " ",
            icon
        ]
    });
}
$914d4be8be01fd5e$var$ShortcutWrapper.displayName = "ShortcutWrapper";

});



parcelRegister("gEPWh", function(module, exports) {
$parcel$export(module.exports, "default", () => $a88c4a0c63e2a533$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $a1Bqx = parcelRequire("a1Bqx");

var $iNzjb = parcelRequire("iNzjb");
var $4u4Z8 = parcelRequire("4u4Z8");

var $aWAN2 = parcelRequire("aWAN2");

var $2CeGr = parcelRequire("2CeGr");

var $5TAdw = parcelRequire("5TAdw");

var $1QF9m = parcelRequire("1QF9m");

var $4RLhz = parcelRequire("4RLhz");

var $kBtiJ = parcelRequire("kBtiJ");

var $bYSs9 = parcelRequire("bYSs9");
function $a88c4a0c63e2a533$export$2e2bcd8739ae039({ id: id, items: items, onClick: onClick, openShortcutsInSameTab: openShortcutsInSameTab, shortcutItems: shortcutItems }) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const setPeekMenuId = (0, $kBtiJ.useSetPeekMenuId)();
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $4RLhz.useOptions)();
    const shortcutItem = shortcutItems?.[id];
    if (shortcutItem) {
        // Render custom components as-is, allowing for things like shortcuts opening modals to work
        // Note: We do not pass down the onClick here because that would close the More menu and thus cause such components to not work.
        if (shortcutItem.type === 'component') return /*#__PURE__*/ (0, $e79Pd.jsx)($a88c4a0c63e2a533$var$MoreShortcutItem, {
            id: id,
            shortcutItem: shortcutItem,
            l1DragAndDropEnabled: l1DragAndDropEnabled
        });
        const moreItem = $a88c4a0c63e2a533$var$buildMoreShortcutItem({
            shortcutItem: shortcutItem,
            formatMessage: formatMessage,
            openShortcutsInSameTab: openShortcutsInSameTab
        });
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2CeGr.default), {
            id: id,
            item: moreItem,
            isInMoreMenu: true,
            group: (0, $aWAN2.L1_MENU_GROUPS).SHORTCUTS
        });
    }
    // Check if the item is in the items map
    const item = items[id];
    if (!item) throw new Error(`NavItem: No item found for id "${id}". Ensure the item is defined in appItems or globalItems.`);
    if ((0, $5TAdw.isCustomItemConfig)(item)) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2CeGr.default), {
        id: id,
        item: item,
        isInMoreMenu: true,
        onPeek: ()=>setPeekMenuId(id),
        onClick: onClick
    });
    const moreItem = $a88c4a0c63e2a533$var$buildMoreItem({
        id: id,
        item: item,
        onClick: onClick,
        onPeek: setPeekMenuId
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2CeGr.default), {
        id: id,
        item: moreItem,
        isInMoreMenu: true
    });
}
$a88c4a0c63e2a533$export$2e2bcd8739ae039.displayName = "MoreMenuItem";
function $a88c4a0c63e2a533$var$MoreShortcutItem({ id: id, shortcutItem: shortcutItem, l1DragAndDropEnabled: l1DragAndDropEnabled }) {
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent } = (0, $1QF9m.useNavAnalytics)();
    const handleClick = (0, $euxye.useCallback)(()=>{
        shortcutItem?.onClick?.();
        fireClickedSideNavItemEvent(id);
    }, [
        fireClickedSideNavItemEvent,
        id,
        shortcutItem
    ]);
    if ((0, $5TAdw.isCustomShortcutDraggableConfig)(shortcutItem) && l1DragAndDropEnabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4u4Z8.ShortcutMenuItem), {
        shortcut: {
            ...shortcutItem,
            onClick: handleClick
        },
        dragAndDropEnabled: l1DragAndDropEnabled,
        isInMoreMenu: true
    });
    if ((0, $5TAdw.isCustomShortcutConfig)(shortcutItem)) {
        const Component = shortcutItem.component;
        const ItemWrapper = shortcutItem.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment;
        return /*#__PURE__*/ (0, $e79Pd.jsx)(ItemWrapper, {
            children: /*#__PURE__*/ (0, $e79Pd.jsx)(Component, {
                onClick: handleClick,
                isInMoreMenu: true
            })
        });
    }
    return null;
}
$a88c4a0c63e2a533$var$MoreShortcutItem.displayName = "MoreShortcutItem";
function $a88c4a0c63e2a533$var$buildMoreShortcutItem({ formatMessage: formatMessage, openShortcutsInSameTab: openShortcutsInSameTab, shortcutItem: shortcutItem }) {
    const elemAfter = openShortcutsInSameTab ? undefined : /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a1Bqx))), {
        size: "small",
        label: formatMessage((0, $bYSs9.messages).linkExternalIconLabel),
        spacing: "spacious"
    });
    return {
        type: 'link',
        elemAfter: elemAfter,
        elemBefore: shortcutItem.icon,
        label: shortcutItem.label,
        target: openShortcutsInSameTab ? '_self' : '_blank',
        href: (0, $iNzjb.getUrlMaybe)(shortcutItem) || '#'
    };
}
function $a88c4a0c63e2a533$var$buildMoreItem({ id: id, item: item, onClick: onClick, onPeek: onPeek }) {
    if ((0, $5TAdw.isExpandableItemConfig)(item) || (0, $5TAdw.isFlyoutItemConfig)(item) || (0, $5TAdw.isObjectListFlyoutItemConfig)(item)) return $a88c4a0c63e2a533$var$buildMoreItemFromExpandableOrFlyout({
        id: id,
        item: item,
        onClick: onClick,
        onPeek: onPeek
    });
    else if ((0, $5TAdw.isButtonItemConfig)(item) || (0, $5TAdw.isLinkItemConfig)(item)) return $a88c4a0c63e2a533$var$buildMoreItemFromButtonOrLink({
        item: item,
        onClick: onClick
    });
    // If the item is not a button, link, expandable, or flyout, return as is
    return item;
}
function $a88c4a0c63e2a533$var$buildMoreItemFromExpandableOrFlyout({ id: id, item: item, onClick: onClick, onPeek: onPeek }) {
    const { elemBefore: elemBefore, label: label } = item;
    const onClickActual = $a88c4a0c63e2a533$var$combineHandlerAndActions(// ExpandableItemConfig['onClick'] has a third parameter we're not currently providing
    item.onClick, onClick, onPeek && (()=>onPeek(id)));
    // If the item is in the more menu and is an expandable or flyout item, render as a button with peek
    return {
        type: 'button',
        elemBefore: elemBefore,
        label: label,
        onClick: onClickActual
    };
}
function $a88c4a0c63e2a533$var$buildMoreItemFromButtonOrLink({ item: item, onClick: onClick }) {
    const onClickActual = $a88c4a0c63e2a533$var$combineHandlerAndActions(item.onClick, onClick);
    return {
        ...item,
        // Remove props that are not appropriate for the more menu
        actions: undefined,
        actionsOnHover: undefined,
        elemAfter: undefined,
        labelElem: undefined,
        onClick: onClickActual
    };
}
const $a88c4a0c63e2a533$var$combineHandlerAndActions = (handler, ...actions)=>(...args)=>{
        handler?.(...args);
        actions.forEach((action)=>{
            action?.();
        });
    };

});
parcelRegister("bYSs9", function(module, exports) {
$parcel$export(module.exports, "messages", () => $4502f91eb06c55e9$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $4502f91eb06c55e9$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    linkExternalIconLabel: {
        id: 'navigation.global-side-navigation.more-menu-item.link-external-item-label',
        description: 'Label for the link external icon',
        defaultMessage: 'Open external link icon'
    }
});

});



parcelRegister("y7eOy", function(module, exports) {
$parcel$export(module.exports, "HideFromSidebarButton", () => $9d1946f470053ee5$export$48ac5b0d18731d0f);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $jYd2W = parcelRequire("jYd2W");

var $1Io8b = parcelRequire("1Io8b");

var $kHnXX = parcelRequire("kHnXX");

var $fRBVu = parcelRequire("fRBVu");
function $9d1946f470053ee5$export$48ac5b0d18731d0f() {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { dropIndicator: dropIndicator, dropTargetRef: dropTargetRef, moreButtonRef: moreButtonRef } = (0, $kHnXX.useMoreMenuDragAndDrop)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1Io8b.ButtonMenuItem), {
        elemBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jYd2W))), {
            label: ""
        }),
        ref: moreButtonRef,
        dropIndicator: dropIndicator,
        visualContentRef: dropTargetRef,
        children: formatMessage((0, $fRBVu.messages).hideFromSidebar)
    });
}
$9d1946f470053ee5$export$48ac5b0d18731d0f.displayName = "HideFromSidebarButton";

});
parcelRegister("kHnXX", function(module, exports) {
$parcel$export(module.exports, "useMoreMenuDragAndDrop", () => $d0e1b620a7cd1360$export$b4c5199e460b5544);

var $euxye = parcelRequire("euxye");

var $aYssY = parcelRequire("aYssY");

var $aWAN2 = parcelRequire("aWAN2");

var $9sYLJ = parcelRequire("9sYLJ");
var $jufsF = parcelRequire("jufsF");

var $4RLhz = parcelRequire("4RLhz");
function $d0e1b620a7cd1360$export$b4c5199e460b5544() {
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $4RLhz.useOptions)();
    const memoisedHookProps = (0, $euxye.useMemo)(()=>{
        if (l1DragAndDropEnabled) return {
            dropTarget: {
                getData: ()=>(0, $9sYLJ.getMoreMenuData)(),
                getOperations: ()=>({
                        combine: 'available'
                    }),
                canDrop: ({ source: source })=>{
                    return (0, $9sYLJ.isL1ItemData)(source.data) && (0, $9sYLJ.isL1ItemDataInGroup)(source.data, [
                        (0, $aWAN2.L1_MENU_GROUPS).MENU,
                        (0, $aWAN2.L1_MENU_GROUPS).SHORTCUTS
                    ]) && source.data.isHideable;
                }
            }
        };
        return {};
    }, [
        l1DragAndDropEnabled
    ]);
    const { dropIndicator: dropIndicator, dropTargetRef: dropTargetRef } = (0, $aYssY.useMenuItemDragAndDrop)(memoisedHookProps);
    const registry = (0, $jufsF.useElementRegistry)();
    const registrationRef = (0, $euxye.useRef)(null);
    const moreButtonRef = (0, $euxye.useCallback)((element)=>{
        if (!element) {
            registrationRef.current?.();
            registrationRef.current = null;
            return;
        }
        // Unregister previous element if exists
        if (registrationRef.current) registrationRef.current();
        // Register the new element with the registry
        registrationRef.current = registry.registerMoreMenuItem(element);
    }, [
        registrationRef,
        registry
    ]);
    return {
        dropIndicator: dropIndicator,
        dropTargetRef: dropTargetRef,
        moreButtonRef: moreButtonRef
    };
}

});

parcelRegister("fRBVu", function(module, exports) {
$parcel$export(module.exports, "messages", () => $12737a912e012daf$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $12737a912e012daf$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    hideFromSidebar: {
        id: 'navigation.global-side-navigation.more-menu.hide-from-sidebar.label',
        description: 'Label on Hide from sidebar button in the side navigation. Button appears in place of the More menu when items are being dragged.',
        defaultMessage: 'Hide from sidebar'
    }
});

});


parcelRegister("aqnwY", function(module, exports) {
$parcel$export(module.exports, "ShowInSidebarButton", () => $ecb96d7f723ec01f$export$df0ec698b216b297);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $5LiAk = parcelRequire("5LiAk");

var $1Io8b = parcelRequire("1Io8b");

var $kHnXX = parcelRequire("kHnXX");

var $l5OhE = parcelRequire("l5OhE");
function $ecb96d7f723ec01f$export$df0ec698b216b297() {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { dropIndicator: dropIndicator, dropTargetRef: dropTargetRef, moreButtonRef: moreButtonRef } = (0, $kHnXX.useMoreMenuDragAndDrop)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1Io8b.ButtonMenuItem), {
        elemBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5LiAk))), {
            label: ""
        }),
        ref: moreButtonRef,
        dropIndicator: dropIndicator,
        visualContentRef: dropTargetRef,
        children: formatMessage((0, $l5OhE.messages).showInSidebar)
    });
}
$ecb96d7f723ec01f$export$df0ec698b216b297.displayName = "ShowInSidebarButton";

});
parcelRegister("l5OhE", function(module, exports) {
$parcel$export(module.exports, "messages", () => $aa6bf28abe03dcd5$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $aa6bf28abe03dcd5$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    showInSidebar: {
        id: 'navigation.global-side-navigation.more-menu.show-in-sidebar.label',
        description: 'Label on Show in sidebar button in the side navigation. Button appears in place of the More menu when items are being dragged.',
        defaultMessage: 'Show in sidebar'
    }
});

});


parcelRegister("79qLH", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f9887d0e797cf388$export$defe85febe8b728c);
$parcel$export(module.exports, "mainNavItemMessages", () => $f9887d0e797cf388$export$b61be8d5923fc7ed);
$parcel$export(module.exports, "defaultErrorMessages", () => $f9887d0e797cf388$export$65be7b412c56ab9b);

var $7eNDO = parcelRequire("7eNDO");
const $f9887d0e797cf388$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    primaryNavigationSectionScreenReader: {
        id: 'navigation.global-side-navigation.primary-navigation-section-screen-reader',
        description: 'Section label used to describe the primary navigation section for screen reader users.',
        defaultMessage: 'Dragging {item} over primary navigation group'
    },
    shortcutsSectionScreenReader: {
        id: 'navigation.global-side-navigation.shortcuts-section-screen-reader',
        description: 'Section label used to describe the shortcuts section for screen reader users.',
        defaultMessage: 'Dragging {item} over shortcuts group'
    },
    hideFromSidebarSectionScreenReader: {
        id: 'navigation.global-side-navigation.hide-from-sidebar-section-screen-reader',
        description: 'Section label used to describe the hide from sidebar button for screen reader users.',
        defaultMessage: 'Dragging {item} over "Hide from navigation" drop area'
    },
    showInSidebarSectionScreenReader: {
        id: 'navigation.global-side-navigation.show-in-sidebar-section-screen-reader',
        description: 'Section label used to describe the show in sidebar button for screen reader users.',
        defaultMessage: 'Dragging {item} over "Show in navigation" drop area'
    }
});
const $f9887d0e797cf388$export$b61be8d5923fc7ed = (0, $7eNDO.defineMessages)({
    header: {
        id: 'navigation.global-side-navigation.main-nav-item.error.header',
        defaultMessage: "We couldn\u2019t load the item {menuId}",
        description: 'Header when an unknown error occurs'
    },
    description: {
        id: 'navigation.global-side-navigation.main-nav-item.error.description',
        defaultMessage: 'Refresh the page and try again',
        description: 'Description when an unknown error occurs'
    }
});
const $f9887d0e797cf388$export$65be7b412c56ab9b = (0, $7eNDO.defineMessages)({
    header: {
        id: 'navigation.global-side-navigation.error.header.default',
        defaultMessage: "We couldn\u2019t load this content",
        description: 'Header when an unknown error occurs'
    },
    description: {
        id: 'navigation.global-side-navigation.error.description.default',
        defaultMessage: 'Refresh the page and try again',
        description: 'Description when an unknown error occurs'
    }
});

});




parcelRegister("iikeY", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d8a430eff45907a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $3y1jN = parcelRequire("3y1jN");

var $f3A47 = parcelRequire("f3A47");

var $5CJjo = parcelRequire("5CJjo");

var $2fzzS = parcelRequire("2fzzS");
var $364Xz = parcelRequire("364Xz");

var $3trGN = parcelRequire("3trGN");

var $hjxd7 = parcelRequire("hjxd7");


var $8g9cc = parcelRequire("8g9cc");

var $5NGt8 = parcelRequire("5NGt8");

var $drhN1 = parcelRequire("drhN1");

var $43GFv = parcelRequire("43GFv");
// TODO: remove mocks and accept props to populate tiles
const $4d8a430eff45907a$var$DEFAULT_SELECTED_APP = 'JIRA';
const $4d8a430eff45907a$var$DEFAULT_APPS = [
    {
        productId: 'JIRA',
        href: '#',
        title: 'JIRA'
    },
    {
        productId: 'CONFLUENCE',
        href: '#',
        title: 'Confluence'
    },
    {
        productId: 'TRELLO',
        href: '#',
        title: 'Trello'
    }
];
const $4d8a430eff45907a$var$DEFAULT_TEST_ID = 'navigation-ribbon';
function $4d8a430eff45907a$var$NavigationRibbonContent({ testId: testId, apps: apps, onAppsReorder: onAppsReorder, selectedApp: selectedApp = $4d8a430eff45907a$var$DEFAULT_SELECTED_APP }) {
    // Store both visibility states in the same state object to prevent race conditions
    // that result in both popups being visible at the same time.
    const [popupVisibility, setPopupVisibility] = (0, $euxye.useState)({
        isMoreAppsVisible: false,
        isOrgSwitcherVisible: false
    });
    const providedApps = apps ?? $4d8a430eff45907a$var$DEFAULT_APPS;
    const [uncontrolledApps, setUncontrolledApps] = (0, $euxye.useState)(()=>providedApps);
    // Keep uncontrolled state in sync with prop changes (if used).
    (0, $euxye.useEffect)(()=>{
        if (onAppsReorder) return;
        // When uncontrolled, treat `apps` prop as an upstream reset.
        setUncontrolledApps(providedApps);
    }, [
        onAppsReorder,
        providedApps
    ]);
    const appTiles = onAppsReorder ? providedApps : uncontrolledApps;
    const updateAppTiles = (0, $euxye.useCallback)((next)=>{
        if (onAppsReorder) // Controlled usage: delegate persistence/ordering to the consumer.
        onAppsReorder(next);
        else // Uncontrolled usage: keep state local (storybook + local demos).
        setUncontrolledApps(next);
    }, [
        onAppsReorder
    ]);
    const { isKeyboardReorderModeEnabled: isKeyboardReorderModeEnabled, temporaryKeyboardOrderedAppTiles: temporaryKeyboardOrderedAppTiles, setAppTiles: setAppTiles, setOnAppsReorder: setOnAppsReorder } = (0, $364Xz.useKeyboardReorderContext)();
    (0, $euxye.useEffect)(()=>{
        setAppTiles(appTiles);
    }, [
        appTiles,
        setAppTiles
    ]);
    (0, $euxye.useEffect)(()=>{
        setOnAppsReorder(()=>updateAppTiles);
    }, [
        setOnAppsReorder,
        updateAppTiles
    ]);
    const { draggingProductId: draggingProductId, isDragActive: isDragActive } = (0, $hjxd7.useDragAndDrop)({
        apps: appTiles,
        onAppsReorder: updateAppTiles
    });
    const testIdPrefix = testId ?? $4d8a430eff45907a$var$DEFAULT_TEST_ID;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3y1jN.UNSAFE_Ribbon), {
            width: (0, $36113880e0e0b542$export$d03df12f1ca56488),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $43GFv.default), {
                testId: testIdPrefix,
                header: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $drhN1.OrgSwitcherPopup), {
                    isOpen: popupVisibility.isOrgSwitcherVisible,
                    onClose: ()=>setPopupVisibility((prev)=>({
                                ...prev,
                                isOrgSwitcherVisible: false
                            })),
                    onOpen: ()=>setPopupVisibility((prev)=>({
                                isMoreAppsVisible: false,
                                isOrgSwitcherVisible: !prev.isOrgSwitcherVisible
                            }))
                }),
                content: (isKeyboardReorderModeEnabled ? temporaryKeyboardOrderedAppTiles : appTiles).map((app, index)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $5CJjo.ReorderableAppTile), {
                        app: app,
                        index: index,
                        selectedApp: selectedApp,
                        isDragging: draggingProductId === app.productId,
                        testId: testIdPrefix
                    }, app.productId)),
                footer: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5NGt8.MoreAppsPopup), {
                    appTiles: appTiles,
                    isDragActive: isDragActive,
                    isOpen: popupVisibility.isMoreAppsVisible,
                    onClose: ()=>setPopupVisibility((prev)=>({
                                ...prev,
                                isMoreAppsVisible: false
                            })),
                    onOpen: ()=>setPopupVisibility((prev)=>({
                                isOrgSwitcherVisible: false,
                                isMoreAppsVisible: !prev.isMoreAppsVisible
                            })),
                    testIdPrefix: testIdPrefix
                })
            })
        })
    });
}
$4d8a430eff45907a$var$NavigationRibbonContent.displayName = "NavigationRibbonContent";
function $4d8a430eff45907a$export$2e2bcd8739ae039(props) {
    const { product: product = 'jira' } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3trGN.RibbonConfigProvider), {
        product: product,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f3A47.NavErrorBoundary), {
            errorFallbackUI: ({ header: header, description: description })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $43GFv.default), {
                    content: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8g9cc.ErrorState), {
                        header: header,
                        description: description
                    })
                }),
            location: (0, $0d02ca2fc86ffe27$export$7b1d5fb8b81e96a9),
            sentryConfig: {
                product: product
            },
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2fzzS.KeyboardReorderProvider), {
                children: /*#__PURE__*/ (0, $e79Pd.jsx)($4d8a430eff45907a$var$NavigationRibbonContent, {
                    ...props
                })
            })
        })
    });
}
$4d8a430eff45907a$export$2e2bcd8739ae039.displayName = "NavigationRibbon";

});
parcelRegister("5CJjo", function(module, exports) {
$parcel$export(module.exports, "ReorderableAppTile", () => $cf5b247435909e71$export$bebcf654aae8ce57);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $e4ZHy = parcelRequire("e4ZHy");
parcelRequire("l7nPt");
var $7aH0o = parcelRequire("7aH0o");
parcelRequire("3nfFb");
var $gOKKd = parcelRequire("gOKKd");
parcelRequire("dA5C0");
var $cEH4V = parcelRequire("cEH4V");
parcelRequire("ij70u");
var $e77YP = parcelRequire("e77YP");

var $ihEDU = parcelRequire("ihEDU");

var $9O35d = parcelRequire("9O35d");

var $364Xz = parcelRequire("364Xz");

var $2gmhU = parcelRequire("2gmhU");

var $bRRX9 = parcelRequire("bRRX9");

var $78JFV = parcelRequire("78JFV");

var $5vxkp = parcelRequire("5vxkp");
const $cf5b247435909e71$var$styles = {
    reorderTileWrapper: "_kqswh2mm _uiztglyw _80om1qgj _1bsb1osq _1qam5szm",
    reorderTileWrapperDragging: "_kqswh2mm _uiztglyw"
};
function $cf5b247435909e71$export$bebcf654aae8ce57({ app: app, index: index, selectedApp: selectedApp, isDragging: isDragging, testId: testId = '' }) {
    const ref = (0, $euxye.useRef)(null);
    const [previewContainer, setPreviewContainer] = (0, $euxye.useState)(null);
    const [closestEdge, setClosestEdge] = (0, $euxye.useState)(null);
    const [isHovered, setIsHovered] = (0, $euxye.useState)(false);
    const { isKeyboardReorderModeEnabled: isKeyboardReorderModeEnabled } = (0, $364Xz.useKeyboardReorderContext)();
    const data = (0, $euxye.useMemo)(()=>({
            type: (0, $78JFV.RIBBON_DND_TILE_TYPE).APP_TILE,
            productId: app.productId,
            index: index
        }), [
        app.productId,
        index
    ]);
    (0, $euxye.useEffect)(()=>{
        const element = ref.current;
        if (!element) return;
        function onChange({ self: self, source: source }) {
            if (source.element === element) {
                setClosestEdge(null);
                return;
            }
            setClosestEdge((0, $e4ZHy.extractClosestEdge)(self.data));
        }
        return (0, $7aH0o.combine)((0, $gOKKd.draggable)({
            element: element,
            getInitialData: ()=>data,
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage, location: location, source: source }) {
                (0, $e77YP.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $cEH4V.preserveOffsetOnSource)({
                        element: source.element,
                        input: location.current.input
                    }),
                    render ({ container: container }) {
                        setPreviewContainer(container);
                        return ()=>setPreviewContainer(null);
                    }
                });
            },
            onDrop () {
                setPreviewContainer(null);
                // this makes the hover state disappear on drop as dropping the tile
                // sometimes does not trigger the onMouseLeave depending on the cursor position
                setIsHovered(false);
            }
        }), (0, $gOKKd.dropTargetForElements)({
            element: element,
            canDrop ({ source: source }) {
                // Can't drop on self. Also ensures we only accept ribbon app tiles.
                return (0, $5vxkp.isRibbonAppTileDndData)(source.data) && source.data.productId !== app.productId;
            },
            getData ({ input: input }) {
                // Attach the closest edge instruction so the monitor can compute the destination index.
                return (0, $e4ZHy.attachClosestEdge)(data, {
                    element: element,
                    input: input,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            getIsSticky: ()=>true,
            onDrag: onChange,
            onDragEnter: onChange,
            onDragLeave () {
                setClosestEdge(null);
            },
            onDrop () {
                setClosestEdge(null);
            }
        }));
    }, [
        app.productId,
        data
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
        ref: ref,
        xcss: isDragging ? $cf5b247435909e71$var$styles.reorderTileWrapperDragging : $cf5b247435909e71$var$styles.reorderTileWrapper,
        testId: `${testId}--reorder-tile-${app.productId}`,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        children: [
            (isHovered && !isDragging || isKeyboardReorderModeEnabled) && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2gmhU.DragHandle), {
                testId: `${testId}--drag-handle-${app.productId}`
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9O35d.AppTile), {
                href: app.href,
                productId: app.productId,
                selectedApp: selectedApp,
                isDragging: isDragging,
                hideNotch: isHovered,
                isHovered: isHovered
            }),
            previewContainer && /*#__PURE__*/ (0, $85XPu.createPortal)(/*#__PURE__*/ (0, $e79Pd.jsx)((0, $9O35d.AppTile), {
                href: app.href,
                productId: app.productId,
                selectedApp: selectedApp,
                hideNotch: true,
                isDragPreview: true
            }), previewContainer),
            closestEdge && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bRRX9.DropIndicator), {
                testId: `${testId}--drop-edge-${app.productId}`,
                closestEdge: closestEdge
            })
        ]
    });
}
$cf5b247435909e71$export$bebcf654aae8ce57.displayName = "ReorderableAppTile";

});
parcelRegister("9O35d", function(module, exports) {
$parcel$export(module.exports, "AppTile", () => $cf51ba1cfdebec1a$export$2a298f46c8d3fd05);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $9MWap = parcelRequire("9MWap");
var $ihEDU = parcelRequire("ihEDU");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $hZDXn = parcelRequire("hZDXn");

var $364Xz = parcelRequire("364Xz");

var $1c1Kj = parcelRequire("1c1Kj");

var $g3yRY = parcelRequire("g3yRY");
const $cf51ba1cfdebec1a$var$styles = {
    appTile: "_9oik18uv _1bnxglyw _jf4cnqa1",
    anchor: "_4bfu18uv _1hmsglyw _ajmmnqa1 _80om1qgj _1bsb1osq _mizu1r31 _ra3xglyw _128m1o36 _9oik18uv _1bnxglyw _jf4cnqa1 _1qam5szm",
    anchorDragging: "_4bfu18uv _1hmsglyw _ajmmnqa1 _80om13gf _lcxvglyw _1bsb1osq _mizu1r31 _ra3xglyw _128m1o36 _9oik18uv _1bnxglyw _jf4cnqa1",
    labelContainer: "_2rko1qi0 _19bvv77o _u5f3v77o"
};
const $cf51ba1cfdebec1a$export$2a298f46c8d3fd05 = (props)=>{
    const { href: href, selectedApp: selectedApp, productId: productId, isDragging: isDragging, hideNotch: hideNotch, isDragPreview: isDragPreview, isHovered: isHovered, testId: testId } = props;
    const [isFocusVisible, setIsFocusVisible] = (0, $euxye.useState)(false);
    const hadPointerDownRef = (0, $euxye.useRef)(false);
    const anchorRef = (0, $euxye.useRef)(null);
    const { isKeyboardReorderModeEnabled: isKeyboardReorderModeEnabled, setKeyboardSelectedProductId: setKeyboardSelectedProductId, setIsKeyboardReorderToggleVisible: setIsKeyboardReorderToggleVisible, moveKeyboardReorderSelectedTile: moveKeyboardReorderSelectedTile, keyboardReorderAppTileRefsMap: keyboardReorderAppTileRefsMap, selectedKeyboardReorderProductId: selectedKeyboardReorderProductId, cancelKeyboardReorder: cancelKeyboardReorder, applyKeyboardReorder: applyKeyboardReorder, exitKeyboardReorderMode: exitKeyboardReorderMode, containerRef: containerRef } = (0, $364Xz.useKeyboardReorderContext)();
    const isSelected = selectedApp === productId;
    const product = (0, $1c1Kj.useAppSelector)(productId);
    (0, $euxye.useEffect)(()=>{
        // Hide the keyboard reorder toggle when the tile is being dragged
        if (isDragging) exitKeyboardReorderMode();
    }, [
        exitKeyboardReorderMode,
        isDragging
    ]);
    (0, $euxye.useEffect)(()=>{
        if (keyboardReorderAppTileRefsMap.current && anchorRef.current) keyboardReorderAppTileRefsMap.current.set(productId, anchorRef.current);
    }, [
        productId,
        keyboardReorderAppTileRefsMap
    ]);
    if (!product) return null;
    const { icon: icon, text: text } = product;
    const textComponent = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
        maxLines: 1,
        size: "small",
        align: "center",
        color: "color.text.subtle",
        children: text
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MWap.default), {
        href: href,
        testId: testId,
        ref: anchorRef,
        // Links are natively draggable in browsers, which can interfere with our tile-level
        // Pragmatic DnD interactions. Disable native link dragging so dragging can start
        // from anywhere on the tile.
        draggable: false,
        xcss: isDragging ? $cf51ba1cfdebec1a$var$styles.anchorDragging : $cf51ba1cfdebec1a$var$styles.anchor,
        "aria-disabled": isDragging,
        tabIndex: isDragging ? -1 : undefined,
        onDragStart: (e)=>{
            e.preventDefault();
        },
        onClick: (e)=>{
            if (!isDragging) return;
            e.preventDefault();
            e.stopPropagation();
        },
        onKeyDown: (e)=>{
            if (!isDragging && !isKeyboardReorderModeEnabled) return;
            // prevent keyboard "click" while disabled
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
            }
            if (isKeyboardReorderModeEnabled) {
                if (e.key === ' ') {
                    if (selectedKeyboardReorderProductId) applyKeyboardReorder();
                    else setKeyboardSelectedProductId(productId);
                }
                if (e.key === 'ArrowUp') moveKeyboardReorderSelectedTile('up');
                if (e.key === 'ArrowDown') moveKeyboardReorderSelectedTile('down');
                if (e.key === 'Escape') cancelKeyboardReorder();
            }
        },
        onPointerDown: ()=>{
            hadPointerDownRef.current = true;
            setIsFocusVisible(false);
        },
        onFocus: ()=>{
            /**
     * We intentionally avoid relying on `:focus-visible` here, since programmatic focus
     * (used by VR tests) may not always count as focus-visible depending on the browser.
     * This heuristic shows the focus ring for keyboard/programmatic focus, but hides it
     * for pointer focus.
     */ const isKeyboardFocus = !hadPointerDownRef.current && !isDragging;
            setIsFocusVisible(isKeyboardFocus);
            if (isKeyboardFocus && setIsKeyboardReorderToggleVisible) setIsKeyboardReorderToggleVisible(true);
            hadPointerDownRef.current = false;
        },
        onBlur: (e)=>{
            hadPointerDownRef.current = false;
            setIsFocusVisible(false);
            // Only exit reorder mode if focus is leaving the ribbon entirely
            const relatedTarget = e.relatedTarget;
            const isStillInRibbon = containerRef.current?.contains(relatedTarget);
            if (!isStillInRibbon) exitKeyboardReorderMode();
        },
        children: isDragging ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
            alignInline: "center",
            xcss: $cf51ba1cfdebec1a$var$styles.appTile,
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g3yRY.UnsafeTile), {
                    logo: icon,
                    isFocused: isFocusVisible,
                    isDisabled: isDragging
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                    maxLines: 1,
                    size: "small",
                    align: "center",
                    color: "color.text.disabled",
                    children: text
                })
            ]
        }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
            content: text,
            children: (tooltipProps)=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
                    alignInline: "center",
                    xcss: $cf51ba1cfdebec1a$var$styles.appTile,
                    ...tooltipProps,
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g3yRY.UnsafeTile), {
                            isEditMode: isKeyboardReorderModeEnabled,
                            logo: icon,
                            isSelected: isSelected && !isKeyboardReorderModeEnabled || isKeyboardReorderModeEnabled && selectedKeyboardReorderProductId === productId,
                            isFocused: isFocusVisible,
                            hideNotch: hideNotch,
                            isDragPreview: isDragPreview,
                            isHovered: isHovered
                        }),
                        isDragPreview ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                            backgroundColor: "elevation.surface",
                            xcss: $cf51ba1cfdebec1a$var$styles.labelContainer,
                            children: textComponent
                        }) : textComponent
                    ]
                })
        })
    });
};
$cf51ba1cfdebec1a$export$2a298f46c8d3fd05.displayName = "AppTile";

});
parcelRegister("364Xz", function(module, exports) {
$parcel$export(module.exports, "useKeyboardReorderContext", () => $f671c515b07a70b5$export$e6e2c130bc2a9118);
$parcel$export(module.exports, "useAppTilesState", () => $f671c515b07a70b5$export$73b3715d71e0ec57);
$parcel$export(module.exports, "useFocusSelectedTile", () => $f671c515b07a70b5$export$2f9798cad9aa7cbc);
$parcel$export(module.exports, "useMoveSelectedTile", () => $f671c515b07a70b5$export$6eee1a631b2551ec);

var $euxye = parcelRequire("euxye");

var $2fzzS = parcelRequire("2fzzS");
function $f671c515b07a70b5$export$e6e2c130bc2a9118() {
    const context = (0, $euxye.useContext)((0, $2fzzS.KeyboardReorderContext));
    if (!context) throw new Error('useKeyboardReorderContext must be used within a KeyboardReorderProvider');
    return context;
}
function $f671c515b07a70b5$export$73b3715d71e0ec57() {
    const [appTiles, setAppTiles] = (0, $euxye.useState)([]);
    const [temporaryOrder, setTemporaryOrder] = (0, $euxye.useState)(appTiles);
    const [onReorder, setOnReorder] = (0, $euxye.useState)(null);
    return {
        appTiles: appTiles,
        setAppTiles: setAppTiles,
        temporaryOrder: temporaryOrder,
        setTemporaryOrder: setTemporaryOrder,
        onReorder: onReorder,
        setOnReorder: setOnReorder
    };
}
function $f671c515b07a70b5$export$2f9798cad9aa7cbc(selectedProductId, tileRefsMap) {
    return (0, $euxye.useCallback)(()=>{
        if (!selectedProductId) return;
        const element = tileRefsMap.current.get(selectedProductId);
        element?.focus();
    }, [
        tileRefsMap,
        selectedProductId
    ]);
}
function $f671c515b07a70b5$export$6eee1a631b2551ec(temporaryOrder, setTemporaryOrder, selectedProductId, focusSelectedTile) {
    return (0, $euxye.useCallback)((direction)=>{
        const selectedIndex = temporaryOrder.findIndex((app)=>app.productId === selectedProductId);
        const selectedTile = temporaryOrder[selectedIndex];
        if (!selectedTile) return;
        const newIndex = direction === 'down' ? selectedIndex + 1 : selectedIndex - 1;
        if (newIndex < 0 || newIndex >= temporaryOrder.length) return;
        const newOrder = [
            ...temporaryOrder
        ];
        newOrder.splice(selectedIndex, 1);
        newOrder.splice(newIndex, 0, selectedTile);
        setTemporaryOrder(newOrder);
        focusSelectedTile();
    }, [
        temporaryOrder,
        selectedProductId,
        focusSelectedTile,
        setTemporaryOrder
    ]);
}

});
parcelRegister("2fzzS", function(module, exports) {
$parcel$export(module.exports, "KeyboardReorderContext", () => $1da80339ce5e7137$export$423eea359e06ad0a);
$parcel$export(module.exports, "KeyboardReorderProvider", () => $1da80339ce5e7137$export$ae78bc628378987);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $364Xz = parcelRequire("364Xz");
const $1da80339ce5e7137$export$423eea359e06ad0a = /*#__PURE__*/ (0, $euxye.createContext)(null);
function $1da80339ce5e7137$export$ae78bc628378987({ children: children }) {
    const [isEnabled, setIsEnabled] = (0, $euxye.useState)(false);
    const [isVisible, setIsVisible] = (0, $euxye.useState)(false);
    const [selectedProductId, setSelectedProductId] = (0, $euxye.useState)(null);
    const { appTiles: appTiles, setAppTiles: setAppTiles, temporaryOrder: temporaryOrder, setTemporaryOrder: setTemporaryOrder, onReorder: onReorder, setOnReorder: setOnReorder } = (0, $364Xz.useAppTilesState)();
    const tileRefsMap = (0, $euxye.useRef)(new Map());
    const toggleRef = (0, $euxye.useRef)(null);
    const containerRef = (0, $euxye.useRef)(null);
    const focusSelectedTile = (0, $364Xz.useFocusSelectedTile)(selectedProductId, tileRefsMap);
    const moveSelectedTile = (0, $364Xz.useMoveSelectedTile)(temporaryOrder, setTemporaryOrder, selectedProductId, focusSelectedTile);
    (0, $euxye.useEffect)(()=>{
        if (!isEnabled || !isVisible) setSelectedProductId(null);
    }, [
        isVisible,
        isEnabled,
        setSelectedProductId
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isEnabled) setTemporaryOrder(appTiles);
    }, [
        isEnabled,
        appTiles,
        setTemporaryOrder
    ]);
    const cancelReorder = (0, $euxye.useCallback)(()=>{
        if (selectedProductId) {
            setSelectedProductId(null);
            setTemporaryOrder(appTiles);
        } else toggleRef.current?.focus();
    }, [
        appTiles,
        selectedProductId,
        setSelectedProductId,
        setTemporaryOrder,
        toggleRef
    ]);
    const applyReorder = (0, $euxye.useCallback)(()=>{
        onReorder?.(temporaryOrder);
        focusSelectedTile();
        setSelectedProductId(null);
    }, [
        onReorder,
        temporaryOrder,
        focusSelectedTile,
        setSelectedProductId
    ]);
    const exitReorderMode = (0, $euxye.useCallback)(()=>{
        setIsVisible(false);
        setIsEnabled(false);
        setSelectedProductId(null);
        setTemporaryOrder(appTiles);
    }, [
        appTiles,
        setIsVisible,
        setIsEnabled,
        setSelectedProductId,
        setTemporaryOrder
    ]);
    const contextValue = (0, $euxye.useMemo)(()=>({
            isKeyboardReorderToggleVisible: isVisible,
            isKeyboardReorderModeEnabled: isEnabled,
            selectedKeyboardReorderProductId: selectedProductId,
            setIsKeyboardReorderToggleVisible: setIsVisible,
            setIsKeyboardReorderModeEnabled: setIsEnabled,
            setKeyboardSelectedProductId: setSelectedProductId,
            temporaryKeyboardOrderedAppTiles: temporaryOrder,
            setAppTiles: setAppTiles,
            setOnAppsReorder: setOnReorder,
            moveKeyboardReorderSelectedTile: moveSelectedTile,
            keyboardReorderAppTileRefsMap: tileRefsMap,
            keyboardReorderToggleRef: toggleRef,
            cancelKeyboardReorder: cancelReorder,
            applyKeyboardReorder: applyReorder,
            exitKeyboardReorderMode: exitReorderMode,
            containerRef: containerRef
        }), [
        isVisible,
        isEnabled,
        selectedProductId,
        setIsVisible,
        setIsEnabled,
        setSelectedProductId,
        temporaryOrder,
        setAppTiles,
        setOnReorder,
        moveSelectedTile,
        tileRefsMap,
        toggleRef,
        cancelReorder,
        applyReorder,
        exitReorderMode,
        containerRef
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($1da80339ce5e7137$export$423eea359e06ad0a.Provider, {
        value: contextValue,
        children: children
    });
}
$1da80339ce5e7137$export$ae78bc628378987.displayName = "KeyboardReorderProvider";

});


parcelRegister("1c1Kj", function(module, exports) {
$parcel$export(module.exports, "useAppSelector", () => $98ff558a0e8ed5d4$export$a7347740d65f620b);

var $1YIbA = parcelRequire("1YIbA");

var $eprc4 = parcelRequire("eprc4");

var $6PJdS = parcelRequire("6PJdS");
const $98ff558a0e8ed5d4$export$a7347740d65f620b = (productId)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    switch(productId){
        case 'ADMIN':
            return {
                icon: (0, $eprc4.AdminIcon),
                text: formatMessage((0, $6PJdS.default).admin)
            };
        case 'ANALYTICS':
            return {
                icon: (0, $eprc4.AnalyticsIcon),
                text: formatMessage((0, $6PJdS.default).analytics)
            };
        case 'ASSETS':
            return {
                icon: (0, $eprc4.AssetsIcon),
                text: formatMessage((0, $6PJdS.default).assets)
            };
        case 'BITBUCKET':
            return {
                icon: (0, $eprc4.BitbucketIcon),
                text: 'Bitbucket'
            };
        case 'CHAT':
            return {
                icon: (0, $eprc4.ChatIcon),
                text: formatMessage((0, $6PJdS.default).chat)
            };
        case 'CSM':
            return {
                icon: (0, $eprc4.CustomerServiceManagementIcon),
                text: 'Customer Service Management'
            };
        case 'COMPASS':
            return {
                icon: (0, $eprc4.CompassIcon),
                text: 'Compass'
            };
        case 'CONFLUENCE':
            return {
                icon: (0, $eprc4.ConfluenceIcon),
                text: 'Confluence'
            };
        case 'DX':
            return {
                icon: (0, $eprc4.DxIcon),
                text: 'DX'
            };
        case 'FOCUS':
            return {
                icon: (0, $eprc4.FocusIcon),
                text: 'Focus'
            };
        case 'GOALS':
            return {
                icon: (0, $eprc4.GoalsIcon),
                text: formatMessage((0, $6PJdS.default).goals)
            };
        case 'HOME':
            return {
                icon: (0, $eprc4.HomeIcon),
                text: formatMessage((0, $6PJdS.default).home)
            };
        case 'JIRA':
            return {
                icon: (0, $eprc4.JiraIcon),
                text: 'Jira'
            };
        case 'JPD':
            return {
                icon: (0, $eprc4.JiraProductDiscoveryIcon),
                text: 'Jira Product Discovery'
            };
        case 'JSM':
            return {
                icon: (0, $eprc4.JiraServiceManagementIcon),
                text: 'Jira Service Management'
            };
        case 'LOOM':
            return {
                icon: (0, $eprc4.LoomIcon),
                text: 'Loom'
            };
        case 'OPSGENIE':
            return {
                icon: (0, $eprc4.OpsgenieIcon),
                text: 'Opsgenie'
            };
        case 'PROJECTS':
            return {
                icon: (0, $eprc4.ProjectsIcon),
                text: formatMessage((0, $6PJdS.default).projects)
            };
        case 'ROVO':
            return {
                icon: (0, $eprc4.RovoIcon),
                text: formatMessage((0, $6PJdS.default).rovo)
            };
        case 'SEARCH':
            return {
                icon: (0, $eprc4.SearchIcon),
                text: formatMessage((0, $6PJdS.default).search)
            };
        case 'STUDIO':
            return {
                icon: (0, $eprc4.StudioIcon),
                text: formatMessage((0, $6PJdS.default).studio)
            };
        case 'TALENT':
            return {
                icon: (0, $eprc4.TalentIcon),
                text: 'Talent'
            };
        case 'TEAMS':
            return {
                icon: (0, $eprc4.TeamsIcon),
                text: formatMessage((0, $6PJdS.default).teams)
            };
        case 'TRELLO':
            return {
                icon: (0, $eprc4.TrelloIcon),
                text: 'Trello'
            };
        default:
            return undefined;
    }
};

});
parcelRegister("6PJdS", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc4d0c50da39e0d2$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $dc4d0c50da39e0d2$var$messages = (0, $7eNDO.defineMessages)({
    admin: {
        id: 'navigation.ribbon.navigation-ribbon.product.admin.label',
        defaultMessage: 'Admin',
        description: 'The text of a link redirecting the user to the Admin app'
    },
    analytics: {
        id: 'navigation.ribbon.navigation-ribbon.product.analytics.label',
        defaultMessage: 'Analytics',
        description: 'The text of a link redirecting the user to the Analytics app'
    },
    assets: {
        id: 'navigation.ribbon.navigation-ribbon.product.assets.label',
        defaultMessage: 'Assets',
        description: 'The text of a link redirecting the user to the Assets app'
    },
    chat: {
        id: 'navigation.ribbon.navigation-ribbon.product.chat.label',
        defaultMessage: 'Chat',
        description: 'The text of a link redirecting the user to the Chat app'
    },
    goals: {
        id: 'navigation.ribbon.navigation-ribbon.product.goals.label',
        defaultMessage: 'Goals',
        description: 'The text of a link redirecting the user to the Goals app'
    },
    home: {
        id: 'navigation.ribbon.navigation-ribbon.product.home.label',
        defaultMessage: 'Home',
        description: 'The text of a link redirecting the user to the Home app'
    },
    projects: {
        id: 'navigation.ribbon.navigation-ribbon.product.projects.label',
        defaultMessage: 'Projects',
        description: 'The text of a link redirecting the user to the Projects app'
    },
    rovo: {
        id: 'navigation.ribbon.navigation-ribbon.product.rovo.label',
        defaultMessage: 'Rovo',
        description: 'The text of a link redirecting the user to the Rovo app'
    },
    search: {
        id: 'navigation.ribbon.navigation-ribbon.product.search.label',
        defaultMessage: 'Search',
        description: 'The text of a link redirecting the user to the Search app'
    },
    studio: {
        id: 'navigation.ribbon.navigation-ribbon.product.studio.label',
        defaultMessage: 'Studio',
        description: 'The text of a link redirecting the user to the Studio app'
    },
    teams: {
        id: 'navigation.ribbon.navigation-ribbon.product.teams.label',
        defaultMessage: 'Teams',
        description: 'The text of a link redirecting the user to the Teams app'
    }
});
var $dc4d0c50da39e0d2$export$2e2bcd8739ae039 = $dc4d0c50da39e0d2$var$messages;

});


parcelRegister("g3yRY", function(module, exports) {
$parcel$export(module.exports, "UnsafeTileInner", () => $c52cdd3d7847716d$export$f626098b34909780);
$parcel$export(module.exports, "UnsafeTile", () => $c52cdd3d7847716d$export$80c8f8efa7e573b7);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
/**
 * IMPORTANT CONTEXT:
 * This is an ADS sanctioned, but ultimately unsafe component that was created to match the Ribbon design.
 * It contains overrides that break NavX paradigms and should not be used outside of the Ribbon until such a
 * time as NavX paradigms can be updated to match Ribbon design needs. If you are using this component please
 * ensure you have read and understand the ADS approval for this component and are following all guidelines
 * outlined within it.
 *
 * See https://hello.atlassian.net/wiki/spaces/DST/pages/6395990823/DACI+Interactive+app+logos+in+ribbon
 *
 * One of the key objectives of this component is to ensure that the "notch" color matches the color of the
 * selected Logo. In order to achieve this the "notch" is actually a duplicate of the main logo with overrides
 * to make the icon color transparent and the tile color match the logo color. This means that any changes to
 * the way logos are rendered in NavX could potentially cause regressions in the appearance of the notch.
 *
 * Because of this, there is a VR test that renders all states of the tile with the current overrides in place.
 */ const $c52cdd3d7847716d$var$styles = {
    root: "_2rkol0p1 _1bsbzwfg _4t3izwfg _kqswh2mm",
    focused: "_16qs5nfi",
    focusedSelected: "_1qu2nqa1 _12y3dkaa _12ji1v1w _1cwgv77o",
    rootSmall: "_1bsb1tcg _4t3i1tcg",
    hovered: "_1rus1f0r",
    interactive: "_80omtlke _rfx3l0p1 _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _1mp41osq _kfgt1osq _1xqc1f0r _105ijer9",
    unselected: "_1d6w3acm _s7xa1q3r",
    disabled: "_tzy42wxo",
    draggable: "_80om1qgj _1qam5szm",
    editMode: "_1qu2gq9o _12y3e4h9 _12ji1l7x _1cwg1n1a _1kt9n7od",
    editModeInteractive: "_irr315s3 _1dit1ihb _1di6nozp _1q5tq98m",
    editModeHovered: "_bfhk15s3 _12ji1ihb",
    editModeFocused: "_16qsglyw _rfx3l0p1 _1kt9b3bt _1cs8stnw _1auk12gs _qnec12gs _1mp41pbc _kfgt1pbc _txdo5nfi _1d6w3acm _s7xa1q3r",
    editModeFocusedSelected: "_16qs130s _1qu2nqa1",
    notch: "_kqswh2mm _1ltv1h22 _s7xa3acm",
    notchFrame: "_1reo15vq _18m915vq _kqswstnw _1ltvidpf _1bsb1y44 _4t3i1tcg _154i1b66 _qrwq1mok _1o0z1mok",
    exterior: "_kqswh2mm _1bsb1osq _4t3izwfg _1e0c1txw _4cvr1h6o _1bah1h6o _n3td12x7"
};
function $c52cdd3d7847716d$export$f626098b34909780(props) {
    const { isDisabled: isDisabled, isDragPreview: isDragPreview, isEditMode: isEditMode, isFocused: isFocused, isHovered: isHovered, isNotch: isNotch, isSelected: isSelected, logo: Logo, size: size } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-app-tile-logo": !isNotch ? 'true' : undefined,
        className: (0, $4jQY2.default)([
            $c52cdd3d7847716d$var$styles.root,
            !isNotch && isFocused && !isSelected && $c52cdd3d7847716d$var$styles.focused,
            !isNotch && isFocused && isSelected && $c52cdd3d7847716d$var$styles.focusedSelected,
            !isDisabled && $c52cdd3d7847716d$var$styles.interactive,
            !isDisabled && !isEditMode && isHovered && $c52cdd3d7847716d$var$styles.hovered,
            !isDisabled && $c52cdd3d7847716d$var$styles.draggable,
            isDisabled && $c52cdd3d7847716d$var$styles.disabled,
            !isSelected && !isDragPreview && $c52cdd3d7847716d$var$styles.unselected,
            isEditMode && $c52cdd3d7847716d$var$styles.editMode,
            isEditMode && !isDisabled && $c52cdd3d7847716d$var$styles.editModeInteractive,
            isEditMode && !isDisabled && isHovered && $c52cdd3d7847716d$var$styles.editModeHovered,
            isEditMode && isFocused && $c52cdd3d7847716d$var$styles.editModeFocused,
            isEditMode && isFocused && isSelected && $c52cdd3d7847716d$var$styles.editModeFocusedSelected,
            isNotch && $c52cdd3d7847716d$var$styles.notch,
            size === 'small' && $c52cdd3d7847716d$var$styles.rootSmall
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)(Logo, {
            // set label to empty string to avoid duplicating the label
            label: '',
            shouldUseNewLogoDesign: true,
            appearance: isDragPreview ? 'inverse' : 'brand',
            size: size || 'medium'
        })
    });
}
$c52cdd3d7847716d$export$f626098b34909780.displayName = "UnsafeTileInner";
function $c52cdd3d7847716d$export$80c8f8efa7e573b7(props) {
    const { isSelected: isSelected, hideNotch: hideNotch, isEditMode: isEditMode } = props;
    if (!isSelected || isEditMode) return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $c52cdd3d7847716d$var$styles.exterior
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($c52cdd3d7847716d$export$f626098b34909780, {
            ...props
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        className: (0, $4jQY2.default)([
            $c52cdd3d7847716d$var$styles.exterior
        ]),
        children: [
            !hideNotch && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    $c52cdd3d7847716d$var$styles.notchFrame
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)($c52cdd3d7847716d$export$f626098b34909780, {
                    ...props,
                    isNotch: true
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)($c52cdd3d7847716d$export$f626098b34909780, {
                ...props,
                isNotch: false
            })
        ]
    });
}
$c52cdd3d7847716d$export$80c8f8efa7e573b7.displayName = "UnsafeTile";

});


parcelRegister("2gmhU", function(module, exports) {
$parcel$export(module.exports, "DragHandle", () => $1e0e6b5176b9f959$export$a0c24614540b0efb);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $arEoN = parcelRequire("arEoN");

var $ihEDU = parcelRequire("ihEDU");
const $1e0e6b5176b9f959$var$styles = {
    dragHandle: "_2rko12b0 _v5641obp _kqswstnw _154iu2gc _1ltvze3t _1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _80om1qgj _1pbykb7n"
};
const $1e0e6b5176b9f959$export$a0c24614540b0efb = ({ testId: testId })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        testId: testId,
        xcss: $1e0e6b5176b9f959$var$styles.dragHandle,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($arEoN))), {
            label: "Reorder",
            size: "small"
        })
    });
};
$1e0e6b5176b9f959$export$a0c24614540b0efb.displayName = "DragHandle";

});

parcelRegister("bRRX9", function(module, exports) {
$parcel$export(module.exports, "DropIndicator", () => $b716f9deb1bc70c4$export$62ed72bc21f6b8a6);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $ihEDU = parcelRequire("ihEDU");
const $b716f9deb1bc70c4$var$styles = {
    dropIndicator: "_4t3iyh40 _1bsbzwfg _kqswstnw _1ltv1ssb _t9ec1ooe",
    dropIndicatorTop: "_154i196n",
    dropIndicatorBottom: "_94n5196n"
};
const $b716f9deb1bc70c4$export$62ed72bc21f6b8a6 = ({ testId: testId, closestEdge: closestEdge })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: (0, $1MNmN.cx)($b716f9deb1bc70c4$var$styles.dropIndicator, closestEdge === 'top' ? $b716f9deb1bc70c4$var$styles.dropIndicatorTop : $b716f9deb1bc70c4$var$styles.dropIndicatorBottom),
        backgroundColor: "color.background.accent.blue.bolder",
        testId: testId
    });
};
$b716f9deb1bc70c4$export$62ed72bc21f6b8a6.displayName = "DropIndicator";

});

parcelRegister("78JFV", function(module, exports) {
$parcel$export(module.exports, "RIBBON_DND_TILE_TYPE", () => $ce9102dbfd66a9b8$export$3087bab914f1671f);
var $ce9102dbfd66a9b8$export$3087bab914f1671f = /*#__PURE__*/ function(RIBBON_DND_TILE_TYPE) {
    RIBBON_DND_TILE_TYPE["APP_TILE"] = "APP_TILE";
    RIBBON_DND_TILE_TYPE["HIDE_TILE"] = "HIDE_TILE";
    return RIBBON_DND_TILE_TYPE;
}({});

});

parcelRegister("5vxkp", function(module, exports) {
$parcel$export(module.exports, "isRibbonAppTileDndData", () => $13ccb035d6ef316c$export$7fa3c824911f44f9);
$parcel$export(module.exports, "isRibbonHideTileDndData", () => $13ccb035d6ef316c$export$d2fa3433eb7a3708);

var $78JFV = parcelRequire("78JFV");
function $13ccb035d6ef316c$export$7fa3c824911f44f9(data) {
    return data.type === (0, $78JFV.RIBBON_DND_TILE_TYPE).APP_TILE && typeof data.productId === 'string' && typeof data.index === 'number';
}
function $13ccb035d6ef316c$export$d2fa3433eb7a3708(data) {
    return data.type === (0, $78JFV.RIBBON_DND_TILE_TYPE).HIDE_TILE;
}

});


parcelRegister("3trGN", function(module, exports) {
$parcel$export(module.exports, "RibbonConfigContext", () => $1bb25902e1d303e3$export$8f6ca93b1a8369c1);
$parcel$export(module.exports, "RibbonConfigProvider", () => $1bb25902e1d303e3$export$91f99d9eb3862edb);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
const $1bb25902e1d303e3$export$8f6ca93b1a8369c1 = /*#__PURE__*/ (0, $euxye.createContext)(null);
const $1bb25902e1d303e3$export$91f99d9eb3862edb = ({ children: children, product: product })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)($1bb25902e1d303e3$export$8f6ca93b1a8369c1.Provider, {
        value: {
            product: product
        },
        children: children
    });
};
$1bb25902e1d303e3$export$91f99d9eb3862edb.displayName = "RibbonConfigProvider";

});

parcelRegister("hjxd7", function(module, exports) {
$parcel$export(module.exports, "useDragAndDrop", () => $56406d67abe53660$export$2cfc5be7a55829f6);

var $euxye = parcelRequire("euxye");

var $e4ZHy = parcelRequire("e4ZHy");

var $lKGrY = parcelRequire("lKGrY");
parcelRequire("3nfFb");
var $gOKKd = parcelRequire("gOKKd");
parcelRequire("jFnbs");
var $Anlri = parcelRequire("Anlri");

var $5vxkp = parcelRequire("5vxkp");
function $56406d67abe53660$export$2cfc5be7a55829f6({ apps: apps, onAppsReorder: onAppsReorder }) {
    const appsRef = (0, $euxye.useRef)(apps);
    (0, $euxye.useEffect)(()=>{
        // Keep the latest list in a ref so DnD callbacks always see current state,
        // without having to re-register the monitor on every reorder.
        appsRef.current = apps;
    }, [
        apps
    ]);
    const updateApps = (0, $euxye.useCallback)((updater)=>{
        // Update based on the latest list (not the list captured when callbacks were created).
        onAppsReorder(updater(appsRef.current));
    }, [
        onAppsReorder
    ]);
    const [draggingProductId, setDraggingProductId] = (0, $euxye.useState)(null);
    const [isDragActive, setIsDragActive] = (0, $euxye.useState)(false);
    (0, $euxye.useEffect)(()=>{
        return (0, $gOKKd.monitorForElements)({
            // Only respond to drags started from ribbon app tiles.
            canMonitor: ({ source: source })=>(0, $5vxkp.isRibbonAppTileDndData)(source.data),
            onDragStart ({ source: source }) {
                if (!(0, $5vxkp.isRibbonAppTileDndData)(source.data)) return;
                setIsDragActive(true);
                setDraggingProductId(source.data.productId);
            },
            onDrop ({ source: source, location: location }) {
                setIsDragActive(false);
                setDraggingProductId(null);
                const sourceData = source.data;
                if (!(0, $5vxkp.isRibbonAppTileDndData)(sourceData)) return;
                // Pragmatic DnD provides dropTargets ordered from inner-most → outer-most.
                // We only care about the inner-most actionable target for reordering/hiding.
                const [innerMost] = location.current.dropTargets;
                if (!innerMost) return;
                const dropTargetData = innerMost.data;
                const startIndex = sourceData.index;
                // Drop onto Hide tile moves it to the end
                if ((0, $5vxkp.isRibbonHideTileDndData)(dropTargetData)) {
                    updateApps((current)=>(0, $Anlri.reorder)({
                            list: current,
                            startIndex: startIndex,
                            finishIndex: current.length - 1
                        }));
                    return;
                }
                // Drop onto another tile reorders
                if (!(0, $5vxkp.isRibbonAppTileDndData)(dropTargetData)) return;
                // The reorder target includes a "closest edge" (top/bottom) instruction attached by the
                // hovered drop target (see `ReorderableAppTile.getData`).
                const closestEdgeOfTarget = (0, $e4ZHy.extractClosestEdge)(dropTargetData);
                const finishIndex = (0, $lKGrY.getReorderDestinationIndex)({
                    startIndex: startIndex,
                    closestEdgeOfTarget: closestEdgeOfTarget,
                    indexOfTarget: dropTargetData.index,
                    axis: 'vertical'
                });
                // If dropping back to the same position, skip any state updates.
                if (finishIndex === startIndex) return;
                updateApps((current)=>(0, $Anlri.reorder)({
                        list: current,
                        startIndex: startIndex,
                        finishIndex: finishIndex
                    }));
            }
        });
    }, [
        updateApps
    ]);
    return {
        draggingProductId: draggingProductId,
        isDragActive: isDragActive
    };
}

});

const $36113880e0e0b542$export$d03df12f1ca56488 = 64;
const $36113880e0e0b542$export$673092e1e0c5877b = 56;

parcelRegister("8g9cc", function(module, exports) {
$parcel$export(module.exports, "ErrorState", () => $0a06987e6ce81a49$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $hctZP = parcelRequire("hctZP");
const $0a06987e6ce81a49$export$c1ed4f415b9e7023 = ({ header: header, description: description })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hctZP.NavEmptyState), {
        header: header,
        description: description
    });
};
$0a06987e6ce81a49$export$c1ed4f415b9e7023.displayName = "ErrorState";

});

parcelRegister("5NGt8", function(module, exports) {
$parcel$export(module.exports, "MoreAppsPopup", () => $edbd9c3d25fb53d3$export$d57014f817c54cbb);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $1CdDx = parcelRequire("1CdDx");

var $luMsO = parcelRequire("luMsO");

var $aIPnR = parcelRequire("aIPnR");

var $dv27q = parcelRequire("dv27q");
function $edbd9c3d25fb53d3$export$d57014f817c54cbb({ appTiles: appTiles, isDragActive: isDragActive, isOpen: isOpen, onClose: onClose, onOpen: onOpen, testIdPrefix: testIdPrefix }) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1CdDx.default), {
        placement: "right-start",
        isOpen: isOpen,
        onClose: onClose,
        content: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $dv27q.MoreApps), {
                appItems: [],
                atlassianAppsItems: appTiles.map((app)=>({
                        productId: app.productId,
                        title: app.title,
                        url: app.href
                    })),
                integrationsAppsItems: [],
                marketplaceAppsItems: []
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $luMsO.MoreAppsOrHideTile), {
                onClick: onOpen,
                isDragActive: isDragActive,
                moreLabel: formatMessage((0, $aIPnR.messages).exampleMoreAppsText),
                hideLabel: formatMessage((0, $aIPnR.messages).exampleHideText),
                testIdPrefix: testIdPrefix,
                triggerProps: triggerProps
            }),
        shouldRenderToParent: true
    });
}
$edbd9c3d25fb53d3$export$d57014f817c54cbb.displayName = "MoreAppsPopup";

});
parcelRegister("luMsO", function(module, exports) {
$parcel$export(module.exports, "MoreAppsOrHideTile", () => $5bb0a2d154a25cf4$export$c9879f7b4380a1cd);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $fOxy5 = parcelRequire("fOxy5");

var $jYd2W = parcelRequire("jYd2W");
parcelRequire("3nfFb");
var $gOKKd = parcelRequire("gOKKd");

var $ihEDU = parcelRequire("ihEDU");
var $6mEZn = parcelRequire("6mEZn");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $auo2G = parcelRequire("auo2G");

var $78JFV = parcelRequire("78JFV");

var $5vxkp = parcelRequire("5vxkp");
const $5bb0a2d154a25cf4$var$styles = {
    moreAppsTrigger: "_18zridpf"
};
function $5bb0a2d154a25cf4$export$c9879f7b4380a1cd({ isDragActive: isDragActive, moreLabel: moreLabel, hideLabel: hideLabel, testIdPrefix: testIdPrefix, onClick: onClick, triggerProps: triggerProps }) {
    const ref = (0, $euxye.useRef)(null);
    const [isDraggedOver, setIsDraggedOver] = (0, $euxye.useState)(false);
    (0, $euxye.useEffect)(()=>{
        // If the overall drag ends (or was cancelled), ensure we clear the "over" state.
        if (!isDragActive) setIsDraggedOver(false);
    }, [
        isDragActive
    ]);
    (0, $euxye.useEffect)(()=>{
        const element = ref.current;
        if (!element) return;
        return (0, $gOKKd.dropTargetForElements)({
            element: element,
            // Keep the drop target registered at all times; `canDrop` ensures we only accept
            // ribbon app tiles, and the UI only shows "Hide" while a drag is active.
            canDrop ({ source: source }) {
                return (0, $5vxkp.isRibbonAppTileDndData)(source.data);
            },
            getData () {
                // This marker is used by the monitor hook to interpret the drop as a "hide" action.
                return {
                    type: (0, $78JFV.RIBBON_DND_TILE_TYPE).HIDE_TILE
                };
            },
            onDragEnter () {
                setIsDraggedOver(true);
            },
            onDragLeave () {
                setIsDraggedOver(false);
            },
            onDrop () {
                setIsDraggedOver(false);
            }
        });
    }, []);
    const handleMoreAppsClick = (event)=>{
        event.preventDefault();
        onClick();
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        ref: ref,
        testId: `${testIdPrefix}--${isDragActive ? 'hide' : 'more-apps'}-tile`,
        children: isDragActive ? // Hide app tile
        /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
            alignInline: "center",
            space: "space.075",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $auo2G.default), {
                    label: hideLabel,
                    size: "medium",
                    backgroundColor: // Provide a clear "drag over" affordance when the dragged tile is over the target.
                    isDragActive && isDraggedOver ? 'color.background.accent.gray.subtler' : 'color.background.accent.gray.subtlest',
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jYd2W))), {
                        label: hideLabel,
                        color: isDragActive ? 'var(--ds-icon-accent-red)' : undefined
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                    size: "small",
                    align: "center",
                    color: "color.text.subtle",
                    children: hideLabel
                })
            ]
        }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
            onClick: handleMoreAppsClick,
            testId: `${testIdPrefix}--more-apps-button`,
            xcss: $5bb0a2d154a25cf4$var$styles.moreAppsTrigger,
            ...triggerProps,
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
                alignInline: "center",
                space: "space.075",
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $auo2G.default), {
                        label: moreLabel,
                        size: "medium",
                        backgroundColor: 'color.background.accent.gray.subtlest',
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOxy5))), {
                            label: moreLabel,
                            color: "var(--ds-icon, #292A2E)"
                        })
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                        size: "small",
                        align: "center",
                        color: "color.text.subtle",
                        children: moreLabel
                    })
                ]
            })
        })
    });
}
$5bb0a2d154a25cf4$export$c9879f7b4380a1cd.displayName = "MoreAppsOrHideTile";

});

parcelRegister("aIPnR", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f4df2fc84f7337a4$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $f4df2fc84f7337a4$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    exampleSwitcherText: {
        id: 'navigation.ribbon.navigation-ribbon.switcher.example-label',
        description: 'Example switcher label in the navigation ribbon example.',
        defaultMessage: 'Switcher'
    },
    exampleMoreAppsText: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.example-label',
        description: 'Example more apps label in the navigation ribbon example.',
        defaultMessage: 'More Apps'
    },
    exampleHideText: {
        id: 'navigation.ribbon.navigation-ribbon.hide.example-label',
        description: 'Example hide label in the navigation ribbon example.',
        defaultMessage: 'Hide'
    },
    exampleProductConfluenceLabel: {
        id: 'navigation.ribbon.navigation-ribbon.product.confluence.label',
        description: 'Label for Confluence product tile in the navigation ribbon example.',
        defaultMessage: 'Confluence'
    },
    exampleProductJiraLabel: {
        id: 'navigation.ribbon.navigation-ribbon.product.jira.label',
        description: 'Label for Jira product tile in the navigation ribbon example.',
        defaultMessage: 'Jira'
    },
    exampleProductChatLabel: {
        id: 'navigation.ribbon.navigation-ribbon.product.chat.label',
        description: 'Label for Chat product tile in the navigation ribbon example.',
        defaultMessage: 'Chat'
    }
});

});

parcelRegister("dv27q", function(module, exports) {
$parcel$export(module.exports, "MoreApps", () => $73a0d3da4459cbb8$export$2a1c3f4f89f8745d);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $iOfms = parcelRequire("iOfms");

var $fOxy5 = parcelRequire("fOxy5");

var $ihEDU = parcelRequire("ihEDU");
var $2XXtG = parcelRequire("2XXtG");
var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $l19WB = parcelRequire("l19WB");

var $aAEvp = parcelRequire("aAEvp");

var $lyF17 = parcelRequire("lyF17");


var $dFeAx = parcelRequire("dFeAx");

var $LnxDx = parcelRequire("LnxDx");

var $iyJys = parcelRequire("iyJys");

var $aXYAn = parcelRequire("aXYAn");
const $73a0d3da4459cbb8$var$MORE_APPS_MAX_HEIGHT = '99vh';
const $73a0d3da4459cbb8$var$styles = {
    container: "_1reo15vq _18m915vq _2rko1mok _189ee4h9 _1h6d1l7x _1dqonqa1 _1e0c1txw _2lx21bp4 _4t3i5b4d _c71l5b4d _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _16qs130s",
    stack: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1tkeidpf _1e0c1txw _2lx21bp4",
    headerRow: "_1o9zidpf",
    filterRow: "_1o9zidpf",
    moreAppsContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf _18m91wug _1reo15vq _1bsb1osq _2lx21bp4 _n3tdutpp",
    exploreMoreAppsButtonContainer: "_1o9zidpf _1bsb1osq _uwhke4h9 _1i531l7x _15a5nqa1 _ca0qu2gc"
};
const $73a0d3da4459cbb8$export$2a1c3f4f89f8745d = (props)=>{
    const { appItems: appItems = [], atlassianAppsItems: atlassianAppsItems = [], integrationsAppsItems: integrationsAppsItems = [], marketplaceAppsItems: marketplaceAppsItems = [], hasLoadError: hasLoadError = false, maxSelectedApps: maxSelectedApps = (0, $79383f19e58fb160$export$79817ae51476ea6f), onUpdateItems: onUpdateItems, containerWidth: containerWidth = (0, $79383f19e58fb160$export$4de47d9300ebac33) } = props;
    const intl = (0, $1YIbA.default)();
    const [isCustomizing, setIsCustomizing] = (0, $euxye.useState)(false);
    const allAppItems = (0, $euxye.useMemo)(()=>{
        return {
            appItems: appItems,
            atlassianAppsItems: atlassianAppsItems,
            integrationsAppsItems: integrationsAppsItems,
            marketplaceAppsItems: marketplaceAppsItems
        };
    }, [
        appItems,
        atlassianAppsItems,
        integrationsAppsItems,
        marketplaceAppsItems
    ]);
    const [filteredAppItems, setFilteredAppItems] = (0, $euxye.useState)(allAppItems);
    const { processedItems: processedItems, selectedApps: selectedApps, onToggleSelect: onToggleSelect } = (0, $aAEvp.useAppItemsState)({
        items: allAppItems,
        filteredItems: filteredAppItems,
        setFilteredAppItems: setFilteredAppItems,
        isCustomizing: isCustomizing,
        maxSelectedApps: maxSelectedApps
    });
    const totalProcessedItemsCount = processedItems.appItems.length + processedItems.atlassianAppsItems.length + processedItems.integrationsAppsItems.length + processedItems.marketplaceAppsItems.length;
    const showNoResultsState = totalProcessedItemsCount === 0;
    const onClickCancelButton = (0, $euxye.useCallback)(()=>{
    // TODO Analytics
    }, []);
    // @TODO Apply save functionality
    const onClickApplyButton = (0, $euxye.useCallback)(()=>{
        // TODO Analytics
        onUpdateItems?.(processedItems);
    }, [
        processedItems,
        onUpdateItems
    ]);
    if (hasLoadError) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dFeAx.ErrorState), {});
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: $73a0d3da4459cbb8$var$styles.container,
        style: {
            width: containerWidth,
            maxWidth: containerWidth
        },
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
            space: "space.150",
            xcss: $73a0d3da4459cbb8$var$styles.stack,
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.default), {
                    xcss: $73a0d3da4459cbb8$var$styles.headerRow,
                    spread: "space-between",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                            color: "color.text.accent.gray",
                            weight: "bold",
                            children: intl.formatMessage((0, $aXYAn.messages).moreAppsLabel)
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $defJG.default), {
                            space: "space.050",
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $l19WB.CustomizeButtons), {
                                isCustomizing: isCustomizing,
                                setIsCustomizing: setIsCustomizing,
                                onCancel: onClickCancelButton,
                                onApply: onClickApplyButton
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2XXtG.default), {
                    xcss: $73a0d3da4459cbb8$var$styles.filterRow,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iyJys.FilterApps), {
                        appItems: allAppItems,
                        onChange: setFilteredAppItems
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2XXtG.default), {
                    xcss: $73a0d3da4459cbb8$var$styles.moreAppsContainer,
                    children: showNoResultsState ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $LnxDx.NoResultsState), {}) : /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                        children: [
                            isCustomizing && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lyF17.AppsGroup), {
                                title: intl.formatMessage((0, $aXYAn.messages).appsSelectedLabel, {
                                    count: selectedApps.size,
                                    max: maxSelectedApps
                                }),
                                isCustomizing: isCustomizing,
                                items: processedItems.appItems,
                                onToggleSelect: onToggleSelect
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lyF17.AppsGroup), {
                                isCustomizing: isCustomizing,
                                title: intl.formatMessage((0, $aXYAn.messages).atlassianAppsGroupTitle),
                                items: processedItems.atlassianAppsItems,
                                onToggleSelect: onToggleSelect
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lyF17.AppsGroup), {
                                isCustomizing: isCustomizing,
                                title: intl.formatMessage((0, $aXYAn.messages).marketplaceAppsGroupTitle),
                                items: processedItems.marketplaceAppsItems,
                                onToggleSelect: onToggleSelect
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lyF17.AppsGroup), {
                                isCustomizing: isCustomizing,
                                title: intl.formatMessage((0, $aXYAn.messages).integrationsAppsGroupTitle),
                                items: processedItems.integrationsAppsItems,
                                onToggleSelect: onToggleSelect
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                    xcss: $73a0d3da4459cbb8$var$styles.exploreMoreAppsButtonContainer,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iOfms.default), {
                        appearance: "default",
                        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($fOxy5))),
                        shouldFitContainer: true,
                        children: intl.formatMessage((0, $aXYAn.messages).exploreMoreAppsButtonLabel)
                    })
                })
            ]
        })
    });
};
$73a0d3da4459cbb8$export$2a1c3f4f89f8745d.displayName = "MoreApps";

});
parcelRegister("l19WB", function(module, exports) {
$parcel$export(module.exports, "CustomizeButtons", () => $e7271bb72f902c50$export$89a32ffab8071ca);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $iOfms = parcelRequire("iOfms");

var $aFuZX = parcelRequire("aFuZX");
function $e7271bb72f902c50$export$89a32ffab8071ca({ isCustomizing: isCustomizing, setIsCustomizing: setIsCustomizing, onCancel: onCancel, onApply: onApply }) {
    const intl = (0, $1YIbA.default)();
    const onClickCustomizeButton = (0, $euxye.useCallback)(()=>{
        setIsCustomizing(true);
    }, [
        setIsCustomizing
    ]);
    const onClickCancelButton = (0, $euxye.useCallback)(()=>{
        setIsCustomizing(false);
        onCancel();
    }, [
        onCancel,
        setIsCustomizing
    ]);
    const onClickApplyButton = (0, $euxye.useCallback)(()=>{
        setIsCustomizing(false);
        onApply();
    }, [
        onApply,
        setIsCustomizing
    ]);
    if (isCustomizing) return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iOfms.default), {
                onClick: onClickCancelButton,
                children: intl.formatMessage((0, $aFuZX.messages).cancelButtonLabel)
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iOfms.default), {
                appearance: "primary",
                onClick: onClickApplyButton,
                children: intl.formatMessage((0, $aFuZX.messages).applyButtonLabel)
            })
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iOfms.default), {
        onClick: onClickCustomizeButton,
        children: intl.formatMessage((0, $aFuZX.messages).customizeButtonLabel)
    });
}
$e7271bb72f902c50$export$89a32ffab8071ca.displayName = "CustomizeButtons";

});
parcelRegister("aFuZX", function(module, exports) {
$parcel$export(module.exports, "messages", () => $885c07369c43cea2$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $885c07369c43cea2$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    applyButtonLabel: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.apply-button.label',
        description: 'Label for the apply button in the more apps component in the navigation ribbon.',
        defaultMessage: 'Apply'
    },
    cancelButtonLabel: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.cancel-button.label',
        description: 'Label for the cancel button in the more apps component in the navigation ribbon.',
        defaultMessage: 'Cancel'
    },
    customizeButtonLabel: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.customize-button.label',
        description: 'Label for the customize button in the more apps component in the navigation ribbon.',
        defaultMessage: 'Customize'
    }
});

});


parcelRegister("aAEvp", function(module, exports) {
$parcel$export(module.exports, "useAppItemsState", () => $989696673349042f$export$3bfce583a695eb14);

var $euxye = parcelRequire("euxye");
function $989696673349042f$export$3bfce583a695eb14({ items: items, filteredItems: filteredItems, isCustomizing: isCustomizing, setFilteredAppItems: setFilteredAppItems, maxSelectedApps: maxSelectedApps }) {
    const [selectedApps, setSelectedApps] = (0, $euxye.useState)(()=>{
        const allItems = [
            ...items.appItems,
            ...items.atlassianAppsItems,
            ...items.integrationsAppsItems,
            ...items.marketplaceAppsItems
        ];
        return new Set(allItems.filter((item)=>item.isSelected).map((item)=>item.productId));
    });
    /**
	 * Regroup the filtered app items based on the selected apps
	 * This allows for presentational regrouping to occur more easily when the selected apps change
	 */ const regroupedAppItemsBySelections = (0, $euxye.useMemo)(()=>{
        const filterSelectedAppItems = (item)=>selectedApps.has(item.productId);
        const appItems = filteredItems.appItems || [];
        const atlassianAppsItems = filteredItems.atlassianAppsItems || [];
        const integrationsAppsItems = filteredItems.integrationsAppsItems || [];
        const marketplaceAppsItems = filteredItems.marketplaceAppsItems || [];
        const regroupedItems = {
            appItems: [
                ...appItems,
                ...atlassianAppsItems.filter(filterSelectedAppItems),
                ...integrationsAppsItems.filter(filterSelectedAppItems),
                ...marketplaceAppsItems.filter(filterSelectedAppItems)
            ],
            atlassianAppsItems: atlassianAppsItems.filter((item)=>!selectedApps.has(item.productId)),
            integrationsAppsItems: integrationsAppsItems.filter((item)=>!selectedApps.has(item.productId)),
            marketplaceAppsItems: marketplaceAppsItems.filter((item)=>!selectedApps.has(item.productId))
        };
        if (isCustomizing) {
            const mapItemsAsSelectable = (item)=>({
                    ...item,
                    isSelectable: item.isSelectable ?? true
                });
            return {
                appItems: regroupedItems.appItems.map(mapItemsAsSelectable),
                atlassianAppsItems: regroupedItems.atlassianAppsItems.map(mapItemsAsSelectable),
                integrationsAppsItems: regroupedItems.integrationsAppsItems,
                marketplaceAppsItems: regroupedItems.marketplaceAppsItems
            };
        }
        return regroupedItems;
    }, [
        filteredItems,
        isCustomizing,
        selectedApps
    ]);
    (0, $euxye.useEffect)(()=>{
        if (isCustomizing === false) setFilteredAppItems(items);
    }, [
        items,
        isCustomizing,
        setFilteredAppItems
    ]);
    const onToggleSelect = (0, $euxye.useCallback)((productId)=>{
        setSelectedApps((prev)=>{
            const next = new Set(prev);
            if (next.has(productId)) next.delete(productId);
            else if (next.size < maxSelectedApps) next.add(productId);
            return next;
        });
    }, [
        maxSelectedApps
    ]);
    const withSelection = (0, $euxye.useCallback)((items)=>items.map((item)=>({
                ...item,
                isSelected: selectedApps.has(item.productId)
            })), [
        selectedApps
    ]);
    const processedItems = (0, $euxye.useMemo)(()=>{
        if (isCustomizing) return {
            appItems: withSelection(regroupedAppItemsBySelections.appItems),
            atlassianAppsItems: withSelection(regroupedAppItemsBySelections.atlassianAppsItems),
            integrationsAppsItems: withSelection(regroupedAppItemsBySelections.integrationsAppsItems),
            marketplaceAppsItems: withSelection(regroupedAppItemsBySelections.marketplaceAppsItems)
        };
        return {
            appItems: filteredItems.appItems,
            atlassianAppsItems: filteredItems.atlassianAppsItems,
            integrationsAppsItems: filteredItems.integrationsAppsItems,
            marketplaceAppsItems: filteredItems.marketplaceAppsItems
        };
    }, [
        filteredItems.appItems,
        filteredItems.atlassianAppsItems,
        filteredItems.integrationsAppsItems,
        filteredItems.marketplaceAppsItems,
        isCustomizing,
        regroupedAppItemsBySelections.appItems,
        regroupedAppItemsBySelections.atlassianAppsItems,
        regroupedAppItemsBySelections.integrationsAppsItems,
        regroupedAppItemsBySelections.marketplaceAppsItems,
        withSelection
    ]);
    return {
        selectedApps: selectedApps,
        processedItems: processedItems,
        onToggleSelect: onToggleSelect
    };
}

});

parcelRegister("lyF17", function(module, exports) {
$parcel$export(module.exports, "AppsGroup", () => $9113e399f138e452$export$18e6b724786831b0);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $m9iwH = parcelRequire("m9iwH");

var $ld25x = parcelRequire("ld25x");

var $aFpts = parcelRequire("aFpts");

var $72ldR = parcelRequire("72ldR");

var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $jWv8W = parcelRequire("jWv8W");

var $f5sEx = parcelRequire("f5sEx");
const $9113e399f138e452$var$styles = {
    container: "_1bsb1osq"
};
const $9113e399f138e452$export$18e6b724786831b0 = (props)=>{
    const { title: title, items: items, onToggleSelect: onToggleSelect, isCustomizing: isCustomizing = false } = props;
    const [isCollapsed, setIsCollapsed] = (0, $euxye.useState)(false);
    const intl = (0, $1YIbA.default)();
    if (!items.length) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
        space: "space.050",
        xcss: $9113e399f138e452$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.default), {
                alignBlock: "center",
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
                        label: isCollapsed ? intl.formatMessage((0, $f5sEx.messages).expandButtonLabel) : intl.formatMessage((0, $f5sEx.messages).collapseButtonLabel),
                        icon: isCollapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($aFpts))) : (0, (/*@__PURE__*/$parcel$interopDefault($ld25x))),
                        onClick: ()=>setIsCollapsed(!isCollapsed),
                        appearance: "subtle",
                        spacing: "compact"
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                        children: title
                    })
                ]
            }),
            !isCollapsed && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $72ldR.default), {
                spacing: "cozy",
                children: items.map((item, index)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $jWv8W.AppsGroupItem), {
                        ...item,
                        isCustomizing: isCustomizing,
                        onToggleSelect: onToggleSelect
                    }, index))
            })
        ]
    });
};
$9113e399f138e452$export$18e6b724786831b0.displayName = "AppsGroup";

});
parcelRegister("jWv8W", function(module, exports) {
$parcel$export(module.exports, "AppsGroupItem", () => $4a0e4c32462e0023$export$39522c52464fbb6a);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $apqVV = parcelRequire("apqVV");

var $cSR11 = parcelRequire("cSR11");

var $ihEDU = parcelRequire("ihEDU");
var $defJG = parcelRequire("defJG");

var $auo2G = parcelRequire("auo2G");

var $1c1Kj = parcelRequire("1c1Kj");

var $g3yRY = parcelRequire("g3yRY");

var $h2Z23 = parcelRequire("h2Z23");
const $4a0e4c32462e0023$var$styles = {
    container: "_4cvr1h6o",
    linkWrapper: "_2rko1qi0 _1reo15vq _18m915vq _1bsb1osq",
    emptyCheckboxSpace: "_1bsb1tcg _4t3i1tcg"
};
const $4a0e4c32462e0023$export$39522c52464fbb6a = (props)=>{
    const { icon: icon, isCustomizing: isCustomizing, isSelectable: isSelectable, isSelected: isSelected = false, onToggleSelect: onToggleSelect, title: title, url: url, productId: productId, iconUrl: iconUrl } = props;
    const productIcon = (0, $1c1Kj.useAppSelector)(productId);
    const intl = (0, $1YIbA.default)();
    const renderableIcon = (0, $euxye.useMemo)(()=>{
        if (productIcon) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g3yRY.UnsafeTileInner), {
            logo: productIcon.icon,
            isSelected: true,
            size: "small"
        });
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $auo2G.default), {
            size: "small",
            label: "",
            isInset: false,
            children: icon || /*#__PURE__*/ (0, $e79Pd.jsx)("img", {
                src: iconUrl,
                alt: title,
                width: 24,
                height: 24
            })
        });
    }, [
        icon,
        iconUrl,
        productIcon,
        title
    ]);
    const onToggleSelectCheckbox = (0, $euxye.useCallback)(()=>{
        onToggleSelect?.(productId);
    }, [
        onToggleSelect,
        productId
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.default), {
        space: "space.100",
        xcss: $4a0e4c32462e0023$var$styles.container,
        children: [
            isCustomizing && (isSelectable ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $apqVV.default), {
                isChecked: isSelected,
                onChange: onToggleSelectCheckbox,
                "aria-label": intl.formatMessage((0, $h2Z23.messages).selectAppCheckboxLabel, {
                    appName: title
                })
            }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $4a0e4c32462e0023$var$styles.emptyCheckboxSpace
            })),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $4a0e4c32462e0023$var$styles.linkWrapper,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cSR11.default), {
                    href: url,
                    iconBefore: renderableIcon,
                    children: title
                })
            })
        ]
    });
};
$4a0e4c32462e0023$export$39522c52464fbb6a.displayName = "AppsGroupItem";

});
parcelRegister("h2Z23", function(module, exports) {
$parcel$export(module.exports, "messages", () => $4769892ca8a5760c$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $4769892ca8a5760c$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    selectAppCheckboxLabel: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.apps-group.apps-group-item.select-app-checkbox-label',
        description: 'Accessible label for the checkbox to select an app in the more apps list.',
        defaultMessage: 'Select {appName}'
    }
});

});


parcelRegister("f5sEx", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8b06f81ab11df597$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $8b06f81ab11df597$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    collapseButtonLabel: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.apps-group.collapse-button-label',
        description: 'Accessible label for the collapsed chevron button in the apps group title.',
        defaultMessage: 'Collapse'
    },
    expandButtonLabel: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.apps-group.expand-button-label',
        description: 'Accessible label for the expanded chevron button in the apps group title.',
        defaultMessage: 'Expand'
    }
});

});


const $79383f19e58fb160$export$79817ae51476ea6f = 12;
const $79383f19e58fb160$export$4de47d9300ebac33 = '312px';

parcelRegister("dFeAx", function(module, exports) {
$parcel$export(module.exports, "ErrorState", () => $aa5782e20f3b9eb6$export$c1ed4f415b9e7023);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $hctZP = parcelRequire("hctZP");

var $aXYAn = parcelRequire("aXYAn");
const $aa5782e20f3b9eb6$export$c1ed4f415b9e7023 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hctZP.NavEmptyState), {
        header: formatMessage((0, $aXYAn.messages).loadErrorTitle),
        description: formatMessage((0, $aXYAn.messages).loadErrorMessage)
    });
};
$aa5782e20f3b9eb6$export$c1ed4f415b9e7023.displayName = "ErrorState";

});
parcelRegister("aXYAn", function(module, exports) {
$parcel$export(module.exports, "messages", () => $47c858394d429974$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $47c858394d429974$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    moreAppsLabel: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.label',
        description: 'More apps label in the navigation ribbon.',
        defaultMessage: 'More Apps'
    },
    noResultsTitle: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.no-results.message',
        description: 'Message shown in the more apps component when the user searches but no apps match the filter text.',
        defaultMessage: "We couldn\u2019t find anything that matches your search"
    },
    noResultsMessage: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.no-results.hint',
        description: 'Message shown under the no results message in the more apps component.',
        defaultMessage: 'Try searching for something else.'
    },
    loadErrorTitle: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.load-error.title',
        description: 'Title shown in the more apps component when the apps data failed to load',
        defaultMessage: "We couldn\u2019t load more apps"
    },
    loadErrorMessage: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.load-error.message',
        description: 'Message shown in the more apps component when the apps data failed to load',
        defaultMessage: 'Refresh the page and try again'
    },
    appsSelectedLabel: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.apps-selected.label',
        description: 'Label showing the number of apps selected out of the maximum allowed in the more apps component in the navigation ribbon.',
        defaultMessage: '{count}/{max} apps selected'
    },
    atlassianAppsGroupTitle: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.atlassian-apps-group.title',
        description: 'Title for the Atlassian apps group in the more apps component in the navigation ribbon.',
        defaultMessage: 'Atlassian apps'
    },
    marketplaceAppsGroupTitle: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.marketplace-apps-group.title',
        description: 'Title for the Marketplace apps group in the more apps component in the navigation ribbon.',
        defaultMessage: 'Marketplace apps'
    },
    integrationsAppsGroupTitle: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.integrations-apps-group.title',
        description: 'Title for the Integrations apps group in the more apps component in the navigation ribbon.',
        defaultMessage: 'Integrations'
    },
    exploreMoreAppsButtonLabel: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.explore-more-apps-button.label',
        description: 'Label for the explore more apps button in the more apps component in the navigation ribbon.',
        defaultMessage: 'Explore more apps'
    }
});

});


parcelRegister("LnxDx", function(module, exports) {
$parcel$export(module.exports, "NoResultsState", () => $16498358127457ec$export$afc8c839ce65544f);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $hctZP = parcelRequire("hctZP");

var $aXYAn = parcelRequire("aXYAn");
const $16498358127457ec$export$afc8c839ce65544f = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hctZP.NavEmptyState), {
        header: formatMessage((0, $aXYAn.messages).noResultsTitle),
        description: formatMessage((0, $aXYAn.messages).noResultsMessage),
        renderImage: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {})
    });
};
$16498358127457ec$export$afc8c839ce65544f.displayName = "NoResultsState";

});

parcelRegister("iyJys", function(module, exports) {
$parcel$export(module.exports, "FilterApps", () => $460b153aa341f9e4$export$99dff3147f9b9874);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $4B6hN = parcelRequire("4B6hN");

var $eAQb7 = parcelRequire("eAQb7");

var $ihEDU = parcelRequire("ihEDU");

var $7aCqr = parcelRequire("7aCqr");


var $8nmxw = parcelRequire("8nmxw");
const $460b153aa341f9e4$var$styles = {
    searchIconContainer: "_bozgu2gc"
};
const $460b153aa341f9e4$export$99dff3147f9b9874 = (props)=>{
    const { onChange: onChange, appItems: appItems } = props;
    const [searchInputValue, setSearchInputValue] = (0, $euxye.useState)('');
    const intl = (0, $1YIbA.default)();
    const [debouncedSetSearchValue] = (0, $4B6hN.default)((inputValue)=>{
        const filteredAppItems = {
            appItems: [],
            atlassianAppsItems: [],
            integrationsAppsItems: [],
            marketplaceAppsItems: []
        };
        for (const [key, value] of Object.entries(appItems))filteredAppItems[key] = value.filter((item)=>item.title.toLowerCase().includes(inputValue.toLowerCase()));
        onChange(filteredAppItems);
    }, (0, $e55cb8bb2b1d30cf$export$e907fe684aa8ce6c));
    const onChangeHandler = (0, $euxye.useCallback)((event)=>{
        const value = event.currentTarget.value;
        setSearchInputValue(value);
        debouncedSetSearchValue(value);
    }, [
        debouncedSetSearchValue
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7aCqr.default), {
        elemBeforeInput: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
            xcss: $460b153aa341f9e4$var$styles.searchIconContainer,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAQb7))), {
                color: "var(--ds-icon-subtlest, #6B6E76)",
                spacing: "spacious",
                label: ""
            })
        }),
        value: searchInputValue,
        onChange: onChangeHandler,
        placeholder: intl.formatMessage((0, $8nmxw.messages).searchAppsPlaceholder)
    });
};
$460b153aa341f9e4$export$99dff3147f9b9874.displayName = "FilterApps";

});
const $e55cb8bb2b1d30cf$export$e907fe684aa8ce6c = 200;

parcelRegister("8nmxw", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e5fe0a4ec18e9a59$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $e5fe0a4ec18e9a59$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    searchAppsPlaceholder: {
        id: 'navigation.ribbon.navigation-ribbon.more-apps.search-apps.placeholder',
        description: 'Placeholder text for the search apps input in the more apps component in the navigation ribbon.',
        defaultMessage: 'Search apps'
    }
});

});




parcelRegister("drhN1", function(module, exports) {
$parcel$export(module.exports, "OrgSwitcherPopup", () => $6fa9c379044eb73f$export$8f51cad9b83be3fb);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $1CdDx = parcelRequire("1CdDx");

var $ihEDU = parcelRequire("ihEDU");
var $6mEZn = parcelRequire("6mEZn");

var $aIPnR = parcelRequire("aIPnR");

var $favxO = parcelRequire("favxO");
const $6fa9c379044eb73f$var$styles = {
    orgSwitcherButton: "_2rko1mok _1bsbzwfg _4t3izwfg _bfhkuibq",
    headerContainer: "_ca0qutpp _1bsbzwfg"
};
function $6fa9c379044eb73f$export$8f51cad9b83be3fb({ isOpen: isOpen, onClose: onClose, onOpen: onOpen }) {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: $6fa9c379044eb73f$var$styles.headerContainer,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1CdDx.default), {
            placement: "right",
            offset: [
                0,
                20
            ],
            isOpen: isOpen,
            onClose: onClose,
            content: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $favxO.default), {
                    currentOrgId: "org-1",
                    title: "Org Switcher",
                    currentUnitId: "unit-1",
                    orgs: [
                        {
                            id: 'org-1',
                            name: 'Org 1',
                            units: [
                                {
                                    id: 'unit-1',
                                    name: 'Unit 1'
                                }
                            ]
                        }
                    ]
                }),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
                    ...triggerProps,
                    "aria-label": formatMessage((0, $aIPnR.messages).exampleSwitcherText),
                    onClick: onOpen,
                    testId: "navigation-ribbon--org-switcher-button",
                    xcss: $6fa9c379044eb73f$var$styles.orgSwitcherButton
                }),
            shouldRenderToParent: true
        })
    });
}
$6fa9c379044eb73f$export$8f51cad9b83be3fb.displayName = "OrgSwitcherPopup";

});
parcelRegister("favxO", function(module, exports) {
$parcel$export(module.exports, "default", () => $324a9ed55de2d4f7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $jaPl6 = parcelRequire("jaPl6");
var $2YPKP = parcelRequire("2YPKP");
var $2Xkyn = parcelRequire("2Xkyn");

var $ld25x = parcelRequire("ld25x");

var $aFpts = parcelRequire("aFpts");

var $ihEDU = parcelRequire("ihEDU");
var $defJG = parcelRequire("defJG");
var $6mEZn = parcelRequire("6mEZn");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $auo2G = parcelRequire("auo2G");

var $f3A47 = parcelRequire("f3A47");

var $jMgrp = parcelRequire("jMgrp");

var $ddT2U = parcelRequire("ddT2U");

var $YtWJt = parcelRequire("YtWJt");
const $324a9ed55de2d4f7$var$styles = {
    switcherTrigger: "_2rko1mok _bfhk1j9a _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _1bsb1osq _9oik18uv _1bnxglyw _jf4cnqa1 _irr3plhp",
    container: "_2rko12b0 _1e0c1txw _2lx21bp4 _bfhk1bhr _16qs130s _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1bsbeo28",
    orgListContainer: "_1reo1wug _18m91wug _ca0qv77o _n3tdv77o",
    chevronIcon: "_19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc"
};
const $324a9ed55de2d4f7$var$OrgSwitcherComponent = (props)=>{
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const [selectedOrg, setSelectedOrg] = (0, $euxye.useState)(()=>{
        return props.orgs.find((org)=>org.id === props.currentOrgId) ?? props.orgs[0];
    });
    const [selectedUnit, setSelectedUnit] = (0, $euxye.useState)(props.currentUnitId);
    const onOrgSelected = (org)=>{
        setSelectedOrg(org);
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3PC9r.default), {
        xcss: $324a9ed55de2d4f7$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jaPl6.default), {
                shouldFitContainer: true,
                shouldFlip: false,
                isOpen: isOpen,
                shouldRenderToParent: true,
                onOpenChange: (attrs)=>{
                    setIsOpen(attrs.isOpen);
                },
                trigger: ({ triggerRef: triggerRef, onClick: onClick, ...triggerProps })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
                        ...triggerProps,
                        ref: triggerRef,
                        xcss: $324a9ed55de2d4f7$var$styles.switcherTrigger,
                        isDisabled: props.orgs.length <= 1,
                        onClick: (e)=>{
                            onClick?.(e);
                        },
                        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.default), {
                            alignBlock: "center",
                            space: "space.100",
                            spread: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.default), {
                                    alignBlock: "center",
                                    space: "space.100",
                                    children: [
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $auo2G.default), {
                                            label: selectedOrg.name
                                        }),
                                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                                            align: "start",
                                            children: selectedOrg.name
                                        })
                                    ]
                                }),
                                props.orgs.length > 1 ? isOpen ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                                    xcss: $324a9ed55de2d4f7$var$styles.chevronIcon,
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aFpts))), {
                                        label: "Collapse",
                                        size: "small"
                                    })
                                }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                                    xcss: $324a9ed55de2d4f7$var$styles.chevronIcon,
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld25x))), {
                                        label: "Expand",
                                        size: "small"
                                    })
                                }) : null
                            ]
                        })
                    }),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                    xcss: $324a9ed55de2d4f7$var$styles.orgListContainer,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2Xkyn.default), {
                        children: props.orgs.map((org)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $2YPKP.default), {
                                isSelected: org.name === selectedOrg.name,
                                onClick: ()=>onOrgSelected(org),
                                children: org.name
                            }, org.name))
                    })
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $YtWJt.default), {
                orgName: selectedOrg.name,
                units: selectedOrg.units,
                setSelectedUnit: (unitId)=>setSelectedUnit(unitId),
                selectedUnitId: selectedUnit
            })
        ]
    });
};
$324a9ed55de2d4f7$var$OrgSwitcherComponent.displayName = "OrgSwitcherComponent";
function $324a9ed55de2d4f7$export$2e2bcd8739ae039(props) {
    const { product: product } = (0, $jMgrp.useRibbonConfig)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $f3A47.NavErrorBoundary), {
        location: `${(0, $0d02ca2fc86ffe27$export$7b1d5fb8b81e96a9)}--org-switcher`,
        sentryConfig: {
            product: product
        },
        errorFallbackUI: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $3PC9r.default), {
                xcss: $324a9ed55de2d4f7$var$styles.container,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ddT2U.ErrorState), {})
            }),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($324a9ed55de2d4f7$var$OrgSwitcherComponent, {
            ...props
        })
    });
}
$324a9ed55de2d4f7$export$2e2bcd8739ae039.displayName = "OrgSwitcher";

});
parcelRegister("jMgrp", function(module, exports) {
$parcel$export(module.exports, "useRibbonConfig", () => $5f0d511be1326d4e$export$d9fbb7d2cdca5bb1);

var $euxye = parcelRequire("euxye");

var $3trGN = parcelRequire("3trGN");
function $5f0d511be1326d4e$export$d9fbb7d2cdca5bb1() {
    const context = (0, $euxye.useContext)((0, $3trGN.RibbonConfigContext));
    if (!context) throw new Error('useRibbonConfig must be used within a RibbonConfigProvider');
    return context;
}

});

parcelRegister("ddT2U", function(module, exports) {
$parcel$export(module.exports, "ErrorState", () => $199417a9781c1970$export$c1ed4f415b9e7023);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $hctZP = parcelRequire("hctZP");

var $2oQNl = parcelRequire("2oQNl");
const $199417a9781c1970$export$c1ed4f415b9e7023 = ()=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hctZP.NavEmptyState), {
        header: formatMessage((0, $2oQNl.messages).loadErrorTitle),
        description: formatMessage((0, $2oQNl.messages).loadErrorMessage)
    });
};
$199417a9781c1970$export$c1ed4f415b9e7023.displayName = "ErrorState";

});
parcelRegister("2oQNl", function(module, exports) {
$parcel$export(module.exports, "messages", () => $20d339abae102cc1$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $20d339abae102cc1$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    loadErrorTitle: {
        id: 'navigation.ribbon.navigation-ribbon.org-switcher.load-error.title',
        description: 'Title shown in the org switcher component when the apps data failed to load',
        defaultMessage: "We couldn\u2019t load the organization switcher"
    },
    loadErrorMessage: {
        id: 'navigation.ribbon.navigation-ribbon.org-switcher.load-error.message',
        description: 'Message shown in the org switcher component when the apps data failed to load',
        defaultMessage: 'Refresh the page and try again'
    }
});

});


parcelRegister("YtWJt", function(module, exports) {
$parcel$export(module.exports, "default", () => $12200080708a5ed2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $ihEDU = parcelRequire("ihEDU");
var $3PC9r = parcelRequire("3PC9r");

var $3G7vk = parcelRequire("3G7vk");

var $dEQOe = parcelRequire("dEQOe");
const $12200080708a5ed2$var$styles = {
    divider: "_1doce4h9 _1il9nqa1 _1o3i1l7x _19pkpxbi _otyrpxbi",
    unitHeader: "_11c8wadc _1rjcu2gc _18zru2gc _syaz1rpy _k48p1wq8"
};
const $12200080708a5ed2$var$UnitSwitcher = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3PC9r.default), {
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                    xcss: $12200080708a5ed2$var$styles.divider
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                    xcss: $12200080708a5ed2$var$styles.unitHeader,
                    children: formatMessage((0, $3G7vk.messages).unitHeader, {
                        orgName: props.orgName
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3PC9r.default), {
                    space: "space.050",
                    children: props.units.map((unit)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $dEQOe.UnitSwitcherItem), {
                            id: unit.id,
                            name: unit.name,
                            isSelectedUnit: props.selectedUnitId === unit.id,
                            onClick: ()=>{
                                props.setSelectedUnit(unit.id);
                            }
                        }, unit.id))
                })
            ]
        })
    });
};
$12200080708a5ed2$var$UnitSwitcher.displayName = "UnitSwitcher";
var $12200080708a5ed2$export$2e2bcd8739ae039 = $12200080708a5ed2$var$UnitSwitcher;

});
parcelRegister("3G7vk", function(module, exports) {
$parcel$export(module.exports, "messages", () => $df193694b5315415$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $df193694b5315415$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    unitHeader: {
        id: 'navigation.ribbon.navigation-ribbon.unit.header',
        description: 'Header for the unit in the navigation ribbon unit switcher.',
        defaultMessage: '{orgName} Units'
    }
});

});

parcelRegister("dEQOe", function(module, exports) {
$parcel$export(module.exports, "UnitSwitcherItem", () => $b43a8aa63f9462fe$export$ce7c950ca7b03f97);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $8z2GW = parcelRequire("8z2GW");

var $1MNmN = parcelRequire("1MNmN");

var $defJG = parcelRequire("defJG");
var $6mEZn = parcelRequire("6mEZn");
var $8Sdzy = parcelRequire("8Sdzy");
const $b43a8aa63f9462fe$var$styles = {
    switcherItem: "_bfhk1bhr _9oik18uv _1bnxglyw _jf4cnqa1 _irr3plhp",
    switcherItemSelected: "_bfhk15s3 _9oik18uv _1bnxglyw _jf4cnqa1 _irr3ufnl",
    switcherItemContainer: "_2rko1mok _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc"
};
const $b43a8aa63f9462fe$export$ce7c950ca7b03f97 = (props)=>{
    const { name: name, isSelectedUnit: isSelectedUnit, onClick: onClick } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
        xcss: (0, $1MNmN.cx)($b43a8aa63f9462fe$var$styles.switcherItemContainer, isSelectedUnit ? $b43a8aa63f9462fe$var$styles.switcherItemSelected : $b43a8aa63f9462fe$var$styles.switcherItem),
        onClick: onClick,
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $defJG.default), {
            alignBlock: "center",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8z2GW.default), {
                    size: "small",
                    appearance: "square"
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                    color: isSelectedUnit ? 'color.text.selected' : 'color.text',
                    children: name
                })
            ]
        })
    });
};
$b43a8aa63f9462fe$export$ce7c950ca7b03f97.displayName = "UnitSwitcherItem";

});




parcelRegister("43GFv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fe21ec65611f86c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
var $2XXtG = parcelRequire("2XXtG");
var $3PC9r = parcelRequire("3PC9r");

var $3tQu8 = parcelRequire("3tQu8");

var $364Xz = parcelRequire("364Xz");

var $kC5Yo = parcelRequire("kC5Yo");

var $dwTax = parcelRequire("dwTax");
const $2fe21ec65611f86c$var$styles = {
    container: "_4t3i1osq _bfhkysee _ca0q1b66",
    contentContainer: "_18m91wug _ca0q1b66",
    divider: "_ca0qu2gc _n3tdu2gc _1bsbzwfg _14b51ylp"
};
function $2fe21ec65611f86c$export$2e2bcd8739ae039({ header: header, content: content, footer: footer, hasLoaded: hasLoaded = true, testId: testId }) {
    const { containerRef: containerRef } = (0, $364Xz.useKeyboardReorderContext)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2XXtG.default), {
        ref: containerRef,
        testId: testId,
        xcss: $2fe21ec65611f86c$var$styles.container,
        direction: "column",
        alignItems: "center",
        "data-layout-slot": true,
        children: !hasLoaded ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dwTax.RibbonSkeleton), {}) : /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
            children: [
                header && /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                    children: [
                        header,
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                            xcss: $2fe21ec65611f86c$var$styles.divider,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3tQu8.Divider), {})
                        })
                    ]
                }),
                content && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3PC9r.default), {
                    space: "space.100",
                    grow: "fill",
                    xcss: $2fe21ec65611f86c$var$styles.contentContainer,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2XXtG.default), {
                        gap: "space.150",
                        direction: "column",
                        alignItems: "center",
                        testId: `${testId}--reorder-content`,
                        children: content
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kC5Yo.default), {}),
                footer && /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $e79Pd.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                            xcss: $2fe21ec65611f86c$var$styles.divider,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3tQu8.Divider), {})
                        }),
                        footer
                    ]
                })
            ]
        })
    });
}
$2fe21ec65611f86c$export$2e2bcd8739ae039.displayName = "RibbonLayout";

});
parcelRegister("3tQu8", function(module, exports) {
$parcel$export(module.exports, "Divider", () => $dffca69a9da57083$export$2e0a83ec2e27ecbb);
/* divider.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $dffca69a9da57083$var$styles = null;
const $dffca69a9da57083$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)("hr", {
        /**
 * The existing usage of these dividers is presentational,
 * so we are removing the separator semantics by default.
 *
 * In the future we may consider allowing opt-in separator semantics,
 * but it probably isn't necessary.
 */ role: "none",
        className: (0, $4jQY2.default)([
            "_h7alglyw _179rglyw _mqm2ia51 _1bsb1osq"
        ])
    });
$dffca69a9da57083$export$2e0a83ec2e27ecbb.displayName = "Divider";

});

parcelRegister("kC5Yo", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4e1ea98c632cab8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $ihEDU = parcelRequire("ihEDU");
var $8Sdzy = parcelRequire("8Sdzy");

var $3qlLs = parcelRequire("3qlLs");

var $364Xz = parcelRequire("364Xz");

var $1gj8e = parcelRequire("1gj8e");
const $f4e1ea98c632cab8$var$styles = {
    container: "_ca0qu2gc _1e0c1txw _2lx21bp4 _4cvr1h6o"
};
function $f4e1ea98c632cab8$export$2e2bcd8739ae039() {
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { isKeyboardReorderModeEnabled: isKeyboardReorderModeEnabled, setIsKeyboardReorderModeEnabled: setIsKeyboardReorderModeEnabled, isKeyboardReorderToggleVisible: isVisible, keyboardReorderToggleRef: keyboardReorderToggleRef, exitKeyboardReorderMode: exitKeyboardReorderMode, containerRef: containerRef } = (0, $364Xz.useKeyboardReorderContext)();
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
        xcss: $f4e1ea98c632cab8$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3qlLs.default), {
                id: "toggle-reorder-apps",
                testId: "toggle-reorder-apps",
                label: formatMessage((0, $1gj8e.messages).ariaReorderLabel),
                isChecked: isKeyboardReorderModeEnabled,
                ref: keyboardReorderToggleRef,
                onChange: ()=>setIsKeyboardReorderModeEnabled(!isKeyboardReorderModeEnabled),
                onBlur: (e)=>{
                    const isStillInRibbon = containerRef.current?.contains(e.relatedTarget);
                    if (!isStillInRibbon) exitKeyboardReorderMode();
                }
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("label", {
                htmlFor: "toggle-reorder-apps",
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                    maxLines: 1,
                    size: "small",
                    align: "center",
                    color: "color.text.disabled",
                    children: formatMessage((0, $1gj8e.messages).reorderLabel)
                })
            })
        ]
    });
}
$f4e1ea98c632cab8$export$2e2bcd8739ae039.displayName = "ReorderToggle";

});
parcelRegister("1gj8e", function(module, exports) {
$parcel$export(module.exports, "messages", () => $6d70b5f5f78aa8f8$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $6d70b5f5f78aa8f8$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    reorderLabel: {
        id: 'navigation.ribbon.reorder-toggle.label',
        description: 'Label for the reorder toggle in the navigation ribbon.',
        defaultMessage: 'Re-order'
    },
    ariaReorderLabel: {
        id: 'navigation.ribbon.reorder-toggle.arial-label',
        description: 'Aria label for the reorder toggle in the navigation ribbon.',
        defaultMessage: 'Re-order apps in the app rail'
    }
});

});


parcelRegister("dwTax", function(module, exports) {
$parcel$export(module.exports, "RibbonSkeleton", () => $cf7c8b07a2a6dc6a$export$b3c6adb9c7b3673e);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $ihEDU = parcelRequire("ihEDU");
var $2XXtG = parcelRequire("2XXtG");

var $3NRLa = parcelRequire("3NRLa");
const $cf7c8b07a2a6dc6a$var$styles = {
    header: "_ca0qutpp _n3tdutpp",
    spacer: "_ca0qu2gc _n3tdu2gc",
    subtitle: "_n3td1b66",
    apps: "_ca0q1b66 _n3tdu2gc",
    footer: "_ca0qu2gc"
};
const $cf7c8b07a2a6dc6a$var$IconSkeleton = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
        width: "32px",
        height: "32px",
        borderRadius: "var(--ds-radius-tile, 25%)",
        isShimmering: true
    });
$cf7c8b07a2a6dc6a$var$IconSkeleton.displayName = "IconSkeleton";
const $cf7c8b07a2a6dc6a$var$SubtitleSkeleton = ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2XXtG.default), {
        direction: "column",
        alignItems: "center",
        gap: "space.100",
        xcss: $cf7c8b07a2a6dc6a$var$styles.subtitle,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)($cf7c8b07a2a6dc6a$var$IconSkeleton, {}),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
                width: "32px",
                height: "4px",
                borderRadius: "var(--ds-radius-full, 9999px)",
                isShimmering: true
            })
        ]
    });
$cf7c8b07a2a6dc6a$var$SubtitleSkeleton.displayName = "SubtitleSkeleton";
const $cf7c8b07a2a6dc6a$var$SpacerSkeleton = ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: $cf7c8b07a2a6dc6a$var$styles.spacer,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3NRLa.default), {
            width: "40px",
            height: "1px",
            isShimmering: true
        })
    });
$cf7c8b07a2a6dc6a$var$SpacerSkeleton.displayName = "SpacerSkeleton";
const $cf7c8b07a2a6dc6a$var$clamp = (value, min, max)=>Math.min(max, Math.max(min, value));
const $cf7c8b07a2a6dc6a$var$getAppSkeletonCountForViewportHeight = (viewportHeight)=>{
    const reservedPx = 220; // header + footer + spacers + vertical padding (approx)
    const perItemPx = 52; // one app row height (approx)
    const availablePx = Math.max(0, viewportHeight - reservedPx);
    const estimatedCount = Math.floor(availablePx / perItemPx);
    return $cf7c8b07a2a6dc6a$var$clamp(estimatedCount, 1, 9);
};
const $cf7c8b07a2a6dc6a$export$b3c6adb9c7b3673e = ({})=>{
    const [appCount, setAppCount] = (0, $euxye.useState)(9);
    (0, $euxye.useEffect)(()=>{
        const update = ()=>setAppCount($cf7c8b07a2a6dc6a$var$getAppSkeletonCountForViewportHeight(window.innerHeight));
        update();
        const unbind = (0, $glbdM.bind)(window, {
            type: 'resize',
            listener: update
        });
        return unbind;
    }, []);
    //Render between 1 and 9 app skeletons based on the viewport height
    const appSkeletonRows = (0, $euxye.useMemo)(()=>Array.from({
            length: appCount
        }, (_, index)=>/*#__PURE__*/ (0, $e79Pd.jsx)($cf7c8b07a2a6dc6a$var$SubtitleSkeleton, {}, index)), [
        appCount
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2XXtG.default), {
        direction: "column",
        alignItems: "center",
        testId: "ribbon-skeleton",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $cf7c8b07a2a6dc6a$var$styles.header,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)($cf7c8b07a2a6dc6a$var$IconSkeleton, {})
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)($cf7c8b07a2a6dc6a$var$SpacerSkeleton, {}),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2XXtG.default), {
                direction: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "space.150",
                xcss: $cf7c8b07a2a6dc6a$var$styles.apps,
                children: appSkeletonRows
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)($cf7c8b07a2a6dc6a$var$SpacerSkeleton, {}),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $cf7c8b07a2a6dc6a$var$styles.footer,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)($cf7c8b07a2a6dc6a$var$SubtitleSkeleton, {})
            })
        ]
    });
};
$cf7c8b07a2a6dc6a$export$b3c6adb9c7b3673e.displayName = "RibbonSkeleton";

});



parcelRegister("diTVj", function(module, exports) {
$parcel$export(module.exports, "IsRibbonEnabledProvider", () => $82c9e87a434a3b6f$export$ddfc044437f61c87);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $eB4z7 = parcelRequire("eB4z7");
const $82c9e87a434a3b6f$export$ddfc044437f61c87 = ({ children: children, value: value })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eB4z7.IsRibbonEnabledContext).Provider, {
        value: value,
        children: children
    });
};
$82c9e87a434a3b6f$export$ddfc044437f61c87.displayName = "IsRibbonEnabledProvider";

});
parcelRegister("eB4z7", function(module, exports) {
$parcel$export(module.exports, "IsRibbonEnabledContext", () => $11fdccf6bf14883a$export$567090b059effdb1);

var $euxye = parcelRequire("euxye");
const $11fdccf6bf14883a$export$567090b059effdb1 = /*#__PURE__*/ (0, $euxye.createContext)(false);

});


parcelRegister("6LQvl", function(module, exports) {
$parcel$export(module.exports, "messages", () => $4166c0d40a06da97$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $4166c0d40a06da97$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    collapseSidebar: {
        defaultMessage: 'Collapse sidebar',
        description: 'Label for the button that collapses the sidebar navigation.',
        id: 'global-root.global-root.collapseSidebar'
    },
    conversationAssistant: {
        defaultMessage: 'Conversation Assistant',
        description: 'Placeholder label for the conversation assistant slot in the top navigation bar.',
        id: 'global-root.global-root.conversationAssistant'
    },
    editionAwareness: {
        defaultMessage: 'Edition awareness',
        description: 'Placeholder label for the edition awareness slot in the top navigation bar.',
        id: 'global-root.global-root.editionAwareness'
    },
    expandSidebar: {
        defaultMessage: 'Expand sidebar',
        description: 'Label for the button that expands the sidebar navigation.',
        id: 'global-root.global-root.expandSidebar'
    },
    help: {
        defaultMessage: 'Help',
        description: 'Label for the help button in the top navigation bar.',
        id: 'global-root.global-root.help'
    },
    logo: {
        defaultMessage: 'Logo',
        description: 'Placeholder label for the logo slot in the top navigation bar.',
        id: 'global-root.global-root.logo'
    },
    notifications: {
        defaultMessage: 'Notifications',
        description: 'Placeholder label for the notifications slot in the top navigation bar.',
        id: 'global-root.global-root.notifications'
    },
    profile: {
        defaultMessage: 'Profile',
        description: 'Placeholder label for the profile slot in the top navigation bar.',
        id: 'global-root.global-root.profile'
    },
    search: {
        defaultMessage: 'Search',
        description: 'Placeholder label for the search slot in the top navigation bar.',
        id: 'global-root.global-root.search'
    },
    settings: {
        defaultMessage: 'Settings',
        description: 'Placeholder label for the settings slot in the top navigation bar.',
        id: 'global-root.global-root.settings'
    },
    universalCreate: {
        defaultMessage: 'Universal Create',
        description: 'Placeholder label for the universal create slot in the top navigation bar.',
        id: 'global-root.global-root.universalCreate'
    }
});

});


parcelRegister("a7e1f", function(module, exports) {
$parcel$export(module.exports, "defaultMemoize", () => $75d56eb6410917f7$export$281bff7f05488aa2, (v) => $75d56eb6410917f7$export$281bff7f05488aa2 = v);
$parcel$export(module.exports, "createSelectorCreator", () => $75d56eb6410917f7$export$5943f4447f6ef248, (v) => $75d56eb6410917f7$export$5943f4447f6ef248 = v);
$parcel$export(module.exports, "createStructuredSelector", () => $75d56eb6410917f7$export$75979cfcd91bf38f, (v) => $75d56eb6410917f7$export$75979cfcd91bf38f = v);
$parcel$export(module.exports, "createSelector", () => $75d56eb6410917f7$export$595d22ed68ca2841, (v) => $75d56eb6410917f7$export$595d22ed68ca2841 = v);
var $75d56eb6410917f7$export$1e511d4a378977f5;
var $75d56eb6410917f7$export$281bff7f05488aa2;
var $75d56eb6410917f7$export$5943f4447f6ef248;
var $75d56eb6410917f7$export$75979cfcd91bf38f;
var $75d56eb6410917f7$export$595d22ed68ca2841;
'use strict';
$75d56eb6410917f7$export$1e511d4a378977f5 = true;
$75d56eb6410917f7$export$281bff7f05488aa2 = $75d56eb6410917f7$var$defaultMemoize;
$75d56eb6410917f7$export$5943f4447f6ef248 = $75d56eb6410917f7$var$createSelectorCreator;
$75d56eb6410917f7$export$75979cfcd91bf38f = $75d56eb6410917f7$var$createStructuredSelector;
function $75d56eb6410917f7$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $75d56eb6410917f7$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function $75d56eb6410917f7$var$defaultMemoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $75d56eb6410917f7$var$defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!$75d56eb6410917f7$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function $75d56eb6410917f7$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function $75d56eb6410917f7$var$createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $75d56eb6410917f7$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = $75d56eb6410917f7$var$defaultMemoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var $75d56eb6410917f7$var$createSelector = $75d56eb6410917f7$export$595d22ed68ca2841 = $75d56eb6410917f7$var$createSelectorCreator($75d56eb6410917f7$var$defaultMemoize);
function $75d56eb6410917f7$var$createStructuredSelector(selectors) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $75d56eb6410917f7$var$createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}

});

parcelRegister("7Tg4F", function(module, exports) {
$parcel$export(module.exports, "QuickFindSkeleton", () => $5653ca489cc456b6$export$8f0d616c2469c6b6);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $gUxVT = parcelRequire("gUxVT");

var $7ZDiP = parcelRequire("7ZDiP");

var $4zsq4 = parcelRequire("4zsq4");

var $9pzAB = parcelRequire("9pzAB");

var $hhYhk = parcelRequire("hhYhk");

var $gXrOS = parcelRequire("gXrOS");

var $b2QJu = parcelRequire("b2QJu");
if (!window.inputSkeletonState) (0, $7ZDiP.resetInputSkeletonState)();
const $5653ca489cc456b6$export$8f0d616c2469c6b6 = ({ onEnter: onEnter, isNav4Enabled: isNav4Enabled, injectValue: injectValue, customPlaceholder: customPlaceholder, inputRef: inputRef })=>{
    const dialogId = (0, $gUxVT.useId)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const initialSearchQuery = (0, $hhYhk.getInitialQuery)();
    // Use the stored state as initial values for expansion and query
    const [isExpanded, setIsExpanded] = (0, $euxye.useState)((0, $7ZDiP.getInputSkeletonFocus)());
    const [value, setValue] = (0, $euxye.useState)(()=>injectValue ?? initialSearchQuery);
    const ghostTextData = (0, $euxye.useMemo)(()=>(0, $gXrOS.parseGhostTextData)(customPlaceholder), [
        customPlaceholder
    ]);
    const onFocus = (e)=>{
        setIsExpanded(true);
        (0, $7ZDiP.setInputSkeletonIsFocus)(true);
        const target = e.currentTarget;
        (0, $7ZDiP.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
    };
    const onBlur = ()=>{
        setIsExpanded(false);
        (0, $7ZDiP.setInputSkeletonIsFocus)(false);
        (0, $7ZDiP.setInputSkeletonSelection)(0, 0, 'none');
    };
    const onKeyDown = (e)=>{
        const target = e.currentTarget;
        if (e.key === 'Escape') {
            target.blur();
            onBlur();
        }
    };
    const onChange = (e)=>{
        const newValue = e.currentTarget.value;
        setValue(newValue);
        (0, $7ZDiP.setInputSkeletonQuery)(newValue);
        const target = e.currentTarget;
        (0, $7ZDiP.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
        (0, $4zsq4.setSessionItem)((0, $4zsq4.SEARCH_QUERY_KEY), newValue);
    };
    const onSelect = (e)=>{
        const target = e.currentTarget;
        (0, $7ZDiP.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9pzAB.Textfield), {
        value: value,
        placeholder: ghostTextData?.text ?? formatMessage((0, $b2QJu.messages).placeholder),
        dialogId: dialogId,
        quickFindOpen: isExpanded,
        onEnter: onEnter,
        onClick: onFocus,
        onFocus: onFocus,
        onBlur: onBlur,
        onSelect: onSelect,
        onKeyDown: onKeyDown,
        onChange: onChange,
        isNav4Enabled: isNav4Enabled,
        inputRef: inputRef
    });
};
$5653ca489cc456b6$export$8f0d616c2469c6b6.displayName = "QuickFindSkeleton";

});
parcelRegister("7ZDiP", function(module, exports) {
$parcel$export(module.exports, "getInputSkeletonQuery", () => $2d08d169433ee773$export$b8b6c2e7a0664212);
$parcel$export(module.exports, "setInputSkeletonQuery", () => $2d08d169433ee773$export$baa1c819dd4691f3);
$parcel$export(module.exports, "getInputSkeletonFocus", () => $2d08d169433ee773$export$38fcbc98be180790);
$parcel$export(module.exports, "setInputSkeletonIsFocus", () => $2d08d169433ee773$export$d3c6894b4e9af000);
$parcel$export(module.exports, "getInputSkeletonSelection", () => $2d08d169433ee773$export$a0c71b3bd9ec143c);
$parcel$export(module.exports, "setInputSkeletonSelection", () => $2d08d169433ee773$export$e0d745255b135363);
$parcel$export(module.exports, "resetInputSkeletonState", () => $2d08d169433ee773$export$c89dd2d5d4024c5e);
$parcel$export(module.exports, "removeInputSkeletonEventListeners", () => $2d08d169433ee773$export$166ce39761ad7743);
$parcel$export(module.exports, "removeInputSkeletonState", () => $2d08d169433ee773$export$c830bcf42e072a93);
const $2d08d169433ee773$var$getWindow = ()=>typeof window !== 'undefined' ? window : null;
const $2d08d169433ee773$export$b8b6c2e7a0664212 = ()=>{
    return $2d08d169433ee773$var$getWindow()?.inputSkeletonState?.query ?? '';
};
const $2d08d169433ee773$export$baa1c819dd4691f3 = (newQuery)=>{
    const { inputSkeletonState: inputSkeletonState } = $2d08d169433ee773$var$getWindow() ?? {};
    if (inputSkeletonState) inputSkeletonState.query = newQuery;
};
const $2d08d169433ee773$export$38fcbc98be180790 = ()=>{
    return $2d08d169433ee773$var$getWindow()?.inputSkeletonState?.isFocused || false;
};
const $2d08d169433ee773$export$d3c6894b4e9af000 = (newIsFocused)=>{
    const { inputSkeletonState: inputSkeletonState } = $2d08d169433ee773$var$getWindow() ?? {};
    if (inputSkeletonState) inputSkeletonState.isFocused = newIsFocused;
};
const $2d08d169433ee773$export$a0c71b3bd9ec143c = ()=>{
    const { inputSkeletonState: inputSkeletonState } = $2d08d169433ee773$var$getWindow() ?? {};
    return {
        selectionStart: inputSkeletonState?.selectionStart ?? 0,
        selectionEnd: inputSkeletonState?.selectionEnd ?? 0,
        selectionDirection: inputSkeletonState?.selectionDirection ?? 'none'
    };
};
const $2d08d169433ee773$export$e0d745255b135363 = (newSelectionStart, newSelectionEnd, newSelectionDirection)=>{
    const { inputSkeletonState: inputSkeletonState } = $2d08d169433ee773$var$getWindow() ?? {};
    if (inputSkeletonState) {
        inputSkeletonState.selectionStart = newSelectionStart;
        inputSkeletonState.selectionEnd = newSelectionEnd;
        inputSkeletonState.selectionDirection = newSelectionDirection;
    }
};
const $2d08d169433ee773$export$c89dd2d5d4024c5e = ()=>{
    const safeWindow = $2d08d169433ee773$var$getWindow();
    if (safeWindow) safeWindow.inputSkeletonState = {
        query: '',
        placeholder: '',
        isFocused: false,
        selectionStart: 0,
        selectionEnd: 0,
        selectionDirection: 'none',
        listeners: []
    };
};
const $2d08d169433ee773$export$166ce39761ad7743 = ()=>{
    const { inputSkeletonState: inputSkeletonState } = $2d08d169433ee773$var$getWindow() ?? {};
    if (inputSkeletonState) {
        inputSkeletonState.listeners.forEach(([target, event, handler])=>{
            target.removeEventListener(event, handler);
        });
        inputSkeletonState.listeners = [];
    }
};
const $2d08d169433ee773$export$c830bcf42e072a93 = ()=>{
    $2d08d169433ee773$export$166ce39761ad7743();
    delete $2d08d169433ee773$var$getWindow()?.inputSkeletonState;
};

});

parcelRegister("4zsq4", function(module, exports) {
$parcel$export(module.exports, "SEARCH_QUERY_KEY", () => $14258b55d44b3a96$export$240cb7dc75f6cac2);
$parcel$export(module.exports, "SEARCH_FILTERS_KEY", () => $14258b55d44b3a96$export$978fb20afa14aaa7);
$parcel$export(module.exports, "SEARCH_SHOW_AI_DIALOG_KEY", () => $14258b55d44b3a96$export$f4dca218ecb5824a);
$parcel$export(module.exports, "getSessionItem", () => $14258b55d44b3a96$export$fdf7104ff19cc288);
$parcel$export(module.exports, "setSessionItem", () => $14258b55d44b3a96$export$a5376dd4adeb0fbf);
$parcel$export(module.exports, "deleteSessionItem", () => $14258b55d44b3a96$export$5896963da935fdc4);

var $4fPPi = parcelRequire("4fPPi");

var $egspI = parcelRequire("egspI");
const $14258b55d44b3a96$export$9d075e4b938a80be = 'atlassian.search-dialog-sticky';
const $14258b55d44b3a96$export$240cb7dc75f6cac2 = 'atlassian.search-dialog-query';
const $14258b55d44b3a96$export$978fb20afa14aaa7 = 'atlassian.search-dialog-filters';
const $14258b55d44b3a96$export$f4dca218ecb5824a = 'atlassian.search-dialog.ai-dialog';
const $14258b55d44b3a96$var$getWindow = ()=>{
    if (typeof window === 'undefined') return null;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    if (typeof window.sessionStorage === 'undefined' && (0, $egspI.fg)('fix_ssr_browser_storage_undefined')) return null;
    return window;
};
const $14258b55d44b3a96$export$fdf7104ff19cc288 = (key)=>{
    const windowReady = $14258b55d44b3a96$var$getWindow();
    if (!windowReady) return null;
    return (0, $egspI.fg)('search_page_use_bsc_session_storage') ? (0, $4fPPi.AtlBrowserStorageSession).getItem(key) : $14258b55d44b3a96$var$getWindow()?.sessionStorage.getItem(key);
};
const $14258b55d44b3a96$export$a5376dd4adeb0fbf = (key, value)=>{
    const windowReady = $14258b55d44b3a96$var$getWindow();
    if (!windowReady) return;
    try {
        if ((0, $egspI.fg)('search_page_use_bsc_session_storage')) (0, $4fPPi.AtlBrowserStorageSession).setItem(key, value);
        else $14258b55d44b3a96$var$getWindow()?.sessionStorage.setItem(key, value);
    } catch (error) {
        error.code, DOMException.QUOTA_EXCEEDED_ERR;
    }
};
const $14258b55d44b3a96$export$5896963da935fdc4 = (key)=>{
    const windowReady = $14258b55d44b3a96$var$getWindow();
    if (!windowReady) return;
    if ((0, $egspI.fg)('search_page_use_bsc_session_storage')) (0, $4fPPi.AtlBrowserStorageSession).removeItem(key);
    else $14258b55d44b3a96$var$getWindow()?.sessionStorage.removeItem(key);
};

});

parcelRegister("9pzAB", function(module, exports) {
$parcel$export(module.exports, "Textfield", () => $8a9662beee4149a8$export$d66ddc2063fc70a7);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $1YIbA = parcelRequire("1YIbA");

var $m9iwH = parcelRequire("m9iwH");

var $i68tN = parcelRequire("i68tN");

var $eAQb7 = parcelRequire("eAQb7");

var $egspI = parcelRequire("egspI");

var $c69sa = parcelRequire("c69sa");
var $fbAgj = parcelRequire("fbAgj");

var $cRVE8 = parcelRequire("cRVE8");

var $3wYKy = parcelRequire("3wYKy");

var $8EB7p = parcelRequire("8EB7p");

var $apvKK = parcelRequire("apvKK");
const $8a9662beee4149a8$var$textFieldBoxBaseStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: 'size.300',
    ':focus': {
        height: 'size.400'
    },
    width: '100%',
    paddingRight: 'space.200'
});
const $8a9662beee4149a8$var$textFieldBoxStyles = (0, $fbAgj.xcss)({
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $8a9662beee4149a8$var$textFieldBoxStylesT26Shape = (0, $fbAgj.xcss)({
    borderRadius: 'radius.medium'
});
const $8a9662beee4149a8$var$textFieldBoxFocusedStyles = (0, $fbAgj.xcss)({
    height: 'size.400',
    border: 'none',
    paddingRight: '0'
});
const $8a9662beee4149a8$var$textFieldBoxFocusedElevationStyles = (0, $fbAgj.xcss)({
    boxShadow: 'elevation.shadow.overlay'
});
const $8a9662beee4149a8$var$textFieldInDialogStyles = (0, $fbAgj.xcss)({
    marginTop: 'space.075',
    position: 'relative',
    zIndex: 'layer'
});
const $8a9662beee4149a8$var$inputStyles = null;
const $8a9662beee4149a8$var$inputFocusedStyles = null;
const $8a9662beee4149a8$var$iconWrapperStyles = (0, $fbAgj.xcss)({
    minWidth: 'size.300',
    minHeight: 'size.300',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'color.text.subtlest'
});
const $8a9662beee4149a8$var$iconWrapperFocusedStyles = (0, $fbAgj.xcss)({
    marginInlineStart: 'space.200',
    marginInlineEnd: 'space.150',
    minWidth: 'size.200'
});
const $8a9662beee4149a8$var$clearIconStyles = (0, $fbAgj.xcss)({
    marginRight: 'space.100'
});
const $8a9662beee4149a8$var$clearIconFadeInAnimation = null;
const $8a9662beee4149a8$var$clearIconFadeInWrapperStyles = null;
// Styles for the trailing Connect Apps icon slot.
const $8a9662beee4149a8$var$connectAppsIconStyles = (0, $fbAgj.xcss)({
    marginRight: 'space.050',
    display: 'flex',
    alignItems: 'center'
});
// When QuickFind is open, align the pill with where the close icon sits.
const $8a9662beee4149a8$var$connectAppsIconOpenStyles = (0, $fbAgj.xcss)({
    marginRight: 'space.100'
});
const $8a9662beee4149a8$var$textFieldBoxNoRightPaddingStyles = (0, $fbAgj.xcss)({
    paddingRight: 'space.0'
});
// Nav3 style overrides
// Can be removed once all supported products use Nav4
const $8a9662beee4149a8$var$nav3StyleOverrides = {
    textFieldBoxStyles: (0, $fbAgj.xcss)({
        borderColor: 'color.border.input',
        backgroundColor: 'color.background.input',
        borderRadius: 'radius.medium',
        width: '200px'
    }),
    textFieldBoxFocusedStyles: (0, $fbAgj.xcss)({
        backgroundColor: 'elevation.surface.overlay',
        borderRadius: 'radius.large',
        width: '780px'
    }),
    iconWrapperStyles: (0, $fbAgj.xcss)({
        minWidth: '30px'
    }),
    inputStyles: null
};
const $8a9662beee4149a8$export$d66ddc2063fc70a7 = ({ value: value, dialogId: dialogId, quickFindOpen: quickFindOpen, isNav4Enabled: isNav4Enabled, onEnter: onEnter, onFocus: onFocus, onBlur: onBlur, onSelect: onSelect, onKeyDown: onKeyDown, onChange: onChange, onClick: onClick, onClear: onClear, onAppsClick: onAppsClick, inputRef: inputRef, clearIconRef: clearIconRef, placeholder: placeholder, intentRouterEnabled: intentRouterEnabled, activeDescendantId: activeDescendantId, cloudId: cloudId, primaryProduct: primaryProduct, smartLinkUsage: smartLinkUsage, thirdPartyConfigs: thirdPartyConfigs })=>{
    const intl = (0, $1YIbA.default)();
    const handleKeyDown = (e)=>{
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
        if (typeof onKeyDown === 'function') onKeyDown(e);
    };
    const isConnectAppsPillEnabled = (0, $cRVE8.serveSearchSettingsModalExperiment)();
    const clearIconButton = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
        ref: clearIconRef,
        icon: (iconProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i68tN))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)",
                label: ""
            }),
        spacing: 'compact',
        onClick: onClear,
        label: intl.formatMessage((0, $apvKK.messages).clearIconLabel),
        appearance: "subtle",
        testId: "search-input-clear-button"
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $c69sa.default), {
        xcss: [
            $8a9662beee4149a8$var$textFieldBoxBaseStyles,
            (!intentRouterEnabled || !quickFindOpen) && $8a9662beee4149a8$var$textFieldBoxStyles,
            intentRouterEnabled && quickFindOpen && $8a9662beee4149a8$var$textFieldInDialogStyles,
            (0, $egspI.fg)('platform-dst-shape-theme-default') && $8a9662beee4149a8$var$textFieldBoxStylesT26Shape,
            quickFindOpen ? $8a9662beee4149a8$var$textFieldBoxFocusedStyles : false,
            !intentRouterEnabled && quickFindOpen && $8a9662beee4149a8$var$textFieldBoxFocusedElevationStyles,
            !isNav4Enabled && $8a9662beee4149a8$var$nav3StyleOverrides.textFieldBoxStyles,
            !isNav4Enabled && quickFindOpen && $8a9662beee4149a8$var$nav3StyleOverrides.textFieldBoxFocusedStyles,
            isConnectAppsPillEnabled && $8a9662beee4149a8$var$textFieldBoxNoRightPaddingStyles
        ],
        onClick: (e)=>{
            if (isConnectAppsPillEnabled) {
                // React's synthetic events bubble through the JSX tree, not the DOM. The Rovo
                // Settings modal is a portal, so clicks inside it bubble to this onClick even
                // though they're outside this DOM subtree. Guard against that here, otherwise
                // closing the modal re-focuses the input and reopens Quick Find.
                if (!e.currentTarget.contains(e.target)) return;
            }
            inputRef?.current?.click();
            inputRef?.current?.focus();
        },
        testId: "search-input-container",
        role: "search",
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $c69sa.default), {
                xcss: [
                    $8a9662beee4149a8$var$iconWrapperStyles,
                    quickFindOpen && $8a9662beee4149a8$var$iconWrapperFocusedStyles,
                    !isNav4Enabled && $8a9662beee4149a8$var$nav3StyleOverrides.iconWrapperStyles
                ],
                children: isNav4Enabled || quickFindOpen ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAQb7))), {
                    color: "currentColor",
                    label: "",
                    "aria-hidden": "true"
                }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8EB7p.LegacySearchIcon), {
                    isExpanded: !!quickFindOpen
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                ref: inputRef,
                onFocus: onFocus,
                onBlur: onBlur,
                onSelect: onSelect,
                onKeyDown: handleKeyDown,
                onClick: onClick,
                placeholder: placeholder || intl.formatMessage((0, $apvKK.messages).inputPlaceholder),
                onChange: onChange,
                value: value,
                "data-testid": "search-input",
                autoComplete: "off",
                "aria-label": intl.formatMessage((0, $apvKK.messages).inputAriaLabel),
                "aria-expanded": quickFindOpen,
                "aria-controls": dialogId,
                "aria-activedescendant": activeDescendantId ?? '',
                "aria-haspopup": "true",
                role: "combobox",
                className: (0, $4jQY2.default)([
                    "_12ji1r31 _1qu2glyw _12y31o36 _11q7glyw _11c8fhey _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq _syaz1rpy _1bsb1osq _1bto1l2s _o5721q9c _1idr1rpy",
                    quickFindOpen && "_syazi7uo",
                    !isNav4Enabled && "_11c8fhey"
                ])
            }),
            quickFindOpen && value && (isConnectAppsPillEnabled ? /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    "_y44v17ta _2hwxu2gc _1o51q7pw"
                ]),
                children: clearIconButton
            }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $c69sa.default), {
                xcss: $8a9662beee4149a8$var$clearIconStyles,
                children: clearIconButton
            })),
            isConnectAppsPillEnabled && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $c69sa.default), {
                xcss: [
                    $8a9662beee4149a8$var$connectAppsIconStyles,
                    quickFindOpen && $8a9662beee4149a8$var$connectAppsIconOpenStyles
                ],
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3wYKy.ConnectAppsSearchIcon), {
                    start: quickFindOpen && !!thirdPartyConfigs,
                    cloudId: cloudId,
                    primaryProduct: primaryProduct,
                    smartLinkUsage: smartLinkUsage,
                    thirdPartyConfigs: thirdPartyConfigs,
                    onAppsClick: onAppsClick
                })
            })
        ]
    }));
};
$8a9662beee4149a8$export$d66ddc2063fc70a7.displayName = "Textfield";

});
parcelRegister("cRVE8", function(module, exports) {
$parcel$export(module.exports, "triggerExposureForWeakLinkExp", () => $834dec13fa39f964$export$de65f9bad07950f2);
$parcel$export(module.exports, "serveWeakLinkExpWithoutExposure", () => $834dec13fa39f964$export$6c232948b0f89805);
$parcel$export(module.exports, "serveConvoStartersSameLine", () => $834dec13fa39f964$export$43910e1172480373);
$parcel$export(module.exports, "removeFedSlackFromAllProductSearch", () => $834dec13fa39f964$export$9f3b4e44245ab299);
$parcel$export(module.exports, "serveNounResultCounts", () => $834dec13fa39f964$export$b8eda33c6a73a867);
$parcel$export(module.exports, "serveWebPagesInTypeFilter", () => $834dec13fa39f964$export$6cc04d45455a2e52);
$parcel$export(module.exports, "serveJiraRecentsExcludeConfluenceWithoutExposure", () => $834dec13fa39f964$export$1b405ed1dcef1833);
$parcel$export(module.exports, "serveQFFilterSuggestionExperiment", () => $834dec13fa39f964$export$dbfae5c8d94a4c99);
$parcel$export(module.exports, "serveRightRailRecommendationsImprovementsWithExposure", () => $834dec13fa39f964$export$df1791a16917f9c3);
$parcel$export(module.exports, "serveQF3PBannerExperiment", () => $834dec13fa39f964$export$a254d1715475fc25);
$parcel$export(module.exports, "serveQF3PBannerExperimentWithoutExposure", () => $834dec13fa39f964$export$6308fede6bfa9216);
$parcel$export(module.exports, "serveConfluenceSpaceIconUpdate", () => $834dec13fa39f964$export$a28677150905172f);
$parcel$export(module.exports, "serve3PClickIngestionExperiment", () => $834dec13fa39f964$export$f980294cad954499);
$parcel$export(module.exports, "serveQuickFind3PBoostingExperiment", () => $834dec13fa39f964$export$32815557e5d06f0a);
$parcel$export(module.exports, "getMultiSiteSearchInRovo", () => $834dec13fa39f964$export$9e14285db0210414);
$parcel$export(module.exports, "serveOneClick3PConnectExperiment", () => $834dec13fa39f964$export$45bf6049ec3ec516);
$parcel$export(module.exports, "getUnifiedSearch3PConnectImprovementsCohort", () => $834dec13fa39f964$export$28f6b85de12145ce);
$parcel$export(module.exports, "isInUnifiedSearch3PConnectImprovementsTestCohort", () => $834dec13fa39f964$export$f22ea87ae194d314);
$parcel$export(module.exports, "serveImproveBannerTargetingExperiment", () => $834dec13fa39f964$export$647c2f5a2b1ce3a5);
$parcel$export(module.exports, "serveInline3PQuerySuggestionsPhase1", () => $834dec13fa39f964$export$1a051b8e8c16594f);
$parcel$export(module.exports, "isEligibleForFPSGitHubAuthBannerSurfaces", () => $834dec13fa39f964$export$9da12dc1aa287e01);
$parcel$export(module.exports, "serveFPSGitHubSocialProofBannerExperiment", () => $834dec13fa39f964$export$d776328c2da05809);
$parcel$export(module.exports, "serveFPSGitHubAuthBannerPromo", () => $834dec13fa39f964$export$380be6dfb8653da1);
$parcel$export(module.exports, "getUnifiedSearchRightRailEnhancementsExpValue", () => $834dec13fa39f964$export$e4fdf56860b85064);
$parcel$export(module.exports, "serveSearchSettingsModalExperiment", () => $834dec13fa39f964$export$faafa351c854e058);
$parcel$export(module.exports, "serveSlackTopReactionInSearchExperiment", () => $834dec13fa39f964$export$97f8cc609584332);
$parcel$export(module.exports, "serveQFZeroQuery3PRecsExperiment", () => $834dec13fa39f964$export$5526c331b5a2a0a4);
$parcel$export(module.exports, "QUICK_FIND_RECS_CHALLENGER_FEATURE_SERVICE_MODEL", () => $834dec13fa39f964$export$215e8e0e5adc6c3d);
$parcel$export(module.exports, "serveQuickFindRecommendationChallenger", () => $834dec13fa39f964$export$153c8024578d07c3);
$parcel$export(module.exports, "serveGithubRecentsExperiment", () => $834dec13fa39f964$export$6d6007cc7a6767d0);
$parcel$export(module.exports, "serveGithubWorkItemsRecentsExperiment", () => $834dec13fa39f964$export$ba9c92ff563d2704);
$parcel$export(module.exports, "serveSlClickedOnlyInRecentsExperiment", () => $834dec13fa39f964$export$1c4aca11d3a542d8);
$parcel$export(module.exports, "serveQfGithubTipBannerExperiment", () => $834dec13fa39f964$export$839b881580a7010a);
$parcel$export(module.exports, "getSearchPageProactiveAiMultiVariantCohort", () => $834dec13fa39f964$export$e611075348720a7f);
$parcel$export(module.exports, "serveJiraNavigationToGNIN", () => $834dec13fa39f964$export$b68b3a4558aaedca);
/* eslint-disable @atlaskit/platform/use-recommended-utils */ 
var $4LDqh = parcelRequire("4LDqh");

var $egspI = parcelRequire("egspI");

var $93bjk = parcelRequire("93bjk");

var $I0JAz = parcelRequire("I0JAz");

var $Rx4yg = parcelRequire("Rx4yg");

var $8sSZp = parcelRequire("8sSZp");
const $834dec13fa39f964$export$de65f9bad07950f2 = ()=>{
    (0, $4LDqh.default).manuallyLogExperimentExposure('enable_google_drive_impersonation_search_in_fps');
};
const $834dec13fa39f964$export$6c232948b0f89805 = ()=>{
    return (0, $4LDqh.default).getExperimentValue('enable_google_drive_impersonation_search_in_fps', 'cohort', 'control', {
        fireExperimentExposure: false
    }) === 'test';
};
const $834dec13fa39f964$export$43910e1172480373 = ()=>{
    return (0, $4LDqh.default).getExperimentValue('kd_convo_starters_same_line', 'cohort', 'control') === 'test';
};
const $834dec13fa39f964$export$9f3b4e44245ab299 = (thirdPartyConfigs, isAllProductSearch)=>{
    const isSlackAuthenticated = !thirdPartyConfigs?.[(0, $93bjk.ProductKeys3P).Slack]?.userNeedsOAuth;
    const hasFederatedConnectorSource = thirdPartyConfigs?.[(0, $93bjk.ProductKeys3P).Slack]?.connectorSources?.includes((0, $8sSZp.FEDERATED_CONNECTOR_SOURCE));
    const isUserEligible = isSlackAuthenticated && hasFederatedConnectorSource && isAllProductSearch;
    return isUserEligible;
};
const $834dec13fa39f964$export$b8eda33c6a73a867 = (fireExperimentExposure = false)=>{
    return (0, $4LDqh.default).getExperimentValue('rovosearch_noun_result_counts', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $834dec13fa39f964$export$6cc04d45455a2e52 = (fireExperimentExposure = false)=>{
    return (0, $4LDqh.default).getExperimentValue('web_pages_type_filter_bug', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $834dec13fa39f964$export$1b405ed1dcef1833 = ()=>{
    return (0, $4LDqh.default).getExperimentValue('qf_jira_recents_exclude_confluence', 'cohort', 'control', {
        fireExperimentExposure: false
    }) === 'test';
};
const $834dec13fa39f964$export$dbfae5c8d94a4c99 = (primaryProduct, { fireLayerExposure: fireLayerExposure = true } = {})=>{
    if (primaryProduct !== (0, $Rx4yg.PrimaryProductKeys).Jira) return false;
    const layer = (0, $I0JAz.getMutuallyExclusiveUIExperiment)('rovo_qf_filter_suggestion_exp', 'rovo_search_qf_experience_layer', {
        fireLayerExposure: fireLayerExposure
    });
    return layer?.get('isFilterSuggestionEnabled', false, (value)=>typeof value === 'boolean') ?? false;
};
const $834dec13fa39f964$export$df1791a16917f9c3 = ()=>{
    return (0, $4LDqh.default).getExperimentValue('search_user_right_rail_3p_personalization_v1', 'cohort', 'control', {
        fireExperimentExposure: true
    }) === 'test';
};
const $834dec13fa39f964$export$a254d1715475fc25 = ()=>{
    return (0, $4LDqh.default).getExperimentValue('quick-find-3p-banner', 'bannerType', 'control') !== 'control';
};
const $834dec13fa39f964$export$6308fede6bfa9216 = ()=>{
    return (0, $4LDqh.default).getExperimentValue('quick-find-3p-banner', 'bannerType', 'control', {
        fireExperimentExposure: false
    }) !== 'control';
};
const $834dec13fa39f964$export$a28677150905172f = ()=>{
    return (0, $4LDqh.default).getExperimentValue('confluence_space_icon_update', 'isEnabled', false) === true;
};
const $834dec13fa39f964$export$f980294cad954499 = (thirdPartyConfigs, options = {
    fireExperimentExposure: true
})=>{
    const isEligible3PUser = Object.keys(thirdPartyConfigs).some((productKey)=>thirdPartyConfigs[productKey]?.userNeedsOAuth === false);
    return isEligible3PUser && (0, $4LDqh.default).getExperimentValue('3p_clicks_in_fps_as_qf_recents', 'cohort', 'control', options) === 'test';
};
const $834dec13fa39f964$export$32815557e5d06f0a = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $4LDqh.default).getExperimentValue('quick_find_3p_boosting_experiment', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $834dec13fa39f964$export$752769d90d201b0a = ()=>{
    return (0, $4LDqh.default).getExperimentValue('afm_customer_contact_search_type_experiment', 'cohort', 'control') === 'test';
};
const $834dec13fa39f964$export$9e14285db0210414 = (experimentConfig)=>{
    const cohort = experimentConfig.frontendExperiments?.['multi_site_search_in_rovo']?.cohort;
    return cohort === 'test';
};
const $834dec13fa39f964$export$45bf6049ec3ec516 = ()=>{
    return (0, $4LDqh.default).getExperimentValue('unified_search_one_click_3p_connect', 'isEnabled', false) === true;
};
/**
 * Unified Search 3P Connect Improvements Experiment
 */ const $834dec13fa39f964$var$UNIFIED_SEARCH_3P_CONNECT_IMPROVEMENTS_TEST_COHORTS = [
    'icon-and-tooltip',
    'icon-only',
    'tooltip-only'
];
const $834dec13fa39f964$export$1abc158ee6a5b777 = [
    'control',
    ...$834dec13fa39f964$var$UNIFIED_SEARCH_3P_CONNECT_IMPROVEMENTS_TEST_COHORTS
];
const $834dec13fa39f964$export$28f6b85de12145ce = ()=>{
    const cohort = (0, $4LDqh.default).getExperimentValue('unified_search_3p_connect_improvements', 'cohort', 'control');
    if ($834dec13fa39f964$export$1abc158ee6a5b777.includes(cohort)) return cohort;
    return 'control';
};
const $834dec13fa39f964$export$f22ea87ae194d314 = ()=>{
    const cohort = $834dec13fa39f964$export$28f6b85de12145ce();
    return $834dec13fa39f964$var$UNIFIED_SEARCH_3P_CONNECT_IMPROVEMENTS_TEST_COHORTS.includes(cohort);
};
const $834dec13fa39f964$var$IMPROVE_BANNER_TARGETING_COHORTS = [
    'control',
    'usage-threshold',
    'max-dismissals'
];
const $834dec13fa39f964$export$647c2f5a2b1ce3a5 = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const cohort = (0, $4LDqh.default).getExperimentValue('rovo_search_improve_banner_targeting', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($834dec13fa39f964$var$IMPROVE_BANNER_TARGETING_COHORTS.includes(cohort)) return cohort;
    return 'control';
};
const $834dec13fa39f964$var$INLINE_3P_QUERY_SUGGESTIONS_TREATMENTS = [
    'control',
    'static',
    'dynamic'
];
const $834dec13fa39f964$export$1a051b8e8c16594f = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const treatment = (0, $4LDqh.default).getExperimentValue('inline_3p_query_suggestions_phase_1', 'inline_3p_query_suggestions_treatment', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($834dec13fa39f964$var$INLINE_3P_QUERY_SUGGESTIONS_TREATMENTS.includes(treatment)) return treatment;
    return 'control';
};
const $834dec13fa39f964$export$9da12dc1aa287e01 = ({ thirdPartyConfigs: thirdPartyConfigs })=>{
    const githubConfig = thirdPartyConfigs?.[(0, $93bjk.ProductKeys3P).Github];
    if (!githubConfig) return false;
    // 1. GitHub connector enabled in tenant.
    if (typeof githubConfig.isEnabled === 'function' && !githubConfig.isEnabled()) return false;
    // 2. User is not yet connected to GitHub.
    if (githubConfig.userNeedsOAuth !== true) return false;
    return true;
};
const $834dec13fa39f964$export$d776328c2da05809 = ({ thirdPartyConfigs: thirdPartyConfigs }, options = {
    fireExperimentExposure: false
})=>{
    if (!$834dec13fa39f964$export$9da12dc1aa287e01({
        thirdPartyConfigs: thirdPartyConfigs
    })) return false;
    return (0, $4LDqh.default).getExperimentValue('fps_github_social_proof_banner', 'cohort', 'control', options) === 'test';
};
const $834dec13fa39f964$export$380be6dfb8653da1 = ({ thirdPartyConfigs: thirdPartyConfigs })=>{
    if (!$834dec13fa39f964$export$9da12dc1aa287e01({
        thirdPartyConfigs: thirdPartyConfigs
    })) return false;
    return (0, $egspI.fg)('fps_github_auth_banner_promo');
};
const $834dec13fa39f964$export$e4fdf56860b85064 = ()=>{
    return (0, $4LDqh.default).getExperimentValue('unified_search_right_rail_enhancements', 'cohort', 'control');
};
const $834dec13fa39f964$export$faafa351c854e058 = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>(0, $4LDqh.default).getExperimentValue('rovo_search_settings_modal_enabled', 'isEnabled', false, {
        fireExperimentExposure: fireExperimentExposure
    });
const $834dec13fa39f964$export$97f8cc609584332 = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>(0, $4LDqh.default).getExperimentValue('rovo_fps_show_slack_top_reaction_in_search_ab', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) !== 'control';
const $834dec13fa39f964$export$5526c331b5a2a0a4 = (options = {
    fireExperimentExposure: false
})=>{
    return (0, $4LDqh.default).getExperimentValue('quick_find_zero_query_3p_recs_experiment', 'isEnabled', false, options) === true;
};
/**
 * Default `featureServiceModel` value used by the recommendations backend
 * when no override is sent (control behaviour). Kept private to this module
 * since it is only ever passed as the default to `getExperimentValue` below.
 */ const $834dec13fa39f964$var$QUICK_FIND_RECS_DEFAULT_FEATURE_SERVICE_MODEL = 'quickfind_user_recs';
const $834dec13fa39f964$export$215e8e0e5adc6c3d = 'quickfind_user_recs_challenger_1';
const $834dec13fa39f964$export$a3c56d33595878d0 = (thirdPartyConfigs)=>{
    if (!thirdPartyConfigs) return false;
    const isAuthorised = (productKey)=>{
        const config = thirdPartyConfigs[productKey];
        if (!config) return false;
        if (config.userNeedsOAuth === false) return true;
        return config.datasources?.some((ds)=>ds?.userNeedsOAuth === false) ?? false;
    };
    return isAuthorised((0, $93bjk.ProductKeys3P).GoogleDrive) || isAuthorised((0, $93bjk.ProductKeys3P).Sharepoint);
};
const $834dec13fa39f964$export$153c8024578d07c3 = (thirdPartyConfigs, options = {
    fireExperimentExposure: false
})=>{
    if (!$834dec13fa39f964$export$a3c56d33595878d0(thirdPartyConfigs)) return false;
    const value = (0, $4LDqh.default).getExperimentValue('quick_find_recs_calibrated_3p_interleaver_exp', 'featureServiceModel', $834dec13fa39f964$var$QUICK_FIND_RECS_DEFAULT_FEATURE_SERVICE_MODEL, options);
    return value === $834dec13fa39f964$export$215e8e0e5adc6c3d;
};
const $834dec13fa39f964$export$6d6007cc7a6767d0 = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $4LDqh.default).getExperimentValue('rovo_search_github_in_recents', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $834dec13fa39f964$export$ba9c92ff563d2704 = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $4LDqh.default).getExperimentValue('rovo_search_github_issues_in_recents', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $834dec13fa39f964$export$1c4aca11d3a542d8 = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $4LDqh.default).getExperimentValue('rovo_search_use_sl_clicked_only_in_recents', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
/**
 * Cohorts for QF GitHub tip banner experiment.
 *
 * - `control`            : banner is not rendered at all.
 * - `test-with-gnin`     : banner triggers on EITHER a GitHub keyword OR a
 *                         Jira GNIN-routing intent (typed JQL / work-item
 *                         key). Matches the experiment doc's "Test 1".
 * - `test-keyword-only`  : banner triggers on a GitHub keyword ONLY \u2014 the
 *                         Jira GNIN intent path is skipped. Matches the
 *                         experiment doc's "Test 2", Jira-specific.
 */ const $834dec13fa39f964$var$QF_GITHUB_TIP_BANNER_COHORTS = [
    'control',
    'test-with-gnin',
    'test-keyword-only'
];
const $834dec13fa39f964$export$839b881580a7010a = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    const value = (0, $4LDqh.default).getExperimentValue('rovo_qf_github_tip_banner', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    return $834dec13fa39f964$var$QF_GITHUB_TIP_BANNER_COHORTS.includes(value) ? value : 'control';
};
const $834dec13fa39f964$var$SEARCH_PAGE_PROACTIVE_AI_MULTI_VARIANT_COHORTS = [
    'control',
    'auto_open_chat_modal',
    'on_demand_sain_banner',
    'inline_chat_input_in_results',
    'floating_chat_input'
];
const $834dec13fa39f964$export$e611075348720a7f = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    const cohort = (0, $4LDqh.default).getExperimentValue('search_page_proactive_ai_multi_variant', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($834dec13fa39f964$var$SEARCH_PAGE_PROACTIVE_AI_MULTI_VARIANT_COHORTS.includes(cohort)) return cohort;
    return 'control';
};
const $834dec13fa39f964$var$JIRA_NAVIGATION_TO_GNIN_COHORTS = [
    'control',
    'work-item-icon',
    'header-link'
];
const $834dec13fa39f964$export$b68b3a4558aaedca = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const cohort = (0, $4LDqh.default).getExperimentValue('rovo_jira_navigation_to_gnin', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($834dec13fa39f964$var$JIRA_NAVIGATION_TO_GNIN_COHORTS.includes(cohort)) return cohort;
    return 'control';
};

});
parcelRegister("93bjk", function(module, exports) {
$parcel$export(module.exports, "ProductKeys3P", () => $3a356e2d66567ac7$export$93aa518ca2694c2d);
$parcel$export(module.exports, "ProductResourceTypes3P", () => $3a356e2d66567ac7$export$5378b945bea99ba3);
/**
 * Product keys for third-party connectors.
 * Each key maps to a unique identifier used throughout the search system.
 */ const $3a356e2d66567ac7$export$93aa518ca2694c2d = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3',
    Databricks: 'databricks',
    JsmDC: 'jsm-dc',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Zoom: 'zoom'
};
const $3a356e2d66567ac7$export$5378b945bea99ba3 = {
    AtlassianWebCrawler: 'webcrawler-connector',
    Figma: 'figma-connector',
    Github: 'github-connector',
    GoogleDrive: 'google-drive-connector',
    OneDrive: 'onedrive-connector',
    Dropbox: 'dropbox-connector',
    Slack: 'slack-connector',
    Sharepoint: 'sharepoint-connector',
    Teams: 'microsoft-teams-connector',
    GoogleCalendar: 'google-calendar-connector',
    OutlookCalendar: 'outlook-calendar-connector',
    OutlookMail: 'outlook-mail-connector',
    Gmail: 'gmail-connector',
    AdobeSign: 'adobe-sign-connector',
    Asana: 'asana-connector',
    Zendesk: 'zendesk-connector',
    Airtable: 'airtable-connector',
    Smartsheet: 'smartsheet-connector',
    Notion: 'notion-connector',
    Miro: 'miro-connector',
    Docusign: 'docusign-connector',
    Lucid: 'lucid-connector',
    Monday: 'monday-connector',
    AzureDevops: 'azure-devops-connector',
    Gitlab: 'gitlab-connector',
    ConfluenceDC: 'confluence-dc-connector',
    JiraDC: 'jira-dc-connector',
    JsmDC: 'jsm-dc-connector',
    Canva: 'canva-connector',
    Box: 'box-connector',
    Zeplin: 'smartlinks-connector-zeplin',
    ServiceNow: 'servicenow-connector',
    Freshservice: 'freshservice-connector',
    PowerBI: 'smartlinks-connector-power-bi',
    ClickUp: 'smartlinks-connector-clickup',
    Amplitude: 'smartlinks-connector-amplitude',
    Stripe: 'smartlinks-connector-stripe',
    AdobeXD: 'smartlinks-connector-adobexd',
    Aha: 'aha-connector',
    Mural: 'smartlinks-connector-mural',
    Webex: 'smartlinks-connector-webex',
    Todoist: 'smartlinks-connector-todoist',
    PagerDuty: 'smartlinks-connector-pagerduty',
    Pipedrive: 'smartlinks-connector-pipedrive',
    Hubspot: 'hubspot-connector',
    Dovetail: 'smartlinks-connector-dovetail',
    LaunchDarkly: 'smartlinks-connector-launchdarkly',
    Salesforce: 'salesforce-connector',
    Sentry: 'smartlinks-connector-sentry',
    Gitbook: 'gitbook-connector',
    AWSS3: 'aws-s3-connector',
    Databricks: 'databricks-connector',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Zoom: 'zoom-connector'
};

});

parcelRegister("I0JAz", function(module, exports) {
$parcel$export(module.exports, "getFrontendExperiment", () => $bbed37dcee311b35$export$a68238496eb1c8ce);
$parcel$export(module.exports, "createFeatureGateHandler", () => $bbed37dcee311b35$export$8774a01dc80b4a26);
$parcel$export(module.exports, "createFrontendExperimentHandler", () => $bbed37dcee311b35$export$841981a8a1feee8d);
$parcel$export(module.exports, "getMutuallyExclusiveUIExperiment", () => $bbed37dcee311b35$export$b8cc3cdd046fba93);

var $4LDqh = parcelRequire("4LDqh");

var $hte9M = parcelRequire("hte9M");
const $bbed37dcee311b35$export$a68238496eb1c8ce = ({ abTestId: abTestId, onError: onError })=>{
    try {
        const cohort = (0, $4LDqh.default).getExperiment(abTestId).get('cohort', (0, $hte9M.Cohort).Default);
        const serveExperiment = cohort === (0, $hte9M.Cohort).Test;
        return {
            serveExperiment: serveExperiment,
            abTestId: abTestId,
            cohort: cohort
        };
    } catch (error) {
        onError?.(error);
    }
    return {
        serveExperiment: false,
        abTestId: abTestId,
        cohort: (0, $hte9M.Cohort).Default
    };
};
const $bbed37dcee311b35$export$8774a01dc80b4a26 = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $4LDqh.default).checkGate('search-experiment-overrides-killswitch')) return $bbed37dcee311b35$var$defaultCheckGate;
    if (!overrides) return $bbed37dcee311b35$var$defaultCheckGate;
    try {
        const gates = overrides.filter((overrides)=>overrides.type === 'gate');
        const getFeatureGate = (name)=>{
            const overrideFeatureGate = gates.find((override)=>'name' in override && override.name === name);
            if (!overrideFeatureGate) return $bbed37dcee311b35$var$defaultCheckGate(name);
            // Overrides always resolve to true as using an override is equivelant to turning FF on.
            return true;
        };
        return getFeatureGate;
    } catch (e) {
        console.error(e);
        return $bbed37dcee311b35$var$defaultCheckGate;
    }
};
const $bbed37dcee311b35$export$841981a8a1feee8d = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $4LDqh.default).checkGate('search-experiment-overrides-killswitch')) return $bbed37dcee311b35$export$a68238496eb1c8ce;
    if (!overrides) return $bbed37dcee311b35$export$a68238496eb1c8ce;
    try {
        const experiments = overrides.filter((overrides)=>overrides.type === 'experiment');
        const customGetFrontendExperiment = ({ abTestId: abTestId, onError: onError })=>{
            const overrideFrontendExperiment = experiments.find((override)=>'name' in override && override.name === abTestId);
            if (!overrideFrontendExperiment) return $bbed37dcee311b35$export$a68238496eb1c8ce({
                abTestId: abTestId,
                onError: onError
            });
            return {
                abTestId: abTestId,
                serveExperiment: true,
                cohort: 'cohort' in overrideFrontendExperiment ? overrideFrontendExperiment.cohort : (0, $hte9M.Cohort).Test
            };
        };
        return customGetFrontendExperiment;
    } catch (e) {
        console.error(e);
        return $bbed37dcee311b35$export$a68238496eb1c8ce;
    }
};
// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
const $bbed37dcee311b35$var$defaultCheckGate = (name)=>(0, $4LDqh.default).checkGate(name);
const $bbed37dcee311b35$export$b8cc3cdd046fba93 = (uiExperimentName, layerName, options = {
    fireLayerExposure: true
})=>{
    const layer = (0, $4LDqh.default).getLayer(layerName, {
        fireLayerExposure: false
    });
    const frontendExperimentName = layer.get('frontendExperimentName', '');
    if (frontendExperimentName === uiExperimentName) return (0, $4LDqh.default).getLayer(layerName, options);
    return undefined;
};

});
parcelRegister("hte9M", function(module, exports) {
$parcel$export(module.exports, "Cohort", () => $865eb8fa29ed0e3a$export$b76685d1b5a37732);
var $865eb8fa29ed0e3a$export$b76685d1b5a37732 = /*#__PURE__*/ function(Cohort) {
    Cohort["Default"] = "not-enrolled";
    Cohort["Control"] = "control";
    Cohort["Test"] = "test";
    return Cohort;
}({});

});


parcelRegister("Rx4yg", function(module, exports) {
$parcel$export(module.exports, "PrimaryProductKeys", () => $341627921214ad8c$export$15d12effc8830544);
const $341627921214ad8c$export$15d12effc8830544 = {
    // Fully supported as GA
    Atlas: 'townsquare',
    Confluence: 'confluence',
    // In development
    Assets: 'cmdb',
    Focus: 'mercury',
    Jira: 'jira',
    Elevate: 'elevate',
    Talent: 'radar',
    RovoExtension: 'rovo-extension'
};

});

parcelRegister("8sSZp", function(module, exports) {
$parcel$export(module.exports, "SMARTLINKS_RESOURCE_TYPE_PREFIX", () => $129c37881bd85a2b$export$e88fb694deeca21a);
$parcel$export(module.exports, "LITE_CONNECTOR_SOURCE_PREFIX", () => $129c37881bd85a2b$export$83921c8e433ffcd9);
$parcel$export(module.exports, "FEDERATED_CONNECTOR_SOURCE", () => $129c37881bd85a2b$export$7ad7a95070d8bb93);
$parcel$export(module.exports, "LITE_CONNECTOR_SOURCE", () => $129c37881bd85a2b$export$e3a0662f044cd99b);
$parcel$export(module.exports, "SMARTLINKS_CONNECTOR_SOURCE", () => $129c37881bd85a2b$export$c14e5e3fa6d8b46);
$parcel$export(module.exports, "FULL_CONNECTOR_SOURCE", () => $129c37881bd85a2b$export$aa06c0b5cc41ad9a);
$parcel$export(module.exports, "isConnectorSource", () => $129c37881bd85a2b$export$af092ad5a950adea);
$parcel$export(module.exports, "isForgeConnectorProductKey", () => $129c37881bd85a2b$export$e5725489d3388d22);
$parcel$export(module.exports, "registerForgeConnectorIcon", () => $129c37881bd85a2b$export$4e96e986802512bd);
$parcel$export(module.exports, "getForgeConnectorIcon", () => $129c37881bd85a2b$export$2f2bd8960b497856);
// The canonical `ThirdPartyConfig` interface lives in
// `@atlassian/rovo-connectors-config`. It is consumed here to build the derived
// `ThirdPartyConfigsWithAPIResponse` type below.

var $80Dpc = parcelRequire("80Dpc");
const $129c37881bd85a2b$export$e88fb694deeca21a = 'smartlinks-connector';
const $129c37881bd85a2b$export$83921c8e433ffcd9 = 'lite-connector-';
const $129c37881bd85a2b$export$7ad7a95070d8bb93 = (0, $80Dpc.ConnectorSources).Federated;
const $129c37881bd85a2b$export$e3a0662f044cd99b = (0, $80Dpc.ConnectorSources).Lite;
const $129c37881bd85a2b$export$c14e5e3fa6d8b46 = (0, $80Dpc.ConnectorSources).Smartlinks;
const $129c37881bd85a2b$export$aa06c0b5cc41ad9a = (0, $80Dpc.ConnectorSources).Full;
const $129c37881bd85a2b$export$37e0ed5b7fa94503 = (0, $80Dpc.ConnectorSources).Backfill;
const $129c37881bd85a2b$export$af092ad5a950adea = (value)=>{
    return Object.values((0, $80Dpc.ConnectorSources)).includes(value);
};
const $129c37881bd85a2b$export$9a0cf6dd1d986cc2 = 'forge-connector-';
const $129c37881bd85a2b$export$e5725489d3388d22 = (type)=>{
    return type.startsWith($129c37881bd85a2b$export$9a0cf6dd1d986cc2);
};
/**
 * Runtime registry for Forge connector icons.
 * Similar to ThirdPartyConfigs, but populated dynamically from API responses.
 */ const $129c37881bd85a2b$var$forgeConnectorIconsRegistry = new Map();
const $129c37881bd85a2b$export$4e96e986802512bd = (productKey, icon)=>{
    $129c37881bd85a2b$var$forgeConnectorIconsRegistry.set(productKey, icon);
};
const $129c37881bd85a2b$export$2f2bd8960b497856 = (productKey)=>{
    return $129c37881bd85a2b$var$forgeConnectorIconsRegistry.get(productKey);
};
const $129c37881bd85a2b$export$2768da79a2599ca3 = ()=>{
    $129c37881bd85a2b$var$forgeConnectorIconsRegistry.clear();
};

});
parcelRegister("80Dpc", function(module, exports) {
$parcel$export(module.exports, "ConnectorSources", () => $d02136f7d6ccd1ae$export$499e9a6668a55181);
const $d02136f7d6ccd1ae$export$499e9a6668a55181 = {
    Federated: 'federated',
    Smartlinks: 'smartlinks',
    Lite: 'lite-connector',
    Full: 'full-connector',
    Backfill: 'backfill'
};

});



parcelRegister("3wYKy", function(module, exports) {
$parcel$export(module.exports, "ConnectAppsSearchIcon", () => $518b4a6a918758d7$export$c3ce9d4249b1b4b1);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $fOxy5 = parcelRequire("fOxy5");

var $8Sdzy = parcelRequire("8Sdzy");

var $dtXcl = parcelRequire("dtXcl");

var $fTvuN = parcelRequire("fTvuN");

var $9n1x5 = parcelRequire("9n1x5");

var $knoE2 = parcelRequire("knoE2");

var $9jEtN = parcelRequire("9jEtN");

var $b26e2 = parcelRequire("b26e2");

var $6PMB1 = parcelRequire("6PMB1");
// --- Icon sequence --------------------------------------------------------
const $518b4a6a918758d7$var$MAX_APP_ICONS = 5;
const $518b4a6a918758d7$var$STATIC_SEQUENCE = [
    {
        type: 'ads'
    },
    ...(0, $9jEtN.STATIC_FALLBACK_ORDER).map((slug)=>({
            type: 'img',
            slug: slug
        })),
    {
        type: 'ads'
    }
];
/**
 * Rank icons by smartlink usage from any 3P app that has a config (icon).
 * Backfill with the static fallback order, deduping.
 */ const $518b4a6a918758d7$var$useIconSequence = (smartLinkUsage, thirdPartyConfigs)=>{
    return (0, $euxye.useMemo)(()=>{
        if (!smartLinkUsage || !thirdPartyConfigs) return $518b4a6a918758d7$var$STATIC_SEQUENCE;
        const rankedByUsage = Object.entries(smartLinkUsage).filter(([key])=>(0, $9n1x5.is3pProductKey)(key) && thirdPartyConfigs[key]?.icon).sort((a, b)=>b[1] - a[1]).map(([key])=>key);
        const seen = new Set(rankedByUsage);
        const backfill = (0, $9jEtN.STATIC_FALLBACK_ORDER).filter((key)=>!seen.has(key) && thirdPartyConfigs[key]?.icon);
        const combined = [
            ...rankedByUsage,
            ...backfill
        ].slice(0, $518b4a6a918758d7$var$MAX_APP_ICONS);
        return [
            {
                type: 'ads'
            },
            ...combined.map((slug)=>({
                    type: 'img',
                    slug: slug
                })),
            {
                type: 'ads'
            }
        ];
    }, [
        smartLinkUsage,
        thirdPartyConfigs
    ]);
};
// --- Layout / styling constants -------------------------------------------
const $518b4a6a918758d7$var$PILL_GAP_PX = 6;
const $518b4a6a918758d7$var$PILL_HORIZONTAL_PADDING_PX = 8;
const $518b4a6a918758d7$var$LABEL_MAX_WIDTH_PX = 160;
// CSS strings cannot interpolate imported values (compiled `no-imported-style-values`),
// so we redeclare the durations here and assert they match `./timing` at compile time.
const $518b4a6a918758d7$var$BG_DURATION_MS = 200;
const $518b4a6a918758d7$var$SLIDE_DURATION_MS = 350;
const $518b4a6a918758d7$var$FADE_DURATION_MS = 300;
const $518b4a6a918758d7$var$EASE_PILL = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
const $518b4a6a918758d7$var$EASE_ICON_CROSSFADE = 'cubic-bezier(0.45, 0, 0.55, 1)';
// Compile-time guard: drift between the timing module and the CSS values would
// silently desync animations and tests. This fails to typecheck if either side
// changes without the other.
const $518b4a6a918758d7$var$_cssTimingMatchesTimingModule = [
    $518b4a6a918758d7$var$BG_DURATION_MS,
    $518b4a6a918758d7$var$SLIDE_DURATION_MS,
    $518b4a6a918758d7$var$FADE_DURATION_MS
];
// --- Styles ---------------------------------------------------------------
const $518b4a6a918758d7$var$pillButtonStyles = null;
const $518b4a6a918758d7$var$pillButtonElevatedStyles = null;
const $518b4a6a918758d7$var$labelWrapperStyles = null;
const $518b4a6a918758d7$var$iconStackStyles = null;
const $518b4a6a918758d7$var$iconLayerStyles = null;
const $518b4a6a918758d7$var$appsIconLayerStyles = null;
const $518b4a6a918758d7$var$appIconWrapperStyles = null;
const $518b4a6a918758d7$var$appIconInnerStyles = null;
const $518b4a6a918758d7$var$IconStack = ({ sequence: sequence, activeIndex: activeIndex, elevated: elevated, thirdPartyConfigs: thirdPartyConfigs })=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        className: (0, $4jQY2.default)([
            "_1bsb1ejb _4t3i1ejb _kqswh2mm _1o9zidpf _lcxvglyw"
        ]),
        children: sequence.map((entry, i)=>{
            const isActive = i === activeIndex;
            const key = entry.type === 'ads' ? `ads-${i}` : entry.slug;
            const Icon = entry.type === 'img' ? thirdPartyConfigs?.[entry.slug]?.icon : null;
            return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                style: {
                    opacity: isActive ? 1 : 0
                },
                className: (0, $4jQY2.default)([
                    "_1r04idpf _v56436ci _kqswstnw _1e0c1txw _4cvr1h6o _1bah1h6o"
                ]),
                children: Icon ? /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                    className: (0, $4jQY2.default)([
                        "_2rko1qi0 _1reo15vq _18m915vq _19it5nxa _1bsb1tcg _4t3i1tcg _vchhusvi _1e0c116y _4cvr1h6o _1bah1h6o _1o9zidpf"
                    ]),
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        className: (0, $4jQY2.default)([
                            "_1e0c116y"
                        ]),
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
                            size: "small"
                        })
                    })
                }) : /*#__PURE__*/ (0, $e79Pd.jsx)($518b4a6a918758d7$var$AdsIconCrossfade, {
                    elevated: elevated
                })
            }, key);
        })
    });
$518b4a6a918758d7$var$IconStack.displayName = "IconStack";
/**
 * Crossfades between the inverse-color and subtle variants of the Apps icon
 * based on whether the pill is elevated. Both labels are empty because the
 * stack is decorative — accessibility comes from the button's `aria-label`.
 */ const $518b4a6a918758d7$var$AdsIconCrossfade = ({ elevated: elevated })=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                style: {
                    opacity: elevated ? 1 : 0
                },
                className: (0, $4jQY2.default)([
                    "_1r04idpf _v564ra4y _kqswstnw _1e0c1txw _4cvr1h6o _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOxy5))), {
                    label: "",
                    color: "var(--ds-icon-inverse, #FFFFFF)"
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                style: {
                    opacity: elevated ? 0 : 1
                },
                className: (0, $4jQY2.default)([
                    "_1r04idpf _v564ra4y _kqswstnw _1e0c1txw _4cvr1h6o _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOxy5))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)"
                })
            })
        ]
    });
$518b4a6a918758d7$var$AdsIconCrossfade.displayName = "AdsIconCrossfade";
/**
 * Rendered as a `<span role="button">` instead of a native `<button>` because
 * this component can be placed inside an element that is already a `<button>`
 * (e.g. Jira's `Pressable` skeleton wrapper).  Nesting `<button>` elements
 * produces invalid HTML that causes browsers to mis-parse the SSR payload,
 * breaking hydration and duplicating the entire page.
 *
 * See: https://jplat.atlassian.net/browse/JRB-1245
 */ const $518b4a6a918758d7$var$PillButton = ({ spanRef: spanRef, ariaLabel: ariaLabel, label: label, sequence: sequence, activeIndex: activeIndex, elevated: elevated, textOut: textOut, onClick: onClick, thirdPartyConfigs: thirdPartyConfigs })=>/*#__PURE__*/ (0, $e79Pd.jsxs)("span", {
        ref: spanRef,
        role: "button",
        tabIndex: 0,
        onClick: (e)=>{
            e.stopPropagation();
            onClick();
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                onClick();
            }
        },
        "aria-label": ariaLabel,
        "data-testid": "quick-find-connect-apps-pill",
        style: {
            gap: textOut ? $518b4a6a918758d7$var$PILL_GAP_PX : 0,
            paddingLeft: elevated ? $518b4a6a918758d7$var$PILL_HORIZONTAL_PADDING_PX : 0
        },
        className: (0, $4jQY2.default)([
            "_2rko1qi0 _11c81kw7 _v5641mxu _1dqoglyw _1e0c1txw _2lx2vrvc _4cvr1h6o _1q51idpf _85i5idpf _y4tiidpf _80omtlke _bfhk18uv _1ygb7g83 _1ah3v77o _irr31dpa",
            elevated && "_bfhk1aqn _irr31ibz"
        ]),
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                "aria-hidden": "true",
                style: {
                    maxWidth: textOut ? $518b4a6a918758d7$var$LABEL_MAX_WIDTH_PX : 0,
                    opacity: textOut ? 1 : 0
                },
                className: (0, $4jQY2.default)([
                    "_1reo15vq _18m915vq _v564ol3k _1e0c116y _4cvr1h6o _o5721q9c _uiztglyw _lcxvglyw"
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
                    size: "small",
                    weight: "medium",
                    color: "color.text.inverse",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)($518b4a6a918758d7$var$IconStack, {
                sequence: sequence,
                activeIndex: activeIndex,
                elevated: elevated,
                thirdPartyConfigs: thirdPartyConfigs
            })
        ]
    });
$518b4a6a918758d7$var$PillButton.displayName = "PillButton";
const $518b4a6a918758d7$export$c3ce9d4249b1b4b1 = ({ start: start = false, onAppsClick: onAppsClick, spanRef: spanRef, cloudId: cloudId, primaryProduct: primaryProduct, smartLinkUsage: smartLinkUsage, thirdPartyConfigs: thirdPartyConfigs })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const sequence = $518b4a6a918758d7$var$useIconSequence(smartLinkUsage, thirdPartyConfigs);
    const { canAnimate: canAnimate, recordAnimation: recordAnimation, dismissPermanently: dismissPermanently } = (0, $6PMB1.useConnectAppsCooldown)();
    const { phase: phase, activeIndex: activeIndex, exitEarly: exitEarly } = (0, $b26e2.useConnectAppsAnimation)({
        start: start,
        sequenceLength: sequence.length,
        canStart: canAnimate,
        onStart: recordAnimation
    });
    const elevated = (0, $b26e2.isElevated)(phase);
    const textOut = (0, $b26e2.isTextOut)(phase);
    const renderPill = (openModal)=>/*#__PURE__*/ (0, $e79Pd.jsx)($518b4a6a918758d7$var$PillButton, {
            spanRef: spanRef,
            ariaLabel: formatMessage((0, $knoE2.i18n).connectAppsButtonAriaLabel),
            label: formatMessage((0, $knoE2.i18n).connectAppsLabel),
            sequence: sequence,
            activeIndex: activeIndex,
            elevated: elevated,
            textOut: textOut,
            thirdPartyConfigs: thirdPartyConfigs,
            onClick: ()=>{
                onAppsClick?.();
                openModal?.();
                dismissPermanently();
                if (textOut) exitEarly();
            }
        });
    if (cloudId && primaryProduct) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fTvuN.RovoSettingsModal), {
        product: primaryProduct,
        cloudId: cloudId,
        surface: (0, $dtXcl.RovoSettingsModalSurface).SEARCH_QF_PILL,
        children: ({ open: open })=>renderPill(()=>open({
                    defaultTab: 'discovery'
                }))
    });
    return renderPill();
};
$518b4a6a918758d7$export$c3ce9d4249b1b4b1.displayName = "ConnectAppsSearchIcon";

});
parcelRegister("dtXcl", function(module, exports) {
$parcel$export(module.exports, "RovoSettingsModalSurface", () => $6443d75985b430a3$export$bc9ec39841ba8fd3);
$parcel$export(module.exports, "isSearchSurface", () => $6443d75985b430a3$export$ec3ac09cbc485f99);
$parcel$export(module.exports, "RovoSettingsConfigProvider", () => $6443d75985b430a3$export$e6e0575f100c37ab);
$parcel$export(module.exports, "RovoSettingsModalMountedProvider", () => $6443d75985b430a3$export$c32765f1b1c62608);
$parcel$export(module.exports, "useRovoSettingsConfig", () => $6443d75985b430a3$export$db68c798d50f727e);
$parcel$export(module.exports, "useIsRovoSettingsModalProviderMounted", () => $6443d75985b430a3$export$ddb548fa2ffa23a3);

var $euxye = parcelRequire("euxye");
const $6443d75985b430a3$export$bc9ec39841ba8fd3 = {
    CHAT: 'chat',
    SEARCH_QF_PILL: 'search-qf-connect-apps-pill',
    SEARCH_FPS_CONNECT_APPS_BUTTON: 'search-fps-connect-apps-button'
};
const $6443d75985b430a3$export$ec3ac09cbc485f99 = (surface)=>surface?.startsWith('search-') === true;
const $6443d75985b430a3$var$initialState = {
    product: '',
    siteId: '',
    experienceId: 'ai-mate',
    assistanceServiceConfig: undefined,
    surface: undefined
};
const $6443d75985b430a3$var$rovoSettingsConfig = /*#__PURE__*/ (0, $euxye.createContext)($6443d75985b430a3$var$initialState);
const $6443d75985b430a3$var$rovoSettingsModalMountedContext = /*#__PURE__*/ (0, $euxye.createContext)(false);
const $6443d75985b430a3$export$e6e0575f100c37ab = $6443d75985b430a3$var$rovoSettingsConfig.Provider;
const $6443d75985b430a3$export$c32765f1b1c62608 = $6443d75985b430a3$var$rovoSettingsModalMountedContext.Provider;
const $6443d75985b430a3$export$db68c798d50f727e = ()=>(0, $euxye.useContext)($6443d75985b430a3$var$rovoSettingsConfig);
const $6443d75985b430a3$export$ddb548fa2ffa23a3 = ()=>(0, $euxye.useContext)($6443d75985b430a3$var$rovoSettingsModalMountedContext);

});

parcelRegister("fTvuN", function(module, exports) {
$parcel$export(module.exports, "RovoSettingsModal", () => $574035363c31e4c8$export$f2c3f3e62df426ba);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $3Rdu9 = parcelRequire("3Rdu9");

var $1YIbA = parcelRequire("1YIbA");

var $fOxy5 = parcelRequire("fOxy5");

var $ihEDU = parcelRequire("ihEDU");
var $2XXtG = parcelRequire("2XXtG");
var $6mEZn = parcelRequire("6mEZn");

var $isYKo = parcelRequire("isYKo");
const $574035363c31e4c8$var$triggerStyles = {
    button: "_1dqoglyw _ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi _bfhk18uv _80omtlke _1bsb1osq _irr31dpa",
    text: "_11c8wadc _syaz1rpy"
};
const $574035363c31e4c8$var$DefaultTrigger = ({ open: open })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
        xcss: $574035363c31e4c8$var$triggerStyles.button,
        onClick: ()=>open(),
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $2XXtG.default), {
            alignItems: "center",
            gap: "space.075",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOxy5))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)"
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                    xcss: $574035363c31e4c8$var$triggerStyles.text,
                    children: formatMessage((0, $isYKo.messages).defaultTriggerLabel)
                })
            ]
        })
    });
};
$574035363c31e4c8$var$DefaultTrigger.displayName = "DefaultTrigger";

const $574035363c31e4c8$var$LazyRovoSettingsModalProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).lazy(()=>(parcelRequire("3Zqca")).then((mod)=>({
            default: mod.RovoSettingsModalLazy
        })));
const $574035363c31e4c8$export$f2c3f3e62df426ba = ({ children: renderTrigger, ...providerProps })=>{
    const [isActivated, setIsActivated] = (0, $euxye.useState)(false);
    const pendingOpenOptions = (0, $euxye.useRef)(undefined);
    const openModalRef = (0, $euxye.useRef)(null);
    const open = (0, $euxye.useCallback)((options)=>{
        if (openModalRef.current) // Provider already mounted — open directly
        openModalRef.current(options);
        else {
            // First click — store options and mount the provider
            pendingOpenOptions.current = options;
            setIsActivated(true);
        }
    }, []);
    // Calling the render function directly (rather than mounting it as a
    // component) makes React diff the returned JSX in-place against the previous
    // render, so the trigger element survives parent re-renders even if the
    // render function's identity changes (e.g. inline arrows).
    const triggerNode = renderTrigger ? renderTrigger({
        open: open
    }) : /*#__PURE__*/ (0, $e79Pd.jsx)($574035363c31e4c8$var$DefaultTrigger, {
        open: open
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3Rdu9.ErrorBoundary), {
        fallbackRender: ()=>null,
        children: [
            triggerNode,
            isActivated && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)($574035363c31e4c8$var$LazyRovoSettingsModalProvider, {
                    ...providerProps,
                    pendingOpenOptions: pendingOpenOptions,
                    openModalRef: openModalRef
                })
            })
        ]
    });
};
$574035363c31e4c8$export$f2c3f3e62df426ba.displayName = "RovoSettingsModal";

});
parcelRegister("3Rdu9", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("euxye")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("isYKo", function(module, exports) {
$parcel$export(module.exports, "messages", () => $84a6758af7070a34$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $84a6758af7070a34$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    modalTitle: {
        id: 'ai-mate.rovo-settings-modal.portable-rovo-settings.modal-title.non-final',
        defaultMessage: 'Sources & apps',
        description: 'Title of the Rovo Settings modal dialog'
    },
    searchPlaceholder: {
        id: 'ai-mate.rovo-settings-modal.portable-rovo-settings.search-placeholder.non-final',
        defaultMessage: 'Search settings',
        description: 'Placeholder for the search box in the Rovo Settings modal side nav'
    },
    defaultTriggerLabel: {
        id: 'ai-mate.rovo-settings-modal.portable-rovo-settings.default-trigger-label.non-final',
        defaultMessage: 'Explore all apps',
        description: 'Label for the default button that opens the Rovo Settings modal'
    }
});

});

parcelRegister("3Zqca", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1VLpQ").then(()=>parcelRequire('1zi1F'));

});


parcelRegister("9n1x5", function(module, exports) {
$parcel$export(module.exports, "ProductKeys1PForAnalytics", () => $34e7a0684b1748d3$export$252aae15ddb3591c);
$parcel$export(module.exports, "ProductKeys", () => $34e7a0684b1748d3$export$ef2c0ffddaaaf76c);
$parcel$export(module.exports, "all3pProductKeys", () => $34e7a0684b1748d3$export$57043b2770b3924d);
$parcel$export(module.exports, "all1pProductKeys", () => $34e7a0684b1748d3$export$225f36a2f261b1e7);
$parcel$export(module.exports, "getAllProductKeys", () => $34e7a0684b1748d3$export$297680dde4e8aef1);
$parcel$export(module.exports, "allProductKeys", () => $34e7a0684b1748d3$export$73be91b73ebbdb05);
$parcel$export(module.exports, "is1pProductKey", () => $34e7a0684b1748d3$export$65f9ab1ba49d5e68);
$parcel$export(module.exports, "is3pProductKey", () => $34e7a0684b1748d3$export$ae4856d6227d0649);
$parcel$export(module.exports, "isProductKey", () => $34e7a0684b1748d3$export$2a41a819c1db85b1);
$parcel$export(module.exports, "productsSupportingEmptyQuery", () => $34e7a0684b1748d3$export$ba4f56e768ae6f1e);
$parcel$export(module.exports, "PRODUCTS_ORDER", () => $34e7a0684b1748d3$export$64c23f2d9ef43822);
$parcel$export(module.exports, "GITHUB_PRODUCT_KEYS", () => $34e7a0684b1748d3$export$1d911f164123ed26);
$parcel$export(module.exports, "PRODUCTS_ORDER_WITH_3P_BY_POPULARITY", () => $34e7a0684b1748d3$export$41ecd101a1ccdccc);
/**
 * Product key constants, types, and lightweight helpers.
 * No icons, no 3P configs, no React components.
 */ 
var $egspI = parcelRequire("egspI");

var $eSGXn = parcelRequire("eSGXn");

var $93bjk = parcelRequire("93bjk");

var $aygo2 = parcelRequire("aygo2");

const $34e7a0684b1748d3$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury',
    Assets: 'cmdb',
    // Can't add these until they're ready as we use this type to enforce that product configs are available for all products
    Talent: 'radar'
};
const $34e7a0684b1748d3$export$252aae15ddb3591c = {
    ...$34e7a0684b1748d3$var$ProductKeys1P,
    Loom: 'loom',
    AtlasGoals: 'goals',
    AtlasProjects: 'projects',
    AtlasTeams: 'teams'
};
const $34e7a0684b1748d3$export$ef2c0ffddaaaf76c = {
    ...$34e7a0684b1748d3$var$ProductKeys1P,
    ...(0, $93bjk.ProductKeys3P)
};
const $34e7a0684b1748d3$var$localAllProductKeys = Object.values($34e7a0684b1748d3$export$ef2c0ffddaaaf76c);
const $34e7a0684b1748d3$export$57043b2770b3924d = Object.values((0, $93bjk.ProductKeys3P));
const $34e7a0684b1748d3$export$225f36a2f261b1e7 = Object.values($34e7a0684b1748d3$var$ProductKeys1P);
const $34e7a0684b1748d3$export$297680dde4e8aef1 = ()=>{
    if ((0, $egspI.fg)('rovo_fps_use_rovo_config')) return 0, $eSGXn.allProductKeys;
    return $34e7a0684b1748d3$var$localAllProductKeys;
};
const $34e7a0684b1748d3$export$73be91b73ebbdb05 = $34e7a0684b1748d3$var$localAllProductKeys;
const $34e7a0684b1748d3$export$65f9ab1ba49d5e68 = (key)=>$34e7a0684b1748d3$export$225f36a2f261b1e7.includes(key);
const $34e7a0684b1748d3$export$ae4856d6227d0649 = (key)=>$34e7a0684b1748d3$export$57043b2770b3924d.includes(key);
const $34e7a0684b1748d3$export$2a41a819c1db85b1 = (key)=>{
    if (!key) return false;
    // Check hardcoded keys first
    if ($34e7a0684b1748d3$export$297680dde4e8aef1().includes(key)) return true;
    // Treat any "forge-connector-*" string as valid ProductKeys to support
    // dynamically provisioned Forge connectors without updating this constant list.
    // This means isProductKey is *looser* than "is configured in ProductKeys".
    return key.startsWith('forge-connector-');
};
const $34e7a0684b1748d3$export$ba4f56e768ae6f1e = [
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Confluence,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Jira
];
const $34e7a0684b1748d3$export$64c23f2d9ef43822 = [
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Confluence,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Jira,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Atlas,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Trello,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Bitbucket,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Compass,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Focus,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Assets,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Talent,
    ...(0, $aygo2.ProductsOrder3P)
];
const $34e7a0684b1748d3$export$1d911f164123ed26 = [
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Github
];
const $34e7a0684b1748d3$export$41ecd101a1ccdccc = [
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Confluence,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Jira,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Atlas,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Trello,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Bitbucket,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Compass,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Focus,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Talent,
    $34e7a0684b1748d3$export$ef2c0ffddaaaf76c.Assets,
    ...(0, $aygo2.NewProductsOrder3P)
];

});
parcelRegister("eSGXn", function(module, exports) {
$parcel$export(module.exports, "allProductKeys", () => $93edfa0ca08a8961$export$73be91b73ebbdb05);

var $3oocO = parcelRequire("3oocO");

var $93bjk = parcelRequire("93bjk");
const $93edfa0ca08a8961$export$73be91b73ebbdb05 = [
    ...Object.values((0, $3oocO.ProductKeys1P)),
    ...Object.values((0, $93bjk.ProductKeys3P))
];

});
parcelRegister("3oocO", function(module, exports) {
$parcel$export(module.exports, "ProductKeys1P", () => $e383d2b4daf811e8$export$a0110d095394669e);
$parcel$export(module.exports, "ARI_EXTRACTED_1P_KEYS", () => $e383d2b4daf811e8$export$deaa7a6e1403419a);
$parcel$export(module.exports, "NounKeys", () => $e383d2b4daf811e8$export$a93cddd79e3ea530);


const $e383d2b4daf811e8$export$a0110d095394669e = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury',
    Assets: 'cmdb',
    Talent: 'radar'
};
const $e383d2b4daf811e8$export$deaa7a6e1403419a = Object.values($e383d2b4daf811e8$export$a0110d095394669e);
const $e383d2b4daf811e8$export$a93cddd79e3ea530 = {
    project: 'project',
    goal: 'goal',
    AtlassianWebCrawler: 'atlassian-web-crawler'
};
const $e383d2b4daf811e8$export$cc6a3ce6b37346b2 = (key)=>{
    return Object.values($e383d2b4daf811e8$export$a93cddd79e3ea530).includes(key);
};

});


parcelRegister("aygo2", function(module, exports) {
$parcel$export(module.exports, "ProductsOrder3P", () => $835de8bb064480e5$export$cc64d659abc3d135);
$parcel$export(module.exports, "NewProductsOrder3P", () => $835de8bb064480e5$export$915acbd1d0c0550d);
$parcel$export(module.exports, "thirdPartyFilterProducts", () => $835de8bb064480e5$export$c36c249aaac5cad0);
/**
 * Pure 3P product key constants extracted for SSR bundle isolation.
 * No icon or config imports - just string mappings.
 *
 * This is the SOURCE OF TRUTH for ProductKeys3P.
 * 3p-product-configs/index.tsx and products.tsx re-export from here.
 */ 
var $93bjk = parcelRequire("93bjk");
const $835de8bb064480e5$export$cc64d659abc3d135 = [
    // Loom is actually a 1P so goes to the top
    (0, $93bjk.ProductKeys3P).Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    (0, $93bjk.ProductKeys3P).GoogleDrive,
    (0, $93bjk.ProductKeys3P).Sharepoint,
    (0, $93bjk.ProductKeys3P).OneDrive,
    (0, $93bjk.ProductKeys3P).Dropbox,
    (0, $93bjk.ProductKeys3P).Slack,
    (0, $93bjk.ProductKeys3P).Teams,
    (0, $93bjk.ProductKeys3P).Github,
    (0, $93bjk.ProductKeys3P).Figma,
    (0, $93bjk.ProductKeys3P).GoogleCalendar,
    (0, $93bjk.ProductKeys3P).Gmail,
    (0, $93bjk.ProductKeys3P).OutlookCalendar,
    (0, $93bjk.ProductKeys3P).OutlookMail,
    (0, $93bjk.ProductKeys3P).Airtable,
    (0, $93bjk.ProductKeys3P).Smartsheet,
    (0, $93bjk.ProductKeys3P).Asana,
    (0, $93bjk.ProductKeys3P).Zendesk,
    (0, $93bjk.ProductKeys3P).Miro,
    (0, $93bjk.ProductKeys3P).Docusign,
    (0, $93bjk.ProductKeys3P).Lucid,
    (0, $93bjk.ProductKeys3P).Monday,
    (0, $93bjk.ProductKeys3P).AzureDevops,
    (0, $93bjk.ProductKeys3P).Gitlab,
    (0, $93bjk.ProductKeys3P).ConfluenceDC,
    (0, $93bjk.ProductKeys3P).Canva,
    (0, $93bjk.ProductKeys3P).Box,
    (0, $93bjk.ProductKeys3P).Zeplin,
    (0, $93bjk.ProductKeys3P).ServiceNow,
    (0, $93bjk.ProductKeys3P).Freshservice,
    (0, $93bjk.ProductKeys3P).PowerBI,
    (0, $93bjk.ProductKeys3P).ClickUp,
    (0, $93bjk.ProductKeys3P).Amplitude,
    (0, $93bjk.ProductKeys3P).Stripe,
    (0, $93bjk.ProductKeys3P).AdobeXD,
    (0, $93bjk.ProductKeys3P).Aha,
    (0, $93bjk.ProductKeys3P).AdobeSign,
    (0, $93bjk.ProductKeys3P).Mural,
    (0, $93bjk.ProductKeys3P).Webex,
    (0, $93bjk.ProductKeys3P).PagerDuty,
    (0, $93bjk.ProductKeys3P).Pipedrive,
    (0, $93bjk.ProductKeys3P).Dovetail,
    (0, $93bjk.ProductKeys3P).LaunchDarkly,
    (0, $93bjk.ProductKeys3P).Salesforce,
    (0, $93bjk.ProductKeys3P).Sentry,
    (0, $93bjk.ProductKeys3P).Gitbook,
    (0, $93bjk.ProductKeys3P).AWSS3,
    (0, $93bjk.ProductKeys3P).ForgeAdamVitareqDev,
    (0, $93bjk.ProductKeys3P).ForgeAdamVitareqProd,
    (0, $93bjk.ProductKeys3P).ForgeK15tScrollSitesDev,
    (0, $93bjk.ProductKeys3P).ForgeK15tScrollSitesProd,
    (0, $93bjk.ProductKeys3P).ForgePioAwsDev,
    (0, $93bjk.ProductKeys3P).ForgePioAwsProd,
    (0, $93bjk.ProductKeys3P).ForgePioClickupDev,
    (0, $93bjk.ProductKeys3P).ForgePioClickupProd,
    (0, $93bjk.ProductKeys3P).ForgePioGithubDev,
    (0, $93bjk.ProductKeys3P).ForgePioGithubProd,
    (0, $93bjk.ProductKeys3P).ForgePioGitbookDev,
    (0, $93bjk.ProductKeys3P).ForgePioGitbookProd,
    (0, $93bjk.ProductKeys3P).ForgePioGitlabDev,
    (0, $93bjk.ProductKeys3P).ForgePioGitlabProd,
    (0, $93bjk.ProductKeys3P).ForgePioGoogleDriveDev,
    (0, $93bjk.ProductKeys3P).ForgePioGoogleDriveProd,
    (0, $93bjk.ProductKeys3P).ForgePioGuruDev,
    (0, $93bjk.ProductKeys3P).ForgePioGuruProd,
    (0, $93bjk.ProductKeys3P).ForgePioHelpjuiceDev,
    (0, $93bjk.ProductKeys3P).ForgePioHelpjuiceProd,
    (0, $93bjk.ProductKeys3P).ForgePioHubspotDev,
    (0, $93bjk.ProductKeys3P).ForgePioHubspotProd,
    (0, $93bjk.ProductKeys3P).ForgePioSalesforceDev,
    (0, $93bjk.ProductKeys3P).ForgePioSalesforceProd,
    (0, $93bjk.ProductKeys3P).ForgePioSharepointDev,
    (0, $93bjk.ProductKeys3P).ForgePioSharepointProd,
    (0, $93bjk.ProductKeys3P).ForgePioStackOverflowDev,
    (0, $93bjk.ProductKeys3P).ForgePioStackOverflowProd,
    (0, $93bjk.ProductKeys3P).ForgeUtoolityGitbookDev,
    (0, $93bjk.ProductKeys3P).ForgeUtoolityGitbookProd,
    (0, $93bjk.ProductKeys3P).ForgeGdriveEugeneTestDev,
    (0, $93bjk.ProductKeys3P).ForgeGdriveEugeneTestProd,
    (0, $93bjk.ProductKeys3P).ForgeUnitoSalesforceDev,
    (0, $93bjk.ProductKeys3P).ForgeUnitoSalesforceProd,
    (0, $93bjk.ProductKeys3P).ForgeUnitoServicenowDev,
    (0, $93bjk.ProductKeys3P).ForgeUnitoServicenowProd,
    (0, $93bjk.ProductKeys3P).ForgeUnitoWrikeDev,
    (0, $93bjk.ProductKeys3P).ForgeUnitoWrikeProd,
    (0, $93bjk.ProductKeys3P).ForgeUnitoAsanaDev,
    (0, $93bjk.ProductKeys3P).ForgeUnitoAsanaProd,
    (0, $93bjk.ProductKeys3P).ForgeUnitoBasecampDev,
    (0, $93bjk.ProductKeys3P).ForgeUnitoBasecampProd,
    // New 3P? Add it here
    (0, $93bjk.ProductKeys3P).Databricks,
    (0, $93bjk.ProductKeys3P).Notion,
    (0, $93bjk.ProductKeys3P).Todoist,
    (0, $93bjk.ProductKeys3P).Hubspot,
    (0, $93bjk.ProductKeys3P).Zoom,
    (0, $93bjk.ProductKeys3P).JiraDC,
    (0, $93bjk.ProductKeys3P).JsmDC,
    // Always last
    (0, $93bjk.ProductKeys3P).AtlassianWebCrawler
];
// TODO: QS-8075 replace into PRODUCTS_ORDER when cleaning up the FG
const $835de8bb064480e5$export$915acbd1d0c0550d = [
    // Loom is actually a 1P so goes to the top
    (0, $93bjk.ProductKeys3P).Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    (0, $93bjk.ProductKeys3P).GoogleDrive,
    (0, $93bjk.ProductKeys3P).Sharepoint,
    (0, $93bjk.ProductKeys3P).Slack,
    (0, $93bjk.ProductKeys3P).Teams,
    (0, $93bjk.ProductKeys3P).Figma,
    (0, $93bjk.ProductKeys3P).Miro,
    (0, $93bjk.ProductKeys3P).Salesforce,
    (0, $93bjk.ProductKeys3P).Github,
    (0, $93bjk.ProductKeys3P).Gmail,
    (0, $93bjk.ProductKeys3P).Gitlab,
    (0, $93bjk.ProductKeys3P).Lucid,
    (0, $93bjk.ProductKeys3P).Asana,
    (0, $93bjk.ProductKeys3P).AzureDevops,
    (0, $93bjk.ProductKeys3P).GoogleCalendar,
    (0, $93bjk.ProductKeys3P).OneDrive,
    (0, $93bjk.ProductKeys3P).Dropbox,
    (0, $93bjk.ProductKeys3P).OutlookCalendar,
    (0, $93bjk.ProductKeys3P).OutlookMail,
    (0, $93bjk.ProductKeys3P).Airtable,
    (0, $93bjk.ProductKeys3P).Smartsheet,
    (0, $93bjk.ProductKeys3P).Zendesk,
    (0, $93bjk.ProductKeys3P).Docusign,
    (0, $93bjk.ProductKeys3P).Databricks,
    (0, $93bjk.ProductKeys3P).Monday,
    (0, $93bjk.ProductKeys3P).ConfluenceDC,
    (0, $93bjk.ProductKeys3P).Canva,
    (0, $93bjk.ProductKeys3P).Box,
    (0, $93bjk.ProductKeys3P).Zeplin,
    (0, $93bjk.ProductKeys3P).ServiceNow,
    (0, $93bjk.ProductKeys3P).Freshservice,
    (0, $93bjk.ProductKeys3P).PowerBI,
    (0, $93bjk.ProductKeys3P).ClickUp,
    (0, $93bjk.ProductKeys3P).Amplitude,
    (0, $93bjk.ProductKeys3P).Stripe,
    (0, $93bjk.ProductKeys3P).AdobeXD,
    (0, $93bjk.ProductKeys3P).Aha,
    (0, $93bjk.ProductKeys3P).AdobeSign,
    (0, $93bjk.ProductKeys3P).Mural,
    (0, $93bjk.ProductKeys3P).Webex,
    (0, $93bjk.ProductKeys3P).PagerDuty,
    (0, $93bjk.ProductKeys3P).Pipedrive,
    (0, $93bjk.ProductKeys3P).Dovetail,
    (0, $93bjk.ProductKeys3P).LaunchDarkly,
    (0, $93bjk.ProductKeys3P).Sentry,
    (0, $93bjk.ProductKeys3P).Gitbook,
    (0, $93bjk.ProductKeys3P).AWSS3,
    (0, $93bjk.ProductKeys3P).Notion,
    (0, $93bjk.ProductKeys3P).Todoist,
    (0, $93bjk.ProductKeys3P).Hubspot,
    (0, $93bjk.ProductKeys3P).JiraDC,
    (0, $93bjk.ProductKeys3P).JsmDC,
    // New 3P? Add it here
    (0, $93bjk.ProductKeys3P).ForgeAdamVitareqDev,
    (0, $93bjk.ProductKeys3P).ForgeAdamVitareqProd,
    (0, $93bjk.ProductKeys3P).ForgeK15tScrollSitesDev,
    (0, $93bjk.ProductKeys3P).ForgeK15tScrollSitesProd,
    (0, $93bjk.ProductKeys3P).ForgePioAwsDev,
    (0, $93bjk.ProductKeys3P).ForgePioAwsProd,
    (0, $93bjk.ProductKeys3P).ForgePioClickupDev,
    (0, $93bjk.ProductKeys3P).ForgePioClickupProd,
    (0, $93bjk.ProductKeys3P).ForgePioGithubDev,
    (0, $93bjk.ProductKeys3P).ForgePioGithubProd,
    (0, $93bjk.ProductKeys3P).ForgePioGitbookDev,
    (0, $93bjk.ProductKeys3P).ForgePioGitbookProd,
    (0, $93bjk.ProductKeys3P).ForgePioGitlabDev,
    (0, $93bjk.ProductKeys3P).ForgePioGitlabProd,
    (0, $93bjk.ProductKeys3P).ForgePioGoogleDriveDev,
    (0, $93bjk.ProductKeys3P).ForgePioGoogleDriveProd,
    (0, $93bjk.ProductKeys3P).ForgePioGuruDev,
    (0, $93bjk.ProductKeys3P).ForgePioGuruProd,
    (0, $93bjk.ProductKeys3P).ForgePioHelpjuiceDev,
    (0, $93bjk.ProductKeys3P).ForgePioHelpjuiceProd,
    (0, $93bjk.ProductKeys3P).ForgePioHubspotDev,
    (0, $93bjk.ProductKeys3P).ForgePioHubspotProd,
    (0, $93bjk.ProductKeys3P).ForgePioSalesforceDev,
    (0, $93bjk.ProductKeys3P).ForgePioSalesforceProd,
    (0, $93bjk.ProductKeys3P).ForgePioSharepointDev,
    (0, $93bjk.ProductKeys3P).ForgePioSharepointProd,
    (0, $93bjk.ProductKeys3P).ForgePioStackOverflowDev,
    (0, $93bjk.ProductKeys3P).ForgePioStackOverflowProd,
    (0, $93bjk.ProductKeys3P).ForgeUtoolityGitbookDev,
    (0, $93bjk.ProductKeys3P).ForgeUtoolityGitbookProd,
    (0, $93bjk.ProductKeys3P).ForgeGdriveEugeneTestDev,
    (0, $93bjk.ProductKeys3P).ForgeGdriveEugeneTestProd,
    (0, $93bjk.ProductKeys3P).ForgeUnitoSalesforceDev,
    (0, $93bjk.ProductKeys3P).ForgeUnitoSalesforceProd,
    (0, $93bjk.ProductKeys3P).ForgeUnitoServicenowDev,
    (0, $93bjk.ProductKeys3P).ForgeUnitoServicenowProd,
    (0, $93bjk.ProductKeys3P).ForgeUnitoWrikeDev,
    (0, $93bjk.ProductKeys3P).ForgeUnitoWrikeProd,
    (0, $93bjk.ProductKeys3P).ForgeUnitoAsanaDev,
    (0, $93bjk.ProductKeys3P).ForgeUnitoAsanaProd,
    (0, $93bjk.ProductKeys3P).ForgeUnitoBasecampDev,
    (0, $93bjk.ProductKeys3P).ForgeUnitoBasecampProd,
    (0, $93bjk.ProductKeys3P).Zoom,
    // Always last
    (0, $93bjk.ProductKeys3P).AtlassianWebCrawler
];
const $835de8bb064480e5$export$c36c249aaac5cad0 = {
    // TODO: when cleaning up `rovo_fps_show_github_assignee_filter`, add Github + ForgePioGithubDev/Prod here.
    assignee: [
        (0, $93bjk.ProductKeys3P).JiraDC,
        (0, $93bjk.ProductKeys3P).JsmDC
    ],
    campaignStatus: [
        (0, $93bjk.ProductKeys3P).Salesforce
    ],
    caseStatus: [
        (0, $93bjk.ProductKeys3P).Salesforce
    ],
    closeDate: [
        (0, $93bjk.ProductKeys3P).Salesforce
    ],
    // TODO: when cleaning up `rovo_fps_enable_gdrive_content_filter` / `rovo_fps_enable_sharepoint_content_filter`, add Google / Sharepoint here.
    content: [
        (0, $93bjk.ProductKeys3P).ConfluenceDC
    ],
    // TODO: when cleaning up `rovo_fps_show_github_created_by_filter`, add Github + ForgePioGithubDev/Prod here.
    createdBy: [
        (0, $93bjk.ProductKeys3P).ConfluenceDC,
        (0, $93bjk.ProductKeys3P).Hubspot,
        (0, $93bjk.ProductKeys3P).Salesforce
    ],
    label: [
        (0, $93bjk.ProductKeys3P).ConfluenceDC
    ],
    lastUpdated: [
        (0, $93bjk.ProductKeys3P).Airtable,
        (0, $93bjk.ProductKeys3P).Asana,
        (0, $93bjk.ProductKeys3P).AzureDevops,
        (0, $93bjk.ProductKeys3P).Box,
        (0, $93bjk.ProductKeys3P).ConfluenceDC,
        (0, $93bjk.ProductKeys3P).Databricks,
        (0, $93bjk.ProductKeys3P).Docusign,
        (0, $93bjk.ProductKeys3P).Dropbox,
        (0, $93bjk.ProductKeys3P).Figma,
        (0, $93bjk.ProductKeys3P).ForgeAdamVitareqDev,
        (0, $93bjk.ProductKeys3P).ForgeAdamVitareqProd,
        (0, $93bjk.ProductKeys3P).ForgeGdriveEugeneTestDev,
        (0, $93bjk.ProductKeys3P).ForgeGdriveEugeneTestProd,
        (0, $93bjk.ProductKeys3P).ForgeK15tScrollSitesDev,
        (0, $93bjk.ProductKeys3P).ForgeK15tScrollSitesProd,
        (0, $93bjk.ProductKeys3P).ForgePioAwsDev,
        (0, $93bjk.ProductKeys3P).ForgePioAwsProd,
        (0, $93bjk.ProductKeys3P).ForgePioClickupDev,
        (0, $93bjk.ProductKeys3P).ForgePioClickupProd,
        (0, $93bjk.ProductKeys3P).ForgePioGitbookDev,
        (0, $93bjk.ProductKeys3P).ForgePioGitbookProd,
        (0, $93bjk.ProductKeys3P).ForgePioGithubDev,
        (0, $93bjk.ProductKeys3P).ForgePioGithubProd,
        (0, $93bjk.ProductKeys3P).ForgePioGitlabDev,
        (0, $93bjk.ProductKeys3P).ForgePioGitlabProd,
        (0, $93bjk.ProductKeys3P).ForgePioGoogleDriveDev,
        (0, $93bjk.ProductKeys3P).ForgePioGoogleDriveProd,
        (0, $93bjk.ProductKeys3P).ForgePioGuruDev,
        (0, $93bjk.ProductKeys3P).ForgePioGuruProd,
        (0, $93bjk.ProductKeys3P).ForgePioHelpjuiceDev,
        (0, $93bjk.ProductKeys3P).ForgePioHelpjuiceProd,
        (0, $93bjk.ProductKeys3P).ForgePioHubspotDev,
        (0, $93bjk.ProductKeys3P).ForgePioHubspotProd,
        (0, $93bjk.ProductKeys3P).ForgePioSalesforceDev,
        (0, $93bjk.ProductKeys3P).ForgePioSalesforceProd,
        (0, $93bjk.ProductKeys3P).ForgePioSharepointDev,
        (0, $93bjk.ProductKeys3P).ForgePioSharepointProd,
        (0, $93bjk.ProductKeys3P).ForgePioStackOverflowDev,
        (0, $93bjk.ProductKeys3P).ForgePioStackOverflowProd,
        (0, $93bjk.ProductKeys3P).ForgeUnitoAsanaDev,
        (0, $93bjk.ProductKeys3P).ForgeUnitoAsanaProd,
        (0, $93bjk.ProductKeys3P).ForgeUnitoBasecampDev,
        (0, $93bjk.ProductKeys3P).ForgeUnitoBasecampProd,
        (0, $93bjk.ProductKeys3P).ForgeUnitoSalesforceDev,
        (0, $93bjk.ProductKeys3P).ForgeUnitoSalesforceProd,
        (0, $93bjk.ProductKeys3P).ForgeUnitoServicenowDev,
        (0, $93bjk.ProductKeys3P).ForgeUnitoServicenowProd,
        (0, $93bjk.ProductKeys3P).ForgeUnitoWrikeDev,
        (0, $93bjk.ProductKeys3P).ForgeUnitoWrikeProd,
        (0, $93bjk.ProductKeys3P).ForgeUtoolityGitbookDev,
        (0, $93bjk.ProductKeys3P).ForgeUtoolityGitbookProd,
        (0, $93bjk.ProductKeys3P).Github,
        (0, $93bjk.ProductKeys3P).Gmail,
        (0, $93bjk.ProductKeys3P).GoogleDrive,
        (0, $93bjk.ProductKeys3P).Hubspot,
        (0, $93bjk.ProductKeys3P).JiraDC,
        (0, $93bjk.ProductKeys3P).JsmDC,
        (0, $93bjk.ProductKeys3P).Loom,
        (0, $93bjk.ProductKeys3P).Lucid,
        (0, $93bjk.ProductKeys3P).Miro,
        (0, $93bjk.ProductKeys3P).Notion,
        (0, $93bjk.ProductKeys3P).OneDrive,
        (0, $93bjk.ProductKeys3P).OutlookMail,
        (0, $93bjk.ProductKeys3P).Salesforce,
        (0, $93bjk.ProductKeys3P).ServiceNow,
        (0, $93bjk.ProductKeys3P).Sharepoint,
        (0, $93bjk.ProductKeys3P).Slack,
        (0, $93bjk.ProductKeys3P).Smartsheet,
        (0, $93bjk.ProductKeys3P).Teams,
        (0, $93bjk.ProductKeys3P).Zendesk,
        (0, $93bjk.ProductKeys3P).Zoom
    ],
    lastUpdatedBy: [
        (0, $93bjk.ProductKeys3P).Hubspot,
        (0, $93bjk.ProductKeys3P).Salesforce
    ],
    opportunityStatus: [
        (0, $93bjk.ProductKeys3P).Salesforce
    ],
    onlyTitleMatch: [
        (0, $93bjk.ProductKeys3P).Airtable,
        (0, $93bjk.ProductKeys3P).Asana,
        (0, $93bjk.ProductKeys3P).Box,
        (0, $93bjk.ProductKeys3P).ConfluenceDC,
        (0, $93bjk.ProductKeys3P).Databricks,
        (0, $93bjk.ProductKeys3P).Docusign,
        (0, $93bjk.ProductKeys3P).Dropbox,
        (0, $93bjk.ProductKeys3P).Github,
        (0, $93bjk.ProductKeys3P).GoogleDrive,
        (0, $93bjk.ProductKeys3P).Hubspot,
        (0, $93bjk.ProductKeys3P).Miro,
        (0, $93bjk.ProductKeys3P).Notion,
        (0, $93bjk.ProductKeys3P).OneDrive,
        (0, $93bjk.ProductKeys3P).OutlookMail,
        (0, $93bjk.ProductKeys3P).Salesforce,
        (0, $93bjk.ProductKeys3P).ServiceNow,
        (0, $93bjk.ProductKeys3P).Sharepoint,
        (0, $93bjk.ProductKeys3P).Smartsheet,
        (0, $93bjk.ProductKeys3P).Zendesk,
        (0, $93bjk.ProductKeys3P).Zoom
    ],
    owner: [
        (0, $93bjk.ProductKeys3P).Salesforce
    ],
    project: [
        (0, $93bjk.ProductKeys3P).JiraDC,
        (0, $93bjk.ProductKeys3P).JsmDC
    ],
    pullRequestStatus: [
        (0, $93bjk.ProductKeys3P).ForgePioGithubDev,
        (0, $93bjk.ProductKeys3P).ForgePioGithubProd,
        (0, $93bjk.ProductKeys3P).ForgePioGitlabDev,
        (0, $93bjk.ProductKeys3P).ForgePioGitlabProd,
        (0, $93bjk.ProductKeys3P).Github,
        (0, $93bjk.ProductKeys3P).Gitlab
    ],
    // TODO: when cleaning up `rovo_fps_show_repository_filter`, add Github + ForgePioGithubDev/Prod here.
    repository: [],
    // TODO: when cleaning up `rovo_fps_show_reviewer_filter`, add Github + ForgePioGithubDev/Prod here.
    reviewer: [],
    slackChannel: [
        (0, $93bjk.ProductKeys3P).Slack
    ],
    // TODO: when cleaning up `rovo_fps_enable_gdrive_space_filter` / `rovo_fps_enable_sharepoint_space_filter`, add Google / Sharepoint here.
    space: [
        (0, $93bjk.ProductKeys3P).ConfluenceDC
    ],
    hasAttachment: [
        (0, $93bjk.ProductKeys3P).Teams
    ],
    // workspaceName is always in ThirdPartyConfigs.filters for Teams (gate controls filterIdOrdering only)
    workspaceName: [
        (0, $93bjk.ProductKeys3P).Teams
    ]
};

});


parcelRegister("knoE2", function(module, exports) {
$parcel$export(module.exports, "i18n", () => $567bb90537b30be3$export$a7357cdd1f0b0168);

var $7eNDO = parcelRequire("7eNDO");
const $567bb90537b30be3$export$a7357cdd1f0b0168 = (0, $7eNDO.defineMessages)({
    connectAppsLabel: {
        id: 'quick_find_connect_apps_label',
        defaultMessage: 'Connect apps',
        description: 'Label that slides in next to the apps icon when the search bar is opened, indicating the user can connect third-party apps.'
    },
    connectAppsButtonAriaLabel: {
        id: 'quick_find_connect_apps_button_aria_label',
        defaultMessage: 'Open app connections',
        description: 'Accessible label for the apps button shown at the trailing edge of the search bar.'
    }
});

});

parcelRegister("9jEtN", function(module, exports) {
$parcel$export(module.exports, "STATIC_FALLBACK_ORDER", () => $986ff8e0d77b603a$export$cf5dbd29f0fc9bcc);

var $93bjk = parcelRequire("93bjk");
const $986ff8e0d77b603a$export$cf5dbd29f0fc9bcc = [
    (0, $93bjk.ProductKeys3P).GoogleDrive,
    (0, $93bjk.ProductKeys3P).Salesforce,
    (0, $93bjk.ProductKeys3P).Slack,
    (0, $93bjk.ProductKeys3P).Github,
    (0, $93bjk.ProductKeys3P).Figma
];

});

parcelRegister("b26e2", function(module, exports) {
$parcel$export(module.exports, "isElevated", () => $2399d20d392c3d4f$export$58fbd07a68af8e16);
$parcel$export(module.exports, "isTextOut", () => $2399d20d392c3d4f$export$918c1c59a77a7524);
$parcel$export(module.exports, "useConnectAppsAnimation", () => $2399d20d392c3d4f$export$3fdaf24cc938081f);

var $euxye = parcelRequire("euxye");

var $kzb1R = parcelRequire("kzb1R");
const $2399d20d392c3d4f$export$58fbd07a68af8e16 = (phase)=>phase === 'bg-fade-in' || phase === 'sliding-out' || phase === 'icon-cycling' || phase === 'sliding-back';
const $2399d20d392c3d4f$export$918c1c59a77a7524 = (phase)=>phase === 'sliding-out' || phase === 'icon-cycling';
/** Maximum number of animation runs allowed per icon-component mount. */ const $2399d20d392c3d4f$var$MAX_STARTS = 2;
const $2399d20d392c3d4f$export$3fdaf24cc938081f = ({ start: start, sequenceLength: sequenceLength, canStart: canStart, onStart: onStart })=>{
    const [phase, setPhase] = (0, $euxye.useState)('idle');
    const [activeIndex, setActiveIndex] = (0, $euxye.useState)(0);
    const timersRef = (0, $euxye.useRef)([]);
    const rafRef = (0, $euxye.useRef)(null);
    const startCountRef = (0, $euxye.useRef)(0);
    // Mirror `sequenceLength` in a ref so the start-effect can read the latest
    // value without re-firing whenever the prop reference changes. This prevents
    // an in-flight animation from being torn down + restarted (visually a "rewind")
    // and from incrementing the cooldown counter twice for the same play.
    const sequenceLengthRef = (0, $euxye.useRef)(sequenceLength);
    sequenceLengthRef.current = sequenceLength;
    const cancelTimers = (0, $euxye.useCallback)(()=>{
        timersRef.current.forEach(clearTimeout);
        timersRef.current = [];
        if (rafRef.current !== null) {
            cancelAnimationFrame(rafRef.current);
            rafRef.current = null;
        }
    }, []);
    const scheduleAfter = (0, $euxye.useCallback)((delayMs, fn)=>{
        timersRef.current.push(setTimeout(fn, delayMs));
    }, []);
    const playReverseTail = (0, $euxye.useCallback)(()=>{
        setActiveIndex(0);
        setPhase('sliding-back');
        scheduleAfter((0, $kzb1R.CONNECT_APPS_SLIDE_DURATION), ()=>{
            setPhase('bg-fade-out');
            scheduleAfter((0, $kzb1R.CONNECT_APPS_BG_DURATION), ()=>setPhase('done'));
        });
    }, [
        scheduleAfter
    ]);
    const exitEarly = (0, $euxye.useCallback)(()=>{
        cancelTimers();
        playReverseTail();
    }, [
        cancelTimers,
        playReverseTail
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!start) {
            cancelTimers();
            setPhase('idle');
            setActiveIndex(0);
            return;
        }
        // Cap the per-mount play count and consult the per-week cooldown.
        // Visual overlap between consecutive runs is prevented separately —
        // the parent must transition `start` back to `false` (the branch
        // above cancels in-flight timers + resets to `idle`) before raising
        // `start` again for the next play.
        if (startCountRef.current >= $2399d20d392c3d4f$var$MAX_STARTS || !canStart()) return;
        // We split the start over two animation frames so the DOM has enough
        // time to flush the idle styles before CSS transitions begin. Without
        // this, opening QuickFind during the initial render burst (e.g. mouse
        // already over QF on refresh) causes the pill to snap to bg-fade-in
        // and freeze because the transition has no painted "from" value.
        // Mirrors the canonical pattern in @atlaskit/motion (resizing, shrink-out).
        rafRef.current = requestAnimationFrame(()=>{
            rafRef.current = requestAnimationFrame(()=>{
                rafRef.current = null;
                // Consume the per-mount play slot and weekly cooldown only once
                // the animation actually begins. Done here (inside the inner rAF)
                // so a fast open-then-close in the ~16ms before paint cancels the
                // rAF without burning the user's budget.
                startCountRef.current += 1;
                onStart();
                // Snapshot the latest sequence length once per run so all
                // timeline math is internally consistent.
                const sequenceLength = sequenceLengthRef.current;
                // Build the full timeline up-front so forward & reverse share one schedule.
                const cycleStart = (0, $kzb1R.CONNECT_APPS_BG_DURATION) + (0, $kzb1R.CONNECT_APPS_SLIDE_DURATION);
                const cycleDuration = (sequenceLength - 1) * (0, $kzb1R.CONNECT_APPS_ICON_STEP) + (0, $kzb1R.HOLD_DURATION);
                const reverseStart = cycleStart + cycleDuration + (0, $kzb1R.END_LINGER);
                const steps = [
                    {
                        atMs: 0,
                        apply: ()=>setPhase('bg-fade-in')
                    },
                    {
                        atMs: (0, $kzb1R.CONNECT_APPS_BG_DURATION),
                        apply: ()=>setPhase('sliding-out')
                    },
                    {
                        atMs: cycleStart,
                        apply: ()=>setPhase('icon-cycling')
                    }
                ];
                // Icon i (1..N-1) becomes active HOLD ms after icon-cycling starts,
                // then every ICON_STEP ms thereafter.
                for(let i = 1; i < sequenceLength; i++)steps.push({
                    atMs: cycleStart + (0, $kzb1R.HOLD_DURATION) + (i - 1) * (0, $kzb1R.CONNECT_APPS_ICON_STEP),
                    apply: ()=>setActiveIndex(i)
                });
                steps.push({
                    atMs: reverseStart,
                    apply: ()=>{
                        setActiveIndex(0);
                        setPhase('sliding-back');
                    }
                }, {
                    atMs: reverseStart + (0, $kzb1R.CONNECT_APPS_SLIDE_DURATION),
                    apply: ()=>setPhase('bg-fade-out')
                }, {
                    atMs: reverseStart + (0, $kzb1R.CONNECT_APPS_SLIDE_DURATION) + (0, $kzb1R.CONNECT_APPS_BG_DURATION),
                    apply: ()=>setPhase('done')
                });
                steps.forEach(({ atMs: atMs, apply: apply })=>scheduleAfter(atMs, apply));
            });
        });
        return cancelTimers;
    // `sequenceLength` is intentionally omitted from the deps; it's read from
    // `sequenceLengthRef` inside the rAF callback so a mid-flight prop change
    // doesn't tear down + restart the animation (see comment on the ref above).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        start,
        canStart,
        onStart,
        cancelTimers,
        scheduleAfter
    ]);
    return {
        phase: phase,
        activeIndex: activeIndex,
        exitEarly: exitEarly
    };
};

});
parcelRegister("kzb1R", function(module, exports) {
$parcel$export(module.exports, "CONNECT_APPS_BG_DURATION", () => $17d724ab3d53bc52$export$db0699d3bbb5c21);
$parcel$export(module.exports, "CONNECT_APPS_SLIDE_DURATION", () => $17d724ab3d53bc52$export$7ed54f99843287d);
$parcel$export(module.exports, "HOLD_DURATION", () => $17d724ab3d53bc52$export$fad50bf971d7fa0e);
$parcel$export(module.exports, "CONNECT_APPS_ICON_STEP", () => $17d724ab3d53bc52$export$cb49a8c4d0e244f2);
$parcel$export(module.exports, "END_LINGER", () => $17d724ab3d53bc52$export$f5cb186d9c55308b);
/**
 * Timing & easing constants for the Connect Apps animation.
 *
 * Single source of truth for both the JS phase machine
 * (`useConnectAppsAnimation`) and the CSS transitions in `index.tsx`.
 * Tests import these to derive total run time without hardcoding magic numbers.
 */ /** Duration of the pill background fade in/out at each end of the animation. */ const $17d724ab3d53bc52$export$db0699d3bbb5c21 = 200;
const $17d724ab3d53bc52$export$7ed54f99843287d = 350;
const $17d724ab3d53bc52$export$fad50bf971d7fa0e = 420;
const $17d724ab3d53bc52$export$9f0b035597bf40dd = 300;
const $17d724ab3d53bc52$export$cb49a8c4d0e244f2 = $17d724ab3d53bc52$export$fad50bf971d7fa0e + $17d724ab3d53bc52$export$9f0b035597bf40dd;
const $17d724ab3d53bc52$export$f5cb186d9c55308b = 1200;
const $17d724ab3d53bc52$export$cf94430de8ea1fba = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
const $17d724ab3d53bc52$export$3ded9395204bb852 = 'cubic-bezier(0.45, 0, 0.55, 1)';

});


parcelRegister("6PMB1", function(module, exports) {
$parcel$export(module.exports, "useConnectAppsCooldown", () => $ad2d654a7910a6a2$export$92cbac270a4be2e0);

var $euxye = parcelRequire("euxye");

var $lxK87 = parcelRequire("lxK87");

var $eV9tM = parcelRequire("eV9tM");

var $1E6WT = parcelRequire("1E6WT");
const $ad2d654a7910a6a2$var$COOLDOWN_STORAGE_KEY = 'quick_find_connect_apps_cooldown';
const $ad2d654a7910a6a2$var$MAX_ANIMATIONS_PER_WEEK = 10;
const $ad2d654a7910a6a2$var$DISMISSED_VALUE = 'dismissed';
const $ad2d654a7910a6a2$var$getCurrentWeekKey = ()=>{
    const now = new Date();
    // ISO week-year + ISO week so we don't get an off-by-one across a year boundary
    // (e.g. Jan 1 can fall in the previous year's last ISO week).
    return `${(0, $eV9tM.default)(now)}_w${(0, $lxK87.default)(now)}`;
};
const $ad2d654a7910a6a2$var$readStore = ()=>{
    const raw = (0, $1E6WT.getLocalStorageItemAsString)($ad2d654a7910a6a2$var$COOLDOWN_STORAGE_KEY);
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object' && 'count' in parsed && 'weekKey' in parsed && typeof parsed.count === 'number' && typeof parsed.weekKey === 'string') return parsed;
        return null;
    } catch  {
        // JSON parse error — degrade gracefully.
        return null;
    }
};
const $ad2d654a7910a6a2$var$isDismissed = ()=>{
    return (0, $1E6WT.getLocalStorageItemAsString)($ad2d654a7910a6a2$var$COOLDOWN_STORAGE_KEY) === $ad2d654a7910a6a2$var$DISMISSED_VALUE;
};
const $ad2d654a7910a6a2$var$writeStore = (store)=>{
    try {
        (0, $1E6WT.setLocalStorageItem)($ad2d654a7910a6a2$var$COOLDOWN_STORAGE_KEY, JSON.stringify(store));
    } catch  {
    // Private browsing / storage full / quota exceeded — degrade gracefully
    // (the animation plays anyway; we just lose the count for this attempt).
    }
};
const $ad2d654a7910a6a2$export$92cbac270a4be2e0 = (maxPerWeek = $ad2d654a7910a6a2$var$MAX_ANIMATIONS_PER_WEEK)=>{
    const canAnimate = (0, $euxye.useCallback)(()=>{
        if ($ad2d654a7910a6a2$var$isDismissed()) return false;
        const weekKey = $ad2d654a7910a6a2$var$getCurrentWeekKey();
        const stored = $ad2d654a7910a6a2$var$readStore();
        if (stored?.weekKey === weekKey && stored.count >= maxPerWeek) return false;
        return true;
    }, [
        maxPerWeek
    ]);
    const recordAnimation = (0, $euxye.useCallback)(()=>{
        const weekKey = $ad2d654a7910a6a2$var$getCurrentWeekKey();
        const stored = $ad2d654a7910a6a2$var$readStore();
        const count = stored?.weekKey === weekKey ? stored.count + 1 : 1;
        $ad2d654a7910a6a2$var$writeStore({
            weekKey: weekKey,
            count: count
        });
    }, []);
    const dismissPermanently = (0, $euxye.useCallback)(()=>{
        try {
            (0, $1E6WT.setLocalStorageItem)($ad2d654a7910a6a2$var$COOLDOWN_STORAGE_KEY, $ad2d654a7910a6a2$var$DISMISSED_VALUE);
        } catch  {
        // degrade gracefully
        }
    }, []);
    return {
        canAnimate: canAnimate,
        recordAnimation: recordAnimation,
        dismissPermanently: dismissPermanently
    };
};

});
parcelRegister("1E6WT", function(module, exports) {
$parcel$export(module.exports, "setLocalStorageItem", () => $61ae16d944652beb$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $61ae16d944652beb$export$93d719890ad66653);
$parcel$export(module.exports, "getLocalStorageItemAsString", () => $61ae16d944652beb$export$5df15f289f441790);
$parcel$export(module.exports, "removeLocalStorageItem", () => $61ae16d944652beb$export$baf306891f1b93bd);

var $egspI = parcelRequire("egspI");

var $4fPPi = parcelRequire("4fPPi");
// `localStorage` is a browser-only Web API and does not exist during server-side
// rendering (SSR). Accessing the bare `localStorage` identifier on the server
// throws a `ReferenceError`, which crashes the render.
const $61ae16d944652beb$var$isLocalStorageAvailable = ()=>{
    if (!(0, $egspI.fg)('fix_ssr_browser_storage_undefined')) return true;
    return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
};
const $61ae16d944652beb$export$5aa524d86254b4f = (key, value)=>{
    if (!$61ae16d944652beb$var$isLocalStorageAvailable()) return;
    if ((0, $egspI.fg)('search_page_use_browser_storage_controls')) (0, $4fPPi.AtlBrowserStorageLocal).setItem(key, value);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(key, value);
};
const $61ae16d944652beb$export$93d719890ad66653 = (key)=>{
    if (!$61ae16d944652beb$var$isLocalStorageAvailable()) return null;
    const item = (0, $egspI.fg)('search_page_use_browser_storage_controls') ? (0, $4fPPi.AtlBrowserStorageLocal).getItem(key) : localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
const $61ae16d944652beb$export$5df15f289f441790 = (key)=>{
    if (!$61ae16d944652beb$var$isLocalStorageAvailable()) return null;
    const item = (0, $egspI.fg)('search_page_use_browser_storage_controls') ? (0, $4fPPi.AtlBrowserStorageLocal).getItem(key) : localStorage.getItem(key);
    return item ? item : null;
};
const $61ae16d944652beb$export$baf306891f1b93bd = (key)=>{
    if (!$61ae16d944652beb$var$isLocalStorageAvailable()) return;
    if ((0, $egspI.fg)('search_page_use_browser_storage_controls')) (0, $4fPPi.AtlBrowserStorageLocal).removeItem(key);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(key);
};

});



parcelRegister("8EB7p", function(module, exports) {
$parcel$export(module.exports, "LegacySearchIcon", () => $9de22af63e12a360$export$c3bd67ecc5ebe519);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $eAQb7 = parcelRequire("eAQb7");
const $9de22af63e12a360$export$c3bd67ecc5ebe519 = ({ isExpanded: isExpanded, primaryColor: primaryColor = "var(--ds-text, #292A2E)", defaultColor: defaultColor = "var(--ds-text-subtlest, #6B6E76)", label: label = '' })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAQb7))), {
        label: label,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : defaultColor
    });
$9de22af63e12a360$export$c3bd67ecc5ebe519.displayName = "LegacySearchIcon";

});

parcelRegister("apvKK", function(module, exports) {
$parcel$export(module.exports, "messages", () => $6a04a3e479377cc8$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $6a04a3e479377cc8$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    clearIconLabel: {
        id: 'input_clear_icon_label',
        defaultMessage: 'Clear search',
        description: 'Label text for clear search button'
    },
    inputPlaceholder: {
        id: 'input_placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text in primary search input'
    },
    inputAriaLabel: {
        id: 'input_aria_label',
        defaultMessage: 'Search, press enter to navigate to advanced search with your text query',
        description: 'Aria label for primary search input, directs users advanced search'
    }
});

});


parcelRegister("hhYhk", function(module, exports) {
$parcel$export(module.exports, "getInitialQuery", () => $6d7ba238b06eb17e$export$ed7270bd966434af);
$parcel$export(module.exports, "useInputSkeleton", () => $6d7ba238b06eb17e$export$67de3a75cbe82e14);

var $euxye = parcelRequire("euxye");

var $7ZDiP = parcelRequire("7ZDiP");
// The query is stored in module scope to persist across remounts
let $6d7ba238b06eb17e$var$initialQueryValue;
const $6d7ba238b06eb17e$export$ed7270bd966434af = (searchQueryParams)=>{
    const stickySearch = $6d7ba238b06eb17e$var$initialQueryValue;
    return searchQueryParams || stickySearch || (0, $7ZDiP.getInputSkeletonQuery)() || '';
};
const $6d7ba238b06eb17e$export$67de3a75cbe82e14 = ({ localQuery: localQuery, inputRef: inputRef })=>{
    // Focus input if skeleton is focused
    (0, $euxye.useEffect)(()=>{
        const skeletonFocused = (0, $7ZDiP.getInputSkeletonFocus)();
        if (skeletonFocused) {
            const input = inputRef?.current;
            if (input) {
                input.focus();
                input.click();
                const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $7ZDiP.getInputSkeletonSelection)();
                input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
            }
        }
        (0, $7ZDiP.removeInputSkeletonState)();
    }, [
        inputRef
    ]);
    // Push local query to session storage
    (0, $euxye.useEffect)(()=>{
        // Update the module-scoped variable to make it available for remounts
        $6d7ba238b06eb17e$var$initialQueryValue = localQuery;
    }, [
        localQuery
    ]);
};

});

parcelRegister("gXrOS", function(module, exports) {
$parcel$export(module.exports, "GhostTextExperimentCohort", () => $3beb9b51db8acc32$export$6891b88a23696d);
$parcel$export(module.exports, "ROTATION_THRESHOLD", () => $3beb9b51db8acc32$export$73fd7fc6fed7f9d9);
$parcel$export(module.exports, "parseGhostTextData", () => $3beb9b51db8acc32$export$bd8829925eef3cc2);

var $eSKht = parcelRequire("eSKht");
var $3beb9b51db8acc32$export$6891b88a23696d = /*#__PURE__*/ function(GhostTextExperimentCohort) {
    GhostTextExperimentCohort["CONTROL"] = "control";
    GhostTextExperimentCohort["THREE_P"] = "3p";
    return GhostTextExperimentCohort;
}({});
const $3beb9b51db8acc32$export$73fd7fc6fed7f9d9 = 3;
const $3beb9b51db8acc32$export$bd8829925eef3cc2 = (customPlaceholder)=>{
    if (!customPlaceholder) return undefined;
    try {
        const result = (0, $eSKht.GhostTextDataV2Schema).safeParse(JSON.parse(customPlaceholder));
        if (result.success) return result.data;
        return undefined;
    } catch  {
        return undefined;
    }
};

});
parcelRegister("eSKht", function(module, exports) {
$parcel$export(module.exports, "GhostTextDataV2Schema", () => $40a3b015ef3f6052$export$9bcc9fe305679f00);
parcelRequire("82QkS");
var $iO6In = parcelRequire("iO6In");
const $40a3b015ef3f6052$export$9bcc9fe305679f00 = (0, $iO6In).object({
    /** Unique key identifying the current ghost text set */ id: (0, $iO6In).string(),
    /** Locale of the ghost text */ locale: (0, $iO6In).string(),
    /** The placeholder text to display */ text: (0, $iO6In).string(),
    /** Number of times this text has been shown (0-2, resets after 3) */ occurrence: (0, $iO6In).number().optional().default(0)
});

});


parcelRegister("b2QJu", function(module, exports) {
$parcel$export(module.exports, "messages", () => $93769f2f9404422a$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $93769f2f9404422a$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    placeholder: {
        id: 'search_dialog_aria_label',
        defaultMessage: 'Search',
        description: 'Placeholder text in primary search input'
    }
});

});


parcelRegister("1LT2r", function(module, exports) {
$parcel$export(module.exports, "PrimaryProductKeys", () => $83df0e4083d8a28f$export$15d12effc8830544);
/**
 * Primary product keys represent products that can mount Search Page.
 */ const $83df0e4083d8a28f$export$15d12effc8830544 = {
    Atlas: 'townsquare',
    Confluence: 'confluence',
    Assets: 'cmdb',
    Focus: 'mercury',
    Jira: 'jira',
    Elevate: 'elevate',
    Talent: 'radar',
    RovoExtension: 'rovo-extension',
    Studio: 'studio'
};

});

parcelRegister("hRQte", function(module, exports) {
$parcel$export(module.exports, "SharedFeaturesInstrumentationIdContext", () => $ab0dbcd9ecdd2d31$export$5ae3634fdb64882c);
$parcel$export(module.exports, "AnalyticsContextWithSourceAndProperties", () => $ab0dbcd9ecdd2d31$export$a00cd3c213413389);
$parcel$export(module.exports, "useAnalyticsPropertiesContext", () => $ab0dbcd9ecdd2d31$export$ab8aa3dfd687f012);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hUqPj = parcelRequire("hUqPj");
const $ab0dbcd9ecdd2d31$var$initialState = {
    conversationChannelId: '',
    experienceId: '',
    product: '',
    productHeader: '',
    inProductExperience: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    agentIsVerified: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: '',
    mode: undefined
};
const $ab0dbcd9ecdd2d31$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $euxye.createContext)({
    propertiesRef: {
        current: {
            ...$ab0dbcd9ecdd2d31$var$initialState
        }
    },
    mode: undefined,
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $ab0dbcd9ecdd2d31$export$5ae3634fdb64882c = /*#__PURE__*/ (0, $euxye.createContext)({
    sharedFeaturesInstrumentationId: undefined,
    isInSmartCreateFlow: undefined
});
const $ab0dbcd9ecdd2d31$export$1aefd27d2ed3c1c9 = ({ children: children, mode: mode })=>{
    const propertiesRef = (0, $euxye.useRef)({
        ...$ab0dbcd9ecdd2d31$var$initialState
    });
    const setAnalyticsPropertiesWithoutRerender = (0, $euxye.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $euxye.useMemo)(()=>({
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender,
        mode
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($ab0dbcd9ecdd2d31$var$AnalyticsPropertiesContext.Provider, {
        value: value,
        children: children
    });
};
$ab0dbcd9ecdd2d31$export$1aefd27d2ed3c1c9.displayName = "AnalyticsPropertiesContextProvider";
const $ab0dbcd9ecdd2d31$export$a00cd3c213413389 = ({ source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow })=>{
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $euxye.useContext)($ab0dbcd9ecdd2d31$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const data = (0, $euxye.useMemo)(()=>({
            source: source,
            attributes: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            }
        }), [
        source,
        sharedFeaturesInstrumentationId,
        parentSharedFeaturesInstrumentationId,
        isInSmartCreateFlow
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hUqPj.default), {
        data: data,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($ab0dbcd9ecdd2d31$export$5ae3634fdb64882c.Provider, {
            value: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            },
            children: /*#__PURE__*/ (0, $e79Pd.jsx)($ab0dbcd9ecdd2d31$export$1aefd27d2ed3c1c9, {
                mode: mode,
                children: children
            })
        })
    });
};
$ab0dbcd9ecdd2d31$export$a00cd3c213413389.displayName = "AnalyticsContextWithSourceAndProperties";
const $ab0dbcd9ecdd2d31$export$ab8aa3dfd687f012 = ()=>{
    return (0, $euxye.useContext)($ab0dbcd9ecdd2d31$var$AnalyticsPropertiesContext);
};

});

parcelRegister("5oGA6", function(module, exports) {
$parcel$export(module.exports, "useAnalytics", () => $06f0a014b2aa50a7$export$e955abb82869dc84);

var $euxye = parcelRequire("euxye");

var $9xulT = parcelRequire("9xulT");
var $inMxE = parcelRequire("inMxE");

var $iK8G7 = parcelRequire("iK8G7");

var $7lmdG = parcelRequire("7lmdG");

var $hRQte = parcelRequire("hRQte");

var $kh2v5 = parcelRequire("kh2v5");

var $29Eij = parcelRequire("29Eij");

var $k7yqz = parcelRequire("k7yqz");
const $06f0a014b2aa50a7$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host?.includes(host));
const $06f0a014b2aa50a7$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $06f0a014b2aa50a7$export$e955abb82869dc84 = (options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef, mode: mode } = (0, $hRQte.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $euxye.useCallback)((inputPayload)=>{
        const payload = (0, $9xulT.isUIAnalyticsEvent)(inputPayload) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $06f0a014b2aa50a7$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const tagsForAIAnalytics = [
        ...$06f0a014b2aa50a7$var$DEFAULT_TAGS
    ];
    if ($06f0a014b2aa50a7$var$isTownSquareEvent()) tagsForAIAnalytics.push('townsquare');
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIResultAdopted: trackAIResultAdopted, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $iK8G7.useAIEventsInstrumentation)({
        // Required configruation
        product: propertiesRef.current.product,
        subproduct: propertiesRef.current.product,
        aiFeatureName: 'aiChat',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        tags: tagsForAIAnalytics,
        skipAISessionValidation: options?.skipAISessionValidation,
        customAnalyticsFire: (rawEvent, _createdEvent)=>{
            // Build event and apply context attributes
            const event = createAnalyticsEvent(rawEvent);
            if (!event) // In SSR / no-listener environments, `createAnalyticsEvent` can return `undefined`.
            // Nothing to fire.
            return;
            const aiMateContextAttributes = (0, $k7yqz.getAttributesFromContexts)(event.context);
            // Fire. `event.update(...)` returns `undefined` for stub events (no `<AnalyticsListener>`
            // mounted, e.g. during SSR), so fall back to the original event and guard `.fire` with
            // optional chaining.
            const updatedEvent = event.update({
                attributes: {
                    ...event.payload?.attributes ?? {},
                    ...aiMateContextAttributes
                }
            }) ?? event;
            updatedEvent?.fire?.((0, $29Eij.ANALYTICS_CHANNEL));
        }
    });
    const getDefaultAttributes = (0, $euxye.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, agentIsVerified: agentIsVerified, conversationChannelId: conversationChannelId, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader, inProductExperience: inProductExperience, mode: mode, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias } = propertiesRef.current;
        return {
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).inProductExperience]: inProductExperience,
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault,
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).agentIsVerified]: agentIsVerified,
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).mode]: mode,
            [(0, $kh2v5.AI_MATE_ATTRIBUTES).assistanceServiceConfigMinionAlias]: assistanceServiceConfigMinionAlias
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $euxye.useCallback)((payload)=>{
        // Handle tags
        const tags = [
            ...$06f0a014b2aa50a7$var$DEFAULT_TAGS
        ];
        if ($06f0a014b2aa50a7$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: sourceUnknown, subjectId: subjectIdUnknown, proactive: proactive, userGenerated: userGenerated, doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, sourceProducts: sourceProducts, sourceProduct: sourceProduct, pluginsInvoked: pluginsInvoked, tools: tools, skillsInvoked: skillsInvoked, executedStratusSkill: executedStratusSkill, responseSources: responseSources, usesJsm: usesJsm, invokedFrom: invokedFrom, conversationChannelId: conversationChannelId, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias, scenarioId: scenarioId, pageContext: pageContext, viewContext: viewContext, attributes: customAttributes } = payload;
        // source and subjectId are optional in the payload type but trackAI* functions require string.
        // The runtime value (including undefined) is intentionally passed through as-is.
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing analytics baseline: preserves the runtime value while satisfying a string-only downstream API type.
        const source = sourceUnknown;
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing analytics baseline: preserves the runtime value while satisfying a string-only downstream API type.
        const subjectId = subjectIdUnknown;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            citedProductList: citedProductList,
            citedProduct: citedProduct,
            sourceProducts: sourceProducts,
            sourceProduct: sourceProduct,
            ...customAttributes,
            aiFeatureName: customAttributes?.aiFeatureName || 'aiChat'
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (invokedFrom) attributes.invokedFrom = invokedFrom;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (pluginsInvoked) attributes.pluginsInvoked = pluginsInvoked;
        if (tools) attributes.tools = tools;
        if (skillsInvoked) attributes.skillsInvoked = skillsInvoked;
        if (executedStratusSkill !== undefined) attributes.executedStratusSkill = executedStratusSkill;
        if (responseSources) attributes.responseSources = responseSources;
        if (usesJsm !== undefined) attributes.usesJsm = usesJsm;
        if (deepResearchEnabled) attributes.deepResearchEnabled = deepResearchEnabled;
        if (fastModeEnabled) attributes.fastModeEnabled = fastModeEnabled;
        if (thinkDeeperEnabled) attributes.thinkDeeperEnabled = thinkDeeperEnabled;
        if (webSearchEnabled) attributes.webSearchEnabled = webSearchEnabled;
        if (conversationChannelId) attributes.conversationChannelId = conversationChannelId;
        if (assistanceServiceConfigMinionAlias) attributes.assistanceServiceConfigMinionAlias = assistanceServiceConfigMinionAlias;
        if (pageContext) attributes.pageContext = pageContext;
        if (scenarioId) attributes.scenarioId = scenarioId;
        if (viewContext) attributes.viewContext = viewContext;
        let libAttributes = {
            ...attributes,
            aiFeatureName: customAttributes?.aiFeatureName || 'aiChat',
            proactiveGeneratedAI: proactive ? 1 : 0
        };
        switch(payload.type){
            case 'initiated':
                trackAIInteractionInit({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'viewed':
                trackAIResultView({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId,
                    doesNotMeetMAUCriteria: doesNotMeetMAUCriteria
                });
                break;
            case 'error':
                trackAIResultError({
                    aiErrorMessage: payload.errorMessage
                }, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'dismissed':
                trackAIInteractionDismiss({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'actioned':
                {
                    const actionedPayload = payload;
                    trackAIResultAction(actionedPayload.actionResult, {
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
            case 'adopted':
                {
                    const adoptedPayload = payload;
                    trackAIResultAdopted(adoptedPayload.actionResult, {
                        attributes: {
                            ...libAttributes,
                            actionKey: adoptedPayload.actionKey,
                            rovoModifiedObjects: adoptedPayload.rovoModifiedObjects
                        },
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
            case 'feedback':
                {
                    const feedbackPayload = payload;
                    trackAIFeedbackSubmit(feedbackPayload.feedbackResult, {
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
        }
    // Handle specific AI MAU events
    }, [
        getDefaultAttributes,
        trackAIInteractionInit,
        trackAIResultView,
        trackAIResultError,
        trackAIInteractionDismiss,
        trackAIResultAction,
        trackAIResultAdopted,
        trackAIFeedbackSubmit
    ]);
    const sendAnalyticsEvent = (0, $euxye.useCallback)((payload, options)=>{
        const extraTags = options?.removeDefaultTags ? [] : $06f0a014b2aa50a7$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...'tags' in payload && Array.isArray(payload.tags) ? payload.tags : [],
            ...maybeAtlasOperationalTags(payload)
        ]));
        const defaultAttributes = getDefaultAttributes();
        // `UIAnalyticsEvent | undefined` because in SSR (no `<AnalyticsListener>`),
        // `createAnalyticsEvent` and `event.update(...)` may return `undefined` stubs.
        let eventToBeLoggedWithSentry;
        if ((0, $9xulT.isUIAnalyticsEvent)(payload)) {
            const aiMateContextAttributes = (0, $k7yqz.getAttributesFromContexts)(payload.context);
            // `payload.update(...)` can return `undefined` for stub events in SSR / no-listener
            // contexts. Fall back to the original event and guard `.fire` with optional chaining.
            const updatedEvent = payload.update({
                ...payload.payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    // `payload.payload` is typed as defined on a UIAnalyticsEvent, but during SSR
                    // (and other no-listener contexts) the underlying event can be a stub whose
                    // `payload` is `undefined`. Guard the spread so the subscriber does not throw
                    // `Cannot read properties of undefined (reading 'attributes')`.
                    ...payload.payload?.attributes ?? {},
                    ...aiMateContextAttributes
                }
            }) ?? payload;
            updatedEvent?.fire?.((0, $29Eij.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent;
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.attributes
                }
            });
            if (!event) // In SSR / no-listener environments, `createAnalyticsEvent` can return `undefined`.
            // Nothing to fire or log.
            return;
            const aiMateContextAttributes = (0, $k7yqz.getAttributesFromContexts)(event.context);
            // `event.update(...)` can return `undefined` for stub events in SSR / no-listener
            // contexts (previously crashed with `Cannot read properties of undefined (reading
            // 'fire')`). Fall back to the original event and guard `.fire` with optional chaining.
            const updatedEvent = event.update({
                attributes: {
                    // `event.payload` is normally defined when `createAnalyticsEvent` is wired up
                    // via `<AnalyticsListener>`, but in SSR (where no listener is mounted) the
                    // returned event can be a stub whose `payload` is `undefined`. Spreading
                    // without a guard previously crashed the ExperienceTracker subscriber with
                    // `Cannot read properties of undefined (reading 'attributes')`.
                    ...event.payload?.attributes ?? {},
                    ...aiMateContextAttributes
                }
            }) ?? event;
            updatedEvent?.fire?.((0, $29Eij.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent;
        }
        if (eventToBeLoggedWithSentry && eventToBeLoggedWithSentry.payload?.eventType !== 'operational') // choosing to log the event with Sentry if it is not an operational event to prevent noise in Sentry and not eat up the Sentry quota
        (0, $7lmdG.addSentryBreadcrumb)(`sendAnalyticsEvent event: ${JSON.stringify(eventToBeLoggedWithSentry)}`);
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        mode: mode
    };
};

});
parcelRegister("iK8G7", function(module, exports) {
$parcel$export(module.exports, "useAIEventsInstrumentation", () => $d16f84a759a8f5fe$export$ddf49ad062368ad2);

var $euxye = parcelRequire("euxye");

var $1kgyW = parcelRequire("1kgyW");

var $bHcfq = parcelRequire("bHcfq");

var $inMxE = parcelRequire("inMxE");

var $egspI = parcelRequire("egspI");

var $6TBsE = parcelRequire("6TBsE");

var $dadCo = parcelRequire("dadCo");

var $dlfu8 = parcelRequire("dlfu8");

var $iky4O = parcelRequire("iky4O");

var $bLGtO = parcelRequire("bLGtO");
const $d16f84a759a8f5fe$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $euxye.useContext)((0, $6TBsE.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $euxye.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $dadCo.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $bLGtO.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $euxye.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $1kgyW.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $iky4O.AISessionState).unset,
            nextState: (0, $1kgyW.P).union((0, $iky4O.AISessionState).viewed, (0, $iky4O.AISessionState).error, (0, $iky4O.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $iky4O.AISessionState).initiated,
            nextState: (0, $1kgyW.P).union((0, $iky4O.AISessionState).submitted, (0, $iky4O.AISessionState).actioned, (0, $iky4O.AISessionState).adopted, (0, $iky4O.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $euxye.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $bHcfq.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $euxye.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $1kgyW.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $dlfu8.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $1kgyW.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $1kgyW.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $euxye.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iky4O.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $euxye.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iky4O.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $euxye.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $iky4O.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $euxye.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iky4O.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $euxye.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iky4O.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $euxye.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iky4O.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $euxye.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iky4O.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $euxye.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $iky4O.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $euxye.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    const baseReturn = {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
    // Each `useCallback` above depends on `createAndMergeEventPayload`, which in
    // turn closes over per-render config values (e.g. `additionalAttributes`
    // passed via `customConfig`). When callers spread fresh literals on every
    // render, those callbacks get fresh identities every render too. Consumers
    // that feed them into their own `useCallback` / `useEffect` deps then suffer
    // spurious re-runs — and combined with functional state updaters, this can
    // drive infinite render loops (see Jira CRCS-4870 / OOM regression).
    //
    // Stabilise the entire return surface behind a feature gate.
    const stableReturn = $d16f84a759a8f5fe$var$useStableMethods(baseReturn);
    return (0, $egspI.fg)('platform_ai_analytics_stable_handler_refs') ? stableReturn : baseReturn;
};
/**
 * Returns an object with the same shape as `methods`, but with every method
 * replaced by a stable wrapper that delegates to the latest version. The
 * wrappers are created once on mount; they always read the freshest closure
 * via a ref, so calls observe the same behaviour as calling the unstable
 * methods directly.
 */ function $d16f84a759a8f5fe$var$useStableMethods(methods) {
    const ref = (0, $euxye.useRef)(methods);
    ref.current = methods;
    return (0, $euxye.useMemo)(()=>{
        const out = {};
        for (const key of Object.keys(ref.current))out[key] = (...args)=>ref.current[key](...args);
        return out;
    // Wrappers always read from `ref.current`; no deps needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});
parcelRegister("1kgyW", function(module, exports) {
$parcel$export(module.exports, "P", () => $0f7481b2dd755655$export$56c0d5a1e737357d);
$parcel$export(module.exports, "match", () => $0f7481b2dd755655$export$4659b591c19bdf3d);
const $0f7481b2dd755655$var$t = Symbol.for("@ts-pattern/matcher"), $0f7481b2dd755655$var$e = Symbol.for("@ts-pattern/isVariadic"), $0f7481b2dd755655$var$n = "@ts-pattern/anonymous-select-key", $0f7481b2dd755655$var$r = (t)=>Boolean(t && "object" == typeof t), $0f7481b2dd755655$var$i = (e)=>e && !!e[$0f7481b2dd755655$var$t], $0f7481b2dd755655$var$o = (n, s, c)=>{
    if ($0f7481b2dd755655$var$i(n)) {
        const e = n[$0f7481b2dd755655$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($0f7481b2dd755655$var$r(n)) {
        if (!$0f7481b2dd755655$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $0f7481b2dd755655$var$i(s) && s[$0f7481b2dd755655$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$0f7481b2dd755655$var$o(t, e[n], c)) && r.every((t, e)=>$0f7481b2dd755655$var$o(t, n[e], c)) && (0 === a.length || $0f7481b2dd755655$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$0f7481b2dd755655$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $0f7481b2dd755655$var$i(a = r) && "optional" === a[$0f7481b2dd755655$var$t]().matcherType) && $0f7481b2dd755655$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $0f7481b2dd755655$var$s = (e)=>{
    var n, o, a;
    return $0f7481b2dd755655$var$r(e) ? $0f7481b2dd755655$var$i(e) ? null != (n = null == (o = (a = e[$0f7481b2dd755655$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $0f7481b2dd755655$var$c(e, $0f7481b2dd755655$var$s) : $0f7481b2dd755655$var$c(Object.values(e), $0f7481b2dd755655$var$s) : [];
}, $0f7481b2dd755655$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $0f7481b2dd755655$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$0f7481b2dd755655$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $0f7481b2dd755655$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $0f7481b2dd755655$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$0f7481b2dd755655$var$l(t),
        and: (e)=>$0f7481b2dd755655$var$m(t, e),
        or: (e)=>$0f7481b2dd755655$var$d(t, e),
        select: (e)=>void 0 === e ? $0f7481b2dd755655$var$y(t) : $0f7481b2dd755655$var$y(e, t)
    });
}
function $0f7481b2dd755655$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$0f7481b2dd755655$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$0f7481b2dd755655$var$h($0f7481b2dd755655$var$l(t)),
        select: (e)=>$0f7481b2dd755655$var$h(void 0 === e ? $0f7481b2dd755655$var$y(t) : $0f7481b2dd755655$var$y(e, t))
    });
}
function $0f7481b2dd755655$var$l(e) {
    return $0f7481b2dd755655$var$u({
        [$0f7481b2dd755655$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($0f7481b2dd755655$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $0f7481b2dd755655$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$0f7481b2dd755655$var$s(e),
                matcherType: "optional"
            })
    });
}
const $0f7481b2dd755655$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $0f7481b2dd755655$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $0f7481b2dd755655$var$m(...e) {
    return $0f7481b2dd755655$var$u({
        [$0f7481b2dd755655$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$0f7481b2dd755655$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$0f7481b2dd755655$var$c(e, $0f7481b2dd755655$var$s),
                matcherType: "and"
            })
    });
}
function $0f7481b2dd755655$var$d(...e) {
    return $0f7481b2dd755655$var$u({
        [$0f7481b2dd755655$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $0f7481b2dd755655$var$c(e, $0f7481b2dd755655$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$0f7481b2dd755655$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$0f7481b2dd755655$var$c(e, $0f7481b2dd755655$var$s),
                matcherType: "or"
            })
    });
}
function $0f7481b2dd755655$var$p(e) {
    return {
        [$0f7481b2dd755655$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $0f7481b2dd755655$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $0f7481b2dd755655$var$u({
        [$0f7481b2dd755655$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $0f7481b2dd755655$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $0f7481b2dd755655$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $0f7481b2dd755655$var$n
                    ].concat(void 0 === i ? [] : $0f7481b2dd755655$var$s(i))
            })
    });
}
function $0f7481b2dd755655$var$v(t) {
    return "number" == typeof t;
}
function $0f7481b2dd755655$var$b(t) {
    return "string" == typeof t;
}
function $0f7481b2dd755655$var$w(t) {
    return "bigint" == typeof t;
}
const $0f7481b2dd755655$var$S = $0f7481b2dd755655$var$u($0f7481b2dd755655$var$p(function(t) {
    return !0;
})), $0f7481b2dd755655$var$O = $0f7481b2dd755655$var$S, $0f7481b2dd755655$var$j = (t)=>Object.assign($0f7481b2dd755655$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $0f7481b2dd755655$var$j($0f7481b2dd755655$var$m(t, (n = e, $0f7481b2dd755655$var$p((t)=>$0f7481b2dd755655$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $0f7481b2dd755655$var$j($0f7481b2dd755655$var$m(t, (n = e, $0f7481b2dd755655$var$p((t)=>$0f7481b2dd755655$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$0f7481b2dd755655$var$j($0f7481b2dd755655$var$m(t, ((t)=>$0f7481b2dd755655$var$p((e)=>$0f7481b2dd755655$var$b(e) && e.length >= t))(e))),
        length: (e)=>$0f7481b2dd755655$var$j($0f7481b2dd755655$var$m(t, ((t)=>$0f7481b2dd755655$var$p((e)=>$0f7481b2dd755655$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$0f7481b2dd755655$var$j($0f7481b2dd755655$var$m(t, ((t)=>$0f7481b2dd755655$var$p((e)=>$0f7481b2dd755655$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $0f7481b2dd755655$var$j($0f7481b2dd755655$var$m(t, (n = e, $0f7481b2dd755655$var$p((t)=>$0f7481b2dd755655$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $0f7481b2dd755655$var$j($0f7481b2dd755655$var$m(t, (n = e, $0f7481b2dd755655$var$p((t)=>$0f7481b2dd755655$var$b(t) && Boolean(t.match(n))))));
        }
    }), $0f7481b2dd755655$var$K = $0f7481b2dd755655$var$j($0f7481b2dd755655$var$p($0f7481b2dd755655$var$b)), $0f7481b2dd755655$var$x = (t)=>Object.assign($0f7481b2dd755655$var$u(t), {
        between: (e, n)=>$0f7481b2dd755655$var$x($0f7481b2dd755655$var$m(t, ((t, e)=>$0f7481b2dd755655$var$p((n)=>$0f7481b2dd755655$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$0f7481b2dd755655$var$x($0f7481b2dd755655$var$m(t, ((t)=>$0f7481b2dd755655$var$p((e)=>$0f7481b2dd755655$var$v(e) && e < t))(e))),
        gt: (e)=>$0f7481b2dd755655$var$x($0f7481b2dd755655$var$m(t, ((t)=>$0f7481b2dd755655$var$p((e)=>$0f7481b2dd755655$var$v(e) && e > t))(e))),
        lte: (e)=>$0f7481b2dd755655$var$x($0f7481b2dd755655$var$m(t, ((t)=>$0f7481b2dd755655$var$p((e)=>$0f7481b2dd755655$var$v(e) && e <= t))(e))),
        gte: (e)=>$0f7481b2dd755655$var$x($0f7481b2dd755655$var$m(t, ((t)=>$0f7481b2dd755655$var$p((e)=>$0f7481b2dd755655$var$v(e) && e >= t))(e))),
        int: ()=>$0f7481b2dd755655$var$x($0f7481b2dd755655$var$m(t, $0f7481b2dd755655$var$p((t)=>$0f7481b2dd755655$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$0f7481b2dd755655$var$x($0f7481b2dd755655$var$m(t, $0f7481b2dd755655$var$p((t)=>$0f7481b2dd755655$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$0f7481b2dd755655$var$x($0f7481b2dd755655$var$m(t, $0f7481b2dd755655$var$p((t)=>$0f7481b2dd755655$var$v(t) && t > 0))),
        negative: ()=>$0f7481b2dd755655$var$x($0f7481b2dd755655$var$m(t, $0f7481b2dd755655$var$p((t)=>$0f7481b2dd755655$var$v(t) && t < 0)))
    }), $0f7481b2dd755655$var$E = $0f7481b2dd755655$var$x($0f7481b2dd755655$var$p($0f7481b2dd755655$var$v)), $0f7481b2dd755655$var$A = (t)=>Object.assign($0f7481b2dd755655$var$u(t), {
        between: (e, n)=>$0f7481b2dd755655$var$A($0f7481b2dd755655$var$m(t, ((t, e)=>$0f7481b2dd755655$var$p((n)=>$0f7481b2dd755655$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$0f7481b2dd755655$var$A($0f7481b2dd755655$var$m(t, ((t)=>$0f7481b2dd755655$var$p((e)=>$0f7481b2dd755655$var$w(e) && e < t))(e))),
        gt: (e)=>$0f7481b2dd755655$var$A($0f7481b2dd755655$var$m(t, ((t)=>$0f7481b2dd755655$var$p((e)=>$0f7481b2dd755655$var$w(e) && e > t))(e))),
        lte: (e)=>$0f7481b2dd755655$var$A($0f7481b2dd755655$var$m(t, ((t)=>$0f7481b2dd755655$var$p((e)=>$0f7481b2dd755655$var$w(e) && e <= t))(e))),
        gte: (e)=>$0f7481b2dd755655$var$A($0f7481b2dd755655$var$m(t, ((t)=>$0f7481b2dd755655$var$p((e)=>$0f7481b2dd755655$var$w(e) && e >= t))(e))),
        positive: ()=>$0f7481b2dd755655$var$A($0f7481b2dd755655$var$m(t, $0f7481b2dd755655$var$p((t)=>$0f7481b2dd755655$var$w(t) && t > 0))),
        negative: ()=>$0f7481b2dd755655$var$A($0f7481b2dd755655$var$m(t, $0f7481b2dd755655$var$p((t)=>$0f7481b2dd755655$var$w(t) && t < 0)))
    }), $0f7481b2dd755655$var$P = $0f7481b2dd755655$var$A($0f7481b2dd755655$var$p($0f7481b2dd755655$var$w)), $0f7481b2dd755655$var$T = $0f7481b2dd755655$var$u($0f7481b2dd755655$var$p(function(t) {
    return "boolean" == typeof t;
})), $0f7481b2dd755655$var$B = $0f7481b2dd755655$var$u($0f7481b2dd755655$var$p(function(t) {
    return "symbol" == typeof t;
})), $0f7481b2dd755655$var$_ = $0f7481b2dd755655$var$u($0f7481b2dd755655$var$p(function(t) {
    return null == t;
})), $0f7481b2dd755655$var$k = $0f7481b2dd755655$var$u($0f7481b2dd755655$var$p(function(t) {
    return null != t;
}));
var $0f7481b2dd755655$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $0f7481b2dd755655$var$t,
    optional: $0f7481b2dd755655$var$l,
    array: function(...e) {
        return $0f7481b2dd755655$var$h({
            [$0f7481b2dd755655$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $0f7481b2dd755655$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$0f7481b2dd755655$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $0f7481b2dd755655$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $0f7481b2dd755655$var$u({
            [$0f7481b2dd755655$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $0f7481b2dd755655$var$f(t, (t)=>$0f7481b2dd755655$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $0f7481b2dd755655$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $0f7481b2dd755655$var$u({
            [$0f7481b2dd755655$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $0f7481b2dd755655$var$g(t, (t, e)=>{
                                const n = $0f7481b2dd755655$var$o(s, e, r), i = $0f7481b2dd755655$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$0f7481b2dd755655$var$s(e[0]),
                            ...$0f7481b2dd755655$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $0f7481b2dd755655$var$m,
    union: $0f7481b2dd755655$var$d,
    not: function(e) {
        return $0f7481b2dd755655$var$u({
            [$0f7481b2dd755655$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$0f7481b2dd755655$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $0f7481b2dd755655$var$p,
    select: $0f7481b2dd755655$var$y,
    any: $0f7481b2dd755655$var$S,
    _: $0f7481b2dd755655$var$O,
    string: $0f7481b2dd755655$var$K,
    number: $0f7481b2dd755655$var$E,
    bigint: $0f7481b2dd755655$var$P,
    boolean: $0f7481b2dd755655$var$T,
    symbol: $0f7481b2dd755655$var$B,
    nullish: $0f7481b2dd755655$var$_,
    nonNullable: $0f7481b2dd755655$var$k,
    instanceOf: function(t) {
        return $0f7481b2dd755655$var$u($0f7481b2dd755655$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $0f7481b2dd755655$var$u($0f7481b2dd755655$var$p($0f7481b2dd755655$export$ce1e7a33533a73d9(t)));
    }
};
class $0f7481b2dd755655$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $0f7481b2dd755655$var$$ = {
    matched: !1,
    value: void 0
};
function $0f7481b2dd755655$export$4659b591c19bdf3d(t) {
    return new $0f7481b2dd755655$var$I(t, $0f7481b2dd755655$var$$);
}
class $0f7481b2dd755655$var$I {
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$0f7481b2dd755655$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $0f7481b2dd755655$var$$ : {
            matched: !0,
            value: e(s ? $0f7481b2dd755655$var$n in c ? c[$0f7481b2dd755655$var$n] : c : this.input, this.input)
        };
        return new $0f7481b2dd755655$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $0f7481b2dd755655$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $0f7481b2dd755655$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $0f7481b2dd755655$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
}
function $0f7481b2dd755655$var$L(t) {
    throw new $0f7481b2dd755655$export$6c1467edb54d3773(t);
}

});

parcelRegister("6TBsE", function(module, exports) {
$parcel$export(module.exports, "AIEventsInstrumentationContext", () => $e9e53a6bf54c4715$export$4f059feb37b5835e);

var $euxye = parcelRequire("euxye");
const $e9e53a6bf54c4715$export$4f059feb37b5835e = (0, $euxye.createContext)(null);

});

parcelRegister("dadCo", function(module, exports) {
$parcel$export(module.exports, "defaultAIEventsInstrumentationConfigValues", () => $3d872bd1936e91d5$export$5013b36eeed4ec19);

var $iky4O = parcelRequire("iky4O");
const $3d872bd1936e91d5$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $iky4O.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};

});
parcelRegister("iky4O", function(module, exports) {
$parcel$export(module.exports, "AISessionState", () => $1d5059f1f3bb054a$export$af92e0e920a45719);
$parcel$export(module.exports, "EventDispatcherSources", () => $1d5059f1f3bb054a$export$7052d5b66e36f60f);
var $1d5059f1f3bb054a$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $1d5059f1f3bb054a$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});

});


parcelRegister("dlfu8", function(module, exports) {
$parcel$export(module.exports, "getTagsWithPlatformTag", () => $bbafb1c7c2edeaff$export$e053e424fcbfebe9);
const $bbafb1c7c2edeaff$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};

});

parcelRegister("bLGtO", function(module, exports) {
$parcel$export(module.exports, "useAIInstrumentationSetup", () => $a2a86788eb29a604$export$259576f4e7ac6488);

var $euxye = parcelRequire("euxye");

var $gjU6m = parcelRequire("gjU6m");

var $38q3o = parcelRequire("38q3o");

var $iky4O = parcelRequire("iky4O");
const $a2a86788eb29a604$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $euxye.useRef)(undefined);
    const aiSessionStateRef = (0, $euxye.useRef)((0, $iky4O.AISessionState).unset);
    const setAISessionState = (0, $euxye.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $euxye.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $euxye.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $gjU6m.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $38q3o.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $euxye.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $38q3o.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};

});
parcelRegister("gjU6m", function(module, exports) {
$parcel$export(module.exports, "getNewSingleInstrumentationID", () => $a0a4fbd175ac9f47$export$cee2a1482be61648);

var $1kgyW = parcelRequire("1kgyW");

var $6IpLl = parcelRequire("6IpLl");
function $a0a4fbd175ac9f47$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $1kgyW.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $1kgyW.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $1kgyW.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6IpLl)))());
}

});

parcelRegister("38q3o", function(module, exports) {
$parcel$export(module.exports, "setSingleInstrumentationIDCookie", () => $3942aa48318c5303$export$9a4eaf99327c19fe);
$parcel$export(module.exports, "readSingleInstrumentationIDCookie", () => $3942aa48318c5303$export$d6fb1caea334c7c7);

var $37LBQ = parcelRequire("37LBQ");
var $hgR5s = parcelRequire("hgR5s");
const $3942aa48318c5303$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $3942aa48318c5303$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $3942aa48318c5303$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $hgR5s.setCookie)($3942aa48318c5303$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $3942aa48318c5303$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $37LBQ.getCookie)($3942aa48318c5303$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $3942aa48318c5303$export$72d8c154d3f75075;

});
parcelRegister("hgR5s", function(module, exports) {
$parcel$export(module.exports, "setCookie", () => $a9eb4121b9207d5e$export$110700823644f4a6);

var $lO5Ez = parcelRequire("lO5Ez");

var $egspI = parcelRequire("egspI");

var $c1I7W = parcelRequire("c1I7W");
var $2rFtA = parcelRequire("2rFtA");

var $bDj2g = parcelRequire("bDj2g");

var $j1sAG = parcelRequire("j1sAG");

var $5MrbU = parcelRequire("5MrbU");
const $a9eb4121b9207d5e$export$110700823644f4a6 = async (key, value, attributes)=>{
    if ((0, $egspI.fg)('platform_moonjelly_bsc_master_killswitch')) {
        // Set the cookie without checking user preferences
        // when master killswitch is enabled
        (0, $lO5Ez.default).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
        return (0, $5MrbU.Status).SUCCESS;
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    const productName = (0, $c1I7W.getBscGlobalState)().product;
    const wasInitialized = (0, $c1I7W.getBscGlobalState)().hasInitialized;
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    let blockedCookieItemCategory;
    const shouldSetCookie = await (0, $bDj2g.isProcessingAllowedByPreferences)({
        itemKey: key,
        storageType: (0, $5MrbU.CategoryStorageType).Cookies,
        productName: productName,
        blockedCallback: ({ itemCategory: itemCategory })=>{
            blockedCookieItemCategory = itemCategory;
        }
    });
    const eventAttributes = {
        wasRejected: !shouldSetCookie,
        cookieKey: key
    };
    try {
        (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'usedSetCookie',
            attributes: eventAttributes
        });
        if (!wasInitialized && (0, $egspI.fg)('platform_bsc_initialize_controls_analytics')) (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: 'Cookie'
            }
        });
        if (shouldSetCookie) {
            (0, $lO5Ez.default).set(key, value, {
                ...attributes,
                'atl-set-cookie': true
            });
            return (0, $5MrbU.Status).SUCCESS;
        } else {
            if (blockedCookieItemCategory === null) (0, $j1sAG.Logger).warn(`setCookie('${key}', ...) was blocked` + `${productName ? ` for product "${productName}"` : ''}` + `: '${key}' is not registered in the BSC data store. Add it to the data store before calling this API.`);
            return (0, $5MrbU.Status).BLOCKED;
        }
    } catch (e) {
        (0, $j1sAG.Logger).errorWithOperationalEvent({
            action: 'usedSetCookieError',
            attributes: eventAttributes,
            message: `Failed to use set cookie. ${e.message || ''}`
        });
        return (0, $5MrbU.Status).BLOCKED;
    }
};

});




parcelRegister("7lmdG", function(module, exports) {
$parcel$export(module.exports, "setupSentryClient", () => $8f6088d3121a7602$export$d8bd0edf6c978788);
$parcel$export(module.exports, "logException", () => $8f6088d3121a7602$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "addSentryBreadcrumb", () => $8f6088d3121a7602$export$de29810e0b4aa46e);

var $97qmU = parcelRequire("97qmU");

var $dcAPc = parcelRequire("dcAPc");

var $56DBy = parcelRequire("56DBy");

var $8SSGd = parcelRequire("8SSGd");

// importing local file instead of from '@sentry/browser' otherwise there will be typescript errors
const $8f6088d3121a7602$var$importSentryAsync = async ()=>(parcelRequire("ffPQB"));
let $8f6088d3121a7602$var$sentryClient;
let $8f6088d3121a7602$var$accountIdPromise;
const $8f6088d3121a7602$var$defaultAccountIdProvider = ()=>new Promise((resolve, reject)=>{
        (0, $97qmU.performHttpFetch)({
            path: '/gateway/api/me',
            options: {
                method: 'GET'
            }
        }).then((profileData)=>{
            if (profileData?.account_id) resolve(profileData.account_id);
            else reject(new Error('Profile data not loaded'));
        }).catch((error)=>{
            reject(error);
        });
    });
let $8f6088d3121a7602$var$accountIdProvider = $8f6088d3121a7602$var$defaultAccountIdProvider;
const $8f6088d3121a7602$export$59333a3d3d770a30 = (fn)=>{
    $8f6088d3121a7602$var$accountIdProvider = fn;
    $8f6088d3121a7602$var$accountIdPromise = undefined;
};
const $8f6088d3121a7602$export$e941c8ce80d1ac70 = ()=>{
    $8f6088d3121a7602$var$accountIdProvider = $8f6088d3121a7602$var$defaultAccountIdProvider;
    $8f6088d3121a7602$var$accountIdPromise = undefined;
};
// copied from platform/packages/people-and-teams/teams-client/src/services/sentry/utils/initialise-sentry.ts
const $8f6088d3121a7602$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
const $8f6088d3121a7602$var$getEnvironment = ()=>{
    return 'production';
};
const $8f6088d3121a7602$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride, ignoreErrors: ignoreErrors, packageVersion: packageVersion } = {})=>{
    let accountId = 'UNKNOWN_AAID';
    let product = productOverride ?? (0, $56DBy.getRovoChatProduct)();
    try {
        if (!$8f6088d3121a7602$var$accountIdPromise) $8f6088d3121a7602$var$accountIdPromise = $8f6088d3121a7602$var$accountIdProvider();
        accountId = await $8f6088d3121a7602$var$accountIdPromise;
    } catch  {
    // do nothing
    }
    if ($8f6088d3121a7602$var$sentryClient) {
        // if sentry is trying to be initialized again with new product or account id
        // update the user and tags
        $8f6088d3121a7602$var$sentryClient.setTag('product', product);
        $8f6088d3121a7602$var$sentryClient.setUser({
            id: accountId
        });
        // do not initialise sentry again, only update the existing one
        return;
    }
    let importedSentry;
    try {
        importedSentry = await $8f6088d3121a7602$var$importSentryAsync();
    } catch (e) {
        console.warn('Failed to load conversation-assistant sentry', e); // eslint-disable-line no-console
        return;
    }
    // https://atlassian-2y.sentry.io/projects/ai-mate-conversation-assistant/getting-started/
    const defaultSentryDsn = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
    try {
        importedSentry.init({
            dsn: customSentryDsn || defaultSentryDsn,
            environment: $8f6088d3121a7602$var$getEnvironment(),
            integrations: (integrations)=>{
                return integrations.filter((integration)=>{
                    return $8f6088d3121a7602$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
                });
            },
            initialScope: {
                user: {
                    id: accountId
                },
                tags: {
                    packageName: packageName || '@atlassian/conversation-assistant',
                    product: product,
                    packageVersion: packageVersion
                }
            },
            // referencing jira/src/packages/platform/observability/errors-handling/src/utils/sentry/handling/normalise-sentry-event.tsx
            beforeSend: (event, hint)=>{
                const exception = hint?.originalException;
                // Ignore network-like errors
                if ((0, $dcAPc.isClientFetchError)(exception)) return null;
                if (!event.tags?.name) // we only want to capture errors that has `name` tag from `logException` function below
                // since the `DISABLED_INTEGRATIONS` filter above is not enough to prevent unhandled errors
                return null;
                let updatedEvent = event;
                if (updatedEvent.request?.url) {
                    // Ignore events from localhost and staging
                    if (updatedEvent.request.url.includes('localhost') || updatedEvent.request.url.includes('jira-dev.com') || updatedEvent.request.url.includes('stg.atlassian.com') || updatedEvent.request.url.includes('stg.internal.atlassian.com') || updatedEvent.request.url.includes('stg-east.frontend.public.atl-paas.net')) return null;
                    updatedEvent.request.url = (0, $8SSGd.normaliseUrl)(updatedEvent.request.url);
                }
                if (updatedEvent.exception?.values) {
                    const allMatchedUUIDs = [];
                    updatedEvent.exception.values = updatedEvent.exception.values.map((exception)=>{
                        const { normalized: normalized, matchedUUIDs: matchedUUIDs } = (0, $8SSGd.normalizeUUID)(exception.value);
                        allMatchedUUIDs.push(...matchedUUIDs);
                        return {
                            ...exception,
                            value: normalized
                        };
                    });
                    if (allMatchedUUIDs.length > 0) {
                        if (!updatedEvent.tags) updatedEvent.tags = {};
                        updatedEvent.tags.matchedUUID = JSON.stringify(allMatchedUUIDs);
                    }
                }
                return updatedEvent;
            },
            attachStacktrace: true,
            ignoreErrors: ignoreErrors
        });
    } catch (error) {
        // this function throws e.update is not a function errors when we have a mismatch in sentry versions.
        // all targeted errors include 'update is not a function' even if minified differently
        if (error instanceof Error && error.message.includes('update is not a function')) ;
        else throw error;
    }
    $8f6088d3121a7602$var$sentryClient = importedSentry;
};
const $8f6088d3121a7602$var$getSentryClient = async ()=>{
    if (!$8f6088d3121a7602$var$sentryClient) // this only happens if something using sentry before the initialisation in root app
    await $8f6088d3121a7602$export$d8bd0edf6c978788();
    return $8f6088d3121a7602$var$sentryClient;
};
const $8f6088d3121a7602$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    const sentryClient = await $8f6088d3121a7602$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        scope.setTag('name', name);
        if (tags) scope.setTags(tags);
        if (tags?.source === 'aiMateExperienceTracker') scope.setTag('experience', name);
        try {
            sentryClient.captureException(exception, scope);
        } catch (error) {
        // this function throws e.update is not a function errors when we have a mismatch in sentry versions. Instead of throwing and logging the error to sentry, swallow it.
        // TODO: upgrade sentry across confluence, jira, etc. to the same version to avoid this error
        }
    });
};
async function $8f6088d3121a7602$export$de29810e0b4aa46e(crumb) {
    const sentryClient = await $8f6088d3121a7602$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.addBreadcrumb !== 'function') return;
    sentryClient.addBreadcrumb(typeof crumb === 'string' ? {
        message: crumb
    } : crumb);
}

});
parcelRegister("97qmU", function(module, exports) {
$parcel$export(module.exports, "getTraceIdFromResponse", () => $569fdb68f57cb62e$export$9f229e40eb65abfc);
$parcel$export(module.exports, "FetchError", () => $569fdb68f57cb62e$export$26e841bcf1aeb894);
$parcel$export(module.exports, "performHttpFetch", () => $569fdb68f57cb62e$export$a38d93aa782475f6);
const $569fdb68f57cb62e$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $569fdb68f57cb62e$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $569fdb68f57cb62e$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $569fdb68f57cb62e$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $569fdb68f57cb62e$var$processHttpErrorResponse({
            response: response
        });
        return await response.json();
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        const statusCode = err instanceof $569fdb68f57cb62e$var$HttpApiError ? err?.errorAttributes?.statusCode : undefined;
        throw new $569fdb68f57cb62e$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $569fdb68f57cb62e$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $569fdb68f57cb62e$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $569fdb68f57cb62e$export$9f229e40eb65abfc(response)
    });
};

});

parcelRegister("dcAPc", function(module, exports) {
$parcel$export(module.exports, "isClientFetchError", () => $ae36122545470810$export$2e7adc44463c3f4f);
$parcel$export(module.exports, "isAuthOrPermissionError", () => $ae36122545470810$export$de229d5c9394f905);
$parcel$export(module.exports, "isProductNotActiveError", () => $ae36122545470810$export$9f0dca42eff14720);

var $hcNg4 = parcelRequire("hcNg4");
// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Issues we are not gonna track in Sentry
const $ae36122545470810$var$KNOWN_NETWORK_ERRORS_LIMITED = [
    'server with the specified hostname could not be found',
    'connection failure',
    'Failed to fetch',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted'
];
const $ae36122545470810$var$isClientFetchErrorMessage = (message)=>{
    const errorTypes = $ae36122545470810$var$KNOWN_NETWORK_ERRORS_LIMITED;
    return Boolean(message) && !!errorTypes.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
};
const $ae36122545470810$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $ae36122545470810$export$2e7adc44463c3f4f = (error)=>{
    if (!(0, $hcNg4.isRecord)(error)) return false;
    // Check top-level error name and message
    const hasKnownName = typeof error.name === 'string' && $ae36122545470810$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name);
    const hasKnownMessage = typeof error.message === 'string' && $ae36122545470810$var$isClientFetchErrorMessage(error.message);
    if (hasKnownName || hasKnownMessage) return true;
    // Also check the nested cause (e.g. wrapped fetch errors)
    if (!(0, $hcNg4.isRecord)(error.cause)) return false;
    return typeof error.cause.name === 'string' && $ae36122545470810$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || typeof error.cause.message === 'string' && $ae36122545470810$var$isClientFetchErrorMessage(error.cause.message);
};
const $ae36122545470810$export$de229d5c9394f905 = (error)=>{
    if (!(0, $hcNg4.isRecord)(error)) return false;
    // RovoInstrumentedError shape
    const errorAttributes = (0, $hcNg4.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    const statusFromAttributes = errorAttributes?.statusCode;
    // Direct status on error
    const attributes = (0, $hcNg4.isRecord)(error.attributes) ? error.attributes : undefined;
    const statusDirect = error.status ?? attributes?.status;
    const status = statusFromAttributes ?? statusDirect;
    return status === 401 || status === 403;
};
const $ae36122545470810$export$9f0dca42eff14720 = (error)=>{
    if (!(0, $hcNg4.isRecord)(error)) return false;
    const errorAttributes = (0, $hcNg4.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    const errorCode = typeof errorAttributes?.errorCode === 'string' ? errorAttributes.errorCode.toLowerCase() : '';
    return errorCode.includes('product.not.active') || errorCode.includes('product_not_active');
};

});
parcelRegister("hcNg4", function(module, exports) {
$parcel$export(module.exports, "isRecord", () => $5774c2e9d1b7bc28$export$6ba840931da50680);
/**
 * Type guard that checks whether a value is a plain record object.
 */ const $5774c2e9d1b7bc28$export$6ba840931da50680 = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);

});


parcelRegister("56DBy", function(module, exports) {
$parcel$export(module.exports, "getRovoChatProduct", () => $d45519e62df8990d$export$d4fdfa93c283ffc);
const $d45519e62df8990d$export$d4fdfa93c283ffc = ()=>{
    let product = 'UNKNOWN';
    const win = window;
    if (win.__ROVO_CHAT_CONFIG_PRODUCT__) product = win.__ROVO_CHAT_CONFIG_PRODUCT__;
    return product;
};

});

parcelRegister("8SSGd", function(module, exports) {
$parcel$export(module.exports, "normaliseUrl", () => $1eadbd0ba310cbec$export$d57ae76c6dc57a5);
$parcel$export(module.exports, "normalizeUUID", () => $1eadbd0ba310cbec$export$5efaf8444170fe75);
const $1eadbd0ba310cbec$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $1eadbd0ba310cbec$var$ATLAS_HOST = 'home.atlassian.com';
const $1eadbd0ba310cbec$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $1eadbd0ba310cbec$var$UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $1eadbd0ba310cbec$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $1eadbd0ba310cbec$var$ATLAS_HOST || parsedUrl.host === $1eadbd0ba310cbec$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$1eadbd0ba310cbec$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};
const $1eadbd0ba310cbec$export$5efaf8444170fe75 = (str)=>{
    if (!str) return {
        normalized: '',
        matchedUUIDs: []
    };
    const matchedUUIDs = str.match($1eadbd0ba310cbec$var$UUID_REGEX) || [];
    const normalized = str.replace($1eadbd0ba310cbec$var$UUID_REGEX, '{uuid}');
    return {
        normalized: normalized,
        matchedUUIDs: matchedUUIDs
    };
};

});

parcelRegister("ffPQB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("c7lJf").then(()=>parcelRequire('aJr84'));

});


parcelRegister("kh2v5", function(module, exports) {
$parcel$export(module.exports, "AI_MATE_ATTRIBUTES", () => $48c1f478d091f08f$export$8cffc8b2c93affd4);
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $48c1f478d091f08f$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    agentIsVerified: 'agentIsVerified',
    conversationChannelId: 'conversationChannelId',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    mode: 'mode',
    product: 'product',
    productHeader: 'productHeader',
    inProductExperience: 'inProductExperience',
    singleInstrumentationID: 'singleInstrumentationID',
    sharedFeaturesInstrumentationId: 'sharedFeaturesInstrumentationId',
    assistanceServiceConfigMinionAlias: 'assistanceServiceConfigMinionAlias',
    skillSelectionSource: 'skillSelectionSource'
};

});

parcelRegister("29Eij", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $32b4119c6aa9319c$export$85183a312807388d);
$parcel$export(module.exports, "SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE", () => $32b4119c6aa9319c$export$e86f3aae41de8a7);
$parcel$export(module.exports, "REMIX_INTERACTION_SOURCES", () => $32b4119c6aa9319c$export$5a1bc70923e441e9);
$parcel$export(module.exports, "AUTOSUGGEST_SOURCE", () => $32b4119c6aa9319c$export$406073150b1a408);

var $bHcfq = parcelRequire("bHcfq");
const $32b4119c6aa9319c$export$85183a312807388d = (0, $bHcfq.FabricChannel).aiMate;
const $32b4119c6aa9319c$var$REMIX_SOURCES = [
    'remix',
    'inlineRovoFromRemix',
    'remixModalFromToolbar',
    'remixModalFromBlockControls',
    'remixModalFromBlockMenu',
    'remixModalFromFloatingToolbar',
    'remixModalFromViewPageFloatingToolbar',
    'remixModalFromViewPageNudge',
    'remixModalFromNudge',
    'remixModalFromObjectLevelSidebar',
    'remixModalFromPasteMenu',
    'remixStagingArea',
    'remixModalFromMediaInserts'
];
const $32b4119c6aa9319c$export$e86f3aae41de8a7 = 'smartLinkRovoButton';
const $32b4119c6aa9319c$export$5a1bc70923e441e9 = new Set($32b4119c6aa9319c$var$REMIX_SOURCES);
var $32b4119c6aa9319c$export$406073150b1a408 = /*#__PURE__*/ function(AUTOSUGGEST_SOURCE) {
    AUTOSUGGEST_SOURCE["ROVO_CHAT"] = "rovo-chat";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC"] = "confluence-aifc";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_SLIDES"] = "confluence-aifc-slides";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_WHITEBOARD"] = "confluence-aifc-whiteboard";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_DATABASE"] = "confluence-aifc-database";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_LIVE_DOC"] = "confluence-aifc-live-doc";
    return AUTOSUGGEST_SOURCE;
}({});

});

parcelRegister("k7yqz", function(module, exports) {
$parcel$export(module.exports, "getAttributesFromContexts", () => $2f320d9d3314065d$export$d97c97ed77ff09e8);

var $5ySJg = parcelRequire("5ySJg");

var $iyM4S = parcelRequire("iyM4S");
const $2f320d9d3314065d$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return (0, $iyM4S.ALLOWED_AI_MATE_SOURCES).includes(x.source);
};
const $2f320d9d3314065d$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let contextsThatHaveAttributes = context.filter((x)=>$2f320d9d3314065d$var$isSourceAndAttributes(x) || x[0, $5ySJg.AI_MATE_CONTEXT]);
    return contextsThatHaveAttributes.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $5ySJg.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};

});
parcelRegister("iyM4S", function(module, exports) {
$parcel$export(module.exports, "ALLOWED_AI_MATE_SOURCES", () => $81c9e9efb904a076$export$e31e24b63b7085fd);
const $81c9e9efb904a076$export$e31e24b63b7085fd = [
    'AIMate',
    'smart-create',
    'CSMAI',
    'CSMAIEmbed',
    'rovoServiceAgent',
    'solutionComposer'
];

});



parcelRegister("fZQSX", function(module, exports) {
$parcel$export(module.exports, "prefetchQuery", () => $acb8c88966283b36$export$96097db97bddd5cd);
$parcel$export(module.exports, "useQuery", () => $acb8c88966283b36$export$dd0a697e1782aedd);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $3h1FP = parcelRequire("3h1FP");
var $3K7NP = parcelRequire("3K7NP");
var $5QDqc = parcelRequire("5QDqc");
var $ciIbx = parcelRequire("ciIbx");

var $6SmuL = parcelRequire("6SmuL");
const $acb8c88966283b36$var$store = (0, $5QDqc.createStore)({
    initialState: {
        cache: {}
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            },
        deleteCacheEntry: (key)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const cache = {
                    ...state.cache
                };
                delete cache[key];
                setState({
                    cache: cache
                });
            }
    }
});
const $acb8c88966283b36$var$selector = (0, $3K7NP.createSelector)((state)=>state.cache, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
	 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
	 * and it will determine whether to rerender the component
	 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
	 *
	 * e.g. for `enabled` true condition:
	 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
	 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
	 *
	 * To test this, run the unit test, and then force this function to return new stuff on every call
	 * e.g. `return { ...result, random: Math.random() };`
	 * it will result in increase renderCount in the unit test
	 */ (cache, key, initialQueryEnabled)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: initialQueryEnabled
    });
const $acb8c88966283b36$var$useCacheEntry = (0, $3h1FP.createHook)($acb8c88966283b36$var$store, {
    selector: $acb8c88966283b36$var$selector
});
const $acb8c88966283b36$export$96097db97bddd5cd = ({ queryKey: queryKeyParts, queryFn: queryFn, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const storeApi = (0, $ciIbx.defaultRegistry).getStore($acb8c88966283b36$var$store);
    const actions = storeApi.actions;
    if (actions.getCacheEntry(queryKey) !== undefined) return;
    onStart?.();
    actions.updateCacheEntry(queryKey, {
        isFetching: true,
        data: null,
        error: null
    });
    queryFn().then((response)=>{
        actions.updateCacheEntry(queryKey, {
            data: response,
            error: null,
            isFetching: false
        });
        onSuccess?.(response);
    }).catch((error)=>{
        // Cache-side errors are intentionally swallowed: a downstream `useQuery`
        // observer (if any) must refetch and surface the error via its normal
        // path. Remove the warm entry so the failed prefetch does not poison the
        // shared cache for the cold path.
        actions.deleteCacheEntry(queryKey);
        onError?.(error);
    });
};
const $acb8c88966283b36$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $euxye.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $euxye.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $euxye.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $acb8c88966283b36$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $euxye.useCallback)(async ()=>{
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const apiError = (0, $6SmuL.mapErrorToApiError)(error);
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    const updateCache = (0, $euxye.useCallback)((data)=>{
        updateCacheEntry(queryKey, {
            data: data
        });
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $euxye.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $glbdM.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData,
        updateCache: updateCache
    };
};

});
parcelRegister("6SmuL", function(module, exports) {
$parcel$export(module.exports, "ApiError", () => $e60344c09427ab0f$export$f2e832acab1bdd79);
$parcel$export(module.exports, "isApiError", () => $e60344c09427ab0f$export$89d83cc97c52a37);
$parcel$export(module.exports, "mapErrorToApiError", () => $e60344c09427ab0f$export$3c02d1a328d4d808);
class $e60344c09427ab0f$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $e60344c09427ab0f$export$89d83cc97c52a37 = (error)=>error instanceof $e60344c09427ab0f$export$f2e832acab1bdd79;
const $e60344c09427ab0f$export$3c02d1a328d4d808 = (error)=>{
    if ($e60344c09427ab0f$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $e60344c09427ab0f$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};

});


parcelRegister("PkUAZ", function(module, exports) {
$parcel$export(module.exports, "AssistanceServiceBase", () => $392637f140e17864$export$40a7802808e2fbe3);
$parcel$export(module.exports, "AssistanceServiceImpl", () => $392637f140e17864$export$a522c5f4ccda1c94);
$parcel$export(module.exports, "AssistanceServiceProvider", () => $392637f140e17864$export$8fe647eb935c33db);
$parcel$export(module.exports, "useAssistanceService", () => $392637f140e17864$export$7e31a1844ebbaf85);
$parcel$export(module.exports, "createHookWithAssistanceService", () => $392637f140e17864$export$5a9ea20fc196ec62);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1uH7N = parcelRequire("1uH7N");

var $4LDqh = parcelRequire("4LDqh");

var $egspI = parcelRequire("egspI");

var $siTdT = parcelRequire("siTdT");

var $4Pjn4 = parcelRequire("4Pjn4");

var $a72sS = parcelRequire("a72sS");

var $6SmuL = parcelRequire("6SmuL");

var $97qmU = parcelRequire("97qmU");

var $j5lly = parcelRequire("j5lly");

var $bWLHK = parcelRequire("bWLHK");

var $covBG = parcelRequire("covBG");

var $kEuUK = parcelRequire("kEuUK");

var $fwenQ = parcelRequire("fwenQ");

var $3yg4B = parcelRequire("3yg4B");

var $b07Us = parcelRequire("b07Us");
const $392637f140e17864$var$PRODUCT_HEADER = 'x-product';
/** Number of tasks to request per page when using cursor-based pagination. */ const $392637f140e17864$var$TASKS_PAGE_SIZE = 25;
const $392637f140e17864$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
const $392637f140e17864$var$CHANNEL_ID_HEADER = 'X-Channel-Id';
const $392637f140e17864$var$DEFAULT_FILE_VALIDATE_PATH = '/rovo/v1/chat/message/file/validate';
const $392637f140e17864$var$DEFAULT_FILE_UPLOAD_PATH = '/rovo/v1/chat/message/file';
class $392637f140e17864$export$40a7802808e2fbe3 {
    constructor(props){
        this.getConfig = ()=>{
            return {
                ...this.config
            };
        };
        const defaultBaseUrl = '/gateway/api/assist';
        const defaultConfig = {
            baseUrl: defaultBaseUrl,
            headers: {}
        };
        this.config = {
            ...props,
            baseUrl: props.baseUrl || defaultConfig.baseUrl,
            credentials: props.credentials,
            headers: {
                ...props.headers || defaultConfig.headers
            }
        };
    }
    createHeaders(init) {
        return new Headers({
            [$392637f140e17864$var$PRODUCT_HEADER]: this.config.product,
            [$392637f140e17864$var$EXPERIENCE_ID_HEADER]: this.config.experienceId,
            ...this.config.headers || {},
            ...init || {}
        });
    }
    getChannelId(defaultChannelId) {
        return this.config.channelId || defaultChannelId;
    }
    async fetch({ path: path, options: options, holdName: holdName }) {
        const { baseUrl: configBaseUrl, credentials: configCredentials } = this.config;
        const baseUrl = configBaseUrl;
        const requestUrl = (0, $fwenQ.addPath)(baseUrl, path);
        const startTime = performance.now();
        const response = await window.fetch(requestUrl, {
            credentials: configCredentials,
            ...options
        });
        if (this.config.labelStack) {
            // Please note that the recorded duration of this hold may differ from the time spent actually fetching the data.
            // This is because the browser may schedule network calls and JavaScript execution at its own discrection based
            // on available resources, the main thread being blocked, etc... Still, it is a helpful approximation.
            const endTime = performance.now();
            (0, $siTdT.addSpanToAll)('fetch', holdName ? `${options.method}-${holdName}` : 'unknown', this.config.labelStack, startTime, endTime);
        }
        return (0, $fwenQ.processResponse)({
            response: response
        });
    }
    async fetchJson(options) {
        const response = await this.fetch(options);
        const json = await response.json();
        return json;
    }
    async fetchStream(options, config) {
        const response = await this.fetch(options);
        const contentType = response.headers.get('content-type') ?? '';
        const headerSuggestsSSE = config?.useSSE && contentType.includes('text/event-stream');
        return {
            responseData: {
                traceId: (0, $97qmU.getTraceIdFromResponse)(response)
            },
            generator: headerSuggestsSSE ? (0, $covBG.readSSEStream)(response) : (0, $bWLHK.readJsonStream)(response)
        };
    }
}
$392637f140e17864$export$40a7802808e2fbe3.displayName = "AssistanceServiceBase";
const $392637f140e17864$var$getHref = (product)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const backendOriginHost = window?.__backendOriginHost;
    if (product === 'confluence' && window.location.hostname === 'localhost' && typeof backendOriginHost === 'string') {
        const urlWithLocalhost = new URL(window?.location?.href);
        urlWithLocalhost.hostname = backendOriginHost;
        urlWithLocalhost.port = '';
        urlWithLocalhost.protocol = 'https:';
        return urlWithLocalhost.toString();
    }
    return window?.location?.href;
};
class $392637f140e17864$export$a522c5f4ccda1c94 extends $392637f140e17864$export$40a7802808e2fbe3 {
    constructor(props){
        super(props), this.getAgentActions = async ()=>{
            const response = await this.fetchJson({
                path: '/rovo/v1/agents/configuration/actions',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-actions'
            });
            return response.actions;
        }, this.getAgentKnowledgeConfiguration = (agentCreatorType)=>{
            const queryParams = agentCreatorType ? `?agentCreatorType=${agentCreatorType}` : '';
            return this.fetchJson({
                path: `/rovo/v1/agents/configuration/knowledge${queryParams}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-knowledge'
            });
        }, this.getAgentPermissions = (agentId, payload)=>{
            return this.fetchJson({
                path: `/rovo/v2/permissions/agents/${agentId}`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v2-permissions-agents-[agentId]'
            });
        }, this.getRecommendedAgents = ({ limit: limit, pageUrl: pageUrl })=>{
            const urlParams = new URLSearchParams({
                limit: limit.toString()
            });
            if (pageUrl) urlParams.append('pageUrl', pageUrl);
            const fullPath = `/rovo/v1/agents/recommend/v2?${urlParams.toString()}`;
            return this.fetchJson({
                path: fullPath,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-recommend-v2'
            });
        }, this.getConversationDebugLogs = async (conversationId)=>{
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/debug-logs`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversation-[conversationId]-debug-logs'
            });
            return response.items;
        }, this.validateFiles = async (payload)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            return this.fetchJson({
                path: this.config.fileValidatePath ?? $392637f140e17864$var$DEFAULT_FILE_VALIDATE_PATH,
                options: {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-message-file-validate'
            });
        }, this.uploadFiles = async (payload)=>{
            const formData = new FormData();
            for (const file of payload.files)formData.append('files', file);
            const response = await this.fetchJson({
                path: this.config.fileUploadPath ?? $392637f140e17864$var$DEFAULT_FILE_UPLOAD_PATH,
                options: {
                    method: 'POST',
                    headers: this.createHeaders(),
                    body: formData
                },
                holdName: 'rovo-v1-chat-message-file'
            });
            return response;
        }, this.rovoLabsSendMessage = (payload)=>{
            return this.fetchStream({
                path: '/rovo/v1/agent-playground/chat/stream',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-agent-playground-chat-stream'
            });
        }, this.rovoLabsGetConversations = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/chat/conversations',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-chat-conversations'
            });
        }, this.rovoLabsGetTools = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/tools',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-tools'
            });
        }, this.rovoLabsGetLanguageModels = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/language-models',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-language-models'
            });
        }, this.rovoLabsGetPrompts = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/prompts',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-prompts'
            });
        }, this.getGeneratedContent = (payload)=>{
            const queryParams = [];
            if (payload?.actions && payload.actions.length > 0) queryParams.push(`actionKeys=${payload.actions.join(',')}`);
            if (payload?.statuses && payload.statuses.length > 0) queryParams.push(`statuses=${payload.statuses.join(',')}`);
            if (payload?.limit !== undefined) queryParams.push(`limit=${payload.limit}`);
            const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
            return this.fetchJson({
                path: `/rovo/v1/chat/generated-content${queryString}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-generated-content'
            });
        }, this.getRovoUserSettings = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        }, this.updateRovoUserSettings = async (settings)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(settings)
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        }, this.getRovoMemories = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories'
            });
        }, this.getRovoMemoryBlurb = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/blurb',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-blurb'
            });
        }, this.answerNow = async (conversationId, messageId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/answer-now`,
                options: options,
                holdName: 'rovo-v1-chat-conversation-message-answer-now'
            });
        }, this.deleteRovoMemory = async (memoryId)=>{
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/memories/${memoryId}`,
                options: options,
                holdName: 'rovo-v1-chat-memories-[memoryId]'
            });
        }, this.getRovoMemoryEdits = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-memory-edits'
            });
        }, this.createMemoryEdit = async (payload)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-memories-memory-edits'
            });
        }, this.createMemory = async (payload)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/create',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-memories-create'
            });
        }, this.getRovoMemoryEditsCount = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits/count',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-memory-edits-count'
            });
        }, this.deleteRovoMemoryEdit = async (editId)=>{
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/memories/memory-edits/${editId}`,
                options: options,
                holdName: 'rovo-v1-chat-memories-memory-edits-[editId]'
            });
        }, this.fetchConversationMetadata = async (conversationId)=>{
            const result = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversation-[conversationId]'
            });
            return this.transformSnakeCaseToCamelCase(result);
        }, this.fetchPersonalizedPromptSuggestions = async (config)=>{
            const { offset: offset = 0, limit: limit = 9 } = config;
            const headers = this.createHeaders({
                'Content-Type': 'application/json'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ai_feature_input: {
                        offset: offset,
                        limit: limit
                    }
                })
            };
            const result = await this.fetchJson({
                path: '/api/ai/v2/ai-feature/confluence-prompt-tiles',
                options: options,
                holdName: 'api-ai-v2-ai-feature-confluence-prompt-tiles'
            });
            return result?.ai_feature_output?.prompt_tiles ?? [];
        }, this.getTasks = async (params)=>{
            const searchParams = new URLSearchParams();
            searchParams.set('limit', String(params?.limit ?? $392637f140e17864$var$TASKS_PAGE_SIZE));
            if (params?.cursor) searchParams.set('cursor', params.cursor);
            return this.fetchJson({
                path: `/rovo/v1/tasks?${searchParams.toString()}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-tasks'
            });
        }, this.getTasksStream = async (controller)=>{
            return this.fetchStream({
                path: '/rovo/v1/tasks/stream',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        Accept: 'text/event-stream'
                    }),
                    signal: controller?.signal
                },
                holdName: 'rovo-v1-tasks-stream'
            }, {
                useSSE: true
            });
        }, this.cancelTask = async (taskId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/tasks/${taskId}/cancel`,
                options: options,
                holdName: 'rovo-v1-tasks-[taskId]-cancel'
            });
        }, this.deleteTask = async (taskId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/tasks/${taskId}`,
                options: options,
                holdName: 'rovo-v1-tasks-[taskId]-delete'
            });
        }, this.renameTask = async (taskId, title)=>{
            return this.fetchJson({
                path: `/rovo/v1/tasks/${taskId}`,
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify({
                        title: title
                    })
                },
                holdName: 'rovo-v1-tasks-[taskId]'
            });
        }, this.fetchPersonalizedPromptSuggestionsStream = async (config)=>{
            const { offset: offset = 0, limit: limit = 9 } = config;
            const headers = this.createHeaders({
                'Content-Type': 'application/json'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ai_feature_input: {
                        offset: offset,
                        limit: limit
                    }
                })
            };
            return this.fetchStream({
                path: '/api/ai/v2/ai-feature/confluence-prompt-tiles/stream',
                options: options,
                holdName: 'api-ai-v2-ai-feature-confluence-prompt-tiles-stream'
            });
        };
    }
    async sendMessageStream({ agentNamedId: agentNamedId, agentId: agentId, message: message, mimeType: mimeType, conversationId: conversationId, controller: controller, storeMessage: storeMessage = false, citationsEnabled: citationsEnabled = true, aiFeatureContext: aiFeatureContext, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, browserContext: browserContext, additionalContext: additionalContext, dashboardContext: dashboardContext, dashboardEditorContext: dashboardEditorContext, fileIds: fileIds, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, appFilters: appFilters, useCurrentBrowsingContext: useCurrentBrowsingContext, minionAliasConfig: minionAliasConfig, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, optInAnsNow: optInAnsNow = false, optInNewToolTraces: optInNewToolTraces = false, optInNewTeamworkTraceIcons: optInNewTeamworkTraceIcons = false, browserContextSanitizer: browserContextSanitizer, optInSSEStream: optInSSEStream = false, agentVersion: agentVersion, spaceId: spaceId, capabilities: capabilities, shouldExtractConversationScopes: shouldExtractConversationScopes, searchArtifact: searchArtifact, parentMessageId: parentMessageId }) {
        const effectiveCapabilities = (0, $kEuUK.buildEffectiveCapabilities)(capabilities);
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            [$392637f140e17864$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat'),
            // This header is used to opt-in to Deep Research v2 on the BE.
            // This is to ensure that we don't use v2 deep research when we are using the old Rovo Chat UI prior to the refresh..
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            // Opt in to using RESEARCH_STEP, RESEARCH_PLAN, and similar messages for "think deeper".
            // Ensures backward compatibility with legacy clients and allows application targeting within the experiment.
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            },
            ...optInAnsNow && {
                'X-Answer-Now-UI-Opt-In': 'true'
            },
            ...optInNewToolTraces && {
                'X-New-Tool-Traces-Opt-In': 'true'
            },
            ...optInNewTeamworkTraceIcons && {
                'X-New-Teamwork-Trace-Icons-Opt-In': 'true'
            },
            ...effectiveCapabilities && effectiveCapabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(effectiveCapabilities)
            }
        });
        let knowledgeOverride = {};
        // not setting knowledgeEnabled and filters means all org knowledge is applied by default.
        if (appFilters) {
            if (appFilters.length === 0) knowledgeOverride = {
                knowledgeEnabled: false
            };
            else knowledgeOverride = {
                knowledgeEnabled: true,
                filters: {
                    knowledgeSources: appFilters
                }
            };
        }
        // Check if the URL is blocklisted
        const browserUrl = browserContext?.context?.browserUrl;
        const isBlocklisted = browserUrl && browserContextSanitizer ? browserContextSanitizer.isBlocklisted(browserUrl) : false;
        // Determine the URL to send to the backend
        // If blocklisted, send empty URL to ensure the site is not sent to the backend
        // If browserContext received and context is undefined, assume we're unable to retrieve the context of the page in focus
        let url;
        if (isBlocklisted || browserContext?.context?.browserUrl === 'NO-URL' && (0, $4LDqh.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) url = '';
        else if (browserContext?.context?.browserUrl) url = browserContext.context.browserUrl;
        else url = $392637f140e17864$var$getHref(this.getConfig().product) ?? '';
        const defaultMimeType = typeof message === 'string' ? 'text/markdown' : 'text/adf';
        const body = {
            content: message,
            context: {
                // without useCurrentBrowsingContext browser_url is not always used by the Rovo,
                // instead it depends on prompt intent to use it,
                // with useCurrentBrowsingContext we can ensure it is always used
                browser_url: url,
                ...useCurrentBrowsingContext === undefined ? {} : {
                    useCurrentBrowsingContext: useCurrentBrowsingContext
                },
                webSearchEnabled: webSearchEnabled,
                deepResearchEnabled: deepResearchEnabled,
                ...thinkDeeperEnabled ? {
                    extendedThinkingEnabled: thinkDeeperEnabled
                } : {},
                ...alphaExtendedThinkingMode ? {
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode
                } : {},
                ...fastModeEnabled ? {
                    fastModeEnabled: fastModeEnabled
                } : {},
                ...planModeEnabled ? {
                    planModeEnabled: planModeEnabled,
                    alphaExtendedThinkingMode: 'MARATHON',
                    extendedThinkingEnabled: true
                } : {},
                ...editorContext ? {
                    editor: editorContext
                } : {},
                ...whiteboardContext ? {
                    whiteboardContext: whiteboardContext
                } : {},
                ...slidesContext ? {
                    slidesContext: slidesContext
                } : {},
                ...databaseContext ? {
                    databaseContext: databaseContext
                } : {},
                ...dashboardEditorContext ? {
                    dashboardEditorContext: dashboardEditorContext
                } : {},
                // If browserUrl is inaccessable, fallback to htmlBody or canvasText if they exist
                // Do not send htmlBody or canvasText if the URL is blocklisted to ensure the site is truly not sent to the backend
                ...browserContext && !isBlocklisted ? {
                    browser: {
                        htmlBody: browserContext.context?.htmlBody,
                        canvasText: browserContext.context?.canvasText
                    }
                } : {},
                jiraWorkflowContext: jiraWorkflowContext,
                ...additionalContext,
                dashboardContext: dashboardContext,
                aiFeatureContext: aiFeatureContext,
                fileIds: fileIds,
                ...knowledgeOverride,
                ...searchArtifact ? {
                    search_artifact: searchArtifact
                } : {},
                ...shouldExtractConversationScopes !== undefined ? {
                    shouldExtractConversationScopes: shouldExtractConversationScopes
                } : {}
            },
            recipient_agent_named_id: agentNamedId,
            agent_id: agentId,
            mimeType: mimeType && (0, $egspI.fg)('jira_ai_rendering_a2ui') ? mimeType : defaultMimeType,
            ...agentVersion ? {
                agent_version: agentVersion
            } : {},
            // don't allow store message if feature flag is off
            store_message: (0, $egspI.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: citationsEnabled,
            ...minionAliasConfig ?? (this.getConfig().minionAlias ? {
                stratus_config: {
                    minion_alias: this.getConfig().minionAlias
                }
            } : {}),
            ...spaceId ? {
                space_id: spaceId
            } : {},
            ...parentMessageId ? {
                parent_message_id: parentMessageId
            } : {}
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async reconnectToMessageStream({ conversationId: conversationId, messageId: messageId, lastEventId: lastEventId, controller: controller }) {
        const headers = this.createHeaders();
        // Add Last-Event-ID header if available
        if (lastEventId) headers.set('Last-Event-ID', lastEventId);
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/stream/sse`,
            options: options
        }, {
            useSSE: true
        });
    }
    // Only takes effect if the stream is a Deep Research stream
    async cancelMessageStream({ conversationId: conversationId, messageId: messageId }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/cancel`,
            options: options
        });
    }
    async sendMessageConfirmedTools({ conversationId: conversationId, agentId: agentId, controller: controller, confirmed_tools: confirmed_tools, optInSSEStream: optInSSEStream = false, storeMessage: storeMessage = false, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, aiFeatureContext: aiFeatureContext, agentVersion: agentVersion, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, optInAnsNow: optInAnsNow = false, optInNewToolTraces: optInNewToolTraces = false, optInNewTeamworkTraceIcons: optInNewTeamworkTraceIcons = false, capabilities: capabilities, searchArtifact: searchArtifact, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, browserContext: browserContext, additionalContext: additionalContext, dashboardContext: dashboardContext, dashboardEditorContext: dashboardEditorContext, useCurrentBrowsingContext: useCurrentBrowsingContext, browserContextSanitizer: browserContextSanitizer }) {
        const effectiveCapabilities = (0, $kEuUK.buildEffectiveCapabilities)(capabilities);
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            [$392637f140e17864$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat'),
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            },
            ...optInAnsNow && {
                'X-Answer-Now-UI-Opt-In': 'true'
            },
            ...optInNewToolTraces && {
                'X-New-Tool-Traces-Opt-In': 'true'
            },
            ...optInNewTeamworkTraceIcons && {
                'X-New-Teamwork-Trace-Icons-Opt-In': 'true'
            },
            ...effectiveCapabilities && effectiveCapabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(effectiveCapabilities)
            }
        });
        // browser_url is historically the current window location. The blocklist gates the page
        // browser context added under the `rovo-include-full-context-on-confirmed-tools`
        // experiment (when a browserContext is supplied). The NO-URL sentinel under the
        // `jira_free_gen_editor` experiment suppresses the URL (matching sendMessageStream) so that
        // cohort does not leak a URL.
        const browserUrl = browserContext?.context?.browserUrl;
        const isBrowserContextBlocklisted = !!(browserUrl && browserContextSanitizer?.isBlocklisted(browserUrl));
        const isBrowserUrlSuppressed = browserUrl === 'NO-URL' && (0, $4LDqh.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false);
        const url = isBrowserUrlSuppressed ? '' : window?.location?.href;
        const body = {
            conversation_id: conversationId,
            agent_id: agentId,
            confirmed_tools: confirmed_tools,
            ...agentVersion ? {
                agent_version: agentVersion
            } : {},
            context: {
                // Historical slim context — unchanged so the experiment-off request is byte-identical.
                browser_url: url,
                webSearchEnabled: webSearchEnabled,
                ...deepResearchEnabled ? {
                    deepResearchEnabled: deepResearchEnabled
                } : {},
                ...thinkDeeperEnabled ? {
                    extendedThinkingEnabled: thinkDeeperEnabled
                } : {},
                ...alphaExtendedThinkingMode ? {
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode
                } : {},
                ...planModeEnabled ? {
                    planModeEnabled: planModeEnabled,
                    alphaExtendedThinkingMode: 'MARATHON',
                    extendedThinkingEnabled: true
                } : {},
                ...fastModeEnabled ? {
                    fastModeEnabled: fastModeEnabled
                } : {},
                ...aiFeatureContext ? {
                    aiFeatureContext: aiFeatureContext
                } : {},
                ...searchArtifact ? {
                    search_artifact: searchArtifact
                } : {},
                // Full request context — supplied by the store action only when the
                // `rovo-include-full-context-on-confirmed-tools` experiment is on, so the backend
                // receives the same page/whiteboard/creation context as a regular sendMessage.
                // Every field is omitted when undefined, so the slim request above is unaffected.
                ...useCurrentBrowsingContext === undefined ? {} : {
                    useCurrentBrowsingContext: useCurrentBrowsingContext
                },
                // Content-context objects. Inlined to mirror sendMessageStream's serialization
                // exactly; a unit test (the drift guard) asserts the two stay in sync. Each is
                // omitted when undefined, so the slim request above is unaffected.
                ...editorContext ? {
                    editor: editorContext
                } : {},
                ...whiteboardContext ? {
                    whiteboardContext: whiteboardContext
                } : {},
                ...slidesContext ? {
                    slidesContext: slidesContext
                } : {},
                ...databaseContext ? {
                    databaseContext: databaseContext
                } : {},
                ...dashboardEditorContext ? {
                    dashboardEditorContext: dashboardEditorContext
                } : {},
                ...browserContext && !isBrowserContextBlocklisted ? {
                    browser: {
                        htmlBody: browserContext.context?.htmlBody,
                        canvasText: browserContext.context?.canvasText
                    }
                } : {},
                jiraWorkflowContext: jiraWorkflowContext,
                ...additionalContext,
                dashboardContext: dashboardContext
            },
            // These values are hardcoded because they are not used in backend, but required in the contract
            content: '',
            mimeType: 'text/markdown',
            // don't allow store message if feature flag is off
            store_message: (0, $egspI.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: false
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async nlCreateAgentStream({ controller: controller, latest_user_message: latest_user_message, draft_agent: draft_agent, conversation_history: conversation_history }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const body = {
            latest_user_message: latest_user_message,
            draft_agent: draft_agent,
            conversation_history: conversation_history
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/agents/nlcreate`,
            options: options
        });
    }
    async getChat(conversationId, capabilities) {
        // Forward the caller-provided chat capabilities (e.g. `inline_lumina_enabled`,
        // which is gated behind `rovo_chat_enable_inline_lumina`) so that fetching a
        // chat from history renders the same rich (Lumina) components as a live stream,
        // rather than downgrading to basic markdown.
        //
        // Note: this intentionally forwards `capabilities` as-is rather than routing
        // through `buildEffectiveCapabilities`. That helper fires the actionable
        // follow-ups experiment exposure, which must only happen when a message is
        // SENT — not when history is read — so reusing it here would pollute the
        // experiment and attach send-only capabilities to a read request.
        const headers = this.createHeaders({
            ...capabilities && capabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(capabilities)
            }
        });
        const options = {
            method: 'GET',
            headers: headers
        };
        const rawChat = await this.fetchJson({
            path: `/rovo/v1/chat/conversation/${conversationId}/messages`,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]-messages'
        });
        const chatArray = rawChat.items;
        return chatArray.map((message)=>(0, $a72sS.isHumanMessage)(message) ? message : (0, $b07Us.toStreamResponse)(message));
    }
    async deleteChat(conversationId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}`,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]'
        });
    }
    async getAgents(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
        return response.items;
    }
    async getAgentDetails(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async getAgentDetailsByIdentityAccountId(identityAccountId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/accountid/${identityAccountId}`,
            options: options,
            holdName: 'rovo-v1-agents-accountid-[identityAccountId]'
        });
    }
    async createAgent(payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        return this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
    }
    async updateAgent(id, payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
        return response;
    }
    async deleteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async favouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'POST',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async unfavouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async createConversationChannel(options) {
        const name = options && 'name' in options ? options.name : (0, $3yg4B.generateConversationName)();
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8',
                    [$392637f140e17864$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat')
                }),
                body: JSON.stringify({
                    name: name,
                    dialogues: options?.dialogues ?? undefined,
                    tags: options?.tags,
                    ...(0, $egspI.fg)('rovo_chat_web_pass_agent_to_conversation') ? {
                        agent_id: options?.agentId
                    } : {}
                })
            },
            holdName: 'rovo-v1-chat-conversation'
        });
    }
    async getConversationChannels(options) {
        // Clean up `ConversationChannel[] | { items: ConversationChannel[] }` when fg('rovo_convo_ai_migration') is removed
        const searchParams = new URLSearchParams();
        if (options?.limit !== undefined) searchParams.set('limit', String(options.limit));
        if (options?.cursor !== undefined) searchParams.set('cursor', options.cursor);
        const queryString = searchParams.toString();
        const result = await this.fetchJson({
            path: `/rovo/v1/chat/conversations${queryString ? `?${queryString}` : ''}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'rovo-v1-chat-conversations'
        });
        // Transform snake_case fields to camelCase
        return {
            items: result.items.map((item)=>this.transformSnakeCaseToCamelCase(item)),
            hasNext: result.hasNext ?? false,
            cursor: result.cursor ?? null
        };
    }
    async getPinnedConversationSummary() {
        try {
            const result = await this.fetchJson({
                path: '/rovo/v1/chat/conversations/pinned-summary',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversations-pinned-summary'
            });
            return {
                pinnedCount: result.pinned_count ?? 0,
                maxPinnedConversations: result.max_pinned_conversations ?? 0
            };
        } catch (error) {
            // The endpoint not being deployed yet surfaces as a 404 — ignore that (callers fall back to
            // the local pinned count). Any other failure is genuine, so rethrow rather than swallow it
            // silently, letting the caller report/handle it.
            const statusCode = error instanceof (0, $6SmuL.ApiError) ? error.errorAttributes?.statusCode : undefined;
            if (statusCode === 404) return undefined;
            throw error;
        }
    }
    updateConversationChannel(id, payload) {
        // Transform camelCase field names to snake_case for the REST API
        const apiPayload = this.transformCamelCaseToSnakeCase(payload);
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}`,
            options: {
                method: 'PUT',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify(apiPayload)
            },
            holdName: 'rovo-v1-chat-conversation-[id]'
        }).then((response)=>this.transformSnakeCaseToCamelCase(response));
    }
    transformCamelCaseToSnakeCase(payload) {
        const result = {};
        for (const [key, value] of Object.entries(payload)){
            if (key === 'readStatus') result['read_status'] = value;
            else if (key === 'isPinned') result['is_pinned'] = value;
            else if (key === 'pinnedAt') result['pinned_at'] = value;
            else result[key] = value;
        }
        return result;
    }
    transformSnakeCaseToCamelCase(item) {
        if (item == null || typeof item !== 'object') throw new Error(`Expected an object from conversation channel API, got: ${typeof item}`);
        const result = {
            ...item
        };
        if ('read_status' in result) {
            result['readStatus'] = result['read_status'];
            delete result['read_status'];
        }
        if ('is_pinned' in result) {
            result['isPinned'] = result['is_pinned'];
            delete result['is_pinned'];
        }
        if ('pinned_at' in result) {
            result['pinnedAt'] = result['pinned_at'];
            delete result['pinned_at'];
        }
        return result;
    }
    async resolveConversationAction(id, payload) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}/action`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    ...payload,
                    context: {
                        ...payload.context,
                        browser_url: window.location.href
                    }
                })
            },
            holdName: 'rovo-v1-chat-conversation-[id]-action'
        });
    }
    async bulkResolveConversationUIActions(conversationId, messageId, payload) {
        // The bulk API supports a maximum of 50 items per request.
        // Split into batches and process them sequentially.
        const BATCH_SIZE = 50;
        const allResponses = [];
        for(let batchStart = 0; batchStart < payload.items.length; batchStart += BATCH_SIZE){
            const batchItems = payload.items.slice(batchStart, batchStart + BATCH_SIZE);
            const batchResponses = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/tools/resolution`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify({
                        items: batchItems.map((item)=>({
                                ...item,
                                context: {
                                    ...item.context,
                                    browser_url: window.location.href
                                }
                            }))
                    })
                },
                holdName: 'rovo-v1-chat-conversation-[id]-message-[messageId]-tools-resolution'
            });
            allResponses.push(...batchResponses);
        }
        return allResponses;
    }
    // REST starters, newer API
    async generateAgentStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/agent-starter-suggestion',
            options: options,
            holdName: 'rovo-v1-conversation-starters-agent-starter-suggestion'
        });
    }
    // REST conversation starters, newer API
    async generateContextualStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/page-contextual',
            options: options,
            holdName: 'rovo-v1-conversation-starters-page-contextual'
        });
    }
    // REST dynamic conversation starters (new endpoint)
    async getDynamicConvoStartersNew(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            'x-experience-id': 'convo-starter-for-rovo-button'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/ai/v2/ai-feature/convo-starters',
            options: options,
            holdName: 'api-ai-v2-ai-feature-convo-starters'
        });
    }
    async getWebSearchConfiguration() {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const result = await this.fetchJson({
            path: '/api/v2/configuration/web-search-ai',
            options: options,
            holdName: 'api-v2-configuration-web-search-ai'
        });
        return result;
    }
    async getPrompts() {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const result = await this.fetchJson({
            path: '/api/v2/prompts',
            options: options,
            holdName: 'api-v2-prompts'
        });
        return result;
    }
    async getPrompt(promptId) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        return this.fetchJson({
            path: `/api/v2/prompts/${promptId}`,
            options: options,
            holdName: 'api-v2-prompts-[promptId]'
        });
    }
    async bulkGetPrompts(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts/bulk-get',
            options: options,
            holdName: 'api-v2-prompts-bulk-get'
        });
    }
    async createPrompt(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts',
            options: options,
            holdName: 'api-v2-prompts'
        });
    }
    async updatePrompt(promptId, payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: `/api/v2/prompts/${promptId}`,
            options: options,
            holdName: 'api-v2-prompts-update'
        });
    }
    async addPromptsToLibrary(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        await this.fetch({
            path: '/api/v2/prompts/add-to-library',
            options: options,
            holdName: 'api-v2-prompts-add-to-library'
        });
    }
    async deletePrompt(shareId) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers
        };
        await this.fetch({
            path: `/api/v2/prompts/${shareId}`,
            options: options,
            holdName: 'api-v2-prompts-delete'
        });
    }
    async favoritePrompts(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        await this.fetch({
            path: `/api/v2/prompts/favorite`,
            options: options,
            holdName: 'api-v2-prompts-favorite'
        });
    }
    async bulkUpdatePrivacy(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts/bulk-update-privacy',
            options: options,
            holdName: 'api-v2-prompts-bulk-update-privacy'
        });
    }
    async upsertConversationShare(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/share',
            options: options,
            holdName: 'api-v2-share-upsert'
        });
    }
    async getConversationShare(shareToken) {
        return this.fetchJson({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-get'
        });
    }
    async forkSharedConversation(shareToken) {
        return this.fetchJson({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}/fork`,
            options: {
                method: 'POST',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-fork'
        });
    }
}
$392637f140e17864$export$a522c5f4ccda1c94.displayName = "AssistanceServiceImpl";
const $392637f140e17864$var$AssistanceServiceContext = /*#__PURE__*/ (0, $euxye.createContext)(new $392637f140e17864$export$a522c5f4ccda1c94({
    baseUrl: '',
    product: '',
    experienceId: ''
}));
const $392637f140e17864$export$8fe647eb935c33db = ({ value: value, children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)($392637f140e17864$var$AssistanceServiceContext.Provider, {
        value: value,
        children: children
    });
$392637f140e17864$export$8fe647eb935c33db.displayName = "AssistanceServiceProvider";
const $392637f140e17864$export$7e31a1844ebbaf85 = (props)=>{
    (0, $1uH7N.di)((0, $euxye.useContext), $392637f140e17864$export$a522c5f4ccda1c94);
    const service = (0, $euxye.useContext)($392637f140e17864$var$AssistanceServiceContext);
    (0, $j5lly.setRovoChatProduct)(props?.product ?? service.getConfig().product);
    if (!props || !props.experienceId && !props.product && !props.headers && !props.channelId) return service;
    const product = props.product ?? service.getConfig().product;
    const experienceId = props.experienceId ?? service.getConfig().experienceId;
    const headers = props.headers ?? service.getConfig().headers;
    const channelId = props.channelId ?? service.getConfig().channelId;
    return new $392637f140e17864$export$a522c5f4ccda1c94({
        ...service.getConfig(),
        product: product,
        experienceId: experienceId,
        headers: headers,
        channelId: channelId
    });
};
const $392637f140e17864$export$5a9ea20fc196ec62 = (originalHook)=>{
    return (props)=>{
        (0, $1uH7N.di)($392637f140e17864$export$a522c5f4ccda1c94, (0, $4Pjn4.useAIMateExperienceTracker));
        const { assistanceServiceParams: assistanceServiceParams, ...restProps } = props;
        const experienceTracker = (0, $4Pjn4.useAIMateExperienceTracker)({
            touchpointSource: assistanceServiceParams.touchpointSource
        });
        const headers = (0, $euxye.useMemo)(()=>{
            // even though AssistanceServiceInputParam enforces lowercase header keys,
            // it is possible to get a non lowercase key if a prebuilt object was assigned to headers at runtime,
            // so this is an additional safety net, without this duplicate headers keys with different case
            // can get appended during header normalization causing request to fail
            // Relevant thread: https://atlassian.slack.com/archives/C0677M19GU9/p1748531977923069?thread_ts=1747336061.856749&cid=C0677M19GU9
            const inputHeaders = props.assistanceServiceParams.headers ? Object.fromEntries(Object.entries(props.assistanceServiceParams.headers).map(([key, value])=>[
                    key.toLowerCase(),
                    value
                ])) : undefined;
            return {
                'x-cloudid': props.assistanceServiceParams.siteId,
                ...inputHeaders
            };
        }, [
            props.assistanceServiceParams.siteId,
            props.assistanceServiceParams.headers
        ]);
        const assistanceService = (0, $euxye.useMemo)(()=>{
            return new $392637f140e17864$export$a522c5f4ccda1c94({
                product: assistanceServiceParams.product,
                experienceId: assistanceServiceParams.experienceId,
                headers: headers,
                baseUrl: assistanceServiceParams.baseUrl,
                minionAlias: assistanceServiceParams.minionAlias,
                fileValidatePath: assistanceServiceParams.fileValidatePath,
                fileUploadPath: assistanceServiceParams.fileUploadPath
            });
        }, [
            assistanceServiceParams.baseUrl,
            assistanceServiceParams.experienceId,
            assistanceServiceParams.product,
            headers,
            assistanceServiceParams.minionAlias,
            assistanceServiceParams.fileValidatePath,
            assistanceServiceParams.fileUploadPath
        ]);
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing assistance-service baseline: injected hook params are adapted to the generic hook parameter type.
        const result = originalHook({
            ...restProps,
            assistanceServiceInjectedParams: {
                ...assistanceServiceParams,
                headers: headers,
                experienceTracker: experienceTracker,
                assistanceService: assistanceService
            }
        });
        return result;
    };
};

});
parcelRegister("4Pjn4", function(module, exports) {
$parcel$export(module.exports, "ExperienceTrackerHandler", () => $3a1e8ced231eb1f6$export$5a92a056565f01cc);
$parcel$export(module.exports, "useUFOLabelStackSetter", () => $3a1e8ced231eb1f6$export$63af6e7bbb4f375d);
$parcel$export(module.exports, "useAIMateExperienceTracker", () => $3a1e8ced231eb1f6$export$412c53791574f6f0);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");

var $1uH7N = parcelRequire("1uH7N");

var $u9iDa = parcelRequire("u9iDa");

var $4LDqh = parcelRequire("4LDqh");

var $egspI = parcelRequire("egspI");

var $siTdT = parcelRequire("siTdT");

var $6Zzi4 = parcelRequire("6Zzi4");

var $dcAPc = parcelRequire("dcAPc");

var $7lmdG = parcelRequire("7lmdG");

var $5oGA6 = parcelRequire("5oGA6");

var $jSoCT = parcelRequire("jSoCT");

var $fudsK = parcelRequire("fudsK");

var $xbXS6 = parcelRequire("xbXS6");
const $3a1e8ced231eb1f6$var$isRovoInstrumentedError = (error)=>error !== null && error !== undefined && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
const $3a1e8ced231eb1f6$var$isTerminalEvent = (event)=>event.action === 'taskSuccess' || event.action === 'taskFail' || event.action === 'taskAbort';
class $3a1e8ced231eb1f6$export$5a92a056565f01cc {
    static{
        this.labelStack = [];
    }
    constructor(dropEvents){
        this.experienceTracker = new (0, $6Zzi4.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        this.tabVisibilityByExperience = new Map();
        const doc = (0, $u9iDa.getDocument)();
        if (doc && (0, $egspI.fg)('rovo_chat_exp_tracking_tab_vis_metrics')) (0, $glbdM.bind)(doc, {
            type: 'visibilitychange',
            listener: ()=>{
                const isHidden = doc.visibilityState === 'hidden';
                this.tabVisibilityByExperience.forEach((tracker)=>{
                    tracker.onVisibilityChange(isHidden);
                });
            }
        });
        if (!dropEvents) this.experienceTracker.subscribe((event)=>{
            if (event.action === 'taskStart' && (0, $egspI.fg)('rovo_chat_exp_tracking_tab_vis_metrics')) this.tabVisibilityByExperience.set(event.name, new (0, $xbXS6.TabVisibilityTracker)(doc));
            let filteredErrorAttributes = {};
            let preventSendingLogException = false;
            // When non-null, converts taskFail → taskAbort so the error is excluded from SLO
            // failure counts but still recorded for anomaly detection purposes.
            // Gated by a feature flag so this behaviour can be toggled off as a kill switch.
            let sloExclusion = null;
            const isErrorEvent = 'error' in event;
            // Skip SLO exclusion logic for the aiMateFilteredClientError experience itself
            // to avoid re-processing and potential infinite loops.
            const isFilteredClientErrorExperience = event.name === (0, $jSoCT.ExperienceName).FILTERED_CLIENT_ERROR;
            if (isErrorEvent && !isFilteredClientErrorExperience) {
                // Classify common non-service errors so they can be tracked separately from
                // real backend failures:
                //   - client fetch errors (e.g. "Failed to fetch") — request never reached Atlassian
                //   - product-not-active — HTTP 200 but SSE payload contains an errorCode
                //   - auth/permission — HTTP 401/403 (session expired, HIPAA, IP allowlist, etc.)
                if ((0, $egspI.fg)('rovo_chat_exclude_client_errors_from_slo')) {
                    if ((0, $dcAPc.isClientFetchError)(event.error)) {
                        preventSendingLogException = true;
                        sloExclusion = {
                            reason: (0, $jSoCT.SLOExclusionReason).CLIENT_FETCH_ERROR
                        };
                    } else if ((0, $dcAPc.isProductNotActiveError)(event.error)) {
                        preventSendingLogException = true;
                        sloExclusion = {
                            reason: (0, $jSoCT.SLOExclusionReason).PRODUCT_NOT_ACTIVE
                        };
                    } else if ((0, $dcAPc.isAuthOrPermissionError)(event.error)) {
                        preventSendingLogException = true;
                        sloExclusion = {
                            reason: (0, $jSoCT.SLOExclusionReason).AUTH_OR_PERMISSION_ERROR
                        };
                    }
                }
                if (event.attributes) {
                    const { webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled } = event.attributes;
                    if (webSearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        webSearchEnabled: webSearchEnabled
                    };
                    if (deepResearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        deepResearchEnabled: deepResearchEnabled
                    };
                    if (fastModeEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        fastModeEnabled: fastModeEnabled
                    };
                    if (thinkDeeperEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        thinkDeeperEnabled: thinkDeeperEnabled
                    };
                }
                if ($3a1e8ced231eb1f6$var$isRovoInstrumentedError(event.error)) {
                    const errorAttributes = event.error.errorAttributes;
                    // Remove undefined properties
                    filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([, value])=>value !== undefined));
                }
                const teamName = (0, $fudsK.getOwningTeam)(event.error.message ?? '', event.name);
                filteredErrorAttributes = {
                    teamName: teamName,
                    ...filteredErrorAttributes
                };
                if (!preventSendingLogException) {
                    const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                    const attributes = event.attributes;
                    // this is added by `useExperienceTracker` below
                    const touchpointSource = typeof attributes?.touchpointSource === 'string' ? attributes.touchpointSource : undefined;
                    const teamName = typeof attributes?.teamName === 'string' ? attributes.teamName : undefined;
                    const { traceId: traceIdFromErrorObject, ...filteredErrorAttributesRest } = filteredErrorAttributes;
                    const altTraceId = attributes?.traceId || traceIdFromErrorObject;
                    (0, $7lmdG.logException)({
                        exception: error,
                        name: event.name,
                        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing experience-tracker baseline: legacy UFO attributes are assembled from mixed attribute sources before being passed to a string map API.
                        tags: {
                            source: 'aiMateExperienceTracker',
                            ...filteredErrorAttributesRest,
                            ...touchpointSource && {
                                touchpointSource: touchpointSource
                            },
                            ...teamName && {
                                teamName: teamName
                            },
                            // Rename traceId to atlTraceId if present in attributes to distinguish from Sentry's Trace ID
                            ...altTraceId && {
                                altTraceId: altTraceId
                            }
                        }
                    });
                }
            }
            if ($3a1e8ced231eb1f6$var$isTerminalEvent(event)) // the experience tracker already uses performance.now() to calculate the duration, so we can just piggyback on that,
            // we will loose some precision due to rounding of duration, but it's good enough for our purposes
            (0, $siTdT.addSpanToAll)('custom', `exp-${event.name}`, $3a1e8ced231eb1f6$export$5a92a056565f01cc.labelStack, event.startTime, event.startTime + event.duration);
            const tabVisibilityAttributes = $3a1e8ced231eb1f6$var$isTerminalEvent(event) && (0, $egspI.fg)('rovo_chat_exp_tracking_tab_vis_metrics') ? this.tabVisibilityByExperience.get(event.name)?.getAttributes(doc) ?? {} : {};
            // If the error should be excluded from SLO, report it as taskAbort instead of taskFail.
            // taskAbort events are not counted as failures in the SLO but are still recorded
            // so anomaly detectors can track spikes in these error types.
            const effectiveAction = sloExclusion && event.action === 'taskFail' ? 'taskAbort' : event.action;
            this.sendAnalyticsEvent?.({
                eventType: 'operational',
                action: effectiveAction,
                actionSubject: 'ui',
                attributes: {
                    task: event.name,
                    taskId: event.id,
                    startTime: event.startTime,
                    ...$3a1e8ced231eb1f6$var$isTerminalEvent(event) && {
                        duration: event.duration
                    },
                    // Include error info on both taskFail and taskAbort (for excluded errors)
                    // so analytics/anomaly detectors can distinguish error types.
                    ...isErrorEvent && {
                        error: event.error.message,
                        ...filteredErrorAttributes
                    },
                    // Surface why the error was excluded from the SLO so the raw analytics
                    // event can be queried/grouped without joining to the synthetic experience.
                    ...sloExclusion && {
                        sloExclusionReason: sloExclusion.reason
                    },
                    ...event.attributes,
                    ...tabVisibilityAttributes
                }
            }, {
                removeDefaultTags: true
            });
            // When a client error is excluded from the main SLO (ie. converted to taskAbort),
            // track a separate experience so the volume of these errors can be monitored with its own SLO threshold.
            if (sloExclusion && isErrorEvent) {
                this.experienceTracker.start({
                    name: (0, $jSoCT.ExperienceName).FILTERED_CLIENT_ERROR,
                    id: (0, $jSoCT.ExperienceName).FILTERED_CLIENT_ERROR,
                    startTime: event.startTime
                });
                this.experienceTracker.fail({
                    name: (0, $jSoCT.ExperienceName).FILTERED_CLIENT_ERROR,
                    error: event.error,
                    attributes: {
                        // Preserve the original experience name, error, and exclusion reason for queryability
                        originalTask: event.name,
                        error: event.error.message,
                        sloExclusionReason: sloExclusion.reason,
                        ...filteredErrorAttributes
                    }
                });
            }
            if ($3a1e8ced231eb1f6$var$isTerminalEvent(event) && (0, $egspI.fg)('rovo_chat_exp_tracking_tab_vis_metrics')) this.tabVisibilityByExperience.delete(event.name);
        });
    }
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$3a1e8ced231eb1f6$export$5a92a056565f01cc.instance) {
            const dropEvents = (0, $4LDqh.default).getExperimentValue('platform_ai_drop_instrumentation_tracking', 'value', false);
            $3a1e8ced231eb1f6$export$5a92a056565f01cc.instance = new $3a1e8ced231eb1f6$export$5a92a056565f01cc(dropEvents);
        }
        // instance is guaranteed to be set after the guard above
        return $3a1e8ced231eb1f6$export$5a92a056565f01cc.instance;
    }
    /**
	 * @internal For tests only.
	 */ static resetInstance() {
        $3a1e8ced231eb1f6$export$5a92a056565f01cc.instance = undefined;
    }
    static setLabelStack(labelStack) {
        $3a1e8ced231eb1f6$export$5a92a056565f01cc.labelStack = labelStack;
    }
}
$3a1e8ced231eb1f6$export$5a92a056565f01cc.displayName = "ExperienceTrackerHandler";
const $3a1e8ced231eb1f6$export$63af6e7bbb4f375d = ()=>{
    return (0, $euxye.useCallback)((componentLabelStack)=>{
        $3a1e8ced231eb1f6$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
    }, []);
};
const $3a1e8ced231eb1f6$export$412c53791574f6f0 = (params)=>{
    (0, $1uH7N.di)((0, $5oGA6.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent, mode: conversationAssistantUIMode } = (0, $5oGA6.useAnalytics)();
    const getNameOverride = (0, $euxye.useCallback)((name)=>{
        switch(conversationAssistantUIMode){
            case 'mini-modal':
                return `${name}.${(0, $jSoCT.ExperienceNamePostfix).MINI_MODAL}`;
            default:
                return name;
        }
    }, [
        conversationAssistantUIMode
    ]);
    (0, $euxye.useMemo)(()=>{
        const experienceTracker = $3a1e8ced231eb1f6$export$5a92a056565f01cc.getInstance();
        // this is not ideal, okay just because `sendAnalyticsEvent` is never change
        // since every hook instance will override the singleton sendAnalyticsEvent
        experienceTracker.setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        sendAnalyticsEvent
    ]);
    const experienceTrackerProxy = (0, $euxye.useMemo)(()=>{
        const proxyHandler = {
            get: (target, prop)=>{
                // Overriding the experienceTracker target methods to add additional attributes
                if (prop === 'fail') return (failParams)=>{
                    target.fail({
                        ...failParams,
                        name: !!failParams.name ? getNameOverride(failParams.name) : failParams.name,
                        attributes: {
                            ...failParams.attributes,
                            touchpointSource: params?.touchpointSource,
                            teamName: failParams.teamName
                        }
                    });
                };
                if (prop === 'succeed') return (succeedParams)=>{
                    target.succeed({
                        ...succeedParams,
                        name: !!succeedParams.name ? getNameOverride(succeedParams.name) : succeedParams.name,
                        attributes: {
                            ...succeedParams.attributes,
                            touchpointSource: params?.touchpointSource
                        }
                    });
                };
                if (prop === 'start') return (startParams)=>{
                    target.start({
                        ...startParams,
                        name: !!startParams.name ? getNameOverride(startParams.name) : startParams.name
                    });
                };
                if (prop === 'abort') return (abortParams)=>{
                    target.abort({
                        ...abortParams,
                        name: !!abortParams.name ? getNameOverride(abortParams.name) : abortParams.name
                    });
                };
                if (prop === 'stopOnError') return (stopOnErrorParams)=>{
                    target.stopOnError({
                        ...stopOnErrorParams,
                        name: !!stopOnErrorParams.name ? getNameOverride(stopOnErrorParams.name) : stopOnErrorParams.name
                    });
                };
                return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
            }
        };
        return new Proxy($3a1e8ced231eb1f6$export$5a92a056565f01cc.getInstance().experienceTracker, proxyHandler);
    }, [
        params?.touchpointSource,
        getNameOverride
    ]);
    return experienceTrackerProxy;
};

});
parcelRegister("jSoCT", function(module, exports) {
$parcel$export(module.exports, "ExperienceName", () => $106c2115c54da0e6$export$b881bd9f00ed8ed1);
$parcel$export(module.exports, "ExperienceNamePostfix", () => $106c2115c54da0e6$export$3615d040a39afa1e);
$parcel$export(module.exports, "sendMessageExperienceName", () => $106c2115c54da0e6$export$97bfa295b10f6f9e);
$parcel$export(module.exports, "SLOExclusionReason", () => $106c2115c54da0e6$export$1b8ade75bafe2a6d);
$parcel$export(module.exports, "REMIX_GENERATE_PREVIEW_MARKS", () => $106c2115c54da0e6$export$ebde7a14f059b67f);
$parcel$export(module.exports, "remixGeneratePreviewExperience", () => $106c2115c54da0e6$export$13437d7a030ee3e7);
$parcel$export(module.exports, "REMIX_EDIT_EXISTING_MARKS", () => $106c2115c54da0e6$export$bef09d36689d0f74);
$parcel$export(module.exports, "remixEditExistingExperience", () => $106c2115c54da0e6$export$a143927e9fe401a2);

var $3nsUD = parcelRequire("3nsUD");
var $1fOu9 = parcelRequire("1fOu9");
const $106c2115c54da0e6$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_PANEL_COMPOSABLE_EDITOR: 'aiMateLoadPanelComposableEditor',
    LOAD_INLINE_EDITOR: 'aiMateLoadInlineComposableEditor',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    LOAD_AUTO_SUGGEST_SKILLS_LEGACY: 'aiMateAutoSuggestSkillsLegacy',
    LOAD_AUTO_SUGGEST_SKILLS_UNIFIED: 'aiMateAutoSuggestSkillsUnified',
    LOAD_CHAT_PROMPT_INPUT_SKILLS: 'aiMateChatPromptInputSkillsLoad',
    LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS: 'aiMateInlineChatPromptInputSkillsLoad',
    FETCH_CHAT: 'aiMateFetchChat',
    PREFETCH_CHAT: 'aiMatePrefetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated',
    FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference',
    FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData',
    FETCH_AGENT_DEBUG_MODAL_CONVERSATION_REVIEW: 'aiMateFetchAgentDebugModalDataConversationReview',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    DUPLICATE_AGENT: 'aiMateDuplicateAgent',
    HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData',
    HYDRATE_SKILL_METADATA: 'aiMateHydrateSkillMetadata',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent',
    SEND_DR_MESSAGE: 'aiMateSendDRMessage',
    SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage',
    SEND_TASK_MODE_MESSAGE: 'aiMateSendTaskModeMessage',
    SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage',
    SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE: 'aiMateSendConfirmedToolsTaskModeMessage',
    RECONNECT_TO_ACTIVE_STREAM: 'aiMateReconnectToActiveStream',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    ANSWER_NOW: 'aiMateAnswerNow',
    HYDRATE_CONVERSATION: 'aiMateHydrateConversation',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    BULK_RESOLVE_CONVERSATION_ACTIONS: 'aiMateBulkResolveConversationActions',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMateFetchKnowledgeSourcesStore',
    PREFETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMatePrefetchKnowledgeSourcesStore',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
    CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
    GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
    AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent',
    PREVIEW_CONTENT: 'aiMatePreviewContent',
    PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender',
    JIRA_PREVIEW_CARD_RENDER: 'aiMateJiraPreviewCardRender',
    JSM_PREVIEW_CARD_RENDER: 'aiMateJsmPreviewCardRender',
    FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions',
    PREFETCH_AGENT_SITE_PERMISSIONS: 'aiMatePrefetchAgentSitePermissions',
    SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
    FILTERED_CLIENT_ERROR: 'aiMateFilteredClientError',
    GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
    PREFETCH_RECOMMENDED_AGENTS: 'aiMatePrefetchRecommendedAgents',
    PREFETCH_RECOMMENDED_SPACES: 'aiMatePrefetchRecommendedSpaces',
    OPEN_RECOMMENDED_SPACES: 'aiMateOpenRecommendedSpaces',
    UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
    VALIDATE_FILES: 'aiMateValidateFiles',
    GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
    AIFC_MESSAGE: 'aiMateAifcMessage',
    AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal',
    AIFC_LOAD_CHAT_ONLY_CREATION_MODAL: 'aiMateLoadChatOnlyCreationModal',
    AIFC_LOAD_DRAFTS_SECTION: 'aiMateLoadDraftsSection',
    AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent',
    AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat',
    AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived',
    AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled',
    AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent',
    UPDATE_CONTENT_IN_CHAT: 'aiMateUpdateContentInChat',
    AIFC_MODAL_SESSION: 'aiMateAifcModalSession',
    CSM_WIDGET_RENDER: 'csmWidgetRender',
    CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
    CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
    CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
    CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage',
    CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters',
    CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters',
    GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState',
    SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState',
    AGENTS_MODAL_AND_SIDEBAR_LIST: 'aiMateAgentsModalAndSidebarList',
    AGENTS_MODAL_FAVOURITE_AGENTS: 'aiMateAgentsModalFavouriteAgents',
    AGENTS_FULLSCREEN_AGENT_LIST: 'aiMateAgentsFullscreenAgentList',
    STUDIO_TRIGGER_SOLUTION_PLAN: 'aiMateStudioTriggerSolutionPlan',
    MY_PROJECTS_LIST_QUERY: 'aiMateMyProjectsListQuery',
    STUDIO_UPDATE_AGENT: 'aiMateStudioUpdateAgent',
    STUDIO_AUTOMATION_CREATE_RULE: 'aiMateStudioAutomationCreateRule',
    THREADS_LIST_QUERY: 'aiMateThreadsListQuery',
    WARM_CONVERSATION_CACHE: 'aiMateWarmConversationCache',
    WARM_CONTEXT_BANNER_LINK: 'aiMateWarmContextBannerLink',
    AIFC_LOAD_PROMPT_SUGGESTIONS: 'aiMateAifcLoadPromptSuggestions',
    REMIX_START: 'aiMateRemixStart',
    FETCH_PROMPTS: 'aiMateFetchPrompts',
    FETCH_INSIGHTS_STATUS: 'aiMateFetchInsightsStatus',
    FETCH_INSIGHTS_FEED: 'aiMateFetchInsightsFeed',
    REMIX_RENDERS_IN_MODAL: 'aiMateRemixRendersInModal',
    REMIX_REGENERATE: 'aiMateRemixRegenerate',
    REMIX_INSERT: 'aiMateRemixInsert',
    REMIX_DIAGRAM_PASTE_FINALIZE: 'aiMateRemixDiagramPasteFinalize',
    FETCH_TASKS: 'aiMateFetchTasks',
    LOAD_STICKY_SKILL_LISTENER: 'aiMateLoadStickySkillListener',
    /**
	 * Tracks duplicating a Remix/MAUI app when its link is pasted into another
	 * Confluence page. Started when the editor plugin detects a MAUI link in
	 * the paste, succeeded once the duplicated app's URL has been swapped into
	 * the editor doc, and failed if the duplicate API call (or any JS error in
	 * the duplication flow) fails. When this experience fails, the
	 * REMIX_INSERT experience is also failed so the overall paste-and-insert
	 * flow is reflected in the SLO.
	 */ REMIX_DUPLICATE_APP: 'aiMateRemixDuplicateApp',
    STUDIO_CREATE_AGENT: 'aiMateStudioCreateAgent',
    STUDIO_CREATE_AGENT_ASSIGN: 'aiMateStudioCreateAgentAssign',
    STUDIO_CREATE_AGENT_INVOKE: 'aiMateStudioCreateAgentInvoke',
    STUDIO_CREATE_AGENT_BUILD_AND_CHAT: 'aiMateStudioCreateAgentBuildAndChat',
    STUDIO_CREATE_AGENT_REFINE_IN_STUDIO: 'aiMateStudioCreateAgentRefineInStudio',
    JIRA_SAVE_DRAFT_WORK_ITEM: 'aiMateJiraSaveDraftWorkItem',
    JIRA_RESOLVE_DRAFT_WORK_ITEM: 'aiMateJiraResolveDraftWorkItem',
    JIRA_CREATE_WORK_ITEMS_BULK: 'aiMateJiraCreateWorkItemsBulk'
};
var $106c2115c54da0e6$export$3615d040a39afa1e = /*#__PURE__*/ function(ExperienceNamePostfix) {
    ExperienceNamePostfix["MINI_MODAL"] = "miniModal";
    return ExperienceNamePostfix;
}({});
const $106c2115c54da0e6$export$97bfa295b10f6f9e = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, taskModeEnabled: taskModeEnabled, fastModeEnabled: fastModeEnabled, isCustomRovoAgent: isCustomRovoAgent })=>{
    if (isCustomRovoAgent) return $106c2115c54da0e6$export$b881bd9f00ed8ed1.SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (deepResearchEnabled) return $106c2115c54da0e6$export$b881bd9f00ed8ed1.SEND_DR_MESSAGE;
    if (thinkDeeperEnabled) return $106c2115c54da0e6$export$b881bd9f00ed8ed1.SEND_TD_MESSAGE;
    if (taskModeEnabled) return $106c2115c54da0e6$export$b881bd9f00ed8ed1.SEND_TASK_MODE_MESSAGE;
    if (fastModeEnabled) // Sending the same experience name for fast mode as it is the same as the default (auto) mode
    return $106c2115c54da0e6$export$b881bd9f00ed8ed1.SEND_MESSAGE;
    return $106c2115c54da0e6$export$b881bd9f00ed8ed1.SEND_MESSAGE;
};
const $106c2115c54da0e6$export$233a4307e330ea30 = [
    $106c2115c54da0e6$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT,
    $106c2115c54da0e6$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT_IN_CHAT,
    $106c2115c54da0e6$export$b881bd9f00ed8ed1.AIFC_UPDATE_CONTENT,
    $106c2115c54da0e6$export$b881bd9f00ed8ed1.AIFC_FINALIZE_CONTENT,
    $106c2115c54da0e6$export$b881bd9f00ed8ed1.AIFC_LOAD_STAGING_AREA_MODAL,
    $106c2115c54da0e6$export$b881bd9f00ed8ed1.AIFC_MODAL_SESSION,
    $106c2115c54da0e6$export$b881bd9f00ed8ed1.REMIX_REGENERATE
];
const $106c2115c54da0e6$export$1b8ade75bafe2a6d = {
    /** Browser-level network failure — request never reached Atlassian servers (e.g. VPN, firewall, no connectivity) */ CLIENT_FETCH_ERROR: 'clientFetchError',
    /** Rovo is not enabled for the user's organisation (product-not-active stream error) */ PRODUCT_NOT_ACTIVE: 'productNotActive',
    /** User is not authenticated or lacks permission (HTTP 401/403) */ AUTH_OR_PERMISSION_ERROR: 'authOrPermissionError'
};
const $106c2115c54da0e6$export$449b821dadec8760 = [
    $106c2115c54da0e6$export$b881bd9f00ed8ed1.AIFC_INITIAL_DATA_RECEIVED,
    $106c2115c54da0e6$export$b881bd9f00ed8ed1.AIFC_ALL_DATA_HANDLED,
    $106c2115c54da0e6$export$b881bd9f00ed8ed1.PREVIEW_CONTENT,
    ...$106c2115c54da0e6$export$233a4307e330ea30
];
const $106c2115c54da0e6$export$ebde7a14f059b67f = {
    SUBMIT: 'submit',
    ACTION_COMPLETE_RECEIVED: 'action_complete_received',
    PREVIEW_VISIBLE: 'preview_visible'
};
const $106c2115c54da0e6$export$35724980a513a99d = [
    {
        key: 'backend_latency',
        startMark: $106c2115c54da0e6$export$ebde7a14f059b67f.SUBMIT,
        endMark: $106c2115c54da0e6$export$ebde7a14f059b67f.ACTION_COMPLETE_RECEIVED
    },
    {
        key: 'render_latency',
        startMark: $106c2115c54da0e6$export$ebde7a14f059b67f.ACTION_COMPLETE_RECEIVED,
        endMark: $106c2115c54da0e6$export$ebde7a14f059b67f.PREVIEW_VISIBLE
    }
];
const $106c2115c54da0e6$export$13437d7a030ee3e7 = new (0, $1fOu9.UFOExperience)('remix-generate-preview', {
    type: (0, $3nsUD.ExperienceTypes).Experience,
    performanceType: (0, $3nsUD.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$106c2115c54da0e6$export$35724980a513a99d
    ]
});
const $106c2115c54da0e6$export$bef09d36689d0f74 = {
    SUBMIT: 'submit',
    ACTION_COMPLETE_RECEIVED: 'action_complete_received',
    NODE_INSERTED: 'node_inserted'
};
const $106c2115c54da0e6$export$222a56424ec38dc0 = [
    {
        key: 'backend_latency',
        startMark: $106c2115c54da0e6$export$bef09d36689d0f74.SUBMIT,
        endMark: $106c2115c54da0e6$export$bef09d36689d0f74.ACTION_COMPLETE_RECEIVED
    },
    {
        key: 'insertion_latency',
        startMark: $106c2115c54da0e6$export$bef09d36689d0f74.ACTION_COMPLETE_RECEIVED,
        endMark: $106c2115c54da0e6$export$bef09d36689d0f74.NODE_INSERTED
    }
];
const $106c2115c54da0e6$export$a143927e9fe401a2 = new (0, $1fOu9.UFOExperience)('remix-edit-existing', {
    type: (0, $3nsUD.ExperienceTypes).Experience,
    performanceType: (0, $3nsUD.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$106c2115c54da0e6$export$222a56424ec38dc0
    ]
});

});

parcelRegister("fudsK", function(module, exports) {
$parcel$export(module.exports, "getOwningTeam", () => $ccb84f3fb478320c$export$d6e429d0895093);
/**
 * Determines the owning team for a failure event based on the experience task name,
 * error message, and optional attributes (e.g. actionKey).
 *
 * The rules are derived from the AIFC Top Baseline Errors report and use regex matching
 * to handle error messages that contain dynamic values (UUIDs, IDs, hashes, etc).
 *
 * @see https://hello.atlassian.net/wiki/spaces/ac8/pages/6822974693/Apr+13-14+2026+-+AIFC+Top+Baseline+Errors
 */ 
var $jSoCT = parcelRequire("jSoCT");
var $ccb84f3fb478320c$export$e196c5257e9c94dd = /*#__PURE__*/ function(OwningTeam) {
    OwningTeam["AifcFoundations"] = "AIFC Foundations";
    OwningTeam["EditorAi"] = "Editor AI";
    OwningTeam["RovoChat"] = "Rovo Chat";
    OwningTeam["Whiteboards"] = "Whiteboards";
    OwningTeam["Databases"] = "Databases";
    OwningTeam["JiraAifc"] = "Jira AIFC";
    return OwningTeam;
}({});
/**
 * Step 1 — Experience-specific error rules.
 * These are checked first and only when the experience name matches.
 */ const $ccb84f3fb478320c$var$RULES_FOR_SPECIFIC_EXPERIENCES = [
    {
        pattern: /Something went wrong on Rovo's end. Please try sending your message again./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $jSoCT.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*whiteboard/i,
        team: "Whiteboards",
        experiences: [
            (0, $jSoCT.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*database/i,
        team: "Databases",
        experiences: [
            (0, $jSoCT.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*page/i,
        team: "AIFC Foundations",
        experiences: [
            (0, $jSoCT.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The orchestrator reached its depth limit and the ConfluenceCreationTool was not invoked./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $jSoCT.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /Could not create content of type \w+ in the Confluence staging area./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $jSoCT.ExperienceName).AIFC_GENERATE_CONTENT,
            (0, $jSoCT.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
        ]
    },
    {
        pattern: /Message action error: [Code 400] convoai.rest.bad.request - Failed to update page: missing pageId and ADF content for actionKey:.*/i,
        team: "AIFC Foundations",
        experiences: [
            (0, $jSoCT.ExperienceName).AIFC_UPDATE_CONTENT
        ]
    },
    {
        pattern: /Message action error: [Code 400] convoai.rest.bad.request - Failed to update page: missing pageId and ADF content for actionKey:.*/i,
        team: "Editor AI",
        experiences: [
            (0, $jSoCT.ExperienceName).UPDATE_CONTENT_IN_CHAT
        ]
    },
    {
        pattern: /AIFC stream received edit tags but no elements were affected/i,
        team: "Whiteboards",
        experiences: [
            (0, $jSoCT.ExperienceName).AIFC_UPDATE_CONTENT
        ]
    }
];
/**
 * Step 2 — Global error rules that apply across all experiences.
 */ const $ccb84f3fb478320c$var$GLOBAL_ERROR_MESSAGE_RULES = [
    {
        pattern: /network error/i,
        team: "Rovo Chat"
    },
    {
        pattern: /An error occurred. Please try again later./i,
        team: "Rovo Chat"
    },
    {
        pattern: /Failed to fetch/i,
        team: "Rovo Chat"
    },
    {
        pattern: /An unknown error occurred/i,
        team: "Rovo Chat"
    },
    {
        pattern: /\[Code 403\] {"code":403,"message":"You're unable to access content because your IP address is not listed in the IP allowlist. Contact your admin for help."}/i,
        team: "Rovo Chat"
    },
    {
        pattern: /AIFC stream received only preamble but no <todo_list>, SVG or whiteboards XML.*/i,
        team: "Whiteboards"
    },
    {
        pattern: /No sizing converter defined for element type 'mindmap'/i,
        team: "Whiteboards"
    },
    {
        pattern: /AIFC stream received edit tags but no elements were affected/i,
        team: "Whiteboards"
    },
    {
        pattern: /Could not find database:/i,
        team: "Databases"
    }
];
/**
 * Step 3 — Default team ownership per experience.
 * Used as a fallback when no error-pattern rule matches.
 */ const $ccb84f3fb478320c$var$DEFAULT_TEAM_FOR_EXPERIENCE = new Map([
    [
        (0, $jSoCT.ExperienceName).AIFC_FINALIZE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $jSoCT.ExperienceName).AIFC_ALL_DATA_HANDLED,
        "AIFC Foundations"
    ],
    [
        (0, $jSoCT.ExperienceName).AIFC_GENERATE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $jSoCT.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT,
        "AIFC Foundations"
    ],
    [
        (0, $jSoCT.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        "AIFC Foundations"
    ],
    [
        (0, $jSoCT.ExperienceName).AIFC_MODAL_SESSION,
        "AIFC Foundations"
    ],
    [
        (0, $jSoCT.ExperienceName).AIFC_UPDATE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $jSoCT.ExperienceName).UPDATE_CONTENT_IN_CHAT,
        "Editor AI"
    ],
    [
        (0, $jSoCT.ExperienceName).PREVIEW_CARD_RENDER,
        "AIFC Foundations"
    ],
    [
        (0, $jSoCT.ExperienceName).PREVIEW_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $jSoCT.ExperienceName).SEND_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $jSoCT.ExperienceName).SEND_TASK_MODE_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $jSoCT.ExperienceName).SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $jSoCT.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_LEGACY,
        "Rovo Chat"
    ],
    [
        (0, $jSoCT.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_UNIFIED,
        "Rovo Chat"
    ],
    [
        (0, $jSoCT.ExperienceName).LOAD_CHAT_PROMPT_INPUT_SKILLS,
        "Rovo Chat"
    ],
    [
        (0, $jSoCT.ExperienceName).LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS,
        "Rovo Chat"
    ],
    [
        (0, $jSoCT.ExperienceName).JIRA_SAVE_DRAFT_WORK_ITEM,
        "Jira AIFC"
    ],
    [
        (0, $jSoCT.ExperienceName).JIRA_CREATE_WORK_ITEMS_BULK,
        "Jira AIFC"
    ]
]);
const $ccb84f3fb478320c$export$d6e429d0895093 = (errorMessage, experienceName)=>{
    if (!errorMessage) return $ccb84f3fb478320c$var$DEFAULT_TEAM_FOR_EXPERIENCE.get(experienceName);
    // Step 1: Experience-specific error-pattern rules
    if (experienceName) for (const rule of $ccb84f3fb478320c$var$RULES_FOR_SPECIFIC_EXPERIENCES){
        if (rule.experiences.includes(experienceName) && rule.pattern.test(errorMessage)) return rule.team;
    }
    // Step 2: Global error-pattern rules
    for (const rule of $ccb84f3fb478320c$var$GLOBAL_ERROR_MESSAGE_RULES){
        if (rule.pattern.test(errorMessage)) return rule.team;
    }
    // Step 3: Default team for this experience
    if (experienceName) return $ccb84f3fb478320c$var$DEFAULT_TEAM_FOR_EXPERIENCE.get(experienceName);
    return undefined;
};

});

parcelRegister("xbXS6", function(module, exports) {
$parcel$export(module.exports, "TabVisibilityTracker", () => $e6e343b6d6bbd6c9$export$79c3dc6f15d36f18);
class $e6e343b6d6bbd6c9$export$79c3dc6f15d36f18 {
    constructor(doc){
        this.totalHiddenMs = 0;
        this.startTime = performance.now();
        const isHidden = doc?.visibilityState === 'hidden';
        this.lastHiddenAt = isHidden ? this.startTime : null;
        this.firstHiddenOffsetMs = isHidden ? 0 : null;
    }
    onVisibilityChange(isHidden) {
        const now = performance.now();
        if (isHidden) {
            if (this.lastHiddenAt === null) this.lastHiddenAt = now;
            if (this.firstHiddenOffsetMs === null) this.firstHiddenOffsetMs = now - this.startTime;
        } else if (this.lastHiddenAt !== null) {
            this.totalHiddenMs += now - this.lastHiddenAt;
            this.lastHiddenAt = null;
        }
    }
    getAttributes(doc) {
        const now = performance.now();
        const elapsed = now - this.startTime;
        let totalHiddenMs = this.totalHiddenMs;
        if (this.lastHiddenAt !== null) totalHiddenMs += now - this.lastHiddenAt;
        const tabHiddenProportion = elapsed > 0 ? totalHiddenMs / elapsed : 0;
        return {
            isActiveTab: doc ? doc.visibilityState === 'visible' : true,
            tabHiddenProportion: tabHiddenProportion,
            tabFirstHiddenOffsetMs: this.firstHiddenOffsetMs
        };
    }
}

});


parcelRegister("a72sS", function(module, exports) {
$parcel$export(module.exports, "isSSEMessage", () => $d5124627678c0dc0$export$f78edfe5a93b58af);
$parcel$export(module.exports, "ACCEPTABLE_USE_VIOLATIONS_ERROR", () => $d5124627678c0dc0$export$c424fe9570a5f2d9);
$parcel$export(module.exports, "isHumanMessage", () => $d5124627678c0dc0$export$a69fab2afb88c2eb);
$parcel$export(module.exports, "isAssistantMessage", () => $d5124627678c0dc0$export$6f965deda7f0960c);
$parcel$export(module.exports, "isStreamResponse", () => $d5124627678c0dc0$export$b4631726cbc1440a);
$parcel$export(module.exports, "isAgentResponse", () => $d5124627678c0dc0$export$a6e5100ca2770191);
$parcel$export(module.exports, "isInProgressStreamResponse", () => $d5124627678c0dc0$export$5c1c15675df13ae5);
$parcel$export(module.exports, "isStreamError", () => $d5124627678c0dc0$export$d422a2733a3b5def);
$parcel$export(module.exports, "isStreamAUPError", () => $d5124627678c0dc0$export$1e1cf807ece63df4);
$parcel$export(module.exports, "isStreamAnswerPart", () => $d5124627678c0dc0$export$e45102edbc73b240);
$parcel$export(module.exports, "isStreamReasoningPart", () => $d5124627678c0dc0$export$51a109436d382715);
$parcel$export(module.exports, "isStreamActionPart", () => $d5124627678c0dc0$export$dbf4211c9117b9bc);
$parcel$export(module.exports, "isStreamActionClassification", () => $d5124627678c0dc0$export$3d7b0b359441d5a6);
$parcel$export(module.exports, "isStreamActionPrepare", () => $d5124627678c0dc0$export$584e11c2903f4ed6);
$parcel$export(module.exports, "isStreamActionComplete", () => $d5124627678c0dc0$export$7d94ce53d589f586);
$parcel$export(module.exports, "isStreamResearchStart", () => $d5124627678c0dc0$export$abec64f24e2ec3e7);
$parcel$export(module.exports, "isStreamResearchBeginningTrace", () => $d5124627678c0dc0$export$9c1f93971e9e3fbe);
$parcel$export(module.exports, "isStreamResearchStepContent", () => $d5124627678c0dc0$export$79a0ed7d987faa8f);
$parcel$export(module.exports, "isStreamResearchStepTitle", () => $d5124627678c0dc0$export$7b1c8227569f1a92);
$parcel$export(module.exports, "isStreamResearchPlan", () => $d5124627678c0dc0$export$cde91b49af35d559);
$parcel$export(module.exports, "isStreamTodoSnapshot", () => $d5124627678c0dc0$export$4a6a601f69cf3c74);
$parcel$export(module.exports, "isStreamTaskStatus", () => $d5124627678c0dc0$export$6b0058543411cb3a);
$parcel$export(module.exports, "isStreamResearchStepTitleShort", () => $d5124627678c0dc0$export$ac74da022f74040a);
$parcel$export(module.exports, "isStreamSkillStart", () => $d5124627678c0dc0$export$7898cc38956b9052);
$parcel$export(module.exports, "isStreamSkillEnd", () => $d5124627678c0dc0$export$bb608d13a1268633);
$parcel$export(module.exports, "isStreamFastModeResponseAvailable", () => $d5124627678c0dc0$export$b65c73c7e2d8d96f);
$parcel$export(module.exports, "isStreamFastModeEnabled", () => $d5124627678c0dc0$export$40cf419186312161);
$parcel$export(module.exports, "isStreamRemoveAnswerNow", () => $d5124627678c0dc0$export$a83708fc4401682d);
$parcel$export(module.exports, "isStreamResearchStepSource", () => $d5124627678c0dc0$export$68192da24ac8c141);
$parcel$export(module.exports, "isStreamResearchStepCompleted", () => $d5124627678c0dc0$export$cfccfd17b68ccb0);
$parcel$export(module.exports, "isStreamResearchStepIcons", () => $d5124627678c0dc0$export$1fd230d6956c2575);
$parcel$export(module.exports, "isStreamResearchStepDocument", () => $d5124627678c0dc0$export$3bc697eeff31bdf6);
$parcel$export(module.exports, "isStreamReconnectSupportPart", () => $d5124627678c0dc0$export$c679ee34f7312895);
$parcel$export(module.exports, "isStreamAnswerGenerationType", () => $d5124627678c0dc0$export$b00dd9d0560e29d2);
$parcel$export(module.exports, "isStreamDynamicLayoutSubAgent", () => $d5124627678c0dc0$export$5fa02529cd2ab34c);
$parcel$export(module.exports, "isStreamResearchPayload", () => $d5124627678c0dc0$export$46e0fb5e4b019a49);
$parcel$export(module.exports, "isStreamSkill", () => $d5124627678c0dc0$export$6f74311d40862a9f);
$parcel$export(module.exports, "isStreamMemoryUpdate", () => $d5124627678c0dc0$export$d95e474df0d530df);
$parcel$export(module.exports, "isStreamTrace", () => $d5124627678c0dc0$export$fd5a05be03f147a0);
$parcel$export(module.exports, "isStreamThinkDeeperTriggered", () => $d5124627678c0dc0$export$682514f3a8131b98);
$parcel$export(module.exports, "isFollowUpMessage", () => $d5124627678c0dc0$export$aeae5b4fda357302);
$parcel$export(module.exports, "isStreamAgenticUi", () => $d5124627678c0dc0$export$6275ff996073145e);
$parcel$export(module.exports, "isStreamHeartbeat", () => $d5124627678c0dc0$export$b46beea5c82aa1b9);
$parcel$export(module.exports, "isActionExecutedSuccessfully", () => $d5124627678c0dc0$export$b8391261162989d9);
$parcel$export(module.exports, "isActionResolutionCancelled", () => $d5124627678c0dc0$export$1060c4fa97e34fa7);
$parcel$export(module.exports, "isChannelNotFoundError", () => $d5124627678c0dc0$export$6ce1ccc24e75456f);
$parcel$export(module.exports, "isStreamActionError", () => $d5124627678c0dc0$export$c3c933dad2745d3f);
$parcel$export(module.exports, "isRateLimitedError", () => $d5124627678c0dc0$export$bc96a6a479480590);
$parcel$export(module.exports, "isHipaaError", () => $d5124627678c0dc0$export$f8b1b75846492611);
$parcel$export(module.exports, "isAUPViolationError", () => $d5124627678c0dc0$export$d263dc5d64f36d48);
$parcel$export(module.exports, "isConversationChannelDataMessage", () => $d5124627678c0dc0$export$b454081350f4a578);
$parcel$export(module.exports, "isScopeDeterminedMessage", () => $d5124627678c0dc0$export$145ab74998a54a20);
$parcel$export(module.exports, "isSpaceSourceRecommendationsMessage", () => $d5124627678c0dc0$export$75ceabc5bb9500e4);
$parcel$export(module.exports, "isStreamPromptRedaction", () => $d5124627678c0dc0$export$f4111656f23d9b9b);
$parcel$export(module.exports, "isStreamPromptBlock", () => $d5124627678c0dc0$export$c43cf9ba6a2176ef);
$parcel$export(module.exports, "isStreamResponseRedaction", () => $d5124627678c0dc0$export$f16ff8eb19967a97);
$parcel$export(module.exports, "isStreamResponseBlock", () => $d5124627678c0dc0$export$55f7bd80eacbc51b);
$parcel$export(module.exports, "isStreamAttachmentBlock", () => $d5124627678c0dc0$export$a1be74470d3c1fe9);
$parcel$export(module.exports, "isConfirmAction", () => $d5124627678c0dc0$export$4af48296a8d61cec);

var $THc1u = parcelRequire("THc1u");

var $6SmuL = parcelRequire("6SmuL");
const $d5124627678c0dc0$export$f78edfe5a93b58af = (message)=>{
    return message !== null && typeof message === 'object' && '__isSSEWrapper' in message && message.__isSSEWrapper === true;
};
const $d5124627678c0dc0$export$5945515082cc2cbf = 'convoai.rest.not.found';
const $d5124627678c0dc0$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
var $d5124627678c0dc0$export$2e28f9aa1dcf9823 = /*#__PURE__*/ function(PromptCategory) {
    PromptCategory["ANALYZE"] = "Analyze";
    PromptCategory["BRAINSTORM"] = "Brainstorm";
    PromptCategory["REVIEW"] = "Review";
    PromptCategory["SUMMARIZE"] = "Summarize";
    PromptCategory["CREATE"] = "Create";
    PromptCategory["EXECUTE"] = "Execute";
    PromptCategory["FIND"] = "Find";
    PromptCategory["LEARN"] = "Learn";
    return PromptCategory;
}({});
var $d5124627678c0dc0$export$bd1535eb0caf2683 = /*#__PURE__*/ function(PromptRole) {
    PromptRole["GENERAL"] = "General";
    PromptRole["ENGINEERING"] = "Engineering";
    PromptRole["PRODUCT"] = "Product";
    PromptRole["PROGRAM_MANAGEMENT"] = "Program Management";
    PromptRole["DESIGN"] = "Design";
    PromptRole["MARKETING"] = "Marketing";
    PromptRole["IT_OPS"] = "IT Ops";
    PromptRole["SALES"] = "Sales";
    PromptRole["CUSTOMER_SUPPORT"] = "Customer Support";
    PromptRole["HELPDESK_SUPPORT"] = "Helpdesk Support";
    PromptRole["SECURITY"] = "Security";
    return PromptRole;
}({});
const $d5124627678c0dc0$export$77c9504201bdfdea = 'PROMPT_TILE';
const $d5124627678c0dc0$export$fb661125ffb29bd6 = (message)=>{
    return $d5124627678c0dc0$export$a69fab2afb88c2eb(message) || $d5124627678c0dc0$export$6f965deda7f0960c(message) || $d5124627678c0dc0$export$b4631726cbc1440a(message);
};
const $d5124627678c0dc0$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $d5124627678c0dc0$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $d5124627678c0dc0$export$a6e5100ca2770191 = (message)=>message instanceof Object && $d5124627678c0dc0$export$6f965deda7f0960c(message.message);
const $d5124627678c0dc0$export$5c1c15675df13ae5 = (message)=>$d5124627678c0dc0$export$b4631726cbc1440a(message) && message.message?.message?.async_status === 'IN_PROGRESS';
const $d5124627678c0dc0$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $d5124627678c0dc0$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $d5124627678c0dc0$export$1e1cf807ece63df4 = (message)=>$d5124627678c0dc0$export$d422a2733a3b5def(message) && message.message?.message_template === $d5124627678c0dc0$export$c424fe9570a5f2d9;
const $d5124627678c0dc0$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $d5124627678c0dc0$export$51a109436d382715 = (message)=>message instanceof Object && message.type === 'REASONING_PART';
const $d5124627678c0dc0$export$dbf4211c9117b9bc = (message)=>message instanceof Object && message.type === 'ACTION_PART';
const $d5124627678c0dc0$export$3d7b0b359441d5a6 = (message)=>message instanceof Object && message.type === 'ACTION_CLASSIFICATION';
const $d5124627678c0dc0$export$584e11c2903f4ed6 = (message)=>message instanceof Object && message.type === 'ACTION_PREPARE';
const $d5124627678c0dc0$export$7d94ce53d589f586 = (message)=>message instanceof Object && message.type === 'ACTION_COMPLETE';
const $d5124627678c0dc0$export$abec64f24e2ec3e7 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_START';
const $d5124627678c0dc0$export$9c1f93971e9e3fbe = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $d5124627678c0dc0$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $d5124627678c0dc0$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $d5124627678c0dc0$export$cde91b49af35d559 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_PLAN';
const $d5124627678c0dc0$export$4a6a601f69cf3c74 = (message)=>message instanceof Object && message.type === 'TODO_SNAPSHOT';
const $d5124627678c0dc0$export$6b0058543411cb3a = (message)=>message instanceof Object && message.type === 'TASK_STATUS';
const $d5124627678c0dc0$export$ac74da022f74040a = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT';
const $d5124627678c0dc0$export$7898cc38956b9052 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_START';
const $d5124627678c0dc0$export$bb608d13a1268633 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_END';
const $d5124627678c0dc0$export$b65c73c7e2d8d96f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_RESPONSE_AVAILABLE';
const $d5124627678c0dc0$export$40cf419186312161 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_ENABLED';
const $d5124627678c0dc0$export$a83708fc4401682d = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'REMOVE_ANSWER_NOW';
const $d5124627678c0dc0$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $d5124627678c0dc0$export$cfccfd17b68ccb0 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $d5124627678c0dc0$export$1fd230d6956c2575 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_ICONS';
const $d5124627678c0dc0$export$3bc697eeff31bdf6 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_DOCUMENT';
const $d5124627678c0dc0$export$c679ee34f7312895 = (message)=>message instanceof Object && message.type === 'RECONNECT_SUPPORTED';
const $d5124627678c0dc0$export$b00dd9d0560e29d2 = (message)=>message instanceof Object && message.type === 'ANSWER_GENERATION_TYPE';
const $d5124627678c0dc0$export$5fa02529cd2ab34c = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'DL_SUB_AGENT';
const $d5124627678c0dc0$export$46e0fb5e4b019a49 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE' || message.message.message_template === 'RESEARCH_STEP_ICONS' || message.message.message_template === 'RESEARCH_STEP_DOCUMENT');
const $d5124627678c0dc0$export$6f74311d40862a9f = (message)=>message instanceof Object && message.type === 'TRACE' && ($d5124627678c0dc0$export$7898cc38956b9052(message) || $d5124627678c0dc0$export$bb608d13a1268633(message));
const $d5124627678c0dc0$export$d95e474df0d530df = (message)=>message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'MEMORY_UPDATE';
const $d5124627678c0dc0$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($d5124627678c0dc0$export$46e0fb5e4b019a49(message)) return false;
    if ($d5124627678c0dc0$export$cde91b49af35d559(message)) return false;
    if ($d5124627678c0dc0$export$6f74311d40862a9f(message)) return false;
    if ($d5124627678c0dc0$export$b65c73c7e2d8d96f(message)) return false;
    if ($d5124627678c0dc0$export$682514f3a8131b98(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $d5124627678c0dc0$export$682514f3a8131b98 = (message)=>{
    return message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'THINK_DEEPER_TRIGGERED';
};
const $d5124627678c0dc0$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $d5124627678c0dc0$export$6275ff996073145e = (message)=>{
    if (!$d5124627678c0dc0$export$f78edfe5a93b58af(message) || message.eventType !== 'AGENTIC_UI') return false;
    if (message.data === null || typeof message.data !== 'object') return false;
    const data = message.data;
    return Array.isArray(data.message?.content);
};
const $d5124627678c0dc0$export$b46beea5c82aa1b9 = (message)=>message instanceof Object && message.type === 'HEART_BEAT';
const $d5124627678c0dc0$export$b8391261162989d9 = (message)=>$d5124627678c0dc0$export$6f965deda7f0960c(message) && (message?.message_metadata?.is_action_execution ?? false) && message?.message_metadata?.action_execution_result === 'SUCCESS';
const $d5124627678c0dc0$export$1060c4fa97e34fa7 = (payloadContext)=>{
    return payloadContext?.resolution?.type === 'cancel';
};
const $d5124627678c0dc0$export$6ce1ccc24e75456f = (error)=>(0, $6SmuL.isApiError)(error) && error.errorAttributes?.errorCode === $d5124627678c0dc0$export$5945515082cc2cbf;
const $d5124627678c0dc0$export$c3c933dad2745d3f = (msg)=>msg && msg.type === 'ACTION_ERROR' && msg.message && msg.message.status === 'ERRORED';
const $d5124627678c0dc0$export$bc96a6a479480590 = (error)=>(0, $6SmuL.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $d5124627678c0dc0$export$f8b1b75846492611 = (error)=>(0, $6SmuL.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $THc1u.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $d5124627678c0dc0$export$d263dc5d64f36d48 = (error)=>error instanceof Object && error?.detail?.type === 'ERROR' && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === $d5124627678c0dc0$export$c424fe9570a5f2d9;
const $d5124627678c0dc0$export$b454081350f4a578 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
const $d5124627678c0dc0$export$145ab74998a54a20 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'SCOPE_DETERMINED';
const $d5124627678c0dc0$export$75ceabc5bb9500e4 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
message)=>message instanceof Object && message.type === 'SPACE_SOURCE_RECOMMENDATIONS' && message.message instanceof Object;
const $d5124627678c0dc0$export$f4111656f23d9b9b = (message)=>message instanceof Object && (message.type === 'PROMPT_REDACTION' || message.type === 'PROMPT_REDACTED');
const $d5124627678c0dc0$export$c43cf9ba6a2176ef = (message)=>message instanceof Object && (message.type === 'PROMPT_BLOCKED' || message.type === 'PROMPT_BLOCK');
const $d5124627678c0dc0$export$f16ff8eb19967a97 = (message)=>message instanceof Object && message.type === 'RESPONSE_REDACTION';
const $d5124627678c0dc0$export$55f7bd80eacbc51b = (message)=>message instanceof Object && message.type === 'RESPONSE_BLOCKED';
const $d5124627678c0dc0$export$a1be74470d3c1fe9 = (message)=>message instanceof Object && message.type === 'ATTACHMENT_BLOCKED';
function $d5124627678c0dc0$export$4af48296a8d61cec(payloadContext) {
    return payloadContext?.resolution?.type === 'confirm';
}

});
parcelRegister("THc1u", function(module, exports) {
$parcel$export(module.exports, "ASSISTANCE_SERVICE_ERROR_CODES", () => $613d027f9111a4bd$export$1106bf31edf2a9b8);
$parcel$export(module.exports, "STATUS_CODES", () => $613d027f9111a4bd$export$333e4f57333eadfa);
const $613d027f9111a4bd$export$e8114853eca81277 = 'ai-mate';
const $613d027f9111a4bd$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    AGENT_FORBIDDEN: 'convoai.rest.agent-forbidden',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $613d027f9111a4bd$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415,
    FILE_RAI_POLICY_VIOLATION: 406
};

});


parcelRegister("j5lly", function(module, exports) {
$parcel$export(module.exports, "setRovoChatProduct", () => $5b7409e10ca06688$export$caa27b16709bc2df);
// Dupe of same function from conversation-assistant
// No need to add a whole dependency just for this function
const $5b7409e10ca06688$export$caa27b16709bc2df = (product)=>{
    if (window) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
};

});

parcelRegister("bWLHK", function(module, exports) {
$parcel$export(module.exports, "readJsonStream", () => $e44e8de12e7c4d7a$export$1f24b2b263bcfa75);

var $egspI = parcelRequire("egspI");

var $kKvu4 = parcelRequire("kKvu4");
async function* $e44e8de12e7c4d7a$export$1f24b2b263bcfa75(response) {
    const reader = (0, $kKvu4.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                const json = chunk.startsWith('data: ') && (0, $egspI.fg)('rovo-guard-ui-redaction-and-blocking') ? chunk.slice(6) : chunk;
                yield JSON.parse(json);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}

});
parcelRegister("kKvu4", function(module, exports) {
$parcel$export(module.exports, "getBufferReader", () => $2f3d6f4e9d994db6$export$f6383c3ea1307da9);
const $2f3d6f4e9d994db6$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};

});


parcelRegister("covBG", function(module, exports) {
$parcel$export(module.exports, "readSSEStream", () => $6b703b780c81eb40$export$6dab2f647580dc69);

var $kKvu4 = parcelRequire("kKvu4");
const $6b703b780c81eb40$var$parseSSEMessage = (message)=>{
    const parsed = {};
    const dataLines = [];
    for (const line of message.split('\n')){
        const trimmedLine = line.trim();
        const colonIndex = trimmedLine.indexOf(':');
        if (trimmedLine && colonIndex !== -1) {
            const field = trimmedLine.substring(0, colonIndex);
            const value = trimmedLine.substring(colonIndex + 1).trimStart();
            switch(field){
                case 'event':
                    parsed.eventType = value;
                    break;
                case 'data':
                    dataLines.push(value);
                    break;
                case 'id':
                    parsed.id = value;
                    break;
                default:
                    break;
            }
        }
    }
    if (dataLines.length) parsed.data = dataLines.join('\n');
    return parsed;
};
async function* $6b703b780c81eb40$export$6dab2f647580dc69(response) {
    const reader = (0, $kKvu4.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const combined = `${remainder}${value}`;
            const parts = combined.split('\n\n'); // SSE messages are separated by double newlines
            // the last part may be incomplete — keep it for the next read
            remainder = parts.pop() ?? '';
            for (const chunk of parts)try {
                const parsed = $6b703b780c81eb40$var$parseSSEMessage(chunk);
                if (parsed.data) {
                    const parsedData = JSON.parse(parsed.data);
                    yield {
                        __isSSEWrapper: true,
                        data: parsedData,
                        id: parsed.id,
                        eventType: parsed.eventType
                    };
                }
            } catch  {
            // ignore malformed JSON; keep streaming future valid messages
            }
        }
        // If the stream just ended and we still have a remainder, try to parse it once.
        if (doneStreaming && remainder) try {
            const parsed = $6b703b780c81eb40$var$parseSSEMessage(remainder);
            if (parsed.data) {
                const parsedData = JSON.parse(parsed.data);
                yield {
                    __isSSEWrapper: true,
                    data: parsedData,
                    id: parsed.id,
                    eventType: parsed.eventType
                };
            }
        } catch  {
        // ignore malformed tail
        } finally{
            remainder = '';
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}

});

parcelRegister("kEuUK", function(module, exports) {
$parcel$export(module.exports, "buildEffectiveCapabilities", () => $4e084c786abcfcf6$export$6656e8be041b8747);

var $4LDqh = parcelRequire("4LDqh");

var $egspI = parcelRequire("egspI");
const $4e084c786abcfcf6$export$3b20549d55cda4db = 'store-message-from-user-settings';
const $4e084c786abcfcf6$export$bd10ff38e53e4101 = 'actionable-follow-ups';
const $4e084c786abcfcf6$export$f447b2e2b8f0d61e = 'actionable-follow-ups-stacked';
/**
 * Maps each gated capability to the gate/experiment that enables it. Add new
 * capability/gate pairs here rather than introducing nested ternaries at the
 * call sites.
 */ const $4e084c786abcfcf6$var$GATED_CAPABILITIES = [
    {
        capability: $4e084c786abcfcf6$export$3b20549d55cda4db,
        isEnabled: ()=>(0, $egspI.fg)('ai_mate_store_messages_be_driven')
    }
];
/** Maps an experiment cohort to the capability header it opts the request into. */ const $4e084c786abcfcf6$var$ACTIONABLE_FOLLOW_UPS_CAPABILITY_BY_COHORT = {
    control: undefined,
    inline: $4e084c786abcfcf6$export$bd10ff38e53e4101,
    stacked: $4e084c786abcfcf6$export$f447b2e2b8f0d61e
};
/**
 * Resolves the actionable follow-ups experiment cohort and FIRES an exposure.
 *
 * Exposure is fired here — at the point we decide which capability header to send —
 * so that all cohorts (including `control`, which never receives a `◈` marker from
 * the backend) are exposed equally. Firing on client-side marker detection instead
 * would never expose the control cohort and would imbalance the experiment.
 */ const $4e084c786abcfcf6$var$resolveActionableFollowUpsCohort = ()=>(0, $4LDqh.default).getExperimentValue('rovo_chat_actionable_follow_ups_exp', 'cohort', 'control');
const $4e084c786abcfcf6$export$6656e8be041b8747 = (capabilities)=>{
    const enabledCapabilities = $4e084c786abcfcf6$var$GATED_CAPABILITIES.filter(({ isEnabled: isEnabled })=>isEnabled()).map(({ capability: capability })=>capability);
    const followUpsCapability = $4e084c786abcfcf6$var$ACTIONABLE_FOLLOW_UPS_CAPABILITY_BY_COHORT[$4e084c786abcfcf6$var$resolveActionableFollowUpsCohort()];
    if (followUpsCapability) enabledCapabilities.push(followUpsCapability);
    if (enabledCapabilities.length === 0) return capabilities;
    return Array.from(new Set([
        ...capabilities ?? [],
        ...enabledCapabilities
    ]));
};

});

parcelRegister("fwenQ", function(module, exports) {
$parcel$export(module.exports, "addPath", () => $b3d93910105ad1c5$export$4c25481b843feb0b);
$parcel$export(module.exports, "processResponse", () => $b3d93910105ad1c5$export$21fcb6cfd5628534);

var $6SmuL = parcelRequire("6SmuL");

var $97qmU = parcelRequire("97qmU");
const $b3d93910105ad1c5$export$4c25481b843feb0b = (baseUrl, path)=>{
    if (path === '') // return base url without trailing slash
    return baseUrl;
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
const $b3d93910105ad1c5$var$removeTimestampFromErrorMessage = (errorBodyJson)=>{
    const { timestamp: _timestamp, ...rest } = errorBodyJson;
    return JSON.stringify(rest);
};
const $b3d93910105ad1c5$var$processErrorResponse = async ({ response: response })=>{
    let errorCode;
    let outputErrorMessage;
    const responseText = await response.text();
    let rawErrorMessage;
    try {
        const errorBodyJson = JSON.parse(responseText);
        const { error_code: error_code, error_message: error_message, message_template: message_template, errors: errors, errorMessage: errorMessage, timestamp: timestamp } = errorBodyJson;
        rawErrorMessage = errorMessage ?? error_message;
        if (errors?.length) // Use a single error code for now
        errorCode = errors[0];
        else if (error_code) errorCode = error_code;
        else errorCode = message_template;
        if (!errorCode || !rawErrorMessage) outputErrorMessage = timestamp ? $b3d93910105ad1c5$var$removeTimestampFromErrorMessage(errorBodyJson) : responseText;
        else outputErrorMessage = `${errorCode} - ${rawErrorMessage}`;
    } catch  {
        outputErrorMessage = responseText;
    }
    throw new (0, $6SmuL.ApiError)(`[Code ${response.status}] ${outputErrorMessage}`, {
        errorCode: errorCode,
        statusCode: response.status,
        rawErrorMessage: rawErrorMessage,
        traceId: (0, $97qmU.getTraceIdFromResponse)(response)
    });
};
const $b3d93910105ad1c5$export$21fcb6cfd5628534 = async ({ response: response })=>{
    if (!response.ok || response.status >= 400) await $b3d93910105ad1c5$var$processErrorResponse({
        response: response
    });
    return response;
};

});

parcelRegister("3yg4B", function(module, exports) {
$parcel$export(module.exports, "generateConversationName", () => $8164afcea87e63af$export$11cc4786742ed7c2);
const $8164afcea87e63af$export$11cc4786742ed7c2 = ()=>{
    const date = new Date();
    const formattedDate = date.toLocaleDateString(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const name = `${formattedDate} ${formattedTime}`;
    return name;
};

});

parcelRegister("b07Us", function(module, exports) {
$parcel$export(module.exports, "getId", () => $ab0ffba4106ce5e6$export$218c8c3169c024d2);
$parcel$export(module.exports, "addAnswerPart", () => $ab0ffba4106ce5e6$export$6e5609c05ab74cc7);
$parcel$export(module.exports, "addActionPart", () => $ab0ffba4106ce5e6$export$13b6a4e4e3704011);
$parcel$export(module.exports, "removeSensitiveData", () => $ab0ffba4106ce5e6$export$efd4f6b5d168b654);
$parcel$export(module.exports, "NO_PARENT_MESSAGE_ID", () => $ab0ffba4106ce5e6$export$4c47ae95c311c518);
$parcel$export(module.exports, "createHumanMessage", () => $ab0ffba4106ce5e6$export$4010f996e89e886a);
$parcel$export(module.exports, "toStreamResponse", () => $ab0ffba4106ce5e6$export$3220a4ff7b3a96df);

var $a72sS = parcelRequire("a72sS");

var $hcNg4 = parcelRequire("hcNg4");
const $ab0ffba4106ce5e6$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
const $ab0ffba4106ce5e6$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
    const content = `${response.content}${answerPart.message.content}`;
    // Remove source indexes, e.g [^1^] from the content
    const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
    return {
        ...response,
        content: cleanedContent
    };
};
const $ab0ffba4106ce5e6$var$addAnswerPartAgentResponse = (response, answerPart)=>({
        ...response,
        message: $ab0ffba4106ce5e6$var$addAnswerPartAssistantMessage(response.message, answerPart)
    });
// ****************************************************************************
// Action streaming accumulation configuration
// ****************************************************************************
const $ab0ffba4106ce5e6$var$toPathArr = (path)=>Array.isArray(path) ? path : path.split('.').filter(Boolean);
const $ab0ffba4106ce5e6$var$getAtPath = (obj, path)=>{
    let cur = obj;
    for (const key of path){
        if (!(0, $hcNg4.isRecord)(cur)) return undefined;
        cur = cur[key];
    }
    return cur;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ab0ffba4106ce5e6$var$setAtPath = (obj, path, value)=>{
    if (path.length === 0) return value;
    const [head, ...rest] = path;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const base = obj && typeof obj === 'object' ? obj : {};
    return {
        ...base,
        [head]: $ab0ffba4106ce5e6$var$setAtPath(base[head], rest, value)
    };
};
// Defines which sub-field(s) of a message action's data should be accumulated by string appending.
// Keyed by action key. Values can be a dot path or an array path, or an array of multiple paths.
// E.g.:
// {
//   'create-document-action': 'content',
//   'update-document-action': ['content', 'meta.subtitle']
// }
let $ab0ffba4106ce5e6$var$actionDataAccumulationConfig = {
    ['aifc-confluence-page-create']: 'adf'
};
const $ab0ffba4106ce5e6$export$a1715e22f3105088 = (prev, next)=>{
    const key = next.key;
    const rulePaths = $ab0ffba4106ce5e6$var$actionDataAccumulationConfig[key];
    const prevData = prev?.data;
    const newData = next?.data;
    if (rulePaths && typeof prevData === 'object' && prevData !== null && typeof newData === 'object' && newData !== null) {
        const paths = Array.isArray(rulePaths) ? rulePaths : [
            rulePaths
        ];
        let base = {
            ...newData
        };
        for (const p of paths){
            const pathArr = $ab0ffba4106ce5e6$var$toPathArr(p);
            const prevVal = $ab0ffba4106ce5e6$var$getAtPath(prevData, pathArr);
            const nextVal = $ab0ffba4106ce5e6$var$getAtPath(newData, pathArr);
            const accumulated = String(prevVal ?? '') + String(nextVal ?? '');
            base = $ab0ffba4106ce5e6$var$setAtPath(base, pathArr, accumulated);
        }
        return {
            ...prev,
            data: base,
            status: next.status
        };
    }
    // Default: replace only data from next, keep other fields from prev
    return {
        ...prev,
        data: next.data,
        status: next.status
    };
};
const $ab0ffba4106ce5e6$export$6554ad578994a75f = (actions, actionPart, actionUpdaterOverride)=>{
    const { key: key } = actionPart.message;
    const existingActionIndex = actions.findIndex((action)=>action.key === key);
    if (existingActionIndex === -1) return [
        ...actions || [],
        actionPart.message
    ];
    const updatedActions = [
        ...actions
    ];
    const prevAction = updatedActions[existingActionIndex];
    const nextAction = actionPart.message;
    updatedActions[existingActionIndex] = actionUpdaterOverride ? actionUpdaterOverride(prevAction, nextAction) : $ab0ffba4106ce5e6$export$a1715e22f3105088(prevAction, nextAction);
    return updatedActions;
};
const $ab0ffba4106ce5e6$export$6e5609c05ab74cc7 = (response, answerPart)=>({
        ...response,
        message: $ab0ffba4106ce5e6$var$addAnswerPartAgentResponse(response.message, answerPart)
    });
const $ab0ffba4106ce5e6$export$13b6a4e4e3704011 = (response, actionPart, actionUpdaterOverride)=>{
    const { message: message } = response.message;
    const { actions: actions } = message;
    const isActionsArrayPresent = actions && actions.length > 0;
    return {
        ...response,
        message: {
            ...response.message,
            message: {
                ...message,
                actions: !isActionsArrayPresent ? [
                    actionPart.message
                ] : $ab0ffba4106ce5e6$export$6554ad578994a75f(actions, actionPart, actionUpdaterOverride)
            }
        }
    };
};
const $ab0ffba4106ce5e6$var$removeSensitiveDataAssistantMessage = (message)=>{
    const { plugin_invocations: plugin_invocations, ...rest } = message;
    return {
        ...rest,
        plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                ...pluginInvocation,
                plugin_output: '--PRIVATE--'
            }))
    };
};
const $ab0ffba4106ce5e6$var$removeSensitiveDataAgentResponse = (message)=>({
        ...message,
        message: $ab0ffba4106ce5e6$var$removeSensitiveDataAssistantMessage(message.message)
    });
const $ab0ffba4106ce5e6$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        message: $ab0ffba4106ce5e6$var$removeSensitiveDataAgentResponse(message.message)
    });
const $ab0ffba4106ce5e6$export$4c47ae95c311c518 = '00000000-0000-0000-0000-000000000000';
const $ab0ffba4106ce5e6$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId, fileUploads)=>{
    return {
        role: 'HUMAN',
        id: id,
        content: content,
        time_created: new Date().toISOString(),
        user_ari: 'unknown',
        plugin_invocations: [],
        isFromSeededConversation: isFromSeededConversation,
        requestId: requestId,
        file_uploads: fileUploads
    };
};
const $ab0ffba4106ce5e6$export$3220a4ff7b3a96df = (message)=>{
    if ((0, $a72sS.isAgentResponse)(message)) return {
        type: 'FINAL_RESPONSE',
        message: message
    };
    return {
        type: 'FINAL_RESPONSE',
        message: {
            message: message
        }
    };
};

});


parcelRegister("3Nrnr", function(module, exports) {
$parcel$export(module.exports, "ProductSearchInputSkeletonInteractive", () => $4afe63fca6aa2daa$export$e3798ad624b9f761);
/*
 * An interactive version of the search input skeleton which allows users to
 * type into the skeleton's input.  The state of the skeleton input is saved in
 * the browser's storage (specifically within window.inputSkeletonState).
 * On the first render of this component, this stored state is used as initial
 * an initial state. This behaviour allows one instance of this component
 * to be replaced by another and appear to seamlessly act as a single component.
 *
 * This component is intended to be used for client side rendering only.
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $if8bj = parcelRequire("if8bj");

var $3qjah = parcelRequire("3qjah");
const $4afe63fca6aa2daa$export$e3798ad624b9f761 = (props)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3qjah.ThemeProvider), {
        partialSearchCSS: props.theme,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $if8bj.SearchInputSkeletonInteractive), {
            ...props
        })
    });
};
$4afe63fca6aa2daa$export$e3798ad624b9f761.displayName = "ProductSearchInputSkeletonInteractive";

});
parcelRegister("if8bj", function(module, exports) {
$parcel$export(module.exports, "SearchInputSkeletonInteractive", () => $3f3bae5fbd3e9f26$export$fca483ab36e9fec9);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1zmLE = parcelRequire("1zmLE");

var $lGwuE = parcelRequire("lGwuE");

var $4zsq4 = parcelRequire("4zsq4");

var $7ZDiP = parcelRequire("7ZDiP");
const $3f3bae5fbd3e9f26$export$fca483ab36e9fec9 = ({ placeholder: placeholder, stickySearchEnabled: stickySearchEnabled, onEnter: onEnter, shouldFillContainer: shouldFillContainer })=>{
    // Initialise stored inputSkeletonState if necessary
    const checkedForInputSkeletonState = (0, $euxye.useRef)(false);
    if (!checkedForInputSkeletonState.current) {
        if (!window.inputSkeletonState) (0, $7ZDiP.resetInputSkeletonState)();
        checkedForInputSkeletonState.current = true;
    }
    const searchInputRef = (0, $euxye.useRef)(null);
    // Use the stored state as initial values for expansion and query
    const [isExpanded, setIsExpanded] = (0, $euxye.useState)((0, $7ZDiP.getInputSkeletonFocus)());
    const [value, setValue] = (0, $euxye.useState)(()=>{
        const stickySearchQuery = (0, $4zsq4.getSessionItem)((0, $4zsq4.SEARCH_QUERY_KEY));
        return stickySearchEnabled && stickySearchQuery ? stickySearchQuery : (0, $7ZDiP.getInputSkeletonQuery)();
    });
    // Use the stored state to focus and set selection
    (0, $euxye.useLayoutEffect)(()=>{
        (0, $7ZDiP.removeInputSkeletonEventListeners)();
        const isFoucsed = (0, $7ZDiP.getInputSkeletonFocus)();
        const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $7ZDiP.getInputSkeletonSelection)();
        if (isFoucsed) {
            searchInputRef?.current?.focus();
            searchInputRef?.current?.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
        }
    }, []);
    const onFocus = ()=>{
        setIsExpanded(true);
        (0, $7ZDiP.setInputSkeletonIsFocus)(true);
        searchInputRef?.current?.focus();
    };
    const onBlur = ()=>{
        setIsExpanded(false);
        (0, $7ZDiP.setInputSkeletonIsFocus)(false);
        if (!stickySearchEnabled) {
            setValue('');
            (0, $7ZDiP.setInputSkeletonQuery)('');
            (0, $7ZDiP.setInputSkeletonSelection)(0, 0, 'none');
        }
    };
    const onKeyDown = (e)=>{
        if (e.key === 'Escape') {
            searchInputRef?.current?.blur();
            onBlur();
        }
    };
    const onInput = (newValue)=>{
        setValue(newValue);
        (0, $7ZDiP.setInputSkeletonQuery)(newValue);
        (0, $7ZDiP.setInputSkeletonSelection)(searchInputRef?.current?.selectionStart || 0, searchInputRef?.current?.selectionEnd || 0, searchInputRef?.current?.selectionDirection || 'none');
        if (stickySearchEnabled) (0, $4zsq4.setSessionItem)((0, $4zsq4.SEARCH_QUERY_KEY), newValue);
    };
    const onSelect = ()=>{
        (0, $7ZDiP.setInputSkeletonSelection)(searchInputRef?.current?.selectionStart || 0, searchInputRef?.current?.selectionEnd || 0, searchInputRef?.current?.selectionDirection || 'none');
    };
    // Fixes some instances where callbacks would not be called when the search
    // input is clicked as the component is being destroyed
    (0, $euxye.useEffect)(()=>{
        let storedSearchInputRef = null;
        if (searchInputRef.current) storedSearchInputRef = searchInputRef.current;
        return ()=>{
            if (storedSearchInputRef) {
                (0, $7ZDiP.setInputSkeletonQuery)(storedSearchInputRef.value);
                (0, $7ZDiP.setInputSkeletonIsFocus)(document.activeElement === storedSearchInputRef);
                (0, $7ZDiP.setInputSkeletonSelection)(storedSearchInputRef.selectionStart || 0, storedSearchInputRef.selectionEnd || 0, storedSearchInputRef.selectionDirection || 'none');
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1zmLE.SearchAnchor), {
        isExpanded: isExpanded,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $lGwuE.default), {
            "data-test-id": "search-dialog-input-skeleton-interactive",
            isExpanded: isExpanded,
            placeholder: placeholder,
            onInput: onInput,
            onSelect: onSelect,
            onEnter: onEnter,
            shouldFillContainer: shouldFillContainer,
            value: value,
            ref: searchInputRef
        })
    });
};
$3f3bae5fbd3e9f26$export$fca483ab36e9fec9.displayName = "SearchInputSkeletonInteractive";

});
parcelRegister("1zmLE", function(module, exports) {
$parcel$export(module.exports, "SearchAnchor", () => $dedec23534cfe4f4$export$bc951697710bb35a);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $aAU61 = parcelRequire("aAU61");

var $ktOOB = parcelRequire("ktOOB");

var $3c1l8 = parcelRequire("3c1l8");
const $dedec23534cfe4f4$export$bc951697710bb35a = ({ children: children, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, isExpanded: isExpanded, shouldFillContainer: shouldFillContainer })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $ktOOB.SearchAnchorWrapper), {
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3c1l8.AbsoluteContainer), {
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $aAU61.SearchDialogAnchor), {
                onBlur: onBlur,
                onFocus: onFocus,
                onKeyDown: onKeyDown,
                isExpanded: isExpanded,
                shouldFillContainer: shouldFillContainer,
                children: children
            })
        })
    });
$dedec23534cfe4f4$export$bc951697710bb35a.displayName = "SearchAnchor";

});
parcelRegister("aAU61", function(module, exports) {
$parcel$export(module.exports, "SearchDialogAnchor", () => $69c75a4ccc76602b$export$f565ce1043dae7c9);
$parcel$export(module.exports, "EnlargedSearchAnchorWrapper", () => $69c75a4ccc76602b$export$5566658d36f6ca7b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hStPE = parcelRequire("hStPE");

var $8PMfn = parcelRequire("8PMfn");

var $eTQ2h = parcelRequire("eTQ2h");

var $ktOOB = parcelRequire("ktOOB");

var $3kknN = parcelRequire("3kknN");

const $69c75a4ccc76602b$export$f565ce1043dae7c9 = /*#__PURE__*/ (0, $3kknN.default)('div', {
    target: "exl9bxq1"
})("position:relative;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $hStPE.css)("@media screen and (max-width: ", (0, $8PMfn.dialogPageCentreWidth), "){ position:", props.shouldFillContainer ? 'static' : 'fixed', "; z-index:", (0, $eTQ2h.zIndex).searchDialog, ";left:calc((100% - ", (0, $8PMfn.dialogWidth), ") / 2);;}@media screen and (max-width: ", (0, $8PMfn.dialogPageTakeoverWidth), "px){ ", props.shouldFillContainer && 'position: fixed;', ";top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column;overflow:auto;}");
    return {};
});
const $69c75a4ccc76602b$export$5566658d36f6ca7b = /*#__PURE__*/ (0, $3kknN.default)((0, $ktOOB.SearchAnchorWrapper), {
    target: "exl9bxq0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        height: props.isExpanded ? (0, $8PMfn.enlargedInputFieldHeight).px : (0, $8PMfn.inputFieldHeight).px
    }));

});
parcelRegister("8PMfn", function(module, exports) {
$parcel$export(module.exports, "grid", () => $75d72dd9880ef502$export$85fc379452d91af0);
$parcel$export(module.exports, "atlassianNavigationHeight", () => $75d72dd9880ef502$export$b9930dabfa4a3a3);
$parcel$export(module.exports, "collapsedSearchInputWidth", () => $75d72dd9880ef502$export$f6af7620e8789c39);
$parcel$export(module.exports, "dialogWidth", () => $75d72dd9880ef502$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogPageTakeoverWidth", () => $75d72dd9880ef502$export$ce4512df260a325a);
$parcel$export(module.exports, "dialogPageCentreWidth", () => $75d72dd9880ef502$export$a406031ed42c8e02);
$parcel$export(module.exports, "inputFieldHeight", () => $75d72dd9880ef502$export$e00021bea368c518);
$parcel$export(module.exports, "enlargedInputFieldHeight", () => $75d72dd9880ef502$export$30310ee354b45eb0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line no-barrel-files/no-barrel-files






const $75d72dd9880ef502$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$75d72dd9880ef502$var$AkGrid(multiplier * num),
        half: ()=>$75d72dd9880ef502$var$AkGrid(0.5 * num),
        twice: ()=>$75d72dd9880ef502$var$AkGrid(2 * num)
    });
const $75d72dd9880ef502$export$85fc379452d91af0 = $75d72dd9880ef502$var$AkGrid(1);
const $75d72dd9880ef502$export$b9930dabfa4a3a3 = '56px';
const $75d72dd9880ef502$export$f6af7620e8789c39 = '200px';
const $75d72dd9880ef502$export$64d8573e83b64ff8 = '150px';
const $75d72dd9880ef502$export$a3da89b899389ed8 = '780px';
const $75d72dd9880ef502$export$ce4512df260a325a = 780;
const $75d72dd9880ef502$export$a406031ed42c8e02 = '1130px';
const $75d72dd9880ef502$export$e00021bea368c518 = $75d72dd9880ef502$export$85fc379452d91af0.multiple(4);
const $75d72dd9880ef502$export$30310ee354b45eb0 = $75d72dd9880ef502$export$85fc379452d91af0.multiple(6);

});

parcelRegister("eTQ2h", function(module, exports) {
$parcel$export(module.exports, "zIndex", () => $f7e1696877fc6f23$export$56446adcecbeec34);

var $akMu8 = parcelRequire("akMu8");
const $f7e1696877fc6f23$export$56446adcecbeec34 = {
    searchDialog: (0, $akMu8.layers).dialog()
};

});

parcelRegister("ktOOB", function(module, exports) {
$parcel$export(module.exports, "SearchAnchorWrapper", () => $ac61ee52b7282c7e$export$dfece74a62f1398d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8PMfn = parcelRequire("8PMfn");

var $3kknN = parcelRequire("3kknN");
const $ac61ee52b7282c7e$export$dfece74a62f1398d = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "e1g6liaa0"
})("position:relative;@media screen and (min-width: ", (0, $8PMfn.dialogPageTakeoverWidth) + 1, "px){", (props)=>props.shouldFillContainer ? 'width: 100%;' : 'min-width: 200px;', ";}", (props)=>props.shouldFillContainer ? 'max-width: 780px;' : '', " width:", (0, $8PMfn.inputFieldHeight).px, ";height:", (0, $8PMfn.inputFieldHeight).px, ";");

});


parcelRegister("3c1l8", function(module, exports) {
$parcel$export(module.exports, "AbsoluteContainer", () => $f667f01a6d280e6b$export$36aa0f4a98890c96);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hStPE = parcelRequire("hStPE");

var $eTQ2h = parcelRequire("eTQ2h");

var $3kknN = parcelRequire("3kknN");
const $f667f01a6d280e6b$export$36aa0f4a98890c96 = /*#__PURE__*/ (0, $3kknN.default)('div', {
    target: "ed6gqfz0"
})("", (props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $hStPE.css)({
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        ...props.shouldFillContainer && {
            left: 0
        },
        right: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $eTQ2h.zIndex).searchDialog
    });
    return {};
});

});


parcelRegister("lGwuE", function(module, exports) {
$parcel$export(module.exports, "default", () => $c685f9a230a1dcee$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $hZDXn = parcelRequire("hZDXn");

var $6JMJ2 = parcelRequire("6JMJ2");

var $m9iwH = parcelRequire("m9iwH");

var $3qjah = parcelRequire("3qjah");

var $bbvTB = parcelRequire("bbvTB");

var $ircD9 = parcelRequire("ircD9");

var $2Q0Gl = parcelRequire("2Q0Gl");

var $58Pb1 = parcelRequire("58Pb1");

var $hTHCD = parcelRequire("hTHCD");
const $c685f9a230a1dcee$var$MAX_INPUT_LENGTH = 500;
const $c685f9a230a1dcee$export$55d7609a8f1eccd2 = ({ onInput: onInput, onClick: onClick, onEnter: onEnter, isExpanded: isExpanded, placeholder: placeholder, forwardRef: forwardRef, value: value, theme: theme, tooltipContent: tooltipContent, onBack: onBack, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, exitSearchLabel: exitSearchLabel, clearSearchLabel: clearSearchLabel, onSelect: onSelect, toggleAISearchButton: toggleAISearchButton, shouldFillContainer: shouldFillContainer, disableBoxShadow: disableBoxShadow, ariaLabelContent: ariaLabelContent })=>{
    const handleInput = (e)=>{
        if (onInput) onInput(e.currentTarget.value);
    };
    const handleClick = (e)=>{
        if (onClick) onClick(e);
    };
    const handleTabEnter = (e)=>{
        if (e.key === 'Enter' && onClick) onClick();
    };
    const handleKeyDown = (e)=>{
        if (e.nativeEvent?.isComposing || e.keyCode === 229) return;
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
    };
    const handleSelect = (e)=>{
        if (onSelect) onSelect(e);
    };
    const TooltipComponent = tooltipContent && !isExpanded ? undefined : (0, $58Pb1.HiddenTooltip);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        content: tooltipContent,
        // NOTE: Types in React 18 have changed, `styled(TooltipPrimitive)` is no longer valid
        component: TooltipComponent,
        position: "bottom",
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ircD9.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ircD9.MobileSearchIconWrapper), {
                    isExpanded: isExpanded,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
                        label: "Search",
                        onClick: handleClick,
                        icon: ()=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $bbvTB.SearchIcon), {
                                theme: theme,
                                isExpanded: isExpanded
                            })
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ircD9.DesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: isExpanded,
                    onKeyPress: handleTabEnter,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bbvTB.SearchIcon), {
                        theme: theme,
                        isExpanded: isExpanded
                    })
                }),
                isExpanded && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2Q0Gl.ArrowIconWrapper), {
                    ...theme,
                    onClick: onBack,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6JMJ2))), {
                        label: exitSearchLabel || 'Exit Search',
                        color: "currentColor"
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ircD9.SearchInputField), {
                    "data-test-id": "search-dialog-input",
                    onInput: handleInput,
                    onChange: handleInput,
                    onKeyDown: handleKeyDown,
                    onClick: handleClick,
                    onSelect: handleSelect,
                    isExpanded: isExpanded,
                    placeholder: placeholder,
                    ref: forwardRef || undefined,
                    value: value,
                    maxLength: $c685f9a230a1dcee$var$MAX_INPUT_LENGTH,
                    "aria-label": ariaLabelContent || placeholder,
                    ...disableBoxShadow && {
                        style: {
                            boxShadow: 'none'
                        }
                    },
                    ...theme
                }),
                (showClearButton || !!toggleAISearchButton) && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hTHCD.SearchInputOverlay), {
                    theme: theme,
                    showClearButton: showClearButton,
                    onClear: onClear,
                    allowChangeExpand: allowChangeExpand,
                    clearSearchLabel: clearSearchLabel,
                    toggleAISearchButton: toggleAISearchButton
                })
            ]
        })
    });
};
$c685f9a230a1dcee$export$55d7609a8f1eccd2.displayName = "SearchInput";
const $c685f9a230a1dcee$var$SearchInputWithTheme = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef((props, ref)=>{
    const theme = (0, $3qjah.useTheme)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)($c685f9a230a1dcee$export$55d7609a8f1eccd2, {
        ...props,
        theme: theme,
        forwardRef: ref
    });
});
$c685f9a230a1dcee$var$SearchInputWithTheme.displayName = 'SearchInput';
var $c685f9a230a1dcee$export$2e2bcd8739ae039 = $c685f9a230a1dcee$var$SearchInputWithTheme;

});
parcelRegister("3qjah", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $0622ad9a476ac89c$export$d8964aec282183a3);
$parcel$export(module.exports, "useTheme", () => $0622ad9a476ac89c$export$93d4e7f90805808f);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $6Fltw = parcelRequire("6Fltw");
/**
 * Pls see the function generateTheme inside - atlassian-frontend/packages/navigation/atlassian-navigation/src/theme/themeGenerator.ts
 * This default generator should overwrite the exact same properties which are being produced by the theme generator.
 */ const $0622ad9a476ac89c$export$e6c62eb05a8288ed = {
    default: {
        default: {
            backgroundColor: "var(--ds-background-input, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)",
            borderColor: "var(--ds-border-input, #8C8F97)",
            borderWidth: "var(--ds-border-width, 1px)",
            iconColor: "var(--ds-icon-subtle, #505258)"
        },
        focus: {
            borderColor: "var(--ds-border-focused, #4688EC)",
            backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-input, #8C8F97)"}`
        },
        hover: {
            backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
        }
    }
};
const $0622ad9a476ac89c$var$getTheme = (searchCSS)=>{
    if (!searchCSS) return $0622ad9a476ac89c$export$e6c62eb05a8288ed.default;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))({}, $0622ad9a476ac89c$export$e6c62eb05a8288ed.default, searchCSS);
};
const $0622ad9a476ac89c$var$ctx = /*#__PURE__*/ (0, $euxye.createContext)($0622ad9a476ac89c$export$e6c62eb05a8288ed.default);
const $0622ad9a476ac89c$export$d8964aec282183a3 = ({ value: value, partialSearchCSS: partialSearchCSS, children: children })=>{
    const theme = $0622ad9a476ac89c$var$getTheme(partialSearchCSS || value);
    return /*#__PURE__*/ (0, $e79Pd.jsx)($0622ad9a476ac89c$var$ctx.Provider, {
        value: theme,
        children: children
    });
};
$0622ad9a476ac89c$export$d8964aec282183a3.displayName = "ThemeProvider";
const $0622ad9a476ac89c$export$93d4e7f90805808f = ()=>{
    return (0, $euxye.useContext)($0622ad9a476ac89c$var$ctx);
};
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $0622ad9a476ac89c$export$f9bb738f552c610d = $0622ad9a476ac89c$var$ctx;
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $0622ad9a476ac89c$export$62640b580a501775 = (suppliedTheme)=>{
    return suppliedTheme;
};

});

parcelRegister("bbvTB", function(module, exports) {
$parcel$export(module.exports, "SearchIcon", () => $5ef4ecdb4f1269d6$export$82eafebb825fc23f);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $eAQb7 = parcelRequire("eAQb7");
const $5ef4ecdb4f1269d6$export$82eafebb825fc23f = ({ isExpanded: isExpanded, theme: theme, primaryColor: primaryColor = "var(--ds-text, #292A2E)", label: label = '' })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAQb7))), {
        label: label,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : theme.default.color
    });
$5ef4ecdb4f1269d6$export$82eafebb825fc23f.displayName = "SearchIcon";

});

parcelRegister("ircD9", function(module, exports) {
$parcel$export(module.exports, "MobileSearchIconWrapper", () => $469bf51da883a782$export$63e083aca343a6ae);
$parcel$export(module.exports, "DesktopSearchIconWrapper", () => $469bf51da883a782$export$9673cb6b61244e6e);
$parcel$export(module.exports, "SearchInputContainer", () => $469bf51da883a782$export$c2b37b18a8b54130);
$parcel$export(module.exports, "SearchInputField", () => $469bf51da883a782$export$b6261a2c5ea449d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hStPE = parcelRequire("hStPE");

var $8PMfn = parcelRequire("8PMfn");

var $48Ol3 = parcelRequire("48Ol3");

var $3kknN = parcelRequire("3kknN");










function $469bf51da883a782$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $469bf51da883a782$var$expandedPlaceholderColor = "var(--ds-text-subtlest, #6B6E76)";
const $469bf51da883a782$export$63e083aca343a6ae = /*#__PURE__*/ (0, $3kknN.default)("span", {
    target: "eq4kchp3"
})("display:none;@media screen and (max-width: ", (0, $8PMfn.dialogPageTakeoverWidth), "px){display:", (props)=>props.isExpanded ? 'none' : 'block', ";}");
const $469bf51da883a782$export$9673cb6b61244e6e = /*#__PURE__*/ (0, $3kknN.default)('span', {
    target: "eq4kchp2"
})("width:", (0, $8PMfn.grid).multiple(2).px, ";height:", (0, $8PMfn.grid).multiple(2).px, ";position:absolute;top:", (0, $8PMfn.grid).px, ";left:", (0, $8PMfn.grid).px, ";color:", (props)=>props.isExpanded ? "var(--ds-text, #292A2E)" : props.default.color, ";display:inline-flex;align-items:baseline;:focus{box-shadow:0 0 0 2px var(--ds-border-focused, #4688EC);border-radius:var(--ds-radius-full, 9999px);outline:none;}&>span[role='img']{line-height:0;}@media screen and (max-width: ", (0, $8PMfn.dialogPageTakeoverWidth), "px){display:none;}");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $469bf51da883a782$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $469bf51da883a782$export$c2b37b18a8b54130 = /*#__PURE__*/ (0, $3kknN.default)('div', {
    target: "eq4kchp1"
})(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $hStPE.css)("position:relative;max-width:100%; @media screen and (max-width: ", (0, $8PMfn.dialogPageTakeoverWidth), "px){ width:100%;}"), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const boundedStyles = /*#__PURE__*/ (0, $hStPE.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        width: props.isExpanded ? (0, $8PMfn.dialogWidth) : (0, $8PMfn.collapsedSearchInputWidth)
    });
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const fluidStyles = $469bf51da883a782$var$_ref;
    const styles = props.shouldFillContainer ? fluidStyles : boundedStyles;
    // todo - this should be another class
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $hStPE.css)(styles, " @media screen and (max-width: ", (0, $8PMfn.dialogPageTakeoverWidth), "px){width:100%;height:", (0, $8PMfn.atlassianNavigationHeight), ";background-color:", props.default.backgroundColor, "; display:flex;align-items:center;max-width:initial;}");
    return styles;
});
const $469bf51da883a782$export$b6261a2c5ea449d = /*#__PURE__*/ (0, $3kknN.default)("input", {
    target: "eq4kchp0"
})("height:", (0, $8PMfn.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:var(--ds-radius-medium, 6px);/* Refer to @atlaskit/textfield for more details */font:var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);", (props)=>`
    border: ${"var(--ds-border-width, 1px)"} solid ${props.isExpanded ? props.focus.borderColor : props.default.borderColor};
    box-shadow: ${props.isExpanded ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${props.focus.borderColor}, -12px 0 24px 0 ${props.default.backgroundColor}` : 'none'};
    background-color: ${props.isExpanded ? props.focus.backgroundColor : props.default.backgroundColor};
    color: ${props.isExpanded ? props.focus.color : props.default.color};

    &::placeholder {
      color: ${props.isExpanded ? $469bf51da883a782$var$expandedPlaceholderColor : props.default.color};
    }
    :focus {
      border: ${"var(--ds-border-width, 1px)"} solid ${props.focus.borderColor};
    }
    @media screen and (max-width: ${0, $8PMfn.dialogPageTakeoverWidth}px) {
      ${props.isExpanded ? `
            padding: 0 ${(0, $8PMfn.grid).multiple(1.5).px} ${(0, $8PMfn.grid).multiple(0.25).px};
            margin: 0 ${(0, $8PMfn.grid).multiple(3).px} 0 0;` : `
            display: none;
          `}
    }
  `, " ", (0, $48Ol3.media).above.xs, "{font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);}");

});

parcelRegister("2Q0Gl", function(module, exports) {
$parcel$export(module.exports, "ArrowIconWrapper", () => $03d752c8fb9a5a3e$export$54c466678ae7c638);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8PMfn = parcelRequire("8PMfn");

var $3kknN = parcelRequire("3kknN");
const $03d752c8fb9a5a3e$export$54c466678ae7c638 = /*#__PURE__*/ (0, $3kknN.default)('div', {
    target: "eseem520"
})("display:none;margin:0 ", (0, $8PMfn.grid).px, ";height:", (0, $8PMfn.grid).multiple(4).px, ";padding-bottom:", (0, $8PMfn.grid).multiple(0.25).px, ";color:", (props)=>props.default.color, ";@media screen and (max-width: ", (0, $8PMfn.dialogPageTakeoverWidth), "px){display:flex;align-items:center;}:hover{border-radius:var(--ds-radius-full, 9999px);background-color:", (props)=>props.hover.backgroundColor, ";color:", (props)=>props.hover.color, ";}");

});

parcelRegister("58Pb1", function(module, exports) {
$parcel$export(module.exports, "HiddenTooltip", () => $df10d288ddeb50a3$export$ca6fe3402791d08e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8qjTI = parcelRequire("8qjTI");

var $3kknN = parcelRequire("3kknN");
function $df10d288ddeb50a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $df10d288ddeb50a3$export$ca6fe3402791d08e = /*#__PURE__*/ (0, $3kknN.default)((0, $8qjTI.default), {
    target: "e1rbdgxr0"
})({
    name: "eivff4",
    styles: "display:none"
});

});

parcelRegister("hTHCD", function(module, exports) {
$parcel$export(module.exports, "SearchInputOverlay", () => $16ea5e565df11918$export$bde709da22d710bb);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $2fyxq = parcelRequire("2fyxq");

var $hDOjr = parcelRequire("hDOjr");

var $9qT28 = parcelRequire("9qT28");
const $16ea5e565df11918$export$bde709da22d710bb = ({ theme: theme, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, clearSearchLabel: clearSearchLabel, toggleAISearchButton: toggleAISearchButton })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $hDOjr.InputBoxOverlayRight), {
        children: [
            showClearButton && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2fyxq.ClearIconWrapper), {
                ...theme,
                role: "button",
                onClick: onClear,
                onMouseEnter: ()=>{
                    allowChangeExpand?.(false);
                },
                onMouseLeave: ()=>{
                    allowChangeExpand?.(true);
                },
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9qT28))), {
                    color: "currentColor",
                    label: clearSearchLabel || 'Clear search session'
                })
            }),
            toggleAISearchButton
        ]
    });
};
$16ea5e565df11918$export$bde709da22d710bb.displayName = "SearchInputOverlay";

});
parcelRegister("2fyxq", function(module, exports) {
$parcel$export(module.exports, "ClearIconWrapper", () => $20fda2e5361db31d$export$ff9b1a25d343474d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8PMfn = parcelRequire("8PMfn");

var $3kknN = parcelRequire("3kknN");
const $20fda2e5361db31d$export$ff9b1a25d343474d = /*#__PURE__*/ (0, $3kknN.default)('div', {
    target: "egczgaz0"
})("width:", (0, $8PMfn.grid).multiple(2).px, ";height:", (0, $8PMfn.grid).multiple(2).px, ";padding:5px var(--ds-space-075, 6px);color:var(--ds-text-subtlest, #6B6E76);background-color:transparent;@media screen and (max-width: ", (0, $8PMfn.dialogPageTakeoverWidth), "px){display:none;}:hover{cursor:pointer;color:var(--ds-icon, #292A2E);}&>span>svg{vertical-align:unset;}");

});

parcelRegister("hDOjr", function(module, exports) {
$parcel$export(module.exports, "InputBoxOverlayRight", () => $68b103f05acbac20$export$1da38d078e896a10);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8PMfn = parcelRequire("8PMfn");

var $3kknN = parcelRequire("3kknN");
const $68b103f05acbac20$export$1da38d078e896a10 = /*#__PURE__*/ (0, $3kknN.default)('div', {
    target: "eq5o9i0"
})("position:absolute;display:flex;top:0;right:0;height:100%;align-items:center;margin:auto 0;@media screen and (max-width: ", (0, $8PMfn.dialogPageTakeoverWidth), "px){right:24px;}");

});





parcelRegister("eMVka", function(module, exports) {
$parcel$export(module.exports, "nowrapEllipsis", () => $5c347dfb6c7085ae$export$b6b16ffe83ef4b56);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $5c347dfb6c7085ae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5c347dfb6c7085ae$export$b6b16ffe83ef4b56 = {
    name: "sqm42b",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};

});

parcelRegister("kwS5g", function(module, exports) {
$parcel$export(module.exports, "SSRsearchInputField", () => $f6c628fe2d9f54e8$export$6d53dccb772ed720);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8PMfn = parcelRequire("8PMfn");

var $3kknN = parcelRequire("3kknN");
const $f6c628fe2d9f54e8$export$6d53dccb772ed720 = /*#__PURE__*/ (0, $3kknN.default)('input', {
    target: "e1tlzr8c0"
})("height:", (0, $8PMfn.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:var(--ds-radius-medium, 6px);font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);border:", ()=>`${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-input, #8C8F97)"}`, ";background-color:var(--ds-background-input, #FFFFFF);color:var(--ds-text-subtlest, #6B6E76);:hover{background-color:var(--ds-background-input-hovered, #F8F8F8);}:focus{color:var(--ds-text, #292A2E);box-shadow:", ()=>`inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-input, #8C8F97)"}`, ";}@media screen and (max-width: ", (0, $8PMfn.dialogPageTakeoverWidth), "px){display:none;}");

});

parcelRegister("dmH8X", function(module, exports) {
$parcel$export(module.exports, "SSRsearchInputWrapper", () => $a324ea982da3bba9$export$c47d4a3e1f1297f1);

var $3kknN = parcelRequire("3kknN");
const $a324ea982da3bba9$export$c47d4a3e1f1297f1 = /*#__PURE__*/ (0, $3kknN.default)('div', {
    target: "e4ak8mg0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
(props)=>({
        position: 'relative',
        height: '32px',
        '@media screen and (min-width: 781px)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            minWidth: props.shouldFillContainer ? '100%' : '200px'
        }
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
(props)=>props.shouldFillContainer ? 'width: 100%;' : '');

});

parcelRegister("gpdsP", function(module, exports) {
$parcel$export(module.exports, "SSRformContainer", () => $397c5a106b582bb4$export$58ae19ee1fc7be8a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3kknN = parcelRequire("3kknN");
function $397c5a106b582bb4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $397c5a106b582bb4$export$58ae19ee1fc7be8a = /*#__PURE__*/ (0, $3kknN.default)('div', {
    target: "ehrlot50"
})({
    name: "bjn8wh",
    styles: "position:relative"
});

});

parcelRegister("hg4cw", function(module, exports) {
$parcel$export(module.exports, "SSRsearchInputContainer", () => $e1fc0d47938a8a26$export$b40f2abde293e8e4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8PMfn = parcelRequire("8PMfn");

var $3kknN = parcelRequire("3kknN");
const $e1fc0d47938a8a26$export$b40f2abde293e8e4 = /*#__PURE__*/ (0, $3kknN.default)('div', {
    target: "e1rxq6i70"
})("position:relative;max-width:100%;@media screen and (max-width: ", (0, $8PMfn.dialogPageTakeoverWidth), "px){width:100%;}width:", (props)=>{
    if (props.shouldFillContainer) return '100%';
    return 0, $8PMfn.collapsedSearchInputWidth;
}, ";");

});

parcelRegister("gmVEh", function(module, exports) {
$parcel$export(module.exports, "SSRdesktopSearchIconWrapper", () => $1e5488258fecf7a4$export$eb4e9f55bbe045df);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8PMfn = parcelRequire("8PMfn");

var $3kknN = parcelRequire("3kknN");
const $1e5488258fecf7a4$export$eb4e9f55bbe045df = /*#__PURE__*/ (0, $3kknN.default)('span', {
    target: "ex7lok0"
})("width:", (0, $8PMfn.grid).multiple(2).px, ";height:", (0, $8PMfn.grid).multiple(2).px, ";position:absolute;top:", (0, $8PMfn.grid).px, ";left:", (0, $8PMfn.grid).px, ";color:rgb(107, 119, 140);display:inline-flex;align-items:baseline;@media screen and (max-width: ", (0, $8PMfn.dialogPageTakeoverWidth), "px){display:none;}");

});

parcelRegister("cvGTM", function(module, exports) {
$parcel$export(module.exports, "SSRmobileSearchIconWrapper", () => $7792691b25a64e71$export$3f33ed4b273b43d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8PMfn = parcelRequire("8PMfn");

var $3kknN = parcelRequire("3kknN");
const $7792691b25a64e71$export$3f33ed4b273b43d = /*#__PURE__*/ (0, $3kknN.default)('span', {
    target: "e12qszb40"
})("display:none;padding:", (0, $8PMfn.grid).multiple(0.5).px, ";padding-right:var(--ds-space-025, 2px);color:rgb(52, 69, 99);@media screen and (max-width: ", (0, $8PMfn.dialogPageTakeoverWidth), "px){display:flex;}");

});

parcelRegister("auByz", function(module, exports) {
$parcel$export(module.exports, "getRovoParams", () => $cc70d424c6b18ad6$export$6405071f390601f7);
$parcel$export(module.exports, "updatePageRovoParams", () => $cc70d424c6b18ad6$export$4a302fc7d977f7b3);
$parcel$export(module.exports, "addRovoParamsToUrl", () => $cc70d424c6b18ad6$export$ef04687636c850fe);
$parcel$export(module.exports, "encodeRovoParams", () => $cc70d424c6b18ad6$export$eddc20a009406015);

var $9YrjR = parcelRequire("9YrjR");
const $cc70d424c6b18ad6$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $cc70d424c6b18ad6$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $cc70d424c6b18ad6$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $cc70d424c6b18ad6$export$9748efee331ec573 = (param)=>`${0, $9YrjR.ROVO_PARAM_PREFIX}${$cc70d424c6b18ad6$export$fda91e425d265029(param)}`;
const $cc70d424c6b18ad6$export$f2888183a34644d4 = (param)=>{
    return $cc70d424c6b18ad6$export$858653b7ee3cbb17(param.replace((0, $9YrjR.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $cc70d424c6b18ad6$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $cc70d424c6b18ad6$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $9YrjR.ROVO_PARAM_PREFIX))) return;
        const paramKey = $cc70d424c6b18ad6$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $cc70d424c6b18ad6$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $cc70d424c6b18ad6$var$processParams(q).rovoParams;
    } catch  {
        return {};
    }
};
const $cc70d424c6b18ad6$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $cc70d424c6b18ad6$export$ef04687636c850fe(window.location.pathname, params));
};
const $cc70d424c6b18ad6$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $cc70d424c6b18ad6$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $cc70d424c6b18ad6$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $cc70d424c6b18ad6$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$cc70d424c6b18ad6$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).filter(([_, value])=>value !== undefined).map(([key, value])=>{
        return `${$cc70d424c6b18ad6$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $cc70d424c6b18ad6$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $cc70d424c6b18ad6$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $9YrjR.ROVO_VALID_PARAMS).map((param)=>`${$cc70d424c6b18ad6$export$9748efee331ec573(param)}${suffix}`);
};

});
parcelRegister("9YrjR", function(module, exports) {
$parcel$export(module.exports, "ROVO_PARAM_PREFIX", () => $b43720fb837fa61e$export$5a550907ffbc9119);
$parcel$export(module.exports, "ROVO_VALID_PARAMS", () => $b43720fb837fa61e$export$3cd6b610e7ede579);
const $b43720fb837fa61e$export$5a550907ffbc9119 = 'rovoChat';
const $b43720fb837fa61e$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt',
    'promptLibraryOpen',
    'openChatMode'
];

});


parcelRegister("1U1HH", function(module, exports) {
$parcel$export(module.exports, "ARTICLE_TYPE", () => $0f5975c441f1fd32$export$a72bfd9b1e5592c8);
var $0f5975c441f1fd32$export$a72bfd9b1e5592c8 = /*#__PURE__*/ function(ARTICLE_TYPE) {
    ARTICLE_TYPE["HELP_ARTICLE"] = "HELP_ARTICLE";
    ARTICLE_TYPE["WHATS_NEW"] = "WHATS_NEW";
    return ARTICLE_TYPE;
}({});

});

parcelRegister("3XwjJ", function(module, exports) {
$parcel$export(module.exports, "ChatContextSubscriber", () => $c08c831d2e2da4d6$export$29ff0802eb3bb217);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $9ll9z = parcelRequire("9ll9z");

var $a8Sah = parcelRequire("a8Sah");
const $c08c831d2e2da4d6$export$29ff0802eb3bb217 = ()=>{
    const { setEditorContext: setEditorContext, setBrowserContext: setBrowserContext, setDashboardContext: setDashboardContext, setAIFeatureContext: setAIFeatureContext, setJiraCreateContext: setJiraCreateContext, mergeDatabaseContext: mergeDatabaseContext, setPageSmartLinks: setPageSmartLinks } = (0, $a8Sah.useChatContextStoreActions)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9ll9z.Subscriber), {
        topic: "ai-mate",
        onEvent: async (payload)=>{
            // TODO https://product-fabric.atlassian.net/browse/AIM-1989 implement experience tracker
            try {
                switch(payload.type){
                    case 'editor-context-payload':
                        setEditorContext(payload.data);
                        break;
                    case 'browser-context-payload':
                        setBrowserContext(payload.data);
                        break;
                    case 'dashboard-insights-actions':
                        setDashboardContext(payload.data);
                        break;
                    case 'database-context-payload':
                        mergeDatabaseContext(payload.data);
                        break;
                    case 'set-message-context':
                        setAIFeatureContext(payload.data);
                        break;
                    case 'jira-create-context-payload':
                        setJiraCreateContext(payload.data);
                        break;
                    case 'smartlinks-context-payload':
                        setPageSmartLinks(payload.data);
                        break;
                    default:
                }
            } catch  {}
        }
    });
};
$c08c831d2e2da4d6$export$29ff0802eb3bb217.displayName = "ChatContextSubscriber";

});
parcelRegister("a8Sah", function(module, exports) {
$parcel$export(module.exports, "useChatContextStoreActions", () => $91a1d902c69b096a$export$53bf948a400e8426);
$parcel$export(module.exports, "useChatContextEditorContext", () => $91a1d902c69b096a$export$9465f65715425f1b);
$parcel$export(module.exports, "useChatContextDatabaseContext", () => $91a1d902c69b096a$export$debe3dc2612d2a8e);
$parcel$export(module.exports, "useChatContextBrowserContext", () => $91a1d902c69b096a$export$376b2a7bf70dad8);
$parcel$export(module.exports, "useChatContextPageSmartLinks", () => $91a1d902c69b096a$export$6280f21050465fe4);
$parcel$export(module.exports, "useChatContextAIFeatureContext", () => $91a1d902c69b096a$export$3794ec8d9f571031);
$parcel$export(module.exports, "useChatContextProvider", () => $91a1d902c69b096a$export$904052abb7b98535);

var $euxye = parcelRequire("euxye");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $4LDqh = parcelRequire("4LDqh");

var $egspI = parcelRequire("egspI");
const $91a1d902c69b096a$export$6f57813fe9f31bf9 = (0, $5QDqc.createStore)({
    initialState: {
        editorContext: undefined,
        whiteboardContext: undefined,
        slidesContext: undefined,
        databaseContext: undefined,
        browserContext: undefined,
        dashboardContext: undefined,
        jiraWorkflowContext: undefined,
        aiFeatureContext: {},
        isAIFeatureContextDismissed: false,
        contentTargets: {},
        currentTargetId: undefined,
        pageSmartLinks: undefined
    },
    actions: {
        getAllContext: ()=>({ getState: getState })=>getState(),
        getAIFeatureContext: ()=>({ getState: getState })=>{
                const currentState = getState().aiFeatureContext;
                // Delete all properties that are undefined
                Object.keys(currentState).forEach((key)=>currentState[key] === undefined && delete currentState[key]);
                // Avoid sending an empty object
                return Object.keys(currentState).length ? currentState : undefined;
            },
        setAIFeatureContext: (chatContextData)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                // Honour the user's explicit "Remove context" action
                if (state.isAIFeatureContextDismissed) return;
                const currentAIFeatureContextState = state.aiFeatureContext;
                const { contextKey: contextKey, setContext: setContext } = chatContextData;
                if (contextKey) {
                    const contextUpdated = setContext(currentAIFeatureContextState[contextKey]);
                    setState({
                        aiFeatureContext: {
                            ...currentAIFeatureContextState,
                            [contextKey]: contextUpdated
                        }
                    });
                }
            },
        setAIFeatureContextDismissed: (isDismissed)=>({ setState: setState })=>{
                setState(isDismissed ? {
                    aiFeatureContext: {},
                    isAIFeatureContextDismissed: true
                } : {
                    isAIFeatureContextDismissed: false
                });
            },
        getDashboardContext: ()=>({ getState: getState })=>getState().dashboardContext,
        setDashboardContext: (dashboardContext)=>({ setState: setState })=>{
                setState({
                    dashboardContext: dashboardContext
                });
            },
        getJiraWorkflowContext: ()=>({ getState: getState })=>getState().jiraWorkflowContext,
        setJiraWorkflowContext: (jiraWorkflowContext)=>({ setState: setState })=>{
                setState({
                    jiraWorkflowContext: jiraWorkflowContext
                });
            },
        getJiraCreateContext: ()=>({ getState: getState })=>getState().jiraCreateContext,
        setJiraCreateContext: (jiraCreateContext)=>({ setState: setState })=>{
                setState({
                    jiraCreateContext: jiraCreateContext
                });
            },
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        getWhiteboardContext: ()=>({ getState: getState })=>getState().whiteboardContext,
        setWhiteboardContext: (whiteboardContext)=>({ setState: setState })=>{
                setState({
                    whiteboardContext: whiteboardContext
                });
            },
        getSlidesContext: ()=>({ getState: getState })=>getState().slidesContext,
        setSlidesContext: (slidesContext)=>({ setState: setState })=>{
                setState({
                    slidesContext: slidesContext
                });
            },
        getDatabaseContext: ()=>({ getState: getState })=>getState().databaseContext,
        setDatabaseContext: (databaseContext)=>({ setState: setState })=>{
                setState({
                    databaseContext: databaseContext
                });
            },
        mergeDatabaseContext: (partial)=>({ getState: getState, setState: setState })=>{
                // If no selected elements published, clean up the database context
                if (!partial?.selectedElementIds) {
                    setState({
                        databaseContext: undefined
                    });
                    return;
                }
                const current = getState().databaseContext;
                setState({
                    databaseContext: current ? {
                        ...current,
                        ...partial
                    } : partial
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            },
        setPageSmartLinks: (pageSmartLinks)=>({ setState: setState })=>{
                setState({
                    pageSmartLinks: pageSmartLinks
                });
            },
        getTarget: (contentContext, activeTargetId)=>({ getState: getState })=>{
                const targets = getState().contentTargets[contentContext];
                if (!targets) return undefined;
                // targets is always an array
                const targetList = targets;
                // If activeTargetId provided, find it; otherwise return first target
                if (activeTargetId) return targetList.find((t)=>t.id === activeTargetId);
                return targetList[0];
            },
        getContentContext: (contentId)=>({ getState: getState })=>{
                const entries = Object.entries(getState().contentTargets);
                for (const [context, targets] of entries){
                    const targetList = targets;
                    if (targetList.some((t)=>t.id === contentId)) return context;
                }
                return undefined;
            },
        getActiveContext: ()=>({ getState: getState })=>{
                const entries = getState().contentTargets;
                // The rules here determine the 'rank' in which Rovo layers are resolved into "which layer is currently active".
                // They map to intended UX - in AIFC, the staging area is a modal-powered experience, on top of global experiences.
                // Consider the scenario of sending a message - the user will be interacting with the topmost layer.
                if (entries['staging-area']) return 'staging-area';
                return 'global';
            },
        hasTarget: (contentContext)=>({ getState: getState })=>!!getState().contentTargets[contentContext],
        setTarget: (toAdd, target)=>({ getState: getState, setState: setState })=>{
                const currentTargets = getState().contentTargets;
                // Store as array, append if not already present
                const existing = currentTargets[toAdd];
                const targetList = existing ?? [];
                // Avoid duplicates by checking if target with same id exists
                // & filter out any targets with empty IDs to avoid stale targets
                const filtered = targetList.filter((t)=>t.id !== '' && t.id !== target.id);
                filtered.push(target);
                setState({
                    contentTargets: {
                        ...currentTargets,
                        [toAdd]: filtered
                    }
                });
            },
        clearTarget: (toRemove, targetId)=>({ getState: getState, setState: setState })=>{
                const currentState = getState().contentTargets;
                const nextState = {};
                for (const key of Object.keys(currentState)){
                    const k = key;
                    if (k !== toRemove) nextState[k] = currentState[k];
                    else if (targetId) {
                        // If a specific targetId is provided, filter out that target
                        const targetList = currentState[k];
                        const filtered = targetList.filter((t)=>t.id !== targetId);
                        if (filtered.length > 0) nextState[k] = filtered;
                    }
                }
                setState({
                    contentTargets: nextState
                });
            },
        setCurrentTargetId: (targetId)=>({ setState: setState })=>{
                setState({
                    currentTargetId: targetId
                });
            },
        getCurrentTargetId: ()=>({ getState: getState })=>getState().currentTargetId
    }
});
const $91a1d902c69b096a$export$53bf948a400e8426 = (0, $3h1FP.createActionsHook)($91a1d902c69b096a$export$6f57813fe9f31bf9);
const $91a1d902c69b096a$export$9465f65715425f1b = (0, $3h1FP.createHook)($91a1d902c69b096a$export$6f57813fe9f31bf9, {
    selector: (state)=>state.editorContext
});
const $91a1d902c69b096a$export$eea520981851a092 = (0, $3h1FP.createHook)($91a1d902c69b096a$export$6f57813fe9f31bf9, {
    selector: (state)=>state.whiteboardContext
});
const $91a1d902c69b096a$export$c517e9a5e436c401 = (0, $3h1FP.createHook)($91a1d902c69b096a$export$6f57813fe9f31bf9, {
    selector: (state)=>state.slidesContext
});
const $91a1d902c69b096a$export$debe3dc2612d2a8e = (0, $3h1FP.createHook)($91a1d902c69b096a$export$6f57813fe9f31bf9, {
    selector: (state)=>state.databaseContext
});
const $91a1d902c69b096a$export$376b2a7bf70dad8 = (0, $3h1FP.createHook)($91a1d902c69b096a$export$6f57813fe9f31bf9, {
    selector: (state)=>state.browserContext
});
const $91a1d902c69b096a$export$6280f21050465fe4 = (0, $3h1FP.createHook)($91a1d902c69b096a$export$6f57813fe9f31bf9, {
    selector: (state)=>state.pageSmartLinks
});
const $91a1d902c69b096a$export$3794ec8d9f571031 = (0, $3h1FP.createHook)($91a1d902c69b096a$export$6f57813fe9f31bf9, {
    selector: (state)=>state.aiFeatureContext
});
const $91a1d902c69b096a$export$904052abb7b98535 = ({ requestBrowserContent: requestBrowserContent, getContentBody: getContentBody, getStagingSpace: getStagingSpace, useCurrentNonEditingPageAsContext: useCurrentNonEditingPageAsContext, requestJiraContext: requestJiraContext })=>{
    const actions = $91a1d902c69b096a$export$53bf948a400e8426();
    const { getTarget: getTarget, getCurrentTargetId: getCurrentTargetId } = actions;
    const fetchContent = (0, $euxye.useCallback)(async (type, contentContext, activeTargetId)=>{
        const currentTargetId = getCurrentTargetId();
        const contentTarget = getTarget(contentContext, activeTargetId);
        if (!contentTarget) return undefined;
        // Only use currentTargetId when staging-area doesn't exist
        // to avoid changing any content open behind the staging
        // area modal
        const shouldUseCurrentTargetId = type === 'page' && !getTarget('staging-area');
        const selectedTargetId = shouldUseCurrentTargetId ? currentTargetId || contentTarget.id : contentTarget.id;
        const contentBody = await getContentBody(type, selectedTargetId);
        if (!contentBody || contentBody.contentType !== type) return undefined;
        switch(contentBody.contentType){
            case 'page':
                {
                    if (!contentBody.pageBody) return undefined;
                    const isViewMode = contentTarget.isViewMode ?? contentBody.isViewMode;
                    return {
                        contentId: contentBody.contentId,
                        editorStreamingContractVersion: contentBody.editorStreamingContractVersion,
                        document: {
                            type: 'text/adf',
                            content: contentBody.pageBody
                        },
                        selection: {
                            type: 'text/markdown',
                            content: contentBody.selectionMarkdown || ''
                        },
                        selectionFragment: contentBody.selectionFragment,
                        selectionLocalIds: contentBody.selectionLocalIds,
                        contentMauiId: contentBody.contentMauiId,
                        dynamicUiSource: contentBody.dynamicUiSource,
                        dynamicUiType: contentBody.dynamicUiType,
                        mediaFileId: contentBody.mediaFileId,
                        isViewMode: isViewMode,
                        isDraftLockedForEditing: contentBody.isDraftLockedForEditing,
                        useGenericEditorSkill: contentBody.useGenericEditorSkill,
                        additionalContext: contentBody.additionalContext
                    };
                }
            case 'whiteboard':
                if (!contentBody.svg || !contentBody.wdf) return undefined;
                return {
                    contentId: contentBody.contentId,
                    type: 'image/svg+xml',
                    svg: contentBody.svg,
                    title: contentBody.title ?? null,
                    url: contentBody.url ?? null,
                    wdf: contentBody.wdf,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'slide':
                if (!contentBody.xml) return undefined;
                return {
                    contentId: contentBody.contentId,
                    xml: contentBody.xml,
                    title: contentBody.title,
                    url: contentBody.url,
                    selectedSlideIndex: contentBody.selectedSlideIndex,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'database':
                if (!contentBody.csv) return undefined;
                return {
                    contentId: contentBody.contentId,
                    csv: contentBody.csv,
                    title: contentBody.title,
                    url: contentBody.url,
                    isViewMode: contentBody.isViewMode
                };
            case 'dashboard':
                if (!contentBody.content) return undefined;
                return {
                    content: contentBody.content,
                    dashboardAri: contentBody.dashboardAri,
                    isEditing: contentBody.isEditing,
                    chartResponseData: contentBody.chartResponseData
                };
            default:
                return undefined;
        }
    }, [
        getContentBody,
        getTarget,
        getCurrentTargetId
    ]);
    /**
	 * Fetches the context of a currently live page with Rovo chat open.
	 *
	 * @description see full list of cases to consider in {@link getContextRequirements}
	 */ const getEditorContext = (0, $euxye.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = (0, $egspI.fg)('aifc_create_enabled');
        const shouldProvideContext = $91a1d902c69b096a$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('page', contentContext, activeTargetId) : actions.getEditorContext();
    }, [
        actions,
        fetchContent
    ]);
    /**
	 * Fetches the context of a currently live page with Rovo chat open.
	 *
	 * @description see full list of cases to consider in {@link getContextRequirements}
	 */ const getWhiteboardContext = (0, $euxye.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = (0, $egspI.fg)('aifc_create_enabled');
        const shouldProvideContext = $91a1d902c69b096a$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('whiteboard', contentContext, activeTargetId) : actions.getWhiteboardContext();
    }, [
        actions,
        fetchContent
    ]);
    const getSlidesContext = (0, $euxye.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = (0, $4LDqh.default).getExperimentValue('cc-mui-slides-experiment', 'isEnabled', false);
        const shouldProvideContext = $91a1d902c69b096a$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('slide', contentContext, activeTargetId) : actions.getSlidesContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDatabaseContext = (0, $euxye.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = (0, $egspI.fg)('aifc_create_enabled');
        const shouldProvideContext = $91a1d902c69b096a$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('database', contentContext, activeTargetId) : actions.getDatabaseContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDashboardEditorContext = (0, $euxye.useCallback)(async ({ contentContext: contentContext, activeTargetId: activeTargetId })=>{
        if (!(0, $egspI.fg)('platform_avp_aifc_enabled')) return undefined;
        return await fetchContent('dashboard', contentContext, activeTargetId);
    }, [
        fetchContent
    ]);
    const getSpaceCreateContext = (0, $euxye.useCallback)(({ contentContext: contentContext, isFirstPrompt: isFirstPrompt })=>{
        if (contentContext === 'staging-area' && !isFirstPrompt && (0, $egspI.fg)('aifc_space_creation_enabled')) return getStagingSpace(String(getTarget(contentContext)?.id));
    }, [
        getStagingSpace,
        getTarget
    ]);
    const getIsStagingArea = (0, $euxye.useCallback)(()=>actions.getActiveContext() === 'staging-area', [
        actions
    ]);
    const useCurrentBrowsingContext = (0, $euxye.useCallback)((addCurrentPageAsContextUserPreference)=>{
        // If the user has explicitly turned off "use current page as context" (e.g.
        // by dismissing the context banner), send false rather than undefined so the
        // backend is explicitly told not to use the browserUrl as context. This is
        // required in edit mode, where useCurrentNonEditingPageAsContext is undefined
        // but the user preference is set to false on dismiss. the value is sent as true
        // when the context is enabled in the chat banner.
        if (addCurrentPageAsContextUserPreference) return addCurrentPageAsContextUserPreference;
        // undefined means don't send useCurrentBrowsingContext at all. false tells backend to explicitly not use the browserUrl as context.
        if (useCurrentNonEditingPageAsContext === undefined) return undefined;
        const stagingAreaEnabled = getIsStagingArea();
        return !stagingAreaEnabled && addCurrentPageAsContextUserPreference && useCurrentNonEditingPageAsContext;
    }, [
        useCurrentNonEditingPageAsContext,
        getIsStagingArea
    ]);
    const getBrowserContext = (0, $euxye.useCallback)(async ({ addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, enabled: enabled })=>{
        // if the feature is not enabled, we return the original context resolution.
        if (!enabled && !(0, $4LDqh.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) return actions.getBrowserContext();
        if (!addCurrentPageAsContextUserPreference) return undefined;
        // Request browser content from the extension
        const browserContextResult = await requestBrowserContent();
        const browserContext = browserContextResult ? {
            context: browserContextResult
        } : actions.getBrowserContext();
        return browserContext;
    }, [
        requestBrowserContent,
        actions
    ]);
    const getJiraContext = (0, $euxye.useCallback)(async ()=>{
        if ((0, $egspI.fg)('jira-aifc-enable-preview-card-in-chat-v2')) {
            const isStagingArea = getIsStagingArea();
            if (!isStagingArea) {
                const jiraCreateContext = actions.getJiraCreateContext();
                if (jiraCreateContext?.draftWorkItems) return jiraCreateContext;
            }
        }
        // Fallback to bridge API if available (staging area doesn't have the state in sync with the chat store)
        if (!requestJiraContext) return undefined;
        try {
            const result = await requestJiraContext();
            return result?.success ? result.context : undefined;
        // eslint-disable-next-line no-unused-vars
        } catch (error) {
            return undefined;
        }
    }, [
        requestJiraContext,
        actions,
        getIsStagingArea
    ]);
    return {
        ...actions,
        getEditorContext: getEditorContext,
        getWhiteboardContext: getWhiteboardContext,
        getSlidesContext: getSlidesContext,
        getSpaceCreateContext: getSpaceCreateContext,
        getIsStagingArea: getIsStagingArea,
        useCurrentBrowsingContext: useCurrentBrowsingContext,
        getDatabaseContext: getDatabaseContext,
        getDashboardEditorContext: getDashboardEditorContext,
        getBrowserContext: getBrowserContext,
        getJiraContext: getJiraContext
    };
};
function $91a1d902c69b096a$export$86d7678a1db25436({ contentContext: contentContext, source: source, isFirstPrompt: isFirstPrompt, isAifcEnabled: isAifcEnabled, userPreference: userPreference }) {
    /**
	 * If AIFC is not enabled, we default to the user's preference.
	 */ if (!isAifcEnabled) return userPreference;
    /**
	 * In the staging area, we always want to provide context if the source is the
	 * inline editor, from the blank object experience, or if the prompt is not the
	 * first in a new conversation.
	 */ const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_MAUI_INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP' || source === 'CONFLUENCE_CWR_TEMPLATE' || source === 'CONFLUENCE_CWR_BLANK_OBJECT';
    if (contentContext === 'staging-area') return sourceEligible || !isFirstPrompt;
    else /**
		 * On real content when AIFC is enabled, we only want to default to true
		 * if the source of the content is the inline editing experience. Otherwise,
		 * we want to respect the preference chosen by the user.
		 */ return sourceEligible || userPreference;
}

});


parcelRegister("6ecZV", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistantUIModes", () => $95b44a4b76af86c0$export$bc36ebf73899a71d);
const $95b44a4b76af86c0$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal',
    FULL_SCREEN_MODAL: 'full-screen-modal'
};

});

parcelRegister("bgVXr", function(module, exports) {
$parcel$export(module.exports, "ChatOpenerSubscriber", () => $1974822793b6c610$export$6fa95a645837361b);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $9ll9z = parcelRequire("9ll9z");

var $auByz = parcelRequire("auByz");

var $6YRFa = parcelRequire("6YRFa");

var $5oGA6 = parcelRequire("5oGA6");
// TODO: Deprecated; teams integrating this event should opt-out of chat open using `openChat` on the core event payload
// Once all teams have opted out the ignoredEvents logic can be removed
const $1974822793b6c610$var$ignoredEvents = new Set([
    'editor-context-payload',
    'browser-context-payload',
    'agent-changed'
]);
const $1974822793b6c610$var$eventsToSkipAnalytics = new Set([
    // This event is fired way too often https://atlassian.slack.com/archives/C06PKQPN8BF/p1729569226011399
    'editor-context-payload',
    'agent-changed'
]);
const $1974822793b6c610$export$6fa95a645837361b = ({ onTriggerOpeningChat: onTriggerOpeningChat })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $5oGA6.useAnalytics)();
    const rovoParams = (0, $euxye.useMemo)(()=>(0, $auByz.getRovoParams)(), []);
    const [triggerOpen, setTriggerOpen] = (0, $euxye.useState)(!!rovoParams?.triggerOpen);
    // Trigger open rovo chat via URL param, respecting openChatMode if provided
    (0, $euxye.useEffect)(()=>{
        try {
            if (!triggerOpen) return;
            if ((0, $egspI.fg)('rovo_chat_openchatmode_query_param')) onTriggerOpeningChat(rovoParams?.conversationId, rovoParams?.openChatMode);
            else onTriggerOpeningChat();
            setTriggerOpen(false);
        } catch (error) {
        // Fail silently
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerOpen
    ]);
    (0, $9ll9z.useSubscribeAll)((payload)=>{
        const { type: type, source: source, openChat: openChat = true } = payload;
        const preventOpen = !openChat || $1974822793b6c610$var$ignoredEvents.has(type);
        if (!$1974822793b6c610$var$eventsToSkipAnalytics.has(type)) sendAnalyticsEvent({
            action: 'eventReceived',
            actionSubject: 'aiMatePubSubEvent',
            source: source,
            attributes: {
                publisherSource: source,
                payloadType: type,
                eventTriggersChatOpen: !preventOpen
            }
        });
        if (preventOpen) return;
        // Extract conversation ID from chat-open events
        const conversationId = type === 'chat-open' && 'data' in payload ? payload.data.channelId : undefined;
        const openChatMode = 'openChatMode' in payload ? payload.openChatMode : undefined;
        if ((0, $egspI.fg)('fix-jira-ai-plugin-dropdown-overlap')) onTriggerOpeningChat(conversationId, openChatMode, source);
        else onTriggerOpeningChat(conversationId, openChatMode);
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e79Pd.Fragment), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6YRFa.RovoPostMessagePubsubListener), {})
    });
};
$1974822793b6c610$export$6fa95a645837361b.displayName = "ChatOpenerSubscriber";

});

parcelRegister("kEMEj", function(module, exports) {
$parcel$export(module.exports, "useRovoEntitlement", () => $f3616571328216f0$export$66d5dd4be64dea43);
$parcel$export(module.exports, "useRovoEntitlementActions", () => $f3616571328216f0$export$8004893135276275);
$parcel$export(module.exports, "RovoEntitlementSetter", () => $f3616571328216f0$export$d03a05ad8547472c);

var $euxye = parcelRequire("euxye");

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $f3616571328216f0$var$rovoEntitlementStore = (0, $5QDqc.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $f3616571328216f0$var$useStateHook = (0, $3h1FP.createStateHook)($f3616571328216f0$var$rovoEntitlementStore);
const $f3616571328216f0$export$66d5dd4be64dea43 = ()=>{
    const result = $f3616571328216f0$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $f3616571328216f0$export$8004893135276275 = (0, $3h1FP.createActionsHook)($f3616571328216f0$var$rovoEntitlementStore);
const $f3616571328216f0$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $f3616571328216f0$export$8004893135276275();
    (0, $euxye.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
$f3616571328216f0$export$d03a05ad8547472c.displayName = "RovoEntitlementSetter";

});

parcelRegister("PLKZi", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistantButton", () => $a1f5c4842828d42a$export$7c328c0993982813);
$parcel$export(module.exports, "ConversationAssistantButtonNav4", () => $a1f5c4842828d42a$export$25e85d244cbf7845);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $1YIbA = parcelRequire("1YIbA");

var $1uH7N = parcelRequire("1uH7N");

var $50OIz = parcelRequire("50OIz");

var $d0kkS = parcelRequire("d0kkS");

var $4LDqh = parcelRequire("4LDqh");

var $eprc4 = parcelRequire("eprc4");

var $8a8ab = parcelRequire("8a8ab");

var $egspI = parcelRequire("egspI");

var $g5k19 = parcelRequire("g5k19");
var $5Gxfr = parcelRequire("5Gxfr");

var $hZDXn = parcelRequire("hZDXn");

var $5oGA6 = parcelRequire("5oGA6");

var $jjrDv = parcelRequire("jjrDv");

var $6JNso = parcelRequire("6JNso");

var $bC0ut = parcelRequire("bC0ut");

var $4q4Ml = parcelRequire("4q4Ml");

var $e62jX = parcelRequire("e62jX");

var $eA6oQ = parcelRequire("eA6oQ");

var $bChVl = parcelRequire("bChVl");

var $6E96k = parcelRequire("6E96k");

var $86XoB = parcelRequire("86XoB");
const $a1f5c4842828d42a$var$defaultButtonStyles = {
    paddingInline: "var(--ds-space-100, 8px)"
};
const $a1f5c4842828d42a$var$inactiveButtonStyles = {
    background: "var(--ds-background-neutral, #0515240F)"
};
const $a1f5c4842828d42a$var$disabledButtonStyles = {
    background: "var(--ds-background-disabled, #0515240F)",
    color: "var(--ds-text-disabled, #080F214A)"
};
const $a1f5c4842828d42a$var$conversationAssistantButtonWrapperStyles = null;
const $a1f5c4842828d42a$var$conversationAssistantButtonWrapperNoOverlayStyles = null;
const $a1f5c4842828d42a$var$topNavButtonFlareKeyframes = null;
const $a1f5c4842828d42a$var$topNavButtonFlareAnimationStyles = null;
const $a1f5c4842828d42a$var$baseShadow = `0 0 0 2px ${"var(--ds-border-discovery, #AF59E1)"}`;
const $a1f5c4842828d42a$var$pulseKeyframes = null;
const $a1f5c4842828d42a$var$pulseAnimationStyles = null;
const $a1f5c4842828d42a$var$reduceMotionStyles = null;
/**
 * Wraps button in a div that plays the top-nav flare animation.
 * Optionally accepts an `overlayCohort` discriminator to layer cohort-specific
 * wrapper styling under the animation styles. The cohort style must be selected
 * here (rather than passed in as a compiled style) so that Compiled can
 * statically resolve every entry in the `css` array at build time.
 */ const $a1f5c4842828d42a$var$AnimatedFlareWrapper = ({ overlayCohort: overlayCohort, productKey: productKey, children: children })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $5oGA6.useAnalytics)();
    (0, $euxye.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: 'animation',
            actionSubjectId: 'conversationAssistantButtonFlareAnimation',
            attributes: {
                overlayCohort: overlayCohort,
                productKey: productKey
            }
        });
    }, [
        sendAnalyticsEvent,
        overlayCohort,
        productKey
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": "animated-flare-wrapper",
        className: (0, $4jQY2.default)([
            overlayCohort === 'overlay' && "_7dir1bhr _d32vi7uo _1q9t1wq8 _6pup6o2t _4pkpi7uo",
            overlayCohort === 'no-overlay' && "_7dirvuon _d32vi7uo _1q9t1wq8 _6pup19i6 _4pkpi7uo",
            "_1reo15vq _18m915vq _2rko12b0 _1e0c116y _mkrzh8ib _kqswh2mm _1s6k9yxf _1dbx1m5u _joxli11n _evp6kb7n _108810qc _154y15ob _1kt9b3bt _1uit1osq _iajmqkx9 _z5wtidpf _154pidpf _dsq4glyw _1cs8stnw _1g0vidpf _7dir18uv _6pup18uv _1xoxglyw _1rgridpf"
        ]),
        children: children
    });
};
$a1f5c4842828d42a$var$AnimatedFlareWrapper.displayName = "AnimatedFlareWrapper";
const $a1f5c4842828d42a$var$getConversationAssistantButton = (Button = (0, $d0kkS.PrimaryButton))=>/*#__PURE__*/ (0, $euxye.forwardRef)(({ testId: testId, isActive: isActive, isDisabled: isDisabled = false, onClick: onClickProp, onMouseEnter: onMouseEnterProp, label: label, tooltipContent: tooltipContent, shortcut: shortcut, siteId: siteId, productKey: productKey, enableOnboardingSpotlight: enableOnboardingSpotlight = false }, ref)=>{
        (0, $1uH7N.di)((0, $4LDqh.default), (0, $eA6oQ.useInsightsStatus));
        const { formatMessage: formatMessage } = (0, $1YIbA.default)();
        const { start: start } = (0, $6JNso.useConversationAssistantSpotlightActions)();
        const { PostOfficePlacement: PostOfficePlacement } = (0, $e62jX.usePostOfficePlacement)();
        // Prefetch insights status to warm the cache before the user opens chat.
        // This triggers the backend to generate insights asynchronously if not already cached.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isPulseExperimentEnabled = (0, $4LDqh.default).getExperimentValue('rovo_growth_chat_pulse', 'isEnabled', false);
        (0, $eA6oQ.useInsightsStatus)({
            enabled: isPulseExperimentEnabled,
            assistanceServiceParams: {
                touchpointSource: 'ask-rovo-button-prefetch',
                product: productKey,
                experienceId: 'ai-mate',
                siteId: siteId
            }
        });
        const [prefersReducedMotion] = (0, $euxye.useState)(()=>typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true);
        const [shouldShowMessage, setShouldShowMessage] = (0, $euxye.useState)(false);
        const messageId = productKey === 'confluence' ? 'confluence_rovo_chat_agents_spotlight_ga' : productKey === 'jira' ? 'jira_rovo_chat_agents_spotlight_ga' : '';
        const shouldUseCoordination = enableOnboardingSpotlight && !!messageId;
        const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $5oGA6.useAnalytics)();
        // Capture initial prop values in a ref so the rendered event fires exactly once
        // on mount, even if reactive props like isActive/isDisabled change later.
        const renderedAttributesRef = (0, $euxye.useRef)({
            isActive: isActive,
            isDisabled: isDisabled,
            productKey: productKey
        });
        const sendAnalyticsEventRef = (0, $euxye.useRef)(sendAnalyticsEvent);
        sendAnalyticsEventRef.current = sendAnalyticsEvent;
        (0, $euxye.useEffect)(()=>{
            sendAnalyticsEventRef.current({
                eventType: 'operational',
                action: 'rendered',
                actionSubject: 'rovoChatButton',
                attributes: renderedAttributesRef.current
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        const openRovoChat = (event, analyticsEvent)=>{
            if (!isActive && onClick) onClick(event, analyticsEvent);
        };
        const onClick = (0, $euxye.useCallback)((...params)=>{
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'rovoChatButton',
                attributes: {
                    isActive: isActive,
                    isDisabled: isDisabled,
                    productKey: productKey
                }
            });
            return onClickProp?.(...params);
        }, [
            isActive,
            isDisabled,
            onClickProp,
            productKey,
            sendAnalyticsEvent
        ]);
        const interactionName = isActive ? 'close-rovo-chat-nav-button' : 'open-rovo-chat-nav-button';
        const buttonLabel = label ?? formatMessage((0, $86XoB.messages).rovoChatButtonLabel);
        const getChildren = ()=>{
            const button = /*#__PURE__*/ (0, $e79Pd.jsx)(Button, {
                "data-spotlight-target": "rovo-chat-ask-rovo-button",
                onMouseEnter: (event)=>{
                    onMouseEnterProp?.(event);
                    sendAnalyticsEvent({
                        eventType: 'ui',
                        action: 'hovered',
                        actionSubject: 'rovoChatButton',
                        attributes: {
                            isActive: isActive,
                            isDisabled: isDisabled,
                            productKey: productKey
                        }
                    });
                    if (shouldShowMessage) {
                        sendAnalyticsEvent({
                            eventType: 'ui',
                            action: 'hovered',
                            actionSubject: 'rovoChatButtonSpotlight'
                        });
                        start();
                    }
                },
                testId: testId,
                isSelected: isActive,
                onClick: onClick,
                isDisabled: isDisabled,
                tooltip: tooltipContent ?? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {
                    children: formatMessage((0, $86XoB.messages).rovoChatButtonLabel)
                }),
                shortcut: shortcut,
                style: {
                    /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ ...$a1f5c4842828d42a$var$defaultButtonStyles,
                    ...!isActive && $a1f5c4842828d42a$var$inactiveButtonStyles,
                    ...isDisabled && $a1f5c4842828d42a$var$disabledButtonStyles
                },
                iconBefore: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eprc4.RovoIcon), {
                    size: "xxsmall"
                }),
                interactionName: interactionName,
                ref: ref,
                children: buttonLabel
            });
            if (Button === (0, $d0kkS.PrimaryButton)) return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                role: "list",
                children: button
            });
            if (!isActive && !isDisabled) {
                // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
                const overlayCohort = (0, $4LDqh.default).getExperimentValue('rovo-chat-nav-button-transparency', 'backgroundColorCohort', 'control');
                const shouldAnimateTopNavButton = !prefersReducedMotion && // Targets non-MAU Rovo Chat users — once a user becomes MAU, the gate
                // resolves to false on their next session (batch trait refreshes daily).
                (0, $egspI.fg)('rovo_chat_non_mau_rovo_button_animation_filter') && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
                (0, $4LDqh.default).getExperimentValue('ask_rovo_top_nav_button_animation', 'isEnabled', false);
                if (shouldAnimateTopNavButton) return /*#__PURE__*/ (0, $e79Pd.jsx)($a1f5c4842828d42a$var$AnimatedFlareWrapper, {
                    overlayCohort: overlayCohort,
                    productKey: productKey,
                    children: button
                });
                if (overlayCohort === 'overlay') return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        "_7dir1bhr _d32vi7uo _1q9t1wq8 _6pup6o2t _4pkpi7uo"
                    ]),
                    children: button
                });
                else if (overlayCohort === 'no-overlay') return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        "_7dirvuon _d32vi7uo _1q9t1wq8 _6pup19i6 _4pkpi7uo"
                    ]),
                    children: button
                });
            }
            return button;
        };
        // The long-running-task PostOffice placement is anchored to the Ask Rovo
        // button (via data-spotlight-target) and must mount for every product
        // including Townsquare (productKey="atlas"), so it lives outside
        // SpotlightWrapper which only renders for products that opt into the
        // agents-onboarding coordination flow.
        // Uses <Fragment> (not <>) because this file has @jsx pragma without @jsxFrag.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isFullPageSpotlightEnabled = productKey === 'jira' && (0, $4LDqh.default).getExperimentValue('rovo_chat_full_page_chat_spotlight', 'isEnabled', false);
        return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
            children: [
                shouldUseCoordination || isFullPageSpotlightEnabled ? /*#__PURE__*/ (0, $e79Pd.jsx)($a1f5c4842828d42a$export$de76c194bfb85689, {
                    setShouldShowMessage: setShouldShowMessage,
                    messageId: messageId,
                    siteId: siteId,
                    children: getChildren(),
                    shouldShowMessage: shouldShowMessage,
                    openRovoChat: (event, analyticsEvent)=>openRovoChat(event, analyticsEvent),
                    isFullPageSpotlightEnabled: isFullPageSpotlightEnabled
                }) : getChildren(),
                PostOfficePlacement && (0, $egspI.fg)('rovo_chat_long_running_task_spotlight') && /*#__PURE__*/ (0, $e79Pd.jsx)(PostOfficePlacement, {
                    placementId: "rovo-chat-long-running-task-spotlight"
                })
            ]
        });
    });
const $a1f5c4842828d42a$var$Nav4Button = /*#__PURE__*/ (0, $euxye.forwardRef)(({ tooltip: tooltip, shortcut: shortcut, ...props }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hZDXn.default), {
        content: tooltip,
        shortcut: shortcut,
        // This button's visible text matches the tooltip
        // Announcing the tooltip means 'Chat' would be announced twice
        isScreenReaderAnnouncementDisabled: true,
        children: ({ ref: tooltipRef, ...triggerProps })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $8a8ab.Button), {
                interactionName: props?.interactionName,
                ref: (0, $50OIz.mergeRefs)([
                    forwardedRef,
                    tooltipRef
                ]),
                ...triggerProps,
                ...props,
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps.onClick?.(event);
                },
                iconBefore: ()=>props.iconBefore || null
            })
    });
});
const $a1f5c4842828d42a$export$7c328c0993982813 = $a1f5c4842828d42a$var$getConversationAssistantButton((0, $d0kkS.PrimaryButton));
const $a1f5c4842828d42a$export$25e85d244cbf7845 = $a1f5c4842828d42a$var$getConversationAssistantButton($a1f5c4842828d42a$var$Nav4Button);
const $a1f5c4842828d42a$export$de76c194bfb85689 = ({ children: children, messageId: messageId, siteId: siteId, setShouldShowMessage: setShouldShowMessage, shouldShowMessage: shouldShowMessage, openRovoChat: openRovoChat, isFullPageSpotlightEnabled: isFullPageSpotlightEnabled = false })=>{
    (0, $1uH7N.di)((0, $jjrDv.usePostOfficeCoordination));
    const { activeSpotlight: activeSpotlight } = (0, $6JNso.useConversationAssistantSpotlightState)();
    const [onboardingStarted, stopOnboarding] = (0, $jjrDv.usePostOfficeCoordination)(messageId);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $5oGA6.useAnalytics)();
    const onDismissMessage = ()=>{
        setShouldShowMessage(false);
        stopOnboarding();
    };
    (0, $euxye.useEffect)(()=>{
        if (shouldShowMessage && activeSpotlight !== null) sendAnalyticsEvent({
            eventType: 'ui',
            action: 'shown',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    }, [
        shouldShowMessage,
        activeSpotlight,
        sendAnalyticsEvent
    ]);
    (0, $euxye.useEffect)(()=>{
        if (onboardingStarted) setShouldShowMessage(true);
    }, [
        onboardingStarted,
        setShouldShowMessage
    ]);
    // Mutually exclusive with the onboarding spotlight — don't show both at once
    const shouldShowFullPageSpotlight = isFullPageSpotlightEnabled && !shouldShowMessage;
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6E96k.ConditionalWrapper), {
        condition: shouldShowMessage || shouldShowFullPageSpotlight,
        wrapper: (children)=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $g5k19.PopoverProvider), {
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5Gxfr.PopoverTarget), {
                        children: /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
                            className: (0, $4jQY2.default)([
                                shouldShowMessage && activeSpotlight === null && "",
                                shouldShowMessage && activeSpotlight === null && "_2rko12b0 _5sagi11n _tip812c5 _j7hqfamb _1pglmcjr _16qs1peg",
                                "_1bumglyw _sedtglyw"
                            ]),
                            children: [
                                children,
                                shouldShowFullPageSpotlight && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bChVl.ChunkErrorBoundary), {
                                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Suspense), {
                                        fallback: null,
                                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bC0ut.AsyncRovoFullPageSpotlightPlacement), {
                                            openRovoChat: openRovoChat
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4q4Ml.ConversationAssistantOnboardingSpotlight), {
                        onDismiss: onDismissMessage,
                        openRovoChat: openRovoChat
                    })
                ]
            }),
        children: children
    });
};
$a1f5c4842828d42a$export$de76c194bfb85689.displayName = "SpotlightWrapper";

});
parcelRegister("jjrDv", function(module, exports) {
$parcel$export(module.exports, "usePostOfficeCoordination", () => $6d29d8a3a2315636$export$a890021247f253fb);

var $euxye = parcelRequire("euxye");

var $2pabT = parcelRequire("2pabT");
const $6d29d8a3a2315636$export$a890021247f253fb = (messageId)=>{
    const { isActive: poIsActive } = (0, $2pabT.useTrigger)(`${messageId}-started`);
    const { fireTrigger: poRequestMessageStart } = (0, $2pabT.useFirePostOfficeTrigger)({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: poFireDismissClick } = (0, $2pabT.useFirePostOfficeTrigger)({
        triggerId: `${messageId}-dismiss`
    });
    (0, $euxye.useEffect)(()=>{
        poRequestMessageStart({
            isActive: true
        });
    }, [
        messageId,
        poRequestMessageStart
    ]);
    const started = poIsActive;
    const stop = (force)=>{
        poFireDismissClick({
            isActive: true
        });
    };
    return [
        started,
        stop
    ];
};

});

parcelRegister("6JNso", function(module, exports) {
$parcel$export(module.exports, "useConversationAssistantSpotlightActions", () => $afa3d89d341bc855$export$283f4929c8863814);
$parcel$export(module.exports, "useConversationAssistantSpotlightState", () => $afa3d89d341bc855$export$258c2a6b93cdef4a);

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $afa3d89d341bc855$var$initialState = {
    activeSpotlight: null
};
const $afa3d89d341bc855$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: 0
            });
        },
    next: ()=>({ setState: setState, getState: getState })=>{
            setState({
                activeSpotlight: (getState().activeSpotlight || 0) + 1
            });
        },
    end: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: null
            });
        }
};
const $afa3d89d341bc855$var$ConversationAssistantSpotlightStore = (0, $5QDqc.createStore)({
    initialState: $afa3d89d341bc855$var$initialState,
    actions: $afa3d89d341bc855$var$actions,
    name: 'ConversationAssistantSpotlightStore'
});
const $afa3d89d341bc855$export$283f4929c8863814 = (0, $3h1FP.createActionsHook)($afa3d89d341bc855$var$ConversationAssistantSpotlightStore);
const $afa3d89d341bc855$export$258c2a6b93cdef4a = (0, $3h1FP.createStateHook)($afa3d89d341bc855$var$ConversationAssistantSpotlightStore);

});

parcelRegister("bC0ut", function(module, exports) {
$parcel$export(module.exports, "AsyncRovoFullPageSpotlightPlacement", () => $77bc6a60712be7d0$export$2a0e9ab75aa119a4);

var $euxye = parcelRequire("euxye");

const $77bc6a60712be7d0$export$2a0e9ab75aa119a4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).lazy(()=>(parcelRequire("fW2br")).then(({ RovoFullPageSpotlightPlacement: RovoFullPageSpotlightPlacement })=>({
            default: RovoFullPageSpotlightPlacement
        })));
$77bc6a60712be7d0$export$2a0e9ab75aa119a4.displayName = 'AsyncRovoFullPageSpotlightPlacement';

});
parcelRegister("fW2br", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gDd1q").then(()=>parcelRequire('a2xba'));

});


parcelRegister("4q4Ml", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistantOnboardingSpotlight", () => $80398b126ae66191$export$e4abc8af2fc5e2ac);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $1uH7N = parcelRequire("1uH7N");

var $fxLck = parcelRequire("fxLck");
var $jFNyB = parcelRequire("jFNyB");
var $liP0D = parcelRequire("liP0D");
var $8CDnU = parcelRequire("8CDnU");
var $8qQ8A = parcelRequire("8qQ8A");
var $8guPH = parcelRequire("8guPH");
var $7okqc = parcelRequire("7okqc");
var $KcP1c = parcelRequire("KcP1c");
var $413te = parcelRequire("413te");
var $jukA2 = parcelRequire("jukA2");
var $bEy1I = parcelRequire("bEy1I");

var $5oGA6 = parcelRequire("5oGA6");

var $6JNso = parcelRequire("6JNso");

var $3bf3m = parcelRequire("3bf3m");
const $80398b126ae66191$export$e4abc8af2fc5e2ac = ({ openRovoChat: openRovoChat, onDismiss: onDismiss })=>{
    (0, $1uH7N.di)((0, $6JNso.useConversationAssistantSpotlightState));
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { end: end } = (0, $6JNso.useConversationAssistantSpotlightActions)();
    const { activeSpotlight: activeSpotlight } = (0, $6JNso.useConversationAssistantSpotlightState)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $5oGA6.useAnalytics)();
    const handleTryChat = (event, analyticsEvent)=>{
        if (openRovoChat) openRovoChat(event, analyticsEvent);
        end();
        onDismiss();
        sendAnalyticsEvent({
            eventType: 'ui',
            // this is more of 'chatButtonClicked'
            action: 'dismissed',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    };
    const handleDismiss = ()=>{
        end();
        onDismiss();
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'dismissButtonClicked',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {
        children: activeSpotlight !== null && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fxLck.PopoverContent), {
            dismiss: handleDismiss,
            isVisible: activeSpotlight !== null,
            placement: "bottom-start",
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $8CDnU.SpotlightCard), {
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $KcP1c.SpotlightHeader), {
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $413te.SpotlightHeadline), {
                                children: formatMessage((0, $3bf3m.default).onboardingHeading)
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8qQ8A.SpotlightControls), {
                                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8guPH.SpotlightDismissControl), {
                                    onClick: handleDismiss
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $liP0D.SpotlightBody), {
                        children: formatMessage((0, $3bf3m.default).onboardingDescription)
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7okqc.SpotlightFooter), {
                        children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $jFNyB.SpotlightActions), {
                            children: [
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bEy1I.SpotlightSecondaryAction), {
                                    onClick: handleDismiss,
                                    children: formatMessage((0, $3bf3m.default).dismissOnboarding)
                                }),
                                /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jukA2.SpotlightPrimaryAction), {
                                    onClick: handleTryChat,
                                    children: formatMessage((0, $3bf3m.default).tryChat)
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
$80398b126ae66191$export$e4abc8af2fc5e2ac.displayName = "ConversationAssistantOnboardingSpotlight";

});
parcelRegister("3bf3m", function(module, exports) {
$parcel$export(module.exports, "default", () => $5782d9d14b38ecaa$export$2e2bcd8739ae039);

var $7eNDO = parcelRequire("7eNDO");
const $5782d9d14b38ecaa$var$_default_1 = (0, $7eNDO.defineMessages)({
    tryChat: {
        id: 'rovo-onboarding-try-chat',
        defaultMessage: 'Try Max',
        description: "Button label displayed on the primary action button in the Rovo onboarding spotlight within the AI conversation interface. Shown as the text on a button in the spotlight. When clicked, it starts a new chat session and begins the user's first interaction with the AI assistant. The purpose is to provide a clear call-to-action for users to begin using the AI chat feature after viewing the onboarding information."
    },
    dismissOnboarding: {
        id: 'rovo-onboarding-dismiss',
        defaultMessage: 'Dismiss',
        description: 'Button label displayed on the dismiss button in the Rovo onboarding spotlight within the AI conversation interface. Shown as the text on a button in the spotlight. When clicked, it closes the onboarding spotlight without starting a chat. The purpose is to provide users with a way to skip the onboarding if they are already familiar with the feature or want to explore on their own.'
    },
    onboardingHeading: {
        id: 'rovo-onboarding-heading',
        defaultMessage: 'Say hi to Max',
        description: 'Heading text displayed at the top of the Rovo onboarding spotlight within the AI conversation interface. Shown as the main title or heading in the spotlight. The purpose is to immediately communicate to new users what the feature is about, which is chatting with an AI assistant to get help with work tasks.'
    },
    onboardingDescription: {
        id: 'rovo-onboarding-description',
        defaultMessage: 'Max takes on complex, multi-step work and comes back with a finished result.',
        description: 'Description text displayed in the body of the Rovo onboarding spotlight within the AI conversation interface. Shown as the body text below the heading. The purpose is to explain the key capabilities of Rovo Chat: exploring company knowledge, creating content, and collaborating on work, helping users understand the value and use cases for the AI assistant.'
    }
});
var $5782d9d14b38ecaa$export$2e2bcd8739ae039 = $5782d9d14b38ecaa$var$_default_1;

});


parcelRegister("e62jX", function(module, exports) {
$parcel$export(module.exports, "usePostOfficePlacement", () => $a777fb4acee8f20f$export$b9e056b3d42aef4);

var $euxye = parcelRequire("euxye");

const $a777fb4acee8f20f$export$b9e056b3d42aef4 = ()=>{
    const [PostOfficePlacement, setPostOfficePlacement] = (0, $euxye.useState)(null);
    const [isMounted, setIsMounted] = (0, $euxye.useState)(false);
    (0, $euxye.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            let isComponentMounted = true;
            // Check for mock in test environments (set by VR test)
            const mockModule = window.__mockPostOfficePlacement__;
            if (mockModule) {
                setPostOfficePlacement(()=>mockModule);
                setIsMounted(true);
                return;
            }
            (parcelRequire("iuDrT")).then((module)=>{
                if (isComponentMounted) {
                    setPostOfficePlacement(()=>module.Placement);
                    setIsMounted(true);
                }
            }).catch(()=>{
                if (isComponentMounted) setIsMounted(true);
            });
            return ()=>{
                isComponentMounted = false;
            };
        }
    }, []);
    return {
        PostOfficePlacement: PostOfficePlacement,
        isMounted: isMounted
    };
};

});
parcelRegister("iuDrT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("1aRRK"),
    $4cvLQ("heoAA")
]).then(()=>parcelRequire('6QxvI'));

});


parcelRegister("eA6oQ", function(module, exports) {
$parcel$export(module.exports, "useInsightsStatus", () => $5ec5907027588e9c$export$d191a72e03ff3705);
/**
 * Hook to check whether the Rovo Insights feature is available for the current user.
 *
 * Uses RovoInsightsService (extends AssistanceServiceBase) so that Rovo Insights
 * concerns stay out of the general-purpose AssistanceService.
 */ 
var $euxye = parcelRequire("euxye");

var $jSoCT = parcelRequire("jSoCT");

var $fZQSX = parcelRequire("fZQSX");

var $PkUAZ = parcelRequire("PkUAZ");

var $6JFW5 = parcelRequire("6JFW5");
const $5ec5907027588e9c$var$FRESHNESS_WINDOW_MS = 172800000;
const $5ec5907027588e9c$var$isGeneratedAtFresh = (generatedAt)=>{
    if (!generatedAt) return false;
    const generatedAtTime = new Date(generatedAt).getTime();
    if (Number.isNaN(generatedAtTime)) return false;
    return Date.now() - generatedAtTime < $5ec5907027588e9c$var$FRESHNESS_WINDOW_MS;
};
const $5ec5907027588e9c$export$d191a72e03ff3705 = (0, $PkUAZ.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, enabled: enabled })=>{
    const insightsService = (0, $euxye.useMemo)(()=>{
        const config = assistanceService.getConfig();
        return new (0, $6JFW5.RovoInsightsService)(config);
    }, [
        assistanceService
    ]);
    const { data: data, isFetching: isFetching } = (0, $fZQSX.useQuery)({
        queryKey: [
            'insightsStatus'
        ],
        enabled: enabled,
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $jSoCT.ExperienceName).FETCH_INSIGHTS_STATUS,
                name: (0, $jSoCT.ExperienceName).FETCH_INSIGHTS_STATUS
            });
            try {
                const response = await insightsService.getInsightsStatus();
                experienceTracker.succeed({
                    name: (0, $jSoCT.ExperienceName).FETCH_INSIGHTS_STATUS
                });
                return response;
            } catch (error) {
                experienceTracker.fail({
                    name: (0, $jSoCT.ExperienceName).FETCH_INSIGHTS_STATUS,
                    error: error instanceof Error ? error : new Error(String(error))
                });
                throw error;
            }
        }
    });
    return {
        isInsightsAvailable: Boolean(data?.insights_available),
        isLoading: isFetching && data === null,
        generatedAt: data?.generated_at,
        isFresh: $5ec5907027588e9c$var$isGeneratedAtFresh(data?.generated_at)
    };
});

});
parcelRegister("6JFW5", function(module, exports) {
$parcel$export(module.exports, "RovoInsightsService", () => $2031f9c92e1cfe8c$export$2687a6d505a87cc5);

var $PkUAZ = parcelRequire("PkUAZ");
const $2031f9c92e1cfe8c$var$CHANNEL_ID_HEADER = 'X-Channel-Id';
const $2031f9c92e1cfe8c$var$PRODUCT_HEADER = 'x-product';
const $2031f9c92e1cfe8c$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
class $2031f9c92e1cfe8c$export$2687a6d505a87cc5 extends (0, $PkUAZ.AssistanceServiceBase) {
    constructor(config){
        super(config);
    }
    /**
	 * Check whether Rovo Insights is available for the current user.
	 */ async getInsightsStatus() {
        return this.fetchJson({
            path: '/rovo/v1/insights/status',
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'Content-Type': 'application/json;charset=UTF-8',
                    [$2031f9c92e1cfe8c$var$CHANNEL_ID_HEADER]: 'rovo-chat',
                    [$2031f9c92e1cfe8c$var$PRODUCT_HEADER]: 'rovo',
                    [$2031f9c92e1cfe8c$var$EXPERIENCE_ID_HEADER]: 'rovo-insights'
                }),
                body: JSON.stringify({})
            },
            holdName: 'rovo-v1-insights-status'
        });
    }
    /**
	 * Fetch the Rovo Insights feed for the current user.
	 * @param options.debugInfo — When true, include debug_info in the response.
	 */ async getInsightsFeed(options) {
        const overrides = {};
        if (options?.debugInfo) overrides.debug_info = true;
        if (typeof localStorage !== 'undefined') {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const promptVariation = localStorage.getItem('DEBUG_rovo_insights_prompt_variation');
            if (promptVariation) overrides.prompt_variation = promptVariation;
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const generate = localStorage.getItem('DEBUG_rovo_insights_generate');
            if (generate) overrides.generate = generate === 'true';
        }
        return this.fetchJson({
            path: '/rovo/v1/insights/fetch',
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'Content-Type': 'application/json;charset=UTF-8',
                    [$2031f9c92e1cfe8c$var$CHANNEL_ID_HEADER]: 'rovo-chat',
                    [$2031f9c92e1cfe8c$var$PRODUCT_HEADER]: 'rovo',
                    [$2031f9c92e1cfe8c$var$EXPERIENCE_ID_HEADER]: 'rovo-insights'
                }),
                body: JSON.stringify(overrides)
            },
            holdName: 'rovo-v1-insights-fetch'
        });
    }
}

});


parcelRegister("bChVl", function(module, exports) {
$parcel$export(module.exports, "ChunkErrorBoundary", () => $607b2cb36638b4d8$export$63986981e4af5143);

var $euxye = parcelRequire("euxye");
class $607b2cb36638b4d8$export$63986981e4af5143 extends (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        // Log chunk load failures so they are detectable in production
        // eslint-disable-next-line no-console
        console.error('[ChunkErrorBoundary] Failed to load async component chunk:', error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}
$607b2cb36638b4d8$export$63986981e4af5143.displayName = "ChunkErrorBoundary";

});

parcelRegister("6E96k", function(module, exports) {
$parcel$export(module.exports, "ConditionalWrapper", () => $b35de0999b387276$export$39aecc95f0365819);
const $b35de0999b387276$export$39aecc95f0365819 = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children;

});

parcelRegister("86XoB", function(module, exports) {
$parcel$export(module.exports, "messages", () => $584a40458d18e6d0$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $584a40458d18e6d0$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    rovoChatButtonLabel: {
        id: 'conversation-assistant-button.ask-rovo-label',
        defaultMessage: 'Ask Rovo',
        description: 'Label for the button that opens the conversation assistant'
    }
});

});


parcelRegister("Bq7bE", function(module, exports) {
$parcel$export(module.exports, "useRovoExperienceAPIStore", () => $991e586d6e5aadca$export$37440b51449f7ac6);

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $ijKLu = parcelRequire("ijKLu");
const $991e586d6e5aadca$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true,
    isFullScreenModalAvailable: false,
    initialPrompt: undefined,
    openWithChatHistory: false,
    wasAutoOpened: false
};
const $991e586d6e5aadca$var$store = (0, $5QDqc.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $991e586d6e5aadca$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($991e586d6e5aadca$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode,
                    wasAutoOpened: false
                });
            },
        clearInitialPrompt: ()=>({ setState: setState })=>{
                setState({
                    initialPrompt: undefined
                });
            },
        setOpenWithChatHistory: (openWithChatHistory)=>({ setState: setState })=>{
                setState({
                    openWithChatHistory: openWithChatHistory
                });
            },
        setWasAutoOpened: (wasAutoOpened)=>({ setState: setState })=>{
                setState({
                    wasAutoOpened: wasAutoOpened
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined,
                        wasAutoOpened: false
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $ijKLu.ConversationAssistantUIModes).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
							which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $ijKLu.ConversationAssistantUIModes).MINI_MODAL:
                        setState({
                            mode: undefined,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $ijKLu.ConversationAssistantUIModes).FULL_SCREEN_MODAL:
                        setState({
                            mode: undefined,
                            wasAutoOpened: false
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $ijKLu.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $ijKLu.ConversationAssistantUIModes).SIDEBAR,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $ijKLu.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $ijKLu.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $ijKLu.ConversationAssistantUIModes).FULL_SCREEN_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $ijKLu.ConversationAssistantUIModes).FULL_SCREEN_MODAL,
                            initialPrompt: initialPrompt,
                            wasAutoOpened: false
                        });
                        return;
                }
            },
        openConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // Already in the desired mode — ensure the sidebar is actually
                // visible (it may have been displaced by another panel) but
                // otherwise treat this as a no-op.
                if (currentMode === targetMode) {
                    if (targetMode === (0, $ijKLu.ConversationAssistantUIModes).SIDEBAR && !sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                    return;
                }
                // Switch to the target mode
                switch(targetMode){
                    case (0, $ijKLu.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $ijKLu.ConversationAssistantUIModes).SIDEBAR,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $ijKLu.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        // wasAutoOpened is managed by the dedicated setWasAutoOpened action and reset on close/toggle/setMode.
                        setState({
                            mode: (0, $ijKLu.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt
                        });
                        return;
                    case (0, $ijKLu.ConversationAssistantUIModes).FULL_SCREEN_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $ijKLu.ConversationAssistantUIModes).FULL_SCREEN_MODAL,
                            initialPrompt: initialPrompt
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            },
        setIsFullScreenModalAvailable: (isFullScreenModalAvailable)=>({ setState: setState })=>{
                setState({
                    isFullScreenModalAvailable: isFullScreenModalAvailable
                });
            }
    }
});
const $991e586d6e5aadca$var$useStore = (0, $3h1FP.createHook)($991e586d6e5aadca$var$store);
const $991e586d6e5aadca$export$37440b51449f7ac6 = ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, isFullScreenModalAvailable: isFullScreenModalAvailable, initialPrompt: initialPrompt, openWithChatHistory: openWithChatHistory, wasAutoOpened: wasAutoOpened }, { reset: reset, clearInitialPrompt: clearInitialPrompt, setOpenWithChatHistory: setOpenWithChatHistory, setWasAutoOpened: setWasAutoOpened, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable, setIsFullScreenModalAvailable: setIsFullScreenModalAvailable }] = $991e586d6e5aadca$var$useStore();
    return {
        mode: mode,
        initialPrompt: initialPrompt,
        openWithChatHistory: openWithChatHistory,
        wasAutoOpened: wasAutoOpened,
        reset: reset,
        clearInitialPrompt: clearInitialPrompt,
        setOpenWithChatHistory: setOpenWithChatHistory,
        setWasAutoOpened: setWasAutoOpened,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        openConversationAssistantUIMode: openConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        setIsFullScreenModalAvailable: setIsFullScreenModalAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable,
        isFullScreenModalAvailable: isFullScreenModalAvailable
    };
};
const $991e586d6e5aadca$export$66cf76b7e04da11f = (0, $3h1FP.createActionsHook)($991e586d6e5aadca$var$store);

});
parcelRegister("ijKLu", function(module, exports) {
$parcel$export(module.exports, "ConversationAssistantUIModes", () => $0d7672bb198badbb$export$bc36ebf73899a71d);
/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ const $0d7672bb198badbb$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal',
    FULL_SCREEN_MODAL: 'full-screen-modal'
};

});


parcelRegister("fL9yy", function(module, exports) {
$parcel$export(module.exports, "useAccountLinks", () => $5f43c9e7d56782f4$export$2afde6c526be23b9);

var $7TSMb = parcelRequire("7TSMb");
/**
 * Helper function to create a string of custom query parameters
 * Returns a string like "&orgId=blah&..." that can be appended to URLs
 */ const $5f43c9e7d56782f4$var$createCustomParametersString = (customParameters)=>{
    if (!customParameters || Object.keys(customParameters).length === 0) return '';
    return Object.entries(customParameters).map(([key, value])=>`&${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('');
};
const $5f43c9e7d56782f4$var$buildProfileLink = (baseUrl, path, applicationParam, email, logInLinkCustomParameters)=>{
    const profileUrl = `${baseUrl}${path}`;
    if (email) {
        const logInLinkCustomParamsString = $5f43c9e7d56782f4$var$createCustomParametersString(logInLinkCustomParameters);
        const loginUrl = `${baseUrl}/login?${applicationParam}&continue=${encodeURIComponent(profileUrl)}&prompt=none&login_hint=${encodeURIComponent(email)}${logInLinkCustomParamsString}`;
        return loginUrl;
    }
    return profileUrl;
};
function $5f43c9e7d56782f4$export$2afde6c526be23b9({ email: email, identityEnvironment: identityEnvironment, application: application, continueUrl: continueUrl, logOutContinueUrl: logOutContinueUrl, isLoggedOut: isLoggedOut, disableSwitchAccountLink: disableSwitchAccountLink, logInLinkCustomParameters: logInLinkCustomParameters }) {
    const { baseUrl: baseUrl } = (0, $7TSMb.resolveEnvironment)(identityEnvironment);
    const applicationParam = `application=${encodeURIComponent(application)}`;
    const continueParam = `continue=${encodeURIComponent(continueUrl)}`;
    const logOutContinueParam = logOutContinueUrl ? `continue=${encodeURIComponent(logOutContinueUrl)}` : continueParam;
    const manageProfileLink = $5f43c9e7d56782f4$var$buildProfileLink(baseUrl, '/manage-profile', applicationParam, email, logInLinkCustomParameters);
    return {
        manageProfileLink: manageProfileLink,
        switchAccountLink: disableSwitchAccountLink ? undefined : `${baseUrl}/login?${applicationParam}&${continueParam}&prompt=select_account${$5f43c9e7d56782f4$var$createCustomParametersString(logInLinkCustomParameters)}`,
        logOutLink: `${baseUrl}/logout?${applicationParam}&${logOutContinueParam}` + (disableSwitchAccountLink ? '' : '&prompt=none'),
        logInLink: isLoggedOut ? `${baseUrl}/login?${applicationParam}&${continueParam}${$5f43c9e7d56782f4$var$createCustomParametersString(logInLinkCustomParameters)}` : undefined
    };
}

});
parcelRegister("7TSMb", function(module, exports) {
$parcel$export(module.exports, "resolveEnvironment", () => $93bed1cbe016be52$export$eabfcea451f48b90);
/**
 * An Identity environment to integrate with. Either a `"dev"`, `"fedex"`, `"staging"` or
 * `"prod"` for real Identity environments, or an `EnvironmentConfig` object for
 * using a fake environment (e.g. for local dev).
 */ const $93bed1cbe016be52$var$environmentConfigs = {
    dev: {
        baseUrl: 'https://id.dev.internal.atlassian.com'
    },
    fedex: {
        baseUrl: 'https://id.atlassian-fex.com'
    },
    staging: {
        baseUrl: 'https://id.stg.internal.atlassian.com'
    },
    'staging-fedramp-moderate': {
        baseUrl: 'https://id.stg.atlassian-us-gov-mod.com'
    },
    prod: {
        baseUrl: 'https://id.atlassian.com'
    },
    'prod-fedramp-moderate': {
        baseUrl: 'https://id.atlassian-us-gov-mod.com'
    }
};
function $93bed1cbe016be52$export$eabfcea451f48b90(identityEnvironment) {
    if (typeof identityEnvironment === 'string') return $93bed1cbe016be52$var$environmentConfigs[identityEnvironment];
    else return identityEnvironment;
}

});


parcelRegister("82r89", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $cf5ca3c814470a5f$export$515664faa1398f37);
$parcel$export(module.exports, "ANALYTICS_CONTEXT", () => $cf5ca3c814470a5f$export$3cbe56a0cabcff38);
const $cf5ca3c814470a5f$export$515664faa1398f37 = 'navigation';
const $cf5ca3c814470a5f$export$3cbe56a0cabcff38 = {
    source: 'atlassianAccountMenu',
    componentName: 'atlassianAccountMenu',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};

});

parcelRegister("huIFY", function(module, exports) {
$parcel$export(module.exports, "AccountMenuIntlProvider", () => $7cf32b6d43ca553c$export$6c1f1571e3dd1b34);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $5KKyn = parcelRequire("5KKyn");
var $1YIbA = parcelRequire("1YIbA");

var $aKxSI = parcelRequire("aKxSI");

var $gIMgJ = parcelRequire("gIMgJ");
const $7cf32b6d43ca553c$export$6c1f1571e3dd1b34 = ({ children: children })=>{
    const { locale: locale } = (0, $1YIbA.default)();
    const messages = $7cf32b6d43ca553c$var$useMessages(locale);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5KKyn.default), {
        locale: locale,
        messages: messages,
        onError: (err)=>{
            // Do not spam local devloop with missing translation errors
            //
            // See: https://github.com/formatjs/formatjs/issues/465#issuecomment-643887472
            // Note the default error handler: https://github.com/formatjs/formatjs/blob/d0b80fd9a814d1427b73577aebb7ccdb80b9ae94/packages/intl/src/utils.ts#L43
            if ($gIMgJ?.env?.NODE_ENV !== 'production' && err?.code !== 'MISSING_TRANSLATION') // eslint-disable-next-line no-console
            console.error(err);
        },
        children: children
    });
};
$7cf32b6d43ca553c$export$6c1f1571e3dd1b34.displayName = "AccountMenuIntlProvider";
const $7cf32b6d43ca553c$var$useMessages = (locale)=>{
    const [messages, setMessages] = (0, $euxye.useState)();
    (0, $euxye.useEffect)(()=>{
        if (/^en(-US)?$/i.exec(locale)) // Use fallback messages, which are already US English
        setMessages(undefined);
        else {
            let cancelled = false;
            $7cf32b6d43ca553c$var$loadMessages(locale).catch((_error)=>undefined) // TODO: Log error somehow (analytics?)
            .then((messages)=>{
                if (!cancelled) setMessages(messages);
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        locale,
        setMessages
    ]);
    return messages;
};
const $7cf32b6d43ca553c$var$loadMessages = async (locale)=>{
    let [language, region = ''] = locale.split('-', 2);
    language = language.toLowerCase();
    region = region.toUpperCase();
    return (await ((0, $aKxSI.default)[`${language}_${region}`] || (0, $aKxSI.default)[language])?.())?.default;
};

});
parcelRegister("aKxSI", function(module, exports) {
$parcel$export(module.exports, "default", () => $25623f3054fa04fe$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by scripts/generate-i18n-index.ts.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index.
 */ 










































const $25623f3054fa04fe$var$lazyMessages = {
    cs: ()=>(parcelRequire("7PLNh")),
    cs_CZ: ()=>(parcelRequire("2nSux")),
    da: ()=>(parcelRequire("8vshi")),
    da_DK: ()=>(parcelRequire("47bil")),
    de: ()=>(parcelRequire("6Lc84")),
    de_DE: ()=>(parcelRequire("2X5rR")),
    en_GB: ()=>(parcelRequire("h3ifV")),
    en_ZZ: ()=>(parcelRequire("1nsm3")),
    es: ()=>(parcelRequire("f0S8E")),
    fi: ()=>(parcelRequire("ivyWp")),
    fi_FI: ()=>(parcelRequire("bBIxc")),
    fr: ()=>(parcelRequire("7BAyP")),
    fr_FR: ()=>(parcelRequire("ilKCq")),
    hu: ()=>(parcelRequire("aZFid")),
    hu_HU: ()=>(parcelRequire("hFD8M")),
    it: ()=>(parcelRequire("kIOeY")),
    it_IT: ()=>(parcelRequire("6nSJ2")),
    ja: ()=>(parcelRequire("aT8m2")),
    ja_JP: ()=>(parcelRequire("7wivo")),
    ko: ()=>(parcelRequire("d5VWh")),
    ko_KR: ()=>(parcelRequire("gmmVc")),
    nb: ()=>(parcelRequire("2Wunu")),
    nb_NO: ()=>(parcelRequire("a58As")),
    nl: ()=>(parcelRequire("5Dw6q")),
    nl_NL: ()=>(parcelRequire("lzwxO")),
    pl: ()=>(parcelRequire("j4YtB")),
    pl_PL: ()=>(parcelRequire("k8Bug")),
    pt_BR: ()=>(parcelRequire("7cpN3")),
    ru: ()=>(parcelRequire("hiySz")),
    ru_RU: ()=>(parcelRequire("fVEqN")),
    sv: ()=>(parcelRequire("duUjy")),
    sv_SE: ()=>(parcelRequire("lxPEp")),
    th: ()=>(parcelRequire("jYq61")),
    th_TH: ()=>(parcelRequire("8Kxoj")),
    tr: ()=>(parcelRequire("cPrmd")),
    tr_TR: ()=>(parcelRequire("6nFdb")),
    uk: ()=>(parcelRequire("iGMfr")),
    uk_UA: ()=>(parcelRequire("kVgGI")),
    vi: ()=>(parcelRequire("4IvBD")),
    vi_VN: ()=>(parcelRequire("71CxK")),
    zh: ()=>(parcelRequire("9G42s")),
    zh_CN: ()=>(parcelRequire("4FYJR")),
    zh_TW: ()=>(parcelRequire("1CL42"))
};
var $25623f3054fa04fe$export$2e2bcd8739ae039 = $25623f3054fa04fe$var$lazyMessages;

});
parcelRegister("7PLNh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kbbmX").then(()=>parcelRequire('5TVq6'));

});

parcelRegister("2nSux", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("ecUBB").then(()=>parcelRequire('j8hJQ'));

});

parcelRegister("8vshi", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("2FEls").then(()=>parcelRequire('l5lOn'));

});

parcelRegister("47bil", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lD3g3").then(()=>parcelRequire('aw03h'));

});

parcelRegister("6Lc84", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fwlxc").then(()=>parcelRequire('7RjFu'));

});

parcelRegister("2X5rR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("biOgC").then(()=>parcelRequire('3zVKe'));

});

parcelRegister("h3ifV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("56p3r").then(()=>parcelRequire('bzRrM'));

});

parcelRegister("1nsm3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("93F8d").then(()=>parcelRequire('8TyQt'));

});

parcelRegister("f0S8E", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5U4EQ").then(()=>parcelRequire('iTc8o'));

});

parcelRegister("ivyWp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("axjAD").then(()=>parcelRequire('48zQa'));

});

parcelRegister("bBIxc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iDvdQ").then(()=>parcelRequire('cjUqE'));

});

parcelRegister("7BAyP", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8lrw8").then(()=>parcelRequire('as2dt'));

});

parcelRegister("ilKCq", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("knxZX").then(()=>parcelRequire('8d9fg'));

});

parcelRegister("aZFid", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5yfKd").then(()=>parcelRequire('egwGZ'));

});

parcelRegister("hFD8M", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("kpsRW").then(()=>parcelRequire('8QZzL'));

});

parcelRegister("kIOeY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jiQqW").then(()=>parcelRequire('fSiAd'));

});

parcelRegister("6nSJ2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7Nz3F").then(()=>parcelRequire('crHQq'));

});

parcelRegister("aT8m2", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("iP2SR").then(()=>parcelRequire('8WPRB'));

});

parcelRegister("7wivo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hswJF").then(()=>parcelRequire('8fqAK'));

});

parcelRegister("d5VWh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lsJZf").then(()=>parcelRequire('l6iQi'));

});

parcelRegister("gmmVc", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gAYZf").then(()=>parcelRequire('lNjm4'));

});

parcelRegister("2Wunu", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fOMo7").then(()=>parcelRequire('esId3'));

});

parcelRegister("a58As", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9mt74").then(()=>parcelRequire('68RPN'));

});

parcelRegister("5Dw6q", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lR2YW").then(()=>parcelRequire('bhKBy'));

});

parcelRegister("lzwxO", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jskhB").then(()=>parcelRequire('bVy9i'));

});

parcelRegister("j4YtB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("YDgaR").then(()=>parcelRequire('2ZcMq'));

});

parcelRegister("k8Bug", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eECuc").then(()=>parcelRequire('8uClj'));

});

parcelRegister("7cpN3", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gpKpk").then(()=>parcelRequire('k073H'));

});

parcelRegister("hiySz", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dGwph").then(()=>parcelRequire('c7fI9'));

});

parcelRegister("fVEqN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("91Phz").then(()=>parcelRequire('461sr'));

});

parcelRegister("duUjy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("juOMq").then(()=>parcelRequire('26Dvc'));

});

parcelRegister("lxPEp", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("72LhW").then(()=>parcelRequire('f0Lst'));

});

parcelRegister("jYq61", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bDi9t").then(()=>parcelRequire('hxHG5'));

});

parcelRegister("8Kxoj", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7wcRR").then(()=>parcelRequire('akgNL'));

});

parcelRegister("cPrmd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jSsvX").then(()=>parcelRequire('48SoC'));

});

parcelRegister("6nFdb", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lwgRa").then(()=>parcelRequire('5zwUn'));

});

parcelRegister("iGMfr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("39P85").then(()=>parcelRequire('lrvjT'));

});

parcelRegister("kVgGI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6mkOA").then(()=>parcelRequire('5dvaC'));

});

parcelRegister("4IvBD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jnq8s").then(()=>parcelRequire('lVqXE'));

});

parcelRegister("71CxK", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cOfdV").then(()=>parcelRequire('eIqCP'));

});

parcelRegister("9G42s", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("giEfd").then(()=>parcelRequire('lLdNT'));

});

parcelRegister("4FYJR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dgDqc").then(()=>parcelRequire('kh4Bu'));

});

parcelRegister("1CL42", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("lqDqC").then(()=>parcelRequire('5d2oc'));

});



parcelRegister("duVNo", function(module, exports) {
$parcel$export(module.exports, "AccountMenuLoggedOutStateNav4", () => $0ca8b6b7935eb2c8$export$f03eabcc4a75d4f3);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1oKpZ = parcelRequire("1oKpZ");

var $82r89 = parcelRequire("82r89");

var $aCh7H = parcelRequire("aCh7H");
const $0ca8b6b7935eb2c8$export$f03eabcc4a75d4f3 = ({ testId: testId, logInLink: logInLink })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $1oKpZ.LogIn), {
        testId: testId,
        href: logInLink,
        onClick: (event, analytics)=>{
            analytics.update({
                actionSubjectId: 'logInLink'
            }).fire((0, $82r89.NAVIGATION_CHANNEL));
        },
        label: (0, $aCh7H.logInTooltip)
    });
$0ca8b6b7935eb2c8$export$f03eabcc4a75d4f3.displayName = "AccountMenuLoggedOutStateNav4";

});
parcelRegister("aCh7H", function(module, exports) {
$parcel$export(module.exports, "logInTooltip", () => $d30fae0305075f08$export$b495e6c63a3a03c1);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $55qdj = parcelRequire("55qdj");
const $d30fae0305075f08$export$b495e6c63a3a03c1 = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $55qdj.default), {
    id: "identity.account-menu.account-menu-logged-out-state.log-in",
    defaultMessage: "Log in",
    description: "Tooltip for log in button when user is logged out"
});

});


parcelRegister("8odHE", function(module, exports) {
$parcel$export(module.exports, "AccountMenuTriggerNav4", () => $663265092d4e6632$export$83537fb6d03c400d);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $dbQw2 = parcelRequire("dbQw2");

var $7gO7g = parcelRequire("7gO7g");

var $51bGE = parcelRequire("51bGE");
const $663265092d4e6632$export$83537fb6d03c400d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(({ picture: picture, email: email, trustPicture: trustPicture = false, ...props }, ref)=>{
    const intl = (0, $1YIbA.default)();
    const state = (0, $7gO7g.useImageState)(picture || '');
    const tooltip = intl.formatMessage((0, $51bGE.messages).triggerTooltip);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dbQw2.Profile), {
        ...props,
        isSelected: props['aria-expanded'],
        ref: ref,
        label: email || tooltip,
        src: trustPicture || state === 'loaded' ? picture : undefined
    });
});

});
parcelRegister("7gO7g", function(module, exports) {
$parcel$export(module.exports, "useImageState", () => $0920b082539a97b2$export$2c1df3428fc3264c);

var $euxye = parcelRequire("euxye");
const $0920b082539a97b2$export$2c1df3428fc3264c = (src)=>{
    const [state, setState] = (0, $euxye.useState)('pending');
    const imgRef = (0, $euxye.useRef)();
    (0, $euxye.useEffect)(()=>{
        if (!imgRef.current) {
            imgRef.current = new Image();
            imgRef.current.onload = ()=>setState('loaded');
            imgRef.current.onerror = ()=>setState('error');
        }
        setState('pending');
        imgRef.current.src = src;
    }, [
        src
    ]);
    return state;
};

});

parcelRegister("51bGE", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1d97cf7b7ab67ea8$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $1d97cf7b7ab67ea8$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    triggerTooltip: {
        id: 'identity.account-menu.account-menu-popup.skeleton.tooltip',
        defaultMessage: 'Account',
        description: 'Tooltip and alt-text for the account menu item'
    }
});

});


const $454bc9fe95ddf677$export$42f4885608027d0c = 'non_boolean';

const $a858cae85500b1b2$export$cf090d5281b5ae06 = 10000;
const $a858cae85500b1b2$export$8575e30be0feb909 = 30000;

/* eslint-disable jira/filename-case */ const $0ce01f968965dadd$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $0ce01f968965dadd$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $0ce01f968965dadd$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $0ce01f968965dadd$export$f154708d773ba5a0 = 'JIRA_BOARD';
const $0ce01f968965dadd$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $0ce01f968965dadd$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $0ce01f968965dadd$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $0ce01f968965dadd$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $0ce01f968965dadd$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $0ce01f968965dadd$export$4695c1a423ffe431 = 'DASHBOARD';
const $0ce01f968965dadd$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $0ce01f968965dadd$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
const $0ce01f968965dadd$export$9a80695e72849f84 = 'X-Atlassian-Capability';

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

/* eslint-disable jira/filename-case */ const $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $eb8cfa569eede1a9$export$e9c56aa3b027d98f = 'jira-customer-service';
const $eb8cfa569eede1a9$export$1346c9aa3cbb477d = 'jira-software';
const $eb8cfa569eede1a9$export$202f50ee62667e32 = 'jira-product-discovery';
const $eb8cfa569eede1a9$export$db515c8cec1e6f79 = 'jira-core';
const $eb8cfa569eede1a9$export$c811f21c9ad05dc2 = 'confluence';
const $eb8cfa569eede1a9$export$961148c98d198270 = 'opsgenie';
const $eb8cfa569eede1a9$export$a310f85340477585 = 'assets';
const $eb8cfa569eede1a9$export$d5e9b613bc4c47f = 'compass';

/* eslint-disable jira/filename-case */ const $d0b0f317b4f60123$export$881d135f98d8d7d0 = 100;
const $d0b0f317b4f60123$export$9ab5bdcb8a1d6c34 = false;
const $d0b0f317b4f60123$export$f267d0e9ab3eb265 = false;
const $d0b0f317b4f60123$export$12c1dc38ea1692da = 0;
const $d0b0f317b4f60123$export$c6d9b82b8528dcc3 = false;

/* eslint-disable jira/filename-case */ const $8f860a533cc71fca$export$ff39ebd4bb12b718 = 201;
const $8f860a533cc71fca$export$3288b14b6745c572 = 204;
const $8f860a533cc71fca$export$9de493bcd9b1d977 = 400;
const $8f860a533cc71fca$export$67d19e9a991baa07 = 401;
const $8f860a533cc71fca$export$a3269a3914b007e3 = 403;
const $8f860a533cc71fca$export$8bca792d963eb0ef = 404;
const $8f860a533cc71fca$export$4a3cb39801694eee = 407;
const $8f860a533cc71fca$export$fa405bbf47d510e2 = 408;
const $8f860a533cc71fca$export$c09e7ea0fc79f34f = 409;
const $8f860a533cc71fca$export$5244030134e99 = 412;
const $8f860a533cc71fca$export$f90ac1df0b60853d = 413;
const $8f860a533cc71fca$export$a447d0a965e16776 = 422;
const $8f860a533cc71fca$export$3b48aba8957000cd = 426;
const $8f860a533cc71fca$export$6763168a631449a2 = 429;
const $8f860a533cc71fca$export$e813cd7045fcc98d = 500;
const $8f860a533cc71fca$export$2ce38d41a306034e = 502;
const $8f860a533cc71fca$export$974c37534b0191b1 = 503;
const $8f860a533cc71fca$export$5400e8dddac3fcf3 = 504;

const $f12a3c5938f2e39b$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $f12a3c5938f2e39b$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $f12a3c5938f2e39b$export$13f57c02915787b3 = 'atlaskit-portal';

const $607cd8ed0bd97f9c$export$ed5835cc67e87f72 = 'akPortalMount';
const $607cd8ed0bd97f9c$export$80816bd900e5bd00 = 'akPortalUnmount';

/**
 * Character key codes which can be used in keyboard events.
 */ const $48dedd10700aff3c$export$390330c10ff2b9a1 = 'ArrowUp';
const $48dedd10700aff3c$export$a80636c6f41931fe = 'ArrowDown';
const $48dedd10700aff3c$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $48dedd10700aff3c$export$c40f9845adc73fb5 = 'ArrowRight';
const $48dedd10700aff3c$export$4af703091671bc = 'Home';
const $48dedd10700aff3c$export$e2bc30913faa5db7 = 'End';
const $48dedd10700aff3c$export$10f6869ed0a7d75b = 'Tab';
const $48dedd10700aff3c$export$8152f929a25a0ff4 = 'Enter';
const $48dedd10700aff3c$export$e51a3576c045c8d5 = 'Space';
const $48dedd10700aff3c$export$2bb790b9008907b4 = 'Escape';

// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $9575501c176c2705$export$a7801e29f563faad = 400;

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $c4e639dc1b853f95$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $a6abf1ec3b2246b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $a6abf1ec3b2246b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $a6abf1ec3b2246b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $a6abf1ec3b2246b3$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
const $a6abf1ec3b2246b3$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
const $a6abf1ec3b2246b3$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
const $a6abf1ec3b2246b3$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

const $9eab319dcc173e7e$export$d6830277b06edd6 = 'normal';

/* eslint-disable jira/filename-case */ const $871dfefee2f46b5c$export$52483b87432059f1 = 'jiraEditionAwarenessForStandardToPremium';
const $871dfefee2f46b5c$export$83e119fb36bc846a = 'jira.user.theme.standard-to-premium-ea-pill.dismissed';

/* eslint-disable jira/filename-case */ const $f0e9a194674bc930$export$b5a308a17bc991f3 = 'projectKey';
const $f0e9a194674bc930$export$929d50f83189406c = 'boardId';
const $f0e9a194674bc930$export$da6f46390e1a426f = 'projectId';

const $5bdb53f12f87b5a8$export$cb2f616a76599e00 = 'APP_SWITCHER';

/* eslint-disable jira/filename-case */ const $b503a2fee96b7946$export$b8b9d90f9e5bd72b = '@jira/navigation-apps__atlassian-navigation';
const $b503a2fee96b7946$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $b503a2fee96b7946$export$9934c8d98fd9e572 = 'atlassianSwitcher';

/* eslint-disable jira/filename-case */ const $5f6e091542d432a9$export$b8b9d90f9e5bd72b = 'jiraAtlassianNavigationNav4';
const $5f6e091542d432a9$export$d57b6b390e78d90f = 'jira-cosmos';
const $5f6e091542d432a9$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $5f6e091542d432a9$export$eed606b4351295d7 = 'login';
const $5f6e091542d432a9$export$35e541d26a145a7c = 'logout';

/* eslint-disable jira/filename-case */ const $3b258ee19859baa5$export$d2aa6c54a5925f01 = 'v3';
const $3b258ee19859baa5$export$2bd315ece9f68967 = 'v4';

/* eslint-disable jira/filename-case */ const $192a2eeaa0a1dbf6$export$2ee9e5a3556c1e43 = 'sidebar';
const $192a2eeaa0a1dbf6$export$793ed84f5e13fedc = 'top';
const $192a2eeaa0a1dbf6$export$f1c9dd0f5207dd5e = 'tab';
const $192a2eeaa0a1dbf6$export$b83d0ee9325a2d0a = 'projectTitle';

/* eslint-disable jira/filename-case */ // TopNav or sidebar
const $fad9173ee481d7de$export$17ff3f7e02c6ac22 = 'global';
const $fad9173ee481d7de$export$33d8c916a600c5e9 = 'container';

/* eslint-disable jira/filename-case */ const $6b2913942bd90807$export$6dd9406e478a1fe2 = 'navigationItem';
const $6b2913942bd90807$export$b887e88d8d0739f6 = 'button';
const $6b2913942bd90807$export$64fed82162bd367 = 'dropdownItem';
const $6b2913942bd90807$export$b0a8b257f1f878a2 = 'searchInput';

/**
 * CSS variables that mirror the legacy `@atlaskit/page-layout` CSS custom properties.
 *
 * These are provided for consumers that previously relied on the `@atlaskit/page-layout`
 * CSS variables and need to reference them when using the navigation system.
 */ const $7c8e8130cce4c6fa$export$f963aecf2d4465bd = 'var(--leftPanelWidth, 0px)';
const $7c8e8130cce4c6fa$export$750459958906793 = 'var(--rightPanelWidth, 0px)';
const $7c8e8130cce4c6fa$export$f897e1ed9f8ed251 = 'var(--leftSidebarWidth, 0px)';
const $7c8e8130cce4c6fa$export$b44ab66843c05a69 = 'var(--rightSidebarWidth, 0px)';
const $7c8e8130cce4c6fa$export$aeff86a16f13529 = 'var(--topNavigationHeight, 0px)';
const $7c8e8130cce4c6fa$export$ed7cc0d417ee89e = 'var(--bannerHeight, 0px)';

const $863aeee714b20c92$export$2ce650757fdac12a = 'NOTIFICATIONS';

/* eslint-disable jira/filename-case */ const $8dfb0c8c68d6c8c9$export$14c62ba6f49b806f = 9;

/* eslint-disable jira/filename-case */ const $71a8d80581e45c48$export$e0226a83abddbd07 = 'check-notifications';

const $57a8d3ee2467d6bc$export$1b6b909295618bea = 'SETTINGS';

const $eb044bb12d0b1d65$export$c1b33b1e65f8bd62 = 'SEARCH';

const $c3b876b1e2716851$export$b98e411ae80c806f = '/';

const $19cdad16ba956d29$export$eeb0307e2964e28d = "var(--ds-text, #292A2E)";

const $1574973252f10ca9$export$7168c0a11fb9ab29 = "var(--ds-text-subtlest, #6B6E76)";

const $a91cdcebb262d5e5$export$4ac85ff259fe4fce = "var(--ds-background-neutral-subtle-hovered, #0515240F)";

const $2242fed6b156c6c0$export$271fb8b1437b1d62 = "var(--ds-link-visited, #803FA5)";

/* eslint-disable jira/filename-case */ const $74cc6705a5fdb0de$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldIncludeBetaAiFeatures: Boolean!, $shouldIncludeRovoEnablementStatus: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	jira_isBetaAiFeaturesEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldIncludeBetaAiFeatures)
	jira_rovoEnablementStatus(cloudId: $cloudId)@optIn(to: "JiraRovoEnablementStatus") @include(if: $shouldIncludeRovoEnablementStatus) {
		isRovoEntitlementEnabledForTenant
		isRovoAiFeaturesEnabledInAnyJiraProducts {
			isEnabled
			disabledReason
		}
		rovoAiFeaturesEnabledJiraProducts
	}
}
`;

/* eslint-disable jira/filename-case */ const $70e36d23224a09de$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $70e36d23224a09de$export$2ee9e5a3556c1e43 = 'SIDEBAR';

const $1056e2b7e19aa4e0$export$f4208f01301e1342 = 'HELP';

/* eslint-disable jira/filename-case */ const $feef523243843e2f$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $2b56b53c34bc2033$export$c43c7444da662fa1 = '1';
const $2b56b53c34bc2033$export$e99efa3985fa3c26 = 'helpPanel';
const $2b56b53c34bc2033$export$23aa6670f346c214 = 368;

/* eslint-disable jira/filename-case */ const $a250aea31dc76f65$export$53f45136e435c2fd = 'help_button_ui_state';

// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $2de0ca8181f03e7e$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $2de0ca8181f03e7e$export$64aee74ba59709e5 = 439; // px
const $2de0ca8181f03e7e$export$1c07393c5bb1bc27 = 439; // px
const $2de0ca8181f03e7e$export$aa3478deee7adbeb = 350; // px
const $2de0ca8181f03e7e$export$21e515a86cd1733b = 'Chat';
const $2de0ca8181f03e7e$export$e942bf04e23ff966 = 'Rovo';

const $0ec5a7f900257a97$export$72b898553bf6a17d = 'JSM_FEATURES_ENABLED';


$parcel$global.rlb("1aRRK")
//# sourceMappingURL=shared~atlassian-navigation~vendor~ar.f4598587.js.map
